webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(150).f;
var createNonEnumerableProperty = __webpack_require__(39);
var defineBuiltIn = __webpack_require__(30);
var defineGlobalProperty = __webpack_require__(136);
var copyConstructorProperties = __webpack_require__(134);
var isForced = __webpack_require__(251);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(107);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(131);
var DESCRIPTORS = __webpack_require__(11);
var globalThis = __webpack_require__(0);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(19);
var hasOwn = __webpack_require__(22);
var classof = __webpack_require__(38);
var tryToString = __webpack_require__(75);
var createNonEnumerableProperty = __webpack_require__(39);
var defineBuiltIn = __webpack_require__(30);
var defineBuiltInAccessor = __webpack_require__(59);
var isPrototypeOf = __webpack_require__(71);
var getPrototypeOf = __webpack_require__(70);
var setPrototypeOf = __webpack_require__(60);
var wellKnownSymbol = __webpack_require__(13);
var uid = __webpack_require__(160);
var InternalStateModule = __webpack_require__(40);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = globalThis.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = globalThis.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = globalThis.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(globalThis.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = globalThis[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = globalThis[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = globalThis[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = globalThis[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = globalThis[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (globalThis[NAME]) {
    createNonEnumerableProperty(globalThis[NAME].prototype, TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(749)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var shared = __webpack_require__(263);
var hasOwn = __webpack_require__(22);
var uid = __webpack_require__(160);
var NATIVE_SYMBOL = __webpack_require__(266);
var USE_SYMBOL_AS_UID = __webpack_require__(275);

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v1.12.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:17Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var deletedIds = [];

var document = window.document;

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "1.12.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1, IE<9
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type( obj ) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {

			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
		} catch ( e ) {

			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( !support.ownFirst ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {

			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1, IE<9
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {

				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[ j ] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// init accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt( 0 ) === "<" &&
				selector.charAt( selector.length - 1 ) === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {

						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[ 2 ] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof root.ready !== "undefined" ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter( function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[ 0 ], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.uniqueSort( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = true;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {

	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener ||
		window.event.type === "load" ||
		document.readyState === "complete" ) {

		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE6-10
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );

		// If IE event model is used
		} else {

			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch ( e ) {}

			if ( top && top.doScroll ) {
				( function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {

							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll( "left" );
						} catch ( e ) {
							return window.setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				} )();
			}
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownFirst = i === "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

// Execute ASAP in case we need to set body.style.zoom
jQuery( function() {

	// Minified: var a,b,c,d
	var val, div, body, container;

	body = document.getElementsByTagName( "body" )[ 0 ];
	if ( !body || !body.style ) {

		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	div = document.createElement( "div" );
	container = document.createElement( "div" );
	container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== "undefined" ) {

		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

		support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
		if ( val ) {

			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );
} );


( function() {
	var div = document.createElement( "div" );

	// Support: IE<9
	support.deleteExpando = true;
	try {
		delete div.test;
	} catch ( e ) {
		support.deleteExpando = false;
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();
var acceptData = function( elem ) {
	var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
};




var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
		data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {

		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {

		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split( " " );
					}
				}
			} else {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[ i ] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, undefined
	} else {
		cache[ id ] = undefined;
	}
}

jQuery.extend( {
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,

		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				jQuery.data( this, key );
			} );
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each( function() {
				jQuery.data( this, key, value );
			} ) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each( function() {
			jQuery.removeData( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object,
	// or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );


( function() {
	var shrinkWrapBlocksVal;

	support.shrinkWrapBlocks = function() {
		if ( shrinkWrapBlocksVal != null ) {
			return shrinkWrapBlocksVal;
		}

		// Will be changed later if needed.
		shrinkWrapBlocksVal = false;

		// Minified: var b,c,d
		var div, body, container;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {

			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		// Support: IE6
		// Check if elements with layout shrink-wrap their children
		if ( typeof div.style.zoom !== "undefined" ) {

			// Reset CSS: box-sizing; display; margin; border
			div.style.cssText =

				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
			div.appendChild( document.createElement( "div" ) ).style.width = "5px";
			shrinkWrapBlocksVal = div.offsetWidth !== 3;
		}

		body.removeChild( container );

		return shrinkWrapBlocksVal;
	};

} )();
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn(
					elems[ i ],
					key,
					raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[ 0 ], key ) : emptyGet;
};
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );

var rleadingWhitespace = ( /^\s+/ );

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
		"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
		"mark|meter|nav|output|picture|progress|section|summary|template|time|video";



function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}


( function() {
	var div = document.createElement( "div" ),
		fragment = document.createDocumentFragment(),
		input = document.createElement( "input" );

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );

	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input = document.createElement( "input" );
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
	support.noCloneEvent = !!div.addEventListener;

	// Support: IE<9
	// Since attributes and properties are the same in IE,
	// cleanData must set properties to undefined rather than use removeAttribute
	div[ jQuery.expando ] = 1;
	support.attributes = !div.getAttribute( jQuery.expando );
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {
	option: [ 1, "<select multiple='multiple'>", "</select>" ],
	legend: [ 1, "<fieldset>", "</fieldset>" ],
	area: [ 1, "<map>", "</map>" ],

	// Support: IE8
	param: [ 1, "<object>", "</object>" ],
	thead: [ 1, "<table>", "</table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
	// unless wrapped in a div with non-breaking characters in front of it.
	_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
};

// Support: IE8-IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
				undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context;
			( elem = elems[ i ] ) != null;
			i++
		) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; ( elem = elems[ i ] ) != null; i++ ) {
		jQuery._data(
			elem,
			"globalEval",
			!refElements || jQuery._data( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/,
	rtbody = /<tbody/i;

function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

function buildFragment( elems, context, scripts, selection, ignored ) {
	var j, elem, contains,
		tmp, tag, tbody, wrap,
		l = elems.length,

		// Ensure a safe fragment
		safe = createSafeFragment( context ),

		nodes = [],
		i = 0;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || safe.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;

				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Manually add leading whitespace removed by IE
				if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
					nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
				}

				// Remove IE's autoinserted <tbody> from table fragments
				if ( !support.tbody ) {

					// String was a <table>, *may* have spurious <tbody>
					elem = tag === "table" && !rtbody.test( elem ) ?
						tmp.firstChild :

						// String was a bare <thead> or <tfoot>
						wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
							tmp :
							0;

					j = elem && elem.childNodes.length;
					while ( j-- ) {
						if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
							!tbody.childNodes.length ) {

							elem.removeChild( tbody );
						}
					}
				}

				jQuery.merge( nodes, tmp.childNodes );

				// Fix #12392 for WebKit and IE > 9
				tmp.textContent = "";

				// Fix #12392 for oldIE
				while ( tmp.firstChild ) {
					tmp.removeChild( tmp.firstChild );
				}

				// Remember the top-level container for proper cleanup
				tmp = safe.lastChild;
			}
		}
	}

	// Fix #11356: Clear elements from fragment
	if ( tmp ) {
		safe.removeChild( tmp );
	}

	// Reset defaultChecked for any radios and checkboxes
	// about to be appended to the DOM in IE 6/7 (#8060)
	if ( !support.appendChecked ) {
		jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
	}

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}

			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( safe.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	tmp = null;

	return safe;
}


( function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
	for ( i in { submit: true, change: true, focusin: true } ) {
		eventName = "on" + i;

		if ( !( support[ i ] = eventName in window ) ) {

			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" &&
					( !e || jQuery.event.triggered !== e.type ) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};

			// Add elem as a property of the handle fn to prevent a memory leak
			// with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
				jQuery._data( cur, "handle" );

			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if (
				( !special._default ||
				 special._default.apply( eventPath.pop(), data ) === false
				) && acceptData( elem )
			) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {

						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Safari 6-8+
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
			"pageX pageY screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ?
					original.toElement :
					fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {

						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// Guard for simulated events was moved to jQuery.event.stopPropagation function
				// since `originalEvent` should point to the original event for the
				// constancy with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event,
			// to properly expose it to GC
			if ( typeof elem[ name ] === "undefined" ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( !e || this.isSimulated ) {
			return;
		}

		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

// IE submit delegation
if ( !support.submit ) {

	jQuery.event.special.submit = {
		setup: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {

				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?

						// Support: IE <=8
						// We use jQuery.prop instead of elem.form
						// to allow fixing the IE8 delegated submit issue (gh-2332)
						// by 3rd party polyfills/workarounds.
						jQuery.prop( elem, "form" ) :
						undefined;

				if ( form && !jQuery._data( form, "submit" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submitBubble = true;
					} );
					jQuery._data( form, "submit", true );
				}
			} );

			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {

			// If form was submitted by the user, bubble the event up the tree
			if ( event._submitBubble ) {
				delete event._submitBubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event );
				}
			}
		},

		teardown: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.change ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {

				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._justChanged = true;
						}
					} );
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._justChanged && !event.isTrigger ) {
							this._justChanged = false;
						}

						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event );
					} );
				}
				return false;
			}

			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event );
						}
					} );
					jQuery._data( elem, "change", true );
				}
			} );
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger ||
				( elem.type !== "radio" && elem.type !== "checkbox" ) ) {

				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	} );
}

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	},

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}
	return elem;
}

function cloneCopyEvent( src, dest ) {
	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {

		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var first, node, hasScripts,
		scripts, doc, fragment,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!jQuery._data( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval(
								( node.text || node.textContent || node.innerHTML || "" )
									.replace( rcleanScript, "" )
							);
						}
					}
				}
			}

			// Fix #11809: Avoid leaking memory
			fragment = first = null;
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		elems = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = elems[ i ] ) != null; i++ ) {

		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
			!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {

			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
				( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {

				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[ i ] ) {
					fixCloneNodeIssues( node, destElements[ i ] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
					cloneCopyEvent( node, destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems, /* internal */ forceAcceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			attributes = support.attributes,
			special = jQuery.event.special;

		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			if ( forceAcceptData || acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// Support: IE<9
						// IE does not allow us to delete expando properties from nodes
						// IE creates expando attributes along with the property
						// IE does not have a removeAttribute function on Document nodes
						if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
							elem.removeAttribute( internalKey );

						// Webkit & Blink performance suffers when deleting properties
						// from DOM nodes, so set to undefined instead
						// https://code.google.com/p/chromium/issues/detail?id=378607
						} else {
							elem[ internalKey ] = undefined;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append(
					( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
				);
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {

			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {

						// Remove element nodes and prevent memory leaks
						elem = this[ i ] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
		reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	div.style.cssText = "float:left;opacity:.5";

	// Support: IE<9
	// Make sure that element opacity exists (as opposed to filter)
	support.opacity = div.style.opacity === "0.5";

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!div.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container = document.createElement( "div" );
	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	div.innerHTML = "";
	container.appendChild( div );

	// Support: Firefox<29, Android 2.3
	// Vendor-prefix box-sizing
	support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
		div.style.WebkitBoxSizing === "";

	jQuery.extend( support, {
		reliableHiddenOffsets: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableHiddenOffsetsVal;
		},

		boxSizingReliable: function() {

			// We're checking for pixelPositionVal here instead of boxSizingReliableVal
			// since that compresses better and they're computed together anyway.
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		reliableMarginRight: function() {

			// Support: Android 2.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginRightVal;
		},

		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		}
	} );

	function computeStyleTests() {
		var contents, divStyle,
			documentElement = document.documentElement;

		// Setup
		documentElement.appendChild( container );

		div.style.cssText =

			// Support: Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";

		// Support: IE<9
		// Assume reasonable values in the absence of getComputedStyle
		pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
		pixelMarginRightVal = reliableMarginRightVal = true;

		// Check for getComputedStyle so that this code is not run in IE<9.
		if ( window.getComputedStyle ) {
			divStyle = window.getComputedStyle( div );
			pixelPositionVal = ( divStyle || {} ).top !== "1%";
			reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
			boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";

			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";

			// Support: Android 2.3 only
			// Div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			contents = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			contents.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
			contents.style.marginRight = contents.style.width = "0";
			div.style.width = "1px";

			reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );

			div.removeChild( contents );
		}

		// Support: IE6-8
		// First check that getClientRects works as expected
		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		div.style.display = "none";
		reliableHiddenOffsetsVal = div.getClientRects().length === 0;
		if ( reliableHiddenOffsetsVal ) {
			div.style.display = "";
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			div.childNodes[ 0 ].style.borderCollapse = "separate";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
		}

		// Teardown
		documentElement.removeChild( container );
	}

} )();


var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		if ( computed ) {

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value"
			// instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values,
			// but width seems to be reliably pixels
			// this is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are
		// proportional to the parent element instead
		// and we can't measure the parent instead because it
		// might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/i,

	// swappable if display is none or starts with table except
	// "table", "table-cell", or "table-caption"
	// see here for display values:
	// https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] =
					jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display && display !== "none" || !hidden ) {
				jQuery._data(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {

		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight
			// (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					style[ name ] = value;
				} catch ( e ) {}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
} );

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {

			// IE uses filters for opacity
			return ropacity.test( ( computed && elem.currentStyle ?
				elem.currentStyle.filter :
				elem.style.filter ) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist -
			// attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule
				// or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return (
				parseFloat( curCSS( elem, "marginLeft" ) ) ||

				// Support: IE<=11+
				// Running getBoundingClientRect on a disconnected node in IE throws an error
				// Support: IE8 only
				// getClientRects() errors on disconnected elems
				( jQuery.contains( elem.ownerDocument, elem ) ?
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} ) :
					0
				)
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var a,
		input = document.createElement( "input" ),
		div = document.createElement( "div" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	// Setup
	div = document.createElement( "div" );
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	// Support: Windows Web Apps (WWA)
	// `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "checkbox" );
	div.appendChild( input );

	a = div.getElementsByTagName( "a" )[ 0 ];

	// First batch of tests.
	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class.
	// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute( "style" ) );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute( "href" ) === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement( "form" ).enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";
} )();


var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if (
					hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// handle most common string cases
					ret.replace( rreturn, "" ) :

					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled :
								option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {

					// Setting the type on a radio button after the value resets the value in IE8-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;

					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {

			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		} else {

			// Support: IE<9
			// Use defaultChecked and defaultSelected for oldIE
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} else {
		attrHandle[ name ] = function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
	}
} );

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {

				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {

				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {

			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					( ret = elem.ownerDocument.createAttribute( name ) )
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each( [ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	} );
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {

			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case sensitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each( function() {

			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch ( e ) {}
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {

	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each( [ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	} );
}

// Support: Safari, IE9+
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return jQuery.attr( elem, "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// store className if set
					jQuery._data( this, "__className__", className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				jQuery.attr( this, "class",
					className || value === false ?
					"" :
					jQuery._data( this, "__className__" ) || ""
				);
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




// Return jQuery for attributes-only inclusion


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );


var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {

	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {

		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	} ) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new window.DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch ( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,

	// IE leaves an \r character at EOL
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var

			// Cross-domain detection vars
			parts,

			// Loop variable
			i,

			// URL without anti-cache param
			cacheURL,

			// Response headers as string
			responseHeadersString,

			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,

			// Response headers
			responseHeaders,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" )
			.replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


function getDisplay( elem ) {
	return elem.style && elem.style.display || jQuery.css( elem, "display" );
}

function filterHidden( elem ) {

	// Disconnected elements are considered hidden
	if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
		return true;
	}
	while ( elem && elem.nodeType === 1 ) {
		if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
			return true;
		}
		elem = elem.parentNode;
	}
	return false;
}

jQuery.expr.filters.hidden = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return support.reliableHiddenOffsets() ?
		( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
			!elem.getClientRects().length ) :
			filterHidden( elem );
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?

	// Support: IE6-IE8
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		if ( this.isLocal ) {
			return createActiveXHR();
		}

		// Support: IE 9-11
		// IE seems to error on cross-domain PATCH requests when ActiveX XHR
		// is used. In IE 9+ always use the native XHR.
		// Note: this condition won't catch Edge as it doesn't define
		// document.documentMode but it also doesn't support ActiveX so it won't
		// reach this code.
		if ( document.documentMode > 8 ) {
			return createStandardXHR();
		}

		// Support: IE<9
		// oldIE XHR does not support non-RFC2616 methods (#13240)
		// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
		// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
		// Although this check for six methods instead of eight
		// since IE also does not support "trace" and "connect"
		return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
			createStandardXHR() || createActiveXHR();
	} :

	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	} );
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport( function( options ) {

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {

						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {

							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch ( e ) {

									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;

								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					// Do send the request
					// `xhr.send` may raise an exception, but it will be
					// handled in jQuery.ajax (so no try/catch here)
					if ( !options.async ) {

						// If we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {

						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						window.setTimeout( callback );
					} else {

						// Register the callback, but delay it in case `xhr.send` throws
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	} );
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch ( e ) {}
}




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement( "script" );

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// data: string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off, url.length ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};





/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left
		// is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== "undefined" ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? ( prop in win ) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
	function( defaultExtra, funcName ) {

		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only,
					// but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(107);

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var toObject = __webpack_require__(31);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var tryToString = __webpack_require__(75);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(112);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);

module.exports = globalThis;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(187)('wks');
var uid = __webpack_require__(119);
var Symbol = __webpack_require__(26).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.4.4
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var _toString = Object.prototype.toString;

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(val);
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "stage" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "stage" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

var warn = noop;
var tip = noop;
var formatComponentName = (null); // work around flow check

if (true) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var name = typeof vm === 'string'
      ? vm
      : typeof vm === 'function' && vm.options
        ? vm.options.name
        : vm._isVue
          ? vm.$options.name || vm.$options._componentTag
          : vm.name;

    var file = vm._isVue && vm.$options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  var generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

function handleError (err, vm, info) {
  if (config.errorHandler) {
    config.errorHandler.call(null, err, vm, info);
  } else {
    if (true) {
      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }
}

/*  */
/* globals MutationObserver */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

/**
 * Defer a task to execute it asynchronously.
 */
var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc;

  function nextTickHandler () {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var logError = function (err) { console.error(err); };
    timerFunc = function () {
      p.then(nextTickHandler).catch(logError);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) { setTimeout(noop); }
    };
  } else if (!isIE && typeof MutationObserver !== 'undefined' && (
    isNative(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = function () {
      setTimeout(nextTickHandler, 0);
    };
  }

  return function queueNextTick (cb, ctx) {
    var _resolve;
    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending) {
      pending = true;
      timerFunc();
    }
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve, reject) {
        _resolve = resolve;
      })
    }
  }
})();

var _Set;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value)) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("stage" !== 'production' && customSetter) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (hasOwn(target, key)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "stage" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "stage" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (true) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "stage" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn.call(this, parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal
    ? extend(res, childVal)
    : res
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (parentVal, childVal) {
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (true) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options) {
  var inject = options.inject;
  if (Array.isArray(inject)) {
    var normalized = options.inject = {};
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = inject[i];
    }
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (true) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child);
  normalizeInject(child);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("stage" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (true) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("stage" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      'Invalid prop: type check failed for prop "' + name + '".' +
      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

var mark;
var measure;

if (true) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (true) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      "referenced during render. Make sure to declare reactive data " +
      "properties in the data option.",
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: {} };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  if (deep && vnode.children) {
    cloned.children = cloneVNodes(vnode.children);
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  var plain = !(passive || once$$1 || capture);
  return {
    name: name,
    plain: plain,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

// #6552
function prioritizePlainEvents (a, b) {
  return a.plain ? -1 : b.plain ? 1 : 0
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  var toAdd = [];
  var hasModifier = false;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (!event.plain) { hasModifier = true; }
    if (isUndef(cur)) {
      "stage" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      event.handler = cur;
      toAdd.push(event);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  if (toAdd.length) {
    if (hasModifier) { toAdd.sort(prioritizePlainEvents); }
    for (var i = 0; i < toAdd.length; i++) {
      var event$1 = toAdd[i];
      add(event$1.name, event$1.handler, event$1.once, event$1.capture, event$1.passive);
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (true) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    last = res[res.length - 1];
    //  nested
    if (Array.isArray(c)) {
      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        (last).text += String(c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[res.length - 1] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (comp.__esModule && comp.default) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "stage" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 true
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once$$1) {
  if (once$$1) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (arguments.length === 1) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (true) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  var defaultSlot = [];
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      data && data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      defaultSlot.push(child);
    }
  }
  // ignore whitespace
  if (!defaultSlot.every(isWhitespace)) {
    slots.default = defaultSlot;
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (true) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("stage" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure((name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure((name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (true) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (true) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (true) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("stage" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  true
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "stage" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function checkOptionType (vm, name) {
  var option = vm.$options[name];
  if (!isPlainObject(option)) {
    warn(
      ("component option \"" + name + "\" should be an object."),
      vm
    );
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (true) {
      if (isReservedAttribute(key) || config.isReservedAttr(key)) {
        warn(
          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "stage" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (true) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "stage" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  "stage" !== 'production' && checkOptionType(vm, 'computed');
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("stage" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (true) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if ("stage" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  "stage" !== 'production' && checkOptionType(vm, 'methods');
  var props = vm.$options.props;
  for (var key in methods) {
    if (true) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  "stage" !== 'production' && checkOptionType(vm, 'watch');
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (true) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (true) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject).filter(function (key) {
          /* istanbul ignore next */
          return Object.getOwnPropertyDescriptor(inject, key).enumerable
        })
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key];
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if ("stage" !== 'production' && !source) {
        warn(("Injection \"" + key + "\" not found"), vm);
      }
    }
    return result
  }
}

/*  */

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  context,
  children
) {
  var props = {};
  var propOptions = Ctor.options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var _context = Object.create(context);
  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
  var vnode = Ctor.options.render.call(null, h, {
    data: data,
    props: props,
    children: children,
    parent: context,
    listeners: data.on || emptyObject,
    injections: resolveInject(Ctor.options.inject, context),
    slots: function () { return resolveSlots(children, context); }
  });
  if (vnode instanceof VNode) {
    vnode.functionalContext = context;
    vnode.functionalOptions = Ctor.options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }
  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (true) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "stage" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("stage" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    return
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && isUndef(child.ns)) {
        applyNS(child, ns);
      }
    }
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      props = extend(extend({}, bindObject), props);
    }
    return scopedSlotFn(props) || fallback
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes && "stage" !== 'production') {
      slotNodes._rendered && warn(
        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
        "- this will likely cause render errors.",
        this
      );
      slotNodes._rendered = true;
    }
    return slotNodes || fallback
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (Array.isArray(keyCodes)) {
    return keyCodes.indexOf(eventKeyCode) === -1
  } else {
    return keyCodes !== eventKeyCode
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "stage" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var tree = this._staticTrees[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = this._staticTrees[index] =
    this.$options.staticRenderFns[index].call(this._renderProxy);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "stage" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(ours, existing) : ours;
      }
    }
  }
  return data
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null;
  var parentVnode = vm.$vnode = vm.$options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (true) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', vm.$options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', vm.$options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var staticRenderFns = ref.staticRenderFns;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        if (slot._rendered) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    if (staticRenderFns && !vm._staticTrees) {
      vm._staticTrees = [];
    }
    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render function");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (true) {
        vnode = vm.$options.renderError
          ? vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e)
          : vm._vnode;
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("stage" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };

  // internal render helpers.
  // these are exposed on the instance prototype to reduce generated render
  // code size.
  Vue.prototype._o = markOnce;
  Vue.prototype._n = toNumber;
  Vue.prototype._s = toString;
  Vue.prototype._l = renderList;
  Vue.prototype._t = renderSlot;
  Vue.prototype._q = looseEqual;
  Vue.prototype._i = looseIndexOf;
  Vue.prototype._m = renderStatic;
  Vue.prototype._f = resolveFilter;
  Vue.prototype._k = checkKeyCodes;
  Vue.prototype._b = bindObjectProps;
  Vue.prototype._v = createTextVNode;
  Vue.prototype._e = createEmptyVNode;
  Vue.prototype._u = resolveScopedSlots;
  Vue.prototype._g = bindObjectListeners;
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("stage" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-init:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (true) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("stage" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(((vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if ("stage" !== 'production' &&
    !(this instanceof Vue$3)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (true) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (true) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

var patternTypes = [String, RegExp, Array];

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (cache, current, filter) {
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode);
        }
        cache[key] = null;
      }
    }
  }
}

function pruneCacheEntry (vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy();
  }
}

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created: function created () {
    this.cache = Object.create(null);
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache[key]);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this.cache, this._vnode, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this.cache, this._vnode, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.include && !matches(this.include, name)) ||
        (this.exclude && matches(this.exclude, name))
      )) {
        return vnode
      }
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (true) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.4.4';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "stage" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (true) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("stage" !== 'production' && data && data.pre) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    var ancestor = vnode;
    while (ancestor) {
      if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
        nodeOps.setAttribute(vnode.elm, i, '');
      }
      ancestor = ancestor.parent;
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, elmToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          elmToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if ("stage" !== 'production' && !elmToMove) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(elmToMove, newStartVnode)) {
            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.elm = elm;
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (true) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("stage" !== 'production' &&
                typeof console !== 'undefined' &&
                !bailed
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("stage" !== 'production' &&
                typeof console !== 'undefined' &&
                !bailed
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (true) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }
        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        if (isDef(vnode.parent)) {
          // component root element replaced.
          // update parent placeholder node element, recursively
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            }
            ancestor = ancestor.parent;
          }
        }

        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  /* istanbul ignore if */
  if (isIE9 && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "stage" !== 'production' && warn &&
    modifiers && modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }
  // check capture modifier
  if (modifiers && modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers && modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers && modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }
  var events;
  if (modifiers && modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }
  var newHandler = { value: value, modifiers: modifiers };
  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

function getAndRemoveAttr (el, name) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var modelRs = parseModel(value);
  if (modelRs.idx === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (modelRs.exp) + ", " + (modelRs.idx) + ", " + assignment + ")")
  }
}

/**
 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
 *
 * for loop possible cases:
 *
 * - test
 * - test[idx]
 * - test[test1[idx]]
 * - test["a"][idx]
 * - xxx.test[a[a].test1[idx]]
 * - test.xxx.a["asa"][test1[idx]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;

function parseModel (val) {
  str = val;
  len = str.length;
  index$1 = expressionPos = expressionEndPos = 0;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    return {
      exp: val,
      idx: null
    }
  }

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.substring(0, expressionPos),
    idx: val.substring(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (true) {
    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (tag === 'input' && dynamicType) {
      warn$1(
        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
        "v-model does not support dynamic input types. Use v-if branches instead."
      );
    }
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (true) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
      "?_i(" + value + "," + valueBinding + ")>-1" + (
        trueValueBinding === 'true'
          ? (":(" + value + ")")
          : (":_q(" + value + "," + trueValueBinding + ")")
      )
  );
  addHandler(el, CHECKBOX_RADIO_TOKEN,
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, CHECKBOX_RADIO_TOKEN, genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;
  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  var event;
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    // Chrome fires microtasks in between click/change, leads to #4521
    event = isChrome ? 'click' : 'change';
    on[event] = [].concat(on[CHECKBOX_RADIO_TOKEN], on[event] || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  if (once$$1) {
    var oldHandler = handler;
    var _target = target$1; // save current target element in closure
    handler = function (ev) {
      var res = arguments.length === 1
        ? oldHandler(ev)
        : oldHandler.apply(null, arguments);
      if (res !== null) {
        remove$2(event, handler, capture, _target);
      }
    };
  }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(event, handler, capture);
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, vnode, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (
  elm,
  vnode,
  checkVal
) {
  return (!elm.composing && (
    vnode.tag === 'option' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser && window.requestAnimationFrame
  ? window.requestAnimationFrame.bind(window)
  : setTimeout;

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("stage" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("stage" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var model$1 = {
  inserted: function inserted (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "stage" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: model$1,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$options._renderChildren;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("stage" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("stage" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (true) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    var body = document.body;
    var f = body.offsetHeight; // eslint-disable-line

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if ("stage" !== 'production' && isChrome) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if ("stage" !== 'production' &&
    config.productionTip !== false &&
    inBrowser && typeof console !== 'undefined'
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

// check whether current browser encodes a char inside attribute values
function shouldDecode (content, encoded) {
  var div = document.createElement('div');
  div.innerHTML = "<div a=\"" + content + "\"/>";
  return div.innerHTML.indexOf(encoded) > 0
}

// #3663
// IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});

function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push(JSON.stringify(text.slice(lastIndex)));
  }
  return tokens.join('+')
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("stage" !== 'production' && staticClass) {
    var expression = parseText(staticClass, options.delimiters);
    if (expression) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (true) {
      var expression = parseText(staticStyle, options.delimiters);
      if (expression) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

var modules$1 = [
  klass$1,
  style$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("stage" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      attrs[i] = {
        name: args[1],
        value: decodeAttr(
          value,
          options.shouldDecodeNewlines
        )
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("stage" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function endPre (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        parent: currentParent,
        children: []
      };
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "stage" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        preTransforms[i](element, options);
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else {
        processFor(element);
        processIf(element);
        processOnce(element);
        processKey(element);

        // determine whether this is a plain element after
        // removing structural attributes
        element.plain = !element.key && !attrs.length;

        processRef(element);
        processSlot(element);
        processComponent(element);
        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
          transforms[i$1](element, options);
        }
        processAttrs(element);
      }

      function checkRootConstraints (el) {
        if (true) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (true) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        endPre(element);
      }
      // apply post-transforms
      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
        postTransforms[i$2](element, options);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      endPre(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (true) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var expression;
        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: expression,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if ("stage" !== 'production' && el.tag === 'template') {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) {
      "stage" !== 'production' && warn$2(
        ("Invalid v-for expression: " + exp)
      );
      return
    }
    el.for = inMatch[2].trim();
    var alias = inMatch[1].trim();
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
      el.alias = iteratorMatch[1].trim();
      el.iterator1 = iteratorMatch[2].trim();
      if (iteratorMatch[3]) {
        el.iterator2 = iteratorMatch[3].trim();
      }
    } else {
      el.alias = alias;
    }
  }
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (true) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("stage" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("stage" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      addAttr(el, 'slot', slotTarget);
    }
    if (el.tag === 'template') {
      el.slotScope = getAndRemoveAttr(el, 'scope');
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if ("stage" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (true) {
        var expression = parseText(value, delimiters);
        if (expression) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "stage" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    var handler = events[name];
    // #5330: warn click.right, since right clicks do not actually fire click events.
    if ("stage" !== 'production' &&
      name === 'click' &&
      handler && handler.modifiers && handler.modifiers.right
    ) {
      warn(
        "Use \"contextmenu\" instead of \"click.right\" since right clicks " +
        "do not actually fire \"click\" events."
      );
    }
    res += "\"" + name + "\":" + (genHandler(name, handler)) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    return isMethodPath || isFunctionExpression
      ? handler.value
      : ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var alias = keyCodes[key];
  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
}

/*  */

function on (el, dir) {
  if ("stage" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "stage" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("stage" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  if (el.slotTarget) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("stage" !== 'production' && (
    el.children.length > 1 || ast.type !== 1
  )) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  return "{key:" + key + ",fn:function(" + (String(el.attrsMap.scope)) + "){" +
    "return " + (el.tag === 'template'
      ? genChildren(el, state) || 'void 0'
      : genElement(el, state)) + "}}"
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// check valid identifier for v-for
var identRE = /[A-Za-z_$][\w$]*/;

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (ident, type, text, errors) {
  if (typeof ident === 'string' && !identRE.test(ident)) {
    errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
      );
    } else {
      errors.push(("invalid expression: " + (text.trim())));
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = options || {};

    /* istanbul ignore if */
    if (true) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (true) {
      if (compiled.errors && compiled.errors.length) {
        warn(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (true) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (true) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  optimize(ast, options);
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "stage" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("stage" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (true) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("stage" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("stage" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(((this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var definePropertyModule = __webpack_require__(36);
var makeBuiltIn = __webpack_require__(254);
var defineGlobalProperty = __webpack_require__(136);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(111);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(23);
var ctx = __webpack_require__(55);
var hide = __webpack_require__(56);
var has = __webpack_require__(65);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(19);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var isCallable = __webpack_require__(10);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(284);
var isBuffer = __webpack_require__(637);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(247);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(276);
var anObject = __webpack_require__(33);
var toPropertyKey = __webpack_require__(157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(158);
var isCallable = __webpack_require__(10);
var classofRaw = __webpack_require__(67);
var wellKnownSymbol = __webpack_require__(13);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var definePropertyModule = __webpack_require__(36);
var createPropertyDescriptor = __webpack_require__(52);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(413);
var globalThis = __webpack_require__(0);
var isObject = __webpack_require__(19);
var createNonEnumerableProperty = __webpack_require__(39);
var hasOwn = __webpack_require__(22);
var shared = __webpack_require__(155);
var sharedKey = __webpack_require__(154);
var hiddenKeys = __webpack_require__(143);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(54);
var IE8_DOM_DEFINE = __webpack_require__(291);
var toPrimitive = __webpack_require__(189);
var dP = Object.defineProperty;

exports.f = __webpack_require__(49) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(141);
var aCallable = __webpack_require__(24);
var NATIVE_BIND = __webpack_require__(107);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(24);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(402);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(38);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(556), __esModule: true };

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(64)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(44);
var IndexedObject = __webpack_require__(82);
var toObject = __webpack_require__(31);
var lengthOfArrayLike = __webpack_require__(25);
var arraySpeciesCreate = __webpack_require__(378);
var createProperty = __webpack_require__(135);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var resIndex = 0;
    var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) createProperty(target, index, result);    // map
        else if (result) switch (TYPE) {
          case 3: return true;                                // some
          case 5: return value;                               // find
          case 6: return index;                               // findIndex
          case 2: createProperty(target, resIndex++, value);  // filter
        } else switch (TYPE) {
          case 4: return false;                               // every
          case 7: createProperty(target, resIndex++, value);  // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(89);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(43);
var createDesc = __webpack_require__(95);
module.exports = __webpack_require__(49) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

module.exports = uncurryThis([].slice);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(254);
var defineProperty = __webpack_require__(36);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(244);
var isObject = __webpack_require__(19);
var requireObjectCoercible = __webpack_require__(111);
var aPossiblePrototype = __webpack_require__(370);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(36).f;
var hasOwn = __webpack_require__(22);
var wellKnownSymbol = __webpack_require__(13);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(82);
var requireObjectCoercible = __webpack_require__(111);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(44);
var call = __webpack_require__(15);
var anObject = __webpack_require__(33);
var tryToString = __webpack_require__(75);
var isArrayIteratorMethod = __webpack_require__(145);
var lengthOfArrayLike = __webpack_require__(25);
var isPrototypeOf = __webpack_require__(71);
var getIterator = __webpack_require__(108);
var getIteratorMethod = __webpack_require__(81);
var iteratorClose = __webpack_require__(148);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    var $iterator = iterator;
    iterator = undefined;
    if ($iterator) iteratorClose($iterator, 'normal');
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    // `IteratorValue` errors should propagate without closing the iterator
    var value = step.value;
    try {
      result = callFn(value);
    } catch (error) {
      if (iterator) iteratorClose(iterator, 'throw', error);
      else throw error;
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(33);
var definePropertiesModule = __webpack_require__(405);
var enumBugKeys = __webpack_require__(137);
var hiddenKeys = __webpack_require__(143);
var html = __webpack_require__(246);
var documentCreateElement = __webpack_require__(106);
var sharedKey = __webpack_require__(154);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(22);
var isCallable = __webpack_require__(10);
var toObject = __webpack_require__(31);
var sharedKey = __webpack_require__(154);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(380);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);

module.exports = globalThis.Promise;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(46);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(62);
var addToUnscopables = __webpack_require__(233);
var Iterators = __webpack_require__(83);
var InternalStateModule = __webpack_require__(40);
var defineProperty = __webpack_require__(36).f;
var defineIterator = __webpack_require__(252);
var createIterResultObject = __webpack_require__(105);
var IS_PURE = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(11);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(180);
var defined = __webpack_require__(177);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(71);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(107);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(38);
var getMethod = __webpack_require__(142);
var isNullOrUndefined = __webpack_require__(109);
var Iterators = __webpack_require__(83);
var wellKnownSymbol = __webpack_require__(13);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(4);
var classof = __webpack_require__(67);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(258);
var enumBugKeys = __webpack_require__(137);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var NativePromiseConstructor = __webpack_require__(73);
var isCallable = __webpack_require__(10);
var isForced = __webpack_require__(251);
var inspectSource = __webpack_require__(144);
var wellKnownSymbol = __webpack_require__(13);
var ENVIRONMENT = __webpack_require__(243);
var IS_PURE = __webpack_require__(41);
var V8_VERSION = __webpack_require__(139);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(265).charAt;
var toString = __webpack_require__(47);
var InternalStateModule = __webpack_require__(40);
var defineIterator = __webpack_require__(252);
var createIterResultObject = __webpack_require__(105);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(559), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(55);
var call = __webpack_require__(294);
var isArrayIter = __webpack_require__(292);
var anObject = __webpack_require__(54);
var toLength = __webpack_require__(118);
var getIterFn = __webpack_require__(306);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(298);
var enumBugKeys = __webpack_require__(179);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(43).f;
var has = __webpack_require__(65);
var TAG = __webpack_require__(28)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(177);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(38);

var $TypeError = TypeError;

// Perform ? RequireInternalSlot(argument, [[TypedArrayName]])
// If argument.[[TypedArrayName]] is not "Uint8Array", throw a TypeError exception
module.exports = function (argument) {
  if (classof(argument) === 'Uint8Array') return argument;
  throw new $TypeError('Argument is not an Uint8Array');
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isDetached = __webpack_require__(372);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isDetached(it)) throw new $TypeError('ArrayBuffer is detached');
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(25);

module.exports = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(62);
var toAbsoluteIndex = __webpack_require__(74);
var lengthOfArrayLike = __webpack_require__(25);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var isObject = __webpack_require__(19);

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () { /* empty */ }.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var anObject = __webpack_require__(33);
var tryToString = __webpack_require__(75);
var getIteratorMethod = __webpack_require__(81);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(73);
var checkCorrectnessOfIteration = __webpack_require__(133);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(85).CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(109);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(46);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);
var wellKnownSymbol = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(11);
var IS_PURE = __webpack_require__(41);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(506);

/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(54);
var dPs = __webpack_require__(579);
var enumBugKeys = __webpack_require__(179);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(178)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(290).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(188);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(586)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(181)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(171);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(550);


/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*! For license information please see okta-auth-js.umd.js.LICENSE.txt */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.OktaAuth=t():e.OktaAuth=t()}(self,(function(){return function(){var e={1506:function(e){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},4575:function(e){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},9100:function(e,t,n){var r=n(9489),o=n(7067);function i(t,n,a){return o()?(e.exports=i=Reflect.construct,e.exports.__esModule=!0,e.exports.default=e.exports):(e.exports=i=function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&r(i,n.prototype),i},e.exports.__esModule=!0,e.exports.default=e.exports),i.apply(null,arguments)}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports},3913:function(e){function t(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}e.exports=function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},9754:function(e){function t(n){return e.exports=t=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},2205:function(e,t,n){var r=n(9489);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&r(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},430:function(e){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")},e.exports.__esModule=!0,e.exports.default=e.exports},7067:function(e){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}},e.exports.__esModule=!0,e.exports.default=e.exports},8585:function(e,t,n){var r=n(8).default,o=n(1506);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},9489:function(e){function t(n,r){return e.exports=t=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n,r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},8:function(e){function t(n){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},5957:function(e,t,n){var r=n(9754),o=n(9489),i=n(430),a=n(9100);function u(t){var n="function"==typeof Map?new Map:void 0;return e.exports=u=function(e){if(null===e||!i(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},e.exports.__esModule=!0,e.exports.default=e.exports,u(t)}e.exports=u,e.exports.__esModule=!0,e.exports.default=e.exports},7757:function(e,t,n){e.exports=n(5666)},7913:function(e,t,n){"use strict";n.d(t,{a:function(){return g},E:function(){return k}});var r=n(5861),o=n(5671),i=n(3144),a=n(4942),u=n(7757),s=n.n(u),c=n(3615),f=n.n(c),l=n(7301),p=n(2852),h=n(146),d=n(5991);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var g=null,m={updateAuthStatePromise:null,canceledTimes:0},b="authStateChange",k=function(){function e(t){var n=this;if((0,o.Z)(this,e),(0,a.Z)(this,"_sdk",void 0),(0,a.Z)(this,"_pending",void 0),(0,a.Z)(this,"_authState",void 0),(0,a.Z)(this,"_prevAuthState",void 0),(0,a.Z)(this,"_logOptions",void 0),(0,a.Z)(this,"_transformQueue",void 0),!t.emitter)throw new l.R("Emitter should be initialized before AuthStateManager");this._sdk=t,this._pending=y({},m),this._authState=g,this._logOptions={},this._prevAuthState=null,this._transformQueue=new d.Z({quiet:!0}),t.tokenManager.on(p.EVENT_ADDED,(function(e,t){n._setLogOptions({event:p.EVENT_ADDED,key:e,token:t}),n.updateAuthState()})),t.tokenManager.on(p.EVENT_REMOVED,(function(e,t){n._setLogOptions({event:p.EVENT_REMOVED,key:e,token:t}),n.updateAuthState()}))}var t;return(0,i.Z)(e,[{key:"_setLogOptions",value:function(e){this._logOptions=e}},{key:"getAuthState",value:function(){return this._authState}},{key:"getPreviousAuthState",value:function(){return this._prevAuthState}},{key:"updateAuthState",value:(t=(0,r.Z)(s().mark((function e(){var t,n,r,o,i,a,u,c=this;return s().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this._sdk.options,n=t.transformAuthState,r=t.devMode,o=function(e){var t=c._logOptions,n=t.event,r=t.key,o=t.token;(0,h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n," Status:").concat(e)),(0,h.dr)().log(r,o),(0,h.dr)().log("Current authState",c._authState),(0,h.dr)().groupEnd(),c._logOptions={}},i=function(e){var t,n;n=e,(t=c._authState)&&t.isAuthenticated===n.isAuthenticated&&JSON.stringify(t.idToken)===JSON.stringify(n.idToken)&&JSON.stringify(t.accessToken)===JSON.stringify(n.accessToken)&&t.error===n.error?r&&o("unchanged"):(c._prevAuthState=c._authState,c._authState=e,c._sdk.emitter.emit(b,y({},e)),r&&o("emitted"))},a=function e(t){return c._pending.updateAuthStatePromise.then((function(){var n=c._pending.updateAuthStatePromise;return n&&n!==t?e(n):c.getAuthState()}))},!this._pending.updateAuthStatePromise){e.next=11;break}if(!(this._pending.canceledTimes>=10)){e.next=10;break}return r&&o("terminated"),e.abrupt("return",a(this._pending.updateAuthStatePromise));case 10:this._pending.updateAuthStatePromise.cancel();case 11:return u=new(f())((function(e,t,a){a.shouldReject=!1,a((function(){c._pending.updateAuthStatePromise=null,c._pending.canceledTimes=c._pending.canceledTimes+1,r&&o("canceled")}));var s=function(t){u.isCanceled?e():(i(t),e(),c._pending=y({},m))};c._sdk.isAuthenticated().then((function(){if(u.isCanceled)e();else{var t=c._sdk.tokenManager.getTokensSync(),r=t.accessToken,o=t.idToken,i=t.refreshToken,a={accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!(!r||!o)};(n?c._transformQueue.push(n,null,c._sdk,a):Promise.resolve(a)).then((function(e){return s(e)})).catch((function(e){return s({accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!1,error:e})}))}}))})),this._pending.updateAuthStatePromise=u,e.abrupt("return",a(u));case 14:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"subscribe",value:function(e){this._sdk.emitter.on(b,e)}},{key:"unsubscribe",value:function(e){this._sdk.emitter.off(b,e)}}]),e}()},3415:function(e,t,n){"use strict";n.d(t,{Z:function(){return mt}});var r={};n.r(r),n.d(r,{buildCredentialCreationOptions:function(){return A},buildCredentialRequestOptions:function(){return P},getAssertion:function(){return x},getAttestation:function(){return R}});var o=n(4925),i=n(5861),a=n(5671),u=n(3144),s=n(4942),c=n(7757),f=n.n(c),l=n(1971),p=n(2375),h=n(3611),d=n(3193),v=n(6718),y=n(7735);function g(e){return e.session.get().then((function(e){return"ACTIVE"===e.status})).catch((function(){return!1}))}function m(e){return(0,y.U2)(e,"/api/v1/sessions/me",{withCredentials:!0}).then((function(t){var n=(0,d.CE)(t,"_links");return n.refresh=function(){return(0,y.v_)(e,(0,d.Rg)(t,"refresh").href,{},{withCredentials:!0})},n.user=function(){return(0,y.U2)(e,(0,d.Rg)(t,"user").href,{withCredentials:!0})},n})).catch((function(){return{status:"INACTIVE"}}))}function b(e){return(0,y.c3)(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE",withCredentials:!0})}function k(e){return(0,y.v_)(e,"/api/v1/sessions/me/lifecycle/refresh",{},{withCredentials:!0})}function w(e,t,n){n=n||window.location.href,window.location.assign(e.getIssuerOrigin()+"/login/sessionCookieRedirect"+(0,v.UK)({checkAccountSetupComplete:!0,token:t,redirectUrl:n}))}var O=n(1279),E=n(415),T=n(9326),S=n(7987),_=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=[];return e.forEach((function(e){"webauthn"===e.key&&t.push({type:"public-key",id:(0,S.dX)(e.credentialId)})})),t},A=function(e,t){return{publicKey:{rp:e.rp,user:{id:(0,S.dX)(e.user.id),name:e.user.name,displayName:e.user.displayName},challenge:(0,S.dX)(e.challenge),pubKeyCredParams:e.pubKeyCredParams,attestation:e.attestation,authenticatorSelection:e.authenticatorSelection,excludeCredentials:_(t)}}},P=function(e,t){return{publicKey:{challenge:(0,S.dX)(e.challenge),userVerification:e.userVerification,allowCredentials:_(t)}}},R=function(e){var t=e.response;return{id:e.id,clientData:(0,S.kQ)(t.clientDataJSON),attestation:(0,S.kQ)(t.attestationObject)}},x=function(e){var t=e.response;return{id:e.id,clientData:(0,S.kQ)(t.clientDataJSON),authenticatorData:(0,S.kQ)(t.authenticatorData),signatureData:(0,S.kQ)(t.signature)}};function Z(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}var j=function e(t,n){function r(e,r,o){if("undefined"!=typeof document){"number"==typeof(o=Z({},n,o)).expires&&(o.expires=new Date(Date.now()+864e5*o.expires)),o.expires&&(o.expires=o.expires.toUTCString()),e=encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var i="";for(var a in o)o[a]&&(i+="; "+a,!0!==o[a]&&(i+="="+o[a].split(";")[0]));return document.cookie=e+"="+t.write(r,e)+i}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],r={},o=0;o<n.length;o++){var i=n[o].split("="),a=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(r[u]=t.read(a,u),e===u)break}catch(e){}}return e?r[e]:r}},remove:function(e,t){r(e,"",Z({},t,{expires:-1}))},withAttributes:function(t){return e(this.converter,Z({},this.attributes,t))},withConverter:function(t){return e(Z({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(t)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"}),C=j,D=n(9123),I=n(146),M={getHttpCache:function(){return null},getPKCEStorage:function(){return null},browserHasLocalStorage:function(){try{var e=this.getLocalStorage();return this.testStorage(e)}catch(e){return!1}},browserHasSessionStorage:function(){try{var e=this.getSessionStorage();return this.testStorage(e)}catch(e){return!1}},testStorageType:function(e){var t=!1;switch(e){case"sessionStorage":t=this.browserHasSessionStorage();break;case"localStorage":t=this.browserHasLocalStorage();break;case"cookie":case"memory":t=!0;break;default:t=!1}return t},getStorageByType:function(e,t){var n;switch(e){case"sessionStorage":n=this.getSessionStorage();break;case"localStorage":n=this.getLocalStorage();break;case"cookie":n=this.getCookieStorage(t);break;case"memory":n=this.getInMemoryStorage();break;default:throw new D.Z("Unrecognized storage option: ".concat(e))}return n},findStorageType:function(e){var t,n;return t=(e=e.slice()).shift(),(n=e.length?e[0]:null)?this.testStorageType(t)?t:((0,I.ZK)("This browser doesn't support ".concat(t,". Switching to ").concat(n,".")),this.findStorageType(e)):t},getLocalStorage:function(){return(0,E.isIE11OrLess)()&&!window.onstorage&&(window.onstorage=function(){}),localStorage},getSessionStorage:function(){return sessionStorage},getCookieStorage:function(e){var t=this,n=e.secure,r=e.sameSite,o=e.sessionCookie;if(void 0===n||void 0===r)throw new D.Z('getCookieStorage: "secure" and "sameSite" options must be provided');var i={getItem:this.storage.get,setItem:function(e,i){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"2200-01-01T00:00:00.000Z";a=o?null:a,t.storage.set(e,i,a,{secure:n,sameSite:r})},removeItem:function(e){t.storage.delete(e)},isSharedStorage:function(){return!0}};return e.useSeparateCookies?{getItem:function(e){var t=i.getItem(),n={};return Object.keys(t).forEach((function(r){0===r.indexOf(e)&&(n[r.replace("".concat(e,"_"),"")]=JSON.parse(t[r]))})),JSON.stringify(n)},setItem:function(e,t){var n=JSON.parse(this.getItem(e));t=JSON.parse(t),Object.keys(t).forEach((function(r){var o=e+"_"+r,a=JSON.stringify(t[r]);i.setItem(o,a),delete n[r]})),Object.keys(n).forEach((function(t){i.removeItem(e+"_"+t)}))},removeItem:function(e){var t=JSON.parse(this.getItem(e));Object.keys(t).forEach((function(t){i.removeItem(e+"_"+t)}))},isSharedStorage:function(){return!0}}:i},inMemoryStore:{},getInMemoryStorage:function(){var e=this;return{getItem:function(t){return e.inMemoryStore[t]},setItem:function(t,n){e.inMemoryStore[t]=n},isSharedStorage:function(){return!1}}},testStorage:function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},storage:{set:function(e,t,n,r){var o=r.sameSite,i=r.secure;if(void 0===i||void 0===o)throw new D.Z('storage.set: "secure" and "sameSite" options must be provided');var a={path:r.path||"/",secure:i,sameSite:o};return Date.parse(n)&&(a.expires=new Date(n)),C.set(e,t,a),this.get(e)},get:function(e){return arguments.length?C.get(e):C.get()},delete:function(e){return C.remove(e,{path:"/"})}}},N=M,U=n(8092),L=n(885),F=n(2982),H=n(7301),K=n(2852),B=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,s.Z)(this,"tokenManager",void 0),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"renewTimeQueue",void 0),(0,s.Z)(this,"started",!1),this.tokenManager=t,this.options=n,this.renewTimeQueue=[],this.onTokenExpiredHandler=this.onTokenExpiredHandler.bind(this)}var t,n;return(0,u.Z)(e,[{key:"shouldThrottleRenew",value:function(){var e=!1;if(this.renewTimeQueue.push(Date.now()),this.renewTimeQueue.length>=10){var t=this.renewTimeQueue.shift();e=this.renewTimeQueue[this.renewTimeQueue.length-1]-t<3e4}return e}},{key:"requiresLeadership",value:function(){return!!this.options.syncStorage&&(0,E.isBrowser)()}},{key:"onTokenExpiredHandler",value:function(e){if(this.options.autoRenew)if(this.shouldThrottleRenew()){var t=new H.R("Too many token renew requests");this.tokenManager.emitError(t)}else this.tokenManager.renew(e).catch((function(){}));else this.options.autoRemove&&this.tokenManager.remove(e)}},{key:"canStart",value:function(){return!!this.options.autoRenew||!!this.options.autoRemove}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.canStart()){e.next=5;break}return e.next=3,this.stop();case 3:this.tokenManager.on(K.EVENT_EXPIRED,this.onTokenExpiredHandler),this.started=!0;case 5:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.started&&(this.tokenManager.off(K.EVENT_EXPIRED,this.onTokenExpiredHandler),this.renewTimeQueue=[],this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"isStarted",value:function(){return this.started}}]),e}();Promise.resolve(!1);var V=Promise.resolve(!0),G=Promise.resolve();function q(e,t){return e||(e=0),new Promise((function(n){return setTimeout((function(){return n(t)}),e)}))}function Y(){return Math.random().toString(36).substring(2)}var W=0,z=0;function $(){var e=(new Date).getTime();return e===W?1e3*e+ ++z:(W=e,z=0,1e3*e)}var Q={create:function(e){var t={messagesCallback:null,bc:new BroadcastChannel(e),subFns:[]};return t.bc.onmessage=function(e){t.messagesCallback&&t.messagesCallback(e.data)},t},close:function(e){e.bc.close(),e.subFns=[]},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){try{return e.bc.postMessage(t,!1),G}catch(e){return Promise.reject(e)}},canBeUsed:function(){if("undefined"==typeof window)return!1;if("function"==typeof BroadcastChannel){if(BroadcastChannel._pubkey)throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");return!0}return!1},type:"native",averageResponseTime:function(){return 150},microSeconds:$},X=function(){function e(e){this.ttl=e,this.map=new Map,this._to=!1}return e.prototype.has=function(e){return this.map.has(e)},e.prototype.add=function(e){var t=this;this.map.set(e,J()),this._to||(this._to=!0,setTimeout((function(){t._to=!1,function(e){for(var t=J()-e.ttl,n=e.map[Symbol.iterator]();;){var r=n.next().value;if(!r)return;var o=r[0];if(!(r[1]<t))return;e.map.delete(o)}}(t)}),0))},e.prototype.clear=function(){this.map.clear()},e}();function J(){return(new Date).getTime()}function ee(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=JSON.parse(JSON.stringify(e));return void 0===t.webWorkerSupport&&(t.webWorkerSupport=!0),t.idb||(t.idb={}),t.idb.ttl||(t.idb.ttl=45e3),t.idb.fallbackInterval||(t.idb.fallbackInterval=150),e.idb&&"function"==typeof e.idb.onclose&&(t.idb.onclose=e.idb.onclose),t.localstorage||(t.localstorage={}),t.localstorage.removeTimeout||(t.localstorage.removeTimeout=6e4),e.methods&&(t.methods=e.methods),t.node||(t.node={}),t.node.ttl||(t.node.ttl=12e4),t.node.maxParallelWrites||(t.node.maxParallelWrites=2048),void 0===t.node.useFastPath&&(t.node.useFastPath=!0),t}var te="messages",ne={durability:"relaxed"};function re(){if("undefined"!=typeof indexedDB)return indexedDB;if("undefined"!=typeof window){if(void 0!==window.mozIndexedDB)return window.mozIndexedDB;if(void 0!==window.webkitIndexedDB)return window.webkitIndexedDB;if(void 0!==window.msIndexedDB)return window.msIndexedDB}return!1}function oe(e){e.commit&&e.commit()}function ie(e){e.closed||ae(e).then((function(){return q(e.options.idb.fallbackInterval)})).then((function(){return ie(e)}))}function ae(e){return e.closed?G:e.messagesCallback?function(e,t){var n=e.transaction(te,"readonly",ne),r=n.objectStore(te),o=[],i=IDBKeyRange.bound(t+1,1/0);if(r.getAll){var a=r.getAll(i);return new Promise((function(e,t){a.onerror=function(e){return t(e)},a.onsuccess=function(t){e(t.target.result)}}))}return new Promise((function(e,a){var u=function(){try{return i=IDBKeyRange.bound(t+1,1/0),r.openCursor(i)}catch(e){return r.openCursor()}}();u.onerror=function(e){return a(e)},u.onsuccess=function(r){var i=r.target.result;i?i.value.id<t+1?i.continue(t+1):(o.push(i.value),i.continue()):(oe(n),e(o))}}))}(e.db,e.lastCursorId).then((function(t){var n=t.filter((function(e){return!!e})).map((function(t){return t.id>e.lastCursorId&&(e.lastCursorId=t.id),t})).filter((function(t){return function(e,t){return!(e.uuid===t.uuid||t.eMIs.has(e.id)||e.data.time<t.messagesCallbackTime)}(t,e)})).sort((function(e,t){return e.time-t.time}));return n.forEach((function(t){e.messagesCallback&&(e.eMIs.add(t.id),e.messagesCallback(t.data))})),G})):G}var ue={create:function(e,t){return t=ee(t),function(e){var t="pubkey.broadcast-channel-0-"+e,n=re().open(t);return n.onupgradeneeded=function(e){e.target.result.createObjectStore(te,{keyPath:"id",autoIncrement:!0})},new Promise((function(e,t){n.onerror=function(e){return t(e)},n.onsuccess=function(){e(n.result)}}))}(e).then((function(n){var r={closed:!1,lastCursorId:0,channelName:e,options:t,uuid:Y(),eMIs:new X(2*t.idb.ttl),writeBlockPromise:G,messagesCallback:null,readQueuePromises:[],db:n};return n.onclose=function(){r.closed=!0,t.idb.onclose&&t.idb.onclose()},ie(r),r}))},close:function(e){e.closed=!0,e.db.close()},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t,ae(e)},postMessage:function(e,t){return e.writeBlockPromise=e.writeBlockPromise.then((function(){return function(e,t,n){var r={uuid:t,time:(new Date).getTime(),data:n},o=e.transaction([te],"readwrite",ne);return new Promise((function(e,t){o.oncomplete=function(){return e()},o.onerror=function(e){return t(e)},o.objectStore(te).add(r),oe(o)}))}(e.db,e.uuid,t)})).then((function(){var t,n;0===(0,10,Math.floor(11*Math.random()+0))&&(t=e.db,n=e.options.idb.ttl,function(e,t){var n=(new Date).getTime()-t,r=e.transaction(te,"readonly",ne),o=r.objectStore(te),i=[];return new Promise((function(e){o.openCursor().onsuccess=function(t){var o=t.target.result;if(o){var a=o.value;if(!(a.time<n))return oe(r),void e(i);i.push(a),o.continue()}else e(i)}}))}(t,n).then((function(e){return function(e,t){var n=e.transaction([te],"readwrite",ne).objectStore(te);return Promise.all(t.map((function(e){var t=n.delete(e);return new Promise((function(e){t.onsuccess=function(){return e()}}))})))}(t,e.map((function(e){return e.id})))})))})),e.writeBlockPromise},canBeUsed:function(){return!!re()},type:"idb",averageResponseTime:function(e){return 2*e.idb.fallbackInterval},microSeconds:$};function se(){var e;if("undefined"==typeof window)return null;try{e=window.localStorage,e=window["ie8-eventlistener/storage"]||window.localStorage}catch(e){}return e}function ce(e){return"pubkey.broadcastChannel-"+e}function fe(){var e=se();if(!e)return!1;try{var t="__broadcastchannel_check";e.setItem(t,"works"),e.removeItem(t)}catch(e){return!1}return!0}var le={create:function(e,t){if(t=ee(t),!fe())throw new Error("BroadcastChannel: localstorage cannot be used");var n=Y(),r=new X(t.localstorage.removeTimeout),o={channelName:e,uuid:n,eMIs:r};return o.listener=function(e,t){var i=ce(e),a=function(e){var t;e.key===i&&(t=JSON.parse(e.newValue),o.messagesCallback&&t.uuid!==n&&t.token&&!r.has(t.token)&&(t.data.time&&t.data.time<o.messagesCallbackTime||(r.add(t.token),o.messagesCallback(t.data))))};return window.addEventListener("storage",a),a}(e),o},close:function(e){var t;t=e.listener,window.removeEventListener("storage",t)},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){q().then((function(){var r=ce(e.channelName),o={token:Y(),time:(new Date).getTime(),data:t,uuid:e.uuid},i=JSON.stringify(o);se().setItem(r,i);var a=document.createEvent("Event");a.initEvent("storage",!0,!0),a.key=r,a.newValue=i,window.dispatchEvent(a),n()}))}))},canBeUsed:fe,type:"localstorage",averageResponseTime:function(){var e=navigator.userAgent.toLowerCase();return e.includes("safari")&&!e.includes("chrome")?240:120},microSeconds:$},pe=$,he=new Set,de={create:function(e){var t={name:e,messagesCallback:null};return he.add(t),t},close:function(e){he.delete(e)},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){return setTimeout((function(){Array.from(he).filter((function(t){return t.name===e.name})).filter((function(t){return t!==e})).filter((function(e){return!!e.messagesCallback})).forEach((function(e){return e.messagesCallback(t)})),n()}),5)}))},canBeUsed:function(){return!0},type:"simulate",averageResponseTime:function(){return 5},microSeconds:pe},ve=[Q,ue,le],ye=new Set,ge=0,me=function(e,t){var n,r,o;this.id=ge++,ye.add(this),this.name=e,this.options=ee(t),this.method=function(e){var t=[].concat(e.methods,ve).filter(Boolean);if(e.type){if("simulate"===e.type)return de;var n=t.find((function(t){return t.type===e.type}));if(n)return n;throw new Error("method-type "+e.type+" not found")}e.webWorkerSupport||(t=t.filter((function(e){return"idb"!==e.type})));var r=t.find((function(e){return e.canBeUsed()}));if(r)return r;throw new Error("No useable method found in "+JSON.stringify(ve.map((function(e){return e.type}))))}(this.options),this._iL=!1,this._onML=null,this._addEL={message:[],internal:[]},this._uMP=new Set,this._befC=[],this._prepP=null,(o=r=(n=this).method.create(n.name,n.options))&&"function"==typeof o.then?(n._prepP=r,r.then((function(e){n._state=e}))):n._state=r};function be(e,t,n){var r={time:e.method.microSeconds(),type:t,data:n};return(e._prepP?e._prepP:G).then((function(){var t=e.method.postMessage(e._state,r);return e._uMP.add(t),t.catch().then((function(){return e._uMP.delete(t)})),t}))}function ke(e){return e._addEL.message.length>0||e._addEL.internal.length>0}function we(e,t,n){e._addEL[t].push(n),function(e){if(!e._iL&&ke(e)){var t=function(t){e._addEL[t.type].forEach((function(e){var n=e.time-1e5;t.time>=n&&e.fn(t.data)}))},n=e.method.microSeconds();e._prepP?e._prepP.then((function(){e._iL=!0,e.method.onMessage(e._state,t,n)})):(e._iL=!0,e.method.onMessage(e._state,t,n))}}(e)}function Oe(e,t,n){e._addEL[t]=e._addEL[t].filter((function(e){return e!==n})),function(e){if(e._iL&&!ke(e)){e._iL=!1;var t=e.method.microSeconds();e.method.onMessage(e._state,null,t)}}(e)}me._pubkey=!0,me.prototype={postMessage:function(e){if(this.closed)throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed "+JSON.stringify(e));return be(this,"message",e)},postInternal:function(e){return be(this,"internal",e)},set onmessage(e){var t={time:this.method.microSeconds(),fn:e};Oe(this,"message",this._onML),e&&"function"==typeof e?(this._onML=t,we(this,"message",t)):this._onML=null},addEventListener:function(e,t){we(this,e,{time:this.method.microSeconds(),fn:t})},removeEventListener:function(e,t){Oe(this,e,this._addEL[e].find((function(e){return e.fn===t})))},close:function(){var e=this;if(!this.closed){ye.delete(this),this.closed=!0;var t=this._prepP?this._prepP:G;return this._onML=null,this._addEL.message=[],t.then((function(){return Promise.all(Array.from(e._uMP))})).then((function(){return Promise.all(e._befC.map((function(e){return e()})))})).then((function(){return e.method.close(e._state)}))}},get type(){return this.method.type},get isClosed(){return this.closed}};var Ee=n(5643),Te=n.n(Ee),Se={add:function(e){if("function"==typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope);else{if("function"!=typeof window.addEventListener)return;window.addEventListener("beforeunload",(function(){e()}),!0),window.addEventListener("unload",(function(){e()}),!0)}}},_e=n(199),Ae=n.n(_e),Pe=Te()?Ae():Se,Re=new Set,xe=!1;function Ze(){var e=[];return Re.forEach((function(t){e.push(t()),Re.delete(t)})),Promise.all(e)}var je=function(e,t){var n=this;this.broadcastChannel=e,this._options=t,this.isLeader=!1,this.hasLeader=!1,this.isDead=!1,this.token=Y(),this._aplQ=G,this._aplQC=0,this._unl=[],this._lstns=[],this._dpL=function(){},this._dpLC=!1;var r=function(e){"leader"===e.context&&("death"===e.action&&(n.hasLeader=!1),"tell"===e.action&&(n.hasLeader=!0))};this.broadcastChannel.addEventListener("internal",r),this._lstns.push(r)};function Ce(e,t){var n={context:"leader",action:t,token:e.token};return e.broadcastChannel.postInternal(n)}function De(e,t){if(e._leaderElector)throw new Error("BroadcastChannel already has a leader-elector");t=function(e,t){return e||(e={}),(e=JSON.parse(JSON.stringify(e))).fallbackInterval||(e.fallbackInterval=3e3),e.responseTime||(e.responseTime=t.method.averageResponseTime(t.options)),e}(t,e);var n=new je(e,t);return e._befC.push((function(){return n.die()})),e._leaderElector=n,n}je.prototype={applyOnce:function(e){var t=this;if(this.isLeader)return q(0,!0);if(this.isDead)return q(0,!1);if(this._aplQC>1)return this._aplQ;var n=function(){if(t.isLeader)return V;var n,r=!1,o=new Promise((function(e){n=function(){r=!0,e()}})),i=[],a=function(e){"leader"===e.context&&e.token!=t.token&&(i.push(e),"apply"===e.action&&e.token>t.token&&n(),"tell"===e.action&&(n(),t.hasLeader=!0))};t.broadcastChannel.addEventListener("internal",a);var u=e?4*t._options.responseTime:t._options.responseTime;return Ce(t,"apply").then((function(){return Promise.race([q(u),o.then((function(){return Promise.reject(new Error)}))])})).then((function(){return Ce(t,"apply")})).then((function(){return Promise.race([q(u),o.then((function(){return Promise.reject(new Error)}))])})).catch((function(){})).then((function(){return t.broadcastChannel.removeEventListener("internal",a),!r&&function(e){e.isLeader=!0,e.hasLeader=!0;var t=function(e){if(xe||(xe=!0,Pe.add(Ze)),"function"!=typeof e)throw new Error("Listener is no function");return Re.add(e),{remove:function(){return Re.delete(e)},run:function(){return Re.delete(e),e()}}}((function(){return e.die()}));e._unl.push(t);var n=function(t){"leader"===t.context&&"apply"===t.action&&Ce(e,"tell"),"leader"!==t.context||"tell"!==t.action||e._dpLC||(e._dpLC=!0,e._dpL(),Ce(e,"tell"))};return e.broadcastChannel.addEventListener("internal",n),e._lstns.push(n),Ce(e,"tell")}(t).then((function(){return!0}))}))};return this._aplQC=this._aplQC+1,this._aplQ=this._aplQ.then((function(){return n()})).then((function(){t._aplQC=t._aplQC-1})),this._aplQ.then((function(){return t.isLeader}))},awaitLeadership:function(){return this._aLP||(this._aLP=(e=this).isLeader?G:new Promise((function(t){var n=!1;function r(){n||(n=!0,e.broadcastChannel.removeEventListener("internal",o),t(!0))}e.applyOnce().then((function(){e.isLeader&&r()})),function t(){return q(e._options.fallbackInterval).then((function(){if(!e.isDead&&!n)return e.isLeader?void r():e.applyOnce(!0).then((function(){e.isLeader?r():t()}))}))}();var o=function(t){"leader"===t.context&&"death"===t.action&&(e.hasLeader=!1,e.applyOnce().then((function(){e.isLeader&&r()})))};e.broadcastChannel.addEventListener("internal",o),e._lstns.push(o)}))),this._aLP;var e},set onduplicate(e){this._dpL=e},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this.hasLeader=!1,this.isLeader=!1),this.isDead=!0,Ce(this,"death")}};var Ie=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,s.Z)(this,"tokenManager",void 0),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"channel",void 0),(0,s.Z)(this,"started",!1),(0,s.Z)(this,"enablePostMessage",!0),this.tokenManager=t,this.options=n,this.onTokenAddedHandler=this.onTokenAddedHandler.bind(this),this.onTokenRemovedHandler=this.onTokenRemovedHandler.bind(this),this.onTokenRenewedHandler=this.onTokenRenewedHandler.bind(this),this.onSetStorageHandler=this.onSetStorageHandler.bind(this),this.onSyncMessageHandler=this.onSyncMessageHandler.bind(this)}var t,n;return(0,u.Z)(e,[{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return!!this.options.syncStorage&&(0,E.isBrowser)()&&this.tokenManager.hasSharedStorage()}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){var t;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.canStart()){e.next=11;break}return e.next=3,this.stop();case 3:t=this.options.syncChannelName,this.channel=new me(t),this.tokenManager.on(K.EVENT_ADDED,this.onTokenAddedHandler),this.tokenManager.on(K.EVENT_REMOVED,this.onTokenRemovedHandler),this.tokenManager.on(K.EVENT_RENEWED,this.onTokenRenewedHandler),this.tokenManager.on(K.EVENT_SET_STORAGE,this.onSetStorageHandler),this.channel.addEventListener("message",this.onSyncMessageHandler),this.started=!0;case 11:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){var t,n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=10;break}return this.tokenManager.off(K.EVENT_ADDED,this.onTokenAddedHandler),this.tokenManager.off(K.EVENT_REMOVED,this.onTokenRemovedHandler),this.tokenManager.off(K.EVENT_RENEWED,this.onTokenRenewedHandler),this.tokenManager.off(K.EVENT_SET_STORAGE,this.onSetStorageHandler),null===(t=this.channel)||void 0===t||t.removeEventListener("message",this.onSyncMessageHandler),e.next=8,null===(n=this.channel)||void 0===n?void 0:n.close();case 8:this.channel=void 0,this.started=!1;case 10:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"onTokenAddedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:K.EVENT_ADDED,key:e,token:t}))}},{key:"onTokenRemovedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:K.EVENT_REMOVED,key:e,token:t}))}},{key:"onTokenRenewedHandler",value:function(e,t,n){var r;this.enablePostMessage&&(null===(r=this.channel)||void 0===r||r.postMessage({type:K.EVENT_RENEWED,key:e,token:t,oldToken:n}))}},{key:"onSetStorageHandler",value:function(e){var t;null===(t=this.channel)||void 0===t||t.postMessage({type:K.EVENT_SET_STORAGE,storage:e})}},{key:"onSyncMessageHandler",value:function(e){switch(this.enablePostMessage=!1,e.type){case K.EVENT_SET_STORAGE:this.tokenManager.getStorage().setStorage(e.storage);break;case K.EVENT_ADDED:this.tokenManager.emitAdded(e.key,e.token),this.tokenManager.setExpireEventTimeout(e.key,e.token);break;case K.EVENT_REMOVED:this.tokenManager.clearExpireEventTimeout(e.key),this.tokenManager.emitRemoved(e.key,e.token);break;case K.EVENT_RENEWED:this.tokenManager.emitRenewed(e.key,e.token,e.oldToken)}this.enablePostMessage=!0}}]),e}(),Me=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,a.Z)(this,e),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"channel",void 0),(0,s.Z)(this,"elector",void 0),(0,s.Z)(this,"started",!1),this.options=t,this.onLeaderDuplicate=this.onLeaderDuplicate.bind(this),this.onLeader=this.onLeader.bind(this)}var t,n,r;return(0,u.Z)(e,[{key:"onLeaderDuplicate",value:function(){}},{key:"onLeader",value:(r=(0,i.Z)(f().mark((function e(){var t,n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null===(t=(n=this.options).onLeader)||void 0===t?void 0:t.call(n);case 2:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.isLeader)}},{key:"hasLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.hasLeader)}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){var t;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.stop();case 2:this.canStart()&&(t=this.options.electionChannelName,this.channel=new me(t),this.elector=De(this.channel),this.elector.onduplicate=this.onLeaderDuplicate,this.elector.awaitLeadership().then(this.onLeader),this.started=!0);case 3:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=11;break}if(!this.elector){e.next=5;break}return e.next=4,this.elector.die();case 4:this.elector=void 0;case 5:if(!this.channel){e.next=10;break}return this.channel.postInternal=function(){return Promise.resolve()},e.next=9,this.channel.close();case 9:this.channel=void 0;case 10:this.started=!1;case 11:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return(0,E.isBrowser)()}}]),e}();function Ne(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ue(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ne(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ne(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Le(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return Fe(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Fe(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function Fe(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var He="autoRenew",Ke="syncStorage",Be="leaderElection",Ve=function(){function e(t){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,s.Z)(this,"sdk",void 0),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"services",void 0),(0,s.Z)(this,"started",void 0),this.sdk=t,this.onLeader=this.onLeader.bind(this);var o=t.tokenManager.getOptions(),i=o.autoRenew,u=o.autoRemove,c=o.syncStorage;r.electionChannelName=r.electionChannelName||r.broadcastChannelName,this.options=Object.assign({},e.defaultOptions,{autoRenew:i,autoRemove:u,syncStorage:c},{electionChannelName:"".concat(t.options.clientId,"-election"),syncChannelName:"".concat(t.options.clientId,"-sync")},(0,d.YY)(r)),this.started=!1,this.services=new Map,e.knownServices.forEach((function(e){var t=n.createService(e);t&&n.services.set(e,t)}))}var t,n,r,o,c;return(0,u.Z)(e,[{key:"onLeader",value:(c=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=3;break}return e.next=3,this.startServices();case 3:case"end":return e.stop()}}),e,this)}))),function(){return c.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return null===(e=this.getService(Be))||void 0===e?void 0:e.isLeader()}},{key:"isLeaderRequired",value:function(){return(0,F.Z)(this.services.values()).some((function(e){return e.canStart()&&e.requiresLeadership()}))}},{key:"start",value:(o=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,this.startServices();case 4:this.started=!0;case 5:case"end":return e.stop()}}),e,this)}))),function(){return o.apply(this,arguments)})},{key:"stop",value:(r=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.stopServices();case 2:this.started=!1;case 3:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"getService",value:function(e){return this.services.get(e)}},{key:"startServices",value:(n=(0,i.Z)(f().mark((function e(){var t,n,r,o,i;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=Le(this.services.entries()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=10;break}if(r=(0,L.Z)(n.value,2),o=r[0],i=r[1],!this.canStartService(o,i)){e.next=8;break}return e.next=8,i.start();case 8:e.next=3;break;case 10:e.next=15;break;case 12:e.prev=12,e.t0=e.catch(1),t.e(e.t0);case 15:return e.prev=15,t.f(),e.finish(15);case 18:case"end":return e.stop()}}),e,this,[[1,12,15,18]])}))),function(){return n.apply(this,arguments)})},{key:"stopServices",value:(t=(0,i.Z)(f().mark((function e(){var t,n,r;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=Le(this.services.values()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=9;break}return r=n.value,e.next=7,r.stop();case 7:e.next=3;break;case 9:e.next=14;break;case 11:e.prev=11,e.t0=e.catch(1),t.e(e.t0);case 14:return e.prev=14,t.f(),e.finish(14);case 17:case"end":return e.stop()}}),e,this,[[1,11,14,17]])}))),function(){return t.apply(this,arguments)})},{key:"canStartService",value:function(e,t){var n=t.canStart()&&!t.isStarted();return e===Be?n&&(n=this.isLeaderRequired()):t.requiresLeadership()&&n&&(n=this.isLeader()),n}},{key:"createService",value:function(e){var t,n=this.sdk.tokenManager;switch(e){case Be:t=new Me(Ue(Ue({},this.options),{},{onLeader:this.onLeader}));break;case He:t=new B(n,Ue({},this.options));break;case Ke:t=new Ie(n,Ue({},this.options));break;default:throw new Error("Unknown service ".concat(e))}return t}}]),e}();(0,s.Z)(Ve,"knownServices",[He,Ke,Be]),(0,s.Z)(Ve,"defaultOptions",{autoRenew:!0,autoRemove:!0,syncStorage:!0});var Ge=n(5991);function qe(e,t){return t=t||{},(0,E.isFingerprintSupported)()?new Promise((function(i,a){var u;(r=document.createElement("iframe")).style.display="none",o=function(t){if(t&&t.data&&t.origin===e.getIssuerOrigin()){try{var n=JSON.parse(t.data)}catch(e){return}if(n)return"FingerprintAvailable"===n.type?i(n.fingerprint):void("FingerprintServiceReady"===n.type&&t.source.postMessage(JSON.stringify({type:"GetFingerprint"}),t.origin))}},(0,O.NH)(window,"message",o),r.src=e.getIssuerOrigin()+"/auth/services/devicefingerprint",document.body.appendChild(r),n=setTimeout((function(){a(new H.R("Fingerprinting timed out"))}),(null===(u=t)||void 0===u?void 0:u.timeout)||15e3)})).finally((function(){clearTimeout(n),(0,O.ys)(window,"message",o),document.body.contains(r)&&r.parentElement.removeChild(r)})):Promise.reject(new H.R("Fingerprinting is not supported on this device"));var n,r,o}var Ye=n(7913),We=n(6311),ze=n(6529);function $e(e){var t=(e=e||{}).scopes;if(t&&!Array.isArray(t))throw new D.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');var n=e.issuer;if(!n)throw new D.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(n))throw new D.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==n.indexOf("-admin."))throw new D.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})')}var Qe=n(1002),Xe=n(4098),Je=n.n(Xe);function et(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var tt=/application\/\w*\+?json/,nt=function(e,t,r){var o=r.data,i=r.headers||{},a=i["Content-Type"]||i["content-type"]||"";o&&"string"!=typeof o&&(tt.test(a)?o=JSON.stringify(o):"application/x-www-form-urlencoded"===a&&(o=Object.entries(o).map((function(e){var t=(0,L.Z)(e,2),n=t[0],r=t[1];return"".concat(n,"=").concat(encodeURIComponent(r))})).join("&")));var u=(n.g.fetch||Je())(t,{method:e,headers:r.headers,body:o,credentials:r.withCredentials?"include":"omit"});return u.finally||(u=Promise.resolve(u)),u.then((function(e){var t=!e.ok,n=e.status;return function(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch((function(e){return{error:e,errorSummary:"Could not parse server response"}})):e.text()}(e).then((function(t){return function(e,t,n){var r,o="object"===(0,Qe.Z)(t),i={},a=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return et(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?et(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(n.headers.entries());try{for(a.s();!(r=a.n()).done;){var u=r.value;i[u[0]]=u[1]}}catch(e){a.e(e)}finally{a.f()}var s={responseText:o?JSON.stringify(t):t,status:e,headers:i};return o&&(s.responseType="json",s.responseJSON=t),s}(n,t,e)})).then((function(e){var n;if(t||null!==(n=e.responseJSON)&&void 0!==n&&n.error)throw e;return e}))}))},rt={token:{storageTypes:["localStorage","sessionStorage","cookie"]},cache:{storageTypes:["localStorage","sessionStorage","cookie"]},transaction:{storageTypes:["sessionStorage","localStorage","cookie"]},"shared-transaction":{storageTypes:["localStorage"]},"original-uri":{storageTypes:["localStorage"]}};function ot(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0,n=e.cookies||{};return void 0===n.secure&&(n.secure=t),void 0===n.sameSite&&(n.sameSite=n.secure?"none":"lax"),n.secure&&!t&&((0,I.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),n.secure=!1),"none"!==n.sameSite||n.secure||(n.sameSite="lax"),n}function it(){return{devMode:!1,httpRequestClient:nt,storageUtil:Object.assign({},N,{inMemoryStore:{}}),storageManager:rt,transactionManager:{enableSharedStorage:!0}}}function at(e,t){return Object.assign({},e,(0,d.YY)(t),{storageManager:Object.assign({},e.storageManager,t.storageManager),transactionManager:Object.assign({},e.transactionManager,t.transactionManager)})}var ut=n(4516),st=function(){function e(){(0,a.Z)(this,e),(0,s.Z)(this,"environments",void 0),this.environments=["okta-auth-js/".concat("6.9.0")]}return(0,u.Z)(e,[{key:"addEnvironment",value:function(e){this.environments.push(e)}},{key:"getHttpHeader",value:function(){return this.maybeAddNodeEnvironment(),{"X-Okta-User-Agent-Extended":this.environments.join(" ")}}},{key:"getVersion",value:function(){return"6.9.0"}},{key:"maybeAddNodeEnvironment",value:function(){if(!(0,E.isBrowser)()&&process&&process.versions){var e=process.versions.node;this.environments.push("nodejs/".concat(e))}}}]),e}(),ct=n(5372),ft=n(2620),lt=n(4279),pt=n.n(lt),ht=n(5294),dt=["originalUri"];function vt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function yt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):vt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var gt=function(){function e(t){var n=this;(0,a.Z)(this,e),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"storageManager",void 0),(0,s.Z)(this,"transactionManager",void 0),(0,s.Z)(this,"tx",void 0),(0,s.Z)(this,"idx",void 0),(0,s.Z)(this,"session",void 0),(0,s.Z)(this,"pkce",void 0),(0,s.Z)(this,"features",E),(0,s.Z)(this,"token",void 0),(0,s.Z)(this,"_tokenQueue",void 0),(0,s.Z)(this,"emitter",void 0),(0,s.Z)(this,"tokenManager",void 0),(0,s.Z)(this,"authStateManager",void 0),(0,s.Z)(this,"serviceManager",void 0),(0,s.Z)(this,"http",void 0),(0,s.Z)(this,"fingerprint",void 0),(0,s.Z)(this,"_oktaUserAgent",void 0),(0,s.Z)(this,"_pending",void 0);var r=this.options=function(){var e,t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return $e(n),n=at(it(),n),(0,d.YY)({issuer:(0,v.Qj)(n.issuer),tokenUrl:(0,v.Qj)(n.tokenUrl),authorizeUrl:(0,v.Qj)(n.authorizeUrl),userinfoUrl:(0,v.Qj)(n.userinfoUrl),revokeUrl:(0,v.Qj)(n.revokeUrl),logoutUrl:(0,v.Qj)(n.logoutUrl),clientId:n.clientId,redirectUri:n.redirectUri,state:n.state,scopes:n.scopes,postLogoutRedirectUri:n.postLogoutRedirectUri,responseMode:n.responseMode,responseType:n.responseType,pkce:!1!==n.pkce,useInteractionCodeFlow:n.useInteractionCodeFlow,httpRequestClient:n.httpRequestClient,httpRequestInterceptors:n.httpRequestInterceptors,transformErrorXHR:n.transformErrorXHR,transformAuthState:n.transformAuthState,restoreOriginalUri:n.restoreOriginalUri,storageUtil:n.storageUtil,headers:n.headers,devMode:!!n.devMode,storageManager:n.storageManager,transactionManager:n.transactionManager,cookies:ot(n,(0,E.isHTTPS)()),flow:n.flow,codeChallenge:n.codeChallenge,codeChallengeMethod:n.codeChallengeMethod,recoveryToken:n.recoveryToken,activationToken:n.activationToken,idx:{useGenericRemediator:!(null===(e=n.idx)||void 0===e||!e.useGenericRemediator),exchangeCodeForTokens:!1!==(null===(t=n.idx)||void 0===t?void 0:t.exchangeCodeForTokens)},ignoreSignature:!!n.ignoreSignature,clientSecret:n.clientSecret,setLocation:n.setLocation})}(t);this.storageManager=new We.A(r.storageManager,r.cookies,r.storageUtil),this.transactionManager=new ze.Z(Object.assign({storageManager:this.storageManager},r.transactionManager)),this._oktaUserAgent=new st,this.tx={status:p.transactionStatus.bind(null,this),resume:p.resumeTransaction.bind(null,this),exists:Object.assign(p.transactionExists.bind(null,this),{_get:function(e){return r.storageUtil.storage.get(e)}}),introspect:p.introspectAuthn.bind(null,this),createTransaction:function(e){return new p.AuthTransaction(n,e)},postToTransaction:function(e,t,r){return(0,p.postToTransaction)(n,e,t,r)}},this.pkce={DEFAULT_CODE_CHALLENGE_METHOD:h.Z.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:h.Z.generateVerifier,computeChallenge:h.Z.computeChallenge},Object.assign(this.options.storageUtil||{},{getPKCEStorage:this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),getHttpCache:this.storageManager.getHttpCache.bind(this.storageManager)}),this._pending={handleLogin:!1},(0,E.isBrowser)()&&(this.options=Object.assign(this.options,{redirectUri:(0,v.BY)(t.redirectUri,window.location.origin)})),t.maxClockSkew||0===t.maxClockSkew?this.options.maxClockSkew=t.maxClockSkew:this.options.maxClockSkew=l.DEFAULT_MAX_CLOCK_SKEW,this.options.ignoreLifetime=!!t.ignoreLifetime,this.session={close:b.bind(null,this),exists:g.bind(null,this),get:m.bind(null,this),refresh:k.bind(null,this),setCookieAndRedirect:w.bind(null,this)},this._tokenQueue=new Ge.Z;var o=function(e){return Ge.Z.prototype.push.bind(n._tokenQueue,e,null)},i=o(O.Hq.bind(null,this)),u=Object.assign(i,{_setLocation:function(e){r.setLocation?r.setLocation(e):window.location=e}}),c=o(O.ko.bind(null,this)),f=Object.assign(c,{_getHistory:function(){return window.history},_getLocation:function(){return window.location},_getDocument:function(){return window.document}});this.token={prepareTokenParams:O.wu.bind(null,this),exchangeCodeForTokens:O.rz.bind(null,this),getWithoutPrompt:O.y6.bind(null,this),getWithPopup:O.dh.bind(null,this),getWithRedirect:u,parseFromUrl:f,decode:O.TD,revoke:O.PX.bind(null,this),renew:O.$m.bind(null,this),renewTokensWithRefresh:O.Rm.bind(null,this),renewTokens:O.IK.bind(null,this),getUserInfo:function(e,t){return(0,O.bG)(n,e,t)},verify:O.WX.bind(null,this),isLoginRedirect:O.gM.bind(null,this)},["getWithoutPrompt","getWithPopup","revoke","renew","renewTokensWithRefresh","renewTokens"].forEach((function(e){n.token[e]=o(n.token[e])}));var T=ut.Yr.bind(null,this);this.idx={interact:ut.EW.bind(null,this),introspect:ut.L8.bind(null,this),makeIdxResponse:ht._T.bind(null,this),authenticate:ut.YR.bind(null,this),register:ut.z2.bind(null,this),start:T,startTransaction:T,poll:ut.$l.bind(null,this),proceed:ut.xc.bind(null,this),cancel:ut.al.bind(null,this),recoverPassword:ut.M4.bind(null,this),handleInteractionCodeRedirect:ut.Xx.bind(null,this),isInteractionRequired:O.wc.bind(null,this),isInteractionRequiredError:O.Cf,handleEmailVerifyCallback:ut.Jn.bind(null,this),isEmailVerifyCallback:ut.GA,parseEmailVerifyCallback:ut.mo,isEmailVerifyCallbackError:ut.gc,getSavedTransactionMeta:ft.uN.bind(null,this),createTransactionMeta:ft.Xc.bind(null,this),getTransactionMeta:ft.Co.bind(null,this),saveTransactionMeta:ft.r0.bind(null,this),clearTransactionMeta:ft.Jm.bind(null,this),isTransactionMetaValid:ft.Wf,setFlow:function(e){n.options.flow=e},getFlow:function(){return n.options.flow},canProceed:ut.Ch.bind(null,this),unlockAccount:ut.le.bind(null,this)},this.http={setRequestHeader:y.rn.bind(null,this)},this.fingerprint=qe.bind(null,this),this.emitter=new(pt()),this.tokenManager=new U.M(this,t.tokenManager),this.authStateManager=new Ye.E(this),this.serviceManager=new Ve(this,t.services)}var t,n,r,c,T,S,_,A,P,R,x,Z,j;return(0,u.Z)(e,[{key:"start",value:(j=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.serviceManager.start();case 2:if(this.tokenManager.start(),this.token.isLoginRedirect()){e.next=6;break}return e.next=6,this.authStateManager.updateAuthState();case 6:case"end":return e.stop()}}),e,this)}))),function(){return j.apply(this,arguments)})},{key:"stop",value:(Z=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.tokenManager.stop(),e.next=3,this.serviceManager.stop();case 3:case"end":return e.stop()}}),e,this)}))),function(){return Z.apply(this,arguments)})},{key:"setHeaders",value:function(e){this.options.headers=Object.assign({},this.options.headers,e)}},{key:"signIn",value:(x=(0,i.Z)(f().mark((function e(t){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.signInWithCredentials(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return x.apply(this,arguments)})},{key:"signInWithCredentials",value:(R=(0,i.Z)(f().mark((function e(t){var n,r=this;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=(0,d.d9)(t||{}),n=function(e){return delete t.sendFingerprint,(0,p.postToTransaction)(r,"/api/v1/authn",t,e)},t.sendFingerprint){e.next=4;break}return e.abrupt("return",n());case 4:return e.abrupt("return",this.fingerprint().then((function(e){return n({headers:{"X-Device-Fingerprint":e}})})));case 5:case"end":return e.stop()}}),e,this)}))),function(e){return R.apply(this,arguments)})},{key:"signInWithRedirect",value:(P=(0,i.Z)(f().mark((function e(){var t,n,r,i,a=arguments;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=a.length>0&&void 0!==a[0]?a[0]:{},n=t.originalUri,r=(0,o.Z)(t,dt),!this._pending.handleLogin){e.next=4;break}return e.abrupt("return");case 4:return this._pending.handleLogin=!0,e.prev=5,n&&this.setOriginalUri(n),i=Object.assign({scopes:this.options.scopes||["openid","email","profile"]},r),e.next=10,this.token.getWithRedirect(i);case 10:return e.prev=10,this._pending.handleLogin=!1,e.finish(10);case 13:case"end":return e.stop()}}),e,this,[[5,,10,13]])}))),function(){return P.apply(this,arguments)})},{key:"closeSession",value:function(){var e=this;return this.session.close().then((0,i.Z)(f().mark((function t(){return f().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:e.tokenManager.clear();case 1:case"end":return t.stop()}}),t)})))).catch((function(e){if("AuthApiError"===e.name&&"E0000007"===e.errorCode)return null;throw e}))}},{key:"revokeAccessToken",value:(A=(0,i.Z)(f().mark((function e(t){var n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=6;break}return e.next=3,this.tokenManager.getTokens();case 3:t=e.sent.accessToken,n=this.tokenManager.getStorageKeyByType("accessToken"),this.tokenManager.remove(n);case 6:if(t){e.next=8;break}return e.abrupt("return",Promise.resolve(null));case 8:return e.abrupt("return",this.token.revoke(t));case 9:case"end":return e.stop()}}),e,this)}))),function(e){return A.apply(this,arguments)})},{key:"revokeRefreshToken",value:(_=(0,i.Z)(f().mark((function e(t){var n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=6;break}return e.next=3,this.tokenManager.getTokens();case 3:t=e.sent.refreshToken,n=this.tokenManager.getStorageKeyByType("refreshToken"),this.tokenManager.remove(n);case 6:if(t){e.next=8;break}return e.abrupt("return",Promise.resolve(null));case 8:return e.abrupt("return",this.token.revoke(t));case 9:case"end":return e.stop()}}),e,this)}))),function(e){return _.apply(this,arguments)})},{key:"getSignOutRedirectUrl",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.idToken,n=e.postLogoutRedirectUri,r=e.state;if(t||(t=this.tokenManager.getTokensSync().idToken),!t)return"";n||(n=this.options.postLogoutRedirectUri);var o=(0,O.Fc)(this).logoutUrl,i=t.idToken,a=o+"?id_token_hint="+encodeURIComponent(i);return n&&(a+="&post_logout_redirect_uri="+encodeURIComponent(n)),r&&(a+="&state="+encodeURIComponent(r)),a}},{key:"signOut",value:(S=(0,i.Z)(f().mark((function e(t){var n,r,o,i,a,u,s,c;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=Object.assign({},t),n=window.location.origin,r=window.location.href,o=t.postLogoutRedirectUri||this.options.postLogoutRedirectUri||n,i=t.accessToken,a=t.refreshToken,u=!1!==t.revokeAccessToken,(s=!1!==t.revokeRefreshToken)&&void 0===a&&(a=this.tokenManager.getTokensSync().refreshToken),u&&void 0===i&&(i=this.tokenManager.getTokensSync().accessToken),t.idToken||(t.idToken=this.tokenManager.getTokensSync().idToken),!s||!a){e.next=14;break}return e.next=14,this.revokeRefreshToken(a);case 14:if(!u||!i){e.next=17;break}return e.next=17,this.revokeAccessToken(i);case 17:if(c=this.getSignOutRedirectUrl(yt(yt({},t),{},{postLogoutRedirectUri:o}))){e.next=22;break}return e.abrupt("return",this.closeSession().then((function(){o===r?window.location.reload():window.location.assign(o)})));case 22:t.clearTokensBeforeRedirect?this.tokenManager.clear():this.tokenManager.addPendingRemoveFlags(),window.location.assign(c);case 24:case"end":return e.stop()}}),e,this)}))),function(e){return S.apply(this,arguments)})},{key:"webfinger",value:function(e){var t="/.well-known/webfinger"+(0,v.UK)(e);return(0,y.U2)(this,t,{headers:{Accept:"application/jrd+json"}})}},{key:"isAuthenticated",value:(T=(0,i.Z)(f().mark((function e(){var t,n,r,o,i,a,u,s,c,l,p=arguments;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=p.length>0&&void 0!==p[0]?p[0]:{},n=this.tokenManager.getOptions(),r=n.autoRenew,o=n.autoRemove,i=t.onExpiredToken?"renew"===t.onExpiredToken:r,a=t.onExpiredToken?"remove"===t.onExpiredToken:o,u=this.tokenManager.getTokensSync(),!(s=u.accessToken)||!this.tokenManager.hasExpired(s)){e.next=19;break}if(s=void 0,!i){e.next=18;break}return e.prev=8,e.next=11,this.tokenManager.renew("accessToken");case 11:s=e.sent,e.next=16;break;case 14:e.prev=14,e.t0=e.catch(8);case 16:e.next=19;break;case 18:a&&this.tokenManager.remove("accessToken");case 19:if(c=this.tokenManager.getTokensSync(),!(l=c.idToken)||!this.tokenManager.hasExpired(l)){e.next=34;break}if(l=void 0,!i){e.next=33;break}return e.prev=23,e.next=26,this.tokenManager.renew("idToken");case 26:l=e.sent,e.next=31;break;case 29:e.prev=29,e.t1=e.catch(23);case 31:e.next=34;break;case 33:a&&this.tokenManager.remove("idToken");case 34:return e.abrupt("return",!(!s||!l));case 35:case"end":return e.stop()}}),e,this,[[8,14],[23,29]])}))),function(){return T.apply(this,arguments)})},{key:"getUser",value:(c=(0,i.Z)(f().mark((function e(){var t,n,r;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=this.tokenManager.getTokensSync(),n=t.idToken,r=t.accessToken,e.abrupt("return",this.token.getUserInfo(r,n));case 2:case"end":return e.stop()}}),e,this)}))),function(){return c.apply(this,arguments)})},{key:"getIdToken",value:function(){var e=this.tokenManager.getTokensSync().idToken;return e?e.idToken:void 0}},{key:"getAccessToken",value:function(){var e=this.tokenManager.getTokensSync().accessToken;return e?e.accessToken:void 0}},{key:"getRefreshToken",value:function(){var e=this.tokenManager.getTokensSync().refreshToken;return e?e.refreshToken:void 0}},{key:"storeTokensFromRedirect",value:(r=(0,i.Z)(f().mark((function e(){var t,n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.token.parseFromUrl();case 2:t=e.sent,n=t.tokens,this.tokenManager.setTokens(n);case 5:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"setOriginalUri",value:function(e,t){N.getSessionStorage().setItem(l.REFERRER_PATH_STORAGE_KEY,e),(t=t||this.options.state)&&this.storageManager.getOriginalUriStorage().setItem(t,e)}},{key:"getOriginalUri",value:function(e){if(e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage().getItem(e);if(t)return t}var n=N.getSessionStorage();return n&&n.getItem(l.REFERRER_PATH_STORAGE_KEY)||void 0}},{key:"removeOriginalUri",value:function(e){if(N.getSessionStorage().removeItem(l.REFERRER_PATH_STORAGE_KEY),e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage();t.removeItem&&t.removeItem(e)}}},{key:"isLoginRedirect",value:function(){return(0,O.gM)(this)}},{key:"handleLoginRedirect",value:(n=(0,i.Z)(f().mark((function e(t,n){var r,o,i;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=this.options.state,!t){e.next=6;break}this.tokenManager.setTokens(t),n=n||this.getOriginalUri(this.options.state),e.next=25;break;case 6:if(!this.isLoginRedirect()){e.next=24;break}return e.prev=7,e.next=10,(0,ct.Tp)(this,{});case 10:return o=e.sent,r=o.state,n=n||this.getOriginalUri(r),e.next=15,this.storeTokensFromRedirect();case 15:e.next=22;break;case 17:return e.prev=17,e.t0=e.catch(7),e.next=21,this.authStateManager.updateAuthState();case 21:throw e.t0;case 22:e.next=25;break;case 24:return e.abrupt("return");case 25:return e.next=27,this.authStateManager.updateAuthState();case 27:if(this.removeOriginalUri(r),!(i=this.options.restoreOriginalUri)){e.next=34;break}return e.next=32,i(this,n);case 32:e.next=35;break;case 34:n&&window.location.replace(n);case 35:case"end":return e.stop()}}),e,this,[[7,17]])}))),function(e,t){return n.apply(this,arguments)})},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return Array.isArray(this.options.responseType)&&this.options.responseType.length?this.options.responseType.indexOf(e)>=0:this.options.responseType===e}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}},{key:"getIssuerOrigin",value:function(){return this.options.issuer.split("/oauth2/")[0]}},{key:"forgotPassword",value:function(e){return(0,p.postToTransaction)(this,"/api/v1/authn/recovery/password",e)}},{key:"unlockAccount",value:function(e){return(0,p.postToTransaction)(this,"/api/v1/authn/recovery/unlock",e)}},{key:"verifyRecoveryToken",value:function(e){return(0,p.postToTransaction)(this,"/api/v1/authn/recovery/token",e)}},{key:"invokeApiMethod",value:(t=(0,i.Z)(f().mark((function e(t){var n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t.accessToken){e.next=5;break}return e.next=3,this.tokenManager.getTokens();case 3:n=e.sent.accessToken,t.accessToken=null==n?void 0:n.accessToken;case 5:return e.abrupt("return",(0,y.c3)(this,t));case 6:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})}]),e}();(0,s.Z)(gt,"features",E),(0,s.Z)(gt,"crypto",T),(0,s.Z)(gt,"webauthn",r),gt.features=gt.prototype.features=E,Object.assign(gt,{constants:l});var mt=gt},5991:function(e,t,n){"use strict";var r=n(5671),o=n(3144),i=n(4942),a=n(146),u=n(4771),s=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{quiet:!1};(0,r.Z)(this,e),(0,i.Z)(this,"queue",void 0),(0,i.Z)(this,"running",void 0),(0,i.Z)(this,"options",void 0),this.queue=[],this.running=!1,this.options=t}return(0,o.Z)(e,[{key:"push",value:function(e,t){for(var n=this,r=arguments.length,o=new Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];return new Promise((function(r,i){n.queue.length>0&&!1!==n.options.quiet&&(0,a.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."),n.queue.push({method:e,thisObject:t,args:o,resolve:r,reject:i}),n.run()}))}},{key:"run",value:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),n=t.method.apply(t.thisObject,t.args);(0,u.tI)(n)?n.then(t.resolve,t.reject).finally((function(){e.running=!1,e.run()})):(t.resolve(n),this.running=!1,this.run())}}}]),e}();t.Z=s},6311:function(e,t,n){"use strict";n.d(t,{A:function(){return d}});var r=n(5671),o=n(3144),i=n(4942),a=n(1971),u=n(9123),s=n(1524),c=function(){function e(t,n){if((0,r.Z)(this,e),(0,i.Z)(this,"storageProvider",void 0),(0,i.Z)(this,"storageName",void 0),!t)throw new u.Z('"storage" is required');if("string"!=typeof n||!n.length)throw new u.Z('"storageName" is required');this.storageName=n,this.storageProvider=t}return(0,o.Z)(e,[{key:"getItem",value:function(e){return this.getStorage()[e]}},{key:"setItem",value:function(e,t){return this.updateStorage(e,t)}},{key:"removeItem",value:function(e){return this.clearStorage(e)}},{key:"isSharedStorage",value:function(){var e,t;return(0,s.f)()&&this.storageProvider===localStorage||!(null===(e=(t=this.storageProvider).isSharedStorage)||void 0===e||!e.call(t))}},{key:"getStorage",value:function(){var e=this.storageProvider.getItem(this.storageName);e=e||"{}";try{return JSON.parse(e)}catch(e){throw new u.Z("Unable to parse storage string: "+this.storageName)}}},{key:"setStorage",value:function(e){try{var t=e?JSON.stringify(e):"{}";this.storageProvider.setItem(this.storageName,t)}catch(e){throw new u.Z("Unable to set storage: "+this.storageName)}}},{key:"clearStorage",value:function(e){if(e){var t=this.getStorage();delete t[e],this.setStorage(t)}else this.storageProvider.removeItem?this.storageProvider.removeItem(this.storageName):this.setStorage()}},{key:"updateStorage",value:function(e,t){var n=this.getStorage();n[e]=t,this.setStorage(n)}}]),e}(),f=n(415),l=n(146),p=n(7301);function h(e){(0,f.isBrowser)()||e.storageProvider||e.storageProvider||(0,l.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.")}var d=function(){function e(t,n,o){(0,r.Z)(this,e),(0,i.Z)(this,"storageManagerOptions",void 0),(0,i.Z)(this,"cookieOptions",void 0),(0,i.Z)(this,"storageUtil",void 0),this.storageManagerOptions=t,this.cookieOptions=n,this.storageUtil=o}return(0,o.Z)(e,[{key:"getOptionsForSection",value:function(e,t){return Object.assign({},this.storageManagerOptions[e],t)}},{key:"getStorage",value:function(e){if((e=Object.assign({},this.cookieOptions,e)).storageProvider)return e.storageProvider;var t=e,n=t.storageType,r=t.storageTypes;if("sessionStorage"===n&&(e.sessionCookie=!0),n&&r){var o=r.indexOf(n);o>=0&&(r=r.slice(o),n=void 0)}return n||(n=this.storageUtil.findStorageType(r)),this.storageUtil.getStorageByType(n,e)}},{key:"getTransactionStorage",value:function(e){h(e=this.getOptionsForSection("transaction",e));var t=this.getStorage(e),n=e.storageKey||a.TRANSACTION_STORAGE_NAME;return new c(t,n)}},{key:"getSharedTansactionStorage",value:function(e){h(e=this.getOptionsForSection("shared-transaction",e));var t=this.getStorage(e),n=e.storageKey||a.SHARED_TRANSACTION_STORAGE_NAME;return new c(t,n)}},{key:"getOriginalUriStorage",value:function(e){h(e=this.getOptionsForSection("original-uri",e));var t=this.getStorage(e),n=e.storageKey||a.ORIGINAL_URI_STORAGE_NAME;return new c(t,n)}},{key:"getIdxResponseStorage",value:function(e){var t;if((0,f.isBrowser)())try{t=this.storageUtil.getStorageByType("memory",e)}catch(e){(0,l.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic")}else{var n=this.getTransactionStorage(e);n&&(t={getItem:function(e){var t=n.getStorage();return t&&t[e]?t[e]:null},setItem:function(e,t){var r=n.getStorage();if(!r)throw new p.R("Transaction has been cleared, failed to save idxState");r[e]=t,n.setStorage(r)},removeItem:function(e){var t=n.getStorage();t&&(delete t[e],n.setStorage(t))}})}return t?new c(t,a.IDX_RESPONSE_STORAGE_NAME):null}},{key:"getTokenStorage",value:function(e){h(e=this.getOptionsForSection("token",e));var t=this.getStorage(e),n=e.storageKey||a.TOKEN_STORAGE_NAME;return new c(t,n)}},{key:"getHttpCache",value:function(e){e=this.getOptionsForSection("cache",e);var t=this.getStorage(e),n=e.storageKey||a.CACHE_STORAGE_NAME;return new c(t,n)}},{key:"getLegacyPKCEStorage",value:function(e){e=this.getOptionsForSection("legacy-pkce",e);var t=this.getStorage(e),n=e.storageKey||a.PKCE_STORAGE_NAME;return new c(t,n)}},{key:"getLegacyOAuthParamsStorage",value:function(e){e=this.getOptionsForSection("legacy-oauth-params",e);var t=this.getStorage(e),n=e.storageKey||a.REDIRECT_OAUTH_PARAMS_NAME;return new c(t,n)}}]),e}()},8092:function(e,t,n){"use strict";n.d(t,{M:function(){return k}});var r=n(5861),o=n(1002),i=n(5671),a=n(3144),u=n(4942),s=n(7757),c=n.n(s),f=n(3193),l=n(7301),p=n(1060),h=n(415),d=function(){function e(t){(0,i.Z)(this,e),(0,u.Z)(this,"localOffset",void 0),this.localOffset=parseInt(t||0)}return(0,a.Z)(e,[{key:"now",value:function(){return(Date.now()+this.localOffset)/1e3}}],[{key:"create",value:function(){return new e(0)}}]),e}(),v=n(2852),y=n(1971);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var b={autoRenew:!0,autoRemove:!0,syncStorage:!0,clearPendingRemoveTokens:!0,storage:void 0,expireEarlySeconds:30,storageKey:y.TOKEN_STORAGE_NAME},k=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if((0,i.Z)(this,e),(0,u.Z)(this,"sdk",void 0),(0,u.Z)(this,"clock",void 0),(0,u.Z)(this,"emitter",void 0),(0,u.Z)(this,"storage",void 0),(0,u.Z)(this,"state",void 0),(0,u.Z)(this,"options",void 0),this.sdk=t,this.emitter=t.emitter,!this.emitter)throw new l.R("Emitter should be initialized before TokenManager");n=Object.assign({},b,(0,f.YY)(n)),(0,h.isLocalhost)()||(n.expireEarlySeconds=b.expireEarlySeconds),this.options=n;var r=(0,f.YY)({storageKey:n.storageKey,secure:n.secure});"object"===(0,o.Z)(n.storage)?r.storageProvider=n.storage:n.storage&&(r.storageType=n.storage),this.storage=t.storageManager.getTokenStorage(m(m({},r),{},{useSeparateCookies:!0})),this.clock=d.create(),this.state={expireTimeouts:{},renewPromise:null}}var t,n,s;return(0,a.Z)(e,[{key:"on",value:function(e,t,n){n?this.emitter.on(e,t,n):this.emitter.on(e,t)}},{key:"off",value:function(e,t){t?this.emitter.off(e,t):this.emitter.off(e)}},{key:"hasSharedStorage",value:function(){return this.storage.isSharedStorage()}},{key:"start",value:function(){this.options.clearPendingRemoveTokens&&this.clearPendingRemoveTokens(),this.setExpireEventTimeoutAll()}},{key:"stop",value:function(){this.clearExpireEventTimeoutAll()}},{key:"getOptions",value:function(){return(0,f.d9)(this.options)}},{key:"getExpireTime",value:function(e){var t=this.options.expireEarlySeconds||0;return e.expiresAt-t}},{key:"hasExpired",value:function(e){return this.getExpireTime(e)<=this.clock.now()}},{key:"emitExpired",value:function(e,t){this.emitter.emit(v.EVENT_EXPIRED,e,t)}},{key:"emitRenewed",value:function(e,t,n){this.emitter.emit(v.EVENT_RENEWED,e,t,n)}},{key:"emitAdded",value:function(e,t){this.emitter.emit(v.EVENT_ADDED,e,t)}},{key:"emitRemoved",value:function(e,t){this.emitter.emit(v.EVENT_REMOVED,e,t)}},{key:"emitError",value:function(e){this.emitter.emit(v.EVENT_ERROR,e)}},{key:"clearExpireEventTimeout",value:function(e){clearTimeout(this.state.expireTimeouts[e]),delete this.state.expireTimeouts[e],this.state.renewPromise=null}},{key:"clearExpireEventTimeoutAll",value:function(){var e=this.state.expireTimeouts;for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&this.clearExpireEventTimeout(t)}},{key:"setExpireEventTimeout",value:function(e,t){var n=this;if(!(0,v.isRefreshToken)(t)){var r=this.getExpireTime(t),o=1e3*Math.max(r-this.clock.now(),0);this.clearExpireEventTimeout(e);var i=setTimeout((function(){n.emitExpired(e,t)}),o);this.state.expireTimeouts[e]=i}}},{key:"setExpireEventTimeoutAll",value:function(){var e=this.storage.getStorage();for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var n=e[t];this.setExpireEventTimeout(t,n)}}},{key:"resetExpireEventTimeoutAll",value:function(){this.clearExpireEventTimeoutAll(),this.setExpireEventTimeoutAll()}},{key:"add",value:function(e,t){var n=this.storage.getStorage();(0,p.Rp)(t),n[e]=t,this.storage.setStorage(n),this.emitSetStorageEvent(),this.emitAdded(e,t),this.setExpireEventTimeout(e,t)}},{key:"getSync",value:function(e){return this.storage.getStorage()[e]}},{key:"get",value:(s=(0,r.Z)(c().mark((function e(t){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getSync(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return s.apply(this,arguments)})},{key:"getTokensSync",value:function(){var e={},t=this.storage.getStorage();return Object.keys(t).forEach((function(n){var r=t[n];(0,v.isAccessToken)(r)?e.accessToken=r:(0,v.isIDToken)(r)?e.idToken=r:(0,v.isRefreshToken)(r)&&(e.refreshToken=r)})),e}},{key:"getTokens",value:(n=(0,r.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getTokensSync());case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"getStorageKeyByType",value:function(e){var t=this.storage.getStorage();return Object.keys(t).filter((function(n){var r=t[n];return(0,v.isAccessToken)(r)&&"accessToken"===e||(0,v.isIDToken)(r)&&"idToken"===e||(0,v.isRefreshToken)(r)&&"refreshToken"===e}))[0]}},{key:"getTokenType",value:function(e){if((0,v.isAccessToken)(e))return"accessToken";if((0,v.isIDToken)(e))return"idToken";if((0,v.isRefreshToken)(e))return"refreshToken";throw new l.R("Unknown token type")}},{key:"emitSetStorageEvent",value:function(){if((0,h.isIE11OrLess)()){var e=this.storage.getStorage();this.emitter.emit(v.EVENT_SET_STORAGE,e)}}},{key:"getStorage",value:function(){return this.storage}},{key:"setTokens",value:function(e,t,n,r){var o=this,i=function(e,i){var a=o.getTokenType(i);"accessToken"===a?t&&t(e,i):"idToken"===a?n&&n(e,i):"refreshToken"===a&&r&&r(e,i)},a=function(e,t){o.emitAdded(e,t),o.setExpireEventTimeout(e,t),i(e,t)},u=function(e,t){o.clearExpireEventTimeout(e),o.emitRemoved(e,t),i(e,t)},s=["idToken","accessToken","refreshToken"],c=this.getTokensSync();s.forEach((function(t){var n=e[t];n&&(0,p.Rp)(n,t)}));var f=s.reduce((function(t,n){var r=e[n];return r&&(t[o.getStorageKeyByType(n)||n]=r),t}),{});this.storage.setStorage(f),this.emitSetStorageEvent(),s.forEach((function(t){var n,r,s,f=e[t],l=c[t],p=o.getStorageKeyByType(t)||t;f&&l?(u(p,l),a(p,f),n=p,r=f,s=l,o.emitRenewed(n,r,s),o.clearExpireEventTimeout(n),o.setExpireEventTimeout(n,r),i(n,r)):f?a(p,f):l&&u(p,l)}))}},{key:"remove",value:function(e){this.clearExpireEventTimeout(e);var t=this.storage.getStorage(),n=t[e];delete t[e],this.storage.setStorage(t),this.emitSetStorageEvent(),this.emitRemoved(e,n)}},{key:"renewToken",value:(t=(0,r.Z)(c().mark((function e(t){var n;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",null===(n=this.sdk.token)||void 0===n?void 0:n.renew(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"validateToken",value:function(e){return(0,p.Rp)(e)}},{key:"renew",value:function(e){var t=this;if(this.state.renewPromise)return this.state.renewPromise;try{var n=this.getSync(e);if(!n)throw new l.R("The tokenManager has no token for the key: "+e)}catch(e){return Promise.reject(e)}return this.clearExpireEventTimeout(e),this.state.renewPromise=this.sdk.token.renewTokens().then((function(e){return t.setTokens(e),e[t.getTokenType(n)]})).catch((function(n){throw t.remove(e),n.tokenKey=e,t.emitError(n),n})).finally((function(){t.state.renewPromise=null})),this.state.renewPromise}},{key:"clear",value:function(){var e=this,t=this.getTokensSync();this.clearExpireEventTimeoutAll(),this.storage.clearStorage(),this.emitSetStorageEvent(),Object.keys(t).forEach((function(n){e.emitRemoved(n,t[n])}))}},{key:"clearPendingRemoveTokens",value:function(){var e=this,t=this.storage.getStorage(),n={};Object.keys(t).forEach((function(e){t[e].pendingRemove&&(n[e]=t[e],delete t[e])})),this.storage.setStorage(t),this.emitSetStorageEvent(),Object.keys(n).forEach((function(t){e.clearExpireEventTimeout(t),e.emitRemoved(t,n[t])}))}},{key:"updateRefreshToken",value:function(e){var t=this.getStorageKeyByType("refreshToken")||y.REFRESH_TOKEN_STORAGE_KEY,n=this.storage.getStorage();(0,p.Rp)(e),n[t]=e,this.storage.setStorage(n),this.emitSetStorageEvent()}},{key:"removeRefreshToken",value:function(){var e=this.getStorageKeyByType("refreshToken")||y.REFRESH_TOKEN_STORAGE_KEY;this.remove(e)}},{key:"addPendingRemoveFlags",value:function(){var e=this.getTokensSync();Object.keys(e).forEach((function(t){e[t].pendingRemove=!0})),this.setTokens(e)}}]),e}()},6529:function(e,t,n){"use strict";n.d(t,{Z:function(){return v}});var r=n(5671),o=n(3144),i=n(4942),a=n(7301),u=n(1971),s=n(2852),c=n(480),f=n(146);function l(e){var t=e.getSharedTansactionStorage(),n=t.getStorage();Object.keys(n).forEach((function(e){var t=n[e];Date.now()-t.dateCreated>18e5&&delete n[e]})),t.setStorage(n)}function p(e,t,n){var r=e.getSharedTansactionStorage(),o=r.getStorage();o[t]={dateCreated:Date.now(),transaction:n},r.setStorage(o)}function h(e,t){var n=e.getSharedTansactionStorage().getStorage()[t];return n&&n.transaction&&(0,s.isTransactionMeta)(n.transaction)?n.transaction:null}function d(e,t){var n=e.getSharedTansactionStorage(),r=n.getStorage();delete r[t],n.setStorage(r)}var v=function(){function e(t){(0,r.Z)(this,e),(0,i.Z)(this,"options",void 0),(0,i.Z)(this,"storageManager",void 0),(0,i.Z)(this,"legacyWidgetSupport",void 0),(0,i.Z)(this,"saveNonceCookie",void 0),(0,i.Z)(this,"saveStateCookie",void 0),(0,i.Z)(this,"saveParamsCookie",void 0),(0,i.Z)(this,"enableSharedStorage",void 0),(0,i.Z)(this,"saveLastResponse",void 0),this.storageManager=t.storageManager,this.legacyWidgetSupport=!1!==t.legacyWidgetSupport,this.saveNonceCookie=!1!==t.saveNonceCookie,this.saveStateCookie=!1!==t.saveStateCookie,this.saveParamsCookie=!1!==t.saveParamsCookie,this.enableSharedStorage=!1!==t.enableSharedStorage,this.saveLastResponse=!1!==t.saveLastResponse,this.options=t}return(0,o.Z)(e,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage(),n=t.getStorage();if(t.clearStorage(),this.enableSharedStorage&&!1!==e.clearSharedStorage){var r=e.state||(null==n?void 0:n.state);r&&d(this.storageManager,r)}!1!==e.clearIdxResponse&&this.clearIdxResponse(),this.legacyWidgetSupport&&(e.oauth&&this.clearLegacyOAuthParams(),e.pkce&&this.clearLegacyPKCE())}},{key:"save",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this.storageManager.getTransactionStorage(),r=n.getStorage();if((0,s.isTransactionMeta)(r)&&!t.muteWarning&&(0,f.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."),n.setStorage(e),this.enableSharedStorage&&e.state&&p(this.storageManager,e.state,e),t.oauth&&(this.saveNonceCookie||this.saveStateCookie||this.saveParamsCookie)){var o=this.storageManager.getStorage({storageType:"cookie"});if(this.saveParamsCookie){var i=e.responseType,a=e.state,c=e.nonce,l=e.scopes,h=e.clientId,d=e.urls,v=e.ignoreSignature,y={responseType:i,state:a,nonce:c,scopes:l,clientId:h,urls:d,ignoreSignature:v};o.setItem(u.REDIRECT_OAUTH_PARAMS_NAME,JSON.stringify(y),null)}this.saveNonceCookie&&e.nonce&&o.setItem(u.REDIRECT_NONCE_COOKIE_NAME,e.nonce,null),this.saveStateCookie&&e.state&&o.setItem(u.REDIRECT_STATE_COOKIE_NAME,e.state,null)}}},{key:"exists",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{var t=this.load(e);return!!t}catch(e){return!1}}},{key:"load",value:function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(this.enableSharedStorage&&t.state&&(l(this.storageManager),e=h(this.storageManager,t.state),(0,s.isTransactionMeta)(e)))return e;var n=this.storageManager.getTransactionStorage();if(e=n.getStorage(),(0,s.isTransactionMeta)(e))return e;if(!this.legacyWidgetSupport)return null;if(t.oauth)try{var r=this.loadLegacyOAuthParams();Object.assign(e,r)}finally{this.clearLegacyOAuthParams()}if(t.pkce)try{var o=this.loadLegacyPKCE();Object.assign(e,o)}finally{this.clearLegacyPKCE()}return(0,s.isTransactionMeta)(e)?e:null}},{key:"clearLegacyPKCE",value:function(){this.storageManager.storageUtil.testStorageType("localStorage")&&this.storageManager.getLegacyPKCEStorage({storageType:"localStorage"}).clearStorage(),this.storageManager.storageUtil.testStorageType("sessionStorage")&&this.storageManager.getLegacyPKCEStorage({storageType:"sessionStorage"}).clearStorage()}},{key:"loadLegacyPKCE",value:function(){var e;if(this.storageManager.storageUtil.testStorageType("localStorage")&&(e=this.storageManager.getLegacyPKCEStorage({storageType:"localStorage"}).getStorage())&&e.codeVerifier)return e;if(this.storageManager.storageUtil.testStorageType("sessionStorage")&&(e=this.storageManager.getLegacyPKCEStorage({storageType:"sessionStorage"}).getStorage())&&e.codeVerifier)return e;throw new a.R("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",void 0)}},{key:"clearLegacyOAuthParams",value:function(){this.storageManager.storageUtil.testStorageType("sessionStorage")&&this.storageManager.getLegacyOAuthParamsStorage({storageType:"sessionStorage"}).clearStorage(),this.storageManager.storageUtil.testStorageType("cookie")&&this.storageManager.getLegacyOAuthParamsStorage({storageType:"cookie"}).clearStorage()}},{key:"loadLegacyOAuthParams",value:function(){var e;if(this.storageManager.storageUtil.testStorageType("sessionStorage")&&(e=this.storageManager.getLegacyOAuthParamsStorage({storageType:"sessionStorage"}).getStorage()),(0,s.isOAuthTransactionMeta)(e))return e;if(this.storageManager.storageUtil.testStorageType("cookie")&&(e=this.storageManager.getLegacyOAuthParamsStorage({storageType:"cookie"}).getStorage()),(0,s.isOAuthTransactionMeta)(e))return e;throw new a.R("Unable to retrieve OAuth redirect params from storage")}},{key:"saveIdxResponse",value:function(e){if(this.saveLastResponse){var t=this.storageManager.getIdxResponseStorage();t&&t.setStorage(e)}}},{key:"loadIdxResponse",value:function(e){if(!this.saveLastResponse)return null;var t=this.storageManager.getIdxResponseStorage();if(!t)return null;var n=t.getStorage();if(!n||!(0,c.P)(n.rawIdxResponse))return null;if(e){var r=e.stateHandle,o=e.interactionHandle;if(r&&n.stateHandle!==r)return null;if(o&&n.interactionHandle!==o)return null}return n}},{key:"clearIdxResponse",value:function(){if(this.saveLastResponse){var e=this.storageManager.getIdxResponseStorage();null==e||e.clearStorage()}}}]),e}()},1971:function(e,t,n){"use strict";n.r(t),n.d(t,{STATE_TOKEN_KEY_NAME:function(){return r},DEFAULT_POLLING_DELAY:function(){return o},DEFAULT_MAX_CLOCK_SKEW:function(){return i},DEFAULT_CACHE_DURATION:function(){return a},REDIRECT_OAUTH_PARAMS_NAME:function(){return u},REDIRECT_STATE_COOKIE_NAME:function(){return s},REDIRECT_NONCE_COOKIE_NAME:function(){return c},TOKEN_STORAGE_NAME:function(){return f},CACHE_STORAGE_NAME:function(){return l},PKCE_STORAGE_NAME:function(){return p},TRANSACTION_STORAGE_NAME:function(){return h},SHARED_TRANSACTION_STORAGE_NAME:function(){return d},ORIGINAL_URI_STORAGE_NAME:function(){return v},IDX_RESPONSE_STORAGE_NAME:function(){return y},ACCESS_TOKEN_STORAGE_KEY:function(){return g},ID_TOKEN_STORAGE_KEY:function(){return m},REFRESH_TOKEN_STORAGE_KEY:function(){return b},REFERRER_PATH_STORAGE_KEY:function(){return k},MIN_VERIFIER_LENGTH:function(){return w},MAX_VERIFIER_LENGTH:function(){return O},DEFAULT_CODE_CHALLENGE_METHOD:function(){return E},IDX_API_VERSION:function(){return T}});var r="oktaStateToken",o=500,i=300,a=86400,u="okta-oauth-redirect-params",s="okta-oauth-state",c="okta-oauth-nonce",f="okta-token-storage",l="okta-cache-storage",p="okta-pkce-storage",h="okta-transaction-storage",d="okta-shared-transaction-storage",v="okta-original-uri-storage",y="okta-idx-response-storage",g="accessToken",m="idToken",b="refreshToken",k="referrerPath",w=43,O=128,E="S256",T="1.0.0"},7987:function(e,t,n){"use strict";n.d(t,{NL:function(){return i},aR:function(){return a},Df:function(){return u},Wy:function(){return s},k8:function(){return c},EL:function(){return f},dX:function(){return l},kQ:function(){return p}});var r=n(7301),o=n(4029);function i(e){return a((0,o.r3)(e))}function a(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function u(e){return e.replace(/-/g,"+").replace(/_/g,"/")}function s(e){var t=u(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw new r.R("Not a valid Base64Url")}var n=(0,o.ty)(t);try{return decodeURIComponent(escape(n))}catch(e){return n}}function c(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}function f(e){return(0,o.ty)(u(e))}function l(e){return Uint8Array.from(f(e),(function(e){return e.charCodeAt(0)}))}function p(e){return(0,o.r3)(new Uint8Array(e).reduce((function(e,t){return e+String.fromCharCode(t)}),""))}},9326:function(e,t,n){"use strict";n.r(t),n.d(t,{atob:function(){return o.ty},base64ToBase64Url:function(){return r.aR},base64UrlDecode:function(){return r.EL},base64UrlToBase64:function(){return r.Df},base64UrlToBuffer:function(){return r.dX},base64UrlToString:function(){return r.Wy},btoa:function(){return o.r3},bufferToBase64Url:function(){return r.kQ},getOidcHash:function(){return i},stringToBase64Url:function(){return r.NL},stringToBuffer:function(){return r.k8},verifyToken:function(){return u},webcrypto:function(){return o.KP}});var r=n(7987),o=n(4029);function i(e){var t=(new TextEncoder).encode(e);return o.KP.subtle.digest("SHA-256",t).then((function(e){var t=new Uint8Array(e).slice(0,16),n=String.fromCharCode.apply(null,t);return(0,r.NL)(n)}))}var a=n(3193);function u(e,t){t=(0,a.d9)(t);var n={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}};return delete t.use,o.KP.subtle.importKey("jwk",t,n,!0,["verify"]).then((function(t){var i=e.split("."),a=(0,r.k8)(i[0]+"."+i[1]),u=(0,r.EL)(i[2]),s=(0,r.k8)(u);return o.KP.subtle.verify(n,t,s,a)}))}},4029:function(e,t,n){"use strict";n.d(t,{ty:function(){return r},r3:function(){return o},KP:function(){return i}});var r=function(e){return atob(e)},o=function(e){return btoa(e)},i="undefined"==typeof crypto?null:crypto},3983:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(5671),o=n(7326),i=n(136),a=n(2963),u=n(1120),s=n(4942);var c=function(e){(0,i.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function f(e,t,n){var i;(0,r.Z)(this,f);var a=e.errorSummary;return i=c.call(this,a),(0,s.Z)((0,o.Z)(i),"errorSummary",void 0),(0,s.Z)((0,o.Z)(i),"errorCode",void 0),(0,s.Z)((0,o.Z)(i),"errorLink",void 0),(0,s.Z)((0,o.Z)(i),"errorId",void 0),(0,s.Z)((0,o.Z)(i),"errorCauses",void 0),(0,s.Z)((0,o.Z)(i),"xhr",void 0),(0,s.Z)((0,o.Z)(i),"meta",void 0),i.name="AuthApiError",i.errorSummary=e.errorSummary,i.errorCode=e.errorCode,i.errorLink=e.errorLink,i.errorId=e.errorId,i.errorCauses=e.errorCauses,t&&(i.xhr=t),n&&(i.meta=n),i}return f}(n(6245).Z)},6573:function(e,t,n){"use strict";n.d(t,{Z:function(){return u}});var r=n(5671),o=n(136),i=n(2963),a=n(1120);var u=function(e){(0,o.Z)(s,e);var t,n,u=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,a.Z)(t);if(n){var o=(0,a.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,i.Z)(this,e)});function s(){return(0,r.Z)(this,s),u.call(this,"The poll was stopped by the sdk")}return s}(n(6245).Z)},9123:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(5671),o=n(7326),i=n(136),a=n(2963),u=n(1120),s=n(4942);var c=function(e){(0,i.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function f(e,t){var n;return(0,r.Z)(this,f),n=c.call(this,e),(0,s.Z)((0,o.Z)(n),"errorSummary",void 0),(0,s.Z)((0,o.Z)(n),"errorCode",void 0),(0,s.Z)((0,o.Z)(n),"errorLink",void 0),(0,s.Z)((0,o.Z)(n),"errorId",void 0),(0,s.Z)((0,o.Z)(n),"errorCauses",void 0),(0,s.Z)((0,o.Z)(n),"xhr",void 0),n.name="AuthSdkError",n.errorCode="INTERNAL",n.errorSummary=e,n.errorLink="INTERNAL",n.errorId="INTERNAL",n.errorCauses=[],t&&(n.xhr=t),n}return f}(n(6245).Z)},6245:function(e,t,n){"use strict";n.d(t,{Z:function(){return p}});var r=n(5671),o=n(7326),i=n(136),a=n(2963),u=n(1120),s=n(9611);function c(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function f(e,t,n){return f=c()?Reflect.construct:function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&(0,s.Z)(o,n.prototype),o},f.apply(null,arguments)}function l(e){var t="function"==typeof Map?new Map:void 0;return l=function(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return f(e,arguments,(0,u.Z)(this).constructor)}return r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),(0,s.Z)(r,e)},l(e)}var p=function(e){(0,i.Z)(c,e);var t,n,s=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function c(e){var t;return(0,r.Z)(this,c),t=s.call(this,e),Object.setPrototypeOf((0,o.Z)(t),(this instanceof c?this.constructor:void 0).prototype),t}return c}(l(Error))},7301:function(e,t,n){"use strict";n.d(t,{Ws:function(){return r.Z},j2:function(){return o.Z},R:function(){return i.Z},BK:function(){return p},Tw:function(){return h},eo:function(){return d}});var r=n(3983),o=n(6573),i=n(9123),a=n(5671),u=n(7326),s=n(136),c=n(2963),f=n(1120),l=n(4942);var p=function(e){(0,s.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,f.Z)(t);if(n){var o=(0,f.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function o(e,t){var n;return(0,a.Z)(this,o),n=r.call(this,t),(0,l.Z)((0,u.Z)(n),"errorCode",void 0),(0,l.Z)((0,u.Z)(n),"errorSummary",void 0),(0,l.Z)((0,u.Z)(n),"error",void 0),(0,l.Z)((0,u.Z)(n),"error_description",void 0),n.name="OAuthError",n.errorCode=e,n.errorSummary=t,n.error=e,n.error_description=t,n}return o}(n(6245).Z);function h(e){return e instanceof r.Z}function d(e){return e instanceof p}},415:function(e,t,n){"use strict";n.r(t),n.d(t,{isBrowser:function(){return i},isIE11OrLess:function(){return a},getUserAgent:function(){return u},isFingerprintSupported:function(){return s},isPopupPostMessageSupported:function(){return c},isTokenVerifySupported:function(){return f},hasTextEncoder:function(){return l},isPKCESupported:function(){return p},isHTTPS:function(){return h},isLocalhost:function(){return d}});var r=n(9326),o=/windows phone|iemobile|wpdesktop/i;function i(){return"undefined"!=typeof document&&"undefined"!=typeof window}function a(){if(!i())return!1;var e=document.documentMode;return!!e&&e<=11}function u(){return navigator.userAgent}function s(){var e=u();return e&&!o.test(e)}function c(){if(!i())return!1;var e=document.documentMode,t=e&&e<10;return void 0!==window.postMessage&&!t}function f(){return void 0!==r.webcrypto&&null!==r.webcrypto&&void 0!==r.webcrypto.subtle&&"undefined"!=typeof Uint8Array}function l(){return"undefined"!=typeof TextEncoder}function p(){return f()&&l()}function h(){return!!i()&&"https:"===window.location.protocol}function d(){return i()&&"localhost"===window.location.hostname}},2281:function(e,t,n){"use strict";function r(e,t,n){e.options.headers=e.options.headers||{},e.options.headers[t]=n}n.d(t,{r:function(){return r}})},7735:function(e,t,n){"use strict";n.d(t,{U2:function(){return d},c3:function(){return h},v_:function(){return v},rn:function(){return r.r}});var r=n(2281),o=n(1002),i=n(4942),a=n(3193),u=n(4771),s=n(6718),c=n(1971),f=n(7301);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function h(e,t){if(t=t||{},e.options.httpRequestInterceptors){var n,r=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return p(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?p(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(e.options.httpRequestInterceptors);try{for(r.s();!(n=r.n()).done;)(0,n.value)(t)}catch(O){r.e(O)}finally{r.f()}}var s=t.url,h=t.method,d=t.args,v=t.saveAuthnState,y=t.accessToken,g=!0===t.withCredentials,m=e.options.storageUtil.storage,b=e.storageManager.getHttpCache(e.options.cookies);if(t.cacheResponse){var k=b.getStorage()[s];if(k&&Date.now()/1e3<k.expiresAt)return Promise.resolve(k.response)}var w=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,i.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({Accept:"application/json","Content-Type":"application/json"},e._oktaUserAgent.getHttpHeader());Object.assign(w,e.options.headers,t.headers),w=(0,a.YY)(w),y&&(0,u.HD)(y)&&(w.Authorization="Bearer "+y);var O,E,T={headers:w,data:d||void 0,withCredentials:g};return e.options.httpRequestClient(h,s,T).then((function(n){return(E=n.responseText)&&(0,u.HD)(E)&&(E=JSON.parse(E))&&"object"===(0,o.Z)(E)&&!E.headers&&(Array.isArray(E)?E.forEach((function(e){e.headers=n.headers})):E.headers=n.headers),v&&(E.stateToken||m.delete(c.STATE_TOKEN_KEY_NAME)),E&&E.stateToken&&E.expiresAt&&m.set(c.STATE_TOKEN_KEY_NAME,E.stateToken,E.expiresAt,e.options.cookies),E&&t.cacheResponse&&b.updateStorage(s,{expiresAt:Math.floor(Date.now()/1e3)+c.DEFAULT_CACHE_DURATION,response:E}),E})).catch((function(t){var n=t.responseText||{};if((0,u.HD)(n))try{n=JSON.parse(n)}catch(e){n={errorSummary:"Unknown error"}}throw t.status>=500&&(n.errorSummary="Unknown error"),e.options.transformErrorXHR&&(t=e.options.transformErrorXHR((0,a.d9)(t))),"E0000011"===(O=n.error&&n.error_description?new f.BK(n.error,n.error_description):new f.Ws(n,t)).errorCode&&m.delete(c.STATE_TOKEN_KEY_NAME),O}))}function d(e,t,n){var r={url:t=(0,s.sD)(t)?t:e.getIssuerOrigin()+t,method:"GET"};return Object.assign(r,n),h(e,r)}function v(e,t,n,r){var o={url:t=(0,s.sD)(t)?t:e.getIssuerOrigin()+t,method:"POST",args:n,saveAuthnState:!0};return Object.assign(o,r),h(e,o)}},5294:function(e,t,n){"use strict";n.d(t,{_T:function(){return Y},A0:function(){return q}});var r=n(1971),o=n(5861),i=n(2982),a=n(7757),u=n.n(a),s=n(885),c=n(4942),f=n(4925),l=n(1002),p=n(7735);function h(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return d(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var v=function(e){return!1!==e.mutable},y=function(e){var t={},n=[],r={};if(!e.value)return n.push(e),{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r};var o,i=h(e.value);try{for(i.s();!(o=i.n()).done;){var a,u,s=o.value;v(s)?(n.push(s),null!==(a=s.value)&&void 0!==a&&a&&(t[s.name]=s.value)):r[s.name]=null!==(u=s.value)&&void 0!==u?u:""}}catch(e){i.e(e)}finally{i.f()}return{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r}},g=n(3983);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var k=function(e,t){var n=t.actionDefinition,r=t.defaultParamsForAction,i=void 0===r?{}:r,a=t.immutableParamsForAction,s=void 0===a?{}:a,c=t.toPersist,f=void 0===c?{}:c,l=n.href;return(0,o.Z)(u().mark((function t(){var r,o,a,c,h,d,v,y,m,k=arguments;return u().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=k.length>0&&void 0!==k[0]?k[0]:{},o={"Content-Type":"application/json",Accept:n.accepts||"application/ion+json"},a=JSON.stringify(b(b(b({},i),r),s)),t.prev=3,t.next=6,(0,p.c3)(e,{url:l,method:n.method,headers:o,args:a,withCredentials:null===(c=null==f?void 0:f.withCredentials)||void 0===c||c});case 6:return h=t.sent,t.abrupt("return",e.idx.makeIdxResponse(b({},h),f,!0));case 10:if(t.prev=10,t.t0=t.catch(3),t.t0 instanceof g.Z&&null!==t.t0&&void 0!==t.t0&&t.t0.xhr){t.next=14;break}throw t.t0;case 14:throw d=t.t0.xhr,v=d.responseJSON||JSON.parse(d.responseText),y=d.headers["WWW-Authenticate"]||d.headers["www-authenticate"],m=e.idx.makeIdxResponse(b({},v),f,!1),401===d.status&&'Oktadevicejwt realm="Okta Device"'===y&&(m.stepUp=!0),m;case 20:case"end":return t.stop()}}),t,null,[[3,10]])})))},w=function(e,t,n){var r=k,o=function(e){var t,n=[],r={},o={},i=h(e=Array.isArray(e)?e:[e]);try{for(i.s();!(t=i.n()).done;){var a=t.value,u=y(a),s=u.defaultParamsForAction,c=u.neededParamsForAction,f=u.immutableParamsForAction;n.push(c),r[a.name]=s,o[a.name]=f}}catch(e){i.e(e)}finally{i.f()}return{defaultParams:r,neededParams:n,immutableParams:o}}(t),i=o.defaultParams,a=o.neededParams,u=o.immutableParams,s=r(e,{actionDefinition:t,defaultParamsForAction:i[t.name],immutableParamsForAction:u[t.name],toPersist:n});return s.neededParams=a,s};function O(e){return O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},O(e)}function E(e){return E=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},E(e)}function T(e,t){return T=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},T(e,t)}function S(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function _(e,t,n){return _=S()?Reflect.construct:function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&T(o,n.prototype),o},_.apply(null,arguments)}function A(e){var t="function"==typeof Map?new Map:void 0;return A=function(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return _(e,arguments,E(this).constructor)}return r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),T(r,e)},A(e)}function P(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function R(e){return function(e){if(Array.isArray(e))return Z(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||x(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function x(e,t){if(e){if("string"==typeof e)return Z(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Z(e,t):void 0}}function Z(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var j=Object.prototype.hasOwnProperty;function C(e,t){return(e=e.slice()).push(t),e}function D(e,t){return(t=t.slice()).unshift(e),t}var I=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&T(e,t)}(o,e);var t,n,r=(t=o,n=S(),function(){var e,r=E(t);if(n){var o=E(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return P(this,e)});function o(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,o),(t=r.call(this,'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew=!0,t.value=e,t.name="NewError",t}return o}(A(Error));function M(e,t,n,r,o){if(!(this instanceof M))try{return new M(e,t,n,r,o)}catch(e){if(!e.avoidNew)throw e;return e.value}"string"==typeof e&&(o=r,r=n,n=t,t=e,e=null);var i=e&&"object"===O(e);if(e=e||{},this.json=e.json||n,this.path=e.path||t,this.resultType=e.resultType||"value",this.flatten=e.flatten||!1,this.wrap=!j.call(e,"wrap")||e.wrap,this.sandbox=e.sandbox||{},this.preventEval=e.preventEval||!1,this.parent=e.parent||null,this.parentProperty=e.parentProperty||null,this.callback=e.callback||r||null,this.otherTypeCallback=e.otherTypeCallback||o||function(){throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.")},!1!==e.autostart){var a={path:i?e.path:t};i?"json"in e&&(a.json=e.json):a.json=n;var u=this.evaluate(a);if(!u||"object"!==O(u))throw new I(u);return u}}M.prototype.evaluate=function(e,t,n,r){var o=this,i=this.parent,a=this.parentProperty,u=this.flatten,s=this.wrap;if(this.currResultType=this.resultType,this.currPreventEval=this.preventEval,this.currSandbox=this.sandbox,n=n||this.callback,this.currOtherTypeCallback=r||this.otherTypeCallback,t=t||this.json,(e=e||this.path)&&"object"===O(e)&&!Array.isArray(e)){if(!e.path&&""!==e.path)throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');if(!j.call(e,"json"))throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');t=e.json,u=j.call(e,"flatten")?e.flatten:u,this.currResultType=j.call(e,"resultType")?e.resultType:this.currResultType,this.currSandbox=j.call(e,"sandbox")?e.sandbox:this.currSandbox,s=j.call(e,"wrap")?e.wrap:s,this.currPreventEval=j.call(e,"preventEval")?e.preventEval:this.currPreventEval,n=j.call(e,"callback")?e.callback:n,this.currOtherTypeCallback=j.call(e,"otherTypeCallback")?e.otherTypeCallback:this.currOtherTypeCallback,i=j.call(e,"parent")?e.parent:i,a=j.call(e,"parentProperty")?e.parentProperty:a,e=e.path}if(i=i||null,a=a||null,Array.isArray(e)&&(e=M.toPathString(e)),(e||""===e)&&t){var c=M.toPathArray(e);"$"===c[0]&&c.length>1&&c.shift(),this._hasParentSelector=null;var f=this._trace(c,t,["$"],i,a,n).filter((function(e){return e&&!e.isParentSelector}));return f.length?s||1!==f.length||f[0].hasArrExpr?f.reduce((function(e,t){var n=o._getPreferredOutput(t);return u&&Array.isArray(n)?e=e.concat(n):e.push(n),e}),[]):this._getPreferredOutput(f[0]):s?[]:void 0}},M.prototype._getPreferredOutput=function(e){var t=this.currResultType;switch(t){case"all":var n=Array.isArray(e.path)?e.path:M.toPathArray(e.path);return e.pointer=M.toPointer(n),e.path="string"==typeof e.path?e.path:M.toPathString(e.path),e;case"value":case"parent":case"parentProperty":return e[t];case"path":return M.toPathString(e[t]);case"pointer":return M.toPointer(e.path);default:throw new TypeError("Unknown result type")}},M.prototype._handleCallback=function(e,t,n){if(t){var r=this._getPreferredOutput(e);e.path="string"==typeof e.path?e.path:M.toPathString(e.path),t(r,n,e)}},M.prototype._trace=function(e,t,n,r,o,i,a,u){var s,c=this;if(!e.length)return s={path:n,value:t,parent:r,parentProperty:o,hasArrExpr:a},this._handleCallback(s,i,"value"),s;var f=e[0],l=e.slice(1),p=[];function h(e){Array.isArray(e)?e.forEach((function(e){p.push(e)})):p.push(e)}if(("string"!=typeof f||u)&&t&&j.call(t,f))h(this._trace(l,t[f],C(n,f),t,f,i,a));else if("*"===f)this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){h(c._trace(D(e,n),r,o,i,a,u,!0,!0))}));else if(".."===f)h(this._trace(l,t,n,r,o,i,a)),this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){"object"===O(r[e])&&h(c._trace(D(t,n),r[e],C(o,e),r,e,u,!0))}));else{if("^"===f)return this._hasParentSelector=!0,{path:n.slice(0,-1),expr:l,isParentSelector:!0};if("~"===f)return s={path:C(n,f),value:o,parent:r,parentProperty:null},this._handleCallback(s,i,"property"),s;if("$"===f)h(this._trace(l,t,n,null,null,i,a));else if(/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(f))h(this._slice(f,l,t,n,r,o,i));else if(0===f.indexOf("?(")){if(this.currPreventEval)throw new Error("Eval [?(expr)] prevented in JSONPath expression.");this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){c._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/,"$1"),r[e],e,o,i,a)&&h(c._trace(D(e,n),r,o,i,a,u,!0))}))}else if("("===f[0]){if(this.currPreventEval)throw new Error("Eval [(expr)] prevented in JSONPath expression.");h(this._trace(D(this._eval(f,t,n[n.length-1],n.slice(0,-1),r,o),l),t,n,r,o,i,a))}else if("@"===f[0]){var d=!1,v=f.slice(1,-2);switch(v){case"scalar":t&&["object","function"].includes(O(t))||(d=!0);break;case"boolean":case"string":case"undefined":case"function":O(t)===v&&(d=!0);break;case"integer":!Number.isFinite(t)||t%1||(d=!0);break;case"number":Number.isFinite(t)&&(d=!0);break;case"nonFinite":"number"!=typeof t||Number.isFinite(t)||(d=!0);break;case"object":t&&O(t)===v&&(d=!0);break;case"array":Array.isArray(t)&&(d=!0);break;case"other":d=this.currOtherTypeCallback(t,n,r,o);break;case"null":null===t&&(d=!0);break;default:throw new TypeError("Unknown value type "+v)}if(d)return s={path:n,value:t,parent:r,parentProperty:o},this._handleCallback(s,i,"value"),s}else if("`"===f[0]&&t&&j.call(t,f.slice(1))){var y=f.slice(1);h(this._trace(l,t[y],C(n,y),t,y,i,a,!0))}else if(f.includes(",")){var g,m=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=x(e))){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(f.split(","));try{for(m.s();!(g=m.n()).done;){var b=g.value;h(this._trace(D(b,l),t,n,r,o,i,!0))}}catch(e){m.e(e)}finally{m.f()}}else!u&&t&&j.call(t,f)&&h(this._trace(l,t[f],C(n,f),t,f,i,a,!0))}if(this._hasParentSelector)for(var k=0;k<p.length;k++){var w=p[k];if(w&&w.isParentSelector){var E=this._trace(w.expr,t,w.path,r,o,i,a);if(Array.isArray(E)){p[k]=E[0];for(var T=E.length,S=1;S<T;S++)k++,p.splice(k,0,E[S])}else p[k]=E}}return p},M.prototype._walk=function(e,t,n,r,o,i,a,u){if(Array.isArray(n))for(var s=n.length,c=0;c<s;c++)u(c,e,t,n,r,o,i,a);else n&&"object"===O(n)&&Object.keys(n).forEach((function(s){u(s,e,t,n,r,o,i,a)}))},M.prototype._slice=function(e,t,n,r,o,i,a){if(Array.isArray(n)){var u=n.length,s=e.split(":"),c=s[2]&&Number.parseInt(s[2])||1,f=s[0]&&Number.parseInt(s[0])||0,l=s[1]&&Number.parseInt(s[1])||u;f=f<0?Math.max(0,f+u):Math.min(u,f),l=l<0?Math.max(0,l+u):Math.min(u,l);for(var p=[],h=f;h<l;h+=c)this._trace(D(h,t),n,r,o,i,a,!0).forEach((function(e){p.push(e)}));return p}},M.prototype._eval=function(e,t,n,r,o,i){e.includes("@parentProperty")&&(this.currSandbox._$_parentProperty=i,e=e.replace(/@parentProperty/g,"_$_parentProperty")),e.includes("@parent")&&(this.currSandbox._$_parent=o,e=e.replace(/@parent/g,"_$_parent")),e.includes("@property")&&(this.currSandbox._$_property=n,e=e.replace(/@property/g,"_$_property")),e.includes("@path")&&(this.currSandbox._$_path=M.toPathString(r.concat([n])),e=e.replace(/@path/g,"_$_path")),e.includes("@root")&&(this.currSandbox._$_root=this.json,e=e.replace(/@root/g,"_$_root")),/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e)&&(this.currSandbox._$_v=t,e=e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g,"_$_v$1"));try{return this.vm.runInNewContext(e,this.currSandbox)}catch(t){throw console.log(t),new Error("jsonPath: "+t.message+": "+e)}},M.cache={},M.toPathString=function(e){for(var t=e,n=t.length,r="$",o=1;o<n;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(r+=/^[\*0-9]+$/.test(t[o])?"["+t[o]+"]":"['"+t[o]+"']");return r},M.toPointer=function(e){for(var t=e,n=t.length,r="",o=1;o<n;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(r+="/"+t[o].toString().replace(/~/g,"~0").replace(/\//g,"~1"));return r},M.toPathArray=function(e){var t=M.cache;if(t[e])return t[e].concat();var n=[],r=e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g,";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g,(function(e,t){return"[#"+(n.push(t)-1)+"]"})).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g,(function(e,t){return"['"+t.replace(/\./g,"%@%").replace(/~/g,"%%@@%%")+"']"})).replace(/~/g,";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g,";").replace(/%@%/g,".").replace(/%%@@%%/g,"~").replace(/(?:;)?(\^+)(?:;)?/g,(function(e,t){return";"+t.split("").join(";")+";"})).replace(/;;;|;;/g,";..;").replace(/;$|'?\]|'$/g,"").split(";").map((function(e){var t=e.match(/#([0-9]+)/);return t&&t[1]?n[t[1]]:e}));return t[e]=r,t[e].concat()},M.prototype.vm={runInNewContext:function(e,t){var n=Object.keys(t),r=[];!function(e,n,r){for(var o=e.length,i=0;i<o;i++)a=e[i],"function"==typeof t[a]&&n.push(e.splice(i--,1)[0]);var a}(n,r);var o=n.map((function(e,n){return t[e]})),i=r.reduce((function(e,n){var r=t[n].toString();return/function/.test(r)||(r="function "+r),"var "+n+"="+r+";"+e}),"");/(["'])use strict\1/.test(e=i+e)||n.includes("arguments")||(e="var arguments = undefined;"+e);var a=(e=e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/,"")).lastIndexOf(";"),u=a>-1?e.slice(0,a+1)+" return "+e.slice(a+1):" return "+e;return _(Function,R(n).concat([u])).apply(void 0,R(o))}};var N=["value","type"];function U(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function L(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?U(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):U(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var F=Object.fromEntries(["remediation","context"].map((function(e){return[e,!0]}))),H=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r={},o={};return Object.keys(t).filter((function(e){return!F[e]})).forEach((function(i){if("object"===(0,l.Z)(t[i])&&t[i])if(t[i].rel)r[t[i].name]=w(e,t[i],n);else{var a=t[i],u=a.value,c=a.type,p=(0,f.Z)(a,N);o[i]=L({type:c},p),"object"===c?(o[i].value={},Object.entries(u).forEach((function(t){var a=(0,s.Z)(t,2),u=a[0],c=a[1];c.rel?r["".concat(i,"-").concat(u.name||u)]=w(e,c,n):o[i].value[u]=c}))):o[i].value=u}else o[i]=t[i]})),{context:o,actions:r}},K=function e(t,n){Object.keys(n).forEach((function(r){if("relatesTo"===r){var o=Array.isArray(n[r])?n[r][0]:n[r];if("string"==typeof o){var i=M({path:o,json:t})[0];if(i)return void(n[r]=i)}}Array.isArray(n[r])&&n[r].forEach((function(n){return e(t,n)}))}))},B=function(e,t,n){if(t.rel){var r=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.fromEntries(t.map((function(t){return[t.name,w(e,t,n)]})))}(e,[t],n),o=r[t.name];return L(L({},t),{},{action:o})}return t},V={makeIdxState:function(e,t,n,r){var a,s,c,f,l=t,p=function(e,t){var n,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=(null===(n=t.remediation)||void 0===n?void 0:n.value)||[];o.forEach((function(e){return K(t,e)}));var i=o.map((function(t){return B(e,t,r)})),a=H(e,t,r),u=a.context,s=a.actions;return{remediations:i,context:u,actions:s}}(e,t,n),h=p.remediations,d=p.context,v=p.actions,y=(0,i.Z)(h),g=(f=(0,o.Z)(u().mark((function e(t){var n,r,o=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=h.find((function(e){return e.name===t}))){e.next=4;break}return e.abrupt("return",Promise.reject("Unknown remediation choice: [".concat(t,"]")));case 4:if("function"==typeof r.action){e.next=7;break}return e.abrupt("return",Promise.reject("Current remediation cannot make form submit action: [".concat(t,"]")));case 7:return e.abrupt("return",r.action(n));case 8:case"end":return e.stop()}}),e)}))),function(e){return f.apply(this,arguments)});return{proceed:g,neededToProceed:y,actions:v,context:d,rawIdxState:l,interactionCode:null===(a=l.successWithInteractionCode)||void 0===a||null===(s=a.value)||void 0===s||null===(c=s.find((function(e){return"interaction_code"===e.name})))||void 0===c?void 0:c.value,toPersist:n,requestDidSucceed:r}}},G=function(e){switch(e){case"1.0.0":return V;case void 0:case null:throw new Error("Api version is required");default:throw new Error("Unknown api version: ".concat(e,".  Use an exact semver version."))}};function q(e){if(!e)throw new Error("version is required");if((null!=e?e:"").replace(/[^0-9a-zA-Z._-]/,"")!==e||!e)throw new Error("invalid version supplied - version is required and uses semver syntax");G(e)}function Y(e,t,n,o){var i,a=null!==(i=null==t?void 0:t.version)&&void 0!==i?i:r.IDX_API_VERSION;return q(a),(0,G(a).makeIdxState)(e,t,n,o)}},4516:function(e,t,n){"use strict";n.d(t,{YR:function(){return $t},Ch:function(){return hn},al:function(){return en},Jm:function(){return c.Jm},Xc:function(){return c.Xc},uN:function(){return c.uN},Co:function(){return c.Co},Jn:function(){return cn},Xx:function(){return xn},$0:function(){return c.$0},EW:function(){return y},L8:function(){return O},GA:function(){return un},gc:function(){return an},Wf:function(){return c.Wf},bl:function(){return c.bl},UC:function(){return c.UC},mo:function(){return sn},$l:function(){return yn},xc:function(){return dn},M4:function(){return Pn},z2:function(){return Tn},r0:function(){return c.r0},Yr:function(){return kn},le:function(){return Dn}});var r={};n.r(r),n.d(r,{AuthenticatorEnrollmentData:function(){return Qe},AuthenticatorVerificationData:function(){return We},ChallengeAuthenticator:function(){return ke},ChallengePoll:function(){return we},EnrollAuthenticator:function(){return fe},EnrollPoll:function(){return he},EnrollProfile:function(){return Se},EnrollmentChannelData:function(){return be},GenericRemediator:function(){return rt},Identify:function(){return Pe},ReEnrollAuthenticator:function(){return Ze},RedirectIdp:function(){return je},Remediator:function(){return H},ResetAuthenticator:function(){return Oe},SelectAuthenticatorAuthenticate:function(){return Ne},SelectAuthenticatorEnroll:function(){return Ue},SelectAuthenticatorUnlockAccount:function(){return He},SelectEnrollProfile:function(){return Ke},SelectEnrollmentChannel:function(){return ye},Skip:function(){return Xe}});var o=n(4942),i=n(5861),a=n(7757),u=n.n(a),s=n(2852),c=n(2620),f=n(1279),l=n(3193),p=n(7735);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function v(e){return{meta:e,interactionHandle:e.interactionHandle,state:e.state}}function y(e){return g.apply(this,arguments)}function g(){return g=(0,i.Z)(u().mark((function e(t){var n,r,o,i,a,s,h,y,g,m,b,k,w,O,E,T,S,_,A,P,R,x,Z,j,C=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=C.length>1&&void 0!==C[1]?C[1]:{},o=(0,l.YY)(o),i=(0,c.uN)(t,o),null===(n=i)||void 0===n||!n.interactionHandle){e.next=5;break}return e.abrupt("return",v(i));case 5:return e.next=7,(0,c.Xc)(t,d(d({},i),o));case 7:return i=e.sent,a=(0,f.zf)(t),h=(s=i).clientId,y=s.redirectUri,g=s.state,m=s.scopes,b=s.withCredentials,k=s.codeChallenge,w=s.codeChallengeMethod,O=s.activationToken,E=s.recoveryToken,T=s.maxAge,S=s.nonce,_=o.clientSecret||t.options.clientSecret,b=null===(r=b)||void 0===r||r,A="".concat(a,"/v1/interact"),P=d(d(d(d(d({client_id:h,scope:m.join(" "),redirect_uri:y,code_challenge:k,code_challenge_method:w,state:g},O&&{activation_token:O}),E&&{recovery_token:E}),_&&{client_secret:_}),T&&{max_age:T}),S&&{nonce:S}),R={"Content-Type":"application/x-www-form-urlencoded"},e.next=17,(0,p.c3)(t,{method:"POST",url:A,headers:R,withCredentials:b,args:P});case 17:return x=e.sent,Z=x.interaction_handle,j=d(d({},i),{},{interactionHandle:Z,withCredentials:b,state:g,scopes:m,recoveryToken:E,activationToken:O}),(0,c.r0)(t,j),e.abrupt("return",v(j));case 22:case"end":return e.stop()}}),e)}))),g.apply(this,arguments)}var m=n(5294),b=n(480),k=n(1971),w=n(7301);function O(e){return E.apply(this,arguments)}function E(){return E=(0,i.Z)(u().mark((function e(t){var n,r,o,i,a,s,c,l,h,d,v,y,g,O,E=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=E.length>1&&void 0!==E[1]?E[1]:{},(i=t.transactionManager.loadIdxResponse(n))&&(r=i.rawIdxResponse,o=i.requestDidSucceed),r){e.next=27;break}return s=n.version||k.IDX_API_VERSION,c=(0,f.Xp)(t),l=n.interactionHandle,h=n.stateHandle,d=null===(a=n.withCredentials)||void 0===a||a,e.prev=8,o=!0,(0,m.A0)(s),v="".concat(c,"/idp/idx/introspect"),y=h?{stateToken:h}:{interactionHandle:l},g={"Content-Type":"application/ion+json; okta-version=".concat(s),Accept:"application/ion+json; okta-version=".concat(s)},e.next=16,(0,p.c3)(t,{method:"POST",url:v,headers:g,withCredentials:d,args:y});case 16:r=e.sent,e.next=27;break;case 19:if(e.prev=19,e.t0=e.catch(8),!((0,w.Tw)(e.t0)&&e.t0.xhr&&(0,b.P)(e.t0.xhr.responseJSON))){e.next=26;break}r=e.t0.xhr.responseJSON,o=!1,e.next=27;break;case 26:throw e.t0;case 27:return O=n.withCredentials,e.abrupt("return",(0,m._T)(t,r,{withCredentials:O},o));case 29:case"end":return e.stop()}}),e,null,[[8,19]])}))),E.apply(this,arguments)}var T=n(1002),S=n(2982),_=n(4925),A=n(885),P=n(8750),R=n(146),x=n(5671),Z=n(3144);function j(e){return e.charAt(0).toUpperCase()+e.substring(1)}function C(e){return e.value.find((function(e){return"authenticator"===e.name}))}var D=n(1384);function I(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function M(e){var t;if((0,D.H)(e))t=e;else{if("string"!=typeof e)throw new Error("Invalid format for authenticator");t={key:e}}return t}function N(e,t){return!!(e&&t&&(e.id&&t.id?e.id===t.id:e.key&&t.key&&e.key===t.key))}function U(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function L(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function F(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?L(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):L(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var H=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,x.Z)(this,e),(0,o.Z)(this,"remediation",void 0),(0,o.Z)(this,"values",void 0),(0,o.Z)(this,"options",void 0),(0,o.Z)(this,"map",void 0),this.values=F({},n),this.options=F({},r),this.formatAuthenticators(),this.remediation=t}return(0,Z.Z)(e,[{key:"formatAuthenticators",value:function(){if(this.values.authenticators=this.values.authenticators||[],this.values.authenticators=this.values.authenticators.map((function(e){return M(e)})),this.values.authenticator){var e=M(this.values.authenticator);this.values.authenticators.some((function(t){return N(e,t)}))||this.values.authenticators.push(e)}this.values.authenticatorsData=this.values.authenticators.reduce((function(e,t){return"object"===(0,T.Z)(t)&&Object.keys(t).length>1&&e.push(t),e}),this.values.authenticatorsData||[])}},{key:"getName",value:function(){return this.remediation.name}},{key:"canRemediate",value:function(){var e,t,n=this;return!(e=this.remediation,null===(t=e.value)||void 0===t?void 0:t.reduce((function(e,t){return t.required&&e.push(t.name),e}),[])).find((function(e){return!n.hasData(e)}))}},{key:"getData",value:function(e){var t,n,r=this;if(!e){var o=(t=this.remediation,null===(n=t.value)||void 0===n?void 0:n.map((function(e){return e.name}))).reduce((function(e,t){return e[t]=r.getData(t),e}),{});return o}if("function"==typeof this["map".concat(j(e))]){var i=this["map".concat(j(e))](this.remediation.value.find((function(t){return t.name===e})));if(i)return i}if(this.map&&this.map[e])for(var a=this.map[e],u=0;u<a.length;u++){var s=this.values[a[u]];if(s)return s}return this.values[e]}},{key:"hasData",value:function(e){return!!this.getData(e)}},{key:"getNextStep",value:function(e,t){var n=this.getName(),r=this.getInputs(),o=this.getAuthenticator(),i=null==o?void 0:o.type;return F(F({name:n,inputs:r},i&&{type:i}),o&&{authenticator:o})}},{key:"getInputs",value:function(){var e=this,t=[];return(this.remediation.value||[]).forEach((function(n){var r,o=n.name,i=n.type,a=n.visible,u=n.messages;if(!1!==a){if("function"==typeof e["getInput".concat(j(o))])r=e["getInput".concat(j(o))](n);else if("object"!==i){var s,c=(e.map?e.map[o]:null)||[];s=1===c.length?c[0]:c.find((function(t){return Object.keys(e.values).includes(t)})),s&&(r=F(F({},n),{},{name:s}))}r||(r=n),Array.isArray(r)?r.forEach((function(e){return t.push(e)})):(u&&(r.messages=u),t.push(r))}})),t}},{key:"getValuesAfterProceed",value:function(){var e,t=this.remediation.value||[],n=this.getInputs(),r=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return U(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?U(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}([].concat((0,S.Z)(t),(0,S.Z)(n)));try{for(r.s();!(e=r.n()).done;){var o=e.value;delete this.values[o.name]}}catch(e){r.e(e)}finally{r.f()}return this.values}},{key:"getAuthenticator",value:function(){var e,t,n=null===(e=this.remediation.relatesTo)||void 0===e?void 0:e.value;if(n){var r=C(this.remediation);if(!r)return n;var o=r.form.value.find((function(e){return"id"===e.name})).value,i=null===(t=r.form.value.find((function(e){return"enrollmentId"===e.name})))||void 0===t?void 0:t.value;return F(F({},n),{},{id:o,enrollmentId:i})}}}],[{key:"getMessages",value:function(e){var t,n;if(e.value)return null===(t=e.value[0])||void 0===t||null===(n=t.form)||void 0===n?void 0:n.value.reduce((function(e,t){return t.messages&&(e=[].concat((0,S.Z)(e),(0,S.Z)(t.messages.value))),e}),[])}}]),e}();(0,o.Z)(H,"remediationName",void 0);var K=n(136),B=n(2963),V=n(1120),G=n(7326);function q(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=(0,V.Z)(e)););return e}function Y(){return Y="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,n){var r=q(e,t);if(r){var o=Object.getOwnPropertyDescriptor(r,t);return o.get?o.get.call(arguments.length<3?e:n):o.value}},Y.apply(this,arguments)}var W=function e(t){(0,x.Z)(this,e),(0,o.Z)(this,"meta",void 0),this.meta=t};function z(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function $(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?z(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):z(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var Q=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){return!!(e.credentials||e.verificationCode||e.otp)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.verificationCode,r=e.otp;if(t||n||r)return t||{passcode:n||r}}},{key:"getInputs",value:function(e){var t;return $($({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"verificationCode",type:"string",required:e.required})}}]),o}(W);var X=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"mapCredentials",value:function(e){var t=e.verificationCode;if(t)return{totp:t}}}]),o}(Q);function J(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ee(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?J(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):J(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var te=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){return!!(e.credentials||e.password||e.passcode)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.password,r=e.passcode;if(t||n||r)return t||{passcode:r||n}}},{key:"getInputs",value:function(e){var t;return ee(ee({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"password",type:"string",required:e.required})}}]),o}(W);var ne=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){var t=e.credentials;if(t&&t.questionKey&&t.answer)return!0;var n=e.questionKey,r=e.question,o=e.answer;return!(!n||!o)||!(!r||!o)}},{key:"mapCredentials",value:function(e){var t=e.questionKey,n=e.question,r=e.answer;if(r&&(t||n))return{questionKey:n?"custom":t,question:n,answer:r}}},{key:"getInputs",value:function(){return[{name:"questionKey",type:"string",required:!0},{name:"question",type:"string",label:"Create a security question"},{name:"answer",type:"string",label:"Answer",required:!0}]}}]),o}(W);var re=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){var t=e.credentials;return!(!t||!t.answer)||!!e.answer}},{key:"mapCredentials",value:function(e){var t=e.answer;if(t)return{questionKey:this.meta.contextualData.enrolledQuestion.questionKey,answer:t}}},{key:"getInputs",value:function(){return[{name:"answer",type:"string",label:"Answer",required:!0}]}}]),o}(W);var oe=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.attestation;return!(!n||!r)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.clientData,r=e.attestation;if(t||n||r)return t||{clientData:n,attestation:r}}},{key:"getInputs",value:function(){return[{name:"clientData",type:"string",required:!0,visible:!1,label:"Client Data"},{name:"attestation",type:"string",required:!0,visible:!1,label:"Attestation"}]}}]),o}(W);var ie=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.authenticatorData,o=t.signatureData;return!!(n&&r&&o)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.authenticatorData,r=e.clientData,o=e.signatureData;if(t||n||r||o)return t||{authenticatorData:n,clientData:r,signatureData:o}}},{key:"getInputs",value:function(){return[{name:"authenticatorData",type:"string",label:"Authenticator Data",required:!0,visible:!1},{name:"clientData",type:"string",label:"Client Data",required:!0,visible:!1},{name:"signatureData",type:"string",label:"Signature Data",required:!0,visible:!1}]}}]),o}(W);function ae(e){var t,n,r=e.relatesTo,o=(null==r?void 0:r.value)||{};switch(o.key){case D.pc.OKTA_PASSWORD:return new te(o);case D.pc.SECURITY_QUESTION:return null!==(t=o.contextualData)&&void 0!==t&&t.enrolledQuestion?new re(o):new ne(o);case D.pc.OKTA_VERIFY:return new X(o);case D.pc.WEBAUTHN:return null!==(n=o.contextualData)&&void 0!==n&&n.challengeData?new ie(o):new oe(o);default:return new Q(o)}}function ue(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function se(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ue(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ue(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var ce=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,x.Z)(this,i),t=r.call(this,e,n),(0,o.Z)((0,G.Z)(t),"authenticator",void 0),t.authenticator=ae(e),t}return(0,Z.Z)(i,[{key:"getNextStep",value:function(e,t){var n,r=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e,t),o=null==t||null===(n=t.authenticatorEnrollments)||void 0===n?void 0:n.value;return se(se({},r),{},{authenticatorEnrollments:o})}},{key:"canRemediate",value:function(){return this.authenticator.canVerify(this.values)}},{key:"mapCredentials",value:function(){return this.authenticator.mapCredentials(this.values)}},{key:"getInputCredentials",value:function(e){return this.authenticator.getInputs(e)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=Y((0,V.Z)(i.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"credentials"!==e})).reduce((function(t,n){return se(se({},t),{},(0,o.Z)({},n,e.values[n]))}),{})}}]),i}(H);var fe=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return o}(ce);function le(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function pe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?le(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):le(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(fe,"remediationName","enroll-authenticator");var he=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){return(0,x.Z)(this,i),r.apply(this,arguments)}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"enroll-poll"===this.options.step}},{key:"getNextStep",value:function(e,t){var n=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e,t),r=this.getAuthenticator();return!r&&null!=t&&t.currentAuthenticator&&(r=t.currentAuthenticator.value),pe(pe({},n),{},{authenticator:r,poll:{required:!0,refresh:this.remediation.refresh}})}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return"startPolling"!==e})).reduce((function(t,n){return pe(pe({},t),{},(0,o.Z)({},n,e.values[n]))}),{})}}]),i}(H);function de(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ve(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?de(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):de(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(he,"remediationName","enroll-poll");var ye=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){return(0,x.Z)(this,i),r.apply(this,arguments)}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){if(this.values.channel)return!0;if(this.values.authenticator){var e=this.values.authenticator,t=e.id,n=e.channel;if(t&&n)return!0}return!1}},{key:"getNextStep",value:function(e,t){var n=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e,t),r=this.getChannels(),o=t.currentAuthenticator.value;return ve(ve(ve({},n),r&&{options:r}),{},{authenticator:o})}},{key:"getChannels",value:function(){var e;return null===(e=C(this.remediation).value.form.value.find((function(e){return"channel"===e.name})))||void 0===e?void 0:e.options}},{key:"getData",value:function(){var e;return{authenticator:{id:this.remediation.value[0].value.form.value[0].value,channel:(null===(e=this.values.authenticator)||void 0===e?void 0:e.channel)||this.values.channel},stateHandle:this.values.stateHandle}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=Y((0,V.Z)(i.prototype),"getValuesAfterProceed",this).call(this),delete this.values.authenticators;var t=this.values.channel?"channel":"authenticator";return Object.keys(this.values).filter((function(e){return e!==t})).reduce((function(t,n){return ve(ve({},t),{},(0,o.Z)({},n,e.values[n]))}),{})}}]),i}(H);function ge(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function me(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ge(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ge(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(ye,"remediationName","select-enrollment-channel");var be=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){return(0,x.Z)(this,i),r.apply(this,arguments)}return(0,Z.Z)(i,[{key:"getInputEmail",value:function(){return[{name:"email",type:"string",required:!0,label:"Email"}]}},{key:"getInputPhoneNumber",value:function(){return[{name:"phoneNumber",type:"string",required:!0,label:"Phone Number"}]}},{key:"canRemediate",value:function(){return Boolean(this.values.email||this.values.phoneNumber)}},{key:"getNextStep",value:function(e,t){var n=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e,t),r=t.currentAuthenticator.value;return me(me({},n),{},{authenticator:r})}},{key:"getData",value:function(){return{stateHandle:this.values.stateHandle,email:this.values.email,phoneNumber:this.values.phoneNumber}}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return!["email","phoneNumber"].includes(e)})).reduce((function(t,n){return me(me({},t),{},(0,o.Z)({},n,e.values[n]))}),{})}}]),i}(H);(0,o.Z)(be,"remediationName","enrollment-channel-data");var ke=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return o}(ce);(0,o.Z)(ke,"remediationName","challenge-authenticator");var we=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"challenge-poll"===this.options.step}}]),o}(he);(0,o.Z)(we,"remediationName","challenge-poll");var Oe=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return o}(ce);function Ee(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Te(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ee(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ee(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(Oe,"remediationName","reset-authenticator");var Se=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,x.Z)(this,i),t=r.call(this,e,n,a),(0,o.Z)((0,G.Z)(t),"authenticator",null);var u=t.getCredentialsFromRemediation();return u&&(t.authenticator=t.authenticator=new te({})),t}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){if(this.authenticator&&!this.authenticator.canVerify(this.values))return!1;var e=this.getData().userProfile;return!!e&&this.remediation.value.find((function(e){return"userProfile"===e.name})).form.value.reduce((function(t,n){return n.required&&(t=t&&!!e[n.name]),t}),!0)}},{key:"getCredentialsFromRemediation",value:function(){return this.remediation.value.find((function(e){return"credentials"===e.name}))}},{key:"mapUserProfile",value:function(e){var t=this,n=e.form.value.map((function(e){return e.name})).reduce((function(e,n){return t.values[n]?Te(Te({},e),{},(0,o.Z)({},n,t.values[n])):e}),{});if(0!==Object.keys(n).length)return n}},{key:"mapCredentials",value:function(){var e=this.authenticator&&this.authenticator.mapCredentials(this.values);if(e)return e}},{key:"getInputUserProfile",value:function(e){return(0,S.Z)(e.form.value)}},{key:"getInputCredentials",value:function(e){return(0,S.Z)(e.form.value)}},{key:"getErrorMessages",value:function(e){return e.value[0].form.value.reduce((function(e,t){return t.messages&&e.push(t.messages.value[0].message),e}),[])}}]),i}(H);function _e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ae(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?_e(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):_e(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(Se,"remediationName","enroll-profile");var Pe=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){var e;(0,x.Z)(this,i);for(var t=arguments.length,n=new Array(t),a=0;a<t;a++)n[a]=arguments[a];return e=r.call.apply(r,[this].concat(n)),(0,o.Z)((0,G.Z)(e),"map",{identifier:["username"]}),e}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){return!!this.getData().identifier}},{key:"mapCredentials",value:function(){var e=this.values,t=e.credentials,n=e.password;if(t||n)return t||{passcode:n}}},{key:"getInputCredentials",value:function(e){return Ae(Ae({},e.form.value[0]),{},{name:"password",required:e.required})}}]),i}(H);function Re(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function xe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Re(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Re(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(Pe,"remediationName","identify");var Ze=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"mapCredentials",value:function(){var e=this.values.newPassword;if(e)return{passcode:e}}},{key:"getInputCredentials",value:function(e){var t="password"===this.getAuthenticator().type?"newPassword":"verificationCode";return xe(xe({},e.form.value[0]),{},{name:t})}}]),o}(H);(0,o.Z)(Ze,"remediationName","reenroll-authenticator");var je=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canRemediate",value:function(){return!1}},{key:"getNextStep",value:function(){var e=this.remediation;return{name:e.name,type:e.type,idp:e.idp,href:e.href}}}]),o}(H);function Ce(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function De(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ce(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ce(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Ie(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}(0,o.Z)(je,"remediationName","redirect-idp");var Me=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){var e;(0,x.Z)(this,i);for(var t=arguments.length,n=new Array(t),a=0;a<t;a++)n[a]=arguments[a];return e=r.call.apply(r,[this].concat(n)),(0,o.Z)((0,G.Z)(e),"selectedAuthenticator",void 0),(0,o.Z)((0,G.Z)(e),"selectedOption",void 0),e}return(0,Z.Z)(i,[{key:"findMatchedOption",value:function(e,t){var n,r,o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return Ie(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Ie(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(e);try{var i=function(){var e=r.value;if(n=t.find((function(t){return t.relatesTo.key===e.key})))return"break"};for(o.s();!(r=o.n()).done&&"break"!==i(););}catch(e){o.e(e)}finally{o.f()}return n}},{key:"canRemediate",value:function(){var e=this.values,t=e.authenticators,n=e.authenticator,r=C(this.remediation).options;return!!(t&&t.length&&((0,D.H)(n)&&n.id||this.findMatchedOption(t,r)))}},{key:"getNextStep",value:function(e){var t=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e),n=C(this.remediation).options.map((function(e){var t=e;return{label:t.label,value:t.relatesTo.key}}));return De(De({},t),{},{options:n})}},{key:"mapAuthenticator",value:function(e){var t=this.values,n=t.authenticators,r=t.authenticator;if((0,D.H)(r)&&r.id)return this.selectedAuthenticator=r,r;var o=function(e,t){var n,r,o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return I(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?I(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(e);try{var i=function(){var e=r.value;if(n=t.find((function(t){return t.relatesTo.key===e.key})))return"break"};for(o.s();!(r=o.n()).done&&"break"!==i(););}catch(e){o.e(e)}finally{o.f()}return n}(n,e.options);return this.selectedAuthenticator=o.relatesTo,this.selectedOption=o,{id:null==o?void 0:o.value.form.value.find((function(e){return"id"===e.name})).value}}},{key:"getInputAuthenticator",value:function(e){return{name:"authenticator",type:"string",options:e.options.map((function(e){return{label:e.label,value:e.relatesTo.key}}))}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=Y((0,V.Z)(i.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticators.filter((function(t){return!0!==N(t,e.selectedAuthenticator)}));return De(De({},this.values),{},{authenticators:t})}}]),i}(H);var Ne=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(e){var t,n,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,x.Z)(this,o);var u="recoverPassword"===(n=r.call(this,e,i,a)).options.flow,s=null===(t=C(e).options)||void 0===t?void 0:t.some((function(e){var t=e.relatesTo;return(null==t?void 0:t.key)===D.pc.OKTA_PASSWORD}));return s&&(u||n.values.password)&&(n.values.authenticators=[].concat((0,S.Z)(n.values.authenticators||[]),[{key:D.pc.OKTA_PASSWORD}])),n}return o}(Me);(0,o.Z)(Ne,"remediationName","select-authenticator-authenticate");var Ue=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return o}(Me);function Le(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Fe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Le(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Le(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(Ue,"remediationName","select-authenticator-enroll");var He=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(){var e;(0,x.Z)(this,i);for(var t=arguments.length,n=new Array(t),a=0;a<t;a++)n[a]=arguments[a];return e=r.call.apply(r,[this].concat(n)),(0,o.Z)((0,G.Z)(e),"authenticator",void 0),(0,o.Z)((0,G.Z)(e),"map",{identifier:["username"]}),e}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){return!!this.getData("identifier")&&Y((0,V.Z)(i.prototype),"canRemediate",this).call(this)}},{key:"mapAuthenticator",value:function(e){var t,n,r,o=Y((0,V.Z)(i.prototype),"mapAuthenticator",this).call(this,e),a=null===(t=this.selectedOption)||void 0===t?void 0:t.value.form.value.find((function(e){return"methodType"===e.name})),u=this.values.methodType||(null==a?void 0:a.value)||(null==a||null===(n=a.options)||void 0===n||null===(r=n[0])||void 0===r?void 0:r.value);return u?Fe(Fe({},o),{},{methodType:u}):o}},{key:"getInputUsername",value:function(){return{name:"username",type:"string"}}}]),i}(Me);(0,o.Z)(He,"remediationName","select-authenticator-unlock-account");var Ke=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canRemediate",value:function(){return!0}}]),o}(H);function Be(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ve(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Be(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Be(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(Ke,"remediationName","select-enroll-profile");var Ge=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,x.Z)(this,i),t=r.call(this,e,n),(0,o.Z)((0,G.Z)(t),"authenticator",void 0),t.authenticator=t.getAuthenticator(),t.formatAuthenticatorData(),t}return(0,Z.Z)(i,[{key:"formatAuthenticatorData",value:function(){var e=this;if(this.getAuthenticatorData())this.values.authenticatorsData=this.values.authenticatorsData.map((function(t){return N(e.authenticator,t)?e.mapAuthenticatorDataFromValues(t):t}));else{var t=this.mapAuthenticatorDataFromValues();t&&this.values.authenticatorsData.push(t)}}},{key:"getAuthenticatorData",value:function(){var e=this;return this.values.authenticatorsData.find((function(t){return N(e.authenticator,t)}))}},{key:"canRemediate",value:function(){var e=this;return this.values.authenticatorsData.some((function(t){return N(e.authenticator,t)}))}},{key:"getNextStep",value:function(e){var t=Y((0,V.Z)(i.prototype),"getNextStep",this).call(this,e),n=this.getMethodTypes();return Ve(Ve({},t),n&&{options:n})}},{key:"mapAuthenticatorDataFromValues",value:function(e){var t=this.values,n=t.methodType,r=t.authenticator;!n&&(0,D.H)(r)&&(n=null==r?void 0:r.methodType);var o=this.authenticator,i=Ve(Ve({id:o.id,enrollmentId:o.enrollmentId},e&&e),n&&{methodType:n});return i.methodType?i:null}},{key:"getAuthenticatorFromRemediation",value:function(){return this.remediation.value.find((function(e){return"authenticator"===e.name}))}},{key:"getMethodTypes",value:function(){var e;return null===(e=this.getAuthenticatorFromRemediation().form.value.find((function(e){return"methodType"===e.name})))||void 0===e?void 0:e.options}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=Y((0,V.Z)(i.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticatorsData.filter((function(t){return!0!==N(e.authenticator,t)}));return Ve(Ve({},this.values),{},{authenticatorsData:t})}}]),i}(H);function qe(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ye(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?qe(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):qe(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var We=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return(0,x.Z)(this,i),t=r.call(this,e,n),(0,o.Z)((0,G.Z)(t),"shouldProceedWithEmailAuthenticator",void 0),t.shouldProceedWithEmailAuthenticator=!1!==a.shouldProceedWithEmailAuthenticator&&1===t.authenticator.methods.length&&"email"===t.authenticator.methods[0].type,t}return(0,Z.Z)(i,[{key:"canRemediate",value:function(){return!1!==this.shouldProceedWithEmailAuthenticator||Y((0,V.Z)(i.prototype),"canRemediate",this).call(this)}},{key:"mapAuthenticator",value:function(){var e;return!1!==this.shouldProceedWithEmailAuthenticator?null===(e=this.getAuthenticatorFromRemediation().form)||void 0===e?void 0:e.value.reduce((function(e,t){if(t.value)e[t.name]=t.value;else{if(!t.options)throw new w.R("Unsupported authenticator data type: ".concat(t));e[t.name]=t.options[0].value}return e}),{}):this.getAuthenticatorData()}},{key:"getInputAuthenticator",value:function(){var e=this.getAuthenticatorFromRemediation(),t=e.form.value.find((function(e){return"methodType"===e.name}));return t&&t.options?{name:"methodType",type:"string",required:!0,options:t.options}:(0,S.Z)(e.form.value)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=Y((0,V.Z)(i.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"authenticator"!==e})).reduce((function(t,n){return Ye(Ye({},t),{},(0,o.Z)({},n,e.values[n]))}),{})}}]),i}(Ge);function ze(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function $e(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ze(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ze(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}(0,o.Z)(We,"remediationName","authenticator-verification-data");var Qe=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"mapAuthenticator",value:function(){var e=this.getAuthenticatorData();return{id:C(this.remediation).form.value.find((function(e){return"id"===e.name})).value,methodType:e.methodType,phoneNumber:e.phoneNumber}}},{key:"getInputAuthenticator",value:function(e){return[{name:"methodType",type:"string"},{name:"phoneNumber",label:"Phone Number",type:"string"}].map((function(t){return $e($e({},e.form.value.find((function(e){return e.name===t.name}))),t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){e=Y((0,V.Z)(o.prototype),"mapAuthenticatorDataFromValues",this).call(this,e);var t=this.values.phoneNumber;if(e||t)return $e($e({},e&&e),t&&{phoneNumber:t})}}]),o}(Ge);(0,o.Z)(Qe,"remediationName","authenticator-enrollment-data");var Xe=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canRemediate",value:function(){return!!this.values.skip||"skip"===this.options.step}}]),o}(H);function Je(e){if(Array.isArray(e))return e.map((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e?e:Je(e)}));for(var t={},n=0,r=Object.entries(e);n<r.length;n++){var o=(0,A.Z)(r[n],2),i=o[0],a=o[1];if(null!=a)if("object"===(0,T.Z)(a)){var u=Object.keys(a);if(["value","form"].includes(i)&&1===u.length&&["value","form"].includes(u[0])){var s=Je(a);Object.entries(s).forEach((function(e){var n=(0,A.Z)(e,2),r=n[0],o=n[1];t[r]=o}))}else t[i]=Je(a)}else t[i]=a}return t}(0,o.Z)(Xe,"remediationName","skip");var et=["href","method","rel","accepts","produces","value","action"];function tt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function nt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?tt(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):tt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var rt=function(e){(0,K.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function o(){return(0,x.Z)(this,o),r.apply(this,arguments)}return(0,Z.Z)(o,[{key:"canRemediate",value:function(){return!("function"!=typeof this.remediation.action||"poll"!==this.remediation.name&&!this.remediation.name.endsWith("-poll")&&!this.options.step)}},{key:"getData",value:function(){var e=this;return this.getInputs().reduce((function(t,n){var r=n.name;return t[r]=e.values[r],t}),{})}},{key:"getNextStep",value:function(e,t){var n,r=this.getName(),o=this.getInputs(),a=this.remediation,s=(a.href,a.method,a.rel,a.accepts,a.produces,a.value,a.action),c=(0,_.Z)(a,et);return s?nt(nt(nt({},c),!!o.length&&{inputs:o}),{},{action:(n=(0,i.Z)(u().mark((function t(n){return u().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed(nt({step:r},n)));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})}):nt({},this.remediation)}},{key:"getInputs",value:function(){return(this.remediation.value||[]).filter((function(e){return"stateHandle"!==e.name})).map(Je).map((function(e){return e.type=e.type||"string",e}))}}]),o}(H),ot=["href","method","rel","accepts","produces"];function it(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function at(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?it(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):it(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function ut(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return st(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?st(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function st(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function ct(e){var t=e.neededToProceed,n=e.interactionCode;return!t.length&&!n}function ft(e){if(e&&Array.isArray(e))return e.reduce((function(e,t){if(t.messages&&(e=[].concat((0,S.Z)(e),(0,S.Z)(t.messages.value))),t.form){var n=ft(t.form.value)||[];e=[].concat((0,S.Z)(e),(0,S.Z)(n))}if(t.options){var r=[];t.options.forEach((function(e){e.value&&"string"!=typeof e.value&&(r=[].concat((0,S.Z)(r),[e.value]))}));var o=ft(r)||[];e=[].concat((0,S.Z)(e),(0,S.Z)(o))}return e}),[])}function lt(e,t){var n,r=[],o=e.rawIdxState,i=e.neededToProceed,a=null===(n=o.messages)||void 0===n?void 0:n.value.map((function(e){return e}));if(a&&(r=[].concat((0,S.Z)(r),(0,S.Z)(a))),!t.useGenericRemediator){var u,s=ut(i);try{for(s.s();!(u=s.n()).done;){var c=ft(u.value.value);c&&(r=[].concat((0,S.Z)(r),(0,S.Z)(c)))}}catch(e){s.e(e)}finally{s.f()}}var f={};return r.reduce((function(e,t){var n,r=null===(n=t.i18n)||void 0===n?void 0:n.key;return r&&f[r]?e:(f[r]=t,e=[].concat((0,S.Z)(e),[t]))}),[])}function pt(e){var t=[],n=e.actions,r=e.neededToProceed;return n["currentAuthenticator-recover"]&&t.push(D.Fw.PASSWORD_RECOVERY),r.some((function(e){return"select-enroll-profile"===e.name}))&&t.push(D.Fw.REGISTRATION),r.some((function(e){return"redirect-idp"===e.name}))&&t.push(D.Fw.SOCIAL_IDP),r.some((function(e){return"unlock-account"===e.name}))&&t.push(D.Fw.ACCOUNT_UNLOCK),t}function ht(e,t,n){var o,a=[],s=Object.values(r).reduce((function(e,t){return t.remediationName&&(e[t.remediationName]=t),e}),{}),c=ut(t.neededToProceed);try{for(c.s();!(o=c.n()).done;){var f=o.value,l=vt(f,{useGenericRemediator:n,remediators:s});if(l){var p=new l(f);a.push(p.getNextStep(e,t.context))}}}catch(e){c.e(e)}finally{c.f()}for(var h=function(){var n,r=(0,A.Z)(v[d],1)[0],o={name:r,action:(n=(0,i.Z)(u().mark((function t(n){return u().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed({actions:[{name:r,params:n}]}));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})};if(r.startsWith("currentAuthenticator")){var s,c=(0,P.YQ)(r,"-"),f=(0,A.Z)(c,2),l=f[0],p=f[1],h=t.rawIdxState[l].value[p],y=(h.href,h.method,h.rel,h.accepts,h.produces,(0,_.Z)(h,ot)),g=null===(s=h.value)||void 0===s?void 0:s.filter((function(e){return"stateHandle"!==e.name}));o=at(at(at({},y),g&&{value:g}),o)}a.push(o)},d=0,v=Object.entries(t.actions||{});d<v.length;d++)h();return a}function dt(e,t,n){var r=(e.neededToProceed||[]).find((function(e){return e.name===t}));return r?r.value.reduce((function(e,t){var r=t.name,o=t.value;return e[r]="stateHandle"===r?o:n[r],e}),{}):((0,R.ZK)('filterValuesForRemediation: "'.concat(t,'" did not match any remediations')),n)}function vt(e,t){var n=t.useGenericRemediator,r=t.remediators;if(e)return n?rt:r[e.name]}function yt(e,t,n){var r,o=n.remediators,i=n.useGenericRemediator;if(!n.step){var a=[];if(i)a.push(new rt(e[0],t,n));else{var u,s=ut(e);try{for(s.s();!(u=s.n()).done;){var c=u.value;if(Object.keys(o).includes(c.name)){if((r=new(vt(c,n))(c,t,n)).canRemediate())return r;a.push(r)}}}catch(e){s.e(e)}finally{s.f()}}return a[0]}var f=e.find((function(e){return e.name===n.step}));if(f){var l=vt(f,n);return l?new l(f,t,n):void 0}(0,R.ZK)('step "'.concat(n.step,'" did not match any remediations'))}function gt(e,t,n){var r=t.getNextStep(e,n.context),o=function(e){return e.neededToProceed.some((function(e){return"skip"===e.name}))}(n),i=function(e){return Object.keys(e.actions).some((function(e){return e.includes("resend")}))}(n);return at(at(at({},r),o&&{canSkip:o}),i&&{canResend:i})}function mt(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=(0,b.f)(t)?t:null;if(!r)throw t;var o=ct(r=at(at({},r),{},{requestDidSucceed:!1})),i=lt(r,n);if(o)return{idxResponse:r,terminal:o,messages:i};var a=yt(r.neededToProceed,{},n),u=a&&gt(e,a,r);return at({idxResponse:r,messages:i},u&&{nextStep:u})}function bt(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return kt(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?kt(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function kt(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function wt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ot(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?wt(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):wt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Et(e,t){return Object.keys(t.actions).find((function(t){return!!e.resend&&t.includes("-resend")}))}function Tt(e){return Ot(Ot({},e),{},{resend:void 0})}function St(e,t){var n=e.actions||[];return n=n.filter((function(e){return"string"==typeof e?e!==t:e.name!==t})),Ot(Ot({},e),{},{actions:n})}function _t(e,t,n,r){return At.apply(this,arguments)}function At(){return(At=(0,i.Z)(u().mark((function e(t,n,r,o){var i,a,s,c,f,l,p,h,d,v,y,g,m,b,k,O,E,_;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=(i=n).neededToProceed,s=i.interactionCode,c=o.flow,!s){e.next=4;break}return e.abrupt("return",{idxResponse:n});case 4:if(f=yt(a,r,o),l=Et(r,n),p=o.actions||[],!(h=[].concat((0,S.Z)(p),(0,S.Z)(l&&[l]||[])))){e.next=28;break}d=bt(h),e.prev=10,y=u().mark((function e(){var i,s,c,f;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=v.value,s={},"string"!=typeof i&&(s=i.params||{},i=i.name),c=Tt(r),f=St(o,i),"function"!=typeof n.actions[i]){e.next=19;break}return e.prev=6,e.next=9,n.actions[i](s);case 9:n=Ot(Ot({},n=e.sent),{},{requestDidSucceed:!0}),e.next=16;break;case 13:return e.prev=13,e.t0=e.catch(6),e.abrupt("return",{v:mt(t,e.t0,o)});case 16:if("cancel"!==i){e.next=18;break}return e.abrupt("return",{v:{idxResponse:n,canceled:!0}});case 18:return e.abrupt("return",{v:_t(t,n,c,f)});case 19:if(!a.find((function(e){return e.name===i}))){e.next=32;break}return e.prev=21,e.next=24,n.proceed(i,s);case 24:n=Ot(Ot({},n=e.sent),{},{requestDidSucceed:!0}),e.next=31;break;case 28:return e.prev=28,e.t1=e.catch(21),e.abrupt("return",{v:mt(t,e.t1,o)});case 31:return e.abrupt("return",{v:_t(t,n,r,f)});case 32:case"end":return e.stop()}}),e,null,[[6,13],[21,28]])})),d.s();case 13:if((v=d.n()).done){e.next=20;break}return e.delegateYield(y(),"t0",15);case 15:if(g=e.t0,"object"!==(0,T.Z)(g)){e.next=18;break}return e.abrupt("return",g.v);case 18:e.next=13;break;case 20:e.next=25;break;case 22:e.prev=22,e.t1=e.catch(10),d.e(e.t1);case 25:return e.prev=25,d.f(),e.finish(25);case 28:if(!(m=ct(n))){e.next=31;break}return e.abrupt("return",{idxResponse:n,terminal:m});case 31:if(f){e.next=48;break}if(!o.step){e.next=45;break}return r=dt(n,o.step,r),e.prev=34,e.next=37,n.proceed(o.step,r);case 37:return n=Ot(Ot({},n=e.sent),{},{requestDidSucceed:!0}),e.abrupt("return",{idxResponse:n});case 42:return e.prev=42,e.t2=e.catch(34),e.abrupt("return",mt(t,e.t2,o));case 45:if("default"!==c){e.next=47;break}return e.abrupt("return",{idxResponse:n});case 47:throw new w.R("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(a.reduce((function(e,t){return e?e+" ,"+t.name:t.name}),""),"]\n    "));case 48:if(f.canRemediate()){e.next=51;break}return b=gt(t,f,n),e.abrupt("return",{idxResponse:n,nextStep:b});case 51:return k=f.getName(),O=f.getData(),e.prev=53,e.next=56,n.proceed(k,O);case 56:if(n=Ot(Ot({},n=e.sent),{},{requestDidSucceed:!0}),r=f.getValuesAfterProceed(),!(o=Ot(Ot({},o),{},{step:void 0})).useGenericRemediator||n.interactionCode||ct(n)){e.next=64;break}return E=yt(n.neededToProceed,r,o),_=gt(t,E,n),e.abrupt("return",{idxResponse:n,nextStep:_});case 64:return e.abrupt("return",_t(t,n,r,o));case 67:return e.prev=67,e.t3=e.catch(53),e.abrupt("return",mt(t,e.t3,o));case 70:case"end":return e.stop()}}),e,null,[[10,22,25,28],[34,42],[53,67]])})))).apply(this,arguments)}var Pt={identify:Pe,"select-authenticator-authenticate":Ne,"select-authenticator-enroll":Ue,"authenticator-enrollment-data":Qe,"authenticator-verification-data":We,"enroll-authenticator":fe,"challenge-authenticator":ke,"challenge-poll":we,"reenroll-authenticator":Ze,"enroll-poll":he,"select-enrollment-channel":ye,"enrollment-channel-data":be,"redirect-idp":je,skip:Xe},Rt={identify:Pe,"identify-recovery":Pe,"select-authenticator-authenticate":Ne,"select-authenticator-enroll":Ue,"challenge-authenticator":ke,"authenticator-verification-data":We,"authenticator-enrollment-data":Qe,"reset-authenticator":Oe,"reenroll-authenticator":Ze,"enroll-poll":he},xt={"select-enroll-profile":Ke,"enroll-profile":Se,"authenticator-enrollment-data":Qe,"select-authenticator-enroll":Ue,"enroll-poll":he,"select-enrollment-channel":ye,"enrollment-channel-data":be,"enroll-authenticator":fe,skip:Xe},Zt={identify:Pe,"select-authenticator-unlock-account":He,"select-authenticator-authenticate":Ne,"challenge-authenticator":ke,"challenge-poll":we,"authenticator-verification-data":We};function jt(e){var t,n,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default",o=!0;switch(r){case"register":case"signup":case"enrollProfile":t=xt,o=!1;break;case"recoverPassword":case"resetPassword":t=Rt,n=["currentAuthenticator-recover","currentAuthenticatorEnrollment-recover"],o=!1;break;case"unlockAccount":t=Zt,o=!1,n=["unlock-account"];break;default:t=Pt}return{flow:r,remediators:t,actions:n,withCredentials:o}}function Ct(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Dt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ct(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ct(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function It(e){var t=Dt({},e);return["flow","remediators","actions","withCredentials","step","useGenericRemediator","exchangeCodeForTokens","shouldProceedWithEmailAuthenticator"].forEach((function(e){delete t[e]})),t}function Mt(e,t){var n=t.options,r=n=Dt(Dt({},e.options.idx),n),o=r.flow,i=r.withCredentials,a=r.remediators,u=r.actions,c=s.IdxStatus.PENDING;if(o=o||e.idx.getFlow()||"default"){e.idx.setFlow(o);var f=jt(e,o);i=void 0!==i?i:f.withCredentials,a=a||f.remediators,u=u||f.actions}return Dt(Dt({},t),{},{options:Dt(Dt({},n),{},{flow:o,withCredentials:i,remediators:a,actions:u}),status:c})}function Nt(e,t){return Ut.apply(this,arguments)}function Ut(){return(Ut=(0,i.Z)(u().mark((function e(t,n){var r,o,i,a,s,f,l,p,h,d,v,g,m,b,k;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=r.stateHandle,i=r.withCredentials,a=r.version,s=r.state,f=r.scopes,l=r.recoveryToken,p=r.activationToken,h=r.maxAge,d=r.nonce,g=(0,c.uN)(t,{state:s,recoveryToken:l,activationToken:p}),!o){e.next=9;break}return e.next=6,O(t,{withCredentials:i,version:a,stateHandle:o});case 6:v=e.sent,e.next=20;break;case 9:if(b=null===(m=g)||void 0===m?void 0:m.interactionHandle){e.next=17;break}return t.transactionManager.clear(),e.next=14,y(t,{withCredentials:i,state:s,scopes:f,activationToken:p,recoveryToken:l,maxAge:h,nonce:d});case 14:k=e.sent,b=k.interactionHandle,g=k.meta;case 17:return e.next=19,O(t,{withCredentials:i,version:a,interactionHandle:b});case 19:v=e.sent;case 20:return e.abrupt("return",Dt(Dt({},n),{},{idxResponse:v,meta:g}));case 21:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function Lt(e,t){return Ft.apply(this,arguments)}function Ft(){return(Ft=(0,i.Z)(u().mark((function e(t,n){var r,o,i,a,s,c,f,l,p,h,d,v,y,g;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.idxResponse,o=n.options,i=n.values,a=o.autoRemediate,s=o.remediators,c=o.actions,f=o.flow,l=o.step,p=o.shouldProceedWithEmailAuthenticator,h=o.useGenericRemediator,!1!==a&&(s||c||l)){e.next=5;break}return e.abrupt("return",n);case 5:return i=Dt(Dt({},i),{},{stateHandle:r.rawIdxState.stateHandle}),e.next=8,_t(t,r,i,{remediators:s,actions:c,flow:f,step:l,shouldProceedWithEmailAuthenticator:p,useGenericRemediator:h});case 8:return d=e.sent,v=d.idxResponse,y=d.nextStep,g=d.canceled,r=v,e.abrupt("return",Dt(Dt({},n),{},{idxResponse:r,nextStep:y,canceled:g}));case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function Ht(e,t){return Kt.apply(this,arguments)}function Kt(){return(Kt=(0,i.Z)(u().mark((function e(t,n){var r,o,i,a,s,c,f,l,p,h,d;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.meta,o=n.idxResponse,i=o.interactionCode,s=(a=r).clientId,c=a.codeVerifier,f=a.ignoreSignature,l=a.redirectUri,p=a.urls,h=a.scopes,e.next=5,t.token.exchangeCodeForTokens({interactionCode:i,clientId:s,codeVerifier:c,ignoreSignature:f,redirectUri:l,scopes:h},p);case 5:return d=e.sent,e.abrupt("return",d.tokens);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function Bt(e,t){return Vt.apply(this,arguments)}function Vt(){return(Vt=(0,i.Z)(u().mark((function e(t,n){var r,o,i,a,c,f,l,p,h,d,v,y,g,m,b,k;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=n.idxResponse,i=n.canceled,a=n.status,c=r.exchangeCodeForTokens,f=!1,l=!1,p=!0,o&&(f=!(!o.requestDidSucceed&&!o.stepUp),v=pt(o),y=ht(t,o,r.useGenericRemediator),g=lt(o,r),m=ct(o)),!m){e.next=15;break}a=s.IdxStatus.TERMINAL,b=Object.keys(o.actions).length>0,k=!!g.find((function(e){return"ERROR"===e.class})),b||k||!0!==o.requestDidSucceed?f=f&&b:l=!0,p=!1,e.next=32;break;case 15:if(!i){e.next=20;break}a=s.IdxStatus.CANCELED,l=!0,e.next=32;break;case 20:if(null==o||!o.interactionCode){e.next=32;break}if(h=o.interactionCode,!1!==c){e.next=27;break}a=s.IdxStatus.SUCCESS,l=!1,e.next=32;break;case 27:return e.next=29,Ht(t,n);case 29:d=e.sent,a=s.IdxStatus.SUCCESS,l=!0;case 32:return e.abrupt("return",Dt(Dt({},n),{},{status:a,interactionCode:h,tokens:d,shouldSaveResponse:f,shouldClearTransaction:l,clearSharedStorage:p,enabledFeatures:v,availableSteps:y,messages:g,terminal:m}));case 33:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function Gt(e,t){var n=t.error,r=t.status;t.shouldClearTransaction;if(!(0,b.f)(e))throw e;return n=e,r=s.IdxStatus.FAILURE,!0,Dt(Dt({},t),{},{error:n,status:r,shouldClearTransaction:true})}function qt(e){return Yt.apply(this,arguments)}function Yt(){return Yt=(0,i.Z)(u().mark((function e(t){var n,r,o,i,a,s,f,l,p,h,d,v,y,g,m,b,k,w,O,E,T,S,_,A,P,R,x,Z,j=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=j.length>1&&void 0!==j[1]?j[1]:{},r={options:n,values:It(n)},r=Mt(t,r),e.prev=3,e.next=6,Nt(t,r);case 6:return r=e.sent,e.next=9,Lt(t,r);case 9:r=e.sent,e.next=15;break;case 12:e.prev=12,e.t0=e.catch(3),r=Gt(e.t0,r);case 15:return e.next=17,Bt(t,r);case 17:return r=e.sent,i=(o=r).idxResponse,a=o.meta,s=o.shouldSaveResponse,f=o.shouldClearTransaction,l=o.clearSharedStorage,p=o.status,h=o.enabledFeatures,d=o.availableSteps,v=o.tokens,y=o.nextStep,g=o.messages,m=o.error,b=o.interactionCode,f?t.transactionManager.clear({clearSharedStorage:l}):((0,c.r0)(t,Dt({},a)),s&&(O=(w=i).rawIdxState,E=w.requestDidSucceed,t.transactionManager.saveIdxResponse({rawIdxResponse:O,requestDidSucceed:E,stateHandle:null===(k=i.context)||void 0===k?void 0:k.stateHandle,interactionHandle:null==a?void 0:a.interactionHandle}))),S=(T=i||{}).actions,_=T.context,A=T.neededToProceed,P=T.proceed,R=T.rawIdxState,x=T.requestDidSucceed,Z=T.stepUp,e.abrupt("return",Dt(Dt(Dt(Dt(Dt(Dt(Dt(Dt(Dt({status:p},a&&{meta:a}),h&&{enabledFeatures:h}),d&&{availableSteps:d}),v&&{tokens:v}),y&&{nextStep:y}),g&&g.length&&{messages:g}),m&&{error:m}),Z&&{stepUp:Z}),{},{interactionCode:b,actions:S,context:_,neededToProceed:A,proceed:P,rawIdxState:R,requestDidSucceed:x}));case 22:case"end":return e.stop()}}),e,null,[[3,12]])}))),Yt.apply(this,arguments)}function Wt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function zt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Wt(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Wt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function $t(e){return Qt.apply(this,arguments)}function Qt(){return Qt=(0,i.Z)(u().mark((function e(t){var n,r=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return(n=r.length>1&&void 0!==r[1]?r[1]:{}).password&&!n.authenticator&&(n.authenticator=s.AuthenticatorKey.OKTA_PASSWORD),e.abrupt("return",qt(t,zt(zt({},n),{},{flow:"authenticate"})));case 3:case"end":return e.stop()}}),e)}))),Qt.apply(this,arguments)}function Xt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Jt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Xt(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Xt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function en(e,t){return tn.apply(this,arguments)}function tn(){return(tn=(0,i.Z)(u().mark((function e(t,n){var r,o;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.transactionManager.load(),o=jt(t,r.flow),e.abrupt("return",qt(t,Jt(Jt(Jt({},n),o),{},{actions:["cancel"]})));case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}var nn=n(6245),rn=n(1969);var on=function(e){(0,K.Z)(i,e);var t,n,r=(t=i,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,V.Z)(t);if(n){var o=(0,V.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,B.Z)(this,e)});function i(e,t){var n;return(0,x.Z)(this,i),n=r.call(this,"Enter the OTP code in the originating client: ".concat(t)),(0,o.Z)((0,G.Z)(n),"state",void 0),(0,o.Z)((0,G.Z)(n),"otp",void 0),n.name="EmailVerifyCallbackError",n.state=e,n.otp=t,n}return i}(nn.Z);function an(e){return"EmailVerifyCallbackError"===e.name}function un(e){return/(otp=)/i.test(e)&&/(state=)/i.test(e)}function sn(e){return(0,rn.v)(e)}function cn(e,t){return fn.apply(this,arguments)}function fn(){return(fn=(0,i.Z)(u().mark((function e(t,n){var r,o,i;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!un(n)){e.next=9;break}if(r=sn(n),o=r.state,i=r.otp,!t.idx.canProceed({state:o})){e.next=8;break}return e.next=5,t.idx.proceed({state:o,otp:i});case 5:return e.abrupt("return",e.sent);case 8:throw new on(o,i);case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function ln(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function pn(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ln(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ln(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function hn(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=(0,c.uN)(e,t);return!(!n&&!t.stateHandle)}function dn(e){return vn.apply(this,arguments)}function vn(){return vn=(0,i.Z)(u().mark((function e(t){var n,r,o,i,a=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=a.length>1&&void 0!==a[1]?a[1]:{},hn(t,n)){e.next=3;break}throw new w.R("Unable to proceed: saved transaction could not be loaded");case 3:return r=n.flow,o=n.state,r||(i=(0,c.uN)(t,{state:o}),r=null==i?void 0:i.flow),e.abrupt("return",qt(t,pn(pn({},n),{},{flow:r})));case 6:case"end":return e.stop()}}),e)}))),vn.apply(this,arguments)}function yn(e){return gn.apply(this,arguments)}function gn(){return gn=(0,i.Z)(u().mark((function e(t){var n,r,o,a,s,f=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=f.length>1&&void 0!==f[1]?f[1]:{},e.next=3,dn(t,{startPolling:!0});case 3:if(o=e.sent,a=(0,c.uN)(t),null!=(s=null==a||null===(n=a.remediations)||void 0===n?void 0:n.find((function(e){return e.includes("poll")})))&&s.length||(0,R.ZK)("No polling remediations available at the current IDX flow stage"),!Number.isInteger(r.refresh)){e.next=9;break}return e.abrupt("return",new Promise((function(e,n){setTimeout((0,i.Z)(u().mark((function r(){var i,a,s;return u().wrap((function(r){for(;;)switch(r.prev=r.next){case 0:try{s=null===(i=o.nextStep)||void 0===i||null===(a=i.poll)||void 0===a?void 0:a.refresh,e(s?yn(t,{refresh:s}):o)}catch(e){n(e)}case 1:case"end":return r.stop()}}),r)}))),r.refresh)})));case 9:return e.abrupt("return",o);case 10:case"end":return e.stop()}}),e)}))),gn.apply(this,arguments)}function mn(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function bn(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?mn(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):mn(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function kn(e){return wn.apply(this,arguments)}function wn(){return wn=(0,i.Z)(u().mark((function e(t){var n,r=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.length>1&&void 0!==r[1]?r[1]:{},t.transactionManager.clear(),e.abrupt("return",qt(t,bn({exchangeCodeForTokens:!1},n)));case 3:case"end":return e.stop()}}),e)}))),wn.apply(this,arguments)}function On(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function En(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?On(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):On(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Tn(e){return Sn.apply(this,arguments)}function Sn(){return Sn=(0,i.Z)(u().mark((function e(t){var n,r,o,i,a=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=a.length>1&&void 0!==a[1]?a[1]:{},(0,c.$0)(t)){e.next=13;break}return e.next=4,kn(t,En(En({},n),{},{flow:"register",autoRemediate:!1}));case 4:if(r=e.sent,o=r.enabledFeatures,i=r.availableSteps,n.activationToken||!o||o.includes(s.IdxFeature.REGISTRATION)){e.next=10;break}throw new w.R("Registration is not supported based on your current org configuration.");case 10:if(!n.activationToken||null==i||!i.some((function(e){return"identify"===e.name}))){e.next=13;break}throw new w.R("activationToken is not supported based on your current org configuration.");case 13:return e.abrupt("return",qt(t,En(En({},n),{},{flow:"register"})));case 14:case"end":return e.stop()}}),e)}))),Sn.apply(this,arguments)}function _n(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function An(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?_n(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):_n(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Pn(e){return Rn.apply(this,arguments)}function Rn(){return Rn=(0,i.Z)(u().mark((function e(t){var n,r,o=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:{},r=jt(t,"recoverPassword"),e.abrupt("return",qt(t,An(An({},n),r)));case 3:case"end":return e.stop()}}),e)}))),Rn.apply(this,arguments)}function xn(e,t){return Zn.apply(this,arguments)}function Zn(){return(Zn=(0,i.Z)(u().mark((function e(t,n){var r,o,i,a,s,c,f,l,p,h;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.transactionManager.load()){e.next=3;break}throw new w.R("No transaction data was found in storage");case 3:if(o=r.codeVerifier,i=r.state,a=new URL(n),s=a.searchParams,c=s.get("state"),f=s.get("interaction_code"),!(l=s.get("error"))){e.next=10;break}throw new w.BK(l,s.get("error_description"));case 10:if(c===i){e.next=12;break}throw new w.R("State in redirect uri does not match with transaction state");case 12:if(f){e.next=14;break}throw new w.R("Unable to parse interaction_code from the url");case 14:return e.next=16,t.token.exchangeCodeForTokens({interactionCode:f,codeVerifier:o});case 16:p=e.sent,h=p.tokens,t.tokenManager.setTokens(h);case 19:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function jn(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Cn(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?jn(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):jn(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Dn(e){return In.apply(this,arguments)}function In(){return In=(0,i.Z)(u().mark((function e(t){var n,r,o,i=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((n=i.length>1&&void 0!==i[1]?i[1]:{}).flow="unlockAccount",(0,c.$0)(t)){e.next=9;break}return e.next=5,kn(t,Cn(Cn({},n),{},{autoRemediate:!1}));case 5:if(r=e.sent,!(o=r.enabledFeatures)||o.includes(s.IdxFeature.ACCOUNT_UNLOCK)){e.next=9;break}throw new w.R("Self Service Account Unlock is not supported based on your current org configuration.");case 9:return e.abrupt("return",qt(t,Cn({},n)));case 10:case"end":return e.stop()}}),e)}))),In.apply(this,arguments)}},2620:function(e,t,n){"use strict";n.d(t,{Xc:function(){return p},$0:function(){return d},uN:function(){return v},Co:function(){return y},r0:function(){return m},Jm:function(){return b},Wf:function(){return k},bl:function(){return w},UC:function(){return O}});var r=n(4942),o=n(5861),i=n(7757),a=n.n(i),u=n(3193),s=n(146),c=n(1279);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function p(e){return h.apply(this,arguments)}function h(){return h=(0,o.Z)(a().mark((function e(t){var n,r,o,i,u,s,f,p,h,d,v,y,g,m,b,k=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=k.length>1&&void 0!==k[1]?k[1]:{},e.next=3,t.token.prepareTokenParams(n);case 3:return r=e.sent,o=(0,c.H)(t,r),i=l(l({},t.options),n),u=i.flow,s=void 0===u?"default":u,f=i.withCredentials,p=void 0===f||f,h=i.activationToken,d=void 0===h?void 0:h,v=i.recoveryToken,y=void 0===v?void 0:v,g=i.maxAge,m=void 0===g?void 0:g,b=l(l({},o),{},{flow:s,withCredentials:p,activationToken:d,recoveryToken:y,maxAge:m}),e.abrupt("return",b);case 8:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}function d(e,t){var n=v(e,t);return!(null==n||!n.interactionHandle)}function v(e,t){var n;t=(0,u.YY)(t),t=l(l({},e.options),t);try{n=e.transactionManager.load(t)}catch(e){}if(n)return k(n,t)?n:void(0,s.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.")}function y(e,t){return g.apply(this,arguments)}function g(){return(g=(0,o.Z)(a().mark((function e(t,n){var r;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=(0,u.YY)(n),n=l(l({},t.options),n),!(r=v(t,n))){e.next=5;break}return e.abrupt("return",r);case 5:return e.abrupt("return",p(t,n));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function m(e,t){e.transactionManager.save(t,{muteWarning:!0})}function b(e){e.transactionManager.clear()}function k(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=["issuer","clientId","redirectUri","state","codeChallenge","codeChallengeMethod","activationToken","recoveryToken"];if(!1===O(e,t,n))return!1;var r=t.flow;return!1!==w(e,r)}function w(e,t){return!(t&&"default"!==t&&"proceed"!==t)||t===e.flow}function O(e,t,n){return!n.some((function(n){var r=t[n];if(r&&r!==e[n])return!0}))}},480:function(e,t,n){"use strict";function r(e){return e&&e.version}function o(e){return e&&r(e.rawIdxState)}n.d(t,{P:function(){return r},f:function(){return o}})},1384:function(e,t,n){"use strict";var r,o,i;function a(e){return e&&(e.key||e.id)}n.d(t,{pc:function(){return o},Fw:function(){return i},Qd:function(){return r},H:function(){return a}}),function(e){e.SUCCESS="SUCCESS",e.PENDING="PENDING",e.FAILURE="FAILURE",e.TERMINAL="TERMINAL",e.CANCELED="CANCELED"}(r||(r={})),function(e){e.OKTA_PASSWORD="okta_password",e.OKTA_EMAIL="okta_email",e.PHONE_NUMBER="phone_number",e.GOOGLE_AUTHENTICATOR="google_otp",e.SECURITY_QUESTION="security_question",e.OKTA_VERIFY="okta_verify",e.WEBAUTHN="webauthn"}(o||(o={})),function(e){e.PASSWORD_RECOVERY="recover-password",e.REGISTRATION="enroll-profile",e.SOCIAL_IDP="redirect-idp",e.ACCOUNT_UNLOCK="unlock-account"}(i||(i={}))},7938:function(e,t,n){"use strict";n.d(t,{BaseTransaction:function(){return v},EmailChallengeTransaction:function(){return k},EmailRole:function(){return N},EmailStatusTransaction:function(){return b},EmailTransaction:function(){return m},PhoneTransaction:function(){return w},ProfileSchemaTransaction:function(){return g},ProfileTransaction:function(){return y},Status:function(){return U},addEmail:function(){return V},addPhone:function(){return Q},deleteEmail:function(){return G},deletePhone:function(){return X},getEmail:function(){return B},getEmailChallenge:function(){return Y},getEmails:function(){return K},getPhone:function(){return $},getPhones:function(){return z},getProfile:function(){return L},getProfileSchema:function(){return H},sendEmailChallenge:function(){return q},sendPhoneChallenge:function(){return J},updateProfile:function(){return F},verifyEmailChallenge:function(){return W},verifyPhoneChallenge:function(){return ee}});var r=n(5861),o=n(7757),i=n.n(o),a=n(4942),u=n(1002),s=n(5671),c=n(7326),f=n(136),l=n(2963),p=n(1120),h=n(4925),d=["headers"],v=function e(t,n){var r=this;(0,s.Z)(this,e),(0,a.Z)(this,"headers",void 0);var o=n.res,i=o.headers,u=(0,h.Z)(o,d);i&&(this.headers=i),Object.keys(u).forEach((function(e){"_links"!==e&&(r[e]=u[e])}))};var y=function(e){(0,f.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function o(e,t){var n;(0,s.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,c.Z)(n),"createdAt",void 0),(0,a.Z)((0,c.Z)(n),"modifiedAt",void 0),(0,a.Z)((0,c.Z)(n),"profile",void 0);var i=t.res,u=i.createdAt,f=i.modifiedAt,l=i.profile;return n.createdAt=u,n.modifiedAt=f,n.profile=l,n}return o}(v);var g=function(e){(0,f.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function o(e,t){var n;return(0,s.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,c.Z)(n),"properties",void 0),n.properties=t.res.properties,n}return o}(v);var m=function(e){(0,f.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function u(e,t){var n;(0,s.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,c.Z)(n),"id",void 0),(0,a.Z)((0,c.Z)(n),"profile",void 0),(0,a.Z)((0,c.Z)(n),"roles",void 0),(0,a.Z)((0,c.Z)(n),"status",void 0),(0,a.Z)((0,c.Z)(n),"get",void 0),(0,a.Z)((0,c.Z)(n),"delete",void 0),(0,a.Z)((0,c.Z)(n),"challenge",void 0),(0,a.Z)((0,c.Z)(n),"poll",void 0),(0,a.Z)((0,c.Z)(n),"verify",void 0);var f,l=t.accessToken,p=t.res,h=p.id,d=p.profile,v=p.roles,y=p.status,g=p._links;return n.id=h,n.profile=d,n.roles=v,n.status=y,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:l,methodName:"get",links:g,transactionClassName:"EmailTransaction"}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:l,methodName:"delete",links:g}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:l,methodName:"challenge",links:g,transactionClassName:"EmailChallengeTransaction"}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),g.poll&&(n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:l,methodName:"poll",links:g,transactionClassName:"EmailStatusTransaction"}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),g.verify&&(n.verify=(f=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=R({oktaAuth:e,accessToken:l,methodName:"verify",links:g}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return f.apply(this,arguments)})),n}return u}(v);var b=function(e){(0,f.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function o(e,t){var n;(0,s.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,c.Z)(n),"id",void 0),(0,a.Z)((0,c.Z)(n),"expiresAt",void 0),(0,a.Z)((0,c.Z)(n),"profile",void 0),(0,a.Z)((0,c.Z)(n),"status",void 0);var i=t.res,u=i.id,f=i.profile,l=i.expiresAt,p=i.status;return n.id=u,n.expiresAt=l,n.profile=f,n.status=p,n}return o}(v);var k=function(e){(0,f.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function u(e,t){var n;(0,s.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,c.Z)(n),"id",void 0),(0,a.Z)((0,c.Z)(n),"expiresAt",void 0),(0,a.Z)((0,c.Z)(n),"profile",void 0),(0,a.Z)((0,c.Z)(n),"status",void 0),(0,a.Z)((0,c.Z)(n),"poll",void 0),(0,a.Z)((0,c.Z)(n),"verify",void 0);var f,l=t.accessToken,p=t.res,h=p.id,d=p.expiresAt,v=p.profile,y=p.status,g=p._links;return n.id=h,n.expiresAt=d,n.profile=v,n.status=y,n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:l,methodName:"poll",links:g,transactionClassName:"EmailStatusTransaction"}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.verify=(f=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=R({oktaAuth:e,accessToken:l,methodName:"verify",links:g}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return f.apply(this,arguments)}),n}return u}(v);var w=function(e){(0,f.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,p.Z)(t);if(n){var o=(0,p.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function u(e,t){var n;(0,s.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,c.Z)(n),"id",void 0),(0,a.Z)((0,c.Z)(n),"profile",void 0),(0,a.Z)((0,c.Z)(n),"status",void 0),(0,a.Z)((0,c.Z)(n),"get",void 0),(0,a.Z)((0,c.Z)(n),"delete",void 0),(0,a.Z)((0,c.Z)(n),"challenge",void 0),(0,a.Z)((0,c.Z)(n),"verify",void 0);var f,l,p=t.res,h=t.accessToken,d=p.id,v=p.profile,y=p.status,g=p._links;return n.id=d,n.profile=v,n.status=y,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:h,methodName:"get",links:g,transactionClassName:"PhoneTransaction"}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=R({oktaAuth:e,accessToken:h,methodName:"delete",links:g}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(f=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=R({oktaAuth:e,accessToken:h,methodName:"challenge",links:g}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return f.apply(this,arguments)}),g.verify&&(n.verify=(l=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=R({oktaAuth:e,accessToken:h,methodName:"verify",links:g}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return l.apply(this,arguments)})),n}return u}(v),O=n(7735),E=n(7301);function T(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function S(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?T(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):T(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var _=function(e){if(!e)throw new E.R("Missing header string");return e.split(",").map((function(e){return e.trim()})).map((function(e){return e.split("=")})).reduce((function(e,t){return e[t[0]]=t[1].replace(/^"(.*)"$/,"$1"),e}),{})};function A(e,t){return P.apply(this,arguments)}function P(){return(P=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,s,c,f,l,p,h,d,T,A,P,R,x,Z,j,C;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.tokenManager.getTokensSync(),o=r.accessToken,a=r.idToken,u=null==a?void 0:a.idToken,s=n.accessToken||(null==o?void 0:o.accessToken),c=t.options.issuer,f=n.url,l=n.method,p=n.payload,h=f.startsWith(c)?f:"".concat(c).concat(f),s){e.next=8;break}throw new E.R("AccessToken is required to request MyAccount API endpoints.");case 8:return e.prev=8,e.next=11,(0,O.c3)(t,S({headers:{Accept:"*/*;okta-version=1.0.0"},accessToken:s,url:h,method:l},p&&{args:p}));case 11:d=e.sent,e.next=28;break;case 14:if(e.prev=14,e.t0=e.catch(8),A=e.t0.xhr,!u||403!==(null==A?void 0:A.status)||null==A||null===(T=A.headers)||void 0===T||!T["www-authenticate"]){e.next=27;break}if(R=_(null==A||null===(P=A.headers)||void 0===P?void 0:P["www-authenticate"]),x=R.error,Z=R.error_description,j=R.max_age,"insufficient_authentication_context"!==x){e.next=24;break}throw new E.Ws({errorSummary:x,errorCauses:[{errorSummary:Z}]},A,{max_age:+j});case 24:case 27:throw e.t0;case 25:e.next=28;break;case 28:if(C={EmailTransaction:m,EmailStatusTransaction:b,EmailChallengeTransaction:k,ProfileTransaction:y,ProfileSchemaTransaction:g,PhoneTransaction:w}[n.transactionClassName]||v,!Array.isArray(d)){e.next=32;break}return e.abrupt("return",d.map((function(e){return new C(t,{res:e,accessToken:s})})));case 32:return e.abrupt("return",new C(t,{res:d,accessToken:s}));case 33:case"end":return e.stop()}}),e,null,[[8,14]])})))).apply(this,arguments)}function R(e){for(var t=e.oktaAuth,n=e.accessToken,o=e.methodName,a=e.links,s=e.transactionClassName,c=function(){var e,u=l[f];if(u.toLowerCase()===o){var c=a.self;return{v:(e=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",A(t,{accessToken:n,url:c.href,method:u,payload:r,transactionClassName:s}));case 1:case"end":return e.stop()}}),e)}))),function(t){return e.apply(this,arguments)})}}},f=0,l=["GET","POST","PUT","DELETE"];f<l.length;f++){var p=c();if("object"===(0,u.Z)(p))return p.v}var h,d=a[o];if(!d)throw new E.R("No link is found with methodName: ".concat(o));return h=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",A(t,{accessToken:n,url:d.href,method:d.hints.allow[0],payload:r,transactionClassName:s}));case 1:case"end":return e.stop()}}),e)}))),function(e){return h.apply(this,arguments)}}var x,Z,j,C,D,I,M,N,U,L=(x=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,A(t,{url:"/idp/myaccount/profile",method:"GET",accessToken:null==n?void 0:n.accessToken,transactionClassName:"ProfileTransaction"});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return x.apply(this,arguments)}),F=(Z=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).payload,a=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/profile",method:"PUT",payload:o,accessToken:a,transactionClassName:"ProfileTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return Z.apply(this,arguments)}),H=(j=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,A(t,{url:"/idp/myaccount/profile/schema",method:"GET",accessToken:null==n?void 0:n.accessToken,transactionClassName:"ProfileSchemaTransaction"});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return j.apply(this,arguments)}),K=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,A(t,{url:"/idp/myaccount/emails",method:"GET",accessToken:null==n?void 0:n.accessToken,transactionClassName:"EmailTransaction"});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),B=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/emails/".concat(o),method:"GET",accessToken:a,transactionClassName:"EmailTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),V=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,A(t,{url:"/idp/myaccount/emails",method:"POST",payload:a,accessToken:o,transactionClassName:"EmailTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),G=(C=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/emails/".concat(o),method:"DELETE",accessToken:a});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return C.apply(this,arguments)}),q=(D=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge"),method:"POST",accessToken:a,transactionClassName:"EmailChallengeTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return D.apply(this,arguments)}),Y=(I=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,u=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a),method:"POST",accessToken:u,transactionClassName:"EmailChallengeTransaction"});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return I.apply(this,arguments)}),W=(M=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,s,c;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,u=r.payload,s=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a,"/verify"),method:"POST",payload:u,accessToken:s});case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return M.apply(this,arguments)}),z=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,A(t,{url:"/idp/myaccount/phones",method:"GET",accessToken:null==n?void 0:n.accessToken,transactionClassName:"PhoneTransaction"});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),$=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,e.next=3,A(t,{url:"/idp/myaccount/phones/".concat(a),method:"GET",accessToken:o,transactionClassName:"PhoneTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Q=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,A(t,{url:"/idp/myaccount/phones",method:"POST",payload:a,accessToken:o,transactionClassName:"PhoneTransaction"});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),X=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/phones/".concat(o),method:"DELETE",accessToken:a});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),J=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,u=r.payload,e.next=3,A(t,{url:"/idp/myaccount/phones/".concat(a,"/challenge"),method:"POST",payload:u,accessToken:o});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),ee=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.payload,u=r.accessToken,e.next=3,A(t,{url:"/idp/myaccount/phones/".concat(o,"/verify"),method:"POST",payload:a,accessToken:u});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}();!function(e){e.PRIMARY="PRIMARY",e.SECONDARY="SECONDARY"}(N||(N={})),function(e){e.VERIFIED="VERIFIED",e.UNVERIFIED="UNVERIFIED"}(U||(U={}))},1237:function(e,t,n){"use strict";n.d(t,{T:function(){return i}});var r=n(7301),o=n(9326);function i(e){var t,n=e.split(".");try{t={header:JSON.parse((0,o.base64UrlToString)(n[0])),payload:JSON.parse((0,o.base64UrlToString)(n[1])),signature:n[2]}}catch(e){throw new r.R("Malformed token")}return t}},52:function(e,t,n){"use strict";n.d(t,{E:function(){return a},k:function(){return u}});var r=n(7735),o=n(3193),i=n(9123);function a(e,t){var n=t||e.options.issuer;return(0,r.U2)(e,n+"/.well-known/openid-configuration",{cacheResponse:!0})}function u(e,t,n){var u=e.storageManager.getHttpCache(e.options.cookies);return a(e,t).then((function(t){var a=t.jwks_uri,s=u.getStorage()[a];if(s&&Date.now()/1e3<s.expiresAt){var c=(0,o.sE)(s.response.keys,{kid:n});if(c)return c}return u.clearStorage(a),(0,r.U2)(e,a,{cacheResponse:!0}).then((function(e){var t=(0,o.sE)(e.keys,{kid:n});if(t)return t;throw new i.Z("The key id, "+n+", was not found in the server's keys")}))}))}},8676:function(e,t,n){"use strict";n.d(t,{s:function(){return p}});var r=n(5861),o=n(7757),i=n.n(o),a=n(3193),u=n(7599),s=n(7301),c=n(1260),f=n(1060);function l(e,t){if(e.error&&e.error_description)throw new s.BK(e.error,e.error_description);if(e.state!==t.state)throw new s.R("OAuth flow response state doesn't match request state")}function p(e,t,n,r){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n,r,o){var p,h,d,v,y,g,m,b,k,w,O,E,T,S;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!1===t.options.pkce||!r.code&&!r.interaction_code){e.next=3;break}return e.abrupt("return",t.token.exchangeCodeForTokens(Object.assign({},n,{authorizationCode:r.code,interactionCode:r.interaction_code}),o));case 3:if(n=n||(0,f.Dx)(t),o=o||(0,u.Fc)(t,n),p=n.responseType||[],Array.isArray(p)||(p=[p]),h=r.scope?r.scope.split(" "):(0,a.d9)(n.scopes),d=n.clientId||t.options.clientId,l(r,n),v={},y=r.expires_in,g=r.token_type,m=r.access_token,b=r.id_token,k=r.refresh_token,w=Math.floor(Date.now()/1e3),m&&(O=t.token.decode(m),v.accessToken={accessToken:m,claims:O.payload,expiresAt:Number(y)+w,tokenType:g,scopes:h,authorizeUrl:o.authorizeUrl,userinfoUrl:o.userinfoUrl}),k&&(v.refreshToken={refreshToken:k,expiresAt:Number(y)+w,scopes:h,tokenUrl:o.tokenUrl,authorizeUrl:o.authorizeUrl,issuer:o.issuer}),!b){e.next=27;break}return E=t.token.decode(b),T={idToken:b,claims:E.payload,expiresAt:E.payload.exp-E.payload.iat+w,scopes:h,authorizeUrl:o.authorizeUrl,issuer:o.issuer,clientId:d},S={clientId:d,issuer:o.issuer,nonce:n.nonce,accessToken:m},void 0!==n.ignoreSignature&&(S.ignoreSignature=n.ignoreSignature),e.next=26,(0,c.W)(t,T,S);case 26:v.idToken=T;case 27:if(-1===p.indexOf("token")||v.accessToken){e.next=29;break}throw new s.R('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');case 29:if(-1===p.indexOf("id_token")||v.idToken){e.next=31;break}throw new s.R('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');case 31:return e.abrupt("return",{tokens:v,state:r.state,code:r.code});case 32:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},1279:function(e,t,n){"use strict";n.d(t,{NH:function(){return g.NH},iC:function(){return g.iC},vz:function(){return g.vz},R0:function(){return l},_6:function(){return f},H:function(){return g.H},TD:function(){return m.T},rz:function(){return G},PY:function(){return g.PY},aV:function(){return g.aV},Dx:function(){return g.Dx},O2:function(){return g.O2},km:function(){return y.k},zf:function(){return g.zf},Xp:function(){return g.Xp},Fc:function(){return g.Fc},LP:function(){return x},bG:function(){return B},ES:function(){return y.E},dh:function(){return q},Hq:function(){return Y},y6:function(){return Z},sw:function(){return R.s},ZP:function(){return g.ZP},hg:function(){return g.hg},d_:function(){return g.d_},kU:function(){return g.kU},tC:function(){return g.tC},Ik:function(){return g.Ik},wc:function(){return g.wc},Cf:function(){return g.Cf},gM:function(){return g.gM},Qs:function(){return g.Qs},Yo:function(){return g.Yo},$E:function(){return g.$E},q0:function(){return g.q0},Rl:function(){return g.Rl},pU:function(){return g.pU},ko:function(){return z.ko},U5:function(){return g.U5},Dp:function(){return v},ti:function(){return d},mi:function(){return g.mi},wu:function(){return g.wu},ys:function(){return g.ys},$m:function(){return U},IK:function(){return F},Rm:function(){return D},PX:function(){return S},vL:function(){return g.vL},pj:function(){return g.pj},br:function(){return g.br},Rp:function(){return g.Rp},WX:function(){return K.W}});var r=n(4942),o=n(4771),i=n(3193),a=n(6718),u=n(7301);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function f(e){if(!e.clientId)throw new u.R("A clientId must be specified in the OktaAuth constructor to get a token");if((0,o.HD)(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new u.R("Multiple OAuth responseTypes must be defined as an array");var t={client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state};if(t=(0,i.YY)(t),["idp_scope","response_type"].forEach((function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))})),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new u.R("openid scope must be specified in the scopes argument when requesting an id_token");return t.scope=e.scopes.join(" "),t}function l(e){var t=f(e);return(0,a.UK)(c(c({},t),e.extraParams&&c({},e.extraParams)))}var p=n(885),h=n(7735);function d(e,t,n){!function(e){if(!e.clientId)throw new u.R("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new u.R("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode&&!e.interactionCode)throw new u.R("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new u.R('The "codeVerifier" (generated and saved by your app) must be passed to /token')}(t);var r=function(e,t){var n=(0,i.YY)({client_id:t.clientId,redirect_uri:t.redirectUri,grant_type:t.interactionCode?"interaction_code":"authorization_code",code_verifier:t.codeVerifier});t.interactionCode?n.interaction_code=t.interactionCode:t.authorizationCode&&(n.code=t.authorizationCode);var r=e.options.clientSecret;return r&&(n.client_secret=r),(0,a.UK)(n).slice(1)}(e,t);return(0,h.c3)(e,{url:n.tokenUrl,method:"POST",args:r,headers:{"Content-Type":"application/x-www-form-urlencoded"}})}function v(e,t,n){return(0,h.c3)(e,{url:n.tokenUrl,method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},args:Object.entries({client_id:t.clientId,grant_type:"refresh_token",scope:n.scopes.join(" "),refresh_token:n.refreshToken}).map((function(e){var t=(0,p.Z)(e,2),n=t[0],r=t[1];return n+"="+encodeURIComponent(r)})).join("&")})}var y=n(52),g=n(1060),m=n(1237),b=n(5861),k=n(7757),w=n.n(k),O=n(7599),E=n(9326),T=n(9123);function S(e,t){return _.apply(this,arguments)}function _(){return(_=(0,b.Z)(w().mark((function e(t,n){var r,o,i,u,s,c,f;return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r="",o="",n&&(r=n.accessToken,o=n.refreshToken),r||o){e.next=5;break}throw new T.Z("A valid access or refresh token object is required");case 5:if(i=t.options.clientId,u=t.options.clientSecret,i){e.next=9;break}throw new T.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");case 9:return s=(0,O.Fc)(t).revokeUrl,c=(0,a.UK)({token_type_hint:o?"refresh_token":"access_token",token:o||r}).slice(1),f=u?(0,E.btoa)("".concat(i,":").concat(u)):(0,E.btoa)(i),e.abrupt("return",(0,h.v_)(t,s,c,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+f}}));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}var A=n(2852),P=n(6898),R=n(8676);function x(e,t){if(arguments.length>2)return Promise.reject(new T.Z('As of version 3.0, "getToken" takes only a single set of options'));var n=(t=t||{}).popupWindow;return t.popupWindow=void 0,(0,P.wu)(e,t).then((function(r){var o,i;switch(t.sessionToken?Object.assign(r,{prompt:"none",responseMode:"okta_post_message",display:null}):t.idp&&Object.assign(r,{display:"popup"}),i=(0,g.Fc)(e,r),o=(t.codeVerifier?i.tokenUrl:i.authorizeUrl)+l(r),r.sessionToken||null===r.display?"IFRAME":"popup"===r.display?"POPUP":"IMPLICIT"){case"IFRAME":var a=(0,g.iC)(e,t.timeout,r.state),u=(0,g.Rl)(o);return a.then((function(t){return(0,R.s)(e,r,t,i)})).finally((function(){var e;document.body.contains(u)&&(null===(e=u.parentElement)||void 0===e||e.removeChild(u))}));case"POPUP":var s;if("okta_post_message"===r.responseMode){if(!e.features.isPopupPostMessageSupported())throw new T.Z("This browser doesn't have full postMessage support");s=(0,g.iC)(e,t.timeout,r.state)}return n&&n.location.assign(o),new Promise((function(e,t){var r=setInterval((function(){n&&!n.closed||(clearInterval(r),t(new T.Z("Unable to parse OAuth flow response")))}),100);s.then((function(t){clearInterval(r),e(t)})).catch((function(e){clearInterval(r),t(e)}))})).then((function(t){return(0,R.s)(e,r,t,i)})).finally((function(){n&&!n.closed&&n.close()}));default:throw new T.Z("The full page redirect flow is not supported")}}))}function Z(e,t){return arguments.length>2?Promise.reject(new u.R('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=(0,i.d9)(t)||{},Object.assign(t,{prompt:"none",responseMode:"okta_post_message",display:null}),x(e,t))}var j=n(6635),C=n(9912);function D(e,t,n){return I.apply(this,arguments)}function I(){return(I=(0,b.Z)(w().mark((function e(t,n,r){var o,i,a,s,c,f,l;return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=t.options.clientId){e.next=3;break}throw new u.R("A clientId must be specified in the OktaAuth constructor to renew tokens");case 3:return e.prev=3,i=Object.assign({},n,{clientId:o}),e.next=7,v(t,i,r);case 7:return a=e.sent,s=(0,O.Fc)(t,n),e.next=11,(0,R.s)(t,i,a,s);case 11:return c=e.sent,f=c.tokens,(l=f.refreshToken)&&!(0,j.q)(l,r)&&t.tokenManager.updateRefreshToken(l),e.abrupt("return",f);case 18:throw e.prev=18,e.t0=e.catch(3),(0,C.$E)(e.t0)&&t.tokenManager.removeRefreshToken(),e.t0;case 22:case"end":return e.stop()}}),e,null,[[3,18]])})))).apply(this,arguments)}function M(){throw new u.R("Renew must be passed a token with an array of scopes and an accessToken or idToken")}function N(e,t){return(0,A.isIDToken)(e)?t.idToken:(0,A.isAccessToken)(e)?t.accessToken:void M()}function U(e,t){return L.apply(this,arguments)}function L(){return(L=(0,b.Z)(w().mark((function e(t,n){var r,o,i,a,u,s,c;return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((0,A.isIDToken)(n)||(0,A.isAccessToken)(n)||M(),!(r=t.tokenManager.getTokensSync()).refreshToken){e.next=7;break}return e.next=5,D(t,{scopes:n.scopes},r.refreshToken);case 5:return r=e.sent,e.abrupt("return",N(n,r));case 7:return o=t.options.pkce?"code":(0,A.isAccessToken)(n)?"token":"id_token",a=(i=n).scopes,u=i.authorizeUrl,s=i.userinfoUrl,c=i.issuer,e.abrupt("return",Z(t,{responseType:o,scopes:a,authorizeUrl:u,userinfoUrl:s,issuer:c}).then((function(e){return N(n,e.tokens)})));case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function F(e,t){return H.apply(this,arguments)}function H(){return(H=(0,b.Z)(w().mark((function e(t,n){var r,o,i,a,s,c,f,l,p;return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(r=t.tokenManager.getTokensSync()).refreshToken){e.next=3;break}return e.abrupt("return",D(t,n||{},r.refreshToken));case 3:if(r.accessToken||r.idToken){e.next=5;break}throw new u.R("renewTokens() was called but there is no existing token");case 5:if(o=r.accessToken||{},i=r.idToken||{},a=o.scopes||i.scopes){e.next=10;break}throw new u.R("renewTokens: invalid tokens: could not read scopes");case 10:if(s=o.authorizeUrl||i.authorizeUrl){e.next=13;break}throw new u.R("renewTokens: invalid tokens: could not read authorizeUrl");case 13:return c=o.userinfoUrl||t.options.userinfoUrl,f=i.issuer||t.options.issuer,n=Object.assign({scopes:a,authorizeUrl:s,userinfoUrl:c,issuer:f},n),t.options.pkce?n.responseType="code":(l=(0,g.Dx)(t),p=l.responseType,n.responseType=p),e.abrupt("return",Z(t,n).then((function(e){return e.tokens})));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}var K=n(1260);function B(e,t,n){return V.apply(this,arguments)}function V(){return(V=(0,b.Z)(w().mark((function e(t,n,r){return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n){e.next=4;break}return e.next=3,t.tokenManager.getTokens();case 3:n=e.sent.accessToken;case 4:if(r){e.next=8;break}return e.next=7,t.tokenManager.getTokens();case 7:r=e.sent.idToken;case 8:if(n&&(0,A.isAccessToken)(n)){e.next=10;break}return e.abrupt("return",Promise.reject(new u.R("getUserInfo requires an access token object")));case 10:if(r&&(0,A.isIDToken)(r)){e.next=12;break}return e.abrupt("return",Promise.reject(new u.R("getUserInfo requires an ID token object")));case 12:return e.abrupt("return",(0,h.c3)(t,{url:n.userinfoUrl,method:"GET",accessToken:n.accessToken}).then((function(e){return e.sub===r.claims.sub?e:Promise.reject(new u.R("getUserInfo request was rejected due to token mismatch"))})).catch((function(e){var t;if(e.xhr&&(401===e.xhr.status||403===e.xhr.status)&&(e.xhr.headers&&(0,o.mf)(e.xhr.headers.get)&&e.xhr.headers.get("WWW-Authenticate")?t=e.xhr.headers.get("WWW-Authenticate"):(0,o.mf)(e.xhr.getResponseHeader)&&(t=e.xhr.getResponseHeader("WWW-Authenticate")),t)){var n=t.match(/error="(.*?)"/)||[],r=t.match(/error_description="(.*?)"/)||[],i=n[1],a=r[1];i&&a&&(e=new u.BK(i,a))}throw e})));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function G(e,t,n){n=n||(0,g.Fc)(e,t);var r=t=Object.assign({},(0,g.Dx)(e),(0,i.d9)(t)),o=r.authorizationCode,a=r.interactionCode,u=r.codeVerifier,s=r.clientId,c=r.redirectUri,f=r.scopes,l=r.ignoreSignature,p=r.state;return d(e,{clientId:s,redirectUri:c,authorizationCode:o,interactionCode:a,codeVerifier:u},n).then((function(t){var r=["token"];-1!==f.indexOf("openid")&&r.push("id_token");var i={clientId:s,redirectUri:c,scopes:f,responseType:r,ignoreSignature:l};return(0,R.s)(e,i,t,n).then((function(e){return e.code=o,e.state=p,e}))})).finally((function(){e.transactionManager.clear()}))}function q(e,t){if(arguments.length>2)return Promise.reject(new u.R('As of version 3.0, "getWithPopup" takes only a single set of options'));var n=(0,g.pU)("/",t);return t=(0,i.d9)(t)||{},Object.assign(t,{display:"popup",responseMode:"okta_post_message",popupWindow:n}),x(e,t)}function Y(e,t){return W.apply(this,arguments)}function W(){return W=(0,b.Z)(w().mark((function e(t,n){var r,o,a,s=arguments;return w().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(s.length>2)){e.next=2;break}return e.abrupt("return",Promise.reject(new u.R('As of version 3.0, "getWithRedirect" takes only a single set of options')));case 2:return n=(0,i.d9)(n)||{},e.next=5,(0,g.wu)(t,n);case 5:r=e.sent,o=(0,g.H)(t,r),a=o.urls.authorizeUrl+l(r),t.transactionManager.save(o,{oauth:!0}),t.token.getWithRedirect._setLocation(a);case 10:case"end":return e.stop()}}),e)}))),W.apply(this,arguments)}var z=n(5372)},5372:function(e,t,n){"use strict";n.d(t,{Tp:function(){return l},ko:function(){return h}});var r=n(5861),o=n(7757),i=n.n(o),a=n(7301),u=n(1060),s=n(4771),c=n(8676);function f(e){var t=e.options.pkce?"query":"fragment";return e.options.responseMode||t}function l(e,t){t=t||{},(0,s.HD)(t)&&(t={url:t});var n,r=t.url,o=t.responseMode||f(e),i=e.token.parseFromUrl._getLocation();if(!(n="query"===o?r?r.substring(r.indexOf("?")):i.search:r?r.substring(r.indexOf("#")):i.hash))throw new a.R("Unable to parse a token from the url");return(0,u.vL)(n)}function p(e,t){"query"===(t.responseMode||f(e))?function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.hash):r.search=""}(e):function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.search):r.hash=""}(e)}function h(e,t){return d.apply(this,arguments)}function d(){return(d=(0,r.Z)(i().mark((function e(t,n){var r,o,f,h;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=n||{},(0,s.HD)(n)&&(n={url:n}),r=l(t,n),o=r.state,f=t.transactionManager.load({oauth:!0,pkce:t.options.pkce,state:o})){e.next=7;break}return e.abrupt("return",Promise.reject(new a.R("Unable to retrieve OAuth redirect params from storage")));case 7:return h=f.urls,delete f.urls,n.url||p(t,n),e.abrupt("return",(0,c.s)(t,f,r,h).catch((function(e){throw(0,u.Cf)(e)||t.transactionManager.clear({state:o}),e})).then((function(e){return t.transactionManager.clear({state:o}),e})));case 11:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},7756:function(e,t,n){"use strict";n.d(t,{D:function(){return a}});var r=n(7599),o=n(415),i=n(3193);function a(e){var t=e.options,n=t.pkce,a=t.clientId,u=t.redirectUri,s=t.responseType,c=t.responseMode,f=t.scopes,l=t.state,p=t.ignoreSignature,h=(0,o.isBrowser)()?window.location.href:void 0;return(0,i.YY)({pkce:n,clientId:a,redirectUri:u||h,responseType:s||["token","id_token"],responseMode:c,state:l||(0,r.aV)(),nonce:(0,r.NH)(),scopes:f||["openid","email"],ignoreSignature:p})}},9912:function(e,t,n){"use strict";n.d(t,{Cf:function(){return o},tC:function(){return i},$E:function(){return a}});var r=n(7301);function o(e){return"OAuthError"===e.name&&"interaction_required"===e.errorCode}function i(e,t){if("AuthApiError"!==t.name)return!1;var n=t.xhr,r=null==n?void 0:n.responseJSON;return e.options.pkce&&"invalid_grant"===(null==r?void 0:r.error)}function a(e){return(0,r.eo)(e)&&"invalid_grant"===e.errorCode&&"The refresh token is invalid or expired."===e.errorSummary}},1060:function(e,t,n){"use strict";n.d(t,{NH:function(){return o},iC:function(){return s},vz:function(){return _.vz},H:function(){return T},PY:function(){return k.NH},aV:function(){return k.aV},Dx:function(){return c.D},O2:function(){return g},zf:function(){return k.zf},Xp:function(){return k.Xp},Fc:function(){return k.Fc},ZP:function(){return p},hg:function(){return d},d_:function(){return h},kU:function(){return l},tC:function(){return f.tC},Ik:function(){return y},wc:function(){return b},Cf:function(){return f.Cf},gM:function(){return m},Qs:function(){return v},Yo:function(){return A.Y},$E:function(){return f.$E},q0:function(){return A.q},Rl:function(){return a},pU:function(){return u},U5:function(){return S.Z},mi:function(){return _.mi},wu:function(){return _.wu},ys:function(){return i},vL:function(){return P.v},pj:function(){return x},br:function(){return _.br},Rp:function(){return j}});var r=n(7301);function o(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n)}function i(e,t,n){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}function a(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)}function u(e,t){var n=t.popupTitle||"External Identity Provider User Authentication";return window.open(e,n,"toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600")}function s(e,t,n){var a,u;return new Promise((function(i,s){a=function(t){if(t.data&&t.data.state===n)return t.origin!==e.getIssuerOrigin()?s(new r.R("The request does not match client configuration")):void i(t.data)},o(window,"message",a),u=setTimeout((function(){s(new r.R("OAuth flow timed out"))}),t||12e4)})).finally((function(){clearTimeout(u),i(window,"message",a)}))}var c=n(7756),f=n(9912);function l(e){return/((id|access)_token=)/i.test(e)}function p(e){return/(code=)/i.test(e)}function h(e){return/(interaction_code=)/i.test(e)}function d(e){return/(error=)/i.test(e)||/(error_description)/i.test(e)}function v(e,t){var n=t.options;return!(!e||!n.redirectUri)&&0===e.indexOf(n.redirectUri)}function y(e){return e.pkce||"code"===e.responseType||"query"===e.responseMode}function g(e){return y(e)&&"fragment"!==e.responseMode?window.location.search:window.location.hash}function m(e){if(!v(window.location.href,e))return!1;var t=y(e.options),n=g(e.options);return!!d(n)||(t?p(n)||h(n):l(window.location.hash))}function b(e,t){if(!t){if(!m(e))return!1;t=g(e.options)}return/(error=interaction_required)/i.test(t)}var k=n(7599),w=n(4942);function O(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function E(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?O(Object(n),!0).forEach((function(t){(0,w.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):O(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function T(e,t){var n={issuer:e.options.issuer,urls:(0,k.Fc)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,scopes:t.scopes,state:t.state,nonce:t.nonce,ignoreSignature:t.ignoreSignature};return!1===t.pkce?n:E(E({},n),{},{codeVerifier:t.codeVerifier,codeChallengeMethod:t.codeChallengeMethod,codeChallenge:t.codeChallenge})}var S=n(3611),_=n(6898),A=n(6635),P=n(1969),R=n(9123);function x(e,t,n){var r=n.clientId,o=n.issuer,i=n.nonce;if(!t||!o||!r)throw new R.Z("The jwt, iss, and aud arguments are all required");if(i&&t.nonce!==i)throw new R.Z("OAuth flow response nonce doesn't match request nonce");var a=Math.floor(Date.now()/1e3);if(t.iss!==o)throw new R.Z("The issuer ["+t.iss+"] does not match ["+o+"]");if(t.aud!==r)throw new R.Z("The audience ["+t.aud+"] does not match ["+r+"]");if(t.iat>t.exp)throw new R.Z("The JWT expired before it was issued");if(!e.options.ignoreLifetime){if(a-e.options.maxClockSkew>t.exp)throw new R.Z("The JWT expired and is no longer valid");if(t.iat>a+e.options.maxClockSkew)throw new R.Z("The JWT was issued in the future")}}var Z=n(2852);function j(e,t){if(!(0,Z.isIDToken)(e)&&!(0,Z.isAccessToken)(e)&&!(0,Z.isRefreshToken)(e))throw new r.R("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");if("accessToken"===t&&!(0,Z.isAccessToken)(e))throw new r.R("invalid accessToken");if("idToken"===t&&!(0,Z.isIDToken)(e))throw new r.R("invalid idToken");if("refreshToken"===t&&!(0,Z.isRefreshToken)(e))throw new r.R("invalid refreshToken")}},7599:function(e,t,n){"use strict";n.d(t,{aV:function(){return a},NH:function(){return u},zf:function(){return c},Xp:function(){return f},Fc:function(){return l}});var r=n(8750),o=n(6718),i=n(9123);function a(){return(0,r.uh)(64)}function u(){return(0,r.uh)(64)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=(0,o.Qj)(t.issuer)||e.options.issuer;return n}function c(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=s(e,t),r=n.indexOf("/oauth2")>0?n:n+"/oauth2";return r}function f(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=s(e,t),r=n.split("/oauth2")[0];return r}function l(e,t){if(arguments.length>2)throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var n=(0,o.Qj)(t.authorizeUrl)||e.options.authorizeUrl,r=s(e,t),a=(0,o.Qj)(t.userinfoUrl)||e.options.userinfoUrl,u=(0,o.Qj)(t.tokenUrl)||e.options.tokenUrl,f=(0,o.Qj)(t.logoutUrl)||e.options.logoutUrl,l=(0,o.Qj)(t.revokeUrl)||e.options.revokeUrl,p=c(e,t);return{issuer:r,authorizeUrl:n=n||p+"/v1/authorize",userinfoUrl:a=a||p+"/v1/userinfo",tokenUrl:u=u||p+"/v1/token",revokeUrl:l=l||p+"/v1/revoke",logoutUrl:f=f||p+"/v1/logout"}}},3611:function(e,t,n){"use strict";var r=n(9326),o=n(1971);function i(e){return("0"+e.toString(16)).substr(-2)}t.Z={DEFAULT_CODE_CHALLENGE_METHOD:o.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:function(e){var t,n,a=e||"";return a.length<o.MIN_VERIFIER_LENGTH&&(a+=(t=o.MIN_VERIFIER_LENGTH-a.length,n=new Uint8Array(Math.ceil(t/2)),r.webcrypto.getRandomValues(n),Array.from(n,i).join("").slice(0,t))),encodeURIComponent(a).slice(0,o.MAX_VERIFIER_LENGTH)},computeChallenge:function(e){var t=(new TextEncoder).encode(e);return r.webcrypto.subtle.digest("SHA-256",t).then((function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return(0,r.stringToBase64Url)(t)}))}}},6898:function(e,t,n){"use strict";n.d(t,{vz:function(){return d},br:function(){return v},mi:function(){return g},wu:function(){return b}});var r=n(4942),o=n(5861),i=n(7757),a=n.n(i),u=n(52),s=n(7301),c=n(7756),f=n(1971),l=n(3611);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){if(!e.features.isPKCESupported()){var t="PKCE requires a modern browser with encryption support running in a secure context.";throw e.features.isHTTPS()||(t+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(t+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),new s.R(t)}}function v(e,t){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=n||t.options.codeChallengeMethod||f.DEFAULT_CODE_CHALLENGE_METHOD,e.next=3,(0,u.E)(t);case 3:if(-1!==(e.sent.code_challenge_methods_supported||[]).indexOf(n)){e.next=7;break}throw new s.R("Invalid code_challenge_method");case 7:return e.abrupt("return",n);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function g(e,t){return m.apply(this,arguments)}function m(){return(m=(0,o.Z)(a().mark((function e(t,n){var r,o,i,u;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=(r=n).codeVerifier,i=r.codeChallenge,u=r.codeChallengeMethod,i=i||t.options.codeChallenge){e.next=8;break}return d(t),o=o||l.Z.generateVerifier(),e.next=7,l.Z.computeChallenge(o);case 7:i=e.sent;case 8:return e.next=10,v(t,u);case 10:return u=e.sent,n=h(h({},n),{},{responseType:"code",codeVerifier:o,codeChallenge:i,codeChallengeMethod:u}),e.abrupt("return",n);case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e){return k.apply(this,arguments)}function k(){return k=(0,o.Z)(a().mark((function e(t){var n,r,o=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=(0,c.D)(t),!1!==(n=h(h({},r),n)).pkce){e.next=5;break}return e.abrupt("return",n);case 5:return e.abrupt("return",g(t,n));case 6:case"end":return e.stop()}}),e)}))),k.apply(this,arguments)}},6635:function(e,t,n){"use strict";n.d(t,{q:function(){return o},Y:function(){return i}});var r=n(7301);function o(e,t){return e.refreshToken===t.refreshToken}function i(e){return!(!(0,r.Tw)(e)||!e.xhr||!e.xhr.responseJSON||"invalid_grant"!==e.xhr.responseJSON.error)}},1969:function(e,t,n){"use strict";function r(e){var t=/\+/g,n=/([^&=]+)=?([^&]*)/g,r=e||"";"#"===r.charAt(0)&&"/"===r.charAt(1)&&(r=r.substring(2)),"#"!==r.charAt(0)&&"?"!==r.charAt(0)||(r=r.substring(1));for(var o,i={};o=n.exec(r);){var a=o[1],u=o[2];i[a]="id_token"===a||"access_token"===a||"code"===a?u:decodeURIComponent(u.replace(t," "))}return i}n.d(t,{v:function(){return r}})},1260:function(e,t,n){"use strict";n.d(t,{W:function(){return l}});var r=n(5861),o=n(7757),i=n.n(o),a=n(52),u=n(1060),s=n(7301),c=n(1237),f=n(9326);function l(e,t,n){return p.apply(this,arguments)}function p(){return(p=(0,r.Z)(i().mark((function e(t,n,r){var o,l,p,h,d,v;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n&&n.idToken){e.next=2;break}throw new s.R("Only idTokens may be verified");case 2:return o=(0,c.T)(n.idToken),l=(null==r?void 0:r.issuer)||t.options.issuer,e.next=6,(0,a.E)(t,l);case 6:if(p=e.sent,h=p.issuer,d=Object.assign({clientId:t.options.clientId,ignoreSignature:t.options.ignoreSignature},r,{issuer:h}),(0,u.pj)(t,o.payload,d),1!=d.ignoreSignature&&t.features.isTokenVerifySupported()){e.next=12;break}return e.abrupt("return",n);case 12:return e.next=14,(0,a.k)(t,n.issuer,o.header.kid);case 14:return v=e.sent,e.next=17,f.verifyToken(n.idToken,v);case 17:if(e.sent){e.next=20;break}throw new s.R("The token signature is not valid");case 20:if(!(r&&r.accessToken&&n.claims.at_hash)){e.next=26;break}return e.next=23,f.getOidcHash(r.accessToken);case 23:if(e.sent===n.claims.at_hash){e.next=26;break}throw new s.R("Token hash verification failed");case 26:return e.abrupt("return",n);case 27:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},3291:function(e,t,n){"use strict";n.d(t,{D:function(){return h}});var r=n(5671),o=n(4942),i=n(7735),a=n(3193),u=n(6718),s=n(4771),c=n(9123),f=n(459),l=n(8903),p=n(4393),h=function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if((0,r.Z)(this,e),(0,o.Z)(this,"next",void 0),(0,o.Z)(this,"cancel",void 0),(0,o.Z)(this,"skip",void 0),(0,o.Z)(this,"unlock",void 0),(0,o.Z)(this,"changePassword",void 0),(0,o.Z)(this,"resetPassword",void 0),(0,o.Z)(this,"answer",void 0),(0,o.Z)(this,"recovery",void 0),(0,o.Z)(this,"verify",void 0),(0,o.Z)(this,"resend",void 0),(0,o.Z)(this,"activate",void 0),(0,o.Z)(this,"poll",void 0),(0,o.Z)(this,"prev",void 0),(0,o.Z)(this,"data",void 0),(0,o.Z)(this,"stateToken",void 0),(0,o.Z)(this,"sessionToken",void 0),(0,o.Z)(this,"status",void 0),(0,o.Z)(this,"user",void 0),(0,o.Z)(this,"factor",void 0),(0,o.Z)(this,"factors",void 0),(0,o.Z)(this,"policy",void 0),(0,o.Z)(this,"scopes",void 0),(0,o.Z)(this,"target",void 0),(0,o.Z)(this,"authentication",void 0),this.data=void 0,this.status=void 0,n){if(this.data=n,this.data.interactionHandle)return void(this.status=n.status);Object.assign(this,v(t,n,n,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==n.status||n._links||(this.cancel=function(){return Promise.resolve(t.tx.createTransaction())})}};function d(e,t,n,r,o){if(Array.isArray(r))return function(i,u){if(!i)throw new c.Z("Must provide a link name");var s=(0,a.sE)(r,{name:i});if(!s)throw new c.Z("No link found for that name");return d(e,t,n,s,o)(u)};if(r.hints&&r.hints.allow&&1===r.hints.allow.length)switch(r.hints.allow[0]){case"GET":return function(){return(0,i.U2)(e,r.href,{withCredentials:!0})};case"POST":return function(i){o&&o.isPolling&&(o.isPolling=!1);var s=(0,f.$)(t,i);"MFA_ENROLL"!==t.status&&"FACTOR_ENROLL"!==t.status||Object.assign(s,{factorType:n.factorType,provider:n.provider});var l={},h=s.autoPush;if(void 0!==h){if("function"==typeof h)try{l.autoPush=!!h()}catch(e){return Promise.reject(new c.Z("AutoPush resulted in an error."))}else null!==h&&(l.autoPush=!!h);s=(0,a.CE)(s,"autoPush")}var d=s.rememberDevice;if(void 0!==d){if("function"==typeof d)try{l.rememberDevice=!!d()}catch(e){return Promise.reject(new c.Z("RememberDevice resulted in an error."))}else null!==d&&(l.rememberDevice=!!d);s=(0,a.CE)(s,"rememberDevice")}else s.profile&&void 0!==s.profile.updatePhone&&(s.profile.updatePhone&&(l.updatePhone=!0),s.profile=(0,a.CE)(s.profile,"updatePhone"));var v=r.href+(0,u.UK)(l);return(0,p.TG)(e,v,s)}}}function v(e,t,n,r){if(n=n||t,n=(0,a.d9)(n),Array.isArray(n)){for(var o=[],i=0,u=n.length;i<u;i++)o.push(v(e,t,n[i],r));return o}var c=n._embedded||{};for(var f in c)Object.prototype.hasOwnProperty.call(c,f)&&((0,s.Kn)(c[f])||Array.isArray(c[f]))&&(c[f]=v(e,t,c[f],r));var p=function(e,t,n,r){var o={};for(var i in n._links)if(Object.prototype.hasOwnProperty.call(n._links,i)){var a=n._links[i];if("next"===i&&(i=a.name),a.type)o[i]=a;else if("poll"===i)o.poll=(0,l.I)(e,t,r);else{var u=d(e,t,n,a,r);u&&(o[i]=u)}}return o}(e,t,n,r);return Object.assign(c,p),n=(0,a.CE)(n,"_embedded","_links"),Object.assign(n,c),n}},5760:function(){},4393:function(e,t,n){"use strict";n.d(t,{L0:function(){return u},oN:function(){return s},LB:function(){return c},FO:function(){return f},lI:function(){return l},TG:function(){return p}});var r=n(7735),o=n(9123),i=n(1971),a=n(459);function u(e,t){return t=(0,a.$)(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn",t,{withCredentials:!0})}function s(e,t){if(!t||!t.stateToken){var n=e.tx.exists._get(i.STATE_TOKEN_KEY_NAME);if(!n)return Promise.reject(new o.Z("No transaction to resume"));t={stateToken:n}}return e.tx.status(t).then((function(t){return e.tx.createTransaction(t)}))}function c(e,t){if(!t||!t.stateToken){var n=e.tx.exists._get(i.STATE_TOKEN_KEY_NAME);if(!n)return Promise.reject(new o.Z("No transaction to evaluate"));t={stateToken:n}}return f(e,t).then((function(t){return e.tx.createTransaction(t)}))}function f(e,t){return t=(0,a.$)(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t,{withCredentials:!0})}function l(e){return!!e.tx.exists._get(i.STATE_TOKEN_KEY_NAME)}function p(e,t,n,o){return o=Object.assign({withCredentials:!0},o),(0,r.v_)(e,t,n,o).then((function(t){return e.tx.createTransaction(t)}))}},2375:function(e,t,n){"use strict";n.r(t),n.d(t,{introspectAuthn:function(){return r.LB},postToTransaction:function(){return r.TG},resumeTransaction:function(){return r.oN},transactionExists:function(){return r.lI},transactionStatus:function(){return r.L0},transactionStep:function(){return r.FO},AuthTransaction:function(){return o.D},getPollFn:function(){return i.I},addStateToken:function(){return c.$},getStateToken:function(){return c.q}});var r=n(4393),o=n(3291),i=n(8903),a=n(5760),u={};for(var s in a)["default","introspectAuthn","postToTransaction","resumeTransaction","transactionExists","transactionStatus","transactionStep","AuthTransaction","getPollFn"].indexOf(s)<0&&(u[s]=function(e){return a[e]}.bind(0,s));n.d(t,u);var c=n(459)},8903:function(e,t,n){"use strict";n.d(t,{I:function(){return p}});var r=n(7735),o=n(4771),i=n(3193),a=n(6718),u=n(8750),s=n(1971),c=n(9123),f=n(6573),l=n(459);function p(e,t,n){return function(p){var h,d,v,y;(0,o.hj)(p)?h=p:(0,o.Kn)(p)&&(h=p.delay,d=p.rememberDevice,v=p.autoPush,y=p.transactionCallBack),h||0===h||(h=s.DEFAULT_POLLING_DELAY);var g=(0,i.Rg)(t,"next","poll");n.isPolling=!0;var m=0;return function o(){return n.isPolling?function(){var n={};if("function"==typeof v)try{n.autoPush=!!v()}catch(e){return Promise.reject(new c.Z("AutoPush resulted in an error."))}else null!=v&&(n.autoPush=!!v);if("function"==typeof d)try{n.rememberDevice=!!d()}catch(e){return Promise.reject(new c.Z("RememberDevice resulted in an error."))}else null!=d&&(n.rememberDevice=!!d);var o=g.href+(0,a.UK)(n);return(0,r.v_)(e,o,(0,l.q)(t),{saveAuthnState:!1,withCredentials:!0})}().then((function(t){if(m=0,t.factorResult&&"WAITING"===t.factorResult){if(!n.isPolling)throw new f.Z;return"function"==typeof y&&y(t),(0,u.gw)(h).then(o)}return n.isPolling=!1,e.tx.createTransaction(t)})).catch((function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&m<=4){var t=1e3*Math.pow(2,m);return m++,(0,u.gw)(t).then(o)}throw e})):Promise.reject(new f.Z)}().catch((function(e){throw n.isPolling=!1,e}))}}},459:function(e,t,n){"use strict";function r(e,t){var n={};return Object.assign(n,t),!n.stateToken&&e.stateToken&&(n.stateToken=e.stateToken),n}function o(e){return r(e)}n.d(t,{$:function(){return r},q:function(){return o}})},3031:function(){},2516:function(){},3833:function(){},9573:function(){},4283:function(e,t,n){"use strict";function r(e){return!!(e&&(e.accessToken||e.idToken||e.refreshToken)&&Array.isArray(e.scopes))}function o(e){return e&&e.accessToken}function i(e){return e&&e.idToken}function a(e){return e&&e.refreshToken}n.d(t,{hD:function(){return r},hv:function(){return o},sI:function(){return i},z9:function(){return a}})},4444:function(e,t,n){"use strict";n.d(t,{$Y:function(){return r},E:function(){return o},O3:function(){return i},FT:function(){return a},$I:function(){return u},zr:function(){return s}});var r="expired",o="renewed",i="added",a="removed",u="error",s="set_storage"},1925:function(e,t,n){"use strict";n.d(t,{G5:function(){return i},ZT:function(){return a},sG:function(){return u},rZ:function(){return s},mH:function(){return c}});var r=n(1002);function o(e){return!(!e||"object"!==(0,r.Z)(e)||0===Object.values(e).length)}function i(e){return!(!o(e)||!e.redirectUri&&!e.responseType)}function a(e){return!!i(e)&&!!e.codeVerifier}function u(e){return!!a(e)&&!!e.interactionHandle}function s(e){return!!o(e)&&void 0===Object.values(e).find((function(e){return"string"!=typeof e}))}function c(e){return!(!i(e)&&!s(e))}},6854:function(){},2852:function(e,t,n){"use strict";n.r(t),n.d(t,{isCustomAuthTransactionMeta:function(){return a.rZ},isIdxTransactionMeta:function(){return a.sG},isOAuthTransactionMeta:function(){return a.G5},isPKCETransactionMeta:function(){return a.ZT},isTransactionMeta:function(){return a.mH},AuthenticatorKey:function(){return s.pc},IdxFeature:function(){return s.Fw},IdxStatus:function(){return s.Qd},isAuthenticator:function(){return s.H},isAccessToken:function(){return f.hv},isIDToken:function(){return f.sI},isRefreshToken:function(){return f.z9},isToken:function(){return f.hD},EVENT_ADDED:function(){return l.O3},EVENT_ERROR:function(){return l.$I},EVENT_EXPIRED:function(){return l.$Y},EVENT_REMOVED:function(){return l.FT},EVENT_RENEWED:function(){return l.E},EVENT_SET_STORAGE:function(){return l.zr},BaseTransaction:function(){return d.BaseTransaction},EmailChallengeTransaction:function(){return d.EmailChallengeTransaction},EmailRole:function(){return d.EmailRole},EmailStatusTransaction:function(){return d.EmailStatusTransaction},EmailTransaction:function(){return d.EmailTransaction},PhoneTransaction:function(){return d.PhoneTransaction},ProfileSchemaTransaction:function(){return d.ProfileSchemaTransaction},ProfileTransaction:function(){return d.ProfileTransaction},Status:function(){return d.Status},addEmail:function(){return d.addEmail},addPhone:function(){return d.addPhone},deleteEmail:function(){return d.deleteEmail},deletePhone:function(){return d.deletePhone},getEmail:function(){return d.getEmail},getEmailChallenge:function(){return d.getEmailChallenge},getEmails:function(){return d.getEmails},getPhone:function(){return d.getPhone},getPhones:function(){return d.getPhones},getProfile:function(){return d.getProfile},getProfileSchema:function(){return d.getProfileSchema},sendEmailChallenge:function(){return d.sendEmailChallenge},sendPhoneChallenge:function(){return d.sendPhoneChallenge},updateProfile:function(){return d.updateProfile},verifyEmailChallenge:function(){return d.verifyEmailChallenge},verifyPhoneChallenge:function(){return d.verifyPhoneChallenge}});var r=n(2516),o={};for(var i in r)"default"!==i&&(o[i]=function(e){return r[e]}.bind(0,i));n.d(t,o);var a=n(1925),u=n(3031);for(var i in o={},u)["default","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta"].indexOf(i)<0&&(o[i]=function(e){return u[e]}.bind(0,i));n.d(t,o);var s=n(1384),c=n(3833);for(var i in o={},c)["default","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta","AuthenticatorKey","IdxFeature","IdxStatus","isAuthenticator"].indexOf(i)<0&&(o[i]=function(e){return c[e]}.bind(0,i));n.d(t,o);var f=n(4283),l=n(4444),p=n(9573);for(var i in o={},p)["default","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta","AuthenticatorKey","IdxFeature","IdxStatus","isAuthenticator","isAccessToken","isIDToken","isRefreshToken","isToken","EVENT_ADDED","EVENT_ERROR","EVENT_EXPIRED","EVENT_REMOVED","EVENT_RENEWED","EVENT_SET_STORAGE"].indexOf(i)<0&&(o[i]=function(e){return p[e]}.bind(0,i));n.d(t,o);var h=n(6854);for(var i in o={},h)["default","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta","AuthenticatorKey","IdxFeature","IdxStatus","isAuthenticator","isAccessToken","isIDToken","isRefreshToken","isToken","EVENT_ADDED","EVENT_ERROR","EVENT_EXPIRED","EVENT_REMOVED","EVENT_RENEWED","EVENT_SET_STORAGE"].indexOf(i)<0&&(o[i]=function(e){return h[e]}.bind(0,i));n.d(t,o);var d=n(7938)},146:function(e,t,n){"use strict";function r(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0}function o(){var e=r();return e&&e.log?e:{log:function(){},warn:function(){},group:function(){},groupEnd:function(){}}}function i(e){o().warn("[okta-auth-sdk] WARN: "+e)}function a(e){o().warn("[okta-auth-sdk] DEPRECATION: "+e)}function u(e,t){return function(){return a(e),t.apply(null,arguments)}}n.d(t,{sW:function(){return r},dr:function(){return o},ZK:function(){return i},Rn:function(){return a},VA:function(){return u}})},305:function(e,t,n){"use strict";n.d(t,{Rn:function(){return r.Rn},VA:function(){return r.VA},dr:function(){return r.dr},sW:function(){return r.sW},ZK:function(){return r.ZK},gw:function(){return o.gw},uh:function(){return o.uh},ng:function(){return o.ng},YQ:function(){return o.YQ},ak:function(){return i.ak},d9:function(){return i.d9},l7:function(){return i.l7},sE:function(){return i.sE},Rg:function(){return i.Rg},CE:function(){return i.CE},YY:function(){return i.YY},mf:function(){return a.mf},hj:function(){return a.hj},Kn:function(){return a.Kn},tI:function(){return a.tI},HD:function(){return a.HD},sD:function(){return u.sD},Qj:function(){return u.Qj},BY:function(){return u.BY},UK:function(){return u.UK},QN:function(){return u.QN},f5:function(){return s.f}});var r=n(146),o=n(8750),i=n(3193),a=n(4771),u=n(6718),s=n(1524)},8750:function(e,t,n){"use strict";function r(e){var t=e.match(/\d+/g),n=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(n).toUTCString()}function o(e){for(var t="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",n="",r=0,o=t.length;r<e;++r)n+=t[Math.floor(Math.random()*o)];return n}function i(e){return new Promise((function(t){setTimeout(t,e)}))}function a(e,t){var n=e.split(t);return[n[0],n.splice(1,n.length).join(t)]}n.d(t,{ng:function(){return r},uh:function(){return o},gw:function(){return i},YQ:function(){return a}})},3193:function(e,t,n){"use strict";function r(e,t){var n=Array.prototype.slice.call(arguments,2);return function(){var r=Array.prototype.slice.call(arguments);return r=n.concat(r),e.apply(t,r)}}function o(){var e=arguments[0],t=[].slice.call(arguments,1);return t.forEach((function(t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&void 0!==t[n]&&(e[n]=t[n])})),e}function i(e){var t={};for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var r=e[n];null!=r&&(t[n]=r)}return t}function a(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e}function u(e){for(var t={},n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&-1==r.indexOf(i)&&(t[i]=e[i]);return a(t)}function s(e,t){for(var n=e.length;n--;){var r=e[n],o=!0;for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&r[i]!==t[i]){o=!1;break}if(o)return r}}function c(e,t,n){if(e&&e._links){var r=a(e._links[t]);return r&&r.name&&n?r.name===n?r:void 0:r}}n.d(t,{ak:function(){return r},l7:function(){return o},YY:function(){return i},d9:function(){return a},CE:function(){return u},sE:function(){return s},Rg:function(){return c}})},1524:function(e,t,n){"use strict";function r(){var e="test";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(e){return!1}}n.d(t,{f:function(){return r}})},4771:function(e,t,n){"use strict";function r(e){return"[object String]"===Object.prototype.toString.call(e)}function o(e){return"[object Object]"===Object.prototype.toString.call(e)}function i(e){return"[object Number]"===Object.prototype.toString.call(e)}function a(e){return!!e&&"[object Function]"==={}.toString.call(e)}function u(e){return e&&e.finally&&"function"==typeof e.finally}n.d(t,{HD:function(){return r},Kn:function(){return o},hj:function(){return i},mf:function(){return a},tI:function(){return u}})},6718:function(e,t,n){"use strict";function r(e){return/^[a-z][a-z0-9+.-]*:/i.test(e)}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)?e:(t=u(t),"/"===e[0]?"".concat(t).concat(e):"".concat(t,"/").concat(e))}function i(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)&&(e=e.substring(t.length)),"/"===e[0]?e:"/".concat(e)}function a(e){var t=[];if(null!==e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&void 0!==e[n]&&null!==e[n]&&t.push(n+"="+encodeURIComponent(e[n]));return t.length?"?"+t.join("&"):""}function u(e){if(e){var t=e.replace(/^\s+|\s+$/gm,"");return t.replace(/\/+$/,"")}}n.d(t,{sD:function(){return r},BY:function(){return o},QN:function(){return i},UK:function(){return a},Qj:function(){return u}})},3615:function(e,t,n){"use strict";var r=n(4575),o=n(3913),i=n(2205),a=n(8585),u=n(9754);function s(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var c=function(e){i(c,e);var t,n,s=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=u(t);if(n){var o=u(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return a(this,e)});function c(e){var t;return r(this,c),(t=s.call(this,e||"Promise was canceled")).name="CancelError",t}return o(c,[{key:"isCanceled",get:function(){return!0}}]),c}(n(5957)(Error)),f=function(){function e(t){var n=this;r(this,e),this._cancelHandlers=[],this._isPending=!0,this._isCanceled=!1,this._rejectOnCancel=!0,this._promise=new Promise((function(e,r){n._reject=r;var o=function(e){if(!n._isPending)throw new Error("The `onCancel` handler was attached after the promise settled.");n._cancelHandlers.push(e)};return Object.defineProperties(o,{shouldReject:{get:function(){return n._rejectOnCancel},set:function(e){n._rejectOnCancel=e}}}),t((function(t){n._isCanceled&&o.shouldReject||(n._isPending=!1,e(t))}),(function(e){n._isPending=!1,r(e)}),o)}))}return o(e,[{key:"then",value:function(e,t){return this._promise.then(e,t)}},{key:"catch",value:function(e){return this._promise.catch(e)}},{key:"finally",value:function(e){return this._promise.finally(e)}},{key:"cancel",value:function(e){if(this._isPending&&!this._isCanceled){if(this._isCanceled=!0,this._cancelHandlers.length>0)try{var t,n=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return s(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?s(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(this._cancelHandlers);try{for(n.s();!(t=n.n()).done;)(0,t.value)()}catch(e){n.e(e)}finally{n.f()}}catch(e){return void this._reject(e)}this._rejectOnCancel&&this._reject(new c(e))}}},{key:"isCanceled",get:function(){return this._isCanceled}}],[{key:"fn",value:function(t){return function(){for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return new e((function(e,n,o){r.push(o),t.apply(void 0,r).then(e,n)}))}}}]),e}();Object.setPrototypeOf(f.prototype,Promise.prototype),e.exports=f,e.exports.CancelError=c},4098:function(e,t){var n="undefined"!=typeof self?self:this,r=function(){function e(){this.fetch=!1,this.DOMException=n.DOMException}return e.prototype=n,new e}();!function(e){!function(t){var n="URLSearchParams"in e,r="Symbol"in e&&"iterator"in Symbol,o="FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),i="FormData"in e,a="ArrayBuffer"in e;if(a)var u=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],s=ArrayBuffer.isView||function(e){return e&&u.indexOf(Object.prototype.toString.call(e))>-1};function c(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function f(e){return"string"!=typeof e&&(e=String(e)),e}function l(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return r&&(t[Symbol.iterator]=function(){return t}),t}function p(e){this.map={},e instanceof p?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function h(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function d(e){return new Promise((function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}}))}function v(e){var t=new FileReader,n=d(t);return t.readAsArrayBuffer(e),n}function y(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function g(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:i&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():a&&o&&(t=e)&&DataView.prototype.isPrototypeOf(t)?(this._bodyArrayBuffer=y(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):a&&(ArrayBuffer.prototype.isPrototypeOf(e)||s(e))?this._bodyArrayBuffer=y(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},o&&(this.blob=function(){var e=h(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?h(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(v)}),this.text=function(){var e,t,n,r=h(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,n=d(t=new FileReader),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},i&&(this.formData=function(){return this.text().then(k)}),this.json=function(){return this.text().then(JSON.parse)},this}p.prototype.append=function(e,t){e=c(e),t=f(t);var n=this.map[e];this.map[e]=n?n+", "+t:t},p.prototype.delete=function(e){delete this.map[c(e)]},p.prototype.get=function(e){return e=c(e),this.has(e)?this.map[e]:null},p.prototype.has=function(e){return this.map.hasOwnProperty(c(e))},p.prototype.set=function(e,t){this.map[c(e)]=f(t)},p.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this)},p.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n)})),l(e)},p.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),l(e)},p.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t])})),l(e)},r&&(p.prototype[Symbol.iterator]=p.prototype.entries);var m=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function b(e,t){var n,r,o=(t=t||{}).body;if(e instanceof b){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new p(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new p(t.headers)),this.method=(r=(n=t.method||this.method||"GET").toUpperCase(),m.indexOf(r)>-1?r:n),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function k(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),o=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(o))}})),t}function w(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new p(t.headers),this.url=t.url||"",this._initBody(e)}b.prototype.clone=function(){return new b(this,{body:this._bodyInit})},g.call(b.prototype),g.call(w.prototype),w.prototype.clone=function(){return new w(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new p(this.headers),url:this.url})},w.error=function(){var e=new w(null,{status:0,statusText:""});return e.type="error",e};var O=[301,302,303,307,308];w.redirect=function(e,t){if(-1===O.indexOf(t))throw new RangeError("Invalid status code");return new w(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function E(e,n){return new Promise((function(r,i){var a=new b(e,n);if(a.signal&&a.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var u=new XMLHttpRequest;function s(){u.abort()}u.onload=function(){var e,t,n={status:u.status,statusText:u.statusText,headers:(e=u.getAllResponseHeaders()||"",t=new p,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var o=n.join(":").trim();t.append(r,o)}})),t)};n.url="responseURL"in u?u.responseURL:n.headers.get("X-Request-URL");var o="response"in u?u.response:u.responseText;r(new w(o,n))},u.onerror=function(){i(new TypeError("Network request failed"))},u.ontimeout=function(){i(new TypeError("Network request failed"))},u.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},u.open(a.method,a.url,!0),"include"===a.credentials?u.withCredentials=!0:"omit"===a.credentials&&(u.withCredentials=!1),"responseType"in u&&o&&(u.responseType="blob"),a.headers.forEach((function(e,t){u.setRequestHeader(t,e)})),a.signal&&(a.signal.addEventListener("abort",s),u.onreadystatechange=function(){4===u.readyState&&a.signal.removeEventListener("abort",s)}),u.send(void 0===a._bodyInit?null:a._bodyInit)}))}E.polyfill=!0,e.fetch||(e.fetch=E,e.Headers=p,e.Request=b,e.Response=w),t.Headers=p,t.Request=b,t.Response=w,t.fetch=E,Object.defineProperty(t,"__esModule",{value:!0})}({})}(r),r.fetch.ponyfill=!0,delete r.fetch.polyfill;var o=r;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t},5643:function(e){e.exports=!1},5666:function(e){var t=function(e){"use strict";var t,n=Object.prototype,r=n.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",a=o.asyncIterator||"@@asyncIterator",u=o.toStringTag||"@@toStringTag";function s(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{s({},"")}catch(e){s=function(e,t,n){return e[t]=n}}function c(e,t,n,r){var o=t&&t.prototype instanceof y?t:y,i=Object.create(o.prototype),a=new P(r||[]);return i._invoke=function(e,t,n){var r=l;return function(o,i){if(r===h)throw new Error("Generator is already running");if(r===d){if("throw"===o)throw i;return x()}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var u=S(a,n);if(u){if(u===v)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===l)throw r=d,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=h;var s=f(e,t,n);if("normal"===s.type){if(r=n.done?d:p,s.arg===v)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(r=d,n.method="throw",n.arg=s.arg)}}}(e,n,a),i}function f(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}e.wrap=c;var l="suspendedStart",p="suspendedYield",h="executing",d="completed",v={};function y(){}function g(){}function m(){}var b={};b[i]=function(){return this};var k=Object.getPrototypeOf,w=k&&k(k(R([])));w&&w!==n&&r.call(w,i)&&(b=w);var O=m.prototype=y.prototype=Object.create(b);function E(e){["next","throw","return"].forEach((function(t){s(e,t,(function(e){return this._invoke(t,e)}))}))}function T(e,t){function n(o,i,a,u){var s=f(e[o],e,i);if("throw"!==s.type){var c=s.arg,l=c.value;return l&&"object"==typeof l&&r.call(l,"__await")?t.resolve(l.__await).then((function(e){n("next",e,a,u)}),(function(e){n("throw",e,a,u)})):t.resolve(l).then((function(e){c.value=e,a(c)}),(function(e){return n("throw",e,a,u)}))}u(s.arg)}var o;this._invoke=function(e,r){function i(){return new t((function(t,o){n(e,r,t,o)}))}return o=o?o.then(i,i):i()}}function S(e,n){var r=e.iterator[n.method];if(r===t){if(n.delegate=null,"throw"===n.method){if(e.iterator.return&&(n.method="return",n.arg=t,S(e,n),"throw"===n.method))return v;n.method="throw",n.arg=new TypeError("The iterator does not provide a 'throw' method")}return v}var o=f(r,e.iterator,n.arg);if("throw"===o.type)return n.method="throw",n.arg=o.arg,n.delegate=null,v;var i=o.arg;return i?i.done?(n[e.resultName]=i.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,v):i:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,v)}function _(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function A(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function P(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(_,this),this.reset(!0)}function R(e){if(e){var n=e[i];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var o=-1,a=function n(){for(;++o<e.length;)if(r.call(e,o))return n.value=e[o],n.done=!1,n;return n.value=t,n.done=!0,n};return a.next=a}}return{next:x}}function x(){return{value:t,done:!0}}return g.prototype=O.constructor=m,m.constructor=g,g.displayName=s(m,u,"GeneratorFunction"),e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===g||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,m):(e.__proto__=m,s(e,u,"GeneratorFunction")),e.prototype=Object.create(O),e},e.awrap=function(e){return{__await:e}},E(T.prototype),T.prototype[a]=function(){return this},e.AsyncIterator=T,e.async=function(t,n,r,o,i){void 0===i&&(i=Promise);var a=new T(c(t,n,r,o),i);return e.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},E(O),s(O,u,"Generator"),O[i]=function(){return this},O.toString=function(){return"[object Generator]"},e.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},e.values=R,P.prototype={constructor:P,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(A),!e)for(var n in this)"t"===n.charAt(0)&&r.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function o(r,o){return u.type="throw",u.arg=e,n.next=r,o&&(n.method="next",n.arg=t),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],u=a.completion;if("root"===a.tryLoc)return o("end");if(a.tryLoc<=this.prev){var s=r.call(a,"catchLoc"),c=r.call(a,"finallyLoc");if(s&&c){if(this.prev<a.catchLoc)return o(a.catchLoc,!0);if(this.prev<a.finallyLoc)return o(a.finallyLoc)}else if(s){if(this.prev<a.catchLoc)return o(a.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return o(a.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n];if(o.tryLoc<=this.prev&&r.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=e,a.arg=t,i?(this.method="next",this.next=i.finallyLoc,v):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),v},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),A(n),v}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;A(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:R(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),v}},e}(e.exports);try{regeneratorRuntime=t}catch(e){Function("r","regeneratorRuntime = r")(t)}},4279:function(e){function t(){}t.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function o(){r.off(e,o),t.apply(n,arguments)}return o._=t,this.on(e,o,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,o=n.length;r<o;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],o=[];if(r&&t)for(var i=0,a=r.length;i<a;i++)r[i].fn!==t&&r[i].fn._!==t&&o.push(r[i]);return o.length?n[e]=o:delete n[e],this}},e.exports=t},199:function(){},907:function(e,t,n){"use strict";function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}n.d(t,{Z:function(){return r}})},7326:function(e,t,n){"use strict";function r(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}n.d(t,{Z:function(){return r}})},5861:function(e,t,n){"use strict";function r(e,t,n,r,o,i,a){try{var u=e[i](a),s=u.value}catch(e){return void n(e)}u.done?t(s):Promise.resolve(s).then(r,o)}function o(e){return function(){var t=this,n=arguments;return new Promise((function(o,i){var a=e.apply(t,n);function u(e){r(a,o,i,u,s,"next",e)}function s(e){r(a,o,i,u,s,"throw",e)}u(void 0)}))}}n.d(t,{Z:function(){return o}})},5671:function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}n.d(t,{Z:function(){return r}})},3144:function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function o(e,t,n){return t&&r(e.prototype,t),n&&r(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}n.d(t,{Z:function(){return o}})},4942:function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,{Z:function(){return r}})},1120:function(e,t,n){"use strict";function r(e){return r=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},r(e)}n.d(t,{Z:function(){return r}})},136:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(9611);function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&(0,r.Z)(e,t)}},4925:function(e,t,n){"use strict";function r(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}n.d(t,{Z:function(){return r}})},2963:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(1002),o=n(7326);function i(e,t){if(t&&("object"===(0,r.Z)(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return(0,o.Z)(e)}},9611:function(e,t,n){"use strict";function r(e,t){return r=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},r(e,t)}n.d(t,{Z:function(){return r}})},885:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(181);function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i=[],a=!0,u=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){u=!0,o=e}finally{try{a||null==n.return||n.return()}finally{if(u)throw o}}return i}}(e,t)||(0,r.Z)(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},2982:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(907),o=n(181);function i(e){return function(e){if(Array.isArray(e))return(0,r.Z)(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||(0,o.Z)(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},1002:function(e,t,n){"use strict";function r(e){return r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(e)}n.d(t,{Z:function(){return r}})},181:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(907);function o(e,t){if(e){if("string"==typeof e)return(0,r.Z)(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?(0,r.Z)(e,t):void 0}}}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var i=t[r]={exports:{}};return e[r].call(i.exports,i,i.exports,n),i.exports}n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,{a:t}),t},n.d=function(e,t){for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return function(){"use strict";n.r(r),n.d(r,{OktaAuth:function(){return t.Z},ACCESS_TOKEN_STORAGE_KEY:function(){return o.ACCESS_TOKEN_STORAGE_KEY},CACHE_STORAGE_NAME:function(){return o.CACHE_STORAGE_NAME},DEFAULT_CACHE_DURATION:function(){return o.DEFAULT_CACHE_DURATION},DEFAULT_CODE_CHALLENGE_METHOD:function(){return o.DEFAULT_CODE_CHALLENGE_METHOD},DEFAULT_MAX_CLOCK_SKEW:function(){return o.DEFAULT_MAX_CLOCK_SKEW},DEFAULT_POLLING_DELAY:function(){return o.DEFAULT_POLLING_DELAY},IDX_API_VERSION:function(){return o.IDX_API_VERSION},IDX_RESPONSE_STORAGE_NAME:function(){return o.IDX_RESPONSE_STORAGE_NAME},ID_TOKEN_STORAGE_KEY:function(){return o.ID_TOKEN_STORAGE_KEY},MAX_VERIFIER_LENGTH:function(){return o.MAX_VERIFIER_LENGTH},MIN_VERIFIER_LENGTH:function(){return o.MIN_VERIFIER_LENGTH},ORIGINAL_URI_STORAGE_NAME:function(){return o.ORIGINAL_URI_STORAGE_NAME},PKCE_STORAGE_NAME:function(){return o.PKCE_STORAGE_NAME},REDIRECT_NONCE_COOKIE_NAME:function(){return o.REDIRECT_NONCE_COOKIE_NAME},REDIRECT_OAUTH_PARAMS_NAME:function(){return o.REDIRECT_OAUTH_PARAMS_NAME},REDIRECT_STATE_COOKIE_NAME:function(){return o.REDIRECT_STATE_COOKIE_NAME},REFERRER_PATH_STORAGE_KEY:function(){return o.REFERRER_PATH_STORAGE_KEY},REFRESH_TOKEN_STORAGE_KEY:function(){return o.REFRESH_TOKEN_STORAGE_KEY},SHARED_TRANSACTION_STORAGE_NAME:function(){return o.SHARED_TRANSACTION_STORAGE_NAME},STATE_TOKEN_KEY_NAME:function(){return o.STATE_TOKEN_KEY_NAME},TOKEN_STORAGE_NAME:function(){return o.TOKEN_STORAGE_NAME},TRANSACTION_STORAGE_NAME:function(){return o.TRANSACTION_STORAGE_NAME},authenticate:function(){return i.YR},canProceed:function(){return i.Ch},cancel:function(){return i.al},clearTransactionMeta:function(){return i.Jm},createTransactionMeta:function(){return i.Xc},getSavedTransactionMeta:function(){return i.uN},getTransactionMeta:function(){return i.Co},handleEmailVerifyCallback:function(){return i.Jn},handleInteractionCodeRedirect:function(){return i.Xx},hasSavedInteractionHandle:function(){return i.$0},interact:function(){return i.EW},introspect:function(){return i.L8},isEmailVerifyCallback:function(){return i.GA},isEmailVerifyCallbackError:function(){return i.gc},isTransactionMetaValid:function(){return i.Wf},isTransactionMetaValidForFlow:function(){return i.bl},isTransactionMetaValidForOptions:function(){return i.UC},parseEmailVerifyCallback:function(){return i.mo},poll:function(){return i.$l},proceed:function(){return i.xc},recoverPassword:function(){return i.M4},register:function(){return i.z2},saveTransactionMeta:function(){return i.r0},startTransaction:function(){return i.Yr},unlockAccount:function(){return i.le},AuthApiError:function(){return f.Ws},AuthPollStopError:function(){return f.j2},AuthSdkError:function(){return f.R},OAuthError:function(){return f.BK},isAuthApiError:function(){return f.Tw},isOAuthError:function(){return f.eo},addListener:function(){return l.NH},addPostMessageListener:function(){return l.iC},assertPKCESupport:function(){return l.vz},buildAuthorizeParams:function(){return l.R0},convertTokenParamsToOAuthParams:function(){return l._6},createOAuthMeta:function(){return l.H},decodeToken:function(){return l.TD},exchangeCodeForTokens:function(){return l.rz},generateNonce:function(){return l.PY},generateState:function(){return l.aV},getDefaultTokenParams:function(){return l.Dx},getHashOrSearch:function(){return l.O2},getKey:function(){return l.km},getOAuthBaseUrl:function(){return l.zf},getOAuthDomain:function(){return l.Xp},getOAuthUrls:function(){return l.Fc},getToken:function(){return l.LP},getUserInfo:function(){return l.bG},getWellKnown:function(){return l.ES},getWithPopup:function(){return l.dh},getWithRedirect:function(){return l.Hq},getWithoutPrompt:function(){return l.y6},handleOAuthResponse:function(){return l.sw},hasAuthorizationCode:function(){return l.ZP},hasErrorInUrl:function(){return l.hg},hasInteractionCode:function(){return l.d_},hasTokensInHash:function(){return l.kU},isAuthorizationCodeError:function(){return l.tC},isCodeFlow:function(){return l.Ik},isInteractionRequired:function(){return l.wc},isInteractionRequiredError:function(){return l.Cf},isLoginRedirect:function(){return l.gM},isRedirectUri:function(){return l.Qs},isRefreshTokenError:function(){return l.Yo},isRefreshTokenInvalidError:function(){return l.$E},isSameRefreshToken:function(){return l.q0},loadFrame:function(){return l.Rl},loadPopup:function(){return l.pU},parseFromUrl:function(){return l.ko},pkce:function(){return l.U5},postRefreshToken:function(){return l.Dp},postToTokenEndpoint:function(){return l.ti},preparePKCE:function(){return l.mi},prepareTokenParams:function(){return l.wu},removeListener:function(){return l.ys},renewToken:function(){return l.$m},renewTokens:function(){return l.IK},renewTokensWithRefresh:function(){return l.Rm},revokeToken:function(){return l.PX},urlParamsToObject:function(){return l.vL},validateClaims:function(){return l.pj},validateCodeChallengeMethod:function(){return l.br},validateToken:function(){return l.Rp},verifyToken:function(){return l.WX},StorageManager:function(){return p.A},TokenManager:function(){return h.M},AuthStateManager:function(){return d.E},INITIAL_AUTH_STATE:function(){return d.a},bind:function(){return v.ak},clone:function(){return v.d9},delay:function(){return v.gw},deprecate:function(){return v.Rn},deprecateWrap:function(){return v.VA},extend:function(){return v.l7},find:function(){return v.sE},genRandomString:function(){return v.uh},getConsole:function(){return v.dr},getLink:function(){return v.Rg},getNativeConsole:function(){return v.sW},isAbsoluteUrl:function(){return v.sD},isFunction:function(){return v.mf},isLocalStorageAvailable:function(){return v.f5},isNumber:function(){return v.hj},isObject:function(){return v.Kn},isPromise:function(){return v.tI},isString:function(){return v.HD},isoToUTCString:function(){return v.ng},omit:function(){return v.CE},removeNils:function(){return v.YY},removeTrailingSlash:function(){return v.Qj},split2:function(){return v.YQ},toAbsoluteUrl:function(){return v.BY},toQueryString:function(){return v.UK},toRelativeUrl:function(){return v.QN},warn:function(){return v.ZK},crypto:function(){return e}});var e=n(9326),t=n(3415),o=n(1971),i=n(4516),a=n(2852),u={};for(var s in a)["default","OktaAuth","crypto","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REDIRECT_NONCE_COOKIE_NAME","REDIRECT_OAUTH_PARAMS_NAME","REDIRECT_STATE_COOKIE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","authenticate","canProceed","cancel","clearTransactionMeta","createTransactionMeta","getSavedTransactionMeta","getTransactionMeta","handleEmailVerifyCallback","handleInteractionCodeRedirect","hasSavedInteractionHandle","interact","introspect","isEmailVerifyCallback","isEmailVerifyCallbackError","isTransactionMetaValid","isTransactionMetaValidForFlow","isTransactionMetaValidForOptions","parseEmailVerifyCallback","poll","proceed","recoverPassword","register","saveTransactionMeta","startTransaction","unlockAccount"].indexOf(s)<0&&(u[s]=function(e){return a[e]}.bind(0,s));n.d(r,u);var c=n(2375);for(var s in u={},c)["default","OktaAuth","crypto","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REDIRECT_NONCE_COOKIE_NAME","REDIRECT_OAUTH_PARAMS_NAME","REDIRECT_STATE_COOKIE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","authenticate","canProceed","cancel","clearTransactionMeta","createTransactionMeta","getSavedTransactionMeta","getTransactionMeta","handleEmailVerifyCallback","handleInteractionCodeRedirect","hasSavedInteractionHandle","interact","introspect","isEmailVerifyCallback","isEmailVerifyCallbackError","isTransactionMetaValid","isTransactionMetaValidForFlow","isTransactionMetaValidForOptions","parseEmailVerifyCallback","poll","proceed","recoverPassword","register","saveTransactionMeta","startTransaction","unlockAccount","AuthenticatorKey","BaseTransaction","EVENT_ADDED","EVENT_ERROR","EVENT_EXPIRED","EVENT_REMOVED","EVENT_RENEWED","EVENT_SET_STORAGE","EmailChallengeTransaction","EmailRole","EmailStatusTransaction","EmailTransaction","IdxFeature","IdxStatus","PhoneTransaction","ProfileSchemaTransaction","ProfileTransaction","Status","addEmail","addPhone","deleteEmail","deletePhone","getEmail","getEmailChallenge","getEmails","getPhone","getPhones","getProfile","getProfileSchema","isAccessToken","isAuthenticator","isCustomAuthTransactionMeta","isIDToken","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isRefreshToken","isToken","isTransactionMeta","sendEmailChallenge","sendPhoneChallenge","updateProfile","verifyEmailChallenge","verifyPhoneChallenge"].indexOf(s)<0&&(u[s]=function(e){return c[e]}.bind(0,s));n.d(r,u);var f=n(7301),l=n(1279),p=n(6311),h=(n(6529),n(8092)),d=n(7913),v=n(305)}(),r}()}));
//# sourceMappingURL=okta-auth-js.umd.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'string') return argument;
  throw new $TypeError('Argument is not a string');
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(11);
var NATIVE_ARRAY_BUFFER = __webpack_require__(131);
var FunctionName = __webpack_require__(140);
var createNonEnumerableProperty = __webpack_require__(39);
var defineBuiltInAccessor = __webpack_require__(59);
var defineBuiltIns = __webpack_require__(241);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(79);
var toIntegerOrInfinity = __webpack_require__(46);
var toIndex = __webpack_require__(268);
var fround = __webpack_require__(399);
var IEEE754 = __webpack_require__(394);
var getPrototypeOf = __webpack_require__(70);
var setPrototypeOf = __webpack_require__(60);
var arrayFill = __webpack_require__(235);
var arraySlice = __webpack_require__(58);
var inheritIfRequired = __webpack_require__(248);
var copyConstructorProperties = __webpack_require__(134);
var setToStringTag = __webpack_require__(61);
var InternalStateModule = __webpack_require__(40);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = globalThis[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = globalThis[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = globalThis.Array;
var RangeError = globalThis.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(fround(number), 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toIndex(byteLength);
    if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new, sonarjs/inconsistent-function-call -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return inheritIfRequired(new NativeArrayBuffer(toIndex(length)), this, $ArrayBuffer);
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    ArrayBufferPrototype.constructor = $ArrayBuffer;

    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(13);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(22);
var ownKeys = __webpack_require__(408);
var getOwnPropertyDescriptorModule = __webpack_require__(150);
var definePropertyModule = __webpack_require__(36);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var definePropertyModule = __webpack_require__(36);
var createPropertyDescriptor = __webpack_require__(52);

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ENVIRONMENT = __webpack_require__(243);

module.exports = ENVIRONMENT === 'NODE';


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var userAgent = __webpack_require__(53);

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var hasOwn = __webpack_require__(22);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() { /* empty */ }.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(67);
var uncurryThis = __webpack_require__(2);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(24);
var isNullOrUndefined = __webpack_require__(109);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var isCallable = __webpack_require__(10);
var store = __webpack_require__(155);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(13);
var Iterators = __webpack_require__(83);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(4);
var isCallable = __webpack_require__(10);
var classof = __webpack_require__(38);
var getBuiltIn = __webpack_require__(34);
var inspectSource = __webpack_require__(144);

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(34);
var isCallable = __webpack_require__(10);
var isPrototypeOf = __webpack_require__(71);
var USE_SYMBOL_AS_UID = __webpack_require__(275);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(15);
var anObject = __webpack_require__(33);
var getMethod = __webpack_require__(142);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(253).IteratorPrototype;
var create = __webpack_require__(69);
var createPropertyDescriptor = __webpack_require__(52);
var setToStringTag = __webpack_require__(61);
var Iterators = __webpack_require__(83);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var call = __webpack_require__(15);
var propertyIsEnumerableModule = __webpack_require__(152);
var createPropertyDescriptor = __webpack_require__(52);
var toIndexedObject = __webpack_require__(62);
var toPropertyKey = __webpack_require__(157);
var hasOwn = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(247);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var InternalStateModule = __webpack_require__(40);
var createIteratorConstructor = __webpack_require__(149);
var createIterResultObject = __webpack_require__(105);
var hasOwn = __webpack_require__(22);
var objectKeys = __webpack_require__(84);
var toObject = __webpack_require__(31);

var OBJECT_ITERATOR = 'Object Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(OBJECT_ITERATOR);

module.exports = createIteratorConstructor(function ObjectIterator(source, mode) {
  var object = toObject(source);
  setInternalState(this, {
    type: OBJECT_ITERATOR,
    mode: mode,
    object: object,
    keys: objectKeys(object),
    index: 0
  });
}, 'Object', function next() {
  var state = getInternalState(this);
  var keys = state.keys;
  while (true) {
    if (keys === null || state.index >= keys.length) {
      state.object = state.keys = null;
      return createIterResultObject(undefined, true);
    }
    var key = keys[state.index++];
    var object = state.object;
    if (!hasOwn(object, key)) continue;
    switch (state.mode) {
      case 'keys': return createIterResultObject(key, false);
      case 'values': return createIterResultObject(object[key], false);
    } /* entries */ return createIterResultObject([key, object[key]], false);
  }
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(34);
var defineBuiltInAccessor = __webpack_require__(59);
var wellKnownSymbol = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(11);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(263);
var uid = __webpack_require__(160);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(41);
var globalThis = __webpack_require__(0);
var defineGlobalProperty = __webpack_require__(136);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.49.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.',
  license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(270);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(270);
var isSymbol = __webpack_require__(147);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(13);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */
var globalThis = __webpack_require__(0);
var fails = __webpack_require__(4);
var checkCorrectnessOfIteration = __webpack_require__(133);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(3).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = globalThis.ArrayBuffer;
var Int8Array = globalThis.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.1.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(158);
var defineBuiltIn = __webpack_require__(30);
var toString = __webpack_require__(406);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(35);
var normalizeHeaderName = __webpack_require__(520);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(280);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(280);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(560), __esModule: true };

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(547);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return base64;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(752)(module), __webpack_require__(57)))

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
}

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
}

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

/* harmony default export */ __webpack_exports__["a"] = ((function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})());


/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(90);
var TAG = __webpack_require__(28)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var document = __webpack_require__(26).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(90);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(93);
var $export = __webpack_require__(32);
var redefine = __webpack_require__(301);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(92);
var $iterCreate = __webpack_require__(576);
var setToStringTag = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(582);
var ITERATOR = __webpack_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(119)('meta');
var isObject = __webpack_require__(42);
var has = __webpack_require__(65);
var setDesc = __webpack_require__(43).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(64)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(89);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(56);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(187)('keys');
var uid = __webpack_require__(119);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(23);
var global = __webpack_require__(26);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(93) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(42);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(23);
var LIBRARY = __webpack_require__(93);
var wksExt = __webpack_require__(191);
var defineProperty = __webpack_require__(43).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);


/***/ }),
/* 192 */
/***/ (function(module, exports) {



/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(590);
var global = __webpack_require__(26);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(92);
var TO_STRING_TAG = __webpack_require__(28)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(642);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(146);
var tryToString = __webpack_require__(75);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(13);
var create = __webpack_require__(69);
var defineProperty = __webpack_require__(36).f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(19);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (argument === undefined || isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object or undefined');
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(74);
var lengthOfArrayLike = __webpack_require__(25);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(44);
var call = __webpack_require__(15);
var toObject = __webpack_require__(31);
var callWithSafeIterationClosing = __webpack_require__(379);
var isArrayIteratorMethod = __webpack_require__(145);
var isConstructor = __webpack_require__(146);
var lengthOfArrayLike = __webpack_require__(25);
var createProperty = __webpack_require__(135);
var setArrayLength = __webpack_require__(376);
var getIterator = __webpack_require__(108);
var getIteratorMethod = __webpack_require__(81);
var iteratorClose = __webpack_require__(148);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var O = toObject(arrayLike);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      try {
        createProperty(result, index, value);
      } catch (error) {
        iteratorClose(iterator, 'throw', error);
      }
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  setArrayLength(result, index);
  return result;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(44);
var IndexedObject = __webpack_require__(82);
var toObject = __webpack_require__(31);
var lengthOfArrayLike = __webpack_require__(25);

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE === 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var index = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(24);
var toObject = __webpack_require__(31);
var IndexedObject = __webpack_require__(82);
var lengthOfArrayLike = __webpack_require__(25);

var $TypeError = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    aCallable(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(58);

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

module.exports = sort;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var commonAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var base64Alphabet = commonAlphabet + '+/';
var base64UrlAlphabet = commonAlphabet + '-_';

var inverse = function (characters) {
  // TODO: use `Object.create(null)` in `core-js@4`
  var result = {};
  var index = 0;
  for (; index < 64; index++) result[characters.charAt(index)] = index;
  return result;
};

module.exports = {
  i2c: base64Alphabet,
  c2i: inverse(base64Alphabet),
  i2cUrl: base64UrlAlphabet,
  c2iUrl: inverse(base64UrlAlphabet)
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(30);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(53);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && /applewebkit/i.test(userAgent);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global Bun, Deno -- detection */
var globalThis = __webpack_require__(0);
var userAgent = __webpack_require__(53);
var classof = __webpack_require__(67);

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(24);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (options) {
  var alphabet = options && options.alphabet;
  if (alphabet === undefined || alphabet === 'base64' || alphabet === 'base64url') return alphabet || 'base64';
  throw new $TypeError('Incorrect `alphabet` option');
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(34);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var fails = __webpack_require__(4);
var createElement = __webpack_require__(106);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(19);
var setPrototypeOf = __webpack_require__(60);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(67);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(38);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);
var isCallable = __webpack_require__(10);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);
var IS_PURE = __webpack_require__(41);
var FunctionName = __webpack_require__(140);
var isCallable = __webpack_require__(10);
var createIteratorConstructor = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(70);
var setPrototypeOf = __webpack_require__(60);
var setToStringTag = __webpack_require__(61);
var createNonEnumerableProperty = __webpack_require__(39);
var defineBuiltIn = __webpack_require__(30);
var wellKnownSymbol = __webpack_require__(13);
var Iterators = __webpack_require__(83);
var IteratorsCore = __webpack_require__(253);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(19);
var create = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(70);
var defineBuiltIn = __webpack_require__(30);
var wellKnownSymbol = __webpack_require__(13);
var IS_PURE = __webpack_require__(41);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(4);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(11);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(140).CONFIGURABLE;
var inspectSource = __webpack_require__(144);
var InternalStateModule = __webpack_require__(40);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var uncurryThis = __webpack_require__(2);
var call = __webpack_require__(15);
var fails = __webpack_require__(4);
var objectKeys = __webpack_require__(84);
var getOwnPropertySymbolsModule = __webpack_require__(257);
var propertyIsEnumerableModule = __webpack_require__(152);
var toObject = __webpack_require__(31);
var IndexedObject = __webpack_require__(82);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(258);
var enumBugKeys = __webpack_require__(137);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var hasOwn = __webpack_require__(22);
var toIndexedObject = __webpack_require__(62);
var indexOf = __webpack_require__(104).indexOf;
var hiddenKeys = __webpack_require__(143);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var fails = __webpack_require__(4);
var uncurryThis = __webpack_require__(2);
var objectGetPrototypeOf = __webpack_require__(70);
var objectKeys = __webpack_require__(84);
var toIndexedObject = __webpack_require__(62);
var $propertyIsEnumerable = __webpack_require__(152).f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(33);
var isObject = __webpack_require__(19);
var newPromiseCapability = __webpack_require__(45);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(11);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var store = __webpack_require__(155);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(33);
var aConstructor = __webpack_require__(232);
var isNullOrUndefined = __webpack_require__(109);
var wellKnownSymbol = __webpack_require__(13);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(46);
var toString = __webpack_require__(47);
var requireObjectCoercible = __webpack_require__(111);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(139);
var fails = __webpack_require__(4);
var globalThis = __webpack_require__(0);

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var apply = __webpack_require__(80);
var bind = __webpack_require__(44);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(22);
var fails = __webpack_require__(4);
var html = __webpack_require__(246);
var arraySlice = __webpack_require__(58);
var createElement = __webpack_require__(106);
var validateArgumentsLength = __webpack_require__(63);
var IS_IOS = __webpack_require__(242);
var IS_NODE = __webpack_require__(138);

var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis.addEventListener &&
    isCallable(globalThis.postMessage) &&
    !globalThis.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(46);
var toLength = __webpack_require__(112);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw new $RangeError('Wrong length or index');
  return length;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPositiveInteger = __webpack_require__(410);

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError('Wrong offset');
  return offset;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(15);
var isObject = __webpack_require__(19);
var isSymbol = __webpack_require__(147);
var getMethod = __webpack_require__(142);
var ordinaryToPrimitive = __webpack_require__(407);
var wellKnownSymbol = __webpack_require__(13);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayFromConstructorAndList = __webpack_require__(103);
var getTypedArrayConstructor = __webpack_require__(3).getTypedArrayConstructor;

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(getTypedArrayConstructor(instance), list);
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(44);
var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var aConstructor = __webpack_require__(232);
var toObject = __webpack_require__(31);
var lengthOfArrayLike = __webpack_require__(25);
var getIterator = __webpack_require__(108);
var getIteratorMethod = __webpack_require__(81);
var isArrayIteratorMethod = __webpack_require__(145);
var isBigIntArray = __webpack_require__(250);
var aTypedArrayConstructor = __webpack_require__(3).aTypedArrayConstructor;
var toBigInt = __webpack_require__(156);

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) aCallable(mapfn);
  var O = toObject(source);
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var anObjectOrUndefined = __webpack_require__(234);
var aString = __webpack_require__(130);
var hasOwn = __webpack_require__(22);
var base64Map = __webpack_require__(240);
var getAlphabetOption = __webpack_require__(245);
var notDetached = __webpack_require__(102);

var base64Alphabet = base64Map.c2i;
var base64UrlAlphabet = base64Map.c2iUrl;

var SyntaxError = globalThis.SyntaxError;
var TypeError = globalThis.TypeError;
var at = uncurryThis(''.charAt);

var skipAsciiWhitespace = function (string, index) {
  var length = string.length;
  for (;index < length; index++) {
    var chr = at(string, index);
    if (chr !== ' ' && chr !== '\t' && chr !== '\n' && chr !== '\f' && chr !== '\r') break;
  } return index;
};

var decodeBase64Chunk = function (chunk, alphabet, throwOnExtraBits) {
  var chunkLength = chunk.length;

  if (chunkLength < 4) {
    chunk += chunkLength === 2 ? 'AA' : 'A';
  }

  var triplet = (alphabet[at(chunk, 0)] << 18)
    + (alphabet[at(chunk, 1)] << 12)
    + (alphabet[at(chunk, 2)] << 6)
    + alphabet[at(chunk, 3)];

  var chunkBytes = [
    (triplet >> 16) & 255,
    (triplet >> 8) & 255,
    triplet & 255
  ];

  if (chunkLength === 2) {
    if (throwOnExtraBits && chunkBytes[1] !== 0) {
      throw new SyntaxError('Extra bits');
    }
    return [chunkBytes[0]];
  }

  if (chunkLength === 3) {
    if (throwOnExtraBits && chunkBytes[2] !== 0) {
      throw new SyntaxError('Extra bits');
    }
    return [chunkBytes[0], chunkBytes[1]];
  }

  return chunkBytes;
};

var writeBytes = function (bytes, elements, written) {
  var elementsLength = elements.length;
  for (var index = 0; index < elementsLength; index++) {
    bytes[written + index] = elements[index];
  }
  return written + elementsLength;
};

/* eslint-disable max-statements, max-depth -- TODO */
module.exports = function (string, options, into, maxLength) {
  aString(string);
  anObjectOrUndefined(options);
  var alphabet = getAlphabetOption(options) === 'base64' ? base64Alphabet : base64UrlAlphabet;
  var lastChunkHandling = options ? options.lastChunkHandling : undefined;

  if (lastChunkHandling === undefined) lastChunkHandling = 'loose';

  if (lastChunkHandling !== 'loose' && lastChunkHandling !== 'strict' && lastChunkHandling !== 'stop-before-partial') {
    throw new TypeError('Incorrect `lastChunkHandling` option');
  }

  if (into) notDetached(into.buffer);

  var stringLength = string.length;
  var bytes = into || [];
  var written = 0;
  var read = 0;
  var chunk = '';
  var index = 0;

  if (maxLength) while (true) {
    index = skipAsciiWhitespace(string, index);
    if (index === stringLength) {
      if (chunk.length > 0) {
        if (lastChunkHandling === 'stop-before-partial') {
          break;
        }
        if (lastChunkHandling === 'loose') {
          if (chunk.length === 1) {
            throw new SyntaxError('Malformed padding: exactly one additional character');
          }
          written = writeBytes(bytes, decodeBase64Chunk(chunk, alphabet, false), written);
        } else {
          throw new SyntaxError('Missing padding');
        }
      }
      read = stringLength;
      break;
    }
    var chr = at(string, index);
    ++index;
    if (chr === '=') {
      if (chunk.length < 2) {
        throw new SyntaxError('Padding is too early');
      }
      index = skipAsciiWhitespace(string, index);
      if (chunk.length === 2) {
        if (index === stringLength) {
          if (lastChunkHandling === 'stop-before-partial') {
            break;
          }
          throw new SyntaxError('Malformed padding: only one =');
        }
        if (at(string, index) === '=') {
          ++index;
          index = skipAsciiWhitespace(string, index);
        }
      }
      if (index < stringLength) {
        throw new SyntaxError('Unexpected character after padding');
      }
      written = writeBytes(bytes, decodeBase64Chunk(chunk, alphabet, lastChunkHandling === 'strict'), written);
      read = stringLength;
      break;
    }
    if (!hasOwn(alphabet, chr)) {
      throw new SyntaxError('Unexpected character');
    }
    var remainingBytes = maxLength - written;
    if (remainingBytes === 1 && chunk.length === 2 || remainingBytes === 2 && chunk.length === 3) {
      // special case: we can fit exactly the number of bytes currently represented by chunk, so we were just checking for `=`
      break;
    }

    chunk += chr;
    if (chunk.length === 4) {
      written = writeBytes(bytes, decodeBase64Chunk(chunk, alphabet, false), written);
      chunk = '';
      read = index;
      if (written === maxLength) {
        break;
      }
    }
  }

  return { bytes: bytes, read: read, written: written };
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);

var Uint8Array = globalThis.Uint8Array;
var SyntaxError = globalThis.SyntaxError;
var min = Math.min;
var stringMatch = uncurryThis(''.match);

module.exports = function (string, into) {
  var stringLength = string.length;
  if (stringLength % 2 !== 0) throw new SyntaxError('String should be an even number of characters');
  var maxLength = into ? min(into.length, stringLength / 2) : stringLength / 2;
  var bytes = into || new Uint8Array(maxLength);
  var segments = stringMatch(string, /.{2}/g);
  var written = 0;
  for (; written < maxLength; written++) {
    var result = +('0x' + segments[written] + '0');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result !== result) {
      throw new SyntaxError('String should only contain hex characters');
    }
    bytes[written] = result >> 4;
  }
  return { bytes: bytes, read: written << 1 };
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(266);

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var fails = __webpack_require__(4);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(13);

exports.f = wellKnownSymbol;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var DOMIterables = __webpack_require__(382);
var DOMTokenListPrototype = __webpack_require__(383);
var ArrayIteratorMethods = __webpack_require__(76);
var createNonEnumerableProperty = __webpack_require__(39);
var setToStringTag = __webpack_require__(61);
var wellKnownSymbol = __webpack_require__(13);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(76);
__webpack_require__(438);
var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var safeGetBuiltIn = __webpack_require__(262);
var getBuiltIn = __webpack_require__(34);
var call = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(11);
var USE_NATIVE_URL = __webpack_require__(113);
var defineBuiltIn = __webpack_require__(30);
var defineBuiltInAccessor = __webpack_require__(59);
var defineBuiltIns = __webpack_require__(241);
var setToStringTag = __webpack_require__(61);
var createIteratorConstructor = __webpack_require__(149);
var InternalStateModule = __webpack_require__(40);
var anInstance = __webpack_require__(79);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(22);
var bind = __webpack_require__(44);
var classof = __webpack_require__(38);
var anObject = __webpack_require__(33);
var isObject = __webpack_require__(19);
var $toString = __webpack_require__(47);
var create = __webpack_require__(69);
var createPropertyDescriptor = __webpack_require__(52);
var getIterator = __webpack_require__(108);
var getIteratorMethod = __webpack_require__(81);
var createIterResultObject = __webpack_require__(105);
var validateArgumentsLength = __webpack_require__(63);
var wellKnownSymbol = __webpack_require__(13);
var arraySort = __webpack_require__(239);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError = globalThis.TypeError;
var encodeURIComponent = globalThis.encodeURIComponent;
var fromCharCode = String.fromCharCode;
var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var exec = uncurryThis(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice(string, start, start + 2);
  if (!exec(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;
  var length = octets.length;

  switch (length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  // reject surrogates, overlong encodings, and out-of-range codepoints
  if (codePoint === null
    || codePoint > 0x10FFFF
    || (codePoint >= 0xD800 && codePoint <= 0xDFFF)
    || codePoint < (length > 3 ? 0x10000 : length > 2 ? 0x800 : length > 1 ? 0x80 : 0)
  ) return null;

  return codePoint;
};

/* eslint-disable max-statements, max-depth -- ok */
var decode = function (input) {
  input = replace(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt(input, i);

    if (decodedChar === '%') {
      if (charAt(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte || nextByte > 191 || nextByte < 128) break;

          // https://encoding.spec.whatwg.org/#utf-8-decoder - position-specific byte ranges
          if (sequenceIndex === 1) {
            if (octet === 0xE0 && nextByte < 0xA0) break;
            if (octet === 0xED && nextByte > 0x9F) break;
            if (octet === 0xF0 && nextByte < 0x90) break;
            if (octet === 0xF4 && nextByte > 0x8F) break;
          }

          push(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          for (var replacement = 0; replacement < byteSequenceLength; replacement++) result += FALLBACK_REPLACER;
          i++;
          continue;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};
/* eslint-enable max-statements, max-depth -- ok */

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError('Expected sequence with length 2');
        push(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: decode(shift(entry)),
            value: decode(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.size++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://url.spec.whatwg.org/#dom-urlsearchparams-size
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var settle = __webpack_require__(512);
var buildURL = __webpack_require__(515);
var parseHeaders = __webpack_require__(521);
var isURLSameOrigin = __webpack_require__(519);
var createError = __webpack_require__(283);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(514);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("stage" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(517);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(511);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(557), __esModule: true };

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(561), __esModule: true };

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(549);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(548);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(327)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && !result.msedge && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(26).document;
module.exports = document && document.documentElement;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(49) && !__webpack_require__(64)(function () {
  return Object.defineProperty(__webpack_require__(178)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(92);
var ITERATOR = __webpack_require__(28)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(90);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(54);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(28)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(298);
var hiddenKeys = __webpack_require__(179).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(65);
var toIObject = __webpack_require__(77);
var arrayIndexOf = __webpack_require__(566)(false);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(54);
var isObject = __webpack_require__(42);
var newPromiseCapability = __webpack_require__(183);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var core = __webpack_require__(23);
var dP = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(49);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(54);
var aFunction = __webpack_require__(89);
var SPECIES = __webpack_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(55);
var invoke = __webpack_require__(575);
var html = __webpack_require__(290);
var cel = __webpack_require__(178);
var global = __webpack_require__(26);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(90)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(176);
var ITERATOR = __webpack_require__(28)('iterator');
var Iterators = __webpack_require__(92);
module.exports = __webpack_require__(23).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.4 */

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Tether = factory();
  }
}(this, function() {

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = undefined;
if (typeof TetherBase === 'undefined') {
  TetherBase = { modules: [] };
}

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  if (node.ownerDocument !== document) {
    var _frameElement = node.ownerDocument.defaultView.frameElement;
    if (_frameElement) {
      var frameRect = getActualBoundingClientRect(_frameElement);
      rect.top += frameRect.top;
      rect.bottom += frameRect.top;
      rect.left += frameRect.left;
      rect.right += frameRect.left;
    }
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node || !document.body.contains(node)) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

var _scrollBarSize = null;
function getScrollBarSize() {
  if (_scrollBarSize) {
    return _scrollBarSize;
  }
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  _scrollBarSize = { width: width, height: width };
  return _scrollBarSize;
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};
/* globals TetherBase, performance */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof TetherBase === 'undefined') {
  throw new Error('You must include the utils.js file before tether.js');
}

var _TetherBase$Utils = TetherBase.Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    TetherBase.modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < TetherBase.modules.length; ++i) {
        var _module2 = TetherBase.modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (win.innerHeight > doc.documentElement.clientHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (win.innerWidth > doc.documentElement.clientWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          if (window.matchMedia) {
            // HubSpot/tether#207
            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
            if (!retina) {
              xPos = Math.round(xPos);
              yPos = Math.round(yPos);
            }
          }

          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        if (this.options.bodyElement) {
          if (this.element.parentNode !== this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          }
        } else {
          var isFullscreenElement = function isFullscreenElement(e) {
            var d = e.ownerDocument;
            var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
            return fe === e;
          };

          var offsetParentIsBody = true;

          var currentNode = this.element.parentNode;
          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY' && !isFullscreenElement(currentNode)) {
            if (getComputedStyle(currentNode).position !== 'static') {
              offsetParentIsBody = false;
              break;
            }

            currentNode = currentNode.parentNode;
          }

          if (!offsetParentIsBody) {
            this.element.parentNode.removeChild(this.element);
            this.element.ownerDocument.body.appendChild(this.element);
          }
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

TetherBase.position = position;

var Tether = extend(TetherClass, TetherBase);
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});
/* globals TetherBase */

'use strict';

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

TetherBase.modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});
return Tether;

}));


/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueRecaptcha);


/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(490);

module.exports = parent;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(491);

module.exports = parent;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(492);

module.exports = parent;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(493);

module.exports = parent;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(494);

module.exports = parent;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(495);

module.exports = parent;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(496);

module.exports = parent;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(497);

module.exports = parent;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(86);
__webpack_require__(419);
var path = __webpack_require__(27);

module.exports = path.Array.from;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(420);
var entryUnbind = __webpack_require__(384);

module.exports = entryUnbind('Array', 'includes');


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(421);
var path = __webpack_require__(27);

module.exports = path.Object.assign;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(422);
var path = __webpack_require__(27);

module.exports = path.Object.entries;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(76);
__webpack_require__(423);
var path = __webpack_require__(27);

module.exports = path.Object.fromEntries;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(424);
var path = __webpack_require__(27);

module.exports = path.Object.keys;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(425);
var path = __webpack_require__(27);

module.exports = path.Object.values;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(416);
__webpack_require__(76);
__webpack_require__(161);
__webpack_require__(432);
__webpack_require__(426);
__webpack_require__(428);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(431);
__webpack_require__(86);
var path = __webpack_require__(27);

module.exports = path.Promise;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(76);
__webpack_require__(161);
__webpack_require__(86);
__webpack_require__(439);
var WrappedWellKnownSymbolModule = __webpack_require__(277);

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(161);
__webpack_require__(86);
__webpack_require__(450);
__webpack_require__(457);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(448);
__webpack_require__(445);
__webpack_require__(447);
__webpack_require__(446);
__webpack_require__(449);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(459);
__webpack_require__(458);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(469);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(471);
__webpack_require__(453);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(470);
__webpack_require__(346);
var global = __webpack_require__(0);

module.exports = global.Uint8Array;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(359);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(360);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(361);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(362);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(363);


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(364);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(365);


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(366);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(367);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(368);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(369);


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(329);

module.exports = parent;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(330);

module.exports = parent;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(331);

module.exports = parent;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(332);

module.exports = parent;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(333);

module.exports = parent;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(478);
var path = __webpack_require__(27);

module.exports = path.Object.iterateEntries;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(479);
var path = __webpack_require__(27);

module.exports = path.Object.iterateKeys;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(480);
var path = __webpack_require__(27);

module.exports = path.Object.iterateValues;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(334);

module.exports = parent;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(335);

module.exports = parent;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(336);

module.exports = parent;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPossiblePrototype = __webpack_require__(397);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThisAccessor = __webpack_require__(244);
var classof = __webpack_require__(67);

var ArrayBuffer = globalThis.ArrayBuffer;
var TypeError = globalThis.TypeError;

// Includes
// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
module.exports = ArrayBuffer && uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
  if (classof(O) !== 'ArrayBuffer') throw new TypeError('ArrayBuffer expected');
  return O.byteLength;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var NATIVE_ARRAY_BUFFER = __webpack_require__(131);
var arrayBufferByteLength = __webpack_require__(371);

var DataView = globalThis.DataView;

module.exports = function (O) {
  if (!NATIVE_ARRAY_BUFFER || arrayBufferByteLength(O) !== 0) return false;
  try {
    // eslint-disable-next-line no-new -- thrower
    new DataView(O);
    return false;
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(74);
var lengthOfArrayLike = __webpack_require__(25);
var deletePropertyOrThrow = __webpack_require__(381);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__(80);
var toIndexedObject = __webpack_require__(62);
var toIntegerOrInfinity = __webpack_require__(46);
var lengthOfArrayLike = __webpack_require__(25);
var arrayMethodIsStrict = __webpack_require__(375);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  if (length === 0) return -1;
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var isArray = __webpack_require__(249);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(249);
var isConstructor = __webpack_require__(146);
var isObject = __webpack_require__(19);
var wellKnownSymbol = __webpack_require__(13);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(377);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(33);
var iteratorClose = __webpack_require__(148);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(75);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(106);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);

module.exports = function (CONSTRUCTOR, METHOD) {
  return uncurryThis(globalThis[CONSTRUCTOR].prototype[METHOD]);
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(53);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UA = __webpack_require__(53);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(53);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(53);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(53);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(39);
var clearErrorStack = __webpack_require__(390);
var ERROR_STACK_INSTALLABLE = __webpack_require__(392);

// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);
var createPropertyDescriptor = __webpack_require__(52);

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[index - 1] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa += pow(2, mantissaLength);
    exponent -= eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(19);
var createNonEnumerableProperty = __webpack_require__(39);

// `InstallErrorCause` abstract operation
// https://tc39.es/ecma262/#sec-installerrorcause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(19);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(19);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sign = __webpack_require__(401);
var roundTiesToEven = __webpack_require__(400);

var abs = Math.abs;

var EPSILON = 2.220446049250313e-16; // Number.EPSILON

module.exports = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs(n);
  var s = sign(n);
  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
  return s * result;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var floatRound = __webpack_require__(398);

var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
module.exports = Math.fround || function fround(x) {
  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;

module.exports = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var safeGetBuiltIn = __webpack_require__(262);
var bind = __webpack_require__(44);
var macrotask = __webpack_require__(267).set;
var Queue = __webpack_require__(261);
var IS_IOS = __webpack_require__(242);
var IS_IOS_PEBBLE = __webpack_require__(387);
var IS_WEBOS_WEBKIT = __webpack_require__(388);
var IS_NODE = __webpack_require__(138);

var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, globalThis);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(47);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(276);
var definePropertyModule = __webpack_require__(36);
var anObject = __webpack_require__(33);
var toIndexedObject = __webpack_require__(62);
var objectKeys = __webpack_require__(84);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(158);
var classof = __webpack_require__(38);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(15);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(19);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(34);
var uncurryThis = __webpack_require__(2);
var getOwnPropertyNamesModule = __webpack_require__(256);
var getOwnPropertySymbolsModule = __webpack_require__(257);
var anObject = __webpack_require__(33);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__(2);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(46);

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var floor = Math.floor;

// https://tc39.es/ecma262/#sec-touint8clamp
module.exports = function (it) {
  var number = +it;
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number <= 0) return 0;
  if (number >= 0xFF) return 0xFF;
  var f = floor(number);
  if (f + 0.5 < number) return f + 1;
  if (number < f + 0.5) return f;
  // round-half-to-even (banker's rounding)
  return f % 2 === 0 ? f : f + 1;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var call = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(11);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(159);
var ArrayBufferViewCore = __webpack_require__(3);
var ArrayBufferModule = __webpack_require__(132);
var anInstance = __webpack_require__(79);
var createPropertyDescriptor = __webpack_require__(52);
var createNonEnumerableProperty = __webpack_require__(39);
var isIntegralNumber = __webpack_require__(396);
var toIndex = __webpack_require__(268);
var toOffset = __webpack_require__(269);
var toUint8Clamped = __webpack_require__(411);
var toPropertyKey = __webpack_require__(157);
var hasOwn = __webpack_require__(22);
var classof = __webpack_require__(38);
var isObject = __webpack_require__(19);
var isSymbol = __webpack_require__(147);
var create = __webpack_require__(69);
var isPrototypeOf = __webpack_require__(71);
var setPrototypeOf = __webpack_require__(60);
var getOwnPropertyNames = __webpack_require__(256).f;
var typedArrayFrom = __webpack_require__(272);
var forEach = __webpack_require__(51).forEach;
var setSpecies = __webpack_require__(153);
var defineBuiltInAccessor = __webpack_require__(59);
var definePropertyModule = __webpack_require__(36);
var getOwnPropertyDescriptorModule = __webpack_require__(150);
var arrayFromConstructorAndList = __webpack_require__(103);
var InternalStateModule = __webpack_require__(40);
var inheritIfRequired = __webpack_require__(248);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError = globalThis.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = globalThis[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
          } else {
            byteLength = toIndex($length) * BYTES;
            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return arrayFromConstructorAndList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var isCallable = __webpack_require__(10);

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(27);
var hasOwn = __webpack_require__(22);
var wrappedWellKnownSymbolModule = __webpack_require__(277);
var defineProperty = __webpack_require__(36).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var isPrototypeOf = __webpack_require__(71);
var getPrototypeOf = __webpack_require__(70);
var setPrototypeOf = __webpack_require__(60);
var copyConstructorProperties = __webpack_require__(134);
var create = __webpack_require__(69);
var createNonEnumerableProperty = __webpack_require__(39);
var createPropertyDescriptor = __webpack_require__(52);
var installErrorCause = __webpack_require__(395);
var installErrorStack = __webpack_require__(391);
var iterate = __webpack_require__(68);
var normalizeStringArgument = __webpack_require__(404);
var wellKnownSymbol = __webpack_require__(13);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(415);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var arrayBufferModule = __webpack_require__(132);
var setSpecies = __webpack_require__(153);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = globalThis[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var uncurryThis = __webpack_require__(141);
var fails = __webpack_require__(4);
var ArrayBufferModule = __webpack_require__(132);
var anObject = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(112);

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new ArrayBuffer(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var from = __webpack_require__(236);
var checkCorrectnessOfIteration = __webpack_require__(133);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var $includes = __webpack_require__(104).includes;
var fails = __webpack_require__(4);
var addToUnscopables = __webpack_require__(233);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// Safari 26.4- bug
var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function () {
  // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
  return [, 1].includes(undefined, 1);
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var assign = __webpack_require__(255);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var $entries = __webpack_require__(259).entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var iterate = __webpack_require__(68);
var createProperty = __webpack_require__(135);

// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var toObject = __webpack_require__(31);
var nativeKeys = __webpack_require__(84);
var fails = __webpack_require__(4);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var $values = __webpack_require__(259).values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var newPromiseCapabilityModule = __webpack_require__(45);
var perform = __webpack_require__(72);
var iterate = __webpack_require__(68);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(110);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var newPromiseCapabilityModule = __webpack_require__(45);
var perform = __webpack_require__(72);
var iterate = __webpack_require__(68);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(110);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var getBuiltIn = __webpack_require__(34);
var newPromiseCapabilityModule = __webpack_require__(45);
var perform = __webpack_require__(72);
var iterate = __webpack_require__(68);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(110);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var IS_PURE = __webpack_require__(41);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(85).CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__(73);
var getBuiltIn = __webpack_require__(34);
var isCallable = __webpack_require__(10);
var defineBuiltIn = __webpack_require__(30);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var IS_PURE = __webpack_require__(41);
var IS_NODE = __webpack_require__(138);
var globalThis = __webpack_require__(0);
var path = __webpack_require__(27);
var call = __webpack_require__(15);
var defineBuiltIn = __webpack_require__(30);
var setPrototypeOf = __webpack_require__(60);
var setToStringTag = __webpack_require__(61);
var setSpecies = __webpack_require__(153);
var aCallable = __webpack_require__(24);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(19);
var anInstance = __webpack_require__(79);
var speciesConstructor = __webpack_require__(264);
var task = __webpack_require__(267).set;
var microtask = __webpack_require__(403);
var hostReportErrors = __webpack_require__(393);
var perform = __webpack_require__(72);
var Queue = __webpack_require__(261);
var InternalStateModule = __webpack_require__(40);
var NativePromiseConstructor = __webpack_require__(73);
var PromiseConstructorDetection = __webpack_require__(85);
var newPromiseCapabilityModule = __webpack_require__(45);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

PromiseWrapper = path.Promise;

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var IS_PURE = __webpack_require__(41);
var NativePromiseConstructor = __webpack_require__(73);
var fails = __webpack_require__(4);
var getBuiltIn = __webpack_require__(34);
var isCallable = __webpack_require__(10);
var speciesConstructor = __webpack_require__(264);
var promiseResolve = __webpack_require__(260);
var defineBuiltIn = __webpack_require__(30);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(430);
__webpack_require__(427);
__webpack_require__(429);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);
var aCallable = __webpack_require__(24);
var newPromiseCapabilityModule = __webpack_require__(45);
var perform = __webpack_require__(72);
var iterate = __webpack_require__(68);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(110);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var newPromiseCapabilityModule = __webpack_require__(45);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(85).CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var getBuiltIn = __webpack_require__(34);
var IS_PURE = __webpack_require__(41);
var NativePromiseConstructor = __webpack_require__(73);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(85).CONSTRUCTOR;
var promiseResolve = __webpack_require__(260);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var apply = __webpack_require__(80);
var slice = __webpack_require__(58);
var newPromiseCapabilityModule = __webpack_require__(45);
var aCallable = __webpack_require__(24);
var perform = __webpack_require__(72);

var Promise = globalThis.Promise;

var ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var FORCED = !Promise || !Promise['try'] || perform(function () {
  Promise['try'](function (argument) {
    ACCEPT_ARGUMENTS = argument === 8;
  }, 8);
}).error || !ACCEPT_ARGUMENTS;

// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$({ target: 'Promise', stat: true, forced: FORCED }, {
  'try': function (callbackfn /* , ...args */) {
    var args = arguments.length > 1 ? slice(arguments, 1) : [];
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var result = perform(function () {
      return apply(aCallable(callbackfn), undefined, args);
    });
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var newPromiseCapabilityModule = __webpack_require__(45);

// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$({ target: 'Promise', stat: true }, {
  withResolvers: function withResolvers() {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    return {
      promise: promiseCapability.promise,
      resolve: promiseCapability.resolve,
      reject: promiseCapability.reject
    };
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var uncurryThis = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(74);

var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i++] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(414);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var lengthOfArrayLike = __webpack_require__(25);
var toIntegerOrInfinity = __webpack_require__(46);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var ArrayBufferViewCore = __webpack_require__(3);
var $ArrayCopyWithin = __webpack_require__(373);

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $every = __webpack_require__(51).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $fill = __webpack_require__(235);
var toBigInt = __webpack_require__(156);
var classof = __webpack_require__(38);
var call = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(4);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $filter = __webpack_require__(51).filter;
var fromSameTypeAndList = __webpack_require__(271);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSameTypeAndList(this, list);
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $findIndex = __webpack_require__(51).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $findLastIndex = __webpack_require__(237).findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlastindex
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $findLast = __webpack_require__(237).findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlast
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $find = __webpack_require__(51).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $forEach = __webpack_require__(51).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(159);
var exportTypedArrayStaticMethod = __webpack_require__(3).exportTypedArrayStaticMethod;
var typedArrayFrom = __webpack_require__(272);

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $includes = __webpack_require__(104).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $indexOf = __webpack_require__(104).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var fails = __webpack_require__(4);
var uncurryThis = __webpack_require__(2);
var ArrayBufferViewCore = __webpack_require__(3);
var ArrayIterators = __webpack_require__(76);
var wellKnownSymbol = __webpack_require__(13);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = globalThis.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var apply = __webpack_require__(80);
var $lastIndexOf = __webpack_require__(374);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $map = __webpack_require__(51).map;
var fromSameTypeAndList = __webpack_require__(271);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  var list = $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSameTypeAndList(this, list);
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(159);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;

// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of(/* ...items */) {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $reduceRight = __webpack_require__(238).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $reduce = __webpack_require__(238).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var call = __webpack_require__(15);
var ArrayBufferViewCore = __webpack_require__(3);
var lengthOfArrayLike = __webpack_require__(25);
var toOffset = __webpack_require__(269);
var toIndexedObject = __webpack_require__(31);
var fails = __webpack_require__(4);

var RangeError = globalThis.RangeError;
var Int8Array = globalThis.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw new RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var fails = __webpack_require__(4);
var arraySlice = __webpack_require__(58);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = getTypedArrayConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var $some = __webpack_require__(51).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(141);
var fails = __webpack_require__(4);
var aCallable = __webpack_require__(24);
var internalSort = __webpack_require__(239);
var ArrayBufferViewCore = __webpack_require__(3);
var FF = __webpack_require__(385);
var IE_OR_EDGE = __webpack_require__(386);
var V8 = __webpack_require__(139);
var WEBKIT = __webpack_require__(389);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = globalThis.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return x !== x ? 0 : -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 ? (1 / y > 0 ? 0 : 1) : (1 / y > 0 ? -1 : 0);
    return x > y ? 1 : x < y ? -1 : 0;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var toLength = __webpack_require__(112);
var toAbsoluteIndex = __webpack_require__(74);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = getTypedArrayConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(0);
var apply = __webpack_require__(80);
var ArrayBufferViewCore = __webpack_require__(3);
var fails = __webpack_require__(4);
var arraySlice = __webpack_require__(58);

var Int8Array = globalThis.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(25);
var ArrayBufferViewCore = __webpack_require__(3);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
exportTypedArrayMethod('toReversed', function toReversed() {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var A = new (getTypedArrayConstructor(O))(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(24);
var arrayFromConstructorAndList = __webpack_require__(103);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exportTypedArrayMethod = __webpack_require__(3).exportTypedArrayMethod;
var fails = __webpack_require__(4);
var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);

var Uint8Array = globalThis.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(412);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(3);
var isBigIntArray = __webpack_require__(250);
var lengthOfArrayLike = __webpack_require__(25);
var toIntegerOrInfinity = __webpack_require__(46);
var toBigInt = __webpack_require__(156);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var $RangeError = RangeError;

var PROPER_ORDER = function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// Bug in WebKit. It should truncate a negative fractional index to zero, but instead throws an error
var THROW_ON_NEGATIVE_FRACTIONAL_INDEX = PROPER_ORDER && function () {
  try {
    // eslint-disable-next-line es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](-0.5, 1);
  } catch (error) {
    return true;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  var numericValue = isBigIntArray(O) ? toBigInt(value) : +value;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new (getTypedArrayConstructor(O))(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? numericValue : O[k];
  return A;
} }['with'], !PROPER_ORDER || THROW_ON_NEGATIVE_FRACTIONAL_INDEX);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var arrayFromConstructorAndList = __webpack_require__(103);
var $fromBase64 = __webpack_require__(273);

var Uint8Array = globalThis.Uint8Array;

var INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS = !Uint8Array || !Uint8Array.fromBase64 || !function () {
  // Webkit not throw an error on odd length string
  try {
    Uint8Array.fromBase64('a');
    return;
  } catch (error) { /* empty */ }
  try {
    Uint8Array.fromBase64('', null);
  } catch (error) {
    return true;
  }
}();

// `Uint8Array.fromBase64` method
// https://tc39.es/ecma262/#sec-uint8array.frombase64
if (Uint8Array) $({ target: 'Uint8Array', stat: true, forced: INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS }, {
  fromBase64: function fromBase64(string /* , options */) {
    var result = $fromBase64(string, arguments.length > 1 ? arguments[1] : undefined, null, 0x1FFFFFFFFFFFFF);
    return arrayFromConstructorAndList(Uint8Array, result.bytes);
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var aString = __webpack_require__(130);
var $fromHex = __webpack_require__(274);

// `Uint8Array.fromHex` method
// https://tc39.es/ecma262/#sec-uint8array.fromhex
if (globalThis.Uint8Array) $({ target: 'Uint8Array', stat: true }, {
  fromHex: function fromHex(string) {
    return $fromHex(aString(string)).bytes;
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var $fromBase64 = __webpack_require__(273);
var anUint8Array = __webpack_require__(101);

var Uint8Array = globalThis.Uint8Array;

var INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS = !Uint8Array || !Uint8Array.prototype.setFromBase64 || !function () {
  var target = new Uint8Array([255, 255, 255, 255, 255]);
  try {
    target.setFromBase64('', null);
    return;
  } catch (error) { /* empty */ }
  // Webkit not throw an error on odd length string
  try {
    target.setFromBase64('a');
    return;
  } catch (error) { /* empty */ }
  try {
    target.setFromBase64('MjYyZg===');
  } catch (error) {
    return target[0] === 50 && target[1] === 54 && target[2] === 50 && target[3] === 255 && target[4] === 255;
  }
}();

// `Uint8Array.prototype.setFromBase64` method
// https://tc39.es/ecma262/#sec-uint8array.prototype.setfrombase64
if (Uint8Array) $({ target: 'Uint8Array', proto: true, forced: INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS }, {
  setFromBase64: function setFromBase64(string /* , options */) {
    anUint8Array(this);

    var result = $fromBase64(string, arguments.length > 1 ? arguments[1] : undefined, this, this.length);

    return { read: result.read, written: result.written };
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var aString = __webpack_require__(130);
var anUint8Array = __webpack_require__(101);
var notDetached = __webpack_require__(102);
var $fromHex = __webpack_require__(274);

// Should not throw an error on length-tracking views over ResizableArrayBuffer
// https://issues.chromium.org/issues/454630441
function throwsOnLengthTrackingView() {
  try {
    // eslint-disable-next-line es/no-resizable-and-growable-arraybuffers -- required for testing
    var rab = new ArrayBuffer(16, { maxByteLength: 1024 });
    // eslint-disable-next-line es/no-uint8array-prototype-setfromhex, es/no-typed-arrays -- required for testing
    new Uint8Array(rab).setFromHex('cafed00d');
  } catch (error) {
    return true;
  }
}

// `Uint8Array.prototype.setFromHex` method
// https://tc39.es/ecma262/#sec-uint8array.prototype.setfromhex
if (globalThis.Uint8Array) $({ target: 'Uint8Array', proto: true, forced: throwsOnLengthTrackingView() }, {
  setFromHex: function setFromHex(string) {
    anUint8Array(this);
    aString(string);
    notDetached(this.buffer);
    var read = $fromHex(string, this).read;
    return { read: read, written: read / 2 };
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var anObjectOrUndefined = __webpack_require__(234);
var anUint8Array = __webpack_require__(101);
var notDetached = __webpack_require__(102);
var base64Map = __webpack_require__(240);
var getAlphabetOption = __webpack_require__(245);

var base64Alphabet = base64Map.i2c;
var base64UrlAlphabet = base64Map.i2cUrl;

var charAt = uncurryThis(''.charAt);

var Uint8Array = globalThis.Uint8Array;

var INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS = !Uint8Array || !Uint8Array.prototype.toBase64 || !function () {
  try {
    var target = new Uint8Array();
    target.toBase64(null);
  } catch (error) {
    return true;
  }
}();

// `Uint8Array.prototype.toBase64` method
// https://tc39.es/ecma262/#sec-uint8array.prototype.tobase64
if (Uint8Array) $({ target: 'Uint8Array', proto: true, forced: INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS }, {
  toBase64: function toBase64(/* options */) {
    var array = anUint8Array(this);
    var options = arguments.length ? anObjectOrUndefined(arguments[0]) : undefined;
    var alphabet = getAlphabetOption(options) === 'base64' ? base64Alphabet : base64UrlAlphabet;
    var omitPadding = !!options && !!options.omitPadding;
    notDetached(this.buffer);

    var result = '';
    var i = 0;
    var length = array.length;
    var triplet;

    var at = function (shift) {
      return charAt(alphabet, (triplet >> (6 * shift)) & 63);
    };

    for (; i + 2 < length; i += 3) {
      triplet = (array[i] << 16) + (array[i + 1] << 8) + array[i + 2];
      result += at(3) + at(2) + at(1) + at(0);
    }
    if (i + 2 === length) {
      triplet = (array[i] << 16) + (array[i + 1] << 8);
      result += at(3) + at(2) + at(1) + (omitPadding ? '' : '=');
    } else if (i + 1 === length) {
      triplet = array[i] << 16;
      result += at(3) + at(2) + (omitPadding ? '' : '==');
    }

    return result;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var globalThis = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var anUint8Array = __webpack_require__(101);
var notDetached = __webpack_require__(102);

var numberToString = uncurryThis(1.1.toString);
var join = uncurryThis([].join);
var $Array = Array;

var Uint8Array = globalThis.Uint8Array;

var INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS = !Uint8Array || !Uint8Array.prototype.toHex || !(function () {
  try {
    var target = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255]);
    return target.toHex() === 'ffffffffffffffff';
  } catch (error) {
    return false;
  }
})();

// `Uint8Array.prototype.toHex` method
// https://tc39.es/ecma262/#sec-uint8array.prototype.tohex
if (Uint8Array) $({ target: 'Uint8Array', proto: true, forced: INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS }, {
  toHex: function toHex() {
    anUint8Array(this);
    notDetached(this.buffer);
    var result = $Array(this.length);
    for (var i = 0, length = this.length; i < length; i++) {
      var hex = numberToString(this[i], 16);
      result[i] = hex.length === 1 ? '0' + hex : hex;
    }
    return join(result, '');
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1);
var ObjectIterator = __webpack_require__(151);

// `Object.iterateEntries` method
// https://github.com/tc39/proposal-object-iteration
$({ target: 'Object', stat: true, forced: true }, {
  iterateEntries: function iterateEntries(object) {
    return new ObjectIterator(object, 'entries');
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1);
var ObjectIterator = __webpack_require__(151);

// `Object.iterateKeys` method
// https://github.com/tc39/proposal-object-iteration
$({ target: 'Object', stat: true, forced: true }, {
  iterateKeys: function iterateKeys(object) {
    return new ObjectIterator(object, 'keys');
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(1);
var ObjectIterator = __webpack_require__(151);

// `Object.iterateValues` method
// https://github.com/tc39/proposal-object-iteration
$({ target: 'Object', stat: true, forced: true }, {
  iterateValues: function iterateValues(object) {
    return new ObjectIterator(object, 'values');
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(30);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(47);
var validateArgumentsLength = __webpack_require__(63);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index];
      $delete(this, entry.key);
      index++;
    }
    index = 0;
    while (index < entriesLength) {
      entry = entries[index++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(30);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(47);
var validateArgumentsLength = __webpack_require__(63);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(279);


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var uncurryThis = __webpack_require__(2);
var defineBuiltInAccessor = __webpack_require__(59);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var getBuiltIn = __webpack_require__(34);
var fails = __webpack_require__(4);
var validateArgumentsLength = __webpack_require__(63);
var toString = __webpack_require__(47);
var USE_NATIVE_URL = __webpack_require__(113);

var URL = getBuiltIn('URL');

// https://github.com/nodejs/node/issues/47505
// https://github.com/denoland/deno/issues/18893
var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function () {
  URL.canParse();
});

// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9250
var WRONG_ARITY = fails(function () {
  return URL.canParse.length !== 1;
});

// `URL.canParse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({ target: 'URL', stat: true, forced: !THROWS_WITHOUT_ARGUMENTS || WRONG_ARITY }, {
  canParse: function canParse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return !!new URL(urlString, base);
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(86);
var $ = __webpack_require__(1);
var DESCRIPTORS = __webpack_require__(11);
var USE_NATIVE_URL = __webpack_require__(113);
var globalThis = __webpack_require__(0);
var bind = __webpack_require__(44);
var uncurryThis = __webpack_require__(2);
var defineBuiltIn = __webpack_require__(30);
var defineBuiltInAccessor = __webpack_require__(59);
var anInstance = __webpack_require__(79);
var hasOwn = __webpack_require__(22);
var assign = __webpack_require__(255);
var arrayFrom = __webpack_require__(236);
var arraySlice = __webpack_require__(58);
var codeAt = __webpack_require__(265).codeAt;
var toASCII = __webpack_require__(409);
var $toString = __webpack_require__(47);
var setToStringTag = __webpack_require__(61);
var validateArgumentsLength = __webpack_require__(63);
var URLSearchParamsModule = __webpack_require__(279);
var InternalStateModule = __webpack_require__(40);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = globalThis.URL;
var TypeError = globalThis.TypeError;
var encodeURIComponent = globalThis.encodeURIComponent;
var parseInt = globalThis.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.1.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
var ALPHANUMERIC_PLUS_MINUS_DOT = /[\d+\-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
// eslint-disable-next-line no-unassigned-vars -- expected `undefined` value
var EOF;

// https://url.spec.whatwg.org/#ends-in-a-number-checker
var endsInNumber = function (input) {
  var parts = split(input, '.');
  var last, hexPart;
  if (parts[parts.length - 1] === '') {
    if (parts.length === 1) return false;
    parts.length--;
  }
  last = parts[parts.length - 1];
  if (exec(DEC, last)) return true;
  if (exec(HEX_START, last)) {
    hexPart = stringSlice(last, 2);
    return hexPart === '' || !!exec(HEX, hexPart);
  }
  return false;
};

// https://url.spec.whatwg.org/#concept-ipv4-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return null;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return null;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return null;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  return currLength > maxLength ? currStart : maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;

  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    }
    return join(result, '.');
  }

  // ipv6
  if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var queryPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '#': 1, '<': 1, '>': 1
});
var specialQueryPercentEncodeSet = assign({}, queryPercentEncodeSet, {
  "'": 1
});
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1, '^': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  // encodeURIComponent does not encode ', which is in the special-query percent-encode set
  return code >= 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : chr === "'" && hasOwn(set, chr) ? '%27' : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && exec(ALPHANUMERIC_PLUS_MINUS_DOT, chr)) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && url.host === '')
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            if (url.path.length) url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || codePoints[pointer + 1] !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            if (stateOverride === HOSTNAME) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          url.host = '';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                url.host = base.host;
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file') {
            url.host = base.host;
            if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))
              && isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host !== null && url.host !== '') url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.query += percentEncode(chr, url.isSpecial() ? specialQueryPercentEncodeSet : queryPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      if (endsInNumber(input)) {
        result = parseIPv4(input);
        if (result === null) return INVALID_HOST;
        this.host = result;
      } else {
        this.host = input;
      }
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return this.host === null || this.host === '' || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    if (host === null && !url.cannotBeABaseURL && path.length > 1 && path[0] === '') output += '/.';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(this.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(486);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var getBuiltIn = __webpack_require__(34);
var validateArgumentsLength = __webpack_require__(63);
var toString = __webpack_require__(47);
var USE_NATIVE_URL = __webpack_require__(113);

var URL = getBuiltIn('URL');

// `URL.parse` method
// https://url.spec.whatwg.org/#dom-url-parse
$({ target: 'URL', stat: true, forced: !USE_NATIVE_URL }, {
  parse: function parse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return new URL(urlString, base);
    } catch (error) {
      return null;
    }
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(1);
var call = __webpack_require__(15);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(337);

module.exports = parent;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(338);

module.exports = parent;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(339);

module.exports = parent;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(340);

module.exports = parent;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(341);
__webpack_require__(278);

module.exports = parent;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(342);

module.exports = parent;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(343);

module.exports = parent;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var parent = __webpack_require__(345);
__webpack_require__(278);

module.exports = parent;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(483);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(484);
var path = __webpack_require__(27);

module.exports = path.URLSearchParams;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(498);
__webpack_require__(487);
__webpack_require__(485);
__webpack_require__(488);
__webpack_require__(489);
var path = __webpack_require__(27);

module.exports = path.URL;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

var encoding = __webpack_require__(502);

module.exports = {
  TextEncoder: encoding.TextEncoder,
  TextDecoder: encoding.TextDecoder,
};


/***/ }),
/* 501 */
/***/ (function(module, exports) {

(function(global) {
  'use strict';

  if (typeof module !== "undefined" && module.exports) {
    module.exports = global;
  }

  global["encoding-indexes"] =
{
  "big5":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,17392,19506,17923,17830,17784,160359,19831,17843,162993,19682,163013,15253,18230,18244,19527,19520,148159,144919,160594,159371,159954,19543,172881,18255,17882,19589,162924,19719,19108,18081,158499,29221,154196,137827,146950,147297,26189,22267,null,32149,22813,166841,15860,38708,162799,23515,138590,23204,13861,171696,23249,23479,23804,26478,34195,170309,29793,29853,14453,138579,145054,155681,16108,153822,15093,31484,40855,147809,166157,143850,133770,143966,17162,33924,40854,37935,18736,34323,22678,38730,37400,31184,31282,26208,27177,34973,29772,31685,26498,31276,21071,36934,13542,29636,155065,29894,40903,22451,18735,21580,16689,145038,22552,31346,162661,35727,18094,159368,16769,155033,31662,140476,40904,140481,140489,140492,40905,34052,144827,16564,40906,17633,175615,25281,28782,40907,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,12736,12737,12738,12739,12740,131340,12741,131281,131277,12742,12743,131275,139240,12744,131274,12745,12746,12747,12748,131342,12749,12750,256,193,461,192,274,201,282,200,332,211,465,210,null,7870,null,7872,202,257,225,462,224,593,275,233,283,232,299,237,464,236,333,243,466,242,363,250,468,249,470,472,474,476,252,null,7871,null,7873,234,609,9178,9179,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,172969,135493,null,25866,null,null,20029,28381,40270,37343,null,null,161589,25745,20250,20264,20392,20822,20852,20892,20964,21153,21160,21307,21326,21457,21464,22242,22768,22788,22791,22834,22836,23398,23454,23455,23706,24198,24635,25993,26622,26628,26725,27982,28860,30005,32420,32428,32442,32455,32463,32479,32518,32567,33402,33487,33647,35270,35774,35810,36710,36711,36718,29713,31996,32205,26950,31433,21031,null,null,null,null,37260,30904,37214,32956,null,36107,33014,133607,null,null,32927,40647,19661,40393,40460,19518,171510,159758,40458,172339,13761,null,28314,33342,29977,null,18705,39532,39567,40857,31111,164972,138698,132560,142054,20004,20097,20096,20103,20159,20203,20279,13388,20413,15944,20483,20616,13437,13459,13477,20870,22789,20955,20988,20997,20105,21113,21136,21287,13767,21417,13649,21424,13651,21442,21539,13677,13682,13953,21651,21667,21684,21689,21712,21743,21784,21795,21800,13720,21823,13733,13759,21975,13765,163204,21797,null,134210,134421,151851,21904,142534,14828,131905,36422,150968,169189,16467,164030,30586,142392,14900,18389,164189,158194,151018,25821,134524,135092,134357,135412,25741,36478,134806,134155,135012,142505,164438,148691,null,134470,170573,164073,18420,151207,142530,39602,14951,169460,16365,13574,152263,169940,161992,142660,40302,38933,null,17369,155813,25780,21731,142668,142282,135287,14843,135279,157402,157462,162208,25834,151634,134211,36456,139681,166732,132913,null,18443,131497,16378,22643,142733,null,148936,132348,155799,134988,134550,21881,16571,17338,null,19124,141926,135325,33194,39157,134556,25465,14846,141173,36288,22177,25724,15939,null,173569,134665,142031,142537,null,135368,145858,14738,14854,164507,13688,155209,139463,22098,134961,142514,169760,13500,27709,151099,null,null,161140,142987,139784,173659,167117,134778,134196,157724,32659,135375,141315,141625,13819,152035,134796,135053,134826,16275,134960,134471,135503,134732,null,134827,134057,134472,135360,135485,16377,140950,25650,135085,144372,161337,142286,134526,134527,142417,142421,14872,134808,135367,134958,173618,158544,167122,167321,167114,38314,21708,33476,21945,null,171715,39974,39606,161630,142830,28992,33133,33004,23580,157042,33076,14231,21343,164029,37302,134906,134671,134775,134907,13789,151019,13833,134358,22191,141237,135369,134672,134776,135288,135496,164359,136277,134777,151120,142756,23124,135197,135198,135413,135414,22428,134673,161428,164557,135093,134779,151934,14083,135094,135552,152280,172733,149978,137274,147831,164476,22681,21096,13850,153405,31666,23400,18432,19244,40743,18919,39967,39821,154484,143677,22011,13810,22153,20008,22786,138177,194680,38737,131206,20059,20155,13630,23587,24401,24516,14586,25164,25909,27514,27701,27706,28780,29227,20012,29357,149737,32594,31035,31993,32595,156266,13505,null,156491,32770,32896,157202,158033,21341,34916,35265,161970,35744,36125,38021,38264,38271,38376,167439,38886,39029,39118,39134,39267,170000,40060,40479,40644,27503,63751,20023,131207,38429,25143,38050,null,20539,28158,171123,40870,15817,34959,147790,28791,23797,19232,152013,13657,154928,24866,166450,36775,37366,29073,26393,29626,144001,172295,15499,137600,19216,30948,29698,20910,165647,16393,27235,172730,16931,34319,133743,31274,170311,166634,38741,28749,21284,139390,37876,30425,166371,40871,30685,20131,20464,20668,20015,20247,40872,21556,32139,22674,22736,138678,24210,24217,24514,141074,25995,144377,26905,27203,146531,27903,null,29184,148741,29580,16091,150035,23317,29881,35715,154788,153237,31379,31724,31939,32364,33528,34199,40873,34960,40874,36537,40875,36815,34143,39392,37409,40876,167353,136255,16497,17058,23066,null,null,null,39016,26475,17014,22333,null,34262,149883,33471,160013,19585,159092,23931,158485,159678,40877,40878,23446,40879,26343,32347,28247,31178,15752,17603,143958,141206,17306,17718,null,23765,146202,35577,23672,15634,144721,23928,40882,29015,17752,147692,138787,19575,14712,13386,131492,158785,35532,20404,131641,22975,33132,38998,170234,24379,134047,null,139713,166253,16642,18107,168057,16135,40883,172469,16632,14294,18167,158790,16764,165554,160767,17773,14548,152730,17761,17691,19849,19579,19830,17898,16328,150287,13921,17630,17597,16877,23870,23880,23894,15868,14351,23972,23993,14368,14392,24130,24253,24357,24451,14600,14612,14655,14669,24791,24893,23781,14729,25015,25017,25039,14776,25132,25232,25317,25368,14840,22193,14851,25570,25595,25607,25690,14923,25792,23829,22049,40863,14999,25990,15037,26111,26195,15090,26258,15138,26390,15170,26532,26624,15192,26698,26756,15218,15217,15227,26889,26947,29276,26980,27039,27013,15292,27094,15325,27237,27252,27249,27266,15340,27289,15346,27307,27317,27348,27382,27521,27585,27626,27765,27818,15563,27906,27910,27942,28033,15599,28068,28081,28181,28184,28201,28294,166336,28347,28386,28378,40831,28392,28393,28452,28468,15686,147265,28545,28606,15722,15733,29111,23705,15754,28716,15761,28752,28756,28783,28799,28809,131877,17345,13809,134872,147159,22462,159443,28990,153568,13902,27042,166889,23412,31305,153825,169177,31333,31357,154028,31419,31408,31426,31427,29137,156813,16842,31450,31453,31466,16879,21682,154625,31499,31573,31529,152334,154878,31650,31599,33692,154548,158847,31696,33825,31634,31672,154912,15789,154725,33938,31738,31750,31797,154817,31812,31875,149634,31910,26237,148856,31945,31943,31974,31860,31987,31989,31950,32359,17693,159300,32093,159446,29837,32137,32171,28981,32179,32210,147543,155689,32228,15635,32245,137209,32229,164717,32285,155937,155994,32366,32402,17195,37996,32295,32576,32577,32583,31030,156368,39393,32663,156497,32675,136801,131176,17756,145254,17667,164666,32762,156809,32773,32776,32797,32808,32815,172167,158915,32827,32828,32865,141076,18825,157222,146915,157416,26405,32935,166472,33031,33050,22704,141046,27775,156824,151480,25831,136330,33304,137310,27219,150117,150165,17530,33321,133901,158290,146814,20473,136445,34018,33634,158474,149927,144688,137075,146936,33450,26907,194964,16859,34123,33488,33562,134678,137140,14017,143741,144730,33403,33506,33560,147083,159139,158469,158615,144846,15807,33565,21996,33669,17675,159141,33708,33729,33747,13438,159444,27223,34138,13462,159298,143087,33880,154596,33905,15827,17636,27303,33866,146613,31064,33960,158614,159351,159299,34014,33807,33681,17568,33939,34020,154769,16960,154816,17731,34100,23282,159385,17703,34163,17686,26559,34326,165413,165435,34241,159880,34306,136578,159949,194994,17770,34344,13896,137378,21495,160666,34430,34673,172280,34798,142375,34737,34778,34831,22113,34412,26710,17935,34885,34886,161248,146873,161252,34910,34972,18011,34996,34997,25537,35013,30583,161551,35207,35210,35238,35241,35239,35260,166437,35303,162084,162493,35484,30611,37374,35472,162393,31465,162618,147343,18195,162616,29052,35596,35615,152624,152933,35647,35660,35661,35497,150138,35728,35739,35503,136927,17941,34895,35995,163156,163215,195028,14117,163155,36054,163224,163261,36114,36099,137488,36059,28764,36113,150729,16080,36215,36265,163842,135188,149898,15228,164284,160012,31463,36525,36534,36547,37588,36633,36653,164709,164882,36773,37635,172703,133712,36787,18730,166366,165181,146875,24312,143970,36857,172052,165564,165121,140069,14720,159447,36919,165180,162494,36961,165228,165387,37032,165651,37060,165606,37038,37117,37223,15088,37289,37316,31916,166195,138889,37390,27807,37441,37474,153017,37561,166598,146587,166668,153051,134449,37676,37739,166625,166891,28815,23235,166626,166629,18789,37444,166892,166969,166911,37747,37979,36540,38277,38310,37926,38304,28662,17081,140922,165592,135804,146990,18911,27676,38523,38550,16748,38563,159445,25050,38582,30965,166624,38589,21452,18849,158904,131700,156688,168111,168165,150225,137493,144138,38705,34370,38710,18959,17725,17797,150249,28789,23361,38683,38748,168405,38743,23370,168427,38751,37925,20688,143543,143548,38793,38815,38833,38846,38848,38866,38880,152684,38894,29724,169011,38911,38901,168989,162170,19153,38964,38963,38987,39014,15118,160117,15697,132656,147804,153350,39114,39095,39112,39111,19199,159015,136915,21936,39137,39142,39148,37752,39225,150057,19314,170071,170245,39413,39436,39483,39440,39512,153381,14020,168113,170965,39648,39650,170757,39668,19470,39700,39725,165376,20532,39732,158120,14531,143485,39760,39744,171326,23109,137315,39822,148043,39938,39935,39948,171624,40404,171959,172434,172459,172257,172323,172511,40318,40323,172340,40462,26760,40388,139611,172435,172576,137531,172595,40249,172217,172724,40592,40597,40606,40610,19764,40618,40623,148324,40641,15200,14821,15645,20274,14270,166955,40706,40712,19350,37924,159138,40727,40726,40761,22175,22154,40773,39352,168075,38898,33919,40802,40809,31452,40846,29206,19390,149877,149947,29047,150008,148296,150097,29598,166874,137466,31135,166270,167478,37737,37875,166468,37612,37761,37835,166252,148665,29207,16107,30578,31299,28880,148595,148472,29054,137199,28835,137406,144793,16071,137349,152623,137208,14114,136955,137273,14049,137076,137425,155467,14115,136896,22363,150053,136190,135848,136134,136374,34051,145062,34051,33877,149908,160101,146993,152924,147195,159826,17652,145134,170397,159526,26617,14131,15381,15847,22636,137506,26640,16471,145215,147681,147595,147727,158753,21707,22174,157361,22162,135135,134056,134669,37830,166675,37788,20216,20779,14361,148534,20156,132197,131967,20299,20362,153169,23144,131499,132043,14745,131850,132116,13365,20265,131776,167603,131701,35546,131596,20120,20685,20749,20386,20227,150030,147082,20290,20526,20588,20609,20428,20453,20568,20732,20825,20827,20829,20830,28278,144789,147001,147135,28018,137348,147081,20904,20931,132576,17629,132259,132242,132241,36218,166556,132878,21081,21156,133235,21217,37742,18042,29068,148364,134176,149932,135396,27089,134685,29817,16094,29849,29716,29782,29592,19342,150204,147597,21456,13700,29199,147657,21940,131909,21709,134086,22301,37469,38644,37734,22493,22413,22399,13886,22731,23193,166470,136954,137071,136976,23084,22968,37519,23166,23247,23058,153926,137715,137313,148117,14069,27909,29763,23073,155267,23169,166871,132115,37856,29836,135939,28933,18802,37896,166395,37821,14240,23582,23710,24158,24136,137622,137596,146158,24269,23375,137475,137476,14081,137376,14045,136958,14035,33066,166471,138682,144498,166312,24332,24334,137511,137131,23147,137019,23364,34324,161277,34912,24702,141408,140843,24539,16056,140719,140734,168072,159603,25024,131134,131142,140827,24985,24984,24693,142491,142599,149204,168269,25713,149093,142186,14889,142114,144464,170218,142968,25399,173147,25782,25393,25553,149987,142695,25252,142497,25659,25963,26994,15348,143502,144045,149897,144043,21773,144096,137433,169023,26318,144009,143795,15072,16784,152964,166690,152975,136956,152923,152613,30958,143619,137258,143924,13412,143887,143746,148169,26254,159012,26219,19347,26160,161904,138731,26211,144082,144097,26142,153714,14545,145466,145340,15257,145314,144382,29904,15254,26511,149034,26806,26654,15300,27326,14435,145365,148615,27187,27218,27337,27397,137490,25873,26776,27212,15319,27258,27479,147392,146586,37792,37618,166890,166603,37513,163870,166364,37991,28069,28427,149996,28007,147327,15759,28164,147516,23101,28170,22599,27940,30786,28987,148250,148086,28913,29264,29319,29332,149391,149285,20857,150180,132587,29818,147192,144991,150090,149783,155617,16134,16049,150239,166947,147253,24743,16115,29900,29756,37767,29751,17567,159210,17745,30083,16227,150745,150790,16216,30037,30323,173510,15129,29800,166604,149931,149902,15099,15821,150094,16127,149957,149747,37370,22322,37698,166627,137316,20703,152097,152039,30584,143922,30478,30479,30587,149143,145281,14942,149744,29752,29851,16063,150202,150215,16584,150166,156078,37639,152961,30750,30861,30856,30930,29648,31065,161601,153315,16654,31131,33942,31141,27181,147194,31290,31220,16750,136934,16690,37429,31217,134476,149900,131737,146874,137070,13719,21867,13680,13994,131540,134157,31458,23129,141045,154287,154268,23053,131675,30960,23082,154566,31486,16889,31837,31853,16913,154547,155324,155302,31949,150009,137136,31886,31868,31918,27314,32220,32263,32211,32590,156257,155996,162632,32151,155266,17002,158581,133398,26582,131150,144847,22468,156690,156664,149858,32733,31527,133164,154345,154947,31500,155150,39398,34373,39523,27164,144447,14818,150007,157101,39455,157088,33920,160039,158929,17642,33079,17410,32966,33033,33090,157620,39107,158274,33378,33381,158289,33875,159143,34320,160283,23174,16767,137280,23339,137377,23268,137432,34464,195004,146831,34861,160802,23042,34926,20293,34951,35007,35046,35173,35149,153219,35156,161669,161668,166901,166873,166812,166393,16045,33955,18165,18127,14322,35389,35356,169032,24397,37419,148100,26068,28969,28868,137285,40301,35999,36073,163292,22938,30659,23024,17262,14036,36394,36519,150537,36656,36682,17140,27736,28603,140065,18587,28537,28299,137178,39913,14005,149807,37051,37015,21873,18694,37307,37892,166475,16482,166652,37927,166941,166971,34021,35371,38297,38311,38295,38294,167220,29765,16066,149759,150082,148458,16103,143909,38543,167655,167526,167525,16076,149997,150136,147438,29714,29803,16124,38721,168112,26695,18973,168083,153567,38749,37736,166281,166950,166703,156606,37562,23313,35689,18748,29689,147995,38811,38769,39224,134950,24001,166853,150194,38943,169178,37622,169431,37349,17600,166736,150119,166756,39132,166469,16128,37418,18725,33812,39227,39245,162566,15869,39323,19311,39338,39516,166757,153800,27279,39457,23294,39471,170225,19344,170312,39356,19389,19351,37757,22642,135938,22562,149944,136424,30788,141087,146872,26821,15741,37976,14631,24912,141185,141675,24839,40015,40019,40059,39989,39952,39807,39887,171565,39839,172533,172286,40225,19630,147716,40472,19632,40204,172468,172269,172275,170287,40357,33981,159250,159711,158594,34300,17715,159140,159364,159216,33824,34286,159232,145367,155748,31202,144796,144960,18733,149982,15714,37851,37566,37704,131775,30905,37495,37965,20452,13376,36964,152925,30781,30804,30902,30795,137047,143817,149825,13978,20338,28634,28633,28702,28702,21524,147893,22459,22771,22410,40214,22487,28980,13487,147884,29163,158784,151447,23336,137141,166473,24844,23246,23051,17084,148616,14124,19323,166396,37819,37816,137430,134941,33906,158912,136211,148218,142374,148417,22932,146871,157505,32168,155995,155812,149945,149899,166394,37605,29666,16105,29876,166755,137375,16097,150195,27352,29683,29691,16086,150078,150164,137177,150118,132007,136228,149989,29768,149782,28837,149878,37508,29670,37727,132350,37681,166606,166422,37766,166887,153045,18741,166530,29035,149827,134399,22180,132634,134123,134328,21762,31172,137210,32254,136898,150096,137298,17710,37889,14090,166592,149933,22960,137407,137347,160900,23201,14050,146779,14000,37471,23161,166529,137314,37748,15565,133812,19094,14730,20724,15721,15692,136092,29045,17147,164376,28175,168164,17643,27991,163407,28775,27823,15574,147437,146989,28162,28428,15727,132085,30033,14012,13512,18048,16090,18545,22980,37486,18750,36673,166940,158656,22546,22472,14038,136274,28926,148322,150129,143331,135856,140221,26809,26983,136088,144613,162804,145119,166531,145366,144378,150687,27162,145069,158903,33854,17631,17614,159014,159057,158850,159710,28439,160009,33597,137018,33773,158848,159827,137179,22921,23170,137139,23137,23153,137477,147964,14125,23023,137020,14023,29070,37776,26266,148133,23150,23083,148115,27179,147193,161590,148571,148170,28957,148057,166369,20400,159016,23746,148686,163405,148413,27148,148054,135940,28838,28979,148457,15781,27871,194597,150095,32357,23019,23855,15859,24412,150109,137183,32164,33830,21637,146170,144128,131604,22398,133333,132633,16357,139166,172726,28675,168283,23920,29583,31955,166489,168992,20424,32743,29389,29456,162548,29496,29497,153334,29505,29512,16041,162584,36972,29173,149746,29665,33270,16074,30476,16081,27810,22269,29721,29726,29727,16098,16112,16116,16122,29907,16142,16211,30018,30061,30066,30093,16252,30152,30172,16320,30285,16343,30324,16348,30330,151388,29064,22051,35200,22633,16413,30531,16441,26465,16453,13787,30616,16490,16495,23646,30654,30667,22770,30744,28857,30748,16552,30777,30791,30801,30822,33864,152885,31027,26627,31026,16643,16649,31121,31129,36795,31238,36796,16743,31377,16818,31420,33401,16836,31439,31451,16847,20001,31586,31596,31611,31762,31771,16992,17018,31867,31900,17036,31928,17044,31981,36755,28864,134351,32207,32212,32208,32253,32686,32692,29343,17303,32800,32805,31545,32814,32817,32852,15820,22452,28832,32951,33001,17389,33036,29482,33038,33042,30048,33044,17409,15161,33110,33113,33114,17427,22586,33148,33156,17445,33171,17453,33189,22511,33217,33252,33364,17551,33446,33398,33482,33496,33535,17584,33623,38505,27018,33797,28917,33892,24803,33928,17668,33982,34017,34040,34064,34104,34130,17723,34159,34160,34272,17783,34418,34450,34482,34543,38469,34699,17926,17943,34990,35071,35108,35143,35217,162151,35369,35384,35476,35508,35921,36052,36082,36124,18328,22623,36291,18413,20206,36410,21976,22356,36465,22005,36528,18487,36558,36578,36580,36589,36594,36791,36801,36810,36812,36915,39364,18605,39136,37395,18718,37416,37464,37483,37553,37550,37567,37603,37611,37619,37620,37629,37699,37764,37805,18757,18769,40639,37911,21249,37917,37933,37950,18794,37972,38009,38189,38306,18855,38388,38451,18917,26528,18980,38720,18997,38834,38850,22100,19172,24808,39097,19225,39153,22596,39182,39193,20916,39196,39223,39234,39261,39266,19312,39365,19357,39484,39695,31363,39785,39809,39901,39921,39924,19565,39968,14191,138178,40265,39994,40702,22096,40339,40381,40384,40444,38134,36790,40571,40620,40625,40637,40646,38108,40674,40689,40696,31432,40772,131220,131767,132000,26906,38083,22956,132311,22592,38081,14265,132565,132629,132726,136890,22359,29043,133826,133837,134079,21610,194619,134091,21662,134139,134203,134227,134245,134268,24807,134285,22138,134325,134365,134381,134511,134578,134600,26965,39983,34725,134660,134670,134871,135056,134957,134771,23584,135100,24075,135260,135247,135286,26398,135291,135304,135318,13895,135359,135379,135471,135483,21348,33965,135907,136053,135990,35713,136567,136729,137155,137159,20088,28859,137261,137578,137773,137797,138282,138352,138412,138952,25283,138965,139029,29080,26709,139333,27113,14024,139900,140247,140282,141098,141425,141647,33533,141671,141715,142037,35237,142056,36768,142094,38840,142143,38983,39613,142412,null,142472,142519,154600,142600,142610,142775,142741,142914,143220,143308,143411,143462,144159,144350,24497,26184,26303,162425,144743,144883,29185,149946,30679,144922,145174,32391,131910,22709,26382,26904,146087,161367,155618,146961,147129,161278,139418,18640,19128,147737,166554,148206,148237,147515,148276,148374,150085,132554,20946,132625,22943,138920,15294,146687,148484,148694,22408,149108,14747,149295,165352,170441,14178,139715,35678,166734,39382,149522,149755,150037,29193,150208,134264,22885,151205,151430,132985,36570,151596,21135,22335,29041,152217,152601,147274,150183,21948,152646,152686,158546,37332,13427,152895,161330,152926,18200,152930,152934,153543,149823,153693,20582,13563,144332,24798,153859,18300,166216,154286,154505,154630,138640,22433,29009,28598,155906,162834,36950,156082,151450,35682,156674,156746,23899,158711,36662,156804,137500,35562,150006,156808,147439,156946,19392,157119,157365,141083,37989,153569,24981,23079,194765,20411,22201,148769,157436,20074,149812,38486,28047,158909,13848,35191,157593,157806,156689,157790,29151,157895,31554,168128,133649,157990,37124,158009,31301,40432,158202,39462,158253,13919,156777,131105,31107,158260,158555,23852,144665,33743,158621,18128,158884,30011,34917,159150,22710,14108,140685,159819,160205,15444,160384,160389,37505,139642,160395,37680,160486,149968,27705,38047,160848,134904,34855,35061,141606,164979,137137,28344,150058,137248,14756,14009,23568,31203,17727,26294,171181,170148,35139,161740,161880,22230,16607,136714,14753,145199,164072,136133,29101,33638,162269,168360,23143,19639,159919,166315,162301,162314,162571,163174,147834,31555,31102,163849,28597,172767,27139,164632,21410,159239,37823,26678,38749,164207,163875,158133,136173,143919,163912,23941,166960,163971,22293,38947,166217,23979,149896,26046,27093,21458,150181,147329,15377,26422,163984,164084,164142,139169,164175,164233,164271,164378,164614,164655,164746,13770,164968,165546,18682,25574,166230,30728,37461,166328,17394,166375,17375,166376,166726,166868,23032,166921,36619,167877,168172,31569,168208,168252,15863,168286,150218,36816,29327,22155,169191,169449,169392,169400,169778,170193,170313,170346,170435,170536,170766,171354,171419,32415,171768,171811,19620,38215,172691,29090,172799,19857,36882,173515,19868,134300,36798,21953,36794,140464,36793,150163,17673,32383,28502,27313,20202,13540,166700,161949,14138,36480,137205,163876,166764,166809,162366,157359,15851,161365,146615,153141,153942,20122,155265,156248,22207,134765,36366,23405,147080,150686,25566,25296,137206,137339,25904,22061,154698,21530,152337,15814,171416,19581,22050,22046,32585,155352,22901,146752,34672,19996,135146,134473,145082,33047,40286,36120,30267,40005,30286,30649,37701,21554,33096,33527,22053,33074,33816,32957,21994,31074,22083,21526,134813,13774,22021,22001,26353,164578,13869,30004,22000,21946,21655,21874,134209,134294,24272,151880,134774,142434,134818,40619,32090,21982,135285,25245,38765,21652,36045,29174,37238,25596,25529,25598,21865,142147,40050,143027,20890,13535,134567,20903,21581,21790,21779,30310,36397,157834,30129,32950,34820,34694,35015,33206,33820,135361,17644,29444,149254,23440,33547,157843,22139,141044,163119,147875,163187,159440,160438,37232,135641,37384,146684,173737,134828,134905,29286,138402,18254,151490,163833,135147,16634,40029,25887,142752,18675,149472,171388,135148,134666,24674,161187,135149,null,155720,135559,29091,32398,40272,19994,19972,13687,23309,27826,21351,13996,14812,21373,13989,149016,22682,150382,33325,21579,22442,154261,133497,null,14930,140389,29556,171692,19721,39917,146686,171824,19547,151465,169374,171998,33884,146870,160434,157619,145184,25390,32037,147191,146988,14890,36872,21196,15988,13946,17897,132238,30272,23280,134838,30842,163630,22695,16575,22140,39819,23924,30292,173108,40581,19681,30201,14331,24857,143578,148466,null,22109,135849,22439,149859,171526,21044,159918,13741,27722,40316,31830,39737,22494,137068,23635,25811,169168,156469,160100,34477,134440,159010,150242,134513,null,20990,139023,23950,38659,138705,40577,36940,31519,39682,23761,31651,25192,25397,39679,31695,39722,31870,39726,31810,31878,39957,31740,39689,40727,39963,149822,40794,21875,23491,20477,40600,20466,21088,15878,21201,22375,20566,22967,24082,38856,40363,36700,21609,38836,39232,38842,21292,24880,26924,21466,39946,40194,19515,38465,27008,20646,30022,137069,39386,21107,null,37209,38529,37212,null,37201,167575,25471,159011,27338,22033,37262,30074,25221,132092,29519,31856,154657,146685,null,149785,30422,39837,20010,134356,33726,34882,null,23626,27072,20717,22394,21023,24053,20174,27697,131570,20281,21660,21722,21146,36226,13822,24332,13811,null,27474,37244,40869,39831,38958,39092,39610,40616,40580,29050,31508,null,27642,34840,32632,null,22048,173642,36471,40787,null,36308,36431,40476,36353,25218,164733,36392,36469,31443,150135,31294,30936,27882,35431,30215,166490,40742,27854,34774,30147,172722,30803,194624,36108,29410,29553,35629,29442,29937,36075,150203,34351,24506,34976,17591,null,137275,159237,null,35454,140571,null,24829,30311,39639,40260,37742,39823,34805,null,34831,36087,29484,38689,39856,13782,29362,19463,31825,39242,155993,24921,19460,40598,24957,null,22367,24943,25254,25145,25294,14940,25058,21418,144373,25444,26626,13778,23895,166850,36826,167481,null,20697,138566,30982,21298,38456,134971,16485,null,30718,null,31938,155418,31962,31277,32870,32867,32077,29957,29938,35220,33306,26380,32866,160902,32859,29936,33027,30500,35209,157644,30035,159441,34729,34766,33224,34700,35401,36013,35651,30507,29944,34010,13877,27058,36262,null,35241,29800,28089,34753,147473,29927,15835,29046,24740,24988,15569,29026,24695,null,32625,166701,29264,24809,19326,21024,15384,146631,155351,161366,152881,137540,135934,170243,159196,159917,23745,156077,166415,145015,131310,157766,151310,17762,23327,156492,40784,40614,156267,12288,65292,12289,12290,65294,8231,65307,65306,65311,65281,65072,8230,8229,65104,65105,65106,183,65108,65109,65110,65111,65372,8211,65073,8212,65075,9588,65076,65103,65288,65289,65077,65078,65371,65373,65079,65080,12308,12309,65081,65082,12304,12305,65083,65084,12298,12299,65085,65086,12296,12297,65087,65088,12300,12301,65089,65090,12302,12303,65091,65092,65113,65114,65115,65116,65117,65118,8216,8217,8220,8221,12317,12318,8245,8242,65283,65286,65290,8251,167,12291,9675,9679,9651,9650,9678,9734,9733,9671,9670,9633,9632,9661,9660,12963,8453,175,65507,65343,717,65097,65098,65101,65102,65099,65100,65119,65120,65121,65291,65293,215,247,177,8730,65308,65310,65309,8806,8807,8800,8734,8786,8801,65122,65123,65124,65125,65126,65374,8745,8746,8869,8736,8735,8895,13266,13265,8747,8750,8757,8756,9792,9794,8853,8857,8593,8595,8592,8594,8598,8599,8601,8600,8741,8739,65295,65340,8725,65128,65284,65509,12306,65504,65505,65285,65312,8451,8457,65129,65130,65131,13269,13212,13213,13214,13262,13217,13198,13199,13252,176,20825,20827,20830,20829,20833,20835,21991,29929,31950,9601,9602,9603,9604,9605,9606,9607,9608,9615,9614,9613,9612,9611,9610,9609,9532,9524,9516,9508,9500,9620,9472,9474,9621,9484,9488,9492,9496,9581,9582,9584,9583,9552,9566,9578,9569,9698,9699,9701,9700,9585,9586,9587,65296,65297,65298,65299,65300,65301,65302,65303,65304,65305,8544,8545,8546,8547,8548,8549,8550,8551,8552,8553,12321,12322,12323,12324,12325,12326,12327,12328,12329,21313,21316,21317,65313,65314,65315,65316,65317,65318,65319,65320,65321,65322,65323,65324,65325,65326,65327,65328,65329,65330,65331,65332,65333,65334,65335,65336,65337,65338,65345,65346,65347,65348,65349,65350,65351,65352,65353,65354,65355,65356,65357,65358,65359,65360,65361,65362,65363,65364,65365,65366,65367,65368,65369,65370,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,963,964,965,966,967,968,969,12549,12550,12551,12552,12553,12554,12555,12556,12557,12558,12559,12560,12561,12562,12563,12564,12565,12566,12567,12568,12569,12570,12571,12572,12573,12574,12575,12576,12577,12578,12579,12580,12581,12582,12583,12584,12585,729,713,714,711,715,9216,9217,9218,9219,9220,9221,9222,9223,9224,9225,9226,9227,9228,9229,9230,9231,9232,9233,9234,9235,9236,9237,9238,9239,9240,9241,9242,9243,9244,9245,9246,9247,9249,8364,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,19968,20057,19969,19971,20035,20061,20102,20108,20154,20799,20837,20843,20960,20992,20993,21147,21269,21313,21340,21448,19977,19979,19976,19978,20011,20024,20961,20037,20040,20063,20062,20110,20129,20800,20995,21242,21315,21449,21475,22303,22763,22805,22823,22899,23376,23377,23379,23544,23567,23586,23608,23665,24029,24037,24049,24050,24051,24062,24178,24318,24331,24339,25165,19985,19984,19981,20013,20016,20025,20043,23609,20104,20113,20117,20114,20116,20130,20161,20160,20163,20166,20167,20173,20170,20171,20164,20803,20801,20839,20845,20846,20844,20887,20982,20998,20999,21000,21243,21246,21247,21270,21305,21320,21319,21317,21342,21380,21451,21450,21453,22764,22825,22827,22826,22829,23380,23569,23588,23610,23663,24052,24187,24319,24340,24341,24515,25096,25142,25163,25166,25903,25991,26007,26020,26041,26085,26352,26376,26408,27424,27490,27513,27595,27604,27611,27663,27700,28779,29226,29238,29243,29255,29273,29275,29356,29579,19993,19990,19989,19988,19992,20027,20045,20047,20046,20197,20184,20180,20181,20182,20183,20195,20196,20185,20190,20805,20804,20873,20874,20908,20985,20986,20984,21002,21152,21151,21253,21254,21271,21277,20191,21322,21321,21345,21344,21359,21358,21435,21487,21476,21491,21484,21486,21481,21480,21500,21496,21493,21483,21478,21482,21490,21489,21488,21477,21485,21499,22235,22234,22806,22830,22833,22900,22902,23381,23427,23612,24040,24039,24038,24066,24067,24179,24188,24321,24344,24343,24517,25098,25171,25172,25170,25169,26021,26086,26414,26412,26410,26411,26413,27491,27597,27665,27664,27704,27713,27712,27710,29359,29572,29577,29916,29926,29976,29983,29992,29993,30000,30001,30002,30003,30091,30333,30382,30399,30446,30683,30690,30707,31034,31166,31348,31435,19998,19999,20050,20051,20073,20121,20132,20134,20133,20223,20233,20249,20234,20245,20237,20240,20241,20239,20210,20214,20219,20208,20211,20221,20225,20235,20809,20807,20806,20808,20840,20849,20877,20912,21015,21009,21010,21006,21014,21155,21256,21281,21280,21360,21361,21513,21519,21516,21514,21520,21505,21515,21508,21521,21517,21512,21507,21518,21510,21522,22240,22238,22237,22323,22320,22312,22317,22316,22319,22313,22809,22810,22839,22840,22916,22904,22915,22909,22905,22914,22913,23383,23384,23431,23432,23429,23433,23546,23574,23673,24030,24070,24182,24180,24335,24347,24537,24534,25102,25100,25101,25104,25187,25179,25176,25910,26089,26088,26092,26093,26354,26355,26377,26429,26420,26417,26421,27425,27492,27515,27670,27741,27735,27737,27743,27744,27728,27733,27745,27739,27725,27726,28784,29279,29277,30334,31481,31859,31992,32566,32650,32701,32769,32771,32780,32786,32819,32895,32905,32907,32908,33251,33258,33267,33276,33292,33307,33311,33390,33394,33406,34411,34880,34892,34915,35199,38433,20018,20136,20301,20303,20295,20311,20318,20276,20315,20309,20272,20304,20305,20285,20282,20280,20291,20308,20284,20294,20323,20316,20320,20271,20302,20278,20313,20317,20296,20314,20812,20811,20813,20853,20918,20919,21029,21028,21033,21034,21032,21163,21161,21162,21164,21283,21363,21365,21533,21549,21534,21566,21542,21582,21543,21574,21571,21555,21576,21570,21531,21545,21578,21561,21563,21560,21550,21557,21558,21536,21564,21568,21553,21547,21535,21548,22250,22256,22244,22251,22346,22353,22336,22349,22343,22350,22334,22352,22351,22331,22767,22846,22941,22930,22952,22942,22947,22937,22934,22925,22948,22931,22922,22949,23389,23388,23386,23387,23436,23435,23439,23596,23616,23617,23615,23614,23696,23697,23700,23692,24043,24076,24207,24199,24202,24311,24324,24351,24420,24418,24439,24441,24536,24524,24535,24525,24561,24555,24568,24554,25106,25105,25220,25239,25238,25216,25206,25225,25197,25226,25212,25214,25209,25203,25234,25199,25240,25198,25237,25235,25233,25222,25913,25915,25912,26097,26356,26463,26446,26447,26448,26449,26460,26454,26462,26441,26438,26464,26451,26455,27493,27599,27714,27742,27801,27777,27784,27785,27781,27803,27754,27770,27792,27760,27788,27752,27798,27794,27773,27779,27762,27774,27764,27782,27766,27789,27796,27800,27778,28790,28796,28797,28792,29282,29281,29280,29380,29378,29590,29996,29995,30007,30008,30338,30447,30691,31169,31168,31167,31350,31995,32597,32918,32915,32925,32920,32923,32922,32946,33391,33426,33419,33421,35211,35282,35328,35895,35910,35925,35997,36196,36208,36275,36523,36554,36763,36784,36802,36806,36805,36804,24033,37009,37026,37034,37030,37027,37193,37318,37324,38450,38446,38449,38442,38444,20006,20054,20083,20107,20123,20126,20139,20140,20335,20381,20365,20339,20351,20332,20379,20363,20358,20355,20336,20341,20360,20329,20347,20374,20350,20367,20369,20346,20820,20818,20821,20841,20855,20854,20856,20925,20989,21051,21048,21047,21050,21040,21038,21046,21057,21182,21179,21330,21332,21331,21329,21350,21367,21368,21369,21462,21460,21463,21619,21621,21654,21624,21653,21632,21627,21623,21636,21650,21638,21628,21648,21617,21622,21644,21658,21602,21608,21643,21629,21646,22266,22403,22391,22378,22377,22369,22374,22372,22396,22812,22857,22855,22856,22852,22868,22974,22971,22996,22969,22958,22993,22982,22992,22989,22987,22995,22986,22959,22963,22994,22981,23391,23396,23395,23447,23450,23448,23452,23449,23451,23578,23624,23621,23622,23735,23713,23736,23721,23723,23729,23731,24088,24090,24086,24085,24091,24081,24184,24218,24215,24220,24213,24214,24310,24358,24359,24361,24448,24449,24447,24444,24541,24544,24573,24565,24575,24591,24596,24623,24629,24598,24618,24597,24609,24615,24617,24619,24603,25110,25109,25151,25150,25152,25215,25289,25292,25284,25279,25282,25273,25298,25307,25259,25299,25300,25291,25288,25256,25277,25276,25296,25305,25287,25293,25269,25306,25265,25304,25302,25303,25286,25260,25294,25918,26023,26044,26106,26132,26131,26124,26118,26114,26126,26112,26127,26133,26122,26119,26381,26379,26477,26507,26517,26481,26524,26483,26487,26503,26525,26519,26479,26480,26495,26505,26494,26512,26485,26522,26515,26492,26474,26482,27427,27494,27495,27519,27667,27675,27875,27880,27891,27825,27852,27877,27827,27837,27838,27836,27874,27819,27861,27859,27832,27844,27833,27841,27822,27863,27845,27889,27839,27835,27873,27867,27850,27820,27887,27868,27862,27872,28821,28814,28818,28810,28825,29228,29229,29240,29256,29287,29289,29376,29390,29401,29399,29392,29609,29608,29599,29611,29605,30013,30109,30105,30106,30340,30402,30450,30452,30693,30717,31038,31040,31041,31177,31176,31354,31353,31482,31998,32596,32652,32651,32773,32954,32933,32930,32945,32929,32939,32937,32948,32938,32943,33253,33278,33293,33459,33437,33433,33453,33469,33439,33465,33457,33452,33445,33455,33464,33443,33456,33470,33463,34382,34417,21021,34920,36555,36814,36820,36817,37045,37048,37041,37046,37319,37329,38263,38272,38428,38464,38463,38459,38468,38466,38585,38632,38738,38750,20127,20141,20142,20449,20405,20399,20415,20448,20433,20431,20445,20419,20406,20440,20447,20426,20439,20398,20432,20420,20418,20442,20430,20446,20407,20823,20882,20881,20896,21070,21059,21066,21069,21068,21067,21063,21191,21193,21187,21185,21261,21335,21371,21402,21467,21676,21696,21672,21710,21705,21688,21670,21683,21703,21698,21693,21674,21697,21700,21704,21679,21675,21681,21691,21673,21671,21695,22271,22402,22411,22432,22435,22434,22478,22446,22419,22869,22865,22863,22862,22864,23004,23000,23039,23011,23016,23043,23013,23018,23002,23014,23041,23035,23401,23459,23462,23460,23458,23461,23553,23630,23631,23629,23627,23769,23762,24055,24093,24101,24095,24189,24224,24230,24314,24328,24365,24421,24456,24453,24458,24459,24455,24460,24457,24594,24605,24608,24613,24590,24616,24653,24688,24680,24674,24646,24643,24684,24683,24682,24676,25153,25308,25366,25353,25340,25325,25345,25326,25341,25351,25329,25335,25327,25324,25342,25332,25361,25346,25919,25925,26027,26045,26082,26149,26157,26144,26151,26159,26143,26152,26161,26148,26359,26623,26579,26609,26580,26576,26604,26550,26543,26613,26601,26607,26564,26577,26548,26586,26597,26552,26575,26590,26611,26544,26585,26594,26589,26578,27498,27523,27526,27573,27602,27607,27679,27849,27915,27954,27946,27969,27941,27916,27953,27934,27927,27963,27965,27966,27958,27931,27893,27961,27943,27960,27945,27950,27957,27918,27947,28843,28858,28851,28844,28847,28845,28856,28846,28836,29232,29298,29295,29300,29417,29408,29409,29623,29642,29627,29618,29645,29632,29619,29978,29997,30031,30028,30030,30027,30123,30116,30117,30114,30115,30328,30342,30343,30344,30408,30406,30403,30405,30465,30457,30456,30473,30475,30462,30460,30471,30684,30722,30740,30732,30733,31046,31049,31048,31047,31161,31162,31185,31186,31179,31359,31361,31487,31485,31869,32002,32005,32000,32009,32007,32004,32006,32568,32654,32703,32772,32784,32781,32785,32822,32982,32997,32986,32963,32964,32972,32993,32987,32974,32990,32996,32989,33268,33314,33511,33539,33541,33507,33499,33510,33540,33509,33538,33545,33490,33495,33521,33537,33500,33492,33489,33502,33491,33503,33519,33542,34384,34425,34427,34426,34893,34923,35201,35284,35336,35330,35331,35998,36000,36212,36211,36276,36557,36556,36848,36838,36834,36842,36837,36845,36843,36836,36840,37066,37070,37057,37059,37195,37194,37325,38274,38480,38475,38476,38477,38754,38761,38859,38893,38899,38913,39080,39131,39135,39318,39321,20056,20147,20492,20493,20515,20463,20518,20517,20472,20521,20502,20486,20540,20511,20506,20498,20497,20474,20480,20500,20520,20465,20513,20491,20505,20504,20467,20462,20525,20522,20478,20523,20489,20860,20900,20901,20898,20941,20940,20934,20939,21078,21084,21076,21083,21085,21290,21375,21407,21405,21471,21736,21776,21761,21815,21756,21733,21746,21766,21754,21780,21737,21741,21729,21769,21742,21738,21734,21799,21767,21757,21775,22275,22276,22466,22484,22475,22467,22537,22799,22871,22872,22874,23057,23064,23068,23071,23067,23059,23020,23072,23075,23081,23077,23052,23049,23403,23640,23472,23475,23478,23476,23470,23477,23481,23480,23556,23633,23637,23632,23789,23805,23803,23786,23784,23792,23798,23809,23796,24046,24109,24107,24235,24237,24231,24369,24466,24465,24464,24665,24675,24677,24656,24661,24685,24681,24687,24708,24735,24730,24717,24724,24716,24709,24726,25159,25331,25352,25343,25422,25406,25391,25429,25410,25414,25423,25417,25402,25424,25405,25386,25387,25384,25421,25420,25928,25929,26009,26049,26053,26178,26185,26191,26179,26194,26188,26181,26177,26360,26388,26389,26391,26657,26680,26696,26694,26707,26681,26690,26708,26665,26803,26647,26700,26705,26685,26612,26704,26688,26684,26691,26666,26693,26643,26648,26689,27530,27529,27575,27683,27687,27688,27686,27684,27888,28010,28053,28040,28039,28006,28024,28023,27993,28051,28012,28041,28014,27994,28020,28009,28044,28042,28025,28037,28005,28052,28874,28888,28900,28889,28872,28879,29241,29305,29436,29433,29437,29432,29431,29574,29677,29705,29678,29664,29674,29662,30036,30045,30044,30042,30041,30142,30149,30151,30130,30131,30141,30140,30137,30146,30136,30347,30384,30410,30413,30414,30505,30495,30496,30504,30697,30768,30759,30776,30749,30772,30775,30757,30765,30752,30751,30770,31061,31056,31072,31071,31062,31070,31069,31063,31066,31204,31203,31207,31199,31206,31209,31192,31364,31368,31449,31494,31505,31881,32033,32023,32011,32010,32032,32034,32020,32016,32021,32026,32028,32013,32025,32027,32570,32607,32660,32709,32705,32774,32792,32789,32793,32791,32829,32831,33009,33026,33008,33029,33005,33012,33030,33016,33011,33032,33021,33034,33020,33007,33261,33260,33280,33296,33322,33323,33320,33324,33467,33579,33618,33620,33610,33592,33616,33609,33589,33588,33615,33586,33593,33590,33559,33600,33585,33576,33603,34388,34442,34474,34451,34468,34473,34444,34467,34460,34928,34935,34945,34946,34941,34937,35352,35344,35342,35340,35349,35338,35351,35347,35350,35343,35345,35912,35962,35961,36001,36002,36215,36524,36562,36564,36559,36785,36865,36870,36855,36864,36858,36852,36867,36861,36869,36856,37013,37089,37085,37090,37202,37197,37196,37336,37341,37335,37340,37337,38275,38498,38499,38497,38491,38493,38500,38488,38494,38587,39138,39340,39592,39640,39717,39730,39740,20094,20602,20605,20572,20551,20547,20556,20570,20553,20581,20598,20558,20565,20597,20596,20599,20559,20495,20591,20589,20828,20885,20976,21098,21103,21202,21209,21208,21205,21264,21263,21273,21311,21312,21310,21443,26364,21830,21866,21862,21828,21854,21857,21827,21834,21809,21846,21839,21845,21807,21860,21816,21806,21852,21804,21859,21811,21825,21847,22280,22283,22281,22495,22533,22538,22534,22496,22500,22522,22530,22581,22519,22521,22816,22882,23094,23105,23113,23142,23146,23104,23100,23138,23130,23110,23114,23408,23495,23493,23492,23490,23487,23494,23561,23560,23559,23648,23644,23645,23815,23814,23822,23835,23830,23842,23825,23849,23828,23833,23844,23847,23831,24034,24120,24118,24115,24119,24247,24248,24246,24245,24254,24373,24375,24407,24428,24425,24427,24471,24473,24478,24472,24481,24480,24476,24703,24739,24713,24736,24744,24779,24756,24806,24765,24773,24763,24757,24796,24764,24792,24789,24774,24799,24760,24794,24775,25114,25115,25160,25504,25511,25458,25494,25506,25509,25463,25447,25496,25514,25457,25513,25481,25475,25499,25451,25512,25476,25480,25497,25505,25516,25490,25487,25472,25467,25449,25448,25466,25949,25942,25937,25945,25943,21855,25935,25944,25941,25940,26012,26011,26028,26063,26059,26060,26062,26205,26202,26212,26216,26214,26206,26361,21207,26395,26753,26799,26786,26771,26805,26751,26742,26801,26791,26775,26800,26755,26820,26797,26758,26757,26772,26781,26792,26783,26785,26754,27442,27578,27627,27628,27691,28046,28092,28147,28121,28082,28129,28108,28132,28155,28154,28165,28103,28107,28079,28113,28078,28126,28153,28088,28151,28149,28101,28114,28186,28085,28122,28139,28120,28138,28145,28142,28136,28102,28100,28074,28140,28095,28134,28921,28937,28938,28925,28911,29245,29309,29313,29468,29467,29462,29459,29465,29575,29701,29706,29699,29702,29694,29709,29920,29942,29943,29980,29986,30053,30054,30050,30064,30095,30164,30165,30133,30154,30157,30350,30420,30418,30427,30519,30526,30524,30518,30520,30522,30827,30787,30798,31077,31080,31085,31227,31378,31381,31520,31528,31515,31532,31526,31513,31518,31534,31890,31895,31893,32070,32067,32113,32046,32057,32060,32064,32048,32051,32068,32047,32066,32050,32049,32573,32670,32666,32716,32718,32722,32796,32842,32838,33071,33046,33059,33067,33065,33072,33060,33282,33333,33335,33334,33337,33678,33694,33688,33656,33698,33686,33725,33707,33682,33674,33683,33673,33696,33655,33659,33660,33670,33703,34389,24426,34503,34496,34486,34500,34485,34502,34507,34481,34479,34505,34899,34974,34952,34987,34962,34966,34957,34955,35219,35215,35370,35357,35363,35365,35377,35373,35359,35355,35362,35913,35930,36009,36012,36011,36008,36010,36007,36199,36198,36286,36282,36571,36575,36889,36877,36890,36887,36899,36895,36893,36880,36885,36894,36896,36879,36898,36886,36891,36884,37096,37101,37117,37207,37326,37365,37350,37347,37351,37357,37353,38281,38506,38517,38515,38520,38512,38516,38518,38519,38508,38592,38634,38633,31456,31455,38914,38915,39770,40165,40565,40575,40613,40635,20642,20621,20613,20633,20625,20608,20630,20632,20634,26368,20977,21106,21108,21109,21097,21214,21213,21211,21338,21413,21883,21888,21927,21884,21898,21917,21912,21890,21916,21930,21908,21895,21899,21891,21939,21934,21919,21822,21938,21914,21947,21932,21937,21886,21897,21931,21913,22285,22575,22570,22580,22564,22576,22577,22561,22557,22560,22777,22778,22880,23159,23194,23167,23186,23195,23207,23411,23409,23506,23500,23507,23504,23562,23563,23601,23884,23888,23860,23879,24061,24133,24125,24128,24131,24190,24266,24257,24258,24260,24380,24429,24489,24490,24488,24785,24801,24754,24758,24800,24860,24867,24826,24853,24816,24827,24820,24936,24817,24846,24822,24841,24832,24850,25119,25161,25507,25484,25551,25536,25577,25545,25542,25549,25554,25571,25552,25569,25558,25581,25582,25462,25588,25578,25563,25682,25562,25593,25950,25958,25954,25955,26001,26000,26031,26222,26224,26228,26230,26223,26257,26234,26238,26231,26366,26367,26399,26397,26874,26837,26848,26840,26839,26885,26847,26869,26862,26855,26873,26834,26866,26851,26827,26829,26893,26898,26894,26825,26842,26990,26875,27454,27450,27453,27544,27542,27580,27631,27694,27695,27692,28207,28216,28244,28193,28210,28263,28234,28192,28197,28195,28187,28251,28248,28196,28246,28270,28205,28198,28271,28212,28237,28218,28204,28227,28189,28222,28363,28297,28185,28238,28259,28228,28274,28265,28255,28953,28954,28966,28976,28961,28982,29038,28956,29260,29316,29312,29494,29477,29492,29481,29754,29738,29747,29730,29733,29749,29750,29748,29743,29723,29734,29736,29989,29990,30059,30058,30178,30171,30179,30169,30168,30174,30176,30331,30332,30358,30355,30388,30428,30543,30701,30813,30828,30831,31245,31240,31243,31237,31232,31384,31383,31382,31461,31459,31561,31574,31558,31568,31570,31572,31565,31563,31567,31569,31903,31909,32094,32080,32104,32085,32043,32110,32114,32097,32102,32098,32112,32115,21892,32724,32725,32779,32850,32901,33109,33108,33099,33105,33102,33081,33094,33086,33100,33107,33140,33298,33308,33769,33795,33784,33805,33760,33733,33803,33729,33775,33777,33780,33879,33802,33776,33804,33740,33789,33778,33738,33848,33806,33796,33756,33799,33748,33759,34395,34527,34521,34541,34516,34523,34532,34512,34526,34903,35009,35010,34993,35203,35222,35387,35424,35413,35422,35388,35393,35412,35419,35408,35398,35380,35386,35382,35414,35937,35970,36015,36028,36019,36029,36033,36027,36032,36020,36023,36022,36031,36024,36234,36229,36225,36302,36317,36299,36314,36305,36300,36315,36294,36603,36600,36604,36764,36910,36917,36913,36920,36914,36918,37122,37109,37129,37118,37219,37221,37327,37396,37397,37411,37385,37406,37389,37392,37383,37393,38292,38287,38283,38289,38291,38290,38286,38538,38542,38539,38525,38533,38534,38541,38514,38532,38593,38597,38596,38598,38599,38639,38642,38860,38917,38918,38920,39143,39146,39151,39145,39154,39149,39342,39341,40643,40653,40657,20098,20653,20661,20658,20659,20677,20670,20652,20663,20667,20655,20679,21119,21111,21117,21215,21222,21220,21218,21219,21295,21983,21992,21971,21990,21966,21980,21959,21969,21987,21988,21999,21978,21985,21957,21958,21989,21961,22290,22291,22622,22609,22616,22615,22618,22612,22635,22604,22637,22602,22626,22610,22603,22887,23233,23241,23244,23230,23229,23228,23219,23234,23218,23913,23919,24140,24185,24265,24264,24338,24409,24492,24494,24858,24847,24904,24863,24819,24859,24825,24833,24840,24910,24908,24900,24909,24894,24884,24871,24845,24838,24887,25121,25122,25619,25662,25630,25642,25645,25661,25644,25615,25628,25620,25613,25654,25622,25623,25606,25964,26015,26032,26263,26249,26247,26248,26262,26244,26264,26253,26371,27028,26989,26970,26999,26976,26964,26997,26928,27010,26954,26984,26987,26974,26963,27001,27014,26973,26979,26971,27463,27506,27584,27583,27603,27645,28322,28335,28371,28342,28354,28304,28317,28359,28357,28325,28312,28348,28346,28331,28369,28310,28316,28356,28372,28330,28327,28340,29006,29017,29033,29028,29001,29031,29020,29036,29030,29004,29029,29022,28998,29032,29014,29242,29266,29495,29509,29503,29502,29807,29786,29781,29791,29790,29761,29759,29785,29787,29788,30070,30072,30208,30192,30209,30194,30193,30202,30207,30196,30195,30430,30431,30555,30571,30566,30558,30563,30585,30570,30572,30556,30565,30568,30562,30702,30862,30896,30871,30872,30860,30857,30844,30865,30867,30847,31098,31103,31105,33836,31165,31260,31258,31264,31252,31263,31262,31391,31392,31607,31680,31584,31598,31591,31921,31923,31925,32147,32121,32145,32129,32143,32091,32622,32617,32618,32626,32681,32680,32676,32854,32856,32902,32900,33137,33136,33144,33125,33134,33139,33131,33145,33146,33126,33285,33351,33922,33911,33853,33841,33909,33894,33899,33865,33900,33883,33852,33845,33889,33891,33897,33901,33862,34398,34396,34399,34553,34579,34568,34567,34560,34558,34555,34562,34563,34566,34570,34905,35039,35028,35033,35036,35032,35037,35041,35018,35029,35026,35228,35299,35435,35442,35443,35430,35433,35440,35463,35452,35427,35488,35441,35461,35437,35426,35438,35436,35449,35451,35390,35432,35938,35978,35977,36042,36039,36040,36036,36018,36035,36034,36037,36321,36319,36328,36335,36339,36346,36330,36324,36326,36530,36611,36617,36606,36618,36767,36786,36939,36938,36947,36930,36948,36924,36949,36944,36935,36943,36942,36941,36945,36926,36929,37138,37143,37228,37226,37225,37321,37431,37463,37432,37437,37440,37438,37467,37451,37476,37457,37428,37449,37453,37445,37433,37439,37466,38296,38552,38548,38549,38605,38603,38601,38602,38647,38651,38649,38646,38742,38772,38774,38928,38929,38931,38922,38930,38924,39164,39156,39165,39166,39347,39345,39348,39649,40169,40578,40718,40723,40736,20711,20718,20709,20694,20717,20698,20693,20687,20689,20721,20686,20713,20834,20979,21123,21122,21297,21421,22014,22016,22043,22039,22013,22036,22022,22025,22029,22030,22007,22038,22047,22024,22032,22006,22296,22294,22645,22654,22659,22675,22666,22649,22661,22653,22781,22821,22818,22820,22890,22889,23265,23270,23273,23255,23254,23256,23267,23413,23518,23527,23521,23525,23526,23528,23522,23524,23519,23565,23650,23940,23943,24155,24163,24149,24151,24148,24275,24278,24330,24390,24432,24505,24903,24895,24907,24951,24930,24931,24927,24922,24920,24949,25130,25735,25688,25684,25764,25720,25695,25722,25681,25703,25652,25709,25723,25970,26017,26071,26070,26274,26280,26269,27036,27048,27029,27073,27054,27091,27083,27035,27063,27067,27051,27060,27088,27085,27053,27084,27046,27075,27043,27465,27468,27699,28467,28436,28414,28435,28404,28457,28478,28448,28460,28431,28418,28450,28415,28399,28422,28465,28472,28466,28451,28437,28459,28463,28552,28458,28396,28417,28402,28364,28407,29076,29081,29053,29066,29060,29074,29246,29330,29334,29508,29520,29796,29795,29802,29808,29805,29956,30097,30247,30221,30219,30217,30227,30433,30435,30596,30589,30591,30561,30913,30879,30887,30899,30889,30883,31118,31119,31117,31278,31281,31402,31401,31469,31471,31649,31637,31627,31605,31639,31645,31636,31631,31672,31623,31620,31929,31933,31934,32187,32176,32156,32189,32190,32160,32202,32180,32178,32177,32186,32162,32191,32181,32184,32173,32210,32199,32172,32624,32736,32737,32735,32862,32858,32903,33104,33152,33167,33160,33162,33151,33154,33255,33274,33287,33300,33310,33355,33993,33983,33990,33988,33945,33950,33970,33948,33995,33976,33984,34003,33936,33980,34001,33994,34623,34588,34619,34594,34597,34612,34584,34645,34615,34601,35059,35074,35060,35065,35064,35069,35048,35098,35055,35494,35468,35486,35491,35469,35489,35475,35492,35498,35493,35496,35480,35473,35482,35495,35946,35981,35980,36051,36049,36050,36203,36249,36245,36348,36628,36626,36629,36627,36771,36960,36952,36956,36963,36953,36958,36962,36957,36955,37145,37144,37150,37237,37240,37239,37236,37496,37504,37509,37528,37526,37499,37523,37532,37544,37500,37521,38305,38312,38313,38307,38309,38308,38553,38556,38555,38604,38610,38656,38780,38789,38902,38935,38936,39087,39089,39171,39173,39180,39177,39361,39599,39600,39654,39745,39746,40180,40182,40179,40636,40763,40778,20740,20736,20731,20725,20729,20738,20744,20745,20741,20956,21127,21128,21129,21133,21130,21232,21426,22062,22075,22073,22066,22079,22068,22057,22099,22094,22103,22132,22070,22063,22064,22656,22687,22686,22707,22684,22702,22697,22694,22893,23305,23291,23307,23285,23308,23304,23534,23532,23529,23531,23652,23653,23965,23956,24162,24159,24161,24290,24282,24287,24285,24291,24288,24392,24433,24503,24501,24950,24935,24942,24925,24917,24962,24956,24944,24939,24958,24999,24976,25003,24974,25004,24986,24996,24980,25006,25134,25705,25711,25721,25758,25778,25736,25744,25776,25765,25747,25749,25769,25746,25774,25773,25771,25754,25772,25753,25762,25779,25973,25975,25976,26286,26283,26292,26289,27171,27167,27112,27137,27166,27161,27133,27169,27155,27146,27123,27138,27141,27117,27153,27472,27470,27556,27589,27590,28479,28540,28548,28497,28518,28500,28550,28525,28507,28536,28526,28558,28538,28528,28516,28567,28504,28373,28527,28512,28511,29087,29100,29105,29096,29270,29339,29518,29527,29801,29835,29827,29822,29824,30079,30240,30249,30239,30244,30246,30241,30242,30362,30394,30436,30606,30599,30604,30609,30603,30923,30917,30906,30922,30910,30933,30908,30928,31295,31292,31296,31293,31287,31291,31407,31406,31661,31665,31684,31668,31686,31687,31681,31648,31692,31946,32224,32244,32239,32251,32216,32236,32221,32232,32227,32218,32222,32233,32158,32217,32242,32249,32629,32631,32687,32745,32806,33179,33180,33181,33184,33178,33176,34071,34109,34074,34030,34092,34093,34067,34065,34083,34081,34068,34028,34085,34047,34054,34690,34676,34678,34656,34662,34680,34664,34649,34647,34636,34643,34907,34909,35088,35079,35090,35091,35093,35082,35516,35538,35527,35524,35477,35531,35576,35506,35529,35522,35519,35504,35542,35533,35510,35513,35547,35916,35918,35948,36064,36062,36070,36068,36076,36077,36066,36067,36060,36074,36065,36205,36255,36259,36395,36368,36381,36386,36367,36393,36383,36385,36382,36538,36637,36635,36639,36649,36646,36650,36636,36638,36645,36969,36974,36968,36973,36983,37168,37165,37159,37169,37255,37257,37259,37251,37573,37563,37559,37610,37548,37604,37569,37555,37564,37586,37575,37616,37554,38317,38321,38660,38662,38663,38665,38752,38797,38795,38799,38945,38955,38940,39091,39178,39187,39186,39192,39389,39376,39391,39387,39377,39381,39378,39385,39607,39662,39663,39719,39749,39748,39799,39791,40198,40201,40195,40617,40638,40654,22696,40786,20754,20760,20756,20752,20757,20864,20906,20957,21137,21139,21235,22105,22123,22137,22121,22116,22136,22122,22120,22117,22129,22127,22124,22114,22134,22721,22718,22727,22725,22894,23325,23348,23416,23536,23566,24394,25010,24977,25001,24970,25037,25014,25022,25034,25032,25136,25797,25793,25803,25787,25788,25818,25796,25799,25794,25805,25791,25810,25812,25790,25972,26310,26313,26297,26308,26311,26296,27197,27192,27194,27225,27243,27224,27193,27204,27234,27233,27211,27207,27189,27231,27208,27481,27511,27653,28610,28593,28577,28611,28580,28609,28583,28595,28608,28601,28598,28582,28576,28596,29118,29129,29136,29138,29128,29141,29113,29134,29145,29148,29123,29124,29544,29852,29859,29848,29855,29854,29922,29964,29965,30260,30264,30266,30439,30437,30624,30622,30623,30629,30952,30938,30956,30951,31142,31309,31310,31302,31308,31307,31418,31705,31761,31689,31716,31707,31713,31721,31718,31957,31958,32266,32273,32264,32283,32291,32286,32285,32265,32272,32633,32690,32752,32753,32750,32808,33203,33193,33192,33275,33288,33368,33369,34122,34137,34120,34152,34153,34115,34121,34157,34154,34142,34691,34719,34718,34722,34701,34913,35114,35122,35109,35115,35105,35242,35238,35558,35578,35563,35569,35584,35548,35559,35566,35582,35585,35586,35575,35565,35571,35574,35580,35947,35949,35987,36084,36420,36401,36404,36418,36409,36405,36667,36655,36664,36659,36776,36774,36981,36980,36984,36978,36988,36986,37172,37266,37664,37686,37624,37683,37679,37666,37628,37675,37636,37658,37648,37670,37665,37653,37678,37657,38331,38567,38568,38570,38613,38670,38673,38678,38669,38675,38671,38747,38748,38758,38808,38960,38968,38971,38967,38957,38969,38948,39184,39208,39198,39195,39201,39194,39405,39394,39409,39608,39612,39675,39661,39720,39825,40213,40227,40230,40232,40210,40219,40664,40660,40845,40860,20778,20767,20769,20786,21237,22158,22144,22160,22149,22151,22159,22741,22739,22737,22734,23344,23338,23332,23418,23607,23656,23996,23994,23997,23992,24171,24396,24509,25033,25026,25031,25062,25035,25138,25140,25806,25802,25816,25824,25840,25830,25836,25841,25826,25837,25986,25987,26329,26326,27264,27284,27268,27298,27292,27355,27299,27262,27287,27280,27296,27484,27566,27610,27656,28632,28657,28639,28640,28635,28644,28651,28655,28544,28652,28641,28649,28629,28654,28656,29159,29151,29166,29158,29157,29165,29164,29172,29152,29237,29254,29552,29554,29865,29872,29862,29864,30278,30274,30284,30442,30643,30634,30640,30636,30631,30637,30703,30967,30970,30964,30959,30977,31143,31146,31319,31423,31751,31757,31742,31735,31756,31712,31968,31964,31966,31970,31967,31961,31965,32302,32318,32326,32311,32306,32323,32299,32317,32305,32325,32321,32308,32313,32328,32309,32319,32303,32580,32755,32764,32881,32882,32880,32879,32883,33222,33219,33210,33218,33216,33215,33213,33225,33214,33256,33289,33393,34218,34180,34174,34204,34193,34196,34223,34203,34183,34216,34186,34407,34752,34769,34739,34770,34758,34731,34747,34746,34760,34763,35131,35126,35140,35128,35133,35244,35598,35607,35609,35611,35594,35616,35613,35588,35600,35905,35903,35955,36090,36093,36092,36088,36091,36264,36425,36427,36424,36426,36676,36670,36674,36677,36671,36991,36989,36996,36993,36994,36992,37177,37283,37278,37276,37709,37762,37672,37749,37706,37733,37707,37656,37758,37740,37723,37744,37722,37716,38346,38347,38348,38344,38342,38577,38584,38614,38684,38686,38816,38867,38982,39094,39221,39425,39423,39854,39851,39850,39853,40251,40255,40587,40655,40670,40668,40669,40667,40766,40779,21474,22165,22190,22745,22744,23352,24413,25059,25139,25844,25842,25854,25862,25850,25851,25847,26039,26332,26406,27315,27308,27331,27323,27320,27330,27310,27311,27487,27512,27567,28681,28683,28670,28678,28666,28689,28687,29179,29180,29182,29176,29559,29557,29863,29887,29973,30294,30296,30290,30653,30655,30651,30652,30990,31150,31329,31330,31328,31428,31429,31787,31783,31786,31774,31779,31777,31975,32340,32341,32350,32346,32353,32338,32345,32584,32761,32763,32887,32886,33229,33231,33290,34255,34217,34253,34256,34249,34224,34234,34233,34214,34799,34796,34802,34784,35206,35250,35316,35624,35641,35628,35627,35920,36101,36441,36451,36454,36452,36447,36437,36544,36681,36685,36999,36995,37000,37291,37292,37328,37780,37770,37782,37794,37811,37806,37804,37808,37784,37786,37783,38356,38358,38352,38357,38626,38620,38617,38619,38622,38692,38819,38822,38829,38905,38989,38991,38988,38990,38995,39098,39230,39231,39229,39214,39333,39438,39617,39683,39686,39759,39758,39757,39882,39881,39933,39880,39872,40273,40285,40288,40672,40725,40748,20787,22181,22750,22751,22754,23541,40848,24300,25074,25079,25078,25077,25856,25871,26336,26333,27365,27357,27354,27347,28699,28703,28712,28698,28701,28693,28696,29190,29197,29272,29346,29560,29562,29885,29898,29923,30087,30086,30303,30305,30663,31001,31153,31339,31337,31806,31807,31800,31805,31799,31808,32363,32365,32377,32361,32362,32645,32371,32694,32697,32696,33240,34281,34269,34282,34261,34276,34277,34295,34811,34821,34829,34809,34814,35168,35167,35158,35166,35649,35676,35672,35657,35674,35662,35663,35654,35673,36104,36106,36476,36466,36487,36470,36460,36474,36468,36692,36686,36781,37002,37003,37297,37294,37857,37841,37855,37827,37832,37852,37853,37846,37858,37837,37848,37860,37847,37864,38364,38580,38627,38698,38695,38753,38876,38907,39006,39000,39003,39100,39237,39241,39446,39449,39693,39912,39911,39894,39899,40329,40289,40306,40298,40300,40594,40599,40595,40628,21240,22184,22199,22198,22196,22204,22756,23360,23363,23421,23542,24009,25080,25082,25880,25876,25881,26342,26407,27372,28734,28720,28722,29200,29563,29903,30306,30309,31014,31018,31020,31019,31431,31478,31820,31811,31821,31983,31984,36782,32381,32380,32386,32588,32768,33242,33382,34299,34297,34321,34298,34310,34315,34311,34314,34836,34837,35172,35258,35320,35696,35692,35686,35695,35679,35691,36111,36109,36489,36481,36485,36482,37300,37323,37912,37891,37885,38369,38704,39108,39250,39249,39336,39467,39472,39479,39477,39955,39949,40569,40629,40680,40751,40799,40803,40801,20791,20792,22209,22208,22210,22804,23660,24013,25084,25086,25885,25884,26005,26345,27387,27396,27386,27570,28748,29211,29351,29910,29908,30313,30675,31824,32399,32396,32700,34327,34349,34330,34851,34850,34849,34847,35178,35180,35261,35700,35703,35709,36115,36490,36493,36491,36703,36783,37306,37934,37939,37941,37946,37944,37938,37931,38370,38712,38713,38706,38911,39015,39013,39255,39493,39491,39488,39486,39631,39764,39761,39981,39973,40367,40372,40386,40376,40605,40687,40729,40796,40806,40807,20796,20795,22216,22218,22217,23423,24020,24018,24398,25087,25892,27402,27489,28753,28760,29568,29924,30090,30318,30316,31155,31840,31839,32894,32893,33247,35186,35183,35324,35712,36118,36119,36497,36499,36705,37192,37956,37969,37970,38717,38718,38851,38849,39019,39253,39509,39501,39634,39706,40009,39985,39998,39995,40403,40407,40756,40812,40810,40852,22220,24022,25088,25891,25899,25898,26348,27408,29914,31434,31844,31843,31845,32403,32406,32404,33250,34360,34367,34865,35722,37008,37007,37987,37984,37988,38760,39023,39260,39514,39515,39511,39635,39636,39633,40020,40023,40022,40421,40607,40692,22225,22761,25900,28766,30321,30322,30679,32592,32648,34870,34873,34914,35731,35730,35734,33399,36123,37312,37994,38722,38728,38724,38854,39024,39519,39714,39768,40031,40441,40442,40572,40573,40711,40823,40818,24307,27414,28771,31852,31854,34875,35264,36513,37313,38002,38000,39025,39262,39638,39715,40652,28772,30682,35738,38007,38857,39522,39525,32412,35740,36522,37317,38013,38014,38012,40055,40056,40695,35924,38015,40474,29224,39530,39729,40475,40478,31858,9312,9313,9314,9315,9316,9317,9318,9319,9320,9321,9332,9333,9334,9335,9336,9337,9338,9339,9340,9341,8560,8561,8562,8563,8564,8565,8566,8567,8568,8569,20022,20031,20101,20128,20866,20886,20907,21241,21304,21353,21430,22794,23424,24027,12083,24191,24308,24400,24417,25908,26080,30098,30326,36789,38582,168,710,12541,12542,12445,12446,12291,20189,12293,12294,12295,12540,65339,65341,10045,12353,12354,12355,12356,12357,12358,12359,12360,12361,12362,12363,12364,12365,12366,12367,12368,12369,12370,12371,12372,12373,12374,12375,12376,12377,12378,12379,12380,12381,12382,12383,12384,12385,12386,12387,12388,12389,12390,12391,12392,12393,12394,12395,12396,12397,12398,12399,12400,12401,12402,12403,12404,12405,12406,12407,12408,12409,12410,12411,12412,12413,12414,12415,12416,12417,12418,12419,12420,12421,12422,12423,12424,12425,12426,12427,12428,12429,12430,12431,12432,12433,12434,12435,12449,12450,12451,12452,12453,12454,12455,12456,12457,12458,12459,12460,12461,12462,12463,12464,12465,12466,12467,12468,12469,12470,12471,12472,12473,12474,12475,12476,12477,12478,12479,12480,12481,12482,12483,12484,12485,12486,12487,12488,12489,12490,12491,12492,12493,12494,12495,12496,12497,12498,12499,12500,12501,12502,12503,12504,12505,12506,12507,12508,12509,12510,12511,12512,12513,12514,12515,12516,12517,12518,12519,12520,12521,12522,12523,12524,12525,12526,12527,12528,12529,12530,12531,12532,12533,12534,1040,1041,1042,1043,1044,1045,1025,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1105,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,8679,8632,8633,12751,131276,20058,131210,20994,17553,40880,20872,40881,161287,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,65506,65508,65287,65282,12849,8470,8481,12443,12444,11904,11908,11910,11911,11912,11914,11916,11917,11925,11932,11933,11941,11943,11946,11948,11950,11958,11964,11966,11974,11978,11980,11981,11983,11990,11991,11998,12003,null,null,null,643,592,603,596,629,339,248,331,650,618,20034,20060,20981,21274,21378,19975,19980,20039,20109,22231,64012,23662,24435,19983,20871,19982,20014,20115,20162,20169,20168,20888,21244,21356,21433,22304,22787,22828,23568,24063,26081,27571,27596,27668,29247,20017,20028,20200,20188,20201,20193,20189,20186,21004,21276,21324,22306,22307,22807,22831,23425,23428,23570,23611,23668,23667,24068,24192,24194,24521,25097,25168,27669,27702,27715,27711,27707,29358,29360,29578,31160,32906,38430,20238,20248,20268,20213,20244,20209,20224,20215,20232,20253,20226,20229,20258,20243,20228,20212,20242,20913,21011,21001,21008,21158,21282,21279,21325,21386,21511,22241,22239,22318,22314,22324,22844,22912,22908,22917,22907,22910,22903,22911,23382,23573,23589,23676,23674,23675,23678,24031,24181,24196,24322,24346,24436,24533,24532,24527,25180,25182,25188,25185,25190,25186,25177,25184,25178,25189,26095,26094,26430,26425,26424,26427,26426,26431,26428,26419,27672,27718,27730,27740,27727,27722,27732,27723,27724,28785,29278,29364,29365,29582,29994,30335,31349,32593,33400,33404,33408,33405,33407,34381,35198,37017,37015,37016,37019,37012,38434,38436,38432,38435,20310,20283,20322,20297,20307,20324,20286,20327,20306,20319,20289,20312,20269,20275,20287,20321,20879,20921,21020,21022,21025,21165,21166,21257,21347,21362,21390,21391,21552,21559,21546,21588,21573,21529,21532,21541,21528,21565,21583,21569,21544,21540,21575,22254,22247,22245,22337,22341,22348,22345,22347,22354,22790,22848,22950,22936,22944,22935,22926,22946,22928,22927,22951,22945,23438,23442,23592,23594,23693,23695,23688,23691,23689,23698,23690,23686,23699,23701,24032,24074,24078,24203,24201,24204,24200,24205,24325,24349,24440,24438,24530,24529,24528,24557,24552,24558,24563,24545,24548,24547,24570,24559,24567,24571,24576,24564,25146,25219,25228,25230,25231,25236,25223,25201,25211,25210,25200,25217,25224,25207,25213,25202,25204,25911,26096,26100,26099,26098,26101,26437,26439,26457,26453,26444,26440,26461,26445,26458,26443,27600,27673,27674,27768,27751,27755,27780,27787,27791,27761,27759,27753,27802,27757,27783,27797,27804,27750,27763,27749,27771,27790,28788,28794,29283,29375,29373,29379,29382,29377,29370,29381,29589,29591,29587,29588,29586,30010,30009,30100,30101,30337,31037,32820,32917,32921,32912,32914,32924,33424,33423,33413,33422,33425,33427,33418,33411,33412,35960,36809,36799,37023,37025,37029,37022,37031,37024,38448,38440,38447,38445,20019,20376,20348,20357,20349,20352,20359,20342,20340,20361,20356,20343,20300,20375,20330,20378,20345,20353,20344,20368,20380,20372,20382,20370,20354,20373,20331,20334,20894,20924,20926,21045,21042,21043,21062,21041,21180,21258,21259,21308,21394,21396,21639,21631,21633,21649,21634,21640,21611,21626,21630,21605,21612,21620,21606,21645,21615,21601,21600,21656,21603,21607,21604,22263,22265,22383,22386,22381,22379,22385,22384,22390,22400,22389,22395,22387,22388,22370,22376,22397,22796,22853,22965,22970,22991,22990,22962,22988,22977,22966,22972,22979,22998,22961,22973,22976,22984,22964,22983,23394,23397,23443,23445,23620,23623,23726,23716,23712,23733,23727,23720,23724,23711,23715,23725,23714,23722,23719,23709,23717,23734,23728,23718,24087,24084,24089,24360,24354,24355,24356,24404,24450,24446,24445,24542,24549,24621,24614,24601,24626,24587,24628,24586,24599,24627,24602,24606,24620,24610,24589,24592,24622,24595,24593,24588,24585,24604,25108,25149,25261,25268,25297,25278,25258,25270,25290,25262,25267,25263,25275,25257,25264,25272,25917,26024,26043,26121,26108,26116,26130,26120,26107,26115,26123,26125,26117,26109,26129,26128,26358,26378,26501,26476,26510,26514,26486,26491,26520,26502,26500,26484,26509,26508,26490,26527,26513,26521,26499,26493,26497,26488,26489,26516,27429,27520,27518,27614,27677,27795,27884,27883,27886,27865,27830,27860,27821,27879,27831,27856,27842,27834,27843,27846,27885,27890,27858,27869,27828,27786,27805,27776,27870,27840,27952,27853,27847,27824,27897,27855,27881,27857,28820,28824,28805,28819,28806,28804,28817,28822,28802,28826,28803,29290,29398,29387,29400,29385,29404,29394,29396,29402,29388,29393,29604,29601,29613,29606,29602,29600,29612,29597,29917,29928,30015,30016,30014,30092,30104,30383,30451,30449,30448,30453,30712,30716,30713,30715,30714,30711,31042,31039,31173,31352,31355,31483,31861,31997,32821,32911,32942,32931,32952,32949,32941,33312,33440,33472,33451,33434,33432,33435,33461,33447,33454,33468,33438,33466,33460,33448,33441,33449,33474,33444,33475,33462,33442,34416,34415,34413,34414,35926,36818,36811,36819,36813,36822,36821,36823,37042,37044,37039,37043,37040,38457,38461,38460,38458,38467,20429,20421,20435,20402,20425,20427,20417,20436,20444,20441,20411,20403,20443,20423,20438,20410,20416,20409,20460,21060,21065,21184,21186,21309,21372,21399,21398,21401,21400,21690,21665,21677,21669,21711,21699,33549,21687,21678,21718,21686,21701,21702,21664,21616,21692,21666,21694,21618,21726,21680,22453,22430,22431,22436,22412,22423,22429,22427,22420,22424,22415,22425,22437,22426,22421,22772,22797,22867,23009,23006,23022,23040,23025,23005,23034,23037,23036,23030,23012,23026,23031,23003,23017,23027,23029,23008,23038,23028,23021,23464,23628,23760,23768,23756,23767,23755,23771,23774,23770,23753,23751,23754,23766,23763,23764,23759,23752,23750,23758,23775,23800,24057,24097,24098,24099,24096,24100,24240,24228,24226,24219,24227,24229,24327,24366,24406,24454,24631,24633,24660,24690,24670,24645,24659,24647,24649,24667,24652,24640,24642,24671,24612,24644,24664,24678,24686,25154,25155,25295,25357,25355,25333,25358,25347,25323,25337,25359,25356,25336,25334,25344,25363,25364,25338,25365,25339,25328,25921,25923,26026,26047,26166,26145,26162,26165,26140,26150,26146,26163,26155,26170,26141,26164,26169,26158,26383,26384,26561,26610,26568,26554,26588,26555,26616,26584,26560,26551,26565,26603,26596,26591,26549,26573,26547,26615,26614,26606,26595,26562,26553,26574,26599,26608,26546,26620,26566,26605,26572,26542,26598,26587,26618,26569,26570,26563,26602,26571,27432,27522,27524,27574,27606,27608,27616,27680,27681,27944,27956,27949,27935,27964,27967,27922,27914,27866,27955,27908,27929,27962,27930,27921,27904,27933,27970,27905,27928,27959,27907,27919,27968,27911,27936,27948,27912,27938,27913,27920,28855,28831,28862,28849,28848,28833,28852,28853,28841,29249,29257,29258,29292,29296,29299,29294,29386,29412,29416,29419,29407,29418,29414,29411,29573,29644,29634,29640,29637,29625,29622,29621,29620,29675,29631,29639,29630,29635,29638,29624,29643,29932,29934,29998,30023,30024,30119,30122,30329,30404,30472,30467,30468,30469,30474,30455,30459,30458,30695,30696,30726,30737,30738,30725,30736,30735,30734,30729,30723,30739,31050,31052,31051,31045,31044,31189,31181,31183,31190,31182,31360,31358,31441,31488,31489,31866,31864,31865,31871,31872,31873,32003,32008,32001,32600,32657,32653,32702,32775,32782,32783,32788,32823,32984,32967,32992,32977,32968,32962,32976,32965,32995,32985,32988,32970,32981,32969,32975,32983,32998,32973,33279,33313,33428,33497,33534,33529,33543,33512,33536,33493,33594,33515,33494,33524,33516,33505,33522,33525,33548,33531,33526,33520,33514,33508,33504,33530,33523,33517,34423,34420,34428,34419,34881,34894,34919,34922,34921,35283,35332,35335,36210,36835,36833,36846,36832,37105,37053,37055,37077,37061,37054,37063,37067,37064,37332,37331,38484,38479,38481,38483,38474,38478,20510,20485,20487,20499,20514,20528,20507,20469,20468,20531,20535,20524,20470,20471,20503,20508,20512,20519,20533,20527,20529,20494,20826,20884,20883,20938,20932,20933,20936,20942,21089,21082,21074,21086,21087,21077,21090,21197,21262,21406,21798,21730,21783,21778,21735,21747,21732,21786,21759,21764,21768,21739,21777,21765,21745,21770,21755,21751,21752,21728,21774,21763,21771,22273,22274,22476,22578,22485,22482,22458,22470,22461,22460,22456,22454,22463,22471,22480,22457,22465,22798,22858,23065,23062,23085,23086,23061,23055,23063,23050,23070,23091,23404,23463,23469,23468,23555,23638,23636,23788,23807,23790,23793,23799,23808,23801,24105,24104,24232,24238,24234,24236,24371,24368,24423,24669,24666,24679,24641,24738,24712,24704,24722,24705,24733,24707,24725,24731,24727,24711,24732,24718,25113,25158,25330,25360,25430,25388,25412,25413,25398,25411,25572,25401,25419,25418,25404,25385,25409,25396,25432,25428,25433,25389,25415,25395,25434,25425,25400,25431,25408,25416,25930,25926,26054,26051,26052,26050,26186,26207,26183,26193,26386,26387,26655,26650,26697,26674,26675,26683,26699,26703,26646,26673,26652,26677,26667,26669,26671,26702,26692,26676,26653,26642,26644,26662,26664,26670,26701,26682,26661,26656,27436,27439,27437,27441,27444,27501,32898,27528,27622,27620,27624,27619,27618,27623,27685,28026,28003,28004,28022,27917,28001,28050,27992,28002,28013,28015,28049,28045,28143,28031,28038,27998,28007,28000,28055,28016,28028,27999,28034,28056,27951,28008,28043,28030,28032,28036,27926,28035,28027,28029,28021,28048,28892,28883,28881,28893,28875,32569,28898,28887,28882,28894,28896,28884,28877,28869,28870,28871,28890,28878,28897,29250,29304,29303,29302,29440,29434,29428,29438,29430,29427,29435,29441,29651,29657,29669,29654,29628,29671,29667,29673,29660,29650,29659,29652,29661,29658,29655,29656,29672,29918,29919,29940,29941,29985,30043,30047,30128,30145,30139,30148,30144,30143,30134,30138,30346,30409,30493,30491,30480,30483,30482,30499,30481,30485,30489,30490,30498,30503,30755,30764,30754,30773,30767,30760,30766,30763,30753,30761,30771,30762,30769,31060,31067,31055,31068,31059,31058,31057,31211,31212,31200,31214,31213,31210,31196,31198,31197,31366,31369,31365,31371,31372,31370,31367,31448,31504,31492,31507,31493,31503,31496,31498,31502,31497,31506,31876,31889,31882,31884,31880,31885,31877,32030,32029,32017,32014,32024,32022,32019,32031,32018,32015,32012,32604,32609,32606,32608,32605,32603,32662,32658,32707,32706,32704,32790,32830,32825,33018,33010,33017,33013,33025,33019,33024,33281,33327,33317,33587,33581,33604,33561,33617,33573,33622,33599,33601,33574,33564,33570,33602,33614,33563,33578,33544,33596,33613,33558,33572,33568,33591,33583,33577,33607,33605,33612,33619,33566,33580,33611,33575,33608,34387,34386,34466,34472,34454,34445,34449,34462,34439,34455,34438,34443,34458,34437,34469,34457,34465,34471,34453,34456,34446,34461,34448,34452,34883,34884,34925,34933,34934,34930,34944,34929,34943,34927,34947,34942,34932,34940,35346,35911,35927,35963,36004,36003,36214,36216,36277,36279,36278,36561,36563,36862,36853,36866,36863,36859,36868,36860,36854,37078,37088,37081,37082,37091,37087,37093,37080,37083,37079,37084,37092,37200,37198,37199,37333,37346,37338,38492,38495,38588,39139,39647,39727,20095,20592,20586,20577,20574,20576,20563,20555,20573,20594,20552,20557,20545,20571,20554,20578,20501,20549,20575,20585,20587,20579,20580,20550,20544,20590,20595,20567,20561,20944,21099,21101,21100,21102,21206,21203,21293,21404,21877,21878,21820,21837,21840,21812,21802,21841,21858,21814,21813,21808,21842,21829,21772,21810,21861,21838,21817,21832,21805,21819,21824,21835,22282,22279,22523,22548,22498,22518,22492,22516,22528,22509,22525,22536,22520,22539,22515,22479,22535,22510,22499,22514,22501,22508,22497,22542,22524,22544,22503,22529,22540,22513,22505,22512,22541,22532,22876,23136,23128,23125,23143,23134,23096,23093,23149,23120,23135,23141,23148,23123,23140,23127,23107,23133,23122,23108,23131,23112,23182,23102,23117,23097,23116,23152,23145,23111,23121,23126,23106,23132,23410,23406,23489,23488,23641,23838,23819,23837,23834,23840,23820,23848,23821,23846,23845,23823,23856,23826,23843,23839,23854,24126,24116,24241,24244,24249,24242,24243,24374,24376,24475,24470,24479,24714,24720,24710,24766,24752,24762,24787,24788,24783,24804,24793,24797,24776,24753,24795,24759,24778,24767,24771,24781,24768,25394,25445,25482,25474,25469,25533,25502,25517,25501,25495,25515,25486,25455,25479,25488,25454,25519,25461,25500,25453,25518,25468,25508,25403,25503,25464,25477,25473,25489,25485,25456,25939,26061,26213,26209,26203,26201,26204,26210,26392,26745,26759,26768,26780,26733,26734,26798,26795,26966,26735,26787,26796,26793,26741,26740,26802,26767,26743,26770,26748,26731,26738,26794,26752,26737,26750,26779,26774,26763,26784,26761,26788,26744,26747,26769,26764,26762,26749,27446,27443,27447,27448,27537,27535,27533,27534,27532,27690,28096,28075,28084,28083,28276,28076,28137,28130,28087,28150,28116,28160,28104,28128,28127,28118,28094,28133,28124,28125,28123,28148,28106,28093,28141,28144,28090,28117,28098,28111,28105,28112,28146,28115,28157,28119,28109,28131,28091,28922,28941,28919,28951,28916,28940,28912,28932,28915,28944,28924,28927,28934,28947,28928,28920,28918,28939,28930,28942,29310,29307,29308,29311,29469,29463,29447,29457,29464,29450,29448,29439,29455,29470,29576,29686,29688,29685,29700,29697,29693,29703,29696,29690,29692,29695,29708,29707,29684,29704,30052,30051,30158,30162,30159,30155,30156,30161,30160,30351,30345,30419,30521,30511,30509,30513,30514,30516,30515,30525,30501,30523,30517,30792,30802,30793,30797,30794,30796,30758,30789,30800,31076,31079,31081,31082,31075,31083,31073,31163,31226,31224,31222,31223,31375,31380,31376,31541,31559,31540,31525,31536,31522,31524,31539,31512,31530,31517,31537,31531,31533,31535,31538,31544,31514,31523,31892,31896,31894,31907,32053,32061,32056,32054,32058,32069,32044,32041,32065,32071,32062,32063,32074,32059,32040,32611,32661,32668,32669,32667,32714,32715,32717,32720,32721,32711,32719,32713,32799,32798,32795,32839,32835,32840,33048,33061,33049,33051,33069,33055,33068,33054,33057,33045,33063,33053,33058,33297,33336,33331,33338,33332,33330,33396,33680,33699,33704,33677,33658,33651,33700,33652,33679,33665,33685,33689,33653,33684,33705,33661,33667,33676,33693,33691,33706,33675,33662,33701,33711,33672,33687,33712,33663,33702,33671,33710,33654,33690,34393,34390,34495,34487,34498,34497,34501,34490,34480,34504,34489,34483,34488,34508,34484,34491,34492,34499,34493,34494,34898,34953,34965,34984,34978,34986,34970,34961,34977,34975,34968,34983,34969,34971,34967,34980,34988,34956,34963,34958,35202,35286,35289,35285,35376,35367,35372,35358,35897,35899,35932,35933,35965,36005,36221,36219,36217,36284,36290,36281,36287,36289,36568,36574,36573,36572,36567,36576,36577,36900,36875,36881,36892,36876,36897,37103,37098,37104,37108,37106,37107,37076,37099,37100,37097,37206,37208,37210,37203,37205,37356,37364,37361,37363,37368,37348,37369,37354,37355,37367,37352,37358,38266,38278,38280,38524,38509,38507,38513,38511,38591,38762,38916,39141,39319,20635,20629,20628,20638,20619,20643,20611,20620,20622,20637,20584,20636,20626,20610,20615,20831,20948,21266,21265,21412,21415,21905,21928,21925,21933,21879,22085,21922,21907,21896,21903,21941,21889,21923,21906,21924,21885,21900,21926,21887,21909,21921,21902,22284,22569,22583,22553,22558,22567,22563,22568,22517,22600,22565,22556,22555,22579,22591,22582,22574,22585,22584,22573,22572,22587,22881,23215,23188,23199,23162,23202,23198,23160,23206,23164,23205,23212,23189,23214,23095,23172,23178,23191,23171,23179,23209,23163,23165,23180,23196,23183,23187,23197,23530,23501,23499,23508,23505,23498,23502,23564,23600,23863,23875,23915,23873,23883,23871,23861,23889,23886,23893,23859,23866,23890,23869,23857,23897,23874,23865,23881,23864,23868,23858,23862,23872,23877,24132,24129,24408,24486,24485,24491,24777,24761,24780,24802,24782,24772,24852,24818,24842,24854,24837,24821,24851,24824,24828,24830,24769,24835,24856,24861,24848,24831,24836,24843,25162,25492,25521,25520,25550,25573,25576,25583,25539,25757,25587,25546,25568,25590,25557,25586,25589,25697,25567,25534,25565,25564,25540,25560,25555,25538,25543,25548,25547,25544,25584,25559,25561,25906,25959,25962,25956,25948,25960,25957,25996,26013,26014,26030,26064,26066,26236,26220,26235,26240,26225,26233,26218,26226,26369,26892,26835,26884,26844,26922,26860,26858,26865,26895,26838,26871,26859,26852,26870,26899,26896,26867,26849,26887,26828,26888,26992,26804,26897,26863,26822,26900,26872,26832,26877,26876,26856,26891,26890,26903,26830,26824,26845,26846,26854,26868,26833,26886,26836,26857,26901,26917,26823,27449,27451,27455,27452,27540,27543,27545,27541,27581,27632,27634,27635,27696,28156,28230,28231,28191,28233,28296,28220,28221,28229,28258,28203,28223,28225,28253,28275,28188,28211,28235,28224,28241,28219,28163,28206,28254,28264,28252,28257,28209,28200,28256,28273,28267,28217,28194,28208,28243,28261,28199,28280,28260,28279,28245,28281,28242,28262,28213,28214,28250,28960,28958,28975,28923,28974,28977,28963,28965,28962,28978,28959,28968,28986,28955,29259,29274,29320,29321,29318,29317,29323,29458,29451,29488,29474,29489,29491,29479,29490,29485,29478,29475,29493,29452,29742,29740,29744,29739,29718,29722,29729,29741,29745,29732,29731,29725,29737,29728,29746,29947,29999,30063,30060,30183,30170,30177,30182,30173,30175,30180,30167,30357,30354,30426,30534,30535,30532,30541,30533,30538,30542,30539,30540,30686,30700,30816,30820,30821,30812,30829,30833,30826,30830,30832,30825,30824,30814,30818,31092,31091,31090,31088,31234,31242,31235,31244,31236,31385,31462,31460,31562,31547,31556,31560,31564,31566,31552,31576,31557,31906,31902,31912,31905,32088,32111,32099,32083,32086,32103,32106,32079,32109,32092,32107,32082,32084,32105,32081,32095,32078,32574,32575,32613,32614,32674,32672,32673,32727,32849,32847,32848,33022,32980,33091,33098,33106,33103,33095,33085,33101,33082,33254,33262,33271,33272,33273,33284,33340,33341,33343,33397,33595,33743,33785,33827,33728,33768,33810,33767,33764,33788,33782,33808,33734,33736,33771,33763,33727,33793,33757,33765,33752,33791,33761,33739,33742,33750,33781,33737,33801,33807,33758,33809,33798,33730,33779,33749,33786,33735,33745,33770,33811,33731,33772,33774,33732,33787,33751,33762,33819,33755,33790,34520,34530,34534,34515,34531,34522,34538,34525,34539,34524,34540,34537,34519,34536,34513,34888,34902,34901,35002,35031,35001,35000,35008,35006,34998,35004,34999,35005,34994,35073,35017,35221,35224,35223,35293,35290,35291,35406,35405,35385,35417,35392,35415,35416,35396,35397,35410,35400,35409,35402,35404,35407,35935,35969,35968,36026,36030,36016,36025,36021,36228,36224,36233,36312,36307,36301,36295,36310,36316,36303,36309,36313,36296,36311,36293,36591,36599,36602,36601,36582,36590,36581,36597,36583,36584,36598,36587,36593,36588,36596,36585,36909,36916,36911,37126,37164,37124,37119,37116,37128,37113,37115,37121,37120,37127,37125,37123,37217,37220,37215,37218,37216,37377,37386,37413,37379,37402,37414,37391,37388,37376,37394,37375,37373,37382,37380,37415,37378,37404,37412,37401,37399,37381,37398,38267,38285,38284,38288,38535,38526,38536,38537,38531,38528,38594,38600,38595,38641,38640,38764,38768,38766,38919,39081,39147,40166,40697,20099,20100,20150,20669,20671,20678,20654,20676,20682,20660,20680,20674,20656,20673,20666,20657,20683,20681,20662,20664,20951,21114,21112,21115,21116,21955,21979,21964,21968,21963,21962,21981,21952,21972,21956,21993,21951,21970,21901,21967,21973,21986,21974,21960,22002,21965,21977,21954,22292,22611,22632,22628,22607,22605,22601,22639,22613,22606,22621,22617,22629,22619,22589,22627,22641,22780,23239,23236,23243,23226,23224,23217,23221,23216,23231,23240,23227,23238,23223,23232,23242,23220,23222,23245,23225,23184,23510,23512,23513,23583,23603,23921,23907,23882,23909,23922,23916,23902,23912,23911,23906,24048,24143,24142,24138,24141,24139,24261,24268,24262,24267,24263,24384,24495,24493,24823,24905,24906,24875,24901,24886,24882,24878,24902,24879,24911,24873,24896,25120,37224,25123,25125,25124,25541,25585,25579,25616,25618,25609,25632,25636,25651,25667,25631,25621,25624,25657,25655,25634,25635,25612,25638,25648,25640,25665,25653,25647,25610,25626,25664,25637,25639,25611,25575,25627,25646,25633,25614,25967,26002,26067,26246,26252,26261,26256,26251,26250,26265,26260,26232,26400,26982,26975,26936,26958,26978,26993,26943,26949,26986,26937,26946,26967,26969,27002,26952,26953,26933,26988,26931,26941,26981,26864,27000,26932,26985,26944,26991,26948,26998,26968,26945,26996,26956,26939,26955,26935,26972,26959,26961,26930,26962,26927,27003,26940,27462,27461,27459,27458,27464,27457,27547,64013,27643,27644,27641,27639,27640,28315,28374,28360,28303,28352,28319,28307,28308,28320,28337,28345,28358,28370,28349,28353,28318,28361,28343,28336,28365,28326,28367,28338,28350,28355,28380,28376,28313,28306,28302,28301,28324,28321,28351,28339,28368,28362,28311,28334,28323,28999,29012,29010,29027,29024,28993,29021,29026,29042,29048,29034,29025,28994,29016,28995,29003,29040,29023,29008,29011,28996,29005,29018,29263,29325,29324,29329,29328,29326,29500,29506,29499,29498,29504,29514,29513,29764,29770,29771,29778,29777,29783,29760,29775,29776,29774,29762,29766,29773,29780,29921,29951,29950,29949,29981,30073,30071,27011,30191,30223,30211,30199,30206,30204,30201,30200,30224,30203,30198,30189,30197,30205,30361,30389,30429,30549,30559,30560,30546,30550,30554,30569,30567,30548,30553,30573,30688,30855,30874,30868,30863,30852,30869,30853,30854,30881,30851,30841,30873,30848,30870,30843,31100,31106,31101,31097,31249,31256,31257,31250,31255,31253,31266,31251,31259,31248,31395,31394,31390,31467,31590,31588,31597,31604,31593,31602,31589,31603,31601,31600,31585,31608,31606,31587,31922,31924,31919,32136,32134,32128,32141,32127,32133,32122,32142,32123,32131,32124,32140,32148,32132,32125,32146,32621,32619,32615,32616,32620,32678,32677,32679,32731,32732,32801,33124,33120,33143,33116,33129,33115,33122,33138,26401,33118,33142,33127,33135,33092,33121,33309,33353,33348,33344,33346,33349,34033,33855,33878,33910,33913,33935,33933,33893,33873,33856,33926,33895,33840,33869,33917,33882,33881,33908,33907,33885,34055,33886,33847,33850,33844,33914,33859,33912,33842,33861,33833,33753,33867,33839,33858,33837,33887,33904,33849,33870,33868,33874,33903,33989,33934,33851,33863,33846,33843,33896,33918,33860,33835,33888,33876,33902,33872,34571,34564,34551,34572,34554,34518,34549,34637,34552,34574,34569,34561,34550,34573,34565,35030,35019,35021,35022,35038,35035,35034,35020,35024,35205,35227,35295,35301,35300,35297,35296,35298,35292,35302,35446,35462,35455,35425,35391,35447,35458,35460,35445,35459,35457,35444,35450,35900,35915,35914,35941,35940,35942,35974,35972,35973,36044,36200,36201,36241,36236,36238,36239,36237,36243,36244,36240,36242,36336,36320,36332,36337,36334,36304,36329,36323,36322,36327,36338,36331,36340,36614,36607,36609,36608,36613,36615,36616,36610,36619,36946,36927,36932,36937,36925,37136,37133,37135,37137,37142,37140,37131,37134,37230,37231,37448,37458,37424,37434,37478,37427,37477,37470,37507,37422,37450,37446,37485,37484,37455,37472,37479,37487,37430,37473,37488,37425,37460,37475,37456,37490,37454,37459,37452,37462,37426,38303,38300,38302,38299,38546,38547,38545,38551,38606,38650,38653,38648,38645,38771,38775,38776,38770,38927,38925,38926,39084,39158,39161,39343,39346,39344,39349,39597,39595,39771,40170,40173,40167,40576,40701,20710,20692,20695,20712,20723,20699,20714,20701,20708,20691,20716,20720,20719,20707,20704,20952,21120,21121,21225,21227,21296,21420,22055,22037,22028,22034,22012,22031,22044,22017,22035,22018,22010,22045,22020,22015,22009,22665,22652,22672,22680,22662,22657,22655,22644,22667,22650,22663,22673,22670,22646,22658,22664,22651,22676,22671,22782,22891,23260,23278,23269,23253,23274,23258,23277,23275,23283,23266,23264,23259,23276,23262,23261,23257,23272,23263,23415,23520,23523,23651,23938,23936,23933,23942,23930,23937,23927,23946,23945,23944,23934,23932,23949,23929,23935,24152,24153,24147,24280,24273,24279,24270,24284,24277,24281,24274,24276,24388,24387,24431,24502,24876,24872,24897,24926,24945,24947,24914,24915,24946,24940,24960,24948,24916,24954,24923,24933,24891,24938,24929,24918,25129,25127,25131,25643,25677,25691,25693,25716,25718,25714,25715,25725,25717,25702,25766,25678,25730,25694,25692,25675,25683,25696,25680,25727,25663,25708,25707,25689,25701,25719,25971,26016,26273,26272,26271,26373,26372,26402,27057,27062,27081,27040,27086,27030,27056,27052,27068,27025,27033,27022,27047,27021,27049,27070,27055,27071,27076,27069,27044,27092,27065,27082,27034,27087,27059,27027,27050,27041,27038,27097,27031,27024,27074,27061,27045,27078,27466,27469,27467,27550,27551,27552,27587,27588,27646,28366,28405,28401,28419,28453,28408,28471,28411,28462,28425,28494,28441,28442,28455,28440,28475,28434,28397,28426,28470,28531,28409,28398,28461,28480,28464,28476,28469,28395,28423,28430,28483,28421,28413,28406,28473,28444,28412,28474,28447,28429,28446,28424,28449,29063,29072,29065,29056,29061,29058,29071,29051,29062,29057,29079,29252,29267,29335,29333,29331,29507,29517,29521,29516,29794,29811,29809,29813,29810,29799,29806,29952,29954,29955,30077,30096,30230,30216,30220,30229,30225,30218,30228,30392,30593,30588,30597,30594,30574,30592,30575,30590,30595,30898,30890,30900,30893,30888,30846,30891,30878,30885,30880,30892,30882,30884,31128,31114,31115,31126,31125,31124,31123,31127,31112,31122,31120,31275,31306,31280,31279,31272,31270,31400,31403,31404,31470,31624,31644,31626,31633,31632,31638,31629,31628,31643,31630,31621,31640,21124,31641,31652,31618,31931,31935,31932,31930,32167,32183,32194,32163,32170,32193,32192,32197,32157,32206,32196,32198,32203,32204,32175,32185,32150,32188,32159,32166,32174,32169,32161,32201,32627,32738,32739,32741,32734,32804,32861,32860,33161,33158,33155,33159,33165,33164,33163,33301,33943,33956,33953,33951,33978,33998,33986,33964,33966,33963,33977,33972,33985,33997,33962,33946,33969,34000,33949,33959,33979,33954,33940,33991,33996,33947,33961,33967,33960,34006,33944,33974,33999,33952,34007,34004,34002,34011,33968,33937,34401,34611,34595,34600,34667,34624,34606,34590,34593,34585,34587,34627,34604,34625,34622,34630,34592,34610,34602,34605,34620,34578,34618,34609,34613,34626,34598,34599,34616,34596,34586,34608,34577,35063,35047,35057,35058,35066,35070,35054,35068,35062,35067,35056,35052,35051,35229,35233,35231,35230,35305,35307,35304,35499,35481,35467,35474,35471,35478,35901,35944,35945,36053,36047,36055,36246,36361,36354,36351,36365,36349,36362,36355,36359,36358,36357,36350,36352,36356,36624,36625,36622,36621,37155,37148,37152,37154,37151,37149,37146,37156,37153,37147,37242,37234,37241,37235,37541,37540,37494,37531,37498,37536,37524,37546,37517,37542,37530,37547,37497,37527,37503,37539,37614,37518,37506,37525,37538,37501,37512,37537,37514,37510,37516,37529,37543,37502,37511,37545,37533,37515,37421,38558,38561,38655,38744,38781,38778,38782,38787,38784,38786,38779,38788,38785,38783,38862,38861,38934,39085,39086,39170,39168,39175,39325,39324,39363,39353,39355,39354,39362,39357,39367,39601,39651,39655,39742,39743,39776,39777,39775,40177,40178,40181,40615,20735,20739,20784,20728,20742,20743,20726,20734,20747,20748,20733,20746,21131,21132,21233,21231,22088,22082,22092,22069,22081,22090,22089,22086,22104,22106,22080,22067,22077,22060,22078,22072,22058,22074,22298,22699,22685,22705,22688,22691,22703,22700,22693,22689,22783,23295,23284,23293,23287,23286,23299,23288,23298,23289,23297,23303,23301,23311,23655,23961,23959,23967,23954,23970,23955,23957,23968,23964,23969,23962,23966,24169,24157,24160,24156,32243,24283,24286,24289,24393,24498,24971,24963,24953,25009,25008,24994,24969,24987,24979,25007,25005,24991,24978,25002,24993,24973,24934,25011,25133,25710,25712,25750,25760,25733,25751,25756,25743,25739,25738,25740,25763,25759,25704,25777,25752,25974,25978,25977,25979,26034,26035,26293,26288,26281,26290,26295,26282,26287,27136,27142,27159,27109,27128,27157,27121,27108,27168,27135,27116,27106,27163,27165,27134,27175,27122,27118,27156,27127,27111,27200,27144,27110,27131,27149,27132,27115,27145,27140,27160,27173,27151,27126,27174,27143,27124,27158,27473,27557,27555,27554,27558,27649,27648,27647,27650,28481,28454,28542,28551,28614,28562,28557,28553,28556,28514,28495,28549,28506,28566,28534,28524,28546,28501,28530,28498,28496,28503,28564,28563,28509,28416,28513,28523,28541,28519,28560,28499,28555,28521,28543,28565,28515,28535,28522,28539,29106,29103,29083,29104,29088,29082,29097,29109,29085,29093,29086,29092,29089,29098,29084,29095,29107,29336,29338,29528,29522,29534,29535,29536,29533,29531,29537,29530,29529,29538,29831,29833,29834,29830,29825,29821,29829,29832,29820,29817,29960,29959,30078,30245,30238,30233,30237,30236,30243,30234,30248,30235,30364,30365,30366,30363,30605,30607,30601,30600,30925,30907,30927,30924,30929,30926,30932,30920,30915,30916,30921,31130,31137,31136,31132,31138,31131,27510,31289,31410,31412,31411,31671,31691,31678,31660,31694,31663,31673,31690,31669,31941,31944,31948,31947,32247,32219,32234,32231,32215,32225,32259,32250,32230,32246,32241,32240,32238,32223,32630,32684,32688,32685,32749,32747,32746,32748,32742,32744,32868,32871,33187,33183,33182,33173,33186,33177,33175,33302,33359,33363,33362,33360,33358,33361,34084,34107,34063,34048,34089,34062,34057,34061,34079,34058,34087,34076,34043,34091,34042,34056,34060,34036,34090,34034,34069,34039,34027,34035,34044,34066,34026,34025,34070,34046,34088,34077,34094,34050,34045,34078,34038,34097,34086,34023,34024,34032,34031,34041,34072,34080,34096,34059,34073,34095,34402,34646,34659,34660,34679,34785,34675,34648,34644,34651,34642,34657,34650,34641,34654,34669,34666,34640,34638,34655,34653,34671,34668,34682,34670,34652,34661,34639,34683,34677,34658,34663,34665,34906,35077,35084,35092,35083,35095,35096,35097,35078,35094,35089,35086,35081,35234,35236,35235,35309,35312,35308,35535,35526,35512,35539,35537,35540,35541,35515,35543,35518,35520,35525,35544,35523,35514,35517,35545,35902,35917,35983,36069,36063,36057,36072,36058,36061,36071,36256,36252,36257,36251,36384,36387,36389,36388,36398,36373,36379,36374,36369,36377,36390,36391,36372,36370,36376,36371,36380,36375,36378,36652,36644,36632,36634,36640,36643,36630,36631,36979,36976,36975,36967,36971,37167,37163,37161,37162,37170,37158,37166,37253,37254,37258,37249,37250,37252,37248,37584,37571,37572,37568,37593,37558,37583,37617,37599,37592,37609,37591,37597,37580,37615,37570,37608,37578,37576,37582,37606,37581,37589,37577,37600,37598,37607,37585,37587,37557,37601,37574,37556,38268,38316,38315,38318,38320,38564,38562,38611,38661,38664,38658,38746,38794,38798,38792,38864,38863,38942,38941,38950,38953,38952,38944,38939,38951,39090,39176,39162,39185,39188,39190,39191,39189,39388,39373,39375,39379,39380,39374,39369,39382,39384,39371,39383,39372,39603,39660,39659,39667,39666,39665,39750,39747,39783,39796,39793,39782,39798,39797,39792,39784,39780,39788,40188,40186,40189,40191,40183,40199,40192,40185,40187,40200,40197,40196,40579,40659,40719,40720,20764,20755,20759,20762,20753,20958,21300,21473,22128,22112,22126,22131,22118,22115,22125,22130,22110,22135,22300,22299,22728,22717,22729,22719,22714,22722,22716,22726,23319,23321,23323,23329,23316,23315,23312,23318,23336,23322,23328,23326,23535,23980,23985,23977,23975,23989,23984,23982,23978,23976,23986,23981,23983,23988,24167,24168,24166,24175,24297,24295,24294,24296,24293,24395,24508,24989,25000,24982,25029,25012,25030,25025,25036,25018,25023,25016,24972,25815,25814,25808,25807,25801,25789,25737,25795,25819,25843,25817,25907,25983,25980,26018,26312,26302,26304,26314,26315,26319,26301,26299,26298,26316,26403,27188,27238,27209,27239,27186,27240,27198,27229,27245,27254,27227,27217,27176,27226,27195,27199,27201,27242,27236,27216,27215,27220,27247,27241,27232,27196,27230,27222,27221,27213,27214,27206,27477,27476,27478,27559,27562,27563,27592,27591,27652,27651,27654,28589,28619,28579,28615,28604,28622,28616,28510,28612,28605,28574,28618,28584,28676,28581,28590,28602,28588,28586,28623,28607,28600,28578,28617,28587,28621,28591,28594,28592,29125,29122,29119,29112,29142,29120,29121,29131,29140,29130,29127,29135,29117,29144,29116,29126,29146,29147,29341,29342,29545,29542,29543,29548,29541,29547,29546,29823,29850,29856,29844,29842,29845,29857,29963,30080,30255,30253,30257,30269,30259,30268,30261,30258,30256,30395,30438,30618,30621,30625,30620,30619,30626,30627,30613,30617,30615,30941,30953,30949,30954,30942,30947,30939,30945,30946,30957,30943,30944,31140,31300,31304,31303,31414,31416,31413,31409,31415,31710,31715,31719,31709,31701,31717,31706,31720,31737,31700,31722,31714,31708,31723,31704,31711,31954,31956,31959,31952,31953,32274,32289,32279,32268,32287,32288,32275,32270,32284,32277,32282,32290,32267,32271,32278,32269,32276,32293,32292,32579,32635,32636,32634,32689,32751,32810,32809,32876,33201,33190,33198,33209,33205,33195,33200,33196,33204,33202,33207,33191,33266,33365,33366,33367,34134,34117,34155,34125,34131,34145,34136,34112,34118,34148,34113,34146,34116,34129,34119,34147,34110,34139,34161,34126,34158,34165,34133,34151,34144,34188,34150,34141,34132,34149,34156,34403,34405,34404,34715,34703,34711,34707,34706,34696,34689,34710,34712,34681,34695,34723,34693,34704,34705,34717,34692,34708,34716,34714,34697,35102,35110,35120,35117,35118,35111,35121,35106,35113,35107,35119,35116,35103,35313,35552,35554,35570,35572,35573,35549,35604,35556,35551,35568,35528,35550,35553,35560,35583,35567,35579,35985,35986,35984,36085,36078,36081,36080,36083,36204,36206,36261,36263,36403,36414,36408,36416,36421,36406,36412,36413,36417,36400,36415,36541,36662,36654,36661,36658,36665,36663,36660,36982,36985,36987,36998,37114,37171,37173,37174,37267,37264,37265,37261,37263,37671,37662,37640,37663,37638,37647,37754,37688,37692,37659,37667,37650,37633,37702,37677,37646,37645,37579,37661,37626,37669,37651,37625,37623,37684,37634,37668,37631,37673,37689,37685,37674,37652,37644,37643,37630,37641,37632,37627,37654,38332,38349,38334,38329,38330,38326,38335,38325,38333,38569,38612,38667,38674,38672,38809,38807,38804,38896,38904,38965,38959,38962,39204,39199,39207,39209,39326,39406,39404,39397,39396,39408,39395,39402,39401,39399,39609,39615,39604,39611,39670,39674,39673,39671,39731,39808,39813,39815,39804,39806,39803,39810,39827,39826,39824,39802,39829,39805,39816,40229,40215,40224,40222,40212,40233,40221,40216,40226,40208,40217,40223,40584,40582,40583,40622,40621,40661,40662,40698,40722,40765,20774,20773,20770,20772,20768,20777,21236,22163,22156,22157,22150,22148,22147,22142,22146,22143,22145,22742,22740,22735,22738,23341,23333,23346,23331,23340,23335,23334,23343,23342,23419,23537,23538,23991,24172,24170,24510,24507,25027,25013,25020,25063,25056,25061,25060,25064,25054,25839,25833,25827,25835,25828,25832,25985,25984,26038,26074,26322,27277,27286,27265,27301,27273,27295,27291,27297,27294,27271,27283,27278,27285,27267,27304,27300,27281,27263,27302,27290,27269,27276,27282,27483,27565,27657,28620,28585,28660,28628,28643,28636,28653,28647,28646,28638,28658,28637,28642,28648,29153,29169,29160,29170,29156,29168,29154,29555,29550,29551,29847,29874,29867,29840,29866,29869,29873,29861,29871,29968,29969,29970,29967,30084,30275,30280,30281,30279,30372,30441,30645,30635,30642,30647,30646,30644,30641,30632,30704,30963,30973,30978,30971,30972,30962,30981,30969,30974,30980,31147,31144,31324,31323,31318,31320,31316,31322,31422,31424,31425,31749,31759,31730,31744,31743,31739,31758,31732,31755,31731,31746,31753,31747,31745,31736,31741,31750,31728,31729,31760,31754,31976,32301,32316,32322,32307,38984,32312,32298,32329,32320,32327,32297,32332,32304,32315,32310,32324,32314,32581,32639,32638,32637,32756,32754,32812,33211,33220,33228,33226,33221,33223,33212,33257,33371,33370,33372,34179,34176,34191,34215,34197,34208,34187,34211,34171,34212,34202,34206,34167,34172,34185,34209,34170,34168,34135,34190,34198,34182,34189,34201,34205,34177,34210,34178,34184,34181,34169,34166,34200,34192,34207,34408,34750,34730,34733,34757,34736,34732,34745,34741,34748,34734,34761,34755,34754,34764,34743,34735,34756,34762,34740,34742,34751,34744,34749,34782,34738,35125,35123,35132,35134,35137,35154,35127,35138,35245,35247,35246,35314,35315,35614,35608,35606,35601,35589,35595,35618,35599,35602,35605,35591,35597,35592,35590,35612,35603,35610,35919,35952,35954,35953,35951,35989,35988,36089,36207,36430,36429,36435,36432,36428,36423,36675,36672,36997,36990,37176,37274,37282,37275,37273,37279,37281,37277,37280,37793,37763,37807,37732,37718,37703,37756,37720,37724,37750,37705,37712,37713,37728,37741,37775,37708,37738,37753,37719,37717,37714,37711,37745,37751,37755,37729,37726,37731,37735,37760,37710,37721,38343,38336,38345,38339,38341,38327,38574,38576,38572,38688,38687,38680,38685,38681,38810,38817,38812,38814,38813,38869,38868,38897,38977,38980,38986,38985,38981,38979,39205,39211,39212,39210,39219,39218,39215,39213,39217,39216,39320,39331,39329,39426,39418,39412,39415,39417,39416,39414,39419,39421,39422,39420,39427,39614,39678,39677,39681,39676,39752,39834,39848,39838,39835,39846,39841,39845,39844,39814,39842,39840,39855,40243,40257,40295,40246,40238,40239,40241,40248,40240,40261,40258,40259,40254,40247,40256,40253,32757,40237,40586,40585,40589,40624,40648,40666,40699,40703,40740,40739,40738,40788,40864,20785,20781,20782,22168,22172,22167,22170,22173,22169,22896,23356,23657,23658,24000,24173,24174,25048,25055,25069,25070,25073,25066,25072,25067,25046,25065,25855,25860,25853,25848,25857,25859,25852,26004,26075,26330,26331,26328,27333,27321,27325,27361,27334,27322,27318,27319,27335,27316,27309,27486,27593,27659,28679,28684,28685,28673,28677,28692,28686,28671,28672,28667,28710,28668,28663,28682,29185,29183,29177,29187,29181,29558,29880,29888,29877,29889,29886,29878,29883,29890,29972,29971,30300,30308,30297,30288,30291,30295,30298,30374,30397,30444,30658,30650,30975,30988,30995,30996,30985,30992,30994,30993,31149,31148,31327,31772,31785,31769,31776,31775,31789,31773,31782,31784,31778,31781,31792,32348,32336,32342,32355,32344,32354,32351,32337,32352,32343,32339,32693,32691,32759,32760,32885,33233,33234,33232,33375,33374,34228,34246,34240,34243,34242,34227,34229,34237,34247,34244,34239,34251,34254,34248,34245,34225,34230,34258,34340,34232,34231,34238,34409,34791,34790,34786,34779,34795,34794,34789,34783,34803,34788,34772,34780,34771,34797,34776,34787,34724,34775,34777,34817,34804,34792,34781,35155,35147,35151,35148,35142,35152,35153,35145,35626,35623,35619,35635,35632,35637,35655,35631,35644,35646,35633,35621,35639,35622,35638,35630,35620,35643,35645,35642,35906,35957,35993,35992,35991,36094,36100,36098,36096,36444,36450,36448,36439,36438,36446,36453,36455,36443,36442,36449,36445,36457,36436,36678,36679,36680,36683,37160,37178,37179,37182,37288,37285,37287,37295,37290,37813,37772,37778,37815,37787,37789,37769,37799,37774,37802,37790,37798,37781,37768,37785,37791,37773,37809,37777,37810,37796,37800,37812,37795,37797,38354,38355,38353,38579,38615,38618,24002,38623,38616,38621,38691,38690,38693,38828,38830,38824,38827,38820,38826,38818,38821,38871,38873,38870,38872,38906,38992,38993,38994,39096,39233,39228,39226,39439,39435,39433,39437,39428,39441,39434,39429,39431,39430,39616,39644,39688,39684,39685,39721,39733,39754,39756,39755,39879,39878,39875,39871,39873,39861,39864,39891,39862,39876,39865,39869,40284,40275,40271,40266,40283,40267,40281,40278,40268,40279,40274,40276,40287,40280,40282,40590,40588,40671,40705,40704,40726,40741,40747,40746,40745,40744,40780,40789,20788,20789,21142,21239,21428,22187,22189,22182,22183,22186,22188,22746,22749,22747,22802,23357,23358,23359,24003,24176,24511,25083,25863,25872,25869,25865,25868,25870,25988,26078,26077,26334,27367,27360,27340,27345,27353,27339,27359,27356,27344,27371,27343,27341,27358,27488,27568,27660,28697,28711,28704,28694,28715,28705,28706,28707,28713,28695,28708,28700,28714,29196,29194,29191,29186,29189,29349,29350,29348,29347,29345,29899,29893,29879,29891,29974,30304,30665,30666,30660,30705,31005,31003,31009,31004,30999,31006,31152,31335,31336,31795,31804,31801,31788,31803,31980,31978,32374,32373,32376,32368,32375,32367,32378,32370,32372,32360,32587,32586,32643,32646,32695,32765,32766,32888,33239,33237,33380,33377,33379,34283,34289,34285,34265,34273,34280,34266,34263,34284,34290,34296,34264,34271,34275,34268,34257,34288,34278,34287,34270,34274,34816,34810,34819,34806,34807,34825,34828,34827,34822,34812,34824,34815,34826,34818,35170,35162,35163,35159,35169,35164,35160,35165,35161,35208,35255,35254,35318,35664,35656,35658,35648,35667,35670,35668,35659,35669,35665,35650,35666,35671,35907,35959,35958,35994,36102,36103,36105,36268,36266,36269,36267,36461,36472,36467,36458,36463,36475,36546,36690,36689,36687,36688,36691,36788,37184,37183,37296,37293,37854,37831,37839,37826,37850,37840,37881,37868,37836,37849,37801,37862,37834,37844,37870,37859,37845,37828,37838,37824,37842,37863,38269,38362,38363,38625,38697,38699,38700,38696,38694,38835,38839,38838,38877,38878,38879,39004,39001,39005,38999,39103,39101,39099,39102,39240,39239,39235,39334,39335,39450,39445,39461,39453,39460,39451,39458,39456,39463,39459,39454,39452,39444,39618,39691,39690,39694,39692,39735,39914,39915,39904,39902,39908,39910,39906,39920,39892,39895,39916,39900,39897,39909,39893,39905,39898,40311,40321,40330,40324,40328,40305,40320,40312,40326,40331,40332,40317,40299,40308,40309,40304,40297,40325,40307,40315,40322,40303,40313,40319,40327,40296,40596,40593,40640,40700,40749,40768,40769,40781,40790,40791,40792,21303,22194,22197,22195,22755,23365,24006,24007,24302,24303,24512,24513,25081,25879,25878,25877,25875,26079,26344,26339,26340,27379,27376,27370,27368,27385,27377,27374,27375,28732,28725,28719,28727,28724,28721,28738,28728,28735,28730,28729,28736,28731,28723,28737,29203,29204,29352,29565,29564,29882,30379,30378,30398,30445,30668,30670,30671,30669,30706,31013,31011,31015,31016,31012,31017,31154,31342,31340,31341,31479,31817,31816,31818,31815,31813,31982,32379,32382,32385,32384,32698,32767,32889,33243,33241,33291,33384,33385,34338,34303,34305,34302,34331,34304,34294,34308,34313,34309,34316,34301,34841,34832,34833,34839,34835,34838,35171,35174,35257,35319,35680,35690,35677,35688,35683,35685,35687,35693,36270,36486,36488,36484,36697,36694,36695,36693,36696,36698,37005,37187,37185,37303,37301,37298,37299,37899,37907,37883,37920,37903,37908,37886,37909,37904,37928,37913,37901,37877,37888,37879,37895,37902,37910,37906,37882,37897,37880,37898,37887,37884,37900,37878,37905,37894,38366,38368,38367,38702,38703,38841,38843,38909,38910,39008,39010,39011,39007,39105,39106,39248,39246,39257,39244,39243,39251,39474,39476,39473,39468,39466,39478,39465,39470,39480,39469,39623,39626,39622,39696,39698,39697,39947,39944,39927,39941,39954,39928,40000,39943,39950,39942,39959,39956,39945,40351,40345,40356,40349,40338,40344,40336,40347,40352,40340,40348,40362,40343,40353,40346,40354,40360,40350,40355,40383,40361,40342,40358,40359,40601,40603,40602,40677,40676,40679,40678,40752,40750,40795,40800,40798,40797,40793,40849,20794,20793,21144,21143,22211,22205,22206,23368,23367,24011,24015,24305,25085,25883,27394,27388,27395,27384,27392,28739,28740,28746,28744,28745,28741,28742,29213,29210,29209,29566,29975,30314,30672,31021,31025,31023,31828,31827,31986,32394,32391,32392,32395,32390,32397,32589,32699,32816,33245,34328,34346,34342,34335,34339,34332,34329,34343,34350,34337,34336,34345,34334,34341,34857,34845,34843,34848,34852,34844,34859,34890,35181,35177,35182,35179,35322,35705,35704,35653,35706,35707,36112,36116,36271,36494,36492,36702,36699,36701,37190,37188,37189,37305,37951,37947,37942,37929,37949,37948,37936,37945,37930,37943,37932,37952,37937,38373,38372,38371,38709,38714,38847,38881,39012,39113,39110,39104,39256,39254,39481,39485,39494,39492,39490,39489,39482,39487,39629,39701,39703,39704,39702,39738,39762,39979,39965,39964,39980,39971,39976,39977,39972,39969,40375,40374,40380,40385,40391,40394,40399,40382,40389,40387,40379,40373,40398,40377,40378,40364,40392,40369,40365,40396,40371,40397,40370,40570,40604,40683,40686,40685,40731,40728,40730,40753,40782,40805,40804,40850,20153,22214,22213,22219,22897,23371,23372,24021,24017,24306,25889,25888,25894,25890,27403,27400,27401,27661,28757,28758,28759,28754,29214,29215,29353,29567,29912,29909,29913,29911,30317,30381,31029,31156,31344,31345,31831,31836,31833,31835,31834,31988,31985,32401,32591,32647,33246,33387,34356,34357,34355,34348,34354,34358,34860,34856,34854,34858,34853,35185,35263,35262,35323,35710,35716,35714,35718,35717,35711,36117,36501,36500,36506,36498,36496,36502,36503,36704,36706,37191,37964,37968,37962,37963,37967,37959,37957,37960,37961,37958,38719,38883,39018,39017,39115,39252,39259,39502,39507,39508,39500,39503,39496,39498,39497,39506,39504,39632,39705,39723,39739,39766,39765,40006,40008,39999,40004,39993,39987,40001,39996,39991,39988,39986,39997,39990,40411,40402,40414,40410,40395,40400,40412,40401,40415,40425,40409,40408,40406,40437,40405,40413,40630,40688,40757,40755,40754,40770,40811,40853,40866,20797,21145,22760,22759,22898,23373,24024,34863,24399,25089,25091,25092,25897,25893,26006,26347,27409,27410,27407,27594,28763,28762,29218,29570,29569,29571,30320,30676,31847,31846,32405,33388,34362,34368,34361,34364,34353,34363,34366,34864,34866,34862,34867,35190,35188,35187,35326,35724,35726,35723,35720,35909,36121,36504,36708,36707,37308,37986,37973,37981,37975,37982,38852,38853,38912,39510,39513,39710,39711,39712,40018,40024,40016,40010,40013,40011,40021,40025,40012,40014,40443,40439,40431,40419,40427,40440,40420,40438,40417,40430,40422,40434,40432,40418,40428,40436,40435,40424,40429,40642,40656,40690,40691,40710,40732,40760,40759,40758,40771,40783,40817,40816,40814,40815,22227,22221,23374,23661,25901,26349,26350,27411,28767,28769,28765,28768,29219,29915,29925,30677,31032,31159,31158,31850,32407,32649,33389,34371,34872,34871,34869,34891,35732,35733,36510,36511,36512,36509,37310,37309,37314,37995,37992,37993,38629,38726,38723,38727,38855,38885,39518,39637,39769,40035,40039,40038,40034,40030,40032,40450,40446,40455,40451,40454,40453,40448,40449,40457,40447,40445,40452,40608,40734,40774,40820,40821,40822,22228,25902,26040,27416,27417,27415,27418,28770,29222,29354,30680,30681,31033,31849,31851,31990,32410,32408,32411,32409,33248,33249,34374,34375,34376,35193,35194,35196,35195,35327,35736,35737,36517,36516,36515,37998,37997,37999,38001,38003,38729,39026,39263,40040,40046,40045,40459,40461,40464,40463,40466,40465,40609,40693,40713,40775,40824,40827,40826,40825,22302,28774,31855,34876,36274,36518,37315,38004,38008,38006,38005,39520,40052,40051,40049,40053,40468,40467,40694,40714,40868,28776,28773,31991,34410,34878,34877,34879,35742,35996,36521,36553,38731,39027,39028,39116,39265,39339,39524,39526,39527,39716,40469,40471,40776,25095,27422,29223,34380,36520,38018,38016,38017,39529,39528,39726,40473,29225,34379,35743,38019,40057,40631,30325,39531,40058,40477,28777,28778,40612,40830,40777,40856,30849,37561,35023,22715,24658,31911,23290,9556,9574,9559,9568,9580,9571,9562,9577,9565,9554,9572,9557,9566,9578,9569,9560,9575,9563,9555,9573,9558,9567,9579,9570,9561,9576,9564,9553,9552,9581,9582,9584,9583,65517,132423,37595,132575,147397,34124,17077,29679,20917,13897,149826,166372,37700,137691,33518,146632,30780,26436,25311,149811,166314,131744,158643,135941,20395,140525,20488,159017,162436,144896,150193,140563,20521,131966,24484,131968,131911,28379,132127,20605,20737,13434,20750,39020,14147,33814,149924,132231,20832,144308,20842,134143,139516,131813,140592,132494,143923,137603,23426,34685,132531,146585,20914,20920,40244,20937,20943,20945,15580,20947,150182,20915,20962,21314,20973,33741,26942,145197,24443,21003,21030,21052,21173,21079,21140,21177,21189,31765,34114,21216,34317,158483,21253,166622,21833,28377,147328,133460,147436,21299,21316,134114,27851,136998,26651,29653,24650,16042,14540,136936,29149,17570,21357,21364,165547,21374,21375,136598,136723,30694,21395,166555,21408,21419,21422,29607,153458,16217,29596,21441,21445,27721,20041,22526,21465,15019,134031,21472,147435,142755,21494,134263,21523,28793,21803,26199,27995,21613,158547,134516,21853,21647,21668,18342,136973,134877,15796,134477,166332,140952,21831,19693,21551,29719,21894,21929,22021,137431,147514,17746,148533,26291,135348,22071,26317,144010,26276,26285,22093,22095,30961,22257,38791,21502,22272,22255,22253,166758,13859,135759,22342,147877,27758,28811,22338,14001,158846,22502,136214,22531,136276,148323,22566,150517,22620,22698,13665,22752,22748,135740,22779,23551,22339,172368,148088,37843,13729,22815,26790,14019,28249,136766,23076,21843,136850,34053,22985,134478,158849,159018,137180,23001,137211,137138,159142,28017,137256,136917,23033,159301,23211,23139,14054,149929,23159,14088,23190,29797,23251,159649,140628,15749,137489,14130,136888,24195,21200,23414,25992,23420,162318,16388,18525,131588,23509,24928,137780,154060,132517,23539,23453,19728,23557,138052,23571,29646,23572,138405,158504,23625,18653,23685,23785,23791,23947,138745,138807,23824,23832,23878,138916,23738,24023,33532,14381,149761,139337,139635,33415,14390,15298,24110,27274,24181,24186,148668,134355,21414,20151,24272,21416,137073,24073,24308,164994,24313,24315,14496,24316,26686,37915,24333,131521,194708,15070,18606,135994,24378,157832,140240,24408,140401,24419,38845,159342,24434,37696,166454,24487,23990,15711,152144,139114,159992,140904,37334,131742,166441,24625,26245,137335,14691,15815,13881,22416,141236,31089,15936,24734,24740,24755,149890,149903,162387,29860,20705,23200,24932,33828,24898,194726,159442,24961,20980,132694,24967,23466,147383,141407,25043,166813,170333,25040,14642,141696,141505,24611,24924,25886,25483,131352,25285,137072,25301,142861,25452,149983,14871,25656,25592,136078,137212,25744,28554,142902,38932,147596,153373,25825,25829,38011,14950,25658,14935,25933,28438,150056,150051,25989,25965,25951,143486,26037,149824,19255,26065,16600,137257,26080,26083,24543,144384,26136,143863,143864,26180,143780,143781,26187,134773,26215,152038,26227,26228,138813,143921,165364,143816,152339,30661,141559,39332,26370,148380,150049,15147,27130,145346,26462,26471,26466,147917,168173,26583,17641,26658,28240,37436,26625,144358,159136,26717,144495,27105,27147,166623,26995,26819,144845,26881,26880,15666,14849,144956,15232,26540,26977,166474,17148,26934,27032,15265,132041,33635,20624,27129,144985,139562,27205,145155,27293,15347,26545,27336,168348,15373,27421,133411,24798,27445,27508,141261,28341,146139,132021,137560,14144,21537,146266,27617,147196,27612,27703,140427,149745,158545,27738,33318,27769,146876,17605,146877,147876,149772,149760,146633,14053,15595,134450,39811,143865,140433,32655,26679,159013,159137,159211,28054,27996,28284,28420,149887,147589,159346,34099,159604,20935,27804,28189,33838,166689,28207,146991,29779,147330,31180,28239,23185,143435,28664,14093,28573,146992,28410,136343,147517,17749,37872,28484,28508,15694,28532,168304,15675,28575,147780,28627,147601,147797,147513,147440,147380,147775,20959,147798,147799,147776,156125,28747,28798,28839,28801,28876,28885,28886,28895,16644,15848,29108,29078,148087,28971,28997,23176,29002,29038,23708,148325,29007,37730,148161,28972,148570,150055,150050,29114,166888,28861,29198,37954,29205,22801,37955,29220,37697,153093,29230,29248,149876,26813,29269,29271,15957,143428,26637,28477,29314,29482,29483,149539,165931,18669,165892,29480,29486,29647,29610,134202,158254,29641,29769,147938,136935,150052,26147,14021,149943,149901,150011,29687,29717,26883,150054,29753,132547,16087,29788,141485,29792,167602,29767,29668,29814,33721,29804,14128,29812,37873,27180,29826,18771,150156,147807,150137,166799,23366,166915,137374,29896,137608,29966,29929,29982,167641,137803,23511,167596,37765,30029,30026,30055,30062,151426,16132,150803,30094,29789,30110,30132,30210,30252,30289,30287,30319,30326,156661,30352,33263,14328,157969,157966,30369,30373,30391,30412,159647,33890,151709,151933,138780,30494,30502,30528,25775,152096,30552,144044,30639,166244,166248,136897,30708,30729,136054,150034,26826,30895,30919,30931,38565,31022,153056,30935,31028,30897,161292,36792,34948,166699,155779,140828,31110,35072,26882,31104,153687,31133,162617,31036,31145,28202,160038,16040,31174,168205,31188],
  "euc-kr":[44034,44035,44037,44038,44043,44044,44045,44046,44047,44056,44062,44063,44065,44066,44067,44069,44070,44071,44072,44073,44074,44075,44078,44082,44083,44084,null,null,null,null,null,null,44085,44086,44087,44090,44091,44093,44094,44095,44097,44098,44099,44100,44101,44102,44103,44104,44105,44106,44108,44110,44111,44112,44113,44114,44115,44117,null,null,null,null,null,null,44118,44119,44121,44122,44123,44125,44126,44127,44128,44129,44130,44131,44132,44133,44134,44135,44136,44137,44138,44139,44140,44141,44142,44143,44146,44147,44149,44150,44153,44155,44156,44157,44158,44159,44162,44167,44168,44173,44174,44175,44177,44178,44179,44181,44182,44183,44184,44185,44186,44187,44190,44194,44195,44196,44197,44198,44199,44203,44205,44206,44209,44210,44211,44212,44213,44214,44215,44218,44222,44223,44224,44226,44227,44229,44230,44231,44233,44234,44235,44237,44238,44239,44240,44241,44242,44243,44244,44246,44248,44249,44250,44251,44252,44253,44254,44255,44258,44259,44261,44262,44265,44267,44269,44270,44274,44276,44279,44280,44281,44282,44283,44286,44287,44289,44290,44291,44293,44295,44296,44297,44298,44299,44302,44304,44306,44307,44308,44309,44310,44311,44313,44314,44315,44317,44318,44319,44321,44322,44323,44324,44325,44326,44327,44328,44330,44331,44334,44335,44336,44337,44338,44339,null,null,null,null,null,null,44342,44343,44345,44346,44347,44349,44350,44351,44352,44353,44354,44355,44358,44360,44362,44363,44364,44365,44366,44367,44369,44370,44371,44373,44374,44375,null,null,null,null,null,null,44377,44378,44379,44380,44381,44382,44383,44384,44386,44388,44389,44390,44391,44392,44393,44394,44395,44398,44399,44401,44402,44407,44408,44409,44410,44414,44416,44419,44420,44421,44422,44423,44426,44427,44429,44430,44431,44433,44434,44435,44436,44437,44438,44439,44440,44441,44442,44443,44446,44447,44448,44449,44450,44451,44453,44454,44455,44456,44457,44458,44459,44460,44461,44462,44463,44464,44465,44466,44467,44468,44469,44470,44472,44473,44474,44475,44476,44477,44478,44479,44482,44483,44485,44486,44487,44489,44490,44491,44492,44493,44494,44495,44498,44500,44501,44502,44503,44504,44505,44506,44507,44509,44510,44511,44513,44514,44515,44517,44518,44519,44520,44521,44522,44523,44524,44525,44526,44527,44528,44529,44530,44531,44532,44533,44534,44535,44538,44539,44541,44542,44546,44547,44548,44549,44550,44551,44554,44556,44558,44559,44560,44561,44562,44563,44565,44566,44567,44568,44569,44570,44571,44572,null,null,null,null,null,null,44573,44574,44575,44576,44577,44578,44579,44580,44581,44582,44583,44584,44585,44586,44587,44588,44589,44590,44591,44594,44595,44597,44598,44601,44603,44604,null,null,null,null,null,null,44605,44606,44607,44610,44612,44615,44616,44617,44619,44623,44625,44626,44627,44629,44631,44632,44633,44634,44635,44638,44642,44643,44644,44646,44647,44650,44651,44653,44654,44655,44657,44658,44659,44660,44661,44662,44663,44666,44670,44671,44672,44673,44674,44675,44678,44679,44680,44681,44682,44683,44685,44686,44687,44688,44689,44690,44691,44692,44693,44694,44695,44696,44697,44698,44699,44700,44701,44702,44703,44704,44705,44706,44707,44708,44709,44710,44711,44712,44713,44714,44715,44716,44717,44718,44719,44720,44721,44722,44723,44724,44725,44726,44727,44728,44729,44730,44731,44735,44737,44738,44739,44741,44742,44743,44744,44745,44746,44747,44750,44754,44755,44756,44757,44758,44759,44762,44763,44765,44766,44767,44768,44769,44770,44771,44772,44773,44774,44775,44777,44778,44780,44782,44783,44784,44785,44786,44787,44789,44790,44791,44793,44794,44795,44797,44798,44799,44800,44801,44802,44803,44804,44805,null,null,null,null,null,null,44806,44809,44810,44811,44812,44814,44815,44817,44818,44819,44820,44821,44822,44823,44824,44825,44826,44827,44828,44829,44830,44831,44832,44833,44834,44835,null,null,null,null,null,null,44836,44837,44838,44839,44840,44841,44842,44843,44846,44847,44849,44851,44853,44854,44855,44856,44857,44858,44859,44862,44864,44868,44869,44870,44871,44874,44875,44876,44877,44878,44879,44881,44882,44883,44884,44885,44886,44887,44888,44889,44890,44891,44894,44895,44896,44897,44898,44899,44902,44903,44904,44905,44906,44907,44908,44909,44910,44911,44912,44913,44914,44915,44916,44917,44918,44919,44920,44922,44923,44924,44925,44926,44927,44929,44930,44931,44933,44934,44935,44937,44938,44939,44940,44941,44942,44943,44946,44947,44948,44950,44951,44952,44953,44954,44955,44957,44958,44959,44960,44961,44962,44963,44964,44965,44966,44967,44968,44969,44970,44971,44972,44973,44974,44975,44976,44977,44978,44979,44980,44981,44982,44983,44986,44987,44989,44990,44991,44993,44994,44995,44996,44997,44998,45002,45004,45007,45008,45009,45010,45011,45013,45014,45015,45016,45017,45018,45019,45021,45022,45023,45024,45025,null,null,null,null,null,null,45026,45027,45028,45029,45030,45031,45034,45035,45036,45037,45038,45039,45042,45043,45045,45046,45047,45049,45050,45051,45052,45053,45054,45055,45058,45059,null,null,null,null,null,null,45061,45062,45063,45064,45065,45066,45067,45069,45070,45071,45073,45074,45075,45077,45078,45079,45080,45081,45082,45083,45086,45087,45088,45089,45090,45091,45092,45093,45094,45095,45097,45098,45099,45100,45101,45102,45103,45104,45105,45106,45107,45108,45109,45110,45111,45112,45113,45114,45115,45116,45117,45118,45119,45120,45121,45122,45123,45126,45127,45129,45131,45133,45135,45136,45137,45138,45142,45144,45146,45147,45148,45150,45151,45152,45153,45154,45155,45156,45157,45158,45159,45160,45161,45162,45163,45164,45165,45166,45167,45168,45169,45170,45171,45172,45173,45174,45175,45176,45177,45178,45179,45182,45183,45185,45186,45187,45189,45190,45191,45192,45193,45194,45195,45198,45200,45202,45203,45204,45205,45206,45207,45211,45213,45214,45219,45220,45221,45222,45223,45226,45232,45234,45238,45239,45241,45242,45243,45245,45246,45247,45248,45249,45250,45251,45254,45258,45259,45260,45261,45262,45263,45266,null,null,null,null,null,null,45267,45269,45270,45271,45273,45274,45275,45276,45277,45278,45279,45281,45282,45283,45284,45286,45287,45288,45289,45290,45291,45292,45293,45294,45295,45296,null,null,null,null,null,null,45297,45298,45299,45300,45301,45302,45303,45304,45305,45306,45307,45308,45309,45310,45311,45312,45313,45314,45315,45316,45317,45318,45319,45322,45325,45326,45327,45329,45332,45333,45334,45335,45338,45342,45343,45344,45345,45346,45350,45351,45353,45354,45355,45357,45358,45359,45360,45361,45362,45363,45366,45370,45371,45372,45373,45374,45375,45378,45379,45381,45382,45383,45385,45386,45387,45388,45389,45390,45391,45394,45395,45398,45399,45401,45402,45403,45405,45406,45407,45409,45410,45411,45412,45413,45414,45415,45416,45417,45418,45419,45420,45421,45422,45423,45424,45425,45426,45427,45428,45429,45430,45431,45434,45435,45437,45438,45439,45441,45443,45444,45445,45446,45447,45450,45452,45454,45455,45456,45457,45461,45462,45463,45465,45466,45467,45469,45470,45471,45472,45473,45474,45475,45476,45477,45478,45479,45481,45482,45483,45484,45485,45486,45487,45488,45489,45490,45491,45492,45493,45494,45495,45496,null,null,null,null,null,null,45497,45498,45499,45500,45501,45502,45503,45504,45505,45506,45507,45508,45509,45510,45511,45512,45513,45514,45515,45517,45518,45519,45521,45522,45523,45525,null,null,null,null,null,null,45526,45527,45528,45529,45530,45531,45534,45536,45537,45538,45539,45540,45541,45542,45543,45546,45547,45549,45550,45551,45553,45554,45555,45556,45557,45558,45559,45560,45562,45564,45566,45567,45568,45569,45570,45571,45574,45575,45577,45578,45581,45582,45583,45584,45585,45586,45587,45590,45592,45594,45595,45596,45597,45598,45599,45601,45602,45603,45604,45605,45606,45607,45608,45609,45610,45611,45612,45613,45614,45615,45616,45617,45618,45619,45621,45622,45623,45624,45625,45626,45627,45629,45630,45631,45632,45633,45634,45635,45636,45637,45638,45639,45640,45641,45642,45643,45644,45645,45646,45647,45648,45649,45650,45651,45652,45653,45654,45655,45657,45658,45659,45661,45662,45663,45665,45666,45667,45668,45669,45670,45671,45674,45675,45676,45677,45678,45679,45680,45681,45682,45683,45686,45687,45688,45689,45690,45691,45693,45694,45695,45696,45697,45698,45699,45702,45703,45704,45706,45707,45708,45709,45710,null,null,null,null,null,null,45711,45714,45715,45717,45718,45719,45723,45724,45725,45726,45727,45730,45732,45735,45736,45737,45739,45741,45742,45743,45745,45746,45747,45749,45750,45751,null,null,null,null,null,null,45752,45753,45754,45755,45756,45757,45758,45759,45760,45761,45762,45763,45764,45765,45766,45767,45770,45771,45773,45774,45775,45777,45779,45780,45781,45782,45783,45786,45788,45790,45791,45792,45793,45795,45799,45801,45802,45808,45809,45810,45814,45820,45821,45822,45826,45827,45829,45830,45831,45833,45834,45835,45836,45837,45838,45839,45842,45846,45847,45848,45849,45850,45851,45853,45854,45855,45856,45857,45858,45859,45860,45861,45862,45863,45864,45865,45866,45867,45868,45869,45870,45871,45872,45873,45874,45875,45876,45877,45878,45879,45880,45881,45882,45883,45884,45885,45886,45887,45888,45889,45890,45891,45892,45893,45894,45895,45896,45897,45898,45899,45900,45901,45902,45903,45904,45905,45906,45907,45911,45913,45914,45917,45920,45921,45922,45923,45926,45928,45930,45932,45933,45935,45938,45939,45941,45942,45943,45945,45946,45947,45948,45949,45950,45951,45954,45958,45959,45960,45961,45962,45963,45965,null,null,null,null,null,null,45966,45967,45969,45970,45971,45973,45974,45975,45976,45977,45978,45979,45980,45981,45982,45983,45986,45987,45988,45989,45990,45991,45993,45994,45995,45997,null,null,null,null,null,null,45998,45999,46000,46001,46002,46003,46004,46005,46006,46007,46008,46009,46010,46011,46012,46013,46014,46015,46016,46017,46018,46019,46022,46023,46025,46026,46029,46031,46033,46034,46035,46038,46040,46042,46044,46046,46047,46049,46050,46051,46053,46054,46055,46057,46058,46059,46060,46061,46062,46063,46064,46065,46066,46067,46068,46069,46070,46071,46072,46073,46074,46075,46077,46078,46079,46080,46081,46082,46083,46084,46085,46086,46087,46088,46089,46090,46091,46092,46093,46094,46095,46097,46098,46099,46100,46101,46102,46103,46105,46106,46107,46109,46110,46111,46113,46114,46115,46116,46117,46118,46119,46122,46124,46125,46126,46127,46128,46129,46130,46131,46133,46134,46135,46136,46137,46138,46139,46140,46141,46142,46143,46144,46145,46146,46147,46148,46149,46150,46151,46152,46153,46154,46155,46156,46157,46158,46159,46162,46163,46165,46166,46167,46169,46170,46171,46172,46173,46174,46175,46178,46180,46182,null,null,null,null,null,null,46183,46184,46185,46186,46187,46189,46190,46191,46192,46193,46194,46195,46196,46197,46198,46199,46200,46201,46202,46203,46204,46205,46206,46207,46209,46210,null,null,null,null,null,null,46211,46212,46213,46214,46215,46217,46218,46219,46220,46221,46222,46223,46224,46225,46226,46227,46228,46229,46230,46231,46232,46233,46234,46235,46236,46238,46239,46240,46241,46242,46243,46245,46246,46247,46249,46250,46251,46253,46254,46255,46256,46257,46258,46259,46260,46262,46264,46266,46267,46268,46269,46270,46271,46273,46274,46275,46277,46278,46279,46281,46282,46283,46284,46285,46286,46287,46289,46290,46291,46292,46294,46295,46296,46297,46298,46299,46302,46303,46305,46306,46309,46311,46312,46313,46314,46315,46318,46320,46322,46323,46324,46325,46326,46327,46329,46330,46331,46332,46333,46334,46335,46336,46337,46338,46339,46340,46341,46342,46343,46344,46345,46346,46347,46348,46349,46350,46351,46352,46353,46354,46355,46358,46359,46361,46362,46365,46366,46367,46368,46369,46370,46371,46374,46379,46380,46381,46382,46383,46386,46387,46389,46390,46391,46393,46394,46395,46396,46397,46398,46399,46402,46406,null,null,null,null,null,null,46407,46408,46409,46410,46414,46415,46417,46418,46419,46421,46422,46423,46424,46425,46426,46427,46430,46434,46435,46436,46437,46438,46439,46440,46441,46442,null,null,null,null,null,null,46443,46444,46445,46446,46447,46448,46449,46450,46451,46452,46453,46454,46455,46456,46457,46458,46459,46460,46461,46462,46463,46464,46465,46466,46467,46468,46469,46470,46471,46472,46473,46474,46475,46476,46477,46478,46479,46480,46481,46482,46483,46484,46485,46486,46487,46488,46489,46490,46491,46492,46493,46494,46495,46498,46499,46501,46502,46503,46505,46508,46509,46510,46511,46514,46518,46519,46520,46521,46522,46526,46527,46529,46530,46531,46533,46534,46535,46536,46537,46538,46539,46542,46546,46547,46548,46549,46550,46551,46553,46554,46555,46556,46557,46558,46559,46560,46561,46562,46563,46564,46565,46566,46567,46568,46569,46570,46571,46573,46574,46575,46576,46577,46578,46579,46580,46581,46582,46583,46584,46585,46586,46587,46588,46589,46590,46591,46592,46593,46594,46595,46596,46597,46598,46599,46600,46601,46602,46603,46604,46605,46606,46607,46610,46611,46613,46614,46615,46617,46618,46619,46620,46621,null,null,null,null,null,null,46622,46623,46624,46625,46626,46627,46628,46630,46631,46632,46633,46634,46635,46637,46638,46639,46640,46641,46642,46643,46645,46646,46647,46648,46649,46650,null,null,null,null,null,null,46651,46652,46653,46654,46655,46656,46657,46658,46659,46660,46661,46662,46663,46665,46666,46667,46668,46669,46670,46671,46672,46673,46674,46675,46676,46677,46678,46679,46680,46681,46682,46683,46684,46685,46686,46687,46688,46689,46690,46691,46693,46694,46695,46697,46698,46699,46700,46701,46702,46703,46704,46705,46706,46707,46708,46709,46710,46711,46712,46713,46714,46715,46716,46717,46718,46719,46720,46721,46722,46723,46724,46725,46726,46727,46728,46729,46730,46731,46732,46733,46734,46735,46736,46737,46738,46739,46740,46741,46742,46743,46744,46745,46746,46747,46750,46751,46753,46754,46755,46757,46758,46759,46760,46761,46762,46765,46766,46767,46768,46770,46771,46772,46773,46774,46775,46776,46777,46778,46779,46780,46781,46782,46783,46784,46785,46786,46787,46788,46789,46790,46791,46792,46793,46794,46795,46796,46797,46798,46799,46800,46801,46802,46803,46805,46806,46807,46808,46809,46810,46811,46812,46813,null,null,null,null,null,null,46814,46815,46816,46817,46818,46819,46820,46821,46822,46823,46824,46825,46826,46827,46828,46829,46830,46831,46833,46834,46835,46837,46838,46839,46841,46842,null,null,null,null,null,null,46843,46844,46845,46846,46847,46850,46851,46852,46854,46855,46856,46857,46858,46859,46860,46861,46862,46863,46864,46865,46866,46867,46868,46869,46870,46871,46872,46873,46874,46875,46876,46877,46878,46879,46880,46881,46882,46883,46884,46885,46886,46887,46890,46891,46893,46894,46897,46898,46899,46900,46901,46902,46903,46906,46908,46909,46910,46911,46912,46913,46914,46915,46917,46918,46919,46921,46922,46923,46925,46926,46927,46928,46929,46930,46931,46934,46935,46936,46937,46938,46939,46940,46941,46942,46943,46945,46946,46947,46949,46950,46951,46953,46954,46955,46956,46957,46958,46959,46962,46964,46966,46967,46968,46969,46970,46971,46974,46975,46977,46978,46979,46981,46982,46983,46984,46985,46986,46987,46990,46995,46996,46997,47002,47003,47005,47006,47007,47009,47010,47011,47012,47013,47014,47015,47018,47022,47023,47024,47025,47026,47027,47030,47031,47033,47034,47035,47036,47037,47038,47039,47040,47041,null,null,null,null,null,null,47042,47043,47044,47045,47046,47048,47050,47051,47052,47053,47054,47055,47056,47057,47058,47059,47060,47061,47062,47063,47064,47065,47066,47067,47068,47069,null,null,null,null,null,null,47070,47071,47072,47073,47074,47075,47076,47077,47078,47079,47080,47081,47082,47083,47086,47087,47089,47090,47091,47093,47094,47095,47096,47097,47098,47099,47102,47106,47107,47108,47109,47110,47114,47115,47117,47118,47119,47121,47122,47123,47124,47125,47126,47127,47130,47132,47134,47135,47136,47137,47138,47139,47142,47143,47145,47146,47147,47149,47150,47151,47152,47153,47154,47155,47158,47162,47163,47164,47165,47166,47167,47169,47170,47171,47173,47174,47175,47176,47177,47178,47179,47180,47181,47182,47183,47184,47186,47188,47189,47190,47191,47192,47193,47194,47195,47198,47199,47201,47202,47203,47205,47206,47207,47208,47209,47210,47211,47214,47216,47218,47219,47220,47221,47222,47223,47225,47226,47227,47229,47230,47231,47232,47233,47234,47235,47236,47237,47238,47239,47240,47241,47242,47243,47244,47246,47247,47248,47249,47250,47251,47252,47253,47254,47255,47256,47257,47258,47259,47260,47261,47262,47263,null,null,null,null,null,null,47264,47265,47266,47267,47268,47269,47270,47271,47273,47274,47275,47276,47277,47278,47279,47281,47282,47283,47285,47286,47287,47289,47290,47291,47292,47293,null,null,null,null,null,null,47294,47295,47298,47300,47302,47303,47304,47305,47306,47307,47309,47310,47311,47313,47314,47315,47317,47318,47319,47320,47321,47322,47323,47324,47326,47328,47330,47331,47332,47333,47334,47335,47338,47339,47341,47342,47343,47345,47346,47347,47348,47349,47350,47351,47354,47356,47358,47359,47360,47361,47362,47363,47365,47366,47367,47368,47369,47370,47371,47372,47373,47374,47375,47376,47377,47378,47379,47380,47381,47382,47383,47385,47386,47387,47388,47389,47390,47391,47393,47394,47395,47396,47397,47398,47399,47400,47401,47402,47403,47404,47405,47406,47407,47408,47409,47410,47411,47412,47413,47414,47415,47416,47417,47418,47419,47422,47423,47425,47426,47427,47429,47430,47431,47432,47433,47434,47435,47437,47438,47440,47442,47443,47444,47445,47446,47447,47450,47451,47453,47454,47455,47457,47458,47459,47460,47461,47462,47463,47466,47468,47470,47471,47472,47473,47474,47475,47478,47479,47481,47482,47483,47485,null,null,null,null,null,null,47486,47487,47488,47489,47490,47491,47494,47496,47499,47500,47503,47504,47505,47506,47507,47508,47509,47510,47511,47512,47513,47514,47515,47516,47517,47518,null,null,null,null,null,null,47519,47520,47521,47522,47523,47524,47525,47526,47527,47528,47529,47530,47531,47534,47535,47537,47538,47539,47541,47542,47543,47544,47545,47546,47547,47550,47552,47554,47555,47556,47557,47558,47559,47562,47563,47565,47571,47572,47573,47574,47575,47578,47580,47583,47584,47586,47590,47591,47593,47594,47595,47597,47598,47599,47600,47601,47602,47603,47606,47611,47612,47613,47614,47615,47618,47619,47620,47621,47622,47623,47625,47626,47627,47628,47629,47630,47631,47632,47633,47634,47635,47636,47638,47639,47640,47641,47642,47643,47644,47645,47646,47647,47648,47649,47650,47651,47652,47653,47654,47655,47656,47657,47658,47659,47660,47661,47662,47663,47664,47665,47666,47667,47668,47669,47670,47671,47674,47675,47677,47678,47679,47681,47683,47684,47685,47686,47687,47690,47692,47695,47696,47697,47698,47702,47703,47705,47706,47707,47709,47710,47711,47712,47713,47714,47715,47718,47722,47723,47724,47725,47726,47727,null,null,null,null,null,null,47730,47731,47733,47734,47735,47737,47738,47739,47740,47741,47742,47743,47744,47745,47746,47750,47752,47753,47754,47755,47757,47758,47759,47760,47761,47762,null,null,null,null,null,null,47763,47764,47765,47766,47767,47768,47769,47770,47771,47772,47773,47774,47775,47776,47777,47778,47779,47780,47781,47782,47783,47786,47789,47790,47791,47793,47795,47796,47797,47798,47799,47802,47804,47806,47807,47808,47809,47810,47811,47813,47814,47815,47817,47818,47819,47820,47821,47822,47823,47824,47825,47826,47827,47828,47829,47830,47831,47834,47835,47836,47837,47838,47839,47840,47841,47842,47843,47844,47845,47846,47847,47848,47849,47850,47851,47852,47853,47854,47855,47856,47857,47858,47859,47860,47861,47862,47863,47864,47865,47866,47867,47869,47870,47871,47873,47874,47875,47877,47878,47879,47880,47881,47882,47883,47884,47886,47888,47890,47891,47892,47893,47894,47895,47897,47898,47899,47901,47902,47903,47905,47906,47907,47908,47909,47910,47911,47912,47914,47916,47917,47918,47919,47920,47921,47922,47923,47927,47929,47930,47935,47936,47937,47938,47939,47942,47944,47946,47947,47948,47950,47953,47954,null,null,null,null,null,null,47955,47957,47958,47959,47961,47962,47963,47964,47965,47966,47967,47968,47970,47972,47973,47974,47975,47976,47977,47978,47979,47981,47982,47983,47984,47985,null,null,null,null,null,null,47986,47987,47988,47989,47990,47991,47992,47993,47994,47995,47996,47997,47998,47999,48000,48001,48002,48003,48004,48005,48006,48007,48009,48010,48011,48013,48014,48015,48017,48018,48019,48020,48021,48022,48023,48024,48025,48026,48027,48028,48029,48030,48031,48032,48033,48034,48035,48037,48038,48039,48041,48042,48043,48045,48046,48047,48048,48049,48050,48051,48053,48054,48056,48057,48058,48059,48060,48061,48062,48063,48065,48066,48067,48069,48070,48071,48073,48074,48075,48076,48077,48078,48079,48081,48082,48084,48085,48086,48087,48088,48089,48090,48091,48092,48093,48094,48095,48096,48097,48098,48099,48100,48101,48102,48103,48104,48105,48106,48107,48108,48109,48110,48111,48112,48113,48114,48115,48116,48117,48118,48119,48122,48123,48125,48126,48129,48131,48132,48133,48134,48135,48138,48142,48144,48146,48147,48153,48154,48160,48161,48162,48163,48166,48168,48170,48171,48172,48174,48175,48178,48179,48181,null,null,null,null,null,null,48182,48183,48185,48186,48187,48188,48189,48190,48191,48194,48198,48199,48200,48202,48203,48206,48207,48209,48210,48211,48212,48213,48214,48215,48216,48217,null,null,null,null,null,null,48218,48219,48220,48222,48223,48224,48225,48226,48227,48228,48229,48230,48231,48232,48233,48234,48235,48236,48237,48238,48239,48240,48241,48242,48243,48244,48245,48246,48247,48248,48249,48250,48251,48252,48253,48254,48255,48256,48257,48258,48259,48262,48263,48265,48266,48269,48271,48272,48273,48274,48275,48278,48280,48283,48284,48285,48286,48287,48290,48291,48293,48294,48297,48298,48299,48300,48301,48302,48303,48306,48310,48311,48312,48313,48314,48315,48318,48319,48321,48322,48323,48325,48326,48327,48328,48329,48330,48331,48332,48334,48338,48339,48340,48342,48343,48345,48346,48347,48349,48350,48351,48352,48353,48354,48355,48356,48357,48358,48359,48360,48361,48362,48363,48364,48365,48366,48367,48368,48369,48370,48371,48375,48377,48378,48379,48381,48382,48383,48384,48385,48386,48387,48390,48392,48394,48395,48396,48397,48398,48399,48401,48402,48403,48405,48406,48407,48408,48409,48410,48411,48412,48413,null,null,null,null,null,null,48414,48415,48416,48417,48418,48419,48421,48422,48423,48424,48425,48426,48427,48429,48430,48431,48432,48433,48434,48435,48436,48437,48438,48439,48440,48441,null,null,null,null,null,null,48442,48443,48444,48445,48446,48447,48449,48450,48451,48452,48453,48454,48455,48458,48459,48461,48462,48463,48465,48466,48467,48468,48469,48470,48471,48474,48475,48476,48477,48478,48479,48480,48481,48482,48483,48485,48486,48487,48489,48490,48491,48492,48493,48494,48495,48496,48497,48498,48499,48500,48501,48502,48503,48504,48505,48506,48507,48508,48509,48510,48511,48514,48515,48517,48518,48523,48524,48525,48526,48527,48530,48532,48534,48535,48536,48539,48541,48542,48543,48544,48545,48546,48547,48549,48550,48551,48552,48553,48554,48555,48556,48557,48558,48559,48561,48562,48563,48564,48565,48566,48567,48569,48570,48571,48572,48573,48574,48575,48576,48577,48578,48579,48580,48581,48582,48583,48584,48585,48586,48587,48588,48589,48590,48591,48592,48593,48594,48595,48598,48599,48601,48602,48603,48605,48606,48607,48608,48609,48610,48611,48612,48613,48614,48615,48616,48618,48619,48620,48621,48622,48623,48625,null,null,null,null,null,null,48626,48627,48629,48630,48631,48633,48634,48635,48636,48637,48638,48639,48641,48642,48644,48646,48647,48648,48649,48650,48651,48654,48655,48657,48658,48659,null,null,null,null,null,null,48661,48662,48663,48664,48665,48666,48667,48670,48672,48673,48674,48675,48676,48677,48678,48679,48680,48681,48682,48683,48684,48685,48686,48687,48688,48689,48690,48691,48692,48693,48694,48695,48696,48697,48698,48699,48700,48701,48702,48703,48704,48705,48706,48707,48710,48711,48713,48714,48715,48717,48719,48720,48721,48722,48723,48726,48728,48732,48733,48734,48735,48738,48739,48741,48742,48743,48745,48747,48748,48749,48750,48751,48754,48758,48759,48760,48761,48762,48766,48767,48769,48770,48771,48773,48774,48775,48776,48777,48778,48779,48782,48786,48787,48788,48789,48790,48791,48794,48795,48796,48797,48798,48799,48800,48801,48802,48803,48804,48805,48806,48807,48809,48810,48811,48812,48813,48814,48815,48816,48817,48818,48819,48820,48821,48822,48823,48824,48825,48826,48827,48828,48829,48830,48831,48832,48833,48834,48835,48836,48837,48838,48839,48840,48841,48842,48843,48844,48845,48846,48847,48850,48851,null,null,null,null,null,null,48853,48854,48857,48858,48859,48860,48861,48862,48863,48865,48866,48870,48871,48872,48873,48874,48875,48877,48878,48879,48880,48881,48882,48883,48884,48885,null,null,null,null,null,null,48886,48887,48888,48889,48890,48891,48892,48893,48894,48895,48896,48898,48899,48900,48901,48902,48903,48906,48907,48908,48909,48910,48911,48912,48913,48914,48915,48916,48917,48918,48919,48922,48926,48927,48928,48929,48930,48931,48932,48933,48934,48935,48936,48937,48938,48939,48940,48941,48942,48943,48944,48945,48946,48947,48948,48949,48950,48951,48952,48953,48954,48955,48956,48957,48958,48959,48962,48963,48965,48966,48967,48969,48970,48971,48972,48973,48974,48975,48978,48979,48980,48982,48983,48984,48985,48986,48987,48988,48989,48990,48991,48992,48993,48994,48995,48996,48997,48998,48999,49000,49001,49002,49003,49004,49005,49006,49007,49008,49009,49010,49011,49012,49013,49014,49015,49016,49017,49018,49019,49020,49021,49022,49023,49024,49025,49026,49027,49028,49029,49030,49031,49032,49033,49034,49035,49036,49037,49038,49039,49040,49041,49042,49043,49045,49046,49047,49048,49049,49050,49051,49052,49053,null,null,null,null,null,null,49054,49055,49056,49057,49058,49059,49060,49061,49062,49063,49064,49065,49066,49067,49068,49069,49070,49071,49073,49074,49075,49076,49077,49078,49079,49080,null,null,null,null,null,null,49081,49082,49083,49084,49085,49086,49087,49088,49089,49090,49091,49092,49094,49095,49096,49097,49098,49099,49102,49103,49105,49106,49107,49109,49110,49111,49112,49113,49114,49115,49117,49118,49120,49122,49123,49124,49125,49126,49127,49128,49129,49130,49131,49132,49133,49134,49135,49136,49137,49138,49139,49140,49141,49142,49143,49144,49145,49146,49147,49148,49149,49150,49151,49152,49153,49154,49155,49156,49157,49158,49159,49160,49161,49162,49163,49164,49165,49166,49167,49168,49169,49170,49171,49172,49173,49174,49175,49176,49177,49178,49179,49180,49181,49182,49183,49184,49185,49186,49187,49188,49189,49190,49191,49192,49193,49194,49195,49196,49197,49198,49199,49200,49201,49202,49203,49204,49205,49206,49207,49208,49209,49210,49211,49213,49214,49215,49216,49217,49218,49219,49220,49221,49222,49223,49224,49225,49226,49227,49228,49229,49230,49231,49232,49234,49235,49236,49237,49238,49239,49241,49242,49243,null,null,null,null,null,null,49245,49246,49247,49249,49250,49251,49252,49253,49254,49255,49258,49259,49260,49261,49262,49263,49264,49265,49266,49267,49268,49269,49270,49271,49272,49273,null,null,null,null,null,null,49274,49275,49276,49277,49278,49279,49280,49281,49282,49283,49284,49285,49286,49287,49288,49289,49290,49291,49292,49293,49294,49295,49298,49299,49301,49302,49303,49305,49306,49307,49308,49309,49310,49311,49314,49316,49318,49319,49320,49321,49322,49323,49326,49329,49330,49335,49336,49337,49338,49339,49342,49346,49347,49348,49350,49351,49354,49355,49357,49358,49359,49361,49362,49363,49364,49365,49366,49367,49370,49374,49375,49376,49377,49378,49379,49382,49383,49385,49386,49387,49389,49390,49391,49392,49393,49394,49395,49398,49400,49402,49403,49404,49405,49406,49407,49409,49410,49411,49413,49414,49415,49417,49418,49419,49420,49421,49422,49423,49425,49426,49427,49428,49430,49431,49432,49433,49434,49435,49441,49442,49445,49448,49449,49450,49451,49454,49458,49459,49460,49461,49463,49466,49467,49469,49470,49471,49473,49474,49475,49476,49477,49478,49479,49482,49486,49487,49488,49489,49490,49491,49494,49495,null,null,null,null,null,null,49497,49498,49499,49501,49502,49503,49504,49505,49506,49507,49510,49514,49515,49516,49517,49518,49519,49521,49522,49523,49525,49526,49527,49529,49530,49531,null,null,null,null,null,null,49532,49533,49534,49535,49536,49537,49538,49539,49540,49542,49543,49544,49545,49546,49547,49551,49553,49554,49555,49557,49559,49560,49561,49562,49563,49566,49568,49570,49571,49572,49574,49575,49578,49579,49581,49582,49583,49585,49586,49587,49588,49589,49590,49591,49592,49593,49594,49595,49596,49598,49599,49600,49601,49602,49603,49605,49606,49607,49609,49610,49611,49613,49614,49615,49616,49617,49618,49619,49621,49622,49625,49626,49627,49628,49629,49630,49631,49633,49634,49635,49637,49638,49639,49641,49642,49643,49644,49645,49646,49647,49650,49652,49653,49654,49655,49656,49657,49658,49659,49662,49663,49665,49666,49667,49669,49670,49671,49672,49673,49674,49675,49678,49680,49682,49683,49684,49685,49686,49687,49690,49691,49693,49694,49697,49698,49699,49700,49701,49702,49703,49706,49708,49710,49712,49715,49717,49718,49719,49720,49721,49722,49723,49724,49725,49726,49727,49728,49729,49730,49731,49732,49733,null,null,null,null,null,null,49734,49735,49737,49738,49739,49740,49741,49742,49743,49746,49747,49749,49750,49751,49753,49754,49755,49756,49757,49758,49759,49761,49762,49763,49764,49766,null,null,null,null,null,null,49767,49768,49769,49770,49771,49774,49775,49777,49778,49779,49781,49782,49783,49784,49785,49786,49787,49790,49792,49794,49795,49796,49797,49798,49799,49802,49803,49804,49805,49806,49807,49809,49810,49811,49812,49813,49814,49815,49817,49818,49820,49822,49823,49824,49825,49826,49827,49830,49831,49833,49834,49835,49838,49839,49840,49841,49842,49843,49846,49848,49850,49851,49852,49853,49854,49855,49856,49857,49858,49859,49860,49861,49862,49863,49864,49865,49866,49867,49868,49869,49870,49871,49872,49873,49874,49875,49876,49877,49878,49879,49880,49881,49882,49883,49886,49887,49889,49890,49893,49894,49895,49896,49897,49898,49902,49904,49906,49907,49908,49909,49911,49914,49917,49918,49919,49921,49922,49923,49924,49925,49926,49927,49930,49931,49934,49935,49936,49937,49938,49942,49943,49945,49946,49947,49949,49950,49951,49952,49953,49954,49955,49958,49959,49962,49963,49964,49965,49966,49967,49968,49969,49970,null,null,null,null,null,null,49971,49972,49973,49974,49975,49976,49977,49978,49979,49980,49981,49982,49983,49984,49985,49986,49987,49988,49990,49991,49992,49993,49994,49995,49996,49997,null,null,null,null,null,null,49998,49999,50000,50001,50002,50003,50004,50005,50006,50007,50008,50009,50010,50011,50012,50013,50014,50015,50016,50017,50018,50019,50020,50021,50022,50023,50026,50027,50029,50030,50031,50033,50035,50036,50037,50038,50039,50042,50043,50046,50047,50048,50049,50050,50051,50053,50054,50055,50057,50058,50059,50061,50062,50063,50064,50065,50066,50067,50068,50069,50070,50071,50072,50073,50074,50075,50076,50077,50078,50079,50080,50081,50082,50083,50084,50085,50086,50087,50088,50089,50090,50091,50092,50093,50094,50095,50096,50097,50098,50099,50100,50101,50102,50103,50104,50105,50106,50107,50108,50109,50110,50111,50113,50114,50115,50116,50117,50118,50119,50120,50121,50122,50123,50124,50125,50126,50127,50128,50129,50130,50131,50132,50133,50134,50135,50138,50139,50141,50142,50145,50147,50148,50149,50150,50151,50154,50155,50156,50158,50159,50160,50161,50162,50163,50166,50167,50169,50170,50171,50172,50173,50174,null,null,null,null,null,null,50175,50176,50177,50178,50179,50180,50181,50182,50183,50185,50186,50187,50188,50189,50190,50191,50193,50194,50195,50196,50197,50198,50199,50200,50201,50202,null,null,null,null,null,null,50203,50204,50205,50206,50207,50208,50209,50210,50211,50213,50214,50215,50216,50217,50218,50219,50221,50222,50223,50225,50226,50227,50229,50230,50231,50232,50233,50234,50235,50238,50239,50240,50241,50242,50243,50244,50245,50246,50247,50249,50250,50251,50252,50253,50254,50255,50256,50257,50258,50259,50260,50261,50262,50263,50264,50265,50266,50267,50268,50269,50270,50271,50272,50273,50274,50275,50278,50279,50281,50282,50283,50285,50286,50287,50288,50289,50290,50291,50294,50295,50296,50298,50299,50300,50301,50302,50303,50305,50306,50307,50308,50309,50310,50311,50312,50313,50314,50315,50316,50317,50318,50319,50320,50321,50322,50323,50325,50326,50327,50328,50329,50330,50331,50333,50334,50335,50336,50337,50338,50339,50340,50341,50342,50343,50344,50345,50346,50347,50348,50349,50350,50351,50352,50353,50354,50355,50356,50357,50358,50359,50361,50362,50363,50365,50366,50367,50368,50369,50370,50371,50372,50373,null,null,null,null,null,null,50374,50375,50376,50377,50378,50379,50380,50381,50382,50383,50384,50385,50386,50387,50388,50389,50390,50391,50392,50393,50394,50395,50396,50397,50398,50399,null,null,null,null,null,null,50400,50401,50402,50403,50404,50405,50406,50407,50408,50410,50411,50412,50413,50414,50415,50418,50419,50421,50422,50423,50425,50427,50428,50429,50430,50434,50435,50436,50437,50438,50439,50440,50441,50442,50443,50445,50446,50447,50449,50450,50451,50453,50454,50455,50456,50457,50458,50459,50461,50462,50463,50464,50465,50466,50467,50468,50469,50470,50471,50474,50475,50477,50478,50479,50481,50482,50483,50484,50485,50486,50487,50490,50492,50494,50495,50496,50497,50498,50499,50502,50503,50507,50511,50512,50513,50514,50518,50522,50523,50524,50527,50530,50531,50533,50534,50535,50537,50538,50539,50540,50541,50542,50543,50546,50550,50551,50552,50553,50554,50555,50558,50559,50561,50562,50563,50565,50566,50568,50569,50570,50571,50574,50576,50578,50579,50580,50582,50585,50586,50587,50589,50590,50591,50593,50594,50595,50596,50597,50598,50599,50600,50602,50603,50604,50605,50606,50607,50608,50609,50610,50611,50614,null,null,null,null,null,null,50615,50618,50623,50624,50625,50626,50627,50635,50637,50639,50642,50643,50645,50646,50647,50649,50650,50651,50652,50653,50654,50655,50658,50660,50662,50663,null,null,null,null,null,null,50664,50665,50666,50667,50671,50673,50674,50675,50677,50680,50681,50682,50683,50690,50691,50692,50697,50698,50699,50701,50702,50703,50705,50706,50707,50708,50709,50710,50711,50714,50717,50718,50719,50720,50721,50722,50723,50726,50727,50729,50730,50731,50735,50737,50738,50742,50744,50746,50748,50749,50750,50751,50754,50755,50757,50758,50759,50761,50762,50763,50764,50765,50766,50767,50770,50774,50775,50776,50777,50778,50779,50782,50783,50785,50786,50787,50788,50789,50790,50791,50792,50793,50794,50795,50797,50798,50800,50802,50803,50804,50805,50806,50807,50810,50811,50813,50814,50815,50817,50818,50819,50820,50821,50822,50823,50826,50828,50830,50831,50832,50833,50834,50835,50838,50839,50841,50842,50843,50845,50846,50847,50848,50849,50850,50851,50854,50856,50858,50859,50860,50861,50862,50863,50866,50867,50869,50870,50871,50875,50876,50877,50878,50879,50882,50884,50886,50887,50888,50889,50890,50891,50894,null,null,null,null,null,null,50895,50897,50898,50899,50901,50902,50903,50904,50905,50906,50907,50910,50911,50914,50915,50916,50917,50918,50919,50922,50923,50925,50926,50927,50929,50930,null,null,null,null,null,null,50931,50932,50933,50934,50935,50938,50939,50940,50942,50943,50944,50945,50946,50947,50950,50951,50953,50954,50955,50957,50958,50959,50960,50961,50962,50963,50966,50968,50970,50971,50972,50973,50974,50975,50978,50979,50981,50982,50983,50985,50986,50987,50988,50989,50990,50991,50994,50996,50998,51000,51001,51002,51003,51006,51007,51009,51010,51011,51013,51014,51015,51016,51017,51019,51022,51024,51033,51034,51035,51037,51038,51039,51041,51042,51043,51044,51045,51046,51047,51049,51050,51052,51053,51054,51055,51056,51057,51058,51059,51062,51063,51065,51066,51067,51071,51072,51073,51074,51078,51083,51084,51085,51087,51090,51091,51093,51097,51099,51100,51101,51102,51103,51106,51111,51112,51113,51114,51115,51118,51119,51121,51122,51123,51125,51126,51127,51128,51129,51130,51131,51134,51138,51139,51140,51141,51142,51143,51146,51147,51149,51151,51153,51154,51155,51156,51157,51158,51159,51161,51162,51163,51164,null,null,null,null,null,null,51166,51167,51168,51169,51170,51171,51173,51174,51175,51177,51178,51179,51181,51182,51183,51184,51185,51186,51187,51188,51189,51190,51191,51192,51193,51194,null,null,null,null,null,null,51195,51196,51197,51198,51199,51202,51203,51205,51206,51207,51209,51211,51212,51213,51214,51215,51218,51220,51223,51224,51225,51226,51227,51230,51231,51233,51234,51235,51237,51238,51239,51240,51241,51242,51243,51246,51248,51250,51251,51252,51253,51254,51255,51257,51258,51259,51261,51262,51263,51265,51266,51267,51268,51269,51270,51271,51274,51275,51278,51279,51280,51281,51282,51283,51285,51286,51287,51288,51289,51290,51291,51292,51293,51294,51295,51296,51297,51298,51299,51300,51301,51302,51303,51304,51305,51306,51307,51308,51309,51310,51311,51314,51315,51317,51318,51319,51321,51323,51324,51325,51326,51327,51330,51332,51336,51337,51338,51342,51343,51344,51345,51346,51347,51349,51350,51351,51352,51353,51354,51355,51356,51358,51360,51362,51363,51364,51365,51366,51367,51369,51370,51371,51372,51373,51374,51375,51376,51377,51378,51379,51380,51381,51382,51383,51384,51385,51386,51387,51390,51391,51392,51393,null,null,null,null,null,null,51394,51395,51397,51398,51399,51401,51402,51403,51405,51406,51407,51408,51409,51410,51411,51414,51416,51418,51419,51420,51421,51422,51423,51426,51427,51429,null,null,null,null,null,null,51430,51431,51432,51433,51434,51435,51436,51437,51438,51439,51440,51441,51442,51443,51444,51446,51447,51448,51449,51450,51451,51454,51455,51457,51458,51459,51463,51464,51465,51466,51467,51470,12288,12289,12290,183,8229,8230,168,12291,173,8213,8741,65340,8764,8216,8217,8220,8221,12308,12309,12296,12297,12298,12299,12300,12301,12302,12303,12304,12305,177,215,247,8800,8804,8805,8734,8756,176,8242,8243,8451,8491,65504,65505,65509,9794,9792,8736,8869,8978,8706,8711,8801,8786,167,8251,9734,9733,9675,9679,9678,9671,9670,9633,9632,9651,9650,9661,9660,8594,8592,8593,8595,8596,12307,8810,8811,8730,8765,8733,8757,8747,8748,8712,8715,8838,8839,8834,8835,8746,8745,8743,8744,65506,51472,51474,51475,51476,51477,51478,51479,51481,51482,51483,51484,51485,51486,51487,51488,51489,51490,51491,51492,51493,51494,51495,51496,51497,51498,51499,null,null,null,null,null,null,51501,51502,51503,51504,51505,51506,51507,51509,51510,51511,51512,51513,51514,51515,51516,51517,51518,51519,51520,51521,51522,51523,51524,51525,51526,51527,null,null,null,null,null,null,51528,51529,51530,51531,51532,51533,51534,51535,51538,51539,51541,51542,51543,51545,51546,51547,51548,51549,51550,51551,51554,51556,51557,51558,51559,51560,51561,51562,51563,51565,51566,51567,8658,8660,8704,8707,180,65374,711,728,733,730,729,184,731,161,191,720,8750,8721,8719,164,8457,8240,9665,9664,9655,9654,9828,9824,9825,9829,9831,9827,8857,9672,9635,9680,9681,9618,9636,9637,9640,9639,9638,9641,9832,9743,9742,9756,9758,182,8224,8225,8597,8599,8601,8598,8600,9837,9833,9834,9836,12927,12828,8470,13255,8482,13250,13272,8481,8364,174,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,51569,51570,51571,51573,51574,51575,51576,51577,51578,51579,51581,51582,51583,51584,51585,51586,51587,51588,51589,51590,51591,51594,51595,51597,51598,51599,null,null,null,null,null,null,51601,51602,51603,51604,51605,51606,51607,51610,51612,51614,51615,51616,51617,51618,51619,51620,51621,51622,51623,51624,51625,51626,51627,51628,51629,51630,null,null,null,null,null,null,51631,51632,51633,51634,51635,51636,51637,51638,51639,51640,51641,51642,51643,51644,51645,51646,51647,51650,51651,51653,51654,51657,51659,51660,51661,51662,51663,51666,51668,51671,51672,51675,65281,65282,65283,65284,65285,65286,65287,65288,65289,65290,65291,65292,65293,65294,65295,65296,65297,65298,65299,65300,65301,65302,65303,65304,65305,65306,65307,65308,65309,65310,65311,65312,65313,65314,65315,65316,65317,65318,65319,65320,65321,65322,65323,65324,65325,65326,65327,65328,65329,65330,65331,65332,65333,65334,65335,65336,65337,65338,65339,65510,65341,65342,65343,65344,65345,65346,65347,65348,65349,65350,65351,65352,65353,65354,65355,65356,65357,65358,65359,65360,65361,65362,65363,65364,65365,65366,65367,65368,65369,65370,65371,65372,65373,65507,51678,51679,51681,51683,51685,51686,51688,51689,51690,51691,51694,51698,51699,51700,51701,51702,51703,51706,51707,51709,51710,51711,51713,51714,51715,51716,null,null,null,null,null,null,51717,51718,51719,51722,51726,51727,51728,51729,51730,51731,51733,51734,51735,51737,51738,51739,51740,51741,51742,51743,51744,51745,51746,51747,51748,51749,null,null,null,null,null,null,51750,51751,51752,51754,51755,51756,51757,51758,51759,51760,51761,51762,51763,51764,51765,51766,51767,51768,51769,51770,51771,51772,51773,51774,51775,51776,51777,51778,51779,51780,51781,51782,12593,12594,12595,12596,12597,12598,12599,12600,12601,12602,12603,12604,12605,12606,12607,12608,12609,12610,12611,12612,12613,12614,12615,12616,12617,12618,12619,12620,12621,12622,12623,12624,12625,12626,12627,12628,12629,12630,12631,12632,12633,12634,12635,12636,12637,12638,12639,12640,12641,12642,12643,12644,12645,12646,12647,12648,12649,12650,12651,12652,12653,12654,12655,12656,12657,12658,12659,12660,12661,12662,12663,12664,12665,12666,12667,12668,12669,12670,12671,12672,12673,12674,12675,12676,12677,12678,12679,12680,12681,12682,12683,12684,12685,12686,51783,51784,51785,51786,51787,51790,51791,51793,51794,51795,51797,51798,51799,51800,51801,51802,51803,51806,51810,51811,51812,51813,51814,51815,51817,51818,null,null,null,null,null,null,51819,51820,51821,51822,51823,51824,51825,51826,51827,51828,51829,51830,51831,51832,51833,51834,51835,51836,51838,51839,51840,51841,51842,51843,51845,51846,null,null,null,null,null,null,51847,51848,51849,51850,51851,51852,51853,51854,51855,51856,51857,51858,51859,51860,51861,51862,51863,51865,51866,51867,51868,51869,51870,51871,51872,51873,51874,51875,51876,51877,51878,51879,8560,8561,8562,8563,8564,8565,8566,8567,8568,8569,null,null,null,null,null,8544,8545,8546,8547,8548,8549,8550,8551,8552,8553,null,null,null,null,null,null,null,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,null,null,null,null,null,null,null,null,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,963,964,965,966,967,968,969,null,null,null,null,null,null,51880,51881,51882,51883,51884,51885,51886,51887,51888,51889,51890,51891,51892,51893,51894,51895,51896,51897,51898,51899,51902,51903,51905,51906,51907,51909,null,null,null,null,null,null,51910,51911,51912,51913,51914,51915,51918,51920,51922,51924,51925,51926,51927,51930,51931,51932,51933,51934,51935,51937,51938,51939,51940,51941,51942,51943,null,null,null,null,null,null,51944,51945,51946,51947,51949,51950,51951,51952,51953,51954,51955,51957,51958,51959,51960,51961,51962,51963,51964,51965,51966,51967,51968,51969,51970,51971,51972,51973,51974,51975,51977,51978,9472,9474,9484,9488,9496,9492,9500,9516,9508,9524,9532,9473,9475,9487,9491,9499,9495,9507,9523,9515,9531,9547,9504,9519,9512,9527,9535,9501,9520,9509,9528,9538,9490,9489,9498,9497,9494,9493,9486,9485,9502,9503,9505,9506,9510,9511,9513,9514,9517,9518,9521,9522,9525,9526,9529,9530,9533,9534,9536,9537,9539,9540,9541,9542,9543,9544,9545,9546,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,51979,51980,51981,51982,51983,51985,51986,51987,51989,51990,51991,51993,51994,51995,51996,51997,51998,51999,52002,52003,52004,52005,52006,52007,52008,52009,null,null,null,null,null,null,52010,52011,52012,52013,52014,52015,52016,52017,52018,52019,52020,52021,52022,52023,52024,52025,52026,52027,52028,52029,52030,52031,52032,52034,52035,52036,null,null,null,null,null,null,52037,52038,52039,52042,52043,52045,52046,52047,52049,52050,52051,52052,52053,52054,52055,52058,52059,52060,52062,52063,52064,52065,52066,52067,52069,52070,52071,52072,52073,52074,52075,52076,13205,13206,13207,8467,13208,13252,13219,13220,13221,13222,13209,13210,13211,13212,13213,13214,13215,13216,13217,13218,13258,13197,13198,13199,13263,13192,13193,13256,13223,13224,13232,13233,13234,13235,13236,13237,13238,13239,13240,13241,13184,13185,13186,13187,13188,13242,13243,13244,13245,13246,13247,13200,13201,13202,13203,13204,8486,13248,13249,13194,13195,13196,13270,13253,13229,13230,13231,13275,13225,13226,13227,13228,13277,13264,13267,13251,13257,13276,13254,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,52077,52078,52079,52080,52081,52082,52083,52084,52085,52086,52087,52090,52091,52092,52093,52094,52095,52096,52097,52098,52099,52100,52101,52102,52103,52104,null,null,null,null,null,null,52105,52106,52107,52108,52109,52110,52111,52112,52113,52114,52115,52116,52117,52118,52119,52120,52121,52122,52123,52125,52126,52127,52128,52129,52130,52131,null,null,null,null,null,null,52132,52133,52134,52135,52136,52137,52138,52139,52140,52141,52142,52143,52144,52145,52146,52147,52148,52149,52150,52151,52153,52154,52155,52156,52157,52158,52159,52160,52161,52162,52163,52164,198,208,170,294,null,306,null,319,321,216,338,186,222,358,330,null,12896,12897,12898,12899,12900,12901,12902,12903,12904,12905,12906,12907,12908,12909,12910,12911,12912,12913,12914,12915,12916,12917,12918,12919,12920,12921,12922,12923,9424,9425,9426,9427,9428,9429,9430,9431,9432,9433,9434,9435,9436,9437,9438,9439,9440,9441,9442,9443,9444,9445,9446,9447,9448,9449,9312,9313,9314,9315,9316,9317,9318,9319,9320,9321,9322,9323,9324,9325,9326,189,8531,8532,188,190,8539,8540,8541,8542,52165,52166,52167,52168,52169,52170,52171,52172,52173,52174,52175,52176,52177,52178,52179,52181,52182,52183,52184,52185,52186,52187,52188,52189,52190,52191,null,null,null,null,null,null,52192,52193,52194,52195,52197,52198,52200,52202,52203,52204,52205,52206,52207,52208,52209,52210,52211,52212,52213,52214,52215,52216,52217,52218,52219,52220,null,null,null,null,null,null,52221,52222,52223,52224,52225,52226,52227,52228,52229,52230,52231,52232,52233,52234,52235,52238,52239,52241,52242,52243,52245,52246,52247,52248,52249,52250,52251,52254,52255,52256,52259,52260,230,273,240,295,305,307,312,320,322,248,339,223,254,359,331,329,12800,12801,12802,12803,12804,12805,12806,12807,12808,12809,12810,12811,12812,12813,12814,12815,12816,12817,12818,12819,12820,12821,12822,12823,12824,12825,12826,12827,9372,9373,9374,9375,9376,9377,9378,9379,9380,9381,9382,9383,9384,9385,9386,9387,9388,9389,9390,9391,9392,9393,9394,9395,9396,9397,9332,9333,9334,9335,9336,9337,9338,9339,9340,9341,9342,9343,9344,9345,9346,185,178,179,8308,8319,8321,8322,8323,8324,52261,52262,52266,52267,52269,52271,52273,52274,52275,52276,52277,52278,52279,52282,52287,52288,52289,52290,52291,52294,52295,52297,52298,52299,52301,52302,null,null,null,null,null,null,52303,52304,52305,52306,52307,52310,52314,52315,52316,52317,52318,52319,52321,52322,52323,52325,52327,52329,52330,52331,52332,52333,52334,52335,52337,52338,null,null,null,null,null,null,52339,52340,52342,52343,52344,52345,52346,52347,52348,52349,52350,52351,52352,52353,52354,52355,52356,52357,52358,52359,52360,52361,52362,52363,52364,52365,52366,52367,52368,52369,52370,52371,12353,12354,12355,12356,12357,12358,12359,12360,12361,12362,12363,12364,12365,12366,12367,12368,12369,12370,12371,12372,12373,12374,12375,12376,12377,12378,12379,12380,12381,12382,12383,12384,12385,12386,12387,12388,12389,12390,12391,12392,12393,12394,12395,12396,12397,12398,12399,12400,12401,12402,12403,12404,12405,12406,12407,12408,12409,12410,12411,12412,12413,12414,12415,12416,12417,12418,12419,12420,12421,12422,12423,12424,12425,12426,12427,12428,12429,12430,12431,12432,12433,12434,12435,null,null,null,null,null,null,null,null,null,null,null,52372,52373,52374,52375,52378,52379,52381,52382,52383,52385,52386,52387,52388,52389,52390,52391,52394,52398,52399,52400,52401,52402,52403,52406,52407,52409,null,null,null,null,null,null,52410,52411,52413,52414,52415,52416,52417,52418,52419,52422,52424,52426,52427,52428,52429,52430,52431,52433,52434,52435,52437,52438,52439,52440,52441,52442,null,null,null,null,null,null,52443,52444,52445,52446,52447,52448,52449,52450,52451,52453,52454,52455,52456,52457,52458,52459,52461,52462,52463,52465,52466,52467,52468,52469,52470,52471,52472,52473,52474,52475,52476,52477,12449,12450,12451,12452,12453,12454,12455,12456,12457,12458,12459,12460,12461,12462,12463,12464,12465,12466,12467,12468,12469,12470,12471,12472,12473,12474,12475,12476,12477,12478,12479,12480,12481,12482,12483,12484,12485,12486,12487,12488,12489,12490,12491,12492,12493,12494,12495,12496,12497,12498,12499,12500,12501,12502,12503,12504,12505,12506,12507,12508,12509,12510,12511,12512,12513,12514,12515,12516,12517,12518,12519,12520,12521,12522,12523,12524,12525,12526,12527,12528,12529,12530,12531,12532,12533,12534,null,null,null,null,null,null,null,null,52478,52479,52480,52482,52483,52484,52485,52486,52487,52490,52491,52493,52494,52495,52497,52498,52499,52500,52501,52502,52503,52506,52508,52510,52511,52512,null,null,null,null,null,null,52513,52514,52515,52517,52518,52519,52521,52522,52523,52525,52526,52527,52528,52529,52530,52531,52532,52533,52534,52535,52536,52538,52539,52540,52541,52542,null,null,null,null,null,null,52543,52544,52545,52546,52547,52548,52549,52550,52551,52552,52553,52554,52555,52556,52557,52558,52559,52560,52561,52562,52563,52564,52565,52566,52567,52568,52569,52570,52571,52573,52574,52575,1040,1041,1042,1043,1044,1045,1025,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,1072,1073,1074,1075,1076,1077,1105,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,null,null,null,null,null,null,null,null,null,null,null,null,null,52577,52578,52579,52581,52582,52583,52584,52585,52586,52587,52590,52592,52594,52595,52596,52597,52598,52599,52601,52602,52603,52604,52605,52606,52607,52608,null,null,null,null,null,null,52609,52610,52611,52612,52613,52614,52615,52617,52618,52619,52620,52621,52622,52623,52624,52625,52626,52627,52630,52631,52633,52634,52635,52637,52638,52639,null,null,null,null,null,null,52640,52641,52642,52643,52646,52648,52650,52651,52652,52653,52654,52655,52657,52658,52659,52660,52661,52662,52663,52664,52665,52666,52667,52668,52669,52670,52671,52672,52673,52674,52675,52677,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,52678,52679,52680,52681,52682,52683,52685,52686,52687,52689,52690,52691,52692,52693,52694,52695,52696,52697,52698,52699,52700,52701,52702,52703,52704,52705,null,null,null,null,null,null,52706,52707,52708,52709,52710,52711,52713,52714,52715,52717,52718,52719,52721,52722,52723,52724,52725,52726,52727,52730,52732,52734,52735,52736,52737,52738,null,null,null,null,null,null,52739,52741,52742,52743,52745,52746,52747,52749,52750,52751,52752,52753,52754,52755,52757,52758,52759,52760,52762,52763,52764,52765,52766,52767,52770,52771,52773,52774,52775,52777,52778,52779,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,52780,52781,52782,52783,52786,52788,52790,52791,52792,52793,52794,52795,52796,52797,52798,52799,52800,52801,52802,52803,52804,52805,52806,52807,52808,52809,null,null,null,null,null,null,52810,52811,52812,52813,52814,52815,52816,52817,52818,52819,52820,52821,52822,52823,52826,52827,52829,52830,52834,52835,52836,52837,52838,52839,52842,52844,null,null,null,null,null,null,52846,52847,52848,52849,52850,52851,52854,52855,52857,52858,52859,52861,52862,52863,52864,52865,52866,52867,52870,52872,52874,52875,52876,52877,52878,52879,52882,52883,52885,52886,52887,52889,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,52890,52891,52892,52893,52894,52895,52898,52902,52903,52904,52905,52906,52907,52910,52911,52912,52913,52914,52915,52916,52917,52918,52919,52920,52921,52922,null,null,null,null,null,null,52923,52924,52925,52926,52927,52928,52930,52931,52932,52933,52934,52935,52936,52937,52938,52939,52940,52941,52942,52943,52944,52945,52946,52947,52948,52949,null,null,null,null,null,null,52950,52951,52952,52953,52954,52955,52956,52957,52958,52959,52960,52961,52962,52963,52966,52967,52969,52970,52973,52974,52975,52976,52977,52978,52979,52982,52986,52987,52988,52989,52990,52991,44032,44033,44036,44039,44040,44041,44042,44048,44049,44050,44051,44052,44053,44054,44055,44057,44058,44059,44060,44061,44064,44068,44076,44077,44079,44080,44081,44088,44089,44092,44096,44107,44109,44116,44120,44124,44144,44145,44148,44151,44152,44154,44160,44161,44163,44164,44165,44166,44169,44170,44171,44172,44176,44180,44188,44189,44191,44192,44193,44200,44201,44202,44204,44207,44208,44216,44217,44219,44220,44221,44225,44228,44232,44236,44245,44247,44256,44257,44260,44263,44264,44266,44268,44271,44272,44273,44275,44277,44278,44284,44285,44288,44292,44294,52994,52995,52997,52998,52999,53001,53002,53003,53004,53005,53006,53007,53010,53012,53014,53015,53016,53017,53018,53019,53021,53022,53023,53025,53026,53027,null,null,null,null,null,null,53029,53030,53031,53032,53033,53034,53035,53038,53042,53043,53044,53045,53046,53047,53049,53050,53051,53052,53053,53054,53055,53056,53057,53058,53059,53060,null,null,null,null,null,null,53061,53062,53063,53064,53065,53066,53067,53068,53069,53070,53071,53072,53073,53074,53075,53078,53079,53081,53082,53083,53085,53086,53087,53088,53089,53090,53091,53094,53096,53098,53099,53100,44300,44301,44303,44305,44312,44316,44320,44329,44332,44333,44340,44341,44344,44348,44356,44357,44359,44361,44368,44372,44376,44385,44387,44396,44397,44400,44403,44404,44405,44406,44411,44412,44413,44415,44417,44418,44424,44425,44428,44432,44444,44445,44452,44471,44480,44481,44484,44488,44496,44497,44499,44508,44512,44516,44536,44537,44540,44543,44544,44545,44552,44553,44555,44557,44564,44592,44593,44596,44599,44600,44602,44608,44609,44611,44613,44614,44618,44620,44621,44622,44624,44628,44630,44636,44637,44639,44640,44641,44645,44648,44649,44652,44656,44664,53101,53102,53103,53106,53107,53109,53110,53111,53113,53114,53115,53116,53117,53118,53119,53121,53122,53123,53124,53126,53127,53128,53129,53130,53131,53133,null,null,null,null,null,null,53134,53135,53136,53137,53138,53139,53140,53141,53142,53143,53144,53145,53146,53147,53148,53149,53150,53151,53152,53154,53155,53156,53157,53158,53159,53161,null,null,null,null,null,null,53162,53163,53164,53165,53166,53167,53169,53170,53171,53172,53173,53174,53175,53176,53177,53178,53179,53180,53181,53182,53183,53184,53185,53186,53187,53189,53190,53191,53192,53193,53194,53195,44665,44667,44668,44669,44676,44677,44684,44732,44733,44734,44736,44740,44748,44749,44751,44752,44753,44760,44761,44764,44776,44779,44781,44788,44792,44796,44807,44808,44813,44816,44844,44845,44848,44850,44852,44860,44861,44863,44865,44866,44867,44872,44873,44880,44892,44893,44900,44901,44921,44928,44932,44936,44944,44945,44949,44956,44984,44985,44988,44992,44999,45000,45001,45003,45005,45006,45012,45020,45032,45033,45040,45041,45044,45048,45056,45057,45060,45068,45072,45076,45084,45085,45096,45124,45125,45128,45130,45132,45134,45139,45140,45141,45143,45145,53196,53197,53198,53199,53200,53201,53202,53203,53204,53205,53206,53207,53208,53209,53210,53211,53212,53213,53214,53215,53218,53219,53221,53222,53223,53225,null,null,null,null,null,null,53226,53227,53228,53229,53230,53231,53234,53236,53238,53239,53240,53241,53242,53243,53245,53246,53247,53249,53250,53251,53253,53254,53255,53256,53257,53258,null,null,null,null,null,null,53259,53260,53261,53262,53263,53264,53266,53267,53268,53269,53270,53271,53273,53274,53275,53276,53277,53278,53279,53280,53281,53282,53283,53284,53285,53286,53287,53288,53289,53290,53291,53292,45149,45180,45181,45184,45188,45196,45197,45199,45201,45208,45209,45210,45212,45215,45216,45217,45218,45224,45225,45227,45228,45229,45230,45231,45233,45235,45236,45237,45240,45244,45252,45253,45255,45256,45257,45264,45265,45268,45272,45280,45285,45320,45321,45323,45324,45328,45330,45331,45336,45337,45339,45340,45341,45347,45348,45349,45352,45356,45364,45365,45367,45368,45369,45376,45377,45380,45384,45392,45393,45396,45397,45400,45404,45408,45432,45433,45436,45440,45442,45448,45449,45451,45453,45458,45459,45460,45464,45468,45480,45516,45520,45524,45532,45533,53294,53295,53296,53297,53298,53299,53302,53303,53305,53306,53307,53309,53310,53311,53312,53313,53314,53315,53318,53320,53322,53323,53324,53325,53326,53327,null,null,null,null,null,null,53329,53330,53331,53333,53334,53335,53337,53338,53339,53340,53341,53342,53343,53345,53346,53347,53348,53349,53350,53351,53352,53353,53354,53355,53358,53359,null,null,null,null,null,null,53361,53362,53363,53365,53366,53367,53368,53369,53370,53371,53374,53375,53376,53378,53379,53380,53381,53382,53383,53384,53385,53386,53387,53388,53389,53390,53391,53392,53393,53394,53395,53396,45535,45544,45545,45548,45552,45561,45563,45565,45572,45573,45576,45579,45580,45588,45589,45591,45593,45600,45620,45628,45656,45660,45664,45672,45673,45684,45685,45692,45700,45701,45705,45712,45713,45716,45720,45721,45722,45728,45729,45731,45733,45734,45738,45740,45744,45748,45768,45769,45772,45776,45778,45784,45785,45787,45789,45794,45796,45797,45798,45800,45803,45804,45805,45806,45807,45811,45812,45813,45815,45816,45817,45818,45819,45823,45824,45825,45828,45832,45840,45841,45843,45844,45845,45852,45908,45909,45910,45912,45915,45916,45918,45919,45924,45925,53397,53398,53399,53400,53401,53402,53403,53404,53405,53406,53407,53408,53409,53410,53411,53414,53415,53417,53418,53419,53421,53422,53423,53424,53425,53426,null,null,null,null,null,null,53427,53430,53432,53434,53435,53436,53437,53438,53439,53442,53443,53445,53446,53447,53450,53451,53452,53453,53454,53455,53458,53462,53463,53464,53465,53466,null,null,null,null,null,null,53467,53470,53471,53473,53474,53475,53477,53478,53479,53480,53481,53482,53483,53486,53490,53491,53492,53493,53494,53495,53497,53498,53499,53500,53501,53502,53503,53504,53505,53506,53507,53508,45927,45929,45931,45934,45936,45937,45940,45944,45952,45953,45955,45956,45957,45964,45968,45972,45984,45985,45992,45996,46020,46021,46024,46027,46028,46030,46032,46036,46037,46039,46041,46043,46045,46048,46052,46056,46076,46096,46104,46108,46112,46120,46121,46123,46132,46160,46161,46164,46168,46176,46177,46179,46181,46188,46208,46216,46237,46244,46248,46252,46261,46263,46265,46272,46276,46280,46288,46293,46300,46301,46304,46307,46308,46310,46316,46317,46319,46321,46328,46356,46357,46360,46363,46364,46372,46373,46375,46376,46377,46378,46384,46385,46388,46392,53509,53510,53511,53512,53513,53514,53515,53516,53518,53519,53520,53521,53522,53523,53524,53525,53526,53527,53528,53529,53530,53531,53532,53533,53534,53535,null,null,null,null,null,null,53536,53537,53538,53539,53540,53541,53542,53543,53544,53545,53546,53547,53548,53549,53550,53551,53554,53555,53557,53558,53559,53561,53563,53564,53565,53566,null,null,null,null,null,null,53567,53570,53574,53575,53576,53577,53578,53579,53582,53583,53585,53586,53587,53589,53590,53591,53592,53593,53594,53595,53598,53600,53602,53603,53604,53605,53606,53607,53609,53610,53611,53613,46400,46401,46403,46404,46405,46411,46412,46413,46416,46420,46428,46429,46431,46432,46433,46496,46497,46500,46504,46506,46507,46512,46513,46515,46516,46517,46523,46524,46525,46528,46532,46540,46541,46543,46544,46545,46552,46572,46608,46609,46612,46616,46629,46636,46644,46664,46692,46696,46748,46749,46752,46756,46763,46764,46769,46804,46832,46836,46840,46848,46849,46853,46888,46889,46892,46895,46896,46904,46905,46907,46916,46920,46924,46932,46933,46944,46948,46952,46960,46961,46963,46965,46972,46973,46976,46980,46988,46989,46991,46992,46993,46994,46998,46999,53614,53615,53616,53617,53618,53619,53620,53621,53622,53623,53624,53625,53626,53627,53629,53630,53631,53632,53633,53634,53635,53637,53638,53639,53641,53642,null,null,null,null,null,null,53643,53644,53645,53646,53647,53648,53649,53650,53651,53652,53653,53654,53655,53656,53657,53658,53659,53660,53661,53662,53663,53666,53667,53669,53670,53671,null,null,null,null,null,null,53673,53674,53675,53676,53677,53678,53679,53682,53684,53686,53687,53688,53689,53691,53693,53694,53695,53697,53698,53699,53700,53701,53702,53703,53704,53705,53706,53707,53708,53709,53710,53711,47000,47001,47004,47008,47016,47017,47019,47020,47021,47028,47029,47032,47047,47049,47084,47085,47088,47092,47100,47101,47103,47104,47105,47111,47112,47113,47116,47120,47128,47129,47131,47133,47140,47141,47144,47148,47156,47157,47159,47160,47161,47168,47172,47185,47187,47196,47197,47200,47204,47212,47213,47215,47217,47224,47228,47245,47272,47280,47284,47288,47296,47297,47299,47301,47308,47312,47316,47325,47327,47329,47336,47337,47340,47344,47352,47353,47355,47357,47364,47384,47392,47420,47421,47424,47428,47436,47439,47441,47448,47449,47452,47456,47464,47465,53712,53713,53714,53715,53716,53717,53718,53719,53721,53722,53723,53724,53725,53726,53727,53728,53729,53730,53731,53732,53733,53734,53735,53736,53737,53738,null,null,null,null,null,null,53739,53740,53741,53742,53743,53744,53745,53746,53747,53749,53750,53751,53753,53754,53755,53756,53757,53758,53759,53760,53761,53762,53763,53764,53765,53766,null,null,null,null,null,null,53768,53770,53771,53772,53773,53774,53775,53777,53778,53779,53780,53781,53782,53783,53784,53785,53786,53787,53788,53789,53790,53791,53792,53793,53794,53795,53796,53797,53798,53799,53800,53801,47467,47469,47476,47477,47480,47484,47492,47493,47495,47497,47498,47501,47502,47532,47533,47536,47540,47548,47549,47551,47553,47560,47561,47564,47566,47567,47568,47569,47570,47576,47577,47579,47581,47582,47585,47587,47588,47589,47592,47596,47604,47605,47607,47608,47609,47610,47616,47617,47624,47637,47672,47673,47676,47680,47682,47688,47689,47691,47693,47694,47699,47700,47701,47704,47708,47716,47717,47719,47720,47721,47728,47729,47732,47736,47747,47748,47749,47751,47756,47784,47785,47787,47788,47792,47794,47800,47801,47803,47805,47812,47816,47832,47833,47868,53802,53803,53806,53807,53809,53810,53811,53813,53814,53815,53816,53817,53818,53819,53822,53824,53826,53827,53828,53829,53830,53831,53833,53834,53835,53836,null,null,null,null,null,null,53837,53838,53839,53840,53841,53842,53843,53844,53845,53846,53847,53848,53849,53850,53851,53853,53854,53855,53856,53857,53858,53859,53861,53862,53863,53864,null,null,null,null,null,null,53865,53866,53867,53868,53869,53870,53871,53872,53873,53874,53875,53876,53877,53878,53879,53880,53881,53882,53883,53884,53885,53886,53887,53890,53891,53893,53894,53895,53897,53898,53899,53900,47872,47876,47885,47887,47889,47896,47900,47904,47913,47915,47924,47925,47926,47928,47931,47932,47933,47934,47940,47941,47943,47945,47949,47951,47952,47956,47960,47969,47971,47980,48008,48012,48016,48036,48040,48044,48052,48055,48064,48068,48072,48080,48083,48120,48121,48124,48127,48128,48130,48136,48137,48139,48140,48141,48143,48145,48148,48149,48150,48151,48152,48155,48156,48157,48158,48159,48164,48165,48167,48169,48173,48176,48177,48180,48184,48192,48193,48195,48196,48197,48201,48204,48205,48208,48221,48260,48261,48264,48267,48268,48270,48276,48277,48279,53901,53902,53903,53906,53907,53908,53910,53911,53912,53913,53914,53915,53917,53918,53919,53921,53922,53923,53925,53926,53927,53928,53929,53930,53931,53933,null,null,null,null,null,null,53934,53935,53936,53938,53939,53940,53941,53942,53943,53946,53947,53949,53950,53953,53955,53956,53957,53958,53959,53962,53964,53965,53966,53967,53968,53969,null,null,null,null,null,null,53970,53971,53973,53974,53975,53977,53978,53979,53981,53982,53983,53984,53985,53986,53987,53990,53991,53992,53993,53994,53995,53996,53997,53998,53999,54002,54003,54005,54006,54007,54009,54010,48281,48282,48288,48289,48292,48295,48296,48304,48305,48307,48308,48309,48316,48317,48320,48324,48333,48335,48336,48337,48341,48344,48348,48372,48373,48374,48376,48380,48388,48389,48391,48393,48400,48404,48420,48428,48448,48456,48457,48460,48464,48472,48473,48484,48488,48512,48513,48516,48519,48520,48521,48522,48528,48529,48531,48533,48537,48538,48540,48548,48560,48568,48596,48597,48600,48604,48617,48624,48628,48632,48640,48643,48645,48652,48653,48656,48660,48668,48669,48671,48708,48709,48712,48716,48718,48724,48725,48727,48729,48730,48731,48736,48737,48740,54011,54012,54013,54014,54015,54018,54020,54022,54023,54024,54025,54026,54027,54031,54033,54034,54035,54037,54039,54040,54041,54042,54043,54046,54050,54051,null,null,null,null,null,null,54052,54054,54055,54058,54059,54061,54062,54063,54065,54066,54067,54068,54069,54070,54071,54074,54078,54079,54080,54081,54082,54083,54086,54087,54088,54089,null,null,null,null,null,null,54090,54091,54092,54093,54094,54095,54096,54097,54098,54099,54100,54101,54102,54103,54104,54105,54106,54107,54108,54109,54110,54111,54112,54113,54114,54115,54116,54117,54118,54119,54120,54121,48744,48746,48752,48753,48755,48756,48757,48763,48764,48765,48768,48772,48780,48781,48783,48784,48785,48792,48793,48808,48848,48849,48852,48855,48856,48864,48867,48868,48869,48876,48897,48904,48905,48920,48921,48923,48924,48925,48960,48961,48964,48968,48976,48977,48981,49044,49072,49093,49100,49101,49104,49108,49116,49119,49121,49212,49233,49240,49244,49248,49256,49257,49296,49297,49300,49304,49312,49313,49315,49317,49324,49325,49327,49328,49331,49332,49333,49334,49340,49341,49343,49344,49345,49349,49352,49353,49356,49360,49368,49369,49371,49372,49373,49380,54122,54123,54124,54125,54126,54127,54128,54129,54130,54131,54132,54133,54134,54135,54136,54137,54138,54139,54142,54143,54145,54146,54147,54149,54150,54151,null,null,null,null,null,null,54152,54153,54154,54155,54158,54162,54163,54164,54165,54166,54167,54170,54171,54173,54174,54175,54177,54178,54179,54180,54181,54182,54183,54186,54188,54190,null,null,null,null,null,null,54191,54192,54193,54194,54195,54197,54198,54199,54201,54202,54203,54205,54206,54207,54208,54209,54210,54211,54214,54215,54218,54219,54220,54221,54222,54223,54225,54226,54227,54228,54229,54230,49381,49384,49388,49396,49397,49399,49401,49408,49412,49416,49424,49429,49436,49437,49438,49439,49440,49443,49444,49446,49447,49452,49453,49455,49456,49457,49462,49464,49465,49468,49472,49480,49481,49483,49484,49485,49492,49493,49496,49500,49508,49509,49511,49512,49513,49520,49524,49528,49541,49548,49549,49550,49552,49556,49558,49564,49565,49567,49569,49573,49576,49577,49580,49584,49597,49604,49608,49612,49620,49623,49624,49632,49636,49640,49648,49649,49651,49660,49661,49664,49668,49676,49677,49679,49681,49688,49689,49692,49695,49696,49704,49705,49707,49709,54231,54233,54234,54235,54236,54237,54238,54239,54240,54242,54244,54245,54246,54247,54248,54249,54250,54251,54254,54255,54257,54258,54259,54261,54262,54263,null,null,null,null,null,null,54264,54265,54266,54267,54270,54272,54274,54275,54276,54277,54278,54279,54281,54282,54283,54284,54285,54286,54287,54288,54289,54290,54291,54292,54293,54294,null,null,null,null,null,null,54295,54296,54297,54298,54299,54300,54302,54303,54304,54305,54306,54307,54308,54309,54310,54311,54312,54313,54314,54315,54316,54317,54318,54319,54320,54321,54322,54323,54324,54325,54326,54327,49711,49713,49714,49716,49736,49744,49745,49748,49752,49760,49765,49772,49773,49776,49780,49788,49789,49791,49793,49800,49801,49808,49816,49819,49821,49828,49829,49832,49836,49837,49844,49845,49847,49849,49884,49885,49888,49891,49892,49899,49900,49901,49903,49905,49910,49912,49913,49915,49916,49920,49928,49929,49932,49933,49939,49940,49941,49944,49948,49956,49957,49960,49961,49989,50024,50025,50028,50032,50034,50040,50041,50044,50045,50052,50056,50060,50112,50136,50137,50140,50143,50144,50146,50152,50153,50157,50164,50165,50168,50184,50192,50212,50220,50224,54328,54329,54330,54331,54332,54333,54334,54335,54337,54338,54339,54341,54342,54343,54344,54345,54346,54347,54348,54349,54350,54351,54352,54353,54354,54355,null,null,null,null,null,null,54356,54357,54358,54359,54360,54361,54362,54363,54365,54366,54367,54369,54370,54371,54373,54374,54375,54376,54377,54378,54379,54380,54382,54384,54385,54386,null,null,null,null,null,null,54387,54388,54389,54390,54391,54394,54395,54397,54398,54401,54403,54404,54405,54406,54407,54410,54412,54414,54415,54416,54417,54418,54419,54421,54422,54423,54424,54425,54426,54427,54428,54429,50228,50236,50237,50248,50276,50277,50280,50284,50292,50293,50297,50304,50324,50332,50360,50364,50409,50416,50417,50420,50424,50426,50431,50432,50433,50444,50448,50452,50460,50472,50473,50476,50480,50488,50489,50491,50493,50500,50501,50504,50505,50506,50508,50509,50510,50515,50516,50517,50519,50520,50521,50525,50526,50528,50529,50532,50536,50544,50545,50547,50548,50549,50556,50557,50560,50564,50567,50572,50573,50575,50577,50581,50583,50584,50588,50592,50601,50612,50613,50616,50617,50619,50620,50621,50622,50628,50629,50630,50631,50632,50633,50634,50636,50638,54430,54431,54432,54433,54434,54435,54436,54437,54438,54439,54440,54442,54443,54444,54445,54446,54447,54448,54449,54450,54451,54452,54453,54454,54455,54456,null,null,null,null,null,null,54457,54458,54459,54460,54461,54462,54463,54464,54465,54466,54467,54468,54469,54470,54471,54472,54473,54474,54475,54477,54478,54479,54481,54482,54483,54485,null,null,null,null,null,null,54486,54487,54488,54489,54490,54491,54493,54494,54496,54497,54498,54499,54500,54501,54502,54503,54505,54506,54507,54509,54510,54511,54513,54514,54515,54516,54517,54518,54519,54521,54522,54524,50640,50641,50644,50648,50656,50657,50659,50661,50668,50669,50670,50672,50676,50678,50679,50684,50685,50686,50687,50688,50689,50693,50694,50695,50696,50700,50704,50712,50713,50715,50716,50724,50725,50728,50732,50733,50734,50736,50739,50740,50741,50743,50745,50747,50752,50753,50756,50760,50768,50769,50771,50772,50773,50780,50781,50784,50796,50799,50801,50808,50809,50812,50816,50824,50825,50827,50829,50836,50837,50840,50844,50852,50853,50855,50857,50864,50865,50868,50872,50873,50874,50880,50881,50883,50885,50892,50893,50896,50900,50908,50909,50912,50913,50920,54526,54527,54528,54529,54530,54531,54533,54534,54535,54537,54538,54539,54541,54542,54543,54544,54545,54546,54547,54550,54552,54553,54554,54555,54556,54557,null,null,null,null,null,null,54558,54559,54560,54561,54562,54563,54564,54565,54566,54567,54568,54569,54570,54571,54572,54573,54574,54575,54576,54577,54578,54579,54580,54581,54582,54583,null,null,null,null,null,null,54584,54585,54586,54587,54590,54591,54593,54594,54595,54597,54598,54599,54600,54601,54602,54603,54606,54608,54610,54611,54612,54613,54614,54615,54618,54619,54621,54622,54623,54625,54626,54627,50921,50924,50928,50936,50937,50941,50948,50949,50952,50956,50964,50965,50967,50969,50976,50977,50980,50984,50992,50993,50995,50997,50999,51004,51005,51008,51012,51018,51020,51021,51023,51025,51026,51027,51028,51029,51030,51031,51032,51036,51040,51048,51051,51060,51061,51064,51068,51069,51070,51075,51076,51077,51079,51080,51081,51082,51086,51088,51089,51092,51094,51095,51096,51098,51104,51105,51107,51108,51109,51110,51116,51117,51120,51124,51132,51133,51135,51136,51137,51144,51145,51148,51150,51152,51160,51165,51172,51176,51180,51200,51201,51204,51208,51210,54628,54630,54631,54634,54636,54638,54639,54640,54641,54642,54643,54646,54647,54649,54650,54651,54653,54654,54655,54656,54657,54658,54659,54662,54666,54667,null,null,null,null,null,null,54668,54669,54670,54671,54673,54674,54675,54676,54677,54678,54679,54680,54681,54682,54683,54684,54685,54686,54687,54688,54689,54690,54691,54692,54694,54695,null,null,null,null,null,null,54696,54697,54698,54699,54700,54701,54702,54703,54704,54705,54706,54707,54708,54709,54710,54711,54712,54713,54714,54715,54716,54717,54718,54719,54720,54721,54722,54723,54724,54725,54726,54727,51216,51217,51219,51221,51222,51228,51229,51232,51236,51244,51245,51247,51249,51256,51260,51264,51272,51273,51276,51277,51284,51312,51313,51316,51320,51322,51328,51329,51331,51333,51334,51335,51339,51340,51341,51348,51357,51359,51361,51368,51388,51389,51396,51400,51404,51412,51413,51415,51417,51424,51425,51428,51445,51452,51453,51456,51460,51461,51462,51468,51469,51471,51473,51480,51500,51508,51536,51537,51540,51544,51552,51553,51555,51564,51568,51572,51580,51592,51593,51596,51600,51608,51609,51611,51613,51648,51649,51652,51655,51656,51658,51664,51665,51667,54730,54731,54733,54734,54735,54737,54739,54740,54741,54742,54743,54746,54748,54750,54751,54752,54753,54754,54755,54758,54759,54761,54762,54763,54765,54766,null,null,null,null,null,null,54767,54768,54769,54770,54771,54774,54776,54778,54779,54780,54781,54782,54783,54786,54787,54789,54790,54791,54793,54794,54795,54796,54797,54798,54799,54802,null,null,null,null,null,null,54806,54807,54808,54809,54810,54811,54813,54814,54815,54817,54818,54819,54821,54822,54823,54824,54825,54826,54827,54828,54830,54831,54832,54833,54834,54835,54836,54837,54838,54839,54842,54843,51669,51670,51673,51674,51676,51677,51680,51682,51684,51687,51692,51693,51695,51696,51697,51704,51705,51708,51712,51720,51721,51723,51724,51725,51732,51736,51753,51788,51789,51792,51796,51804,51805,51807,51808,51809,51816,51837,51844,51864,51900,51901,51904,51908,51916,51917,51919,51921,51923,51928,51929,51936,51948,51956,51976,51984,51988,51992,52000,52001,52033,52040,52041,52044,52048,52056,52057,52061,52068,52088,52089,52124,52152,52180,52196,52199,52201,52236,52237,52240,52244,52252,52253,52257,52258,52263,52264,52265,52268,52270,52272,52280,52281,52283,54845,54846,54847,54849,54850,54851,54852,54854,54855,54858,54860,54862,54863,54864,54866,54867,54870,54871,54873,54874,54875,54877,54878,54879,54880,54881,null,null,null,null,null,null,54882,54883,54884,54885,54886,54888,54890,54891,54892,54893,54894,54895,54898,54899,54901,54902,54903,54904,54905,54906,54907,54908,54909,54910,54911,54912,null,null,null,null,null,null,54913,54914,54916,54918,54919,54920,54921,54922,54923,54926,54927,54929,54930,54931,54933,54934,54935,54936,54937,54938,54939,54940,54942,54944,54946,54947,54948,54949,54950,54951,54953,54954,52284,52285,52286,52292,52293,52296,52300,52308,52309,52311,52312,52313,52320,52324,52326,52328,52336,52341,52376,52377,52380,52384,52392,52393,52395,52396,52397,52404,52405,52408,52412,52420,52421,52423,52425,52432,52436,52452,52460,52464,52481,52488,52489,52492,52496,52504,52505,52507,52509,52516,52520,52524,52537,52572,52576,52580,52588,52589,52591,52593,52600,52616,52628,52629,52632,52636,52644,52645,52647,52649,52656,52676,52684,52688,52712,52716,52720,52728,52729,52731,52733,52740,52744,52748,52756,52761,52768,52769,52772,52776,52784,52785,52787,52789,54955,54957,54958,54959,54961,54962,54963,54964,54965,54966,54967,54968,54970,54972,54973,54974,54975,54976,54977,54978,54979,54982,54983,54985,54986,54987,null,null,null,null,null,null,54989,54990,54991,54992,54994,54995,54997,54998,55000,55002,55003,55004,55005,55006,55007,55009,55010,55011,55013,55014,55015,55017,55018,55019,55020,55021,null,null,null,null,null,null,55022,55023,55025,55026,55027,55028,55030,55031,55032,55033,55034,55035,55038,55039,55041,55042,55043,55045,55046,55047,55048,55049,55050,55051,55052,55053,55054,55055,55056,55058,55059,55060,52824,52825,52828,52831,52832,52833,52840,52841,52843,52845,52852,52853,52856,52860,52868,52869,52871,52873,52880,52881,52884,52888,52896,52897,52899,52900,52901,52908,52909,52929,52964,52965,52968,52971,52972,52980,52981,52983,52984,52985,52992,52993,52996,53000,53008,53009,53011,53013,53020,53024,53028,53036,53037,53039,53040,53041,53048,53076,53077,53080,53084,53092,53093,53095,53097,53104,53105,53108,53112,53120,53125,53132,53153,53160,53168,53188,53216,53217,53220,53224,53232,53233,53235,53237,53244,53248,53252,53265,53272,53293,53300,53301,53304,53308,55061,55062,55063,55066,55067,55069,55070,55071,55073,55074,55075,55076,55077,55078,55079,55082,55084,55086,55087,55088,55089,55090,55091,55094,55095,55097,null,null,null,null,null,null,55098,55099,55101,55102,55103,55104,55105,55106,55107,55109,55110,55112,55114,55115,55116,55117,55118,55119,55122,55123,55125,55130,55131,55132,55133,55134,null,null,null,null,null,null,55135,55138,55140,55142,55143,55144,55146,55147,55149,55150,55151,55153,55154,55155,55157,55158,55159,55160,55161,55162,55163,55166,55167,55168,55170,55171,55172,55173,55174,55175,55178,55179,53316,53317,53319,53321,53328,53332,53336,53344,53356,53357,53360,53364,53372,53373,53377,53412,53413,53416,53420,53428,53429,53431,53433,53440,53441,53444,53448,53449,53456,53457,53459,53460,53461,53468,53469,53472,53476,53484,53485,53487,53488,53489,53496,53517,53552,53553,53556,53560,53562,53568,53569,53571,53572,53573,53580,53581,53584,53588,53596,53597,53599,53601,53608,53612,53628,53636,53640,53664,53665,53668,53672,53680,53681,53683,53685,53690,53692,53696,53720,53748,53752,53767,53769,53776,53804,53805,53808,53812,53820,53821,53823,53825,53832,53852,55181,55182,55183,55185,55186,55187,55188,55189,55190,55191,55194,55196,55198,55199,55200,55201,55202,55203,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,53860,53888,53889,53892,53896,53904,53905,53909,53916,53920,53924,53932,53937,53944,53945,53948,53951,53952,53954,53960,53961,53963,53972,53976,53980,53988,53989,54000,54001,54004,54008,54016,54017,54019,54021,54028,54029,54030,54032,54036,54038,54044,54045,54047,54048,54049,54053,54056,54057,54060,54064,54072,54073,54075,54076,54077,54084,54085,54140,54141,54144,54148,54156,54157,54159,54160,54161,54168,54169,54172,54176,54184,54185,54187,54189,54196,54200,54204,54212,54213,54216,54217,54224,54232,54241,54243,54252,54253,54256,54260,54268,54269,54271,54273,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,54280,54301,54336,54340,54364,54368,54372,54381,54383,54392,54393,54396,54399,54400,54402,54408,54409,54411,54413,54420,54441,54476,54480,54484,54492,54495,54504,54508,54512,54520,54523,54525,54532,54536,54540,54548,54549,54551,54588,54589,54592,54596,54604,54605,54607,54609,54616,54617,54620,54624,54629,54632,54633,54635,54637,54644,54645,54648,54652,54660,54661,54663,54664,54665,54672,54693,54728,54729,54732,54736,54738,54744,54745,54747,54749,54756,54757,54760,54764,54772,54773,54775,54777,54784,54785,54788,54792,54800,54801,54803,54804,54805,54812,54816,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,54820,54829,54840,54841,54844,54848,54853,54856,54857,54859,54861,54865,54868,54869,54872,54876,54887,54889,54896,54897,54900,54915,54917,54924,54925,54928,54932,54941,54943,54945,54952,54956,54960,54969,54971,54980,54981,54984,54988,54993,54996,54999,55001,55008,55012,55016,55024,55029,55036,55037,55040,55044,55057,55064,55065,55068,55072,55080,55081,55083,55085,55092,55093,55096,55100,55108,55111,55113,55120,55121,55124,55126,55127,55128,55129,55136,55137,55139,55141,55145,55148,55152,55156,55164,55165,55169,55176,55177,55180,55184,55192,55193,55195,55197,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,20285,20339,20551,20729,21152,21487,21621,21733,22025,23233,23478,26247,26550,26551,26607,27468,29634,30146,31292,33499,33540,34903,34952,35382,36040,36303,36603,36838,39381,21051,21364,21508,24682,24932,27580,29647,33050,35258,35282,38307,20355,21002,22718,22904,23014,24178,24185,25031,25536,26438,26604,26751,28567,30286,30475,30965,31240,31487,31777,32925,33390,33393,35563,38291,20075,21917,26359,28212,30883,31469,33883,35088,34638,38824,21208,22350,22570,23884,24863,25022,25121,25954,26577,27204,28187,29976,30131,30435,30640,32058,37039,37969,37970,40853,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,21283,23724,30002,32987,37440,38296,21083,22536,23004,23713,23831,24247,24378,24394,24951,27743,30074,30086,31968,32115,32177,32652,33108,33313,34193,35137,35611,37628,38477,40007,20171,20215,20491,20977,22607,24887,24894,24936,25913,27114,28433,30117,30342,30422,31623,33445,33995,63744,37799,38283,21888,23458,22353,63745,31923,32697,37301,20520,21435,23621,24040,25298,25454,25818,25831,28192,28844,31067,36317,36382,63746,36989,37445,37624,20094,20214,20581,24062,24314,24838,26967,33137,34388,36423,37749,39467,20062,20625,26480,26688,20745,21133,21138,27298,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,30652,37392,40660,21163,24623,36850,20552,25001,25581,25802,26684,27268,28608,33160,35233,38548,22533,29309,29356,29956,32121,32365,32937,35211,35700,36963,40273,25225,27770,28500,32080,32570,35363,20860,24906,31645,35609,37463,37772,20140,20435,20510,20670,20742,21185,21197,21375,22384,22659,24218,24465,24950,25004,25806,25964,26223,26299,26356,26775,28039,28805,28913,29855,29861,29898,30169,30828,30956,31455,31478,32069,32147,32789,32831,33051,33686,35686,36629,36885,37857,38915,38968,39514,39912,20418,21843,22586,22865,23395,23622,24760,25106,26690,26800,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,26856,28330,30028,30328,30926,31293,31995,32363,32380,35336,35489,35903,38542,40388,21476,21481,21578,21617,22266,22993,23396,23611,24235,25335,25911,25925,25970,26272,26543,27073,27837,30204,30352,30590,31295,32660,32771,32929,33167,33510,33533,33776,34241,34865,34996,35493,63747,36764,37678,38599,39015,39640,40723,21741,26011,26354,26767,31296,35895,40288,22256,22372,23825,26118,26801,26829,28414,29736,34974,39908,27752,63748,39592,20379,20844,20849,21151,23380,24037,24656,24685,25329,25511,25915,29657,31354,34467,36002,38799,20018,23521,25096,26524,29916,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,31185,33747,35463,35506,36328,36942,37707,38982,24275,27112,34303,37101,63749,20896,23448,23532,24931,26874,27454,28748,29743,29912,31649,32592,33733,35264,36011,38364,39208,21038,24669,25324,36866,20362,20809,21281,22745,24291,26336,27960,28826,29378,29654,31568,33009,37979,21350,25499,32619,20054,20608,22602,22750,24618,24871,25296,27088,39745,23439,32024,32945,36703,20132,20689,21676,21932,23308,23968,24039,25898,25934,26657,27211,29409,30350,30703,32094,32761,33184,34126,34527,36611,36686,37066,39171,39509,39851,19992,20037,20061,20167,20465,20855,21246,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,21312,21475,21477,21646,22036,22389,22434,23495,23943,24272,25084,25304,25937,26552,26601,27083,27472,27590,27628,27714,28317,28792,29399,29590,29699,30655,30697,31350,32127,32777,33276,33285,33290,33503,34914,35635,36092,36544,36881,37041,37476,37558,39378,39493,40169,40407,40860,22283,23616,33738,38816,38827,40628,21531,31384,32676,35033,36557,37089,22528,23624,25496,31391,23470,24339,31353,31406,33422,36524,20518,21048,21240,21367,22280,25331,25458,27402,28099,30519,21413,29527,34152,36470,38357,26426,27331,28528,35437,36556,39243,63750,26231,27512,36020,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,39740,63751,21483,22317,22862,25542,27131,29674,30789,31418,31429,31998,33909,35215,36211,36917,38312,21243,22343,30023,31584,33740,37406,63752,27224,20811,21067,21127,25119,26840,26997,38553,20677,21156,21220,25027,26020,26681,27135,29822,31563,33465,33771,35250,35641,36817,39241,63753,20170,22935,25810,26129,27278,29748,31105,31165,33449,34942,34943,35167,63754,37670,20235,21450,24613,25201,27762,32026,32102,20120,20834,30684,32943,20225,20238,20854,20864,21980,22120,22331,22522,22524,22804,22855,22931,23492,23696,23822,24049,24190,24524,25216,26071,26083,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,26398,26399,26462,26827,26820,27231,27450,27683,27773,27778,28103,29592,29734,29738,29826,29859,30072,30079,30849,30959,31041,31047,31048,31098,31637,32000,32186,32648,32774,32813,32908,35352,35663,35912,36215,37665,37668,39138,39249,39438,39439,39525,40594,32202,20342,21513,25326,26708,37329,21931,20794,63755,63756,23068,25062,63757,25295,25343,63758,63759,63760,63761,63762,63763,37027,63764,63765,63766,63767,63768,35582,63769,63770,63771,63772,26262,63773,29014,63774,63775,38627,63776,25423,25466,21335,63777,26511,26976,28275,63778,30007,63779,63780,63781,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,32013,63782,63783,34930,22218,23064,63784,63785,63786,63787,63788,20035,63789,20839,22856,26608,32784,63790,22899,24180,25754,31178,24565,24684,25288,25467,23527,23511,21162,63791,22900,24361,24594,63792,63793,63794,29785,63795,63796,63797,63798,63799,63800,39377,63801,63802,63803,63804,63805,63806,63807,63808,63809,63810,63811,28611,63812,63813,33215,36786,24817,63814,63815,33126,63816,63817,23615,63818,63819,63820,63821,63822,63823,63824,63825,23273,35365,26491,32016,63826,63827,63828,63829,63830,63831,33021,63832,63833,23612,27877,21311,28346,22810,33590,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,20025,20150,20294,21934,22296,22727,24406,26039,26086,27264,27573,28237,30701,31471,31774,32222,34507,34962,37170,37723,25787,28606,29562,30136,36948,21846,22349,25018,25812,26311,28129,28251,28525,28601,30192,32835,33213,34113,35203,35527,35674,37663,27795,30035,31572,36367,36957,21776,22530,22616,24162,25095,25758,26848,30070,31958,34739,40680,20195,22408,22382,22823,23565,23729,24118,24453,25140,25825,29619,33274,34955,36024,38538,40667,23429,24503,24755,20498,20992,21040,22294,22581,22615,23566,23648,23798,23947,24230,24466,24764,25361,25481,25623,26691,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,26873,27330,28120,28193,28372,28644,29182,30428,30585,31153,31291,33796,35241,36077,36339,36424,36867,36884,36947,37117,37709,38518,38876,27602,28678,29272,29346,29544,30563,31167,31716,32411,35712,22697,24775,25958,26109,26302,27788,28958,29129,35930,38931,20077,31361,20189,20908,20941,21205,21516,24999,26481,26704,26847,27934,28540,30140,30643,31461,33012,33891,37509,20828,26007,26460,26515,30168,31431,33651,63834,35910,36887,38957,23663,33216,33434,36929,36975,37389,24471,23965,27225,29128,30331,31561,34276,35588,37159,39472,21895,25078,63835,30313,32645,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,34367,34746,35064,37007,63836,27931,28889,29662,32097,33853,63837,37226,39409,63838,20098,21365,27396,27410,28734,29211,34349,40478,21068,36771,23888,25829,25900,27414,28651,31811,32412,34253,35172,35261,25289,33240,34847,24266,26391,28010,29436,29701,29807,34690,37086,20358,23821,24480,33802,20919,25504,30053,20142,20486,20841,20937,26753,27153,31918,31921,31975,33391,35538,36635,37327,20406,20791,21237,21570,24300,24942,25150,26053,27354,28670,31018,34268,34851,38317,39522,39530,40599,40654,21147,26310,27511,28701,31019,36706,38722,24976,25088,25891,28451,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,29001,29833,32244,32879,34030,36646,36899,37706,20925,21015,21155,27916,28872,35010,24265,25986,27566,28610,31806,29557,20196,20278,22265,63839,23738,23994,24604,29618,31533,32666,32718,32838,36894,37428,38646,38728,38936,40801,20363,28583,31150,37300,38583,21214,63840,25736,25796,27347,28510,28696,29200,30439,32769,34310,34396,36335,36613,38706,39791,40442,40565,30860,31103,32160,33737,37636,40575,40595,35542,22751,24324,26407,28711,29903,31840,32894,20769,28712,29282,30922,36034,36058,36084,38647,20102,20698,23534,24278,26009,29134,30274,30637,32842,34044,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,36988,39719,40845,22744,23105,23650,27155,28122,28431,30267,32047,32311,34078,35128,37860,38475,21129,26066,26611,27060,27969,28316,28687,29705,29792,30041,30244,30827,35628,39006,20845,25134,38520,20374,20523,23833,28138,32184,36650,24459,24900,26647,63841,38534,21202,32907,20956,20940,26974,31260,32190,33777,38517,20442,21033,21400,21519,21774,23653,24743,26446,26792,28012,29313,29432,29702,29827,63842,30178,31852,32633,32696,33673,35023,35041,37324,37328,38626,39881,21533,28542,29136,29848,34298,36522,38563,40023,40607,26519,28107,29747,33256,38678,30764,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,31435,31520,31890,25705,29802,30194,30908,30952,39340,39764,40635,23518,24149,28448,33180,33707,37000,19975,21325,23081,24018,24398,24930,25405,26217,26364,28415,28459,28771,30622,33836,34067,34875,36627,39237,39995,21788,25273,26411,27819,33545,35178,38778,20129,22916,24536,24537,26395,32178,32596,33426,33579,33725,36638,37017,22475,22969,23186,23504,26151,26522,26757,27599,29028,32629,36023,36067,36993,39749,33032,35978,38476,39488,40613,23391,27667,29467,30450,30431,33804,20906,35219,20813,20885,21193,26825,27796,30468,30496,32191,32236,38754,40629,28357,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,34065,20901,21517,21629,26126,26269,26919,28319,30399,30609,33559,33986,34719,37225,37528,40180,34946,20398,20882,21215,22982,24125,24917,25720,25721,26286,26576,27169,27597,27611,29279,29281,29761,30520,30683,32791,33468,33541,35584,35624,35980,26408,27792,29287,30446,30566,31302,40361,27519,27794,22818,26406,33945,21359,22675,22937,24287,25551,26164,26483,28218,29483,31447,33495,37672,21209,24043,25006,25035,25098,25287,25771,26080,26969,27494,27595,28961,29687,30045,32326,33310,33538,34154,35491,36031,38695,40289,22696,40664,20497,21006,21563,21839,25991,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,27766,32010,32011,32862,34442,38272,38639,21247,27797,29289,21619,23194,23614,23883,24396,24494,26410,26806,26979,28220,28228,30473,31859,32654,34183,35598,36855,38753,40692,23735,24758,24845,25003,25935,26107,26108,27665,27887,29599,29641,32225,38292,23494,34588,35600,21085,21338,25293,25615,25778,26420,27192,27850,29632,29854,31636,31893,32283,33162,33334,34180,36843,38649,39361,20276,21322,21453,21467,25292,25644,25856,26001,27075,27886,28504,29677,30036,30242,30436,30460,30928,30971,31020,32070,33324,34784,36820,38930,39151,21187,25300,25765,28196,28497,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,30332,36299,37297,37474,39662,39747,20515,20621,22346,22952,23592,24135,24439,25151,25918,26041,26049,26121,26507,27036,28354,30917,32033,32938,33152,33323,33459,33953,34444,35370,35607,37030,38450,40848,20493,20467,63843,22521,24472,25308,25490,26479,28227,28953,30403,32972,32986,35060,35061,35097,36064,36649,37197,38506,20271,20336,24091,26575,26658,30333,30334,39748,24161,27146,29033,29140,30058,63844,32321,34115,34281,39132,20240,31567,32624,38309,20961,24070,26805,27710,27726,27867,29359,31684,33539,27861,29754,20731,21128,22721,25816,27287,29863,30294,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,30887,34327,38370,38713,63845,21342,24321,35722,36776,36783,37002,21029,30629,40009,40712,19993,20482,20853,23643,24183,26142,26170,26564,26821,28851,29953,30149,31177,31453,36647,39200,39432,20445,22561,22577,23542,26222,27493,27921,28282,28541,29668,29995,33769,35036,35091,35676,36628,20239,20693,21264,21340,23443,24489,26381,31119,33145,33583,34068,35079,35206,36665,36667,39333,39954,26412,20086,20472,22857,23553,23791,23792,25447,26834,28925,29090,29739,32299,34028,34562,36898,37586,40179,19981,20184,20463,20613,21078,21103,21542,21648,22496,22827,23142,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,23386,23413,23500,24220,63846,25206,25975,26023,28014,28325,29238,31526,31807,32566,33104,33105,33178,33344,33433,33705,35331,36000,36070,36091,36212,36282,37096,37340,38428,38468,39385,40167,21271,20998,21545,22132,22707,22868,22894,24575,24996,25198,26128,27774,28954,30406,31881,31966,32027,33452,36033,38640,63847,20315,24343,24447,25282,23849,26379,26842,30844,32323,40300,19989,20633,21269,21290,21329,22915,23138,24199,24754,24970,25161,25209,26000,26503,27047,27604,27606,27607,27608,27832,63848,29749,30202,30738,30865,31189,31192,31875,32203,32737,32933,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,33086,33218,33778,34586,35048,35513,35692,36027,37145,38750,39131,40763,22188,23338,24428,25996,27315,27567,27996,28657,28693,29277,29613,36007,36051,38971,24977,27703,32856,39425,20045,20107,20123,20181,20282,20284,20351,20447,20735,21490,21496,21766,21987,22235,22763,22882,23057,23531,23546,23556,24051,24107,24473,24605,25448,26012,26031,26614,26619,26797,27515,27801,27863,28195,28681,29509,30722,31038,31040,31072,31169,31721,32023,32114,32902,33293,33678,34001,34503,35039,35408,35422,35613,36060,36198,36781,37034,39164,39391,40605,21066,63849,26388,63850,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,20632,21034,23665,25955,27733,29642,29987,30109,31639,33948,37240,38704,20087,25746,27578,29022,34217,19977,63851,26441,26862,28183,33439,34072,34923,25591,28545,37394,39087,19978,20663,20687,20767,21830,21930,22039,23360,23577,23776,24120,24202,24224,24258,24819,26705,27233,28248,29245,29248,29376,30456,31077,31665,32724,35059,35316,35443,35937,36062,38684,22622,29885,36093,21959,63852,31329,32034,33394,29298,29983,29989,63853,31513,22661,22779,23996,24207,24246,24464,24661,25234,25471,25933,26257,26329,26360,26646,26866,29312,29790,31598,32110,32214,32626,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,32997,33298,34223,35199,35475,36893,37604,40653,40736,22805,22893,24109,24796,26132,26227,26512,27728,28101,28511,30707,30889,33990,37323,37675,20185,20682,20808,21892,23307,23459,25159,25982,26059,28210,29053,29697,29764,29831,29887,30316,31146,32218,32341,32680,33146,33203,33337,34330,34796,35445,36323,36984,37521,37925,39245,39854,21352,23633,26964,27844,27945,28203,33292,34203,35131,35373,35498,38634,40807,21089,26297,27570,32406,34814,36109,38275,38493,25885,28041,29166,63854,22478,22995,23468,24615,24826,25104,26143,26207,29481,29689,30427,30465,31596,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,32854,32882,33125,35488,37266,19990,21218,27506,27927,31237,31545,32048,63855,36016,21484,22063,22609,23477,23567,23569,24034,25152,25475,25620,26157,26803,27836,28040,28335,28703,28836,29138,29990,30095,30094,30233,31505,31712,31787,32032,32057,34092,34157,34311,35380,36877,36961,37045,37559,38902,39479,20439,23660,26463,28049,31903,32396,35606,36118,36895,23403,24061,25613,33984,36956,39137,29575,23435,24730,26494,28126,35359,35494,36865,38924,21047,63856,28753,30862,37782,34928,37335,20462,21463,22013,22234,22402,22781,23234,23432,23723,23744,24101,24833,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,25101,25163,25480,25628,25910,25976,27193,27530,27700,27929,28465,29159,29417,29560,29703,29874,30246,30561,31168,31319,31466,31929,32143,32172,32353,32670,33065,33585,33936,34010,34282,34966,35504,35728,36664,36930,36995,37228,37526,37561,38539,38567,38568,38614,38656,38920,39318,39635,39706,21460,22654,22809,23408,23487,28113,28506,29087,29729,29881,32901,33789,24033,24455,24490,24642,26092,26642,26991,27219,27529,27957,28147,29667,30462,30636,31565,32020,33059,33308,33600,34036,34147,35426,35524,37255,37662,38918,39348,25100,34899,36848,37477,23815,23847,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,23913,29791,33181,34664,28629,25342,32722,35126,35186,19998,20056,20711,21213,21319,25215,26119,32361,34821,38494,20365,21273,22070,22987,23204,23608,23630,23629,24066,24337,24643,26045,26159,26178,26558,26612,29468,30690,31034,32709,33940,33997,35222,35430,35433,35553,35925,35962,22516,23508,24335,24687,25325,26893,27542,28252,29060,31698,34645,35672,36606,39135,39166,20280,20353,20449,21627,23072,23480,24892,26032,26216,29180,30003,31070,32051,33102,33251,33688,34218,34254,34563,35338,36523,36763,63857,36805,22833,23460,23526,24713,23529,23563,24515,27777,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,63858,28145,28683,29978,33455,35574,20160,21313,63859,38617,27663,20126,20420,20818,21854,23077,23784,25105,29273,33469,33706,34558,34905,35357,38463,38597,39187,40201,40285,22538,23731,23997,24132,24801,24853,25569,27138,28197,37122,37716,38990,39952,40823,23433,23736,25353,26191,26696,30524,38593,38797,38996,39839,26017,35585,36555,38332,21813,23721,24022,24245,26263,30284,33780,38343,22739,25276,29390,40232,20208,22830,24591,26171,27523,31207,40230,21395,21696,22467,23830,24859,26326,28079,30861,33406,38552,38724,21380,25212,25494,28082,32266,33099,38989,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,27387,32588,40367,40474,20063,20539,20918,22812,24825,25590,26928,29242,32822,63860,37326,24369,63861,63862,32004,33509,33903,33979,34277,36493,63863,20335,63864,63865,22756,23363,24665,25562,25880,25965,26264,63866,26954,27171,27915,28673,29036,30162,30221,31155,31344,63867,32650,63868,35140,63869,35731,37312,38525,63870,39178,22276,24481,26044,28417,30208,31142,35486,39341,39770,40812,20740,25014,25233,27277,33222,20547,22576,24422,28937,35328,35578,23420,34326,20474,20796,22196,22852,25513,28153,23978,26989,20870,20104,20313,63871,63872,63873,22914,63874,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,63875,27487,27741,63876,29877,30998,63877,33287,33349,33593,36671,36701,63878,39192,63879,63880,63881,20134,63882,22495,24441,26131,63883,63884,30123,32377,35695,63885,36870,39515,22181,22567,23032,23071,23476,63886,24310,63887,63888,25424,25403,63889,26941,27783,27839,28046,28051,28149,28436,63890,28895,28982,29017,63891,29123,29141,63892,30799,30831,63893,31605,32227,63894,32303,63895,34893,36575,63896,63897,63898,37467,63899,40182,63900,63901,63902,24709,28037,63903,29105,63904,63905,38321,21421,63906,63907,63908,26579,63909,28814,28976,29744,33398,33490,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,63910,38331,39653,40573,26308,63911,29121,33865,63912,63913,22603,63914,63915,23992,24433,63916,26144,26254,27001,27054,27704,27891,28214,28481,28634,28699,28719,29008,29151,29552,63917,29787,63918,29908,30408,31310,32403,63919,63920,33521,35424,36814,63921,37704,63922,38681,63923,63924,20034,20522,63925,21000,21473,26355,27757,28618,29450,30591,31330,33454,34269,34306,63926,35028,35427,35709,35947,63927,37555,63928,38675,38928,20116,20237,20425,20658,21320,21566,21555,21978,22626,22714,22887,23067,23524,24735,63929,25034,25942,26111,26212,26791,27738,28595,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,28879,29100,29522,31613,34568,35492,39986,40711,23627,27779,29508,29577,37434,28331,29797,30239,31337,32277,34314,20800,22725,25793,29934,29973,30320,32705,37013,38605,39252,28198,29926,31401,31402,33253,34521,34680,35355,23113,23436,23451,26785,26880,28003,29609,29715,29740,30871,32233,32747,33048,33109,33694,35916,38446,38929,26352,24448,26106,26505,27754,29579,20525,23043,27498,30702,22806,23916,24013,29477,30031,63930,63931,20709,20985,22575,22829,22934,23002,23525,63932,63933,23970,25303,25622,25747,25854,63934,26332,63935,27208,63936,29183,29796,63937,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,31368,31407,32327,32350,32768,33136,63938,34799,35201,35616,36953,63939,36992,39250,24958,27442,28020,32287,35109,36785,20433,20653,20887,21191,22471,22665,23481,24248,24898,27029,28044,28263,28342,29076,29794,29992,29996,32883,33592,33993,36362,37780,37854,63940,20110,20305,20598,20778,21448,21451,21491,23431,23507,23588,24858,24962,26100,29275,29591,29760,30402,31056,31121,31161,32006,32701,33419,34261,34398,36802,36935,37109,37354,38533,38632,38633,21206,24423,26093,26161,26671,29020,31286,37057,38922,20113,63941,27218,27550,28560,29065,32792,33464,34131,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,36939,38549,38642,38907,34074,39729,20112,29066,38596,20803,21407,21729,22291,22290,22435,23195,23236,23491,24616,24895,25588,27781,27961,28274,28304,29232,29503,29783,33489,34945,36677,36960,63942,38498,39000,40219,26376,36234,37470,20301,20553,20702,21361,22285,22996,23041,23561,24944,26256,28205,29234,29771,32239,32963,33806,33894,34111,34655,34907,35096,35586,36949,38859,39759,20083,20369,20754,20842,63943,21807,21929,23418,23461,24188,24189,24254,24736,24799,24840,24841,25540,25912,26377,63944,26580,26586,63945,26977,26978,27833,27943,63946,28216,63947,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,28641,29494,29495,63948,29788,30001,63949,30290,63950,63951,32173,33278,33848,35029,35480,35547,35565,36400,36418,36938,36926,36986,37193,37321,37742,63952,63953,22537,63954,27603,32905,32946,63955,63956,20801,22891,23609,63957,63958,28516,29607,32996,36103,63959,37399,38287,63960,63961,63962,63963,32895,25102,28700,32104,34701,63964,22432,24681,24903,27575,35518,37504,38577,20057,21535,28139,34093,38512,38899,39150,25558,27875,37009,20957,25033,33210,40441,20381,20506,20736,23452,24847,25087,25836,26885,27589,30097,30691,32681,33380,34191,34811,34915,35516,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,35696,37291,20108,20197,20234,63965,63966,22839,23016,63967,24050,24347,24411,24609,63968,63969,63970,63971,29246,29669,63972,30064,30157,63973,31227,63974,32780,32819,32900,33505,33617,63975,63976,36029,36019,36999,63977,63978,39156,39180,63979,63980,28727,30410,32714,32716,32764,35610,20154,20161,20995,21360,63981,21693,22240,23035,23493,24341,24525,28270,63982,63983,32106,33589,63984,34451,35469,63985,38765,38775,63986,63987,19968,20314,20350,22777,26085,28322,36920,37808,39353,20219,22764,22922,23001,24641,63988,63989,31252,63990,33615,36035,20837,21316,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,63991,63992,63993,20173,21097,23381,33471,20180,21050,21672,22985,23039,23376,23383,23388,24675,24904,28363,28825,29038,29574,29943,30133,30913,32043,32773,33258,33576,34071,34249,35566,36039,38604,20316,21242,22204,26027,26152,28796,28856,29237,32189,33421,37196,38592,40306,23409,26855,27544,28538,30430,23697,26283,28507,31668,31786,34870,38620,19976,20183,21280,22580,22715,22767,22892,23559,24115,24196,24373,25484,26290,26454,27167,27299,27404,28479,29254,63994,29520,29835,31456,31911,33144,33247,33255,33674,33900,34083,34196,34255,35037,36115,37292,38263,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,38556,20877,21705,22312,23472,25165,26448,26685,26771,28221,28371,28797,32289,35009,36001,36617,40779,40782,29229,31631,35533,37658,20295,20302,20786,21632,22992,24213,25269,26485,26990,27159,27822,28186,29401,29482,30141,31672,32053,33511,33785,33879,34295,35419,36015,36487,36889,37048,38606,40799,21219,21514,23265,23490,25688,25973,28404,29380,63995,30340,31309,31515,31821,32318,32735,33659,35627,36042,36196,36321,36447,36842,36857,36969,37841,20291,20346,20659,20840,20856,21069,21098,22625,22652,22880,23560,23637,24283,24731,25136,26643,27583,27656,28593,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,29006,29728,30000,30008,30033,30322,31564,31627,31661,31686,32399,35438,36670,36681,37439,37523,37666,37931,38651,39002,39019,39198,20999,25130,25240,27993,30308,31434,31680,32118,21344,23742,24215,28472,28857,31896,38673,39822,40670,25509,25722,34678,19969,20117,20141,20572,20597,21576,22979,23450,24128,24237,24311,24449,24773,25402,25919,25972,26060,26230,26232,26622,26984,27273,27491,27712,28096,28136,28191,28254,28702,28833,29582,29693,30010,30555,30855,31118,31243,31357,31934,32142,33351,35330,35562,35998,37165,37194,37336,37478,37580,37664,38662,38742,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,38748,38914,40718,21046,21137,21884,22564,24093,24351,24716,25552,26799,28639,31085,31532,33229,34234,35069,35576,36420,37261,38500,38555,38717,38988,40778,20430,20806,20939,21161,22066,24340,24427,25514,25805,26089,26177,26362,26361,26397,26781,26839,27133,28437,28526,29031,29157,29226,29866,30522,31062,31066,31199,31264,31381,31895,31967,32068,32368,32903,34299,34468,35412,35519,36249,36481,36896,36973,37347,38459,38613,40165,26063,31751,36275,37827,23384,23562,21330,25305,29469,20519,23447,24478,24752,24939,26837,28121,29742,31278,32066,32156,32305,33131,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,36394,36405,37758,37912,20304,22352,24038,24231,25387,32618,20027,20303,20367,20570,23005,32964,21610,21608,22014,22863,23449,24030,24282,26205,26417,26609,26666,27880,27954,28234,28557,28855,29664,30087,31820,32002,32044,32162,33311,34523,35387,35461,36208,36490,36659,36913,37198,37202,37956,39376,31481,31909,20426,20737,20934,22472,23535,23803,26201,27197,27994,28310,28652,28940,30063,31459,34850,36897,36981,38603,39423,33537,20013,20210,34886,37325,21373,27355,26987,27713,33914,22686,24974,26366,25327,28893,29969,30151,32338,33976,35657,36104,20043,21482,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,21675,22320,22336,24535,25345,25351,25711,25903,26088,26234,26525,26547,27490,27744,27802,28460,30693,30757,31049,31063,32025,32930,33026,33267,33437,33463,34584,35468,63996,36100,36286,36978,30452,31257,31287,32340,32887,21767,21972,22645,25391,25634,26185,26187,26733,27035,27524,27941,28337,29645,29800,29857,30043,30137,30433,30494,30603,31206,32265,32285,33275,34095,34967,35386,36049,36587,36784,36914,37805,38499,38515,38663,20356,21489,23018,23241,24089,26702,29894,30142,31209,31378,33187,34541,36074,36300,36845,26015,26389,63997,22519,28503,32221,36655,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,37878,38598,24501,25074,28548,19988,20376,20511,21449,21983,23919,24046,27425,27492,30923,31642,63998,36425,36554,36974,25417,25662,30528,31364,37679,38015,40810,25776,28591,29158,29864,29914,31428,31762,32386,31922,32408,35738,36106,38013,39184,39244,21049,23519,25830,26413,32046,20717,21443,22649,24920,24921,25082,26028,31449,35730,35734,20489,20513,21109,21809,23100,24288,24432,24884,25950,26124,26166,26274,27085,28356,28466,29462,30241,31379,33081,33369,33750,33980,20661,22512,23488,23528,24425,25505,30758,32181,33756,34081,37319,37365,20874,26613,31574,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,36012,20932,22971,24765,34389,20508,63999,21076,23610,24957,25114,25299,25842,26021,28364,30240,33034,36448,38495,38587,20191,21315,21912,22825,24029,25797,27849,28154,29588,31359,33307,34214,36068,36368,36983,37351,38369,38433,38854,20984,21746,21894,24505,25764,28552,32180,36639,36685,37941,20681,23574,27838,28155,29979,30651,31805,31844,35449,35522,22558,22974,24086,25463,29266,30090,30571,35548,36028,36626,24307,26228,28152,32893,33729,35531,38737,39894,64000,21059,26367,28053,28399,32224,35558,36910,36958,39636,21021,21119,21736,24980,25220,25307,26786,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,26898,26970,27189,28818,28966,30813,30977,30990,31186,31245,32918,33400,33493,33609,34121,35970,36229,37218,37259,37294,20419,22225,29165,30679,34560,35320,23544,24534,26449,37032,21474,22618,23541,24740,24961,25696,32317,32880,34085,37507,25774,20652,23828,26368,22684,25277,25512,26894,27000,27166,28267,30394,31179,33467,33833,35535,36264,36861,37138,37195,37276,37648,37656,37786,38619,39478,39949,19985,30044,31069,31482,31569,31689,32302,33988,36441,36468,36600,36880,26149,26943,29763,20986,26414,40668,20805,24544,27798,34802,34909,34935,24756,33205,33795,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,36101,21462,21561,22068,23094,23601,28810,32736,32858,33030,33261,36259,37257,39519,40434,20596,20164,21408,24827,28204,23652,20360,20516,21988,23769,24159,24677,26772,27835,28100,29118,30164,30196,30305,31258,31305,32199,32251,32622,33268,34473,36636,38601,39347,40786,21063,21189,39149,35242,19971,26578,28422,20405,23522,26517,27784,28024,29723,30759,37341,37756,34756,31204,31281,24555,20182,21668,21822,22702,22949,24816,25171,25302,26422,26965,33333,38464,39345,39389,20524,21331,21828,22396,64001,25176,64002,25826,26219,26589,28609,28655,29730,29752,35351,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,37944,21585,22022,22374,24392,24986,27470,28760,28845,32187,35477,22890,33067,25506,30472,32829,36010,22612,25645,27067,23445,24081,28271,64003,34153,20812,21488,22826,24608,24907,27526,27760,27888,31518,32974,33492,36294,37040,39089,64004,25799,28580,25745,25860,20814,21520,22303,35342,24927,26742,64005,30171,31570,32113,36890,22534,27084,33151,35114,36864,38969,20600,22871,22956,25237,36879,39722,24925,29305,38358,22369,23110,24052,25226,25773,25850,26487,27874,27966,29228,29750,30772,32631,33453,36315,38935,21028,22338,26495,29256,29923,36009,36774,37393,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,38442,20843,21485,25420,20329,21764,24726,25943,27803,28031,29260,29437,31255,35207,35997,24429,28558,28921,33192,24846,20415,20559,25153,29255,31687,32232,32745,36941,38829,39449,36022,22378,24179,26544,33805,35413,21536,23318,24163,24290,24330,25987,32954,34109,38281,38491,20296,21253,21261,21263,21638,21754,22275,24067,24598,25243,25265,25429,64006,27873,28006,30129,30770,32990,33071,33502,33889,33970,34957,35090,36875,37610,39165,39825,24133,26292,26333,28689,29190,64007,20469,21117,24426,24915,26451,27161,28418,29922,31080,34920,35961,39111,39108,39491,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,21697,31263,26963,35575,35914,39080,39342,24444,25259,30130,30382,34987,36991,38466,21305,24380,24517,27852,29644,30050,30091,31558,33534,39325,20047,36924,19979,20309,21414,22799,24264,26160,27827,29781,33655,34662,36032,36944,38686,39957,22737,23416,34384,35604,40372,23506,24680,24717,26097,27735,28450,28579,28698,32597,32752,38289,38290,38480,38867,21106,36676,20989,21547,21688,21859,21898,27323,28085,32216,33382,37532,38519,40569,21512,21704,30418,34532,38308,38356,38492,20130,20233,23022,23270,24055,24658,25239,26477,26689,27782,28207,32568,32923,33322,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,64008,64009,38917,20133,20565,21683,22419,22874,23401,23475,25032,26999,28023,28707,34809,35299,35442,35559,36994,39405,39608,21182,26680,20502,24184,26447,33607,34892,20139,21521,22190,29670,37141,38911,39177,39255,39321,22099,22687,34395,35377,25010,27382,29563,36562,27463,38570,39511,22869,29184,36203,38761,20436,23796,24358,25080,26203,27883,28843,29572,29625,29694,30505,30541,32067,32098,32291,33335,34898,64010,36066,37449,39023,23377,31348,34880,38913,23244,20448,21332,22846,23805,25406,28025,29433,33029,33031,33698,37583,38960,20136,20804,21009,22411,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,24418,27842,28366,28677,28752,28847,29074,29673,29801,33610,34722,34913,36872,37026,37795,39336,20846,24407,24800,24935,26291,34137,36426,37295,38795,20046,20114,21628,22741,22778,22909,23733,24359,25142,25160,26122,26215,27627,28009,28111,28246,28408,28564,28640,28649,28765,29392,29733,29786,29920,30355,31068,31946,32286,32993,33446,33899,33983,34382,34399,34676,35703,35946,37804,38912,39013,24785,25110,37239,23130,26127,28151,28222,29759,39746,24573,24794,31503,21700,24344,27742,27859,27946,28888,32005,34425,35340,40251,21270,21644,23301,27194,28779,30069,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,31117,31166,33457,33775,35441,35649,36008,38772,64011,25844,25899,30906,30907,31339,20024,21914,22864,23462,24187,24739,25563,27489,26213,26707,28185,29029,29872,32008,36996,39529,39973,27963,28369,29502,35905,38346,20976,24140,24488,24653,24822,24880,24908,26179,26180,27045,27841,28255,28361,28514,29004,29852,30343,31681,31783,33618,34647,36945,38541,40643,21295,22238,24315,24458,24674,24724,25079,26214,26371,27292,28142,28590,28784,29546,32362,33214,33588,34516,35496,36036,21123,29554,23446,27243,37892,21742,22150,23389,25928,25989,26313,26783,28045,28102,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,29243,32948,37237,39501,20399,20505,21402,21518,21564,21897,21957,24127,24460,26429,29030,29661,36869,21211,21235,22628,22734,28932,29071,29179,34224,35347,26248,34216,21927,26244,29002,33841,21321,21913,27585,24409,24509,25582,26249,28999,35569,36637,40638,20241,25658,28875,30054,34407,24676,35662,40440,20807,20982,21256,27958,33016,40657,26133,27427,28824,30165,21507,23673,32007,35350,27424,27453,27462,21560,24688,27965,32725,33288,20694,20958,21916,22123,22221,23020,23305,24076,24985,24984,25137,26206,26342,29081,29113,29114,29351,31143,31232,32690,35440,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],
  "gb18030":[19970,19972,19973,19974,19983,19986,19991,19999,20000,20001,20003,20006,20009,20014,20015,20017,20019,20021,20023,20028,20032,20033,20034,20036,20038,20042,20049,20053,20055,20058,20059,20066,20067,20068,20069,20071,20072,20074,20075,20076,20077,20078,20079,20082,20084,20085,20086,20087,20088,20089,20090,20091,20092,20093,20095,20096,20097,20098,20099,20100,20101,20103,20106,20112,20118,20119,20121,20124,20125,20126,20131,20138,20143,20144,20145,20148,20150,20151,20152,20153,20156,20157,20158,20168,20172,20175,20176,20178,20186,20187,20188,20192,20194,20198,20199,20201,20205,20206,20207,20209,20212,20216,20217,20218,20220,20222,20224,20226,20227,20228,20229,20230,20231,20232,20235,20236,20242,20243,20244,20245,20246,20252,20253,20257,20259,20264,20265,20268,20269,20270,20273,20275,20277,20279,20281,20283,20286,20287,20288,20289,20290,20292,20293,20295,20296,20297,20298,20299,20300,20306,20308,20310,20321,20322,20326,20328,20330,20331,20333,20334,20337,20338,20341,20343,20344,20345,20346,20349,20352,20353,20354,20357,20358,20359,20362,20364,20366,20368,20370,20371,20373,20374,20376,20377,20378,20380,20382,20383,20385,20386,20388,20395,20397,20400,20401,20402,20403,20404,20406,20407,20408,20409,20410,20411,20412,20413,20414,20416,20417,20418,20422,20423,20424,20425,20427,20428,20429,20434,20435,20436,20437,20438,20441,20443,20448,20450,20452,20453,20455,20459,20460,20464,20466,20468,20469,20470,20471,20473,20475,20476,20477,20479,20480,20481,20482,20483,20484,20485,20486,20487,20488,20489,20490,20491,20494,20496,20497,20499,20501,20502,20503,20507,20509,20510,20512,20514,20515,20516,20519,20523,20527,20528,20529,20530,20531,20532,20533,20534,20535,20536,20537,20539,20541,20543,20544,20545,20546,20548,20549,20550,20553,20554,20555,20557,20560,20561,20562,20563,20564,20566,20567,20568,20569,20571,20573,20574,20575,20576,20577,20578,20579,20580,20582,20583,20584,20585,20586,20587,20589,20590,20591,20592,20593,20594,20595,20596,20597,20600,20601,20602,20604,20605,20609,20610,20611,20612,20614,20615,20617,20618,20619,20620,20622,20623,20624,20625,20626,20627,20628,20629,20630,20631,20632,20633,20634,20635,20636,20637,20638,20639,20640,20641,20642,20644,20646,20650,20651,20653,20654,20655,20656,20657,20659,20660,20661,20662,20663,20664,20665,20668,20669,20670,20671,20672,20673,20674,20675,20676,20677,20678,20679,20680,20681,20682,20683,20684,20685,20686,20688,20689,20690,20691,20692,20693,20695,20696,20697,20699,20700,20701,20702,20703,20704,20705,20706,20707,20708,20709,20712,20713,20714,20715,20719,20720,20721,20722,20724,20726,20727,20728,20729,20730,20732,20733,20734,20735,20736,20737,20738,20739,20740,20741,20744,20745,20746,20748,20749,20750,20751,20752,20753,20755,20756,20757,20758,20759,20760,20761,20762,20763,20764,20765,20766,20767,20768,20770,20771,20772,20773,20774,20775,20776,20777,20778,20779,20780,20781,20782,20783,20784,20785,20786,20787,20788,20789,20790,20791,20792,20793,20794,20795,20796,20797,20798,20802,20807,20810,20812,20814,20815,20816,20818,20819,20823,20824,20825,20827,20829,20830,20831,20832,20833,20835,20836,20838,20839,20841,20842,20847,20850,20858,20862,20863,20867,20868,20870,20871,20874,20875,20878,20879,20880,20881,20883,20884,20888,20890,20893,20894,20895,20897,20899,20902,20903,20904,20905,20906,20909,20910,20916,20920,20921,20922,20926,20927,20929,20930,20931,20933,20936,20938,20941,20942,20944,20946,20947,20948,20949,20950,20951,20952,20953,20954,20956,20958,20959,20962,20963,20965,20966,20967,20968,20969,20970,20972,20974,20977,20978,20980,20983,20990,20996,20997,21001,21003,21004,21007,21008,21011,21012,21013,21020,21022,21023,21025,21026,21027,21029,21030,21031,21034,21036,21039,21041,21042,21044,21045,21052,21054,21060,21061,21062,21063,21064,21065,21067,21070,21071,21074,21075,21077,21079,21080,21081,21082,21083,21085,21087,21088,21090,21091,21092,21094,21096,21099,21100,21101,21102,21104,21105,21107,21108,21109,21110,21111,21112,21113,21114,21115,21116,21118,21120,21123,21124,21125,21126,21127,21129,21130,21131,21132,21133,21134,21135,21137,21138,21140,21141,21142,21143,21144,21145,21146,21148,21156,21157,21158,21159,21166,21167,21168,21172,21173,21174,21175,21176,21177,21178,21179,21180,21181,21184,21185,21186,21188,21189,21190,21192,21194,21196,21197,21198,21199,21201,21203,21204,21205,21207,21209,21210,21211,21212,21213,21214,21216,21217,21218,21219,21221,21222,21223,21224,21225,21226,21227,21228,21229,21230,21231,21233,21234,21235,21236,21237,21238,21239,21240,21243,21244,21245,21249,21250,21251,21252,21255,21257,21258,21259,21260,21262,21265,21266,21267,21268,21272,21275,21276,21278,21279,21282,21284,21285,21287,21288,21289,21291,21292,21293,21295,21296,21297,21298,21299,21300,21301,21302,21303,21304,21308,21309,21312,21314,21316,21318,21323,21324,21325,21328,21332,21336,21337,21339,21341,21349,21352,21354,21356,21357,21362,21366,21369,21371,21372,21373,21374,21376,21377,21379,21383,21384,21386,21390,21391,21392,21393,21394,21395,21396,21398,21399,21401,21403,21404,21406,21408,21409,21412,21415,21418,21419,21420,21421,21423,21424,21425,21426,21427,21428,21429,21431,21432,21433,21434,21436,21437,21438,21440,21443,21444,21445,21446,21447,21454,21455,21456,21458,21459,21461,21466,21468,21469,21470,21473,21474,21479,21492,21498,21502,21503,21504,21506,21509,21511,21515,21524,21528,21529,21530,21532,21538,21540,21541,21546,21552,21555,21558,21559,21562,21565,21567,21569,21570,21572,21573,21575,21577,21580,21581,21582,21583,21585,21594,21597,21598,21599,21600,21601,21603,21605,21607,21609,21610,21611,21612,21613,21614,21615,21616,21620,21625,21626,21630,21631,21633,21635,21637,21639,21640,21641,21642,21645,21649,21651,21655,21656,21660,21662,21663,21664,21665,21666,21669,21678,21680,21682,21685,21686,21687,21689,21690,21692,21694,21699,21701,21706,21707,21718,21720,21723,21728,21729,21730,21731,21732,21739,21740,21743,21744,21745,21748,21749,21750,21751,21752,21753,21755,21758,21760,21762,21763,21764,21765,21768,21770,21771,21772,21773,21774,21778,21779,21781,21782,21783,21784,21785,21786,21788,21789,21790,21791,21793,21797,21798,21800,21801,21803,21805,21810,21812,21813,21814,21816,21817,21818,21819,21821,21824,21826,21829,21831,21832,21835,21836,21837,21838,21839,21841,21842,21843,21844,21847,21848,21849,21850,21851,21853,21854,21855,21856,21858,21859,21864,21865,21867,21871,21872,21873,21874,21875,21876,21881,21882,21885,21887,21893,21894,21900,21901,21902,21904,21906,21907,21909,21910,21911,21914,21915,21918,21920,21921,21922,21923,21924,21925,21926,21928,21929,21930,21931,21932,21933,21934,21935,21936,21938,21940,21942,21944,21946,21948,21951,21952,21953,21954,21955,21958,21959,21960,21962,21963,21966,21967,21968,21973,21975,21976,21977,21978,21979,21982,21984,21986,21991,21993,21997,21998,22000,22001,22004,22006,22008,22009,22010,22011,22012,22015,22018,22019,22020,22021,22022,22023,22026,22027,22029,22032,22033,22034,22035,22036,22037,22038,22039,22041,22042,22044,22045,22048,22049,22050,22053,22054,22056,22057,22058,22059,22062,22063,22064,22067,22069,22071,22072,22074,22076,22077,22078,22080,22081,22082,22083,22084,22085,22086,22087,22088,22089,22090,22091,22095,22096,22097,22098,22099,22101,22102,22106,22107,22109,22110,22111,22112,22113,22115,22117,22118,22119,22125,22126,22127,22128,22130,22131,22132,22133,22135,22136,22137,22138,22141,22142,22143,22144,22145,22146,22147,22148,22151,22152,22153,22154,22155,22156,22157,22160,22161,22162,22164,22165,22166,22167,22168,22169,22170,22171,22172,22173,22174,22175,22176,22177,22178,22180,22181,22182,22183,22184,22185,22186,22187,22188,22189,22190,22192,22193,22194,22195,22196,22197,22198,22200,22201,22202,22203,22205,22206,22207,22208,22209,22210,22211,22212,22213,22214,22215,22216,22217,22219,22220,22221,22222,22223,22224,22225,22226,22227,22229,22230,22232,22233,22236,22243,22245,22246,22247,22248,22249,22250,22252,22254,22255,22258,22259,22262,22263,22264,22267,22268,22272,22273,22274,22277,22279,22283,22284,22285,22286,22287,22288,22289,22290,22291,22292,22293,22294,22295,22296,22297,22298,22299,22301,22302,22304,22305,22306,22308,22309,22310,22311,22315,22321,22322,22324,22325,22326,22327,22328,22332,22333,22335,22337,22339,22340,22341,22342,22344,22345,22347,22354,22355,22356,22357,22358,22360,22361,22370,22371,22373,22375,22380,22382,22384,22385,22386,22388,22389,22392,22393,22394,22397,22398,22399,22400,22401,22407,22408,22409,22410,22413,22414,22415,22416,22417,22420,22421,22422,22423,22424,22425,22426,22428,22429,22430,22431,22437,22440,22442,22444,22447,22448,22449,22451,22453,22454,22455,22457,22458,22459,22460,22461,22462,22463,22464,22465,22468,22469,22470,22471,22472,22473,22474,22476,22477,22480,22481,22483,22486,22487,22491,22492,22494,22497,22498,22499,22501,22502,22503,22504,22505,22506,22507,22508,22510,22512,22513,22514,22515,22517,22518,22519,22523,22524,22526,22527,22529,22531,22532,22533,22536,22537,22538,22540,22542,22543,22544,22546,22547,22548,22550,22551,22552,22554,22555,22556,22557,22559,22562,22563,22565,22566,22567,22568,22569,22571,22572,22573,22574,22575,22577,22578,22579,22580,22582,22583,22584,22585,22586,22587,22588,22589,22590,22591,22592,22593,22594,22595,22597,22598,22599,22600,22601,22602,22603,22606,22607,22608,22610,22611,22613,22614,22615,22617,22618,22619,22620,22621,22623,22624,22625,22626,22627,22628,22630,22631,22632,22633,22634,22637,22638,22639,22640,22641,22642,22643,22644,22645,22646,22647,22648,22649,22650,22651,22652,22653,22655,22658,22660,22662,22663,22664,22666,22667,22668,22669,22670,22671,22672,22673,22676,22677,22678,22679,22680,22683,22684,22685,22688,22689,22690,22691,22692,22693,22694,22695,22698,22699,22700,22701,22702,22703,22704,22705,22706,22707,22708,22709,22710,22711,22712,22713,22714,22715,22717,22718,22719,22720,22722,22723,22724,22726,22727,22728,22729,22730,22731,22732,22733,22734,22735,22736,22738,22739,22740,22742,22743,22744,22745,22746,22747,22748,22749,22750,22751,22752,22753,22754,22755,22757,22758,22759,22760,22761,22762,22765,22767,22769,22770,22772,22773,22775,22776,22778,22779,22780,22781,22782,22783,22784,22785,22787,22789,22790,22792,22793,22794,22795,22796,22798,22800,22801,22802,22803,22807,22808,22811,22813,22814,22816,22817,22818,22819,22822,22824,22828,22832,22834,22835,22837,22838,22843,22845,22846,22847,22848,22851,22853,22854,22858,22860,22861,22864,22866,22867,22873,22875,22876,22877,22878,22879,22881,22883,22884,22886,22887,22888,22889,22890,22891,22892,22893,22894,22895,22896,22897,22898,22901,22903,22906,22907,22908,22910,22911,22912,22917,22921,22923,22924,22926,22927,22928,22929,22932,22933,22936,22938,22939,22940,22941,22943,22944,22945,22946,22950,22951,22956,22957,22960,22961,22963,22964,22965,22966,22967,22968,22970,22972,22973,22975,22976,22977,22978,22979,22980,22981,22983,22984,22985,22988,22989,22990,22991,22997,22998,23001,23003,23006,23007,23008,23009,23010,23012,23014,23015,23017,23018,23019,23021,23022,23023,23024,23025,23026,23027,23028,23029,23030,23031,23032,23034,23036,23037,23038,23040,23042,23050,23051,23053,23054,23055,23056,23058,23060,23061,23062,23063,23065,23066,23067,23069,23070,23073,23074,23076,23078,23079,23080,23082,23083,23084,23085,23086,23087,23088,23091,23093,23095,23096,23097,23098,23099,23101,23102,23103,23105,23106,23107,23108,23109,23111,23112,23115,23116,23117,23118,23119,23120,23121,23122,23123,23124,23126,23127,23128,23129,23131,23132,23133,23134,23135,23136,23137,23139,23140,23141,23142,23144,23145,23147,23148,23149,23150,23151,23152,23153,23154,23155,23160,23161,23163,23164,23165,23166,23168,23169,23170,23171,23172,23173,23174,23175,23176,23177,23178,23179,23180,23181,23182,23183,23184,23185,23187,23188,23189,23190,23191,23192,23193,23196,23197,23198,23199,23200,23201,23202,23203,23204,23205,23206,23207,23208,23209,23211,23212,23213,23214,23215,23216,23217,23220,23222,23223,23225,23226,23227,23228,23229,23231,23232,23235,23236,23237,23238,23239,23240,23242,23243,23245,23246,23247,23248,23249,23251,23253,23255,23257,23258,23259,23261,23262,23263,23266,23268,23269,23271,23272,23274,23276,23277,23278,23279,23280,23282,23283,23284,23285,23286,23287,23288,23289,23290,23291,23292,23293,23294,23295,23296,23297,23298,23299,23300,23301,23302,23303,23304,23306,23307,23308,23309,23310,23311,23312,23313,23314,23315,23316,23317,23320,23321,23322,23323,23324,23325,23326,23327,23328,23329,23330,23331,23332,23333,23334,23335,23336,23337,23338,23339,23340,23341,23342,23343,23344,23345,23347,23349,23350,23352,23353,23354,23355,23356,23357,23358,23359,23361,23362,23363,23364,23365,23366,23367,23368,23369,23370,23371,23372,23373,23374,23375,23378,23382,23390,23392,23393,23399,23400,23403,23405,23406,23407,23410,23412,23414,23415,23416,23417,23419,23420,23422,23423,23426,23430,23434,23437,23438,23440,23441,23442,23444,23446,23455,23463,23464,23465,23468,23469,23470,23471,23473,23474,23479,23482,23483,23484,23488,23489,23491,23496,23497,23498,23499,23501,23502,23503,23505,23508,23509,23510,23511,23512,23513,23514,23515,23516,23520,23522,23523,23526,23527,23529,23530,23531,23532,23533,23535,23537,23538,23539,23540,23541,23542,23543,23549,23550,23552,23554,23555,23557,23559,23560,23563,23564,23565,23566,23568,23570,23571,23575,23577,23579,23582,23583,23584,23585,23587,23590,23592,23593,23594,23595,23597,23598,23599,23600,23602,23603,23605,23606,23607,23619,23620,23622,23623,23628,23629,23634,23635,23636,23638,23639,23640,23642,23643,23644,23645,23647,23650,23652,23655,23656,23657,23658,23659,23660,23661,23664,23666,23667,23668,23669,23670,23671,23672,23675,23676,23677,23678,23680,23683,23684,23685,23686,23687,23689,23690,23691,23694,23695,23698,23699,23701,23709,23710,23711,23712,23713,23716,23717,23718,23719,23720,23722,23726,23727,23728,23730,23732,23734,23737,23738,23739,23740,23742,23744,23746,23747,23749,23750,23751,23752,23753,23754,23756,23757,23758,23759,23760,23761,23763,23764,23765,23766,23767,23768,23770,23771,23772,23773,23774,23775,23776,23778,23779,23783,23785,23787,23788,23790,23791,23793,23794,23795,23796,23797,23798,23799,23800,23801,23802,23804,23805,23806,23807,23808,23809,23812,23813,23816,23817,23818,23819,23820,23821,23823,23824,23825,23826,23827,23829,23831,23832,23833,23834,23836,23837,23839,23840,23841,23842,23843,23845,23848,23850,23851,23852,23855,23856,23857,23858,23859,23861,23862,23863,23864,23865,23866,23867,23868,23871,23872,23873,23874,23875,23876,23877,23878,23880,23881,23885,23886,23887,23888,23889,23890,23891,23892,23893,23894,23895,23897,23898,23900,23902,23903,23904,23905,23906,23907,23908,23909,23910,23911,23912,23914,23917,23918,23920,23921,23922,23923,23925,23926,23927,23928,23929,23930,23931,23932,23933,23934,23935,23936,23937,23939,23940,23941,23942,23943,23944,23945,23946,23947,23948,23949,23950,23951,23952,23953,23954,23955,23956,23957,23958,23959,23960,23962,23963,23964,23966,23967,23968,23969,23970,23971,23972,23973,23974,23975,23976,23977,23978,23979,23980,23981,23982,23983,23984,23985,23986,23987,23988,23989,23990,23992,23993,23994,23995,23996,23997,23998,23999,24000,24001,24002,24003,24004,24006,24007,24008,24009,24010,24011,24012,24014,24015,24016,24017,24018,24019,24020,24021,24022,24023,24024,24025,24026,24028,24031,24032,24035,24036,24042,24044,24045,24048,24053,24054,24056,24057,24058,24059,24060,24063,24064,24068,24071,24073,24074,24075,24077,24078,24082,24083,24087,24094,24095,24096,24097,24098,24099,24100,24101,24104,24105,24106,24107,24108,24111,24112,24114,24115,24116,24117,24118,24121,24122,24126,24127,24128,24129,24131,24134,24135,24136,24137,24138,24139,24141,24142,24143,24144,24145,24146,24147,24150,24151,24152,24153,24154,24156,24157,24159,24160,24163,24164,24165,24166,24167,24168,24169,24170,24171,24172,24173,24174,24175,24176,24177,24181,24183,24185,24190,24193,24194,24195,24197,24200,24201,24204,24205,24206,24210,24216,24219,24221,24225,24226,24227,24228,24232,24233,24234,24235,24236,24238,24239,24240,24241,24242,24244,24250,24251,24252,24253,24255,24256,24257,24258,24259,24260,24261,24262,24263,24264,24267,24268,24269,24270,24271,24272,24276,24277,24279,24280,24281,24282,24284,24285,24286,24287,24288,24289,24290,24291,24292,24293,24294,24295,24297,24299,24300,24301,24302,24303,24304,24305,24306,24307,24309,24312,24313,24315,24316,24317,24325,24326,24327,24329,24332,24333,24334,24336,24338,24340,24342,24345,24346,24348,24349,24350,24353,24354,24355,24356,24360,24363,24364,24366,24368,24370,24371,24372,24373,24374,24375,24376,24379,24381,24382,24383,24385,24386,24387,24388,24389,24390,24391,24392,24393,24394,24395,24396,24397,24398,24399,24401,24404,24409,24410,24411,24412,24414,24415,24416,24419,24421,24423,24424,24427,24430,24431,24434,24436,24437,24438,24440,24442,24445,24446,24447,24451,24454,24461,24462,24463,24465,24467,24468,24470,24474,24475,24477,24478,24479,24480,24482,24483,24484,24485,24486,24487,24489,24491,24492,24495,24496,24497,24498,24499,24500,24502,24504,24505,24506,24507,24510,24511,24512,24513,24514,24519,24520,24522,24523,24526,24531,24532,24533,24538,24539,24540,24542,24543,24546,24547,24549,24550,24552,24553,24556,24559,24560,24562,24563,24564,24566,24567,24569,24570,24572,24583,24584,24585,24587,24588,24592,24593,24595,24599,24600,24602,24606,24607,24610,24611,24612,24620,24621,24622,24624,24625,24626,24627,24628,24630,24631,24632,24633,24634,24637,24638,24640,24644,24645,24646,24647,24648,24649,24650,24652,24654,24655,24657,24659,24660,24662,24663,24664,24667,24668,24670,24671,24672,24673,24677,24678,24686,24689,24690,24692,24693,24695,24702,24704,24705,24706,24709,24710,24711,24712,24714,24715,24718,24719,24720,24721,24723,24725,24727,24728,24729,24732,24734,24737,24738,24740,24741,24743,24745,24746,24750,24752,24755,24757,24758,24759,24761,24762,24765,24766,24767,24768,24769,24770,24771,24772,24775,24776,24777,24780,24781,24782,24783,24784,24786,24787,24788,24790,24791,24793,24795,24798,24801,24802,24803,24804,24805,24810,24817,24818,24821,24823,24824,24827,24828,24829,24830,24831,24834,24835,24836,24837,24839,24842,24843,24844,24848,24849,24850,24851,24852,24854,24855,24856,24857,24859,24860,24861,24862,24865,24866,24869,24872,24873,24874,24876,24877,24878,24879,24880,24881,24882,24883,24884,24885,24886,24887,24888,24889,24890,24891,24892,24893,24894,24896,24897,24898,24899,24900,24901,24902,24903,24905,24907,24909,24911,24912,24914,24915,24916,24918,24919,24920,24921,24922,24923,24924,24926,24927,24928,24929,24931,24932,24933,24934,24937,24938,24939,24940,24941,24942,24943,24945,24946,24947,24948,24950,24952,24953,24954,24955,24956,24957,24958,24959,24960,24961,24962,24963,24964,24965,24966,24967,24968,24969,24970,24972,24973,24975,24976,24977,24978,24979,24981,24982,24983,24984,24985,24986,24987,24988,24990,24991,24992,24993,24994,24995,24996,24997,24998,25002,25003,25005,25006,25007,25008,25009,25010,25011,25012,25013,25014,25016,25017,25018,25019,25020,25021,25023,25024,25025,25027,25028,25029,25030,25031,25033,25036,25037,25038,25039,25040,25043,25045,25046,25047,25048,25049,25050,25051,25052,25053,25054,25055,25056,25057,25058,25059,25060,25061,25063,25064,25065,25066,25067,25068,25069,25070,25071,25072,25073,25074,25075,25076,25078,25079,25080,25081,25082,25083,25084,25085,25086,25088,25089,25090,25091,25092,25093,25095,25097,25107,25108,25113,25116,25117,25118,25120,25123,25126,25127,25128,25129,25131,25133,25135,25136,25137,25138,25141,25142,25144,25145,25146,25147,25148,25154,25156,25157,25158,25162,25167,25168,25173,25174,25175,25177,25178,25180,25181,25182,25183,25184,25185,25186,25188,25189,25192,25201,25202,25204,25205,25207,25208,25210,25211,25213,25217,25218,25219,25221,25222,25223,25224,25227,25228,25229,25230,25231,25232,25236,25241,25244,25245,25246,25251,25254,25255,25257,25258,25261,25262,25263,25264,25266,25267,25268,25270,25271,25272,25274,25278,25280,25281,25283,25291,25295,25297,25301,25309,25310,25312,25313,25316,25322,25323,25328,25330,25333,25336,25337,25338,25339,25344,25347,25348,25349,25350,25354,25355,25356,25357,25359,25360,25362,25363,25364,25365,25367,25368,25369,25372,25382,25383,25385,25388,25389,25390,25392,25393,25395,25396,25397,25398,25399,25400,25403,25404,25406,25407,25408,25409,25412,25415,25416,25418,25425,25426,25427,25428,25430,25431,25432,25433,25434,25435,25436,25437,25440,25444,25445,25446,25448,25450,25451,25452,25455,25456,25458,25459,25460,25461,25464,25465,25468,25469,25470,25471,25473,25475,25476,25477,25478,25483,25485,25489,25491,25492,25493,25495,25497,25498,25499,25500,25501,25502,25503,25505,25508,25510,25515,25519,25521,25522,25525,25526,25529,25531,25533,25535,25536,25537,25538,25539,25541,25543,25544,25546,25547,25548,25553,25555,25556,25557,25559,25560,25561,25562,25563,25564,25565,25567,25570,25572,25573,25574,25575,25576,25579,25580,25582,25583,25584,25585,25587,25589,25591,25593,25594,25595,25596,25598,25603,25604,25606,25607,25608,25609,25610,25613,25614,25617,25618,25621,25622,25623,25624,25625,25626,25629,25631,25634,25635,25636,25637,25639,25640,25641,25643,25646,25647,25648,25649,25650,25651,25653,25654,25655,25656,25657,25659,25660,25662,25664,25666,25667,25673,25675,25676,25677,25678,25679,25680,25681,25683,25685,25686,25687,25689,25690,25691,25692,25693,25695,25696,25697,25698,25699,25700,25701,25702,25704,25706,25707,25708,25710,25711,25712,25713,25714,25715,25716,25717,25718,25719,25723,25724,25725,25726,25727,25728,25729,25731,25734,25736,25737,25738,25739,25740,25741,25742,25743,25744,25747,25748,25751,25752,25754,25755,25756,25757,25759,25760,25761,25762,25763,25765,25766,25767,25768,25770,25771,25775,25777,25778,25779,25780,25782,25785,25787,25789,25790,25791,25793,25795,25796,25798,25799,25800,25801,25802,25803,25804,25807,25809,25811,25812,25813,25814,25817,25818,25819,25820,25821,25823,25824,25825,25827,25829,25831,25832,25833,25834,25835,25836,25837,25838,25839,25840,25841,25842,25843,25844,25845,25846,25847,25848,25849,25850,25851,25852,25853,25854,25855,25857,25858,25859,25860,25861,25862,25863,25864,25866,25867,25868,25869,25870,25871,25872,25873,25875,25876,25877,25878,25879,25881,25882,25883,25884,25885,25886,25887,25888,25889,25890,25891,25892,25894,25895,25896,25897,25898,25900,25901,25904,25905,25906,25907,25911,25914,25916,25917,25920,25921,25922,25923,25924,25926,25927,25930,25931,25933,25934,25936,25938,25939,25940,25943,25944,25946,25948,25951,25952,25953,25956,25957,25959,25960,25961,25962,25965,25966,25967,25969,25971,25973,25974,25976,25977,25978,25979,25980,25981,25982,25983,25984,25985,25986,25987,25988,25989,25990,25992,25993,25994,25997,25998,25999,26002,26004,26005,26006,26008,26010,26013,26014,26016,26018,26019,26022,26024,26026,26028,26030,26033,26034,26035,26036,26037,26038,26039,26040,26042,26043,26046,26047,26048,26050,26055,26056,26057,26058,26061,26064,26065,26067,26068,26069,26072,26073,26074,26075,26076,26077,26078,26079,26081,26083,26084,26090,26091,26098,26099,26100,26101,26104,26105,26107,26108,26109,26110,26111,26113,26116,26117,26119,26120,26121,26123,26125,26128,26129,26130,26134,26135,26136,26138,26139,26140,26142,26145,26146,26147,26148,26150,26153,26154,26155,26156,26158,26160,26162,26163,26167,26168,26169,26170,26171,26173,26175,26176,26178,26180,26181,26182,26183,26184,26185,26186,26189,26190,26192,26193,26200,26201,26203,26204,26205,26206,26208,26210,26211,26213,26215,26217,26218,26219,26220,26221,26225,26226,26227,26229,26232,26233,26235,26236,26237,26239,26240,26241,26243,26245,26246,26248,26249,26250,26251,26253,26254,26255,26256,26258,26259,26260,26261,26264,26265,26266,26267,26268,26270,26271,26272,26273,26274,26275,26276,26277,26278,26281,26282,26283,26284,26285,26287,26288,26289,26290,26291,26293,26294,26295,26296,26298,26299,26300,26301,26303,26304,26305,26306,26307,26308,26309,26310,26311,26312,26313,26314,26315,26316,26317,26318,26319,26320,26321,26322,26323,26324,26325,26326,26327,26328,26330,26334,26335,26336,26337,26338,26339,26340,26341,26343,26344,26346,26347,26348,26349,26350,26351,26353,26357,26358,26360,26362,26363,26365,26369,26370,26371,26372,26373,26374,26375,26380,26382,26383,26385,26386,26387,26390,26392,26393,26394,26396,26398,26400,26401,26402,26403,26404,26405,26407,26409,26414,26416,26418,26419,26422,26423,26424,26425,26427,26428,26430,26431,26433,26436,26437,26439,26442,26443,26445,26450,26452,26453,26455,26456,26457,26458,26459,26461,26466,26467,26468,26470,26471,26475,26476,26478,26481,26484,26486,26488,26489,26490,26491,26493,26496,26498,26499,26501,26502,26504,26506,26508,26509,26510,26511,26513,26514,26515,26516,26518,26521,26523,26527,26528,26529,26532,26534,26537,26540,26542,26545,26546,26548,26553,26554,26555,26556,26557,26558,26559,26560,26562,26565,26566,26567,26568,26569,26570,26571,26572,26573,26574,26581,26582,26583,26587,26591,26593,26595,26596,26598,26599,26600,26602,26603,26605,26606,26610,26613,26614,26615,26616,26617,26618,26619,26620,26622,26625,26626,26627,26628,26630,26637,26640,26642,26644,26645,26648,26649,26650,26651,26652,26654,26655,26656,26658,26659,26660,26661,26662,26663,26664,26667,26668,26669,26670,26671,26672,26673,26676,26677,26678,26682,26683,26687,26695,26699,26701,26703,26706,26710,26711,26712,26713,26714,26715,26716,26717,26718,26719,26730,26732,26733,26734,26735,26736,26737,26738,26739,26741,26744,26745,26746,26747,26748,26749,26750,26751,26752,26754,26756,26759,26760,26761,26762,26763,26764,26765,26766,26768,26769,26770,26772,26773,26774,26776,26777,26778,26779,26780,26781,26782,26783,26784,26785,26787,26788,26789,26793,26794,26795,26796,26798,26801,26802,26804,26806,26807,26808,26809,26810,26811,26812,26813,26814,26815,26817,26819,26820,26821,26822,26823,26824,26826,26828,26830,26831,26832,26833,26835,26836,26838,26839,26841,26843,26844,26845,26846,26847,26849,26850,26852,26853,26854,26855,26856,26857,26858,26859,26860,26861,26863,26866,26867,26868,26870,26871,26872,26875,26877,26878,26879,26880,26882,26883,26884,26886,26887,26888,26889,26890,26892,26895,26897,26899,26900,26901,26902,26903,26904,26905,26906,26907,26908,26909,26910,26913,26914,26915,26917,26918,26919,26920,26921,26922,26923,26924,26926,26927,26929,26930,26931,26933,26934,26935,26936,26938,26939,26940,26942,26944,26945,26947,26948,26949,26950,26951,26952,26953,26954,26955,26956,26957,26958,26959,26960,26961,26962,26963,26965,26966,26968,26969,26971,26972,26975,26977,26978,26980,26981,26983,26984,26985,26986,26988,26989,26991,26992,26994,26995,26996,26997,26998,27002,27003,27005,27006,27007,27009,27011,27013,27018,27019,27020,27022,27023,27024,27025,27026,27027,27030,27031,27033,27034,27037,27038,27039,27040,27041,27042,27043,27044,27045,27046,27049,27050,27052,27054,27055,27056,27058,27059,27061,27062,27064,27065,27066,27068,27069,27070,27071,27072,27074,27075,27076,27077,27078,27079,27080,27081,27083,27085,27087,27089,27090,27091,27093,27094,27095,27096,27097,27098,27100,27101,27102,27105,27106,27107,27108,27109,27110,27111,27112,27113,27114,27115,27116,27118,27119,27120,27121,27123,27124,27125,27126,27127,27128,27129,27130,27131,27132,27134,27136,27137,27138,27139,27140,27141,27142,27143,27144,27145,27147,27148,27149,27150,27151,27152,27153,27154,27155,27156,27157,27158,27161,27162,27163,27164,27165,27166,27168,27170,27171,27172,27173,27174,27175,27177,27179,27180,27181,27182,27184,27186,27187,27188,27190,27191,27192,27193,27194,27195,27196,27199,27200,27201,27202,27203,27205,27206,27208,27209,27210,27211,27212,27213,27214,27215,27217,27218,27219,27220,27221,27222,27223,27226,27228,27229,27230,27231,27232,27234,27235,27236,27238,27239,27240,27241,27242,27243,27244,27245,27246,27247,27248,27250,27251,27252,27253,27254,27255,27256,27258,27259,27261,27262,27263,27265,27266,27267,27269,27270,27271,27272,27273,27274,27275,27276,27277,27279,27282,27283,27284,27285,27286,27288,27289,27290,27291,27292,27293,27294,27295,27297,27298,27299,27300,27301,27302,27303,27304,27306,27309,27310,27311,27312,27313,27314,27315,27316,27317,27318,27319,27320,27321,27322,27323,27324,27325,27326,27327,27328,27329,27330,27331,27332,27333,27334,27335,27336,27337,27338,27339,27340,27341,27342,27343,27344,27345,27346,27347,27348,27349,27350,27351,27352,27353,27354,27355,27356,27357,27358,27359,27360,27361,27362,27363,27364,27365,27366,27367,27368,27369,27370,27371,27372,27373,27374,27375,27376,27377,27378,27379,27380,27381,27382,27383,27384,27385,27386,27387,27388,27389,27390,27391,27392,27393,27394,27395,27396,27397,27398,27399,27400,27401,27402,27403,27404,27405,27406,27407,27408,27409,27410,27411,27412,27413,27414,27415,27416,27417,27418,27419,27420,27421,27422,27423,27429,27430,27432,27433,27434,27435,27436,27437,27438,27439,27440,27441,27443,27444,27445,27446,27448,27451,27452,27453,27455,27456,27457,27458,27460,27461,27464,27466,27467,27469,27470,27471,27472,27473,27474,27475,27476,27477,27478,27479,27480,27482,27483,27484,27485,27486,27487,27488,27489,27496,27497,27499,27500,27501,27502,27503,27504,27505,27506,27507,27508,27509,27510,27511,27512,27514,27517,27518,27519,27520,27525,27528,27532,27534,27535,27536,27537,27540,27541,27543,27544,27545,27548,27549,27550,27551,27552,27554,27555,27556,27557,27558,27559,27560,27561,27563,27564,27565,27566,27567,27568,27569,27570,27574,27576,27577,27578,27579,27580,27581,27582,27584,27587,27588,27590,27591,27592,27593,27594,27596,27598,27600,27601,27608,27610,27612,27613,27614,27615,27616,27618,27619,27620,27621,27622,27623,27624,27625,27628,27629,27630,27632,27633,27634,27636,27638,27639,27640,27642,27643,27644,27646,27647,27648,27649,27650,27651,27652,27656,27657,27658,27659,27660,27662,27666,27671,27676,27677,27678,27680,27683,27685,27691,27692,27693,27697,27699,27702,27703,27705,27706,27707,27708,27710,27711,27715,27716,27717,27720,27723,27724,27725,27726,27727,27729,27730,27731,27734,27736,27737,27738,27746,27747,27749,27750,27751,27755,27756,27757,27758,27759,27761,27763,27765,27767,27768,27770,27771,27772,27775,27776,27780,27783,27786,27787,27789,27790,27793,27794,27797,27798,27799,27800,27802,27804,27805,27806,27808,27810,27816,27820,27823,27824,27828,27829,27830,27831,27834,27840,27841,27842,27843,27846,27847,27848,27851,27853,27854,27855,27857,27858,27864,27865,27866,27868,27869,27871,27876,27878,27879,27881,27884,27885,27890,27892,27897,27903,27904,27906,27907,27909,27910,27912,27913,27914,27917,27919,27920,27921,27923,27924,27925,27926,27928,27932,27933,27935,27936,27937,27938,27939,27940,27942,27944,27945,27948,27949,27951,27952,27956,27958,27959,27960,27962,27967,27968,27970,27972,27977,27980,27984,27989,27990,27991,27992,27995,27997,27999,28001,28002,28004,28005,28007,28008,28011,28012,28013,28016,28017,28018,28019,28021,28022,28025,28026,28027,28029,28030,28031,28032,28033,28035,28036,28038,28039,28042,28043,28045,28047,28048,28050,28054,28055,28056,28057,28058,28060,28066,28069,28076,28077,28080,28081,28083,28084,28086,28087,28089,28090,28091,28092,28093,28094,28097,28098,28099,28104,28105,28106,28109,28110,28111,28112,28114,28115,28116,28117,28119,28122,28123,28124,28127,28130,28131,28133,28135,28136,28137,28138,28141,28143,28144,28146,28148,28149,28150,28152,28154,28157,28158,28159,28160,28161,28162,28163,28164,28166,28167,28168,28169,28171,28175,28178,28179,28181,28184,28185,28187,28188,28190,28191,28194,28198,28199,28200,28202,28204,28206,28208,28209,28211,28213,28214,28215,28217,28219,28220,28221,28222,28223,28224,28225,28226,28229,28230,28231,28232,28233,28234,28235,28236,28239,28240,28241,28242,28245,28247,28249,28250,28252,28253,28254,28256,28257,28258,28259,28260,28261,28262,28263,28264,28265,28266,28268,28269,28271,28272,28273,28274,28275,28276,28277,28278,28279,28280,28281,28282,28283,28284,28285,28288,28289,28290,28292,28295,28296,28298,28299,28300,28301,28302,28305,28306,28307,28308,28309,28310,28311,28313,28314,28315,28317,28318,28320,28321,28323,28324,28326,28328,28329,28331,28332,28333,28334,28336,28339,28341,28344,28345,28348,28350,28351,28352,28355,28356,28357,28358,28360,28361,28362,28364,28365,28366,28368,28370,28374,28376,28377,28379,28380,28381,28387,28391,28394,28395,28396,28397,28398,28399,28400,28401,28402,28403,28405,28406,28407,28408,28410,28411,28412,28413,28414,28415,28416,28417,28419,28420,28421,28423,28424,28426,28427,28428,28429,28430,28432,28433,28434,28438,28439,28440,28441,28442,28443,28444,28445,28446,28447,28449,28450,28451,28453,28454,28455,28456,28460,28462,28464,28466,28468,28469,28471,28472,28473,28474,28475,28476,28477,28479,28480,28481,28482,28483,28484,28485,28488,28489,28490,28492,28494,28495,28496,28497,28498,28499,28500,28501,28502,28503,28505,28506,28507,28509,28511,28512,28513,28515,28516,28517,28519,28520,28521,28522,28523,28524,28527,28528,28529,28531,28533,28534,28535,28537,28539,28541,28542,28543,28544,28545,28546,28547,28549,28550,28551,28554,28555,28559,28560,28561,28562,28563,28564,28565,28566,28567,28568,28569,28570,28571,28573,28574,28575,28576,28578,28579,28580,28581,28582,28584,28585,28586,28587,28588,28589,28590,28591,28592,28593,28594,28596,28597,28599,28600,28602,28603,28604,28605,28606,28607,28609,28611,28612,28613,28614,28615,28616,28618,28619,28620,28621,28622,28623,28624,28627,28628,28629,28630,28631,28632,28633,28634,28635,28636,28637,28639,28642,28643,28644,28645,28646,28647,28648,28649,28650,28651,28652,28653,28656,28657,28658,28659,28660,28661,28662,28663,28664,28665,28666,28667,28668,28669,28670,28671,28672,28673,28674,28675,28676,28677,28678,28679,28680,28681,28682,28683,28684,28685,28686,28687,28688,28690,28691,28692,28693,28694,28695,28696,28697,28700,28701,28702,28703,28704,28705,28706,28708,28709,28710,28711,28712,28713,28714,28715,28716,28717,28718,28719,28720,28721,28722,28723,28724,28726,28727,28728,28730,28731,28732,28733,28734,28735,28736,28737,28738,28739,28740,28741,28742,28743,28744,28745,28746,28747,28749,28750,28752,28753,28754,28755,28756,28757,28758,28759,28760,28761,28762,28763,28764,28765,28767,28768,28769,28770,28771,28772,28773,28774,28775,28776,28777,28778,28782,28785,28786,28787,28788,28791,28793,28794,28795,28797,28801,28802,28803,28804,28806,28807,28808,28811,28812,28813,28815,28816,28817,28819,28823,28824,28826,28827,28830,28831,28832,28833,28834,28835,28836,28837,28838,28839,28840,28841,28842,28848,28850,28852,28853,28854,28858,28862,28863,28868,28869,28870,28871,28873,28875,28876,28877,28878,28879,28880,28881,28882,28883,28884,28885,28886,28887,28890,28892,28893,28894,28896,28897,28898,28899,28901,28906,28910,28912,28913,28914,28915,28916,28917,28918,28920,28922,28923,28924,28926,28927,28928,28929,28930,28931,28932,28933,28934,28935,28936,28939,28940,28941,28942,28943,28945,28946,28948,28951,28955,28956,28957,28958,28959,28960,28961,28962,28963,28964,28965,28967,28968,28969,28970,28971,28972,28973,28974,28978,28979,28980,28981,28983,28984,28985,28986,28987,28988,28989,28990,28991,28992,28993,28994,28995,28996,28998,28999,29000,29001,29003,29005,29007,29008,29009,29010,29011,29012,29013,29014,29015,29016,29017,29018,29019,29021,29023,29024,29025,29026,29027,29029,29033,29034,29035,29036,29037,29039,29040,29041,29044,29045,29046,29047,29049,29051,29052,29054,29055,29056,29057,29058,29059,29061,29062,29063,29064,29065,29067,29068,29069,29070,29072,29073,29074,29075,29077,29078,29079,29082,29083,29084,29085,29086,29089,29090,29091,29092,29093,29094,29095,29097,29098,29099,29101,29102,29103,29104,29105,29106,29108,29110,29111,29112,29114,29115,29116,29117,29118,29119,29120,29121,29122,29124,29125,29126,29127,29128,29129,29130,29131,29132,29133,29135,29136,29137,29138,29139,29142,29143,29144,29145,29146,29147,29148,29149,29150,29151,29153,29154,29155,29156,29158,29160,29161,29162,29163,29164,29165,29167,29168,29169,29170,29171,29172,29173,29174,29175,29176,29178,29179,29180,29181,29182,29183,29184,29185,29186,29187,29188,29189,29191,29192,29193,29194,29195,29196,29197,29198,29199,29200,29201,29202,29203,29204,29205,29206,29207,29208,29209,29210,29211,29212,29214,29215,29216,29217,29218,29219,29220,29221,29222,29223,29225,29227,29229,29230,29231,29234,29235,29236,29242,29244,29246,29248,29249,29250,29251,29252,29253,29254,29257,29258,29259,29262,29263,29264,29265,29267,29268,29269,29271,29272,29274,29276,29278,29280,29283,29284,29285,29288,29290,29291,29292,29293,29296,29297,29299,29300,29302,29303,29304,29307,29308,29309,29314,29315,29317,29318,29319,29320,29321,29324,29326,29328,29329,29331,29332,29333,29334,29335,29336,29337,29338,29339,29340,29341,29342,29344,29345,29346,29347,29348,29349,29350,29351,29352,29353,29354,29355,29358,29361,29362,29363,29365,29370,29371,29372,29373,29374,29375,29376,29381,29382,29383,29385,29386,29387,29388,29391,29393,29395,29396,29397,29398,29400,29402,29403,58566,58567,58568,58569,58570,58571,58572,58573,58574,58575,58576,58577,58578,58579,58580,58581,58582,58583,58584,58585,58586,58587,58588,58589,58590,58591,58592,58593,58594,58595,58596,58597,58598,58599,58600,58601,58602,58603,58604,58605,58606,58607,58608,58609,58610,58611,58612,58613,58614,58615,58616,58617,58618,58619,58620,58621,58622,58623,58624,58625,58626,58627,58628,58629,58630,58631,58632,58633,58634,58635,58636,58637,58638,58639,58640,58641,58642,58643,58644,58645,58646,58647,58648,58649,58650,58651,58652,58653,58654,58655,58656,58657,58658,58659,58660,58661,12288,12289,12290,183,713,711,168,12291,12293,8212,65374,8214,8230,8216,8217,8220,8221,12308,12309,12296,12297,12298,12299,12300,12301,12302,12303,12310,12311,12304,12305,177,215,247,8758,8743,8744,8721,8719,8746,8745,8712,8759,8730,8869,8741,8736,8978,8857,8747,8750,8801,8780,8776,8765,8733,8800,8814,8815,8804,8805,8734,8757,8756,9794,9792,176,8242,8243,8451,65284,164,65504,65505,8240,167,8470,9734,9733,9675,9679,9678,9671,9670,9633,9632,9651,9650,8251,8594,8592,8593,8595,12307,58662,58663,58664,58665,58666,58667,58668,58669,58670,58671,58672,58673,58674,58675,58676,58677,58678,58679,58680,58681,58682,58683,58684,58685,58686,58687,58688,58689,58690,58691,58692,58693,58694,58695,58696,58697,58698,58699,58700,58701,58702,58703,58704,58705,58706,58707,58708,58709,58710,58711,58712,58713,58714,58715,58716,58717,58718,58719,58720,58721,58722,58723,58724,58725,58726,58727,58728,58729,58730,58731,58732,58733,58734,58735,58736,58737,58738,58739,58740,58741,58742,58743,58744,58745,58746,58747,58748,58749,58750,58751,58752,58753,58754,58755,58756,58757,8560,8561,8562,8563,8564,8565,8566,8567,8568,8569,59238,59239,59240,59241,59242,59243,9352,9353,9354,9355,9356,9357,9358,9359,9360,9361,9362,9363,9364,9365,9366,9367,9368,9369,9370,9371,9332,9333,9334,9335,9336,9337,9338,9339,9340,9341,9342,9343,9344,9345,9346,9347,9348,9349,9350,9351,9312,9313,9314,9315,9316,9317,9318,9319,9320,9321,8364,59245,12832,12833,12834,12835,12836,12837,12838,12839,12840,12841,59246,59247,8544,8545,8546,8547,8548,8549,8550,8551,8552,8553,8554,8555,59248,59249,58758,58759,58760,58761,58762,58763,58764,58765,58766,58767,58768,58769,58770,58771,58772,58773,58774,58775,58776,58777,58778,58779,58780,58781,58782,58783,58784,58785,58786,58787,58788,58789,58790,58791,58792,58793,58794,58795,58796,58797,58798,58799,58800,58801,58802,58803,58804,58805,58806,58807,58808,58809,58810,58811,58812,58813,58814,58815,58816,58817,58818,58819,58820,58821,58822,58823,58824,58825,58826,58827,58828,58829,58830,58831,58832,58833,58834,58835,58836,58837,58838,58839,58840,58841,58842,58843,58844,58845,58846,58847,58848,58849,58850,58851,58852,12288,65281,65282,65283,65509,65285,65286,65287,65288,65289,65290,65291,65292,65293,65294,65295,65296,65297,65298,65299,65300,65301,65302,65303,65304,65305,65306,65307,65308,65309,65310,65311,65312,65313,65314,65315,65316,65317,65318,65319,65320,65321,65322,65323,65324,65325,65326,65327,65328,65329,65330,65331,65332,65333,65334,65335,65336,65337,65338,65339,65340,65341,65342,65343,65344,65345,65346,65347,65348,65349,65350,65351,65352,65353,65354,65355,65356,65357,65358,65359,65360,65361,65362,65363,65364,65365,65366,65367,65368,65369,65370,65371,65372,65373,65507,58854,58855,58856,58857,58858,58859,58860,58861,58862,58863,58864,58865,58866,58867,58868,58869,58870,58871,58872,58873,58874,58875,58876,58877,58878,58879,58880,58881,58882,58883,58884,58885,58886,58887,58888,58889,58890,58891,58892,58893,58894,58895,58896,58897,58898,58899,58900,58901,58902,58903,58904,58905,58906,58907,58908,58909,58910,58911,58912,58913,58914,58915,58916,58917,58918,58919,58920,58921,58922,58923,58924,58925,58926,58927,58928,58929,58930,58931,58932,58933,58934,58935,58936,58937,58938,58939,58940,58941,58942,58943,58944,58945,58946,58947,58948,58949,12353,12354,12355,12356,12357,12358,12359,12360,12361,12362,12363,12364,12365,12366,12367,12368,12369,12370,12371,12372,12373,12374,12375,12376,12377,12378,12379,12380,12381,12382,12383,12384,12385,12386,12387,12388,12389,12390,12391,12392,12393,12394,12395,12396,12397,12398,12399,12400,12401,12402,12403,12404,12405,12406,12407,12408,12409,12410,12411,12412,12413,12414,12415,12416,12417,12418,12419,12420,12421,12422,12423,12424,12425,12426,12427,12428,12429,12430,12431,12432,12433,12434,12435,59250,59251,59252,59253,59254,59255,59256,59257,59258,59259,59260,58950,58951,58952,58953,58954,58955,58956,58957,58958,58959,58960,58961,58962,58963,58964,58965,58966,58967,58968,58969,58970,58971,58972,58973,58974,58975,58976,58977,58978,58979,58980,58981,58982,58983,58984,58985,58986,58987,58988,58989,58990,58991,58992,58993,58994,58995,58996,58997,58998,58999,59000,59001,59002,59003,59004,59005,59006,59007,59008,59009,59010,59011,59012,59013,59014,59015,59016,59017,59018,59019,59020,59021,59022,59023,59024,59025,59026,59027,59028,59029,59030,59031,59032,59033,59034,59035,59036,59037,59038,59039,59040,59041,59042,59043,59044,59045,12449,12450,12451,12452,12453,12454,12455,12456,12457,12458,12459,12460,12461,12462,12463,12464,12465,12466,12467,12468,12469,12470,12471,12472,12473,12474,12475,12476,12477,12478,12479,12480,12481,12482,12483,12484,12485,12486,12487,12488,12489,12490,12491,12492,12493,12494,12495,12496,12497,12498,12499,12500,12501,12502,12503,12504,12505,12506,12507,12508,12509,12510,12511,12512,12513,12514,12515,12516,12517,12518,12519,12520,12521,12522,12523,12524,12525,12526,12527,12528,12529,12530,12531,12532,12533,12534,59261,59262,59263,59264,59265,59266,59267,59268,59046,59047,59048,59049,59050,59051,59052,59053,59054,59055,59056,59057,59058,59059,59060,59061,59062,59063,59064,59065,59066,59067,59068,59069,59070,59071,59072,59073,59074,59075,59076,59077,59078,59079,59080,59081,59082,59083,59084,59085,59086,59087,59088,59089,59090,59091,59092,59093,59094,59095,59096,59097,59098,59099,59100,59101,59102,59103,59104,59105,59106,59107,59108,59109,59110,59111,59112,59113,59114,59115,59116,59117,59118,59119,59120,59121,59122,59123,59124,59125,59126,59127,59128,59129,59130,59131,59132,59133,59134,59135,59136,59137,59138,59139,59140,59141,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,59269,59270,59271,59272,59273,59274,59275,59276,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,963,964,965,966,967,968,969,59277,59278,59279,59280,59281,59282,59283,65077,65078,65081,65082,65087,65088,65085,65086,65089,65090,65091,65092,59284,59285,65083,65084,65079,65080,65073,59286,65075,65076,59287,59288,59289,59290,59291,59292,59293,59294,59295,59142,59143,59144,59145,59146,59147,59148,59149,59150,59151,59152,59153,59154,59155,59156,59157,59158,59159,59160,59161,59162,59163,59164,59165,59166,59167,59168,59169,59170,59171,59172,59173,59174,59175,59176,59177,59178,59179,59180,59181,59182,59183,59184,59185,59186,59187,59188,59189,59190,59191,59192,59193,59194,59195,59196,59197,59198,59199,59200,59201,59202,59203,59204,59205,59206,59207,59208,59209,59210,59211,59212,59213,59214,59215,59216,59217,59218,59219,59220,59221,59222,59223,59224,59225,59226,59227,59228,59229,59230,59231,59232,59233,59234,59235,59236,59237,1040,1041,1042,1043,1044,1045,1025,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,59296,59297,59298,59299,59300,59301,59302,59303,59304,59305,59306,59307,59308,59309,59310,1072,1073,1074,1075,1076,1077,1105,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,59311,59312,59313,59314,59315,59316,59317,59318,59319,59320,59321,59322,59323,714,715,729,8211,8213,8229,8245,8453,8457,8598,8599,8600,8601,8725,8735,8739,8786,8806,8807,8895,9552,9553,9554,9555,9556,9557,9558,9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,9570,9571,9572,9573,9574,9575,9576,9577,9578,9579,9580,9581,9582,9583,9584,9585,9586,9587,9601,9602,9603,9604,9605,9606,9607,9608,9609,9610,9611,9612,9613,9614,9615,9619,9620,9621,9660,9661,9698,9699,9700,9701,9737,8853,12306,12317,12318,59324,59325,59326,59327,59328,59329,59330,59331,59332,59333,59334,257,225,462,224,275,233,283,232,299,237,464,236,333,243,466,242,363,250,468,249,470,472,474,476,252,234,593,7743,324,328,505,609,59337,59338,59339,59340,12549,12550,12551,12552,12553,12554,12555,12556,12557,12558,12559,12560,12561,12562,12563,12564,12565,12566,12567,12568,12569,12570,12571,12572,12573,12574,12575,12576,12577,12578,12579,12580,12581,12582,12583,12584,12585,59341,59342,59343,59344,59345,59346,59347,59348,59349,59350,59351,59352,59353,59354,59355,59356,59357,59358,59359,59360,59361,12321,12322,12323,12324,12325,12326,12327,12328,12329,12963,13198,13199,13212,13213,13214,13217,13252,13262,13265,13266,13269,65072,65506,65508,59362,8481,12849,59363,8208,59364,59365,59366,12540,12443,12444,12541,12542,12294,12445,12446,65097,65098,65099,65100,65101,65102,65103,65104,65105,65106,65108,65109,65110,65111,65113,65114,65115,65116,65117,65118,65119,65120,65121,65122,65123,65124,65125,65126,65128,65129,65130,65131,12350,12272,12273,12274,12275,12276,12277,12278,12279,12280,12281,12282,12283,12295,59380,59381,59382,59383,59384,59385,59386,59387,59388,59389,59390,59391,59392,9472,9473,9474,9475,9476,9477,9478,9479,9480,9481,9482,9483,9484,9485,9486,9487,9488,9489,9490,9491,9492,9493,9494,9495,9496,9497,9498,9499,9500,9501,9502,9503,9504,9505,9506,9507,9508,9509,9510,9511,9512,9513,9514,9515,9516,9517,9518,9519,9520,9521,9522,9523,9524,9525,9526,9527,9528,9529,9530,9531,9532,9533,9534,9535,9536,9537,9538,9539,9540,9541,9542,9543,9544,9545,9546,9547,59393,59394,59395,59396,59397,59398,59399,59400,59401,59402,59403,59404,59405,59406,59407,29404,29405,29407,29410,29411,29412,29413,29414,29415,29418,29419,29429,29430,29433,29437,29438,29439,29440,29442,29444,29445,29446,29447,29448,29449,29451,29452,29453,29455,29456,29457,29458,29460,29464,29465,29466,29471,29472,29475,29476,29478,29479,29480,29485,29487,29488,29490,29491,29493,29494,29498,29499,29500,29501,29504,29505,29506,29507,29508,29509,29510,29511,29512,29513,29514,29515,29516,29518,29519,29521,29523,29524,29525,29526,29528,29529,29530,29531,29532,29533,29534,29535,29537,29538,29539,29540,29541,29542,29543,29544,29545,29546,29547,29550,29552,29553,57344,57345,57346,57347,57348,57349,57350,57351,57352,57353,57354,57355,57356,57357,57358,57359,57360,57361,57362,57363,57364,57365,57366,57367,57368,57369,57370,57371,57372,57373,57374,57375,57376,57377,57378,57379,57380,57381,57382,57383,57384,57385,57386,57387,57388,57389,57390,57391,57392,57393,57394,57395,57396,57397,57398,57399,57400,57401,57402,57403,57404,57405,57406,57407,57408,57409,57410,57411,57412,57413,57414,57415,57416,57417,57418,57419,57420,57421,57422,57423,57424,57425,57426,57427,57428,57429,57430,57431,57432,57433,57434,57435,57436,57437,29554,29555,29556,29557,29558,29559,29560,29561,29562,29563,29564,29565,29567,29568,29569,29570,29571,29573,29574,29576,29578,29580,29581,29583,29584,29586,29587,29588,29589,29591,29592,29593,29594,29596,29597,29598,29600,29601,29603,29604,29605,29606,29607,29608,29610,29612,29613,29617,29620,29621,29622,29624,29625,29628,29629,29630,29631,29633,29635,29636,29637,29638,29639,29643,29644,29646,29650,29651,29652,29653,29654,29655,29656,29658,29659,29660,29661,29663,29665,29666,29667,29668,29670,29672,29674,29675,29676,29678,29679,29680,29681,29683,29684,29685,29686,29687,57438,57439,57440,57441,57442,57443,57444,57445,57446,57447,57448,57449,57450,57451,57452,57453,57454,57455,57456,57457,57458,57459,57460,57461,57462,57463,57464,57465,57466,57467,57468,57469,57470,57471,57472,57473,57474,57475,57476,57477,57478,57479,57480,57481,57482,57483,57484,57485,57486,57487,57488,57489,57490,57491,57492,57493,57494,57495,57496,57497,57498,57499,57500,57501,57502,57503,57504,57505,57506,57507,57508,57509,57510,57511,57512,57513,57514,57515,57516,57517,57518,57519,57520,57521,57522,57523,57524,57525,57526,57527,57528,57529,57530,57531,29688,29689,29690,29691,29692,29693,29694,29695,29696,29697,29698,29700,29703,29704,29707,29708,29709,29710,29713,29714,29715,29716,29717,29718,29719,29720,29721,29724,29725,29726,29727,29728,29729,29731,29732,29735,29737,29739,29741,29743,29745,29746,29751,29752,29753,29754,29755,29757,29758,29759,29760,29762,29763,29764,29765,29766,29767,29768,29769,29770,29771,29772,29773,29774,29775,29776,29777,29778,29779,29780,29782,29784,29789,29792,29793,29794,29795,29796,29797,29798,29799,29800,29801,29802,29803,29804,29806,29807,29809,29810,29811,29812,29813,29816,29817,29818,57532,57533,57534,57535,57536,57537,57538,57539,57540,57541,57542,57543,57544,57545,57546,57547,57548,57549,57550,57551,57552,57553,57554,57555,57556,57557,57558,57559,57560,57561,57562,57563,57564,57565,57566,57567,57568,57569,57570,57571,57572,57573,57574,57575,57576,57577,57578,57579,57580,57581,57582,57583,57584,57585,57586,57587,57588,57589,57590,57591,57592,57593,57594,57595,57596,57597,57598,57599,57600,57601,57602,57603,57604,57605,57606,57607,57608,57609,57610,57611,57612,57613,57614,57615,57616,57617,57618,57619,57620,57621,57622,57623,57624,57625,29819,29820,29821,29823,29826,29828,29829,29830,29832,29833,29834,29836,29837,29839,29841,29842,29843,29844,29845,29846,29847,29848,29849,29850,29851,29853,29855,29856,29857,29858,29859,29860,29861,29862,29866,29867,29868,29869,29870,29871,29872,29873,29874,29875,29876,29877,29878,29879,29880,29881,29883,29884,29885,29886,29887,29888,29889,29890,29891,29892,29893,29894,29895,29896,29897,29898,29899,29900,29901,29902,29903,29904,29905,29907,29908,29909,29910,29911,29912,29913,29914,29915,29917,29919,29921,29925,29927,29928,29929,29930,29931,29932,29933,29936,29937,29938,57626,57627,57628,57629,57630,57631,57632,57633,57634,57635,57636,57637,57638,57639,57640,57641,57642,57643,57644,57645,57646,57647,57648,57649,57650,57651,57652,57653,57654,57655,57656,57657,57658,57659,57660,57661,57662,57663,57664,57665,57666,57667,57668,57669,57670,57671,57672,57673,57674,57675,57676,57677,57678,57679,57680,57681,57682,57683,57684,57685,57686,57687,57688,57689,57690,57691,57692,57693,57694,57695,57696,57697,57698,57699,57700,57701,57702,57703,57704,57705,57706,57707,57708,57709,57710,57711,57712,57713,57714,57715,57716,57717,57718,57719,29939,29941,29944,29945,29946,29947,29948,29949,29950,29952,29953,29954,29955,29957,29958,29959,29960,29961,29962,29963,29964,29966,29968,29970,29972,29973,29974,29975,29979,29981,29982,29984,29985,29986,29987,29988,29990,29991,29994,29998,30004,30006,30009,30012,30013,30015,30017,30018,30019,30020,30022,30023,30025,30026,30029,30032,30033,30034,30035,30037,30038,30039,30040,30045,30046,30047,30048,30049,30050,30051,30052,30055,30056,30057,30059,30060,30061,30062,30063,30064,30065,30067,30069,30070,30071,30074,30075,30076,30077,30078,30080,30081,30082,30084,30085,30087,57720,57721,57722,57723,57724,57725,57726,57727,57728,57729,57730,57731,57732,57733,57734,57735,57736,57737,57738,57739,57740,57741,57742,57743,57744,57745,57746,57747,57748,57749,57750,57751,57752,57753,57754,57755,57756,57757,57758,57759,57760,57761,57762,57763,57764,57765,57766,57767,57768,57769,57770,57771,57772,57773,57774,57775,57776,57777,57778,57779,57780,57781,57782,57783,57784,57785,57786,57787,57788,57789,57790,57791,57792,57793,57794,57795,57796,57797,57798,57799,57800,57801,57802,57803,57804,57805,57806,57807,57808,57809,57810,57811,57812,57813,30088,30089,30090,30092,30093,30094,30096,30099,30101,30104,30107,30108,30110,30114,30118,30119,30120,30121,30122,30125,30134,30135,30138,30139,30143,30144,30145,30150,30155,30156,30158,30159,30160,30161,30163,30167,30169,30170,30172,30173,30175,30176,30177,30181,30185,30188,30189,30190,30191,30194,30195,30197,30198,30199,30200,30202,30203,30205,30206,30210,30212,30214,30215,30216,30217,30219,30221,30222,30223,30225,30226,30227,30228,30230,30234,30236,30237,30238,30241,30243,30247,30248,30252,30254,30255,30257,30258,30262,30263,30265,30266,30267,30269,30273,30274,30276,57814,57815,57816,57817,57818,57819,57820,57821,57822,57823,57824,57825,57826,57827,57828,57829,57830,57831,57832,57833,57834,57835,57836,57837,57838,57839,57840,57841,57842,57843,57844,57845,57846,57847,57848,57849,57850,57851,57852,57853,57854,57855,57856,57857,57858,57859,57860,57861,57862,57863,57864,57865,57866,57867,57868,57869,57870,57871,57872,57873,57874,57875,57876,57877,57878,57879,57880,57881,57882,57883,57884,57885,57886,57887,57888,57889,57890,57891,57892,57893,57894,57895,57896,57897,57898,57899,57900,57901,57902,57903,57904,57905,57906,57907,30277,30278,30279,30280,30281,30282,30283,30286,30287,30288,30289,30290,30291,30293,30295,30296,30297,30298,30299,30301,30303,30304,30305,30306,30308,30309,30310,30311,30312,30313,30314,30316,30317,30318,30320,30321,30322,30323,30324,30325,30326,30327,30329,30330,30332,30335,30336,30337,30339,30341,30345,30346,30348,30349,30351,30352,30354,30356,30357,30359,30360,30362,30363,30364,30365,30366,30367,30368,30369,30370,30371,30373,30374,30375,30376,30377,30378,30379,30380,30381,30383,30384,30387,30389,30390,30391,30392,30393,30394,30395,30396,30397,30398,30400,30401,30403,21834,38463,22467,25384,21710,21769,21696,30353,30284,34108,30702,33406,30861,29233,38552,38797,27688,23433,20474,25353,26263,23736,33018,26696,32942,26114,30414,20985,25942,29100,32753,34948,20658,22885,25034,28595,33453,25420,25170,21485,21543,31494,20843,30116,24052,25300,36299,38774,25226,32793,22365,38712,32610,29240,30333,26575,30334,25670,20336,36133,25308,31255,26001,29677,25644,25203,33324,39041,26495,29256,25198,25292,20276,29923,21322,21150,32458,37030,24110,26758,27036,33152,32465,26834,30917,34444,38225,20621,35876,33502,32990,21253,35090,21093,30404,30407,30409,30411,30412,30419,30421,30425,30426,30428,30429,30430,30432,30433,30434,30435,30436,30438,30439,30440,30441,30442,30443,30444,30445,30448,30451,30453,30454,30455,30458,30459,30461,30463,30464,30466,30467,30469,30470,30474,30476,30478,30479,30480,30481,30482,30483,30484,30485,30486,30487,30488,30491,30492,30493,30494,30497,30499,30500,30501,30503,30506,30507,30508,30510,30512,30513,30514,30515,30516,30521,30523,30525,30526,30527,30530,30532,30533,30534,30536,30537,30538,30539,30540,30541,30542,30543,30546,30547,30548,30549,30550,30551,30552,30553,30556,34180,38649,20445,22561,39281,23453,25265,25253,26292,35961,40077,29190,26479,30865,24754,21329,21271,36744,32972,36125,38049,20493,29384,22791,24811,28953,34987,22868,33519,26412,31528,23849,32503,29997,27893,36454,36856,36924,40763,27604,37145,31508,24444,30887,34006,34109,27605,27609,27606,24065,24199,30201,38381,25949,24330,24517,36767,22721,33218,36991,38491,38829,36793,32534,36140,25153,20415,21464,21342,36776,36777,36779,36941,26631,24426,33176,34920,40150,24971,21035,30250,24428,25996,28626,28392,23486,25672,20853,20912,26564,19993,31177,39292,28851,30557,30558,30559,30560,30564,30567,30569,30570,30573,30574,30575,30576,30577,30578,30579,30580,30581,30582,30583,30584,30586,30587,30588,30593,30594,30595,30598,30599,30600,30601,30602,30603,30607,30608,30611,30612,30613,30614,30615,30616,30617,30618,30619,30620,30621,30622,30625,30627,30628,30630,30632,30635,30637,30638,30639,30641,30642,30644,30646,30647,30648,30649,30650,30652,30654,30656,30657,30658,30659,30660,30661,30662,30663,30664,30665,30666,30667,30668,30670,30671,30672,30673,30674,30675,30676,30677,30678,30680,30681,30682,30685,30686,30687,30688,30689,30692,30149,24182,29627,33760,25773,25320,38069,27874,21338,21187,25615,38082,31636,20271,24091,33334,33046,33162,28196,27850,39539,25429,21340,21754,34917,22496,19981,24067,27493,31807,37096,24598,25830,29468,35009,26448,25165,36130,30572,36393,37319,24425,33756,34081,39184,21442,34453,27531,24813,24808,28799,33485,33329,20179,27815,34255,25805,31961,27133,26361,33609,21397,31574,20391,20876,27979,23618,36461,25554,21449,33580,33590,26597,30900,25661,23519,23700,24046,35815,25286,26612,35962,25600,25530,34633,39307,35863,32544,38130,20135,38416,39076,26124,29462,30694,30696,30698,30703,30704,30705,30706,30708,30709,30711,30713,30714,30715,30716,30723,30724,30725,30726,30727,30728,30730,30731,30734,30735,30736,30739,30741,30745,30747,30750,30752,30753,30754,30756,30760,30762,30763,30766,30767,30769,30770,30771,30773,30774,30781,30783,30785,30786,30787,30788,30790,30792,30793,30794,30795,30797,30799,30801,30803,30804,30808,30809,30810,30811,30812,30814,30815,30816,30817,30818,30819,30820,30821,30822,30823,30824,30825,30831,30832,30833,30834,30835,30836,30837,30838,30840,30841,30842,30843,30845,30846,30847,30848,30849,30850,30851,22330,23581,24120,38271,20607,32928,21378,25950,30021,21809,20513,36229,25220,38046,26397,22066,28526,24034,21557,28818,36710,25199,25764,25507,24443,28552,37108,33251,36784,23576,26216,24561,27785,38472,36225,34924,25745,31216,22478,27225,25104,21576,20056,31243,24809,28548,35802,25215,36894,39563,31204,21507,30196,25345,21273,27744,36831,24347,39536,32827,40831,20360,23610,36196,32709,26021,28861,20805,20914,34411,23815,23456,25277,37228,30068,36364,31264,24833,31609,20167,32504,30597,19985,33261,21021,20986,27249,21416,36487,38148,38607,28353,38500,26970,30852,30853,30854,30856,30858,30859,30863,30864,30866,30868,30869,30870,30873,30877,30878,30880,30882,30884,30886,30888,30889,30890,30891,30892,30893,30894,30895,30901,30902,30903,30904,30906,30907,30908,30909,30911,30912,30914,30915,30916,30918,30919,30920,30924,30925,30926,30927,30929,30930,30931,30934,30935,30936,30938,30939,30940,30941,30942,30943,30944,30945,30946,30947,30948,30949,30950,30951,30953,30954,30955,30957,30958,30959,30960,30961,30963,30965,30966,30968,30969,30971,30972,30973,30974,30975,30976,30978,30979,30980,30982,30983,30984,30985,30986,30987,30988,30784,20648,30679,25616,35302,22788,25571,24029,31359,26941,20256,33337,21912,20018,30126,31383,24162,24202,38383,21019,21561,28810,25462,38180,22402,26149,26943,37255,21767,28147,32431,34850,25139,32496,30133,33576,30913,38604,36766,24904,29943,35789,27492,21050,36176,27425,32874,33905,22257,21254,20174,19995,20945,31895,37259,31751,20419,36479,31713,31388,25703,23828,20652,33030,30209,31929,28140,32736,26449,23384,23544,30923,25774,25619,25514,25387,38169,25645,36798,31572,30249,25171,22823,21574,27513,20643,25140,24102,27526,20195,36151,34955,24453,36910,30989,30990,30991,30992,30993,30994,30996,30997,30998,30999,31000,31001,31002,31003,31004,31005,31007,31008,31009,31010,31011,31013,31014,31015,31016,31017,31018,31019,31020,31021,31022,31023,31024,31025,31026,31027,31029,31030,31031,31032,31033,31037,31039,31042,31043,31044,31045,31047,31050,31051,31052,31053,31054,31055,31056,31057,31058,31060,31061,31064,31065,31073,31075,31076,31078,31081,31082,31083,31084,31086,31088,31089,31090,31091,31092,31093,31094,31097,31099,31100,31101,31102,31103,31106,31107,31110,31111,31112,31113,31115,31116,31117,31118,31120,31121,31122,24608,32829,25285,20025,21333,37112,25528,32966,26086,27694,20294,24814,28129,35806,24377,34507,24403,25377,20826,33633,26723,20992,25443,36424,20498,23707,31095,23548,21040,31291,24764,36947,30423,24503,24471,30340,36460,28783,30331,31561,30634,20979,37011,22564,20302,28404,36842,25932,31515,29380,28068,32735,23265,25269,24213,22320,33922,31532,24093,24351,36882,32532,39072,25474,28359,30872,28857,20856,38747,22443,30005,20291,30008,24215,24806,22880,28096,27583,30857,21500,38613,20939,20993,25481,21514,38035,35843,36300,29241,30879,34678,36845,35853,21472,31123,31124,31125,31126,31127,31128,31129,31131,31132,31133,31134,31135,31136,31137,31138,31139,31140,31141,31142,31144,31145,31146,31147,31148,31149,31150,31151,31152,31153,31154,31156,31157,31158,31159,31160,31164,31167,31170,31172,31173,31175,31176,31178,31180,31182,31183,31184,31187,31188,31190,31191,31193,31194,31195,31196,31197,31198,31200,31201,31202,31205,31208,31210,31212,31214,31217,31218,31219,31220,31221,31222,31223,31225,31226,31228,31230,31231,31233,31236,31237,31239,31240,31241,31242,31244,31247,31248,31249,31250,31251,31253,31254,31256,31257,31259,31260,19969,30447,21486,38025,39030,40718,38189,23450,35746,20002,19996,20908,33891,25026,21160,26635,20375,24683,20923,27934,20828,25238,26007,38497,35910,36887,30168,37117,30563,27602,29322,29420,35835,22581,30585,36172,26460,38208,32922,24230,28193,22930,31471,30701,38203,27573,26029,32526,22534,20817,38431,23545,22697,21544,36466,25958,39039,22244,38045,30462,36929,25479,21702,22810,22842,22427,36530,26421,36346,33333,21057,24816,22549,34558,23784,40517,20420,39069,35769,23077,24694,21380,25212,36943,37122,39295,24681,32780,20799,32819,23572,39285,27953,20108,31261,31263,31265,31266,31268,31269,31270,31271,31272,31273,31274,31275,31276,31277,31278,31279,31280,31281,31282,31284,31285,31286,31288,31290,31294,31296,31297,31298,31299,31300,31301,31303,31304,31305,31306,31307,31308,31309,31310,31311,31312,31314,31315,31316,31317,31318,31320,31321,31322,31323,31324,31325,31326,31327,31328,31329,31330,31331,31332,31333,31334,31335,31336,31337,31338,31339,31340,31341,31342,31343,31345,31346,31347,31349,31355,31356,31357,31358,31362,31365,31367,31369,31370,31371,31372,31374,31375,31376,31379,31380,31385,31386,31387,31390,31393,31394,36144,21457,32602,31567,20240,20047,38400,27861,29648,34281,24070,30058,32763,27146,30718,38034,32321,20961,28902,21453,36820,33539,36137,29359,39277,27867,22346,33459,26041,32938,25151,38450,22952,20223,35775,32442,25918,33778,38750,21857,39134,32933,21290,35837,21536,32954,24223,27832,36153,33452,37210,21545,27675,20998,32439,22367,28954,27774,31881,22859,20221,24575,24868,31914,20016,23553,26539,34562,23792,38155,39118,30127,28925,36898,20911,32541,35773,22857,20964,20315,21542,22827,25975,32932,23413,25206,25282,36752,24133,27679,31526,20239,20440,26381,31395,31396,31399,31401,31402,31403,31406,31407,31408,31409,31410,31412,31413,31414,31415,31416,31417,31418,31419,31420,31421,31422,31424,31425,31426,31427,31428,31429,31430,31431,31432,31433,31434,31436,31437,31438,31439,31440,31441,31442,31443,31444,31445,31447,31448,31450,31451,31452,31453,31457,31458,31460,31463,31464,31465,31466,31467,31468,31470,31472,31473,31474,31475,31476,31477,31478,31479,31480,31483,31484,31486,31488,31489,31490,31493,31495,31497,31500,31501,31502,31504,31506,31507,31510,31511,31512,31514,31516,31517,31519,31521,31522,31523,31527,31529,31533,28014,28074,31119,34993,24343,29995,25242,36741,20463,37340,26023,33071,33105,24220,33104,36212,21103,35206,36171,22797,20613,20184,38428,29238,33145,36127,23500,35747,38468,22919,32538,21648,22134,22030,35813,25913,27010,38041,30422,28297,24178,29976,26438,26577,31487,32925,36214,24863,31174,25954,36195,20872,21018,38050,32568,32923,32434,23703,28207,26464,31705,30347,39640,33167,32660,31957,25630,38224,31295,21578,21733,27468,25601,25096,40509,33011,30105,21106,38761,33883,26684,34532,38401,38548,38124,20010,21508,32473,26681,36319,32789,26356,24218,32697,31535,31536,31538,31540,31541,31542,31543,31545,31547,31549,31551,31552,31553,31554,31555,31556,31558,31560,31562,31565,31566,31571,31573,31575,31577,31580,31582,31583,31585,31587,31588,31589,31590,31591,31592,31593,31594,31595,31596,31597,31599,31600,31603,31604,31606,31608,31610,31612,31613,31615,31617,31618,31619,31620,31622,31623,31624,31625,31626,31627,31628,31630,31631,31633,31634,31635,31638,31640,31641,31642,31643,31646,31647,31648,31651,31652,31653,31662,31663,31664,31666,31667,31669,31670,31671,31673,31674,31675,31676,31677,31678,31679,31680,31682,31683,31684,22466,32831,26775,24037,25915,21151,24685,40858,20379,36524,20844,23467,24339,24041,27742,25329,36129,20849,38057,21246,27807,33503,29399,22434,26500,36141,22815,36764,33735,21653,31629,20272,27837,23396,22993,40723,21476,34506,39592,35895,32929,25925,39038,22266,38599,21038,29916,21072,23521,25346,35074,20054,25296,24618,26874,20851,23448,20896,35266,31649,39302,32592,24815,28748,36143,20809,24191,36891,29808,35268,22317,30789,24402,40863,38394,36712,39740,35809,30328,26690,26588,36330,36149,21053,36746,28378,26829,38149,37101,22269,26524,35065,36807,21704,31685,31688,31689,31690,31691,31693,31694,31695,31696,31698,31700,31701,31702,31703,31704,31707,31708,31710,31711,31712,31714,31715,31716,31719,31720,31721,31723,31724,31725,31727,31728,31730,31731,31732,31733,31734,31736,31737,31738,31739,31741,31743,31744,31745,31746,31747,31748,31749,31750,31752,31753,31754,31757,31758,31760,31761,31762,31763,31764,31765,31767,31768,31769,31770,31771,31772,31773,31774,31776,31777,31778,31779,31780,31781,31784,31785,31787,31788,31789,31790,31791,31792,31793,31794,31795,31796,31797,31798,31799,31801,31802,31803,31804,31805,31806,31810,39608,23401,28023,27686,20133,23475,39559,37219,25000,37039,38889,21547,28085,23506,20989,21898,32597,32752,25788,25421,26097,25022,24717,28938,27735,27721,22831,26477,33322,22741,22158,35946,27627,37085,22909,32791,21495,28009,21621,21917,33655,33743,26680,31166,21644,20309,21512,30418,35977,38402,27827,28088,36203,35088,40548,36154,22079,40657,30165,24456,29408,24680,21756,20136,27178,34913,24658,36720,21700,28888,34425,40511,27946,23439,24344,32418,21897,20399,29492,21564,21402,20505,21518,21628,20046,24573,29786,22774,33899,32993,34676,29392,31946,28246,31811,31812,31813,31814,31815,31816,31817,31818,31819,31820,31822,31823,31824,31825,31826,31827,31828,31829,31830,31831,31832,31833,31834,31835,31836,31837,31838,31839,31840,31841,31842,31843,31844,31845,31846,31847,31848,31849,31850,31851,31852,31853,31854,31855,31856,31857,31858,31861,31862,31863,31864,31865,31866,31870,31871,31872,31873,31874,31875,31876,31877,31878,31879,31880,31882,31883,31884,31885,31886,31887,31888,31891,31892,31894,31897,31898,31899,31904,31905,31907,31910,31911,31912,31913,31915,31916,31917,31919,31920,31924,31925,31926,31927,31928,31930,31931,24359,34382,21804,25252,20114,27818,25143,33457,21719,21326,29502,28369,30011,21010,21270,35805,27088,24458,24576,28142,22351,27426,29615,26707,36824,32531,25442,24739,21796,30186,35938,28949,28067,23462,24187,33618,24908,40644,30970,34647,31783,30343,20976,24822,29004,26179,24140,24653,35854,28784,25381,36745,24509,24674,34516,22238,27585,24724,24935,21321,24800,26214,36159,31229,20250,28905,27719,35763,35826,32472,33636,26127,23130,39746,27985,28151,35905,27963,20249,28779,33719,25110,24785,38669,36135,31096,20987,22334,22522,26426,30072,31293,31215,31637,31935,31936,31938,31939,31940,31942,31945,31947,31950,31951,31952,31953,31954,31955,31956,31960,31962,31963,31965,31966,31969,31970,31971,31972,31973,31974,31975,31977,31978,31979,31980,31981,31982,31984,31985,31986,31987,31988,31989,31990,31991,31993,31994,31996,31997,31998,31999,32000,32001,32002,32003,32004,32005,32006,32007,32008,32009,32011,32012,32013,32014,32015,32016,32017,32018,32019,32020,32021,32022,32023,32024,32025,32026,32027,32028,32029,32030,32031,32033,32035,32036,32037,32038,32040,32041,32042,32044,32045,32046,32048,32049,32050,32051,32052,32053,32054,32908,39269,36857,28608,35749,40481,23020,32489,32521,21513,26497,26840,36753,31821,38598,21450,24613,30142,27762,21363,23241,32423,25380,20960,33034,24049,34015,25216,20864,23395,20238,31085,21058,24760,27982,23492,23490,35745,35760,26082,24524,38469,22931,32487,32426,22025,26551,22841,20339,23478,21152,33626,39050,36158,30002,38078,20551,31292,20215,26550,39550,23233,27516,30417,22362,23574,31546,38388,29006,20860,32937,33392,22904,32516,33575,26816,26604,30897,30839,25315,25441,31616,20461,21098,20943,33616,27099,37492,36341,36145,35265,38190,31661,20214,32055,32056,32057,32058,32059,32060,32061,32062,32063,32064,32065,32066,32067,32068,32069,32070,32071,32072,32073,32074,32075,32076,32077,32078,32079,32080,32081,32082,32083,32084,32085,32086,32087,32088,32089,32090,32091,32092,32093,32094,32095,32096,32097,32098,32099,32100,32101,32102,32103,32104,32105,32106,32107,32108,32109,32111,32112,32113,32114,32115,32116,32117,32118,32120,32121,32122,32123,32124,32125,32126,32127,32128,32129,32130,32131,32132,32133,32134,32135,32136,32137,32138,32139,32140,32141,32142,32143,32144,32145,32146,32147,32148,32149,32150,32151,32152,20581,33328,21073,39279,28176,28293,28071,24314,20725,23004,23558,27974,27743,30086,33931,26728,22870,35762,21280,37233,38477,34121,26898,30977,28966,33014,20132,37066,27975,39556,23047,22204,25605,38128,30699,20389,33050,29409,35282,39290,32564,32478,21119,25945,37237,36735,36739,21483,31382,25581,25509,30342,31224,34903,38454,25130,21163,33410,26708,26480,25463,30571,31469,27905,32467,35299,22992,25106,34249,33445,30028,20511,20171,30117,35819,23626,24062,31563,26020,37329,20170,27941,35167,32039,38182,20165,35880,36827,38771,26187,31105,36817,28908,28024,32153,32154,32155,32156,32157,32158,32159,32160,32161,32162,32163,32164,32165,32167,32168,32169,32170,32171,32172,32173,32175,32176,32177,32178,32179,32180,32181,32182,32183,32184,32185,32186,32187,32188,32189,32190,32191,32192,32193,32194,32195,32196,32197,32198,32199,32200,32201,32202,32203,32204,32205,32206,32207,32208,32209,32210,32211,32212,32213,32214,32215,32216,32217,32218,32219,32220,32221,32222,32223,32224,32225,32226,32227,32228,32229,32230,32231,32232,32233,32234,32235,32236,32237,32238,32239,32240,32241,32242,32243,32244,32245,32246,32247,32248,32249,32250,23613,21170,33606,20834,33550,30555,26230,40120,20140,24778,31934,31923,32463,20117,35686,26223,39048,38745,22659,25964,38236,24452,30153,38742,31455,31454,20928,28847,31384,25578,31350,32416,29590,38893,20037,28792,20061,37202,21417,25937,26087,33276,33285,21646,23601,30106,38816,25304,29401,30141,23621,39545,33738,23616,21632,30697,20030,27822,32858,25298,25454,24040,20855,36317,36382,38191,20465,21477,24807,28844,21095,25424,40515,23071,20518,30519,21367,32482,25733,25899,25225,25496,20500,29237,35273,20915,35776,32477,22343,33740,38055,20891,21531,23803,32251,32252,32253,32254,32255,32256,32257,32258,32259,32260,32261,32262,32263,32264,32265,32266,32267,32268,32269,32270,32271,32272,32273,32274,32275,32276,32277,32278,32279,32280,32281,32282,32283,32284,32285,32286,32287,32288,32289,32290,32291,32292,32293,32294,32295,32296,32297,32298,32299,32300,32301,32302,32303,32304,32305,32306,32307,32308,32309,32310,32311,32312,32313,32314,32316,32317,32318,32319,32320,32322,32323,32324,32325,32326,32328,32329,32330,32331,32332,32333,32334,32335,32336,32337,32338,32339,32340,32341,32342,32343,32344,32345,32346,32347,32348,32349,20426,31459,27994,37089,39567,21888,21654,21345,21679,24320,25577,26999,20975,24936,21002,22570,21208,22350,30733,30475,24247,24951,31968,25179,25239,20130,28821,32771,25335,28900,38752,22391,33499,26607,26869,30933,39063,31185,22771,21683,21487,28212,20811,21051,23458,35838,32943,21827,22438,24691,22353,21549,31354,24656,23380,25511,25248,21475,25187,23495,26543,21741,31391,33510,37239,24211,35044,22840,22446,25358,36328,33007,22359,31607,20393,24555,23485,27454,21281,31568,29378,26694,30719,30518,26103,20917,20111,30420,23743,31397,33909,22862,39745,20608,32350,32351,32352,32353,32354,32355,32356,32357,32358,32359,32360,32361,32362,32363,32364,32365,32366,32367,32368,32369,32370,32371,32372,32373,32374,32375,32376,32377,32378,32379,32380,32381,32382,32383,32384,32385,32387,32388,32389,32390,32391,32392,32393,32394,32395,32396,32397,32398,32399,32400,32401,32402,32403,32404,32405,32406,32407,32408,32409,32410,32412,32413,32414,32430,32436,32443,32444,32470,32484,32492,32505,32522,32528,32542,32567,32569,32571,32572,32573,32574,32575,32576,32577,32579,32582,32583,32584,32585,32586,32587,32588,32589,32590,32591,32594,32595,39304,24871,28291,22372,26118,25414,22256,25324,25193,24275,38420,22403,25289,21895,34593,33098,36771,21862,33713,26469,36182,34013,23146,26639,25318,31726,38417,20848,28572,35888,25597,35272,25042,32518,28866,28389,29701,27028,29436,24266,37070,26391,28010,25438,21171,29282,32769,20332,23013,37226,28889,28061,21202,20048,38647,38253,34174,30922,32047,20769,22418,25794,32907,31867,27882,26865,26974,20919,21400,26792,29313,40654,31729,29432,31163,28435,29702,26446,37324,40100,31036,33673,33620,21519,26647,20029,21385,21169,30782,21382,21033,20616,20363,20432,32598,32601,32603,32604,32605,32606,32608,32611,32612,32613,32614,32615,32619,32620,32621,32623,32624,32627,32629,32630,32631,32632,32634,32635,32636,32637,32639,32640,32642,32643,32644,32645,32646,32647,32648,32649,32651,32653,32655,32656,32657,32658,32659,32661,32662,32663,32664,32665,32667,32668,32672,32674,32675,32677,32678,32680,32681,32682,32683,32684,32685,32686,32689,32691,32692,32693,32694,32695,32698,32699,32702,32704,32706,32707,32708,32710,32711,32712,32713,32715,32717,32719,32720,32721,32722,32723,32726,32727,32729,32730,32731,32732,32733,32734,32738,32739,30178,31435,31890,27813,38582,21147,29827,21737,20457,32852,33714,36830,38256,24265,24604,28063,24088,25947,33080,38142,24651,28860,32451,31918,20937,26753,31921,33391,20004,36742,37327,26238,20142,35845,25769,32842,20698,30103,29134,23525,36797,28518,20102,25730,38243,24278,26009,21015,35010,28872,21155,29454,29747,26519,30967,38678,20020,37051,40158,28107,20955,36161,21533,25294,29618,33777,38646,40836,38083,20278,32666,20940,28789,38517,23725,39046,21478,20196,28316,29705,27060,30827,39311,30041,21016,30244,27969,26611,20845,40857,32843,21657,31548,31423,32740,32743,32744,32746,32747,32748,32749,32751,32754,32756,32757,32758,32759,32760,32761,32762,32765,32766,32767,32770,32775,32776,32777,32778,32782,32783,32785,32787,32794,32795,32797,32798,32799,32801,32803,32804,32811,32812,32813,32814,32815,32816,32818,32820,32825,32826,32828,32830,32832,32833,32836,32837,32839,32840,32841,32846,32847,32848,32849,32851,32853,32854,32855,32857,32859,32860,32861,32862,32863,32864,32865,32866,32867,32868,32869,32870,32871,32872,32875,32876,32877,32878,32879,32880,32882,32883,32884,32885,32886,32887,32888,32889,32890,32891,32892,32893,38534,22404,25314,38471,27004,23044,25602,31699,28431,38475,33446,21346,39045,24208,28809,25523,21348,34383,40065,40595,30860,38706,36335,36162,40575,28510,31108,24405,38470,25134,39540,21525,38109,20387,26053,23653,23649,32533,34385,27695,24459,29575,28388,32511,23782,25371,23402,28390,21365,20081,25504,30053,25249,36718,20262,20177,27814,32438,35770,33821,34746,32599,36923,38179,31657,39585,35064,33853,27931,39558,32476,22920,40635,29595,30721,34434,39532,39554,22043,21527,22475,20080,40614,21334,36808,33033,30610,39314,34542,28385,34067,26364,24930,28459,32894,32897,32898,32901,32904,32906,32909,32910,32911,32912,32913,32914,32916,32917,32919,32921,32926,32931,32934,32935,32936,32940,32944,32947,32949,32950,32952,32953,32955,32965,32967,32968,32969,32970,32971,32975,32976,32977,32978,32979,32980,32981,32984,32991,32992,32994,32995,32998,33006,33013,33015,33017,33019,33022,33023,33024,33025,33027,33028,33029,33031,33032,33035,33036,33045,33047,33049,33051,33052,33053,33055,33056,33057,33058,33059,33060,33061,33062,33063,33064,33065,33066,33067,33069,33070,33072,33075,33076,33077,33079,33081,33082,33083,33084,33085,33087,35881,33426,33579,30450,27667,24537,33725,29483,33541,38170,27611,30683,38086,21359,33538,20882,24125,35980,36152,20040,29611,26522,26757,37238,38665,29028,27809,30473,23186,38209,27599,32654,26151,23504,22969,23194,38376,38391,20204,33804,33945,27308,30431,38192,29467,26790,23391,30511,37274,38753,31964,36855,35868,24357,31859,31192,35269,27852,34588,23494,24130,26825,30496,32501,20885,20813,21193,23081,32517,38754,33495,25551,30596,34256,31186,28218,24217,22937,34065,28781,27665,25279,30399,25935,24751,38397,26126,34719,40483,38125,21517,21629,35884,25720,33088,33089,33090,33091,33092,33093,33095,33097,33101,33102,33103,33106,33110,33111,33112,33115,33116,33117,33118,33119,33121,33122,33123,33124,33126,33128,33130,33131,33132,33135,33138,33139,33141,33142,33143,33144,33153,33155,33156,33157,33158,33159,33161,33163,33164,33165,33166,33168,33170,33171,33172,33173,33174,33175,33177,33178,33182,33183,33184,33185,33186,33188,33189,33191,33193,33195,33196,33197,33198,33199,33200,33201,33202,33204,33205,33206,33207,33208,33209,33212,33213,33214,33215,33220,33221,33223,33224,33225,33227,33229,33230,33231,33232,33233,33234,33235,25721,34321,27169,33180,30952,25705,39764,25273,26411,33707,22696,40664,27819,28448,23518,38476,35851,29279,26576,25287,29281,20137,22982,27597,22675,26286,24149,21215,24917,26408,30446,30566,29287,31302,25343,21738,21584,38048,37027,23068,32435,27670,20035,22902,32784,22856,21335,30007,38590,22218,25376,33041,24700,38393,28118,21602,39297,20869,23273,33021,22958,38675,20522,27877,23612,25311,20320,21311,33147,36870,28346,34091,25288,24180,30910,25781,25467,24565,23064,37247,40479,23615,25423,32834,23421,21870,38218,38221,28037,24744,26592,29406,20957,23425,33236,33237,33238,33239,33240,33241,33242,33243,33244,33245,33246,33247,33248,33249,33250,33252,33253,33254,33256,33257,33259,33262,33263,33264,33265,33266,33269,33270,33271,33272,33273,33274,33277,33279,33283,33287,33288,33289,33290,33291,33294,33295,33297,33299,33301,33302,33303,33304,33305,33306,33309,33312,33316,33317,33318,33319,33321,33326,33330,33338,33340,33341,33343,33344,33345,33346,33347,33349,33350,33352,33354,33356,33357,33358,33360,33361,33362,33363,33364,33365,33366,33367,33369,33371,33372,33373,33374,33376,33377,33378,33379,33380,33381,33382,33383,33385,25319,27870,29275,25197,38062,32445,33043,27987,20892,24324,22900,21162,24594,22899,26262,34384,30111,25386,25062,31983,35834,21734,27431,40485,27572,34261,21589,20598,27812,21866,36276,29228,24085,24597,29750,25293,25490,29260,24472,28227,27966,25856,28504,30424,30928,30460,30036,21028,21467,20051,24222,26049,32810,32982,25243,21638,21032,28846,34957,36305,27873,21624,32986,22521,35060,36180,38506,37197,20329,27803,21943,30406,30768,25256,28921,28558,24429,34028,26842,30844,31735,33192,26379,40527,25447,30896,22383,30738,38713,25209,25259,21128,29749,27607,33386,33387,33388,33389,33393,33397,33398,33399,33400,33403,33404,33408,33409,33411,33413,33414,33415,33417,33420,33424,33427,33428,33429,33430,33434,33435,33438,33440,33442,33443,33447,33458,33461,33462,33466,33467,33468,33471,33472,33474,33475,33477,33478,33481,33488,33494,33497,33498,33501,33506,33511,33512,33513,33514,33516,33517,33518,33520,33522,33523,33525,33526,33528,33530,33532,33533,33534,33535,33536,33546,33547,33549,33552,33554,33555,33558,33560,33561,33565,33566,33567,33568,33569,33570,33571,33572,33573,33574,33577,33578,33582,33584,33586,33591,33595,33597,21860,33086,30130,30382,21305,30174,20731,23617,35692,31687,20559,29255,39575,39128,28418,29922,31080,25735,30629,25340,39057,36139,21697,32856,20050,22378,33529,33805,24179,20973,29942,35780,23631,22369,27900,39047,23110,30772,39748,36843,31893,21078,25169,38138,20166,33670,33889,33769,33970,22484,26420,22275,26222,28006,35889,26333,28689,26399,27450,26646,25114,22971,19971,20932,28422,26578,27791,20854,26827,22855,27495,30054,23822,33040,40784,26071,31048,31041,39569,36215,23682,20062,20225,21551,22865,30732,22120,27668,36804,24323,27773,27875,35755,25488,33598,33599,33601,33602,33604,33605,33608,33610,33611,33612,33613,33614,33619,33621,33622,33623,33624,33625,33629,33634,33648,33649,33650,33651,33652,33653,33654,33657,33658,33662,33663,33664,33665,33666,33667,33668,33671,33672,33674,33675,33676,33677,33679,33680,33681,33684,33685,33686,33687,33689,33690,33693,33695,33697,33698,33699,33700,33701,33702,33703,33708,33709,33710,33711,33717,33723,33726,33727,33730,33731,33732,33734,33736,33737,33739,33741,33742,33744,33745,33746,33747,33749,33751,33753,33754,33755,33758,33762,33763,33764,33766,33767,33768,33771,33772,33773,24688,27965,29301,25190,38030,38085,21315,36801,31614,20191,35878,20094,40660,38065,38067,21069,28508,36963,27973,35892,22545,23884,27424,27465,26538,21595,33108,32652,22681,34103,24378,25250,27207,38201,25970,24708,26725,30631,20052,20392,24039,38808,25772,32728,23789,20431,31373,20999,33540,19988,24623,31363,38054,20405,20146,31206,29748,21220,33465,25810,31165,23517,27777,38738,36731,27682,20542,21375,28165,25806,26228,27696,24773,39031,35831,24198,29756,31351,31179,19992,37041,29699,27714,22234,37195,27845,36235,21306,34502,26354,36527,23624,39537,28192,33774,33775,33779,33780,33781,33782,33783,33786,33787,33788,33790,33791,33792,33794,33797,33799,33800,33801,33802,33808,33810,33811,33812,33813,33814,33815,33817,33818,33819,33822,33823,33824,33825,33826,33827,33833,33834,33835,33836,33837,33838,33839,33840,33842,33843,33844,33845,33846,33847,33849,33850,33851,33854,33855,33856,33857,33858,33859,33860,33861,33863,33864,33865,33866,33867,33868,33869,33870,33871,33872,33874,33875,33876,33877,33878,33880,33885,33886,33887,33888,33890,33892,33893,33894,33895,33896,33898,33902,33903,33904,33906,33908,33911,33913,33915,33916,21462,23094,40843,36259,21435,22280,39079,26435,37275,27849,20840,30154,25331,29356,21048,21149,32570,28820,30264,21364,40522,27063,30830,38592,35033,32676,28982,29123,20873,26579,29924,22756,25880,22199,35753,39286,25200,32469,24825,28909,22764,20161,20154,24525,38887,20219,35748,20995,22922,32427,25172,20173,26085,25102,33592,33993,33635,34701,29076,28342,23481,32466,20887,25545,26580,32905,33593,34837,20754,23418,22914,36785,20083,27741,20837,35109,36719,38446,34122,29790,38160,38384,28070,33509,24369,25746,27922,33832,33134,40131,22622,36187,19977,21441,33917,33918,33919,33920,33921,33923,33924,33925,33926,33930,33933,33935,33936,33937,33938,33939,33940,33941,33942,33944,33946,33947,33949,33950,33951,33952,33954,33955,33956,33957,33958,33959,33960,33961,33962,33963,33964,33965,33966,33968,33969,33971,33973,33974,33975,33979,33980,33982,33984,33986,33987,33989,33990,33991,33992,33995,33996,33998,33999,34002,34004,34005,34007,34008,34009,34010,34011,34012,34014,34017,34018,34020,34023,34024,34025,34026,34027,34029,34030,34031,34033,34034,34035,34036,34037,34038,34039,34040,34041,34042,34043,34045,34046,34048,34049,34050,20254,25955,26705,21971,20007,25620,39578,25195,23234,29791,33394,28073,26862,20711,33678,30722,26432,21049,27801,32433,20667,21861,29022,31579,26194,29642,33515,26441,23665,21024,29053,34923,38378,38485,25797,36193,33203,21892,27733,25159,32558,22674,20260,21830,36175,26188,19978,23578,35059,26786,25422,31245,28903,33421,21242,38902,23569,21736,37045,32461,22882,36170,34503,33292,33293,36198,25668,23556,24913,28041,31038,35774,30775,30003,21627,20280,36523,28145,23072,32453,31070,27784,23457,23158,29978,32958,24910,28183,22768,29983,29989,29298,21319,32499,34051,34052,34053,34054,34055,34056,34057,34058,34059,34061,34062,34063,34064,34066,34068,34069,34070,34072,34073,34075,34076,34077,34078,34080,34082,34083,34084,34085,34086,34087,34088,34089,34090,34093,34094,34095,34096,34097,34098,34099,34100,34101,34102,34110,34111,34112,34113,34114,34116,34117,34118,34119,34123,34124,34125,34126,34127,34128,34129,34130,34131,34132,34133,34135,34136,34138,34139,34140,34141,34143,34144,34145,34146,34147,34149,34150,34151,34153,34154,34155,34156,34157,34158,34159,34160,34161,34163,34165,34166,34167,34168,34172,34173,34175,34176,34177,30465,30427,21097,32988,22307,24072,22833,29422,26045,28287,35799,23608,34417,21313,30707,25342,26102,20160,39135,34432,23454,35782,21490,30690,20351,23630,39542,22987,24335,31034,22763,19990,26623,20107,25325,35475,36893,21183,26159,21980,22124,36866,20181,20365,37322,39280,27663,24066,24643,23460,35270,35797,25910,25163,39318,23432,23551,25480,21806,21463,30246,20861,34092,26530,26803,27530,25234,36755,21460,33298,28113,30095,20070,36174,23408,29087,34223,26257,26329,32626,34560,40653,40736,23646,26415,36848,26641,26463,25101,31446,22661,24246,25968,28465,34178,34179,34182,34184,34185,34186,34187,34188,34189,34190,34192,34193,34194,34195,34196,34197,34198,34199,34200,34201,34202,34205,34206,34207,34208,34209,34210,34211,34213,34214,34215,34217,34219,34220,34221,34225,34226,34227,34228,34229,34230,34232,34234,34235,34236,34237,34238,34239,34240,34242,34243,34244,34245,34246,34247,34248,34250,34251,34252,34253,34254,34257,34258,34260,34262,34263,34264,34265,34266,34267,34269,34270,34271,34272,34273,34274,34275,34277,34278,34279,34280,34282,34283,34284,34285,34286,34287,34288,34289,34290,34291,34292,34293,34294,34295,34296,24661,21047,32781,25684,34928,29993,24069,26643,25332,38684,21452,29245,35841,27700,30561,31246,21550,30636,39034,33308,35828,30805,26388,28865,26031,25749,22070,24605,31169,21496,19997,27515,32902,23546,21987,22235,20282,20284,39282,24051,26494,32824,24578,39042,36865,23435,35772,35829,25628,33368,25822,22013,33487,37221,20439,32032,36895,31903,20723,22609,28335,23487,35785,32899,37240,33948,31639,34429,38539,38543,32485,39635,30862,23681,31319,36930,38567,31071,23385,25439,31499,34001,26797,21766,32553,29712,32034,38145,25152,22604,20182,23427,22905,22612,34297,34298,34300,34301,34302,34304,34305,34306,34307,34308,34310,34311,34312,34313,34314,34315,34316,34317,34318,34319,34320,34322,34323,34324,34325,34327,34328,34329,34330,34331,34332,34333,34334,34335,34336,34337,34338,34339,34340,34341,34342,34344,34346,34347,34348,34349,34350,34351,34352,34353,34354,34355,34356,34357,34358,34359,34361,34362,34363,34365,34366,34367,34368,34369,34370,34371,34372,34373,34374,34375,34376,34377,34378,34379,34380,34386,34387,34389,34390,34391,34392,34393,34395,34396,34397,34399,34400,34401,34403,34404,34405,34406,34407,34408,34409,34410,29549,25374,36427,36367,32974,33492,25260,21488,27888,37214,22826,24577,27760,22349,25674,36138,30251,28393,22363,27264,30192,28525,35885,35848,22374,27631,34962,30899,25506,21497,28845,27748,22616,25642,22530,26848,33179,21776,31958,20504,36538,28108,36255,28907,25487,28059,28372,32486,33796,26691,36867,28120,38518,35752,22871,29305,34276,33150,30140,35466,26799,21076,36386,38161,25552,39064,36420,21884,20307,26367,22159,24789,28053,21059,23625,22825,28155,22635,30000,29980,24684,33300,33094,25361,26465,36834,30522,36339,36148,38081,24086,21381,21548,28867,34413,34415,34416,34418,34419,34420,34421,34422,34423,34424,34435,34436,34437,34438,34439,34440,34441,34446,34447,34448,34449,34450,34452,34454,34455,34456,34457,34458,34459,34462,34463,34464,34465,34466,34469,34470,34475,34477,34478,34482,34483,34487,34488,34489,34491,34492,34493,34494,34495,34497,34498,34499,34501,34504,34508,34509,34514,34515,34517,34518,34519,34522,34524,34525,34528,34529,34530,34531,34533,34534,34535,34536,34538,34539,34540,34543,34549,34550,34551,34554,34555,34556,34557,34559,34561,34564,34565,34566,34571,34572,34574,34575,34576,34577,34580,34582,27712,24311,20572,20141,24237,25402,33351,36890,26704,37230,30643,21516,38108,24420,31461,26742,25413,31570,32479,30171,20599,25237,22836,36879,20984,31171,31361,22270,24466,36884,28034,23648,22303,21520,20820,28237,22242,25512,39059,33151,34581,35114,36864,21534,23663,33216,25302,25176,33073,40501,38464,39534,39548,26925,22949,25299,21822,25366,21703,34521,27964,23043,29926,34972,27498,22806,35916,24367,28286,29609,39037,20024,28919,23436,30871,25405,26202,30358,24779,23451,23113,19975,33109,27754,29579,20129,26505,32593,24448,26106,26395,24536,22916,23041,34585,34587,34589,34591,34592,34596,34598,34599,34600,34602,34603,34604,34605,34607,34608,34610,34611,34613,34614,34616,34617,34618,34620,34621,34624,34625,34626,34627,34628,34629,34630,34634,34635,34637,34639,34640,34641,34642,34644,34645,34646,34648,34650,34651,34652,34653,34654,34655,34657,34658,34662,34663,34664,34665,34666,34667,34668,34669,34671,34673,34674,34675,34677,34679,34680,34681,34682,34687,34688,34689,34692,34694,34695,34697,34698,34700,34702,34703,34704,34705,34706,34708,34709,34710,34712,34713,34714,34715,34716,34717,34718,34720,34721,34722,34723,34724,24013,24494,21361,38886,36829,26693,22260,21807,24799,20026,28493,32500,33479,33806,22996,20255,20266,23614,32428,26410,34074,21619,30031,32963,21890,39759,20301,28205,35859,23561,24944,21355,30239,28201,34442,25991,38395,32441,21563,31283,32010,38382,21985,32705,29934,25373,34583,28065,31389,25105,26017,21351,25569,27779,24043,21596,38056,20044,27745,35820,23627,26080,33436,26791,21566,21556,27595,27494,20116,25410,21320,33310,20237,20398,22366,25098,38654,26212,29289,21247,21153,24735,35823,26132,29081,26512,35199,30802,30717,26224,22075,21560,38177,29306,34725,34726,34727,34729,34730,34734,34736,34737,34738,34740,34742,34743,34744,34745,34747,34748,34750,34751,34753,34754,34755,34756,34757,34759,34760,34761,34764,34765,34766,34767,34768,34772,34773,34774,34775,34776,34777,34778,34780,34781,34782,34783,34785,34786,34787,34788,34790,34791,34792,34793,34795,34796,34797,34799,34800,34801,34802,34803,34804,34805,34806,34807,34808,34810,34811,34812,34813,34815,34816,34817,34818,34820,34821,34822,34823,34824,34825,34827,34828,34829,34830,34831,34832,34833,34834,34836,34839,34840,34841,34842,34844,34845,34846,34847,34848,34851,31232,24687,24076,24713,33181,22805,24796,29060,28911,28330,27728,29312,27268,34989,24109,20064,23219,21916,38115,27927,31995,38553,25103,32454,30606,34430,21283,38686,36758,26247,23777,20384,29421,19979,21414,22799,21523,25472,38184,20808,20185,40092,32420,21688,36132,34900,33335,38386,28046,24358,23244,26174,38505,29616,29486,21439,33146,39301,32673,23466,38519,38480,32447,30456,21410,38262,39321,31665,35140,28248,20065,32724,31077,35814,24819,21709,20139,39033,24055,27233,20687,21521,35937,33831,30813,38660,21066,21742,22179,38144,28040,23477,28102,26195,34852,34853,34854,34855,34856,34857,34858,34859,34860,34861,34862,34863,34864,34865,34867,34868,34869,34870,34871,34872,34874,34875,34877,34878,34879,34881,34882,34883,34886,34887,34888,34889,34890,34891,34894,34895,34896,34897,34898,34899,34901,34902,34904,34906,34907,34908,34909,34910,34911,34912,34918,34919,34922,34925,34927,34929,34931,34932,34933,34934,34936,34937,34938,34939,34940,34944,34947,34950,34951,34953,34954,34956,34958,34959,34960,34961,34963,34964,34965,34967,34968,34969,34970,34971,34973,34974,34975,34976,34977,34979,34981,34982,34983,34984,34985,34986,23567,23389,26657,32918,21880,31505,25928,26964,20123,27463,34638,38795,21327,25375,25658,37034,26012,32961,35856,20889,26800,21368,34809,25032,27844,27899,35874,23633,34218,33455,38156,27427,36763,26032,24571,24515,20449,34885,26143,33125,29481,24826,20852,21009,22411,24418,37026,34892,37266,24184,26447,24615,22995,20804,20982,33016,21256,27769,38596,29066,20241,20462,32670,26429,21957,38152,31168,34966,32483,22687,25100,38656,34394,22040,39035,24464,35768,33988,37207,21465,26093,24207,30044,24676,32110,23167,32490,32493,36713,21927,23459,24748,26059,29572,34988,34990,34991,34992,34994,34995,34996,34997,34998,35000,35001,35002,35003,35005,35006,35007,35008,35011,35012,35015,35016,35018,35019,35020,35021,35023,35024,35025,35027,35030,35031,35034,35035,35036,35037,35038,35040,35041,35046,35047,35049,35050,35051,35052,35053,35054,35055,35058,35061,35062,35063,35066,35067,35069,35071,35072,35073,35075,35076,35077,35078,35079,35080,35081,35083,35084,35085,35086,35087,35089,35092,35093,35094,35095,35096,35100,35101,35102,35103,35104,35106,35107,35108,35110,35111,35112,35113,35116,35117,35118,35119,35121,35122,35123,35125,35127,36873,30307,30505,32474,38772,34203,23398,31348,38634,34880,21195,29071,24490,26092,35810,23547,39535,24033,27529,27739,35757,35759,36874,36805,21387,25276,40486,40493,21568,20011,33469,29273,34460,23830,34905,28079,38597,21713,20122,35766,28937,21693,38409,28895,28153,30416,20005,30740,34578,23721,24310,35328,39068,38414,28814,27839,22852,25513,30524,34893,28436,33395,22576,29141,21388,30746,38593,21761,24422,28976,23476,35866,39564,27523,22830,40495,31207,26472,25196,20335,30113,32650,27915,38451,27687,20208,30162,20859,26679,28478,36992,33136,22934,29814,35128,35129,35130,35131,35132,35133,35134,35135,35136,35138,35139,35141,35142,35143,35144,35145,35146,35147,35148,35149,35150,35151,35152,35153,35154,35155,35156,35157,35158,35159,35160,35161,35162,35163,35164,35165,35168,35169,35170,35171,35172,35173,35175,35176,35177,35178,35179,35180,35181,35182,35183,35184,35185,35186,35187,35188,35189,35190,35191,35192,35193,35194,35196,35197,35198,35200,35202,35204,35205,35207,35208,35209,35210,35211,35212,35213,35214,35215,35216,35217,35218,35219,35220,35221,35222,35223,35224,35225,35226,35227,35228,35229,35230,35231,35232,35233,25671,23591,36965,31377,35875,23002,21676,33280,33647,35201,32768,26928,22094,32822,29239,37326,20918,20063,39029,25494,19994,21494,26355,33099,22812,28082,19968,22777,21307,25558,38129,20381,20234,34915,39056,22839,36951,31227,20202,33008,30097,27778,23452,23016,24413,26885,34433,20506,24050,20057,30691,20197,33402,25233,26131,37009,23673,20159,24441,33222,36920,32900,30123,20134,35028,24847,27589,24518,20041,30410,28322,35811,35758,35850,35793,24322,32764,32716,32462,33589,33643,22240,27575,38899,38452,23035,21535,38134,28139,23493,39278,23609,24341,38544,35234,35235,35236,35237,35238,35239,35240,35241,35242,35243,35244,35245,35246,35247,35248,35249,35250,35251,35252,35253,35254,35255,35256,35257,35258,35259,35260,35261,35262,35263,35264,35267,35277,35283,35284,35285,35287,35288,35289,35291,35293,35295,35296,35297,35298,35300,35303,35304,35305,35306,35308,35309,35310,35312,35313,35314,35316,35317,35318,35319,35320,35321,35322,35323,35324,35325,35326,35327,35329,35330,35331,35332,35333,35334,35336,35337,35338,35339,35340,35341,35342,35343,35344,35345,35346,35347,35348,35349,35350,35351,35352,35353,35354,35355,35356,35357,21360,33521,27185,23156,40560,24212,32552,33721,33828,33829,33639,34631,36814,36194,30408,24433,39062,30828,26144,21727,25317,20323,33219,30152,24248,38605,36362,34553,21647,27891,28044,27704,24703,21191,29992,24189,20248,24736,24551,23588,30001,37038,38080,29369,27833,28216,37193,26377,21451,21491,20305,37321,35825,21448,24188,36802,28132,20110,30402,27014,34398,24858,33286,20313,20446,36926,40060,24841,28189,28180,38533,20104,23089,38632,19982,23679,31161,23431,35821,32701,29577,22495,33419,37057,21505,36935,21947,23786,24481,24840,27442,29425,32946,35465,35358,35359,35360,35361,35362,35363,35364,35365,35366,35367,35368,35369,35370,35371,35372,35373,35374,35375,35376,35377,35378,35379,35380,35381,35382,35383,35384,35385,35386,35387,35388,35389,35391,35392,35393,35394,35395,35396,35397,35398,35399,35401,35402,35403,35404,35405,35406,35407,35408,35409,35410,35411,35412,35413,35414,35415,35416,35417,35418,35419,35420,35421,35422,35423,35424,35425,35426,35427,35428,35429,35430,35431,35432,35433,35434,35435,35436,35437,35438,35439,35440,35441,35442,35443,35444,35445,35446,35447,35448,35450,35451,35452,35453,35454,35455,35456,28020,23507,35029,39044,35947,39533,40499,28170,20900,20803,22435,34945,21407,25588,36757,22253,21592,22278,29503,28304,32536,36828,33489,24895,24616,38498,26352,32422,36234,36291,38053,23731,31908,26376,24742,38405,32792,20113,37095,21248,38504,20801,36816,34164,37213,26197,38901,23381,21277,30776,26434,26685,21705,28798,23472,36733,20877,22312,21681,25874,26242,36190,36163,33039,33900,36973,31967,20991,34299,26531,26089,28577,34468,36481,22122,36896,30338,28790,29157,36131,25321,21017,27901,36156,24590,22686,24974,26366,36192,25166,21939,28195,26413,36711,35457,35458,35459,35460,35461,35462,35463,35464,35467,35468,35469,35470,35471,35472,35473,35474,35476,35477,35478,35479,35480,35481,35482,35483,35484,35485,35486,35487,35488,35489,35490,35491,35492,35493,35494,35495,35496,35497,35498,35499,35500,35501,35502,35503,35504,35505,35506,35507,35508,35509,35510,35511,35512,35513,35514,35515,35516,35517,35518,35519,35520,35521,35522,35523,35524,35525,35526,35527,35528,35529,35530,35531,35532,35533,35534,35535,35536,35537,35538,35539,35540,35541,35542,35543,35544,35545,35546,35547,35548,35549,35550,35551,35552,35553,35554,35555,38113,38392,30504,26629,27048,21643,20045,28856,35784,25688,25995,23429,31364,20538,23528,30651,27617,35449,31896,27838,30415,26025,36759,23853,23637,34360,26632,21344,25112,31449,28251,32509,27167,31456,24432,28467,24352,25484,28072,26454,19976,24080,36134,20183,32960,30260,38556,25307,26157,25214,27836,36213,29031,32617,20806,32903,21484,36974,25240,21746,34544,36761,32773,38167,34071,36825,27993,29645,26015,30495,29956,30759,33275,36126,38024,20390,26517,30137,35786,38663,25391,38215,38453,33976,25379,30529,24449,29424,20105,24596,25972,25327,27491,25919,35556,35557,35558,35559,35560,35561,35562,35563,35564,35565,35566,35567,35568,35569,35570,35571,35572,35573,35574,35575,35576,35577,35578,35579,35580,35581,35582,35583,35584,35585,35586,35587,35588,35589,35590,35592,35593,35594,35595,35596,35597,35598,35599,35600,35601,35602,35603,35604,35605,35606,35607,35608,35609,35610,35611,35612,35613,35614,35615,35616,35617,35618,35619,35620,35621,35623,35624,35625,35626,35627,35628,35629,35630,35631,35632,35633,35634,35635,35636,35637,35638,35639,35640,35641,35642,35643,35644,35645,35646,35647,35648,35649,35650,35651,35652,35653,24103,30151,37073,35777,33437,26525,25903,21553,34584,30693,32930,33026,27713,20043,32455,32844,30452,26893,27542,25191,20540,20356,22336,25351,27490,36286,21482,26088,32440,24535,25370,25527,33267,33268,32622,24092,23769,21046,26234,31209,31258,36136,28825,30164,28382,27835,31378,20013,30405,24544,38047,34935,32456,31181,32959,37325,20210,20247,33311,21608,24030,27954,35788,31909,36724,32920,24090,21650,30385,23449,26172,39588,29664,26666,34523,26417,29482,35832,35803,36880,31481,28891,29038,25284,30633,22065,20027,33879,26609,21161,34496,36142,38136,31569,35654,35655,35656,35657,35658,35659,35660,35661,35662,35663,35664,35665,35666,35667,35668,35669,35670,35671,35672,35673,35674,35675,35676,35677,35678,35679,35680,35681,35682,35683,35684,35685,35687,35688,35689,35690,35691,35693,35694,35695,35696,35697,35698,35699,35700,35701,35702,35703,35704,35705,35706,35707,35708,35709,35710,35711,35712,35713,35714,35715,35716,35717,35718,35719,35720,35721,35722,35723,35724,35725,35726,35727,35728,35729,35730,35731,35732,35733,35734,35735,35736,35737,35738,35739,35740,35741,35742,35743,35756,35761,35771,35783,35792,35818,35849,35870,20303,27880,31069,39547,25235,29226,25341,19987,30742,36716,25776,36186,31686,26729,24196,35013,22918,25758,22766,29366,26894,38181,36861,36184,22368,32512,35846,20934,25417,25305,21331,26700,29730,33537,37196,21828,30528,28796,27978,20857,21672,36164,23039,28363,28100,23388,32043,20180,31869,28371,23376,33258,28173,23383,39683,26837,36394,23447,32508,24635,32437,37049,36208,22863,25549,31199,36275,21330,26063,31062,35781,38459,32452,38075,32386,22068,37257,26368,32618,23562,36981,26152,24038,20304,26590,20570,20316,22352,24231,59408,59409,59410,59411,59412,35896,35897,35898,35899,35900,35901,35902,35903,35904,35906,35907,35908,35909,35912,35914,35915,35917,35918,35919,35920,35921,35922,35923,35924,35926,35927,35928,35929,35931,35932,35933,35934,35935,35936,35939,35940,35941,35942,35943,35944,35945,35948,35949,35950,35951,35952,35953,35954,35956,35957,35958,35959,35963,35964,35965,35966,35967,35968,35969,35971,35972,35974,35975,35976,35979,35981,35982,35983,35984,35985,35986,35987,35989,35990,35991,35993,35994,35995,35996,35997,35998,35999,36000,36001,36002,36003,36004,36005,36006,36007,36008,36009,36010,36011,36012,36013,20109,19980,20800,19984,24319,21317,19989,20120,19998,39730,23404,22121,20008,31162,20031,21269,20039,22829,29243,21358,27664,22239,32996,39319,27603,30590,40727,20022,20127,40720,20060,20073,20115,33416,23387,21868,22031,20164,21389,21405,21411,21413,21422,38757,36189,21274,21493,21286,21294,21310,36188,21350,21347,20994,21000,21006,21037,21043,21055,21056,21068,21086,21089,21084,33967,21117,21122,21121,21136,21139,20866,32596,20155,20163,20169,20162,20200,20193,20203,20190,20251,20211,20258,20324,20213,20261,20263,20233,20267,20318,20327,25912,20314,20317,36014,36015,36016,36017,36018,36019,36020,36021,36022,36023,36024,36025,36026,36027,36028,36029,36030,36031,36032,36033,36034,36035,36036,36037,36038,36039,36040,36041,36042,36043,36044,36045,36046,36047,36048,36049,36050,36051,36052,36053,36054,36055,36056,36057,36058,36059,36060,36061,36062,36063,36064,36065,36066,36067,36068,36069,36070,36071,36072,36073,36074,36075,36076,36077,36078,36079,36080,36081,36082,36083,36084,36085,36086,36087,36088,36089,36090,36091,36092,36093,36094,36095,36096,36097,36098,36099,36100,36101,36102,36103,36104,36105,36106,36107,36108,36109,20319,20311,20274,20285,20342,20340,20369,20361,20355,20367,20350,20347,20394,20348,20396,20372,20454,20456,20458,20421,20442,20451,20444,20433,20447,20472,20521,20556,20467,20524,20495,20526,20525,20478,20508,20492,20517,20520,20606,20547,20565,20552,20558,20588,20603,20645,20647,20649,20666,20694,20742,20717,20716,20710,20718,20743,20747,20189,27709,20312,20325,20430,40864,27718,31860,20846,24061,40649,39320,20865,22804,21241,21261,35335,21264,20971,22809,20821,20128,20822,20147,34926,34980,20149,33044,35026,31104,23348,34819,32696,20907,20913,20925,20924,36110,36111,36112,36113,36114,36115,36116,36117,36118,36119,36120,36121,36122,36123,36124,36128,36177,36178,36183,36191,36197,36200,36201,36202,36204,36206,36207,36209,36210,36216,36217,36218,36219,36220,36221,36222,36223,36224,36226,36227,36230,36231,36232,36233,36236,36237,36238,36239,36240,36242,36243,36245,36246,36247,36248,36249,36250,36251,36252,36253,36254,36256,36257,36258,36260,36261,36262,36263,36264,36265,36266,36267,36268,36269,36270,36271,36272,36274,36278,36279,36281,36283,36285,36288,36289,36290,36293,36295,36296,36297,36298,36301,36304,36306,36307,36308,20935,20886,20898,20901,35744,35750,35751,35754,35764,35765,35767,35778,35779,35787,35791,35790,35794,35795,35796,35798,35800,35801,35804,35807,35808,35812,35816,35817,35822,35824,35827,35830,35833,35836,35839,35840,35842,35844,35847,35852,35855,35857,35858,35860,35861,35862,35865,35867,35864,35869,35871,35872,35873,35877,35879,35882,35883,35886,35887,35890,35891,35893,35894,21353,21370,38429,38434,38433,38449,38442,38461,38460,38466,38473,38484,38495,38503,38508,38514,38516,38536,38541,38551,38576,37015,37019,37021,37017,37036,37025,37044,37043,37046,37050,36309,36312,36313,36316,36320,36321,36322,36325,36326,36327,36329,36333,36334,36336,36337,36338,36340,36342,36348,36350,36351,36352,36353,36354,36355,36356,36358,36359,36360,36363,36365,36366,36368,36369,36370,36371,36373,36374,36375,36376,36377,36378,36379,36380,36384,36385,36388,36389,36390,36391,36392,36395,36397,36400,36402,36403,36404,36406,36407,36408,36411,36412,36414,36415,36419,36421,36422,36428,36429,36430,36431,36432,36435,36436,36437,36438,36439,36440,36442,36443,36444,36445,36446,36447,36448,36449,36450,36451,36452,36453,36455,36456,36458,36459,36462,36465,37048,37040,37071,37061,37054,37072,37060,37063,37075,37094,37090,37084,37079,37083,37099,37103,37118,37124,37154,37150,37155,37169,37167,37177,37187,37190,21005,22850,21154,21164,21165,21182,21759,21200,21206,21232,21471,29166,30669,24308,20981,20988,39727,21430,24321,30042,24047,22348,22441,22433,22654,22716,22725,22737,22313,22316,22314,22323,22329,22318,22319,22364,22331,22338,22377,22405,22379,22406,22396,22395,22376,22381,22390,22387,22445,22436,22412,22450,22479,22439,22452,22419,22432,22485,22488,22490,22489,22482,22456,22516,22511,22520,22500,22493,36467,36469,36471,36472,36473,36474,36475,36477,36478,36480,36482,36483,36484,36486,36488,36489,36490,36491,36492,36493,36494,36497,36498,36499,36501,36502,36503,36504,36505,36506,36507,36509,36511,36512,36513,36514,36515,36516,36517,36518,36519,36520,36521,36522,36525,36526,36528,36529,36531,36532,36533,36534,36535,36536,36537,36539,36540,36541,36542,36543,36544,36545,36546,36547,36548,36549,36550,36551,36552,36553,36554,36555,36556,36557,36559,36560,36561,36562,36563,36564,36565,36566,36567,36568,36569,36570,36571,36572,36573,36574,36575,36576,36577,36578,36579,36580,22539,22541,22525,22509,22528,22558,22553,22596,22560,22629,22636,22657,22665,22682,22656,39336,40729,25087,33401,33405,33407,33423,33418,33448,33412,33422,33425,33431,33433,33451,33464,33470,33456,33480,33482,33507,33432,33463,33454,33483,33484,33473,33449,33460,33441,33450,33439,33476,33486,33444,33505,33545,33527,33508,33551,33543,33500,33524,33490,33496,33548,33531,33491,33553,33562,33542,33556,33557,33504,33493,33564,33617,33627,33628,33544,33682,33596,33588,33585,33691,33630,33583,33615,33607,33603,33631,33600,33559,33632,33581,33594,33587,33638,33637,36581,36582,36583,36584,36585,36586,36587,36588,36589,36590,36591,36592,36593,36594,36595,36596,36597,36598,36599,36600,36601,36602,36603,36604,36605,36606,36607,36608,36609,36610,36611,36612,36613,36614,36615,36616,36617,36618,36619,36620,36621,36622,36623,36624,36625,36626,36627,36628,36629,36630,36631,36632,36633,36634,36635,36636,36637,36638,36639,36640,36641,36642,36643,36644,36645,36646,36647,36648,36649,36650,36651,36652,36653,36654,36655,36656,36657,36658,36659,36660,36661,36662,36663,36664,36665,36666,36667,36668,36669,36670,36671,36672,36673,36674,36675,36676,33640,33563,33641,33644,33642,33645,33646,33712,33656,33715,33716,33696,33706,33683,33692,33669,33660,33718,33705,33661,33720,33659,33688,33694,33704,33722,33724,33729,33793,33765,33752,22535,33816,33803,33757,33789,33750,33820,33848,33809,33798,33748,33759,33807,33795,33784,33785,33770,33733,33728,33830,33776,33761,33884,33873,33882,33881,33907,33927,33928,33914,33929,33912,33852,33862,33897,33910,33932,33934,33841,33901,33985,33997,34000,34022,33981,34003,33994,33983,33978,34016,33953,33977,33972,33943,34021,34019,34060,29965,34104,34032,34105,34079,34106,36677,36678,36679,36680,36681,36682,36683,36684,36685,36686,36687,36688,36689,36690,36691,36692,36693,36694,36695,36696,36697,36698,36699,36700,36701,36702,36703,36704,36705,36706,36707,36708,36709,36714,36736,36748,36754,36765,36768,36769,36770,36772,36773,36774,36775,36778,36780,36781,36782,36783,36786,36787,36788,36789,36791,36792,36794,36795,36796,36799,36800,36803,36806,36809,36810,36811,36812,36813,36815,36818,36822,36823,36826,36832,36833,36835,36839,36844,36847,36849,36850,36852,36853,36854,36858,36859,36860,36862,36863,36871,36872,36876,36878,36883,36885,36888,34134,34107,34047,34044,34137,34120,34152,34148,34142,34170,30626,34115,34162,34171,34212,34216,34183,34191,34169,34222,34204,34181,34233,34231,34224,34259,34241,34268,34303,34343,34309,34345,34326,34364,24318,24328,22844,22849,32823,22869,22874,22872,21263,23586,23589,23596,23604,25164,25194,25247,25275,25290,25306,25303,25326,25378,25334,25401,25419,25411,25517,25590,25457,25466,25486,25524,25453,25516,25482,25449,25518,25532,25586,25592,25568,25599,25540,25566,25550,25682,25542,25534,25669,25665,25611,25627,25632,25612,25638,25633,25694,25732,25709,25750,36889,36892,36899,36900,36901,36903,36904,36905,36906,36907,36908,36912,36913,36914,36915,36916,36919,36921,36922,36925,36927,36928,36931,36933,36934,36936,36937,36938,36939,36940,36942,36948,36949,36950,36953,36954,36956,36957,36958,36959,36960,36961,36964,36966,36967,36969,36970,36971,36972,36975,36976,36977,36978,36979,36982,36983,36984,36985,36986,36987,36988,36990,36993,36996,36997,36998,36999,37001,37002,37004,37005,37006,37007,37008,37010,37012,37014,37016,37018,37020,37022,37023,37024,37028,37029,37031,37032,37033,37035,37037,37042,37047,37052,37053,37055,37056,25722,25783,25784,25753,25786,25792,25808,25815,25828,25826,25865,25893,25902,24331,24530,29977,24337,21343,21489,21501,21481,21480,21499,21522,21526,21510,21579,21586,21587,21588,21590,21571,21537,21591,21593,21539,21554,21634,21652,21623,21617,21604,21658,21659,21636,21622,21606,21661,21712,21677,21698,21684,21714,21671,21670,21715,21716,21618,21667,21717,21691,21695,21708,21721,21722,21724,21673,21674,21668,21725,21711,21726,21787,21735,21792,21757,21780,21747,21794,21795,21775,21777,21799,21802,21863,21903,21941,21833,21869,21825,21845,21823,21840,21820,37058,37059,37062,37064,37065,37067,37068,37069,37074,37076,37077,37078,37080,37081,37082,37086,37087,37088,37091,37092,37093,37097,37098,37100,37102,37104,37105,37106,37107,37109,37110,37111,37113,37114,37115,37116,37119,37120,37121,37123,37125,37126,37127,37128,37129,37130,37131,37132,37133,37134,37135,37136,37137,37138,37139,37140,37141,37142,37143,37144,37146,37147,37148,37149,37151,37152,37153,37156,37157,37158,37159,37160,37161,37162,37163,37164,37165,37166,37168,37170,37171,37172,37173,37174,37175,37176,37178,37179,37180,37181,37182,37183,37184,37185,37186,37188,21815,21846,21877,21878,21879,21811,21808,21852,21899,21970,21891,21937,21945,21896,21889,21919,21886,21974,21905,21883,21983,21949,21950,21908,21913,21994,22007,21961,22047,21969,21995,21996,21972,21990,21981,21956,21999,21989,22002,22003,21964,21965,21992,22005,21988,36756,22046,22024,22028,22017,22052,22051,22014,22016,22055,22061,22104,22073,22103,22060,22093,22114,22105,22108,22092,22100,22150,22116,22129,22123,22139,22140,22149,22163,22191,22228,22231,22237,22241,22261,22251,22265,22271,22276,22282,22281,22300,24079,24089,24084,24081,24113,24123,24124,37189,37191,37192,37201,37203,37204,37205,37206,37208,37209,37211,37212,37215,37216,37222,37223,37224,37227,37229,37235,37242,37243,37244,37248,37249,37250,37251,37252,37254,37256,37258,37262,37263,37267,37268,37269,37270,37271,37272,37273,37276,37277,37278,37279,37280,37281,37284,37285,37286,37287,37288,37289,37291,37292,37296,37297,37298,37299,37302,37303,37304,37305,37307,37308,37309,37310,37311,37312,37313,37314,37315,37316,37317,37318,37320,37323,37328,37330,37331,37332,37333,37334,37335,37336,37337,37338,37339,37341,37342,37343,37344,37345,37346,37347,37348,37349,24119,24132,24148,24155,24158,24161,23692,23674,23693,23696,23702,23688,23704,23705,23697,23706,23708,23733,23714,23741,23724,23723,23729,23715,23745,23735,23748,23762,23780,23755,23781,23810,23811,23847,23846,23854,23844,23838,23814,23835,23896,23870,23860,23869,23916,23899,23919,23901,23915,23883,23882,23913,23924,23938,23961,23965,35955,23991,24005,24435,24439,24450,24455,24457,24460,24469,24473,24476,24488,24493,24501,24508,34914,24417,29357,29360,29364,29367,29368,29379,29377,29390,29389,29394,29416,29423,29417,29426,29428,29431,29441,29427,29443,29434,37350,37351,37352,37353,37354,37355,37356,37357,37358,37359,37360,37361,37362,37363,37364,37365,37366,37367,37368,37369,37370,37371,37372,37373,37374,37375,37376,37377,37378,37379,37380,37381,37382,37383,37384,37385,37386,37387,37388,37389,37390,37391,37392,37393,37394,37395,37396,37397,37398,37399,37400,37401,37402,37403,37404,37405,37406,37407,37408,37409,37410,37411,37412,37413,37414,37415,37416,37417,37418,37419,37420,37421,37422,37423,37424,37425,37426,37427,37428,37429,37430,37431,37432,37433,37434,37435,37436,37437,37438,37439,37440,37441,37442,37443,37444,37445,29435,29463,29459,29473,29450,29470,29469,29461,29474,29497,29477,29484,29496,29489,29520,29517,29527,29536,29548,29551,29566,33307,22821,39143,22820,22786,39267,39271,39272,39273,39274,39275,39276,39284,39287,39293,39296,39300,39303,39306,39309,39312,39313,39315,39316,39317,24192,24209,24203,24214,24229,24224,24249,24245,24254,24243,36179,24274,24273,24283,24296,24298,33210,24516,24521,24534,24527,24579,24558,24580,24545,24548,24574,24581,24582,24554,24557,24568,24601,24629,24614,24603,24591,24589,24617,24619,24586,24639,24609,24696,24697,24699,24698,24642,37446,37447,37448,37449,37450,37451,37452,37453,37454,37455,37456,37457,37458,37459,37460,37461,37462,37463,37464,37465,37466,37467,37468,37469,37470,37471,37472,37473,37474,37475,37476,37477,37478,37479,37480,37481,37482,37483,37484,37485,37486,37487,37488,37489,37490,37491,37493,37494,37495,37496,37497,37498,37499,37500,37501,37502,37503,37504,37505,37506,37507,37508,37509,37510,37511,37512,37513,37514,37515,37516,37517,37519,37520,37521,37522,37523,37524,37525,37526,37527,37528,37529,37530,37531,37532,37533,37534,37535,37536,37537,37538,37539,37540,37541,37542,37543,24682,24701,24726,24730,24749,24733,24707,24722,24716,24731,24812,24763,24753,24797,24792,24774,24794,24756,24864,24870,24853,24867,24820,24832,24846,24875,24906,24949,25004,24980,24999,25015,25044,25077,24541,38579,38377,38379,38385,38387,38389,38390,38396,38398,38403,38404,38406,38408,38410,38411,38412,38413,38415,38418,38421,38422,38423,38425,38426,20012,29247,25109,27701,27732,27740,27722,27811,27781,27792,27796,27788,27752,27753,27764,27766,27782,27817,27856,27860,27821,27895,27896,27889,27863,27826,27872,27862,27898,27883,27886,27825,27859,27887,27902,37544,37545,37546,37547,37548,37549,37551,37552,37553,37554,37555,37556,37557,37558,37559,37560,37561,37562,37563,37564,37565,37566,37567,37568,37569,37570,37571,37572,37573,37574,37575,37577,37578,37579,37580,37581,37582,37583,37584,37585,37586,37587,37588,37589,37590,37591,37592,37593,37594,37595,37596,37597,37598,37599,37600,37601,37602,37603,37604,37605,37606,37607,37608,37609,37610,37611,37612,37613,37614,37615,37616,37617,37618,37619,37620,37621,37622,37623,37624,37625,37626,37627,37628,37629,37630,37631,37632,37633,37634,37635,37636,37637,37638,37639,37640,37641,27961,27943,27916,27971,27976,27911,27908,27929,27918,27947,27981,27950,27957,27930,27983,27986,27988,27955,28049,28015,28062,28064,27998,28051,28052,27996,28000,28028,28003,28186,28103,28101,28126,28174,28095,28128,28177,28134,28125,28121,28182,28075,28172,28078,28203,28270,28238,28267,28338,28255,28294,28243,28244,28210,28197,28228,28383,28337,28312,28384,28461,28386,28325,28327,28349,28347,28343,28375,28340,28367,28303,28354,28319,28514,28486,28487,28452,28437,28409,28463,28470,28491,28532,28458,28425,28457,28553,28557,28556,28536,28530,28540,28538,28625,37642,37643,37644,37645,37646,37647,37648,37649,37650,37651,37652,37653,37654,37655,37656,37657,37658,37659,37660,37661,37662,37663,37664,37665,37666,37667,37668,37669,37670,37671,37672,37673,37674,37675,37676,37677,37678,37679,37680,37681,37682,37683,37684,37685,37686,37687,37688,37689,37690,37691,37692,37693,37695,37696,37697,37698,37699,37700,37701,37702,37703,37704,37705,37706,37707,37708,37709,37710,37711,37712,37713,37714,37715,37716,37717,37718,37719,37720,37721,37722,37723,37724,37725,37726,37727,37728,37729,37730,37731,37732,37733,37734,37735,37736,37737,37739,28617,28583,28601,28598,28610,28641,28654,28638,28640,28655,28698,28707,28699,28729,28725,28751,28766,23424,23428,23445,23443,23461,23480,29999,39582,25652,23524,23534,35120,23536,36423,35591,36790,36819,36821,36837,36846,36836,36841,36838,36851,36840,36869,36868,36875,36902,36881,36877,36886,36897,36917,36918,36909,36911,36932,36945,36946,36944,36968,36952,36962,36955,26297,36980,36989,36994,37000,36995,37003,24400,24407,24406,24408,23611,21675,23632,23641,23409,23651,23654,32700,24362,24361,24365,33396,24380,39739,23662,22913,22915,22925,22953,22954,22947,37740,37741,37742,37743,37744,37745,37746,37747,37748,37749,37750,37751,37752,37753,37754,37755,37756,37757,37758,37759,37760,37761,37762,37763,37764,37765,37766,37767,37768,37769,37770,37771,37772,37773,37774,37776,37777,37778,37779,37780,37781,37782,37783,37784,37785,37786,37787,37788,37789,37790,37791,37792,37793,37794,37795,37796,37797,37798,37799,37800,37801,37802,37803,37804,37805,37806,37807,37808,37809,37810,37811,37812,37813,37814,37815,37816,37817,37818,37819,37820,37821,37822,37823,37824,37825,37826,37827,37828,37829,37830,37831,37832,37833,37835,37836,37837,22935,22986,22955,22942,22948,22994,22962,22959,22999,22974,23045,23046,23005,23048,23011,23000,23033,23052,23049,23090,23092,23057,23075,23059,23104,23143,23114,23125,23100,23138,23157,33004,23210,23195,23159,23162,23230,23275,23218,23250,23252,23224,23264,23267,23281,23254,23270,23256,23260,23305,23319,23318,23346,23351,23360,23573,23580,23386,23397,23411,23377,23379,23394,39541,39543,39544,39546,39551,39549,39552,39553,39557,39560,39562,39568,39570,39571,39574,39576,39579,39580,39581,39583,39584,39586,39587,39589,39591,32415,32417,32419,32421,32424,32425,37838,37839,37840,37841,37842,37843,37844,37845,37847,37848,37849,37850,37851,37852,37853,37854,37855,37856,37857,37858,37859,37860,37861,37862,37863,37864,37865,37866,37867,37868,37869,37870,37871,37872,37873,37874,37875,37876,37877,37878,37879,37880,37881,37882,37883,37884,37885,37886,37887,37888,37889,37890,37891,37892,37893,37894,37895,37896,37897,37898,37899,37900,37901,37902,37903,37904,37905,37906,37907,37908,37909,37910,37911,37912,37913,37914,37915,37916,37917,37918,37919,37920,37921,37922,37923,37924,37925,37926,37927,37928,37929,37930,37931,37932,37933,37934,32429,32432,32446,32448,32449,32450,32457,32459,32460,32464,32468,32471,32475,32480,32481,32488,32491,32494,32495,32497,32498,32525,32502,32506,32507,32510,32513,32514,32515,32519,32520,32523,32524,32527,32529,32530,32535,32537,32540,32539,32543,32545,32546,32547,32548,32549,32550,32551,32554,32555,32556,32557,32559,32560,32561,32562,32563,32565,24186,30079,24027,30014,37013,29582,29585,29614,29602,29599,29647,29634,29649,29623,29619,29632,29641,29640,29669,29657,39036,29706,29673,29671,29662,29626,29682,29711,29738,29787,29734,29733,29736,29744,29742,29740,37935,37936,37937,37938,37939,37940,37941,37942,37943,37944,37945,37946,37947,37948,37949,37951,37952,37953,37954,37955,37956,37957,37958,37959,37960,37961,37962,37963,37964,37965,37966,37967,37968,37969,37970,37971,37972,37973,37974,37975,37976,37977,37978,37979,37980,37981,37982,37983,37984,37985,37986,37987,37988,37989,37990,37991,37992,37993,37994,37996,37997,37998,37999,38000,38001,38002,38003,38004,38005,38006,38007,38008,38009,38010,38011,38012,38013,38014,38015,38016,38017,38018,38019,38020,38033,38038,38040,38087,38095,38099,38100,38106,38118,38139,38172,38176,29723,29722,29761,29788,29783,29781,29785,29815,29805,29822,29852,29838,29824,29825,29831,29835,29854,29864,29865,29840,29863,29906,29882,38890,38891,38892,26444,26451,26462,26440,26473,26533,26503,26474,26483,26520,26535,26485,26536,26526,26541,26507,26487,26492,26608,26633,26584,26634,26601,26544,26636,26585,26549,26586,26547,26589,26624,26563,26552,26594,26638,26561,26621,26674,26675,26720,26721,26702,26722,26692,26724,26755,26653,26709,26726,26689,26727,26688,26686,26698,26697,26665,26805,26767,26740,26743,26771,26731,26818,26990,26876,26911,26912,26873,38183,38195,38205,38211,38216,38219,38229,38234,38240,38254,38260,38261,38263,38264,38265,38266,38267,38268,38269,38270,38272,38273,38274,38275,38276,38277,38278,38279,38280,38281,38282,38283,38284,38285,38286,38287,38288,38289,38290,38291,38292,38293,38294,38295,38296,38297,38298,38299,38300,38301,38302,38303,38304,38305,38306,38307,38308,38309,38310,38311,38312,38313,38314,38315,38316,38317,38318,38319,38320,38321,38322,38323,38324,38325,38326,38327,38328,38329,38330,38331,38332,38333,38334,38335,38336,38337,38338,38339,38340,38341,38342,38343,38344,38345,38346,38347,26916,26864,26891,26881,26967,26851,26896,26993,26937,26976,26946,26973,27012,26987,27008,27032,27000,26932,27084,27015,27016,27086,27017,26982,26979,27001,27035,27047,27067,27051,27053,27092,27057,27073,27082,27103,27029,27104,27021,27135,27183,27117,27159,27160,27237,27122,27204,27198,27296,27216,27227,27189,27278,27257,27197,27176,27224,27260,27281,27280,27305,27287,27307,29495,29522,27521,27522,27527,27524,27538,27539,27533,27546,27547,27553,27562,36715,36717,36721,36722,36723,36725,36726,36728,36727,36729,36730,36732,36734,36737,36738,36740,36743,36747,38348,38349,38350,38351,38352,38353,38354,38355,38356,38357,38358,38359,38360,38361,38362,38363,38364,38365,38366,38367,38368,38369,38370,38371,38372,38373,38374,38375,38380,38399,38407,38419,38424,38427,38430,38432,38435,38436,38437,38438,38439,38440,38441,38443,38444,38445,38447,38448,38455,38456,38457,38458,38462,38465,38467,38474,38478,38479,38481,38482,38483,38486,38487,38488,38489,38490,38492,38493,38494,38496,38499,38501,38502,38507,38509,38510,38511,38512,38513,38515,38520,38521,38522,38523,38524,38525,38526,38527,38528,38529,38530,38531,38532,38535,38537,38538,36749,36750,36751,36760,36762,36558,25099,25111,25115,25119,25122,25121,25125,25124,25132,33255,29935,29940,29951,29967,29969,29971,25908,26094,26095,26096,26122,26137,26482,26115,26133,26112,28805,26359,26141,26164,26161,26166,26165,32774,26207,26196,26177,26191,26198,26209,26199,26231,26244,26252,26279,26269,26302,26331,26332,26342,26345,36146,36147,36150,36155,36157,36160,36165,36166,36168,36169,36167,36173,36181,36185,35271,35274,35275,35276,35278,35279,35280,35281,29294,29343,29277,29286,29295,29310,29311,29316,29323,29325,29327,29330,25352,25394,25520,38540,38542,38545,38546,38547,38549,38550,38554,38555,38557,38558,38559,38560,38561,38562,38563,38564,38565,38566,38568,38569,38570,38571,38572,38573,38574,38575,38577,38578,38580,38581,38583,38584,38586,38587,38591,38594,38595,38600,38602,38603,38608,38609,38611,38612,38614,38615,38616,38617,38618,38619,38620,38621,38622,38623,38625,38626,38627,38628,38629,38630,38631,38635,38636,38637,38638,38640,38641,38642,38644,38645,38648,38650,38651,38652,38653,38655,38658,38659,38661,38666,38667,38668,38672,38673,38674,38676,38677,38679,38680,38681,38682,38683,38685,38687,38688,25663,25816,32772,27626,27635,27645,27637,27641,27653,27655,27654,27661,27669,27672,27673,27674,27681,27689,27684,27690,27698,25909,25941,25963,29261,29266,29270,29232,34402,21014,32927,32924,32915,32956,26378,32957,32945,32939,32941,32948,32951,32999,33000,33001,33002,32987,32962,32964,32985,32973,32983,26384,32989,33003,33009,33012,33005,33037,33038,33010,33020,26389,33042,35930,33078,33054,33068,33048,33074,33096,33100,33107,33140,33113,33114,33137,33120,33129,33148,33149,33133,33127,22605,23221,33160,33154,33169,28373,33187,33194,33228,26406,33226,33211,38689,38690,38691,38692,38693,38694,38695,38696,38697,38699,38700,38702,38703,38705,38707,38708,38709,38710,38711,38714,38715,38716,38717,38719,38720,38721,38722,38723,38724,38725,38726,38727,38728,38729,38730,38731,38732,38733,38734,38735,38736,38737,38740,38741,38743,38744,38746,38748,38749,38751,38755,38756,38758,38759,38760,38762,38763,38764,38765,38766,38767,38768,38769,38770,38773,38775,38776,38777,38778,38779,38781,38782,38783,38784,38785,38786,38787,38788,38790,38791,38792,38793,38794,38796,38798,38799,38800,38803,38805,38806,38807,38809,38810,38811,38812,38813,33217,33190,27428,27447,27449,27459,27462,27481,39121,39122,39123,39125,39129,39130,27571,24384,27586,35315,26000,40785,26003,26044,26054,26052,26051,26060,26062,26066,26070,28800,28828,28822,28829,28859,28864,28855,28843,28849,28904,28874,28944,28947,28950,28975,28977,29043,29020,29032,28997,29042,29002,29048,29050,29080,29107,29109,29096,29088,29152,29140,29159,29177,29213,29224,28780,28952,29030,29113,25150,25149,25155,25160,25161,31035,31040,31046,31049,31067,31068,31059,31066,31074,31063,31072,31087,31079,31098,31109,31114,31130,31143,31155,24529,24528,38814,38815,38817,38818,38820,38821,38822,38823,38824,38825,38826,38828,38830,38832,38833,38835,38837,38838,38839,38840,38841,38842,38843,38844,38845,38846,38847,38848,38849,38850,38851,38852,38853,38854,38855,38856,38857,38858,38859,38860,38861,38862,38863,38864,38865,38866,38867,38868,38869,38870,38871,38872,38873,38874,38875,38876,38877,38878,38879,38880,38881,38882,38883,38884,38885,38888,38894,38895,38896,38897,38898,38900,38903,38904,38905,38906,38907,38908,38909,38910,38911,38912,38913,38914,38915,38916,38917,38918,38919,38920,38921,38922,38923,38924,38925,38926,24636,24669,24666,24679,24641,24665,24675,24747,24838,24845,24925,25001,24989,25035,25041,25094,32896,32895,27795,27894,28156,30710,30712,30720,30729,30743,30744,30737,26027,30765,30748,30749,30777,30778,30779,30751,30780,30757,30764,30755,30761,30798,30829,30806,30807,30758,30800,30791,30796,30826,30875,30867,30874,30855,30876,30881,30883,30898,30905,30885,30932,30937,30921,30956,30962,30981,30964,30995,31012,31006,31028,40859,40697,40699,40700,30449,30468,30477,30457,30471,30472,30490,30498,30489,30509,30502,30517,30520,30544,30545,30535,30531,30554,30568,38927,38928,38929,38930,38931,38932,38933,38934,38935,38936,38937,38938,38939,38940,38941,38942,38943,38944,38945,38946,38947,38948,38949,38950,38951,38952,38953,38954,38955,38956,38957,38958,38959,38960,38961,38962,38963,38964,38965,38966,38967,38968,38969,38970,38971,38972,38973,38974,38975,38976,38977,38978,38979,38980,38981,38982,38983,38984,38985,38986,38987,38988,38989,38990,38991,38992,38993,38994,38995,38996,38997,38998,38999,39000,39001,39002,39003,39004,39005,39006,39007,39008,39009,39010,39011,39012,39013,39014,39015,39016,39017,39018,39019,39020,39021,39022,30562,30565,30591,30605,30589,30592,30604,30609,30623,30624,30640,30645,30653,30010,30016,30030,30027,30024,30043,30066,30073,30083,32600,32609,32607,35400,32616,32628,32625,32633,32641,32638,30413,30437,34866,38021,38022,38023,38027,38026,38028,38029,38031,38032,38036,38039,38037,38042,38043,38044,38051,38052,38059,38058,38061,38060,38063,38064,38066,38068,38070,38071,38072,38073,38074,38076,38077,38079,38084,38088,38089,38090,38091,38092,38093,38094,38096,38097,38098,38101,38102,38103,38105,38104,38107,38110,38111,38112,38114,38116,38117,38119,38120,38122,39023,39024,39025,39026,39027,39028,39051,39054,39058,39061,39065,39075,39080,39081,39082,39083,39084,39085,39086,39087,39088,39089,39090,39091,39092,39093,39094,39095,39096,39097,39098,39099,39100,39101,39102,39103,39104,39105,39106,39107,39108,39109,39110,39111,39112,39113,39114,39115,39116,39117,39119,39120,39124,39126,39127,39131,39132,39133,39136,39137,39138,39139,39140,39141,39142,39145,39146,39147,39148,39149,39150,39151,39152,39153,39154,39155,39156,39157,39158,39159,39160,39161,39162,39163,39164,39165,39166,39167,39168,39169,39170,39171,39172,39173,39174,39175,38121,38123,38126,38127,38131,38132,38133,38135,38137,38140,38141,38143,38147,38146,38150,38151,38153,38154,38157,38158,38159,38162,38163,38164,38165,38166,38168,38171,38173,38174,38175,38178,38186,38187,38185,38188,38193,38194,38196,38198,38199,38200,38204,38206,38207,38210,38197,38212,38213,38214,38217,38220,38222,38223,38226,38227,38228,38230,38231,38232,38233,38235,38238,38239,38237,38241,38242,38244,38245,38246,38247,38248,38249,38250,38251,38252,38255,38257,38258,38259,38202,30695,30700,38601,31189,31213,31203,31211,31238,23879,31235,31234,31262,31252,39176,39177,39178,39179,39180,39182,39183,39185,39186,39187,39188,39189,39190,39191,39192,39193,39194,39195,39196,39197,39198,39199,39200,39201,39202,39203,39204,39205,39206,39207,39208,39209,39210,39211,39212,39213,39215,39216,39217,39218,39219,39220,39221,39222,39223,39224,39225,39226,39227,39228,39229,39230,39231,39232,39233,39234,39235,39236,39237,39238,39239,39240,39241,39242,39243,39244,39245,39246,39247,39248,39249,39250,39251,39254,39255,39256,39257,39258,39259,39260,39261,39262,39263,39264,39265,39266,39268,39270,39283,39288,39289,39291,39294,39298,39299,39305,31289,31287,31313,40655,39333,31344,30344,30350,30355,30361,30372,29918,29920,29996,40480,40482,40488,40489,40490,40491,40492,40498,40497,40502,40504,40503,40505,40506,40510,40513,40514,40516,40518,40519,40520,40521,40523,40524,40526,40529,40533,40535,40538,40539,40540,40542,40547,40550,40551,40552,40553,40554,40555,40556,40561,40557,40563,30098,30100,30102,30112,30109,30124,30115,30131,30132,30136,30148,30129,30128,30147,30146,30166,30157,30179,30184,30182,30180,30187,30183,30211,30193,30204,30207,30224,30208,30213,30220,30231,30218,30245,30232,30229,30233,39308,39310,39322,39323,39324,39325,39326,39327,39328,39329,39330,39331,39332,39334,39335,39337,39338,39339,39340,39341,39342,39343,39344,39345,39346,39347,39348,39349,39350,39351,39352,39353,39354,39355,39356,39357,39358,39359,39360,39361,39362,39363,39364,39365,39366,39367,39368,39369,39370,39371,39372,39373,39374,39375,39376,39377,39378,39379,39380,39381,39382,39383,39384,39385,39386,39387,39388,39389,39390,39391,39392,39393,39394,39395,39396,39397,39398,39399,39400,39401,39402,39403,39404,39405,39406,39407,39408,39409,39410,39411,39412,39413,39414,39415,39416,39417,30235,30268,30242,30240,30272,30253,30256,30271,30261,30275,30270,30259,30285,30302,30292,30300,30294,30315,30319,32714,31462,31352,31353,31360,31366,31368,31381,31398,31392,31404,31400,31405,31411,34916,34921,34930,34941,34943,34946,34978,35014,34999,35004,35017,35042,35022,35043,35045,35057,35098,35068,35048,35070,35056,35105,35097,35091,35099,35082,35124,35115,35126,35137,35174,35195,30091,32997,30386,30388,30684,32786,32788,32790,32796,32800,32802,32805,32806,32807,32809,32808,32817,32779,32821,32835,32838,32845,32850,32873,32881,35203,39032,39040,39043,39418,39419,39420,39421,39422,39423,39424,39425,39426,39427,39428,39429,39430,39431,39432,39433,39434,39435,39436,39437,39438,39439,39440,39441,39442,39443,39444,39445,39446,39447,39448,39449,39450,39451,39452,39453,39454,39455,39456,39457,39458,39459,39460,39461,39462,39463,39464,39465,39466,39467,39468,39469,39470,39471,39472,39473,39474,39475,39476,39477,39478,39479,39480,39481,39482,39483,39484,39485,39486,39487,39488,39489,39490,39491,39492,39493,39494,39495,39496,39497,39498,39499,39500,39501,39502,39503,39504,39505,39506,39507,39508,39509,39510,39511,39512,39513,39049,39052,39053,39055,39060,39066,39067,39070,39071,39073,39074,39077,39078,34381,34388,34412,34414,34431,34426,34428,34427,34472,34445,34443,34476,34461,34471,34467,34474,34451,34473,34486,34500,34485,34510,34480,34490,34481,34479,34505,34511,34484,34537,34545,34546,34541,34547,34512,34579,34526,34548,34527,34520,34513,34563,34567,34552,34568,34570,34573,34569,34595,34619,34590,34597,34606,34586,34622,34632,34612,34609,34601,34615,34623,34690,34594,34685,34686,34683,34656,34672,34636,34670,34699,34643,34659,34684,34660,34649,34661,34707,34735,34728,34770,39514,39515,39516,39517,39518,39519,39520,39521,39522,39523,39524,39525,39526,39527,39528,39529,39530,39531,39538,39555,39561,39565,39566,39572,39573,39577,39590,39593,39594,39595,39596,39597,39598,39599,39602,39603,39604,39605,39609,39611,39613,39614,39615,39619,39620,39622,39623,39624,39625,39626,39629,39630,39631,39632,39634,39636,39637,39638,39639,39641,39642,39643,39644,39645,39646,39648,39650,39651,39652,39653,39655,39656,39657,39658,39660,39662,39664,39665,39666,39667,39668,39669,39670,39671,39672,39674,39676,39677,39678,39679,39680,39681,39682,39684,39685,39686,34758,34696,34693,34733,34711,34691,34731,34789,34732,34741,34739,34763,34771,34749,34769,34752,34762,34779,34794,34784,34798,34838,34835,34814,34826,34843,34849,34873,34876,32566,32578,32580,32581,33296,31482,31485,31496,31491,31492,31509,31498,31531,31503,31559,31544,31530,31513,31534,31537,31520,31525,31524,31539,31550,31518,31576,31578,31557,31605,31564,31581,31584,31598,31611,31586,31602,31601,31632,31654,31655,31672,31660,31645,31656,31621,31658,31644,31650,31659,31668,31697,31681,31692,31709,31706,31717,31718,31722,31756,31742,31740,31759,31766,31755,39687,39689,39690,39691,39692,39693,39694,39696,39697,39698,39700,39701,39702,39703,39704,39705,39706,39707,39708,39709,39710,39712,39713,39714,39716,39717,39718,39719,39720,39721,39722,39723,39724,39725,39726,39728,39729,39731,39732,39733,39734,39735,39736,39737,39738,39741,39742,39743,39744,39750,39754,39755,39756,39758,39760,39762,39763,39765,39766,39767,39768,39769,39770,39771,39772,39773,39774,39775,39776,39777,39778,39779,39780,39781,39782,39783,39784,39785,39786,39787,39788,39789,39790,39791,39792,39793,39794,39795,39796,39797,39798,39799,39800,39801,39802,39803,31775,31786,31782,31800,31809,31808,33278,33281,33282,33284,33260,34884,33313,33314,33315,33325,33327,33320,33323,33336,33339,33331,33332,33342,33348,33353,33355,33359,33370,33375,33384,34942,34949,34952,35032,35039,35166,32669,32671,32679,32687,32688,32690,31868,25929,31889,31901,31900,31902,31906,31922,31932,31933,31937,31943,31948,31949,31944,31941,31959,31976,33390,26280,32703,32718,32725,32741,32737,32742,32745,32750,32755,31992,32119,32166,32174,32327,32411,40632,40628,36211,36228,36244,36241,36273,36199,36205,35911,35913,37194,37200,37198,37199,37220,39804,39805,39806,39807,39808,39809,39810,39811,39812,39813,39814,39815,39816,39817,39818,39819,39820,39821,39822,39823,39824,39825,39826,39827,39828,39829,39830,39831,39832,39833,39834,39835,39836,39837,39838,39839,39840,39841,39842,39843,39844,39845,39846,39847,39848,39849,39850,39851,39852,39853,39854,39855,39856,39857,39858,39859,39860,39861,39862,39863,39864,39865,39866,39867,39868,39869,39870,39871,39872,39873,39874,39875,39876,39877,39878,39879,39880,39881,39882,39883,39884,39885,39886,39887,39888,39889,39890,39891,39892,39893,39894,39895,39896,39897,39898,39899,37218,37217,37232,37225,37231,37245,37246,37234,37236,37241,37260,37253,37264,37261,37265,37282,37283,37290,37293,37294,37295,37301,37300,37306,35925,40574,36280,36331,36357,36441,36457,36277,36287,36284,36282,36292,36310,36311,36314,36318,36302,36303,36315,36294,36332,36343,36344,36323,36345,36347,36324,36361,36349,36372,36381,36383,36396,36398,36387,36399,36410,36416,36409,36405,36413,36401,36425,36417,36418,36433,36434,36426,36464,36470,36476,36463,36468,36485,36495,36500,36496,36508,36510,35960,35970,35978,35973,35992,35988,26011,35286,35294,35290,35292,39900,39901,39902,39903,39904,39905,39906,39907,39908,39909,39910,39911,39912,39913,39914,39915,39916,39917,39918,39919,39920,39921,39922,39923,39924,39925,39926,39927,39928,39929,39930,39931,39932,39933,39934,39935,39936,39937,39938,39939,39940,39941,39942,39943,39944,39945,39946,39947,39948,39949,39950,39951,39952,39953,39954,39955,39956,39957,39958,39959,39960,39961,39962,39963,39964,39965,39966,39967,39968,39969,39970,39971,39972,39973,39974,39975,39976,39977,39978,39979,39980,39981,39982,39983,39984,39985,39986,39987,39988,39989,39990,39991,39992,39993,39994,39995,35301,35307,35311,35390,35622,38739,38633,38643,38639,38662,38657,38664,38671,38670,38698,38701,38704,38718,40832,40835,40837,40838,40839,40840,40841,40842,40844,40702,40715,40717,38585,38588,38589,38606,38610,30655,38624,37518,37550,37576,37694,37738,37834,37775,37950,37995,40063,40066,40069,40070,40071,40072,31267,40075,40078,40080,40081,40082,40084,40085,40090,40091,40094,40095,40096,40097,40098,40099,40101,40102,40103,40104,40105,40107,40109,40110,40112,40113,40114,40115,40116,40117,40118,40119,40122,40123,40124,40125,40132,40133,40134,40135,40138,40139,39996,39997,39998,39999,40000,40001,40002,40003,40004,40005,40006,40007,40008,40009,40010,40011,40012,40013,40014,40015,40016,40017,40018,40019,40020,40021,40022,40023,40024,40025,40026,40027,40028,40029,40030,40031,40032,40033,40034,40035,40036,40037,40038,40039,40040,40041,40042,40043,40044,40045,40046,40047,40048,40049,40050,40051,40052,40053,40054,40055,40056,40057,40058,40059,40061,40062,40064,40067,40068,40073,40074,40076,40079,40083,40086,40087,40088,40089,40093,40106,40108,40111,40121,40126,40127,40128,40129,40130,40136,40137,40145,40146,40154,40155,40160,40161,40140,40141,40142,40143,40144,40147,40148,40149,40151,40152,40153,40156,40157,40159,40162,38780,38789,38801,38802,38804,38831,38827,38819,38834,38836,39601,39600,39607,40536,39606,39610,39612,39617,39616,39621,39618,39627,39628,39633,39749,39747,39751,39753,39752,39757,39761,39144,39181,39214,39253,39252,39647,39649,39654,39663,39659,39675,39661,39673,39688,39695,39699,39711,39715,40637,40638,32315,40578,40583,40584,40587,40594,37846,40605,40607,40667,40668,40669,40672,40671,40674,40681,40679,40677,40682,40687,40738,40748,40751,40761,40759,40765,40766,40772,40163,40164,40165,40166,40167,40168,40169,40170,40171,40172,40173,40174,40175,40176,40177,40178,40179,40180,40181,40182,40183,40184,40185,40186,40187,40188,40189,40190,40191,40192,40193,40194,40195,40196,40197,40198,40199,40200,40201,40202,40203,40204,40205,40206,40207,40208,40209,40210,40211,40212,40213,40214,40215,40216,40217,40218,40219,40220,40221,40222,40223,40224,40225,40226,40227,40228,40229,40230,40231,40232,40233,40234,40235,40236,40237,40238,40239,40240,40241,40242,40243,40244,40245,40246,40247,40248,40249,40250,40251,40252,40253,40254,40255,40256,40257,40258,57908,57909,57910,57911,57912,57913,57914,57915,57916,57917,57918,57919,57920,57921,57922,57923,57924,57925,57926,57927,57928,57929,57930,57931,57932,57933,57934,57935,57936,57937,57938,57939,57940,57941,57942,57943,57944,57945,57946,57947,57948,57949,57950,57951,57952,57953,57954,57955,57956,57957,57958,57959,57960,57961,57962,57963,57964,57965,57966,57967,57968,57969,57970,57971,57972,57973,57974,57975,57976,57977,57978,57979,57980,57981,57982,57983,57984,57985,57986,57987,57988,57989,57990,57991,57992,57993,57994,57995,57996,57997,57998,57999,58000,58001,40259,40260,40261,40262,40263,40264,40265,40266,40267,40268,40269,40270,40271,40272,40273,40274,40275,40276,40277,40278,40279,40280,40281,40282,40283,40284,40285,40286,40287,40288,40289,40290,40291,40292,40293,40294,40295,40296,40297,40298,40299,40300,40301,40302,40303,40304,40305,40306,40307,40308,40309,40310,40311,40312,40313,40314,40315,40316,40317,40318,40319,40320,40321,40322,40323,40324,40325,40326,40327,40328,40329,40330,40331,40332,40333,40334,40335,40336,40337,40338,40339,40340,40341,40342,40343,40344,40345,40346,40347,40348,40349,40350,40351,40352,40353,40354,58002,58003,58004,58005,58006,58007,58008,58009,58010,58011,58012,58013,58014,58015,58016,58017,58018,58019,58020,58021,58022,58023,58024,58025,58026,58027,58028,58029,58030,58031,58032,58033,58034,58035,58036,58037,58038,58039,58040,58041,58042,58043,58044,58045,58046,58047,58048,58049,58050,58051,58052,58053,58054,58055,58056,58057,58058,58059,58060,58061,58062,58063,58064,58065,58066,58067,58068,58069,58070,58071,58072,58073,58074,58075,58076,58077,58078,58079,58080,58081,58082,58083,58084,58085,58086,58087,58088,58089,58090,58091,58092,58093,58094,58095,40355,40356,40357,40358,40359,40360,40361,40362,40363,40364,40365,40366,40367,40368,40369,40370,40371,40372,40373,40374,40375,40376,40377,40378,40379,40380,40381,40382,40383,40384,40385,40386,40387,40388,40389,40390,40391,40392,40393,40394,40395,40396,40397,40398,40399,40400,40401,40402,40403,40404,40405,40406,40407,40408,40409,40410,40411,40412,40413,40414,40415,40416,40417,40418,40419,40420,40421,40422,40423,40424,40425,40426,40427,40428,40429,40430,40431,40432,40433,40434,40435,40436,40437,40438,40439,40440,40441,40442,40443,40444,40445,40446,40447,40448,40449,40450,58096,58097,58098,58099,58100,58101,58102,58103,58104,58105,58106,58107,58108,58109,58110,58111,58112,58113,58114,58115,58116,58117,58118,58119,58120,58121,58122,58123,58124,58125,58126,58127,58128,58129,58130,58131,58132,58133,58134,58135,58136,58137,58138,58139,58140,58141,58142,58143,58144,58145,58146,58147,58148,58149,58150,58151,58152,58153,58154,58155,58156,58157,58158,58159,58160,58161,58162,58163,58164,58165,58166,58167,58168,58169,58170,58171,58172,58173,58174,58175,58176,58177,58178,58179,58180,58181,58182,58183,58184,58185,58186,58187,58188,58189,40451,40452,40453,40454,40455,40456,40457,40458,40459,40460,40461,40462,40463,40464,40465,40466,40467,40468,40469,40470,40471,40472,40473,40474,40475,40476,40477,40478,40484,40487,40494,40496,40500,40507,40508,40512,40525,40528,40530,40531,40532,40534,40537,40541,40543,40544,40545,40546,40549,40558,40559,40562,40564,40565,40566,40567,40568,40569,40570,40571,40572,40573,40576,40577,40579,40580,40581,40582,40585,40586,40588,40589,40590,40591,40592,40593,40596,40597,40598,40599,40600,40601,40602,40603,40604,40606,40608,40609,40610,40611,40612,40613,40615,40616,40617,40618,58190,58191,58192,58193,58194,58195,58196,58197,58198,58199,58200,58201,58202,58203,58204,58205,58206,58207,58208,58209,58210,58211,58212,58213,58214,58215,58216,58217,58218,58219,58220,58221,58222,58223,58224,58225,58226,58227,58228,58229,58230,58231,58232,58233,58234,58235,58236,58237,58238,58239,58240,58241,58242,58243,58244,58245,58246,58247,58248,58249,58250,58251,58252,58253,58254,58255,58256,58257,58258,58259,58260,58261,58262,58263,58264,58265,58266,58267,58268,58269,58270,58271,58272,58273,58274,58275,58276,58277,58278,58279,58280,58281,58282,58283,40619,40620,40621,40622,40623,40624,40625,40626,40627,40629,40630,40631,40633,40634,40636,40639,40640,40641,40642,40643,40645,40646,40647,40648,40650,40651,40652,40656,40658,40659,40661,40662,40663,40665,40666,40670,40673,40675,40676,40678,40680,40683,40684,40685,40686,40688,40689,40690,40691,40692,40693,40694,40695,40696,40698,40701,40703,40704,40705,40706,40707,40708,40709,40710,40711,40712,40713,40714,40716,40719,40721,40722,40724,40725,40726,40728,40730,40731,40732,40733,40734,40735,40737,40739,40740,40741,40742,40743,40744,40745,40746,40747,40749,40750,40752,40753,58284,58285,58286,58287,58288,58289,58290,58291,58292,58293,58294,58295,58296,58297,58298,58299,58300,58301,58302,58303,58304,58305,58306,58307,58308,58309,58310,58311,58312,58313,58314,58315,58316,58317,58318,58319,58320,58321,58322,58323,58324,58325,58326,58327,58328,58329,58330,58331,58332,58333,58334,58335,58336,58337,58338,58339,58340,58341,58342,58343,58344,58345,58346,58347,58348,58349,58350,58351,58352,58353,58354,58355,58356,58357,58358,58359,58360,58361,58362,58363,58364,58365,58366,58367,58368,58369,58370,58371,58372,58373,58374,58375,58376,58377,40754,40755,40756,40757,40758,40760,40762,40764,40767,40768,40769,40770,40771,40773,40774,40775,40776,40777,40778,40779,40780,40781,40782,40783,40786,40787,40788,40789,40790,40791,40792,40793,40794,40795,40796,40797,40798,40799,40800,40801,40802,40803,40804,40805,40806,40807,40808,40809,40810,40811,40812,40813,40814,40815,40816,40817,40818,40819,40820,40821,40822,40823,40824,40825,40826,40827,40828,40829,40830,40833,40834,40845,40846,40847,40848,40849,40850,40851,40852,40853,40854,40855,40856,40860,40861,40862,40865,40866,40867,40868,40869,63788,63865,63893,63975,63985,58378,58379,58380,58381,58382,58383,58384,58385,58386,58387,58388,58389,58390,58391,58392,58393,58394,58395,58396,58397,58398,58399,58400,58401,58402,58403,58404,58405,58406,58407,58408,58409,58410,58411,58412,58413,58414,58415,58416,58417,58418,58419,58420,58421,58422,58423,58424,58425,58426,58427,58428,58429,58430,58431,58432,58433,58434,58435,58436,58437,58438,58439,58440,58441,58442,58443,58444,58445,58446,58447,58448,58449,58450,58451,58452,58453,58454,58455,58456,58457,58458,58459,58460,58461,58462,58463,58464,58465,58466,58467,58468,58469,58470,58471,64012,64013,64014,64015,64017,64019,64020,64024,64031,64032,64033,64035,64036,64039,64040,64041,11905,59414,59415,59416,11908,13427,13383,11912,11915,59422,13726,13850,13838,11916,11927,14702,14616,59430,14799,14815,14963,14800,59435,59436,15182,15470,15584,11943,59441,59442,11946,16470,16735,11950,17207,11955,11958,11959,59451,17329,17324,11963,17373,17622,18017,17996,59459,18211,18217,18300,18317,11978,18759,18810,18813,18818,18819,18821,18822,18847,18843,18871,18870,59476,59477,19619,19615,19616,19617,19575,19618,19731,19732,19733,19734,19735,19736,19737,19886,59492,58472,58473,58474,58475,58476,58477,58478,58479,58480,58481,58482,58483,58484,58485,58486,58487,58488,58489,58490,58491,58492,58493,58494,58495,58496,58497,58498,58499,58500,58501,58502,58503,58504,58505,58506,58507,58508,58509,58510,58511,58512,58513,58514,58515,58516,58517,58518,58519,58520,58521,58522,58523,58524,58525,58526,58527,58528,58529,58530,58531,58532,58533,58534,58535,58536,58537,58538,58539,58540,58541,58542,58543,58544,58545,58546,58547,58548,58549,58550,58551,58552,58553,58554,58555,58556,58557,58558,58559,58560,58561,58562,58563,58564,58565],
  "gb18030-ranges":[[0,128],[36,165],[38,169],[45,178],[50,184],[81,216],[89,226],[95,235],[96,238],[100,244],[103,248],[104,251],[105,253],[109,258],[126,276],[133,284],[148,300],[172,325],[175,329],[179,334],[208,364],[306,463],[307,465],[308,467],[309,469],[310,471],[311,473],[312,475],[313,477],[341,506],[428,594],[443,610],[544,712],[545,716],[558,730],[741,930],[742,938],[749,962],[750,970],[805,1026],[819,1104],[820,1106],[7922,8209],[7924,8215],[7925,8218],[7927,8222],[7934,8231],[7943,8241],[7944,8244],[7945,8246],[7950,8252],[8062,8365],[8148,8452],[8149,8454],[8152,8458],[8164,8471],[8174,8482],[8236,8556],[8240,8570],[8262,8596],[8264,8602],[8374,8713],[8380,8720],[8381,8722],[8384,8726],[8388,8731],[8390,8737],[8392,8740],[8393,8742],[8394,8748],[8396,8751],[8401,8760],[8406,8766],[8416,8777],[8419,8781],[8424,8787],[8437,8802],[8439,8808],[8445,8816],[8482,8854],[8485,8858],[8496,8870],[8521,8896],[8603,8979],[8936,9322],[8946,9372],[9046,9548],[9050,9588],[9063,9616],[9066,9622],[9076,9634],[9092,9652],[9100,9662],[9108,9672],[9111,9676],[9113,9680],[9131,9702],[9162,9735],[9164,9738],[9218,9793],[9219,9795],[11329,11906],[11331,11909],[11334,11913],[11336,11917],[11346,11928],[11361,11944],[11363,11947],[11366,11951],[11370,11956],[11372,11960],[11375,11964],[11389,11979],[11682,12284],[11686,12292],[11687,12312],[11692,12319],[11694,12330],[11714,12351],[11716,12436],[11723,12447],[11725,12535],[11730,12543],[11736,12586],[11982,12842],[11989,12850],[12102,12964],[12336,13200],[12348,13215],[12350,13218],[12384,13253],[12393,13263],[12395,13267],[12397,13270],[12510,13384],[12553,13428],[12851,13727],[12962,13839],[12973,13851],[13738,14617],[13823,14703],[13919,14801],[13933,14816],[14080,14964],[14298,15183],[14585,15471],[14698,15585],[15583,16471],[15847,16736],[16318,17208],[16434,17325],[16438,17330],[16481,17374],[16729,17623],[17102,17997],[17122,18018],[17315,18212],[17320,18218],[17402,18301],[17418,18318],[17859,18760],[17909,18811],[17911,18814],[17915,18820],[17916,18823],[17936,18844],[17939,18848],[17961,18872],[18664,19576],[18703,19620],[18814,19738],[18962,19887],[19043,40870],[33469,59244],[33470,59336],[33471,59367],[33484,59413],[33485,59417],[33490,59423],[33497,59431],[33501,59437],[33505,59443],[33513,59452],[33520,59460],[33536,59478],[33550,59493],[37845,63789],[37921,63866],[37948,63894],[38029,63976],[38038,63986],[38064,64016],[38065,64018],[38066,64021],[38069,64025],[38075,64034],[38076,64037],[38078,64042],[39108,65074],[39109,65093],[39113,65107],[39114,65112],[39115,65127],[39116,65132],[39265,65375],[39394,65510],[189000,65536]],
  "jis0208":[12288,12289,12290,65292,65294,12539,65306,65307,65311,65281,12443,12444,180,65344,168,65342,65507,65343,12541,12542,12445,12446,12291,20189,12293,12294,12295,12540,8213,8208,65295,65340,65374,8741,65372,8230,8229,8216,8217,8220,8221,65288,65289,12308,12309,65339,65341,65371,65373,12296,12297,12298,12299,12300,12301,12302,12303,12304,12305,65291,65293,177,215,247,65309,8800,65308,65310,8806,8807,8734,8756,9794,9792,176,8242,8243,8451,65509,65284,65504,65505,65285,65283,65286,65290,65312,167,9734,9733,9675,9679,9678,9671,9670,9633,9632,9651,9650,9661,9660,8251,12306,8594,8592,8593,8595,12307,null,null,null,null,null,null,null,null,null,null,null,8712,8715,8838,8839,8834,8835,8746,8745,null,null,null,null,null,null,null,null,8743,8744,65506,8658,8660,8704,8707,null,null,null,null,null,null,null,null,null,null,null,8736,8869,8978,8706,8711,8801,8786,8810,8811,8730,8765,8733,8757,8747,8748,null,null,null,null,null,null,null,8491,8240,9839,9837,9834,8224,8225,182,null,null,null,null,9711,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,65296,65297,65298,65299,65300,65301,65302,65303,65304,65305,null,null,null,null,null,null,null,65313,65314,65315,65316,65317,65318,65319,65320,65321,65322,65323,65324,65325,65326,65327,65328,65329,65330,65331,65332,65333,65334,65335,65336,65337,65338,null,null,null,null,null,null,65345,65346,65347,65348,65349,65350,65351,65352,65353,65354,65355,65356,65357,65358,65359,65360,65361,65362,65363,65364,65365,65366,65367,65368,65369,65370,null,null,null,null,12353,12354,12355,12356,12357,12358,12359,12360,12361,12362,12363,12364,12365,12366,12367,12368,12369,12370,12371,12372,12373,12374,12375,12376,12377,12378,12379,12380,12381,12382,12383,12384,12385,12386,12387,12388,12389,12390,12391,12392,12393,12394,12395,12396,12397,12398,12399,12400,12401,12402,12403,12404,12405,12406,12407,12408,12409,12410,12411,12412,12413,12414,12415,12416,12417,12418,12419,12420,12421,12422,12423,12424,12425,12426,12427,12428,12429,12430,12431,12432,12433,12434,12435,null,null,null,null,null,null,null,null,null,null,null,12449,12450,12451,12452,12453,12454,12455,12456,12457,12458,12459,12460,12461,12462,12463,12464,12465,12466,12467,12468,12469,12470,12471,12472,12473,12474,12475,12476,12477,12478,12479,12480,12481,12482,12483,12484,12485,12486,12487,12488,12489,12490,12491,12492,12493,12494,12495,12496,12497,12498,12499,12500,12501,12502,12503,12504,12505,12506,12507,12508,12509,12510,12511,12512,12513,12514,12515,12516,12517,12518,12519,12520,12521,12522,12523,12524,12525,12526,12527,12528,12529,12530,12531,12532,12533,12534,null,null,null,null,null,null,null,null,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,null,null,null,null,null,null,null,null,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,963,964,965,966,967,968,969,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,1040,1041,1042,1043,1044,1045,1025,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,1072,1073,1074,1075,1076,1077,1105,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,null,null,null,null,null,null,null,null,null,null,null,null,null,9472,9474,9484,9488,9496,9492,9500,9516,9508,9524,9532,9473,9475,9487,9491,9499,9495,9507,9523,9515,9531,9547,9504,9519,9512,9527,9535,9501,9520,9509,9528,9538,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,9312,9313,9314,9315,9316,9317,9318,9319,9320,9321,9322,9323,9324,9325,9326,9327,9328,9329,9330,9331,8544,8545,8546,8547,8548,8549,8550,8551,8552,8553,null,13129,13076,13090,13133,13080,13095,13059,13110,13137,13143,13069,13094,13091,13099,13130,13115,13212,13213,13214,13198,13199,13252,13217,null,null,null,null,null,null,null,null,13179,12317,12319,8470,13261,8481,12964,12965,12966,12967,12968,12849,12850,12857,13182,13181,13180,8786,8801,8747,8750,8721,8730,8869,8736,8735,8895,8757,8745,8746,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,20124,21782,23043,38463,21696,24859,25384,23030,36898,33909,33564,31312,24746,25569,28197,26093,33894,33446,39925,26771,22311,26017,25201,23451,22992,34427,39156,32098,32190,39822,25110,31903,34999,23433,24245,25353,26263,26696,38343,38797,26447,20197,20234,20301,20381,20553,22258,22839,22996,23041,23561,24799,24847,24944,26131,26885,28858,30031,30064,31227,32173,32239,32963,33806,34915,35586,36949,36986,21307,20117,20133,22495,32946,37057,30959,19968,22769,28322,36920,31282,33576,33419,39983,20801,21360,21693,21729,22240,23035,24341,39154,28139,32996,34093,38498,38512,38560,38907,21515,21491,23431,28879,32701,36802,38632,21359,40284,31418,19985,30867,33276,28198,22040,21764,27421,34074,39995,23013,21417,28006,29916,38287,22082,20113,36939,38642,33615,39180,21473,21942,23344,24433,26144,26355,26628,27704,27891,27945,29787,30408,31310,38964,33521,34907,35424,37613,28082,30123,30410,39365,24742,35585,36234,38322,27022,21421,20870,22290,22576,22852,23476,24310,24616,25513,25588,27839,28436,28814,28948,29017,29141,29503,32257,33398,33489,34199,36960,37467,40219,22633,26044,27738,29989,20985,22830,22885,24448,24540,25276,26106,27178,27431,27572,29579,32705,35158,40236,40206,40644,23713,27798,33659,20740,23627,25014,33222,26742,29281,20057,20474,21368,24681,28201,31311,38899,19979,21270,20206,20309,20285,20385,20339,21152,21487,22025,22799,23233,23478,23521,31185,26247,26524,26550,27468,27827,28779,29634,31117,31166,31292,31623,33457,33499,33540,33655,33775,33747,34662,35506,22057,36008,36838,36942,38686,34442,20420,23784,25105,29273,30011,33253,33469,34558,36032,38597,39187,39381,20171,20250,35299,22238,22602,22730,24315,24555,24618,24724,24674,25040,25106,25296,25913,39745,26214,26800,28023,28784,30028,30342,32117,33445,34809,38283,38542,35997,20977,21182,22806,21683,23475,23830,24936,27010,28079,30861,33995,34903,35442,37799,39608,28012,39336,34521,22435,26623,34510,37390,21123,22151,21508,24275,25313,25785,26684,26680,27579,29554,30906,31339,35226,35282,36203,36611,37101,38307,38548,38761,23398,23731,27005,38989,38990,25499,31520,27179,27263,26806,39949,28511,21106,21917,24688,25324,27963,28167,28369,33883,35088,36676,19988,39993,21494,26907,27194,38788,26666,20828,31427,33970,37340,37772,22107,40232,26658,33541,33841,31909,21000,33477,29926,20094,20355,20896,23506,21002,21208,21223,24059,21914,22570,23014,23436,23448,23515,24178,24185,24739,24863,24931,25022,25563,25954,26577,26707,26874,27454,27475,27735,28450,28567,28485,29872,29976,30435,30475,31487,31649,31777,32233,32566,32752,32925,33382,33694,35251,35532,36011,36996,37969,38291,38289,38306,38501,38867,39208,33304,20024,21547,23736,24012,29609,30284,30524,23721,32747,36107,38593,38929,38996,39000,20225,20238,21361,21916,22120,22522,22855,23305,23492,23696,24076,24190,24524,25582,26426,26071,26082,26399,26827,26820,27231,24112,27589,27671,27773,30079,31048,23395,31232,32000,24509,35215,35352,36020,36215,36556,36637,39138,39438,39740,20096,20605,20736,22931,23452,25135,25216,25836,27450,29344,30097,31047,32681,34811,35516,35696,25516,33738,38816,21513,21507,21931,26708,27224,35440,30759,26485,40653,21364,23458,33050,34384,36870,19992,20037,20167,20241,21450,21560,23470,24339,24613,25937,26429,27714,27762,27875,28792,29699,31350,31406,31496,32026,31998,32102,26087,29275,21435,23621,24040,25298,25312,25369,28192,34394,35377,36317,37624,28417,31142,39770,20136,20139,20140,20379,20384,20689,20807,31478,20849,20982,21332,21281,21375,21483,21932,22659,23777,24375,24394,24623,24656,24685,25375,25945,27211,27841,29378,29421,30703,33016,33029,33288,34126,37111,37857,38911,39255,39514,20208,20957,23597,26241,26989,23616,26354,26997,29577,26704,31873,20677,21220,22343,24062,37670,26020,27427,27453,29748,31105,31165,31563,32202,33465,33740,34943,35167,35641,36817,37329,21535,37504,20061,20534,21477,21306,29399,29590,30697,33510,36527,39366,39368,39378,20855,24858,34398,21936,31354,20598,23507,36935,38533,20018,27355,37351,23633,23624,25496,31391,27795,38772,36705,31402,29066,38536,31874,26647,32368,26705,37740,21234,21531,34219,35347,32676,36557,37089,21350,34952,31041,20418,20670,21009,20804,21843,22317,29674,22411,22865,24418,24452,24693,24950,24935,25001,25522,25658,25964,26223,26690,28179,30054,31293,31995,32076,32153,32331,32619,33550,33610,34509,35336,35427,35686,36605,38938,40335,33464,36814,39912,21127,25119,25731,28608,38553,26689,20625,27424,27770,28500,31348,32080,34880,35363,26376,20214,20537,20518,20581,20860,21048,21091,21927,22287,22533,23244,24314,25010,25080,25331,25458,26908,27177,29309,29356,29486,30740,30831,32121,30476,32937,35211,35609,36066,36562,36963,37749,38522,38997,39443,40568,20803,21407,21427,24187,24358,28187,28304,29572,29694,32067,33335,35328,35578,38480,20046,20491,21476,21628,22266,22993,23396,24049,24235,24359,25144,25925,26543,28246,29392,31946,34996,32929,32993,33776,34382,35463,36328,37431,38599,39015,40723,20116,20114,20237,21320,21577,21566,23087,24460,24481,24735,26791,27278,29786,30849,35486,35492,35703,37264,20062,39881,20132,20348,20399,20505,20502,20809,20844,21151,21177,21246,21402,21475,21521,21518,21897,22353,22434,22909,23380,23389,23439,24037,24039,24055,24184,24195,24218,24247,24344,24658,24908,25239,25304,25511,25915,26114,26179,26356,26477,26657,26775,27083,27743,27946,28009,28207,28317,30002,30343,30828,31295,31968,32005,32024,32094,32177,32789,32771,32943,32945,33108,33167,33322,33618,34892,34913,35611,36002,36092,37066,37237,37489,30783,37628,38308,38477,38917,39321,39640,40251,21083,21163,21495,21512,22741,25335,28640,35946,36703,40633,20811,21051,21578,22269,31296,37239,40288,40658,29508,28425,33136,29969,24573,24794,39592,29403,36796,27492,38915,20170,22256,22372,22718,23130,24680,25031,26127,26118,26681,26801,28151,30165,32058,33390,39746,20123,20304,21449,21766,23919,24038,24046,26619,27801,29811,30722,35408,37782,35039,22352,24231,25387,20661,20652,20877,26368,21705,22622,22971,23472,24425,25165,25505,26685,27507,28168,28797,37319,29312,30741,30758,31085,25998,32048,33756,35009,36617,38555,21092,22312,26448,32618,36001,20916,22338,38442,22586,27018,32948,21682,23822,22524,30869,40442,20316,21066,21643,25662,26152,26388,26613,31364,31574,32034,37679,26716,39853,31545,21273,20874,21047,23519,25334,25774,25830,26413,27578,34217,38609,30352,39894,25420,37638,39851,30399,26194,19977,20632,21442,23665,24808,25746,25955,26719,29158,29642,29987,31639,32386,34453,35715,36059,37240,39184,26028,26283,27531,20181,20180,20282,20351,21050,21496,21490,21987,22235,22763,22987,22985,23039,23376,23629,24066,24107,24535,24605,25351,25903,23388,26031,26045,26088,26525,27490,27515,27663,29509,31049,31169,31992,32025,32043,32930,33026,33267,35222,35422,35433,35430,35468,35566,36039,36060,38604,39164,27503,20107,20284,20365,20816,23383,23546,24904,25345,26178,27425,28363,27835,29246,29885,30164,30913,31034,32780,32819,33258,33940,36766,27728,40575,24335,35672,40235,31482,36600,23437,38635,19971,21489,22519,22833,23241,23460,24713,28287,28422,30142,36074,23455,34048,31712,20594,26612,33437,23649,34122,32286,33294,20889,23556,25448,36198,26012,29038,31038,32023,32773,35613,36554,36974,34503,37034,20511,21242,23610,26451,28796,29237,37196,37320,37675,33509,23490,24369,24825,20027,21462,23432,25163,26417,27530,29417,29664,31278,33131,36259,37202,39318,20754,21463,21610,23551,25480,27193,32172,38656,22234,21454,21608,23447,23601,24030,20462,24833,25342,27954,31168,31179,32066,32333,32722,33261,33311,33936,34886,35186,35728,36468,36655,36913,37195,37228,38598,37276,20160,20303,20805,21313,24467,25102,26580,27713,28171,29539,32294,37325,37507,21460,22809,23487,28113,31069,32302,31899,22654,29087,20986,34899,36848,20426,23803,26149,30636,31459,33308,39423,20934,24490,26092,26991,27529,28147,28310,28516,30462,32020,24033,36981,37255,38918,20966,21021,25152,26257,26329,28186,24246,32210,32626,26360,34223,34295,35576,21161,21465,22899,24207,24464,24661,37604,38500,20663,20767,21213,21280,21319,21484,21736,21830,21809,22039,22888,22974,23100,23477,23558,23567,23569,23578,24196,24202,24288,24432,25215,25220,25307,25484,25463,26119,26124,26157,26230,26494,26786,27167,27189,27836,28040,28169,28248,28988,28966,29031,30151,30465,30813,30977,31077,31216,31456,31505,31911,32057,32918,33750,33931,34121,34909,35059,35359,35388,35412,35443,35937,36062,37284,37478,37758,37912,38556,38808,19978,19976,19998,20055,20887,21104,22478,22580,22732,23330,24120,24773,25854,26465,26454,27972,29366,30067,31331,33976,35698,37304,37664,22065,22516,39166,25325,26893,27542,29165,32340,32887,33394,35302,39135,34645,36785,23611,20280,20449,20405,21767,23072,23517,23529,24515,24910,25391,26032,26187,26862,27035,28024,28145,30003,30137,30495,31070,31206,32051,33251,33455,34218,35242,35386,36523,36763,36914,37341,38663,20154,20161,20995,22645,22764,23563,29978,23613,33102,35338,36805,38499,38765,31525,35535,38920,37218,22259,21416,36887,21561,22402,24101,25512,27700,28810,30561,31883,32736,34928,36930,37204,37648,37656,38543,29790,39620,23815,23913,25968,26530,36264,38619,25454,26441,26905,33733,38935,38592,35070,28548,25722,23544,19990,28716,30045,26159,20932,21046,21218,22995,24449,24615,25104,25919,25972,26143,26228,26866,26646,27491,28165,29298,29983,30427,31934,32854,22768,35069,35199,35488,35475,35531,36893,37266,38738,38745,25993,31246,33030,38587,24109,24796,25114,26021,26132,26512,30707,31309,31821,32318,33034,36012,36196,36321,36447,30889,20999,25305,25509,25666,25240,35373,31363,31680,35500,38634,32118,33292,34633,20185,20808,21315,21344,23459,23554,23574,24029,25126,25159,25776,26643,26676,27849,27973,27927,26579,28508,29006,29053,26059,31359,31661,32218,32330,32680,33146,33307,33337,34214,35438,36046,36341,36984,36983,37549,37521,38275,39854,21069,21892,28472,28982,20840,31109,32341,33203,31950,22092,22609,23720,25514,26366,26365,26970,29401,30095,30094,30990,31062,31199,31895,32032,32068,34311,35380,38459,36961,40736,20711,21109,21452,21474,20489,21930,22766,22863,29245,23435,23652,21277,24803,24819,25436,25475,25407,25531,25805,26089,26361,24035,27085,27133,28437,29157,20105,30185,30456,31379,31967,32207,32156,32865,33609,33624,33900,33980,34299,35013,36208,36865,36973,37783,38684,39442,20687,22679,24974,33235,34101,36104,36896,20419,20596,21063,21363,24687,25417,26463,28204,36275,36895,20439,23646,36042,26063,32154,21330,34966,20854,25539,23384,23403,23562,25613,26449,36956,20182,22810,22826,27760,35409,21822,22549,22949,24816,25171,26561,33333,26965,38464,39364,39464,20307,22534,23550,32784,23729,24111,24453,24608,24907,25140,26367,27888,28382,32974,33151,33492,34955,36024,36864,36910,38538,40667,39899,20195,21488,22823,31532,37261,38988,40441,28381,28711,21331,21828,23429,25176,25246,25299,27810,28655,29730,35351,37944,28609,35582,33592,20967,34552,21482,21481,20294,36948,36784,22890,33073,24061,31466,36799,26842,35895,29432,40008,27197,35504,20025,21336,22022,22374,25285,25506,26086,27470,28129,28251,28845,30701,31471,31658,32187,32829,32966,34507,35477,37723,22243,22727,24382,26029,26262,27264,27573,30007,35527,20516,30693,22320,24347,24677,26234,27744,30196,31258,32622,33268,34584,36933,39347,31689,30044,31481,31569,33988,36880,31209,31378,33590,23265,30528,20013,20210,23449,24544,25277,26172,26609,27880,34411,34935,35387,37198,37619,39376,27159,28710,29482,33511,33879,36015,19969,20806,20939,21899,23541,24086,24115,24193,24340,24373,24427,24500,25074,25361,26274,26397,28526,29266,30010,30522,32884,33081,33144,34678,35519,35548,36229,36339,37530,38263,38914,40165,21189,25431,30452,26389,27784,29645,36035,37806,38515,27941,22684,26894,27084,36861,37786,30171,36890,22618,26626,25524,27131,20291,28460,26584,36795,34086,32180,37716,26943,28528,22378,22775,23340,32044,29226,21514,37347,40372,20141,20302,20572,20597,21059,35998,21576,22564,23450,24093,24213,24237,24311,24351,24716,25269,25402,25552,26799,27712,30855,31118,31243,32224,33351,35330,35558,36420,36883,37048,37165,37336,40718,27877,25688,25826,25973,28404,30340,31515,36969,37841,28346,21746,24505,25764,36685,36845,37444,20856,22635,22825,23637,24215,28155,32399,29980,36028,36578,39003,28857,20253,27583,28593,30000,38651,20814,21520,22581,22615,22956,23648,24466,26007,26460,28193,30331,33759,36077,36884,37117,37709,30757,30778,21162,24230,22303,22900,24594,20498,20826,20908,20941,20992,21776,22612,22616,22871,23445,23798,23947,24764,25237,25645,26481,26691,26812,26847,30423,28120,28271,28059,28783,29128,24403,30168,31095,31561,31572,31570,31958,32113,21040,33891,34153,34276,35342,35588,35910,36367,36867,36879,37913,38518,38957,39472,38360,20685,21205,21516,22530,23566,24999,25758,27934,30643,31461,33012,33796,36947,37509,23776,40199,21311,24471,24499,28060,29305,30563,31167,31716,27602,29420,35501,26627,27233,20984,31361,26932,23626,40182,33515,23493,37193,28702,22136,23663,24775,25958,27788,35930,36929,38931,21585,26311,37389,22856,37027,20869,20045,20970,34201,35598,28760,25466,37707,26978,39348,32260,30071,21335,26976,36575,38627,27741,20108,23612,24336,36841,21250,36049,32905,34425,24319,26085,20083,20837,22914,23615,38894,20219,22922,24525,35469,28641,31152,31074,23527,33905,29483,29105,24180,24565,25467,25754,29123,31896,20035,24316,20043,22492,22178,24745,28611,32013,33021,33075,33215,36786,35223,34468,24052,25226,25773,35207,26487,27874,27966,29750,30772,23110,32629,33453,39340,20467,24259,25309,25490,25943,26479,30403,29260,32972,32954,36649,37197,20493,22521,23186,26757,26995,29028,29437,36023,22770,36064,38506,36889,34687,31204,30695,33833,20271,21093,21338,25293,26575,27850,30333,31636,31893,33334,34180,36843,26333,28448,29190,32283,33707,39361,40614,20989,31665,30834,31672,32903,31560,27368,24161,32908,30033,30048,20843,37474,28300,30330,37271,39658,20240,32624,25244,31567,38309,40169,22138,22617,34532,38588,20276,21028,21322,21453,21467,24070,25644,26001,26495,27710,27726,29256,29359,29677,30036,32321,33324,34281,36009,31684,37318,29033,38930,39151,25405,26217,30058,30436,30928,34115,34542,21290,21329,21542,22915,24199,24444,24754,25161,25209,25259,26000,27604,27852,30130,30382,30865,31192,32203,32631,32933,34987,35513,36027,36991,38750,39131,27147,31800,20633,23614,24494,26503,27608,29749,30473,32654,40763,26570,31255,21305,30091,39661,24422,33181,33777,32920,24380,24517,30050,31558,36924,26727,23019,23195,32016,30334,35628,20469,24426,27161,27703,28418,29922,31080,34920,35413,35961,24287,25551,30149,31186,33495,37672,37618,33948,34541,39981,21697,24428,25996,27996,28693,36007,36051,38971,25935,29942,19981,20184,22496,22827,23142,23500,20904,24067,24220,24598,25206,25975,26023,26222,28014,29238,31526,33104,33178,33433,35676,36000,36070,36212,38428,38468,20398,25771,27494,33310,33889,34154,37096,23553,26963,39080,33914,34135,20239,21103,24489,24133,26381,31119,33145,35079,35206,28149,24343,25173,27832,20175,29289,39826,20998,21563,22132,22707,24996,25198,28954,22894,31881,31966,32027,38640,25991,32862,19993,20341,20853,22592,24163,24179,24330,26564,20006,34109,38281,38491,31859,38913,20731,22721,30294,30887,21029,30629,34065,31622,20559,22793,29255,31687,32232,36794,36820,36941,20415,21193,23081,24321,38829,20445,33303,37610,22275,25429,27497,29995,35036,36628,31298,21215,22675,24917,25098,26286,27597,31807,33769,20515,20472,21253,21574,22577,22857,23453,23792,23791,23849,24214,25265,25447,25918,26041,26379,27861,27873,28921,30770,32299,32990,33459,33804,34028,34562,35090,35370,35914,37030,37586,39165,40179,40300,20047,20129,20621,21078,22346,22952,24125,24536,24537,25151,26292,26395,26576,26834,20882,32033,32938,33192,35584,35980,36031,37502,38450,21536,38956,21271,20693,21340,22696,25778,26420,29287,30566,31302,37350,21187,27809,27526,22528,24140,22868,26412,32763,20961,30406,25705,30952,39764,40635,22475,22969,26151,26522,27598,21737,27097,24149,33180,26517,39850,26622,40018,26717,20134,20451,21448,25273,26411,27819,36804,20397,32365,40639,19975,24930,28288,28459,34067,21619,26410,39749,24051,31637,23724,23494,34588,28234,34001,31252,33032,22937,31885,27665,30496,21209,22818,28961,29279,30683,38695,40289,26891,23167,23064,20901,21517,21629,26126,30431,36855,37528,40180,23018,29277,28357,20813,26825,32191,32236,38754,40634,25720,27169,33538,22916,23391,27611,29467,30450,32178,32791,33945,20786,26408,40665,30446,26466,21247,39173,23588,25147,31870,36016,21839,24758,32011,38272,21249,20063,20918,22812,29242,32822,37326,24357,30690,21380,24441,32004,34220,35379,36493,38742,26611,34222,37971,24841,24840,27833,30290,35565,36664,21807,20305,20778,21191,21451,23461,24189,24736,24962,25558,26377,26586,28263,28044,29494,29495,30001,31056,35029,35480,36938,37009,37109,38596,34701,22805,20104,20313,19982,35465,36671,38928,20653,24188,22934,23481,24248,25562,25594,25793,26332,26954,27096,27915,28342,29076,29992,31407,32650,32768,33865,33993,35201,35617,36362,36965,38525,39178,24958,25233,27442,27779,28020,32716,32764,28096,32645,34746,35064,26469,33713,38972,38647,27931,32097,33853,37226,20081,21365,23888,27396,28651,34253,34349,35239,21033,21519,23653,26446,26792,29702,29827,30178,35023,35041,37324,38626,38520,24459,29575,31435,33870,25504,30053,21129,27969,28316,29705,30041,30827,31890,38534,31452,40845,20406,24942,26053,34396,20102,20142,20698,20001,20940,23534,26009,26753,28092,29471,30274,30637,31260,31975,33391,35538,36988,37327,38517,38936,21147,32209,20523,21400,26519,28107,29136,29747,33256,36650,38563,40023,40607,29792,22593,28057,32047,39006,20196,20278,20363,20919,21169,23994,24604,29618,31036,33491,37428,38583,38646,38666,40599,40802,26278,27508,21015,21155,28872,35010,24265,24651,24976,28451,29001,31806,32244,32879,34030,36899,37676,21570,39791,27347,28809,36034,36335,38706,21172,23105,24266,24324,26391,27004,27028,28010,28431,29282,29436,31725,32769,32894,34635,37070,20845,40595,31108,32907,37682,35542,20525,21644,35441,27498,36036,33031,24785,26528,40434,20121,20120,39952,35435,34241,34152,26880,28286,30871,33109,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,24332,19984,19989,20010,20017,20022,20028,20031,20034,20054,20056,20098,20101,35947,20106,33298,24333,20110,20126,20127,20128,20130,20144,20147,20150,20174,20173,20164,20166,20162,20183,20190,20205,20191,20215,20233,20314,20272,20315,20317,20311,20295,20342,20360,20367,20376,20347,20329,20336,20369,20335,20358,20374,20760,20436,20447,20430,20440,20443,20433,20442,20432,20452,20453,20506,20520,20500,20522,20517,20485,20252,20470,20513,20521,20524,20478,20463,20497,20486,20547,20551,26371,20565,20560,20552,20570,20566,20588,20600,20608,20634,20613,20660,20658,20681,20682,20659,20674,20694,20702,20709,20717,20707,20718,20729,20725,20745,20737,20738,20758,20757,20756,20762,20769,20794,20791,20796,20795,20799,20800,20818,20812,20820,20834,31480,20841,20842,20846,20864,20866,22232,20876,20873,20879,20881,20883,20885,20886,20900,20902,20898,20905,20906,20907,20915,20913,20914,20912,20917,20925,20933,20937,20955,20960,34389,20969,20973,20976,20981,20990,20996,21003,21012,21006,21031,21034,21038,21043,21049,21071,21060,21067,21068,21086,21076,21098,21108,21097,21107,21119,21117,21133,21140,21138,21105,21128,21137,36776,36775,21164,21165,21180,21173,21185,21197,21207,21214,21219,21222,39149,21216,21235,21237,21240,21241,21254,21256,30008,21261,21264,21263,21269,21274,21283,21295,21297,21299,21304,21312,21318,21317,19991,21321,21325,20950,21342,21353,21358,22808,21371,21367,21378,21398,21408,21414,21413,21422,21424,21430,21443,31762,38617,21471,26364,29166,21486,21480,21485,21498,21505,21565,21568,21548,21549,21564,21550,21558,21545,21533,21582,21647,21621,21646,21599,21617,21623,21616,21650,21627,21632,21622,21636,21648,21638,21703,21666,21688,21669,21676,21700,21704,21672,21675,21698,21668,21694,21692,21720,21733,21734,21775,21780,21757,21742,21741,21754,21730,21817,21824,21859,21836,21806,21852,21829,21846,21847,21816,21811,21853,21913,21888,21679,21898,21919,21883,21886,21912,21918,21934,21884,21891,21929,21895,21928,21978,21957,21983,21956,21980,21988,21972,22036,22007,22038,22014,22013,22043,22009,22094,22096,29151,22068,22070,22066,22072,22123,22116,22063,22124,22122,22150,22144,22154,22176,22164,22159,22181,22190,22198,22196,22210,22204,22209,22211,22208,22216,22222,22225,22227,22231,22254,22265,22272,22271,22276,22281,22280,22283,22285,22291,22296,22294,21959,22300,22310,22327,22328,22350,22331,22336,22351,22377,22464,22408,22369,22399,22409,22419,22432,22451,22436,22442,22448,22467,22470,22484,22482,22483,22538,22486,22499,22539,22553,22557,22642,22561,22626,22603,22640,27584,22610,22589,22649,22661,22713,22687,22699,22714,22750,22715,22712,22702,22725,22739,22737,22743,22745,22744,22757,22748,22756,22751,22767,22778,22777,22779,22780,22781,22786,22794,22800,22811,26790,22821,22828,22829,22834,22840,22846,31442,22869,22864,22862,22874,22872,22882,22880,22887,22892,22889,22904,22913,22941,20318,20395,22947,22962,22982,23016,23004,22925,23001,23002,23077,23071,23057,23068,23049,23066,23104,23148,23113,23093,23094,23138,23146,23194,23228,23230,23243,23234,23229,23267,23255,23270,23273,23254,23290,23291,23308,23307,23318,23346,23248,23338,23350,23358,23363,23365,23360,23377,23381,23386,23387,23397,23401,23408,23411,23413,23416,25992,23418,23424,23427,23462,23480,23491,23495,23497,23508,23504,23524,23526,23522,23518,23525,23531,23536,23542,23539,23557,23559,23560,23565,23571,23584,23586,23592,23608,23609,23617,23622,23630,23635,23632,23631,23409,23660,23662,20066,23670,23673,23692,23697,23700,22939,23723,23739,23734,23740,23735,23749,23742,23751,23769,23785,23805,23802,23789,23948,23786,23819,23829,23831,23900,23839,23835,23825,23828,23842,23834,23833,23832,23884,23890,23886,23883,23916,23923,23926,23943,23940,23938,23970,23965,23980,23982,23997,23952,23991,23996,24009,24013,24019,24018,24022,24027,24043,24050,24053,24075,24090,24089,24081,24091,24118,24119,24132,24131,24128,24142,24151,24148,24159,24162,24164,24135,24181,24182,24186,40636,24191,24224,24257,24258,24264,24272,24271,24278,24291,24285,24282,24283,24290,24289,24296,24297,24300,24305,24307,24304,24308,24312,24318,24323,24329,24413,24412,24331,24337,24342,24361,24365,24376,24385,24392,24396,24398,24367,24401,24406,24407,24409,24417,24429,24435,24439,24451,24450,24447,24458,24456,24465,24455,24478,24473,24472,24480,24488,24493,24508,24534,24571,24548,24568,24561,24541,24755,24575,24609,24672,24601,24592,24617,24590,24625,24603,24597,24619,24614,24591,24634,24666,24641,24682,24695,24671,24650,24646,24653,24675,24643,24676,24642,24684,24683,24665,24705,24717,24807,24707,24730,24708,24731,24726,24727,24722,24743,24715,24801,24760,24800,24787,24756,24560,24765,24774,24757,24792,24909,24853,24838,24822,24823,24832,24820,24826,24835,24865,24827,24817,24845,24846,24903,24894,24872,24871,24906,24895,24892,24876,24884,24893,24898,24900,24947,24951,24920,24921,24922,24939,24948,24943,24933,24945,24927,24925,24915,24949,24985,24982,24967,25004,24980,24986,24970,24977,25003,25006,25036,25034,25033,25079,25032,25027,25030,25018,25035,32633,25037,25062,25059,25078,25082,25076,25087,25085,25084,25086,25088,25096,25097,25101,25100,25108,25115,25118,25121,25130,25134,25136,25138,25139,25153,25166,25182,25187,25179,25184,25192,25212,25218,25225,25214,25234,25235,25238,25300,25219,25236,25303,25297,25275,25295,25343,25286,25812,25288,25308,25292,25290,25282,25287,25243,25289,25356,25326,25329,25383,25346,25352,25327,25333,25424,25406,25421,25628,25423,25494,25486,25472,25515,25462,25507,25487,25481,25503,25525,25451,25449,25534,25577,25536,25542,25571,25545,25554,25590,25540,25622,25652,25606,25619,25638,25654,25885,25623,25640,25615,25703,25711,25718,25678,25898,25749,25747,25765,25769,25736,25788,25818,25810,25797,25799,25787,25816,25794,25841,25831,33289,25824,25825,25260,25827,25839,25900,25846,25844,25842,25850,25856,25853,25880,25884,25861,25892,25891,25899,25908,25909,25911,25910,25912,30027,25928,25942,25941,25933,25944,25950,25949,25970,25976,25986,25987,35722,26011,26015,26027,26039,26051,26054,26049,26052,26060,26066,26075,26073,26080,26081,26097,26482,26122,26115,26107,26483,26165,26166,26164,26140,26191,26180,26185,26177,26206,26205,26212,26215,26216,26207,26210,26224,26243,26248,26254,26249,26244,26264,26269,26305,26297,26313,26302,26300,26308,26296,26326,26330,26336,26175,26342,26345,26352,26357,26359,26383,26390,26398,26406,26407,38712,26414,26431,26422,26433,26424,26423,26438,26462,26464,26457,26467,26468,26505,26480,26537,26492,26474,26508,26507,26534,26529,26501,26551,26607,26548,26604,26547,26601,26552,26596,26590,26589,26594,26606,26553,26574,26566,26599,27292,26654,26694,26665,26688,26701,26674,26702,26803,26667,26713,26723,26743,26751,26783,26767,26797,26772,26781,26779,26755,27310,26809,26740,26805,26784,26810,26895,26765,26750,26881,26826,26888,26840,26914,26918,26849,26892,26829,26836,26855,26837,26934,26898,26884,26839,26851,26917,26873,26848,26863,26920,26922,26906,26915,26913,26822,27001,26999,26972,27000,26987,26964,27006,26990,26937,26996,26941,26969,26928,26977,26974,26973,27009,26986,27058,27054,27088,27071,27073,27091,27070,27086,23528,27082,27101,27067,27075,27047,27182,27025,27040,27036,27029,27060,27102,27112,27138,27163,27135,27402,27129,27122,27111,27141,27057,27166,27117,27156,27115,27146,27154,27329,27171,27155,27204,27148,27250,27190,27256,27207,27234,27225,27238,27208,27192,27170,27280,27277,27296,27268,27298,27299,27287,34327,27323,27331,27330,27320,27315,27308,27358,27345,27359,27306,27354,27370,27387,27397,34326,27386,27410,27414,39729,27423,27448,27447,30428,27449,39150,27463,27459,27465,27472,27481,27476,27483,27487,27489,27512,27513,27519,27520,27524,27523,27533,27544,27541,27550,27556,27562,27563,27567,27570,27569,27571,27575,27580,27590,27595,27603,27615,27628,27627,27635,27631,40638,27656,27667,27668,27675,27684,27683,27742,27733,27746,27754,27778,27789,27802,27777,27803,27774,27752,27763,27794,27792,27844,27889,27859,27837,27863,27845,27869,27822,27825,27838,27834,27867,27887,27865,27882,27935,34893,27958,27947,27965,27960,27929,27957,27955,27922,27916,28003,28051,28004,27994,28025,27993,28046,28053,28644,28037,28153,28181,28170,28085,28103,28134,28088,28102,28140,28126,28108,28136,28114,28101,28154,28121,28132,28117,28138,28142,28205,28270,28206,28185,28274,28255,28222,28195,28267,28203,28278,28237,28191,28227,28218,28238,28196,28415,28189,28216,28290,28330,28312,28361,28343,28371,28349,28335,28356,28338,28372,28373,28303,28325,28354,28319,28481,28433,28748,28396,28408,28414,28479,28402,28465,28399,28466,28364,28478,28435,28407,28550,28538,28536,28545,28544,28527,28507,28659,28525,28546,28540,28504,28558,28561,28610,28518,28595,28579,28577,28580,28601,28614,28586,28639,28629,28652,28628,28632,28657,28654,28635,28681,28683,28666,28689,28673,28687,28670,28699,28698,28532,28701,28696,28703,28720,28734,28722,28753,28771,28825,28818,28847,28913,28844,28856,28851,28846,28895,28875,28893,28889,28937,28925,28956,28953,29029,29013,29064,29030,29026,29004,29014,29036,29071,29179,29060,29077,29096,29100,29143,29113,29118,29138,29129,29140,29134,29152,29164,29159,29173,29180,29177,29183,29197,29200,29211,29224,29229,29228,29232,29234,29243,29244,29247,29248,29254,29259,29272,29300,29310,29314,29313,29319,29330,29334,29346,29351,29369,29362,29379,29382,29380,29390,29394,29410,29408,29409,29433,29431,20495,29463,29450,29468,29462,29469,29492,29487,29481,29477,29502,29518,29519,40664,29527,29546,29544,29552,29560,29557,29563,29562,29640,29619,29646,29627,29632,29669,29678,29662,29858,29701,29807,29733,29688,29746,29754,29781,29759,29791,29785,29761,29788,29801,29808,29795,29802,29814,29822,29835,29854,29863,29898,29903,29908,29681,29920,29923,29927,29929,29934,29938,29936,29937,29944,29943,29956,29955,29957,29964,29966,29965,29973,29971,29982,29990,29996,30012,30020,30029,30026,30025,30043,30022,30042,30057,30052,30055,30059,30061,30072,30070,30086,30087,30068,30090,30089,30082,30100,30106,30109,30117,30115,30146,30131,30147,30133,30141,30136,30140,30129,30157,30154,30162,30169,30179,30174,30206,30207,30204,30209,30192,30202,30194,30195,30219,30221,30217,30239,30247,30240,30241,30242,30244,30260,30256,30267,30279,30280,30278,30300,30296,30305,30306,30312,30313,30314,30311,30316,30320,30322,30326,30328,30332,30336,30339,30344,30347,30350,30358,30355,30361,30362,30384,30388,30392,30393,30394,30402,30413,30422,30418,30430,30433,30437,30439,30442,34351,30459,30472,30471,30468,30505,30500,30494,30501,30502,30491,30519,30520,30535,30554,30568,30571,30555,30565,30591,30590,30585,30606,30603,30609,30624,30622,30640,30646,30649,30655,30652,30653,30651,30663,30669,30679,30682,30684,30691,30702,30716,30732,30738,31014,30752,31018,30789,30862,30836,30854,30844,30874,30860,30883,30901,30890,30895,30929,30918,30923,30932,30910,30908,30917,30922,30956,30951,30938,30973,30964,30983,30994,30993,31001,31020,31019,31040,31072,31063,31071,31066,31061,31059,31098,31103,31114,31133,31143,40779,31146,31150,31155,31161,31162,31177,31189,31207,31212,31201,31203,31240,31245,31256,31257,31264,31263,31104,31281,31291,31294,31287,31299,31319,31305,31329,31330,31337,40861,31344,31353,31357,31368,31383,31381,31384,31382,31401,31432,31408,31414,31429,31428,31423,36995,31431,31434,31437,31439,31445,31443,31449,31450,31453,31457,31458,31462,31469,31472,31490,31503,31498,31494,31539,31512,31513,31518,31541,31528,31542,31568,31610,31492,31565,31499,31564,31557,31605,31589,31604,31591,31600,31601,31596,31598,31645,31640,31647,31629,31644,31642,31627,31634,31631,31581,31641,31691,31681,31692,31695,31668,31686,31709,31721,31761,31764,31718,31717,31840,31744,31751,31763,31731,31735,31767,31757,31734,31779,31783,31786,31775,31799,31787,31805,31820,31811,31828,31823,31808,31824,31832,31839,31844,31830,31845,31852,31861,31875,31888,31908,31917,31906,31915,31905,31912,31923,31922,31921,31918,31929,31933,31936,31941,31938,31960,31954,31964,31970,39739,31983,31986,31988,31990,31994,32006,32002,32028,32021,32010,32069,32075,32046,32050,32063,32053,32070,32115,32086,32078,32114,32104,32110,32079,32099,32147,32137,32091,32143,32125,32155,32186,32174,32163,32181,32199,32189,32171,32317,32162,32175,32220,32184,32159,32176,32216,32221,32228,32222,32251,32242,32225,32261,32266,32291,32289,32274,32305,32287,32265,32267,32290,32326,32358,32315,32309,32313,32323,32311,32306,32314,32359,32349,32342,32350,32345,32346,32377,32362,32361,32380,32379,32387,32213,32381,36782,32383,32392,32393,32396,32402,32400,32403,32404,32406,32398,32411,32412,32568,32570,32581,32588,32589,32590,32592,32593,32597,32596,32600,32607,32608,32616,32617,32615,32632,32642,32646,32643,32648,32647,32652,32660,32670,32669,32666,32675,32687,32690,32697,32686,32694,32696,35697,32709,32710,32714,32725,32724,32737,32742,32745,32755,32761,39132,32774,32772,32779,32786,32792,32793,32796,32801,32808,32831,32827,32842,32838,32850,32856,32858,32863,32866,32872,32883,32882,32880,32886,32889,32893,32895,32900,32902,32901,32923,32915,32922,32941,20880,32940,32987,32997,32985,32989,32964,32986,32982,33033,33007,33009,33051,33065,33059,33071,33099,38539,33094,33086,33107,33105,33020,33137,33134,33125,33126,33140,33155,33160,33162,33152,33154,33184,33173,33188,33187,33119,33171,33193,33200,33205,33214,33208,33213,33216,33218,33210,33225,33229,33233,33241,33240,33224,33242,33247,33248,33255,33274,33275,33278,33281,33282,33285,33287,33290,33293,33296,33302,33321,33323,33336,33331,33344,33369,33368,33373,33370,33375,33380,33378,33384,33386,33387,33326,33393,33399,33400,33406,33421,33426,33451,33439,33467,33452,33505,33507,33503,33490,33524,33523,33530,33683,33539,33531,33529,33502,33542,33500,33545,33497,33589,33588,33558,33586,33585,33600,33593,33616,33605,33583,33579,33559,33560,33669,33690,33706,33695,33698,33686,33571,33678,33671,33674,33660,33717,33651,33653,33696,33673,33704,33780,33811,33771,33742,33789,33795,33752,33803,33729,33783,33799,33760,33778,33805,33826,33824,33725,33848,34054,33787,33901,33834,33852,34138,33924,33911,33899,33965,33902,33922,33897,33862,33836,33903,33913,33845,33994,33890,33977,33983,33951,34009,33997,33979,34010,34000,33985,33990,34006,33953,34081,34047,34036,34071,34072,34092,34079,34069,34068,34044,34112,34147,34136,34120,34113,34306,34123,34133,34176,34212,34184,34193,34186,34216,34157,34196,34203,34282,34183,34204,34167,34174,34192,34249,34234,34255,34233,34256,34261,34269,34277,34268,34297,34314,34323,34315,34302,34298,34310,34338,34330,34352,34367,34381,20053,34388,34399,34407,34417,34451,34467,34473,34474,34443,34444,34486,34479,34500,34502,34480,34505,34851,34475,34516,34526,34537,34540,34527,34523,34543,34578,34566,34568,34560,34563,34555,34577,34569,34573,34553,34570,34612,34623,34615,34619,34597,34601,34586,34656,34655,34680,34636,34638,34676,34647,34664,34670,34649,34643,34659,34666,34821,34722,34719,34690,34735,34763,34749,34752,34768,38614,34731,34756,34739,34759,34758,34747,34799,34802,34784,34831,34829,34814,34806,34807,34830,34770,34833,34838,34837,34850,34849,34865,34870,34873,34855,34875,34884,34882,34898,34905,34910,34914,34923,34945,34942,34974,34933,34941,34997,34930,34946,34967,34962,34990,34969,34978,34957,34980,34992,35007,34993,35011,35012,35028,35032,35033,35037,35065,35074,35068,35060,35048,35058,35076,35084,35082,35091,35139,35102,35109,35114,35115,35137,35140,35131,35126,35128,35148,35101,35168,35166,35174,35172,35181,35178,35183,35188,35191,35198,35203,35208,35210,35219,35224,35233,35241,35238,35244,35247,35250,35258,35261,35263,35264,35290,35292,35293,35303,35316,35320,35331,35350,35344,35340,35355,35357,35365,35382,35393,35419,35410,35398,35400,35452,35437,35436,35426,35461,35458,35460,35496,35489,35473,35493,35494,35482,35491,35524,35533,35522,35546,35563,35571,35559,35556,35569,35604,35552,35554,35575,35550,35547,35596,35591,35610,35553,35606,35600,35607,35616,35635,38827,35622,35627,35646,35624,35649,35660,35663,35662,35657,35670,35675,35674,35691,35679,35692,35695,35700,35709,35712,35724,35726,35730,35731,35734,35737,35738,35898,35905,35903,35912,35916,35918,35920,35925,35938,35948,35960,35962,35970,35977,35973,35978,35981,35982,35988,35964,35992,25117,36013,36010,36029,36018,36019,36014,36022,36040,36033,36068,36067,36058,36093,36090,36091,36100,36101,36106,36103,36111,36109,36112,40782,36115,36045,36116,36118,36199,36205,36209,36211,36225,36249,36290,36286,36282,36303,36314,36310,36300,36315,36299,36330,36331,36319,36323,36348,36360,36361,36351,36381,36382,36368,36383,36418,36405,36400,36404,36426,36423,36425,36428,36432,36424,36441,36452,36448,36394,36451,36437,36470,36466,36476,36481,36487,36485,36484,36491,36490,36499,36497,36500,36505,36522,36513,36524,36528,36550,36529,36542,36549,36552,36555,36571,36579,36604,36603,36587,36606,36618,36613,36629,36626,36633,36627,36636,36639,36635,36620,36646,36659,36667,36665,36677,36674,36670,36684,36681,36678,36686,36695,36700,36706,36707,36708,36764,36767,36771,36781,36783,36791,36826,36837,36834,36842,36847,36999,36852,36869,36857,36858,36881,36885,36897,36877,36894,36886,36875,36903,36918,36917,36921,36856,36943,36944,36945,36946,36878,36937,36926,36950,36952,36958,36968,36975,36982,38568,36978,36994,36989,36993,36992,37002,37001,37007,37032,37039,37041,37045,37090,37092,25160,37083,37122,37138,37145,37170,37168,37194,37206,37208,37219,37221,37225,37235,37234,37259,37257,37250,37282,37291,37295,37290,37301,37300,37306,37312,37313,37321,37323,37328,37334,37343,37345,37339,37372,37365,37366,37406,37375,37396,37420,37397,37393,37470,37463,37445,37449,37476,37448,37525,37439,37451,37456,37532,37526,37523,37531,37466,37583,37561,37559,37609,37647,37626,37700,37678,37657,37666,37658,37667,37690,37685,37691,37724,37728,37756,37742,37718,37808,37804,37805,37780,37817,37846,37847,37864,37861,37848,37827,37853,37840,37832,37860,37914,37908,37907,37891,37895,37904,37942,37931,37941,37921,37946,37953,37970,37956,37979,37984,37986,37982,37994,37417,38000,38005,38007,38013,37978,38012,38014,38017,38015,38274,38279,38282,38292,38294,38296,38297,38304,38312,38311,38317,38332,38331,38329,38334,38346,28662,38339,38349,38348,38357,38356,38358,38364,38369,38373,38370,38433,38440,38446,38447,38466,38476,38479,38475,38519,38492,38494,38493,38495,38502,38514,38508,38541,38552,38549,38551,38570,38567,38577,38578,38576,38580,38582,38584,38585,38606,38603,38601,38605,35149,38620,38669,38613,38649,38660,38662,38664,38675,38670,38673,38671,38678,38681,38692,38698,38704,38713,38717,38718,38724,38726,38728,38722,38729,38748,38752,38756,38758,38760,21202,38763,38769,38777,38789,38780,38785,38778,38790,38795,38799,38800,38812,38824,38822,38819,38835,38836,38851,38854,38856,38859,38876,38893,40783,38898,31455,38902,38901,38927,38924,38968,38948,38945,38967,38973,38982,38991,38987,39019,39023,39024,39025,39028,39027,39082,39087,39089,39094,39108,39107,39110,39145,39147,39171,39177,39186,39188,39192,39201,39197,39198,39204,39200,39212,39214,39229,39230,39234,39241,39237,39248,39243,39249,39250,39244,39253,39319,39320,39333,39341,39342,39356,39391,39387,39389,39384,39377,39405,39406,39409,39410,39419,39416,39425,39439,39429,39394,39449,39467,39479,39493,39490,39488,39491,39486,39509,39501,39515,39511,39519,39522,39525,39524,39529,39531,39530,39597,39600,39612,39616,39631,39633,39635,39636,39646,39647,39650,39651,39654,39663,39659,39662,39668,39665,39671,39675,39686,39704,39706,39711,39714,39715,39717,39719,39720,39721,39722,39726,39727,39730,39748,39747,39759,39757,39758,39761,39768,39796,39827,39811,39825,39830,39831,39839,39840,39848,39860,39872,39882,39865,39878,39887,39889,39890,39907,39906,39908,39892,39905,39994,39922,39921,39920,39957,39956,39945,39955,39948,39942,39944,39954,39946,39940,39982,39963,39973,39972,39969,39984,40007,39986,40006,39998,40026,40032,40039,40054,40056,40167,40172,40176,40201,40200,40171,40195,40198,40234,40230,40367,40227,40223,40260,40213,40210,40257,40255,40254,40262,40264,40285,40286,40292,40273,40272,40281,40306,40329,40327,40363,40303,40314,40346,40356,40361,40370,40388,40385,40379,40376,40378,40390,40399,40386,40409,40403,40440,40422,40429,40431,40445,40474,40475,40478,40565,40569,40573,40577,40584,40587,40588,40594,40597,40593,40605,40613,40617,40632,40618,40621,38753,40652,40654,40655,40656,40660,40668,40670,40669,40672,40677,40680,40687,40692,40694,40695,40697,40699,40700,40701,40711,40712,30391,40725,40737,40748,40766,40778,40786,40788,40803,40799,40800,40801,40806,40807,40812,40810,40823,40818,40822,40853,40860,40864,22575,27079,36953,29796,20956,29081,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,32394,35100,37704,37512,34012,20425,28859,26161,26824,37625,26363,24389,20008,20193,20220,20224,20227,20281,20310,20370,20362,20378,20372,20429,20544,20514,20479,20510,20550,20592,20546,20628,20724,20696,20810,20836,20893,20926,20972,21013,21148,21158,21184,21211,21248,21255,21284,21362,21395,21426,21469,64014,21660,21642,21673,21759,21894,22361,22373,22444,22472,22471,64015,64016,22686,22706,22795,22867,22875,22877,22883,22948,22970,23382,23488,29999,23512,23532,23582,23718,23738,23797,23847,23891,64017,23874,23917,23992,23993,24016,24353,24372,24423,24503,24542,24669,24709,24714,24798,24789,24864,24818,24849,24887,24880,24984,25107,25254,25589,25696,25757,25806,25934,26112,26133,26171,26121,26158,26142,26148,26213,26199,26201,64018,26227,26265,26272,26290,26303,26362,26382,63785,26470,26555,26706,26560,26625,26692,26831,64019,26984,64020,27032,27106,27184,27243,27206,27251,27262,27362,27364,27606,27711,27740,27782,27759,27866,27908,28039,28015,28054,28076,28111,28152,28146,28156,28217,28252,28199,28220,28351,28552,28597,28661,28677,28679,28712,28805,28843,28943,28932,29020,28998,28999,64021,29121,29182,29361,29374,29476,64022,29559,29629,29641,29654,29667,29650,29703,29685,29734,29738,29737,29742,29794,29833,29855,29953,30063,30338,30364,30366,30363,30374,64023,30534,21167,30753,30798,30820,30842,31024,64024,64025,64026,31124,64027,31131,31441,31463,64028,31467,31646,64029,32072,32092,32183,32160,32214,32338,32583,32673,64030,33537,33634,33663,33735,33782,33864,33972,34131,34137,34155,64031,34224,64032,64033,34823,35061,35346,35383,35449,35495,35518,35551,64034,35574,35667,35711,36080,36084,36114,36214,64035,36559,64036,64037,36967,37086,64038,37141,37159,37338,37335,37342,37357,37358,37348,37349,37382,37392,37386,37434,37440,37436,37454,37465,37457,37433,37479,37543,37495,37496,37607,37591,37593,37584,64039,37589,37600,37587,37669,37665,37627,64040,37662,37631,37661,37634,37744,37719,37796,37830,37854,37880,37937,37957,37960,38290,63964,64041,38557,38575,38707,38715,38723,38733,38735,38737,38741,38999,39013,64042,64043,39207,64044,39326,39502,39641,39644,39797,39794,39823,39857,39867,39936,40304,40299,64045,40473,40657,null,null,8560,8561,8562,8563,8564,8565,8566,8567,8568,8569,65506,65508,65287,65282,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,8560,8561,8562,8563,8564,8565,8566,8567,8568,8569,8544,8545,8546,8547,8548,8549,8550,8551,8552,8553,65506,65508,65287,65282,12849,8470,8481,8757,32394,35100,37704,37512,34012,20425,28859,26161,26824,37625,26363,24389,20008,20193,20220,20224,20227,20281,20310,20370,20362,20378,20372,20429,20544,20514,20479,20510,20550,20592,20546,20628,20724,20696,20810,20836,20893,20926,20972,21013,21148,21158,21184,21211,21248,21255,21284,21362,21395,21426,21469,64014,21660,21642,21673,21759,21894,22361,22373,22444,22472,22471,64015,64016,22686,22706,22795,22867,22875,22877,22883,22948,22970,23382,23488,29999,23512,23532,23582,23718,23738,23797,23847,23891,64017,23874,23917,23992,23993,24016,24353,24372,24423,24503,24542,24669,24709,24714,24798,24789,24864,24818,24849,24887,24880,24984,25107,25254,25589,25696,25757,25806,25934,26112,26133,26171,26121,26158,26142,26148,26213,26199,26201,64018,26227,26265,26272,26290,26303,26362,26382,63785,26470,26555,26706,26560,26625,26692,26831,64019,26984,64020,27032,27106,27184,27243,27206,27251,27262,27362,27364,27606,27711,27740,27782,27759,27866,27908,28039,28015,28054,28076,28111,28152,28146,28156,28217,28252,28199,28220,28351,28552,28597,28661,28677,28679,28712,28805,28843,28943,28932,29020,28998,28999,64021,29121,29182,29361,29374,29476,64022,29559,29629,29641,29654,29667,29650,29703,29685,29734,29738,29737,29742,29794,29833,29855,29953,30063,30338,30364,30366,30363,30374,64023,30534,21167,30753,30798,30820,30842,31024,64024,64025,64026,31124,64027,31131,31441,31463,64028,31467,31646,64029,32072,32092,32183,32160,32214,32338,32583,32673,64030,33537,33634,33663,33735,33782,33864,33972,34131,34137,34155,64031,34224,64032,64033,34823,35061,35346,35383,35449,35495,35518,35551,64034,35574,35667,35711,36080,36084,36114,36214,64035,36559,64036,64037,36967,37086,64038,37141,37159,37338,37335,37342,37357,37358,37348,37349,37382,37392,37386,37434,37440,37436,37454,37465,37457,37433,37479,37543,37495,37496,37607,37591,37593,37584,64039,37589,37600,37587,37669,37665,37627,64040,37662,37631,37661,37634,37744,37719,37796,37830,37854,37880,37937,37957,37960,38290,63964,64041,38557,38575,38707,38715,38723,38733,38735,38737,38741,38999,39013,64042,64043,39207,64044,39326,39502,39641,39644,39797,39794,39823,39857,39867,39936,40304,40299,64045,40473,40657,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],
  "jis0212":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,728,711,184,729,733,175,731,730,65374,900,901,null,null,null,null,null,null,null,null,161,166,191,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,186,170,169,174,8482,164,8470,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,902,904,905,906,938,null,908,null,910,939,null,911,null,null,null,null,940,941,942,943,970,912,972,962,973,971,944,974,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036,1038,1039,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1118,1119,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,198,272,null,294,null,306,null,321,319,null,330,216,338,null,358,222,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,230,273,240,295,305,307,312,322,320,329,331,248,339,223,359,254,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,193,192,196,194,258,461,256,260,197,195,262,264,268,199,266,270,201,200,203,202,282,278,274,280,null,284,286,290,288,292,205,204,207,206,463,304,298,302,296,308,310,313,317,315,323,327,325,209,211,210,214,212,465,336,332,213,340,344,342,346,348,352,350,356,354,218,217,220,219,364,467,368,362,370,366,360,471,475,473,469,372,221,376,374,377,381,379,null,null,null,null,null,null,null,225,224,228,226,259,462,257,261,229,227,263,265,269,231,267,271,233,232,235,234,283,279,275,281,501,285,287,null,289,293,237,236,239,238,464,null,299,303,297,309,311,314,318,316,324,328,326,241,243,242,246,244,466,337,333,245,341,345,343,347,349,353,351,357,355,250,249,252,251,365,468,369,363,371,367,361,472,476,474,470,373,253,255,375,378,382,380,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,19970,19972,19973,19980,19986,19999,20003,20004,20008,20011,20014,20015,20016,20021,20032,20033,20036,20039,20049,20058,20060,20067,20072,20073,20084,20085,20089,20095,20109,20118,20119,20125,20143,20153,20163,20176,20186,20187,20192,20193,20194,20200,20207,20209,20211,20213,20221,20222,20223,20224,20226,20227,20232,20235,20236,20242,20245,20246,20247,20249,20270,20273,20320,20275,20277,20279,20281,20283,20286,20288,20290,20296,20297,20299,20300,20306,20308,20310,20312,20319,20323,20330,20332,20334,20337,20343,20344,20345,20346,20349,20350,20353,20354,20356,20357,20361,20362,20364,20366,20368,20370,20371,20372,20375,20377,20378,20382,20383,20402,20407,20409,20411,20412,20413,20414,20416,20417,20421,20422,20424,20425,20427,20428,20429,20431,20434,20444,20448,20450,20464,20466,20476,20477,20479,20480,20481,20484,20487,20490,20492,20494,20496,20499,20503,20504,20507,20508,20509,20510,20514,20519,20526,20528,20530,20531,20533,20544,20545,20546,20549,20550,20554,20556,20558,20561,20562,20563,20567,20569,20575,20576,20578,20579,20582,20583,20586,20589,20592,20593,20539,20609,20611,20612,20614,20618,20622,20623,20624,20626,20627,20628,20630,20635,20636,20638,20639,20640,20641,20642,20650,20655,20656,20665,20666,20669,20672,20675,20676,20679,20684,20686,20688,20691,20692,20696,20700,20701,20703,20706,20708,20710,20712,20713,20719,20721,20726,20730,20734,20739,20742,20743,20744,20747,20748,20749,20750,20722,20752,20759,20761,20763,20764,20765,20766,20771,20775,20776,20780,20781,20783,20785,20787,20788,20789,20792,20793,20802,20810,20815,20819,20821,20823,20824,20831,20836,20838,20862,20867,20868,20875,20878,20888,20893,20897,20899,20909,20920,20922,20924,20926,20927,20930,20936,20943,20945,20946,20947,20949,20952,20958,20962,20965,20974,20978,20979,20980,20983,20993,20994,20997,21010,21011,21013,21014,21016,21026,21032,21041,21042,21045,21052,21061,21065,21077,21079,21080,21082,21084,21087,21088,21089,21094,21102,21111,21112,21113,21120,21122,21125,21130,21132,21139,21141,21142,21143,21144,21146,21148,21156,21157,21158,21159,21167,21168,21174,21175,21176,21178,21179,21181,21184,21188,21190,21192,21196,21199,21201,21204,21206,21211,21212,21217,21221,21224,21225,21226,21228,21232,21233,21236,21238,21239,21248,21251,21258,21259,21260,21265,21267,21272,21275,21276,21278,21279,21285,21287,21288,21289,21291,21292,21293,21296,21298,21301,21308,21309,21310,21314,21324,21323,21337,21339,21345,21347,21349,21356,21357,21362,21369,21374,21379,21383,21384,21390,21395,21396,21401,21405,21409,21412,21418,21419,21423,21426,21428,21429,21431,21432,21434,21437,21440,21445,21455,21458,21459,21461,21466,21469,21470,21472,21478,21479,21493,21506,21523,21530,21537,21543,21544,21546,21551,21553,21556,21557,21571,21572,21575,21581,21583,21598,21602,21604,21606,21607,21609,21611,21613,21614,21620,21631,21633,21635,21637,21640,21641,21645,21649,21653,21654,21660,21663,21665,21670,21671,21673,21674,21677,21678,21681,21687,21689,21690,21691,21695,21702,21706,21709,21710,21728,21738,21740,21743,21750,21756,21758,21759,21760,21761,21765,21768,21769,21772,21773,21774,21781,21802,21803,21810,21813,21814,21819,21820,21821,21825,21831,21833,21834,21837,21840,21841,21848,21850,21851,21854,21856,21857,21860,21862,21887,21889,21890,21894,21896,21902,21903,21905,21906,21907,21908,21911,21923,21924,21933,21938,21951,21953,21955,21958,21961,21963,21964,21966,21969,21970,21971,21975,21976,21979,21982,21986,21993,22006,22015,22021,22024,22026,22029,22030,22031,22032,22033,22034,22041,22060,22064,22067,22069,22071,22073,22075,22076,22077,22079,22080,22081,22083,22084,22086,22089,22091,22093,22095,22100,22110,22112,22113,22114,22115,22118,22121,22125,22127,22129,22130,22133,22148,22149,22152,22155,22156,22165,22169,22170,22173,22174,22175,22182,22183,22184,22185,22187,22188,22189,22193,22195,22199,22206,22213,22217,22218,22219,22223,22224,22220,22221,22233,22236,22237,22239,22241,22244,22245,22246,22247,22248,22257,22251,22253,22262,22263,22273,22274,22279,22282,22284,22289,22293,22298,22299,22301,22304,22306,22307,22308,22309,22313,22314,22316,22318,22319,22323,22324,22333,22334,22335,22341,22342,22348,22349,22354,22370,22373,22375,22376,22379,22381,22382,22383,22384,22385,22387,22388,22389,22391,22393,22394,22395,22396,22398,22401,22403,22412,22420,22423,22425,22426,22428,22429,22430,22431,22433,22421,22439,22440,22441,22444,22456,22461,22471,22472,22476,22479,22485,22493,22494,22500,22502,22503,22505,22509,22512,22517,22518,22520,22525,22526,22527,22531,22532,22536,22537,22497,22540,22541,22555,22558,22559,22560,22566,22567,22573,22578,22585,22591,22601,22604,22605,22607,22608,22613,22623,22625,22628,22631,22632,22648,22652,22655,22656,22657,22663,22664,22665,22666,22668,22669,22671,22672,22676,22678,22685,22688,22689,22690,22694,22697,22705,22706,22724,22716,22722,22728,22733,22734,22736,22738,22740,22742,22746,22749,22753,22754,22761,22771,22789,22790,22795,22796,22802,22803,22804,34369,22813,22817,22819,22820,22824,22831,22832,22835,22837,22838,22847,22851,22854,22866,22867,22873,22875,22877,22878,22879,22881,22883,22891,22893,22895,22898,22901,22902,22905,22907,22908,22923,22924,22926,22930,22933,22935,22943,22948,22951,22957,22958,22959,22960,22963,22967,22970,22972,22977,22979,22980,22984,22986,22989,22994,23005,23006,23007,23011,23012,23015,23022,23023,23025,23026,23028,23031,23040,23044,23052,23053,23054,23058,23059,23070,23075,23076,23079,23080,23082,23085,23088,23108,23109,23111,23112,23116,23120,23125,23134,23139,23141,23143,23149,23159,23162,23163,23166,23179,23184,23187,23190,23193,23196,23198,23199,23200,23202,23207,23212,23217,23218,23219,23221,23224,23226,23227,23231,23236,23238,23240,23247,23258,23260,23264,23269,23274,23278,23285,23286,23293,23296,23297,23304,23319,23348,23321,23323,23325,23329,23333,23341,23352,23361,23371,23372,23378,23382,23390,23400,23406,23407,23420,23421,23422,23423,23425,23428,23430,23434,23438,23440,23441,23443,23444,23446,23464,23465,23468,23469,23471,23473,23474,23479,23482,23484,23488,23489,23501,23503,23510,23511,23512,23513,23514,23520,23535,23537,23540,23549,23564,23575,23582,23583,23587,23590,23593,23595,23596,23598,23600,23602,23605,23606,23641,23642,23644,23650,23651,23655,23656,23657,23661,23664,23668,23669,23674,23675,23676,23677,23687,23688,23690,23695,23698,23709,23711,23712,23714,23715,23718,23722,23730,23732,23733,23738,23753,23755,23762,23773,23767,23790,23793,23794,23796,23809,23814,23821,23826,23851,23843,23844,23846,23847,23857,23860,23865,23869,23871,23874,23875,23878,23880,23893,23889,23897,23882,23903,23904,23905,23906,23908,23914,23917,23920,23929,23930,23934,23935,23937,23939,23944,23946,23954,23955,23956,23957,23961,23963,23967,23968,23975,23979,23984,23988,23992,23993,24003,24007,24011,24016,24014,24024,24025,24032,24036,24041,24056,24057,24064,24071,24077,24082,24084,24085,24088,24095,24096,24110,24104,24114,24117,24126,24139,24144,24137,24145,24150,24152,24155,24156,24158,24168,24170,24171,24172,24173,24174,24176,24192,24203,24206,24226,24228,24229,24232,24234,24236,24241,24243,24253,24254,24255,24262,24268,24267,24270,24273,24274,24276,24277,24284,24286,24293,24299,24322,24326,24327,24328,24334,24345,24348,24349,24353,24354,24355,24356,24360,24363,24364,24366,24368,24372,24374,24379,24381,24383,24384,24388,24389,24391,24397,24400,24404,24408,24411,24416,24419,24420,24423,24431,24434,24436,24437,24440,24442,24445,24446,24457,24461,24463,24470,24476,24477,24482,24487,24491,24484,24492,24495,24496,24497,24504,24516,24519,24520,24521,24523,24528,24529,24530,24531,24532,24542,24545,24546,24552,24553,24554,24556,24557,24558,24559,24562,24563,24566,24570,24572,24583,24586,24589,24595,24596,24599,24600,24602,24607,24612,24621,24627,24629,24640,24647,24648,24649,24652,24657,24660,24662,24663,24669,24673,24679,24689,24702,24703,24706,24710,24712,24714,24718,24721,24723,24725,24728,24733,24734,24738,24740,24741,24744,24752,24753,24759,24763,24766,24770,24772,24776,24777,24778,24779,24782,24783,24788,24789,24793,24795,24797,24798,24802,24805,24818,24821,24824,24828,24829,24834,24839,24842,24844,24848,24849,24850,24851,24852,24854,24855,24857,24860,24862,24866,24874,24875,24880,24881,24885,24886,24887,24889,24897,24901,24902,24905,24926,24928,24940,24946,24952,24955,24956,24959,24960,24961,24963,24964,24971,24973,24978,24979,24983,24984,24988,24989,24991,24992,24997,25000,25002,25005,25016,25017,25020,25024,25025,25026,25038,25039,25045,25052,25053,25054,25055,25057,25058,25063,25065,25061,25068,25069,25071,25089,25091,25092,25095,25107,25109,25116,25120,25122,25123,25127,25129,25131,25145,25149,25154,25155,25156,25158,25164,25168,25169,25170,25172,25174,25178,25180,25188,25197,25199,25203,25210,25213,25229,25230,25231,25232,25254,25256,25267,25270,25271,25274,25278,25279,25284,25294,25301,25302,25306,25322,25330,25332,25340,25341,25347,25348,25354,25355,25357,25360,25363,25366,25368,25385,25386,25389,25397,25398,25401,25404,25409,25410,25411,25412,25414,25418,25419,25422,25426,25427,25428,25432,25435,25445,25446,25452,25453,25457,25460,25461,25464,25468,25469,25471,25474,25476,25479,25482,25488,25492,25493,25497,25498,25502,25508,25510,25517,25518,25519,25533,25537,25541,25544,25550,25553,25555,25556,25557,25564,25568,25573,25578,25580,25586,25587,25589,25592,25593,25609,25610,25616,25618,25620,25624,25630,25632,25634,25636,25637,25641,25642,25647,25648,25653,25661,25663,25675,25679,25681,25682,25683,25684,25690,25691,25692,25693,25695,25696,25697,25699,25709,25715,25716,25723,25725,25733,25735,25743,25744,25745,25752,25753,25755,25757,25759,25761,25763,25766,25768,25772,25779,25789,25790,25791,25796,25801,25802,25803,25804,25806,25808,25809,25813,25815,25828,25829,25833,25834,25837,25840,25845,25847,25851,25855,25857,25860,25864,25865,25866,25871,25875,25876,25878,25881,25883,25886,25887,25890,25894,25897,25902,25905,25914,25916,25917,25923,25927,25929,25936,25938,25940,25951,25952,25959,25963,25978,25981,25985,25989,25994,26002,26005,26008,26013,26016,26019,26022,26030,26034,26035,26036,26047,26050,26056,26057,26062,26064,26068,26070,26072,26079,26096,26098,26100,26101,26105,26110,26111,26112,26116,26120,26121,26125,26129,26130,26133,26134,26141,26142,26145,26146,26147,26148,26150,26153,26154,26155,26156,26158,26160,26161,26163,26169,26167,26176,26181,26182,26186,26188,26193,26190,26199,26200,26201,26203,26204,26208,26209,26363,26218,26219,26220,26238,26227,26229,26239,26231,26232,26233,26235,26240,26236,26251,26252,26253,26256,26258,26265,26266,26267,26268,26271,26272,26276,26285,26289,26290,26293,26299,26303,26304,26306,26307,26312,26316,26318,26319,26324,26331,26335,26344,26347,26348,26350,26362,26373,26375,26382,26387,26393,26396,26400,26402,26419,26430,26437,26439,26440,26444,26452,26453,26461,26470,26476,26478,26484,26486,26491,26497,26500,26510,26511,26513,26515,26518,26520,26521,26523,26544,26545,26546,26549,26555,26556,26557,26617,26560,26562,26563,26565,26568,26569,26578,26583,26585,26588,26593,26598,26608,26610,26614,26615,26706,26644,26649,26653,26655,26664,26663,26668,26669,26671,26672,26673,26675,26683,26687,26692,26693,26698,26700,26709,26711,26712,26715,26731,26734,26735,26736,26737,26738,26741,26745,26746,26747,26748,26754,26756,26758,26760,26774,26776,26778,26780,26785,26787,26789,26793,26794,26798,26802,26811,26821,26824,26828,26831,26832,26833,26835,26838,26841,26844,26845,26853,26856,26858,26859,26860,26861,26864,26865,26869,26870,26875,26876,26877,26886,26889,26890,26896,26897,26899,26902,26903,26929,26931,26933,26936,26939,26946,26949,26953,26958,26967,26971,26979,26980,26981,26982,26984,26985,26988,26992,26993,26994,27002,27003,27007,27008,27021,27026,27030,27032,27041,27045,27046,27048,27051,27053,27055,27063,27064,27066,27068,27077,27080,27089,27094,27095,27106,27109,27118,27119,27121,27123,27125,27134,27136,27137,27139,27151,27153,27157,27162,27165,27168,27172,27176,27184,27186,27188,27191,27195,27198,27199,27205,27206,27209,27210,27214,27216,27217,27218,27221,27222,27227,27236,27239,27242,27249,27251,27262,27265,27267,27270,27271,27273,27275,27281,27291,27293,27294,27295,27301,27307,27311,27312,27313,27316,27325,27326,27327,27334,27337,27336,27340,27344,27348,27349,27350,27356,27357,27364,27367,27372,27376,27377,27378,27388,27389,27394,27395,27398,27399,27401,27407,27408,27409,27415,27419,27422,27428,27432,27435,27436,27439,27445,27446,27451,27455,27462,27466,27469,27474,27478,27480,27485,27488,27495,27499,27502,27504,27509,27517,27518,27522,27525,27543,27547,27551,27552,27554,27555,27560,27561,27564,27565,27566,27568,27576,27577,27581,27582,27587,27588,27593,27596,27606,27610,27617,27619,27622,27623,27630,27633,27639,27641,27647,27650,27652,27653,27657,27661,27662,27664,27666,27673,27679,27686,27687,27688,27692,27694,27699,27701,27702,27706,27707,27711,27722,27723,27725,27727,27730,27732,27737,27739,27740,27755,27757,27759,27764,27766,27768,27769,27771,27781,27782,27783,27785,27796,27797,27799,27800,27804,27807,27824,27826,27828,27842,27846,27853,27855,27856,27857,27858,27860,27862,27866,27868,27872,27879,27881,27883,27884,27886,27890,27892,27908,27911,27914,27918,27919,27921,27923,27930,27942,27943,27944,27751,27950,27951,27953,27961,27964,27967,27991,27998,27999,28001,28005,28007,28015,28016,28028,28034,28039,28049,28050,28052,28054,28055,28056,28074,28076,28084,28087,28089,28093,28095,28100,28104,28106,28110,28111,28118,28123,28125,28127,28128,28130,28133,28137,28143,28144,28148,28150,28156,28160,28164,28190,28194,28199,28210,28214,28217,28219,28220,28228,28229,28232,28233,28235,28239,28241,28242,28243,28244,28247,28252,28253,28254,28258,28259,28264,28275,28283,28285,28301,28307,28313,28320,28327,28333,28334,28337,28339,28347,28351,28352,28353,28355,28359,28360,28362,28365,28366,28367,28395,28397,28398,28409,28411,28413,28420,28424,28426,28428,28429,28438,28440,28442,28443,28454,28457,28458,28463,28464,28467,28470,28475,28476,28461,28495,28497,28498,28499,28503,28505,28506,28509,28510,28513,28514,28520,28524,28541,28542,28547,28551,28552,28555,28556,28557,28560,28562,28563,28564,28566,28570,28575,28576,28581,28582,28583,28584,28590,28591,28592,28597,28598,28604,28613,28615,28616,28618,28634,28638,28648,28649,28656,28661,28665,28668,28669,28672,28677,28678,28679,28685,28695,28704,28707,28719,28724,28727,28729,28732,28739,28740,28744,28745,28746,28747,28756,28757,28765,28766,28750,28772,28773,28780,28782,28789,28790,28798,28801,28805,28806,28820,28821,28822,28823,28824,28827,28836,28843,28848,28849,28852,28855,28874,28881,28883,28884,28885,28886,28888,28892,28900,28922,28931,28932,28933,28934,28935,28939,28940,28943,28958,28960,28971,28973,28975,28976,28977,28984,28993,28997,28998,28999,29002,29003,29008,29010,29015,29018,29020,29022,29024,29032,29049,29056,29061,29063,29068,29074,29082,29083,29088,29090,29103,29104,29106,29107,29114,29119,29120,29121,29124,29131,29132,29139,29142,29145,29146,29148,29176,29182,29184,29191,29192,29193,29203,29207,29210,29213,29215,29220,29227,29231,29236,29240,29241,29249,29250,29251,29253,29262,29263,29264,29267,29269,29270,29274,29276,29278,29280,29283,29288,29291,29294,29295,29297,29303,29304,29307,29308,29311,29316,29321,29325,29326,29331,29339,29352,29357,29358,29361,29364,29374,29377,29383,29385,29388,29397,29398,29400,29407,29413,29427,29428,29434,29435,29438,29442,29444,29445,29447,29451,29453,29458,29459,29464,29465,29470,29474,29476,29479,29480,29484,29489,29490,29493,29498,29499,29501,29507,29517,29520,29522,29526,29528,29533,29534,29535,29536,29542,29543,29545,29547,29548,29550,29551,29553,29559,29561,29564,29568,29569,29571,29573,29574,29582,29584,29587,29589,29591,29592,29596,29598,29599,29600,29602,29605,29606,29610,29611,29613,29621,29623,29625,29628,29629,29631,29637,29638,29641,29643,29644,29647,29650,29651,29654,29657,29661,29665,29667,29670,29671,29673,29684,29685,29687,29689,29690,29691,29693,29695,29696,29697,29700,29703,29706,29713,29722,29723,29732,29734,29736,29737,29738,29739,29740,29741,29742,29743,29744,29745,29753,29760,29763,29764,29766,29767,29771,29773,29777,29778,29783,29789,29794,29798,29799,29800,29803,29805,29806,29809,29810,29824,29825,29829,29830,29831,29833,29839,29840,29841,29842,29848,29849,29850,29852,29855,29856,29857,29859,29862,29864,29865,29866,29867,29870,29871,29873,29874,29877,29881,29883,29887,29896,29897,29900,29904,29907,29912,29914,29915,29918,29919,29924,29928,29930,29931,29935,29940,29946,29947,29948,29951,29958,29970,29974,29975,29984,29985,29988,29991,29993,29994,29999,30006,30009,30013,30014,30015,30016,30019,30023,30024,30030,30032,30034,30039,30046,30047,30049,30063,30065,30073,30074,30075,30076,30077,30078,30081,30085,30096,30098,30099,30101,30105,30108,30114,30116,30132,30138,30143,30144,30145,30148,30150,30156,30158,30159,30167,30172,30175,30176,30177,30180,30183,30188,30190,30191,30193,30201,30208,30210,30211,30212,30215,30216,30218,30220,30223,30226,30227,30229,30230,30233,30235,30236,30237,30238,30243,30245,30246,30249,30253,30258,30259,30261,30264,30265,30266,30268,30282,30272,30273,30275,30276,30277,30281,30283,30293,30297,30303,30308,30309,30317,30318,30319,30321,30324,30337,30341,30348,30349,30357,30363,30364,30365,30367,30368,30370,30371,30372,30373,30374,30375,30376,30378,30381,30397,30401,30405,30409,30411,30412,30414,30420,30425,30432,30438,30440,30444,30448,30449,30454,30457,30460,30464,30470,30474,30478,30482,30484,30485,30487,30489,30490,30492,30498,30504,30509,30510,30511,30516,30517,30518,30521,30525,30526,30530,30533,30534,30538,30541,30542,30543,30546,30550,30551,30556,30558,30559,30560,30562,30564,30567,30570,30572,30576,30578,30579,30580,30586,30589,30592,30596,30604,30605,30612,30613,30614,30618,30623,30626,30631,30634,30638,30639,30641,30645,30654,30659,30665,30673,30674,30677,30681,30686,30687,30688,30692,30694,30698,30700,30704,30705,30708,30712,30715,30725,30726,30729,30733,30734,30737,30749,30753,30754,30755,30765,30766,30768,30773,30775,30787,30788,30791,30792,30796,30798,30802,30812,30814,30816,30817,30819,30820,30824,30826,30830,30842,30846,30858,30863,30868,30872,30881,30877,30878,30879,30884,30888,30892,30893,30896,30897,30898,30899,30907,30909,30911,30919,30920,30921,30924,30926,30930,30931,30933,30934,30948,30939,30943,30944,30945,30950,30954,30962,30963,30976,30966,30967,30970,30971,30975,30982,30988,30992,31002,31004,31006,31007,31008,31013,31015,31017,31021,31025,31028,31029,31035,31037,31039,31044,31045,31046,31050,31051,31055,31057,31060,31064,31067,31068,31079,31081,31083,31090,31097,31099,31100,31102,31115,31116,31121,31123,31124,31125,31126,31128,31131,31132,31137,31144,31145,31147,31151,31153,31156,31160,31163,31170,31172,31175,31176,31178,31183,31188,31190,31194,31197,31198,31200,31202,31205,31210,31211,31213,31217,31224,31228,31234,31235,31239,31241,31242,31244,31249,31253,31259,31262,31265,31271,31275,31277,31279,31280,31284,31285,31288,31289,31290,31300,31301,31303,31304,31308,31317,31318,31321,31324,31325,31327,31328,31333,31335,31338,31341,31349,31352,31358,31360,31362,31365,31366,31370,31371,31376,31377,31380,31390,31392,31395,31404,31411,31413,31417,31419,31420,31430,31433,31436,31438,31441,31451,31464,31465,31467,31468,31473,31476,31483,31485,31486,31495,31508,31519,31523,31527,31529,31530,31531,31533,31534,31535,31536,31537,31540,31549,31551,31552,31553,31559,31566,31573,31584,31588,31590,31593,31594,31597,31599,31602,31603,31607,31620,31625,31630,31632,31633,31638,31643,31646,31648,31653,31660,31663,31664,31666,31669,31670,31674,31675,31676,31677,31682,31685,31688,31690,31700,31702,31703,31705,31706,31707,31720,31722,31730,31732,31733,31736,31737,31738,31740,31742,31745,31746,31747,31748,31750,31753,31755,31756,31758,31759,31769,31771,31776,31781,31782,31784,31788,31793,31795,31796,31798,31801,31802,31814,31818,31829,31825,31826,31827,31833,31834,31835,31836,31837,31838,31841,31843,31847,31849,31853,31854,31856,31858,31865,31868,31869,31878,31879,31887,31892,31902,31904,31910,31920,31926,31927,31930,31931,31932,31935,31940,31943,31944,31945,31949,31951,31955,31956,31957,31959,31961,31962,31965,31974,31977,31979,31989,32003,32007,32008,32009,32015,32017,32018,32019,32022,32029,32030,32035,32038,32042,32045,32049,32060,32061,32062,32064,32065,32071,32072,32077,32081,32083,32087,32089,32090,32092,32093,32101,32103,32106,32112,32120,32122,32123,32127,32129,32130,32131,32133,32134,32136,32139,32140,32141,32145,32150,32151,32157,32158,32166,32167,32170,32179,32182,32183,32185,32194,32195,32196,32197,32198,32204,32205,32206,32215,32217,32256,32226,32229,32230,32234,32235,32237,32241,32245,32246,32249,32250,32264,32272,32273,32277,32279,32284,32285,32288,32295,32296,32300,32301,32303,32307,32310,32319,32324,32325,32327,32334,32336,32338,32344,32351,32353,32354,32357,32363,32366,32367,32371,32376,32382,32385,32390,32391,32394,32397,32401,32405,32408,32410,32413,32414,32572,32571,32573,32574,32575,32579,32580,32583,32591,32594,32595,32603,32604,32605,32609,32611,32612,32613,32614,32621,32625,32637,32638,32639,32640,32651,32653,32655,32656,32657,32662,32663,32668,32673,32674,32678,32682,32685,32692,32700,32703,32704,32707,32712,32718,32719,32731,32735,32739,32741,32744,32748,32750,32751,32754,32762,32765,32766,32767,32775,32776,32778,32781,32782,32783,32785,32787,32788,32790,32797,32798,32799,32800,32804,32806,32812,32814,32816,32820,32821,32823,32825,32826,32828,32830,32832,32836,32864,32868,32870,32877,32881,32885,32897,32904,32910,32924,32926,32934,32935,32939,32952,32953,32968,32973,32975,32978,32980,32981,32983,32984,32992,33005,33006,33008,33010,33011,33014,33017,33018,33022,33027,33035,33046,33047,33048,33052,33054,33056,33060,33063,33068,33072,33077,33082,33084,33093,33095,33098,33100,33106,33111,33120,33121,33127,33128,33129,33133,33135,33143,33153,33168,33156,33157,33158,33163,33166,33174,33176,33179,33182,33186,33198,33202,33204,33211,33227,33219,33221,33226,33230,33231,33237,33239,33243,33245,33246,33249,33252,33259,33260,33264,33265,33266,33269,33270,33272,33273,33277,33279,33280,33283,33295,33299,33300,33305,33306,33309,33313,33314,33320,33330,33332,33338,33347,33348,33349,33350,33355,33358,33359,33361,33366,33372,33376,33379,33383,33389,33396,33403,33405,33407,33408,33409,33411,33412,33415,33417,33418,33422,33425,33428,33430,33432,33434,33435,33440,33441,33443,33444,33447,33448,33449,33450,33454,33456,33458,33460,33463,33466,33468,33470,33471,33478,33488,33493,33498,33504,33506,33508,33512,33514,33517,33519,33526,33527,33533,33534,33536,33537,33543,33544,33546,33547,33620,33563,33565,33566,33567,33569,33570,33580,33581,33582,33584,33587,33591,33594,33596,33597,33602,33603,33604,33607,33613,33614,33617,33621,33622,33623,33648,33656,33661,33663,33664,33666,33668,33670,33677,33682,33684,33685,33688,33689,33691,33692,33693,33702,33703,33705,33708,33726,33727,33728,33735,33737,33743,33744,33745,33748,33757,33619,33768,33770,33782,33784,33785,33788,33793,33798,33802,33807,33809,33813,33817,33709,33839,33849,33861,33863,33864,33866,33869,33871,33873,33874,33878,33880,33881,33882,33884,33888,33892,33893,33895,33898,33904,33907,33908,33910,33912,33916,33917,33921,33925,33938,33939,33941,33950,33958,33960,33961,33962,33967,33969,33972,33978,33981,33982,33984,33986,33991,33992,33996,33999,34003,34012,34023,34026,34031,34032,34033,34034,34039,34098,34042,34043,34045,34050,34051,34055,34060,34062,34064,34076,34078,34082,34083,34084,34085,34087,34090,34091,34095,34099,34100,34102,34111,34118,34127,34128,34129,34130,34131,34134,34137,34140,34141,34142,34143,34144,34145,34146,34148,34155,34159,34169,34170,34171,34173,34175,34177,34181,34182,34185,34187,34188,34191,34195,34200,34205,34207,34208,34210,34213,34215,34228,34230,34231,34232,34236,34237,34238,34239,34242,34247,34250,34251,34254,34221,34264,34266,34271,34272,34278,34280,34285,34291,34294,34300,34303,34304,34308,34309,34317,34318,34320,34321,34322,34328,34329,34331,34334,34337,34343,34345,34358,34360,34362,34364,34365,34368,34370,34374,34386,34387,34390,34391,34392,34393,34397,34400,34401,34402,34403,34404,34409,34412,34415,34421,34422,34423,34426,34445,34449,34454,34456,34458,34460,34465,34470,34471,34472,34477,34481,34483,34484,34485,34487,34488,34489,34495,34496,34497,34499,34501,34513,34514,34517,34519,34522,34524,34528,34531,34533,34535,34440,34554,34556,34557,34564,34565,34567,34571,34574,34575,34576,34579,34580,34585,34590,34591,34593,34595,34600,34606,34607,34609,34610,34617,34618,34620,34621,34622,34624,34627,34629,34637,34648,34653,34657,34660,34661,34671,34673,34674,34683,34691,34692,34693,34694,34695,34696,34697,34699,34700,34704,34707,34709,34711,34712,34713,34718,34720,34723,34727,34732,34733,34734,34737,34741,34750,34751,34753,34760,34761,34762,34766,34773,34774,34777,34778,34780,34783,34786,34787,34788,34794,34795,34797,34801,34803,34808,34810,34815,34817,34819,34822,34825,34826,34827,34832,34841,34834,34835,34836,34840,34842,34843,34844,34846,34847,34856,34861,34862,34864,34866,34869,34874,34876,34881,34883,34885,34888,34889,34890,34891,34894,34897,34901,34902,34904,34906,34908,34911,34912,34916,34921,34929,34937,34939,34944,34968,34970,34971,34972,34975,34976,34984,34986,35002,35005,35006,35008,35018,35019,35020,35021,35022,35025,35026,35027,35035,35038,35047,35055,35056,35057,35061,35063,35073,35078,35085,35086,35087,35093,35094,35096,35097,35098,35100,35104,35110,35111,35112,35120,35121,35122,35125,35129,35130,35134,35136,35138,35141,35142,35145,35151,35154,35159,35162,35163,35164,35169,35170,35171,35179,35182,35184,35187,35189,35194,35195,35196,35197,35209,35213,35216,35220,35221,35227,35228,35231,35232,35237,35248,35252,35253,35254,35255,35260,35284,35285,35286,35287,35288,35301,35305,35307,35309,35313,35315,35318,35321,35325,35327,35332,35333,35335,35343,35345,35346,35348,35349,35358,35360,35362,35364,35366,35371,35372,35375,35381,35383,35389,35390,35392,35395,35397,35399,35401,35405,35406,35411,35414,35415,35416,35420,35421,35425,35429,35431,35445,35446,35447,35449,35450,35451,35454,35455,35456,35459,35462,35467,35471,35472,35474,35478,35479,35481,35487,35495,35497,35502,35503,35507,35510,35511,35515,35518,35523,35526,35528,35529,35530,35537,35539,35540,35541,35543,35549,35551,35564,35568,35572,35573,35574,35580,35583,35589,35590,35595,35601,35612,35614,35615,35594,35629,35632,35639,35644,35650,35651,35652,35653,35654,35656,35666,35667,35668,35673,35661,35678,35683,35693,35702,35704,35705,35708,35710,35713,35716,35717,35723,35725,35727,35732,35733,35740,35742,35743,35896,35897,35901,35902,35909,35911,35913,35915,35919,35921,35923,35924,35927,35928,35931,35933,35929,35939,35940,35942,35944,35945,35949,35955,35957,35958,35963,35966,35974,35975,35979,35984,35986,35987,35993,35995,35996,36004,36025,36026,36037,36038,36041,36043,36047,36054,36053,36057,36061,36065,36072,36076,36079,36080,36082,36085,36087,36088,36094,36095,36097,36099,36105,36114,36119,36123,36197,36201,36204,36206,36223,36226,36228,36232,36237,36240,36241,36245,36254,36255,36256,36262,36267,36268,36271,36274,36277,36279,36281,36283,36288,36293,36294,36295,36296,36298,36302,36305,36308,36309,36311,36313,36324,36325,36327,36332,36336,36284,36337,36338,36340,36349,36353,36356,36357,36358,36363,36369,36372,36374,36384,36385,36386,36387,36390,36391,36401,36403,36406,36407,36408,36409,36413,36416,36417,36427,36429,36430,36431,36436,36443,36444,36445,36446,36449,36450,36457,36460,36461,36463,36464,36465,36473,36474,36475,36482,36483,36489,36496,36498,36501,36506,36507,36509,36510,36514,36519,36521,36525,36526,36531,36533,36538,36539,36544,36545,36547,36548,36551,36559,36561,36564,36572,36584,36590,36592,36593,36599,36601,36602,36589,36608,36610,36615,36616,36623,36624,36630,36631,36632,36638,36640,36641,36643,36645,36647,36648,36652,36653,36654,36660,36661,36662,36663,36666,36672,36673,36675,36679,36687,36689,36690,36691,36692,36693,36696,36701,36702,36709,36765,36768,36769,36772,36773,36774,36789,36790,36792,36798,36800,36801,36806,36810,36811,36813,36816,36818,36819,36821,36832,36835,36836,36840,36846,36849,36853,36854,36859,36862,36866,36868,36872,36876,36888,36891,36904,36905,36911,36906,36908,36909,36915,36916,36919,36927,36931,36932,36940,36955,36957,36962,36966,36967,36972,36976,36980,36985,36997,37000,37003,37004,37006,37008,37013,37015,37016,37017,37019,37024,37025,37026,37029,37040,37042,37043,37044,37046,37053,37068,37054,37059,37060,37061,37063,37064,37077,37079,37080,37081,37084,37085,37087,37093,37074,37110,37099,37103,37104,37108,37118,37119,37120,37124,37125,37126,37128,37133,37136,37140,37142,37143,37144,37146,37148,37150,37152,37157,37154,37155,37159,37161,37166,37167,37169,37172,37174,37175,37177,37178,37180,37181,37187,37191,37192,37199,37203,37207,37209,37210,37211,37217,37220,37223,37229,37236,37241,37242,37243,37249,37251,37253,37254,37258,37262,37265,37267,37268,37269,37272,37278,37281,37286,37288,37292,37293,37294,37296,37297,37298,37299,37302,37307,37308,37309,37311,37314,37315,37317,37331,37332,37335,37337,37338,37342,37348,37349,37353,37354,37356,37357,37358,37359,37360,37361,37367,37369,37371,37373,37376,37377,37380,37381,37382,37383,37385,37386,37388,37392,37394,37395,37398,37400,37404,37405,37411,37412,37413,37414,37416,37422,37423,37424,37427,37429,37430,37432,37433,37434,37436,37438,37440,37442,37443,37446,37447,37450,37453,37454,37455,37457,37464,37465,37468,37469,37472,37473,37477,37479,37480,37481,37486,37487,37488,37493,37494,37495,37496,37497,37499,37500,37501,37503,37512,37513,37514,37517,37518,37522,37527,37529,37535,37536,37540,37541,37543,37544,37547,37551,37554,37558,37560,37562,37563,37564,37565,37567,37568,37569,37570,37571,37573,37574,37575,37576,37579,37580,37581,37582,37584,37587,37589,37591,37592,37593,37596,37597,37599,37600,37601,37603,37605,37607,37608,37612,37614,37616,37625,37627,37631,37632,37634,37640,37645,37649,37652,37653,37660,37661,37662,37663,37665,37668,37669,37671,37673,37674,37683,37684,37686,37687,37703,37704,37705,37712,37713,37714,37717,37719,37720,37722,37726,37732,37733,37735,37737,37738,37741,37743,37744,37745,37747,37748,37750,37754,37757,37759,37760,37761,37762,37768,37770,37771,37773,37775,37778,37781,37784,37787,37790,37793,37795,37796,37798,37800,37803,37812,37813,37814,37818,37801,37825,37828,37829,37830,37831,37833,37834,37835,37836,37837,37843,37849,37852,37854,37855,37858,37862,37863,37881,37879,37880,37882,37883,37885,37889,37890,37892,37896,37897,37901,37902,37903,37909,37910,37911,37919,37934,37935,37937,37938,37939,37940,37947,37951,37949,37955,37957,37960,37962,37964,37973,37977,37980,37983,37985,37987,37992,37995,37997,37998,37999,38001,38002,38020,38019,38264,38265,38270,38276,38280,38284,38285,38286,38301,38302,38303,38305,38310,38313,38315,38316,38324,38326,38330,38333,38335,38342,38344,38345,38347,38352,38353,38354,38355,38361,38362,38365,38366,38367,38368,38372,38374,38429,38430,38434,38436,38437,38438,38444,38449,38451,38455,38456,38457,38458,38460,38461,38465,38482,38484,38486,38487,38488,38497,38510,38516,38523,38524,38526,38527,38529,38530,38531,38532,38537,38545,38550,38554,38557,38559,38564,38565,38566,38569,38574,38575,38579,38586,38602,38610,23986,38616,38618,38621,38622,38623,38633,38639,38641,38650,38658,38659,38661,38665,38682,38683,38685,38689,38690,38691,38696,38705,38707,38721,38723,38730,38734,38735,38741,38743,38744,38746,38747,38755,38759,38762,38766,38771,38774,38775,38776,38779,38781,38783,38784,38793,38805,38806,38807,38809,38810,38814,38815,38818,38828,38830,38833,38834,38837,38838,38840,38841,38842,38844,38846,38847,38849,38852,38853,38855,38857,38858,38860,38861,38862,38864,38865,38868,38871,38872,38873,38877,38878,38880,38875,38881,38884,38895,38897,38900,38903,38904,38906,38919,38922,38937,38925,38926,38932,38934,38940,38942,38944,38947,38950,38955,38958,38959,38960,38962,38963,38965,38949,38974,38980,38983,38986,38993,38994,38995,38998,38999,39001,39002,39010,39011,39013,39014,39018,39020,39083,39085,39086,39088,39092,39095,39096,39098,39099,39103,39106,39109,39112,39116,39137,39139,39141,39142,39143,39146,39155,39158,39170,39175,39176,39185,39189,39190,39191,39194,39195,39196,39199,39202,39206,39207,39211,39217,39218,39219,39220,39221,39225,39226,39227,39228,39232,39233,39238,39239,39240,39245,39246,39252,39256,39257,39259,39260,39262,39263,39264,39323,39325,39327,39334,39344,39345,39346,39349,39353,39354,39357,39359,39363,39369,39379,39380,39385,39386,39388,39390,39399,39402,39403,39404,39408,39412,39413,39417,39421,39422,39426,39427,39428,39435,39436,39440,39441,39446,39454,39456,39458,39459,39460,39463,39469,39470,39475,39477,39478,39480,39495,39489,39492,39498,39499,39500,39502,39505,39508,39510,39517,39594,39596,39598,39599,39602,39604,39605,39606,39609,39611,39614,39615,39617,39619,39622,39624,39630,39632,39634,39637,39638,39639,39643,39644,39648,39652,39653,39655,39657,39660,39666,39667,39669,39673,39674,39677,39679,39680,39681,39682,39683,39684,39685,39688,39689,39691,39692,39693,39694,39696,39698,39702,39705,39707,39708,39712,39718,39723,39725,39731,39732,39733,39735,39737,39738,39741,39752,39755,39756,39765,39766,39767,39771,39774,39777,39779,39781,39782,39784,39786,39787,39788,39789,39790,39795,39797,39799,39800,39801,39807,39808,39812,39813,39814,39815,39817,39818,39819,39821,39823,39824,39828,39834,39837,39838,39846,39847,39849,39852,39856,39857,39858,39863,39864,39867,39868,39870,39871,39873,39879,39880,39886,39888,39895,39896,39901,39903,39909,39911,39914,39915,39919,39923,39927,39928,39929,39930,39933,39935,39936,39938,39947,39951,39953,39958,39960,39961,39962,39964,39966,39970,39971,39974,39975,39976,39977,39978,39985,39989,39990,39991,39997,40001,40003,40004,40005,40009,40010,40014,40015,40016,40019,40020,40022,40024,40027,40029,40030,40031,40035,40041,40042,40028,40043,40040,40046,40048,40050,40053,40055,40059,40166,40178,40183,40185,40203,40194,40209,40215,40216,40220,40221,40222,40239,40240,40242,40243,40244,40250,40252,40261,40253,40258,40259,40263,40266,40275,40276,40287,40291,40290,40293,40297,40298,40299,40304,40310,40311,40315,40316,40318,40323,40324,40326,40330,40333,40334,40338,40339,40341,40342,40343,40344,40353,40362,40364,40366,40369,40373,40377,40380,40383,40387,40391,40393,40394,40404,40405,40406,40407,40410,40414,40415,40416,40421,40423,40425,40427,40430,40432,40435,40436,40446,40458,40450,40455,40462,40464,40465,40466,40469,40470,40473,40476,40477,40570,40571,40572,40576,40578,40579,40580,40581,40583,40590,40591,40598,40600,40603,40606,40612,40616,40620,40622,40623,40624,40627,40628,40629,40646,40648,40651,40661,40671,40676,40679,40684,40685,40686,40688,40689,40690,40693,40696,40703,40706,40707,40713,40719,40720,40721,40722,40724,40726,40727,40729,40730,40731,40735,40738,40742,40746,40747,40751,40753,40754,40756,40759,40761,40762,40764,40765,40767,40769,40771,40772,40773,40774,40775,40787,40789,40790,40791,40792,40794,40797,40798,40808,40809,40813,40814,40815,40816,40817,40819,40821,40826,40829,40847,40848,40849,40850,40852,40854,40855,40862,40865,40866,40867,40869,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],
  "ibm866":[1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,9617,9618,9619,9474,9508,9569,9570,9558,9557,9571,9553,9559,9565,9564,9563,9488,9492,9524,9516,9500,9472,9532,9566,9567,9562,9556,9577,9574,9568,9552,9580,9575,9576,9572,9573,9561,9560,9554,9555,9579,9578,9496,9484,9608,9604,9612,9616,9600,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,1025,1105,1028,1108,1031,1111,1038,1118,176,8729,183,8730,8470,164,9632,160],
  "iso-8859-2":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,260,728,321,164,317,346,167,168,352,350,356,377,173,381,379,176,261,731,322,180,318,347,711,184,353,351,357,378,733,382,380,340,193,194,258,196,313,262,199,268,201,280,203,282,205,206,270,272,323,327,211,212,336,214,215,344,366,218,368,220,221,354,223,341,225,226,259,228,314,263,231,269,233,281,235,283,237,238,271,273,324,328,243,244,337,246,247,345,367,250,369,252,253,355,729],
  "iso-8859-3":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,294,728,163,164,null,292,167,168,304,350,286,308,173,null,379,176,295,178,179,180,181,293,183,184,305,351,287,309,189,null,380,192,193,194,null,196,266,264,199,200,201,202,203,204,205,206,207,null,209,210,211,212,288,214,215,284,217,218,219,220,364,348,223,224,225,226,null,228,267,265,231,232,233,234,235,236,237,238,239,null,241,242,243,244,289,246,247,285,249,250,251,252,365,349,729],
  "iso-8859-4":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,260,312,342,164,296,315,167,168,352,274,290,358,173,381,175,176,261,731,343,180,297,316,711,184,353,275,291,359,330,382,331,256,193,194,195,196,197,198,302,268,201,280,203,278,205,206,298,272,325,332,310,212,213,214,215,216,370,218,219,220,360,362,223,257,225,226,227,228,229,230,303,269,233,281,235,279,237,238,299,273,326,333,311,244,245,246,247,248,371,250,251,252,361,363,729],
  "iso-8859-5":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036,173,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,8470,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,167,1118,1119],
  "iso-8859-6":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,null,null,null,164,null,null,null,null,null,null,null,1548,173,null,null,null,null,null,null,null,null,null,null,null,null,null,1563,null,null,null,1567,null,1569,1570,1571,1572,1573,1574,1575,1576,1577,1578,1579,1580,1581,1582,1583,1584,1585,1586,1587,1588,1589,1590,1591,1592,1593,1594,null,null,null,null,null,1600,1601,1602,1603,1604,1605,1606,1607,1608,1609,1610,1611,1612,1613,1614,1615,1616,1617,1618,null,null,null,null,null,null,null,null,null,null,null,null,null],
  "iso-8859-7":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,8216,8217,163,8364,8367,166,167,168,169,890,171,172,173,null,8213,176,177,178,179,900,901,902,183,904,905,906,187,908,189,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,null,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,964,965,966,967,968,969,970,971,972,973,974,null],
  "iso-8859-8":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,null,162,163,164,165,166,167,168,169,215,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,247,187,188,189,190,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,8215,1488,1489,1490,1491,1492,1493,1494,1495,1496,1497,1498,1499,1500,1501,1502,1503,1504,1505,1506,1507,1508,1509,1510,1511,1512,1513,1514,null,null,8206,8207,null],
  "iso-8859-10":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,260,274,290,298,296,310,167,315,272,352,358,381,173,362,330,176,261,275,291,299,297,311,183,316,273,353,359,382,8213,363,331,256,193,194,195,196,197,198,302,268,201,280,203,278,205,206,207,208,325,332,211,212,213,214,360,216,370,218,219,220,221,222,223,257,225,226,227,228,229,230,303,269,233,281,235,279,237,238,239,240,326,333,243,244,245,246,361,248,371,250,251,252,253,254,312],
  "iso-8859-13":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,8221,162,163,164,8222,166,167,216,169,342,171,172,173,174,198,176,177,178,179,8220,181,182,183,248,185,343,187,188,189,190,230,260,302,256,262,196,197,280,274,268,201,377,278,290,310,298,315,352,323,325,211,332,213,214,215,370,321,346,362,220,379,381,223,261,303,257,263,228,229,281,275,269,233,378,279,291,311,299,316,353,324,326,243,333,245,246,247,371,322,347,363,252,380,382,8217],
  "iso-8859-14":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,7682,7683,163,266,267,7690,167,7808,169,7810,7691,7922,173,174,376,7710,7711,288,289,7744,7745,182,7766,7809,7767,7811,7776,7923,7812,7813,7777,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,372,209,210,211,212,213,214,7786,216,217,218,219,220,221,374,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,373,241,242,243,244,245,246,7787,248,249,250,251,252,253,375,255],
  "iso-8859-15":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,8364,165,352,167,353,169,170,171,172,173,174,175,176,177,178,179,381,181,182,183,382,185,186,187,338,339,376,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255],
  "iso-8859-16":[128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,260,261,321,8364,8222,352,167,353,169,536,171,377,173,378,379,176,177,268,322,381,8221,182,183,382,269,537,187,338,339,376,380,192,193,194,258,196,262,198,199,200,201,202,203,204,205,206,207,272,323,210,211,212,336,214,346,368,217,218,219,220,280,538,223,224,225,226,259,228,263,230,231,232,233,234,235,236,237,238,239,273,324,242,243,244,337,246,347,369,249,250,251,252,281,539,255],
  "koi8-r":[9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9600,9604,9608,9612,9616,9617,9618,9619,8992,9632,8729,8730,8776,8804,8805,160,8993,176,178,183,247,9552,9553,9554,1105,9555,9556,9557,9558,9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,1025,9570,9571,9572,9573,9574,9575,9576,9577,9578,9579,9580,169,1102,1072,1073,1094,1076,1077,1092,1075,1093,1080,1081,1082,1083,1084,1085,1086,1087,1103,1088,1089,1090,1091,1078,1074,1100,1099,1079,1096,1101,1097,1095,1098,1070,1040,1041,1062,1044,1045,1060,1043,1061,1048,1049,1050,1051,1052,1053,1054,1055,1071,1056,1057,1058,1059,1046,1042,1068,1067,1047,1064,1069,1065,1063,1066],
  "koi8-u":[9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9600,9604,9608,9612,9616,9617,9618,9619,8992,9632,8729,8730,8776,8804,8805,160,8993,176,178,183,247,9552,9553,9554,1105,1108,9556,1110,1111,9559,9560,9561,9562,9563,1169,1118,9566,9567,9568,9569,1025,1028,9571,1030,1031,9574,9575,9576,9577,9578,1168,1038,169,1102,1072,1073,1094,1076,1077,1092,1075,1093,1080,1081,1082,1083,1084,1085,1086,1087,1103,1088,1089,1090,1091,1078,1074,1100,1099,1079,1096,1101,1097,1095,1098,1070,1040,1041,1062,1044,1045,1060,1043,1061,1048,1049,1050,1051,1052,1053,1054,1055,1071,1056,1057,1058,1059,1046,1042,1068,1067,1047,1064,1069,1065,1063,1066],
  "macintosh":[196,197,199,201,209,214,220,225,224,226,228,227,229,231,233,232,234,235,237,236,238,239,241,243,242,244,246,245,250,249,251,252,8224,176,162,163,167,8226,182,223,174,169,8482,180,168,8800,198,216,8734,177,8804,8805,165,181,8706,8721,8719,960,8747,170,186,937,230,248,191,161,172,8730,402,8776,8710,171,187,8230,160,192,195,213,338,339,8211,8212,8220,8221,8216,8217,247,9674,255,376,8260,8364,8249,8250,64257,64258,8225,183,8218,8222,8240,194,202,193,203,200,205,206,207,204,211,212,63743,210,218,219,217,305,710,732,175,728,729,730,184,733,731,711],
  "windows-874":[8364,129,130,131,132,8230,134,135,136,137,138,139,140,141,142,143,144,8216,8217,8220,8221,8226,8211,8212,152,153,154,155,156,157,158,159,160,3585,3586,3587,3588,3589,3590,3591,3592,3593,3594,3595,3596,3597,3598,3599,3600,3601,3602,3603,3604,3605,3606,3607,3608,3609,3610,3611,3612,3613,3614,3615,3616,3617,3618,3619,3620,3621,3622,3623,3624,3625,3626,3627,3628,3629,3630,3631,3632,3633,3634,3635,3636,3637,3638,3639,3640,3641,3642,null,null,null,null,3647,3648,3649,3650,3651,3652,3653,3654,3655,3656,3657,3658,3659,3660,3661,3662,3663,3664,3665,3666,3667,3668,3669,3670,3671,3672,3673,3674,3675,null,null,null,null],
  "windows-1250":[8364,129,8218,131,8222,8230,8224,8225,136,8240,352,8249,346,356,381,377,144,8216,8217,8220,8221,8226,8211,8212,152,8482,353,8250,347,357,382,378,160,711,728,321,164,260,166,167,168,169,350,171,172,173,174,379,176,177,731,322,180,181,182,183,184,261,351,187,317,733,318,380,340,193,194,258,196,313,262,199,268,201,280,203,282,205,206,270,272,323,327,211,212,336,214,215,344,366,218,368,220,221,354,223,341,225,226,259,228,314,263,231,269,233,281,235,283,237,238,271,273,324,328,243,244,337,246,247,345,367,250,369,252,253,355,729],
  "windows-1251":[1026,1027,8218,1107,8222,8230,8224,8225,8364,8240,1033,8249,1034,1036,1035,1039,1106,8216,8217,8220,8221,8226,8211,8212,152,8482,1113,8250,1114,1116,1115,1119,160,1038,1118,1032,164,1168,166,167,1025,169,1028,171,172,173,174,1031,176,177,1030,1110,1169,181,182,183,1105,8470,1108,187,1112,1029,1109,1111,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103],
  "windows-1252":[8364,129,8218,402,8222,8230,8224,8225,710,8240,352,8249,338,141,381,143,144,8216,8217,8220,8221,8226,8211,8212,732,8482,353,8250,339,157,382,376,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255],
  "windows-1253":[8364,129,8218,402,8222,8230,8224,8225,136,8240,138,8249,140,141,142,143,144,8216,8217,8220,8221,8226,8211,8212,152,8482,154,8250,156,157,158,159,160,901,902,163,164,165,166,167,168,169,null,171,172,173,174,8213,176,177,178,179,900,181,182,183,904,905,906,187,908,189,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,null,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,964,965,966,967,968,969,970,971,972,973,974,null],
  "windows-1254":[8364,129,8218,402,8222,8230,8224,8225,710,8240,352,8249,338,141,142,143,144,8216,8217,8220,8221,8226,8211,8212,732,8482,353,8250,339,157,158,376,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,286,209,210,211,212,213,214,215,216,217,218,219,220,304,350,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,287,241,242,243,244,245,246,247,248,249,250,251,252,305,351,255],
  "windows-1255":[8364,129,8218,402,8222,8230,8224,8225,710,8240,138,8249,140,141,142,143,144,8216,8217,8220,8221,8226,8211,8212,732,8482,154,8250,156,157,158,159,160,161,162,163,8362,165,166,167,168,169,215,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,247,187,188,189,190,191,1456,1457,1458,1459,1460,1461,1462,1463,1464,1465,1466,1467,1468,1469,1470,1471,1472,1473,1474,1475,1520,1521,1522,1523,1524,null,null,null,null,null,null,null,1488,1489,1490,1491,1492,1493,1494,1495,1496,1497,1498,1499,1500,1501,1502,1503,1504,1505,1506,1507,1508,1509,1510,1511,1512,1513,1514,null,null,8206,8207,null],
  "windows-1256":[8364,1662,8218,402,8222,8230,8224,8225,710,8240,1657,8249,338,1670,1688,1672,1711,8216,8217,8220,8221,8226,8211,8212,1705,8482,1681,8250,339,8204,8205,1722,160,1548,162,163,164,165,166,167,168,169,1726,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,1563,187,188,189,190,1567,1729,1569,1570,1571,1572,1573,1574,1575,1576,1577,1578,1579,1580,1581,1582,1583,1584,1585,1586,1587,1588,1589,1590,215,1591,1592,1593,1594,1600,1601,1602,1603,224,1604,226,1605,1606,1607,1608,231,232,233,234,235,1609,1610,238,239,1611,1612,1613,1614,244,1615,1616,247,1617,249,1618,251,252,8206,8207,1746],
  "windows-1257":[8364,129,8218,131,8222,8230,8224,8225,136,8240,138,8249,140,168,711,184,144,8216,8217,8220,8221,8226,8211,8212,152,8482,154,8250,156,175,731,159,160,null,162,163,164,null,166,167,216,169,342,171,172,173,174,198,176,177,178,179,180,181,182,183,248,185,343,187,188,189,190,230,260,302,256,262,196,197,280,274,268,201,377,278,290,310,298,315,352,323,325,211,332,213,214,215,370,321,346,362,220,379,381,223,261,303,257,263,228,229,281,275,269,233,378,279,291,311,299,316,353,324,326,243,333,245,246,247,371,322,347,363,252,380,382,729],
  "windows-1258":[8364,129,8218,402,8222,8230,8224,8225,710,8240,138,8249,338,141,142,143,144,8216,8217,8220,8221,8226,8211,8212,732,8482,154,8250,339,157,158,376,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,258,196,197,198,199,200,201,202,203,768,205,206,207,272,209,777,211,212,416,214,215,216,217,218,219,220,431,771,223,224,225,226,259,228,229,230,231,232,233,234,235,769,237,238,239,273,241,803,243,244,417,246,247,248,249,250,251,252,432,8363,255],
  "x-mac-cyrillic":[1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,8224,176,1168,163,167,8226,182,1030,174,169,8482,1026,1106,8800,1027,1107,8734,177,8804,8805,1110,181,1169,1032,1028,1108,1031,1111,1033,1113,1034,1114,1112,1029,172,8730,402,8776,8710,171,187,8230,160,1035,1115,1036,1116,1109,8211,8212,8220,8221,8216,8217,247,8222,1038,1118,1039,1119,8470,1025,1105,1103,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,8364]
};

// For strict environments where `this` inside the global scope
// is `undefined`, take a pure object instead
}(this || {}));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.

/**
 * @fileoverview Global |this| required for resolving indexes in node.
 * @suppress {globalThis}
 */
(function(global) {
  'use strict';

  // If we're in node require encoding-indexes and attach it to the global.
  if (typeof module !== "undefined" && module.exports &&
    !global["encoding-indexes"]) {
    global["encoding-indexes"] =
      __webpack_require__(501)["encoding-indexes"];
  }

  //
  // Utilities
  //

  /**
   * @param {number} a The number to test.
   * @param {number} min The minimum value in the range, inclusive.
   * @param {number} max The maximum value in the range, inclusive.
   * @return {boolean} True if a >= min and a <= max.
   */
  function inRange(a, min, max) {
    return min <= a && a <= max;
  }

  /**
   * @param {!Array.<*>} array The array to check.
   * @param {*} item The item to look for in the array.
   * @return {boolean} True if the item appears in the array.
   */
  function includes(array, item) {
    return array.indexOf(item) !== -1;
  }

  var floor = Math.floor;

  /**
   * @param {*} o
   * @return {Object}
   */
  function ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError('Could not convert argument to dictionary');
  }

  /**
   * @param {string} string Input string of UTF-16 code units.
   * @return {!Array.<number>} Code points.
   */
  function stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode

    // 1. Let S be the DOMString value.
    var s = String(string);

    // 2. Let n be the length of S.
    var n = s.length;

    // 3. Initialize i to 0.
    var i = 0;

    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];

    // 5. While i < n:
    while (i < n) {

      // 1. Let c be the code unit in S at index i.
      var c = s.charCodeAt(i);

      // 2. Depending on the value of c:

      // c < 0xD800 or c > 0xDFFF
      if (c < 0xD800 || c > 0xDFFF) {
        // Append to U the Unicode character with code point c.
        u.push(c);
      }

      // 0xDC00 ≤ c ≤ 0xDFFF
      else if (0xDC00 <= c && c <= 0xDFFF) {
        // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
      }

      // 0xD800 ≤ c ≤ 0xDBFF
      else if (0xD800 <= c && c <= 0xDBFF) {
        // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
        // CHARACTER.
        if (i === n - 1) {
          u.push(0xFFFD);
        }
        // 2. Otherwise, i < n−1:
        else {
          // 1. Let d be the code unit in S at index i+1.
          var d = s.charCodeAt(i + 1);

          // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
          if (0xDC00 <= d && d <= 0xDFFF) {
            // 1. Let a be c & 0x3FF.
            var a = c & 0x3FF;

            // 2. Let b be d & 0x3FF.
            var b = d & 0x3FF;

            // 3. Append to U the Unicode character with code point
            // 2^16+2^10*a+b.
            u.push(0x10000 + (a << 10) + b);

            // 4. Set i to i+1.
            i += 1;
          }

          // 3. Otherwise, d < 0xDC00 or d > 0xDFFF. Append to U a
          // U+FFFD REPLACEMENT CHARACTER.
          else  {
            u.push(0xFFFD);
          }
        }
      }

      // 3. Set i to i+1.
      i += 1;
    }

    // 6. Return U.
    return u;
  }

  /**
   * @param {!Array.<number>} code_points Array of code points.
   * @return {string} string String of UTF-16 code units.
   */
  function codePointsToString(code_points) {
    var s = '';
    for (var i = 0; i < code_points.length; ++i) {
      var cp = code_points[i];
      if (cp <= 0xFFFF) {
        s += String.fromCharCode(cp);
      } else {
        cp -= 0x10000;
        s += String.fromCharCode((cp >> 10) + 0xD800,
                                 (cp & 0x3FF) + 0xDC00);
      }
    }
    return s;
  }


  //
  // Implementation of Encoding specification
  // https://encoding.spec.whatwg.org/
  //

  //
  // 4. Terminology
  //

  /**
   * An ASCII byte is a byte in the range 0x00 to 0x7F, inclusive.
   * @param {number} a The number to test.
   * @return {boolean} True if a is in the range 0x00 to 0x7F, inclusive.
   */
  function isASCIIByte(a) {
    return 0x00 <= a && a <= 0x7F;
  }

  /**
   * An ASCII code point is a code point in the range U+0000 to
   * U+007F, inclusive.
   */
  var isASCIICodePoint = isASCIIByte;


  /**
   * End-of-stream is a special token that signifies no more tokens
   * are in the stream.
   * @const
   */ var end_of_stream = -1;

  /**
   * A stream represents an ordered sequence of tokens.
   *
   * @constructor
   * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide
   * the stream.
   */
  function Stream(tokens) {
    /** @type {!Array.<number>} */
    this.tokens = [].slice.call(tokens);
    // Reversed as push/pop is more efficient than shift/unshift.
    this.tokens.reverse();
  }

  Stream.prototype = {
    /**
     * @return {boolean} True if end-of-stream has been hit.
     */
    endOfStream: function() {
      return !this.tokens.length;
    },

    /**
     * When a token is read from a stream, the first token in the
     * stream must be returned and subsequently removed, and
     * end-of-stream must be returned otherwise.
     *
     * @return {number} Get the next token from the stream, or
     * end_of_stream.
     */
     read: function() {
      if (!this.tokens.length)
        return end_of_stream;
       return this.tokens.pop();
     },

    /**
     * When one or more tokens are prepended to a stream, those tokens
     * must be inserted, in given order, before the first token in the
     * stream.
     *
     * @param {(number|!Array.<number>)} token The token(s) to prepend to the
     * stream.
     */
    prepend: function(token) {
      if (Array.isArray(token)) {
        var tokens = /**@type {!Array.<number>}*/(token);
        while (tokens.length)
          this.tokens.push(tokens.pop());
      } else {
        this.tokens.push(token);
      }
    },

    /**
     * When one or more tokens are pushed to a stream, those tokens
     * must be inserted, in given order, after the last token in the
     * stream.
     *
     * @param {(number|!Array.<number>)} token The tokens(s) to push to the
     * stream.
     */
    push: function(token) {
      if (Array.isArray(token)) {
        var tokens = /**@type {!Array.<number>}*/(token);
        while (tokens.length)
          this.tokens.unshift(tokens.shift());
      } else {
        this.tokens.unshift(token);
      }
    }
  };

  //
  // 5. Encodings
  //

  // 5.1 Encoders and decoders

  /** @const */
  var finished = -1;

  /**
   * @param {boolean} fatal If true, decoding errors raise an exception.
   * @param {number=} opt_code_point Override the standard fallback code point.
   * @return {number} The code point to insert on a decoding error.
   */
  function decoderError(fatal, opt_code_point) {
    if (fatal)
      throw TypeError('Decoder error');
    return opt_code_point || 0xFFFD;
  }

  /**
   * @param {number} code_point The code point that could not be encoded.
   * @return {number} Always throws, no value is actually returned.
   */
  function encoderError(code_point) {
    throw TypeError('The code point ' + code_point + ' could not be encoded.');
  }

  /** @interface */
  function Decoder() {}
  Decoder.prototype = {
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point, or |finished|.
     */
    handler: function(stream, bite) {}
  };

  /** @interface */
  function Encoder() {}
  Encoder.prototype = {
    /**
     * @param {Stream} stream The stream of code points being encoded.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit, or |finished|.
     */
    handler: function(stream, code_point) {}
  };

  // 5.2 Names and labels

  // TODO: Define @typedef for Encoding: {name:string,labels:Array.<string>}
  // https://github.com/google/closure-compiler/issues/247

  /**
   * @param {string} label The encoding label.
   * @return {?{name:string,labels:Array.<string>}}
   */
  function getEncoding(label) {
    // 1. Remove any leading and trailing ASCII whitespace from label.
    label = String(label).trim().toLowerCase();

    // 2. If label is an ASCII case-insensitive match for any of the
    // labels listed in the table below, return the corresponding
    // encoding, and failure otherwise.
    if (Object.prototype.hasOwnProperty.call(label_to_encoding, label)) {
      return label_to_encoding[label];
    }
    return null;
  }

  /**
   * Encodings table: https://encoding.spec.whatwg.org/encodings.json
   * @const
   * @type {!Array.<{
   *          heading: string,
   *          encodings: Array.<{name:string,labels:Array.<string>}>
   *        }>}
   */
  var encodings = [
    {
      "encodings": [
        {
          "labels": [
            "unicode-1-1-utf-8",
            "utf-8",
            "utf8"
          ],
          "name": "UTF-8"
        }
      ],
      "heading": "The Encoding"
    },
    {
      "encodings": [
        {
          "labels": [
            "866",
            "cp866",
            "csibm866",
            "ibm866"
          ],
          "name": "IBM866"
        },
        {
          "labels": [
            "csisolatin2",
            "iso-8859-2",
            "iso-ir-101",
            "iso8859-2",
            "iso88592",
            "iso_8859-2",
            "iso_8859-2:1987",
            "l2",
            "latin2"
          ],
          "name": "ISO-8859-2"
        },
        {
          "labels": [
            "csisolatin3",
            "iso-8859-3",
            "iso-ir-109",
            "iso8859-3",
            "iso88593",
            "iso_8859-3",
            "iso_8859-3:1988",
            "l3",
            "latin3"
          ],
          "name": "ISO-8859-3"
        },
        {
          "labels": [
            "csisolatin4",
            "iso-8859-4",
            "iso-ir-110",
            "iso8859-4",
            "iso88594",
            "iso_8859-4",
            "iso_8859-4:1988",
            "l4",
            "latin4"
          ],
          "name": "ISO-8859-4"
        },
        {
          "labels": [
            "csisolatincyrillic",
            "cyrillic",
            "iso-8859-5",
            "iso-ir-144",
            "iso8859-5",
            "iso88595",
            "iso_8859-5",
            "iso_8859-5:1988"
          ],
          "name": "ISO-8859-5"
        },
        {
          "labels": [
            "arabic",
            "asmo-708",
            "csiso88596e",
            "csiso88596i",
            "csisolatinarabic",
            "ecma-114",
            "iso-8859-6",
            "iso-8859-6-e",
            "iso-8859-6-i",
            "iso-ir-127",
            "iso8859-6",
            "iso88596",
            "iso_8859-6",
            "iso_8859-6:1987"
          ],
          "name": "ISO-8859-6"
        },
        {
          "labels": [
            "csisolatingreek",
            "ecma-118",
            "elot_928",
            "greek",
            "greek8",
            "iso-8859-7",
            "iso-ir-126",
            "iso8859-7",
            "iso88597",
            "iso_8859-7",
            "iso_8859-7:1987",
            "sun_eu_greek"
          ],
          "name": "ISO-8859-7"
        },
        {
          "labels": [
            "csiso88598e",
            "csisolatinhebrew",
            "hebrew",
            "iso-8859-8",
            "iso-8859-8-e",
            "iso-ir-138",
            "iso8859-8",
            "iso88598",
            "iso_8859-8",
            "iso_8859-8:1988",
            "visual"
          ],
          "name": "ISO-8859-8"
        },
        {
          "labels": [
            "csiso88598i",
            "iso-8859-8-i",
            "logical"
          ],
          "name": "ISO-8859-8-I"
        },
        {
          "labels": [
            "csisolatin6",
            "iso-8859-10",
            "iso-ir-157",
            "iso8859-10",
            "iso885910",
            "l6",
            "latin6"
          ],
          "name": "ISO-8859-10"
        },
        {
          "labels": [
            "iso-8859-13",
            "iso8859-13",
            "iso885913"
          ],
          "name": "ISO-8859-13"
        },
        {
          "labels": [
            "iso-8859-14",
            "iso8859-14",
            "iso885914"
          ],
          "name": "ISO-8859-14"
        },
        {
          "labels": [
            "csisolatin9",
            "iso-8859-15",
            "iso8859-15",
            "iso885915",
            "iso_8859-15",
            "l9"
          ],
          "name": "ISO-8859-15"
        },
        {
          "labels": [
            "iso-8859-16"
          ],
          "name": "ISO-8859-16"
        },
        {
          "labels": [
            "cskoi8r",
            "koi",
            "koi8",
            "koi8-r",
            "koi8_r"
          ],
          "name": "KOI8-R"
        },
        {
          "labels": [
            "koi8-ru",
            "koi8-u"
          ],
          "name": "KOI8-U"
        },
        {
          "labels": [
            "csmacintosh",
            "mac",
            "macintosh",
            "x-mac-roman"
          ],
          "name": "macintosh"
        },
        {
          "labels": [
            "dos-874",
            "iso-8859-11",
            "iso8859-11",
            "iso885911",
            "tis-620",
            "windows-874"
          ],
          "name": "windows-874"
        },
        {
          "labels": [
            "cp1250",
            "windows-1250",
            "x-cp1250"
          ],
          "name": "windows-1250"
        },
        {
          "labels": [
            "cp1251",
            "windows-1251",
            "x-cp1251"
          ],
          "name": "windows-1251"
        },
        {
          "labels": [
            "ansi_x3.4-1968",
            "ascii",
            "cp1252",
            "cp819",
            "csisolatin1",
            "ibm819",
            "iso-8859-1",
            "iso-ir-100",
            "iso8859-1",
            "iso88591",
            "iso_8859-1",
            "iso_8859-1:1987",
            "l1",
            "latin1",
            "us-ascii",
            "windows-1252",
            "x-cp1252"
          ],
          "name": "windows-1252"
        },
        {
          "labels": [
            "cp1253",
            "windows-1253",
            "x-cp1253"
          ],
          "name": "windows-1253"
        },
        {
          "labels": [
            "cp1254",
            "csisolatin5",
            "iso-8859-9",
            "iso-ir-148",
            "iso8859-9",
            "iso88599",
            "iso_8859-9",
            "iso_8859-9:1989",
            "l5",
            "latin5",
            "windows-1254",
            "x-cp1254"
          ],
          "name": "windows-1254"
        },
        {
          "labels": [
            "cp1255",
            "windows-1255",
            "x-cp1255"
          ],
          "name": "windows-1255"
        },
        {
          "labels": [
            "cp1256",
            "windows-1256",
            "x-cp1256"
          ],
          "name": "windows-1256"
        },
        {
          "labels": [
            "cp1257",
            "windows-1257",
            "x-cp1257"
          ],
          "name": "windows-1257"
        },
        {
          "labels": [
            "cp1258",
            "windows-1258",
            "x-cp1258"
          ],
          "name": "windows-1258"
        },
        {
          "labels": [
            "x-mac-cyrillic",
            "x-mac-ukrainian"
          ],
          "name": "x-mac-cyrillic"
        }
      ],
      "heading": "Legacy single-byte encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "chinese",
            "csgb2312",
            "csiso58gb231280",
            "gb2312",
            "gb_2312",
            "gb_2312-80",
            "gbk",
            "iso-ir-58",
            "x-gbk"
          ],
          "name": "GBK"
        },
        {
          "labels": [
            "gb18030"
          ],
          "name": "gb18030"
        }
      ],
      "heading": "Legacy multi-byte Chinese (simplified) encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "big5",
            "big5-hkscs",
            "cn-big5",
            "csbig5",
            "x-x-big5"
          ],
          "name": "Big5"
        }
      ],
      "heading": "Legacy multi-byte Chinese (traditional) encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "cseucpkdfmtjapanese",
            "euc-jp",
            "x-euc-jp"
          ],
          "name": "EUC-JP"
        },
        {
          "labels": [
            "csiso2022jp",
            "iso-2022-jp"
          ],
          "name": "ISO-2022-JP"
        },
        {
          "labels": [
            "csshiftjis",
            "ms932",
            "ms_kanji",
            "shift-jis",
            "shift_jis",
            "sjis",
            "windows-31j",
            "x-sjis"
          ],
          "name": "Shift_JIS"
        }
      ],
      "heading": "Legacy multi-byte Japanese encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "cseuckr",
            "csksc56011987",
            "euc-kr",
            "iso-ir-149",
            "korean",
            "ks_c_5601-1987",
            "ks_c_5601-1989",
            "ksc5601",
            "ksc_5601",
            "windows-949"
          ],
          "name": "EUC-KR"
        }
      ],
      "heading": "Legacy multi-byte Korean encodings"
    },
    {
      "encodings": [
        {
          "labels": [
            "csiso2022kr",
            "hz-gb-2312",
            "iso-2022-cn",
            "iso-2022-cn-ext",
            "iso-2022-kr"
          ],
          "name": "replacement"
        },
        {
          "labels": [
            "utf-16be"
          ],
          "name": "UTF-16BE"
        },
        {
          "labels": [
            "utf-16",
            "utf-16le"
          ],
          "name": "UTF-16LE"
        },
        {
          "labels": [
            "x-user-defined"
          ],
          "name": "x-user-defined"
        }
      ],
      "heading": "Legacy miscellaneous encodings"
    }
  ];

  // Label to encoding registry.
  /** @type {Object.<string,{name:string,labels:Array.<string>}>} */
  var label_to_encoding = {};
  encodings.forEach(function(category) {
    category.encodings.forEach(function(encoding) {
      encoding.labels.forEach(function(label) {
        label_to_encoding[label] = encoding;
      });
    });
  });

  // Registry of of encoder/decoder factories, by encoding name.
  /** @type {Object.<string, function({fatal:boolean}): Encoder>} */
  var encoders = {};
  /** @type {Object.<string, function({fatal:boolean}): Decoder>} */
  var decoders = {};

  //
  // 6. Indexes
  //

  /**
   * @param {number} pointer The |pointer| to search for.
   * @param {(!Array.<?number>|undefined)} index The |index| to search within.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in |index|.
   */
  function indexCodePointFor(pointer, index) {
    if (!index) return null;
    return index[pointer] || null;
  }

  /**
   * @param {number} code_point The |code point| to search for.
   * @param {!Array.<?number>} index The |index| to search within.
   * @return {?number} The first pointer corresponding to |code point| in
   *     |index|, or null if |code point| is not in |index|.
   */
  function indexPointerFor(code_point, index) {
    var pointer = index.indexOf(code_point);
    return pointer === -1 ? null : pointer;
  }

  /**
   * @param {string} name Name of the index.
   * @return {(!Array.<number>|!Array.<Array.<number>>)}
   *  */
  function index(name) {
    if (!('encoding-indexes' in global)) {
      throw Error("Indexes missing." +
                  " Did you forget to include encoding-indexes.js first?");
    }
    return global['encoding-indexes'][name];
  }

  /**
   * @param {number} pointer The |pointer| to search for in the gb18030 index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the gb18030 index.
   */
  function indexGB18030RangesCodePointFor(pointer) {
    // 1. If pointer is greater than 39419 and less than 189000, or
    // pointer is greater than 1237575, return null.
    if ((pointer > 39419 && pointer < 189000) || (pointer > 1237575))
      return null;

    // 2. If pointer is 7457, return code point U+E7C7.
    if (pointer === 7457) return 0xE7C7;

    // 3. Let offset be the last pointer in index gb18030 ranges that
    // is equal to or less than pointer and let code point offset be
    // its corresponding code point.
    var offset = 0;
    var code_point_offset = 0;
    var idx = index('gb18030-ranges');
    var i;
    for (i = 0; i < idx.length; ++i) {
      /** @type {!Array.<number>} */
      var entry = idx[i];
      if (entry[0] <= pointer) {
        offset = entry[0];
        code_point_offset = entry[1];
      } else {
        break;
      }
    }

    // 4. Return a code point whose value is code point offset +
    // pointer − offset.
    return code_point_offset + pointer - offset;
  }

  /**
   * @param {number} code_point The |code point| to locate in the gb18030 index.
   * @return {number} The first pointer corresponding to |code point| in the
   *     gb18030 index.
   */
  function indexGB18030RangesPointerFor(code_point) {
    // 1. If code point is U+E7C7, return pointer 7457.
    if (code_point === 0xE7C7) return 7457;

    // 2. Let offset be the last code point in index gb18030 ranges
    // that is equal to or less than code point and let pointer offset
    // be its corresponding pointer.
    var offset = 0;
    var pointer_offset = 0;
    var idx = index('gb18030-ranges');
    var i;
    for (i = 0; i < idx.length; ++i) {
      /** @type {!Array.<number>} */
      var entry = idx[i];
      if (entry[1] <= code_point) {
        offset = entry[1];
        pointer_offset = entry[0];
      } else {
        break;
      }
    }

    // 3. Return a pointer whose value is pointer offset + code point
    // − offset.
    return pointer_offset + code_point - offset;
  }

  /**
   * @param {number} code_point The |code_point| to search for in the Shift_JIS
   *     index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the Shift_JIS index.
   */
  function indexShiftJISPointerFor(code_point) {
    // 1. Let index be index jis0208 excluding all entries whose
    // pointer is in the range 8272 to 8835, inclusive.
    shift_jis_index = shift_jis_index ||
      index('jis0208').map(function(code_point, pointer) {
        return inRange(pointer, 8272, 8835) ? null : code_point;
      });
    var index_ = shift_jis_index;

    // 2. Return the index pointer for code point in index.
    return index_.indexOf(code_point);
  }
  var shift_jis_index;

  /**
   * @param {number} code_point The |code_point| to search for in the big5
   *     index.
   * @return {?number} The code point corresponding to |pointer| in |index|,
   *     or null if |code point| is not in the big5 index.
   */
  function indexBig5PointerFor(code_point) {
    // 1. Let index be index Big5 excluding all entries whose pointer
    big5_index_no_hkscs = big5_index_no_hkscs ||
      index('big5').map(function(code_point, pointer) {
        return (pointer < (0xA1 - 0x81) * 157) ? null : code_point;
      });
    var index_ = big5_index_no_hkscs;

    // 2. If code point is U+2550, U+255E, U+2561, U+256A, U+5341, or
    // U+5345, return the last pointer corresponding to code point in
    // index.
    if (code_point === 0x2550 || code_point === 0x255E ||
        code_point === 0x2561 || code_point === 0x256A ||
        code_point === 0x5341 || code_point === 0x5345) {
      return index_.lastIndexOf(code_point);
    }

    // 3. Return the index pointer for code point in index.
    return indexPointerFor(code_point, index_);
  }
  var big5_index_no_hkscs;

  //
  // 8. API
  //

  /** @const */ var DEFAULT_ENCODING = 'utf-8';

  // 8.1 Interface TextDecoder

  /**
   * @constructor
   * @param {string=} label The label of the encoding;
   *     defaults to 'utf-8'.
   * @param {Object=} options
   */
  function TextDecoder(label, options) {
    // Web IDL conventions
    if (!(this instanceof TextDecoder))
      throw TypeError('Called as a function. Did you forget \'new\'?');
    label = label !== undefined ? String(label) : DEFAULT_ENCODING;
    options = ToDictionary(options);

    // A TextDecoder object has an associated encoding, decoder,
    // stream, ignore BOM flag (initially unset), BOM seen flag
    // (initially unset), error mode (initially replacement), and do
    // not flush flag (initially unset).

    /** @private */
    this._encoding = null;
    /** @private @type {?Decoder} */
    this._decoder = null;
    /** @private @type {boolean} */
    this._ignoreBOM = false;
    /** @private @type {boolean} */
    this._BOMseen = false;
    /** @private @type {string} */
    this._error_mode = 'replacement';
    /** @private @type {boolean} */
    this._do_not_flush = false;


    // 1. Let encoding be the result of getting an encoding from
    // label.
    var encoding = getEncoding(label);

    // 2. If encoding is failure or replacement, throw a RangeError.
    if (encoding === null || encoding.name === 'replacement')
      throw RangeError('Unknown encoding: ' + label);
    if (!decoders[encoding.name]) {
      throw Error('Decoder not present.' +
                  ' Did you forget to include encoding-indexes.js first?');
    }

    // 3. Let dec be a new TextDecoder object.
    var dec = this;

    // 4. Set dec's encoding to encoding.
    dec._encoding = encoding;

    // 5. If options's fatal member is true, set dec's error mode to
    // fatal.
    if (Boolean(options['fatal']))
      dec._error_mode = 'fatal';

    // 6. If options's ignoreBOM member is true, set dec's ignore BOM
    // flag.
    if (Boolean(options['ignoreBOM']))
      dec._ignoreBOM = true;

    // For pre-ES5 runtimes:
    if (!Object.defineProperty) {
      this.encoding = dec._encoding.name.toLowerCase();
      this.fatal = dec._error_mode === 'fatal';
      this.ignoreBOM = dec._ignoreBOM;
    }

    // 7. Return dec.
    return dec;
  }

  if (Object.defineProperty) {
    // The encoding attribute's getter must return encoding's name.
    Object.defineProperty(TextDecoder.prototype, 'encoding', {
      /** @this {TextDecoder} */
      get: function() { return this._encoding.name.toLowerCase(); }
    });

    // The fatal attribute's getter must return true if error mode
    // is fatal, and false otherwise.
    Object.defineProperty(TextDecoder.prototype, 'fatal', {
      /** @this {TextDecoder} */
      get: function() { return this._error_mode === 'fatal'; }
    });

    // The ignoreBOM attribute's getter must return true if ignore
    // BOM flag is set, and false otherwise.
    Object.defineProperty(TextDecoder.prototype, 'ignoreBOM', {
      /** @this {TextDecoder} */
      get: function() { return this._ignoreBOM; }
    });
  }

  /**
   * @param {BufferSource=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  TextDecoder.prototype.decode = function decode(input, options) {
    var bytes;
    if (typeof input === 'object' && input instanceof ArrayBuffer) {
      bytes = new Uint8Array(input);
    } else if (typeof input === 'object' && 'buffer' in input &&
               input.buffer instanceof ArrayBuffer) {
      bytes = new Uint8Array(input.buffer,
                             input.byteOffset,
                             input.byteLength);
    } else {
      bytes = new Uint8Array(0);
    }

    options = ToDictionary(options);

    // 1. If the do not flush flag is unset, set decoder to a new
    // encoding's decoder, set stream to a new stream, and unset the
    // BOM seen flag.
    if (!this._do_not_flush) {
      this._decoder = decoders[this._encoding.name]({
        fatal: this._error_mode === 'fatal'});
      this._BOMseen = false;
    }

    // 2. If options's stream is true, set the do not flush flag, and
    // unset the do not flush flag otherwise.
    this._do_not_flush = Boolean(options['stream']);

    // 3. If input is given, push a copy of input to stream.
    // TODO: Align with spec algorithm - maintain stream on instance.
    var input_stream = new Stream(bytes);

    // 4. Let output be a new stream.
    var output = [];

    /** @type {?(number|!Array.<number>)} */
    var result;

    // 5. While true:
    while (true) {
      // 1. Let token be the result of reading from stream.
      var token = input_stream.read();

      // 2. If token is end-of-stream and the do not flush flag is
      // set, return output, serialized.
      // TODO: Align with spec algorithm.
      if (token === end_of_stream)
        break;

      // 3. Otherwise, run these subsubsteps:

      // 1. Let result be the result of processing token for decoder,
      // stream, output, and error mode.
      result = this._decoder.handler(input_stream, token);

      // 2. If result is finished, return output, serialized.
      if (result === finished)
        break;

      if (result !== null) {
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      }

      // 3. Otherwise, if result is error, throw a TypeError.
      // (Thrown in handler)

      // 4. Otherwise, do nothing.
    }
    // TODO: Align with spec algorithm.
    if (!this._do_not_flush) {
      do {
        result = this._decoder.handler(input_stream, input_stream.read());
        if (result === finished)
          break;
        if (result === null)
          continue;
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      } while (!input_stream.endOfStream());
      this._decoder = null;
    }

    // A TextDecoder object also has an associated serialize stream
    // algorithm...
    /**
     * @param {!Array.<number>} stream
     * @return {string}
     * @this {TextDecoder}
     */
    function serializeStream(stream) {
      // 1. Let token be the result of reading from stream.
      // (Done in-place on array, rather than as a stream)

      // 2. If encoding is UTF-8, UTF-16BE, or UTF-16LE, and ignore
      // BOM flag and BOM seen flag are unset, run these subsubsteps:
      if (includes(['UTF-8', 'UTF-16LE', 'UTF-16BE'], this._encoding.name) &&
          !this._ignoreBOM && !this._BOMseen) {
        if (stream.length > 0 && stream[0] === 0xFEFF) {
          // 1. If token is U+FEFF, set BOM seen flag.
          this._BOMseen = true;
          stream.shift();
        } else if (stream.length > 0) {
          // 2. Otherwise, if token is not end-of-stream, set BOM seen
          // flag and append token to stream.
          this._BOMseen = true;
        } else {
          // 3. Otherwise, if token is not end-of-stream, append token
          // to output.
          // (no-op)
        }
      }
      // 4. Otherwise, return output.
      return codePointsToString(stream);
    }

    return serializeStream.call(this, output);
  };

  // 8.2 Interface TextEncoder

  /**
   * @constructor
   * @param {string=} label The label of the encoding. NONSTANDARD.
   * @param {Object=} options NONSTANDARD.
   */
  function TextEncoder(label, options) {
    // Web IDL conventions
    if (!(this instanceof TextEncoder))
      throw TypeError('Called as a function. Did you forget \'new\'?');
    options = ToDictionary(options);

    // A TextEncoder object has an associated encoding and encoder.

    /** @private */
    this._encoding = null;
    /** @private @type {?Encoder} */
    this._encoder = null;

    // Non-standard
    /** @private @type {boolean} */
    this._do_not_flush = false;
    /** @private @type {string} */
    this._fatal = Boolean(options['fatal']) ? 'fatal' : 'replacement';

    // 1. Let enc be a new TextEncoder object.
    var enc = this;

    // 2. Set enc's encoding to UTF-8's encoder.
    if (Boolean(options['NONSTANDARD_allowLegacyEncoding'])) {
      // NONSTANDARD behavior.
      label = label !== undefined ? String(label) : DEFAULT_ENCODING;
      var encoding = getEncoding(label);
      if (encoding === null || encoding.name === 'replacement')
        throw RangeError('Unknown encoding: ' + label);
      if (!encoders[encoding.name]) {
        throw Error('Encoder not present.' +
                    ' Did you forget to include encoding-indexes.js first?');
      }
      enc._encoding = encoding;
    } else {
      // Standard behavior.
      enc._encoding = getEncoding('utf-8');

      if (label !== undefined && 'console' in global) {
        console.warn('TextEncoder constructor called with encoding label, '
                     + 'which is ignored.');
      }
    }

    // For pre-ES5 runtimes:
    if (!Object.defineProperty)
      this.encoding = enc._encoding.name.toLowerCase();

    // 3. Return enc.
    return enc;
  }

  if (Object.defineProperty) {
    // The encoding attribute's getter must return encoding's name.
    Object.defineProperty(TextEncoder.prototype, 'encoding', {
      /** @this {TextEncoder} */
      get: function() { return this._encoding.name.toLowerCase(); }
    });
  }

  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {!Uint8Array} Encoded bytes, as a Uint8Array.
   */
  TextEncoder.prototype.encode = function encode(opt_string, options) {
    opt_string = opt_string === undefined ? '' : String(opt_string);
    options = ToDictionary(options);

    // NOTE: This option is nonstandard. None of the encodings
    // permitted for encoding (i.e. UTF-8, UTF-16) are stateful when
    // the input is a USVString so streaming is not necessary.
    if (!this._do_not_flush)
      this._encoder = encoders[this._encoding.name]({
        fatal: this._fatal === 'fatal'});
    this._do_not_flush = Boolean(options['stream']);

    // 1. Convert input to a stream.
    var input = new Stream(stringToCodePoints(opt_string));

    // 2. Let output be a new stream
    var output = [];

    /** @type {?(number|!Array.<number>)} */
    var result;
    // 3. While true, run these substeps:
    while (true) {
      // 1. Let token be the result of reading from input.
      var token = input.read();
      if (token === end_of_stream)
        break;
      // 2. Let result be the result of processing token for encoder,
      // input, output.
      result = this._encoder.handler(input, token);
      if (result === finished)
        break;
      if (Array.isArray(result))
        output.push.apply(output, /**@type {!Array.<number>}*/(result));
      else
        output.push(result);
    }
    // TODO: Align with spec algorithm.
    if (!this._do_not_flush) {
      while (true) {
        result = this._encoder.handler(input, input.read());
        if (result === finished)
          break;
        if (Array.isArray(result))
          output.push.apply(output, /**@type {!Array.<number>}*/(result));
        else
          output.push(result);
      }
      this._encoder = null;
    }
    // 3. If result is finished, convert output into a byte sequence,
    // and then return a Uint8Array object wrapping an ArrayBuffer
    // containing output.
    return new Uint8Array(output);
  };


  //
  // 9. The encoding
  //

  // 9.1 utf-8

  // 9.1.1 utf-8 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function UTF8Decoder(options) {
    var fatal = options.fatal;

    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0,
        /** @type {number} */ utf8_bytes_seen = 0,
        /** @type {number} */ utf8_bytes_needed = 0,
        /** @type {number} */ utf8_lower_boundary = 0x80,
        /** @type {number} */ utf8_upper_boundary = 0xBF;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
      // set utf-8 bytes needed to 0 and return error.
      if (bite === end_of_stream && utf8_bytes_needed !== 0) {
        utf8_bytes_needed = 0;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 3. If utf-8 bytes needed is 0, based on byte:
      if (utf8_bytes_needed === 0) {

        // 0x00 to 0x7F
        if (inRange(bite, 0x00, 0x7F)) {
          // Return a code point whose value is byte.
          return bite;
        }

        // 0xC2 to 0xDF
        else if (inRange(bite, 0xC2, 0xDF)) {
          // 1. Set utf-8 bytes needed to 1.
          utf8_bytes_needed = 1;

          // 2. Set UTF-8 code point to byte & 0x1F.
          utf8_code_point = bite & 0x1F;
        }

        // 0xE0 to 0xEF
        else if (inRange(bite, 0xE0, 0xEF)) {
          // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
          if (bite === 0xE0)
            utf8_lower_boundary = 0xA0;
          // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
          if (bite === 0xED)
            utf8_upper_boundary = 0x9F;
          // 3. Set utf-8 bytes needed to 2.
          utf8_bytes_needed = 2;
          // 4. Set UTF-8 code point to byte & 0xF.
          utf8_code_point = bite & 0xF;
        }

        // 0xF0 to 0xF4
        else if (inRange(bite, 0xF0, 0xF4)) {
          // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
          if (bite === 0xF0)
            utf8_lower_boundary = 0x90;
          // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
          if (bite === 0xF4)
            utf8_upper_boundary = 0x8F;
          // 3. Set utf-8 bytes needed to 3.
          utf8_bytes_needed = 3;
          // 4. Set UTF-8 code point to byte & 0x7.
          utf8_code_point = bite & 0x7;
        }

        // Otherwise
        else {
          // Return error.
          return decoderError(fatal);
        }

        // Return continue.
        return null;
      }

      // 4. If byte is not in the range utf-8 lower boundary to utf-8
      // upper boundary, inclusive, run these substeps:
      if (!inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {

        // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
        // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
        // utf-8 upper boundary to 0xBF.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;

        // 2. Prepend byte to stream.
        stream.prepend(bite);

        // 3. Return error.
        return decoderError(fatal);
      }

      // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
      // to 0xBF.
      utf8_lower_boundary = 0x80;
      utf8_upper_boundary = 0xBF;

      // 6. Set UTF-8 code point to (UTF-8 code point << 6) | (byte &
      // 0x3F)
      utf8_code_point = (utf8_code_point << 6) | (bite & 0x3F);

      // 7. Increase utf-8 bytes seen by one.
      utf8_bytes_seen += 1;

      // 8. If utf-8 bytes seen is not equal to utf-8 bytes needed,
      // continue.
      if (utf8_bytes_seen !== utf8_bytes_needed)
        return null;

      // 9. Let code point be utf-8 code point.
      var code_point = utf8_code_point;

      // 10. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
      // seen to 0.
      utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;

      // 11. Return a code point whose value is code point.
      return code_point;
    };
  }

  // 9.1.2 utf-8 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Set count and offset based on the range code point is in:
      var count, offset;
      // U+0080 to U+07FF, inclusive:
      if (inRange(code_point, 0x0080, 0x07FF)) {
        // 1 and 0xC0
        count = 1;
        offset = 0xC0;
      }
      // U+0800 to U+FFFF, inclusive:
      else if (inRange(code_point, 0x0800, 0xFFFF)) {
        // 2 and 0xE0
        count = 2;
        offset = 0xE0;
      }
      // U+10000 to U+10FFFF, inclusive:
      else if (inRange(code_point, 0x10000, 0x10FFFF)) {
        // 3 and 0xF0
        count = 3;
        offset = 0xF0;
      }

      // 4. Let bytes be a byte sequence whose first byte is (code
      // point >> (6 × count)) + offset.
      var bytes = [(code_point >> (6 * count)) + offset];

      // 5. Run these substeps while count is greater than 0:
      while (count > 0) {

        // 1. Set temp to code point >> (6 × (count − 1)).
        var temp = code_point >> (6 * (count - 1));

        // 2. Append to bytes 0x80 | (temp & 0x3F).
        bytes.push(0x80 | (temp & 0x3F));

        // 3. Decrease count by one.
        count -= 1;
      }

      // 6. Return bytes bytes, in order.
      return bytes;
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['UTF-8'] = function(options) {
    return new UTF8Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['UTF-8'] = function(options) {
    return new UTF8Decoder(options);
  };

  //
  // 10. Legacy single-byte encodings
  //

  // 10.1 single-byte decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {!Array.<number>} index The encoding index.
   * @param {{fatal: boolean}} options
   */
  function SingleByteDecoder(index, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 2. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 3. Let code point be the index code point for byte − 0x80 in
      // index single-byte.
      var code_point = index[bite - 0x80];

      // 4. If code point is null, return error.
      if (code_point === null)
        return decoderError(fatal);

      // 5. Return a code point whose value is code point.
      return code_point;
    };
  }

  // 10.2 single-byte encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {!Array.<?number>} index The encoding index.
   * @param {{fatal: boolean}} options
   */
  function SingleByteEncoder(index, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index pointer for code point in index
      // single-byte.
      var pointer = indexPointerFor(code_point, index);

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        encoderError(code_point);

      // 5. Return a byte whose value is pointer + 0x80.
      return pointer + 0x80;
    };
  }

  (function() {
    if (!('encoding-indexes' in global))
      return;
    encodings.forEach(function(category) {
      if (category.heading !== 'Legacy single-byte encodings')
        return;
      category.encodings.forEach(function(encoding) {
        var name = encoding.name;
        var idx = index(name.toLowerCase());
        /** @param {{fatal: boolean}} options */
        decoders[name] = function(options) {
          return new SingleByteDecoder(idx, options);
        };
        /** @param {{fatal: boolean}} options */
        encoders[name] = function(options) {
          return new SingleByteEncoder(idx, options);
        };
      });
    });
  }());

  //
  // 11. Legacy multi-byte Chinese (simplified) encodings
  //

  // 11.1 gbk

  // 11.1.1 gbk decoder
  // gbk's decoder is gb18030's decoder.
  /** @param {{fatal: boolean}} options */
  decoders['GBK'] = function(options) {
    return new GB18030Decoder(options);
  };

  // 11.1.2 gbk encoder
  // gbk's encoder is gb18030's encoder with its gbk flag set.
  /** @param {{fatal: boolean}} options */
  encoders['GBK'] = function(options) {
    return new GB18030Encoder(options, true);
  };

  // 11.2 gb18030

  // 11.2.1 gb18030 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function GB18030Decoder(options) {
    var fatal = options.fatal;
    // gb18030's decoder has an associated gb18030 first, gb18030
    // second, and gb18030 third (all initially 0x00).
    var /** @type {number} */ gb18030_first = 0x00,
        /** @type {number} */ gb18030_second = 0x00,
        /** @type {number} */ gb18030_third = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and gb18030 first, gb18030
      // second, and gb18030 third are 0x00, return finished.
      if (bite === end_of_stream && gb18030_first === 0x00 &&
          gb18030_second === 0x00 && gb18030_third === 0x00) {
        return finished;
      }
      // 2. If byte is end-of-stream, and gb18030 first, gb18030
      // second, or gb18030 third is not 0x00, set gb18030 first,
      // gb18030 second, and gb18030 third to 0x00, and return error.
      if (bite === end_of_stream &&
          (gb18030_first !== 0x00 || gb18030_second !== 0x00 ||
           gb18030_third !== 0x00)) {
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        gb18030_third = 0x00;
        decoderError(fatal);
      }
      var code_point;
      // 3. If gb18030 third is not 0x00, run these substeps:
      if (gb18030_third !== 0x00) {
        // 1. Let code point be null.
        code_point = null;
        // 2. If byte is in the range 0x30 to 0x39, inclusive, set
        // code point to the index gb18030 ranges code point for
        // (((gb18030 first − 0x81) × 10 + gb18030 second − 0x30) ×
        // 126 + gb18030 third − 0x81) × 10 + byte − 0x30.
        if (inRange(bite, 0x30, 0x39)) {
          code_point = indexGB18030RangesCodePointFor(
              (((gb18030_first - 0x81) * 10 + gb18030_second - 0x30) * 126 +
               gb18030_third - 0x81) * 10 + bite - 0x30);
        }

        // 3. Let buffer be a byte sequence consisting of gb18030
        // second, gb18030 third, and byte, in order.
        var buffer = [gb18030_second, gb18030_third, bite];

        // 4. Set gb18030 first, gb18030 second, and gb18030 third to
        // 0x00.
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        gb18030_third = 0x00;

        // 5. If code point is null, prepend buffer to stream and
        // return error.
        if (code_point === null) {
          stream.prepend(buffer);
          return decoderError(fatal);
        }

        // 6. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If gb18030 second is not 0x00, run these substeps:
      if (gb18030_second !== 0x00) {

        // 1. If byte is in the range 0x81 to 0xFE, inclusive, set
        // gb18030 third to byte and return continue.
        if (inRange(bite, 0x81, 0xFE)) {
          gb18030_third = bite;
          return null;
        }

        // 2. Prepend gb18030 second followed by byte to stream, set
        // gb18030 first and gb18030 second to 0x00, and return error.
        stream.prepend([gb18030_second, bite]);
        gb18030_first = 0x00;
        gb18030_second = 0x00;
        return decoderError(fatal);
      }

      // 5. If gb18030 first is not 0x00, run these substeps:
      if (gb18030_first !== 0x00) {

        // 1. If byte is in the range 0x30 to 0x39, inclusive, set
        // gb18030 second to byte and return continue.
        if (inRange(bite, 0x30, 0x39)) {
          gb18030_second = bite;
          return null;
        }

        // 2. Let lead be gb18030 first, let pointer be null, and set
        // gb18030 first to 0x00.
        var lead = gb18030_first;
        var pointer = null;
        gb18030_first = 0x00;

        // 3. Let offset be 0x40 if byte is less than 0x7F and 0x41
        // otherwise.
        var offset = bite < 0x7F ? 0x40 : 0x41;

        // 4. If byte is in the range 0x40 to 0x7E, inclusive, or 0x80
        // to 0xFE, inclusive, set pointer to (lead − 0x81) × 190 +
        // (byte − offset).
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0x80, 0xFE))
          pointer = (lead - 0x81) * 190 + (bite - offset);

        // 5. Let code point be null if pointer is null and the index
        // code point for pointer in index gb18030 otherwise.
        code_point = pointer === null ? null :
            indexCodePointFor(pointer, index('gb18030'));

        // 6. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 7. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 8. Return a code point whose value is code point.
        return code_point;
      }

      // 6. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 7. If byte is 0x80, return code point U+20AC.
      if (bite === 0x80)
        return 0x20AC;

      // 8. If byte is in the range 0x81 to 0xFE, inclusive, set
      // gb18030 first to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        gb18030_first = bite;
        return null;
      }

      // 9. Return error.
      return decoderError(fatal);
    };
  }

  // 11.2.2 gb18030 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   * @param {boolean=} gbk_flag
   */
  function GB18030Encoder(options, gbk_flag) {
    var fatal = options.fatal;
    // gb18030's decoder has an associated gbk flag (initially unset).
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is U+E5E5, return error with code point.
      if (code_point === 0xE5E5)
        return encoderError(code_point);

      // 4. If the gbk flag is set and code point is U+20AC, return
      // byte 0x80.
      if (gbk_flag && code_point === 0x20AC)
        return 0x80;

      // 5. Let pointer be the index pointer for code point in index
      // gb18030.
      var pointer = indexPointerFor(code_point, index('gb18030'));

      // 6. If pointer is not null, run these substeps:
      if (pointer !== null) {

        // 1. Let lead be floor(pointer / 190) + 0x81.
        var lead = floor(pointer / 190) + 0x81;

        // 2. Let trail be pointer % 190.
        var trail = pointer % 190;

        // 3. Let offset be 0x40 if trail is less than 0x3F and 0x41 otherwise.
        var offset = trail < 0x3F ? 0x40 : 0x41;

        // 4. Return two bytes whose values are lead and trail + offset.
        return [lead, trail + offset];
      }

      // 7. If gbk flag is set, return error with code point.
      if (gbk_flag)
        return encoderError(code_point);

      // 8. Set pointer to the index gb18030 ranges pointer for code
      // point.
      pointer = indexGB18030RangesPointerFor(code_point);

      // 9. Let byte1 be floor(pointer / 10 / 126 / 10).
      var byte1 = floor(pointer / 10 / 126 / 10);

      // 10. Set pointer to pointer − byte1 × 10 × 126 × 10.
      pointer = pointer - byte1 * 10 * 126 * 10;

      // 11. Let byte2 be floor(pointer / 10 / 126).
      var byte2 = floor(pointer / 10 / 126);

      // 12. Set pointer to pointer − byte2 × 10 × 126.
      pointer = pointer - byte2 * 10 * 126;

      // 13. Let byte3 be floor(pointer / 10).
      var byte3 = floor(pointer / 10);

      // 14. Let byte4 be pointer − byte3 × 10.
      var byte4 = pointer - byte3 * 10;

      // 15. Return four bytes whose values are byte1 + 0x81, byte2 +
      // 0x30, byte3 + 0x81, byte4 + 0x30.
      return [byte1 + 0x81,
              byte2 + 0x30,
              byte3 + 0x81,
              byte4 + 0x30];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['gb18030'] = function(options) {
    return new GB18030Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['gb18030'] = function(options) {
    return new GB18030Decoder(options);
  };


  //
  // 12. Legacy multi-byte Chinese (traditional) encodings
  //

  // 12.1 Big5

  // 12.1.1 Big5 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function Big5Decoder(options) {
    var fatal = options.fatal;
    // Big5's decoder has an associated Big5 lead (initially 0x00).
    var /** @type {number} */ Big5_lead = 0x00;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and Big5 lead is not 0x00, set
      // Big5 lead to 0x00 and return error.
      if (bite === end_of_stream && Big5_lead !== 0x00) {
        Big5_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and Big5 lead is 0x00, return
      // finished.
      if (bite === end_of_stream && Big5_lead === 0x00)
        return finished;

      // 3. If Big5 lead is not 0x00, let lead be Big5 lead, let
      // pointer be null, set Big5 lead to 0x00, and then run these
      // substeps:
      if (Big5_lead !== 0x00) {
        var lead = Big5_lead;
        var pointer = null;
        Big5_lead = 0x00;

        // 1. Let offset be 0x40 if byte is less than 0x7F and 0x62
        // otherwise.
        var offset = bite < 0x7F ? 0x40 : 0x62;

        // 2. If byte is in the range 0x40 to 0x7E, inclusive, or 0xA1
        // to 0xFE, inclusive, set pointer to (lead − 0x81) × 157 +
        // (byte − offset).
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0xA1, 0xFE))
          pointer = (lead - 0x81) * 157 + (bite - offset);

        // 3. If there is a row in the table below whose first column
        // is pointer, return the two code points listed in its second
        // column
        // Pointer | Code points
        // --------+--------------
        // 1133    | U+00CA U+0304
        // 1135    | U+00CA U+030C
        // 1164    | U+00EA U+0304
        // 1166    | U+00EA U+030C
        switch (pointer) {
          case 1133: return [0x00CA, 0x0304];
          case 1135: return [0x00CA, 0x030C];
          case 1164: return [0x00EA, 0x0304];
          case 1166: return [0x00EA, 0x030C];
        }

        // 4. Let code point be null if pointer is null and the index
        // code point for pointer in index Big5 otherwise.
        var code_point = (pointer === null) ? null :
            indexCodePointFor(pointer, index('big5'));

        // 5. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 6. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 7. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 5. If byte is in the range 0x81 to 0xFE, inclusive, set Big5
      // lead to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        Big5_lead = bite;
        return null;
      }

      // 6. Return error.
      return decoderError(fatal);
    };
  }

  // 12.1.2 Big5 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function Big5Encoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index Big5 pointer for code point.
      var pointer = indexBig5PointerFor(code_point);

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 5. Let lead be floor(pointer / 157) + 0x81.
      var lead = floor(pointer / 157) + 0x81;

      // 6. If lead is less than 0xA1, return error with code point.
      if (lead < 0xA1)
        return encoderError(code_point);

      // 7. Let trail be pointer % 157.
      var trail = pointer % 157;

      // 8. Let offset be 0x40 if trail is less than 0x3F and 0x62
      // otherwise.
      var offset = trail < 0x3F ? 0x40 : 0x62;

      // Return two bytes whose values are lead and trail + offset.
      return [lead, trail + offset];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['Big5'] = function(options) {
    return new Big5Encoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['Big5'] = function(options) {
    return new Big5Decoder(options);
  };


  //
  // 13. Legacy multi-byte Japanese encodings
  //

  // 13.1 euc-jp

  // 13.1.1 euc-jp decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function EUCJPDecoder(options) {
    var fatal = options.fatal;

    // euc-jp's decoder has an associated euc-jp jis0212 flag
    // (initially unset) and euc-jp lead (initially 0x00).
    var /** @type {boolean} */ eucjp_jis0212_flag = false,
        /** @type {number} */ eucjp_lead = 0x00;

    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and euc-jp lead is not 0x00, set
      // euc-jp lead to 0x00, and return error.
      if (bite === end_of_stream && eucjp_lead !== 0x00) {
        eucjp_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and euc-jp lead is 0x00, return
      // finished.
      if (bite === end_of_stream && eucjp_lead === 0x00)
        return finished;

      // 3. If euc-jp lead is 0x8E and byte is in the range 0xA1 to
      // 0xDF, inclusive, set euc-jp lead to 0x00 and return a code
      // point whose value is 0xFF61 − 0xA1 + byte.
      if (eucjp_lead === 0x8E && inRange(bite, 0xA1, 0xDF)) {
        eucjp_lead = 0x00;
        return 0xFF61 - 0xA1 + bite;
      }

      // 4. If euc-jp lead is 0x8F and byte is in the range 0xA1 to
      // 0xFE, inclusive, set the euc-jp jis0212 flag, set euc-jp lead
      // to byte, and return continue.
      if (eucjp_lead === 0x8F && inRange(bite, 0xA1, 0xFE)) {
        eucjp_jis0212_flag = true;
        eucjp_lead = bite;
        return null;
      }

      // 5. If euc-jp lead is not 0x00, let lead be euc-jp lead, set
      // euc-jp lead to 0x00, and run these substeps:
      if (eucjp_lead !== 0x00) {
        var lead = eucjp_lead;
        eucjp_lead = 0x00;

        // 1. Let code point be null.
        var code_point = null;

        // 2. If lead and byte are both in the range 0xA1 to 0xFE,
        // inclusive, set code point to the index code point for (lead
        // − 0xA1) × 94 + byte − 0xA1 in index jis0208 if the euc-jp
        // jis0212 flag is unset and in index jis0212 otherwise.
        if (inRange(lead, 0xA1, 0xFE) && inRange(bite, 0xA1, 0xFE)) {
          code_point = indexCodePointFor(
            (lead - 0xA1) * 94 + (bite - 0xA1),
            index(!eucjp_jis0212_flag ? 'jis0208' : 'jis0212'));
        }

        // 3. Unset the euc-jp jis0212 flag.
        eucjp_jis0212_flag = false;

        // 4. If byte is not in the range 0xA1 to 0xFE, inclusive,
        // prepend byte to stream.
        if (!inRange(bite, 0xA1, 0xFE))
          stream.prepend(bite);

        // 5. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 6. Return a code point whose value is code point.
        return code_point;
      }

      // 6. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 7. If byte is 0x8E, 0x8F, or in the range 0xA1 to 0xFE,
      // inclusive, set euc-jp lead to byte and return continue.
      if (bite === 0x8E || bite === 0x8F || inRange(bite, 0xA1, 0xFE)) {
        eucjp_lead = bite;
        return null;
      }

      // 8. Return error.
      return decoderError(fatal);
    };
  }

  // 13.1.2 euc-jp encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function EUCJPEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is U+00A5, return byte 0x5C.
      if (code_point === 0x00A5)
        return 0x5C;

      // 4. If code point is U+203E, return byte 0x7E.
      if (code_point === 0x203E)
        return 0x7E;

      // 5. If code point is in the range U+FF61 to U+FF9F, inclusive,
      // return two bytes whose values are 0x8E and code point −
      // 0xFF61 + 0xA1.
      if (inRange(code_point, 0xFF61, 0xFF9F))
        return [0x8E, code_point - 0xFF61 + 0xA1];

      // 6. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 7. Let pointer be the index pointer for code point in index
      // jis0208.
      var pointer = indexPointerFor(code_point, index('jis0208'));

      // 8. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 9. Let lead be floor(pointer / 94) + 0xA1.
      var lead = floor(pointer / 94) + 0xA1;

      // 10. Let trail be pointer % 94 + 0xA1.
      var trail = pointer % 94 + 0xA1;

      // 11. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['EUC-JP'] = function(options) {
    return new EUCJPEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['EUC-JP'] = function(options) {
    return new EUCJPDecoder(options);
  };

  // 13.2 iso-2022-jp

  // 13.2.1 iso-2022-jp decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function ISO2022JPDecoder(options) {
    var fatal = options.fatal;
    /** @enum */
    var states = {
      ASCII: 0,
      Roman: 1,
      Katakana: 2,
      LeadByte: 3,
      TrailByte: 4,
      EscapeStart: 5,
      Escape: 6
    };
    // iso-2022-jp's decoder has an associated iso-2022-jp decoder
    // state (initially ASCII), iso-2022-jp decoder output state
    // (initially ASCII), iso-2022-jp lead (initially 0x00), and
    // iso-2022-jp output flag (initially unset).
    var /** @type {number} */ iso2022jp_decoder_state = states.ASCII,
        /** @type {number} */ iso2022jp_decoder_output_state = states.ASCII,
        /** @type {number} */ iso2022jp_lead = 0x00,
        /** @type {boolean} */ iso2022jp_output_flag = false;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // switching on iso-2022-jp decoder state:
      switch (iso2022jp_decoder_state) {
      default:
      case states.ASCII:
        // ASCII
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x00 to 0x7F, excluding 0x0E, 0x0F, and 0x1B
        if (inRange(bite, 0x00, 0x7F) && bite !== 0x0E
            && bite !== 0x0F && bite !== 0x1B) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is byte.
          iso2022jp_output_flag = false;
          return bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.Roman:
        // Roman
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x5C
        if (bite === 0x5C) {
          // Unset the iso-2022-jp output flag and return code point
          // U+00A5.
          iso2022jp_output_flag = false;
          return 0x00A5;
        }

        // 0x7E
        if (bite === 0x7E) {
          // Unset the iso-2022-jp output flag and return code point
          // U+203E.
          iso2022jp_output_flag = false;
          return 0x203E;
        }

        // 0x00 to 0x7F, excluding 0x0E, 0x0F, 0x1B, 0x5C, and 0x7E
        if (inRange(bite, 0x00, 0x7F) && bite !== 0x0E && bite !== 0x0F
            && bite !== 0x1B && bite !== 0x5C && bite !== 0x7E) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is byte.
          iso2022jp_output_flag = false;
          return bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.Katakana:
        // Katakana
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x21 to 0x5F
        if (inRange(bite, 0x21, 0x5F)) {
          // Unset the iso-2022-jp output flag and return a code point
          // whose value is 0xFF61 − 0x21 + byte.
          iso2022jp_output_flag = false;
          return 0xFF61 - 0x21 + bite;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.LeadByte:
        // Lead byte
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return null;
        }

        // 0x21 to 0x7E
        if (inRange(bite, 0x21, 0x7E)) {
          // Unset the iso-2022-jp output flag, set iso-2022-jp lead
          // to byte, iso-2022-jp decoder state to trail byte, and
          // return continue.
          iso2022jp_output_flag = false;
          iso2022jp_lead = bite;
          iso2022jp_decoder_state = states.TrailByte;
          return null;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Return finished.
          return finished;
        }

        // Otherwise
        // Unset the iso-2022-jp output flag and return error.
        iso2022jp_output_flag = false;
        return decoderError(fatal);

      case states.TrailByte:
        // Trail byte
        // Based on byte:

        // 0x1B
        if (bite === 0x1B) {
          // Set iso-2022-jp decoder state to escape start and return
          // continue.
          iso2022jp_decoder_state = states.EscapeStart;
          return decoderError(fatal);
        }

        // 0x21 to 0x7E
        if (inRange(bite, 0x21, 0x7E)) {
          // 1. Set the iso-2022-jp decoder state to lead byte.
          iso2022jp_decoder_state = states.LeadByte;

          // 2. Let pointer be (iso-2022-jp lead − 0x21) × 94 + byte − 0x21.
          var pointer = (iso2022jp_lead - 0x21) * 94 + bite - 0x21;

          // 3. Let code point be the index code point for pointer in
          // index jis0208.
          var code_point = indexCodePointFor(pointer, index('jis0208'));

          // 4. If code point is null, return error.
          if (code_point === null)
            return decoderError(fatal);

          // 5. Return a code point whose value is code point.
          return code_point;
        }

        // end-of-stream
        if (bite === end_of_stream) {
          // Set the iso-2022-jp decoder state to lead byte, prepend
          // byte to stream, and return error.
          iso2022jp_decoder_state = states.LeadByte;
          stream.prepend(bite);
          return decoderError(fatal);
        }

        // Otherwise
        // Set iso-2022-jp decoder state to lead byte and return
        // error.
        iso2022jp_decoder_state = states.LeadByte;
        return decoderError(fatal);

      case states.EscapeStart:
        // Escape start

        // 1. If byte is either 0x24 or 0x28, set iso-2022-jp lead to
        // byte, iso-2022-jp decoder state to escape, and return
        // continue.
        if (bite === 0x24 || bite === 0x28) {
          iso2022jp_lead = bite;
          iso2022jp_decoder_state = states.Escape;
          return null;
        }

        // 2. Prepend byte to stream.
        stream.prepend(bite);

        // 3. Unset the iso-2022-jp output flag, set iso-2022-jp
        // decoder state to iso-2022-jp decoder output state, and
        // return error.
        iso2022jp_output_flag = false;
        iso2022jp_decoder_state = iso2022jp_decoder_output_state;
        return decoderError(fatal);

      case states.Escape:
        // Escape

        // 1. Let lead be iso-2022-jp lead and set iso-2022-jp lead to
        // 0x00.
        var lead = iso2022jp_lead;
        iso2022jp_lead = 0x00;

        // 2. Let state be null.
        var state = null;

        // 3. If lead is 0x28 and byte is 0x42, set state to ASCII.
        if (lead === 0x28 && bite === 0x42)
          state = states.ASCII;

        // 4. If lead is 0x28 and byte is 0x4A, set state to Roman.
        if (lead === 0x28 && bite === 0x4A)
          state = states.Roman;

        // 5. If lead is 0x28 and byte is 0x49, set state to Katakana.
        if (lead === 0x28 && bite === 0x49)
          state = states.Katakana;

        // 6. If lead is 0x24 and byte is either 0x40 or 0x42, set
        // state to lead byte.
        if (lead === 0x24 && (bite === 0x40 || bite === 0x42))
          state = states.LeadByte;

        // 7. If state is non-null, run these substeps:
        if (state !== null) {
          // 1. Set iso-2022-jp decoder state and iso-2022-jp decoder
          // output state to states.
          iso2022jp_decoder_state = iso2022jp_decoder_state = state;

          // 2. Let output flag be the iso-2022-jp output flag.
          var output_flag = iso2022jp_output_flag;

          // 3. Set the iso-2022-jp output flag.
          iso2022jp_output_flag = true;

          // 4. Return continue, if output flag is unset, and error
          // otherwise.
          return !output_flag ? null : decoderError(fatal);
        }

        // 8. Prepend lead and byte to stream.
        stream.prepend([lead, bite]);

        // 9. Unset the iso-2022-jp output flag, set iso-2022-jp
        // decoder state to iso-2022-jp decoder output state and
        // return error.
        iso2022jp_output_flag = false;
        iso2022jp_decoder_state = iso2022jp_decoder_output_state;
        return decoderError(fatal);
      }
    };
  }

  // 13.2.2 iso-2022-jp encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function ISO2022JPEncoder(options) {
    var fatal = options.fatal;
    // iso-2022-jp's encoder has an associated iso-2022-jp encoder
    // state which is one of ASCII, Roman, and jis0208 (initially
    // ASCII).
    /** @enum */
    var states = {
      ASCII: 0,
      Roman: 1,
      jis0208: 2
    };
    var /** @type {number} */ iso2022jp_state = states.ASCII;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream and iso-2022-jp encoder
      // state is not ASCII, prepend code point to stream, set
      // iso-2022-jp encoder state to ASCII, and return three bytes
      // 0x1B 0x28 0x42.
      if (code_point === end_of_stream &&
          iso2022jp_state !== states.ASCII) {
        stream.prepend(code_point);
        iso2022jp_state = states.ASCII;
        return [0x1B, 0x28, 0x42];
      }

      // 2. If code point is end-of-stream and iso-2022-jp encoder
      // state is ASCII, return finished.
      if (code_point === end_of_stream && iso2022jp_state === states.ASCII)
        return finished;

      // 3. If ISO-2022-JP encoder state is ASCII or Roman, and code
      // point is U+000E, U+000F, or U+001B, return error with U+FFFD.
      if ((iso2022jp_state === states.ASCII ||
           iso2022jp_state === states.Roman) &&
          (code_point === 0x000E || code_point === 0x000F ||
           code_point === 0x001B)) {
        return encoderError(0xFFFD);
      }

      // 4. If iso-2022-jp encoder state is ASCII and code point is an
      // ASCII code point, return a byte whose value is code point.
      if (iso2022jp_state === states.ASCII &&
          isASCIICodePoint(code_point))
        return code_point;

      // 5. If iso-2022-jp encoder state is Roman and code point is an
      // ASCII code point, excluding U+005C and U+007E, or is U+00A5
      // or U+203E, run these substeps:
      if (iso2022jp_state === states.Roman &&
          ((isASCIICodePoint(code_point) &&
           code_point !== 0x005C && code_point !== 0x007E) ||
          (code_point == 0x00A5 || code_point == 0x203E))) {

        // 1. If code point is an ASCII code point, return a byte
        // whose value is code point.
        if (isASCIICodePoint(code_point))
          return code_point;

        // 2. If code point is U+00A5, return byte 0x5C.
        if (code_point === 0x00A5)
          return 0x5C;

        // 3. If code point is U+203E, return byte 0x7E.
        if (code_point === 0x203E)
          return 0x7E;
      }

      // 6. If code point is an ASCII code point, and iso-2022-jp
      // encoder state is not ASCII, prepend code point to stream, set
      // iso-2022-jp encoder state to ASCII, and return three bytes
      // 0x1B 0x28 0x42.
      if (isASCIICodePoint(code_point) &&
          iso2022jp_state !== states.ASCII) {
        stream.prepend(code_point);
        iso2022jp_state = states.ASCII;
        return [0x1B, 0x28, 0x42];
      }

      // 7. If code point is either U+00A5 or U+203E, and iso-2022-jp
      // encoder state is not Roman, prepend code point to stream, set
      // iso-2022-jp encoder state to Roman, and return three bytes
      // 0x1B 0x28 0x4A.
      if ((code_point === 0x00A5 || code_point === 0x203E) &&
          iso2022jp_state !== states.Roman) {
        stream.prepend(code_point);
        iso2022jp_state = states.Roman;
        return [0x1B, 0x28, 0x4A];
      }

      // 8. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 9. Let pointer be the index pointer for code point in index
      // jis0208.
      var pointer = indexPointerFor(code_point, index('jis0208'));

      // 10. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 11. If iso-2022-jp encoder state is not jis0208, prepend code
      // point to stream, set iso-2022-jp encoder state to jis0208,
      // and return three bytes 0x1B 0x24 0x42.
      if (iso2022jp_state !== states.jis0208) {
        stream.prepend(code_point);
        iso2022jp_state = states.jis0208;
        return [0x1B, 0x24, 0x42];
      }

      // 12. Let lead be floor(pointer / 94) + 0x21.
      var lead = floor(pointer / 94) + 0x21;

      // 13. Let trail be pointer % 94 + 0x21.
      var trail = pointer % 94 + 0x21;

      // 14. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['ISO-2022-JP'] = function(options) {
    return new ISO2022JPEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['ISO-2022-JP'] = function(options) {
    return new ISO2022JPDecoder(options);
  };

  // 13.3 Shift_JIS

  // 13.3.1 Shift_JIS decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function ShiftJISDecoder(options) {
    var fatal = options.fatal;
    // Shift_JIS's decoder has an associated Shift_JIS lead (initially
    // 0x00).
    var /** @type {number} */ Shift_JIS_lead = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and Shift_JIS lead is not 0x00,
      // set Shift_JIS lead to 0x00 and return error.
      if (bite === end_of_stream && Shift_JIS_lead !== 0x00) {
        Shift_JIS_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and Shift_JIS lead is 0x00,
      // return finished.
      if (bite === end_of_stream && Shift_JIS_lead === 0x00)
        return finished;

      // 3. If Shift_JIS lead is not 0x00, let lead be Shift_JIS lead,
      // let pointer be null, set Shift_JIS lead to 0x00, and then run
      // these substeps:
      if (Shift_JIS_lead !== 0x00) {
        var lead = Shift_JIS_lead;
        var pointer = null;
        Shift_JIS_lead = 0x00;

        // 1. Let offset be 0x40, if byte is less than 0x7F, and 0x41
        // otherwise.
        var offset = (bite < 0x7F) ? 0x40 : 0x41;

        // 2. Let lead offset be 0x81, if lead is less than 0xA0, and
        // 0xC1 otherwise.
        var lead_offset = (lead < 0xA0) ? 0x81 : 0xC1;

        // 3. If byte is in the range 0x40 to 0x7E, inclusive, or 0x80
        // to 0xFC, inclusive, set pointer to (lead − lead offset) ×
        // 188 + byte − offset.
        if (inRange(bite, 0x40, 0x7E) || inRange(bite, 0x80, 0xFC))
          pointer = (lead - lead_offset) * 188 + bite - offset;

        // 4. If pointer is in the range 8836 to 10715, inclusive,
        // return a code point whose value is 0xE000 − 8836 + pointer.
        if (inRange(pointer, 8836, 10715))
          return 0xE000 - 8836 + pointer;

        // 5. Let code point be null, if pointer is null, and the
        // index code point for pointer in index jis0208 otherwise.
        var code_point = (pointer === null) ? null :
              indexCodePointFor(pointer, index('jis0208'));

        // 6. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (code_point === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 7. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 8. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte or 0x80, return a code point
      // whose value is byte.
      if (isASCIIByte(bite) || bite === 0x80)
        return bite;

      // 5. If byte is in the range 0xA1 to 0xDF, inclusive, return a
      // code point whose value is 0xFF61 − 0xA1 + byte.
      if (inRange(bite, 0xA1, 0xDF))
        return 0xFF61 - 0xA1 + bite;

      // 6. If byte is in the range 0x81 to 0x9F, inclusive, or 0xE0
      // to 0xFC, inclusive, set Shift_JIS lead to byte and return
      // continue.
      if (inRange(bite, 0x81, 0x9F) || inRange(bite, 0xE0, 0xFC)) {
        Shift_JIS_lead = bite;
        return null;
      }

      // 7. Return error.
      return decoderError(fatal);
    };
  }

  // 13.3.2 Shift_JIS encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function ShiftJISEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point or U+0080, return a
      // byte whose value is code point.
      if (isASCIICodePoint(code_point) || code_point === 0x0080)
        return code_point;

      // 3. If code point is U+00A5, return byte 0x5C.
      if (code_point === 0x00A5)
        return 0x5C;

      // 4. If code point is U+203E, return byte 0x7E.
      if (code_point === 0x203E)
        return 0x7E;

      // 5. If code point is in the range U+FF61 to U+FF9F, inclusive,
      // return a byte whose value is code point − 0xFF61 + 0xA1.
      if (inRange(code_point, 0xFF61, 0xFF9F))
        return code_point - 0xFF61 + 0xA1;

      // 6. If code point is U+2212, set it to U+FF0D.
      if (code_point === 0x2212)
        code_point = 0xFF0D;

      // 7. Let pointer be the index Shift_JIS pointer for code point.
      var pointer = indexShiftJISPointerFor(code_point);

      // 8. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 9. Let lead be floor(pointer / 188).
      var lead = floor(pointer / 188);

      // 10. Let lead offset be 0x81, if lead is less than 0x1F, and
      // 0xC1 otherwise.
      var lead_offset = (lead < 0x1F) ? 0x81 : 0xC1;

      // 11. Let trail be pointer % 188.
      var trail = pointer % 188;

      // 12. Let offset be 0x40, if trail is less than 0x3F, and 0x41
      // otherwise.
      var offset = (trail < 0x3F) ? 0x40 : 0x41;

      // 13. Return two bytes whose values are lead + lead offset and
      // trail + offset.
      return [lead + lead_offset, trail + offset];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['Shift_JIS'] = function(options) {
    return new ShiftJISEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['Shift_JIS'] = function(options) {
    return new ShiftJISDecoder(options);
  };

  //
  // 14. Legacy multi-byte Korean encodings
  //

  // 14.1 euc-kr

  // 14.1.1 euc-kr decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function EUCKRDecoder(options) {
    var fatal = options.fatal;

    // euc-kr's decoder has an associated euc-kr lead (initially 0x00).
    var /** @type {number} */ euckr_lead = 0x00;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and euc-kr lead is not 0x00, set
      // euc-kr lead to 0x00 and return error.
      if (bite === end_of_stream && euckr_lead !== 0) {
        euckr_lead = 0x00;
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and euc-kr lead is 0x00, return
      // finished.
      if (bite === end_of_stream && euckr_lead === 0)
        return finished;

      // 3. If euc-kr lead is not 0x00, let lead be euc-kr lead, let
      // pointer be null, set euc-kr lead to 0x00, and then run these
      // substeps:
      if (euckr_lead !== 0x00) {
        var lead = euckr_lead;
        var pointer = null;
        euckr_lead = 0x00;

        // 1. If byte is in the range 0x41 to 0xFE, inclusive, set
        // pointer to (lead − 0x81) × 190 + (byte − 0x41).
        if (inRange(bite, 0x41, 0xFE))
          pointer = (lead - 0x81) * 190 + (bite - 0x41);

        // 2. Let code point be null, if pointer is null, and the
        // index code point for pointer in index euc-kr otherwise.
        var code_point = (pointer === null)
              ? null : indexCodePointFor(pointer, index('euc-kr'));

        // 3. If code point is null and byte is an ASCII byte, prepend
        // byte to stream.
        if (pointer === null && isASCIIByte(bite))
          stream.prepend(bite);

        // 4. If code point is null, return error.
        if (code_point === null)
          return decoderError(fatal);

        // 5. Return a code point whose value is code point.
        return code_point;
      }

      // 4. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 5. If byte is in the range 0x81 to 0xFE, inclusive, set
      // euc-kr lead to byte and return continue.
      if (inRange(bite, 0x81, 0xFE)) {
        euckr_lead = bite;
        return null;
      }

      // 6. Return error.
      return decoderError(fatal);
    };
  }

  // 14.1.2 euc-kr encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function EUCKREncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. Let pointer be the index pointer for code point in index
      // euc-kr.
      var pointer = indexPointerFor(code_point, index('euc-kr'));

      // 4. If pointer is null, return error with code point.
      if (pointer === null)
        return encoderError(code_point);

      // 5. Let lead be floor(pointer / 190) + 0x81.
      var lead = floor(pointer / 190) + 0x81;

      // 6. Let trail be pointer % 190 + 0x41.
      var trail = (pointer % 190) + 0x41;

      // 7. Return two bytes whose values are lead and trail.
      return [lead, trail];
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['EUC-KR'] = function(options) {
    return new EUCKREncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['EUC-KR'] = function(options) {
    return new EUCKRDecoder(options);
  };


  //
  // 15. Legacy miscellaneous encodings
  //

  // 15.1 replacement

  // Not needed - API throws RangeError

  // 15.2 Common infrastructure for utf-16be and utf-16le

  /**
   * @param {number} code_unit
   * @param {boolean} utf16be
   * @return {!Array.<number>} bytes
   */
  function convertCodeUnitToBytes(code_unit, utf16be) {
    // 1. Let byte1 be code unit >> 8.
    var byte1 = code_unit >> 8;

    // 2. Let byte2 be code unit & 0x00FF.
    var byte2 = code_unit & 0x00FF;

    // 3. Then return the bytes in order:
        // utf-16be flag is set: byte1, then byte2.
    if (utf16be)
      return [byte1, byte2];
    // utf-16be flag is unset: byte2, then byte1.
    return [byte2, byte1];
  }

  // 15.2.1 shared utf-16 decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {boolean} utf16_be True if big-endian, false if little-endian.
   * @param {{fatal: boolean}} options
   */
  function UTF16Decoder(utf16_be, options) {
    var fatal = options.fatal;
    var /** @type {?number} */ utf16_lead_byte = null,
        /** @type {?number} */ utf16_lead_surrogate = null;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream and either utf-16 lead byte or
      // utf-16 lead surrogate is not null, set utf-16 lead byte and
      // utf-16 lead surrogate to null, and return error.
      if (bite === end_of_stream && (utf16_lead_byte !== null ||
                                utf16_lead_surrogate !== null)) {
        return decoderError(fatal);
      }

      // 2. If byte is end-of-stream and utf-16 lead byte and utf-16
      // lead surrogate are null, return finished.
      if (bite === end_of_stream && utf16_lead_byte === null &&
          utf16_lead_surrogate === null) {
        return finished;
      }

      // 3. If utf-16 lead byte is null, set utf-16 lead byte to byte
      // and return continue.
      if (utf16_lead_byte === null) {
        utf16_lead_byte = bite;
        return null;
      }

      // 4. Let code unit be the result of:
      var code_unit;
      if (utf16_be) {
        // utf-16be decoder flag is set
        //   (utf-16 lead byte << 8) + byte.
        code_unit = (utf16_lead_byte << 8) + bite;
      } else {
        // utf-16be decoder flag is unset
        //   (byte << 8) + utf-16 lead byte.
        code_unit = (bite << 8) + utf16_lead_byte;
      }
      // Then set utf-16 lead byte to null.
      utf16_lead_byte = null;

      // 5. If utf-16 lead surrogate is not null, let lead surrogate
      // be utf-16 lead surrogate, set utf-16 lead surrogate to null,
      // and then run these substeps:
      if (utf16_lead_surrogate !== null) {
        var lead_surrogate = utf16_lead_surrogate;
        utf16_lead_surrogate = null;

        // 1. If code unit is in the range U+DC00 to U+DFFF,
        // inclusive, return a code point whose value is 0x10000 +
        // ((lead surrogate − 0xD800) << 10) + (code unit − 0xDC00).
        if (inRange(code_unit, 0xDC00, 0xDFFF)) {
          return 0x10000 + (lead_surrogate - 0xD800) * 0x400 +
              (code_unit - 0xDC00);
        }

        // 2. Prepend the sequence resulting of converting code unit
        // to bytes using utf-16be decoder flag to stream and return
        // error.
        stream.prepend(convertCodeUnitToBytes(code_unit, utf16_be));
        return decoderError(fatal);
      }

      // 6. If code unit is in the range U+D800 to U+DBFF, inclusive,
      // set utf-16 lead surrogate to code unit and return continue.
      if (inRange(code_unit, 0xD800, 0xDBFF)) {
        utf16_lead_surrogate = code_unit;
        return null;
      }

      // 7. If code unit is in the range U+DC00 to U+DFFF, inclusive,
      // return error.
      if (inRange(code_unit, 0xDC00, 0xDFFF))
        return decoderError(fatal);

      // 8. Return code point code unit.
      return code_unit;
    };
  }

  // 15.2.2 shared utf-16 encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {boolean} utf16_be True if big-endian, false if little-endian.
   * @param {{fatal: boolean}} options
   */
  function UTF16Encoder(utf16_be, options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1. If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is in the range U+0000 to U+FFFF, inclusive,
      // return the sequence resulting of converting code point to
      // bytes using utf-16be encoder flag.
      if (inRange(code_point, 0x0000, 0xFFFF))
        return convertCodeUnitToBytes(code_point, utf16_be);

      // 3. Let lead be ((code point − 0x10000) >> 10) + 0xD800,
      // converted to bytes using utf-16be encoder flag.
      var lead = convertCodeUnitToBytes(
        ((code_point - 0x10000) >> 10) + 0xD800, utf16_be);

      // 4. Let trail be ((code point − 0x10000) & 0x3FF) + 0xDC00,
      // converted to bytes using utf-16be encoder flag.
      var trail = convertCodeUnitToBytes(
        ((code_point - 0x10000) & 0x3FF) + 0xDC00, utf16_be);

      // 5. Return a byte sequence of lead followed by trail.
      return lead.concat(trail);
    };
  }

  // 15.3 utf-16be
  // 15.3.1 utf-16be decoder
  /** @param {{fatal: boolean}} options */
  encoders['UTF-16BE'] = function(options) {
    return new UTF16Encoder(true, options);
  };
  // 15.3.2 utf-16be encoder
  /** @param {{fatal: boolean}} options */
  decoders['UTF-16BE'] = function(options) {
    return new UTF16Decoder(true, options);
  };

  // 15.4 utf-16le
  // 15.4.1 utf-16le decoder
  /** @param {{fatal: boolean}} options */
  encoders['UTF-16LE'] = function(options) {
    return new UTF16Encoder(false, options);
  };
  // 15.4.2 utf-16le encoder
  /** @param {{fatal: boolean}} options */
  decoders['UTF-16LE'] = function(options) {
    return new UTF16Decoder(false, options);
  };

  // 15.5 x-user-defined

  // 15.5.1 x-user-defined decoder
  /**
   * @constructor
   * @implements {Decoder}
   * @param {{fatal: boolean}} options
   */
  function XUserDefinedDecoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream The stream of bytes being decoded.
     * @param {number} bite The next byte read from the stream.
     * @return {?(number|!Array.<number>)} The next code point(s)
     *     decoded, or null if not enough data exists in the input
     *     stream to decode a complete code point.
     */
    this.handler = function(stream, bite) {
      // 1. If byte is end-of-stream, return finished.
      if (bite === end_of_stream)
        return finished;

      // 2. If byte is an ASCII byte, return a code point whose value
      // is byte.
      if (isASCIIByte(bite))
        return bite;

      // 3. Return a code point whose value is 0xF780 + byte − 0x80.
      return 0xF780 + bite - 0x80;
    };
  }

  // 15.5.2 x-user-defined encoder
  /**
   * @constructor
   * @implements {Encoder}
   * @param {{fatal: boolean}} options
   */
  function XUserDefinedEncoder(options) {
    var fatal = options.fatal;
    /**
     * @param {Stream} stream Input stream.
     * @param {number} code_point Next code point read from the stream.
     * @return {(number|!Array.<number>)} Byte(s) to emit.
     */
    this.handler = function(stream, code_point) {
      // 1.If code point is end-of-stream, return finished.
      if (code_point === end_of_stream)
        return finished;

      // 2. If code point is an ASCII code point, return a byte whose
      // value is code point.
      if (isASCIICodePoint(code_point))
        return code_point;

      // 3. If code point is in the range U+F780 to U+F7FF, inclusive,
      // return a byte whose value is code point − 0xF780 + 0x80.
      if (inRange(code_point, 0xF780, 0xF7FF))
        return code_point - 0xF780 + 0x80;

      // 4. Return error with code point.
      return encoderError(code_point);
    };
  }

  /** @param {{fatal: boolean}} options */
  encoders['x-user-defined'] = function(options) {
    return new XUserDefinedEncoder(options);
  };
  /** @param {{fatal: boolean}} options */
  decoders['x-user-defined'] = function(options) {
    return new XUserDefinedDecoder(options);
  };

  if (!global['TextEncoder'])
    global['TextEncoder'] = TextEncoder;
  if (!global['TextDecoder'])
    global['TextDecoder'] = TextDecoder;

  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      TextEncoder: global['TextEncoder'],
      TextDecoder: global['TextDecoder'],
      EncodingIndexes: global["encoding-indexes"]
    };
  }

// For strict environments where `this` inside the global scope
// is `undefined`, take a pure object instead
}(this || {}));

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */


// Polyfills objects needed to support IE 11+
__webpack_require__(350);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(352);
__webpack_require__(351);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(358);
__webpack_require__(344);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(499);
__webpack_require__(751);

if (typeof window.TextEncoder !== 'function') {
  var TextEncodingPolyfill = __webpack_require__(500);
  window.TextEncoder = TextEncodingPolyfill.TextEncoder;
  window.TextDecoder = TextEncodingPolyfill.TextDecoder;
}


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process, Buffer, setImmediate) {/*! Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")

You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.

See the License for the specific language governing permissions and limitations under the License.
 */

!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="ab99c15a-8a52-5c2c-813d-d31ebc5cc76d")}catch(e){}}();
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.OktaSignIn=t():e.OktaSignIn=t()}(self,(function(){return function(){var e={72284:function(e,t,n){"use strict";var r=n(12990),o=n(66583),i={days:function(e){return 864e5*e},hours:function(e){return 36e5*e},minutes:function(e){return 6e4*e},seconds:function(e){return 1e3*e},milliseconds:function(e){return e},microseconds:function(e){return e/1e3},nanoseconds:function(e){return e/1e6}},a=function(e){return Object.entries(e).reduce((function(e,t){var n=o(t,2),a=n[0],s=n[1];if("number"!=typeof s)throw new TypeError("Expected a `number` for key `".concat(a,"`, got `").concat(s,"` (").concat(r(s),")"));if(!i[a])throw new Error("Unsupported time key");return e+i[a](s)}),0)};e.exports=a,e.exports.default=a},67820:function(e){"use strict";e.exports=function(e){if("number"!=typeof e)throw new TypeError("Expected a number");var t=e>0?Math.floor:Math.ceil;return{days:t(e/864e5),hours:t(e/36e5)%24,minutes:t(e/6e4)%60,seconds:t(e/1e3)%60,milliseconds:t(e)%1e3,microseconds:t(1e3*e)%1e3,nanoseconds:t(1e6*e)%1e3}}},22603:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.commonjsGlobal=void 0,t.getDefaultExportFromCjs=function(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e};var n="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};t.commonjsGlobal=n},59098:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.b=void 0;t.b={exports:{}}},76222:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},33530:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.b=void 0;t.b={exports:{}}},88287:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},60381:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},31178:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.e=void 0;t.e={exports:{}}},39338:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.e=void 0;t.e={exports:{}}},99185:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.h=void 0;t.h={exports:{}}},49982:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.h=void 0;t.h={exports:{}}},77666:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},67196:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t._=void 0;t._={exports:{}}},51822:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.i=void 0;t.i={exports:{}}},89278:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.j=void 0;t.j={exports:{}}},1701:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.l=void 0;t.l={exports:{}}},90147:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.l=void 0;t.l={exports:{}}},45057:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.l=void 0;t.l={exports:{}}},64827:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.n=void 0;t.n={exports:{}}},58324:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},82971:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},95882:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.s=void 0;t.s={exports:{}}},3206:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.u=void 0;t.u={exports:{}}},82014:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},59575:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t._=void 0;t._={exports:{}}},21795:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.__exports=void 0;t.__exports={}},2875:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(22603),o=n(99185);n(81585),n(85187),n(79267),n(30227),n(29622),n(56470);var i=n(76222),a=n(82014),s=n(82971),l=n(39338),u=n(64827),c=n(95882);!function(e,t){function n(e){return e&&e.__esModule?e:{default:e}}function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}t.__esModule=!0;var o=r(i.__exports),d=n(c.s.exports),f=n(l.e.exports),p=r(a.__exports),h=r(s.__exports),m=n(u.n.exports);function v(){var e=new o.HandlebarsEnvironment;return p.extend(e,o),e.SafeString=d.default,e.Exception=f.default,e.Utils=p,e.escapeExpression=p.escapeExpression,e.VM=h,e.template=function(t){return h.template(t,e)},e}var g=v();g.create=v,m.default(g),g.default=g,t.default=g,e.exports=t.default}(o.h,o.h.exports);var d=(0,r.getDefaultExportFromCjs)(o.h.exports);t.default=d,e.exports=t.default},81585:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(76222);n(30227),n(79267),n(60979),n(87390),n(9656),n(61443);var o=n(82014),i=n(58324),a=n(77666),s=n(60381),l=n(90147),u=n(39338);function c(e){return e&&e.__esModule?e:{default:e}}r.__exports.__esModule=!0,r.__exports.HandlebarsEnvironment=y;var d=o.__exports,f=c(u.e.exports),p=a.__exports,h=s.__exports,m=c(l.l.exports),v=i.__exports;r.__exports.VERSION="4.7.7";r.__exports.COMPILER_REVISION=8;r.__exports.LAST_COMPATIBLE_COMPILER_REVISION=7;r.__exports.REVISION_CHANGES={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};var g="[object Object]";function y(e,t,n){this.helpers=e||{},this.partials=t||{},this.decorators=n||{},p.registerDefaultHelpers(this),h.registerDefaultDecorators(this)}y.prototype={constructor:y,logger:m.default,log:m.default.log,registerHelper:function(e,t){if(d.toString.call(e)===g){if(t)throw new f.default("Arg not supported with multiple helpers");d.extend(this.helpers,e)}else this.helpers[e]=t},unregisterHelper:function(e){delete this.helpers[e]},registerPartial:function(e,t){if(d.toString.call(e)===g)d.extend(this.partials,e);else{if(void 0===t)throw new f.default('Attempting to register a partial called "'+e+'" as undefined');this.partials[e]=t}},unregisterPartial:function(e){delete this.partials[e]},registerDecorator:function(e,t){if(d.toString.call(e)===g){if(t)throw new f.default("Arg not supported with multiple decorators");d.extend(this.decorators,e)}else this.decorators[e]=t},unregisterDecorator:function(e){delete this.decorators[e]},resetLoggedPropertyAccesses:function(){v.resetLoggedProperties()}};var b=m.default.log;r.__exports.log=b,r.__exports.createFrame=d.createFrame,r.__exports.logger=m.default,e.exports=t.default},87390:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(60381);n(17512);var o=n(51822);r.__exports.__esModule=!0,r.__exports.registerDefaultDecorators=function(e){s.default(e)};var i,a=o.i.exports,s=(i=a)&&i.__esModule?i:{default:i};e.exports=t.default},17512:function(e,t,n){"use strict";var r=n(51822);n(30227);var o=n(82014);!function(e,t){t.__esModule=!0;var n=o.__exports;t.default=function(e){e.registerDecorator("inline",(function(e,t,r,o){var i=e;return t.partials||(t.partials={},i=function(o,i){var a=r.partials;r.partials=n.extend({},a,t.partials);var s=e(o,i);return r.partials=a,s}),t.partials[o.args[0]]=o.fn,i}))},e.exports=t.default}(r.i,r.i.exports)},79267:function(e,t,n){"use strict";var r=n(39338);!function(e,t){t.__esModule=!0;var n=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];function r(e,t){var o=t&&t.loc,i=void 0,a=void 0,s=void 0,l=void 0;o&&(i=o.start.line,a=o.end.line,s=o.start.column,l=o.end.column,e+=" - "+i+":"+s);for(var u=Error.prototype.constructor.call(this,e),c=0;c<n.length;c++)this[n[c]]=u[n[c]];Error.captureStackTrace&&Error.captureStackTrace(this,r);try{o&&(this.lineNumber=i,this.endLineNumber=a,Object.defineProperty?(Object.defineProperty(this,"column",{value:s,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:l,enumerable:!0})):(this.column=s,this.endColumn=l))}catch(e){}}r.prototype=new Error,t.default=r,e.exports=t.default}(r.e,r.e.exports)},60979:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(77666);n(3603),n(9907),n(70891),n(47437),n(40774),n(27004),n(95614);var o=n(31178),i=n(49982),a=n(67196),s=n(1701),l=n(45057),u=n(59575),c=n(33530);function d(e){return e&&e.__esModule?e:{default:e}}r.__exports.__esModule=!0,r.__exports.registerDefaultHelpers=function(e){f.default(e),p.default(e),h.default(e),m.default(e),v.default(e),g.default(e),y.default(e)},r.__exports.moveHelperToHooks=function(e,t,n){e.helpers[t]&&(e.hooks[t]=e.helpers[t],n||delete e.helpers[t])};var f=d(c.b.exports),p=d(o.e.exports),h=d(i.h.exports),m=d(a._.exports),v=d(s.l.exports),g=d(l.l.exports),y=d(u._.exports);e.exports=t.default},3603:function(e,t,n){"use strict";var r=n(33530);n(30227);var o=n(82014);!function(e,t){t.__esModule=!0;var n=o.__exports;t.default=function(e){e.registerHelper("blockHelperMissing",(function(t,r){var o=r.inverse,i=r.fn;if(!0===t)return i(this);if(!1===t||null==t)return o(this);if(n.isArray(t))return t.length>0?(r.ids&&(r.ids=[r.name]),e.helpers.each(t,r)):o(this);if(r.data&&r.ids){var a=n.createFrame(r.data);a.contextPath=n.appendContextPath(r.data.contextPath,r.name),r={data:a}}return i(t,r)}))},e.exports=t.default}(r.b,r.b.exports)},9907:function(e,t,n){"use strict";var r=n(1654)(n(12990)),o=n(22603),i=n(31178);n(30227),n(79267);var a=n(82014),s=n(39338);!function(e,t){t.__esModule=!0;var n,i=a.__exports,l=s.e.exports,u=(n=l)&&n.__esModule?n:{default:n};t.default=function(e){e.registerHelper("each",(function(e,t){if(!t)throw new u.default("Must pass iterator to #each");var n,a=t.fn,s=t.inverse,l=0,c="",d=void 0,f=void 0;function p(t,n,r){d&&(d.key=t,d.index=n,d.first=0===n,d.last=!!r,f&&(d.contextPath=f+t)),c+=a(e[t],{data:d,blockParams:i.blockParams([e[t],t],[f+t,null])})}if(t.data&&t.ids&&(f=i.appendContextPath(t.data.contextPath,t.ids[0])+"."),i.isFunction(e)&&(e=e.call(this)),t.data&&(d=i.createFrame(t.data)),e&&"object"===(0,r.default)(e))if(i.isArray(e))for(var h=e.length;l<h;l++)l in e&&p(l,l,l===e.length-1);else if(o.commonjsGlobal.Symbol&&e[o.commonjsGlobal.Symbol.iterator]){for(var m=[],v=e[o.commonjsGlobal.Symbol.iterator](),g=v.next();!g.done;g=v.next())m.push(g.value);for(h=(e=m).length;l<h;l++)p(l,l,l===e.length-1)}else n=void 0,Object.keys(e).forEach((function(e){void 0!==n&&p(n,l-1),n=e,l++})),void 0!==n&&p(n,l-1,!0);return 0===l&&(c=s(this)),c}))},e.exports=t.default}(i.e,i.e.exports)},70891:function(e,t,n){"use strict";var r=n(49982);n(79267);var o=n(39338);!function(e,t){t.__esModule=!0;var n,r=o.e.exports,i=(n=r)&&n.__esModule?n:{default:n};t.default=function(e){e.registerHelper("helperMissing",(function(){if(1!==arguments.length)throw new i.default('Missing helper: "'+arguments[arguments.length-1].name+'"')}))},e.exports=t.default}(r.h,r.h.exports)},47437:function(e,t,n){"use strict";var r=n(67196);n(30227),n(79267);var o=n(82014),i=n(39338);!function(e,t){t.__esModule=!0;var n,r=o.__exports,a=i.e.exports,s=(n=a)&&n.__esModule?n:{default:n};t.default=function(e){e.registerHelper("if",(function(e,t){if(2!=arguments.length)throw new s.default("#if requires exactly one argument");return r.isFunction(e)&&(e=e.call(this)),!t.hash.includeZero&&!e||r.isEmpty(e)?t.inverse(this):t.fn(this)})),e.registerHelper("unless",(function(t,n){if(2!=arguments.length)throw new s.default("#unless requires exactly one argument");return e.helpers.if.call(this,t,{fn:n.inverse,inverse:n.fn,hash:n.hash})}))},e.exports=t.default}(r._,r._.exports)},40774:function(e,t,n){"use strict";var r=n(1701);!function(e,t){t.__esModule=!0,t.default=function(e){e.registerHelper("log",(function(){for(var t=[void 0],n=arguments[arguments.length-1],r=0;r<arguments.length-1;r++)t.push(arguments[r]);var o=1;null!=n.hash.level?o=n.hash.level:n.data&&null!=n.data.level&&(o=n.data.level),t[0]=o,e.log.apply(e,t)}))},e.exports=t.default}(r.l,r.l.exports)},27004:function(e,t,n){"use strict";var r=n(45057);!function(e,t){t.__esModule=!0,t.default=function(e){e.registerHelper("lookup",(function(e,t,n){return e?n.lookupProperty(e,t):e}))},e.exports=t.default}(r.l,r.l.exports)},95614:function(e,t,n){"use strict";var r=n(59575);n(30227),n(79267);var o=n(82014),i=n(39338);!function(e,t){t.__esModule=!0;var n,r=o.__exports,a=i.e.exports,s=(n=a)&&n.__esModule?n:{default:n};t.default=function(e){e.registerHelper("with",(function(e,t){if(2!=arguments.length)throw new s.default("#with requires exactly one argument");r.isFunction(e)&&(e=e.call(this));var n=t.fn;if(r.isEmpty(e))return t.inverse(this);var o=t.data;return t.data&&t.ids&&((o=r.createFrame(t.data)).contextPath=r.appendContextPath(t.data.contextPath,t.ids[0])),n(e,{data:o,blockParams:r.blockParams([e],[o&&o.contextPath])})}))},e.exports=t.default}(r._,r._.exports)},46192:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(88287);n(30227);var o=n(82014);r.__exports.__esModule=!0,r.__exports.createNewLookupObject=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return i.extend.apply(void 0,[Object.create(null)].concat(t))};var i=o.__exports;e.exports=t.default},61443:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(58324);n(46192),n(9656);var o=n(88287),i=n(90147);r.__exports.__esModule=!0,r.__exports.createProtoAccessControl=function(e){var t=Object.create(null);t.constructor=!1,t.__defineGetter__=!1,t.__defineSetter__=!1,t.__lookupGetter__=!1;var n=Object.create(null);return n.__proto__=!1,{properties:{whitelist:a.createNewLookupObject(n,e.allowedProtoProperties),defaultValue:e.allowProtoPropertiesByDefault},methods:{whitelist:a.createNewLookupObject(t,e.allowedProtoMethods),defaultValue:e.allowProtoMethodsByDefault}}},r.__exports.resultIsAllowed=function(e,t,n){return u("function"==typeof e?t.methods:t.properties,n)},r.__exports.resetLoggedProperties=function(){Object.keys(l).forEach((function(e){delete l[e]}))};var a=o.__exports,s=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(i.l.exports),l=Object.create(null);function u(e,t){return void 0!==e.whitelist[t]?!0===e.whitelist[t]:void 0!==e.defaultValue?e.defaultValue:(function(e){!0!==l[e]&&(l[e]=!0,s.log("error",'Handlebars: Access has been denied to resolve the property "'+e+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'))}(t),!1)}e.exports=t.default},86696:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r.__exports}});var r=n(21795);r.__exports.__esModule=!0,r.__exports.wrapHelper=function(e,t){if("function"!=typeof e)return e;return function(){return arguments[arguments.length-1]=t(arguments[arguments.length-1]),e.apply(this,arguments)}},e.exports=t.default},9656:function(e,t,n){"use strict";var r=n(90147);n(30227);var o=n(82014);!function(e,t){t.__esModule=!0;var n=o.__exports,r={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(e){if("string"==typeof e){var t=n.indexOf(r.methodMap,e.toLowerCase());e=t>=0?t:parseInt(e,10)}return e},log:function(e){if(e=r.lookupLevel(e),"undefined"!=typeof console&&r.lookupLevel(r.level)<=e){var t=r.methodMap[e];console[t]||(t="log");for(var n=arguments.length,o=Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i]}}};t.default=r,e.exports=t.default}(r.l,r.l.exports)},56470:function(e,t,n){"use strict";var r=n(22603),o=n(64827);!function(e,t){t.__esModule=!0,t.default=function(e){var t=void 0!==r.commonjsGlobal?r.commonjsGlobal:window,n=t.Handlebars;e.noConflict=function(){return t.Handlebars===e&&(t.Handlebars=n),e}},e.exports=t.default}(o.n,o.n.exports)},29622:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return i.__exports}});var o=r(n(12990)),i=n(82971);n(30227),n(79267),n(81585),n(60979),n(86696),n(61443);var a=n(82014),s=n(76222),l=n(58324),u=n(77666),c=n(21795),d=n(39338);i.__exports.__esModule=!0,i.__exports.checkRevision=function(e){var t=e&&e[0]||1,n=v.COMPILER_REVISION;if(t>=v.LAST_COMPATIBLE_COMPILER_REVISION&&t<=v.COMPILER_REVISION)return;if(t<v.LAST_COMPATIBLE_COMPILER_REVISION){var r=v.REVISION_CHANGES[n],o=v.REVISION_CHANGES[t];throw new m.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+r+") or downgrade your runtime to an older version ("+o+").")}throw new m.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+e[1]+").")},i.__exports.template=function(e,t){if(!t)throw new m.default("No environment passed to template");if(!e||!e.main)throw new m.default("Unknown template object: "+(0,o.default)(e));e.main.decorator=e.main_d,t.VM.checkRevision(e.compiler);var n=e.compiler&&7===e.compiler[0];var r={strict:function(e,t,n){if(!e||!(t in e))throw new m.default('"'+t+'" not defined in '+e,{loc:n});return r.lookupProperty(e,t)},lookupProperty:function(e,t){var n=e[t];return null==n||Object.prototype.hasOwnProperty.call(e,t)||b.resultIsAllowed(n,r.protoAccessControl,t)?n:void 0},lookup:function(e,t){for(var n=e.length,o=0;o<n;o++){if(null!=(e[o]&&r.lookupProperty(e[o],t)))return e[o][t]}},lambda:function(e,t){return"function"==typeof e?e.call(t):e},escapeExpression:p.escapeExpression,invokePartial:function(n,r,o){o.hash&&(r=p.extend({},r,o.hash),o.ids&&(o.ids[0]=!0)),n=t.VM.resolvePartial.call(this,n,r,o);var i=p.extend({},o,{hooks:this.hooks,protoAccessControl:this.protoAccessControl}),a=t.VM.invokePartial.call(this,n,r,i);if(null==a&&t.compile&&(o.partials[o.name]=t.compile(n,e.compilerOptions,t),a=o.partials[o.name](r,i)),null!=a){if(o.indent){for(var s=a.split("\n"),l=0,u=s.length;l<u&&(s[l]||l+1!==u);l++)s[l]=o.indent+s[l];a=s.join("\n")}return a}throw new m.default("The partial "+o.name+" could not be compiled when running in runtime-only mode")},fn:function(t){var n=e[t];return n.decorator=e[t+"_d"],n},programs:[],program:function(e,t,n,r,o){var i=this.programs[e],a=this.fn(e);return t||o||r||n?i=w(this,e,a,t,n,r,o):i||(i=this.programs[e]=w(this,e,a)),i},data:function(e,t){for(;e&&t--;)e=e._parent;return e},mergeIfNeeded:function(e,t){var n=e||t;return e&&t&&e!==t&&(n=p.extend({},t,e)),n},nullContext:Object.seal({}),noop:t.VM.noop,compilerInfo:e.compiler};function i(t){var n=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],o=n.data;i._setup(n),!n.partial&&e.useData&&(o=O(t,o));var a=void 0,s=e.useBlockParams?[]:void 0;function l(t){return""+e.main(r,t,r.helpers,r.partials,o,s,a)}return e.useDepths&&(a=n.depths?t!=n.depths[0]?[t].concat(n.depths):n.depths:[t]),(l=k(e.main,l,r,n.depths||[],o,s))(t,n)}return i.isTop=!0,i._setup=function(o){if(o.partial)r.protoAccessControl=o.protoAccessControl,r.helpers=o.helpers,r.partials=o.partials,r.decorators=o.decorators,r.hooks=o.hooks;else{var i=p.extend({},t.helpers,o.helpers);!function(e,t){Object.keys(e).forEach((function(n){var r=e[n];e[n]=function(e,t){var n=t.lookupProperty;return y.wrapHelper(e,(function(e){return p.extend({lookupProperty:n},e)}))}(r,t)}))}(i,r),r.helpers=i,e.usePartial&&(r.partials=r.mergeIfNeeded(o.partials,t.partials)),(e.usePartial||e.useDecorators)&&(r.decorators=p.extend({},t.decorators,o.decorators)),r.hooks={},r.protoAccessControl=b.createProtoAccessControl(o);var a=o.allowCallsToHelperMissing||n;g.moveHelperToHooks(r,"helperMissing",a),g.moveHelperToHooks(r,"blockHelperMissing",a)}},i._child=function(t,n,o,i){if(e.useBlockParams&&!o)throw new m.default("must pass block params");if(e.useDepths&&!i)throw new m.default("must pass parent depths");return w(r,t,e[t],n,0,o,i)},i},i.__exports.wrapProgram=w,i.__exports.resolvePartial=function(e,t,n){e?e.call||n.name||(n.name=e,e=n.partials[e]):e="@partial-block"===n.name?n.data["partial-block"]:n.partials[n.name];return e},i.__exports.invokePartial=function(e,t,n){var r=n.data&&n.data["partial-block"];n.partial=!0,n.ids&&(n.data.contextPath=n.ids[0]||n.data.contextPath);var o=void 0;n.fn&&n.fn!==_&&function(){n.data=v.createFrame(n.data);var e=n.fn;o=n.data["partial-block"]=function(t){var n=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return n.data=v.createFrame(n.data),n.data["partial-block"]=r,e(t,n)},e.partials&&(n.partials=p.extend({},n.partials,e.partials))}();void 0===e&&o&&(e=o);if(void 0===e)throw new m.default("The partial "+n.name+" could not be found");if(e instanceof Function)return e(t,n)},i.__exports.noop=_;var f,p=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(a.__exports),h=d.e.exports,m=(f=h)&&f.__esModule?f:{default:f},v=s.__exports,g=u.__exports,y=c.__exports,b=l.__exports;function w(e,t,n,r,o,i,a){function s(t){var o=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],s=a;return!a||t==a[0]||t===e.nullContext&&null===a[0]||(s=[t].concat(a)),n(e,t,e.helpers,e.partials,o.data||r,i&&[o.blockParams].concat(i),s)}return(s=k(n,s,e,a,r,i)).program=t,s.depth=a?a.length:0,s.blockParams=o||0,s}function _(){return""}function O(e,t){return t&&"root"in t||((t=t?v.createFrame(t):{}).root=e),t}function k(e,t,n,r,o,i){if(e.decorator){var a={};t=e.decorator(t,a,n,r&&r[0],o,i,r),p.extend(t,a)}return t}e.exports=t.default},85187:function(e,t,n){"use strict";var r=n(95882);!function(e,t){function n(e){this.string=e}t.__esModule=!0,n.prototype.toString=n.prototype.toHTML=function(){return""+this.string},t.default=n,e.exports=t.default}(r.s,r.s.exports)},30227:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return i.__exports}});var o=r(n(12990)),i=n(82014);i.__exports.__esModule=!0,i.__exports.extend=c,i.__exports.indexOf=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},i.__exports.escapeExpression=function(e){if("string"!=typeof e){if(e&&e.toHTML)return e.toHTML();if(null==e)return"";if(!e)return e+"";e=""+e}if(!l.test(e))return e;return e.replace(s,u)},i.__exports.isEmpty=function(e){return!e&&0!==e||!(!p(e)||0!==e.length)},i.__exports.createFrame=function(e){var t=c({},e);return t._parent=e,t},i.__exports.blockParams=function(e,t){return e.path=t,e},i.__exports.appendContextPath=function(e,t){return(e?e+".":"")+t};var a={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},s=/[&<>"'`=]/g,l=/[&<>"'`=]/;function u(e){return a[e]}function c(e){for(var t=1;t<arguments.length;t++)for(var n in arguments[t])Object.prototype.hasOwnProperty.call(arguments[t],n)&&(e[n]=arguments[t][n]);return e}var d=Object.prototype.toString;i.__exports.toString=d;var f=function(e){return"function"==typeof e};f(/x/)&&(i.__exports.isFunction=f=function(e){return"function"==typeof e&&"[object Function]"===d.call(e)}),i.__exports.isFunction=f;var p=Array.isArray||function(e){return!(!e||"object"!==(0,o.default)(e))&&"[object Array]"===d.call(e)};i.__exports.isArray=p,e.exports=t.default},37870:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=n(22603),a=n(3206);!function(e,t){i.commonjsGlobal,e.exports=function(){
//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
var e="1.13.1",t="object"==("undefined"==typeof self?"undefined":(0,o.default)(self))&&self.self===self&&self||"object"==(0,o.default)(i.commonjsGlobal)&&i.commonjsGlobal.global===i.commonjsGlobal&&i.commonjsGlobal||Function("return this")()||{},n=Array.prototype,r=Object.prototype,a="undefined"!=typeof Symbol?Symbol.prototype:null,s=n.push,l=n.slice,u=r.toString,c=r.hasOwnProperty,d="undefined"!=typeof ArrayBuffer,f="undefined"!=typeof DataView,p=Array.isArray,h=Object.keys,m=Object.create,v=d&&ArrayBuffer.isView,g=isNaN,y=isFinite,b=!{toString:null}.propertyIsEnumerable("toString"),w=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],_=Math.pow(2,53)-1;function O(e,t){return t=null==t?e.length-1:+t,function(){for(var n=Math.max(arguments.length-t,0),r=Array(n),o=0;o<n;o++)r[o]=arguments[o+t];switch(t){case 0:return e.call(this,r);case 1:return e.call(this,arguments[0],r);case 2:return e.call(this,arguments[0],arguments[1],r)}var i=Array(t+1);for(o=0;o<t;o++)i[o]=arguments[o];return i[t]=r,e.apply(this,i)}}function k(e){var t=(0,o.default)(e);return"function"===t||"object"===t&&!!e}function x(e){return void 0===e}function E(e){return!0===e||!1===e||"[object Boolean]"===u.call(e)}function T(e){var t="[object "+e+"]";return function(e){return u.call(e)===t}}var S=T("String"),A=T("Number"),P=T("Date"),C=T("RegExp"),R=T("Error"),I=T("Symbol"),N=T("ArrayBuffer"),M=T("Function"),j=t.document&&t.document.childNodes;"object"!=("undefined"==typeof Int8Array?"undefined":(0,o.default)(Int8Array))&&"function"!=typeof j&&(M=function(e){return"function"==typeof e||!1});var D=M,L=T("Object"),U=f&&L(new DataView(new ArrayBuffer(8))),F="undefined"!=typeof Map&&L(new Map),B=T("DataView"),V=U?function(e){return null!=e&&D(e.getInt8)&&N(e.buffer)}:B,Z=p||T("Array");function H(e,t){return null!=e&&c.call(e,t)}var q=T("Arguments");!function(){q(arguments)||(q=function(e){return H(e,"callee")})}();var W=q;function K(e){return A(e)&&g(e)}function $(e){return function(){return e}}function z(e){return function(t){var n=e(t);return"number"==typeof n&&n>=0&&n<=_}}function Y(e){return function(t){return null==t?void 0:t[e]}}var G=Y("byteLength"),J=z(G),Q=/\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,X=d?function(e){return v?v(e)&&!V(e):J(e)&&Q.test(u.call(e))}:$(!1),ee=Y("length");function te(e,t){t=function(e){for(var t={},n=e.length,r=0;r<n;++r)t[e[r]]=!0;return{contains:function(e){return t[e]},push:function(n){return t[n]=!0,e.push(n)}}}(t);var n=w.length,o=e.constructor,i=D(o)&&o.prototype||r,a="constructor";for(H(e,a)&&!t.contains(a)&&t.push(a);n--;)(a=w[n])in e&&e[a]!==i[a]&&!t.contains(a)&&t.push(a)}function ne(e){if(!k(e))return[];if(h)return h(e);var t=[];for(var n in e)H(e,n)&&t.push(n);return b&&te(e,t),t}function re(e,t){var n=ne(t),r=n.length;if(null==e)return!r;for(var o=Object(e),i=0;i<r;i++){var a=n[i];if(t[a]!==o[a]||!(a in o))return!1}return!0}function oe(e){return e instanceof oe?e:this instanceof oe?void(this._wrapped=e):new oe(e)}function ie(e){return new Uint8Array(e.buffer||e,e.byteOffset||0,G(e))}oe.VERSION=e,oe.prototype.value=function(){return this._wrapped},oe.prototype.valueOf=oe.prototype.toJSON=oe.prototype.value,oe.prototype.toString=function(){return String(this._wrapped)};var ae="[object DataView]";function se(e,t,n,r){if(e===t)return 0!==e||1/e==1/t;if(null==e||null==t)return!1;if(e!=e)return t!=t;var i=(0,o.default)(e);return("function"===i||"object"===i||"object"==(0,o.default)(t))&&function e(t,n,r,i){t instanceof oe&&(t=t._wrapped),n instanceof oe&&(n=n._wrapped);var s=u.call(t);if(s!==u.call(n))return!1;if(U&&"[object Object]"==s&&V(t)){if(!V(n))return!1;s=ae}switch(s){case"[object RegExp]":case"[object String]":return""+t==""+n;case"[object Number]":return+t!=+t?+n!=+n:0==+t?1/+t==1/n:+t==+n;case"[object Date]":case"[object Boolean]":return+t==+n;case"[object Symbol]":return a.valueOf.call(t)===a.valueOf.call(n);case"[object ArrayBuffer]":case ae:return e(ie(t),ie(n),r,i)}var l="[object Array]"===s;if(!l&&X(t)){if(G(t)!==G(n))return!1;if(t.buffer===n.buffer&&t.byteOffset===n.byteOffset)return!0;l=!0}if(!l){if("object"!=(0,o.default)(t)||"object"!=(0,o.default)(n))return!1;var c=t.constructor,d=n.constructor;if(c!==d&&!(D(c)&&c instanceof c&&D(d)&&d instanceof d)&&"constructor"in t&&"constructor"in n)return!1}i=i||[];for(var f=(r=r||[]).length;f--;)if(r[f]===t)return i[f]===n;if(r.push(t),i.push(n),l){if((f=t.length)!==n.length)return!1;for(;f--;)if(!se(t[f],n[f],r,i))return!1}else{var p,h=ne(t);if(f=h.length,ne(n).length!==f)return!1;for(;f--;)if(!H(n,p=h[f])||!se(t[p],n[p],r,i))return!1}return r.pop(),i.pop(),!0}(e,t,n,r)}function le(e){if(!k(e))return[];var t=[];for(var n in e)t.push(n);return b&&te(e,t),t}function ue(e){var t=ee(e);return function(n){if(null==n)return!1;var r=le(n);if(ee(r))return!1;for(var o=0;o<t;o++)if(!D(n[e[o]]))return!1;return e!==me||!D(n[ce])}}var ce="forEach",de="has",fe=["clear","delete"],pe=["get",de,"set"],he=fe.concat(ce,pe),me=fe.concat(pe),ve=["add"].concat(fe,ce,de),ge=F?ue(he):T("Map"),ye=F?ue(me):T("WeakMap"),be=F?ue(ve):T("Set"),we=T("WeakSet");function _e(e){for(var t=ne(e),n=t.length,r=Array(n),o=0;o<n;o++)r[o]=e[t[o]];return r}function Oe(e){for(var t={},n=ne(e),r=0,o=n.length;r<o;r++)t[e[n[r]]]=n[r];return t}function ke(e){var t=[];for(var n in e)D(e[n])&&t.push(n);return t.sort()}function xe(e,t){return function(n){var r=arguments.length;if(t&&(n=Object(n)),r<2||null==n)return n;for(var o=1;o<r;o++)for(var i=arguments[o],a=e(i),s=a.length,l=0;l<s;l++){var u=a[l];t&&void 0!==n[u]||(n[u]=i[u])}return n}}var Ee=xe(le),Te=xe(ne),Se=xe(le,!0);function Ae(e){if(!k(e))return{};if(m)return m(e);var t=function(){};t.prototype=e;var n=new t;return t.prototype=null,n}function Pe(e){return k(e)?Z(e)?e.slice():Ee({},e):e}function Ce(e){return Z(e)?e:[e]}function Re(e){return oe.toPath(e)}function Ie(e,t){for(var n=t.length,r=0;r<n;r++){if(null==e)return;e=e[t[r]]}return n?e:void 0}function Ne(e,t,n){var r=Ie(e,Re(t));return x(r)?n:r}function Me(e){return e}function je(e){return e=Te({},e),function(t){return re(t,e)}}function De(e){return e=Re(e),function(t){return Ie(t,e)}}function Le(e,t,n){if(void 0===t)return e;switch(null==n?3:n){case 1:return function(n){return e.call(t,n)};case 3:return function(n,r,o){return e.call(t,n,r,o)};case 4:return function(n,r,o,i){return e.call(t,n,r,o,i)}}return function(){return e.apply(t,arguments)}}function Ue(e,t,n){return null==e?Me:D(e)?Le(e,t,n):k(e)&&!Z(e)?je(e):De(e)}function Fe(e,t){return Ue(e,t,1/0)}function Be(e,t,n){return oe.iteratee!==Fe?oe.iteratee(e,t):Ue(e,t,n)}function Ve(){}function Ze(e,t){return null==t&&(t=e,e=0),e+Math.floor(Math.random()*(t-e+1))}oe.toPath=Ce,oe.iteratee=Fe;var He=Date.now||function(){return(new Date).getTime()};function qe(e){var t=function(t){return e[t]},n="(?:"+ne(e).join("|")+")",r=RegExp(n),o=RegExp(n,"g");return function(e){return e=null==e?"":""+e,r.test(e)?e.replace(o,t):e}}var We={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},Ke=qe(We),$e=qe(Oe(We)),ze=oe.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g},Ye=/(.)^/,Ge={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},Je=/\\|'|\r|\n|\u2028|\u2029/g;function Qe(e){return"\\"+Ge[e]}var Xe=/^\s*(\w|\$)+\s*$/,et=0;function tt(e,t,n,r,o){if(!(r instanceof t))return e.apply(n,o);var i=Ae(e.prototype),a=e.apply(i,o);return k(a)?a:i}var nt=O((function(e,t){var n=nt.placeholder,r=function r(){for(var o=0,i=t.length,a=Array(i),s=0;s<i;s++)a[s]=t[s]===n?arguments[o++]:t[s];for(;o<arguments.length;)a.push(arguments[o++]);return tt(e,r,this,this,a)};return r}));nt.placeholder=oe;var rt=O((function(e,t,n){if(!D(e))throw new TypeError("Bind must be called on a function");var r=O((function(o){return tt(e,r,t,this,n.concat(o))}));return r})),ot=z(ee);function it(e,t,n,r){if(r=r||[],t||0===t){if(t<=0)return r.concat(e)}else t=1/0;for(var o=r.length,i=0,a=ee(e);i<a;i++){var s=e[i];if(ot(s)&&(Z(s)||W(s)))if(t>1)it(s,t-1,n,r),o=r.length;else for(var l=0,u=s.length;l<u;)r[o++]=s[l++];else n||(r[o++]=s)}return r}var at=O((function(e,t){var n=(t=it(t,!1,!1)).length;if(n<1)throw new Error("bindAll must be passed function names");for(;n--;){var r=t[n];e[r]=rt(e[r],e)}return e})),st=O((function(e,t,n){return setTimeout((function(){return e.apply(null,n)}),t)})),lt=nt(st,oe,1);function ut(e){return function(){return!e.apply(this,arguments)}}function ct(e,t){var n;return function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=null),n}}var dt=nt(ct,2);function ft(e,t,n){t=Be(t,n);for(var r,o=ne(e),i=0,a=o.length;i<a;i++)if(t(e[r=o[i]],r,e))return r}function pt(e){return function(t,n,r){n=Be(n,r);for(var o=ee(t),i=e>0?0:o-1;i>=0&&i<o;i+=e)if(n(t[i],i,t))return i;return-1}}var ht=pt(1),mt=pt(-1);function vt(e,t,n,r){for(var o=(n=Be(n,r,1))(t),i=0,a=ee(e);i<a;){var s=Math.floor((i+a)/2);n(e[s])<o?i=s+1:a=s}return i}function gt(e,t,n){return function(r,o,i){var a=0,s=ee(r);if("number"==typeof i)e>0?a=i>=0?i:Math.max(i+s,a):s=i>=0?Math.min(i+1,s):i+s+1;else if(n&&i&&s)return r[i=n(r,o)]===o?i:-1;if(o!=o)return(i=t(l.call(r,a,s),K))>=0?i+a:-1;for(i=e>0?a:s-1;i>=0&&i<s;i+=e)if(r[i]===o)return i;return-1}}var yt=gt(1,ht,vt),bt=gt(-1,mt);function wt(e,t,n){var r=(ot(e)?ht:ft)(e,t,n);if(void 0!==r&&-1!==r)return e[r]}function _t(e,t,n){var r,o;if(t=Le(t,n),ot(e))for(r=0,o=e.length;r<o;r++)t(e[r],r,e);else{var i=ne(e);for(r=0,o=i.length;r<o;r++)t(e[i[r]],i[r],e)}return e}function Ot(e,t,n){t=Be(t,n);for(var r=!ot(e)&&ne(e),o=(r||e).length,i=Array(o),a=0;a<o;a++){var s=r?r[a]:a;i[a]=t(e[s],s,e)}return i}function kt(e){var t=function(t,n,r,o){var i=!ot(t)&&ne(t),a=(i||t).length,s=e>0?0:a-1;for(o||(r=t[i?i[s]:s],s+=e);s>=0&&s<a;s+=e){var l=i?i[s]:s;r=n(r,t[l],l,t)}return r};return function(e,n,r,o){var i=arguments.length>=3;return t(e,Le(n,o,4),r,i)}}var xt=kt(1),Et=kt(-1);function Tt(e,t,n){var r=[];return t=Be(t,n),_t(e,(function(e,n,o){t(e,n,o)&&r.push(e)})),r}function St(e,t,n){t=Be(t,n);for(var r=!ot(e)&&ne(e),o=(r||e).length,i=0;i<o;i++){var a=r?r[i]:i;if(!t(e[a],a,e))return!1}return!0}function At(e,t,n){t=Be(t,n);for(var r=!ot(e)&&ne(e),o=(r||e).length,i=0;i<o;i++){var a=r?r[i]:i;if(t(e[a],a,e))return!0}return!1}function Pt(e,t,n,r){return ot(e)||(e=_e(e)),("number"!=typeof n||r)&&(n=0),yt(e,t,n)>=0}var Ct=O((function(e,t,n){var r,o;return D(t)?o=t:(t=Re(t),r=t.slice(0,-1),t=t[t.length-1]),Ot(e,(function(e){var i=o;if(!i){if(r&&r.length&&(e=Ie(e,r)),null==e)return;i=e[t]}return null==i?i:i.apply(e,n)}))}));function Rt(e,t){return Ot(e,De(t))}function It(e,t,n){var r,i,a=-1/0,s=-1/0;if(null==t||"number"==typeof t&&"object"!=(0,o.default)(e[0])&&null!=e)for(var l=0,u=(e=ot(e)?e:_e(e)).length;l<u;l++)null!=(r=e[l])&&r>a&&(a=r);else t=Be(t,n),_t(e,(function(e,n,r){((i=t(e,n,r))>s||i===-1/0&&a===-1/0)&&(a=e,s=i)}));return a}function Nt(e,t,n){if(null==t||n)return ot(e)||(e=_e(e)),e[Ze(e.length-1)];var r=ot(e)?Pe(e):_e(e),o=ee(r);t=Math.max(Math.min(t,o),0);for(var i=o-1,a=0;a<t;a++){var s=Ze(a,i),l=r[a];r[a]=r[s],r[s]=l}return r.slice(0,t)}function Mt(e,t){return function(n,r,o){var i=t?[[],[]]:{};return r=Be(r,o),_t(n,(function(t,o){var a=r(t,o,n);e(i,t,a)})),i}}var jt=Mt((function(e,t,n){H(e,n)?e[n].push(t):e[n]=[t]})),Dt=Mt((function(e,t,n){e[n]=t})),Lt=Mt((function(e,t,n){H(e,n)?e[n]++:e[n]=1})),Ut=Mt((function(e,t,n){e[n?0:1].push(t)}),!0),Ft=/[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;function Bt(e,t,n){return t in n}var Vt=O((function(e,t){var n={},r=t[0];if(null==e)return n;D(r)?(t.length>1&&(r=Le(r,t[1])),t=le(e)):(r=Bt,t=it(t,!1,!1),e=Object(e));for(var o=0,i=t.length;o<i;o++){var a=t[o],s=e[a];r(s,a,e)&&(n[a]=s)}return n})),Zt=O((function(e,t){var n,r=t[0];return D(r)?(r=ut(r),t.length>1&&(n=t[1])):(t=Ot(it(t,!1,!1),String),r=function(e,n){return!Pt(t,n)}),Vt(e,r,n)}));function Ht(e,t,n){return l.call(e,0,Math.max(0,e.length-(null==t||n?1:t)))}function qt(e,t,n){return null==e||e.length<1?null==t||n?void 0:[]:null==t||n?e[0]:Ht(e,e.length-t)}function Wt(e,t,n){return l.call(e,null==t||n?1:t)}var Kt=O((function(e,t){return t=it(t,!0,!0),Tt(e,(function(e){return!Pt(t,e)}))})),$t=O((function(e,t){return Kt(e,t)}));function zt(e,t,n,r){E(t)||(r=n,n=t,t=!1),null!=n&&(n=Be(n,r));for(var o=[],i=[],a=0,s=ee(e);a<s;a++){var l=e[a],u=n?n(l,a,e):l;t&&!n?(a&&i===u||o.push(l),i=u):n?Pt(i,u)||(i.push(u),o.push(l)):Pt(o,l)||o.push(l)}return o}var Yt=O((function(e){return zt(it(e,!0,!0))}));function Gt(e){for(var t=e&&It(e,ee).length||0,n=Array(t),r=0;r<t;r++)n[r]=Rt(e,r);return n}var Jt=O(Gt);function Qt(e,t){return e._chain?oe(t).chain():t}function Xt(e){return _t(ke(e),(function(t){var n=oe[t]=e[t];oe.prototype[t]=function(){var e=[this._wrapped];return s.apply(e,arguments),Qt(this,n.apply(oe,e))}})),oe}_t(["pop","push","reverse","shift","sort","splice","unshift"],(function(e){var t=n[e];oe.prototype[e]=function(){var n=this._wrapped;return null!=n&&(t.apply(n,arguments),"shift"!==e&&"splice"!==e||0!==n.length||delete n[0]),Qt(this,n)}})),_t(["concat","join","slice"],(function(e){var t=n[e];oe.prototype[e]=function(){var e=this._wrapped;return null!=e&&(e=t.apply(e,arguments)),Qt(this,e)}}));var en=Xt({__proto__:null,VERSION:e,restArguments:O,isObject:k,isNull:function(e){return null===e},isUndefined:x,isBoolean:E,isElement:function(e){return!(!e||1!==e.nodeType)},isString:S,isNumber:A,isDate:P,isRegExp:C,isError:R,isSymbol:I,isArrayBuffer:N,isDataView:V,isArray:Z,isFunction:D,isArguments:W,isFinite:function(e){return!I(e)&&y(e)&&!isNaN(parseFloat(e))},isNaN:K,isTypedArray:X,isEmpty:function(e){if(null==e)return!0;var t=ee(e);return"number"==typeof t&&(Z(e)||S(e)||W(e))?0===t:0===ee(ne(e))},isMatch:re,isEqual:function(e,t){return se(e,t)},isMap:ge,isWeakMap:ye,isSet:be,isWeakSet:we,keys:ne,allKeys:le,values:_e,pairs:function(e){for(var t=ne(e),n=t.length,r=Array(n),o=0;o<n;o++)r[o]=[t[o],e[t[o]]];return r},invert:Oe,functions:ke,methods:ke,extend:Ee,extendOwn:Te,assign:Te,defaults:Se,create:function(e,t){var n=Ae(e);return t&&Te(n,t),n},clone:Pe,tap:function(e,t){return t(e),e},get:Ne,has:function(e,t){for(var n=(t=Re(t)).length,r=0;r<n;r++){var o=t[r];if(!H(e,o))return!1;e=e[o]}return!!n},mapObject:function(e,t,n){t=Be(t,n);for(var r=ne(e),o=r.length,i={},a=0;a<o;a++){var s=r[a];i[s]=t(e[s],s,e)}return i},identity:Me,constant:$,noop:Ve,toPath:Ce,property:De,propertyOf:function(e){return null==e?Ve:function(t){return Ne(e,t)}},matcher:je,matches:je,times:function(e,t,n){var r=Array(Math.max(0,e));t=Le(t,n,1);for(var o=0;o<e;o++)r[o]=t(o);return r},random:Ze,now:He,escape:Ke,unescape:$e,templateSettings:ze,template:function(e,t,n){!t&&n&&(t=n),t=Se({},t,oe.templateSettings);var r=RegExp([(t.escape||Ye).source,(t.interpolate||Ye).source,(t.evaluate||Ye).source].join("|")+"|$","g"),o=0,i="__p+='";e.replace(r,(function(t,n,r,a,s){return i+=e.slice(o,s).replace(Je,Qe),o=s+t.length,n?i+="'+\n((__t=("+n+"))==null?'':_.escape(__t))+\n'":r?i+="'+\n((__t=("+r+"))==null?'':__t)+\n'":a&&(i+="';\n"+a+"\n__p+='"),t})),i+="';\n";var a,s=t.variable;if(s){if(!Xe.test(s))throw new Error("variable is not a bare identifier: "+s)}else i="with(obj||{}){\n"+i+"}\n",s="obj";i="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{a=new Function(s,"_",i)}catch(e){throw e.source=i,e}var l=function(e){return a.call(this,e,oe)};return l.source="function("+s+"){\n"+i+"}",l},result:function(e,t,n){var r=(t=Re(t)).length;if(!r)return D(n)?n.call(e):n;for(var o=0;o<r;o++){var i=null==e?void 0:e[t[o]];void 0===i&&(i=n,o=r),e=D(i)?i.call(e):i}return e},uniqueId:function(e){var t=++et+"";return e?e+t:t},chain:function(e){var t=oe(e);return t._chain=!0,t},iteratee:Fe,partial:nt,bind:rt,bindAll:at,memoize:function(e,t){var n=function n(r){var o=n.cache,i=""+(t?t.apply(this,arguments):r);return H(o,i)||(o[i]=e.apply(this,arguments)),o[i]};return n.cache={},n},delay:st,defer:lt,throttle:function(e,t,n){var r,o,i,a,s=0;n||(n={});var l=function(){s=!1===n.leading?0:He(),r=null,a=e.apply(o,i),r||(o=i=null)},u=function(){var u=He();s||!1!==n.leading||(s=u);var c=t-(u-s);return o=this,i=arguments,c<=0||c>t?(r&&(clearTimeout(r),r=null),s=u,a=e.apply(o,i),r||(o=i=null)):r||!1===n.trailing||(r=setTimeout(l,c)),a};return u.cancel=function(){clearTimeout(r),s=0,r=o=i=null},u},debounce:function(e,t,n){var r,o,i,a,s,l=function l(){var u=He()-o;t>u?r=setTimeout(l,t-u):(r=null,n||(a=e.apply(s,i)),r||(i=s=null))},u=O((function(u){return s=this,i=u,o=He(),r||(r=setTimeout(l,t),n&&(a=e.apply(s,i))),a}));return u.cancel=function(){clearTimeout(r),r=i=s=null},u},wrap:function(e,t){return nt(t,e)},negate:ut,compose:function(){var e=arguments,t=e.length-1;return function(){for(var n=t,r=e[t].apply(this,arguments);n--;)r=e[n].call(this,r);return r}},after:function(e,t){return function(){if(--e<1)return t.apply(this,arguments)}},before:ct,once:dt,findKey:ft,findIndex:ht,findLastIndex:mt,sortedIndex:vt,indexOf:yt,lastIndexOf:bt,find:wt,detect:wt,findWhere:function(e,t){return wt(e,je(t))},each:_t,forEach:_t,map:Ot,collect:Ot,reduce:xt,foldl:xt,inject:xt,reduceRight:Et,foldr:Et,filter:Tt,select:Tt,reject:function(e,t,n){return Tt(e,ut(Be(t)),n)},every:St,all:St,some:At,any:At,contains:Pt,includes:Pt,include:Pt,invoke:Ct,pluck:Rt,where:function(e,t){return Tt(e,je(t))},max:It,min:function(e,t,n){var r,i,a=1/0,s=1/0;if(null==t||"number"==typeof t&&"object"!=(0,o.default)(e[0])&&null!=e)for(var l=0,u=(e=ot(e)?e:_e(e)).length;l<u;l++)null!=(r=e[l])&&r<a&&(a=r);else t=Be(t,n),_t(e,(function(e,n,r){((i=t(e,n,r))<s||i===1/0&&a===1/0)&&(a=e,s=i)}));return a},shuffle:function(e){return Nt(e,1/0)},sample:Nt,sortBy:function(e,t,n){var r=0;return t=Be(t,n),Rt(Ot(e,(function(e,n,o){return{value:e,index:r++,criteria:t(e,n,o)}})).sort((function(e,t){var n=e.criteria,r=t.criteria;if(n!==r){if(n>r||void 0===n)return 1;if(n<r||void 0===r)return-1}return e.index-t.index})),"value")},groupBy:jt,indexBy:Dt,countBy:Lt,partition:Ut,toArray:function(e){return e?Z(e)?l.call(e):S(e)?e.match(Ft):ot(e)?Ot(e,Me):_e(e):[]},size:function(e){return null==e?0:ot(e)?e.length:ne(e).length},pick:Vt,omit:Zt,first:qt,head:qt,take:qt,initial:Ht,last:function(e,t,n){return null==e||e.length<1?null==t||n?void 0:[]:null==t||n?e[e.length-1]:Wt(e,Math.max(0,e.length-t))},rest:Wt,tail:Wt,drop:Wt,compact:function(e){return Tt(e,Boolean)},flatten:function(e,t){return it(e,t,!1)},without:$t,uniq:zt,unique:zt,union:Yt,intersection:function(e){for(var t=[],n=arguments.length,r=0,o=ee(e);r<o;r++){var i=e[r];if(!Pt(t,i)){var a;for(a=1;a<n&&Pt(arguments[a],i);a++);a===n&&t.push(i)}}return t},difference:Kt,unzip:Gt,transpose:Gt,zip:Jt,object:function(e,t){for(var n={},r=0,o=ee(e);r<o;r++)t?n[e[r]]=t[r]:n[e[r][0]]=e[r][1];return n},range:function(e,t,n){null==t&&(t=e||0,e=0),n||(n=t<e?-1:1);for(var r=Math.max(Math.ceil((t-e)/n),0),o=Array(r),i=0;i<r;i++,e+=n)o[i]=e;return o},chunk:function(e,t){if(null==t||t<1)return[];for(var n=[],r=0,o=e.length;r<o;)n.push(l.call(e,r,r+=t));return n},mixin:Xt,default:oe});return en._=en,en}()}(a.u);var s=a.u.exports;t.default=s,e.exports=t.default},2890:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"$",{enumerable:!0,get:function(){return w.default}}),Object.defineProperty(t,"Backbone",{enumerable:!0,get:function(){return F.default}}),Object.defineProperty(t,"BaseModel",{enumerable:!0,get:function(){return i.default}}),t.Form=t.Controller=t.Collection=void 0,Object.defineProperty(t,"FrameworkView",{enumerable:!0,get:function(){return B.default}}),Object.defineProperty(t,"Handlebars",{enumerable:!0,get:function(){return b.default}}),Object.defineProperty(t,"ListView",{enumerable:!0,get:function(){return O.default}}),Object.defineProperty(t,"Model",{enumerable:!0,get:function(){return s.default}}),t.View=t.Router=void 0,Object.defineProperty(t,"_",{enumerable:!0,get:function(){return _.default}}),t.internal=t.createCallout=t.createButton=void 0,Object.defineProperty(t,"isModelPropertySchema",{enumerable:!0,get:function(){return V.isModelPropertySchema}}),t.registerInput=t.loc=void 0;var o=r(n(74154)),i=r(n(34146)),a=r(n(50553)),s=r(n(13614)),l=r(n(84829)),u=r(n(41380)),c=r(n(23825)),d=r(n(2431)),f=r(n(96577)),p=r(n(11403)),h=r(n(86063)),m=r(n(83365)),v=r(n(77861)),g=r(n(88712)),y=r(n(51645)),b=r(n(2875));n(97406),n(37997);var w=r(n(96129)),_=r(n(28107)),O=r(n(54833)),k=r(n(45361)),x=r(n(92328)),E=r(n(1375)),T=r(n(21198)),S=r(n(63301)),A=r(n(57581)),P=r(n(66728)),C=r(n(76906)),R=r(n(15982)),I=r(n(37002)),N=r(n(18329)),M=r(n(63984)),j=r(n(84983)),D=r(n(59924)),L=r(n(69407)),U=r(n(73026)),F=r(n(2770)),B=r(n(67282));n(57223);var V=n(50926);n(53303);var Z=u.default.extend({render:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return k.default.prototype.render.apply(this,t),this}});t.Controller=Z,j.default.prototype.remove=function(){return R.default.prototype.remove.apply(this,arguments)},B.default.prototype.compileTemplate=function(e){var t=function(){return e};return t.source="",t};var H={"input input":"update","change input":"update","keydown input":"update","keyup input":function(e){m.default.isEsc(e)&&this.model.trigger("form:cancel")}},q=L.default.extend({events:H}),W=N.default.extend({events:H}),K=T.default.extend({scrollOnError:function(){return!1!==this.options.settings.get("features.scrollOnError")}});t.Form=K;var $=g.default.localize;t.loc=$;var z=d.default.create;t.createButton=z;var Y=U.default.create;t.createCallout=Y;var G=P.default.register;t.registerInput=G;var J=o.default;t.Collection=J;var Q=k.default;t.View=Q;var X=c.default;t.Router=X;var ee={util:{Util:y.default,Cookie:p.default,Clipboard:h.default,Logger:v.default,Class:f.default,Keys:m.default},views:{components:{BaseDropDown:x.default,Notification:E.default},forms:{helpers:{FormUtil:A.default,SchemaFormFactory:C.default},components:{Toolbar:S.default},inputs:{TextBox:q,PasswordBox:W,CheckBox:I.default,Radio:M.default,Select:j.default,InputGroup:D.default}}},models:{BaseSchema:a.default,SchemaProperty:l.default}};t.internal=ee,G("text",q),G("password",W),G("checkbox",I.default),G("radio",M.default),G("select",j.default),G("group",D.default)},50843:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(2770)),a="__STATE__",s="FETCH_DATA",l="PAGINATION_DATA",u="DEFAULT_PARAMS",c="LINK_BY_HEADER";function d(e,t){try{var n=function(e){for(var t,n=/[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g,r=e.match(/<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g),o={},i=0;i<r.length;i++){var a=r[i].split(">"),s=a[0].substring(1),l={href:void 0,rel:void 0};l.href=s;for(var u=a[1].match(n),c=0;c<u.length;c++){var d=u[c].split("=");l[d[0]]='"'===(t=d[1]).charAt(0)&&'"'===t.charAt(t.length-1)?t.substring(1,t.length-1):t}void 0!==l.rel&&(o[l.rel]=l)}return o}(t.getResponseHeader("link"));e[a].set(c,!0),e.setPagination(n.next.href)}catch(t){e[a].get(c)&&e.setPagination(null)}}var f={params:{},preinitialize:function(e,t){var n=new i.default.Model,r=o.default.defaults(t&&t.params||{},o.default.result(this,"params")||{});n.set(u,r),this[a]=n,o.default.isFunction(this.model)&&0===this.model.length&&!0!==this.model.isCourageModel&&(this.model=o.default.result(this,"model")),i.default.Collection.prototype.preinitialize.apply(this,arguments)},sync:function(e,t,n){var r=this,o=n.success;return n.success=function(e,t,n){d(r,n),o.apply(null,arguments)},i.default.Collection.prototype.sync.call(this,e,t,n)},fetch:function(e){e||(e={});var t=this[a],n=t.get("XHR");return e.data=o.default.extend({},t.get(u),e.data||{}),e.fromFetch=!0,t.set(s,e.data),n&&n.abort&&!1!==e.abort&&n.abort(),n=i.default.Collection.prototype.fetch.call(this,e),t.set("XHR",n),n},setPagination:function(e,t){o.default.isString(e)&&e&&(e=function(e){for(var t={},n=e&&e.split("?")[1],r=n&&n.split("#")[0],o=r?r.split("&"):[],i=0;i<o.length;i++){var a=decodeURIComponent(o[i]).replace(/\+/g," ").split("=");t[a.shift()]=a.join("=")}return t}(e)),o.default.isObject(e)&&!o.default.isArray(e)&&o.default.size(e)?t&&t.fromFetch&&(e=o.default.extend({},this.getFetchData(),e)):e=null,this[a].set(l,e)},getFetchData:function(){return this[a].get(s)||{}},getPaginationData:function(){return this[a].get(l)||{}},hasMore:function(){return o.default.size(this.getPaginationData())>0},fetchMore:function(){if(!this.hasMore())throw new Error("Invalid Request");return this.fetch({data:this.getPaginationData(),add:!0,remove:!1,update:!0})},reset:function(e,t){return t||(t={}),t.fromFetch||this.setPagination(null),i.default.Collection.prototype.reset.apply(this,arguments)},where:function(e,t){return o.default.isEmpty(e)?t?void 0:[]:this[t?"find":"filter"]((function(t){for(var n in e)if(e[n]!==t.get(n))return!1;return!0}))},create:function(e,t){return t||(t={}),o.default.result(e,"urlRoot")||(t.url=o.default.result(this,"url")),i.default.Collection.prototype.create.call(this,e,t)},_reset:function(){i.default.Collection.prototype._reset.call(this),this._byId=Object.create(null)}},p=i.default.Collection.extend(f);t.default=p,p.isCourageCollection=!0,e.exports=t.default},83050:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(67282)),i=r(n(28107)),a=o.default.extend({constructor:function(){if(o.default.apply(this,arguments),!this.collection)throw new Error("Missing collection");this.listenTo(this.collection,"reset sort",this.reset),this.listenTo(this.collection,"add",this.addItem),this.fetchCollection?this.collection.fetch():this.collection.each(this.addItem,this)},item:null,itemSelector:null,reset:function(){var e=this;return this.removeChildren(),this.collection.each((function(t,n){e.addItem(t,n)})),this},addItem:function(e){var t=this.add(this.item,this.itemSelector,{options:{model:e}}).last();return this.state&&this.state.get("trackItemAdded")&&this.state.trigger("itemAdded",t),t.listenTo(e,"destroy remove",t.remove),this},addShowMore:i.default.noop});t.default=a,e.exports=t.default},50926:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0,t.isModelPropertySchema=u;var o,i=r(n(12990)),a=r(n(28107)),s=r(n(2770)),l=r(n(77861));function u(e){return e&&e.type||e.deps}function c(e,t,n,r){var o=a.default.contains(t,n);return r||(r={}),o||!a.default.isObject(e)||a.default.isArray(e)||a.default.isFunction(e)?void 0!==n&&(r[n]=e):a.default.each(e,(function(e,o){c(e,t,n?n+"."+o:o,r)})),r}function d(e){return a.default.each(e,(function(e,t,n){if(-1!==t.indexOf(".")){for(var r,o=n,i=t.split(".");void 0!==(r=i.shift());)o[r]||(o[r]=i.length?{}:e),o=o[r];delete n[t]}})),e}function f(e,t){var n={};return n[e.name]=t,n}function p(e,t){var n;return n=a.default.isString(e)?{type:e}:a.default.isArray(e)?{type:e[0],required:e[1],value:e[2]}:a.default.clone(e),a.default.defaults(n,{required:!1,name:t}),n}function h(e,t,n){if(!t.test(e))return n}var m={email:function(e){return h(e,/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,o.ERROR_INVALID_FORMAT_EMAIL)},uri:function(e){return h(e,/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,o.ERROR_INVALID_FORMAT_URI)},ipv4:function(e){return h(e,/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,o.ERROR_INVALID_FORMAT_IPV4)},hostname:function(e){return h(e,/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/,o.ERROR_INVALID_FORMAT_HOSTNAME)}};function v(e,t){var n=a.default.partial(f,e),r=function(e,t){var n=m[e.format];if(e.format&&!n)throw new TypeError(e.format+" is not a supported string format");return n&&n(t)}(e,t);return r?n(r):t&&e.minLength&&t.length<e.minLength?n(o.ERROR_STRING_STRING_MIN_LENGTH):t&&e.maxLength&&t.length>e.maxLength?n(o.ERROR_STRING_STRING_MAX_LENGTH):void 0}function g(e,t){var n,r,i,s=a.default.partial(f,e),l=!a.default.isUndefined(t)&&!a.default.isNull(t);if(Array.isArray(e.validate)){var u,c=[],d=!1;return e.validate.forEach((function(e){if(t)if("regex"===e.type.toLowerCase())u=new RegExp(e.value.pattern,e.value.flags||"").test(t);else u=!1;else u=!1;d=d||!u,c.push({message:e.hasOwnProperty("message")?e.message:"",passed:u})})),d?s(c):void 0}if(e.required&&(!l||a.default.isNull(t)||""===t))return s(o.ERROR_BLANK);if(n=a.default["is"+(i=e.type,i.toLowerCase().replace(/\b[a-z]/g,(function(e){return e.toUpperCase()})))],l&&"any"!==e.type&&(!a.default.isFunction(n)||!n(t)))return s(o.ERROR_WRONG_TYPE);if(t&&"string"===e.type){var h=v(e,t);if(h)return h}if(l&&e.values&&!a.default.contains(e.values,t))return s(o.ERROR_NOT_ALLOWED);if(a.default.isFunction(e.validate)){var m=e.validate(t);if(a.default.isString(m)&&m)return s(m);if(!1===m)return s(o.ERROR_INVALID)}return l&&"array"===e.type&&(r=function(e,t){if(e.minItems&&t.length<e.minItems)return"model.validation.field.array.minItems";if(e.maxItems&&t.length>e.maxItems)return"model.validation.field.array.maxItems";if(e.uniqueItems&&t.length>a.default.uniq(t).length)return o.ERROR_IARRAY_UNIQUE;if(e.items)for(var n=p(e.items,"placeholder"),r=0;r<t.length;r++){var i=g(n,t[r]);if(i)return i.placeholder}}(e,t))?s(r):void 0}var y={props:{},derived:{},local:{},flat:!0,defaults:{},preinitialize:function(e){for(var t,n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];this.options=e||{};var i=this.__schema__={},l=[];i.computedProperties={},i.props=a.default.clone(a.default.result(this,"props")||{}),i.derived=a.default.clone(a.default.result(this,"derived")||{}),i.local=a.default.clone(a.default.result(this,"local")||{});var u={};if(a.default.each(a.default.extend({},i.props,i.local),(function(e,t){var n=p(e,t);a.default.isUndefined(n.value)||(u[t]=n.value),"object"===n.type&&l.push(t)}),this),a.default.size(u)){var d=a.default.result(this,"defaults");this.defaults=function(){return a.default.defaults({},u,d)}}this.validate=a.default.wrap(this.validate,(function(e){var t=a.default.rest(arguments),n=a.default.extend(this._validateSchema.apply(this,t),e.apply(this,t));return a.default.size(n)&&n||void 0})),this.parse=a.default.wrap(this.parse,(function(e){var t=e.apply(this,a.default.rest(arguments));return a.default.result(this,"flat")&&(t=c(t,l)),t})),(t=s.default.Model.prototype.preinitialize).call.apply(t,[this,e].concat(r))},constructor:function(){s.default.Model.apply(this,arguments);var e=this.__schema__;a.default.each(e.derived,(function(t,n){e.computedProperties[n]=this.__getDerivedValue(n);var r=u(t)&&t.deps||[];r.length&&this.on("cache:clear change:"+r.join(" change:"),(function(){var t=this.__getDerivedValue(n);t!==e.computedProperties[n]&&(e.computedProperties[n]=t,this.trigger("change:"+n,this,t))}),this)}),this),this.on("sync",(function(){this.__syncedData=this.toJSON()}),this)},validate:function(){},allows:function(e){var t=this.__schema__,n=a.default.extend({},t.props,t.local);return a.default.has(n,e)||l.default.warn("Field not defined in schema",e),!0},getPropertySchema:function(e){var t=this.__schema__;return a.default.reduce([t.props,t.local],(function(t,n){return t||p(n[e],e)}),null)},set:function(e,t){var n;"object"===(0,i.default)(e)?n=e:(n={})[e]=t,a.default.each(n,(function(e,t){if(a.default.has(this.__schema__.derived,t))throw new Error("overriding derived properties is not supported: ".concat(t))}),this);var r=[];if(a.default.each(n,(function(e,t){this.allows(t)||r.push(t)}),this),r.length)throw new Error("field not allowed: ".concat(r.join(", ")));return s.default.Model.prototype.set.apply(this,arguments)},get:function(e){var t=this.__schema__;return a.default.has(t.derived,e)?!1!==t.derived[e].cache?t.computedProperties[e]:this.__getDerivedValue(e):s.default.Model.prototype.get.apply(this,arguments)},toJSON:function(e){e||(e={});var t=a.default.clone(s.default.Model.prototype.toJSON.apply(this,arguments)),n=this.__schema__;return e.verbose?a.default.each(n.derived,(function(e,n){t[n]=this.get(n)}),this):t=a.default.omit(t,a.default.keys(n.local)),this.flat&&(t=d(t)),t},reset:function(e){this.clear(e),this.set(a.default.result(this,"defaults"),e)},isSynced:function(){return a.default.isEqual(this.__syncedData,this.toJSON())},validateField:function(e){var t=e&&this.getPropertySchema(e);return t&&g(t,this.get(e))},_validateSchema:function(){var e=this.__schema__;return a.default.reduce(a.default.extend({},e.props,e.local),(function(e,t,n){return a.default.extend(e,this.validateField(n)||{})}),{},this)},__getDerivedValue:function(e){var t=this.__schema__.derived[e];if(a.default.isString(t)){var n=t;t={deps:[n],fn:function(){return this.get(n)}}}var r=t.deps||[];return t.fn.apply(this,a.default.map(r,this.get,this))}};(o=s.default.Model.extend(y,{ERROR_BLANK:"model.validation.field.blank",ERROR_WRONG_TYPE:"model.validation.field.wrong.type",ERROR_NOT_ALLOWED:"model.validation.field.value.not.allowed",ERROR_INVALID:"model.validation.field.invalid",ERROR_IARRAY_UNIQUE:"model.validation.field.array.unique",ERROR_INVALID_FORMAT_EMAIL:"model.validation.field.invalid.format.email",ERROR_INVALID_FORMAT_URI:"model.validation.field.invalid.format.uri",ERROR_INVALID_FORMAT_IPV4:"model.validation.field.invalid.format.ipv4",ERROR_INVALID_FORMAT_HOSTNAME:"model.validation.field.invalid.format.hostname",ERROR_STRING_STRING_MIN_LENGTH:"model.validation.field.string.minLength",ERROR_STRING_STRING_MAX_LENGTH:"model.validation.field.string.maxLength"})).isCourageModel=!0;var b=o;t.default=b},67282:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o,i=r(n(28107)),a=r(n(2770)),s="__children__",l="__rendered__",u="__parent__",c="__children_definitions__",d="__add_to_container__";function f(e,t){for(var n=0;n<e[s].length;n++)if(t.cid===e[s][n].cid)return n}function p(){}function h(e){var t=/^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;i.default.each(i.default.allKeys(e),(function(n){var r=n.match(t);if(r){var o=i.default.result(e,n),a=e.options[r[1]]||e[r[1]];a&&i.default.isObject(o)&&i.default.isFunction(a.trigger)&&i.default.each(o,(function(t,n){var r=i.default.isFunction(t)?[t]:i.default.reduce(t.split(/\s+/),(function(t,n){return i.default.isFunction(e[n])&&t.push(e[n]),t}),[]);i.default.each(r,(function(t){e.listenTo(a,n,t)}))}))}}))}var m={preinitialize:function(e){this.options=e||{},i.default.extend(this,i.default.pick(this.options,"state","settings")),this[s]=[],this[l]=!1,this[u]=null,this[c]=this.children,this.__original_initialize__=this.initialize,this.initialize=p},constructor:function(e){var t;a.default.View.call(this,e),i.default.each(i.default.result(this,c),(function(e){this.add.apply(this,i.default.isArray(e)?e:[e])}),this),delete this[c];var n=i.default.result(this,"autoRender");if(n&&this.model){var r=i.default.isArray(n)?i.default.map(n,(function(e){return"change:"+e})).join(" "):"change";this.listenTo(this.model,r,(function(){this.render()}))}this.initialize=this.__original_initialize__;for(var o=arguments.length,s=new Array(o>1?o-1:0),l=1;l<o;l++)s[l-1]=arguments[l];(t=this.initialize).call.apply(t,[this,e].concat(s)),h(this)},unregister:function(e){this.stopListening(e);var t=f(this,e);i.default.isNumber(t)&&this[s].splice(t,1)},autoRender:!1,template:null,children:[],add:function(e,t,n,r,l){var c,p={},h=i.default.toArray(arguments);if(i.default.isFunction(e)&&(!e.prototype||!e.prototype.render))throw new Error("Type passed to add() is not a View");if(i.default.isObject(t)?(t=(p=t).selector,n=p.bubble,r=p.prepend,l=p.options):i.default.isObject(n)&&(n=(p=n).bubble,r=p.prepend,l=p.options),i.default.isString(e)&&(c=e,e=o.extend({constructor:function(){try{var e=a.default.$(c);if(1!==e.length)throw new Error("invalid Element");var t=/&(\w+|#x\d+);/g,n=e.prop("outerHTML").replace(t," ").length,r=c.replace(t," ").length;if(n!==r)throw new Error("invalid Element");this.template=e.html(),this.el=e.empty()[0]}catch(e){this.template=c}o.apply(this,arguments)}})),e.prototype&&e.prototype instanceof o){var m=i.default.omit(i.default.extend({},this.options,l),"el");return h[0]=new e(m),this.add.apply(this,h)}if(i.default.isNumber(f(this,e)))throw new Error("Duplicate child");return e[u]=this,e[d]=function(t){return function(){if(t&&1!==e[u].$(t).length)throw new Error("Invalid selector: "+t);var n=t?this[u].$(t):this[u].$el;this.render(),this.delegateEvents(),r?n.prepend(this.el):n.append(this.el)}}.call(e,t),n&&this.listenTo(e,"all",(function(){this.trigger.apply(this,arguments)})),this.rendered()&&e[d](),this[s].push(e),this},removeChildren:function(){return this.each((function(e){e.remove()})),this},remove:function(){return this.removeChildren(),this[u]&&this[u].unregister(this),a.default.View.prototype.remove.apply(this,arguments)},compileTemplate:function(e){return i.default.template(e,void 0)},renderTemplate:function(e){if(i.default.isString(e)&&(e=this.compileTemplate(e)),i.default.isFunction(e))return e(this.getTemplateData())},getTemplateData:function(){var e=this.model&&this.model.toJSON({verbose:!0})||{},t=i.default.omit(this.options,["state","settings","model","collection"]);return i.default.defaults({},e,t)},render:function(){return this.preRender(),function(e){e[l]=!0;var t=e.renderTemplate(e.template);t?e.$el.html(t):e.length&&e.$el.empty(),e.each((function(e){e[d]()}))}(this),this.postRender(),this},preRender:p,postRender:p,rendered:function(){return this[l]},getChildren:function(){return this.toArray()},at:function(e){return this.getChildren()[e]},invoke:function(e){var t=i.default.toArray(arguments);return this.each((function(n){n.size()&&n.invoke.apply(n,t),i.default.isFunction(n[e])&&n[e].apply(n,t.slice(1))})),this}};o=a.default.View.extend(m);i.default.each(["each","map","reduce","reduceRight","find","filter","reject","every","some","contains","toArray","size","first","initial","rest","last","without","indexOf","shuffle","lastIndexOf","isEmpty","chain","where","findWhere"],(function(e){o.prototype[e]=function(){var t=i.default.toArray(arguments);return t.unshift(i.default.toArray(this[s])),i.default[e].apply(i.default,t)}})),o.isCourageView=!0;var v=o;t.default=v,e.exports=t.default},74154:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(50843)),a={secureJSON:!1,constructor:function(){i.default.apply(this,arguments),o.default.result(this,"secureJSON")&&(this.sync=o.default.wrap(this.sync,(function(e,t,n,r){return e.call(this,t,n,o.default.extend({dataType:"secureJSON"},r))})))}},s=i.default.extend(a);t.default=s,e.exports=t.default},34146:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(28107)),a=r(n(13614)),s=function(e){var t=i.default.omit(e.local,i.default.keys(e._builtInLocalProps));return i.default.size(e.props)+i.default.size(t)>0},l={flat:!1,constructor:function(){a.default.apply(this,arguments),this.on("sync",this._setSynced)},allows:function(){return!s(this)||a.default.prototype.allows.apply(this,arguments)},set:function(e,t){var n;return"object"===(0,o.default)(e)?n=e:(n={})[e]=t,(0,i.default)(n).each((function(e,t){e&&i.default.isArray(e.__attributes)&&this.on("change:"+e.__attributes.join(" change:"),(function(){var e=this.get(t);e!==this.__schema__.computedProperties[t]&&(this.__schema__.computedProperties[t]=e,this.trigger("change:"+t,e))}),this)}),this),a.default.prototype.set.apply(this,arguments)},get:function(){var e=a.default.prototype.get.apply(this,arguments);return i.default.isFunction(e)?e.apply(this,i.default.map(e.__attributes||[],this.get,this)):e},toJSON:function(e){e||(e={});var t=a.default.prototype.toJSON.apply(this,arguments);return(0,i.default)(t).each((function(n,r){"function"==typeof n&&(e.verbose?t[r]=this.get(r):delete t[r])}),this),e.verbose||(0,i.default)(t).each((function(e,n){/^__\w+__$/.test(n)&&delete t[n]})),t},sanitizeAttributes:function(e){var t={};return i.default.each(e,(function(e,n){i.default.isFunction(e)||(t[n]=e)})),t},reset:function(e){this.clear(e),this.set(this.sanitizeAttributes(this.defaults),e)},clear:function(e){var t={};return i.default.each(this.sanitizeAttributes(this.attributes),(function(e,n){t[n]=void 0})),this.set(t,i.default.extend({},e,{unset:!0}))},_setSynced:function(e){this._syncedData=e&&i.default.isFunction(e.toJSON)?e.toJSON():{}},_getSynced:function(){return this._syncedData},isSynced:function(){return i.default.isEqual(this._getSynced(),this.toJSON())}},u=a.default.extend(l,{ComputedProperty:function(e,t){return t||"function"!=typeof e?t.__attributes=e:t=e,t}});t.default=u,e.exports=t.default},50553:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(74154)),a=r(n(34146)),s=r(n(84829)),l=function(e){var t=o.default.pick(e,"id","name","displayName"),n=o.default.map(e.schema.properties,(function(e,t){return o.default.extend({name:t},e)}));return o.default.each(n,(function(e){e.__schemaMeta__=t,e.__metadata&&(e.__metadata__=e.__metadata,delete e.__metadata)})),n},u=a.default.extend({defaults:{id:void 0,displayName:void 0,name:void 0},constructor:function(){this.properties=new s.default.Collection,a.default.apply(this,arguments)},getProperties:function(){return this.properties},clone:function(){var e=a.default.prototype.clone.apply(this,arguments);return e.getProperties().set(this.getProperties().toJSON({verbose:!0})),e},parse:function(e){var t=l(e);return this.properties.set(t,{parse:!0}),o.default.omit(e,"schema")},trimProperty:function(e){return o.default.omit(e,"name")},toJSON:function(){var e=a.default.prototype.toJSON.apply(this,arguments);return e.schema={properties:{}},this.getProperties().each((function(t){var n=t.toJSON();e.schema.properties[n.name]=this.trimProperty(n)}),this),e},save:function(){return this.getProperties().each((function(e){e.cleanup()})),a.default.prototype.save.apply(this,arguments)}}),c=i.default.extend({model:u}),d={parseProperties:l,Model:u,Collection:c};t.default=d,e.exports=t.default},13614:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(50926)),a=i.default.extend({secureJSON:!1,_builtInLocalProps:{__edit__:"boolean",__pending__:"boolean"},preinitialize:function(){this.local=o.default.defaults({},o.default.result(this,"local"),this._builtInLocalProps),i.default.prototype.preinitialize.apply(this,arguments)},constructor:function(){i.default.apply(this,arguments),o.default.result(this,"secureJSON")&&(this.sync=o.default.wrap(this.sync,(function(e,t,n,r){return e.call(this,t,n,o.default.extend({dataType:"secureJSON"},r))})))}});t.default=a,e.exports=t.default},84829:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(96129)),i=r(n(28107)),a=r(n(74154)),s=r(n(34146)),l=r(n(77861)),u=r(n(33270)),c=r(n(88712)),d=r(n(52078)),f=c.default.localize,p=u.default.STRING,h=u.default.NUMBER,m=u.default.INTEGER,v=u.default.OBJECT,g=s.default.extend({defaults:{description:void 0,minLength:void 0,maxLength:void 0,format:void 0},parse:function(e){if(i.default.isString(e.format)){var t=/^\/(.+)\/$/.exec(e.format);t&&(e.format=t[1])}return e}}),y=a.default.extend({model:g}),b=y.extend({_type:"allOf"}),w=y.extend({_type:"oneOf"}),_=y.extend({_type:"noneOf"}),O={string:f("schema.validation.field.value.must.string","courage"),number:f("schema.validation.field.value.must.number","courage"),integer:f("schema.validation.field.value.must.integer","courage"),object:f("schema.validation.field.value.must.object","courage")},k=/[^a-zA-Z0-9-]/,x={between:"_checkBetweenConstraints",greaterThan:"_checkGreaterThanConstraint",lessThan:"_checkLessThanConstraint",equals:"_checkEqualsConstraint"},E=s.default.extend({idAttribute:"name",local:{__oneOf__:{type:"array",minItems:1}},defaults:{name:"",title:void 0,type:void 0,description:void 0,required:!1,format:void 0,union:void 0,subSchemas:void 0,settings:{permissions:{SELF:u.default.PERMISSION.READ_ONLY}},unique:void 0,__metadata__:void 0,__isSensitive__:s.default.ComputedProperty(["settings"],(function(e){return!(!e||!e.sensitive||"NOT_SENSITIVE"===e.sensitive)})),__isPendingSensitive__:s.default.ComputedProperty(["settings"],(function(e){return!(!e||!e.sensitive||"PENDING_SENSITIVE"!==e.sensitive)})),__unique__:!1,__isUniqueValidated__:s.default.ComputedProperty(["unique"],(function(e){return e===u.default.UNIQUENESS.UNIQUE_VALIDATED})),__isPendingUniqueness__:s.default.ComputedProperty(["unique"],(function(e){return e===u.default.UNIQUENESS.PENDING_UNIQUENESS})),__isUniqueness__:s.default.ComputedProperty(["__isUniqueValidated__","__isPendingUniqueness__"],(function(e,t){return e||t})),__canBeSensitive__:s.default.ComputedProperty(["__metadata__"],(function(e){return!(!e||!e.sensitivizable)})),__userPermission__:u.default.PERMISSION.READ_ONLY,__displayType__:void 0,__displayTypeLabel__:s.default.ComputedProperty(["__displayType__"],(function(e){return u.default.DATATYPE[e]||e})),__supportsMinMax__:!1,__isReadOnly__:s.default.ComputedProperty(["mutability"],(function(e){return e===u.default.MUTABILITY.READONLY})),__isWriteOnly__:s.default.ComputedProperty(["mutability"],(function(e){return e===u.default.MUTABILITY.WRITEONLY})),__displayScope__:void 0,__isScopeSelf__:s.default.ComputedProperty(["scope"],(function(e){return e===u.default.SCOPE.SELF})),__isNoneScopeArrayType__:s.default.ComputedProperty(["__isScopeSelf__","__displayType__"],(function(e,t){return!e&&u.default.isArrayDataType(t)})),__isImported__:s.default.ComputedProperty(["externalName"],(function(e){return!!e})),__isFromBaseSchema__:s.default.ComputedProperty(["__schemaMeta__"],(function(e){return e&&"base"===e.name})),__enumDefined__:!1,__supportEnum__:s.default.ComputedProperty(["__displayType__"],(function(e){return i.default.contains(u.default.SUPPORTENUM,e)})),__isNumberTypeEnum__:s.default.ComputedProperty(["__displayType__"],(function(e){return i.default.contains([u.default.NUMBER,u.default.ARRAYDISPLAYTYPE.arrayofnumber],e)})),__isIntegerTypeEnum__:s.default.ComputedProperty(["__displayType__"],(function(e){return i.default.contains([u.default.INTEGER,u.default.ARRAYDISPLAYTYPE.arrayofinteger],e)})),__isObjectTypeEnum__:s.default.ComputedProperty(["__displayType__"],(function(e){return i.default.contains([u.default.OBJECT,u.default.ARRAYDISPLAYTYPE.arrayofobject],e)})),__isStringTypeEnum__:s.default.ComputedProperty(["__displayType__"],(function(e){return i.default.contains([u.default.STRING,u.default.ARRAYDISPLAYTYPE.arrayofstring],e)})),__enumConstraintType__:s.default.ComputedProperty(["__isStringTypeEnum__","__isNumberTypeEnum__","__isIntegerTypeEnum__","__isObjectTypeEnum__"],(function(e,t,n,r){return e?p:t?h:n?m:r?v:void 0})),__isEnumDefinedAndSupported__:s.default.ComputedProperty(["__enumDefined__","__supportEnum__"],(function(e,t){return e&&t})),__isLoginOfBaseSchema__:s.default.ComputedProperty(["__isFromBaseSchema__","name"],(function(e,t){return e&&"login"===t})),__isLoginFormatRestrictionToEmail__:s.default.ComputedProperty(["__loginFormatRestriction__"],(function(e){return e===u.default.LOGINPATTERNFORMAT.EMAIL}))},initialize:function(){s.default.prototype.initialize.apply(this,arguments),this.listenTo(this,"change:__displayType__",this._updateTypeFormatConstraints),this.listenTo(this,"change:type change:format change:items",this._updateDisplayType),this.listenTo(this,"change:__minVal__ change:__maxVal__",this._updateMinMax),this.listenTo(this,"change:__equals__",this._convertEqualsToMinMax),this.listenTo(this,"change:__constraint__",this._setConstraintText),this._setConstraintText(),this._setLoginPattern()},parse:function(e){return"object"===(e=i.default.clone(e)).type&&"image"===e.extendedType&&(e.type="image"),e.__displayType__=u.default.getDisplayType(e.type,e.format,e.items?e.items.format?e.items.format:e.items.type:void 0),this._setRangeConstraints(e),e.__supportsMinMax__=-1!==u.default.SUPPORTSMINMAX.indexOf(e.__displayType__),e.__displayScope__=u.default.DISPLAYSCOPE[e.scope]||u.default.DISPLAYSCOPE.NA,e.settings&&e.settings.permissions&&e.settings.permissions.SELF&&(e.__userPermission__=e.settings.permissions.SELF),this._setMasterOverride(e),this._setSubSchemas(e),this._setUniqueness(e),e},validate:function(){var e=this._validateEnumOneOf();if(e)return e;if(this.get("__supportsMinMax__")&&this.get("__constraint__")){var t=this.get("__constraint__"),n=this[x[t]];return i.default.isFunction(n)?n.call(this):void l.default.warn("No constraint handler found for: "+t)}},_checkBetweenConstraints:function(){var e=this.get("__minVal__"),t=this.get("__maxVal__");if(e||t){if(!e)return{__minVal__:f("schema.validation.field.enter.minimum.number","courage")};if(!t)return{__maxVal__:f("schema.validation.field.enter.maximum.number","courage")};var n=this._checkIntegerConstraints("__minVal__","Min value");return n||((n=this._checkIntegerConstraints("__maxVal__","Max value"))||(+e>=+t?{__maxVal__:f("schema.validation.field.maximum.must.be.greater.than.minimum","courage")}:void 0))}},_checkGreaterThanConstraint:function(){if(this.get("__minVal__")){var e=this._checkIntegerConstraints("__minVal__","Constraint");return e||void 0}},_checkLessThanConstraint:function(){if(this.get("__maxVal__")){var e=this._checkIntegerConstraints("__maxVal__","Constraint");return e||void 0}},_checkEqualsConstraint:function(){if(this.get("__equals__")){var e=this._checkIntegerConstraints("__equals__","Constraint");return e||void 0}},_checkIntegerConstraints:function(e,t){var n=this.get(e),r={};return isNaN(n)?("Min value"===t?r[e]=f("schema.validation.field.minimum.value.must.be.number","courage"):"Max value"===t?r[e]=f("schema.validation.field.maximum.value.must.be.number","courage"):"Constraint"===t&&(r[e]=f("schema.validation.field.constraint.must.be.number","courage")),r):+n<0?("Min value"===t?r[e]=f("schema.validation.field.minimum.number.must.be.greater.than.zero","courage"):"Max value"===t?r[e]=f("schema.validation.field.maximum.number.must.be.greater.than.zero","courage"):"Constraint"===t&&(r[e]=f("schema.validation.field.number.must.be.greater.than.zero","courage")),r):void 0},_setMasterOverride:function(e){if(e.settings&&e.settings.masterOverride&&e.settings.masterOverride){var t=e.settings.masterOverride.value;i.default.isArray(t)&&!i.default.isEmpty(t)?(e.__masterOverrideType__="OVERRIDE",e.__masterOverrideValue__=t||[]):e.__masterOverrideType__=e.settings.masterOverride.type}else e.__masterOverrideType__="INHERIT"},_setRangeConstraints:function(e){e.__displayType__===p?(e.__minVal__=e.minLength,e.__maxVal__=e.maxLength):e.__displayType__!==m&&e.__displayType__!==h||(e.__minVal__=e.minimum,e.__maxVal__=e.maximum),e.__minVal__&&e.__maxVal__?e.__minVal__===e.__maxVal__?(e.__constraint__="equals",e.__equals__=e.__minVal__):e.__constraint__="between":!e.__minVal__&&e.__maxVal__?e.__constraint__="lessThan":!e.__maxVal__&&e.__minVal__&&(e.__constraint__="greaterThan")},_setSubSchemas:function(e){e.allOf?e.subSchemas=new b(e.allOf,{parse:!0}):e.oneOf?e.subSchemas=new w(e.oneOf,{parse:!0}):e.noneOf&&(e.subSchemas=new _(e.noneOf,{parse:!0}))},_setUniqueness:function(e){var t=e&&e.unique;e.__unique__=!(!t||t!==u.default.UNIQUENESS.UNIQUE_VALIDATED&&t!==u.default.UNIQUENESS.PENDING_UNIQUENESS)},_setLoginPattern:function(){if(this.get("__isLoginOfBaseSchema__")){var e=this.get("pattern");".+"===e?this.set("__loginFormatRestriction__",u.default.LOGINPATTERNFORMAT.NONE):e?(this.set("__loginFormatRestriction__",u.default.LOGINPATTERNFORMAT.CUSTOM),this.set("__loginFormatRestrictionCustom__",this._extractLoginPattern(e))):this.set("__loginFormatRestriction__",u.default.LOGINPATTERNFORMAT.EMAIL)}},_updateDisplayType:function(){var e=this.get("type");if(e===p&&this.get("format"))this.set("__displayType__",u.default.FORMATDISPLAYTYPE[this.get("format")]);else{var t=this.get("items"),n=t&&(t.format?t.format:t.type);e&&n?this.set("__displayType__",u.default.ARRAYDISPLAYTYPE[function(e,t){return e+"of"+t}(e,n)]):this.set("__displayType__",e)}},_validateEnumOneOf:function(){if(this.get("__isEnumDefinedAndSupported__")){var e=this.get("__oneOf__")||[];if(i.default.isEmpty(e))return{__oneOf__:f("model.validation.field.blank","courage")};if(!this._isValidateOneOfConstraint(e)){var t=this.get("__enumConstraintType__");return{__oneOf__:O[t]}}}},_isValidateOneOfConstraint:function(e){var t=this.get("__enumConstraintType__");return i.default.all(e,(function(e){return d.default.isConstraintValueMatchType(e.const,t)}))},toJSON:function(){var e=s.default.prototype.toJSON.apply(this,arguments);return e.settings={permissions:{}},e.settings.permissions.SELF=this.get("__userPermission__"),this.get("__isSensitive__")&&(e.settings.sensitive=this.get("__isSensitive__")),"image"===this.get("type")&&(e.type="object",e.extendedType="image"),e=this._enumAssignment(e),e=this._attributeOverrideToJson(e),e=this._normalizeUnionValue(e),e=this._patternAssignment(e),e=this._uniquenessAssignment(e)},_attributeOverrideToJson:function(e){var t=this.get("__masterOverrideType__"),n=this.get("__masterOverrideValue__");return"OKTA_MASTERED"===t?e.settings.masterOverride={type:"OKTA_MASTERED"}:"OVERRIDE"===t&&(e.settings.masterOverride={type:"ORDERED_LIST",value:[]},n instanceof a.default?i.default.each(n.toJSON(),(function(t){e.settings.masterOverride.value.push(t.id)})):n instanceof Array&&(e.settings.masterOverride.value=n),i.default.isEmpty(e.settings.masterOverride.value)&&delete e.settings.masterOverride),"INHERIT"===t&&delete e.settings.masterOverride,e},_normalizeUnionValue:function(e){return this.get("__isNoneScopeArrayType__")||(e.union=void 0),e},_enumAssignment:function(e){if(!this.get("__isEnumDefinedAndSupported__"))return e;var t=this._getEnumOneOfWithTitleCheck();return"array"===this.get("type")?(delete e.items.enum,e.items.oneOf=t):(delete e.enum,e.oneOf=t),e},_patternAssignment:function(e){if(!this.get("__isLoginOfBaseSchema__")||!this.get("__loginFormatRestriction__"))return e;switch(this.get("__loginFormatRestriction__")){case u.default.LOGINPATTERNFORMAT.EMAIL:delete e.pattern;break;case u.default.LOGINPATTERNFORMAT.CUSTOM:e.pattern=this._buildLoginPattern(this.get("__loginFormatRestrictionCustom__"));break;case u.default.LOGINPATTERNFORMAT.NONE:e.pattern=".+"}return e},_uniquenessAssignment:function(e){return this.get("__unique__")?this.get("__isUniqueness__")||(e.unique=u.default.UNIQUENESS.UNIQUE_VALIDATED):delete e.unique,e},_escapedRegexChar:function(e,t){var n=e.charAt(t);return k.test(n)?"\\"+n:n},_buildLoginPattern:function(e){for(var t="",n=0;n<e.length;n++)t+=this._escapedRegexChar(e,n);return"["+t+"]+"},_extractLoginPattern:function(e){var t=e.match(/^\[(.*)\]\+/);return t?t[1].replace(/\\(.)/g,"$1"):e},_getEnumOneOfWithTitleCheck:function(){var e=this.get("__oneOf__");return i.default.map(e,(function(e){return""!==o.default.trim(e.title)||(e.title=i.default.isString(e.const)?e.const:JSON.stringify(e.const)),e}))},_updateTypeFormatConstraints:function(){var e=this.get("__displayType__");this.unset("format",{silent:!0}),this.unset("items",{silent:!0}),this.set(u.default.DISPLAYTYPES[e]),e!==h&&e!==m&&(this.unset("minimum"),this.unset("maximum")),e!==p&&(this.unset("minLength"),this.unset("maxLength")),this.unset("__minVal__"),this.unset("__maxVal__"),this.unset("__equals__"),this.set("__supportsMinMax__",-1!==u.default.SUPPORTSMINMAX.indexOf(this.get("__displayType__")))},_updateMinMax:function(){var e,t,n=this.get("__displayType__");n===p?(e="minLength",t="maxLength"):n!==m&&n!==h||(e="minimum",t="maximum"),this.get("__minVal__")?this.set(e,parseInt(this.get("__minVal__"),10)):this.unset(e),this.get("__maxVal__")?this.set(t,parseInt(this.get("__maxVal__"),10)):this.unset(t)},_convertEqualsToMinMax:function(){var e=this.get("__equals__");e&&(this.set("__minVal__",e),this.set("__maxVal__",e))},_setConstraintText:function(){var e=this.get("__constraint__"),t=this.get("__minVal__"),n=this.get("__maxVal__"),r=this.get("__equals__");switch(e){case"between":this.set("__constraintText__","Between "+t+" and "+n);break;case"greaterThan":this.set("__constraintText__","Greater than "+t);break;case"lessThan":this.set("__constraintText__","Less than "+n);break;case"equals":this.set("__constraintText__","Equals "+r);break;default:this.set("__constraintText__","")}},cleanup:function(){"lessThan"===this.get("__constraint__")?this.unset("__minVal__"):"greaterThan"===this.get("__constraint__")&&this.unset("__maxVal__"),this.get("scope")!==u.default.SCOPE.SYSTEM&&(!0===this.get("__isScopeSelf__")?this.set({scope:u.default.SCOPE.SELF},{silent:!0}):this.unset("scope")),this.get("__unique__")||this.unset("unique")},isEnumType:function(){return!!this.getEnumValues()},getEnumValues:function(){return this.get("oneOf")||this.get("enum")||this.get("items")&&this.get("items").oneOf||this.get("items")&&this.get("items").enum},detectHasEnumDefined:function(){var e=this.getEnumValues();e&&(this.set("__oneOf__",d.default.convertToOneOf(e)),this.set("__enumDefined__",!0))}}),T={Model:E,Collection:a.default.extend({model:E,clone:function(){return new this.constructor(this.toJSON({verbose:!0}),{parse:!0})},areAllReadOnly:function(){return i.default.all(this.pluck("__isReadOnly__"))},createModelProperties:function(){return this.reduce((function(e,t){var n=t.get("type");return e[t.id]=i.default.clone(u.default.DISPLAYTYPES[n]),-1!==u.default.SUPPORTSMINMAX.indexOf(n)&&(e[t.id].minLength=t.get("minLength"),e[t.id].maxLength=t.get("maxLength")),"string"===n&&(e[t.id].format=t.get("format")),e}),{})}})};t.default=T,e.exports=t.default},41380:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(96129)),i=r(n(28107)),a=r(n(23825)),s=r(n(53303)),l=r(n(50999)),u=r(n(45361));function c(e){var t={};return i.default.each(e,(function(e,n){i.default.isNull(e)||(t[n]=e)})),t}var d={preinitialize:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.state=i.default.result(this,"state");var t=this.state instanceof l.default||e.state instanceof l.default;if(!t){var n=i.default.defaults(c(e.state),this.state||{});this.state=new l.default(n),delete e.state}e.settings||(e.settings=new s.default(i.default.omit(e||{},"el")),this.listen("notification",a.default.prototype._notify),this.listen("confirmation",a.default.prototype._confirm)),u.default.prototype.preinitialize.call(this,e)},constructor:function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};u.default.call(this,t),this.listenTo(this.state,"__invoke__",(function(){var e=i.default.toArray(arguments),t=e.shift();i.default.isFunction(this[t])&&this[t].apply(this,e)})),this.View&&this.View.isCourageView?e=this.View:i.default.result(this,"View")&&i.default.result(this,"View").isCourageView&&(e=i.default.result(this,"View")),e&&this.add(new e(this.toJSON()))},state:{},View:null,render:function(){var e=arguments,t=this;return(0,o.default)((function(){u.default.prototype.render.apply(t,e)})),this},toJSON:function(e){return i.default.extend(i.default.pick(this,"state","settings","collection","model"),e||{})},remove:function(){return this.removeChildren(),this.stopListening(),this.$el.empty(),this}},f=u.default.extend(d);t.default=f,e.exports=t.default},23825:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2770)),i=r(n(20290)),a=r(n(96129)),s=r(n(28107)),l=r(n(77861)),u=r(n(53303)),c=r(n(1375));function d(e,t){var n=s.default.result(e,"root")||"";return n&&s.default.isString(t)?[n,t].join("/").replace(/\/{2,}/g,"/"):t}var f={root:"",listen:c.default.prototype.listen,constructor:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.el=e.el,this.settings=new u.default(s.default.omit(e,"el")),e.root&&(this.root=e.root),o.default.Router.apply(this,arguments),this.listen("notification",this._notify),this.listen("confirmation",this._confirm)},_confirm:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=i.default.extend(s.default.pick(e,"title","subtitle","save","ok","cancel","cancelFn","noCancelButton","noSubmitButton","content","danger","type","closeOnOverlayClick","buttonOrder")),n=new t({model:this.settings});return n.render(),n},_notify:function(e){var t=new c.default(e);return(0,a.default)("#content").prepend(t.render().el),t},render:function(e,t){this.unload(),t=s.default.extend(s.default.pick(this,"settings","el"),t||{}),this.controller=new e(t),this.controller.render()},start:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];(0,a.default)((function(){var e;o.default.History.started?l.default.error("History has already been started"):(e=o.default.history).start.apply(e,t)}))},unload:function(){this.controller&&(this.stopListening(this.controller),this.stopListening(this.controller.state),this.controller.remove())},route:function(e,t,n){return o.default.Router.prototype.route.call(this,d(this,e),t,n)},navigate:function(e,t){return o.default.Router.prototype.navigate.call(this,d(this,e),t)}},p=o.default.Router.extend(f);t.default=p,e.exports=t.default},2431:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(73613));function a(e){var t=o.default.extend(e.click?{click:e.click}:{},e.events||{}),n={};return o.default.each(t,(function(t,r){n[r]=function(n){e.href||(n.preventDefault(),n.stopPropagation()),this.disabled&&"click"===r||t.apply(this,arguments)}})),n}var s={create:function(e){return(e=o.default.clone(e)).attrs=e.attributes,delete e.attributes,i.default.extend(o.default.extend(e,{events:a(e)}))}};t.default=s,e.exports=t.default},96577:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;var o=r(n(2770)),i=r(n(28107));function a(e){this.options=i.default.clone(e||{}),this.cid=i.default.uniqueId("class"),this.initialize.apply(this,arguments)}i.default.extend(a.prototype,o.default.Events,{initialize:function(){}}),a.extend=o.default.Model.extend,e.exports=t.default},86063:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(35237)),i=r(n(96129)),a=r(n(28107)),s=r(n(67282)),l=r(n(96577)),u=o.default,c=["success","error","target","text"],d=l.default.extend({initialize:function(e,t){var n,r,o;t=a.default.pick(t||{},c),a.default.isString(e)&&(n=e),a.default.isElement(e)&&(n=e),e instanceof i.default&&(n=e.selector),e instanceof s.default&&(n=e.el),a.default.isFunction(t.target)&&(r=t.target),a.default.isElement(t.target)&&(r=a.default.constant(t.target)),a.default.isString(t.text)?o=a.default.constant(t.text):a.default.isFunction(t.text)&&(o=t.text),this.__instance=new u(n,{target:r,text:o}),this.done=a.default.partial(this.__setCallback,"success"),this.error=a.default.partial(this.__setCallback,"error"),this.done(t.success),this.error(t.error)},__setCallback:function(e,t){if(a.default.isFunction(t))return this.__instance.on(e,t),this.__instance}}),f={attach:function(e,t){return new d(e,t)}};t.default=f,e.exports=t.default},11403:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(62806)),a=/^https/.test(window.location.href),s={setCookie:function(e,t,n){i.default.set(e,t,o.default.defaults(n||{},{secure:a,path:"/"}))},getCookie:function(){return i.default.get.apply(i.default,arguments)},removeCookie:function(){return i.default.remove.apply(i.default,arguments)}};t.default=s,e.exports=t.default},83365:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={UP:38,DOWN:40,DEL:46,TAB:9,RETURN:13,ENTER:13,ESC:27,COMMA:188,PAGEUP:33,PAGEDOWN:34,SPACE:32,BACKSPACE:8,__isKey:function(e,t){return(e.which||e.keyCode)===this[t]},isEnter:function(e){return this.__isKey(e,"ENTER")},isEsc:function(e){return this.__isKey(e,"ESC")},isSpaceBar:function(e){return this.__isKey(e,"SPACE")}},e.exports=t.default},77861:function(e,t){"use strict";function n(e){if(window.console&&window.okta&&window.okta.debug){for(var t,n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];(t=window.console)[e].apply(t,r)}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r={trace:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["trace"].concat(t))},dir:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["dir"].concat(t))},time:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["time"].concat(t))},timeEnd:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["timeEnd"].concat(t))},group:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["group"].concat(t))},groupEnd:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["groupEnd"].concat(t))},assert:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["assert"].concat(t))},log:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["log"].concat(t))},info:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["info"].concat(t))},warn:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["warn"].concat(t))},error:function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return n.apply(void 0,["error"].concat(t))}};t.default=r,e.exports=t.default},33270:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(88712)).default.localize,a={STRING:"string",NUMBER:"number",INTEGER:"integer",BOOLEAN:"boolean",OBJECT:"object",FORMATDISPLAYTYPE:{"date-time":"date",uri:"uri",email:"email","country-code":"country-code","language-code":"language-code",country_code:"country_code",language_code:"language_code",locale:"locale",timezone:"timezone","ref-id":"reference"},ARRAYDISPLAYTYPE:{arrayofobject:"arrayofobject",arrayofstring:"arrayofstring",arrayofnumber:"arrayofnumber",arrayofinteger:"arrayofinteger","arrayofref-id":"arrayofref-id"},DISPLAYTYPES:{date:{type:"string",format:"date-time"},uri:{type:"string",format:"uri"},email:{type:"string",format:"email"},"country-code":{type:"string",format:"country-code"},"language-code":{type:"string",format:"language-code"},country_code:{type:"string"},language_code:{type:"string"},locale:{type:"string",format:"locale"},timezone:{type:"string",format:"timezone"},string:{type:"string"},number:{type:"number"},boolean:{type:"boolean"},integer:{type:"integer"},reference:{type:"string",format:"ref-id"},arrayofobject:{type:"array",items:{type:"object"}},arrayofstring:{type:"array",items:{type:"string"}},arrayofnumber:{type:"array",items:{type:"number"}},arrayofinteger:{type:"array",items:{type:"integer"}},"arrayofref-id":{type:"array",items:{type:"string",format:"ref-id"}},image:{type:"image"},password:{type:"string"}},SUPPORTSMINMAX:["string","number","integer","password"],SUPPORTENUM:["string","number","integer","object","arrayofstring","arrayofnumber","arrayofinteger","arrayofobject"],DATATYPE:{string:"string",number:"number",boolean:"boolean",integer:"integer",date:"datetime",object:"object",arrayofobject:"object array",arrayofstring:"string array",arrayofnumber:"number array",arrayofinteger:"integer array","arrayofref-id":"reference array","country-code":"country code","language-code":"language code",country_code:"country code",language_code:"language code",reference:"reference",timezone:"timezone",image:"image"},MUTABILITY:{READONLY:"READ_ONLY",WRITEONLY:"WRITE_ONLY",READWRITE:"READ_WRITE",IMMUTABLE:"IMMUTABLE"},SCOPE:{NONE:"NONE",SELF:"SELF",SYSTEM:"SYSTEM"},DISPLAYSCOPE:{SELF:"User personal",SYSTEM:"System",NA:"None"},UNION:{DISABLE:"DISABLE",ENABLE:"ENABLE"},UNION_OPTIONS:{DISABLE:i("universal-directory.profiles.attribute.form.union.enable.display","courage"),ENABLE:i("universal-directory.profiles.attribute.form.union.disable.display","courage")},PERMISSION:{HIDE:"HIDE",READ_ONLY:"READ_ONLY",WRITE_ONLY:"WRITE_ONLY",READ_WRITE:"READ_WRITE"},ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS:{HIDE:i("universal-directory.profiles.attribute.enduser.permission.hide","courage"),READ_ONLY:i("universal-directory.profiles.attribute.enduser.permission.readonly","courage"),READ_WRITE:i("universal-directory.profiles.attribute.enduser.permission.readwrite","courage")},ATTRIBUTE_LEVEL_MASTERING_OPTIONS:{INHERIT:i("universal-directory.profiles.attribute.source.inherit","courage"),OKTA_MASTERED:i("universal-directory.profiles.attribute.source.oktamastered","courage"),OVERRIDE:i("universal-directory.profiles.attribute.source.override","courage")},USERNAMETYPE:{NONE:"non-username",OKTA_TO_APP:"okta-to-app-username",OKTA_TO_AD:"okta-to-ad-username",APP_TO_OKTA:"app-to-okta-username",IDP_TO_OKTA:"idp-to-okta-username"},LOGINPATTERNFORMAT:{EMAIL:"EMAIL",CUSTOM:"CUSTOM",NONE:"NONE"},UNIQUENESS:{NOT_UNIQUE:"NOT_UNIQUE",PENDING_UNIQUENESS:"PENDING_UNIQUENESS",UNIQUE_VALIDATED:"UNIQUE_VALIDATED"},getDisplayType:function(e,t,n,r){var o;return e&&(o=t?this.FORMATDISPLAYTYPE[t]:n?this.ARRAYDISPLAYTYPE[e+"of"+n]:e),o||(o=void 0===r?"":r),o},getSourceUsernameType:function(e,t,n){var r=this.USERNAMETYPE.NONE;return"oktaToApp"===e?"userName"===t?r=this.USERNAMETYPE.OKTA_TO_APP:"cn"===t&&(r=this.USERNAMETYPE.OKTA_TO_AD):"appToOkta"===e&&"login"===t&&(r="saml_idp"===n?this.USERNAMETYPE.IDP_TO_OKTA:this.USERNAMETYPE.APP_TO_OKTA),r},isArrayDataType:function(e){return o.default.contains(o.default.values(this.ARRAYDISPLAYTYPE),e)},isObjectDataType:function(e){return this.DATATYPE.object===e}};t.default=a,e.exports=t.default},53303:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(13614)),a={local:function(){var e=window.okta&&window.okta.settings||{},t=window.okta&&window.okta.theme||"";return{orgId:["string",!1,e.orgId],orgName:["string",!1,e.orgName],serverStatus:["string",!1,e.serverStatus],persona:["string",!1,e.persona],isDeveloperConsole:["boolean",!1,e.isDeveloperConsole],isPreview:["boolean",!1,e.isPreview],permissions:["array",!0,e.permissions||[]],theme:["string",!1,t]}},constructor:function(){i.default.apply(this,arguments),this.features=window._features||[]},hasFeature:function(e){return o.default.contains(this.features,e)},hasAnyFeature:function(e){return o.default.some(e,this.hasFeature,this)},hasPermission:function(e){return o.default.contains(this.get("permissions"),e)},isDsTheme:function(){return"dstheme"===this.get("theme")}},s=i.default.extend(a);t.default=s,e.exports=t.default},50999:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(13614)).default.extend({invoke:function(){var e=o.default.toArray(arguments);e.unshift("__invoke__"),this.trigger.apply(this,e)}});t.default=i,e.exports=t.default},88712:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(96129)),i=r(n(28107)),a=r(n(52115)),s={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'","&#039;":"'","&#x2F;":"/"},l=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,u=function(e){if(/-/.test(e)){var t=e.split("-");return t[1]=t[1].toUpperCase(),t.join("_")}return e};function c(){return window&&window.okta&&window.okta.locale?window.okta.isEnableBcp47OktaUi?window.okta.locale:window.okta.locale.toLowerCase():"en"}function d(e){if(!e)return a.default[i.default.keys(a.default)[0]];var t=u(c());return a.default["".concat(e,"_").concat(t)]||a.default[e]}function f(e,t){t=t||{bubbles:!1,cancelable:!1,detail:null};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}function p(e,t,n){if(window.CustomEvent||(window.CustomEvent=f),"function"==typeof window.CustomEvent){var r=new CustomEvent("okta-i18n-error",{detail:{type:"l10n-error",key:e,bundleName:t,reason:n}});document.dispatchEvent(r)}}var h={getRawLocale:function(){return c()},getParsedLocale:function(){return u(c())},isLocaleBundleExist:function(e,t){var n=u(t);return!!a.default["".concat(e,"_").concat(n)]},sprintf:function(){var e=Array.prototype.slice.apply(arguments),t=e.shift(),n=t;function r(){throw new Error("Mismatch number of variables: "+arguments[0]+", "+JSON.stringify(e))}for(var o=0,i=e.length;o<i;o++){var a=e[o],s=new RegExp("\\{"+o+"\\}","g");t=t.replace(s,a),null!=a&&t!==n||r(),n=t}return/\{[\d+]\}/.test(t)&&r(),t},parseQuery:function(e){for(var t={},n=decodeURIComponent(e.replace(/\+/g," ")).split("&"),r=0;r<n.length;r++){var o=n[r].split("=");t[o.shift()]=o.join("=")}return t},encodeJSObject:function(e){return encodeURIComponent(JSON.stringify(e))},decodeJSObject:function(e){try{return JSON.parse(decodeURIComponent(e))}catch(e){return null}},unescapeHtml:function(e){return String(e).replace(/&[\w#\d]{2,};/g,(function(e){return s[e]||e}))},getTemplate:function(e,t){var n=d(t);return n?n[e]?n[e]:(p(e,t,"key"),"L10N_ERROR["+e+"]"):(p(e,t,"bundle"),"L10N_ERROR["+t+"]")},localize:function(e,t,n){var r=d(t);if(!r)return p(e,t,"bundle"),"L10N_ERROR["+t+"]";var o=r[e];try{return(n=n&&n.slice?n.slice(0):[]).unshift(o),(o=h.sprintf.apply(null,n))||(p(e,t,"key"),"L10N_ERROR["+e+"]")}catch(n){return p(e,t,"parameters"),"L10N_ERROR["+e+"]"}},parseFloat:function(e){function t(t){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(e){var t=+e;return"string"==typeof e&&t===parseFloat(e)?t:e})),parseInt:function(e){function t(t){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(e){var t=+e;return i.default.isString(e)&&t===parseInt(e,10)?t:e})),parseObject:function(e){if(!i.default.isString(e))return e;try{var t=JSON.parse(e);return o.default.isPlainObject(t)?t:e}catch(t){return e}},randomString:function(e){var t="0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";if(void 0===e)e=i.default.random(t.length);else if(0===e)return"";for(var n=[];e--;)n.push(t[i.default.random(t.length-1)]);return n.join("")},endsWith:function(e,t){return(e+="").length>=(t+="").length&&e.substring(e.length-t.length)===t},isEmail:function(e){var t=o.default.trim(e);return!i.default.isEmpty(t)&&l.test(t)}};t.default=h,e.exports=t.default},86499:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i={tpl:r(n(28107)).default.memoize((function(e){return function(t){return o.default.compile(e)(t)}}))};t.default=i,e.exports=t.default},60196:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={DEBOUNCE_DELAY:200,LOADING_FADE:400,UNLOADING_FADE:400,ROW_EXPANDER_TRANSITION:150,HIDE_ADD_MAPPING_FORM:300},e.exports=t.default},51645:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(45361)),a={redirect:function(e){window.location=e},reloadPage:function(){window.location.reload()},constantError:function(e){return function(){throw new Error(e)}},getUrlQueryString:function(e){o.default.isObject(e)||(e={});var t=o.default.without(o.default.map(e,(function(e,t){if(null!=e)return t+"="+encodeURIComponent(e)})),void 0).join("&");return o.default.isEmpty(t)?"":"?"+t},isABaseView:function(e){return e instanceof i.default||e.prototype instanceof i.default||e===i.default},isSafari:function(){return/^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent)}};t.default=a,e.exports=t.default},50808:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107));function i(e,t){var n=this.model.get(t);return o.default.isFunction(e)?e.call(this,n):e===n}function a(e,t,n){var r=o.default.bind(n,e,e,t);e.render=o.default.wrap(e.render,(function(t){var n=t.call(e);return r({animate:!1}),n})),e.listenTo(e.model,function(e){return"change:"+o.default.keys(e).join(" change:")}(t),(function(){r({animate:!0})}))}var s={applyDoWhen:function(e,t,n){e.model&&o.default.isObject(t)&&o.default.size(t)&&o.default.isFunction(n)&&a(e,t,(function(e,t,r){var a=o.default.every(o.default.map(t,i,e));n.call(e,a,r)}))}};t.default=s,e.exports=t.default},97406:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return o.default}});var o=r(n(2875)),i=o.default.Utils.escapeExpression;o.default.Utils.escapeExpression=function(e){return i(e).replace(/&#x3D;/g,"=")},e.exports=t.default},37997:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"default",{enumerable:!0,get:function(){return i.default}});var o=r(n(66583)),i=r(n(2875)),a=r(n(28107)),s=r(n(77861)),l=r(n(88712)),u=i.default.Utils.escapeExpression;function c(e){return e&&e.replace(/^\s+|\s+$/g,"")}i.default.registerHelper("i18n",(function(e){var t,n=c(e.hash.code),r=c(e.hash.bundle),d=c(e.hash.arguments),f=Object.keys(e.hash).filter((function(e){return e.match(/^\$\d+/)})).map((function(t){return{tag:t,value:e.hash[t]}}));d&&(t=a.default.map(c(d).split(";"),(function(e){var t,n=this;return e=c(e),a.default.each(e.split("."),(function(e){t=t?t[e]:n[e]})),t}),this));var p=l.default.localize(n,r,t);if(f.length<1)return p;var h=u(p);try{return f.forEach((function(e){h=function(e,t,n){var r=u("<".concat(t,">")),i=u("</".concat(t,">")),a=n.split(t),s=(0,o.default)(a,2),l=s[0],c=s[1];if(!e.includes(r)&&!e.includes(i))throw Error('Parsed tag "'.concat(t,'" is not present in "').concat(e,'"'));if(!n.includes(t))throw Error('Parsed tag "'.concat(t,'" is not present in "').concat(n,'"'));if(!l||!c)throw Error('Template value "'.concat(n,'" must contain beginning and closing tags'));return e.replace(r,l).replace(i,c)}(h,e.tag,e.value)})),new i.default.SafeString(h)}catch(e){return s.default.error(e.toString()),p}})),e.exports=t.default},96129:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(79602));o.default.ajaxSetup({beforeSend:function(e){e.setRequestHeader("X-Okta-XsrfToken",(0,o.default)("#_xsrfToken").text())},converters:{"text secureJSON":function(e){return"while(1){};"===e.substring(0,11)&&(e=e.substring(11)),JSON.parse(e)}}});var i=o.default;t.default=i,window.jQueryCourage=i,e.exports=t.default},28107:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(37870));i.default.mixin({resultCtx:function(e,t,n,r){var o=i.default.isObject(e)?e[t]:void 0;return i.default.isFunction(o)&&(o=o.call(n||e)),o||(i.default.isUndefined(r)?o:r)},isInteger:function(e){return i.default.isNumber(e)&&e%1==0},template:function(e,t){var n=o.default.compile(e);if(t)return n(t);var r=function(e){return n(e)};return r.source="",r}});var a=i.default;t.default=a,e.exports=t.default},2770:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=n(22603),a=n(59098),s=r(n(79602));n(37870);var l=n(3206);!function(e,t){
//     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
//     Backbone may be freely distributed under the MIT license.
var n=s.default;!function(e){var r,a="object"==("undefined"==typeof self?"undefined":(0,o.default)(self))&&self.self===self&&self||"object"==(0,o.default)(i.commonjsGlobal)&&i.commonjsGlobal.global===i.commonjsGlobal&&i.commonjsGlobal,s=l.u.exports;try{r=n}catch(e){}!function(e,t,n,r){var i=e.Backbone,a=Array.prototype.slice;t.VERSION="1.4.0",t.$=r,t.noConflict=function(){return e.Backbone=i,this},t.emulateHTTP=!1,t.emulateJSON=!1;var s,l=t.Events={},u=/\s+/,c=function e(t,r,i,a,s){var l,c=0;if(i&&"object"===(0,o.default)(i)){void 0!==a&&"context"in s&&void 0===s.context&&(s.context=a);for(l=n.keys(i);c<l.length;c++)r=e(t,r,l[c],i[l[c]],s)}else if(i&&u.test(i))for(l=i.split(u);c<l.length;c++)r=t(r,l[c],a,s);else r=t(r,i,a,s);return r};l.on=function(e,t,n){(this._events=c(d,this._events||{},e,t,{context:n,ctx:this,listening:s}),s)&&((this._listeners||(this._listeners={}))[s.id]=s,s.interop=!1);return this},l.listenTo=function(e,t,r){if(!e)return this;var o=e._listenId||(e._listenId=n.uniqueId("l")),i=this._listeningTo||(this._listeningTo={}),a=s=i[o];a||(this._listenId||(this._listenId=n.uniqueId("l")),a=s=i[o]=new g(this,e));var l=f(e,t,r,this);if(s=void 0,l)throw l;return a.interop&&a.on(t,r),this};var d=function(e,t,n,r){if(n){var o=e[t]||(e[t]=[]),i=r.context,a=r.ctx,s=r.listening;s&&s.count++,o.push({callback:n,context:i,ctx:i||a,listening:s})}return e},f=function(e,t,n,r){try{e.on(t,n,r)}catch(e){return e}};l.off=function(e,t,n){return this._events?(this._events=c(p,this._events,e,t,{context:n,listeners:this._listeners}),this):this},l.stopListening=function(e,t,r){var o=this._listeningTo;if(!o)return this;for(var i=e?[e._listenId]:n.keys(o),a=0;a<i.length;a++){var s=o[i[a]];if(!s)break;s.obj.off(t,r,this),s.interop&&s.off(t,r)}return n.isEmpty(o)&&(this._listeningTo=void 0),this};var p=function(e,t,r,o){if(e){var i,a=o.context,s=o.listeners,l=0;if(t||a||r){for(i=t?[t]:n.keys(e);l<i.length;l++){var u=e[t=i[l]];if(!u)break;for(var c=[],d=0;d<u.length;d++){var f=u[d];if(r&&r!==f.callback&&r!==f.callback._callback||a&&a!==f.context)c.push(f);else{var p=f.listening;p&&p.off(t,r)}}c.length?e[t]=c:delete e[t]}return e}for(i=n.keys(s);l<i.length;l++)s[i[l]].cleanup()}};l.once=function(e,t,n){var r=c(h,{},e,t,this.off.bind(this));return"string"==typeof e&&null==n&&(t=void 0),this.on(r,t,n)},l.listenToOnce=function(e,t,n){var r=c(h,{},t,n,this.stopListening.bind(this,e));return this.listenTo(e,r)};var h=function(e,t,r,o){if(r){var i=e[t]=n.once((function(){o(t,i),r.apply(this,arguments)}));i._callback=r}return e};l.trigger=function(e){if(!this._events)return this;for(var t=Math.max(0,arguments.length-1),n=Array(t),r=0;r<t;r++)n[r]=arguments[r+1];return c(m,this._events,e,void 0,n),this};var m=function(e,t,n,r){if(e){var o=e[t],i=e.all;o&&i&&(i=i.slice()),o&&v(o,r),i&&v(i,[t].concat(r))}return e},v=function(e,t){var n,r=-1,o=e.length,i=t[0],a=t[1],s=t[2];switch(t.length){case 0:for(;++r<o;)(n=e[r]).callback.call(n.ctx);return;case 1:for(;++r<o;)(n=e[r]).callback.call(n.ctx,i);return;case 2:for(;++r<o;)(n=e[r]).callback.call(n.ctx,i,a);return;case 3:for(;++r<o;)(n=e[r]).callback.call(n.ctx,i,a,s);return;default:for(;++r<o;)(n=e[r]).callback.apply(n.ctx,t);return}},g=function(e,t){this.id=e._listenId,this.listener=e,this.obj=t,this.interop=!0,this.count=0,this._events=void 0};g.prototype.on=l.on,g.prototype.off=function(e,t){var n;this.interop?(this._events=c(p,this._events,e,t,{context:void 0,listeners:void 0}),n=!this._events):(this.count--,n=0===this.count),n&&this.cleanup()},g.prototype.cleanup=function(){delete this.listener._listeningTo[this.obj._listenId],this.interop||delete this.obj._listeners[this.id]},l.bind=l.on,l.unbind=l.off,n.extend(t,l);var y=t.Model=function(e,t){var r=e||{};t||(t={}),this.preinitialize.apply(this,arguments),this.cid=n.uniqueId(this.cidPrefix),this.attributes={},t.collection&&(this.collection=t.collection),t.parse&&(r=this.parse(r,t)||{});var o=n.result(this,"defaults");r=n.defaults(n.extend({},o,r),o),this.set(r,t),this.changed={},this.initialize.apply(this,arguments)};n.extend(y.prototype,l,{changed:null,validationError:null,idAttribute:"id",cidPrefix:"c",preinitialize:function(){},initialize:function(){},toJSON:function(e){return n.clone(this.attributes)},sync:function(){return t.sync.apply(this,arguments)},get:function(e){return this.attributes[e]},escape:function(e){return n.escape(this.get(e))},has:function(e){return null!=this.get(e)},matches:function(e){return!!n.iteratee(e,this)(this.attributes)},set:function(e,t,r){if(null==e)return this;var i;if("object"===(0,o.default)(e)?(i=e,r=t):(i={})[e]=t,r||(r={}),!this._validate(i,r))return!1;var a=r.unset,s=r.silent,l=[],u=this._changing;this._changing=!0,u||(this._previousAttributes=n.clone(this.attributes),this.changed={});var c=this.attributes,d=this.changed,f=this._previousAttributes;for(var p in i)t=i[p],n.isEqual(c[p],t)||l.push(p),n.isEqual(f[p],t)?delete d[p]:d[p]=t,a?delete c[p]:c[p]=t;if(this.idAttribute in i&&(this.id=this.get(this.idAttribute)),!s){l.length&&(this._pending=r);for(var h=0;h<l.length;h++)this.trigger("change:"+l[h],this,c[l[h]],r)}if(u)return this;if(!s)for(;this._pending;)r=this._pending,this._pending=!1,this.trigger("change",this,r);return this._pending=!1,this._changing=!1,this},unset:function(e,t){return this.set(e,void 0,n.extend({},t,{unset:!0}))},clear:function(e){var t={};for(var r in this.attributes)t[r]=void 0;return this.set(t,n.extend({},e,{unset:!0}))},hasChanged:function(e){return null==e?!n.isEmpty(this.changed):n.has(this.changed,e)},changedAttributes:function(e){if(!e)return!!this.hasChanged()&&n.clone(this.changed);var t,r=this._changing?this._previousAttributes:this.attributes,o={};for(var i in e){var a=e[i];n.isEqual(r[i],a)||(o[i]=a,t=!0)}return!!t&&o},previous:function(e){return null!=e&&this._previousAttributes?this._previousAttributes[e]:null},previousAttributes:function(){return n.clone(this._previousAttributes)},fetch:function(e){e=n.extend({parse:!0},e);var t=this,r=e.success;return e.success=function(n){var o=e.parse?t.parse(n,e):n;if(!t.set(o,e))return!1;r&&r.call(e.context,t,n,e),t.trigger("sync",t,n,e)},Y(this,e),this.sync("read",this,e)},save:function(e,t,r){var i;null==e||"object"===(0,o.default)(e)?(i=e,r=t):(i={})[e]=t;var a=(r=n.extend({validate:!0,parse:!0},r)).wait;if(i&&!a){if(!this.set(i,r))return!1}else if(!this._validate(i,r))return!1;var s=this,l=r.success,u=this.attributes;r.success=function(e){s.attributes=u;var t=r.parse?s.parse(e,r):e;if(a&&(t=n.extend({},i,t)),t&&!s.set(t,r))return!1;l&&l.call(r.context,s,e,r),s.trigger("sync",s,e,r)},Y(this,r),i&&a&&(this.attributes=n.extend({},u,i));var c=this.isNew()?"create":r.patch?"patch":"update";"patch"!==c||r.attrs||(r.attrs=i);var d=this.sync(c,this,r);return this.attributes=u,d},destroy:function(e){e=e?n.clone(e):{};var t=this,r=e.success,o=e.wait,i=function(){t.stopListening(),t.trigger("destroy",t,t.collection,e)};e.success=function(n){o&&i(),r&&r.call(e.context,t,n,e),t.isNew()||t.trigger("sync",t,n,e)};var a=!1;return this.isNew()?n.defer(e.success):(Y(this,e),a=this.sync("delete",this,e)),o||i(),a},url:function(){var e=n.result(this,"urlRoot")||n.result(this.collection,"url")||z();if(this.isNew())return e;var t=this.get(this.idAttribute);return e.replace(/[^\/]$/,"$&/")+encodeURIComponent(t)},parse:function(e,t){return e},clone:function(){return new this.constructor(this.attributes)},isNew:function(){return!this.has(this.idAttribute)},isValid:function(e){return this._validate({},n.extend({},e,{validate:!0}))},_validate:function(e,t){if(!t.validate||!this.validate)return!0;e=n.extend({},this.attributes,e);var r=this.validationError=this.validate(e,t)||null;return!r||(this.trigger("invalid",this,r,n.extend(t,{validationError:r})),!1)}});var b=t.Collection=function(e,t){t||(t={}),this.preinitialize.apply(this,arguments),t.model&&(this.model=t.model),void 0!==t.comparator&&(this.comparator=t.comparator),this._reset(),this.initialize.apply(this,arguments),e&&this.reset(e,n.extend({silent:!0},t))},w={add:!0,remove:!0,merge:!0},_={add:!0,remove:!1},O=function(e,t,n){n=Math.min(Math.max(n,0),e.length);var r,o=Array(e.length-n),i=t.length;for(r=0;r<o.length;r++)o[r]=e[r+n];for(r=0;r<i;r++)e[r+n]=t[r];for(r=0;r<o.length;r++)e[r+i+n]=o[r]};n.extend(b.prototype,l,{model:y,preinitialize:function(){},initialize:function(){},toJSON:function(e){return this.map((function(t){return t.toJSON(e)}))},sync:function(){return t.sync.apply(this,arguments)},add:function(e,t){return this.set(e,n.extend({merge:!1},t,_))},remove:function(e,t){t=n.extend({},t);var r=!n.isArray(e);e=r?[e]:e.slice();var o=this._removeModels(e,t);return!t.silent&&o.length&&(t.changes={added:[],merged:[],removed:o},this.trigger("update",this,t)),r?o[0]:o},set:function(e,t){if(null!=e){(t=n.extend({},w,t)).parse&&!this._isModel(e)&&(e=this.parse(e,t)||[]);var r=!n.isArray(e);e=r?[e]:e.slice();var o=t.at;null!=o&&(o=+o),o>this.length&&(o=this.length),o<0&&(o+=this.length+1);var i,a,s=[],l=[],u=[],c=[],d={},f=t.add,p=t.merge,h=t.remove,m=!1,v=this.comparator&&null==o&&!1!==t.sort,g=n.isString(this.comparator)?this.comparator:null;for(a=0;a<e.length;a++){i=e[a];var y=this.get(i);if(y){if(p&&i!==y){var b=this._isModel(i)?i.attributes:i;t.parse&&(b=y.parse(b,t)),y.set(b,t),u.push(y),v&&!m&&(m=y.hasChanged(g))}d[y.cid]||(d[y.cid]=!0,s.push(y)),e[a]=y}else f&&(i=e[a]=this._prepareModel(i,t))&&(l.push(i),this._addReference(i,t),d[i.cid]=!0,s.push(i))}if(h){for(a=0;a<this.length;a++)d[(i=this.models[a]).cid]||c.push(i);c.length&&this._removeModels(c,t)}var _=!1,k=!v&&f&&h;if(s.length&&k?(_=this.length!==s.length||n.some(this.models,(function(e,t){return e!==s[t]})),this.models.length=0,O(this.models,s,0),this.length=this.models.length):l.length&&(v&&(m=!0),O(this.models,l,null==o?this.length:o),this.length=this.models.length),m&&this.sort({silent:!0}),!t.silent){for(a=0;a<l.length;a++)null!=o&&(t.index=o+a),(i=l[a]).trigger("add",i,this,t);(m||_)&&this.trigger("sort",this,t),(l.length||c.length||u.length)&&(t.changes={added:l,removed:c,merged:u},this.trigger("update",this,t))}return r?e[0]:e}},reset:function(e,t){t=t?n.clone(t):{};for(var r=0;r<this.models.length;r++)this._removeReference(this.models[r],t);return t.previousModels=this.models,this._reset(),e=this.add(e,n.extend({silent:!0},t)),t.silent||this.trigger("reset",this,t),e},push:function(e,t){return this.add(e,n.extend({at:this.length},t))},pop:function(e){var t=this.at(this.length-1);return this.remove(t,e)},unshift:function(e,t){return this.add(e,n.extend({at:0},t))},shift:function(e){var t=this.at(0);return this.remove(t,e)},slice:function(){return a.apply(this.models,arguments)},get:function(e){if(null!=e)return this._byId[e]||this._byId[this.modelId(this._isModel(e)?e.attributes:e)]||e.cid&&this._byId[e.cid]},has:function(e){return null!=this.get(e)},at:function(e){return e<0&&(e+=this.length),this.models[e]},where:function(e,t){return this[t?"find":"filter"](e)},findWhere:function(e){return this.where(e,!0)},sort:function(e){var t=this.comparator;if(!t)throw new Error("Cannot sort a set without a comparator");e||(e={});var r=t.length;return n.isFunction(t)&&(t=t.bind(this)),1===r||n.isString(t)?this.models=this.sortBy(t):this.models.sort(t),e.silent||this.trigger("sort",this,e),this},pluck:function(e){return this.map(e+"")},fetch:function(e){var t=(e=n.extend({parse:!0},e)).success,r=this;return e.success=function(n){var o=e.reset?"reset":"set";r[o](n,e),t&&t.call(e.context,r,n,e),r.trigger("sync",r,n,e)},Y(this,e),this.sync("read",this,e)},create:function(e,t){var r=(t=t?n.clone(t):{}).wait;if(!(e=this._prepareModel(e,t)))return!1;r||this.add(e,t);var o=this,i=t.success;return t.success=function(e,t,n){r&&o.add(e,n),i&&i.call(n.context,e,t,n)},e.save(null,t),e},parse:function(e,t){return e},clone:function(){return new this.constructor(this.models,{model:this.model,comparator:this.comparator})},modelId:function(e){return e[this.model.prototype.idAttribute||"id"]},values:function(){return new x(this,E)},keys:function(){return new x(this,T)},entries:function(){return new x(this,S)},_reset:function(){this.length=0,this.models=[],this._byId={}},_prepareModel:function(e,t){if(this._isModel(e))return e.collection||(e.collection=this),e;(t=t?n.clone(t):{}).collection=this;var r=new this.model(e,t);return r.validationError?(this.trigger("invalid",this,r.validationError,t),!1):r},_removeModels:function(e,t){for(var n=[],r=0;r<e.length;r++){var o=this.get(e[r]);if(o){var i=this.indexOf(o);this.models.splice(i,1),this.length--,delete this._byId[o.cid];var a=this.modelId(o.attributes);null!=a&&delete this._byId[a],t.silent||(t.index=i,o.trigger("remove",o,this,t)),n.push(o),this._removeReference(o,t)}}return n},_isModel:function(e){return e instanceof y},_addReference:function(e,t){this._byId[e.cid]=e;var n=this.modelId(e.attributes);null!=n&&(this._byId[n]=e),e.on("all",this._onModelEvent,this)},_removeReference:function(e,t){delete this._byId[e.cid];var n=this.modelId(e.attributes);null!=n&&delete this._byId[n],this===e.collection&&delete e.collection,e.off("all",this._onModelEvent,this)},_onModelEvent:function(e,t,n,r){if(t){if(("add"===e||"remove"===e)&&n!==this)return;if("destroy"===e&&this.remove(t,r),"change"===e){var o=this.modelId(t.previousAttributes()),i=this.modelId(t.attributes);o!==i&&(null!=o&&delete this._byId[o],null!=i&&(this._byId[i]=t))}}this.trigger.apply(this,arguments)}});var k="function"==typeof Symbol&&Symbol.iterator;k&&(b.prototype[k]=b.prototype.values);var x=function(e,t){this._collection=e,this._kind=t,this._index=0},E=1,T=2,S=3;k&&(x.prototype[k]=function(){return this});x.prototype.next=function(){if(this._collection){if(this._index<this._collection.length){var e,t=this._collection.at(this._index);if(this._index++,this._kind===E)e=t;else{var n=this._collection.modelId(t.attributes);e=this._kind===T?n:[n,t]}return{value:e,done:!1}}this._collection=void 0}return{value:void 0,done:!0}};var A=t.View=function(e){this.cid=n.uniqueId("view"),this.preinitialize.apply(this,arguments),n.extend(this,n.pick(e,C)),this._ensureElement(),this.initialize.apply(this,arguments)},P=/^(\S+)\s*(.*)$/,C=["model","collection","el","id","attributes","className","tagName","events"];n.extend(A.prototype,l,{tagName:"div",$:function(e){return this.$el.find(e)},preinitialize:function(){},initialize:function(){},render:function(){return this},remove:function(){return this._removeElement(),this.stopListening(),this},_removeElement:function(){this.$el.remove()},setElement:function(e){return this.undelegateEvents(),this._setElement(e),this.delegateEvents(),this},_setElement:function(e){this.$el=e instanceof t.$?e:t.$(e),this.el=this.$el[0]},delegateEvents:function(e){if(e||(e=n.result(this,"events")),!e)return this;for(var t in this.undelegateEvents(),e){var r=e[t];if(n.isFunction(r)||(r=this[r]),r){var o=t.match(P);this.delegate(o[1],o[2],r.bind(this))}}return this},delegate:function(e,t,n){return this.$el.on(e+".delegateEvents"+this.cid,t,n),this},undelegateEvents:function(){return this.$el&&this.$el.off(".delegateEvents"+this.cid),this},undelegate:function(e,t,n){return this.$el.off(e+".delegateEvents"+this.cid,t,n),this},_createElement:function(e){return document.createElement(e)},_ensureElement:function(){if(this.el)this.setElement(n.result(this,"el"));else{var e=n.extend({},n.result(this,"attributes"));this.id&&(e.id=n.result(this,"id")),this.className&&(e.class=n.result(this,"className")),this.setElement(this._createElement(n.result(this,"tagName"))),this._setAttributes(e)}},_setAttributes:function(e){this.$el.attr(e)}});var R=function(e,t,n,r){switch(t){case 1:return function(){return e[n](this[r])};case 2:return function(t){return e[n](this[r],t)};case 3:return function(t,o){return e[n](this[r],N(t,this),o)};case 4:return function(t,o,i){return e[n](this[r],N(t,this),o,i)};default:return function(){var t=a.call(arguments);return t.unshift(this[r]),e[n].apply(e,t)}}},I=function(e,t,r,o){n.each(r,(function(n,r){t[r]&&(e.prototype[r]=R(t,n,r,o))}))},N=function(e,t){return n.isFunction(e)?e:n.isObject(e)&&!t._isModel(e)?M(e):n.isString(e)?function(t){return t.get(e)}:e},M=function(e){var t=n.matches(e);return function(e){return t(e.attributes)}},j={forEach:3,each:3,map:3,collect:3,reduce:0,foldl:0,inject:0,reduceRight:0,foldr:0,find:3,detect:3,filter:3,select:3,reject:3,every:3,all:3,some:3,any:3,include:3,includes:3,contains:3,invoke:0,max:3,min:3,toArray:1,size:1,first:3,head:3,take:3,initial:3,rest:3,tail:3,drop:3,last:3,without:0,difference:0,indexOf:3,shuffle:1,lastIndexOf:3,isEmpty:1,chain:1,sample:3,partition:3,groupBy:3,countBy:3,sortBy:3,indexBy:3,findIndex:3,findLastIndex:3},D={keys:1,values:1,pairs:1,invert:1,pick:0,omit:0,chain:1,isEmpty:1};n.each([[b,j,"models"],[y,D,"attributes"]],(function(e){var t=e[0],r=e[1],o=e[2];t.mixin=function(e){var r=n.reduce(n.functions(e),(function(e,t){return e[t]=0,e}),{});I(t,e,r,o)},I(t,n,r,o)})),t.sync=function(e,r,o){var i=L[e];n.defaults(o||(o={}),{emulateHTTP:t.emulateHTTP,emulateJSON:t.emulateJSON});var a={type:i,dataType:"json"};if(o.url||(a.url=n.result(r,"url")||z()),null!=o.data||!r||"create"!==e&&"update"!==e&&"patch"!==e||(a.contentType="application/json",a.data=JSON.stringify(o.attrs||r.toJSON(o))),o.emulateJSON&&(a.contentType="application/x-www-form-urlencoded",a.data=a.data?{model:a.data}:{}),o.emulateHTTP&&("PUT"===i||"DELETE"===i||"PATCH"===i)){a.type="POST",o.emulateJSON&&(a.data._method=i);var s=o.beforeSend;o.beforeSend=function(e){if(e.setRequestHeader("X-HTTP-Method-Override",i),s)return s.apply(this,arguments)}}"GET"===a.type||o.emulateJSON||(a.processData=!1);var l=o.error;o.error=function(e,t,n){o.textStatus=t,o.errorThrown=n,l&&l.call(o.context,e,t,n)};var u=o.xhr=t.ajax(n.extend(a,o));return r.trigger("request",r,u,o),u};var L={create:"POST",update:"PUT",patch:"PATCH",delete:"DELETE",read:"GET"};t.ajax=function(){return t.$.ajax.apply(t.$,arguments)};var U=t.Router=function(e){e||(e={}),this.preinitialize.apply(this,arguments),e.routes&&(this.routes=e.routes),this._bindRoutes(),this.initialize.apply(this,arguments)},F=/\((.*?)\)/g,B=/(\(\?)?:\w+/g,V=/\*\w+/g,Z=/[\-{}\[\]+?.,\\\^$|#\s]/g;n.extend(U.prototype,l,{preinitialize:function(){},initialize:function(){},route:function(e,r,o){n.isRegExp(e)||(e=this._routeToRegExp(e)),n.isFunction(r)&&(o=r,r=""),o||(o=this[r]);var i=this;return t.history.route(e,(function(n){var a=i._extractParameters(e,n);!1!==i.execute(o,a,r)&&(i.trigger.apply(i,["route:"+r].concat(a)),i.trigger("route",r,a),t.history.trigger("route",i,r,a))})),this},execute:function(e,t,n){e&&e.apply(this,t)},navigate:function(e,n){return t.history.navigate(e,n),this},_bindRoutes:function(){if(this.routes){this.routes=n.result(this,"routes");for(var e,t=n.keys(this.routes);null!=(e=t.pop());)this.route(e,this.routes[e])}},_routeToRegExp:function(e){return e=e.replace(Z,"\\$&").replace(F,"(?:$1)?").replace(B,(function(e,t){return t?e:"([^/?]+)"})).replace(V,"([^?]*?)"),new RegExp("^"+e+"(?:\\?([\\s\\S]*))?$")},_extractParameters:function(e,t){var r=e.exec(t).slice(1);return n.map(r,(function(e,t){return t===r.length-1?e||null:e?decodeURIComponent(e):null}))}});var H=t.History=function(){this.handlers=[],this.checkUrl=this.checkUrl.bind(this),"undefined"!=typeof window&&(this.location=window.location,this.history=window.history)},q=/^[#\/]|\s+$/g,W=/^\/+|\/+$/g,K=/#.*$/;H.started=!1,n.extend(H.prototype,l,{interval:50,atRoot:function(){return this.location.pathname.replace(/[^\/]$/,"$&/")===this.root&&!this.getSearch()},matchRoot:function(){return this.decodeFragment(this.location.pathname).slice(0,this.root.length-1)+"/"===this.root},decodeFragment:function(e){return decodeURI(e.replace(/%25/g,"%2525"))},getSearch:function(){var e=this.location.href.replace(/#.*/,"").match(/\?.+/);return e?e[0]:""},getHash:function(e){var t=(e||this).location.href.match(/#(.*)$/);return t?t[1]:""},getPath:function(){var e=this.decodeFragment(this.location.pathname+this.getSearch()).slice(this.root.length-1);return"/"===e.charAt(0)?e.slice(1):e},getFragment:function(e){return null==e&&(e=this._usePushState||!this._wantsHashChange?this.getPath():this.getHash()),e.replace(q,"")},start:function(e){if(H.started)throw new Error("Backbone.history has already been started");if(H.started=!0,this.options=n.extend({root:"/"},this.options,e),this.root=this.options.root,this._wantsHashChange=!1!==this.options.hashChange,this._hasHashChange="onhashchange"in window&&(void 0===document.documentMode||document.documentMode>7),this._useHashChange=this._wantsHashChange&&this._hasHashChange,this._wantsPushState=!!this.options.pushState,this._hasPushState=!(!this.history||!this.history.pushState),this._usePushState=this._wantsPushState&&this._hasPushState,this.fragment=this.getFragment(),this.root=("/"+this.root+"/").replace(W,"/"),this._wantsHashChange&&this._wantsPushState){if(!this._hasPushState&&!this.atRoot()){var t=this.root.slice(0,-1)||"/";return this.location.replace(t+"#"+this.getPath()),!0}this._hasPushState&&this.atRoot()&&this.navigate(this.getHash(),{replace:!0})}if(!this._hasHashChange&&this._wantsHashChange&&!this._usePushState){this.iframe=document.createElement("iframe"),this.iframe.src="javascript:0",this.iframe.style.display="none",this.iframe.tabIndex=-1;var r=document.body,o=r.insertBefore(this.iframe,r.firstChild).contentWindow;o.document.open(),o.document.close(),o.location.hash="#"+this.fragment}var i=window.addEventListener||function(e,t){return attachEvent("on"+e,t)};if(this._usePushState?i("popstate",this.checkUrl,!1):this._useHashChange&&!this.iframe?i("hashchange",this.checkUrl,!1):this._wantsHashChange&&(this._checkUrlInterval=setInterval(this.checkUrl,this.interval)),!this.options.silent)return this.loadUrl()},stop:function(){var e=window.removeEventListener||function(e,t){return detachEvent("on"+e,t)};this._usePushState?e("popstate",this.checkUrl,!1):this._useHashChange&&!this.iframe&&e("hashchange",this.checkUrl,!1),this.iframe&&(document.body.removeChild(this.iframe),this.iframe=null),this._checkUrlInterval&&clearInterval(this._checkUrlInterval),H.started=!1},route:function(e,t){this.handlers.unshift({route:e,callback:t})},checkUrl:function(e){var t=this.getFragment();if(t===this.fragment&&this.iframe&&(t=this.getHash(this.iframe.contentWindow)),t===this.fragment)return!1;this.iframe&&this.navigate(t),this.loadUrl()},loadUrl:function(e){return!!this.matchRoot()&&(e=this.fragment=this.getFragment(e),n.some(this.handlers,(function(t){if(t.route.test(e))return t.callback(e),!0})))},navigate:function(e,t){if(!H.started)return!1;t&&!0!==t||(t={trigger:!!t}),e=this.getFragment(e||"");var n=this.root;""!==e&&"?"!==e.charAt(0)||(n=n.slice(0,-1)||"/");var r=n+e;e=e.replace(K,"");var o=this.decodeFragment(e);if(this.fragment!==o){if(this.fragment=o,this._usePushState)this.history[t.replace?"replaceState":"pushState"]({},document.title,r);else{if(!this._wantsHashChange)return this.location.assign(r);if(this._updateHash(this.location,e,t.replace),this.iframe&&e!==this.getHash(this.iframe.contentWindow)){var i=this.iframe.contentWindow;t.replace||(i.document.open(),i.document.close()),this._updateHash(i.location,e,t.replace)}}return t.trigger?this.loadUrl(e):void 0}},_updateHash:function(e,t,n){if(n){var r=e.href.replace(/(javascript:|#).*$/,"");e.replace(r+"#"+t)}else e.hash="#"+t}}),t.history=new H;var $=function(e,t){var r,o=this;return r=e&&n.has(e,"constructor")?e.constructor:function(){return o.apply(this,arguments)},n.extend(r,o,t),r.prototype=n.create(o.prototype,e),r.prototype.constructor=r,r.__super__=o.prototype,r};y.extend=b.extend=U.extend=A.extend=H.extend=$;var z=function(){throw new Error('A "url" property or function must be specified')},Y=function(e,t){var n=t.error;t.error=function(r){n&&n.call(t.context,e,r,t),e.trigger("error",e,r,t)}}}(a,t,s,r)}()}(a.b,a.b.exports);var u=a.b.exports;t.default=u,e.exports=t.default},62806:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(89278);
/*!
 * JavaScript Cookie v2.1.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */!function(e,t){e.exports=function(){function e(){for(var e=0,t={};e<arguments.length;e++){var n=arguments[e];for(var r in n)t[r]=n[r]}return t}function t(n){function r(t,o,i){var a;if(arguments.length>1){if("number"==typeof(i=e({path:"/"},r.defaults,i)).expires){var s=new Date;s.setMilliseconds(s.getMilliseconds()+864e5*i.expires),i.expires=s}try{a=JSON.stringify(o),/^[\{\[]/.test(a)&&(o=a)}catch(e){}return o=n.write?n.write(o,t):encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),t=(t=(t=encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape),document.cookie=[t,"=",o,i.expires&&"; expires="+i.expires.toUTCString(),i.path&&"; path="+i.path,i.domain&&"; domain="+i.domain,i.secure?"; secure":""].join("")}t||(a={});for(var l=document.cookie?document.cookie.split("; "):[],u=/(%[0-9A-Z]{2})+/g,c=0;c<l.length;c++){var d=l[c].split("="),f=d[0].replace(u,decodeURIComponent),p=d.slice(1).join("=");'"'===p.charAt(0)&&(p=p.slice(1,-1));try{if(p=n.read?n.read(p,f):n(p,f)||p.replace(u,decodeURIComponent),this.json)try{p=JSON.parse(p)}catch(e){}if(t===f){a=p;break}t||(a[f]=p)}catch(e){}}return a}return r.get=r.set=r,r.getJSON=function(){return r.apply({json:!0},[].slice.call(arguments))},r.defaults={},r.remove=function(t,n){r(t,"",e(n,{expires:-1}))},r.withConverter=t,r}return t((function(){}))}()}(r.j);var o=r.j.exports;t.default=o,e.exports=t.default},1303:function(e,t,n){"use strict";var r,o,i=n(1654)(n(79602));
/**
 * --------------------------------------------------------------------
 * jQuery customInput plugin
 * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
 * Copyright (c) 2009 Filament Group
 * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
 * --------------------------------------------------------------------
*/
r=i.default,o=r,r.fn.customInput=function(){return o(this).each((function(){if(o(this).is("[type=checkbox],[type=radio]")){var e=o(this),t=e.siblings('label[for="'+e.attr("id")+'"]:first');t.length||(t=e.closest('label[for="'+e.attr("id")+'"]:first')),e.add(t).wrapAll('<div class="custom-'+e.attr("type")+'"></div>'),t.hover((function(){o(this).addClass("hover")}),(function(){o(this).removeClass("hover")})),e.bind("updateState",(function(){e.is(":checked")?t.addClass("checked"):t.removeClass("checked checkedHover checkedFocus")})).trigger("updateState").click((function(){o('input[name="'+o(this).attr("name")+'"]').trigger("updateState")})).focus((function(){t.addClass("focus"),e.is(":checked")&&o(this).addClass("checkedFocus")})).blur((function(){t.removeClass("focus checkedFocus")}))}}))}},22891:function(e,t,n){"use strict";var r=n(1654)(n(79602));
/*! http://mths.be/placeholder v2.0.7 by @mathias */
!function(){var e,t,n=r.default,o="placeholder"in document.createElement("input"),i="placeholder"in document.createElement("textarea"),a=n.fn,s=n.valHooks;function l(e,t){var r=this,o=n(r);if(r.value==o.attr("placeholder")&&o.hasClass("placeholder"))if(o.data("placeholder-password")){if(o=o.hide().next().show().attr("id",o.removeAttr("id").data("placeholder-id")),!0===e)return o[0].value=t;o.focus()}else r.value="",o.removeClass("placeholder"),r==document.activeElement&&r.select()}function u(){var e,t,r,o,i=this,a=n(i),s=this.id;if(""==i.value){if("password"==i.type){if(!a.data("placeholder-textinput")){try{e=a.clone().attr({type:"text"})}catch(i){e=n("<input>").attr(n.extend((t=this,r={},o=/^jQuery\d+$/,n.each(t.attributes,(function(e,t){t.specified&&!o.test(t.name)&&(r[t.name]=t.value)})),r),{type:"text"}))}e.removeAttr("name").data({"placeholder-password":!0,"placeholder-id":s}).bind("focus.placeholder",l),a.data({"placeholder-textinput":e,"placeholder-id":s}).before(e)}a=a.removeAttr("id").hide().prev().attr("id",s).show()}a.addClass("placeholder"),a[0].value=a.attr("placeholder")}else a.removeClass("placeholder")}o&&i?(t=a.placeholder=function(){return this}).input=t.textarea=!0:((t=a.placeholder=function(){return this.filter((o?"textarea":":input")+"[placeholder]").not(".placeholder").bind({"focus.placeholder":l,"blur.placeholder":u}).data("placeholder-enabled",!0).trigger("blur.placeholder"),this}).input=o,t.textarea=i,e={get:function(e){var t=n(e);return t.data("placeholder-enabled")&&t.hasClass("placeholder")?"":e.value},set:function(e,t){var r=n(e);return r.data("placeholder-enabled")?(""==t?(e.value=t,e!=document.activeElement&&u.call(e)):r.hasClass("placeholder")&&l.call(e,!0,t)||(e.value=t),r):e.value=t}},o||(s.input=e),i||(s.textarea=e),n((function(){n(document).delegate("form","submit.placeholder",(function(){var e=n(".placeholder",this).each(l);setTimeout((function(){e.each(u)}),10)}))})),n(window).bind("beforeunload.placeholder",(function(){n(".placeholder").each((function(){this.value=""}))})))}()},54833:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(83050)),i=r(n(45361)).default.decorate(o.default);t.default=i,e.exports=t.default},45361:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2770)),a=r(n(28107)),s=r(n(67282)),l=r(n(86499)),u=a.default.clone(i.default.Events),c={constructor:function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];s.default.call.apply(s.default,[this,e].concat(n)),this.module&&this.$el.attr("data-view",this.module.id)},empty:function(){return this.removeChildren()},compileTemplate:l.default.tpl,broadcast:function(){return u.trigger.apply(u,arguments),this},listen:function(e,t){return u.off(e,t),this.listenTo(u,e,t),this},notify:function(e,t,n){return this.broadcast("notification",a.default.defaults({message:t,level:e},n)),this},confirm:function(e,t,n,r){var i;return i="object"===(0,o.default)(e)?e:2===arguments.length&&a.default.isFunction(t)?{title:"Okta",subtitle:e,ok:t}:{title:e,subtitle:t,ok:n,cancelFn:r},a.default.isFunction(i.ok)&&(i.ok=a.default.bind(i.ok,this)),a.default.isFunction(i.cancelFn)&&(i.cancelFn=a.default.bind(i.cancelFn,this)),this.broadcast("confirmation",i),this},alert:function(e){return a.default.isString(e)&&(e={subtitle:e}),this.confirm(a.default.extend({},e,{noCancelButton:!0})),this}},d=s.default.extend(c,{decorate:function(e){var t=e.extend({});return a.default.defaults(t.prototype,c),t}});t.default=d,e.exports=t.default},73613:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(28107)),a=r(n(50808)),s=r(n(45361)),l={click:function(e){e.preventDefault(),e.stopPropagation()}},u=s.default.extend({attributes:function(){var e=this.__getAttribute("attrs");return i.default.extend({"data-se":"button"},e)},tagName:"a",template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon '+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"icon")||(null!=t?a(t,"icon"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"icon",hash:{},data:o,loc:{start:{line:1,column:30},end:{line:1,column:38}}}):i)+'"></span>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:67},end:{line:1,column:76}}}):i)},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"icon"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:54}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"title"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:54},end:{line:1,column:83}}}))?i:"")},useData:!0}),visible:!0,enabled:!0,enableWhen:{},showWhen:{},constructor:function(e){this.options=e||{};var t=this.getTemplateData();this.disabled=!1,s.default.apply(this,arguments),this.$el.addClass("link-button"),t.icon&&(this.$el.addClass("link-button-icon"),t.title||this.$el.addClass("icon-only"))},getTemplateData:function(){return{href:this.__getAttribute("href"),title:this.__getAttribute("title"),icon:this.__getAttribute("icon")}},initialize:function(){a.default.applyDoWhen(this,i.default.resultCtx(this,"enableWhen",this),this.toggle),a.default.applyDoWhen(this,i.default.resultCtx(this,"showWhen",this),this.toggleVisible)},render:function(){s.default.prototype.render.apply(this,arguments),i.default.result(this,"enabled")||this.toggle(!1),i.default.result(this,"visible")||this.toggleVisible(!1);var e=this.getTemplateData();return this.$el.attr("href",e.href||"#"),this},__getAttribute:function(e,t){var n=i.default.resultCtx(this.options,e,this);return i.default.isUndefined(n)&&(n=i.default.result(this,e)),i.default.isUndefined(n)?t:n},enable:function(){this.toggle(!0)},disable:function(){this.toggle(!1)},show:function(){this.toggleVisible(!0)},hide:function(){this.toggleVisible(!1)},toggle:function(e){var t=!!e&&i.default.result(this,"enabled");this.disabled=!t,this.$el.toggleClass("link-button-disabled btn-disabled disabled",this.disabled),this.delegateEvents(this.disabled?l:null)},toggleVisible:function(e){var t=!e||!i.default.result(this,"visible");this.$el.toggleClass("hide",t)}});t.default=u,e.exports=t.default},92328:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(96129)),s=r(n(28107)),l=r(n(45361)),u=i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon '+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"icon")||(null!=t?a(t,"icon"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"icon",hash:{},data:o,loc:{start:{line:1,column:96},end:{line:1,column:104}}}):i)+'"></span>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:133},end:{line:1,column:142}}}):i)},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="option-subtitle">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"subtitle")||(null!=t?a(t,"subtitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:192},end:{line:1,column:204}}}):i)+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="" class="icon-16 '+d((s=null!=(s=f(n,"className")||(null!=t?f(t,"className"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"className",hash:{},data:i,loc:{start:{line:1,column:26},end:{line:1,column:39}}}):s))+'" data-se="'+d((s=null!=(s=f(n,"seleniumId")||(null!=t?f(t,"seleniumId"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"seleniumId",hash:{},data:i,loc:{start:{line:1,column:50},end:{line:1,column:64}}}):s))+'">'+(null!=(a=f(n,"if").call(l,null!=t?f(t,"icon"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:66},end:{line:1,column:120}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"title"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:120},end:{line:1,column:149}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"subtitle"):t,{name:"if",hash:{},fn:e.program(5,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:149},end:{line:1,column:215}}}))?a:"")+"</a>"},useData:!0}),c=l.default.extend({tagName:"li",events:{click:function(e){e.preventDefault(),this.action&&this.action.call(this)}},constructor:function(){l.default.apply(this,arguments),this.$el.addClass("okta-dropdown-option option")},render:function(){return this.$el.html(u({icon:s.default.result(this,"icon"),className:s.default.result(this,"className")||"",title:s.default.result(this,"title"),subtitle:s.default.result(this,"subtitle"),seleniumId:s.default.result(this,"seleniumId")})),s.default.result(this,"disabled")&&this.disable(),this},disable:function(){this.$el.addClass("option-disabled"),this.$el.find("a").attr("tabindex","-1")}}),d=l.default.extend({events:{"click a.option-selected":function(e){e.preventDefault(),s.default.result(this,"disabled")&&e.stopPropagation()},"click .dropdown-disabled":function(e){e.preventDefault(),e.stopPropagation()}},items:[],constructor:function(){var e=this.className;this.className=null,l.default.apply(this,arguments),this.className=e,this.$el.addClass("dropdown more-actions float-l"),s.default.each(s.default.result(this,"items"),(function(e){this.addOption(e,this.options)}),this)},template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon '+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"icon")||(null!=t?a(t,"icon"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"icon",hash:{},data:o,loc:{start:{line:1,column:176},end:{line:1,column:184}}}):i)+'"></span>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="off-screen">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"screenReaderText")||(null!=t?a(t,"screenReaderText"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"screenReaderText",hash:{},data:o,loc:{start:{line:1,column:249},end:{line:1,column:269}}}):i)+"</span>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link-button '+d((s=null!=(s=f(n,"className")||(null!=t?f(t,"className"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"className",hash:{},data:i,loc:{start:{line:1,column:31},end:{line:1,column:44}}}):s))+' link-button-icon option-selected center" aria-expanded="false" aria-controls="okta-dropdown-options">'+(null!=(a=f(n,"if").call(l,null!=t?f(t,"icon"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:146},end:{line:1,column:200}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"screenReaderText"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:200},end:{line:1,column:283}}}))?a:"")+'<span class="option-selected-text">'+d((s=null!=(s=f(n,"title")||(null!=t?f(t,"title"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"title",hash:{},data:i,loc:{start:{line:1,column:318},end:{line:1,column:327}}}):s))+'</span><span class="icon-dm"></span></a><div id="okta-dropdown-options" class="options clearfix"><ul class="okta-dropdown-list options-wrap clearfix"></ul></div>'},useData:!0}),getTemplateData:function(){var e=[s.default.result(this,"className")||"",s.default.result(this,"disabled")?"dropdown-disabled":""];return{icon:s.default.result(this,"icon"),className:a.default.trim(e.join(" ")),title:s.default.result(this,"title"),screenReaderText:s.default.result(this,"screenReaderText")}},addOption:function(e,t){this.add(c.extend(e),"ul.options-wrap",{options:t||{}})}});t.default=d,e.exports=t.default},73026:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(28107)),a=r(n(60196)),s=r(n(45361));function l(e,t){return i.default.resultCtx(e.options,t,e)||i.default.result(e,t)}function u(e){var t="infobox clearfix infobox-"+l(e,"type");switch(l(e,"size")){case"standard":t+="";break;case"slim":t+=" infobox-slim";break;case"compact":t+=" infobox-compact";break;case"large":t+=" infobox-md"}return l(e,"dismissible")&&(t+=" infobox-dismiss"),t}var c={"click .infobox-dismiss-link":function(e){var t=this;e.preventDefault(),this.$el.fadeOut(a.default.UNLOADING_FADE,(function(){t.trigger("dismissed"),t.remove()}))}},d=o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a data-se="dismiss-link" class="infobox-dismiss-link" title="'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"courage",code:"component.dismiss"},data:o,loc:{start:{line:1,column:81},end:{line:1,column:131}}}))+'" href="#"><span data-se="icon" class="dismiss-icon"></span></a>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h3 data-se="header">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:286},end:{line:1,column:295}}}):i)+"</h3>"},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p data-se="sub-header">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"subtitle")||(null!=t?a(t,"subtitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:347},end:{line:1,column:359}}}):i)+"</p>"},7:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ul data-se="list" class="bullets">'+(null!=(i=a(n,"each").call(null!=t?t:e.nullContext||{},null!=t?a(t,"bullets"):t,{name:"each",hash:{},fn:e.program(8,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:420},end:{line:1,column:483}}}))?i:"")+"</ul>"},8:function(e,t,n,r,o){return'<li data-se="list-item">'+e.escapeExpression(e.lambda(t,t))+"</li>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=l(n,"if").call(s,null!=t?l(t,"dismissible"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:202}}}))?i:"")+'<span data-se="icon" class="icon '+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"icon")||(null!=t?l(t,"icon"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"icon",hash:{},data:o,loc:{start:{line:1,column:235},end:{line:1,column:243}}}):a)+'"></span>'+(null!=(i=l(n,"if").call(s,null!=t?l(t,"title"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:252},end:{line:1,column:307}}}))?i:"")+(null!=(i=l(n,"if").call(s,null!=t?l(t,"subtitle"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:307},end:{line:1,column:370}}}))?i:"")+(null!=(i=l(n,"if").call(s,null!=t?l(t,"bullets"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:370},end:{line:1,column:495}}}))?i:"")},useData:!0}),f=s.default.extend({attributes:{"data-se":"callout"},content:null,size:"standard",type:"info",dismissible:!1,title:null,subtitle:null,bullets:null,constructor:function(){this.events=i.default.defaults(this.events||{},c),s.default.apply(this,arguments),this.$el.addClass(u(this)),this.template=d;var e=l(this,"content");e&&this.add(e)},getTemplateData:function(){var e=l(this,"type");switch("tip"===e&&(e="light-bulb"),l(this,"size")){case"slim":e="";break;case"large":e=[e,"-","24"].join("");break;default:e=[e,"-","16"].join("")}return{icon:e,title:l(this,"title"),subtitle:l(this,"subtitle"),bullets:l(this,"bullets"),dismissible:l(this,"dismissible")}}}),p={create:function(e){return new f(e)}};t.default=p,e.exports=t.default},1375:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107)),s=r(n(45361)),l=r(n(88712)),u={level:"success",hide:!0,fade:400,delay:3e3,width:0,dismissable:!1},c=s.default.extend({className:"infobox infobox-confirm infobox-confirm-fixed",events:{"click .infobox-dismiss-link":function(e){e.preventDefault(),this.fadeOut()}},template:i.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a class="infobox-dismiss-link" title="'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"courage",code:"component.dismiss"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:108}}}))+'" href="#"><span class="dismiss-icon"></span></a>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<h3>"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:220},end:{line:1,column:229}}}):i)+"</h3>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(a=f(n,"if").call(l,null!=t?f(t,"dismissable"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:0},end:{line:1,column:164}}}))?a:"")+'<span class="icon '+d((s=null!=(s=f(n,"level")||(null!=t?f(t,"level"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"level",hash:{},data:i,loc:{start:{line:1,column:182},end:{line:1,column:191}}}):s))+'-16"></span>'+(null!=(a=f(n,"if").call(l,null!=t?f(t,"title"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:203},end:{line:1,column:241}}}))?a:"")+"<p>"+d((s=null!=(s=f(n,"message")||(null!=t?f(t,"message"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"message",hash:{},data:i,loc:{start:{line:1,column:244},end:{line:1,column:255}}}):s))+"</p>"},useData:!0}),initialize:function(){if(this.options=a.default.defaults({},this.options,u),!this.options.message)switch(this.options.level){case"success":this.options.message=l.default.localize("notification.default.message.success","courage");break;case"error":this.options.message=l.default.localize("notification.default.message.error","courage");break;case"warning":this.options.message=l.default.localize("notification.default.message.warning","courage")}this.$el.addClass("infobox-"+this.options.level),this.options.width&&this.$el.width(this.options.width)},getTemplateData:function(){return a.default.extend(a.default.pick(this.options,"level","message","title"),{dismissable:!1===this.options.hide||!0===this.options.dismissable})},postRender:function(){this.options.hide&&a.default.delay(a.default.bind(this.fadeOut,this),this.options.delay)},fadeOut:function(){this.$el.fadeOut(this.options.fade,a.default.bind(this.remove,this))}});t.default=c,e.exports=t.default},21198:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(96129)),a=r(n(28107)),s=r(n(88712)),l=r(n(45361)),u=r(n(21990)),c=r(n(63301)),d=r(n(44995)),f=r(n(52930)),p=r(n(57581)),h=r(n(29752)),m=r(n(80685)),v=r(n(3197)),g=r(n(34564)),y=r(n(53303)),b=o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h2 class="o-form-title-bar" data-se="o-form-title-bar">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:75},end:{line:1,column:84}}}):i)+"</h2>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"title"):t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:192},end:{line:1,column:288}}}))?i:""},4:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h2 data-se="o-form-head" class="okta-form-title o-form-head">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:267},end:{line:1,column:276}}}):i)+"</h2>"},6:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="okta-form-subtitle o-form-explain" data-se="o-form-explain">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"subtitle")||(null!=t?a(t,"subtitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:385},end:{line:1,column:397}}}):i)+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=l(n,"if").call(s,null!=t?l(t,"hasReadMode"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:96}}}))?i:"")+'<div data-se="o-form-content" class="o-form-content '+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"layout")||(null!=t?l(t,"layout"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"layout",hash:{},data:o,loc:{start:{line:1,column:148},end:{line:1,column:158}}}):a)+' clearfix">'+(null!=(i=l(n,"unless").call(s,null!=t?l(t,"hasReadMode"):t,{name:"unless",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:169},end:{line:1,column:299}}}))?i:"")+(null!=(i=l(n,"if").call(s,null!=t?l(t,"subtitle"):t,{name:"if",hash:{},fn:e.program(6,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:299},end:{line:1,column:408}}}))?i:"")+'<div class="o-form-error-container" data-se="o-form-error-container"></div><div class="o-form-fieldset-container" data-se="o-form-fieldset-container"></div></div>'},useData:!0}),w=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h2 class="o-form-head">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:24},end:{line:1,column:33}}}):i)+"</h2>"},useData:!0}),_="auto"===(0,i.default)("<div>").css({"pointer-events":"auto"})[0].style.pointerEvents;function O(e){if(!_&&this.$el.hasClass("o-form-saving")){var t=(0,i.default)(e.currentTarget);t.css("display","none");var n=document.elementFromPoint(e.clientX,e.clientY);return t.css("display","block"),e.target=n,(0,i.default)(n).trigger(e),!1}}var k={submit:function(e){e.preventDefault(),this.__save()}};a.default.each(["click","dblclick","mousedown","mouseup"],(function(e){k[e+" .o-form-input"]=O}));var x=function(e,t){e||(e="");var n=[];return a.default.isString(e)&&(n=e.split(" ")),(n=a.default.union(n,t)).join(" ")},E=l.default.extend({constructor:function(e){e||(e={}),this.options=e,e.settings?this.settings=e.settings:this.settings=e.settings=new y.default,this.id=a.default.uniqueId("form"),this.tagName="form",a.default.defaults(this.events,k),a.default.defaults(this.attributes,function(e){e||(e={});var t=e&&e.collection||{};return{method:"POST",action:a.default.result(e,"urlRoot")||a.default.result(t,"url")||window.location.pathname,"data-se":"o-form",slot:"content"}}(e.model)),this.__buttons=[],this.__errorFields={},this.__saveModelState(e.model);var t=a.default.result(this,"step");if(t){if(!this.save){var n=a.default.result(this,"totalSteps");this.save=n&&t!==n?s.default.localize("oform.button.next","courage"):s.default.localize("oform.button.finish","courage")}this.className=a.default.result(this,"className")+" wizard"}this.className=a.default.result(this,"className")+" o-form",this.__toolbar=this.__createToolbar(e),l.default.call(this,e),a.default.each(a.default.result(this,"inputs")||[],(function(e){this.__addLayoutItem(e)}),this),this.add(this.__toolbar,""),this.listenTo(this.model,"change:__edit__",this.__applyMode),this.listenTo(this.model,"invalid error",a.default.throttle((function(e,t,n){this.__showErrors(e,t,!1!==n)}),100,{trailing:!1})),this.listenTo(this.model,"form:resize",(function(){this.trigger("resize")})),this.listenTo(this.model,"form:cancel",a.default.throttle(this.__cancel,100,{trailing:!1})),this.listenTo(this.model,"form:previous",a.default.throttle(this.__previous,100,{trailing:!1})),this.__save=a.default.throttle(this.__save,200,{trailing:!1}),this.listenTo(this.model,"form:save",(function(){this.$el.submit()})),this.listenTo(this.model,"sync",(function(){this.model.get("__edit__")&&this.model.set("__edit__",!1,{silent:!0}),this.__saveModelState(this.model),this.render()}));var r=this.getAttribute("hasSavingState");if(this.getAttribute("autoSave")&&(this.listenTo(this,"save",(function(e){var t=this,n=e.save();n&&n.done&&n.done((function(){t.trigger("saved",e)}))})),a.default.isUndefined(r)&&(r=!0)),r){var o=this.getAttribute("customSavingState",{});this.listenTo(this.model,x(o.start||"",["request"]),this.__setSavingState),this.listenTo(this.model,x(o.stop||"",["error","sync"]),this.__clearSavingState)}},__createToolbar:function(e){var t=!0===this.getAttribute("danger")?"button-error":"button-primary",n=a.default.result(this,"step"),r=new c.default(a.default.extend({save:this.save||s.default.localize("oform.save","courage"),saveId:this.saveId,saveClassName:t,cancel:this.cancel||s.default.localize("oform.cancel","courage"),noCancelButton:this.noCancelButton||!1,noSubmitButton:this.noSubmitButton||!1,buttonOrder:this.buttonOrder,hasPrevStep:n&&n>1},e||this.options));return a.default.each(this.__buttons,(function(e){r.addButton.apply(r,e)})),r},className:"",attributes:{},events:{},inputs:[],template:null,read:!1,readOnly:!1,noButtonBar:!1,noCancelButton:!1,noSubmitButton:!1,buttonOrder:["previous","save","cancel"],save:null,cancel:null,danger:!1,layout:"",step:void 0,totalSteps:void 0,title:null,subtitle:null,autoSave:!1,scrollOnError:!0,showErrors:!0,resizeSelector:".o-form-content",getAttribute:function(e,t){var n=a.default.resultCtx(this.options,e,this);return a.default.isUndefined(n)&&(n=a.default.result(this,e)),a.default.isUndefined(n)?t:n},hasReadMode:function(){return!!this.getAttribute("read")},isReadOnly:function(){return!!this.getAttribute("readOnly")},hasButtonBar:function(){return!(this.getAttribute("noButtonBar")||this.isReadOnly())},render:function(){if(this.__readModeBar&&this.__readModeBar.remove(),this.hasReadMode()&&!this.isReadOnly()){var e=u.default.extend({formTitle:this.getAttribute("title","")});this.__readModeBar=this.add(e,".o-form-title-bar").last()}var t=b({layout:this.getAttribute("layout",""),title:this.getAttribute("title","",!0),subtitle:this.getAttribute("subtitle","",!0),hasReadMode:this.hasReadMode()});return this.$el.html(t),delete this.template,l.default.prototype.render.apply(this,arguments),this.__applyMode(),this},__setSavingState:function(){this.model.trigger("form:set-saving-state"),this.$el.addClass("o-form-saving")},__clearSavingState:function(){this.model.trigger("form:clear-saving-state"),this.$el.removeClass("o-form-saving")},__toggleToolbar:function(){this.__toolbar&&this.__toolbar.remove(),this.hasButtonBar()&&this._editMode()&&(this.__toolbar=this.__createToolbar(),this.add(this.__toolbar,"")),this.trigger("resize")},__cancel:function(){var e,t=this.model.get("__edit__");this.model.clear({silent:!0}),e=this.model.sanitizeAttributes?this.model.sanitizeAttributes(this.__originalModel):a.default.clone(this.__originalModel),this.model.set(e,{silent:!0}),this.trigger("cancel",this.model),this.model.trigger("cache:clear"),t&&(this.model.set("__edit__",!1,{silent:!0}),this.model.trigger("change:__edit__",this.model,!1)),this.clearErrors()},isValid:function(){var e,t=this;function n(e){return a.default.reduce(e,(function(e,n){return a.default.extend(e,t.model.validateField(n))}),{})}return a.default.isUndefined(this.validate)?this.model.isValid():(a.default.isFunction(this.validate)?e=this.validate():a.default.isArray(this.validate)?e=n(this.validate):"local"===this.validate&&(e=n(this.getInputs().map((function(e){return e.options.name})))),!!a.default.isEmpty(e)||(this.model.trigger("invalid",this.model,e),!1))},__save:function(){this.clearErrors(),this.isValid()&&this.trigger("save",this.model)},__previous:function(){this.trigger("previous",this.model)},__applyMode:function(){this.clearErrors(),this.__toggleToolbar(),this._editMode()?(this.$el.addClass("o-form-edit-mode"),this.$el.removeClass("o-form-read-mode"),this.$(".o-form-content").removeClass("rounded-btm-4"),this.focus()):(this.$el.removeClass("o-form-edit-mode"),this.$el.addClass("o-form-read-mode"),this.$(".o-form-content").addClass("rounded-btm-4"))},_editMode:function(){return this.model.get("__edit__")||!this.hasReadMode()},parseErrorMessage:a.default.identity,_handleErrorScroll:function(){if(this.getAttribute("scrollOnError")){var e=(0,i.default)("#"+this.id+" .o-form-error-container");if(e.length){var t,n=e.scrollParent();n[0]===document?(n=(0,i.default)("html, body"),t=e.offset().top):t=n.scrollTop()+e.offset().top-n.offset().top,n.animate({scrollTop:t},400)}}},__showErrors:function(e,t,n){if(this.trigger("error",e),this.getAttribute("showErrors")){var r,o=f.default.getResponseJSON(t),i=f.default.parseFieldErrors(t);a.default.size(i)?a.default.each(i,(function(e,t){this.model.trigger("form:field-error",this.__errorFields[t]||t,a.default.map(e,(function(e){return/^model\.validation/.test(e)?s.default.localize(e,"courage"):e})))}),this):r=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Array.isArray(e.errorCauses)&&e.errorCauses.length>0?e.errorCauses[0].errorSummary:e.errorSummary}(o=this.parseErrorMessage(o)),n&&(this.$(".o-form-error-container").addClass("o-form-has-errors"),this.add(d.default,".o-form-error-container",{options:{errorSummary:r}})),this._handleErrorScroll(),this.model.trigger("form:resize")}},clearErrors:function(){this.$(".o-form-error-container").removeClass("o-form-has-errors"),this.model.trigger("form:clear-errors"),this.model.trigger("form:resize")},toggle:function(){return this.model.set("__edit__",!this.hasReadMode()||!this.model.get("__edit__")),this},__addLayoutItem:function(e){m.default.supports(e)?this.addInput(e):this.__addNonInputLayoutItem(e)},__addNonInputLayoutItem:function(e){var t=a.default.omit(e,"type");switch(e.type){case"sectionTitle":this.addSectionTitle(e.title,a.default.omit(t,"title"));break;case"divider":this.addDivider(t);break;default:throw new Error("unknown input: "+e.type)}},addButton:function(e,t){this.__toolbar&&this.__toolbar.addButton(e,t),this.__buttons.push([e,t])},addDivider:function(e){return this.add('<div class="okta-form-divider form-divider"></div>'),p.default.applyShowWhen(this.last(),e&&e.showWhen),p.default.applyToggleWhen(this.last(),e&&e.toggleWhen),this},addSectionTitle:function(e,t){return this.add(w({title:e})),p.default.applyShowWhen(this.last(),t&&t.showWhen),p.default.applyToggleWhen(this.last(),t&&t.toggleWhen),this},addInput:function(e){e=a.default.clone(e),p.default.validateInput(e,this.model);var t=p.default.generateInputOptions(e,this,this.__createInput).reverse();a.default.isEmpty(this.getInputs().toArray())&&a.default.extend(t[0],{validateOnlyIfDirty:!0});var n=a.default.map(t,this.__createInput,this);a.default.each(t,(function(e){e.errorField&&(this.__errorFields[e.errorField]=e.name)}),this);var r={inputId:a.default.last(n).options.inputId,input:n,multi:t.length>1?t.length:void 0};a.default.extend(r,a.default.omit(this.options,"input"),a.default.omit(e,"input"));var o=this.__createWrapper(r);!1!==r.label&&o.add(this.__createLabel(r)),o.add(this._createContainer(r)),o.type=r.type||r.input.type||"custom";var i=[o].concat(a.default.rest(arguments));return this.add.apply(this,i)},__createInput:function(e){return e=a.default.pick(e,p.default.INPUT_OPTIONS),m.default.create(e)},__createWrapper:function(e){return e=a.default.pick(e,p.default.WRAPPER_OPTIONS),new g.default(e)},__createLabel:function(e){return e=a.default.pick(e,p.default.LABEL_OPTIONS),new v.default(e)},_createContainer:function(e){return e=a.default.pick(e,p.default.CONTAINER_OPTIONS),new h.default(e)},__saveModelState:function(e){this.__originalModel=i.default.extend(!0,{},e.attributes)},add:function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return void 0===t[1]&&(t[1]="> div.o-form-content > .o-form-fieldset-container"),l.default.prototype.add.apply(this,t)},focus:function(){var e=this.getInputs().first();return e&&e.focus&&e.focus(),this},disable:function(){return this.invoke("disable"),this},enable:function(){this.invoke("enable")},contentHeight:function(e){var t=this.$(".o-form-content");if(!a.default.isNumber(e))return t.height();t.css("max-height",e)},getInputs:function(){return(0,a.default)(this.filter((function(e){return e instanceof g.default})))}});t.default=E,e.exports=t.default},15982:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(96129)),a=r(n(28107)),s=r(n(2431)),l=r(n(88712)),u=r(n(45361)),c=r(n(73026)),d=r(n(83365)),f={tagName:"span",attributes:function(){return{"data-se":"o-form-input-"+this.getNameString()}},defaultPlaceholder:"",constructor:function(e){delete(e=a.default.defaults(e||{},{inputId:e.id||a.default.uniqueId("input"),placeholder:this.defaultPlaceholder,inlineValidation:!0,validateOnlyIfDirty:!1})).id;var t=this;a.default.each({enable:"removeClass",disable:"addClass"},(function(e,n){t[n]=a.default.wrap(t[n],(function(n){n.apply(t,arguments),t.$el[e]("o-form-disabled")}))})),u.default.call(this,e),!0!==a.default.result(e,"readOnly")&&!0===a.default.result(e,"read")&&this.listenTo(this.model,"change:__edit__",this.render),a.default.isFunction(this.focus)&&(this.focus=a.default.debounce(a.default.bind(this.focus,this),50)),a.default.result(e,"validateOnlyIfDirty")||this.addInlineValidation(),this.addModelListeners(),this.$el.addClass("o-form-input-name-"+this.getNameString())},addAriaLabel:function(){var e=this.options.ariaLabel;e&&this.$(":input").attr("aria-label",e)},addInlineValidation:function(){a.default.result(this.options,"inlineValidation")&&this.$el.on("focusout",":input",a.default.bind(this.validate,this))},toModelValue:function(){var e=this.val();return a.default.isFunction(this.to)&&(e=this.to.call(this,e)),a.default.isFunction(this.options.to)&&(e=this.options.to.call(this,e)),e},__getDependencyCalloutBtn:function(e){var t=this,n=a.default.clone(e),r=n.click||function(){};return n.click=function(){(0,i.default)(window).one("focus.dependency",(function(){t.__showInputDependencies()})),r.call(t)},new(u.default.extend({children:[s.default.create(n)]}))},getCalloutParent:function(){return this.$('input[value="'+this.getModelValue()+'"]').parent()},__getCalloutMsgContainer:function(e){return u.default.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="o-form-explain">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"msg")||(null!=t?a(t,"msg"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"msg",hash:{},data:o,loc:{start:{line:1,column:29},end:{line:1,column:36}}}):i)+"</span>"},useData:!0}),getTemplateData:function(){return{msg:e}}})},showCallout:function(e,t){var n=a.default.clone(e);n.className="dependency-callout",n.btn&&(n.content=this.__getDependencyCalloutBtn(n.btn),delete n.btn);var r=c.default.create(n);t||r.add(this.__getCalloutMsgContainer(l.default.localize("dependency.callout.msg","courage"))),this.getCalloutParent().append(r.render().el),"success"===n.type&&a.default.delay((function(){r.$el.fadeOut(800)}),1e3)},removeCallout:function(){this.$el.find(".dependency-callout").remove()},__evaluateCalloutObject:function(e,t){return e?{title:l.default.localize("dependency.action.completed","courage"),size:"large",type:"success"}:{title:l.default.localize("dependency.action.required","courage",[t]),size:"large",type:"warning"}},__handleDependency:function(e,t){var n=this,r=a.default.isFunction(t)?t(e):a.default.extend({},t,n.__evaluateCalloutObject(e.resolved,t.title));n.removeCallout(),n.showCallout(r,e.resolved)},__showInputDependencies:function(){var e=this,t=e.options.deps[e.getModelValue()];t&&a.default.isFunction(t.func)?t.func().done((function(n){e.__handleDependency({resolved:!0,data:n},t.callout)})).fail((function(n){e.__handleDependency({resolved:!1,data:n},t.callout)})):e.removeCallout()},_isEdited:!1,hasIMESupport:!1,update:function(e){var t,n;if(!this._isEdited&&a.default.result(this.options,"validateOnlyIfDirty")&&(this._isEdited=!0,this.addInlineValidation()),this.model.set(this.options.name,this.toModelValue()),this.options.deps&&this.__showInputDependencies(),this.hasIMESupport&&null!==(t=window)&&void 0!==t&&null!==(n=t.okta)&&void 0!==n&&n.enableIMESupport){if(this.isComposing)return;e&&d.default.isEnter(e)&&this.model.trigger("form:save")}},isEditMode:function(){return!a.default.result(this.options,"readOnly")&&(!0!==a.default.result(this.options,"read")||!0===this.model.get("__edit__"))},render:function(){this.preRender();var e=this.options.params;return this.options.params=a.default.resultCtx(this.options,"params",this),this.isEditMode()?(this.editMode(),this.applyEnabledState()):this.readMode(),this.options.params=e,this.addAriaLabel(),this.postRender(),this},applyEnabledState:function(){a.default.resultCtx(this.options,"disabled",this)?this.disable():this.enable()},validate:function(){if(!this.model.get("__pending__")&&this.isEditMode()&&a.default.isFunction(this.model.validateField)){var e=this.model.validateField(this.options.name);e&&a.default.delay(function(){this.model.trigger("form:clear-error:"+this.options.name),this.model.trigger("invalid",this.model,e,!1)}.bind(this),100)}},addModelListeners:function(){this.listenTo(this.model,"form:field-error",(function(e){this.options.name===e&&this.__markError()})),this.listenTo(this.model,"form:clear-errors change:"+this.options.name,this.__clearError),this.listenTo(this.model,"form:clear-error:"+this.options.name,this.__clearError)},val:function(){throw new Error("val() is an abstract method")},focus:function(){throw new Error("focus() is an abstract method")},defaultValue:function(){return""},editMode:function(){var e=a.default.extend({},this.options,{value:this.getModelValue()});return this.$el.html(this.template(e)),this.options.multi&&this.$el.removeClass("margin-r"),this},readMode:function(){return this.$el.text(this.getReadModeString()),this.$el.removeClass("error-field"),this.options.multi&&this.$el.addClass("margin-r"),this},getReadModeString:function(){var e=a.default.resultCtx(this.options,"readModeString",this);return e||this.toStringValue()},getModelValue:function(){var e=this.model.get(this.options.name);return a.default.isFunction(this.from)&&(e=this.from.call(this,e)),a.default.isFunction(this.options.from)&&(e=this.options.from.call(this,e)),e},toStringValue:function(){var e=this.getModelValue();return this.options.options&&(e=this.options.options[e]),(Number.isInteger(e)||"boolean"==typeof e)&&(e=String(e)),e||this.defaultValue()},resize:function(){this.model.trigger("form:resize")},disable:function(){this.$(":input").prop("disabled",!0)},enable:function(){this.$(":input").prop("disabled",!1)},changeType:function(e){this.$(":input").prop("type",e),this.options.type=e},getNameString:function(){return a.default.isArray(this.options.name)?this.options.name.join("-"):this.options.name},getParams:function(e){var t=e||this.options||{};return a.default.clone(a.default.resultCtx(t,"params",this)||{})},getParam:function(e,t){var n=a.default.resultCtx(this.getParams(),e,this);return a.default.isUndefined(n)?t:n},getParamOrAttribute:function(e){return this.getParam(e)||a.default.result(this,e)},__markError:function(){this.$el.addClass("o-form-has-errors")},__clearError:function(){this.$el.removeClass("o-form-has-errors")}},p=u.default.extend(f);t.default=p,e.exports=t.default},21990:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45361)),i=r(n(57581)),a=o.default.extend({el:'<span class="o-form-toggle" data-type="header-btn"></span>',formTitle:"",modelEvents:{"change:__edit__":"toggle"},initialize:function(){this.addButton()},addButton:function(){this.model.get("__edit__")?this.add(i.default.createReadFormButton({type:"cancel"})):this.add(i.default.createReadFormButton({type:"edit",formTitle:this.formTitle,className:"disable-in-read-only"}))},toggle:function(){this.removeChildren(),this.addButton()}});t.default=a,e.exports=t.default},63301:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(45361)),a=r(n(57581)),s={className:function(){return"o-form-button-bar"},buttonOrder:["previous","save","cancel"],initialize:function(e){var t=this,n={previous:{type:"previous"},save:{type:"save",text:o.default.resultCtx(e,"save",this),id:o.default.resultCtx(e,"saveId",this),className:o.default.resultCtx(e,"saveClassName",this)},cancel:{type:"cancel",text:o.default.resultCtx(e,"cancel",this)}};this.__getButtonOrder(e).forEach((function(e){t.addButton(n[e])}))},addButton:function(e,t){return this.add(a.default.createButton(e),t)},__getButtonOrder:function(e){var t=o.default.resultCtx(e,"buttonOrder",this,this.buttonOrder),n=[];return e.noSubmitButton&&n.push("save"),e.noCancelButton&&n.push("cancel"),e.hasPrevStep||n.push("previous"),o.default.without.apply(o.default,[t].concat(n))}},l=i.default.extend(s);t.default=l,e.exports=t.default},52078:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(96129)),i=r(n(28107)),a=r(n(33270)),s=r(n(88712)),l="name",u="_enum_";function c(e){return f(e)?i.default.reduce(e,(function(e,t,n){return e[m(n)]=t.title,e}),{}):{}}function d(e){return i.default.all(e,o.default.isPlainObject)?f(e)?e:function(e){var t=i.default.partial(i.default.has,i.default,l);if(i.default.all(e,t))return i.default.chain(e).filter((function(e){return o.default.isPlainObject(e)&&i.default.has(e,l)})).map((function(e){return{const:e,title:e.name}})).value();return p(e)}(e):p(e)}function f(e){return i.default.isArray(e)&&i.default.all(e,(function(e){return i.default.has(e,"const")&&i.default.has(e,"title")}))}function p(e){return i.default.map(e,(function(e){return{const:e,title:h(e)}}))}function h(e){return i.default.isObject(e)?JSON.stringify(e):i.default.isNumber(e)?e+"":e}function m(e){return"".concat(u).concat(e)}function v(e){var t=i.default.findIndex(this.options.params.enumOneOf,(function(t){return i.default.isObject(e)?i.default.isEqual(t.const,e):t.const===e}));return t>-1?m(t):e}function g(e){if(!i.default.isString(e)||0!==e.indexOf(u))return e;var t=e.replace(u,""),n=this.options.params&&i.default.isArray(this.options.params.enumOneOf)?this.options.params.enumOneOf[t]:null;return i.default.has(n,"const")?n.const:n}function y(e){return i.default.map(e,g.bind(this))}function b(e){return i.default.map(e,v.bind(this))}var w={getEnumInputOptions:function(e){var t=d(e.enumValues),n={name:e.name,label:e.title,readOnly:e.readOnly,customExplain:e.explain,params:{enumOneOf:t},options:c(t)};return a.default.isArrayDataType(e.displayType)?(n.type="checkboxset",n.to=y,n.from=b):(n.type="select",n.to=g,n.from=v),n.input=null,n},getDropdownOptions:function(e){return i.default.isArray(e)?c(d(e)):{}},convertToOneOf:d,isConstraintValueMatchType:function(e,t){switch(t){case a.default.STRING:return function(e){return i.default.isString(e)}(e);case a.default.NUMBER:return function(e){return i.default.isNumber(e)||i.default.isNumber(s.default.parseFloat(o.default.trim(e)))}(e);case a.default.INTEGER:return function(e){var t=i.default.isNumber(e)?e:s.default.parseInt(o.default.trim(e));return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}(e);case a.default.OBJECT:return function(e){if(i.default.isObject(e)&&!i.default.isArray(e))return!0;var t=s.default.parseObject(o.default.trim(e));return i.default.isObject(t)&&!i.default.isArray(t)}(e)}}};t.default=w,e.exports=t.default},44995:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(45361)).default.extend({template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"errorSummary")||(null!=t?a(t,"errorSummary"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"errorSummary",hash:{},data:o,loc:{start:{line:1,column:130},end:{line:1,column:146}}}):i)+"</p>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"courage",code:"oform.errorbanner.title"},data:o,loc:{start:{line:1,column:161},end:{line:1,column:217}}}))+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span>'+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"errorSummary"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:107},end:{line:1,column:228}}}))?i:"")+"</div>"},useData:!0}),modelEvents:{"form:clear-errors":"remove"}});t.default=i,e.exports=t.default},52930:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(88712)),a=/^([\S]+): (.+)$/,s={getResponseJSON:function(e){try{return e.responseJSON||JSON.parse(e.responseText)}catch(e){}},parseErrorSummary:function(e){var t=e.match(a);if(t)return[t[1],t[2]]},parseErrorCauseObject:function(e){if(e.property&&e.errorSummary){var t=e.reason?i.default.localize(e.reason):void 0,n=e.errorSummary;return[e.property,-1===(null==t?void 0:t.indexOf("L10N_ERROR["))?t:n]}},parseErrors:function(e){var t=this.getResponseJSON(e);return o.default.map(t&&t.errorCauses||[],(function(e){return(""+e.errorSummary).replace(a,"$2")}))},parseFieldErrors:function(e){var t=this.getResponseJSON(e),n={};return t?o.default.each(t.errorCauses||[],(function(e){var t=[];if(t=e.property&&e.errorSummary?this.parseErrorCauseObject(e):e.location&&e.errorSummary?[e.location,e.errorSummary]:this.parseErrorSummary(e&&e.errorSummary||"")){var r=t[0],o=t[1];n[r]||(n[r]=[]),n[r].push(o)}}),this):o.default.isObject(e)&&o.default.size(e)&&o.default.each(e,(function(e,t){n[t]=[e]})),o.default.size(n)?n:void 0}};t.default=s,e.exports=t.default},57581:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(31752)),i=r(n(28107)),a=r(n(83365)),s=r(n(77861)),l=r(n(88712)),u=r(n(50808)),c=r(n(45361)),d=["model","id","inputId","type","label","sublabel","tooltip","name","group"],f=["wide","multi","input","label-top","explain","explain-top","customExplain","model","name","type","autoRender","multirowError"],p=["model","name","label-top","readOnly","events","initialize","showWhen","bindings","render","className","data-se","toggleWhen","group"],h=["model","name","inputId","type","input","placeholder","label","readOnly","read","disabled","readModeString","options","deps","from","to","autoRender","inlineValidation","validateOnlyIfDirty","ariaLabel","params","autoComplete","sortByKey"],m=i.default.uniq(i.default.union(d,f,p,h,["errorField"])),v=["•         ","•  •      ","•  •  •   ","•  •  •  •","   •  •  •","      •  •","         •","          ","          ","          "];function g(e){if(e&&!e.__edit__)return i.default.extend({__edit__:i.default.constant(!0)},e)}var y={LABEL_OPTIONS:d,CONTAINER_OPTIONS:f,WRAPPER_OPTIONS:p,INPUT_OPTIONS:h,generateInputOptions:function e(t,n,r){t=i.default.clone(t),i.default.contains(["list","group"],t.type)&&(t.params=i.default.defaults({create:r,inputs:i.default.map(i.default.isArray(t.input)?t.input:[t.input],(function(t){return i.default.first(e(t,n,r))}))},t.params||{}),delete t.input);var o=i.default.isArray(t.input)?i.default.clone(t.input):[t];return i.default.map(o,(function(e){var r=i.default.defaults({model:n.model},e,i.default.omit(t,"input","inputs"),n.options,{id:i.default.uniqueId("input"),readOnly:n.isReadOnly(),read:n.hasReadMode()});return n.isReadOnly()&&(r.read=r.readOnly=!0),r}))},changeEventString:function(e){return"change:"+e.join(" change:")},createReadFormButton:function(e){var t,n,r;return"cancel"===e.type?(n=r=l.default.localize("oform.cancel","courage"),t=function(){this.model.trigger("form:cancel")}):(r=(n=l.default.localize("oform.edit","courage"))+" "+e.formTitle,t=function(){this.model.set("__edit__",!0)}),c.default.extend({tagName:"a",className:e.className,attributes:{href:"#","aria-label":r},template:function(){return i.default.escape(n)},events:{click:function(e){e.preventDefault(),t.call(this)}}})},createButton:function(e){switch((e=i.default.clone(e)).type){case"save":i.default.defaults(e,{className:"button-primary"});break;case"cancel":i.default.defaults(e,{className:"button-clear",text:l.default.localize("oform.cancel","courage"),action:function(){this.model.trigger("form:cancel")}});break;case"previous":i.default.defaults(e,{text:l.default.localize("oform.previous","courage"),action:function(){this.model.trigger("form:previous")}})}return function(e){var t,n,r;return e=i.default.pick(e||{},"action","id","className","text","type"),c.default.extend({tagName:"input",className:"button",events:{click:function(){e.action&&!this.disabled()&&e.action.call(this)},keyup:function(t){a.default.isEnter(t)&&e.action&&!this.disabled()&&e.action.call(this)}},disabled:function(){return!0===this.$el.prop("disabled")},disable:function(){this.$el.prop("disabled",!0),this.$el.addClass("btn-disabled")},enable:function(){this.$el.prop("disabled",!1),this.$el.removeClass("btn-disabled")},initialize:function(){var r=this;this.$el.attr("type","save"===e.type?"submit":"button"),this.$el.val(e.text),e.id&&this.$el.attr("id",e.id),e.className&&this.$el.addClass(e.className),e.type&&this.$el.attr("data-type",e.type),this.$el.mousedown((function(){r.model.set("__pending__",!0)})),this.$el.mouseup((function(){r.model.set("__pending__",!1)})),this.listenTo(this.model,"form:set-saving-state",(function(){this.disable(),"save"===e.type&&(clearTimeout(t),t=setTimeout(i.default.bind(this.__changeSaveText,this),1e3))})),this.listenTo(this.model,"form:clear-saving-state",(function(){this.enable(),"save"===e.type&&(clearTimeout(t),clearInterval(n),this.$el.val(e.text))}))},__changeSaveText:function(){r=0,clearInterval(n),n=setInterval(i.default.bind(this.__showLoadingText,this),200)},__showLoadingText:function(){this.$el.val(v[r++%v.length])}})}(e)},validateInput:function e(t,n){if(t||(t={}),"label"!==t.type){if("button"===t.type)return t.title||t.icon||s.default.warn('A button input must have a "title" and/or an "icon" parameter',t),void(t.click||t.href||s.default.warn('A button input must have a "click" and/or an "href" parameter',t));if(t.name||t.input||s.default.warn('Missing "name" or "input" parameters',t),i.default.isArray(t.name)&&i.default.isArray(t.input))throw new Error('Not allowed to have both "name" and "input" defined as array.');if("list"!==t.type&&t.name&&n&&n.allows){var r=[];i.default.isArray(t.name)?r=t.name:r.push(t.name),i.default.each(r,(function(e){if(!n.allows(e))throw new Error("field not allowed: "+t.name)}))}i.default.isArray(t.input)&&"list"!==t.type&&i.default.each(t.input,(function(t){e(t,n)}));var a=i.default.keys(t),l=i.default.intersection(a,m);if(i.default.size(l)!==i.default.size(t)){var u=i.default.clone(m);s.default.warn("Invalid input parameters",i.default.without.apply(i.default,[a].concat((0,o.default)(u))),t)}}else t.label||s.default.warn('A label input must have a "label" parameter',t)},applyShowWhen:function(e,t){u.default.applyDoWhen(e,g(t),(function(t,n){n.animate?e.$el["slide"+(t?"Down":"Up")](200,function(t){return function(){e.$el.toggle(t),e.model.trigger("form:resize")}}(t)):e.$el.toggle(t)}))},applyToggleWhen:function(e,t){u.default.applyDoWhen(e,g(t),(function(t,n){e.$el.toggle(t),e.model.trigger("form:resize"),n.animate&&e.render()}))}};t.default=y,e.exports=t.default},29752:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107)),s=r(n(77861)),l=r(n(51645)),u=r(n(88712)),c=r(n(45361)),d=l.default.isABaseView,f=c.default.extend({attributes:function(){return{"data-se":"o-form-input-container"}},className:function(){var e="o-form-input";(this.options.wide&&(e+=" o-form-wide"),a.default.contains([1,2,3,4],this.options.multi))&&(e+=" o-form-multi-input-"+this.options.multi,a.default.isArray(this.options.input)&&a.default.find(this.options.input,(function(e){return a.default.contains(["text+select","select+text"],e.options.type)}))&&(e+=" o-form-multi-input-group-"+this.options.multi));return e},_getNames:function(){var e=a.default.isArray(this.options.name)?this.options.name:[this.options.name];return"group"===this.options.type?e.push.apply(e,a.default.pluck(this.options.input[0].options.params.inputs,"name")):a.default.isArray(this.options.name)?this.options.input&&this.options.input.options&&this.options.input.options.name&&e.push(this.options.input.options.name):this.options.input&&(a.default.isArray(this.options.input)?a.default.each(this.options.input,(function(t){e.push(t.options.name)})):e.push(this.options.input.options.name)),a.default.uniq(a.default.compact(e))},_getInputElement:function(){var e=Array.isArray(this.options.input)?a.default.last(this.options.input):this.options.input,t=e&&e.options&&e.options.inputId,n=t?this.$("#"+t):null;return n&&n.length?n:null},constructor:function(){c.default.apply(this,arguments);var e=this.options["explain-top"]&&this.options["label-top"];this.options.input&&(a.default.isArray(this.options.input)?a.default.each(this.options.input,(function(t){this.add(t,{prepend:!e})}),this):this.add(this.options.input,{prepend:!e})),this.__setExplain(this.options);var t=this._getNames();this.listenTo(this.model,"form:field-error",(function(n,r){a.default.contains(t,n)&&this.__setError(r,e)})),this.listenTo(this.model,"form:clear-errors change:"+t.join(" change:"),this.__clearError),this.listenTo(this.model,"form:clear-error:"+t.join(" form:clear-error:"),this.__clearError),a.default.resultCtx(this.options,"autoRender",this)&&this.listenTo(this.model,"change:"+this.options.name,this.render),this.__errorState=!1},__setExplain:function(e){var t;if(e.customExplain)return s.default.warn("Deprecated - use explain instead of customExplain"),void this.add(this.options.customExplain);t=e.explain,a.default.isFunction(t)&&!d(t)&&(t=a.default.resultCtx(this.options,"explain",this)),t&&(d(t)?(this.template=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<p class="o-form-explain"></p>'},useData:!0}),this.add(t," > .o-form-explain")):this.template=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="o-form-explain">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"explain")||(null!=t?a(t,"explain"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"explain",hash:{},data:o,loc:{start:{line:1,column:26},end:{line:1,column:37}}}):i)+"</p>"},useData:!0}))},__setError:function(e,t){this.__errorState=!0,this.$el.addClass("o-form-has-errors");var n=a.default.uniqueId("input-container-error"),r=this.__getHTMLForError(a.default.flatten(e),n),o=this.$(".o-form-explain").not(".o-form-input-error").first();o.length&&!t?o.before(r):this.$el.append(r);var i=this._getInputElement()||this.$el;i.attr("aria-describedby",n),i.attr("aria-invalid",!0)},__getHTMLForError:function(e,t){var n=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p id="'+c((a=null!=(a=d(n,"errorId")||(null!=t?d(t,"errorId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"errorId",hash:{},data:i,loc:{start:{line:1,column:7},end:{line:1,column:18}}}):a))+'" class="okta-form-input-error o-form-input-error o-form-explain" role="alert"><span class="icon icon-16 error-16-small" role="img" aria-label="'+c((a=null!=(a=d(n,"iconLabel")||(null!=t?d(t,"iconLabel"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"iconLabel",hash:{},data:i,loc:{start:{line:1,column:162},end:{line:1,column:175}}}):a))+'"></span>'+c((a=null!=(a=d(n,"text")||(null!=t?d(t,"text"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"text",hash:{},data:i,loc:{start:{line:1,column:184},end:{line:1,column:192}}}):a))+"</p>"},useData:!0}),r=u.default.localize("oform.error.icon.ariaLabel","courage");if(this.options.multirowError){var a="";return e.forEach((function(e){a+=n({errorId:t,iconLabel:r,text:e})})),a}return n({errorId:t,iconLabel:r,text:e.join(", ")})},__clearError:function(){var e=this;if(this.__errorState){this.$(".o-form-input-error").remove();var t=this._getInputElement()||this.$el;t.attr("aria-describedby",null),t.attr("aria-invalid",null),this.$el.removeClass("o-form-has-errors"),this.__errorState=!1,a.default.defer((function(){e.model.trigger("form:resize")}))}},focus:function(){return this.each((function(e){if(e.focus)return e.focus()})),this}});t.default=f,e.exports=t.default},80685:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(66728));function a(e,t){return i.default.isBaseInput(e)&&e.prototype?new e(o.default.omit(t,"input")):e}var s={create:function(e){if((e=o.default.clone(e)).input)return a(e.input,e);var t=i.default.get(e);if(!t)throw new Error("unknown input: "+e.type);return a(t,e)},supports:function(e){return!!e.input||!!i.default.get(e)}};t.default=s,e.exports=t.default},3197:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107));n(48231);var s=r(n(45361)),l=s.default.extend({className:"okta-form-label o-form-label",attributes:{"data-se":"o-form-label"},constructor:function(e){a.default.defaults(e,{inputId:e.id}),delete e.id,s.default.apply(this,arguments)},template:i.default.template({1:function(e,t,n,r,o){return"<legend>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<label for="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"inputId")||(null!=t?a(t,"inputId"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"inputId",hash:{},data:o,loc:{start:{line:1,column:61},end:{line:1,column:72}}}):i)+'"></label>'},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"label")||(null!=t?a(t,"label"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"label",hash:{},data:o,loc:{start:{line:1,column:116},end:{line:1,column:125}}}):i)},7:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<label for="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:167},end:{line:1,column:178}}}):a))+'">'+c((a=null!=(a=d(n,"label")||(null!=t?d(t,"label"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"label",hash:{},data:i,loc:{start:{line:1,column:180},end:{line:1,column:189}}}):a))+"&nbsp;</label>"},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="o-form-explain">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"sublabel")||(null!=t?a(t,"sublabel"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"sublabel",hash:{},data:o,loc:{start:{line:1,column:256},end:{line:1,column:268}}}):i)+"</span>"},11:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="o-form-tooltip icon-16 icon-only form-help-16" title="'+e.escapeExpression(e.lambda(null!=(i=null!=t?a(t,"tooltip"):t)?a(i,"text"):i,t))+'"></span>'},13:function(e,t,n,r,o){return"</legend>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"group"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:28}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"_isLabelView"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:28},end:{line:1,column:89}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"_isRadioOrCheckbox"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:89},end:{line:1,column:132}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"_standardLabel"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:132},end:{line:1,column:210}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"sublabel"):t,{name:"if",hash:{},fn:e.program(9,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:210},end:{line:1,column:282}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"tooltip"):t,{name:"if",hash:{},fn:e.program(11,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:282},end:{line:1,column:397}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"group"):t,{name:"if",hash:{},fn:e.program(13,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:397},end:{line:1,column:426}}}))?i:"")},useData:!0}),getTemplateData:function(){var e={label:""};return a.default.each(["inputId","label","sublabel","tooltip","group"],(function(t){e[t]=a.default.resultCtx(this.options,t,this)}),this),this._isLabelView(e.label)?e._isLabelView=!0:a.default.contains(["radio","checkbox"],this.options.type)||!e.label?e._isRadioOrCheckbox=!0:e._standardLabel=!0,e.tooltip&&a.default.isString(e.tooltip)&&(e.tooltip={text:e.tooltip}),e},_isLabelView:function(e){return!a.default.isUndefined(e)&&e instanceof s.default},postRender:function(){var e=this.getTemplateData();this._isLabelView(e.label)&&(this.removeChildren(),this.add(e.label,"label")),e.tooltip&&this.$(".o-form-tooltip").qtip(a.default.extend({style:{classes:"qtip-custom qtip-shadow"},position:{my:window.okta&&"dstheme"===window.okta.theme?"bottom center":"bottom left",at:"top center"},hide:{fixed:!0},show:{delay:0}},e.tooltip.options))}});t.default=l,e.exports=t.default},66728:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i={};function a(e){return o.default.isFunction(e)?o.default.isFunction(e.prototype.editMode)&&o.default.isFunction(e.prototype.readMode):o.default.isObject(e)&&o.default.isFunction(e.editMode)&&o.default.isFunction(e.readMode)}var s={isBaseInput:a,register:function(e,t){i[e]=t},get:function(e){var t=i[e.type];return t&&(a(t)?t:t(e))},unregister:function(e){delete i[e]}};t.default=s,e.exports=t.default},34564:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(45361)),a=r(n(57581));function s(e,t){e.apply(this,o.default.map(t.split(/\s+/),(function(e){return this.model.get(e)}),this))}function l(e,t){o.default.isFunction(e)&&e.call(t)}var u=i.default.extend({tagName:function(){return this.options.group?"fieldset":"div"},className:function(){var e="o-form-fieldset";return this.options["label-top"]&&(e+=" o-form-label-top"),this.options.readOnly&&(e+=" o-form-read-mode"),e},attributes:function(){return{"data-se":this.options["data-se"]||"o-form-fieldset"}},constructor:function(e){e.className&&(this.inputWrapperClassName=this.className,this.optionsClassName=e.className,e.className=function(){return o.default.result(this,"inputWrapperClassName","")+" "+o.default.result(this,"optionsClassName")}),i.default.apply(this,arguments),o.default.each(e.events||{},(function(e,t){this.listenTo(this.model,t,e)}),this),o.default.each(e.bindings||{},(function(e,t){this.listenTo(this.model,a.default.changeEventString(t.split(/\s+/)),o.default.bind(s,this,e,t))}),this),a.default.applyShowWhen(this,e.showWhen),a.default.applyToggleWhen(this,e.toggleWhen),l(e.initialize,this)},postRender:function(){o.default.each(this.options.bindings||{},s,this),l(this.options.render,this)},getLabel:function(){return this.size()>1?this.at(0):null},getInput:function(){return this.getInputContainer()},getInputContainer:function(){return this.at(this.size()>1?1:0)},getInputs:function(){return this.getInputContainer().toArray()},focus:function(){return this.getInput().focus()}});t.default=u,e.exports=t.default},76906:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(88712)),a=r(n(80699)),s=r(n(35575)),l=r(n(52078));function u(e){var t=i.default.parseFloat(e);return""===e?null:t}function c(e){return o.default.object(e,e)}function d(e){var t=e.get("items");return t?t.objectName:e.get("objectName")}function f(e,t,n){var r,i=e.get("name"),a=n.__nestedProperty__,s=t[i],l=n.get(i);a&&e.set("__fieldNamePrefix__",a);var u=t[d(e)];s&&l&&(s=o.default.union(s,l)),u&&u.length?r=u:s&&s.length&&(r=s),e.set("__possibleValues__",r)}function p(e,t,n){return e.each((function(e){f(e,t,n)})),e}function h(e,t){return e.filter((function(e){return function(e,t){var n=d(e),r=t[n];return!n||!(0,o.default)(r).isEmpty()}(e,t)}))}var m={createInputOptions:function(e){var t=function(e){var t={},n=e.get("name"),r=e.get("__displayType__"),i=e.get("__possibleValues__"),a=e.get("__fieldNamePrefix__");if(a&&(t.name=a+n,t.errorField=n),e.isEnumType()){var s={displayType:r,title:e.get("title"),enumValues:e.getEnumValues()};t=o.default.extend({},l.default.getEnumInputOptions(s),t)}else(function(e){return e&&e.indexOf("array")>=0})(r)&&i&&(t.type="checkboxset",t.input=null,t.options=c(i));return t}(e),n=function(e){var t=e.get("__displayType__"),n=e.get("__possibleValues__"),r=e.get("name"),l={type:"text",name:r,label:e.get("title")||r};switch(t){case"arrayofstring":l.input=s.default,l.params={itemType:"string"};break;case"arrayofnumber":l.input=s.default,l.params={itemType:"number"};break;case"arrayofinteger":l.input=s.default,l.params={itemType:"integer"};break;case"arrayofobject":l.input=s.default,l.params={itemType:e.get("items").type};break;case"arrayofref-id":l.input=s.default,l.params={itemType:e.get("items").format};break;case"boolean":l.input=a.default;break;case"integer":case"number":l.to=u;break;case"reference":l.type="select",l.options=c(n);break;case"image":l.readOnly=!0,l.from=function(e){return o.default.isEmpty(e)?"":i.default.localize("user.profile.image.image_set","courage")};break;case"password":l.type="password";break;case"date":l.type="date";break;case"uri":case"country-code":case"country_code":case"language-code":case"language_code":case"email":case"locale":case"timezone":case"string":case"object":break;default:throw new Error("unknown type: ".concat(t))}return l}(e);return t.params&&n.params&&(t.params=o.default.defaults(t.params,n.params)),o.default.defaults(t,n)},hasValidSchemaProps:function(e,t){return!o.default.isEmpty(e)&&!!h(e,t).length},prepareSchema:function(e,t,n){return e.reset(h(e,t)),p(e,t,n)},augmentSchemaProps:p,augmentSchemaProp:f};t.default=m,e.exports=t.default},80699:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(84983)),i={undefined:"undefined",true:"true",false:"false"},a=function(e){return e?"true":!1===e?"false":"undefined"},s=function(e){switch(e){case"undefined":default:return null;case"true":return!0;case"false":return!1}},l=o.default.extend({initialize:function(){this.options.options=i,this.options.from=a,this.options.to=s}});t.default=l,e.exports=t.default},37002:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107)),s=r(n(83365));n(1303);var l=r(n(15982)).default.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<input type="checkbox" name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:29},end:{line:1,column:37}}}):a))+'" id="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:43},end:{line:1,column:54}}}):a))+'"/><label for="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:69},end:{line:1,column:80}}}):a))+'" data-se-for-name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:100},end:{line:1,column:108}}}):a))+'">'+c((a=null!=(a=d(n,"placeholder")||(null!=t?d(t,"placeholder"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:110},end:{line:1,column:125}}}):a))+"</label>"},useData:!0}),events:{"change :checkbox":"update",keyup:function(e){e.preventDefault(),s.default.isSpaceBar(e)?this.$(":checkbox").click():s.default.isEnter(e)&&this.model.trigger("form:save")}},editMode:function(){var e=a.default.resultCtx(this.options,"placeholder",this);return""===e?e=a.default.resultCtx(this.options,"label",this):!1===e&&(e=""),this.$el.html(this.template(a.default.extend(a.default.omit(this.options,"placeholder"),{placeholder:e}))),this.$(":checkbox").prop("checked",this.getModelValue()||!1),this.$("input").customInput(),this.model.trigger("form:resize"),this},readMode:function(){return this.editMode(),this.$(":checkbox").prop("disabled",!0),this},val:function(){return this.$(":checkbox").prop("checked")},focus:function(){return this.$(":checkbox").focus()}});t.default=l,e.exports=t.default},90958:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107)),s=r(n(33270)),l=r(n(88712)),u=r(n(60196)),c=r(n(45361)),d=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="o-form-input-group-controls"><span class="input-fix o-form-control"><input type="text" class="o-form-text" name="'+c((a=null!=(a=d(n,"key")||(null!=t?d(t,"key"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"key",hash:{},data:i,loc:{start:{line:1,column:125},end:{line:1,column:132}}}):a))+'" id="'+c((a=null!=(a=d(n,"key")||(null!=t?d(t,"key"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"key",hash:{},data:i,loc:{start:{line:1,column:138},end:{line:1,column:145}}}):a))+'" value="'+c((a=null!=(a=d(n,"value")||(null!=t?d(t,"value"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"value",hash:{},data:i,loc:{start:{line:1,column:154},end:{line:1,column:163}}}):a))+'" placeholder="'+c((a=null!=(a=d(n,"placeholder")||(null!=t?d(t,"placeholder"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:178},end:{line:1,column:193}}}):a))+'"/></span><a href="#" class="link-button link-button-icon icon-only"><span class="icon clear-input-16 "></span></a></div><p class="o-form-input-error o-form-explain"><span class="icon icon-16 error-16-small"></span>'+c((a=null!=(a=d(n,"errorExplain")||(null!=t?d(t,"errorExplain"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"errorExplain",hash:{},data:i,loc:{start:{line:1,column:408},end:{line:1,column:424}}}):a))+"</p>"},useData:!0}),f="o-form-has-errors",p="updateArray",h=c.default.extend({tagName:"div",className:"o-form-input-group",events:{"click a":function(e){e.preventDefault(),this.remove()},"keyup input":function(){this.update()}},isEditMode:function(){return!this.options.readOnly&&(!0!==this.options.read||!0===this.model.get("__edit__"))},initialize:function(){this.template=d(a.default.extend(this.options,{placeholder:this.getPlaceholderText(),errorExplain:this.getErrorExplainText()})),this.update=a.default.debounce(this.update,this.options.debounceDelay||u.default.DEBOUNCE_DELAY)},render:function(){return this.isEditMode()?this.$el.html(this.template):(this.$el.text(this.options.value),this.$("a").hide()),this},remove:function(){var e=arguments,t=this;this.trigger(p,null),this.$el.slideUp((function(){c.default.prototype.remove.call(t,e)}))},update:function(){var e=this.$("input").val(),t=a.default.object([s.default.DATATYPE.number,s.default.DATATYPE.integer],[l.default.parseFloat,this.parseInt]);a.default.has(t,this.options.itemType)&&(e=t[this.options.itemType](e),a.default.isNumber(e)?this.clearInvalid():this.markInvalid()),this.trigger(p,e)},markInvalid:function(){this.$el.addClass(f)},clearInvalid:function(){this.$el.removeClass(f)},getPlaceholderText:function(){var e;switch(this.options.itemType.toLowerCase()){case"string":e=l.default.localize("placeholder.text.string","courage");break;case"number":e=l.default.localize("placeholder.text.number","courage");break;case"integer":e=l.default.localize("placeholder.text.integer","courage");break;default:e=""}return e},getErrorExplainText:function(){var e;switch(this.options.itemType.toLowerCase()){case"string":e=l.default.localize("string.item.type.error.message","courage");break;case"number":e=l.default.localize("number.item.type.error.message","courage");break;case"integer":e=l.default.localize("integer.item.type.error.message","courage");break;default:e=""}return e},parseInt:function(e){function t(t){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}((function(e){if(/^-?\d+$/.test(e)){var t=parseInt(e,10);return a.default.isNaN(t)?e:t}return e}))});t.default=h,e.exports=t.default},59924:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(28107)),i=r(n(2431)),a=r(n(45361)),s=r(n(15982));var l=s.default.extend({tagName:"span",initialize:function(){this.$el.text(this.getModelValue())},editMode:function(){this.toggle(!0)},readMode:function(){this.toggle(!1)},getModelValue:function(){return this.options.label},toggle:function(e){this.$el.toggleClass("o-form-label-inline",e),this.$el.toggleClass("o-form-control",!e)},focus:o.default.noop});var u=a.default.extend({getParams:s.default.prototype.getParams,getParam:s.default.prototype.getParam,className:function(){var e,t;return this.getParam("noBaseClasses")?"":(e="text"===this.getParam("display")?"o-form-input-group-subtle":"o-form-input-group",t=this.getParam("inputs"),o.default.filter(t||[],(function(e){return!o.default.contains(["label","button","select"],e.type)})).length>1&&(e+=" o-form-input-group-2"),e)},initialize:function(){o.default.each(this.getParam("inputs"),(function(e){switch(e.type){case"label":this.add(l,{options:e});break;case"button":this.add((t=e,i.default.create(o.default.defaults({getReadModeString:o.default.constant(" "),focus:o.default.noop},o.default.pick(t,"click","title","href","icon")))));break;default:e=o.default.defaults({model:this.model,params:o.default.extend({autoWidth:!0},e.params||{})},e),this.add(this.getParams().create(e))}var t}),this)},focus:function(){this.first().focus()}}),c=s.default.extend({constructor:function(e){this.inputGroupView=new u(e),s.default.apply(this,arguments)},editMode:function(){this.inputGroupView.remove(),this.inputGroupView=new u(this.options),this.$el.html(this.inputGroupView.render().el)},readMode:function(){this.getParam("useChildInputsReadMode")?this.editMode():s.default.prototype.readMode.apply(this,arguments)},toStringValue:function(){var e=this.inputGroupView.map((function(e){return e.getReadModeString()}));return e.length&&o.default.every(e)?e.join(" "):" "},focus:function(){this.inputGroupView.focus()}},{LabelInput:l,InputGroupView:u});t.default=c,e.exports=t.default},18329:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(28107)),a=r(n(69407)),s=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<span class="password-toggle"><span class="eyeicon visibility-16 button-show"></span><span class="eyeicon visibility-off-16 button-hide"></span></span>'},useData:!0}),l=a.default.extend({initialize:function(){this.__showPasswordToggle()&&(this.events["click .password-toggle .button-show"]="__showPassword",this.events["click .password-toggle .button-hide"]="__hidePassword"),this.delegateEvents()},postRender:function(){this.isEditMode()&&this.__showPasswordToggle()&&(this.$el.append(s),this.$el.find('input[type="password"]').addClass("password-with-toggle")),a.default.prototype.postRender.apply(this,arguments)},val:function(){return this.$('input[type="'+this.options.type+'"]').val()},__showPasswordToggle:function(){return this.options.params&&this.options.params.showPasswordToggle},__showPassword:function(){var e=this;this.$("input").attr("spellcheck",!1),a.default.prototype.changeType.apply(this,["text"]),this.$(".password-toggle .button-show").hide(),this.$(".password-toggle .button-hide").show(),this.passwordToggleTimer=i.default.delay((function(){e.__hidePassword()}),3e4)},__hidePassword:function(){a.default.prototype.changeType.apply(this,["password"]),this.$(".password-toggle .button-show").show(),this.$(".password-toggle .button-hide").hide(),this.passwordToggleTimer&&clearTimeout(this.passwordToggleTimer)}});t.default=l,e.exports=t.default},63984:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(96129)),s=r(n(28107)),l=r(n(83365)),u=r(n(51645)),c=r(n(45361));n(1303);var d=r(n(15982)),f=u.default.isABaseView,p=c.default.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<input type="radio" name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:26},end:{line:1,column:34}}}):a))+'" data-se-name="'+c((a=null!=(a=d(n,"realName")||(null!=t?d(t,"realName"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"realName",hash:{},data:i,loc:{start:{line:1,column:50},end:{line:1,column:62}}}):a))+'" value="'+c((a=null!=(a=d(n,"value")||(null!=t?d(t,"value"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"value",hash:{},data:i,loc:{start:{line:1,column:71},end:{line:1,column:80}}}):a))+'" id="'+c((a=null!=(a=d(n,"optionId")||(null!=t?d(t,"optionId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"optionId",hash:{},data:i,loc:{start:{line:1,column:86},end:{line:1,column:98}}}):a))+'"><label for="'+c((a=null!=(a=d(n,"optionId")||(null!=t?d(t,"optionId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"optionId",hash:{},data:i,loc:{start:{line:1,column:112},end:{line:1,column:124}}}):a))+'" data-se-for-name="'+c((a=null!=(a=d(n,"realName")||(null!=t?d(t,"realName"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"realName",hash:{},data:i,loc:{start:{line:1,column:144},end:{line:1,column:156}}}):a))+'" class="radio-label">'+c((a=null!=(a=d(n,"label")||(null!=t?d(t,"label"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"label",hash:{},data:i,loc:{start:{line:1,column:178},end:{line:1,column:187}}}):a))+"</label>"},useData:!0}),initialize:function(e){var t;t=e.explain,s.default.isFunction(t)&&!f(t)&&(t=s.default.resultCtx(this.options,"explain",this)),t&&(f(t)?(this.add('<p class="o-form-explain"></p>',".radio-label"),this.add(t,".o-form-explain")):this.add(c.default.extend({className:"o-form-explain",tagName:"p",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"explain")||(null!=t?a(t,"explain"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"explain",hash:{},data:o,loc:{start:{line:1,column:0},end:{line:1,column:11}}}):i)},useData:!0})}),".radio-label"))}}),h=d.default.extend({events:{"change :radio":"update",keyup:function(e){l.default.isSpaceBar(e)?(0,a.default)(e.target).click():l.default.isEnter(e)&&this.model.trigger("form:save")}},editMode:function(){var e=[];this.$el.empty(),s.default.each(this.options.options,(function(t,n){var r={optionId:s.default.uniqueId("option"),name:this.options.inputId,realName:this.options.name,value:n};s.default.isObject(t)||(t={label:t}),s.default.extend(r,t),e.push(new p(r).render().el)}),this),this.$el.append(e);var t=this.getModelValue();return t&&this.$(":radio[value="+t+"]").prop("checked",!0),this.$("input").customInput(),this.model.trigger("form:resize"),!0===this.getParam("inline")&&this.$("div.custom-radio").addClass("inline"),this},readMode:function(){return this.editMode(),this.$(":radio").prop("disabled",!0),this},val:function(){return this.$(":radio:checked").val()},focus:function(){return this.$("label:eq(0)").focus()}});t.default=h,e.exports=t.default},84983:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(28107)),s=r(n(15982)),l=r(n(88712)),u=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l="function",u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<select id="'+u((i=null!=(i=c(n,"inputId")||(null!=t?c(t,"inputId"):t))?i:s,(0,o.default)(i)===l?i.call(a,{name:"inputId",hash:{},data:r,loc:{start:{line:1,column:12},end:{line:1,column:23}}}):i))+'" name="'+u((i=null!=(i=c(n,"name")||(null!=t?c(t,"name"):t))?i:s,(0,o.default)(i)===l?i.call(a,{name:"name",hash:{},data:r,loc:{start:{line:1,column:31},end:{line:1,column:39}}}):i))+'"></select>'},useData:!0}),c=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l="function",u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<option value="'+u((i=null!=(i=c(n,"key")||(null!=t?c(t,"key"):t))?i:s,(0,o.default)(i)===l?i.call(a,{name:"key",hash:{},data:r,loc:{start:{line:1,column:15},end:{line:1,column:22}}}):i))+'">'+u((i=null!=(i=c(n,"value")||(null!=t?c(t,"value"):t))?i:s,(0,o.default)(i)===l?i.call(a,{name:"value",hash:{},data:r,loc:{start:{line:1,column:24},end:{line:1,column:33}}}):i))+"</option>"},useData:!0}),d=s.default.extend({className:"o-form-select",events:{"change select":"update"},constructor:function(){this.template=u,this.option=this.option||c,s.default.apply(this,arguments),this.params=this.options.params||{}},editMode:function(){this.$el.html(u(this.options)),this.$select=this.$("select"),this.appendOptions();var e=this.getModelValue();return e?this.$select.val(e):this.$("option:first-child").prop("selected",!0),this.$el.addClass("o-form-control"),this},appendOptions:function(){var e=this;if(this.getOptions()){var t=this.getOptions(),n=Object.keys(t);this.applySortByKey(n),n.forEach((function(n){n?e.$select.append(e.option({key:n,value:t[n]})):e.$select.prepend(e.option({key:"",value:l.default.localize("select.default_value","login")}))})),a.default.defer(a.default.bind(this.update,this))}},applySortByKey:function(e){var t=this.options.sortByKey;t&&(t instanceof Function&&e.sort(t),"asc"===t&&e.sort(),"desc"===t&&(e.sort(),e.reverse()))},val:function(){return this.$select&&this.$select.val()},focus:function(){if(this.$select)return this.$select.focus()},toStringValue:function(){var e=this.getModelValue(),t=e,n=this.getOptions();return a.default.isEmpty(n)||(t=n[e]),a.default.isUndefined(t)&&(t=this.defaultValue()),t||""},getOptions:function(){var e=this.options.options;return a.default.isFunction(e)&&(e=e.call(this)),a.default.isObject(e)?e:{}},remove:function(){return this.$select&&this.$select.trigger("remove"),s.default.prototype.remove.apply(this,arguments)},accessibilityUpdate:function(e,t){var n=this.$select.attr("id")+"_txt",r=(this.$select.attr("id"),this.$select.attr("id")+"_ul");if(e?this.$("input[type=text]").attr("id",n).attr("aria-autocomplete","list").attr("aria-activedescendant","").attr("role","combobox").attr("aria-expanded","true").attr("aria-controls",r):this.$("input[type=text]").attr("id",n).attr("role","listbox"),t&&t.aria&&t.aria.label){var o=t.aria.label.trim();this.$("input[type=text]").attr("id",n).attr("aria-label",o)}else{var i=this.$el.parent().prev(".o-form-label").find("label").text().trim();this.$("input[type=text]").attr("id",n).attr("aria-label",i)}}});t.default=d,e.exports=t.default},69407:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(96129));n(48231);var s=r(n(83365));n(22891);var l=r(n(15982)),u="okta-form-input-field input-fix";var c=l.default.extend({template:i.default.template({1:function(e,t,n,r,o){return'<span class="input-tooltip icon form-help-16"></span>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon input-icon '+e.escapeExpression(e.lambda(null!=(i=null!=t?a(t,"params"):t)?a(i,"icon"):i,t))+'"></span>'},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"autoComplete")||(null!=t?a(t,"autoComplete"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"autoComplete",hash:{},data:o,loc:{start:{line:1,column:333},end:{line:1,column:349}}}):i)},7:function(e,t,n,r,o){return"off"},9:function(e,t,n,r,o){return'<span class="input-icon-divider"></span>'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(a=f(n,"if").call(l,null!=(a=null!=t?f(t,"params"):t)?f(a,"innerTooltip"):a,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:0},end:{line:1,column:87}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=(a=null!=t?f(t,"params"):t)?f(a,"icon"):a,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:87},end:{line:1,column:166}}}))?a:"")+'<input type="'+d((s=null!=(s=f(n,"type")||(null!=t?f(t,"type"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"type",hash:{},data:i,loc:{start:{line:1,column:179},end:{line:1,column:187}}}):s))+'" placeholder="'+d((s=null!=(s=f(n,"placeholder")||(null!=t?f(t,"placeholder"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:202},end:{line:1,column:217}}}):s))+'" name="'+d((s=null!=(s=f(n,"name")||(null!=t?f(t,"name"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"name",hash:{},data:i,loc:{start:{line:1,column:225},end:{line:1,column:233}}}):s))+'" id="'+d((s=null!=(s=f(n,"inputId")||(null!=t?f(t,"inputId"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:239},end:{line:1,column:250}}}):s))+'" value="'+d((s=null!=(s=f(n,"value")||(null!=t?f(t,"value"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"value",hash:{},data:i,loc:{start:{line:1,column:259},end:{line:1,column:268}}}):s))+'" aria-label="'+d((s=null!=(s=f(n,"placeholder")||(null!=t?f(t,"placeholder"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:282},end:{line:1,column:297}}}):s))+'" autocomplete="'+(null!=(a=f(n,"if").call(l,null!=t?f(t,"autoComplete"):t,{name:"if",hash:{},fn:e.program(5,i,0),inverse:e.program(7,i,0),data:i,loc:{start:{line:1,column:313},end:{line:1,column:367}}}))?a:"")+'" />'+(null!=(a=f(n,"if").call(l,null!=(a=null!=t?f(t,"params"):t)?f(a,"iconDivider"):a,{name:"if",hash:{},fn:e.program(9,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:371},end:{line:1,column:444}}}))?a:"")},useData:!0}),events:{"input input":"update","change input":"update","keydown input":"update","compositionend input":function(){this.isComposing=!1},"compositionstart input":function(){this.isComposing=!0},"keyup input":function(e){!s.default.isEnter(e)||window.okta&&window.okta.enableIMESupport?s.default.isEsc(e)&&this.model.trigger("form:cancel"):this.model.trigger("form:save")}},hasIMESupport:!0,constructor:function(){l.default.apply(this,arguments),this.$el.addClass("o-form-control")},editMode:function(){this.$el.addClass(u),l.default.prototype.editMode.apply(this,arguments),this.$("input").placeholder()},readMode:function(){l.default.prototype.readMode.apply(this,arguments),this.$el.addClass("no-translate"),"password"===this.options.type&&this.$el.text("********"),this.$el.removeClass(u)},val:function(){var e=this.$('input[type="'+this.options.type+'"]').val();return"password"!==this.options.type&&(e=a.default.trim(e)),e},focus:function(){return this.$("input").focus()},postRender:function(){var e,t=this.options.params;if(t&&t.innerTooltip){var n=function(e){var t=e.title,n=e.text;return t&&n&&t!==n}(e=t.innerTooltip)?e:{text:e.text||e};this.$(".input-tooltip").qtip({content:n,style:{classes:"okta-tooltip qtip-custom qtip-shadow"},position:{my:"bottom left",target:"mouse",adjust:{method:"flip",mouse:!0,y:-5,x:5},viewport:(0,a.default)("body")}})}}});t.default=c,e.exports=t.default},35575:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=r(n(28107)),a=r(n(33270)),s=r(n(15982)),l=r(n(90958)),u=s.default.extend({className:"array-input",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="array-inputs-button link-button">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"courage",code:"oform.add.another"},data:o,loc:{start:{line:1,column:52},end:{line:1,column:102}}}))+"</a>"},useData:!0}),params:{itemType:"string"},events:{"click .array-inputs-button":function(e){e.preventDefault(),this.isEditMode()&&this.addNewElement()}},initialize:function(e){e||(e={}),this.params=i.default.defaults(e.params||{},this.params),this.uniqueIdPrefix="array"},from:function(e){return i.default.isArray(e)?e:[]},editMode:function(){return this._setArrayObject(),this.$el.html(this.template),i.default.each(this.arrayObject,i.default.bind(this._addDeletableBox,this)),this},readMode:function(){this.editMode(),this.$(".array-inputs-button").addClass("link-button-disabled")},val:function(){var e=i.default.values(this.arrayObject);return i.default.contains([a.default.DATATYPE.number,a.default.DATATYPE.integer],this.params.itemType)&&(e=i.default.filter(e,i.default.isNumber)),e},focus:function(){},addNewElement:function(){var e=i.default.uniqueId(this.uniqueIdPrefix);this.arrayObject[e]="",this._addDeletableBox("",e),this.update()},_addDeletableBox:function(e,t){var n=new l.default(i.default.extend(i.default.pick(this.options,"read","readOnly","model"),{key:t,value:e,itemType:this.params.itemType}));return this.listenTo(n,"updateArray",(function(e){i.default.isNull(e)?(delete this.arrayObject[t],this.stopListening(n)):this.arrayObject[t]=e,this.update()})),n.render().$el.hide(),this.$(".array-inputs-button").before(n.el),n.$el.slideDown(),n},_setArrayObject:function(){var e=this.model.get(this.options.name);if(this.arrayObject={},i.default.isArray(e)&&!i.default.isEmpty(e)){var t=[],n=this;(0,i.default)(e.length).times((function(){t.push(i.default.uniqueId(n.uniqueIdPrefix))})),this.arrayObject=i.default.object(t,e)}}});t.default=u,e.exports=t.default},20290:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={extend:function(){}},e.exports=t.default},6475:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"$",{enumerable:!0,get:function(){return s.default}}),Object.defineProperty(t,"Backbone",{enumerable:!0,get:function(){return a.default}}),Object.defineProperty(t,"BaseModel",{enumerable:!0,get:function(){return d.default}}),Object.defineProperty(t,"Collection",{enumerable:!0,get:function(){return o.Collection}}),Object.defineProperty(t,"Controller",{enumerable:!0,get:function(){return o.Controller}}),Object.defineProperty(t,"Form",{enumerable:!0,get:function(){return o.Form}}),Object.defineProperty(t,"FrameworkView",{enumerable:!0,get:function(){return f.default}}),Object.defineProperty(t,"Handlebars",{enumerable:!0,get:function(){return u.default}}),Object.defineProperty(t,"ListView",{enumerable:!0,get:function(){return p.default}}),Object.defineProperty(t,"Model",{enumerable:!0,get:function(){return c.default}}),Object.defineProperty(t,"Router",{enumerable:!0,get:function(){return o.Router}}),Object.defineProperty(t,"View",{enumerable:!0,get:function(){return o.View}}),Object.defineProperty(t,"_",{enumerable:!0,get:function(){return l.default}}),Object.defineProperty(t,"createButton",{enumerable:!0,get:function(){return o.createButton}}),Object.defineProperty(t,"createCallout",{enumerable:!0,get:function(){return o.createCallout}}),Object.defineProperty(t,"internal",{enumerable:!0,get:function(){return o.internal}}),Object.defineProperty(t,"isModelPropertySchema",{enumerable:!0,get:function(){return i.isModelPropertySchema}}),Object.defineProperty(t,"loc",{enumerable:!0,get:function(){return o.loc}}),Object.defineProperty(t,"registerInput",{enumerable:!0,get:function(){return o.registerInput}});var o=n(2890),i=n(50926),a=r(n(2770)),s=r(n(96129)),l=r(n(28107)),u=r(n(2875)),c=r(n(13614)),d=r(n(34146)),f=r(n(67282)),p=r(n(54833))},57223:function(e,t,n){"use strict";var r=n(1654)(n(96129));r.default.fn.scrollParent=function(e){var t=this.css("position"),n="absolute"===t,o=e?/(auto|scroll|hidden)/:/(auto|scroll)/,i=this.parents().filter((function(){var e=(0,r.default)(this);return(!n||"static"!==e.css("position"))&&o.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))})).eq(0);return"fixed"!==t&&i.length?i:(0,r.default)(this[0].ownerDocument||document)}},80496:function(e,t,n){var r=n(66583),o=n(12990);
/**
 * TypingDNA - Typing Biometrics JavaScript API
 * https://api.typingdna.com/scripts/typingdna.js
 * https://typingdna.com/scripts/typingdna.js (alternative)
 *
 * @version 2.15
 * @author Raul Popa
 * @copyright SC TypingDNA SRL, http://typingdna.com
 * @license http://www.apache.org/licenses/LICENSE-2.0
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Typical usage:
 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
 * returns a type 1 typing pattern (and continues recording afterwards)
 *
 * Optional:
 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
 * (there is no need to initialize the class to do pattern quality checking)
 */
e.exports=function e(){if(1==e.initialized)return e.instance;for(var t in e.prototype.start=function(){return e.start.apply(this,arguments)},e.prototype.stop=function(){return e.stop.apply(this,arguments)},e.prototype.reset=function(){return e.reset.apply(this,arguments)},e.prototype.addTarget=function(){return e.addTarget.apply(this,arguments)},e.prototype.removeTarget=function(){return e.removeTarget.apply(this,arguments)},e.prototype.getTypingPattern=function(){return e.getTypingPattern.apply(this,arguments)},e.prototype.get=function(){return e.get.apply(this,arguments)},e.prototype.startDiagram=function(){},e.prototype.stopDiagram=function(){},e.prototype.getDiagram=function(){return e.getDiagram.apply(this,arguments)},e.prototype.getExtendedDiagram=function(){return e.getExtendedDiagram.apply(this,arguments)},e.prototype.getMouseDiagram=function(){return e.getMouseDiagram.apply(this,arguments)},e.prototype.startMouse=function(){return e.startMouse.apply(this,arguments)},e.prototype.stopMouse=function(){return e.stopMouse.apply(this,arguments)},e.prototype.getQuality=function(){return e.getQuality.apply(this,arguments)},e.prototype.getLength=function(){return e.getLength.apply(this,arguments)},e.prototype.isMobile=function(){return e.isMobile.apply(this,arguments)},e.prototype.getTextId=function(){return e.getTextId.apply(this,arguments)},e.initialized=!0,e.prototype.maxHistoryLength=e.maxHistoryLength,e.prototype.defaultHistoryLength=e.defaultHistoryLength,e.prototype.maxSeekTime=e.maxSeekTime,e.prototype.maxPressTime=e.maxPressTime,e.version=2.15,e.flags=0,e.instance=this,e.document=document,e.maxHistoryLength=2e3,e.maxSeekTime=1500,e.maxPressTime=300,e.defaultHistoryLength=160,e.spKeyCodes=[8,13,32],e.spKeyCodesObj={8:1,13:1,32:1},e.keyCodes=[65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,32,222,188,190,186,187,189,191,48,49,50,51,52,53,54,55,56,57],e.keyCodesObj={},e.keyCodes)e.keyCodesObj[e.keyCodes[t]]=1;e.pt1=e.ut1=(new Date).getTime(),e.wfk=[],e.sti=[],e.skt=[],e.recording=!0,e.mouseRecording=!0,e.mouseMoveRecording=!1,e.spKeyRecording=!0,e.diagramRecording=!0,e.dwfk=[],e.dsti=[],e.dskt=[],e.drkc=[],e.prevKeyCode=0,e.maxMoveDeltaTime=600,e.maxScrollDeltaTime=800,e.maxStopTime=1500,e.maxClickTime=600,e.maxMouseHistoryLength=500,e.lastMouseMoveTime=e.lastMouseDownTime=(new Date).getTime(),e.stopTimes=[],e.clickTimes=[],e.lastMouseStop=!0,e.zl=1e-7,e.isAndroidChrome=!1,e.ACLastTime=(new Date).getTime(),e.ACSeekTime=0,e.ACPressTime=0,e.ACLastCharCode=0,e.ACLastKeyCode=0,e.ACInputLengths={inputs:[],lastLength:[]},e.ACPreviousKeyCode=0,e.targetIds=[],e.lastTarget="",e.lastTargetFound=!1,e.replaceMissingKeys=!0,e.replaceMissingKeysPerc=7,e.keyDown=function(t){if((e.recording||e.diagramRecording)&&e.isTarget(t.target.id)){var n=t.keyCode;if(1==e.wfk[n]||e.dwfk[n],229==n&&e.isMobile()&&!e.isAndroidChrome)e.isAndroidChrome=!0,e.ACSeekTime=(new Date).getTime()-e.ACLastTime,e.ACLastTime=(new Date).getTime(),e.document.removeEventListener("keydown",e.keyDown),e.document.removeEventListener("keyup",e.keyUp),e.document.removeEventListener("keypress",e.keyPress),e.document.addEventListener("keydown",e.ACKeyDown),e.document.addEventListener("keyup",e.ACKeyUp);else{var r=e.pt1,o=(e.pt1=(new Date).getTime())-r,i=e.pt1;(1==e.recording||e.spKeyCodesObj[n]&&1==e.spKeyRecording)&&(t.shiftKey&&!e.isMobile()||(e.wfk[n]=1,e.skt[n]=o,e.sti[n]=i)),1==e.diagramRecording&&(e.dwfk[n]=1,e.dskt[n]=o,e.dsti[n]=i,e.dlastDownKey=n)}}},e.keyPress=function(t){(e.recording||e.diagramRecording)&&(e.isTarget(t.target.id)&&1==e.diagramRecording&&(e.drkc[e.dlastDownKey]=t.charCode))},e.keyUp=function(t){if((e.recording||e.diagramRecording)&&e.isTarget(t.target.id)){var n=(new Date).getTime(),r=t.keyCode;if(1==e.recording||e.spKeyCodesObj[r]&&1==e.spKeyRecording){if((!t.shiftKey||e.isMobile())&&1==e.wfk[r]){var o=n-e.sti[r],i=[r,e.skt[r],o,e.prevKeyCode,n,t.target.id];e.history.add(i),e.prevKeyCode=r}e.wfk[r]=0}if(1==e.diagramRecording){if(null!=e.drkc[r]&&0!=e.drkc[r]&&1==e.dwfk[r]){o=n-e.dsti[r];var a=[r,e.dskt[r],o,e.drkc[r],n,t.target.id];e.history.addDiagram(a)}e.dwfk[r]=0}}},e.mouseScroll=function(t){if(1==e.mouseRecording&&1==e.mouseMoveRecording)if(1==e.mouse.scrollStarted){var n=(new Date).getTime();e.mouse.scrollTimes.push(n),e.mouse.scrollTopArr.push(e.document.body.scrollTop),clearInterval(e.scrollInterval),e.scrollInterval=setInterval(e.mouse.checkScroll,e.maxScrollDeltaTime)}else e.mouse.scrollStarted=!0},e.mouseMove=function(t){if(1==e.mouseRecording){var n=(new Date).getTime();1==e.mouseMoveRecording&&(1==e.mouse.started?(e.mouse.times.push(n),e.mouse.xPositions.push(t.screenX),e.mouse.yPositions.push(t.screenY),clearInterval(e.moveInterval),e.moveInterval=setInterval(e.mouse.checkMove,e.maxMoveDeltaTime)):e.mouse.started=!0),e.lastMouseMoveTime=n}},e.mouseDown=function(t){if(1==e.mouseRecording&&(e.mouse.checkMove(),e.mouse.checkScroll(),1==t.which)){var n=(e.lastMouseDownTime=(new Date).getTime())-e.lastMouseMoveTime;if(n<e.maxStopTime&&0==e.lastMouseStop&&(e.stopTimes.push(n),1==e.mouseMoveRecording)){var r=[3,n];e.mouse.history.add(r),e.lastMouseStop=!0}}},e.mouseUp=function(t){if(1==e.mouseRecording&&1==t.which){var n=(new Date).getTime()-e.lastMouseDownTime;if(n<e.maxClickTime&&e.lastMouseDownTime>e.lastMouseMoveTime&&(e.clickTimes.push(n),1==e.mouseMoveRecording)){var r=[4,n];e.mouse.history.add(r)}}},e.ACKeyDown=function(t){(e.recording||e.diagramRecording)&&(e.ACSeekTime=(new Date).getTime()-e.ACLastTime,e.ACLastTime=(new Date).getTime(),e.isTarget(t.target.id)&&-1===e.ACInputLengths.inputs.indexOf(t.target)&&(e.ACInputLengths.inputs.push(t.target),e.ACInputLengths.lastLength.push(0)))},e.ACKeyUp=function(t){if((e.recording||e.diagramRecording)&&(e.ACPressTime=(new Date).getTime()-e.ACLastTime,e.ACLastTime=(new Date).getTime(),e.isTarget(t.target.id))){var n=t.keyCode,r=e.ACInputLengths.inputs.indexOf(t.target);if(-1===r&&(e.ACInputLengths.inputs.push(t.target),e.ACInputLengths.lastLength.push(0),r=e.ACInputLengths.inputs.indexOf(t.target)),229==n&&t.target.value.length>=e.ACInputLengths.lastLength[r]){var o=t.target.value.substr(t.target.selectionStart-1||0,1);n=o.toUpperCase().charCodeAt(0),e.ACLastCharCode=o.charCodeAt(0),e.ACLastKeyCode=o.toUpperCase().charCodeAt(0)}e.ACInputLengths.lastLength[r]=t.target.value.length;var i=[n,e.ACSeekTime,e.ACPressTime,e.ACPreviousKeyCode,e.ACLastTime];if(e.history.add(i),e.ACPreviousKeyCode=n,1==e.diagramRecording){var a=[n,e.ACSeekTime,e.ACPressTime,e.ACLastCharCode];e.history.addDiagram(a)}}},e.isTarget=function(t){if(e.lastTarget==t&&e.lastTargetFound)return!0;var n=e.targetIds.length,r=!1;if(n>0){for(var o=0;o<n;o++)if(e.targetIds[o]==t){r=!0;break}return e.lastTarget=t,e.lastTargetFound=r,r}return e.lastTarget=t,e.lastTargetFound=!0,!0},e.document.addEventListener?(e.document.addEventListener("keydown",e.keyDown),e.document.addEventListener("keyup",e.keyUp),e.document.addEventListener("keypress",e.keyPress),e.document.addEventListener("mousemove",e.mouseMove),e.document.addEventListener("mousedown",e.mouseDown),e.document.addEventListener("mouseup",e.mouseUp),e.document.addEventListener("scroll",e.mouseScroll)):e.document.attachEvent&&(e.document.attachEvent("onkeydown",e.keyDown),e.document.attachEvent("onkeyup",e.keyUp),e.document.attachEvent("onkeypress",e.keyPress),e.document.attachEvent("onmousemove",e.mouseMove),e.document.attachEvent("onmousedown",e.mouseDown),e.document.attachEvent("onmouseup",e.mouseUp),e.document.attachEvent("onscroll",e.mouseScroll)),(e.mouse={}).times=[],e.mouse.xPositions=[],e.mouse.yPositions=[],e.mouse.scrollTimes=[],e.mouse.scrollTopArr=[],e.mouse.history={},e.mouse.history.stack=[],e.mouse.getDistance=function(e,t){return Math.sqrt(e*e+t*t)},e.mouse.getTotalDistance=function(n,r){var o=0,i=n.length;for(t=1;t<i-1;t++){var a=n[t]-n[t-1],s=r[t]-r[t-1];o+=e.mouse.getDistance(a,s)}return o},e.mouse.getAngle=function(e,t){var n=t<0;return e>=0?n?180+Math.round(Math.atan(Math.abs(e)/(Math.abs(t)+1e-7))/.01745329251):90-Math.round(Math.atan(Math.abs(e)/(Math.abs(t)+1e-7))/.01745329251)+270:n?90-Math.round(Math.atan(Math.abs(e)/(Math.abs(t)+1e-7))/.01745329251)+90:Math.round(Math.atan(Math.abs(e)/(Math.abs(t)+1e-7))/.01745329251)},e.mouse.recordMoveAction=function(){var n=e.mouse.times.length;if(!(n<3)){var r=e.mouse.times[n-1]-e.mouse.times[0],o=e.mouse.xPositions[n-1]-e.mouse.xPositions[0],i=e.mouse.yPositions[n-1]-e.mouse.yPositions[0],a=Math.round(e.mouse.getDistance(o,i)),s=Math.round(e.mouse.getTotalDistance(e.mouse.xPositions,e.mouse.yPositions)),l=Math.round(100*s/a),u=[1,r,a,Math.round(100*a/r),e.mouse.getAngle(o,i),l];for(t in u)if(isNaN(u[t]))return;e.mouse.history.add(u),e.lastMouseStop=!1}},e.mouse.recordScrollAction=function(){var n=e.mouse.scrollTimes.length;if(!(n<2)){var r=e.mouse.scrollTimes[n-1]-e.mouse.scrollTimes[0],o=e.mouse.scrollTopArr[n-1]-e.mouse.scrollTopArr[0],i=[2,r,o,Math.round(100*o/r)];for(t in i)if(isNaN(i[t])&&!isFinite(i[t]))return;e.mouse.history.add(i)}},e.mouse.history.add=function(t){this.stack.push(t),this.stack.length>e.maxMouseHistoryLength&&this.stack.shift()},e.mouse.history.getDiagram=function(){var t=this.stack.join("|");return[String(e.isMobile())+","+String(e.version),t].join("|")},e.mouse.clearLastMove=function(){e.mouse.times=[],e.mouse.xPositions=[],e.mouse.yPositions=[]},e.mouse.checkMove=function(){clearInterval(e.moveInterval),1==e.mouse.started&&(e.mouse.started=!1,e.mouse.recordMoveAction(),e.mouse.clearLastMove())},e.mouse.clearLastScroll=function(){e.mouse.scrollTimes=[],e.mouse.scrollTopArr=[]},e.mouse.checkScroll=function(){clearInterval(e.scrollInterval),1==e.mouse.scrollStarted&&(e.mouse.scrollStarted=!1,e.mouse.recordScrollAction(),e.mouse.clearLastScroll())},e.addTarget=function(t){var n=e.targetIds.length,r=!1;if(n>0){for(var o=0;o<n;o++)if(e.targetIds[o]==t){r=!0;break}r||e.targetIds.push(t)}else e.targetIds.push(t)},e.removeTarget=function(t){var n=e.targetIds.length;if(n>0)for(var r=0;r<n;r++)if(e.targetIds[r]==t){e.targetIds.splice(r,1);break}},e.reset=function(t){e.history.stack=[],e.history.stackDiagram=[],e.clickTimes=[],e.stopTimes=[],e.ACInputLengths={inputs:[],lastLength:[]},1==t&&(e.mouse.history.stack=[])},e.start=function(){return e.diagramRecording=!0,e.recording=!0},e.stop=function(){return e.diagramRecording=!1,e.recording=!1},e.startMouse=function(){return e.mouseRecording=e.mouseMoveRecording=!0},e.stopMouse=function(){return e.mouseRecording=e.mouseMoveRecording=!1},e.getTypingPattern=function(t){if("object"!==o(t))return e.get();switch(t.type){case 0:return e.get(t.length,t.targetId);case 1:var n=null!=t.text?t.text:t.length;return e.history.getDiagram(t.extended,n,t.textId,t.targetId,t.caseSensitive);case 2:n=null!=t.text?t.text:t.length;return e.history.getDiagram(!0,n,t.textId,t.targetId,t.caseSensitive);default:return e.get(t.length)}},e.getDiagram=function(t,n){return e.history.getDiagram(!1,t,n,void 0,!1)},e.getExtendedDiagram=function(t,n){return e.history.getDiagram(!0,t,n,void 0,!1)},e.getMouseDiagram=function(){return e.mouse.history.getDiagram()},e.get=function(t,n){var o=e.history.stack.length;null!=t&&0!=t||(t=e.defaultHistoryLength),t>o&&(t=o);var i={},a=e.history.get(t,"",n),s=r(a,2);i.arr=s[0],targetLength=s[1],null!=n&&""!=n&&(t=targetLength);var l=e.zl,u=t,c=e.math.fo(e.history.get(t,"seek",n)),d=e.math.fo(e.history.get(t,"press",n)),f=Math.round(e.math.avg(d)),p=Math.round(e.math.avg(c)),h=Math.round(e.math.sd(d)),m=Math.round(e.math.sd(c)),v=p+f,g=e.math.rd((f+l)/(v+l),4),y=e.math.rd((1-g)/g,4),b=e.math.rd((h+l)/(f+l),4),w=e.math.rd((m+l)/(f+l),4),_=Math.round(6e4/(v+l));for(var O in 0==u&&(_=0),i.arr){var k=i.arr[O][1].length,x=0,E=0,T=0,S=0,A=0,P=0;switch(i.arr[O][0].length){case 0:break;case 1:x=e.math.rd((i.arr[O][0][0]+l)/(p+l),4);break;default:var C=e.math.fo(i.arr[O][0]);x=e.math.rd((e.math.avg(C)+l)/(p+l),4),S=e.math.rd((e.math.sd(C)+l)/(m+l),4)}switch(i.arr[O][1].length){case 0:break;case 1:E=e.math.rd((i.arr[O][1][0]+l)/(f+l),4);break;default:var C=e.math.fo(i.arr[O][1]);E=e.math.rd((e.math.avg(C)+l)/(f+l),4),A=e.math.rd((e.math.sd(C)+l)/(h+l),4)}switch(i.arr[O][2].length){case 0:break;case 1:T=e.math.rd((i.arr[O][2][0]+l)/(p+l),4);break;default:C=e.math.fo(i.arr[O][2]);T=e.math.rd((e.math.avg(C)+l)/(p+l),4),P=e.math.rd((e.math.sd(C)+l)/(m+l),4)}delete i.arr[O][2],delete i.arr[O][1],delete i.arr[O][0],i.arr[O][0]=k,i.arr[O][1]=x,i.arr[O][2]=E,i.arr[O][3]=T,i.arr[O][4]=S,i.arr[O][5]=A,i.arr[O][6]=P}e.apu(C=[],u),e.apu(C,_),e.apu(C,v),e.apu(C,g),e.apu(C,y),e.apu(C,b),e.apu(C,w),e.apu(C,f),e.apu(C,p),e.apu(C,h),e.apu(C,m);for(var R=0;R<=6;R++)for(O=0;O<44;O++){var I=e.keyCodes[O],N=i.arr[I][R];0==N&&R>0&&(N=1),e.apu(C,N)}return e.apu(C,e.isMobile()),e.apu(C,e.version),e.apu(C,e.flags),C.push(e.history.getSpecialKeys()),C.join(",")},e.apu=function(e,t){"NaN"==String(t)&&(t=0),e.push(t)},(e.math={}).rd=function(e,t){return Number(e.toFixed(t))},e.math.avg=function(e){var t=e.length;if(t>0){for(var n=0,r=0;r<t;r++)n+=e[r];return this.rd(n/t,4)}return 0},e.math.sd=function(e){var t=e.length;if(t<2)return 0;for(var n=0,r=this.avg(e),o=0;o<t;o++)n+=(e[o]-r)*(e[o]-r);return Math.sqrt(n/t)},e.math.fo=function(e){if(e.length>1){var t=e.concat(),n=e.length;t.sort((function(e,t){return e-t}));var r=this.sd(t),o=t[Math.ceil(e.length/2)],i=o+2*r,a=o-2*r;n<20&&(a=0);for(var s=[],l=0;l<n;l++){var u=t[l];u<i&&u>a&&s.push(u)}return s}return e},e.math.fnv1aHash=function(e){if(null==e&&"string"!=typeof e)return 0;var t,n,r=1914395348;for(t=0,n=(e=e.toLowerCase()).length;t<n;t++)r^=e.charCodeAt(t),r+=(r<<1)+(r<<4)+(r<<7)+(r<<8)+(r<<24);return r>>>0},(e.history={}).stack=[],e.history.stackDiagram=[],e.history.add=function(t){this.stack.push(t),this.stack.length>e.maxHistoryLength&&this.stack.shift()},e.history.addDiagram=function(e){this.stackDiagram.push(e)},e.history.getDiagram=function(t,n,r,i,a){a=null!=a?a:null==n||""==n;var s=[],l=1==t?1:0,u=this.stackDiagram;if(null!=i&&""!=i&&u.length>0){if(u=e.sliceStackByTargetId(u,i),null==n||""==n)null!=(f=e.document.getElementById(i))&&(n=f.value)}else{var c=e.targetIds.length;if((null==n||""==n)&&c>0){n="";for(var d=0;d<c;d++){var f;null!=(f=e.document.getElementById(e.targetIds[d]))&&(n+=f.value)}}}var p=0,h=u.length,m=h;"string"==typeof n?m=n.length:"number"==typeof n&&n<h&&(m=n);var v=0;if(null!=r?v=isNaN(parseInt(r))?e.math.fnv1aHash(r):parseInt(r):"string"==typeof n&&(v=e.math.fnv1aHash(n)),s.push([e.isMobile(),e.version,e.flags,l,m,v,e.history.getSpecialKeys()]),null!=n&&n.length>0&&"string"==typeof n){var g,y,b=n.toLowerCase(),w=n.toUpperCase(),_=[],O=0;for(d=0;d<n.length;d++){var k=n.charCodeAt(d);a||(y=(g=w.charCodeAt(d))!=k?g:b.charCodeAt(d));for(var x=O,E=h,T=!1;0==T;){for(var S=x;S<E;S++){if((D=(j=u[S])[3])==k||!a&&D==y){if(T=!0,S==O)O++,_=[];else{_.push(S);var A=_.length;A>1&&_[A-1]==_[A-2]+1&&(O=S+1,_=[])}var P=j[0],C=j[1],R=j[2];t?s.push([D,C,R,P]):s.push([C,R]);break}}if(0==T)if(0!=x)x=0,E=O;else if(T=!0,e.replaceMissingKeys){if(p++,"object"!==o(e.savedMissingAvgValues)||e.savedMissingAvgValues.historyLength!=h){var I=e.math.fo(e.history.get(0,"seek")),N=e.math.fo(e.history.get(0,"press"));C=Math.round(e.math.avg(I)),R=Math.round(e.math.avg(N));e.savedMissingAvgValues={seekTime:C,pressTime:R,historyLength:h}}else C=e.savedMissingAvgValues.seekTime,R=e.savedMissingAvgValues.pressTime;t?s.push([k,C,R,k,1]):s.push([C,R,1]);break}}if(e.replaceMissingKeysPerc<100*p/m)return null}}else{var M=0;"number"==typeof n&&(M=h-n),M<0&&(M=0);for(d=M;d<h;d++){var j;P=(j=u[d])[0],C=j[1],R=j[2];if(t){var D=j[3];s.push([D,C,R,P])}else s.push([C,R])}}return s.join("|")},e.sliceStackByTargetId=function(e,n){var r=e.length,o=[];for(t=0;t<r;t++){var i=e[t];i[5]==n&&o.push(i)}return o},e.history.get=function(t,n,r){var o=this.stack;null!=r&&""!=r&&o.length>0&&(o=e.sliceStackByTargetId(o,r));var i=o.length;switch(0!=t&&null!=t||(t=e.defaultHistoryLength),t>i&&(t=i),n){case"seek":var a=[];for(u=1;u<=t;u++){(f=o[i-u][1])<=e.maxSeekTime&&a.push(f)}return a;case"press":var s=[];for(u=1;u<=t;u++){(p=o[i-u][2])<=e.maxPressTime&&s.push(p)}return s;default:var l={};for(var u in e.keyCodes)l[e.keyCodes[u]]=[[],[],[]];for(u=1;u<=t;u++){var c=o[i-u],d=c[0],f=c[1],p=c[2],h=c[3];e.keyCodesObj[d]&&(f<=e.maxSeekTime&&(l[d][0].push(f),0!=h&&e.keyCodesObj[h]&&l[h][2].push(f)),p<=e.maxPressTime&&l[d][1].push(p))}return[l,t]}},e.history.getSpecialKeys=function(){var t=[],n=this.stack.length,r={};for(var o in e.spKeyCodes)r[e.spKeyCodes[o]]=[[]];for(o=1;o<=n;o++){var i=this.stack[n-o];if(e.spKeyCodesObj[i[0]]){var a=i[0],s=i[2];s<=e.maxPressTime&&r[a][0].push(s)}}for(var o in e.spKeyCodes){var l=(i=e.math.fo(r[e.spKeyCodes[o]][0])).length;t.push(l),l>1?(t.push(Math.round(e.math.avg(i))),t.push(Math.round(e.math.sd(i)))):1==l?t.push([i[0],-1]):t.push([-1,-1])}var u=e.clickTimes.length;t.push(u),u>1?(t.push(Math.round(e.math.avg(e.clickTimes))),t.push(Math.round(e.math.sd(e.clickTimes)))):1==u?t.push(e.clickTimes[0],-1):t.push([-1,-1]);var c=e.stopTimes.length;return t.push(c),c>1?(t.push(Math.round(e.math.avg(e.stopTimes))),t.push(Math.round(e.math.sd(e.stopTimes)))):1==c?t.push(e.stopTimes[0],-1):t.push([-1,-1]),t},e.getQuality=function(t){var n=t.split(",");for(a=0;a<n.length;a++)n[a]=Number(n[a]);n[0];var r=rec=avgAcc=0,o=e.math.avg(n),i=n.slice(11,55);for(var a in i)rec+=Number(i[a]>0),r+=Number(i[a]>4),avgAcc+=Number(i[a]>o);var s=Math.sqrt(rec*r*avgAcc)/80;return s>1?1:s},e.checkMobileValidity=function(e){var t=e.split(","),n=t[0];if(0==n)return 0;var r=0,o=t.slice(11,55);for(var i in o)r+=Number(o[i]);return r/n},e.getLength=function(e){return Number(e.split(",")[1])},e.isMobile=function(){if(null!=e.mobile)return e.mobile;var t,n=0;return t=navigator.userAgent||navigator.vendor||window.opera,(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(n=1),e.mobile=n,n},e.getTextId=function(t){return e.math.fnv1aHash(t)}}},79084:function(e){
/**
 * Duo Web SDK v2
 * Copyright 2019, Duo Security
 */
e.exports=function(){var e,t,n,r,o,i,a=/^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/,s=/^ERR\|[\w\s\.\(\)]+$/,l=/^DUO_OPEN_WINDOW\|/,u=["duo.com","duosecurity.com","duomobile.s3-us-west-1.amazonaws.com"];function c(){e="",t="sig_response",n=void 0,r=void 0,o=void 0,i=void 0}function d(e,t){var n=t||"https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe";throw new Error("Duo Web SDK error: "+e+(n?"\nSee "+n+" for more information":""))}function f(e){return e.replace(/([a-z])([A-Z])/,"$1-$2").toLowerCase()}function p(e,t){return"dataset"in e?e.dataset[t]:e.getAttribute("data-"+f(t))}function h(e,t,n,r){"addEventListener"in window?e.addEventListener(t,r,!1):e.attachEvent(n,r)}function m(e,t,n,r){"removeEventListener"in window?e.removeEventListener(t,r,!1):e.detachEvent(n,r)}function v(e){h(document,"DOMContentLoaded","onreadystatechange",e)}function g(e){m(document,"DOMContentLoaded","onreadystatechange",e)}function y(e){h(window,"message","onmessage",e)}function b(e){m(window,"message","onmessage",e)}function w(e){if(e){0===e.indexOf("ERR|")&&d(e.split("|")[1]),-1!==e.indexOf(":")&&2===e.split(":").length||d("Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries.");var t=e.split(":");return r=t[0],o=t[1],{sigRequest:e,duoSig:t[0],appSig:t[1]}}}function _(e){return Boolean(e.origin==="https://"+n&&"string"==typeof e.data&&(e.data.match(a)||e.data.match(s)||e.data.match(l)))}function O(r){c(),r&&(r.host&&(n=r.host),r.sig_request&&w(r.sig_request),r.post_action&&(e=r.post_action),r.post_argument&&(t=r.post_argument),"function"==typeof r.submit_callback&&r.submit_callback);var o=k(r);o?I(o,r.iframeAttributes||{}):R(r),g(O)}function k(e){var t;return e.iframe&&e.iframeContainer?d("Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed."):e.iframe?T(t=x(e.iframe)):e.iframeContainer?S(t=x(e.iframeContainer)):t=document.getElementById("duo_iframe"),t}function x(e){return e.tagName?e:"string"==typeof e?document.getElementById(e):null}function E(e){return e&&e.tagName&&"iframe"===e.tagName.toLowerCase()}function T(e){e&&!E(e)&&d("`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.")}function S(e){e&&E(e)&&d("`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().")}function A(){return["https://",n,"/frame/web/v1/auth?tx=",r,"&parent=",encodeURIComponent(document.location.href),"&v=2.8"].join("")}function P(e){if(_(e))if(e.data.match(l)){var t=e.data.substring("DUO_OPEN_WINDOW|".length);C(t)&&window.open(t,"_self")}else N(e.data),b(P)}function C(e){if(!e)return!1;var t=document.createElement("a");if(t.href=e,"duotrustedendpoints:"===t.protocol)return!0;if("https:"!==t.protocol)return!1;for(var n=0;n<u.length;n++)if(t.hostname.endsWith("."+u[n])||t.hostname===u[n])return!0;return!1}function R(e){v((function t(){var n=k(e);n||d('This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.'),I(n,e.iframeAttributes||{}),g(t)}))}function I(a,s){if(n||(n=p(a,"host"))||d("No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element."),r&&o||(w(p(a,"sigRequest")),r&&o||d("No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.")),""===e&&(e=p(a,"postAction")||e),"sig_response"===t&&(t=p(a,"postArgument")||t),E(a))(i=a).src=A();else{for(;a.firstChild;)a.removeChild(a.firstChild);for(var l in i=document.createElement("iframe"),s.src=A(),s)i.setAttribute(l,s[l]);a.appendChild(i)}y(P)}function N(t){e(t+":"+o)}return c(),{init:O,_onReady:v,_parseSigRequest:w,_isDuoMessage:_,_doPostBack:N}}()},21576:function(e,t,n){n(58245),n(58603),n(53950),n(27672),n(44799),n(91512),n(88991),n(89691),n(75497),n(70257),n(42075),n(72534),n(88150),n(24611),n(26397),n(560),n(20697),n(18470),n(87971),n(86797),n(61068),n(33268),n(23582),n(69765)},66757:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(6321)),a=r(n(35546));function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var u={};function c(e,t,n){var r=i.default.defer();return e.animate({"text-indent":1},{duration:200,easing:"swing",step:function(r,o){o.start=t,o.end=n,e.css("transform","scale("+r+", "+r+")")},always:function(){r.resolve(e)}}),r.promise}function d(e,t,n){var r=i.default.defer();return e.animate({"text-indent":1},{duration:150,easing:"swing",step:function(r,o){o.start=t,o.end=n,e.css("transform","rotate("+r+"deg)")},always:function(){r.resolve(e)}}),r.promise}u.swapPages=function(e){var t=i.default.defer(),n=e.$parent,r=e.$oldRoot,s=e.$newRoot,u=e.success,c=e.ctx,d="transition-from-right";e.dir&&e.dir===a.default.DIRECTION_BACK&&(d="transition-from-left"),s.addClass(d),n.append(s),n.addClass("animation-container-overflow");var f={left:"0px",top:"0px",opacity:1};return s.animate(f,200,(function(){n.removeClass("animation-container-overflow"),s.removeClass(d);var e=Object.keys(f).reduce((function(e,t){return l(l({},e),{},(0,o.default)({},t,""))}),{});s.css(e),u.call(c),t.resolve()})),r.animate({height:s.height(),opacity:0},160),t.promise},u.swapBeacons=function(e){var t=e.$el,n=e.swap,r=e.ctx;return this.implode(t).then((function(){return n.call(r),t})).then(this.explode)},u.explode=function(e){return c(e,0,1)},u.implode=function(e){return c(e,1,0)},u.radialProgressBar=function(e){var t=e.$el,n=e.swap,r=t.children();return d(r,0,180).then((function(){t.css({clip:"auto"})})).then((function(){var e=r.eq(0);return n(),d(e,180,360)})).then((function(){t.css({clip:"rect(0px, 96px, 96px, 48px)"}),r.css({transform:"rotate(0deg)","text-indent":"1px"})}))};var f=u;t.default=f,e.exports=t.default},28766:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(35546)),i={};i.lighten=function(e,t){t=t||0,e=e.substr(1);for(var n="#",r=0;r<3;r++){var o=parseInt(e.substr(2*r,2),16);n+=("00"+(o=Math.round(Math.min(Math.max(0,o+o*t),255)).toString(16))).substr(o.length)}return n},i.addStyle=function(e,t){var n=function(e){return"\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: ".concat(e.brand,"; }\n#okta-sign-in.auth-container .button-primary:hover { background: ").concat(i.lighten(e.brand,.05),"; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: ").concat(e.brand,";\n  opacity: 0.5;\n}\n    ")}(e),r=document.getElementById(o.default.WIDGET_CONTAINER_ID),a=document.createElement("style");a.id=o.default.WIDGET_CONFIG_COLORS_ID,a.type="text/css",t&&(a.nonce=t),a.appendChild(document.createTextNode(n)),r.appendChild(a)},i.isLoaded=function(){return!!document.getElementById(o.default.WIDGET_CONFIG_COLORS_ID)};var a=i;t.default=a,e.exports=t.default},26368:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475).internal.util.Cookie,o="ln",i={getCookieUsername:function(){return r.getCookie(o)},setUsernameCookie:function(e){r.setCookie(o,e,{expires:365,path:"/"})},removeUsernameCookie:function(){r.removeCookie(o,{path:"/"})}},a=i;t.default=a,e.exports=t.default},73390:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45091)),i=n(71244),a=r(n(52115)),s=r(n(53512)),l={getCountries:function(){var e=o.default.omit(a.default.country,"HM","BV","TF"),t=o.default.map(e,(function(e,t){return{name:e,code:t}}));t=o.default.sortBy(t,"name");var n={};return o.default.each(t,(function(e){n[e.code]=e.name})),n},getCountryCode:function(){var e=o.default.omit(a.default.country,"HM","BV","TF"),t=o.default.map(e,(function(e,t){return{name:e,code:t}}));t=o.default.sortBy(t,"name");var n={};return o.default.each(t,(function(e){n[e.code]=(0,i.loc)("country.option.label","login",[e.name,e.code])})),n},getCallingCodeForCountry:function(e){return s.default[e]}},u=l;t.default=u,e.exports=t.default},76587:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n={getStringHash:function(e){for(var t=5381,n=e.length;n;)t=33*t^e.charCodeAt(--n);return t>>>0},base64UrlSafeToBase64:function(e){return e.replace(new RegExp("_","g"),"/").replace(new RegExp("-","g"),"+")},binToStr:function(e){return btoa(new Uint8Array(e).reduce((function(e,t){return e+String.fromCharCode(t)}),""))},strToBin:function(e){return Uint8Array.from(atob(this.base64UrlSafeToBase64(e)),(function(e){return e.charCodeAt(0)}))}},r=n;t.default=r,e.exports=t.default},35546:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={API_RATE_LIMIT:3e4,WIDGET_LOGIN_CONTAINER_ID:"signin-container",WIDGET_CONTAINER_ID:"okta-sign-in",WIDGET_CONFIG_COLORS_ID:"okta-sign-in-config-colors",DIRECTION_BACK:"DIRECTION_BACK",RECOVERY_TYPE_PASSWORD:"PASSWORD",RECOVERY_TYPE_UNLOCK:"UNLOCK",RECOVERY_FACTOR_TYPE_SMS:"SMS",RECOVERY_FACTOR_TYPE_EMAIL:"EMAIL",RECOVERY_FACTOR_TYPE_CALL:"CALL",IOS:"ios",ANDROID:"android",ODA:"oda",MDM:"mdm",WS1:"ws1",SUCCESS:"SUCCESS",FORGOT_PASSWORD_EMAIL_SENT:"FORGOT_PASSWORD_EMAIL_SENT",UNLOCK_ACCOUNT_EMAIL_SENT:"UNLOCK_ACCOUNT_EMAIL_SENT",CONFIG_ERROR:"CONFIG_ERROR",UNSUPPORTED_BROWSER_ERROR:"UNSUPPORTED_BROWSER_ERROR",OAUTH_ERROR:"OAUTH_ERROR",AUTH_STOP_POLL_INITIATION_ERROR:"AUTH_STOP_POLL_INITIATION_ERROR",U2F_ERROR:"U2F_ERROR",WEB_AUTHN_ERROR:"WEB_AUTHN_ERROR",WEBAUTHN_ABORT_ERROR:"WEBAUTHN_ABORT_ERROR",CONFIGURED_FLOW_ERROR:"CONFIGURED_FLOW_ERROR",CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR:"CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR",ALL_OPTIONAL_NONE_ENROLLED:"ALL_OPTIONAL_NONE_ENROLLED",ALL_OPTIONAL_SOME_ENROLLED:"ALL_OPTIONAL_SOME_ENROLLED",HAS_REQUIRED_NONE_ENROLLED:"HAS_REQUIRED_NONE_ENROLLED",HAS_REQUIRED_SOME_REQUIRED_ENROLLED:"HAS_REQUIRED_SOME_REQUIRED_ENROLLED",HAS_REQUIRED_ALL_REQUIRED_ENROLLED:"HAS_REQUIRED_ALL_REQUIRED_ENROLLED",PRIMARY_AUTH:"PRIMARY_AUTH",FORGOT_PASSWORD:"FORGOT_PASSWORD",UNLOCK_ACCOUNT:"UNLOCK_ACCOUNT",SESSION_SSO:"SESSION_SSO",SESSION_STEP_UP:"SESSION_STEP_UP",ACTIVATION_EMAIL_SENT:"ACTIVATION_EMAIL_SENT",REGISTRATION_COMPLETE:"REGISTRATION_COMPLETE",REGISTRATION_FAILED:"REGISTRATION_FAILED",IDP_DISCOVERY:"IDP_DISCOVERY",OKTA_VERIFY_APPLE_APP_STORE_URL:"https://apps.apple.com/us/app/okta-verify/id490179405",OKTA_VERIFY_GOOGLE_PLAY_STORE_URL:"https://play.google.com/store/apps/details?id=com.okta.android.auth",LOOPBACK_CHALLENGE:"LOOPBACK",CUSTOM_URI_CHALLENGE:"CUSTOM_URI",UNIVERSAL_LINK_CHALLENGE:"UNIVERSAL_LINK",APP_LINK_CHALLENGE:"APP_LINK",CHROME_DTC:"CHROME_DTC"},e.exports=t.default},88882:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={INVALID_TOKEN_EXCEPTION:"E0000011"},e.exports=t.default},2645:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45091)),i=n(71244),a=r(n(30471)),s={},l={OKTA_VERIFY:{label:"factor.totpSoft.oktaVerify",description:"factor.totpSoft.description",iconClassName:"mfa-okta-verify",sortOrder:1},OKTA_VERIFY_PUSH:{label:"factor.oktaVerifyPush",description:"factor.push.description",iconClassName:"mfa-okta-verify",sortOrder:1},U2F:{label:"factor.u2f",description:function(e){return e?"factor.u2f.description.specific":"factor.u2f.description.generic"},iconClassName:"mfa-u2f",sortOrder:2},WEBAUTHN:{label:"factor.webauthn.biometric",description:"factor.webauthn.biometric.description",iconClassName:"mfa-webauthn",sortOrder:2},WINDOWS_HELLO:{label:"factor.windowsHello",description:function(e){return e?"factor.windowsHello.signin.description.specific":"factor.windowsHello.signin.description.generic"},iconClassName:"mfa-windows-hello",sortOrder:3},YUBIKEY:{label:"factor.totpHard.yubikey",description:"factor.totpHard.yubikey.description",iconClassName:"mfa-yubikey",sortOrder:4},GOOGLE_AUTH:{label:"factor.totpSoft.googleAuthenticator",description:"factor.totpSoft.description",iconClassName:"mfa-google-auth",sortOrder:5},CUSTOM_HOTP:{label:"",description:"factor.hotp.description",iconClassName:"mfa-hotp",sortOrder:6},SMS:{label:"factor.sms",description:"factor.sms.description",iconClassName:"mfa-okta-sms",sortOrder:7},CALL:{label:"factor.call",description:"factor.call.description",iconClassName:"mfa-okta-call",sortOrder:8},EMAIL:{label:"factor.email",description:"factor.email.description",iconClassName:"mfa-okta-email",sortOrder:9},QUESTION:{label:"factor.securityQuestion",description:"factor.securityQuestion.description",iconClassName:"mfa-okta-security-question",sortOrder:10},DUO:{label:"factor.duo",description:"factor.duo.description",iconClassName:"mfa-duo",sortOrder:11},SYMANTEC_VIP:{label:"factor.totpHard.symantecVip",description:"factor.totpHard.description",iconClassName:"mfa-symantec",sortOrder:12},RSA_SECURID:{label:"factor.totpHard.rsaSecurId",description:"factor.totpHard.description",iconClassName:"mfa-rsa",sortOrder:13},ON_PREM:{label:"",description:"factor.totpHard.description",iconClassName:"mfa-onprem",sortOrder:14},PASSWORD:{label:"factor.password",description:"",iconClassName:"mfa-okta-password",sortOrder:15},CUSTOM_CLAIMS:{label:"",description:"factor.customFactor.description",iconClassName:"mfa-custom-factor",sortOrder:16},GENERIC_SAML:{label:"",description:function(e){return e?"factor.customFactor.description.specific":"factor.customFactor.description.generic"},iconClassName:"mfa-custom-factor",sortOrder:17},GENERIC_OIDC:{label:"",description:function(e){return e?"factor.customFactor.description.specific":"factor.customFactor.description.generic"},iconClassName:"mfa-custom-factor",sortOrder:18}},u=function(e,t,n){var r={complexity:[],history:[],age:[]};r.complexity=function(e,t){if(e.complexity){var n=t.complexity,r=function(e){var t=e.excludeAttributes;return e.excludeFirstName=o.default.contains(t,"firstName"),e.excludeLastName=o.default.contains(t,"lastName"),o.default.omit(e,"excludeAttributes")}(e.complexity),a=r;r.useADComplexityRequirements&&(a=o.default.pick(r,["minLength","useADComplexityRequirements","excludeUsername","excludeFirstName","excludeLastName","excludeAttributes"]));var s=o.default.map(a,(function(e,t){if(!(e<=0)){var r=n[t];return r.args?(0,i.loc)(r.i18n,"login",[e]):(0,i.loc)(r.i18n,"login")}}));return o.default.compact(s)}return[]}(e,t);var s=function(e,t,n){return e.age&&e.age.historyCount>0?n?1===e.age.historyCount?(0,i.loc)(t.history.one.i18n,"login"):(0,i.loc)(t.history.many.i18n,"login",[e.age.historyCount]):(0,i.loc)(t.history.i18n,"login",[e.age.historyCount]):null}(e,t,n);s&&r.history.push(s);var l=function(e,t){return e.age&&e.age.minAgeMinutes>0?function(e){var n;switch(e.unit){case"DAY":n=t.age.days.i18n;break;case"HOUR":n=t.age.hours.i18n;break;case"MINUTE":n=t.age.minutes.i18n}return(0,i.loc)(n,"login",[e.time])}(a.default.getTimeInHighestRelevantUnit(e.age.minAgeMinutes,"MINUTE")):null}(e,t);return l&&r.age.push(l),r};s.getFactorName=function(e,t){return"OKTA"===e&&"token:software:totp"===t?"OKTA_VERIFY":"OKTA"===e&&"push"===t?"OKTA_VERIFY_PUSH":"GOOGLE"===e?"GOOGLE_AUTH":"SYMANTEC"===e&&"token"===t?"SYMANTEC_VIP":"RSA"===e&&"token"===t?"RSA_SECURID":"DEL_OATH"===e&&"token"===t?"ON_PREM":"DUO"===e&&"web"===t?"DUO":"YUBICO"===e&&"token:hardware"===t?"YUBIKEY":"OKTA"===e&&"sms"===t?"SMS":"OKTA"===e&&"call"===t?"CALL":"OKTA"===e&&"question"===t?"QUESTION":"OKTA"===e&&"email"===t?"EMAIL":"OKTA"===e&&"password"===t?"PASSWORD":"GENERIC_SAML"===e&&"assertion:saml2"===t?"GENERIC_SAML":"GENERIC_OIDC"===e&&"assertion:oidc"===t?"GENERIC_OIDC":s.getFactorNameForFactorType.call(this,t)},s.getFactorNameForFactorType=function(e){return"u2f"===e?"U2F":"token:software:totp"===e?"OKTA_VERIFY":"webauthn"===e?this.settings.get("features.webauthn")?"WEBAUTHN":"WINDOWS_HELLO":"token:hotp"===e?"CUSTOM_HOTP":"claims_provider"===e?"CUSTOM_CLAIMS":void 0},s.isOktaVerify=function(e,t){return"OKTA"===e&&("token:software:totp"===t||"push"===t)},s.getFactorLabel=function(e,t){var n=l[s.getFactorName.apply(this,[e,t])].label;return(0,i.loc)(n,"login")},s.getFactorDescription=function(e,t){var n=l[s.getFactorName.apply(this,[e,t])].description;if(o.default.isFunction(n)){var r=this.settings.get("brandName"),a=n(r);return r?(0,i.loc)(a,"login",[r]):(0,i.loc)(a,"login")}return n?(0,i.loc)(n,"login"):""},s.getFactorIconClassName=function(e,t){return l[s.getFactorName.apply(this,[e,t])].iconClassName},s.getFactorSortOrder=function(e,t){return l[s.getFactorName.apply(this,[e,t])].sortOrder},s.getRememberDeviceValue=function(e){return e&&e.get("rememberDeviceByDefault")},s.getSecurityQuestionLabel=function(e){var t=(0,i.loc)("security."+e.question);return t.indexOf("L10N_ERROR")<0?t:e.questionText},s.removeRequirementsFromError=function(e,t){var n=this.getPasswordComplexityDescription(t);return e.errorCauses&&e.errorCauses.length>0&&o.default.isString(e.errorCauses[0].errorSummary)&&(e.errorCauses[0].errorSummary=e.errorCauses[0].errorSummary.replace(n,"").trim()),e},s.getPasswordComplexityDescriptionForHtmlList=function(e){var t=u(e,{complexity:{minLength:{i18n:"password.complexity.length.description",args:!0},minLowerCase:{i18n:"password.complexity.lowercase.description"},minUpperCase:{i18n:"password.complexity.uppercase.description"},minNumber:{i18n:"password.complexity.number.description"},minSymbol:{i18n:"password.complexity.symbol.description"},excludeUsername:{i18n:"password.complexity.no_username.description"},excludeFirstName:{i18n:"password.complexity.no_first_name.description"},excludeLastName:{i18n:"password.complexity.no_last_name.description"},useADComplexityRequirements:{i18n:"password.complexity.adRequirements.description"},maxConsecutiveRepeatingCharacters:{i18n:"password.complexity.maxConsecutiveRepeatingCharacters.description",args:!0}},history:{one:{i18n:"password.complexity.history.one.description"},many:{i18n:"password.complexity.history.description"}},age:{minutes:{i18n:"password.complexity.minAgeMinutes.description"},hours:{i18n:"password.complexity.minAgeHours.description"},days:{i18n:"password.complexity.minAgeDays.description"}}},!0);return o.default.union(t.complexity,t.history,t.age)},s.getPasswordComplexityDescription=function(e){var t=[],n=u(e,{complexity:{minLength:{i18n:"password.complexity.length",args:!0},minLowerCase:{i18n:"password.complexity.lowercase"},minUpperCase:{i18n:"password.complexity.uppercase"},minNumber:{i18n:"password.complexity.number"},minSymbol:{i18n:"password.complexity.symbol"},excludeUsername:{i18n:"password.complexity.no_username"},excludeFirstName:{i18n:"password.complexity.no_first_name"},excludeLastName:{i18n:"password.complexity.no_last_name"},useADComplexityRequirements:{i18n:"password.complexity.adRequirements"},maxConsecutiveRepeatingCharacters:{i18n:"password.complexity.maxConsecutiveRepeatingCharacters",args:!0}},history:{i18n:"password.complexity.history"},age:{minutes:{i18n:"password.complexity.minAgeMinutes"},hours:{i18n:"password.complexity.minAgeHours"},days:{i18n:"password.complexity.minAgeDays"}}},!1),r=n.complexity;return r.length>0&&(r=o.default.reduce(r,(function(e,t){return e?e+(0,i.loc)("password.complexity.list.element","login",[t]):t})),t.push((0,i.loc)("password.complexity.requirements","login",[r]))),t.push(n.history[0]),t.push(n.age[0]),o.default.compact(t).join(" ")},s.getCardinalityText=function(e,t,n){if(n){if(e)return 1===n.enrolled?"":(0,i.loc)("enroll.choices.cardinality.setup","login",[n.enrolled]);if(t&&n.maximum>1)return(0,i.loc)("enroll.choices.cardinality.setup.remaining","login",[n.enrolled,n.minimum])}return""},s.findFactorInFactorsArray=function(e,t,n){var r=e.findWhere({provider:t,factorType:n});return void 0===r&&(r=e.findWhere({factorType:n})),r};var c=s;t.default=c,e.exports=t.default},14726:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(71244),o={getU2fEnrollErrorMessageKeyByCode:function(e){switch(e){default:case 1:return"u2f.error.other";case 2:case 3:return"u2f.error.badRequest";case 4:return"u2f.error.unsupported";case 5:return"u2f.error.timeout"}},getU2fVerifyErrorMessageKeyByCode:function(e,t){switch(e){case 1:return t?"u2f.error.other.oneFactor":"u2f.error.other";case 2:case 3:return t?"u2f.error.badRequest.oneFactor":"u2f.error.badRequest";case 4:return t?"u2f.error.unsupported.oneFactor":"u2f.error.unsupported";case 5:return"u2f.error.timeout"}},getU2fEnrollErrorMessageByCode:function(e){return(0,r.loc)(o.getU2fEnrollErrorMessageKeyByCode(e),"login")},getU2fVerifyErrorMessageByCode:function(e,t){return(0,r.loc)(o.getU2fVerifyErrorMessageKeyByCode(e,t),"login")},getU2fVersion:function(){return"U2F_V2"},isU2fAvailable:function(){return Object.prototype.hasOwnProperty.call(window,"u2f")}},i=o;t.default=i,e.exports=t.default},53736:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.executeHookFunctions=a,t.executeHooksAfter=function(e){return u.apply(this,arguments)},t.executeHooksBefore=function(e){return l.apply(this,arguments)},t.mergeHook=function(e,t,n){var r=e[t]=e[t]||{before:[],after:[]};n.before&&(r.before=(r.before||[]).concat(n.before));n.after&&(r.after=(r.after||[]).concat(n.after))};var o=r(n(70232)),i=r(n(31049));function a(e){return s.apply(this,arguments)}function s(){return(s=(0,i.default)(o.default.mark((function e(t){var n;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:n=0;case 1:if(!(n<t.length)){e.next=7;break}return e.next=4,t[n]();case 4:n++,e.next=1;break;case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function l(){return(l=(0,i.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t&&t.before&&t.before.length){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,a(t.before);case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function u(){return(u=(0,i.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t&&t.after&&t.after.length){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,a(t.after);case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},78719:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n={SUPPORTED_SOCIAL_IDPS:["facebook","google","linkedin","microsoft","apple","github","gitlab","yahoo","line","paypal","paypal_sandbox","salesforce","amazon","yahoojp","discord","adobe","orcid","spotify","xero","quickbooks"]};t.default=n,e.exports=t.default},36894:function(e,t){"use strict";function n(e,t){var n,r,o;("error"===e||null!==(n=window)&&void 0!==n&&null!==(r=n.OktaSignInDebug)&&void 0!==r&&null!==(o=r.isEnabled)&&void 0!==o&&o.call(r))&&window.console[e].apply(window.console,t)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r={trace:function(){return n("trace",arguments)},dir:function(){return n("dir",arguments)},time:function(){return n("time",arguments)},timeEnd:function(){return n("timeEnd",arguments)},group:function(){return n("group",arguments)},groupEnd:function(){return n("groupEnd",arguments)},assert:function(){return n("assert",arguments)},log:function(){return n("log",arguments)},info:function(){return n("info",arguments)},warn:function(){return n("warn",arguments)},error:function(){return n("error",arguments)},deprecate:function(e){return n("warn",["[okta-signin-widget] DEPRECATED:",e])}};t.default=r,e.exports=t.default},97329:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45091)),i=n(71244),a=r(n(35546)),s=n(45570),l=r(n(90570)),u={},c=["responseType","scopes","state","nonce","idp","idpScope","display","prompt","maxAge","loginHint"];u.AUTH_PARAMS=c,u.getTokens=function(e,t,n){function r(t){e.callGlobalSuccess(a.default.SUCCESS,t)}function u(t){var r=(0,s.getTypedOAuthError)(t);r.is("terminal")?(n.model.appState.set("flashError",r),n.model.appState.trigger("navigate","signin/error")):r.is("inline")&&(n.model.trigger("error",n.model,{responseJSON:{errorSummary:r.errorDetails.errorSummary}}),n.model.appState.trigger("removeLoading")),r.is("terminal")||l.default.triggerAfterError(n,r,e),r instanceof s.NonRecoverableError&&e.callGlobalError(r)}var d=e.getAuthClient(),f=d.isAuthorizationCodeFlow()&&!d.isPKCE(),p=e.toJSON({verbose:!0}),h={};o.default.extend(h,o.default.pick(p,"clientId","redirectUri"),o.default.pick(p.authParams,c),t),h.popupTitle=(0,i.loc)("socialauth.popup.title","login"),h.timeout=p.oAuthTimeout,"always"===p.redirect||f?d.token.getWithRedirect(h).catch(u):h.sessionToken?d.token.getWithoutPrompt(h).then(r).catch(u):(p.initialPopupPath&&(h.initialPath=p.initialPopupPath),d.token.getWithPopup(h).then(r).catch(u))};var d=u;t.default=d,e.exports=t.default},30471:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(72284)),a=r(n(67820)),s={MILLISECOND:"milliseconds",SECOND:"seconds",MINUTE:"minutes",HOUR:"hours",DAY:"days"},l=Object.keys(s),u={getTimeInHighestRelevantUnit:function(e,t){var n,r=s[t]||t;try{var u=(0,i.default)(Object.assign({days:0,hours:0,minutes:0,seconds:0,milliseconds:0},(0,o.default)({},r,e)));n=(0,a.default)(u)}catch(e){n={}}var c,d,f,p,h=Object.keys(n).reduce((function(e,t){return 0!==n[t]&&(e[t]=n[t]),e}),{});return 1===Object.keys(h).length?Object.keys(h).forEach((function(e){d=h[e],c=e})):(d=e,c=r),{time:d,unit:(f=c,p=l.filter((function(e){return s[e]===f})),1===p.length?p[0]:f)}},formatDateToDeviceAssuranceGracePeriodExpiryLocaleString:function(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];try{if(!(e instanceof Date)||isNaN(e.valueOf()))return null;if(null===t)return null;n&&e.setMinutes(0,0,0);var r={year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",timeZoneName:"short"};return e.toLocaleString(t,r)}catch(e){return null}},calculateDaysBetween:function(e,t){try{if("number"==typeof e&&"number"==typeof t){var n=Math.abs(t-e);return Math.floor(n/864e5)}}catch(e){}return null}};t.default=u,e.exports=t.default},90570:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(45091)),a=n(71244),s=r(n(35546)),l=r(n(36894)),u=r(n(34425)),c={},d=function(e,t){var n=document.createElement("input");return n.name=e,n.value=decodeURIComponent(t),n.type="hidden",n},f=function(){var e=document.createElement("input");return e.type="submit",e},p=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0,n=e.split("#"),r=n[1],o=(n[0]||"").split("?"),i=o[1],a=o[0];r&&(a+="#"+r);var s=document.createElement("form");if(s.method=t,s.style.display="none",s.action=a,i&&i.length){var l=i.split("&");l.forEach((function(e){var t=e.split("="),n=d(t[0],t[1]);s.appendChild(n)}))}return s.appendChild(f()),s};function h(e){for(var t=[e],n=e.split("-");n.pop()&&n.length>0;)t.push(n.join("-"));return t}c.transformErrorXHR=function(e){if(0===e.status&&i.default.isEmpty(e.responseJSON))return e.responseJSON={errorSummary:(0,a.loc)("error.network.connection","login")},e;if(!e.responseJSON){if(!e.responseText)return e.responseJSON={errorSummary:(0,a.loc)("error.unsupported.response","login")},e;if("string"==typeof e.responseText)try{e.responseJSON=JSON.parse(e.responseText)}catch(t){return e.responseJSON={errorSummary:(0,a.loc)("error.unsupported.response","login")},e}else"object"===(0,o.default)(e.responseText)&&(e.responseJSON=e.responseText)}if(e.responseJSON&&e.responseJSON.errorCauses&&e.responseJSON.errorCauses.length&&(e.responseJSON.errorSummary=e.responseJSON.errorCauses[0].errorSummary),!i.default.isEmpty(e.responseJSON)){var t=e.responseJSON.errorCode,n=t&&(0,a.doesTranslationExist)("errors."+t,"login")?(0,a.loc)("errors."+t,"login",[],!0):void 0;-1===(null==n?void 0:n.indexOf("L10N_ERROR["))&&(e.responseJSON.errorSummary=n,e.responseJSON&&e.responseJSON.errorCauses&&e.responseJSON.errorCauses.length&&delete e.responseJSON.errorCauses)}return e},c.toLower=function(e){return i.default.map(e,(function(e){return e.toLowerCase()}))},c.expandLanguages=function(e){return i.default.chain(e).map(h).flatten().uniq().value()},c.callAfterTimeout=function(e,t){return setTimeout(e,t)},c.callAfterTimeoutOrWindowRefocus=function(e,t){var n,r,o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=function(){if(document.removeEventListener("visibilitychange",r),!o)return e();setTimeout(e,t)};return r=function(){document.hidden?clearTimeout(n):i()},document.addEventListener("visibilitychange",r),n=setTimeout(i,t),function(){clearTimeout(n),document.removeEventListener("visibilitychange",r)}},c.debugMessage=function(e){l.default.warn("\n".concat(e.replace(/^(\s)+/gm,"")))},c.logConsoleError=function(e){l.default.error(e)},c.triggerAfterError=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!t.statusCode&&t.xhr&&t.xhr.status&&(t.statusCode=t.xhr.status);var n=i.default.isFunction(e.className)?e.className():e.className,r=i.default.pick(t,"name","message","statusCode","xhr");e.trigger("afterError",{controller:n},r),l.default.warn("controller: "+n+", error: "+r)},c.redirect=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window,n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];u.default.isAndroid()&&!n?c.redirectWithFormGet(e):c.changeLocation(e,t)},c.changeLocation=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window;e?t.location.href=e:l.default.error("Cannot redirect to empty URL: (".concat(e,")"))},c.executeOnVisiblePage=function(e){if("hidden"===document.visibilityState){document.addEventListener("visibilitychange",(function t(){"visible"===document.visibilityState&&(document.removeEventListener("visibilitychange",t),e())}))}else e()},c.redirectWithFormGet=function(e){c.redirectWithForm(e,"get")};var m=!1;c.getRedirectWithFormLock=function(){return m},c.setRedirectWithFormLock=function(){m=!0},c.redirectWithForm=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"post";if(e)if(!0!==c.getRedirectWithFormLock()){var n=document.getElementById(s.default.WIDGET_CONTAINER_ID);if(n){c.setRedirectWithFormLock();var r=p(e,t);n.appendChild(r),r.querySelector('input[type="submit"]').click()}else l.default.error("Cannot find okta-sign-in container append to which a form")}else l.default.error("Cannot redirect with form, already in progress");else l.default.error("Cannot redirect to empty URL: (".concat(e,")"))},c.createInputExplain=function(e,t,n,r,o){var i=r?(0,a.loc)(e,n,r):(0,a.loc)(e,n);return i!==(o?(0,a.loc)(t,n,o):(0,a.loc)(t,n))&&i},c.isV1StateToken=function(e){return!!(e&&i.default.isString(e)&&e.startsWith("00"))},c.getAutocompleteValue=function(e,t){return(null==e?void 0:e.get("features.disableAutocomplete"))?"off":t},c.searchParamsToString=function(e){return Object.keys(e).filter((function(t){var n=e[t];return null!=n})).map((function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])})).join("&")};var v=c;t.default=v,e.exports=t.default},53512:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={US:"1",AG:"1",AI:"1",AS:"1",BB:"1",BM:"1",BS:"1",CA:"1",DM:"1",DO:"1",GD:"1",GU:"1",JM:"1",KN:"1",KY:"1",LC:"1",MP:"1",MS:"1",PR:"1",SX:"1",TC:"1",TT:"1",VC:"1",VG:"1",VI:"1",RU:"7",KZ:"7",EG:"20",ZA:"27",GR:"30",NL:"31",BE:"32",FR:"33",ES:"34",HU:"36",IT:"39",VA:"39",RO:"40",CH:"41",AT:"43",GB:"44",GG:"44",IM:"44",JE:"44",DK:"45",SE:"46",NO:"47",SJ:"47",PL:"48",DE:"49",PE:"51",MX:"52",CU:"53",AR:"54",BR:"55",CL:"56",CO:"57",VE:"58",MY:"60",AU:"61",CC:"61",CX:"61",ID:"62",PH:"63",NZ:"64",SG:"65",TH:"66",JP:"81",KR:"82",VN:"84",CN:"86",TR:"90",IN:"91",PK:"92",AF:"93",LK:"94",MM:"95",IR:"98",SS:"211",MA:"212",EH:"212",DZ:"213",TN:"216",LY:"218",GM:"220",SN:"221",MR:"222",ML:"223",GN:"224",CI:"225",BF:"226",NE:"227",TG:"228",BJ:"229",MU:"230",LR:"231",SL:"232",GH:"233",NG:"234",TD:"235",CF:"236",CM:"237",CV:"238",ST:"239",GQ:"240",GA:"241",CG:"242",CD:"243",AO:"244",GW:"245",IO:"246",AC:"247",SC:"248",SD:"249",RW:"250",ET:"251",SO:"252",DJ:"253",KE:"254",TZ:"255",UG:"256",BI:"257",MZ:"258",ZM:"260",MG:"261",RE:"262",YT:"262",ZW:"263",NA:"264",MW:"265",LS:"266",BW:"267",SZ:"268",KM:"269",SH:"290",TA:"290",ER:"291",AW:"297",FO:"298",GL:"299",GI:"350",PT:"351",LU:"352",IE:"353",IS:"354",AL:"355",MT:"356",CY:"357",FI:"358",AX:"358",BG:"359",LT:"370",LV:"371",EE:"372",MD:"373",AM:"374",BY:"375",AD:"376",MC:"377",SM:"378",UA:"380",RS:"381",ME:"382",XK:"383",HR:"385",SI:"386",BA:"387",MK:"389",CZ:"420",SK:"421",LI:"423",FK:"500",BZ:"501",GT:"502",SV:"503",HN:"504",NI:"505",CR:"506",PA:"507",PM:"508",HT:"509",GP:"590",BL:"590",MF:"590",BO:"591",GY:"592",EC:"593",GF:"594",PY:"595",MQ:"596",SR:"597",UY:"598",CW:"599",BQ:"599",TL:"670",NF:"672",BN:"673",NR:"674",PG:"675",TO:"676",SB:"677",VU:"678",FJ:"679",PW:"680",WF:"681",CK:"682",NU:"683",WS:"685",KI:"686",NC:"687",TV:"688",PF:"689",TK:"690",FM:"691",MH:"692","001":"979",KP:"850",HK:"852",MO:"853",KH:"855",LA:"856",BD:"880",TW:"886",MV:"960",LB:"961",JO:"962",SY:"963",IQ:"964",KW:"965",SA:"966",YE:"967",OM:"968",PS:"970",AE:"971",IL:"972",BH:"973",QA:"974",BT:"975",MN:"976",NP:"977",TJ:"992",TM:"993",AZ:"994",GE:"995",KG:"996",UZ:"998",GS:"500",PN:"64",AQ:"672",UM:"1",AN:"599"},e.exports=t.default},49268:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31049)),a=r(n(6321)),s=r(n(14726));function l(e){return new a.default(e)}var u,c={makeCredential:function(e,t,n){return t=t.map((function(e){return{type:"FIDO_2_0",algorithm:e.algorithm}})),l(window.msCredentials.makeCredential(e,t,n).then((function(e){return Object.freeze({credential:{id:e.id},publicKey:JSON.parse(e.publicKey),attestation:e.attestation})})))},getAssertion:function(e,t){var n={accept:t.map((function(e){return{type:"FIDO_2_0",id:e.id}}))};return l(window.msCredentials.getAssertion(e,n).then((function(e){var t=e.signature;return Object.freeze({credential:{id:e.id},clientData:t.clientData,authenticatorData:t.authnrData,signature:t.signature})})))},processWebAuthnResponse:function(e,t){if(void 0===e)return null;var n=e.apply(t);return null==n?null:JSON.stringify(n)},isAvailable:function(){return Object.prototype.hasOwnProperty.call(window,"msCredentials")},isNewApiAvailable:function(){return navigator&&navigator.credentials&&navigator.credentials.create},isWebauthnOrU2fAvailable:function(){return this.isNewApiAvailable()||s.default.isU2fAvailable()},isConditionalMediationAvailable:function(){return"undefined"!=typeof PublicKeyCredential&&void 0!==PublicKeyCredential.isConditionalMediationAvailable},isPasskeyAutofillAvailable:(u=(0,i.default)(o.default.mark((function e(){var t;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=!1,!this.isConditionalMediationAvailable()){e.next=5;break}return e.next=4,PublicKeyCredential.isConditionalMediationAvailable();case 4:t=e.sent;case 5:return e.abrupt("return",t);case 6:case"end":return e.stop()}}),e,this)}))),function(){return u.apply(this,arguments)}),isPasskeyAvailable:function(){var e,t=(null===(e=navigator)||void 0===e?void 0:e.credentials)||{};return"undefined"!=typeof PublicKeyCredential&&"function"==typeof t.get&&"function"==typeof t.create},isRelyingPartyIdMismatchError:function(e){return"SecurityError"===(null==e?void 0:e.name)&&18===(null==e?void 0:e.code)},isAbortError:function(e){return"AbortError"===(null==e?void 0:e.name)&&20===(null==e?void 0:e.code)},isNotAllowedError:function(e){return"NotAllowedError"===(null==e?void 0:e.name)&&0===(null==e?void 0:e.code)}};t.default=c,e.exports=t.default},67934:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(58346)),a=r(n(27447)),s=r(n(52115)),l=r(n(36894)),u=r(n(84757)),c=r(n(4449)),d=r(n(94164)),f=r(n(66757)),p=r(n(34425)),h=r(n(28766)),m=r(n(35546)),v=n(13671),g=r(n(39409)),y=r(n(90570)),b=n(19838);var w=o.Router.extend({Events:o.Backbone.Events,initialize:function(e){e.globalSuccessFn||(e.globalSuccessFn=function(){}),e.globalErrorFn||(e.globalErrorFn=function(e){l.default.error(e)}),this.settings=new a.default(o._.omit(e,"el"),{parse:!0}),e.el||this.settings.callGlobalError(new v.ConfigError((0,o.loc)("error.required.el"))),(0,o.$)("body > div").on("click",(function(){})),this.appState=new i.default({baseUrl:this.settings.get("baseUrl"),settings:this.settings},{parse:!0});var t=new u.default({appState:this.appState});(0,o.$)(e.el).append(t.render().$el),this.el="#".concat(m.default.WIDGET_CONTAINER_ID),this.header=new c.default({el:this.el,appState:this.appState,settings:this.settings}),this.hide(),this.listenTo(this.appState,"change:transactionError",(function(e,t){g.default.routeAfterAuthStatusChangeError(this,t)})),this.listenTo(this.appState,"change:transaction",(function(e,t){g.default.routeAfterAuthStatusChange(this,t.data)})),this.listenTo(this.appState,"navigate",(function(e){this.navigate(e,{trigger:!0})}))},execute:function(e,t){var n=this.settings.get("recoveryToken");if(n)return this.settings.unset("recoveryToken"),void this.navigate(g.default.createRecoveryUrl(n),{trigger:!0});var r=this.settings.get("stateToken");if(r)return this.settings.unset("stateToken"),void this.navigate(g.default.createRefreshUrl(r),{trigger:!0});var i,a,s=this.appState.get("transaction");s&&s.data||(i=this,a=e,o._.find(i.stateLessRouteHandlers,(function(e){return a===i[e]})))?e.apply(this,t):this.settings.getAuthClient().tx.exists()?this.navigate(g.default.createRefreshUrl(),{trigger:!0}):this.navigate("",{trigger:!0})},navigate:function(e,t){return this.settings.get("features.router")?o.Router.prototype.navigate.apply(this,arguments):t&&t.trigger?o.Backbone.history.loadUrl(e):void 0},render:function(e,t){var n=this;t||(t={});var r=t.Beacon,i=o._.extend({settings:this.settings,appState:this.appState},o._.omit(t,"Beacon"));if(this.header.rendered()||(this.el=this.header.render().getContentEl()),!s.default.isLoaded(this.appState.get("languageCode")))return(0,b.loadLanguage)(this.appState,this.settings).then(o._.bind(this.render,this,e,t));if(this.settings.get("colors.brand")&&!h.default.isLoaded()){var a={brand:this.settings.get("colors.brand")},l=this.settings.get("cspNonce");h.default.addStyle(a,l)}var u=this.controller;return this.controller=new e(i),this.listenTo(this.controller,"all",this.trigger),this.controller.fetchInitialData().then((function(){return function(e,t){return!!e&&(e!==d.default||t.get("features.securityImage"))}(r,n.settings)||(r=null),n.header.setBeacon(r,i),n.show(),n.controller.render(),u?f.default.swapPages({$parent:n.el,$oldRoot:u.$el,$newRoot:n.controller.$el,dir:u.state.get("navigateDir"),ctx:n,success:function(){var e,t=this.appState.get("flashError"),n=this.controller.model;(u.remove(),u.$el.remove(),this.controller.postRenderAnimation(),t)&&(e=t.is&&t.is("terminal")?t.errorDetails.errorSummary:(0,o.loc)(this.settings.get("features.mfaOnlyFlow")?"error.mfa.only.expired.session":"error.expired.session"),n.trigger("error",n,{responseJSON:{errorSummary:e}}),this.appState.unset("flashError"),y.default.triggerAfterError(this.controller,t))}}):(n.el.append(n.controller.el),void n.controller.postRenderAnimation())})).catch((function(){u&&(u.remove(),u.$el.remove())}))},start:function(){var e=this,t=!1;window.addEventListener&&this.settings.get("features.router")&&(window.addEventListener("popstate",(function(t){e.controller.back&&(t.preventDefault(),t.stopImmediatePropagation(),e.controller.back())})),t=p.default.supportsPushState()),o.Router.prototype.start.call(this,{pushState:t})},hide:function(){this.header.$el.hide()},show:function(){this.header.$el.show()},remove:function(){this.controller&&this.controller.remove(),this.header.$el.remove(),s.default.remove(),o.Backbone.history.stop()}});t.default=w,e.exports=t.default},45385:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(35546)),a=r(n(73650)),s=r(n(39694)),l=a.default.extend({className:"account-unlocked",Model:function(){return{local:{userFullName:["string",!1,this.options.appState.get("userFullName")]}}},Form:{title:o._.partial(o.loc,"account.unlock.unlocked.title","login"),subtitle:o._.partial(o.loc,"account.unlock.unlocked.desc","login"),noButtonBar:!0,attributes:{"data-se":"account-unlocked"},formChildren:function(){return[s.default.Button({title:(0,o.loc)("goback","login"),className:"button button-primary button-wide",attributes:{"data-se":"back-button"},click:function(){this.state.set("navigateDir",i.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}})]}}});t.default=l,e.exports=t.default},91939:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(73650)),i=r(n(21304)),a=r(n(68457)),s=o.default.extend({className:"activate-totp",Model:function(){return{props:{factorId:["string",!0,this.options.appState.get("activatedFactorId")],passCode:["string",!0]},local:{__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]},save:function(){return this.doTransaction((function(e){return e.activate({passCode:this.get("passCode")})}))}}},Form:i.default,Footer:a.default});t.default=s,e.exports=t.default},61525:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(29531)),l=r(n(91482)),u={props:{scopes:["array",!0]},save:function(){return this.doTransaction((function(e){return e.consent({consent:{scopes:o._.pluck(this.get("scopes"),"name")}})}))},cancel:function(){var e=this;return this.doTransaction((function(e){return e.cancel()})).then((function(){var t=e.settings.get("consent.cancel");o._.isFunction(t)&&t()}))}},c=o.View.extend({className:"consent-title detail-row",template:l.default,getTemplateData:function(){var e=this.options.appState;return{appName:e.escape("targetLabel"),customLogo:e.get("targetLogo")&&e.get("targetLogo").href,defaultLogo:e.get("defaultAppLogo"),clientURI:e.get("targetClientURI")&&e.get("targetClientURI").href,issuer:e.get("issuer")}}}),d={noCancelButton:!1,buttonOrder:["cancel","save"],autoSave:!0,save:o._.partial(o.loc,"consent.required.consentButton","login"),cancel:o._.partial(o.loc,"consent.required.cancelButton","login"),formChildren:[a.default.View({View:c}),a.default.View({View:s.default})]},f=i.default.extend({Model:u,Form:d,className:"admin-consent-required",initialize:function(){var e=this;this.model.set("scopes",this.options.appState.get("scopes")),this.listenTo(this.form,"cancel",(function(){e.model.cancel()}))}});t.default=f,e.exports=t.default},24687:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(39694)),l=r(n(34361)),u=r(n(68457)),c=a.default.extend({className:"barcode-push",Model:function(){return{local:{__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]}}},Form:{title:function(){var e=i.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,o.loc)("enroll.totp.title","login",[e])},noButtonBar:!0,attributes:{"data-se":"step-scan"},className:"barcode-scan",initialize:function(){this.listenTo(this.model,"error errors:clear",(function(){this.clearErrors()}))},formChildren:[s.default.View({View:l.default})]},Footer:u.default,initialize:function(){this.pollForEnrollment().catch((function(){}))},pollForEnrollment:function(){return this.model.doTransaction((function(e){return e.poll(6e3)}))},trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return!0}});t.default=c,e.exports=t.default},98318:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(39694)),l=r(n(39409)),u=r(n(34361)),c=r(n(68457)),d=a.default.extend({className:"barcode-totp",Model:function(){return{local:{__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]}}},Form:{title:function(){var e=i.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,o.loc)("enroll.totp.title","login",[e])},save:o._.partial(o.loc,"oform.next","login"),noCancelButton:!0,attributes:{"data-se":"step-scan"},className:"barcode-scan",formChildren:[s.default.View({View:u.default})]},Footer:c.default,initialize:function(){this.listenTo(this.form,"save",(function(){var e=l.default.createActivateFactorUrl(this.model.get("__provider__"),this.model.get("__factorType__"),"activate");this.options.appState.trigger("navigate",e)}))}});t.default=d,e.exports=t.default},93100:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(73650)),l=r(n(39694)),u=r(n(99629)),c=r(n(27008)),d=r(n(26069)),f=r(n(91482)),p=o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"clientURI")||(null!=t?a(t,"clientURI"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"clientURI",hash:{},data:o,loc:{start:{line:1,column:26},end:{line:1,column:39}}}):i)+'" class="client-logo-link" target="_blank">'},3:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo custom-logo" src="'+l("function"==typeof(i=null!=(i=u(n,"customLogo")||(null!=t?u(t,"customLogo"):t))?i:s)?i.call(a,{name:"customLogo",hash:{},data:o,loc:{start:{line:1,column:149},end:{line:1,column:163}}}):i)+'" alt="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"common.logo.alt"},data:o,loc:{start:{line:1,column:170},end:{line:1,column:216}}}))+'" aria-hidden="true" />'},5:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo default-logo" src="'+l("function"==typeof(i=null!=(i=u(n,"defaultLogo")||(null!=t?u(t,"defaultLogo"):t))?i:s)?i.call(a,{name:"defaultLogo",hash:{},data:o,loc:{start:{line:1,column:290},end:{line:1,column:305}}}):i)+'" alt="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"common.logo.alt"},data:o,loc:{start:{line:1,column:312},end:{line:1,column:358}}}))+'" aria-hidden="true" />'},7:function(e,t,n,r,o){return"</a>"},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="issuer"><span>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"issuer")||(null!=t?a(t,"issuer"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"issuer",hash:{},data:o,loc:{start:{line:1,column:624},end:{line:1,column:634}}}):i)+"</span></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:89}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"customLogo"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.program(5,o,0),data:o,loc:{start:{line:1,column:89},end:{line:1,column:388}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:388},end:{line:1,column:416}}}))?i:"")+'<h1><span class="title-text">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{$2:"<p>$2</p>",$1:"<b class='no-translate'>$1</b>",arguments:"appName",bundle:"login",code:"granular.consent.scopes.title"},data:o,loc:{start:{line:1,column:445},end:{line:1,column:577}}}))+"</span>"+(null!=(i=s(n,"if").call(a,null!=t?s(t,"issuer"):t,{name:"if",hash:{},fn:e.program(9,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:584},end:{line:1,column:654}}}))?i:"")+"</h1>"},useData:!0}),h=function(e){return l.default.View({View:i.View.extend({className:"consent-title detail-row",template:e,getTemplateData:function(){var e=this.options.appState;return{appName:e.escape("targetLabel"),customLogo:e.get("targetLogo")&&e.get("targetLogo").href,defaultLogo:e.get("defaultAppLogo"),clientURI:e.get("targetClientURI")&&e.get("targetClientURI").href}}})})},m=l.default.View({View:i.View.extend({className:"consent-description detail-row",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"consent.required.description"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:62}}}))+"</p>"},useData:!0})})}),v=l.default.View({View:i.View.extend({className:"consent-description",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"granular.consent.scopes.description"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:69}}}))+"</p>"},useData:!0})})}),g=function(e){return"optional"in e.get("scopes")[0]},y=s.default.extend({className:"consent-required",initialize:function(){var e=this;this.model.set("expiresAt",this.options.appState.get("expiresAt")),this.model.set("scopes",this.options.appState.get("scopes")),this.listenTo(this.form,"cancel",i._.bind(this.model.cancel,this.model));var t=new d.default;(0,i.$)("#".concat(a.default.WIDGET_LOGIN_CONTAINER_ID)).prepend(t.render().$el),g(this.options.appState)&&(this.$el.addClass("granular-consent").removeClass("consent-required"),this.form.cancel=i._.partial(i.loc,"oform.cancel","login"),i._.forEach(this.options.appState.get("scopes"),(function(t){e.model.set(t.name,!0)})))},postRender:function(){s.default.prototype.postRender.apply(this,arguments),this.$(".o-form-button-bar .button-primary").removeClass("button-primary")},Model:{props:{expiresAt:["string",!0],scopes:["array",!0]},save:function(){return this.doTransaction((function(e){var t=this,n=i._.pluck(this.get("scopes"),"name"),r={expiresAt:this.get("expiresAt")};return g(this)?r.optedScopes=i._.reduce(n,(function(e,n){return e[n]=t.get(n),e}),{}):r.scopes=n,e.consent({consent:r})}))},cancel:function(){var e=this;return this.doTransaction((function(e){return e.cancel()})).then((function(){var t=e.settings.get("consent.cancel");i._.isFunction(t)&&t()}))}},Form:{noCancelButton:!1,buttonOrder:["cancel","save"],autoSave:!0,save:i._.partial(i.loc,"consent.required.consentButton","login"),cancel:i._.partial(i.loc,"consent.required.cancelButton","login"),formChildren:function(){return g(this.options.appState)?[h(p),v].concat((e=this.options.appState.get("scopes"),t=e.slice().sort((function(e,t){return t.optional-e.optional})),i._.map(t,(function(e){var t=e.name,n=e.displayName,r=e.description,o=e.optional,i=e.isCustomized;return l.default.Input({name:t,input:c.default,placeholder:n,label:!1,modelType:"boolean",required:!0,options:{description:r,optional:o,isCustomized:i}})})))):[h(f.default),l.default.View({View:new u.default({model:this.model})}),m];var e,t}},Footer:i.View.extend({className:"consent-footer",template:o.default.template({1:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a class="terms-of-service" href="'+u("function"==typeof(a=null!=(a=c(n,"termsOfService")||(null!=t?c(t,"termsOfService"):t))?a:l)?a.call(s,{name:"termsOfService",hash:{},data:o,loc:{start:{line:1,column:56},end:{line:1,column:74}}}):a)+'" target="_blank">'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"consent.required.termsOfService"},data:o,loc:{start:{line:1,column:92},end:{line:1,column:154}}}))+"</a>"+(null!=(i=c(n,"if").call(s,null!=t?c(t,"privacyPolicy"):t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:158},end:{line:1,column:194}}}))?i:"")},2:function(e,t,n,r,o){return" &#8226 "},4:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a class="privacy-policy" href="'+l("function"==typeof(i=null!=(i=u(n,"privacyPolicy")||(null!=t?u(t,"privacyPolicy"):t))?i:s)?i.call(a,{name:"privacyPolicy",hash:{},data:o,loc:{start:{line:1,column:254},end:{line:1,column:271}}}):i)+'" target="_blank">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"consent.required.privacyPolicy"},data:o,loc:{start:{line:1,column:289},end:{line:1,column:350}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"termsOfService"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:201}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"privacyPolicy"):t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:201},end:{line:1,column:361}}}))?i:"")},useData:!0}),getTemplateData:function(){var e=this.options.appState;return{termsOfService:e.get("targetTermsOfService")&&e.get("targetTermsOfService").href,privacyPolicy:e.get("targetPrivacyPolicy")&&e.get("targetPrivacyPolicy").href}}})});t.default=y,e.exports=t.default},93788:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(84977)),l=o.internal.util.Util,u=i.default.extend({className:"custom-password-expired",Model:{},Form:{noButtonBar:!0,title:function(){var e=this.options.appState.get("isPwdExpiringSoon"),t=this.options.appState.get("passwordExpireDays");return e&&t>0?(0,o.loc)("password.expiring.title","login",[t]):e&&0===t?(0,o.loc)("password.expiring.today","login"):e?(0,o.loc)("password.expiring.soon","login"):this.settings.get("brandName")?(0,o.loc)("password.expired.title.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.expired.title.generic","login")},subtitle:function(){return this.options.appState.get("isPwdExpiringSoon")?this.settings.get("brandName")?(0,o.loc)("password.expiring.soon.subtitle.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.expiring.soon.subtitle.generic","login"):(0,o.loc)("password.expired.custom.subtitle","login")},formChildren:function(){return[a.default.Button({title:o._.partial(o.loc,"password.expired.custom.submit","login",[this.options.appState.get("passwordExpiredWebsiteName")]),className:"button button-primary button-wide",attributes:{"data-se":"custom-button"},click:function(){l.redirect(this.options.appState.get("passwordExpiredLinkUrl"))}})]}},Footer:s.default});t.default=u,e.exports=t.default},43252:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73650)),s=r(n(39694)),l=r(n(50160)),u=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"api.authn.error.PASSCODE_INVALID"},data:o,loc:{start:{line:1,column:110},end:{line:1,column:173}}}))+"</p></div>"},useData:!0})}),c=a.default.extend({className:"device-code-activate",Model:function(){var e,t;return{props:{userCode:["string",!0,null===(e=this.options)||void 0===e||null===(t=e.appState)||void 0===t?void 0:t.get("userCode")],stateToken:"string"},save:function(){var e=this;return this.doTransaction((function(t){return t.deviceActivate({userCode:e.get("userCode")})}))}}},Form:{noCancelButton:!0,autoSave:!0,save:function(){return(0,i.loc)("oform.next","login")},title:function(){return(0,i.loc)("device.code.activate.title","login")},subtitle:function(){return(0,i.loc)("device.code.activate.subtitle","login")},formChildren:function(){return"INVALID_USER_CODE"===this.options.appState.get("deviceActivationStatus")&&this.add(u,".o-form-error-container"),[s.default.Input({label:(0,i.loc)("device.code.activate.label","login"),"label-top":!0,name:"userCode",input:l.default,inputId:"user-code",type:"text",inlineValidation:!1})]},events:{'keyup input[name="userCode"]':function(e){e.preventDefault(),this.addHyphen(e)}},addHyphen:function(e){var t=e.target.value;t&&4===t.length&&!["Backspace","Delete","-"].includes(e.key)&&(e.target.value=t.concat("-"))}}});t.default=c,e.exports=t.default},76920:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73650)),s=r(n(39694)),l="DEVICE_ACTIVATED",u="DEVICE_NOT_ACTIVATED_CONSENT_DENIED",c="DEVICE_NOT_ACTIVATED",d=[u,c],f=a.default.extend({className:"device-code-terminal",postRender:function(){a.default.prototype.postRender.apply(this,arguments);var e=this.options.appState.get("deviceActivationStatus")===l?"success-24-green":"error-24-red";this.$(".o-form-head").before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon '+e+'"></span></div>')},Model:{},Form:{noCancelButton:!0,noButtonBar:!0,title:function(){var e=this.options.appState.get("deviceActivationStatus");return e===l?(0,i.loc)("device.code.activated.success.title","login"):i._.contains(d,e)?(0,i.loc)("device.code.activated.error.title","login"):void 0},subtitle:function(){var e=this.options.appState.get("deviceActivationStatus");return e===l?(0,i.loc)("idx.device.activated","login"):e===u?(0,i.loc)("idx.device.not.activated.consent.denied","login"):e===c?(0,i.loc)("idx.device.not.activated.internal.error","login"):void 0},formChildren:function(){return[s.default.View({View:i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="/activate" class="button button-primary text-align-c retry-button" data-se="try-again">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.try.again"},data:o,loc:{start:{line:1,column:121},end:{line:1,column:165}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"isDeviceCodeError"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:176}}}))?i:""},useData:!0}),getTemplateData:function(){return{isDeviceCodeError:i._.contains(d,this.options.appState.get("deviceActivationStatus"))}}})})]}}});t.default=f,e.exports=t.default},4374:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(83567)),a=r(n(15073)),s=r(n(39694)),l=r(n(81824)),u=o.internal.util.Util,c=i.default.extend({Model:{local:{provider:"string",factorType:"string"},save:function(){var e=this;return this.manageTransaction((function(){var t=e.appState.get("enrollCustomFactorRedirectUrl");null!==t&&u.redirect(t)}))}},Form:function(){var e=new a.default.Model(this.options.appState.get("factor"),this.toJSON()).get("vendorName");return{autoSave:!0,title:e,subtitle:(0,o.loc)("enroll.customFactor.subtitle","login",[e]),save:(0,o.loc)("enroll.customFactor.save","login"),formChildren:function(){var e=[];return this.options.appState.get("isFactorResultFailed")&&e.push(s.default.View({View:new l.default({message:this.options.appState.get("factorResultErrorMessage")})},{selector:".o-form-error-container"})),e}}}});t.default=c,e.exports=t.default},90192:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73650)),s=r(n(39694)),l=r(n(53292)),u=r(n(68457)),c=a.default.extend({className:"enroll-activate-email",Model:{props:{passCode:"string"},resend:function(){return this.trigger("form:clear-errors"),this.doTransaction((function(e){return e.resend("email")}))},save:function(){this.trigger("save");var e=this.toJSON();return this.doTransaction((function(t){return t.activate(e)}))}},Form:function(){return{title:i._.partial(i.loc,"email.enroll.title","login"),noButtonBar:!1,autoSave:!0,save:i._.partial(i.loc,"oform.verify","login"),formChildren:[s.default.View({View:i.View.extend({className:"enroll-activate-email-content",attributes:{"data-se":"enroll-activate-email-content"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"factorEmail",bundle:"login",code:"email.mfa.email.sent.description"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:89}}}))?i:""},useData:!0}),getTemplateData:function(){var e=this.options.appState.get("factor"),t=e&&e.profile?e.profile.email:"";return{factorEmail:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="mask-email">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"email")||(null!=t?a(t,"email"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"email",hash:{},data:o,loc:{start:{line:1,column:25},end:{line:1,column:34}}}):i)+"</span>"},useData:!0})({email:t})}}})}),s.default.View({View:l.default}),s.default.Input({label:(0,i.loc)("email.code.label","login"),"label-top":!0,name:"passCode",type:"text",wide:!0})]}},Footer:u.default});t.default=c,e.exports=t.default},66493:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73390)),s=r(n(35546)),l=r(n(73650)),u=r(n(39694)),c=r(n(90570)),d=r(n(68457)),f=r(n(39838)),p=r(n(50160)),h=i.internal.util.Keys,m=i.View.extend({className:"okta-form-infobox-warning infobox infobox-warning login-timeout-warning",attributes:{"aria-live":"polite"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon warning-16"></span><p>'+(null!=(i="function"==typeof(a=null!=(a=s(n,"warning")||(null!=t?s(t,"warning"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"warning",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:53}}}):a)?i:"")+"</p>"},useData:!0})}),v={factorId:function(e){return!i._.isUndefined(e)}};function g(e){return"call"===e}function y(e){return g(e)?"enroll-call":"enroll-sms"}function b(e){h.isEnter(e)&&(e.stopPropagation(),e.preventDefault(),"keyup"===e.type&&e.data&&e.data.model&&e.data.model.sendCode())}var w=l.default.extend({className:function(){return y(this.options.factorType)},Model:function(){return{props:{phoneNumber:["string",!0],phoneExtension:["string",!1],lastEnrolledPhoneNumber:"string",passCode:["string",!0],factorId:"string"},local:{countryCode:["string",!1,this.options.appState.get("userCountryCode")],hasExistingPhones:"boolean",trapEnrollment:"boolean",ableToResend:"boolean",factorType:"string",skipPhoneValidation:"boolean"},derived:{countryCallingCode:{deps:["countryCode"],fn:function(e){return"+"+a.default.getCallingCodeForCountry(e)}},fullPhoneNumber:{deps:["countryCallingCode","phoneNumber"],fn:function(e,t){return t?e+t:""}},enrolled:{deps:["lastEnrolledPhoneNumber","fullPhoneNumber"],fn:function(e,t){return e===t}}},limitResending:function(){this.set({ableToResend:!1}),i._.delay(i._.bind(this.set,this),s.default.API_RATE_LIMIT,{ableToResend:!0})},sendCode:function(){var e=this,t=this.get("fullPhoneNumber"),n=this.get("phoneExtension");if(e.trigger("errors:clear"),t.length)return this.doTransaction((function(r){var o="MFA_ENROLL"===r.status||"FACTOR_ENROLL"===r.status,a={phoneNumber:t,updatePhone:!o||e.get("hasExistingPhones")};g(e.get("factorType"))&&(a.phoneExtension=n),e.get("skipPhoneValidation")&&(a.validatePhone=!1);var s=function(t){return i._.findWhere(t.factors,{factorType:e.get("factorType"),provider:"OKTA"}).enroll({profile:a}).catch((function(t){throw"E0000098"===t.errorCode&&(e.set("skipPhoneValidation",!0),t.xhr.responseJSON.errorSummary=(0,i.loc)("enroll.sms.try_again","login")),t}))};return o?s(r):(e.set("trapEnrollment",!0),r.prev().then(s).then((function(t){return e.set("trapEnrollment",!1),t})))}),!0).then((function(){e.set("lastEnrolledPhoneNumber",t),e.limitResending()})).catch((function(){e.set("trapEnrollment",!1)}));e.trigger("invalid",e,{phoneNumber:"model.validation.field.blank"})},resendCode:function(){return this.trigger("errors:clear"),this.limitResending(),this.doTransaction((function(e){return e.resend(this.get("factorType"))}))},save:function(){return this.doTransaction((function(e){return e.activate({passCode:this.get("passCode")})}))}}},Form:function(){var e=this.options.factorType,t=g(e),n=(0,i.loc)(t?"enroll.call.setup":"enroll.sms.setup","login"),r=(0,i.loc)(t?"mfa.call":"mfa.sendCode","login"),s=(0,i.loc)(t?"mfa.redial":"mfa.resendCode","login"),l=(0,i.loc)(t?"mfa.calling":"mfa.sent","login"),d=t?"enroll-call-phone":"enroll-sms-phone",h=t?"call-request-button":"sms-request-button",w=[u.default.Input({name:"countryCode",type:"select",wide:!0,options:a.default.getCountries()}),u.default.Input({label:(0,i.loc)("mfa.phoneNumber.placeholder","login"),"label-top":!0,className:d,name:"phoneNumber",input:f.default,type:"text",render:function(){this.$('input[name="phoneNumber"]').off("keydown keyup",b).keydown(b).keyup({model:this.model},b)}})];return t&&w.push(u.default.Input({label:(0,i.loc)("mfa.phoneNumber.ext.placeholder","login"),"label-top":!0,className:"enroll-call-extension",name:"phoneExtension",input:p.default,type:"text"})),w.push(u.default.Button({title:r,attributes:{"data-se":h},className:"button button-primary js-enroll-phone margin-top-30 "+h,click:function(){this.model.sendCode()}}),u.default.Button({title:s,attributes:{"data-se":h},className:"button js-enroll-phone margin-top-30 "+h,click:function(){this.model.resendCode()},initialize:function(){this.$el.css({display:"none"}),this.listenTo(this.model,"change:ableToResend",(function(e,t){t?(this.options.title=s,this.enable()):(this.options.title=l,this.disable()),this.render()}))}}),u.default.Divider({showWhen:v}),u.default.Input({label:(0,i.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,explain:c.default.createInputExplain("mfa.challenge.enterCode.tooltip","mfa.challenge.enterCode.placeholder","login"),"explain-top":!0,name:"passCode",input:p.default,type:"tel",showWhen:v}),u.default.Toolbar({noCancelButton:!0,save:(0,i.loc)("mfa.challenge.verify","login"),showWhen:v})),{title:n,noButtonBar:!0,autoSave:!0,className:y(e),showWarning:function(e){this.clearWarnings(),this.add(m,".o-form-error-container",{options:{warning:e}})},clearWarnings:function(){this.$(".okta-form-infobox-warning").remove()},initialize:function(){var e=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<b>$1</b>",bundle:"login",code:"factor.call.time.warning"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:71}}}))},useData:!0}),n=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<b>$1</b>",bundle:"login",code:"factor.sms.time.warning"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:70}}}))},useData:!0});this.listenTo(this.model,"change:ableToResend",(function(r,o){o?this.showWarning(t?e:n):this.clearWarnings()})),this.listenTo(this.model,"error errors:clear",(function(){this.clearWarnings(),this.clearErrors()})),this.listenTo(this.model,"change:enrolled",(function(){this.$(".js-enroll-phone").toggle()}))},formChildren:w}},Footer:d.default,trapAuthResponse:function(){return this.options.appState.get("isMfaEnrollActivate")?(this.model.set("factorId",this.options.appState.get("activatedFactorId")),!0):!(!this.options.appState.get("isMfaEnroll")||!this.model.get("trapEnrollment"))||void 0},initialize:function(){g(this.options.factorType)?this.model.set("hasExistingPhones",this.options.appState.get("hasExistingPhonesForCall")):this.model.set("hasExistingPhones",this.options.appState.get("hasExistingPhones")),this.model.set("factorType",this.options.factorType)}});t.default=w,e.exports=t.default},87459:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(38513)),s=r(n(91537)),l=r(n(10268)),u=r(n(35546)),c=r(n(73650)),d=r(n(39409)),f=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<span>"+(null!=(i="function"==typeof(a=null!=(a=s(n,"subtitle")||(null!=t?s(t,"subtitle"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:6},end:{line:1,column:20}}}):a)?i:"")+"</span>"},useData:!0}),p=c.default.extend({className:"enroll-choices",state:{pageType:null},Model:{},Form:{noCancelButton:!0,title:i._.partial(i.loc,"enroll.choices.title","login"),noButtonBar:function(){return this.state.get("pageType")===u.default.ALL_OPTIONAL_NONE_ENROLLED},subtitle:" ",getSubtitle:function(){switch(this.state.get("pageType")){case u.default.ALL_OPTIONAL_SOME_ENROLLED:case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:return(0,i.loc)("enroll.choices.optional","login");case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:var e=this.options.appState.get("gracePeriodRemainingDays");return null!==e&&e>=0?this.getGracePeriodSubtitle(e):this.getDefaultSubtitle();default:return this.getDefaultSubtitle()}},getDefaultSubtitle:function(){return this.settings.get("brandName")?(0,i.loc)("enroll.choices.description.specific","login",[this.settings.get("brandName")]):(0,i.loc)("enroll.choices.description.generic","login")},getGracePeriodSubtitle:function(e){return e>=1?(0,i.loc)("enroll.choices.description.gracePeriod.bold","login",[e]):(0,i.loc)("enroll.choices.description.gracePeriod.oneDay.bold","login")},save:function(){switch(this.state.get("pageType")){case u.default.ALL_OPTIONAL_SOME_ENROLLED:case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:return(0,i.loc)("enroll.choices.submit.finish","login");case u.default.HAS_REQUIRED_NONE_ENROLLED:return(0,i.loc)("enroll.choices.submit.configure","login");case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:return(0,i.loc)("enroll.choices.submit.next","login");default:return""}},initialize:function(e){this.listenTo(this,"save",(function(){var t;switch(this.state.get("pageType")){case u.default.HAS_REQUIRED_NONE_ENROLLED:case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:t=e.appState.get("factors").getFirstUnenrolledRequiredFactor(),e.appState.trigger("navigate",d.default.createEnrollFactorUrl(t.get("provider"),t.get("factorType")));break;default:return this.model.doTransaction((function(e){return e.skip()}))}}))},preRender:function(){this.add(f({subtitle:this.getSubtitle()}),"p.okta-form-subtitle");var e=this.options.appState.get("factors");switch(this.state.get("pageType")){case u.default.HAS_REQUIRED_NONE_ENROLLED:case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:this.add(new l.default({minimize:!0,collection:new i.Collection(e.where({required:!0})),appState:this.options.appState}));break;case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:case u.default.ALL_OPTIONAL_SOME_ENROLLED:case u.default.ALL_OPTIONAL_NONE_ENROLLED:var t,n=e.where({enrolled:!0}),r=e.filter((function(e){return!e.get("enrolled")||e.get("additionalEnrollment")}));n.length>0&&(t=(0,i.loc)("enroll.choices.list.optional","login"),this.add(new a.default({listTitle:(0,i.loc)("enroll.choices.list.enrolled","login"),minimize:!0,collection:new i.Collection(n),appState:this.options.appState}))),this.add(new a.default({listTitle:t,collection:new i.Collection(r),appState:this.options.appState,showInlineSetupButton:!0}))}}},initialize:function(e){var t,n,r=0,o=0,i=0,a=0;e.appState.get("factors").each((function(e){var t=e.get("required"),n=e.get("enrolled"),s=e.get("additionalEnrollment");t&&n?r++:t&&!n?o++:!t&&n?i++:t||n||a++,n&&s&&a++})),(t=r>0||o>0)&&0===r?n=u.default.HAS_REQUIRED_NONE_ENROLLED:t&&o>0?n=u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:t&&a>0?n=u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:0===i&&a>0?n=u.default.ALL_OPTIONAL_NONE_ENROLLED:a>0?n=u.default.ALL_OPTIONAL_SOME_ENROLLED:this.model.doTransaction((function(e){return e.skip()})),this.state.set("pageType",n),this.options.appState.get("skipLink")&&n===u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED&&this.add(new s.default(this.toJSON()))}});t.default=p,e.exports=t.default},83567:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(68457)),s=o.internal.util.Util,l=i.default.extend({className:"enroll-custom-factor",Model:{local:{provider:"string",factorType:"string"},save:function(){var e=this;return this.manageTransaction((function(t,n){return o._.findWhere(t.factors,{provider:e.get("provider"),factorType:e.get("factorType")}).enroll().then((function(t){n(t);var r=e.appState.get("enrollCustomFactorRedirectUrl");null!==r&&s.redirect(r)})).catch((function(e){throw e}))}))}},Form:function(){var e=this.options.appState.get("factors").findWhere({provider:this.options.provider,factorType:this.options.factorType}).get("vendorName");return{autoSave:!0,title:e,subtitle:(0,o.loc)("enroll.customFactor.subtitle","login",[e]),save:(0,o.loc)("enroll.customFactor.save","login")}},trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return!0},initialize:function(){this.model.set("provider",this.options.provider),this.model.set("factorType",this.options.factorType)},Footer:a.default});t.default=l,e.exports=t.default},40471:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(79084)),a=r(n(6321)),s=r(n(73650)),l=r(n(68457)),u=s.default.extend({className:"enroll-duo duo-form",Model:{props:{host:"string",signature:"string",postAction:"string",factorId:"string",stateToken:"string"},getInitOptions:function(){return this.doTransaction((function(e){return o._.findWhere(e.factors,{factorType:"web",provider:"DUO"}).enroll()}))},activate:function(e){var t=this.get("postAction"),n=this.get("factorId"),r=this,i={id:n,stateToken:this.get("stateToken"),sig_response:e};return(0,a.default)(o.$.post(t,i)).then((function(){return r.doTransaction((function(e){return e.poll()}))})).catch((function(e){r.trigger("error",r,e.xhr)}))}},Form:{autoSave:!0,noButtonBar:!0,title:o._.partial(o.loc,"enroll.duo.title","login"),postRender:function(){this.add('<iframe frameborder="0" title="'+this.title()+'"></iframe>'),i.default.init({host:this.model.get("host"),sig_request:this.model.get("signature"),iframe:this.$("iframe").get(0),post_action:o._.bind(this.model.activate,this.model)})}},Footer:l.default,fetchInitialData:function(){var e=this;return this.model.getInitOptions(this.options.appState).then((function(t){var n=t.data;if(!(n&&n._embedded&&n._embedded.factor&&n._embedded.factor._embedded&&n._embedded.factor._embedded.activation))throw new Error("Response does not have duo activation options");var r=n._embedded.factor,o=r._embedded.activation;e.model.set({host:o.host,signature:o.signature,postAction:o._links.complete.href,factorId:r.id,stateToken:n.stateToken})}))},trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return!0}});t.default=u,e.exports=t.default},25523:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73650)),s=r(n(39694)),l=r(n(68457)),u={local:{factorType:"string",provider:"string"},save:function(){this.trigger("save");var e=this.pick("factorType","provider");return this.doTransaction((function(t){return i._.findWhere(t.factors,e).enroll()}))}},c=a.default.extend({className:"enroll-email",Model:u,Form:function(){return{title:i._.partial(i.loc,"email.enroll.title","login"),noButtonBar:!1,autoSave:!0,save:i._.partial(i.loc,"email.button.send","login"),formChildren:[s.default.View({View:i.View.extend({attributes:{"data-se":"enroll-email-content"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"email.enroll.description"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:55}}}))},useData:!0})})})]}},Footer:l.default,initialize:function(){this.model.set(i._.pick(this.options,"factorType","provider"))}});t.default=c,e.exports=t.default},6418:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(68457)),l=r(n(81824)),u=i.default.extend({className:"enroll-hotp",Model:function(){return{local:{__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]}}},Form:{title:function(){var e=this.options.appState.get("factors").findWhere({provider:this.model.get("__provider__"),factorType:this.model.get("__factorType__")});return(0,o.loc)("enroll.totp.title","login",[e.get("factorLabel")])},noButtonBar:!0,attributes:{"data-se":"restrict-enroll"},formChildren:function(){return[a.default.View({View:new l.default({message:(0,o.loc)("enroll.hotp.restricted","login")})})]}},Footer:s.default});t.default=u,e.exports=t.default},98702:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(90570)),l=r(n(68457)),u=r(n(50160));function c(e){return"RSA"===e}function d(e){return c(e)?"enroll-rsa":"enroll-onprem"}var f=i.default.extend({className:function(){return d(this.options.provider)},Model:function(){var e=this.options.provider,t=this.options.appState.get("factors").findWhere(o._.pick(this.options,"provider","factorType")).get("profile");return{props:{credentialId:["string",!0,t&&t.credentialId?t.credentialId:""],passCode:["string",!0],factorId:"string"},save:function(){return this.doTransaction((function(t){return o._.findWhere(t.factors,{factorType:"token",provider:e}).enroll({passCode:this.get("passCode"),profile:{credentialId:this.get("credentialId")}})}))}}},Form:function(){var e=this.options.provider,t=this.options.appState.get("factors").findWhere(o._.pick(this.options,"provider","factorType")).get("vendorName");return{title:c(e)?(0,o.loc)("factor.totpHard.rsaSecurId","login"):t,noButtonBar:!0,autoSave:!0,className:d(e),initialize:function(){var e=this;this.listenTo(this.model,"error",(function(t,n){n&&409===n.status&&(e.$(".o-form-input-name-passCode input").val(""),e.$(".o-form-input-name-passCode input").trigger("change"),e.$(".o-form-input-name-passCode input").focus())}))},formChildren:[a.default.Input({label:(0,o.loc)("enroll.onprem.username.placeholder","login",[t]),"label-top":!0,explain:s.default.createInputExplain("enroll.onprem.username.tooltip","enroll.onprem.username.placeholder","login",[t],[t]),"explain-top":!0,name:"credentialId",input:u.default,type:"text"}),a.default.Input({label:(0,o.loc)("enroll.onprem.passcode.placeholder","login",[t]),"label-top":!0,explain:s.default.createInputExplain("enroll.onprem.passcode.tooltip","enroll.onprem.passcode.placeholder","login",[t],[t]),"explain-top":!0,name:"passCode",input:u.default,type:"password"}),a.default.Toolbar({noCancelButton:!0,save:(0,o.loc)("mfa.challenge.verify","login")})]}},Footer:l.default});t.default=f,e.exports=t.default},33874:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(78419)),s=r(n(68457)),l=r(n(50160)),u=i.default.extend({className:"enroll-password",Model:{props:{password:["string",!0],confirmPassword:["string",!0]},validate:function(){return a.default.validateFieldsMatch(this,"password","confirmPassword",(0,o.loc)("password.enroll.error.match","login"))},save:function(){return this.doTransaction((function(e){return o._.findWhere(e.factors,{factorType:"password",provider:"OKTA"}).enroll({profile:{password:this.get("password")}})}))}},Form:{autoSave:!0,title:o._.partial(o.loc,"enroll.password.setup","login"),inputs:function(){return[{label:(0,o.loc)("mfa.challenge.password.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"password",input:l.default,type:"password"},{label:(0,o.loc)("password.confirmPassword.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"confirmPassword",input:l.default,type:"password"}]}},Footer:s.default});t.default=u,e.exports=t.default},70567:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(90570)),l=r(n(68457)),u=r(n(50160)),c=a.default.extend({className:"enroll-question",Model:{props:{question:"string",answer:["string",!0]},local:{securityQuestions:"object"},save:function(){return this.doTransaction((function(e){return o._.findWhere(e.factors,{factorType:"question",provider:"OKTA"}).enroll({profile:{question:this.get("question"),answer:this.get("answer")}})}))}},Form:{autoSave:!0,title:o._.partial(o.loc,"enroll.securityQuestion.setup","login"),inputs:function(){return[{label:!1,"label-top":!0,name:"question",type:"select",wide:!0,options:function(){return this.model.get("securityQuestions")},params:{searchThreshold:25}},{label:(0,o.loc)("mfa.challenge.answer.placeholder","login"),"label-top":!0,explain:s.default.createInputExplain("mfa.challenge.answer.tooltip","mfa.challenge.answer.placeholder","login"),"explain-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"answer",input:u.default,type:"text"}]}},Footer:l.default,fetchInitialData:function(){var e=this;return this.model.manageTransaction((function(e){return o._.findWhere(e.factors,{factorType:"question",provider:"OKTA"}).questions()})).then((function(t){var n={};o._.each(t,(function(e){n[e.question]=i.default.getSecurityQuestionLabel(e)})),e.model.set("securityQuestions",n)}))}});t.default=c,e.exports=t.default},32436:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(90570)),l=r(n(68457)),u=r(n(50160)),c=i.default.extend({className:"enroll-symantec",Model:{props:{credentialId:["string",!0],passCode:["string",!0],nextPassCode:["string",!0],factorId:"string"},save:function(){return this.doTransaction((function(e){return o._.findWhere(e.factors,{factorType:"token",provider:"SYMANTEC"}).enroll({passCode:this.get("passCode"),nextPassCode:this.get("nextPassCode"),profile:{credentialId:this.get("credentialId")}})}))}},Form:{title:o._.partial(o.loc,"factor.totpHard.symantecVip","login"),subtitle:o._.partial(o.loc,"enroll.symantecVip.subtitle","login"),noButtonBar:!0,autoSave:!0,className:"enroll-symantec",formChildren:function(){return[a.default.Input({label:(0,o.loc)("enroll.symantecVip.credentialId.placeholder","login"),"label-top":!0,explain:s.default.createInputExplain("enroll.symantecVip.credentialId.tooltip","enroll.symantecVip.credentialId.placeholder","login"),"explain-top":!0,name:"credentialId",input:u.default,type:"text"}),a.default.Input({label:(0,o.loc)("enroll.symantecVip.passcode1.placeholder","login"),"label-top":!0,explain:s.default.createInputExplain("enroll.symantecVip.passcode1.tooltip","enroll.symantecVip.passcode1.placeholder","login"),"explain-top":!0,name:"passCode",input:u.default,type:"text"}),a.default.Input({label:(0,o.loc)("enroll.symantecVip.passcode2.placeholder","login"),"label-top":!0,explain:s.default.createInputExplain("enroll.symantecVip.passcode2.tooltip","enroll.symantecVip.passcode2.placeholder","login"),"explain-top":!0,name:"nextPassCode",input:u.default,type:"text"}),a.default.Toolbar({noCancelButton:!0,save:(0,o.loc)("mfa.challenge.verify","login")})]}},Footer:l.default});t.default=c,e.exports=t.default},41438:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(2645)),l=r(n(73650)),u=r(n(39694)),c=r(n(89866)),d=r(n(68457)),f={__deviceType__:function(e){return void 0!==e}},p=a.View.extend({attributes:{"data-se":"app-download-instructions"},className:"app-download-instructions",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="app-logo '+e.escapeExpression((s=null!=(s=d(n,"appIcon")||(null!=t?d(t,"appIcon"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"appIcon",hash:{},data:i,loc:{start:{line:1,column:22},end:{line:1,column:33}}}):s))+'"></span><p class="instructions">'+(null!=(s=null!=(s=d(n,"appStoreLinkText")||(null!=t?d(t,"appStoreLinkText"):t))?s:u,a=(0,o.default)(s)===c?s.call(l,{name:"appStoreLinkText",hash:{},data:i,loc:{start:{line:1,column:66},end:{line:1,column:88}}}):s)?a:"")+"</p>"},useData:!0}),initialize:function(){this.listenTo(this.model,"change:__deviceType__",this.render)},postRender:function(){var e=this.$el.find(".instructions a");e.length&&(e[0].setAttribute("target","_blank"),e[0].setAttribute("rel","noreferer noopener"))},getTemplateData:function(){var e,t,n,r=s.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return n=c.default.STORE[this.model.get("__deviceType__")],"GOOGLE"===this.model.get("__provider__")?(e=c.default.GOOGLE[this.model.get("__deviceType__")],t="google-auth-38"):(e=c.default.OKTA[this.model.get("__deviceType__")],t="okta-verify-download-icon"),{appStoreLinkText:n?(0,a.loc)("enroll.totp.downloadApp","login",[e,r,n]):null,appIcon:t}}}),h=l.default.extend({className:"enroll-totp",Model:function(){return{local:{__deviceType__:"string",__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]},save:function(){return this.doTransaction((function(e){return a._.findWhere(e.factors,{factorType:this.get("__factorType__"),provider:this.get("__provider__")}).enroll()}))}}},Form:{title:function(){var e=s.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,a.loc)("enroll.totp.title","login",[e])},noButtonBar:!0,attributes:{"data-se":"step-device-type"},formChildren:function(){var e={APPLE:(0,a.loc)("iphone","login"),ANDROID:(0,a.loc)("android","login")};return[u.default.Input({name:"__deviceType__",type:"radio",options:e,group:!0,label:a._.partial(a.loc,"enroll.totp.selectDevice","login")}),u.default.Divider({showWhen:f}),u.default.View({View:p,showWhen:f}),u.default.Button({title:(0,a.loc)("oform.next","login"),attributes:{"data-type":"save"},className:"button button-primary default-custom-button",click:function(){this.model.save()},showWhen:f})]}},Footer:d.default});t.default=h,e.exports=t.default},87312:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6321));n(83147);var s=n(13671),l=r(n(14726)),u=r(n(73650)),c=r(n(39694)),d=r(n(68457)),f=r(n(81824)),p=u.default.extend({className:"enroll-u2f",Model:{local:{__enrolled__:"boolean"},save:function(){return this.trigger("request"),this.get("__enrolled__")?this.activate():this.doTransaction((function(e){return i._.findWhere(e.factors,{factorType:"u2f",provider:"FIDO"}).enroll()}))},activate:function(){return this.set("__enrolled__",!0),this.trigger("errors:clear"),this.doTransaction((function(e){var t=e.factor.activation,n=t.appId,r=[{version:l.default.getU2fVersion(),challenge:t.nonce}],o=this,i=a.default.defer();return u2f.register(n,r,[],(function(t){o.trigger("errors:clear"),t.errorCode&&0!==t.errorCode?i.reject(new s.U2FError({xhr:{responseJSON:{errorSummary:l.default.getU2fEnrollErrorMessageByCode(t.errorCode)}}})):i.resolve(e.activate({registrationData:t.registrationData,version:t.version,challenge:t.challenge,clientData:t.clientData}))})),i.promise}))}},Form:{title:i._.partial(i.loc,"enroll.u2f.title","login"),save:i._.partial(i.loc,"enroll.u2f.save","login"),noCancelButton:!0,hasSavingState:!1,autoSave:!0,className:"enroll-u2f-form",noButtonBar:function(){return!l.default.isU2fAvailable()},modelEvents:{request:"_startEnrollment",error:"_stopEnrollment"},formChildren:function(){var e=[];if(l.default.isU2fAvailable())e.push(c.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="u2f-instructions"><ol><li>'+(null!=(i=(l(n,"i18n")||t&&l(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.u2f.general2"},data:o,loc:{start:{line:1,column:38},end:{line:1,column:90}}}))?i:"")+"</li><li>"+e.escapeExpression((l(n,"i18n")||t&&l(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.u2f.general3"},data:o,loc:{start:{line:1,column:99},end:{line:1,column:149}}}))+"</li></ol></div>"},useData:!0})})})),e.push(c.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="u2f-enroll-text hide"><p>'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.u2f.instructions"},data:o,loc:{start:{line:1,column:37},end:{line:1,column:91}}}))+"</p><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.u2f.instructionsBluetooth"},data:o,loc:{start:{line:1,column:98},end:{line:1,column:161}}}))+'</p><div data-se="u2f-devices" class="u2f-devices-images"><div class="u2f-usb"></div><div class="u2f-bluetooth"></div></div><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>'},useData:!0})})}));else{var t="u2f.error.factorNotSupported";1===this.options.appState.get("factors").length&&(t="u2f.error.factorNotSupported.oneFactor"),e.push(c.default.View({View:new f.default({message:(0,i.loc)(t,"login")})},{selector:".o-form-error-container"}))}return e},_startEnrollment:function(){this.$(".u2f-instructions").addClass("hide"),this.$(".u2f-enroll-text").removeClass("hide"),this.$(".o-form-button-bar").hide()},_stopEnrollment:function(){this.$(".u2f-instructions").removeClass("hide"),this.$(".u2f-enroll-text").addClass("hide"),this.$(".o-form-button-bar").show()}},Footer:d.default,trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return this.model.activate(),!0}});t.default=p,e.exports=t.default},85584:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(21749)),i=r(n(96336)),a=r(n(80549)),s=r(n(41706)),l=i.default.extend({className:"enroll-user",initialize:function(e){this.options=e||{},this.model=new o.default(this.options)},fetchInitialData:function(){return this.options.appState.get("isUnauthenticated")?this.model.getEnrollFormData():i.default.prototype.fetchInitialData.call()},trapAuthResponse:function(){if(this.options.appState.get("isProfileRequired"))return!0},postRender:function(){var e=new a.default(this.toJSON());this.add(e),this.add(new s.default(this.toJSON())),this.addListeners()}});t.default=l,e.exports=t.default},43125:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6321)),s=r(n(34425)),l=r(n(76587)),u=n(13671),c=r(n(73650)),d=r(n(39694)),f=r(n(49268)),p=r(n(68457)),h=r(n(81824));var m=c.default.extend({className:"enroll-webauthn",Model:{local:{__enrolled__:"boolean"},save:function(){return this.trigger("request"),this.get("__enrolled__")?this.activate():this.doTransaction((function(e){return i._.findWhere(e.factors,{factorType:"webauthn",provider:"FIDO"}).enroll()}))},activate:function(){var e=this;return this.set("__enrolled__",!0),this.trigger("errors:clear"),this.appState.on("backToFactors",(function(){e.webauthnAbortController&&(e.webauthnAbortController.abort(),e.webauthnAbortController=null)})),this.doTransaction((function(e){var t,n,r=e.factor.activation,o=this;if(f.default.isNewApiAvailable()){var s=i._.extend({},r,{challenge:l.default.strToBin(r.challenge),user:{id:l.default.strToBin(r.user.id),name:r.user.name,displayName:r.user.displayName},excludeCredentials:(t=r.excludeCredentials,n=[],i._.each(t,(function(e){n.push({type:"public-key",id:l.default.strToBin(e.id)})})),n)});return"undefined"!=typeof AbortController&&(o.webauthnAbortController=new AbortController),new a.default(navigator.credentials.create({publicKey:s,signal:o.webauthnAbortController&&o.webauthnAbortController.signal})).then((function(t){return e.activate({attestation:l.default.binToStr(t.response.attestationObject),clientData:l.default.binToStr(t.response.clientDataJSON),transports:f.default.processWebAuthnResponse(t.response.getTransports,t.response),clientExtensions:f.default.processWebAuthnResponse(t.getClientExtensionResults,t)})})).catch((function(e){throw o.trigger("errors:clear"),o.webauthnAbortController?new u.WebAuthnError({xhr:{responseJSON:{errorSummary:e.message}}}):new u.WebauthnAbortError})).finally((function(){o.webauthnAbortController=null}))}}))}},Form:{title:i._.partial(i.loc,"enroll.webauthn.biometric.title","login"),save:i._.partial(i.loc,"enroll.webauthn.save","login"),noCancelButton:!0,hasSavingState:!1,autoSave:!0,className:"enroll-webauthn-form",noButtonBar:function(){return!f.default.isNewApiAvailable()},modelEvents:{request:"_startEnrollment",error:"_stopEnrollment"},formChildren:function(){var e=[];if(f.default.isNewApiAvailable())e.push(d.default.View({View:i.View.extend({className:"webauthn-enroll-text",template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="webauthn-edge-text"><p>'+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"enroll.webauthn.biometric.instructions.edge"},data:o,loc:{start:{line:1,column:173},end:{line:1,column:249}}}))?i:"")+"</p></div>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="webauthn-restrictions-text"><p>'+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"enroll.webauthn.instructions.noSupportForBiometric"},data:o,loc:{start:{line:1,column:340},end:{line:1,column:423}}}))?i:"")+"</p></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="webauthn-enroll-instructions"><p>'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.webauthn.biometric.instructions"},data:o,loc:{start:{line:1,column:45},end:{line:1,column:114}}}))+"</p></div>"+(null!=(i=s(n,"if").call(a,null!=t?s(t,"isEdge"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:124},end:{line:1,column:266}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"onlySupportsSecurityKey"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:266},end:{line:1,column:440}}}))?i:"")+'<div data-se="webauthn-waiting" class="okta-waiting-spinner hide"></div>'},useData:!0}),getTemplateData:function(){return{isEdge:s.default.isEdge(),onlySupportsSecurityKey:(s.default.isFirefox()||s.default.isSafari())&&s.default.isMac()}}})}));else{var t="webauthn.biometric.error.factorNotSupported";1===this.options.appState.get("factors").length&&(t="webauthn.biometric.error.factorNotSupported.oneFactor"),e.push(d.default.View({View:new h.default({message:(0,i.loc)(t,"login")})},{selector:".o-form-error-container"}))}return e},_startEnrollment:function(){this.$(".okta-waiting-spinner").show(),this.$(".o-form-button-bar").hide()},_stopEnrollment:function(){this.$(".okta-waiting-spinner").hide(),this.$(".o-form-button-bar").show()}},Footer:p.default,trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return this.model.activate(),!0}});t.default=m,e.exports=t.default},63824:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(49268)),l=r(n(68457)),u=r(n(81824)),c=r(n(64521)),d=i.default.extend({className:"enroll-windows-hello",Model:{local:{__isEnrolled__:"boolean"},save:function(){if(s.default.isAvailable())return this.trigger("request"),this.get("__isEnrolled__")?this.activate():this.doTransaction((function(e){return this._enroll(e)}))},_enroll:function(e){return o._.findWhere(e.factors,{factorType:"webauthn",provider:"FIDO"}).enroll()},activate:function(){return this.set("__isEnrolled__",!0),this.doTransaction((function(e){var t=e.factor.activation,n=e.user,r=this,o={rpDisplayName:t.rpDisplayName,userDisplayName:n.profile.displayName,accountName:n.profile.login,userId:n.id},i=[{algorithm:t.algorithm}],a=t.nonce;return s.default.makeCredential(o,i,a).then((function(t){return e.activate({credentialId:t.credential.id,publicKey:t.publicKey,attestation:null})})).catch((function(t){switch(t.message){case"AbortError":case"NotFoundError":case"NotSupportedError":return r.trigger("abort",t.message),e}throw t}))}))}},Form:{autoSave:!0,hasSavingState:!1,title:o._.partial(o.loc,"enroll.windowsHello.title","login"),subtitle:function(){return s.default.isAvailable()?(0,o.loc)("enroll.windowsHello.subtitle","login"):""},save:o._.partial(o.loc,"enroll.windowsHello.save","login"),customSavingState:{stop:"abort"},modelEvents:function(){return s.default.isAvailable()?{request:"_startEnrollment",error:"_stopEnrollment",abort:"_stopEnrollment"}:{}},noButtonBar:function(){return!s.default.isAvailable()},formChildren:function(){var e=[];return s.default.isAvailable()||e.push(a.default.View({View:new u.default({message:(0,o.loc)("enroll.windowsHello.error.notWindows","login")})},{selector:".o-form-error-container"})),e.push(a.default.View({View:new c.default({model:this.model,visible:!1})})),e},_startEnrollment:function(){this.subtitle=(0,o.loc)("enroll.windowsHello.subtitle.loading","login"),this.model.trigger("spinner:show"),this._resetErrorMessage(),this.render(),this.$(".o-form-button-bar").addClass("hide")},_stopEnrollment:function(e){var t;if(this.subtitle=(0,o.loc)("enroll.windowsHello.subtitle","login"),this.model.trigger("spinner:hide"),"NotSupportedError"===e)t=(0,o.loc)("enroll.windowsHello.error.notConfiguredHtml","login");if(this._resetErrorMessage(),t){var n=new u.default({message:t});this.$(".o-form-error-container").addClass("o-form-has-errors"),this.add(n,{selector:".o-form-error-container"}),this._errorMessageView=this.last()}this.render(),this.$(".o-form-button-bar").removeClass("hide")},_resetErrorMessage:function(){this._errorMessageView&&this._errorMessageView.remove(),this._errorMessageView=void 0,this.clearErrors()}},Footer:l.default,trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate"))return this.model.activate(),!0}});t.default=d,e.exports=t.default},53177:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(68457)),l=r(n(50160)),u=i.default.extend({className:"enroll-yubikey",Model:{props:{passCode:["string",!0],factorId:"string"},save:function(){return this.doTransaction((function(e){return o._.findWhere(e.factors,{factorType:"token:hardware",provider:"YUBICO"}).enroll({passCode:this.get("passCode")})}))}},Form:{title:o._.partial(o.loc,"enroll.yubikey.title","login"),subtitle:o._.partial(o.loc,"enroll.yubikey.subtitle","login"),noCancelButton:!0,save:o._.partial(o.loc,"mfa.challenge.verify","login"),autoSave:!0,className:"enroll-yubikey",formChildren:[a.default.View({View:'<div class="yubikey-demo" data-type="yubikey-example"></div>'}),a.default.Input({name:"passCode",input:l.default,type:"password"})]},Footer:s.default});t.default=u,e.exports=t.default},38889:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73390)),s=r(n(73650)),l=r(n(39694)),u=r(n(39409)),c=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oform.back"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:99}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()}},back:function(){var e=u.default.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"),this.options.appState.get("activatedFactorType"),"manual");this.options.appState.trigger("navigate",e)}}),d={title:i._.partial(i.loc,"enroll.totp.enrollViaEmail.title","login"),noButtonBar:!0,attributes:{"data-se":"sent-email-activation-link"},formChildren:[l.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.enrollViaEmail.msg"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:64}}}))+'</p><p class="email-address">'+l("function"==typeof(i=null!=(i=u(n,"email")||(null!=t?u(t,"email"):t))?i:s)?i.call(a,{name:"email",hash:{},data:o,loc:{start:{line:1,column:93},end:{line:1,column:102}}}):i)+"</p>"},useData:!0}),getTemplateData:function(){return{email:this.options.appState.get("userEmail")}}})})]},f={title:i._.partial(i.loc,"enroll.totp.enrollViaSms.title","login"),noButtonBar:!0,attributes:{"data-se":"sent-sms-activation-link"},formChildren:[l.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.enrollViaSms.msg"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:62}}}))+'</p><p class="phone-number">'+l("function"==typeof(i=null!=(i=u(n,"phoneNumber")||(null!=t?u(t,"phoneNumber"):t))?i:s)?i.call(a,{name:"phoneNumber",hash:{},data:o,loc:{start:{line:1,column:90},end:{line:1,column:105}}}):i)+"</p>"},useData:!0}),getTemplateData:function(){return{phoneNumber:this.model.get("fullPhoneNumber")}}})})]},p=s.default.extend({className:"enroll-activation-link-sent",Model:function(){return{local:{countryCode:["string",!1,this.options.appState.get("userCountryCode")],phoneNumber:["string",!1,this.options.appState.get("userPhoneNumber")],__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]},derived:{countryCallingCode:{deps:["countryCode"],fn:function(e){return"+"+a.default.getCallingCodeForCountry(e)}},fullPhoneNumber:{deps:["countryCallingCode","phoneNumber"],fn:function(e,t){return e+t}}}}},Form:function(){var e=this.options.appState.get("factorActivationType");switch(e){case"SMS":return f;case"EMAIL":return d;default:throw new Error("Unknown activation option: "+e)}},Footer:c,initialize:function(){this.pollForEnrollment()},remove:function(){return s.default.prototype.remove.apply(this,arguments)},pollForEnrollment:function(){return this.model.doTransaction((function(e){return e.poll(6e3)}))},trapAuthResponse:function(){if(this.options.appState.get("isWaitingForActivation"))return this.pollForEnrollment(),!0}});t.default=p,e.exports=t.default},2093:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(73650)),s=r(n(39409)),l=r(n(21304)),u=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oform.back"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:99}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()}},back:function(){var e=s.default.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"),"push","manual");this.options.appState.trigger("navigate",e)}}),c=a.default.extend({className:"activate-push",Model:function(){return{props:{factorId:["string",!0,this.options.appState.get("activatedFactorId")],passCode:["string",!0]},local:{__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]},save:function(){return this.doTransaction((function(e){return e.activate({passCode:this.get("passCode")})}))}}},Form:l.default,Footer:u});t.default=c,e.exports=t.default},75996:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(73650)),i=r(n(11205)),a=o.default.extend({className:"error-state",Model:{},Form:{noButtonBar:!0},Footer:i.default});t.default=a,e.exports=t.default},40635:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(64521)),i=r(n(96336)),a=r(n(90570)),s=i.default.extend({className:"force-idp-discovery",View:o.default,Model:{},initialize:function(){var e=this,t=this.options,n=t.appState.get("lastAuthResponse"),r={resource:"okta:acct:",requestContext:n&&(null==n?void 0:n.stateToken)};t.appState.settings.getAuthClient().webfinger(r).then((function(n){if(null!=n&&n.links&&n.links[0]&&("OKTA"!==n.links[0].properties["okta:idp:type"]&&n.links[0].href))return void(n.links[0].href.includes("OKTA_INVALID_SESSION_REPOST%3Dtrue")?a.default.redirectWithFormGet.bind(a.default):e.settings.get("redirectUtilFn"))(n.links[0].href);t.appState.trigger("navigate","")})).catch((function(){t.appState.trigger("navigate","")}))}});t.default=s,e.exports=t.default},61437:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(73650)),l=r(n(39694)),u=r(n(90570)),c=r(n(78419)),d=r(n(17849)),f=r(n(50160)),p=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"password.forgot.noFactorsEnabled"},data:o,loc:{start:{line:1,column:110},end:{line:1,column:173}}}))+"</p></div>"},useData:!0})}),h=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"goback"},data:o,loc:{start:{line:1,column:94},end:{line:1,column:131}}}))+"</a>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link goto js-contact-support">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"mfa.noAccessToEmail"},data:o,loc:{start:{line:1,column:220},end:{line:1,column:270}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"unless").call(a,null!=t?s(t,"hideBackToSignInForReset"):t,{name:"unless",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:146}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"helpSupportNumber"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:146},end:{line:1,column:281}}}))?i:"")},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()},"click .js-contact-support":function(e){e.preventDefault(),this.state.trigger("contactSupport"),this.$(".js-contact-support").hide()}},getTemplateData:function(){return{hideBackToSignInForReset:this.settings.get("features.hideBackToSignInForReset"),helpSupportNumber:this.settings.get("helpSupportNumber")}},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}}),m=s.default.extend({className:"forgot-password",Model:{props:{username:["string",!0],factorType:["string",!0]},validate:function(){return c.default.validateUsername(this)},save:function(){var e=this,t=this.settings.get("relayState");this.startTransaction((function(n){return n.forgotPassword({username:e.settings.transformUsername(e.get("username"),a.default.FORGOT_PASSWORD),factorType:e.get("factorType"),relayState:t})})).catch((function(){}))}},Form:{noButtonBar:!0,title:i._.partial(i.loc,"password.reset","login"),formChildren:function(){var e=this.settings.get("features.smsRecovery"),t=this.settings.get("features.callRecovery"),n=this.settings.get("features.emailRecovery"),r=[];return!(e||t||n)?this.add(p,".o-form-error-container"):(r.push(l.default.Input({label:(0,i.loc)("password.forgot.email.or.username.placeholder","login"),"label-top":!0,explain:u.default.createInputExplain("password.forgot.email.or.username.tooltip","password.forgot.email.or.username.placeholder","login"),"explain-top":!0,name:"username",input:f.default,inputId:"account-recovery-username",autoComplete:u.default.getAutocompleteValue(this.settings,"username"),type:"text",inlineValidation:!1})),(e||t)&&r.push(l.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="mobile-recovery-hint">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"mobileFactors",bundle:"login",code:"recovery.mobile.hint"},data:o,loc:{start:{line:1,column:32},end:{line:1,column:109}}}))+"</p>"},useData:!0}),getTemplateData:function(){return{mobileFactors:e&&t?(0,i.loc)("recovery.smsOrCall"):t?(0,i.loc)("recovery.call"):(0,i.loc)("recovery.sms")}}})})),e&&(this.$el.addClass("forgot-password-sms-enabled"),r.push(this.createRecoveryFactorButton("sms-button","password.forgot.sendText",a.default.RECOVERY_FACTOR_TYPE_SMS,this)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)),t&&(this.$el.addClass("forgot-password-call-enabled"),r.push(this.createRecoveryFactorButton("call-button","password.forgot.call",a.default.RECOVERY_FACTOR_TYPE_CALL,this)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)),n&&(this.$el.addClass("forgot-password-email-enabled"),r.push(this.createRecoveryFactorButton("email-button","password.forgot.sendEmail",a.default.RECOVERY_FACTOR_TYPE_EMAIL,this)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))),r},initialize:function(){this.listenTo(this.state,"contactSupport",(function(){this.add(d.default,".o-form-error-container")})),this.listenTo(this,"save",(function(){this.options.appState.set("username",this.model.get("username")),this.model.save()}))},setDefaultFactorType:function(e){i._.isEmpty(this.model.get("factorType"))&&this.model.set("factorType",e)},createRecoveryFactorButton:function(e,t,n,r){return l.default.Button({attributes:{"data-se":e},className:"button button-primary button-wide "+e,title:(0,i.loc)(t,"login"),click:function(){r.clearErrors(),this.model.isValid()&&(this.model.set("factorType",n),r.trigger("save",this.model))}})}},Footer:h,initialize:function(){this.options.appState.unset("username")}});t.default=m,e.exports=t.default},94408:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(23947)),i=r(n(31749)),a=r(n(28528)),s=r(n(96336)),l=r(n(69834)),u=r(n(65422)),c=r(n(75104)),d=r(n(39409)),f=r(n(90570)),p=o.default.extend({className:"idp-discovery",View:l.default,constructor:function(e){e.appState.unset("username");var t=e.settings.get("idpDiscovery.requestContext"),n=e.appState.get("lastAuthResponse"),r=n&&(null==n?void 0:n.stateToken);f.default.isV1StateToken(t)&&(t=r),this.model=new i.default({requestContext:t,settings:e.settings,appState:e.appState},{parse:!0}),s.default.apply(this,arguments),this.addListeners(),e.settings.get("hasConfiguredButtons")&&this.add(u.default,{prepend:e.settings.get("socialAuthPositionTop"),options:{currentController:this}}),this.addFooter(e),this.setUsername()},initialize:function(){o.default.prototype.initialize.apply(this),this.listenTo(this.model,"goToPrimaryAuth",(function(){this.settings.set("username",this.model.get("username"));var e=this;this.settings.get("features.deviceFingerprinting")?c.default.generateDeviceFingerprint(this.settings.getAuthClient(),this.$el[0]).then((function(t){e.options.appState.set("deviceFingerprint",t),e.options.appState.set("username",e.model.get("username"))})).catch((function(){e.options.appState.set("username",e.model.get("username"))})).finally((function(){e.doPrimaryAuth()})):e.doPrimaryAuth()}))},doPrimaryAuth:function(){if(this.settings.get("features.passwordlessAuth")){var e=new a.default({username:this.model.get("username"),multiOptionalFactorEnroll:this.options.settings.get("features.multiOptionalFactorEnroll"),settings:this.options.settings,appState:this.options.appState},{parse:!0});this.listenTo(e,"error",(function(e,t){this.toggleButtonState(!1),this.model.trigger("error",this.model,t)})),this.addModelListeners(e),e.save()}else{this.options.appState.set("disableUsername",!0);var t=d.default.createSigninUrl(this.settings.get("features.prefillUsernameFromIdpDiscovery")&&this.model.get("username"));this.options.appState.trigger("navigate",t)}}});t.default=p,e.exports=t.default},32992:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(73390)),l=r(n(2645)),u=r(n(73650)),c=r(n(39694)),d=r(n(39409)),f=r(n(4940)),p=r(n(39838));function h(e,t){var n=d.default.createActivateFactorUrl(e.options.appState.get("activatedFactorProvider"),e.options.appState.get("activatedFactorType"),t);e.options.appState.trigger("navigate",n)}var m={sharedSecret:function(e){return!a._.isUndefined(e)},activationType:"MANUAL"};function v(e){var t,n;"SMS"===e.model.get("activationType")&&(n=e.model.get("countryCode"),t=e.model.get("phoneNumber")),e.options.appState.set({factorActivationType:e.model.get("activationType"),userCountryCode:n,userPhoneNumber:t})}function g(e,t){return e.model.doTransaction((function(n){return n.prev().then((function(e){return a._.findWhere(e.factors,{factorType:t,provider:"OKTA"}).enroll()})).then((function(t){var n,r,o,i=t.data;if(i&&i._embedded&&i._embedded.factor&&i._embedded.factor._embedded&&i._embedded.factor._embedded.activation){var s=i._embedded.factor;if(o=s._embedded.activation.sharedSecret,s._embedded.activation._links&&s._embedded.activation._links.send){var l=s._embedded.activation._links.send,u=a._.findWhere(l,{name:"sms"});n=u?u.href:null;var c=a._.findWhere(l,{name:"email"});r=c?c.href:null}}return e.model.set({SMS:n,EMAIL:r,sharedSecret:o}),t}))}))}var y=u.default.extend({className:"enroll-manual-push",Model:function(){return{local:{activationType:["string",!0,this.options.appState.get("factorActivationType")||"SMS"],countryCode:["string",!1,this.options.appState.get("userCountryCode")],phoneNumber:"string",SMS:["string",!1,this.options.appState.get("textActivationLinkUrl")],EMAIL:["string",!1,this.options.appState.get("emailActivationLinkUrl")],sharedSecret:["string",!1,this.options.appState.get("sharedSecret")],__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]},derived:{countryCallingCode:{deps:["countryCode"],fn:function(e){return"+"+s.default.getCallingCodeForCountry(e)}},fullPhoneNumber:{deps:["countryCallingCode","phoneNumber"],fn:function(e,t){return e+t}}}}},Form:{title:function(){var e=l.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,a.loc)("enroll.totp.title","login",[e])},subtitle:a._.partial(a.loc,"enroll.totp.cannotScanBarcode","login"),noButtonBar:!0,attributes:{"data-se":"step-manual-setup"},formChildren:function(){var e=this,t=this.settings.get("brandName")?(0,a.loc)("enroll.totp.sharedSecretInstructions.specific","login",[this.settings.get("brandName")]):(0,a.loc)("enroll.totp.sharedSecretInstructions.generic","login");return[c.default.Input({name:"activationType",label:(0,a.loc)("mfa.setupOptions","login"),type:"select",wide:!0,options:{SMS:(0,a.loc)("enroll.totp.sendSms","login"),EMAIL:(0,a.loc)("enroll.totp.sendEmail","login"),MANUAL:(0,a.loc)("enroll.totp.setupManually","login")}}),c.default.Input({label:(0,a.loc)("mfa.country","login"),name:"countryCode",type:"select",wide:!0,options:s.default.getCountries(),showWhen:{activationType:"SMS"}}),c.default.Input({label:(0,a.loc)("mfa.phoneNumber.placeholder","login"),"label-top":!0,className:"enroll-sms-phone",name:"phoneNumber",input:p.default,type:"text",showWhen:{activationType:"SMS"}}),c.default.View({View:a.View.extend({className:"secret-key-instructions",attributes:{"data-se":"secret-key-instructions"},template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<section aria-live="assertive"><p class="okta-form-subtitle o-form-explain text-align-c">'+c((a=null!=(a=d(n,"instructions")||(null!=t?d(t,"instructions"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"instructions",hash:{},data:i,loc:{start:{line:1,column:89},end:{line:1,column:105}}}):a))+'</p><p class="shared-key margin-top-10" tabindex=0 aria-label="'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{arguments:"sharedSecretKey",bundle:"login",code:"enroll.totp.sharedSecretInstructions.aria.secretKey"},data:i,loc:{start:{line:1,column:168},end:{line:1,column:278}}}))+'">'+c((a=null!=(a=d(n,"sharedSecretKey")||(null!=t?d(t,"sharedSecretKey"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"sharedSecretKey",hash:{},data:i,loc:{start:{line:1,column:280},end:{line:1,column:299}}}):a))+"</p></section>"},useData:!0}),initialize:function(){this.listenTo(this.model,"change:sharedSecret",this.render)},getTemplateData:function(){return{instructions:t,sharedSecretKey:this.model.get("sharedSecret")}}}),showWhen:{activationType:"MANUAL"}}),c.default.View({View:a.View.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div data-type="next-button-wrap"></div>'},useData:!0})}),showWhen:m}),c.default.Button({title:(0,a.loc)("oform.next","login"),className:"button button-primary button-wide button-next",attributes:{"data-se":"next-button"},click:function(){v(e),h(e,"passcode")}},'[data-type="next-button-wrap"]'),c.default.Toolbar({noCancelButton:!0,save:(0,a.loc)("oform.send","login"),showWhen:{activationType:function(e){return"SMS"===e||"EMAIL"===e}}})]}},Footer:f.default,initialize:function(){this.setInitialModel(),this.listenTo(this.form,"save",(function(){var e=this;this.model.doTransaction((function(t){var n=this.get("activationType").toLowerCase(),r={};return"sms"===n&&(r.profile={phoneNumber:this.get("fullPhoneNumber")}),t.factor.activation.send(n,r).then((function(t){return v(e),a._.defer((function(){h(e,"sent")})),t}))}))})),this.listenTo(this.model,"change:activationType",(function(e,t){this.form.clearErrors(),"MANUAL"===t&&"token:software:totp"!==this.options.appState.get("activatedFactorType")?g(this,"token:software:totp"):"push"!==this.options.appState.get("activatedFactorType")&&g(this,"push")}))},setInitialModel:function(){"SMS"===this.options.appState.get("factorActivationType")&&this.model.set({countryCode:this.options.appState.get("userCountryCode")||"US",phoneNumber:this.options.appState.get("userPhoneNumber")})},trapAuthResponse:function(){if(this.options.appState.get("isMfaEnrollActivate")||this.options.appState.get("isMfaEnroll"))return!0}});t.default=y,e.exports=t.default},47685:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(2645)),l=r(n(73650)),u=r(n(39694)),c=r(n(39409)),d=r(n(89104)),f=l.default.extend({className:"enroll-manual-totp",Model:function(){return{local:{sharedSecret:["string",!1,this.options.appState.get("sharedSecret")],__factorType__:["string",!1,this.options.factorType],__provider__:["string",!1,this.options.provider]}}},Form:{title:function(){var e=s.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,a.loc)("enroll.totp.title","login",[e])},subtitle:a._.partial(a.loc,"enroll.totp.cannotScanBarcode","login"),noButtonBar:!0,attributes:{"data-se":"step-manual-setup"},formChildren:function(){var e=this.settings.get("brandName")?(0,a.loc)("enroll.totp.manualSetupInstructions.specific","login",[this.settings.get("brandName")]):(0,a.loc)("enroll.totp.manualSetupInstructions.generic","login");return[u.default.View({View:a.View.extend({className:"secret-key-instructions",attributes:{"data-se":"secret-key-instructions"},template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<section aria-live="assertive"><p class="okta-form-subtitle o-form-explain text-align-c">'+c((a=null!=(a=d(n,"instructions")||(null!=t?d(t,"instructions"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"instructions",hash:{},data:i,loc:{start:{line:1,column:89},end:{line:1,column:105}}}):a))+'</p><p class="shared-key margin-top-10" tabindex=0 aria-label="'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{arguments:"sharedSecretKey",bundle:"login",code:"enroll.totp.sharedSecretInstructions.aria.secretKey"},data:i,loc:{start:{line:1,column:168},end:{line:1,column:278}}}))+'">'+c((a=null!=(a=d(n,"sharedSecretKey")||(null!=t?d(t,"sharedSecretKey"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"sharedSecretKey",hash:{},data:i,loc:{start:{line:1,column:280},end:{line:1,column:299}}}):a))+"</p></section>"},useData:!0}),initialize:function(){this.listenTo(this.model,"change:sharedSecret",this.render)},getTemplateData:function(){return{instructions:e,sharedSecretKey:this.model.get("sharedSecret")}}})}),u.default.Toolbar({noCancelButton:!0,save:(0,a.loc)("oform.next","login")})]}},Footer:d.default,initialize:function(){this.listenTo(this.form,"save",(function(){var e=c.default.createActivateFactorUrl(this.model.get("__provider__"),this.model.get("__factorType__"),"activate");this.options.appState.trigger("navigate",e)}))}});t.default=f,e.exports=t.default},26e3:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(96336)),a=r(n(96823)),s=r(n(86139)),l=r(n(54311)),u=r(n(89274)),c=r(n(99423)),d=r(n(39877)),f=r(n(83344)),p=r(n(61174)),h=r(n(27797)),m=r(n(71271)),v=o.internal.views.forms.inputs.CheckBox,g=i.default.extend({className:"mfa-verify",initialize:function(e){var t,n=e.factorType;switch(n){case"question":t=d.default;break;case"email":t=this.options.appState.get("isIdxStateToken")?a.default:f.default;break;case"sms":case"call":t=l.default;break;case"token":case"token:software:totp":case"token:hotp":t=p.default;break;case"token:hardware":t=h.default;break;case"push":t=c.default;break;case"password":t=u.default;break;default:throw new Error("Unrecognized factor type")}if(this.model=this.findModel(n,e),!this.model)throw new Error("Unrecognized factor/provider");this.addListeners(),this.add(new t(this.toJSON())),"push"===n&&this.model.get("isOktaFactor")&&(this.model.get("backupFactor")&&(this.inlineTotpForm=this.add(s.default,{options:{model:this.model.get("backupFactor")}}).last()),this.settings.get("features.autoPush")&&(this.autoPushCheckBox=this.add(v,{options:{model:this.model,name:"autoPush",placeholder:(0,o.loc)("autoPush","login"),label:!1,"label-top":!1,className:"margin-btm-0"}}).last()),this.options.appState.get("allowRememberDevice")&&(this.rememberDeviceCheckbox=this.add(v,{options:{model:this.model,name:"rememberDevice",placeholder:this.options.appState.get("rememberDeviceLabel"),label:!1,"label-top":!0,className:"margin-btm-0"}}).last()),this.model.get("backupFactor")&&this.listenTo(this.model,"change:rememberDevice",(function(e,t){e.get("backupFactor").set("rememberDevice",t)}))),this.listenTo(this.options.appState,"change:isWaitingForNumberChallenge",(function(e,t){t||"SUCCESS"===this.options.appState.get("lastAuthResponse").status?(this.autoPushCheckBox&&this.autoPushCheckBox.$el.hide(),this.rememberDeviceCheckbox&&this.rememberDeviceCheckbox.$el.hide(),this.inlineTotpForm&&this.inlineTotpForm.$el.hide()):(this.autoPushCheckBox&&this.autoPushCheckBox.$el.show(),this.rememberDeviceCheckbox&&this.rememberDeviceCheckbox.$el.show(),this.inlineTotpForm&&this.inlineTotpForm.$el.show())})),this.add(new m.default(this.toJSON()))},findModel:function(e,t){var n=t.appState.get("factors"),r=t.provider,o=t.factorIndex;return r?n.hasMultipleFactorsOfSameType(e)&&o?n.getFactorByTypeAndIndex(e,o):n.findWhere({provider:r,factorType:e}):n.findWhere({factorType:e,isFactorTypeVerification:!0})},trapAuthResponse:function(){return!!(this.options.appState.get("isMfaRequired")&&this.options.appState.get("trapMfaRequiredResponse")||this.options.appState.get("isMfaChallenge"))&&(this.options.appState.set("trapMfaRequiredResponse",!1),!0)},back:function(){}});t.default=g,e.exports=t.default},29161:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(39694)),l=r(n(90570)),u=r(n(78419)),c=r(n(84977)),d=r(n(25015)),f=r(n(50160)),p=a.default.extend({className:"password-expired",Model:{props:{oldPassword:["string",!0],newPassword:["string",!0],confirmPassword:["string",!0]},validate:function(){return u.default.validatePasswordMatch(this)},save:function(){return this.trigger("save"),this.doTransaction((function(e){return e.changePassword({oldPassword:this.get("oldPassword"),newPassword:this.get("newPassword")})}))}},Form:{save:o._.partial(o.loc,"password.expired.submit","login"),title:function(){var e=this.options.appState.get("isPwdExpiringSoon"),t=this.options.appState.get("passwordExpireDays");return e&&t>0?(0,o.loc)("password.expiring.title","login",[t]):e&&0===t?(0,o.loc)("password.expiring.today","login"):e?(0,o.loc)("password.expiring.soon","login"):this.settings.get("brandName")?(0,o.loc)("password.expired.title.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.expired.title.generic","login")},subtitle:function(){if(this.options.appState.get("isPwdExpiringSoon"))return this.settings.get("brandName")?(0,o.loc)("password.expiring.subtitle.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.expiring.subtitle.generic","login");var e=this.options.appState.get("policy");return e&&!this.settings.get("features.showPasswordRequirementsAsHtmlList")?i.default.getPasswordComplexityDescription(e):void 0},parseErrorMessage:function(e){var t=this.options.appState.get("policy");return t&&this.settings.get("features.showPasswordRequirementsAsHtmlList")&&(e=i.default.removeRequirementsFromError(e,t)),e},formChildren:function(){var e=[];return this.settings.get("features.showPasswordRequirementsAsHtmlList")&&e.push(s.default.View({View:new d.default({policy:this.options.appState.get("policy")})})),e=e.concat([s.default.Input({"label-top":!0,label:(0,o.loc)("password.oldPassword.placeholder","login"),explain:l.default.createInputExplain("password.oldPassword.tooltip","password.oldPassword.placeholder","login"),"explain-top":!0,name:"oldPassword",input:f.default,type:"password"}),s.default.Divider(),s.default.Input({className:"margin-btm-5","label-top":!0,label:(0,o.loc)("password.newPassword.placeholder","login"),explain:l.default.createInputExplain("password.newPassword.tooltip","password.newPassword.placeholder","login"),"explain-top":!0,name:"newPassword",input:f.default,type:"password"}),s.default.Input({"label-top":!0,label:(0,o.loc)("password.confirmPassword.placeholder","login"),explain:l.default.createInputExplain("password.confirmPassword.tooltip","password.confirmPassword.placeholder","login"),"explain-top":!0,name:"confirmPassword",input:f.default,type:"password"})])}},Footer:c.default,initialize:function(){this.listenTo(this.form,"save",(function(){var e={username:this.options.appState.get("userEmail"),password:this.model.get("newPassword")};this.settings.processCreds(e).then(o._.bind(this.model.save,this.model))}))}});t.default=p,e.exports=t.default},31539:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(39694)),l=r(n(90570)),u=r(n(78419)),c=r(n(88522)),d=r(n(25015)),f=r(n(50160)),p=o.internal.views.forms.inputs.CheckBox,h=a.default.extend({className:"password-reset",Model:{props:{newPassword:["string",!0],confirmPassword:["string",!0],revokeSessions:["boolean",!1]},validate:function(){return u.default.validatePasswordMatch(this)},save:function(){this.trigger("save");var e=this;return this.doTransaction((function(t){var n={newPassword:e.get("newPassword")};return e.settings.get("features.showSessionRevocation")&&(n.revokeSessions=e.get("revokeSessions")),t.resetPassword(n)}))}},Form:{save:o._.partial(o.loc,"password.reset","login"),title:function(){return this.settings.get("brandName")?(0,o.loc)("password.reset.title.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.reset.title.generic","login")},subtitle:function(){var e=this.options.appState.get("policy");if(e&&!this.settings.get("features.showPasswordRequirementsAsHtmlList"))return i.default.getPasswordComplexityDescription(e)},parseErrorMessage:function(e){var t=this.options.appState.get("policy");return t&&this.settings.get("features.showPasswordRequirementsAsHtmlList")&&(e=i.default.removeRequirementsFromError(e,t)),e},formChildren:function(){var e=[];return this.settings.get("features.showPasswordRequirementsAsHtmlList")&&e.push(s.default.View({View:new d.default({policy:this.options.appState.get("policy")})})),e=e.concat([s.default.Input({className:"margin-btm-5",label:(0,o.loc)("password.newPassword.placeholder","login"),"label-top":!0,explain:l.default.createInputExplain("password.newPassword.tooltip","password.newPassword.placeholder","login"),"explain-top":!0,name:"newPassword",input:f.default,type:"password",autoComplete:l.default.getAutocompleteValue(this.settings,"new-password")}),s.default.Input({label:(0,o.loc)("password.confirmPassword.placeholder","login"),"label-top":!0,explain:l.default.createInputExplain("password.confirmPassword.tooltip","password.confirmPassword.placeholder","login"),"explain-top":!0,name:"confirmPassword",input:f.default,type:"password",autoComplete:l.default.getAutocompleteValue(this.settings,"new-password")})]),this.settings.get("features.showSessionRevocation")&&(e=e.concat([s.default.Input({placeholder:(0,o.loc)("password.reset.revokeSessions","login"),name:"revokeSessions",input:p,type:"checkbox"})])),e}},initialize:function(){this.listenTo(this.form,"save",(function(){var e={username:this.options.appState.get("userEmail"),password:this.model.get("newPassword")};this.settings.processCreds(e).then(o._.bind(this.model.save,this.model))})),this.settings.get("features.hideBackToSignInForReset")||this.addFooter(c.default)}});t.default=h,e.exports=t.default},37210:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=i.default.extend({className:"poll",Model:{save:function(){var e=this;return this.trigger("cancelRequest"),this.appState.get("transaction").cancel().then((function(){e.options.appState.trigger("navigate","")})).catch((function(){e._stopCountDown()}))}},Form:{autoSave:!0,hasSavingState:!1,title:function(){return this.title},className:"poll-controller",noCancelButton:!0,save:(0,o.loc)("oform.cancel","login"),modelEvents:{cancelRequest:"_stopCountDown"},formChildren:[a.default.View({View:'<div >               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>             </div>'})],_checkStatus:function(){var e=this;this.transactionObject.poll().then((function(t){if(t.data&&"POLL"!==t.status)e.options.appState.set("transaction",t);else{e.$(".okta-waiting-spinner").hide();var n=Math.ceil(t.transaction.profile.refresh/1e3);e._startCountDown(n)}})).catch((function(){e._stopCountDown()}))},_startCountDown:function(e){var t=this;this.countDown=setInterval((function(){t._updateTitle(e),0===e?(t._stopCountDown(),t.$(".okta-waiting-spinner").show(),t.checkStatusTimeout=setTimeout((function(){t._checkStatus()}),200)):e-=1}),1e3)},_updateTitle:function(e){this.title=(0,o.loc)("polling.title","login",[e]),this.$el.find(".okta-form-title").text(this.title)},_stopCountDown:function(){this.countDown&&clearInterval(this.countDown),this.checkStatusTimeout&&clearInterval(this.checkStatusTimeout)},initialize:function(e){this.transactionObject=e.appState.get("transaction"),this.factorPollingIntervalSeconds=Math.ceil(this.transactionObject.transaction.profile.refresh/1e3),this._updateTitle(this.factorPollingIntervalSeconds),this._startCountDown(this.factorPollingIntervalSeconds)}},back:function(){},remove:function(){this.form._stopCountDown()}});t.default=s,e.exports=t.default},23947:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(28528)),a=r(n(96336)),s=r(n(75104)),l=r(n(65422)),u=r(n(25708)),c=r(n(89365)),d=r(n(83536)),f=r(n(41706)),p=a.default.extend({className:"primary-auth",state:{enabled:!0},View:u.default,constructor:function(e){e.appState.unset("username"),this.model=new i.default({multiOptionalFactorEnroll:e.settings.get("features.multiOptionalFactorEnroll"),settings:e.settings,appState:e.appState},{parse:!0}),a.default.apply(this,arguments),this.addListeners(),e.settings.get("hasConfiguredButtons")&&this.add(l.default,{prepend:e.settings.get("socialAuthPositionTop"),options:{currentController:this}}),this.addFooter(e),this.options.appState.get("disableUsername")&&this.addFooterWithBackLink(this.options),this.setUsername()},addFooter:function(e){this.add(new c.default(this.toJSON({appState:e.appState}))),(e.settings.get("features.registration")||e.appState.get("isIdxStateToken"))&&this.add(new d.default({settings:this.settings,appState:e.appState}))},addFooterWithBackLink:function(e){this.$el.find(".footer-back-link").length||this.add(new f.default(this.toJSON({appState:e.appState,className:"auth-footer footer-back-link"})))},setUsername:function(){var e=this.model.get("username");e&&this.options.appState.set("username",e)},setUsernameFromIdpDiscovery:function(){var e=this.options.username;e&&(this.model.set("username",e),this.options.appState.set("disableUsername",!0))},events:{"focusout input[name=username]":function(){if(this.shouldComputeDeviceFingerprint()&&this.model.get("username")){var e=this;this.options.appState.trigger("loading",!0),s.default.generateDeviceFingerprint(this.settings.getAuthClient(),this.$el[0]).then((function(t){e.options.appState.set("deviceFingerprint",t),e.options.appState.set("username",e.model.get("username"))})).catch((function(){e.options.appState.set("username",e.model.get("username"))})).finally((function(){e.options.appState.trigger("loading",!1)}))}else this.options.appState.set("username",this.model.get("username"))},"focusin input":function(e){(0,o.$)(e.target.parentElement).addClass("focused-input")},"focusout input":function(e){(0,o.$)(e.target.parentElement).removeClass("focused-input")}},initialize:function(){this.options.appState.unset("deviceFingerprint"),this.settings.get("features.prefillUsernameFromIdpDiscovery")&&this.setUsernameFromIdpDiscovery(),this.listenTo(this.model,"change:username",(function(e,t){t||this.options.appState.set("username","")})),this.listenTo(this.model,"save",(function(){this.state.set("enabled",!1)})),this.listenTo(this.model,"error",(function(){this.state.set("enabled",!0),this.options.appState.get("disableUsername")&&(this.state.set("disableUsername",!0),this.addFooterWithBackLink(this.options))})),this.listenTo(this.state,"togglePrimaryAuthButton",(function(e){this.toggleButtonState(e)}))},shouldComputeDeviceFingerprint:function(){return this.settings.get("features.securityImage")&&this.settings.get("features.deviceFingerprinting")&&this.settings.get("features.useDeviceFingerprintForSecurityImage")}});t.default=p,e.exports=t.default},33243:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(73650)),l=r(n(39694)),u=s.default.extend({className:"password-reset-email-sent",Model:function(){return{local:{userFullName:["string",!1,this.options.appState.get("userFullName")]}}},Form:{title:i._.partial(i.loc,"password.forgot.emailSent.title","login"),subtitle:function(){var e=this.options.appState.get("username");return(0,i.loc)("password.forgot.emailSent.desc","login",[e])},noButtonBar:!0,attributes:{"data-se":"pwd-reset-email-sent"},formChildren:function(){var e=[l.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="accessibility-text" role="status">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"alert")||(null!=t?a(t,"alert"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"alert",hash:{},data:o,loc:{start:{line:1,column:47},end:{line:1,column:56}}}):i)+"</span>"},useData:!0}),getTemplateData:function(){return{alert:(0,i.loc)("password.forgot.emailSent.title","login")}}})})];return this.settings.get("features.hideBackToSignInForReset")||e.push(l.default.Button({title:(0,i.loc)("goback","login"),className:"button button-primary button-wide",attributes:{"data-se":"back-button"},click:function(){var e=this;return this.model.doTransaction((function(e){return e.cancel()})).then((function(){e.state.set("navigateDir",a.default.DIRECTION_BACK),e.options.appState.trigger("navigate","")}))}})),e}},initialize:function(e){this.settings.callGlobalSuccess(a.default.FORGOT_PASSWORD_EMAIL_SENT,{username:e.appState.get("username")})}});t.default=u,e.exports=t.default},46615:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(73650)),l=r(n(39694)),u=r(n(88522)),c=r(n(50160)),d=s.default.extend({className:"recovery-challenge",Model:{props:{passCode:["string",!0]},local:{ableToResend:"boolean"},resendCode:function(){return this.limitResending(),this.doTransaction((function(e){return e.resend()}))},limitResending:function(){this.set({ableToResend:!1}),i._.delay(i._.bind(this.set,this),a.default.API_RATE_LIMIT,{ableToResend:!0})},save:function(){return this.doTransaction((function(e){return e.verify({passCode:this.get("passCode")})}))}},Form:{autoSave:!0,save:i._.partial(i.loc,"mfa.challenge.verify","login"),title:function(){return this.options.appState.get("factorType")===a.default.RECOVERY_FACTOR_TYPE_CALL?(0,i.loc)("recoveryChallenge.call.title","login"):(0,i.loc)("recoveryChallenge.sms.title","login")},className:"recovery-challenge",initialize:function(){this.listenTo(this.model,"error",(function(){this.clearErrors()}))},formChildren:function(){return[l.default.Button({title:(0,i.loc)("mfa.resendCode","login"),attributes:{"data-se":"resend-button"},className:"button sms-request-button margin-top-30",click:function(){this.model.resendCode()},initialize:function(){this.listenTo(this.model,"change:ableToResend",(function(e,t){t?(this.options.title=(0,i.loc)("mfa.resendCode","login"),this.enable(),this.render()):(this.options.title=(0,i.loc)("mfa.sent","login"),this.disable(),this.render())}))}}),l.default.Input({label:(0,i.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,className:"enroll-sms-phone",name:"passCode",input:c.default,type:"text"})]}},events:{"click .send-email-link":function(e){e.preventDefault();var t=this.model.settings,n=this.options.appState.get("username"),r=this.options.appState.get("recoveryType");this.model.startTransaction((function(e){switch(r){case a.default.RECOVERY_TYPE_PASSWORD:return e.forgotPassword({username:t.transformUsername(n,a.default.FORGOT_PASSWORD),factorType:a.default.RECOVERY_FACTOR_TYPE_EMAIL});case a.default.RECOVERY_TYPE_UNLOCK:return e.unlockAccount({username:t.transformUsername(n,a.default.UNLOCK_ACCOUNT),factorType:a.default.RECOVERY_FACTOR_TYPE_EMAIL});default:return}})).catch((function(){}))}},initialize:function(){var e;switch(this.options.appState.get("recoveryType")){case a.default.RECOVERY_TYPE_PASSWORD:e=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"password.forgot.code.notReceived"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:63}}}))},useData:!0});break;case a.default.RECOVERY_TYPE_UNLOCK:e=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"account.unlock.code.notReceived"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:62}}}))},useData:!0})}e&&this.settings.get("features.emailRecovery")&&this.add(i.View.extend({className:"link send-email-link",tagName:"a",attributes:{href:"#","data-se":"send-email-link"},template:e})),this.settings.get("features.hideBackToSignInForReset")||this.addFooter(u.default)},postRender:function(){this.model.limitResending()}});t.default=d,e.exports=t.default},79518:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985));function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}var a=r(n(73650)).default.extend({className:"recovery-loading",Model:{},Form:{noButtonBar:!0},initialize:function(e){var t=this,n=this.options.settings.get("features.multiOptionalFactorEnroll");return this.model.startTransaction((function(t){return t.verifyRecoveryToken(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({recoveryToken:e.token},n&&{multiOptionalFactorEnroll:n}))})).catch((function(){t.options.appState.trigger("loading",!1),t.options.appState.trigger("removeLoading")}))},preRender:function(){this.options.appState.trigger("loading",!0)},trapAuthResponse:function(){return this.options.appState.trigger("loading",!1),!1}});t.default=a,e.exports=t.default},79636:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(88522)),l=r(n(50160)),u=i.default.extend({className:"recovery-question",Model:{props:{answer:["string",!0],showAnswer:"boolean"},save:function(){return this.doTransaction((function(e){return e.answer({answer:this.get("answer")})}))}},Form:{autoSave:!0,save:function(){switch(this.options.appState.get("recoveryType")){case"PASSWORD":return(0,o.loc)("password.forgot.question.submit","login");case"UNLOCK":return(0,o.loc)("account.unlock.question.submit","login");default:return(0,o.loc)("mfa.challenge.verify","login")}},title:function(){switch(this.options.appState.get("recoveryType")){case"PASSWORD":return(0,o.loc)("password.forgot.question.title","login");case"UNLOCK":return(0,o.loc)("account.unlock.question.title","login");default:return""}},formChildren:function(){return[a.default.Input({label:this.options.appState.get("recoveryQuestion"),placeholder:(0,o.loc)("mfa.challenge.answer.placeholder","login"),name:"answer",input:l.default,type:"password",initialize:function(){this.listenTo(this.model,"change:showAnswer",(function(){var e=this.model.get("showAnswer")?"text":"password";this.getInputs()[0].changeType(e)}))}}),a.default.Input({label:!1,"label-top":!0,placeholder:(0,o.loc)("mfa.challenge.answer.showAnswer","login"),className:"recovery-question-show margin-btm-0",name:"showAnswer",type:"checkbox"})]}},initialize:function(){this.settings.get("features.hideBackToSignInForReset")||this.addFooter(s.default)}});t.default=u,e.exports=t.default},30929:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(73650)),i=o.default.extend({className:"refresh-auth-state",Model:{},Form:{noButtonBar:!0},preRender:function(){var e=this.options.appState,t=this.options.token;this.model.startTransaction((function(n){return e.trigger("loading",!0),t?n.tx.introspect({stateToken:t}):n.tx.exists()?n.tx.resume():void e.trigger("navigate","")}))},remove:function(){return this.options.appState.trigger("loading",!1),o.default.prototype.remove.apply(this,arguments)}});t.default=i,e.exports=t.default},94617:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(35546)),l=r(n(73650)),u=r(n(39694)),c=l.default.extend({events:{"click .back-btn":function(e){e.preventDefault(),this.back()}},back:function(){this.state.set("navigateDir",s.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")},className:"registration-complete",Model:function(){},initialize:function(){this.settings.callGlobalSuccess(s.default.ACTIVATION_EMAIL_SENT,{username:this.options.appState.get("username")})},Form:{noButtonBar:!0,formChildren:function(){return[u.default.View({View:a.View.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="container"><span class="title-icon icon icon-16 confirm-16-green"></span><h2 class="title">'+c((a=null!=(a=d(n,"title")||(null!=t?d(t,"title"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"title",hash:{},data:i,loc:{start:{line:1,column:103},end:{line:1,column:112}}}):a))+'</h2><div class="desc">'+c((a=null!=(a=d(n,"desc")||(null!=t?d(t,"desc"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"desc",hash:{},data:i,loc:{start:{line:1,column:135},end:{line:1,column:143}}}):a))+'</div></div><a href="#" class="back-btn" data-se="back-link">'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"goback"},data:i,loc:{start:{line:1,column:204},end:{line:1,column:241}}}))+"</a>"},useData:!0}),getTemplateData:function(){return{desc:(0,a.loc)("registration.complete.confirm.text","login"),title:(0,a.loc)("registration.complete.title","login")}}})})]}}});t.default=c,e.exports=t.default},78070:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(97020)),s=r(n(71440)),l=r(n(6321)),u=r(n(96336)),c=r(n(35546)),d=n(13671),f=r(n(37197)),p=r(n(90570)),h=r(n(41797)),m=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"goback"},data:o,loc:{start:{line:1,column:50},end:{line:1,column:87}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .help":function(e){e.preventDefault(),this.back()}},back:function(){this.state.set("navigateDir",c.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}}),v=u.default.extend({className:"registration",initialize:function(){var e=new(s.default.extend({settings:this.options.settings,url:this.options.settings.get("baseUrl")+"/api/v1/registration/form"}));this.state.set("schema",e)},getRegistrationApiUrl:function(){var e=this.settings.get("defaultPolicyId"),t=this.options.settings.get("policyId");return e?this.getRegistrationPolicyApi(e):this.getRegistrationPolicyApi(t)},getRegistrationPolicyApi:function(e){return this.options.settings.get("baseUrl")+"/api/v1/registration/"+e},doPostSubmit:function(){if(this.model.get("activationToken")){var e=this;e.settings.callGlobalSuccess(c.default.REGISTRATION_COMPLETE,{activationToken:this.model.get("activationToken")}),new a.default({settings:e.model.appState.settings}).loginWithActivationToken(this.model.get("activationToken")).then((function(t){e.model.trigger("setTransaction",t)}))}else this.model.appState.set("username",this.model.get("email")),this.model.appState.trigger("navigate","signin/register-complete")},registerUser:function(e){var t=this,n=this;Object.keys(e).forEach((function(t){return(i._.isNull(e[t])||i._.isUndefined(e[t])||""===e[t])&&delete e[t]})),this.model.attributes=e,i.Backbone.Model.prototype.save.call(this.model).then((function(){n.model.trigger("startSaving");var e=n.model.get("activationToken"),t=e||n.model.get("email");n.settings.postRegistrationSubmit(t,(function(){n.doPostSubmit()}),(function(e){n.showErrors(e)}))})).fail((function(e){var n=e.responseJSON;if(n&&n.errorCauses.length){var r=n.errorCode,o=n.errorCauses[0],i=o.errorSummary,a=o.reason,s=o.location;"E0000001"===r&&"UNIQUE_CONSTRAINT"===a&&t.renderIsNotUniqueError(n),t.renderLegacyLocationErrorIfNeeded(s,i),p.default.triggerAfterError(t,new d.RegistrationError(i))}}))},renderIsNotUniqueError:function(e){var t=e.errorCauses[0].location,n=(0,i.loc)("registration.error.userName.notUniqueWithinOrg","login",[t]);this.$el.find(".okta-form-infobox-error p").text(n)},renderLegacyLocationErrorIfNeeded:function(e,t){e&&/^data\.userProfile.*/.test(e)&&this.$el.find(".okta-form-infobox-error p").text(t)},createRegistrationModel:function(e){var t=this,n=i.Model.extend({url:t.getRegistrationApiUrl()+"/register",settings:this.settings,appState:this.options.appState,props:e,local:{activationToken:"string"},toJSON:function(){var e=i.Model.prototype.toJSON.apply(this,arguments);return{userProfile:e,relayState:this.settings.get("relayState")}},parse:function(e){return this.set("activationToken",e.activationToken),delete e.activationToken,e},save:function(){this.settings.preRegistrationSubmit(this.attributes,(function(e){t.registerUser(e)}),(function(e){t.showErrors(e)}))}});return new n},showErrors:function(e,t){"parseRegistrationSchema"===e.callback&&e.errorCauses&&(e.errorSummary=i._.clone(e.errorCauses[0].errorSummary),delete e.errorCauses),this.model.trigger("error",this.model,{responseJSON:e});var n=e.callback?e.callback+":"+e.errorSummary:e.errorSummary;p.default.triggerAfterError(this,new d.RegistrationError(n)),t&&this.$el.find(".button-primary").hide()},fetchInitialData:function(){var e=this;return e.state.get("schema").on("parseComplete",(function(t){var n=t.properties.createModelProperties();e.settings.set("defaultPolicyId",t.properties.defaultPolicyId),e.model=e.createRegistrationModel(n);var r=new(i.Form.extend({layout:"o-form-theme",autoSave:!0,noCancelButton:!0,title:(0,i.loc)("registration.form.title","login"),save:(0,i.loc)("registration.form.submit","login"),modelEvents:{invalid:"modifyErrors"},hasSavingState:!0,customSavingState:{start:"startSaving",stop:"stopSaving"},modifyErrors:function(e,t){for(var n in t)"model.validation.field.string.minLength"===t[n]?t[n]=(0,i.loc)("registration.model.validation.field.string.too.short","login",[e.props[n].minLength]):"model.validation.field.string.maxLength"===t[n]&&(t[n]=(0,i.loc)("registration.model.validation.field.string.too.long","login",[e.props[n].maxLength+1]))}}))(e.toJSON());if(e.add(r),e.footer=new e.Footer(e.toJSON()),e.add(e.footer),e.addListeners(),t.error)e.showErrors(t.error,!0);else{t.properties.each((function(e){var t=f.default.createInputOptions(e),n=e.get("subSchemas"),o=e.get("name");r.addInput(t),"password"===o&&n&&r.add(h.default.extend({id:"subschemas-"+o,subSchemas:n}))}));var a=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="required-fields-label">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"label")||(null!=t?a(t,"label"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"label",hash:{},data:o,loc:{start:{line:1,column:36},end:{line:1,column:45}}}):i)+"</span>"},useData:!0})({label:(0,i.loc)("registration.required.fields.label","login")});r.add(a)}})),(0,l.default)(this.state.get("schema").fetch())},Footer:m});t.default=v,e.exports=t.default},72468:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(73650)),l=r(n(39694)),u=r(n(90570)),c=r(n(78419)),d=r(n(17849)),f=r(n(50160)),p=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"account.unlock.noFactorsEnabled"},data:o,loc:{start:{line:1,column:110},end:{line:1,column:172}}}))+"</p></div>"},useData:!0})}),h=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link goto js-contact-support">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"mfa.noAccessToEmail"},data:o,loc:{start:{line:1,column:173},end:{line:1,column:223}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"goback"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:95}}}))+"</a>"+(null!=(i=s(n,"if").call(a,null!=t?s(t,"helpSupportNumber"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:99},end:{line:1,column:234}}}))?i:"")},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()},"click .js-contact-support":function(e){e.preventDefault(),this.state.trigger("contactSupport"),this.$(".js-contact-support").hide()}},getTemplateData:function(){return this.settings.pick("helpSupportNumber")},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}}),m=s.default.extend({className:"account-unlock",Model:{props:{username:["string",!0],factorType:["string",!0]},validate:function(){return c.default.validateUsername(this)},save:function(){var e=this;return this.startTransaction((function(t){return t.unlockAccount({username:e.settings.transformUsername(e.get("username"),a.default.UNLOCK_ACCOUNT),factorType:e.get("factorType")})})).catch((function(){}))}},Form:{noButtonBar:!0,title:i._.partial(i.loc,"account.unlock.title","login"),formChildren:function(){var e=this.settings.get("features.smsRecovery"),t=this.settings.get("features.callRecovery"),n=this.settings.get("features.emailRecovery"),r=[],s=this;return!(e||t||n)?this.add(p,".o-form-error-container"):(r.push(l.default.Input({label:(0,i.loc)("account.unlock.email.or.username.placeholder","login"),"label-top":!0,explain:u.default.createInputExplain("account.unlock.email.or.username.tooltip","account.unlock.email.or.username.placeholder","login"),"explain-top":!0,name:"username",input:f.default,inputId:"account-recovery-username",type:"text",inlineValidation:!1})),(e||t)&&r.push(l.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="mobile-recovery-hint">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"mobileFactors",bundle:"login",code:"recovery.mobile.hint"},data:o,loc:{start:{line:1,column:32},end:{line:1,column:109}}}))+"</p>"},useData:!0}),getTemplateData:function(){return{mobileFactors:e&&t?(0,i.loc)("recovery.smsOrCall"):t?(0,i.loc)("recovery.call"):(0,i.loc)("recovery.sms")}}})})),e&&(this.$el.addClass("forgot-password-sms-enabled"),r.push(this.createRecoveryFactorButton("sms-button","account.unlock.sendText",a.default.RECOVERY_FACTOR_TYPE_SMS,s)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)),t&&(this.$el.addClass("forgot-password-call-enabled"),r.push(this.createRecoveryFactorButton("call-button","account.unlock.voiceCall",a.default.RECOVERY_FACTOR_TYPE_CALL,s)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)),n&&(this.$el.addClass("forgot-password-email-enabled"),r.push(this.createRecoveryFactorButton("email-button","account.unlock.sendEmail",a.default.RECOVERY_FACTOR_TYPE_EMAIL,s)),this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))),r},initialize:function(){this.listenTo(this,"save",(function(){this.options.appState.set("username",this.model.get("username")),this.model.save()})),this.listenTo(this.state,"contactSupport",(function(){this.add(d.default,".o-form-error-container")}))},setDefaultFactorType:function(e){i._.isEmpty(this.model.get("factorType"))&&this.model.set("factorType",e)},createRecoveryFactorButton:function(e,t,n,r){return l.default.Button({attributes:{"data-se":e},className:"button button-primary button-wide "+e,title:(0,i.loc)(t,"login"),click:function(){r.clearErrors(),this.model.isValid()&&(this.model.set("factorType",n),r.trigger("save",this.model))}})}},Footer:h});t.default=m,e.exports=t.default},15629:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(35546)),a=r(n(73650)),s=r(n(39694)),l=a.default.extend({className:"account-unlock-email-sent",Model:function(){return{local:{userFullName:["string",!1,this.options.appState.get("userFullName")]}}},Form:{title:o._.partial(o.loc,"account.unlock.emailSent.title","login"),subtitle:function(){var e=this.options.appState.get("username");return(0,o.loc)("account.unlock.emailSent.desc","login",[e])},noButtonBar:!0,attributes:{"data-se":"unlock-email-sent"},formChildren:function(){return[s.default.Button({title:(0,o.loc)("goback","login"),className:"button button-primary button-wide",attributes:{"data-se":"back-button"},click:function(){this.state.set("navigateDir",i.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}})]}},initialize:function(e){this.settings.callGlobalSuccess(i.default.UNLOCK_ACCOUNT_EMAIL_SENT,{username:e.appState.get("username")})}});t.default=l,e.exports=t.default},68358:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(73650)),s=r(n(39694)),l=r(n(81824)),u=r(n(71271)),c=o.internal.util.Util,d=a.default.extend({className:"verify-custom-factor custom-factor-form",Model:{props:{rememberDevice:"boolean"},initialize:function(){var e=i.default.getRememberDeviceValue(this.appState);this.set("rememberDevice",e),this.settings.get("features.skipIdpFactorVerificationBtn")&&!this.appState.get("lastFailedChallengeFactorData")&&(this.set("provider","CUSTOM"),this.set("factorType","claims_provider"),this.save())},save:function(){var e=this,t=!!this.get("rememberDevice");return this.manageTransaction((function(n,r){var i={rememberDevice:t};return o._.findWhere(n.factors,{provider:e.get("provider"),factorType:e.get("factorType")}).verify(i).then((function(t){r(t);var n=e.appState.get("verifyCustomFactorRedirectUrl");null!==n&&c.redirect(n)})).catch((function(e){throw e}))}))}},Form:function(){var e=this,t=this.options.appState.get("factors").findWhere({provider:this.options.provider,factorType:this.options.factorType}).get("vendorName"),n=(0,o.loc)("mfa.challenge.verify","login"),r=this.options.appState.get("lastFailedChallengeFactorData"),i=(0,o.loc)("verify.customFactor.subtitle","login",[t]);return this.settings.get("features.skipIdpFactorVerificationBtn")&&!r&&(i=(0,o.loc)("verify.customFactor.subtitle.redirect","login",[t]),this.listenTo(this.model,"error",(function(){i=(0,o.loc)("verify.customFactor.subtitle","login",[t]),e.$(".o-form-explain").text(i)}))),{autoSave:!0,title:t,save:n,subtitle:i,attributes:{"data-se":"factor-custom"},initialize:function(){this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})},formChildren:function(){var e=[],t=this.options.appState.get("lastFailedChallengeFactorData");return this.settings.get("features.skipIdpFactorVerificationBtn")&&!t&&e.push(s.default.View({View:'<div data-se="custom-factor-waiting" class="okta-waiting-spinner"></div>'})),t&&e.push(s.default.View({View:new l.default({message:t.errorMessage})},{selector:".o-form-error-container"})),e}}},postRender:function(){this.settings.get("features.skipIdpFactorVerificationBtn")&&!this.options.appState.get("lastFailedChallengeFactorData")&&(this.$(".o-form-button-bar").hide(),this.$(".okta-waiting-spinner").show())},trapAuthResponse:function(){if(this.options.appState.get("isMfaChallenge"))return!0},back:function(){},initialize:function(){var e=this;this.model.set("provider",this.options.provider),this.model.set("factorType",this.options.factorType),this.settings.get("features.skipIdpFactorVerificationBtn")&&this.listenTo(this.model,"error",(function(){e.$(".okta-waiting-spinner").hide(),e.$(".o-form-button-bar").show()})),this.addFooter(u.default)}});t.default=d,e.exports=t.default},38864:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(79084)),a=r(n(6321)),s=r(n(2645)),l=r(n(73650)),u=r(n(71271)),c=l.default.extend({className:"mfa-verify-duo duo-form",Model:{props:{host:"string",signature:"string",postAction:"string",factorId:"string",stateToken:"string",rememberDevice:"boolean"},initialize:function(){var e=s.default.getRememberDeviceValue(this.appState);this.set("rememberDevice",e)},getInitOptions:function(){var e=!!this.get("rememberDevice");return this.doTransaction((function(t){var n={rememberDevice:e};return o._.findWhere(t.factors,{provider:"DUO",factorType:"web"}).verify(n).catch((function(e){throw e}))}),!0)},verify:function(e){var t=this.get("postAction"),n=this.get("factorId"),r=this,i={id:n,stateToken:this.get("stateToken"),sig_response:e},s=this.get("rememberDevice");return(0,a.default)(o.$.post(t,i)).then((function(){return r.doTransaction((function(e){var t;return s&&(t={rememberDevice:s}),e.poll(t)}))})).catch((function(e){r.trigger("error",r,e.xhr)}))}},Form:{autoSave:!0,noButtonBar:!0,title:o._.partial(o.loc,"factor.duo"),attributes:{"data-se":"factor-duo"},postRender:function(){this.add('<iframe frameborder="0" title="'+this.title()+'"></iframe>'),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"}),i.default.init({host:this.model.get("host"),sig_request:this.model.get("signature"),iframe:this.$("iframe").get(0),post_action:o._.bind(this.model.verify,this.model)})}},fetchInitialData:function(){var e=this;return this.model.getInitOptions().then((function(t){var n=t.data;if(!(n._embedded&&n._embedded.factor&&n._embedded.factor._embedded&&n._embedded.factor._embedded.verification))throw new Error("Response does not have duo verification options");var r=n._embedded.factor._embedded.verification;e.model.set({host:r.host,signature:r.signature,postAction:r._links.complete.href,factorId:n._embedded.factor.id,stateToken:n.stateToken})}))},trapAuthResponse:function(){if(this.options.appState.get("isMfaChallenge"))return!0},back:function(){},Footer:u.default});t.default=c,e.exports=t.default},92835:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o,i=r(n(70232)),a=r(n(31049)),s=r(n(2875)),l=n(6475),u=r(n(73650)),c=r(n(39694)),d=r(n(41706)),f=l.internal.util.Util,p=u.default.extend({className:"piv-cac-card",Model:{save:(o=(0,a.default)(i.default.mark((function e(){var t,n,r,o;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.trigger("request"),t=this,n=this.settings.get("piv"),r={fromURI:this.settings.get("relayState"),isCustomDomain:n.isCustomDomain,customDomain:n.customDomain},e.prev=4,e.next=7,this.getCert(n.certAuthUrl);case 7:return e.next=9,this.postCert(n.certAuthUrl,r);case 9:o=e.sent,f.redirect(o.redirectUrl),e.next=17;break;case 13:e.prev=13,e.t0=e.catch(4),l._.isEmpty(e.t0.responseJSON)&&!e.t0.responseText&&(e.t0.responseJSON={errorSummary:(0,l.loc)("piv.cac.error","login")}),t.trigger("error",t,e.t0);case 17:case"end":return e.stop()}}),e,this,[[4,13]])}))),function(){return o.apply(this,arguments)}),getCert:function(e){return l.$.get({url:e,xhrFields:{withCredentials:!0},beforeSend:function(){}})},postCert:function(e,t){return l.$.post({url:e,xhrFields:{withCredentials:!0},data:JSON.stringify(t),contentType:"text/plain",beforeSend:function(){}})}},Form:{autoSave:!0,hasSavingState:!1,title:l._.partial(l.loc,"piv.cac.title","login"),className:"piv-cac-card",noCancelButton:!0,save:l._.partial(l.loc,"retry","login"),modelEvents:{request:"_startEnrollment",error:"_stopEnrollment"},formChildren:[c.default.View({View:l.View.extend({template:s.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="piv-verify-text"><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"piv.cac.card.insert"},data:o,loc:{start:{line:1,column:32},end:{line:1,column:82}}}))+'</p><div data-se="piv-waiting" class="okta-waiting-spinner"></div></div>'},useData:!0})})})],_startEnrollment:function(){this.$(".okta-waiting-spinner").show(),this.$(".o-form-button-bar").hide()},_stopEnrollment:function(){this.$(".okta-waiting-spinner").hide(),this.$(".o-form-button-bar").show()},postRender:function(){var e=this;l._.defer((function(){e.model.save()}))}},back:function(){},Footer:d.default});t.default=p,e.exports=t.default},45375:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6321));n(83147);var s=n(13671),l=r(n(2645)),u=r(n(14726)),c=r(n(73650)),d=r(n(39694)),f=r(n(81824)),p=r(n(71271));var h=c.default.extend({className:"mfa-verify verify-u2f",Model:{props:{rememberDevice:"boolean"},initialize:function(){var e=l.default.getRememberDeviceValue(this.appState);this.set("rememberDevice",e)},save:function(){return this.trigger("request"),this.doTransaction((function(e){var t;t=e.factorTypes?i._.findWhere(e.factorTypes,{factorType:"u2f"}):i._.findWhere(e.factors,{factorType:"u2f",provider:"FIDO"});var n=this;return t.verify().then((function(e){var r,o,l;if(e.factors){var c=e.factors;o=c[0].profile.appId,l=e.challenge.nonce,r=function(e){var t=[];return i._.each(e,(function(e){t.push({version:e.profile.version,keyHandle:e.profile.credentialId})})),t}(c)}else{var d=e.factor;o=d.profile.appId,l=d.challenge.nonce,r=[{version:u.default.getU2fVersion(),keyHandle:d.profile.credentialId}]}n.trigger("request");var f=a.default.defer();return u2f.sign(o,l,r,(function(e){if(n.trigger("errors:clear"),!e.errorCode||0===e.errorCode){var r=!!n.get("rememberDevice");return t.verify({clientData:e.clientData,signatureData:e.signatureData,rememberDevice:r}).then(f.resolve)}var o=1===n.options.appState.get("factors").length;f.reject(new s.U2FError({xhr:{responseJSON:{errorSummary:u.default.getU2fVerifyErrorMessageByCode(e.errorCode,o)}}}))})),f.promise}))})).catch((function(){}))}},Form:{autoSave:!0,hasSavingState:!1,title:i._.partial(i.loc,"factor.u2f","login"),className:"verify-u2f-form",noCancelButton:!0,save:i._.partial(i.loc,"verify.u2f.retry","login"),noButtonBar:function(){return!u.default.isU2fAvailable()},modelEvents:{request:"_startEnrollment",error:"_stopEnrollment"},formChildren:function(){var e=[];if(u.default.isU2fAvailable())e.push(d.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="u2f-verify-text"><p>'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"verify.u2f.instructions"},data:o,loc:{start:{line:1,column:32},end:{line:1,column:86}}}))+"</p><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"verify.u2f.instructionsBluetooth"},data:o,loc:{start:{line:1,column:93},end:{line:1,column:156}}}))+'</p><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>'},useData:!0})})}));else{var t="u2f.error.factorNotSupported";1===this.options.appState.get("factors").length&&(t="u2f.error.factorNotSupported.oneFactor"),e.push(d.default.View({View:new f.default({message:(0,i.loc)(t,"login")})},{selector:".o-form-error-container"}))}return this.options.appState.get("allowRememberDevice")&&e.push(d.default.Input({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})),e},postRender:function(){var e=this;i._.defer((function(){u.default.isU2fAvailable()?e.model.save():e.$('[data-se="u2f-waiting"]').addClass("hide")}))},_startEnrollment:function(){this.$(".okta-waiting-spinner").removeClass("hide"),this.$(".o-form-button-bar").hide()},_stopEnrollment:function(){this.$(".okta-waiting-spinner").addClass("hide"),this.$(".o-form-button-bar").show()}},back:function(){},Footer:p.default});t.default=h,e.exports=t.default},25152:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6321)),s=r(n(76587)),l=n(13671),u=r(n(2645)),c=r(n(73650)),d=r(n(39694)),f=r(n(49268)),p=r(n(34425)),h=r(n(81824)),m=r(n(71271));function v(e){var t=[];return i._.each(e,(function(e){t.push({type:"public-key",id:s.default.strToBin(e.profile.credentialId)})})),t}var g=c.default.extend({className:"mfa-verify verify-webauthn",Model:{props:{rememberDevice:"boolean"},initialize:function(){var e=this,t=u.default.getRememberDeviceValue(this.appState);this.set("rememberDevice",t),this.appState.on("factorSwitched signOut",(function(){e.webauthnAbortController&&(e.webauthnAbortController.abort(),e.webauthnAbortController=null)}))},save:function(){return this.trigger("request"),this.doTransaction((function(e){var t;t=e.factorTypes?i._.findWhere(e.factorTypes,{factorType:"webauthn"}):i._.findWhere(e.factors,{factorType:"webauthn",provider:"FIDO"});var n=this;return t.verify().then((function(e){var r,o;if(e.factors){var u=e.factors;o=e.challenge,r=v(u)}else{var c=e.factor;o=c.challenge,r=v([c])}n.trigger("request");var d=i._.extend({},o,{allowCredentials:r,challenge:s.default.strToBin(o.challenge)});return"undefined"!=typeof AbortController&&(n.webauthnAbortController=new AbortController),new a.default(navigator.credentials.get({publicKey:d,signal:n.webauthnAbortController&&n.webauthnAbortController.signal})).then((function(e){var r=!!n.get("rememberDevice");return t.verify({clientData:s.default.binToStr(e.response.clientDataJSON),authenticatorData:s.default.binToStr(e.response.authenticatorData),signatureData:s.default.binToStr(e.response.signature),rememberDevice:r})})).catch((function(e){throw n.trigger("errors:clear"),n.webauthnAbortController?new l.WebAuthnError({xhr:{responseJSON:{errorSummary:e.message}}}):new l.WebauthnAbortError})).finally((function(){n.webauthnAbortController=null}))}))})).catch((function(){}))}},Form:{autoSave:!0,hasSavingState:!1,title:i._.partial(i.loc,"factor.webauthn.biometric","login"),className:"verify-webauthn-form",noCancelButton:!0,save:i._.partial(i.loc,"mfa.challenge.verify","login"),noButtonBar:function(){return!f.default.isNewApiAvailable()},modelEvents:{request:"_startEnrollment",error:"_stopEnrollment"},formChildren:function(){var e=[];if(f.default.isNewApiAvailable())e.push(d.default.View({View:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="webauthn-verify-text"><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"verify.webauthn.biometric.instructions"},data:o,loc:{start:{line:1,column:37},end:{line:1,column:106}}}))+'</p><div data-se="webauthn-waiting" class="okta-waiting-spinner"></div></div>'},useData:!0})})}));else{var t="webauthn.biometric.error.factorNotSupported";1===this.options.appState.get("factors").length&&(t="webauthn.biometric.error.factorNotSupported.oneFactor"),e.push(d.default.View({View:new h.default({message:(0,i.loc)(t,"login")})},{selector:".o-form-error-container"}))}return this.options.appState.get("allowRememberDevice")&&e.push(d.default.Input({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})),e},_startEnrollment:function(){this.$(".okta-waiting-spinner").show(),this.$(".o-form-button-bar").hide()},_stopEnrollment:function(){this.$(".okta-waiting-spinner").hide(),this.$('.o-form-button-bar [type="submit"]')[0].value=(0,i.loc)("verify.u2f.retry","login"),this.$(".o-form-button-bar").show()}},postRender:function(){var e=this;i._.defer((function(){f.default.isNewApiAvailable()&&!p.default.isSafari()&&e.model.save()}))},back:function(){},Footer:m.default});t.default=g,e.exports=t.default},73269:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(73650)),a=r(n(39694)),s=r(n(49268)),l=r(n(81824)),u=r(n(71271)),c=r(n(64521)),d=i.default.extend({className:"mfa-verify verify-windows-hello",Model:{local:{__autoTriggered__:"boolean"},save:function(){if(s.default.isAvailable()){this.trigger("request");var e=this;return this.doTransaction((function(t){var n=o._.findWhere(t.factors,{factorType:"webauthn",provider:"FIDO"});return n.verify().then((function(r){var o=r.factor;return s.default.getAssertion(o.challenge.nonce,[{id:o.profile.credentialId}]).then((function(e){return n.verify({authenticatorData:e.authenticatorData,clientData:e.clientData,signatureData:e.signature})})).then((function(t){return e.trigger("sync"),e.trigger("signIn"),t})).catch((function(n){switch(n.message){case"AbortError":case"NotFoundError":case"NotSupportedError":return e.trigger("abort",n.message),t}throw n}))}))}))}}},Form:{autoSave:!0,hasSavingState:!1,title:o._.partial(o.loc,"factor.windowsHello","login"),subtitle:function(){return s.default.isAvailable()?(0,o.loc)("verify.windowsHello.subtitle","login"):""},save:o._.partial(o.loc,"verify.windowsHello.save","login"),customSavingState:{stop:"abort"},modelEvents:function(){return s.default.isAvailable()?{request:"_startEnrollment",error:"_stopEnrollment",abort:"_stopEnrollment",signIn:"_successEnrollment"}:{}},noButtonBar:function(){return!s.default.isAvailable()},formChildren:function(){var e=[];return s.default.isAvailable()||e.push(a.default.View({View:new l.default({message:(0,o.loc)("enroll.windowsHello.error.notWindows","login")})},{selector:".o-form-error-container"})),e.push(a.default.View({View:new c.default({model:this.model,visible:!1})})),e},postRender:function(){1!==this.options.appState.get("factors").length||this.model.get("__autoTriggered__")||(this.model.set("__autoTriggered__",!0),this.model.save())},_startEnrollment:function(){this.subtitle=(0,o.loc)("verify.windowsHello.subtitle.loading","login"),this.model.trigger("spinner:show"),this._resetErrorMessage(),this.render(),this.$(".o-form-button-bar").addClass("hide")},_stopEnrollment:function(e){var t;switch(this.subtitle=(0,o.loc)("verify.windowsHello.subtitle","login"),this.model.trigger("spinner:hide"),this.$(".o-form-button-bar").removeClass("hide"),e){case"NotFoundError":t=this.options.appState.get("factors").length>1?(0,o.loc)("verify.windowsHello.error.notFound.selectAnother","login"):(0,o.loc)("verify.windowsHello.error.notFound","login");break;case"NotSupportedError":t=(0,o.loc)("enroll.windowsHello.error.notConfiguredHtml","login")}if(this._resetErrorMessage(),t){var n=new l.default({message:t});this.$(".o-form-error-container").addClass("o-form-has-errors"),this.add(n,{selector:".o-form-error-container"}),this._errorMessageView=this.last()}this.render()},_successEnrollment:function(){this.subtitle=this.settings.get("brandName")?(0,o.loc)("verify.windowsHello.subtitle.signingIn.specific","login",[this.settings.get("brandName")]):(0,o.loc)("verify.windowsHello.subtitle.signingIn.generic","login"),this.render(),this.$(".o-form-button-bar").addClass("hide")},_resetErrorMessage:function(){this._errorMessageView&&this._errorMessageView.remove(),this._errorMessageView=void 0,this.clearErrors()}},back:function(){},Footer:u.default});t.default=d,e.exports=t.default},58346:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0,t.getSecurityImageUrl=d;var o=n(6475),i=r(n(15073)),a=r(n(6321)),s=r(n(34425)),l=n(13671),u="/img/security/default.png",c="/img/security/unknown-device.png";function d(e,t){var n=encodeURIComponent(t);return"".concat(e,"/login/getimage?username=").concat(n)}var f=o.Model.extend({initialize:function(){if(this.settings.get("features.securityImage")){var e=this;this.listenTo(this,"change:username",(function(t,n){(function(e,t,n){if(o._.isEmpty(t)||o._.isUndefined(t))return(0,a.default)({securityImage:u,securityImageDescription:""});var r={url:d(e,t),dataType:"json"};return n&&(r.headers={"X-Device-Fingerprint":n}),(0,a.default)(o.$.ajax(r)).then((function(e){return"/img/security/unknown.png"===e.pwdImg?{securityImage:c,securityImageDescription:""}:{securityImage:e.pwdImg,securityImageDescription:e.imageDescription||""}}))})(this.get("baseUrl"),n,this.get("deviceFingerprint")).then((function(e){t.set("securityImage",e.securityImage),t.set("securityImageDescription",e.securityImageDescription),t.unset("deviceFingerprint")})).fail((function(t){s.default.corsIsNotEnabled(t)?e.settings.callGlobalError(new l.UnsupportedBrowserError((0,o.loc)("error.enabled.cors"))):e.settings.callGlobalError(new Error("Failed to fetch security image: ".concat(t.statusText)))})).done()}))}},local:{baseUrl:"string",lastAuthResponse:["object",!0,{}],transaction:"object",transactionError:"object",username:"string",factors:"object",policy:"object",securityImage:["string",!0,u],securityImageDescription:["string",!0,""],userCountryCode:"string",userPhoneNumber:"string",factorActivationType:"string",flashError:"object",beaconType:"string",deviceFingerprint:"string",typingPattern:"string",languageCode:["string",!0],disableUsername:["boolean",!1,!1],trapMfaRequiredResponse:["boolean",!1,!1],lastFailedChallengeFactorData:["object",!1]},setAuthResponse:function(e){var t=this;if(e._embedded&&e._embedded.policy&&this.set("policy",e._embedded.policy),e._embedded&&e._embedded.factors){var n=e._embedded.factors;e._embedded.factorTypes&&(n=function(e,t){var n=[],r=[];return o._.each(t,(function(t){var i=t.factorType;if(!o._.contains(n,i)){var a=o._.findWhere(e,{factorType:i});a?(n.push(i),r.push(a)):r.push(t)}})),r}(e._embedded.factorTypes,n));var r=o._.map(n,(function(e){return e.settings=t.settings,e.appState=t,e}));this.set("factors",new i.default.Collection(r,{parse:!0}))}this.set("lastAuthResponse",e)},clearLastAuthResponse:function(){this.set("lastAuthResponse",{})},setLastFailedChallengeFactorData:function(){this.set("lastFailedChallengeFactorData",{factor:this.get("factor"),errorMessage:this.get("factorResultErrorMessage")})},clearLastFailedChallengeFactorData:function(){this.unset("lastFailedChallengeFactorData")},getUser:function(){return this.get("user")},derived:{isSuccessResponse:{deps:["lastAuthResponse"],fn:function(e){return"SUCCESS"===e.status}},isMfaRequired:{deps:["lastAuthResponse"],fn:function(e){return"MFA_REQUIRED"===e.status||"FACTOR_REQUIRED"===e.status}},isProfileRequired:{deps:["lastAuthResponse"],fn:function(e){return"PROFILE_REQUIRED"===e.status}},isMfaEnroll:{deps:["lastAuthResponse"],fn:function(e){return"MFA_ENROLL"===e.status||"FACTOR_ENROLL"===e.status}},isMfaChallenge:{deps:["lastAuthResponse"],fn:function(e){return"MFA_CHALLENGE"===e.status||"FACTOR_CHALLENGE"===e.status}},isSMSPasswordRecovery:{deps:["lastAuthResponse"],fn:function(e){var t=e.status,n=e.factorType,r=e.recoveryType;return"RECOVERY_CHALLENGE"===t&&"sms"===(null==n?void 0:n.toLowerCase())&&"password"===(null==r?void 0:r.toLowerCase())}},isUnauthenticated:{deps:["lastAuthResponse"],fn:function(e){return"UNAUTHENTICATED"===e.status}},isMfaRejected:{deps:["lastAuthResponse"],fn:function(e){return"REJECTED"===e.factorResult}},isMfaTimeout:{deps:["lastAuthResponse"],fn:function(e){return"TIMEOUT"===e.factorResult}},isMfaEnrollActivate:{deps:["lastAuthResponse"],fn:function(e){return"MFA_ENROLL_ACTIVATE"===e.status||"FACTOR_ENROLL_ACTIVATE"===e.status}},isWaitingForActivation:{deps:["isMfaEnrollActivate","lastAuthResponse"],fn:function(e,t){return e&&"WAITING"===t.factorResult}},isWaitingForNumberChallenge:{deps:["lastAuthResponse","isMfaChallenge"],fn:function(e,t){return!!(t&&e&&"WAITING"===e.factorResult&&e._embedded&&e._embedded.factor&&e._embedded.factor._embedded&&e._embedded.factor._embedded.challenge)}},hasMultipleFactorsAvailable:{deps:["factors","isMfaRequired","isMfaChallenge","isUnauthenticated"],fn:function(e,t,n,r){return!!(t||n||r)&&(e&&e.length>1)}},promptForFactorInUnauthenticated:{deps:["lastAuthResponse","factors"],fn:function(e,t){return"UNAUTHENTICATED"===e.status&&(t&&t.length>0)}},userId:{deps:["lastAuthResponse"],fn:function(e){return e._embedded&&e._embedded.user?e._embedded.user.id:null}},isIdxStateToken:{deps:["lastAuthResponse"],fn:function(e){return e&&o._.isString(e.stateToken)&&e.stateToken.startsWith("01")}},isPwdExpiringSoon:{deps:["lastAuthResponse"],fn:function(e){return"PASSWORD_WARN"===e.status}},passwordExpireDays:{deps:["lastAuthResponse"],fn:function(e){return e._embedded&&e._embedded.policy&&e._embedded.policy.expiration?e._embedded.policy.expiration.passwordExpireDays:null}},isPwdManagedByOkta:{deps:["lastAuthResponse"],fn:function(e){return!(e._links&&e._links.next&&e._links.next.title)}},passwordExpiredWebsiteName:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.next&&e._links.next.title?e._links.next.title:null}},passwordExpiredLinkUrl:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.next&&e._links.next.title&&e._links.next.href?e._links.next.href:null}},recoveryType:{deps:["lastAuthResponse"],fn:function(e){return e.recoveryType}},factorType:{deps:["lastAuthResponse"],fn:function(e){return e.factorType}},factor:{deps:["lastAuthResponse"],fn:function(e){return e._embedded&&e._embedded.factor?e._embedded.factor:null}},activatedFactorId:{deps:["factor"],fn:function(e){return e?e.id:null}},activatedFactorType:{deps:["factor"],fn:function(e){return e?e.factorType:null}},activatedFactorProvider:{deps:["factor"],fn:function(e){return e?e.provider:null}},qrcode:{deps:["factor"],fn:function(e){try{return e._embedded.activation._links.qrcode.href}catch(e){return null}}},activationSendLinks:{deps:["factor"],fn:function(e){var t;try{t=e._embedded.activation._links.send}catch(e){t=[]}return t}},textActivationLinkUrl:{deps:["activationSendLinks"],fn:function(e){var t=o._.findWhere(e,{name:"sms"});return t?t.href:null}},emailActivationLinkUrl:{deps:["activationSendLinks"],fn:function(e){var t=o._.findWhere(e,{name:"email"});return t?t.href:null}},sharedSecret:{deps:["factor"],fn:function(e){try{return e._embedded.activation.sharedSecret}catch(e){return null}}},duoEnrollActivation:{deps:["factor"],fn:function(e){return e&&e._embedded&&e._embedded.activation?e._embedded.activation:null}},prevLink:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.prev?e._links.prev.href:null}},skipLink:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.skip?e._links.skip.href:null}},gracePeriodRemainingDays:{deps:["policy"],fn:function(e){return e&&e.gracePeriod&&e.gracePeriod.endDate?(t=e.gracePeriod.endDate,n=new Date(t).getTime(),Math.floor((n-(new Date).getTime())/864e5)):null;var t,n}},user:{deps:["lastAuthResponse"],fn:function(e){return e._embedded&&e._embedded.user?e._embedded.user:null}},recoveryQuestion:{deps:["user"],fn:function(e){return e&&e.recovery_question?e.recovery_question.question:null}},userProfile:{deps:["user"],fn:function(e){return e&&e.profile?e.profile:null}},userConsentName:{deps:["userProfile","username"],fn:function(e,t){return!e||o._.isEmpty(e.firstName)?t:o._.isEmpty(e.lastName)?e.firstName:e.firstName+" "+e.lastName.charAt(0)+"."}},userEmail:{deps:["userProfile"],fn:function(e){return e&&e.login?e.login:null}},userFullName:{deps:["userProfile"],fn:function(e){return e&&(e.firstName||e.lastName)?e.firstName+" "+e.lastName:""}},defaultAppLogo:{deps:["baseUrl"],fn:function(e){return e+"/img/logos/default.png"}},expiresAt:{deps:["lastAuthResponse"],fn:function(e){return e.expiresAt}},target:{deps:["lastAuthResponse"],fn:function(e){return e._embedded?e._embedded.target:null}},targetLabel:{deps:["target"],fn:function(e){return e?e.label:null}},targetLogo:{deps:["target"],fn:function(e){return e&&e._links?e._links.logo:null}},targetTermsOfService:{deps:["target"],fn:function(e){return e&&e._links?e._links["terms-of-service"]:null}},targetPrivacyPolicy:{deps:["target"],fn:function(e){return e&&e._links?e._links["privacy-policy"]:null}},targetClientURI:{deps:["target"],fn:function(e){return e&&e._links?e._links["client-uri"]:null}},scopes:{deps:["lastAuthResponse"],fn:function(e){return e._embedded?e._embedded.scopes:null}},issuer:{deps:["lastAuthResponse"],fn:function(e){var t,n,r;return null==e||null===(t=e._embedded)||void 0===t||null===(n=t.authentication)||void 0===n||null===(r=n.issuer)||void 0===r?void 0:r.uri}},hasExistingPhones:{deps:["lastAuthResponse"],fn:function(e){if(!e._embedded||!e._embedded.factors)return!1;var t=e._embedded.factors,n=o._.findWhere(t,{factorType:"sms",provider:"OKTA"});return!(!n||!n._embedded)&&!!n._embedded.phones.length}},hasExistingPhonesForCall:{deps:["lastAuthResponse"],fn:function(e){if(!e._embedded||!e._embedded.factors)return!1;var t=e._embedded.factors,n=o._.findWhere(t,{factorType:"call",provider:"OKTA"});return!(!n||!n._embedded)&&!!n._embedded.phones.length}},isUndefinedUser:{deps:["securityImage"],fn:function(e){return e===u}},isNewUser:{deps:["securityImage"],fn:function(e){return e===c}},allowRememberDevice:{deps:["policy"],fn:function(e){return e&&e.allowRememberDevice}},rememberDeviceLabel:{deps:["policy"],fn:function(e){if(e&&e.rememberDeviceLifetimeInMinutes>0){var t=function(e){if(e>60&&e<=1440){var t=e/60;return(0,o.loc)("hours","login",[t])}if(e>1440){var n=e/1440;return(0,o.loc)("days","login",[n])}return 1===e?(0,o.loc)("minutes.oneMinute","login"):(0,o.loc)("minutes","login",[e])}(e.rememberDeviceLifetimeInMinutes);return(0,o.loc)("rememberDevice.timebased","login",[t])}return e&&0===e.rememberDeviceLifetimeInMinutes?(0,o.loc)("rememberDevice.devicebased","login"):(0,o.loc)("rememberDevice","login")}},rememberDeviceByDefault:{deps:["policy"],fn:function(e){return e&&e.rememberDeviceByDefault}},factorsPolicyInfo:{deps:["policy"],fn:function(e){return e&&e.factorsPolicyInfo?e.factorsPolicyInfo:null}},verifyCustomFactorRedirectUrl:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.next&&"redirect"===e._links.next.name&&e._links.next.href?e._links.next.href:null}},enrollCustomFactorRedirectUrl:{deps:["lastAuthResponse"],fn:function(e){return e._links&&e._links.next&&"activate"===e._links.next.name&&e._links.next.href?e._links.next.href:null}},isFactorResultFailed:{deps:["lastAuthResponse"],fn:function(e){return"FAILED"===e.factorResult}},factorResultErrorMessage:{deps:["lastAuthResponse","isFactorResultFailed"],fn:function(e,t){return t?e.factorResultMessage||(0,o.loc)("oform.error.unexpected","login"):null}},deviceActivationStatus:{deps:["lastAuthResponse"],fn:function(e){return e._embedded?e._embedded.deviceActivationStatus:null}},usingDeviceFlow:{deps:["lastAuthResponse"],fn:function(e){return!(!e._embedded||!e._embedded.usingDeviceFlow)}},userCode:{deps:["lastAuthResponse"],fn:function(e){var t;return null==e||null===(t=e._embedded)||void 0===t?void 0:t.userCode}}},parse:function(e){return this.settings=e.settings,o._.extend(o._.omit(e,"settings"),{languageCode:this.settings.get("languageCode"),userCountryCode:this.settings.get("countryCode")})}});t.default=f},29685:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(6321)),a=r(n(35546)),s=["OAuthError","AuthSdkError","AuthPollStopError","AuthApiError"],l=o.Model.extend({doTransaction:function(e,t){var n=this;return e.call(this,this.appState.get("transaction")).then((function(e){return n.trigger("setTransaction",e),e})).catch((function(e){if("AuthPollStopError"!==e.name&&e.name!==a.default.AUTH_STOP_POLL_INITIATION_ERROR&&e.name!==a.default.WEBAUTHN_ABORT_ERROR&&(n.trigger("error",n,e.xhr),n.trigger("setTransactionError",e),t||-1===o._.indexOf(s,e.name)))throw e}))},manageTransaction:function(e){var t=this,n=e.call(this,this.appState.get("transaction"),o._.bind(this.setTransaction,this));return i.default.isPromiseAlike(n)?n.catch((function(e){"AuthPollStopError"!==e.name&&e.name!==a.default.AUTH_STOP_POLL_INITIATION_ERROR&&e.name!==a.default.WEBAUTHN_ABORT_ERROR&&(t.trigger("error",t,e.xhr),t.trigger("setTransactionError",e))})):i.default.resolve(n)},startTransaction:function(e){var t=this,n=e.call(this,this.settings.getAuthClient());return i.default.isPromiseAlike(n)?n.then((function(e){return t.trigger("setTransaction",e),e})).catch((function(e){throw t.trigger("error",t,e.xhr),t.trigger("setTransactionError",e),e})):i.default.resolve(n)},setTransaction:function(e){this.appState.set("transaction",e)}});t.default=l,e.exports=t.default},21749:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(29685)),a=i.default.extend({initialize:function(e){this.options=e||{},this.appState=this.options.appState},constructPostData:function(e){var t={registration:{profile:e}};return this.appState.get("policy").registration.createNewAccount&&(t.registration.createNewAccount=!0),t},getEnrollFormData:function(){return this.manageTransaction((function(e,t){return e.enroll().then((function(e){t(e)}))}))},save:function(){var e=i.default.prototype.toJSON.apply(this,arguments);if(e=o._.omit(e,["appState","settings","createNewAccount"]),!o._.isEmpty(e))return this.manageTransaction((function(t,n){t.enroll(this.constructPostData(e)).then((function(e){n(e)}))}));var t={errorSummary:(0,o.loc)("oform.errorbanner.title","login")};this.trigger("error",this,{responseJSON:t})}});t.default=a,e.exports=t.default},15073:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(6321)),a=n(13671),s=r(n(2645)),l=r(n(90570)),u=r(n(34425)),c=r(n(29685)),d=c.default.extend({extraProperties:!0,flat:!1,props:{id:"string",factorType:{type:"string",values:["sms","call","email","token","token:software:totp","token:hotp","token:hardware","question","push","u2f","password","assertion:saml2","assertion:oidc","claims_provider","webauthn"]},provider:{type:"string",values:["OKTA","RSA","DEL_OATH","SYMANTEC","GOOGLE","YUBICO","FIDO","CUSTOM","GENERIC_SAML","GENERIC_OIDC"]},enrollment:{type:"string",values:["OPTIONAL","REQUIRED"]},status:{type:"string",values:["NOT_SETUP","ACTIVE"]},profile:["object"],vendorName:"string",policy:["object"],profiles:["object"]},local:{answer:"string",password:"string",backupFactor:"object",showAnswer:"boolean",rememberDevice:"boolean",autoPush:["boolean",!0,!1]},derived:{isOktaFactor:{deps:["provider"],fn:function(e){return"OKTA"===e}},factorName:{deps:["provider","factorType"],fn:s.default.getFactorName},factorLabel:{deps:["provider","factorType","vendorName"],fn:function(e,t,n){return o._.contains(["DEL_OATH","GENERIC_SAML","GENERIC_OIDC","CUSTOM"],e)?n:s.default.getFactorLabel.apply(this,[e,t])}},factorDescription:{deps:["provider","factorType"],fn:s.default.getFactorDescription},sortOrder:{deps:["provider","factorType"],fn:s.default.getFactorSortOrder},iconClassName:{deps:["provider","factorType"],fn:s.default.getFactorIconClassName},securityQuestion:{deps:["profile","factorType"],fn:function(e,t){return"question"!==t?null:e&&s.default.getSecurityQuestionLabel(e)}},phoneNumber:{deps:["profile","factorType"],fn:function(e,t){return o._.contains(["sms","call"],t)?e&&e.phoneNumber:null}},email:{deps:["profile","factorType"],fn:function(e,t){return"email"===t?e&&e.email:null}},deviceName:{deps:["profile","factorType"],fn:function(e,t){return"push"!==t?null:e&&e.name}},enrolled:{deps:["status"],fn:function(e){return"ACTIVE"===e}},cardinality:{deps:["policy","profiles"],fn:function(e,t){if(t&&t.length>0){var n=t[0],r=n._embedded.enrolledFactors.length,i=o._.findWhere(n._embedded.features,{type:"adoption"});return!(!i||!i.cardinality)&&{enrolled:r,minimum:i.cardinality.min,maximum:i.cardinality.max}}return!(!e||!e.enrollment)&&e.enrollment}},additionalEnrollment:{deps:["cardinality"],fn:function(e){return!!e&&(0!==e.enrolled&&e.enrolled<e.maximum)}},required:{deps:["enrollment"],fn:function(e){return"REQUIRED"===e}},canUseResend:{deps:["provider","factorType"],fn:function(e,t){return"OKTA"===e&&o._.contains(["push","sms","call","email"],t)}},isAnswerRequired:{deps:["factorType"],fn:function(e){return o._.contains(["sms","call","email","token","token:software:totp","question"],e)}},isFactorTypeVerification:{deps:["provider","id"],fn:function(e,t){return void 0===e&&void 0===t}}},parse:function(e){return this.settings=e.settings,this.appState=e.appState,e.rememberDevice=s.default.getRememberDeviceValue(this.appState),this.setCustomHotpVendorName(e),o._.omit(e,["settings","appState"])},validate:function(){return this.get("isAnswerRequired")&&!this.get("answer")?{answer:(0,o.loc)("model.validation.field.blank")}:"password"!==this.get("factorType")||this.get("password")?void 0:{password:(0,o.loc)("error.password.required")}},needsPasscode:function(){return!(this.options.appState.get("isIdxStateToken")&&"email"===this.get("factorType"))},resend:function(){return this.trigger("form:clear-errors"),this.manageTransaction((function(e){var t=e.data._links.resend[0];return e.resend(t.name)}))},save:function(){var e=!!this.get("rememberDevice"),t=this;return this.manageTransaction((function(n,r){var o,s={rememberDevice:e};if("question"===this.get("factorType")?s.answer=this.get("answer"):"password"===this.get("factorType")?s.password=this.get("password"):this.needsPasscode()&&(s.passCode=this.get("answer")),this.pushFactorHasAutoPush()&&(s.autoPush=this.get("autoPush")),"MFA_REQUIRED"===n.status||"FACTOR_REQUIRED"===n.status||this.appState.get("promptForFactorInUnauthenticated"))o=this._findFactor(n).verify(s);else if(this.get("canUseResend")&&!this.get("answer")&&n.resend){var c=n.data._links.resend[0];o=n.resend(c.name)}else o=n.verify(s);return this.trigger("save"),o.then((function(e){var n=!1,o={delay:4e3,transactionCallBack:function(e){n=!0,t.options.appState.set("lastAuthResponse",e)}};if(r(e),"MFA_CHALLENGE"===e.status&&e.poll||"FACTOR_CHALLENGE"===e.status&&e.poll){var s=i.default.defer(),c=l.default.callAfterTimeoutOrWindowRefocus(s.resolve,4e3);return t.listenToOnce(t.options.appState,"factorSwitched",(function(){c(),s.reject(new a.AuthStopPollInitiationError)})),s.promise.then((function(){var a,s,c;(t.stopListening(t.options.appState,"factorSwitched"),t.pushFactorHasAutoPush()&&(o.autoPush=function(){return t.get("autoPush")},o.rememberDevice=function(){return t.get("rememberDevice")}),u.default.isIOS())?a=i.default.race([e.poll(o),(c=i.default.defer(),s=l.default.callAfterTimeoutOrWindowRefocus(c.resolve,2e3,!0),c.promise.then((function(){return n?i.default.defer().promise:e.poll(o)})))]).then((function(e){return s(),e})):a=e.poll(o);return a.then((function(e){t.options.appState.set("lastAuthResponse",e.data),r(e)}))}))}}))}))},_findFactor:function(e){var t;return e.factorTypes&&(t=o._.findWhere(e.factorTypes,{factorType:this.get("factorType")})),t||(t=o._.findWhere(e.factors,{id:this.get("id")})),t},pushFactorHasAutoPush:function(){return this.settings.get("features.autoPush")&&"push"===this.get("factorType")},setCustomHotpVendorName:function(e){if("token:hotp"===e.factorType&&e.profiles)if("NOT_SETUP"===e.status)e.vendorName=e.profiles[0].name;else if("ACTIVE"===e.status){var t=e.profiles.filter((function(e){return e._embedded.enrolledFactors.length>0}));e.vendorName=t[0].name}return e}}),f=o.Collection.extend({model:d,comparator:"sortOrder",parse:function(e){this.lastUsedFactor=e[0];var t,n=o._.findWhere(e,{provider:"OKTA",factorType:"push"});if(t=o._.where(e,{factorType:"push"}).length>1?o._.findWhere(e,{factorType:"token:software:totp"}):o._.findWhere(e,{provider:"OKTA",factorType:"token:software:totp"}),!n||!t)return e;var r=t===e[0],i=o._.reduce(e,(function(e,r){var o="OKTA"===r.provider,i=o&&"token:software:totp"===r.factorType,a=o&&"push"===r.factorType,s="ACTIVE"!==r.status,l=i&&(s||"ACTIVE"===n.status),u=a&&s&&"ACTIVE"===t.status;return l||u||(a&&(r.backupFactor=new d(t,{parse:!0})),e.push(r)),e}),[]);return r&&(this.lastUsedFactor=n),i},getDefaultFactor:function(){var e=o._.pick(this.lastUsedFactor,"factorType","provider");return this.findWhere(e)},getFirstUnenrolledRequiredFactor:function(){return this.findWhere({required:!0,enrolled:!1})},_getFactorsOfType:function(e){return this.where({factorType:e})},getFactorIndex:function(e,t){return this._getFactorsOfType(e).findIndex((function(e){return e.get("id")===t}))},hasMultipleFactorsOfSameType:function(e){return this._getFactorsOfType(e).length>1},getFactorByTypeAndIndex:function(e,t){return this._getFactorsOfType(e)[t]}}),p={Model:d,Collection:f};t.default=p,e.exports=t.default},31749:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(28528)),a=r(n(26368)),s=r(n(35546)),l=r(n(90570)),u=i.default.extend({props:function(){var e=a.default.getCookieUsername(),t=this.getUsernameAndRemember(e);return{username:["string",!0,t.username],lastUsername:["string",!1,e],context:["object",!1],remember:["boolean",!0,t.remember]}},local:{},save:function(){var e=this,t=this.settings.transformUsername(this.get("username"),s.default.IDP_DISCOVERY),n=this.get("remember"),r=this.get("lastUsername"),i="okta:acct:"+t,u=this.get("requestContext");this.setUsernameCookie(t,n,r),this.trigger("save"),this.appState.trigger("loading",!0);var c={resource:i,requestContext:u};this.appState.settings.getAuthClient().webfinger(c).then((function(t){if(t&&t.links&&t.links[0])if("OKTA"===t.links[0].properties["okta:idp:type"])e.trigger("goToPrimaryAuth");else if(t.links[0].href){(t.links[0].href.includes("OKTA_INVALID_SESSION_REPOST%3Dtrue")?l.default.redirectWithFormGet.bind(l.default):e.settings.get("redirectUtilFn"))(t.links[0].href)}})).catch((function(){var t={errorSummary:(0,o.loc)("oform.error.webfinger","login")};e.trigger("error",e,{responseJSON:t}),e.appState.trigger("removeLoading"),a.default.removeUsernameCookie()})).finally((function(){e.appState.trigger("loading",!1)}))}});t.default=u,e.exports=t.default},97020:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(29685)).default.extend({constructor:function(e){this.settings=e&&e.settings,o.Model.apply(this,arguments)},loginWithActivationToken:function(e){return this.startTransaction((function(t){return t.signInWithCredentials({token:e})}))}});t.default=i,e.exports=t.default},28528:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(26368)),a=r(n(35546)),s=r(n(29685)).default.extend({props:function(){var e=i.default.getCookieUsername(),t=this.getUsernameAndRemember(e),n={username:{type:"string",validate:function(e){if(o._.isEmpty(e))return(0,o.loc)("error.username.required","login")},value:t.username},lastUsername:["string",!1,e],context:["object",!1],remember:["boolean",!0,t.remember],multiOptionalFactorEnroll:["boolean",!0]};return this.settings&&this.settings.get("features.passwordlessAuth")||(n.password={type:"string",validate:function(e){if(o._.isEmpty(e))return(0,o.loc)("error.password.required","login")}}),n},getUsernameAndRemember:function(e){var t,n=this.settings&&this.settings.get("username"),r=this.settings&&this.settings.get("features.rememberMe"),o=!1;return n?(t=n,o=r&&t===e):r&&e&&(t=e,o=!0),{username:t,remember:o}},constructor:function(e){this.settings=e&&e.settings,this.appState=e&&e.appState,o.Model.apply(this,arguments),this.listenTo(this,"change:username",(function(e,t){this.set({remember:t===this.get("lastUsername")})}))},parse:function(e){return o._.omit(e,["settings","appState"])},save:function(){var e=this,t=this.settings.transformUsername(this.get("username"),a.default.PRIMARY_AUTH),n=this.get("remember"),r=this.get("lastUsername");this.setUsernameCookie(t,n,r),this.trigger("save"),this.appState.trigger("loading",!0);var s,l=this.getSignInArgs(t);if(this.appState.get("isUnauthenticated")){var u=this.appState.settings.getAuthClient();s=this.appState.get("isIdxStateToken")?this.doTransaction((function(e){return this.doPrimaryAuth(u,l,e.login)})):this.doTransaction((function(e){return this.doPrimaryAuth(u,l,e.authenticate)}),!0)}else s=this.startTransaction((function(e){return this.doPrimaryAuth(e,l,o._.bind(e.signInWithCredentials,e))}));return s.catch((function(){e.appState.trigger("removeLoading"),i.default.removeUsernameCookie()})).finally((function(){e.appState.trigger("loading",!1)}))},getSignInArgs:function(e){var t=this.get("multiOptionalFactorEnroll"),n={};return this.settings.get("features.passwordlessAuth")||(n.password=this.get("password")),this.appState.get("isIdxStateToken")?n.identifier=e:(n.username=e,n.options={warnBeforePasswordExpired:!0,multiOptionalFactorEnroll:t}),n},setUsernameCookie:function(e,t,n){this.settings.get("features.rememberMe")&&(t||n!==e?t&&i.default.setUsernameCookie(e):i.default.removeUsernameCookie())},doPrimaryAuth:function(e,t,n){var r=this.settings.get("features.deviceFingerprinting"),o=this.settings.get("features.trackTypingPattern");r&&this.appState.get("deviceFingerprint")&&e.http.setRequestHeader("X-Device-Fingerprint",this.appState.get("deviceFingerprint")),o&&this.appState.get("typingPattern")&&e.http.setRequestHeader("X-Typing-Pattern",this.appState.get("typingPattern"));var i=this;return n(t).finally((function(){r&&(e.http.setRequestHeader("X-Device-Fingerprint",void 0),i.appState.unset("deviceFingerprint")),o&&(e.http.setRequestHeader("X-Typing-Pattern",void 0),i.appState.unset("typingPattern"))}))}});t.default=s,e.exports=t.default},51730:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=r.internal.models.BaseSchema.Model.extend({expand:["schema"],setFieldPlaceholder:function(e){return r._.each(e,(function(e){e.title=e.label})),e},initialize:function(e){var t=e.profileSchemaAttributes;if(t=this.setFieldPlaceholder(t)){for(var n={properties:{}},r=0;r<t.length;r++){var o=t[r];n.properties[o.name]=o}this.parse.apply(this,[{schema:n}])}}});t.default=o,e.exports=t.default},71440:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=r.internal.models,i=o.BaseSchema,a=o.SchemaProperty,s=a.Collection.extend({createModelProperties:function(){var e=a.Collection.prototype.createModelProperties.apply(this);return r._.each(e,(function(e,t){e.required=!!this.get(t).get("required")}),this),e}}),l=i.Model.extend({expand:["schema"],constructor:function(){this.properties=new s,r.BaseModel.apply(this,arguments)},parse:function(e){var t=this,n=this;this.settings.parseRegistrationSchema(e,(function(e){e.profileSchema&&(e.schema=e.profileSchema,i.Model.prototype.parse.apply(n,[e]),e=function(e){var n=e.schema.required;r._.isArray(n)&&r._.each(n,(function(e){var t=this.properties.get(e);t&&t.set("required",!0)}),t);var o=e.schema.fieldOrder;return r._.isArray(o)&&(r._.each(o,(function(e,t){var n=this.properties.get(e);n&&n.set("sortOrder",t)}),t),t.properties.comparator="sortOrder",t.properties.sort()),t.properties.defaultPolicyId=e.policyId,e}(e)),n.trigger("parseComplete",{properties:n.properties})}),(function(e){n.trigger("parseComplete",{properties:n.properties,error:e})}))}});t.default=l,e.exports=t.default},96336:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(6321));var a=o.Controller.extend({addListeners:function(){this.listenTo(this.model,"save",(function(){var e,t=(e=this,o._.find(e.getChildren(),(function(e){return e instanceof o.Form})));t.disableSubmitButton&&!t.disableSubmitButton()||this.toggleButtonState(!0)})),this.listenTo(this.model,"error",(function(){this.toggleButtonState(!1)})),this.addModelListeners(this.model)},addModelListeners:function(e){var t=this,n=function(e){t.options.appState.set("transaction",e)},r=function(e){t.options.appState.set("transactionError",e)};this.listenTo(e,"setTransaction",n),this.listenTo(e,"setTransactionError",r);var o=e.get("backupFactor");o&&(this.listenTo(o,"setTransaction",n),this.listenTo(o,"setTransactionError",r))},fetchInitialData:function(){return(0,i.default)()},trapAuthResponse:function(){return!1},toJSON:function(){var e=o.Controller.prototype.toJSON.apply(this,arguments);return o._.extend(o._.pick(this.options,"appState"),e)},toggleButtonState:function(e){this.$el.find(".button").toggleClass("link-button-disabled",e).prop("disabled",e)},postRenderAnimation:function(){this.trigger("pageRendered",{page:this.className}),this.trigger("afterRender",{controller:this.className})}});t.default=a,e.exports=t.default},75104:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={generateDeviceFingerprint:function(e,t){return e.fingerprint({timeout:2e3,container:t})}},e.exports=t.default},73650:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(29685)),a=r(n(96336)),s=r(n(39694)),l=o.internal.views.forms.components.Toolbar,u=o.internal.views.forms.helpers.FormUtil,c=o.Form.extend({layout:"o-form-theme",noCancelButton:!0,constructor:function(e){o.Form.call(this,e),o._.each(o._.result(this,"formChildren")||[],(function(e){switch(e.type){case s.default.INPUT:this.addInput(o._.extend({label:!1,"label-top":!0},e.viewOptions));break;case s.default.BUTTON:this.add((0,o.createButton)(o._.extend({model:this.model},e.viewOptions)),e.addOptions),u.applyShowWhen(this.last(),e.viewOptions&&e.viewOptions.showWhen);break;case s.default.DIVIDER:this.addDivider(e.viewOptions);break;case s.default.TOOLBAR:this.add(l,{options:e.viewOptions}),u.applyShowWhen(this.last(),e.viewOptions&&e.viewOptions.showWhen);break;case s.default.VIEW:this.add(e.viewOptions.View,e.addOptions),u.applyShowWhen(this.last(),e.viewOptions.showWhen);break;default:throw new Error("Unrecognized child type: "+e.type)}}),this)}}),d=a.default.extend({constructor:function(){var e=this.initialize;if(this.initialize=function(){},a.default.apply(this,arguments),this.Model&&this.Form){var t=i.default.extend(o._.extend({parse:function(e){return this.settings=e.settings,this.appState=e.appState,o._.omit(e,["settings","appState"])}},o._.result(this,"Model")));this.model=new t({settings:this.settings,appState:this.options.appState},{parse:!0});var n=c.extend(o._.result(this,"Form",this));this.form=new n(this.toJSON()),this.add(this.form)}this.Footer&&this.addFooter(this.Footer),this.addListeners(),e.apply(this,arguments)},addFooter:function(e,t){this.footer=new e(o._.extend(this.toJSON(),t||{})),this.add(this.footer)},toJSON:function(){var e=a.default.prototype.toJSON.apply(this,arguments);return o._.extend(o._.pick(this.options,"appState"),e)},back:function(){this.footer&&this.footer.back&&this.footer.back()}});t.default=d,e.exports=t.default},39694:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n="INPUT",r="BUTTON",o="DIVIDER",i="TOOLBAR",a="VIEW";function s(e){return function(t,n){return{type:e,viewOptions:t,addOptions:n}}}var l={Input:s(n),Button:s(r),Divider:s(o),Toolbar:s(i),View:s(a),INPUT:n,BUTTON:r,DIVIDER:o,TOOLBAR:i,VIEW:a};t.default=l,e.exports=t.default},37197:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(50160)),a=o.internal.views.forms.helpers.SchemaFormFactory,s=o.internal.views.forms.inputs.CheckBox,l=function(e){var t=e.split(""),n=[],r=[",",".","-","_","#","@"],i="";return o._.each(t,(function(e){-1===r.indexOf(e)?i+=e:(i.length>=4&&n.push(o._.clone(i)),i="")})),i.length>=4&&n.push(o._.clone(i)),n.filter(Boolean)},u=function(e,t){if(!e)return!1;e=e.toLowerCase(),t=t.toLowerCase();for(var n=l(e),r=0;r<n.length;r++){var o=n[r];if(-1!==t.indexOf(o))return!0}return!1},c=function(e,t,n){var r=e.get("minLength"),i=e.get("maxLength"),a=e.get("format");if(o._.isNumber(r)&&t.length<r)return!1;if(o._.isNumber(i)&&t.length>i)return!1;var s=t;if(o._.isString(a)){if("^[#/userName]"===a||"^[#/firstName]"===a||"^[#/lastName]"===a){var l=a.split("^[#/")[1].split("]")[0],c=n.get(l);return"userName"===l?(c=n.has("userName")?n.get("userName"):n.get("email"),!u(c,s)):!c||-1===s.indexOf(c)}if(!new RegExp(a).test(t))return!1}return!0},d=function(e,t,n,r){var i=t.get(e);o._.isString(i)&&n.each((function(n,a){var s=(0,o.$)("#subschemas-"+e+" .subschema-"+a);i?s.children("p").removeClass("default-schema"):s.children("p").addClass("default-schema"),s.children("p").removeAttr("role").removeAttr("aria-live"),s.removeClass("subschema-satisfied subschema-unsatisfied subschema-error"),c(n,i,t)?(s.addClass("subschema-satisfied"),s.find("p span").removeClass("error error-16-small"),s.find("p span").addClass("confirm-16")):r&&(s.find("p span").removeClass("confirm-16"),s.find("p span").addClass("error error-16-small"),s.addClass("subschema-error subschema-unsatisfied"),s.find("p").attr("role","alert").attr("aria-live","polite"))}))},f={createInputOptions:function(e){var t,n=a.createInputOptions(e);if("boolean"===(null===(t=e.options)||void 0===t?void 0:t.type)&&(n.input=s),"select"===n.type)n=o._.extend(n,{label:e.get("title")});else{var r=e.get("title");e.get("required")&&(r+=" *"),n=o._.extend(n,{label:!1,"label-top":!0,placeholder:r})}var l=e.get("name");switch(l){case"userName":n.input=i.default,n.params={icon:"person-16-gray"};break;case"password":n.type="password",n.input=i.default,n.params={icon:"remote-lock-16"}}var u=e.get("subSchemas");return u&&(n.events={input:function(){d(l,this.model,u,!0)},focusout:function(){d(l,this.model,u,!0)},"change:userName":function(){d(l,this.model,u,!0)},"change:firstName":function(){d(l,this.model,u,!0)},"change:lastName":function(){d(l,this.model,u,!0)},"change:email":function(){d(l,this.model,u,!0)}}),n},getUsernameParts:l,passwordContainsFormField:u,checkSubSchema:c};t.default=f,e.exports=t.default},39409:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(34425)),l=r(n(35546)),u=r(n(88882)),c=n(13671),d=r(n(97329)),f=r(n(90570)),p={},h=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/verify/"+c((a=null!=(a=d(n,"provider")||(null!=t?d(t,"provider"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"provider",hash:{},data:i,loc:{start:{line:1,column:14},end:{line:1,column:26}}}):a))+"/"+c((a=null!=(a=d(n,"factorType")||(null!=t?d(t,"factorType"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorType",hash:{},data:i,loc:{start:{line:1,column:27},end:{line:1,column:41}}}):a))},useData:!0}),m=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/verify/"+c((a=null!=(a=d(n,"provider")||(null!=t?d(t,"provider"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"provider",hash:{},data:i,loc:{start:{line:1,column:14},end:{line:1,column:26}}}):a))+"/"+c((a=null!=(a=d(n,"factorType")||(null!=t?d(t,"factorType"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorType",hash:{},data:i,loc:{start:{line:1,column:27},end:{line:1,column:41}}}):a))+"/"+c((a=null!=(a=d(n,"factorIndex")||(null!=t?d(t,"factorIndex"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorIndex",hash:{},data:i,loc:{start:{line:1,column:42},end:{line:1,column:57}}}):a))},useData:!0}),v=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/verify/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"factorType")||(null!=t?a(t,"factorType"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"factorType",hash:{},data:o,loc:{start:{line:1,column:14},end:{line:1,column:28}}}):i)},useData:!0}),g=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/enroll/"+c((a=null!=(a=d(n,"provider")||(null!=t?d(t,"provider"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"provider",hash:{},data:i,loc:{start:{line:1,column:14},end:{line:1,column:26}}}):a))+"/"+c((a=null!=(a=d(n,"factorType")||(null!=t?d(t,"factorType"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorType",hash:{},data:i,loc:{start:{line:1,column:27},end:{line:1,column:41}}}):a))},useData:!0}),y=i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"step")||(null!=t?a(t,"step"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"step",hash:{},data:o,loc:{start:{line:1,column:63},end:{line:1,column:71}}}):i)},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/enroll-activate/"+d((s=null!=(s=f(n,"provider")||(null!=t?f(t,"provider"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"provider",hash:{},data:i,loc:{start:{line:1,column:23},end:{line:1,column:35}}}):s))+"/"+d((s=null!=(s=f(n,"factorType")||(null!=t?f(t,"factorType"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"factorType",hash:{},data:i,loc:{start:{line:1,column:36},end:{line:1,column:50}}}):s))+(null!=(a=f(n,"if").call(l,null!=t?f(t,"step"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:50},end:{line:1,column:78}}}))?a:"")},useData:!0}),b=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/recovery/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"recoveryToken")||(null!=t?a(t,"recoveryToken"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"recoveryToken",hash:{},data:o,loc:{start:{line:1,column:16},end:{line:1,column:33}}}):i)},useData:!0}),w=i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"token")||(null!=t?a(t,"token"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"token",hash:{},data:o,loc:{start:{line:1,column:39},end:{line:1,column:48}}}):i)},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/refresh-auth-state"+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"token"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:25},end:{line:1,column:55}}}))?i:"")},useData:!0}),_=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"signin/okta/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"username")||(null!=t?a(t,"username"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"username",hash:{},data:o,loc:{start:{line:1,column:12},end:{line:1,column:24}}}):i)},useData:!0}),O=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((s=null!=(s=d(n,"baseUrl")||(null!=t?d(t,"baseUrl"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"baseUrl",hash:{},data:i,loc:{start:{line:1,column:0},end:{line:1,column:11}}}):s))+"/login/sessionCookieRedirect?checkAccountSetupComplete=true&token="+(null!=(s=null!=(s=d(n,"token")||(null!=t?d(t,"token"):t))?s:u,a=(0,o.default)(s)===c?s.call(l,{name:"token",hash:{},data:i,loc:{start:{line:1,column:77},end:{line:1,column:88}}}):s)?a:"")+"&redirectUrl="+(null!=(s=null!=(s=d(n,"redirectUrl")||(null!=t?d(t,"redirectUrl"):t))?s:u,a=(0,o.default)(s)===c?s.call(l,{name:"redirectUrl",hash:{},data:i,loc:{start:{line:1,column:101},end:{line:1,column:118}}}):s)?a:"")},useData:!0}),k=["DEVICE_ACTIVATED","DEVICE_NOT_ACTIVATED_CONSENT_DENIED","DEVICE_NOT_ACTIVATED"];p.isHostBackgroundChromeTab=function(){return!!(navigator.userAgent.match(/Android/)&&navigator.userAgent.match(/Chrome/)&&document.hidden)},p.isDocumentVisible=function(){return"visible"===document.visibilityState},p.createVerifyUrl=function(e,t,n){return e&&n?m({provider:encodeURIComponent(e.toLowerCase()),factorType:encodeURIComponent(t),factorIndex:encodeURIComponent(n)}):e?h({provider:encodeURIComponent(e.toLowerCase()),factorType:encodeURIComponent(t)}):v({factorType:encodeURIComponent(t)})},p.createEnrollFactorUrl=function(e,t){return g({provider:encodeURIComponent(e.toLowerCase()),factorType:encodeURIComponent(t)})},p.createActivateFactorUrl=function(e,t,n){return y({provider:encodeURIComponent(e.toLowerCase()),factorType:encodeURIComponent(t),step:!!n&&encodeURIComponent(n)})},p.createRecoveryUrl=function(e){return b({recoveryToken:encodeURIComponent(e)})},p.createRefreshUrl=function(e){var t=e?encodeURIComponent(e):null;return w({token:t})},p.createSigninUrl=function(e){return e?_({username:encodeURIComponent(e)}):"signin"},p.routeAfterAuthStatusChangeError=function(e,t){if(t){if(!t.xhr||!s.default.corsIsNotEnabled(t.xhr))return t.errorCode===u.default.INVALID_TOKEN_EXCEPTION?(e.appState.set("flashError",t),e.controller.state.set("navigateDir",l.default.DIRECTION_BACK),void(e.settings.get("features.mfaOnlyFlow")?e.navigate("signin/error",{trigger:!0}):e.navigate("",{trigger:!0}))):void f.default.triggerAfterError(e.controller,t);e.settings.callGlobalError(new c.UnsupportedBrowserError((0,a.loc)("error.enabled.cors")))}},p.routeAfterAuthStatusChange=function(e,t){t&&t.status?(e.appState.setAuthResponse(t),e.controller&&e.controller.trapAuthResponse(t)||p.handleResponseStatus(e,t)):e.appState.clearLastAuthResponse()},p.handleResponseStatus=function(e,t){switch(t.status){case"SUCCESS":return void function(e,t){var n,r,o,i,s;if(t.recoveryType===l.default.RECOVERY_TYPE_UNLOCK)return void e.navigate("signin/account-unlocked",{trigger:!0});if(a._.contains(k,null===(n=t._embedded)||void 0===n?void 0:n.deviceActivationStatus))return void e.navigate("signin/device-activate-complete",{trigger:!0});if(e.settings.get("oauth2Enabled"))return void d.default.getTokens(e.settings,{sessionToken:t.sessionToken},e.controller);var u={user:t._embedded.user,type:t.type||l.default.SESSION_SSO};t.relayState&&(u.relayState=t.relayState);var h=e.settings.get("redirectUtilFn"),m=(null==t||null===(r=t._links)||void 0===r||null===(o=r.original)||void 0===o?void 0:o.href)||(null==t||null===(i=t._links)||void 0===i||null===(s=i.next)||void 0===s?void 0:s.href);if(t.type===l.default.SESSION_STEP_UP){var v,g,y=null==t||null===(v=t._links)||void 0===v||null===(g=v.next)||void 0===g?void 0:g.href;u.stepUp={url:y,finish:function(){h(y)}}}else m?u.next=function(){h(m)}:u.type=l.default.SESSION_SSO,t.sessionToken&&(u.session={token:t.sessionToken,setCookieAndRedirect:function(n){if(n&&f.default.debugMessage('\n              Passing a "redirectUri" to "setCookieAndRedirect" is strongly discouraged.\n              It is recommended to set a "redirectUri" option in the config object passed to the widget constructor.\n            '),!(n=n||e.settings.get("redirectUri")))throw new c.ConfigError('"redirectUri" is required');h(O({baseUrl:e.settings.get("baseUrl"),token:encodeURIComponent(t.sessionToken),redirectUrl:encodeURIComponent(n)}))}});p.isHostBackgroundChromeTab()?document.addEventListener("visibilitychange",(function t(){p.isDocumentVisible()&&(document.removeEventListener("visibilitychange",t),e.settings.callGlobalSuccess(l.default.SUCCESS,u))})):e.settings.callGlobalSuccess(l.default.SUCCESS,u)}(e,t);case"ADMIN_CONSENT_REQUIRED":return void e.navigate("signin/admin-consent",{trigger:!0});case"CONSENT_REQUIRED":return void e.navigate("signin/consent",{trigger:!0});case"DEVICE_ACTIVATE":return void e.navigate("signin/device-activate",{trigger:!0});case"FACTOR_REQUIRED":case"FACTOR_CHALLENGE":case"MFA_REQUIRED":var n=e.appState.get("lastFailedChallengeFactorData");n&&n.factor&&(e.appState.get("factors").lastUsedFactor=n.factor);var r=e.appState.get("factors").getDefaultFactor(),o=p.createVerifyUrl(r.get("provider"),r.get("factorType"));return e.navigate(o,{trigger:!0}),void e.appState.clearLastFailedChallengeFactorData();case"POLL":return void e.navigate("signin/poll",{trigger:!0});case"MFA_CHALLENGE":return e.appState.get("isFactorResultFailed")&&e.appState.setLastFailedChallengeFactorData(),void e.appState.get("transaction").prev().then((function(t){e.appState.set("transaction",t)}));case"MFA_ENROLL":case"FACTOR_ENROLL":return void e.navigate("signin/enroll",{trigger:!0});case"MFA_ENROLL_ACTIVATE":case"FACTOR_ENROLL_ACTIVATE":var i=p.createActivateFactorUrl(e.appState.get("activatedFactorProvider"),e.appState.get("activatedFactorType"));return void e.navigate(i,{trigger:!0});case"PASSWORD_WARN":case"PASSWORD_EXPIRED":return void(e.settings.get("features.customExpiredPassword")&&!e.appState.get("isPwdManagedByOkta")?e.navigate("signin/custom-password-expired",{trigger:!0}):e.navigate("signin/password-expired",{trigger:!0}));case"RECOVERY_CHALLENGE":var s=t.factorType.toLowerCase()===l.default.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase(),u=t.recoveryType===l.default.RECOVERY_TYPE_PASSWORD,h=t.recoveryType===l.default.RECOVERY_TYPE_UNLOCK;return void(u&&s?e.navigate("signin/recovery-emailed",{trigger:!0}):h&&s?e.navigate("signin/unlock-emailed",{trigger:!0}):e.navigate("signin/recovery-challenge",{trigger:!0}));case"RECOVERY":return void e.navigate("signin/recovery-question",{trigger:!0});case"PASSWORD_RESET":return void e.navigate("signin/password-reset",{trigger:!0});case"LOCKED_OUT":if(e.settings.get("features.selfServiceUnlock"))e.navigate("signin/unlock",{trigger:!0});else{var m=(0,a.loc)("error.auth.lockedOut","login"),v={responseJSON:{errorCauses:[],errorSummary:m,errorCode:"E0000119"}},g={name:"AuthApiError",message:m,xhr:v};e.controller.model.appState.trigger("removeLoading"),e.controller.model.trigger("error",e.controller.model,v),f.default.triggerAfterError(e.controller,g)}return;case"PROFILE_REQUIRED":return void e.navigate("signin/enroll-user",{trigger:!0});case"UNAUTHENTICATED":if(e.appState.get("promptForFactorInUnauthenticated")){var y=e.appState.get("factors").getDefaultFactor(),b=p.createVerifyUrl(y.get("provider"),y.get("factorType"));return void e.navigate(b,{trigger:!0})}return e.appState.get("usingDeviceFlow")?void e.navigate("signin/idp-discovery-check",{trigger:!0}):void e.navigate("",{trigger:!0});default:throw new Error("Unknown status: "+t.status)}};var x=p;t.default=x,e.exports=t.default},89866:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={OKTA:{APPLE:"https://itunes.apple.com/us/app/okta-verify/id490179405",ANDROID:"https://play.google.com/store/apps/details?id=com.okta.android.auth"},GOOGLE:{APPLE:"https://itunes.apple.com/us/app/google-authenticator/id388497605",ANDROID:"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"},STORE:{APPLE:"App Store",ANDROID:"Google Play Store"}},e.exports=t.default},73771:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o,i=r(n(80496)),a={track:function(e){try{(o=new i.default).addTarget(e),o.start()}catch(e){}},getTypingPattern:function(){try{return o.getTypingPattern({type:1})}catch(e){return null}}};t.default=a,e.exports=t.default},78419:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o={validateUsername:function(e){var t=e.get("username");if(t&&t.length>256)return{username:(0,r.loc)("model.validation.field.username","login")}},validateFieldsMatch:function(e,t,n,r){if(e.get(t)!==e.get(n)){var o={};return o[n]=r,o}},validatePasswordMatch:function(e){return o.validateFieldsMatch(e,"newPassword","confirmPassword",(0,r.loc)("password.error.match","login"))}},i=o;t.default=i,e.exports=t.default},53292:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.View.extend({className:"hide resend-email-infobox",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="infobox infobox-warning" aria-live="polite"><span class="icon warning-16"></span><p><span>'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"email.code.not.received"},data:o,loc:{start:{line:1,column:102},end:{line:1,column:156}}}))+'</span><a href="#" class="resend-email-btn">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"email.button.resend"},data:o,loc:{start:{line:1,column:200},end:{line:1,column:250}}}))+"</a></p></div>"},useData:!0}),events:{"click .resend-email-btn":"resendEmail"},postRender:function(){this.showResendCallout()},showResendCallout:function(){var e=this;i._.delay((function(){e.$el.removeClass("hide")}),a.default.API_RATE_LIMIT)},hideResendCallout:function(){this.$el.addClass("hide")},resendEmail:function(e){e.preventDefault(),this.hideResendCallout(),this.model.resend().finally(this.showResendCallout.bind(this))}});t.default=s,e.exports=t.default},6896:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475);n(48231);var a=i.View.extend({className:"scope-item",template:o.default.template({1:function(e,t,n,r,o){return'<span class="scope-item-tooltip icon form-help-16" />'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="scope-item-text no-translate">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"name")||(null!=t?l(t,"name"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"name",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:48}}}):a)+"</p>"+(null!=(i=l(n,"if").call(s,null!=t?l(t,"description"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:52},end:{line:1,column:131}}}))?i:"")},useData:!0}),postRender:function(){this.$(".scope-item-tooltip").qtip({content:{text:i._.escape(this.options.description)},style:{classes:"okta-tooltip qtip-custom qtip-shadow"},position:{my:"bottom left",target:"mouse"}})}});t.default=a,e.exports=t.default},29531:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6896)),s={groups:"user",myAccount:"user",users:"user",apps:"resource",authenticators:"resource",authorizationServers:"resource",clients:"resource",domains:"resource",factors:"resource",idps:"resource",linkedObjects:"resource",policies:"resource",templates:"resource",eventHooks:"hook",inlineHooks:"hook",events:"system",logs:"system",orgs:"system",roles:"system",schemas:"system",sessions:"system",trustedOrigins:"system"},l=function(e){var t=e.name,n=(void 0===t?"":t).split(".")[1];return s[n]||"system"},u=i.View.extend({className:"scope-group",events:{click:"expandScopes"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="scope-group--header"><h3>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"groupName")||(null!=t?a(t,"groupName"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"groupName",hash:{},data:o,loc:{start:{line:1,column:37},end:{line:1,column:50}}}):i)+'</h3><span class="scope-group--toggle"><svg class="caret" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z" fill="#A0A7AC"></path></svg></span></div>'},useData:!0}),expandScopes:function(){this.$el.toggleClass("scope-group--is-expanded"),this.$(".caret").toggleClass("caret--is-rotated")},preRender:function(){var e=this;i._.chain(this.options.scopes).sortBy((function(e){return e.name})).each((function(t){var n=t.name,r=t.displayName,o=t.description;e.add(a.default,{options:{name:r||n,description:o}})}))}}),c=i.View.extend({className:"scope-list detail-row",postRender:function(){var e=this,t=this.model.get("scopes"),n=i._.groupBy(t,l),r={user:(0,i.loc)("admin.consent.group.user.group","login"),resource:(0,i.loc)("admin.consent.group.resource.policy","login"),hook:(0,i.loc)("admin.consent.group.hook","login"),system:(0,i.loc)("admin.consent.group.system","login")};i._.each(r,(function(t,r){var o=n[r];Array.isArray(o)&&e.add(u,{options:{groupName:t,scopes:o}})}))}});t.default=c,e.exports=t.default},27008:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=a.internal.views.forms.inputs.CheckBox.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<input type="checkbox" name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:29},end:{line:1,column:37}}}):a))+'" id="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:43},end:{line:1,column:54}}}):a))+'"/><label for="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:69},end:{line:1,column:80}}}):a))+'" data-se-for-name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:100},end:{line:1,column:108}}}):a))+'"><b>'+c((a=null!=(a=d(n,"placeholder")||(null!=t?d(t,"placeholder"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:113},end:{line:1,column:128}}}):a))+"</b><p>"+c((a=null!=(a=d(n,"desc")||(null!=t?d(t,"desc"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"desc",hash:{},data:i,loc:{start:{line:1,column:135},end:{line:1,column:143}}}):a))+"</p></label>"},useData:!0}),enable:function(){this.options.options.optional&&this.$(":input").prop("disabled",!1)},editMode:function(){if(this.$el.html(this.template(a._.extend(a._.omit(this.options,"placeholder"),{placeholder:this.options.placeholder||this.options.name,desc:this.options.options.description}))),this.$(":checkbox").prop("checked",this.getModelValue()||!1),this.$("input").customInput(),this.model.trigger("form:resize"),!this.options.options.optional){var e=this.$("input").get(0);this.$(e.parentElement).addClass("o-form-read-mode"),this.$(":checkbox").prop("disabled",!0)}return("openid"===this.options.name||this.options.options.isCustomized)&&(this.$("label > b").addClass("no-translate"),this.options.options.isCustomized&&this.$("label > p").addClass("no-translate")),this}});t.default=s,e.exports=t.default},47894:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475);n(48231);var s=a.View.extend({className:"scope-item",template:i.default.template({1:function(e,t,n,r,o){return'<span class="scope-item-tooltip icon form-help-16"></span>'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="'+d((s=null!=(s=f(n,"classNames")||(null!=t?f(t,"classNames"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"classNames",hash:{},data:i,loc:{start:{line:1,column:12},end:{line:1,column:26}}}):s))+'"><p>'+d((s=null!=(s=f(n,"name")||(null!=t?f(t,"name"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"name",hash:{},data:i,loc:{start:{line:1,column:31},end:{line:1,column:39}}}):s))+"</p></div>"+(null!=(a=f(n,"if").call(l,null!=t?f(t,"description"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:49},end:{line:1,column:133}}}))?a:"")},useData:!0}),getTemplateData:function(){var e=this.options,t=e.name,n=e.description,r=e.isCustomized,o="scope-item-text";return{classNames:"openid"===t||r?"".concat(o," no-translate"):o,name:t,description:n}},postRender:function(){this.$(".scope-item-tooltip").qtip({content:{text:a._.escape(this.options.description)},style:{classes:"okta-tooltip qtip-custom qtip-shadow"},position:{my:"bottom right",target:"mouse"}})}});t.default=s,e.exports=t.default},99629:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(47894)),a=o.View.extend({className:"scope-list detail-row",postRender:function(){var e=this;this.model.get("scopes").forEach((function(t){e.add(i.default,{options:{name:t.displayName||t.name,description:t.description,isCustomized:t.isCustomized}})}))}});t.default=a,e.exports=t.default},38513:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(2645)),l=r(n(39409)),u=i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="factor-cardinality">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"cardinalityText")||(null!=t?a(t,"cardinalityText"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"cardinalityText",hash:{},data:o,loc:{start:{line:1,column:33},end:{line:1,column:52}}}):i)+"</span>"},useData:!0}),c=a.View.extend({tagName:"li",className:"enroll-factor-row clearfix",template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"factorDescription")||(null!=t?a(t,"factorDescription"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"factorDescription",hash:{},data:o,loc:{start:{line:1,column:235},end:{line:1,column:256}}}):i)+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enroll-factor-icon-container"><div class="factor-icon enroll-factor-icon '+d((s=null!=(s=f(n,"iconClassName")||(null!=t?f(t,"iconClassName"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"iconClassName",hash:{},data:i,loc:{start:{line:1,column:85},end:{line:1,column:102}}}):s))+'"></div></div><div class="enroll-factor-description"><h3 class="enroll-factor-label">'+d((s=null!=(s=f(n,"factorLabel")||(null!=t?f(t,"factorLabel"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"factorLabel",hash:{},data:i,loc:{start:{line:1,column:187},end:{line:1,column:202}}}):s))+"</h3>"+(null!=(a=f(n,"if").call(l,null!=t?f(t,"factorDescription"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:207},end:{line:1,column:267}}}))?a:"")+'<div class="enroll-factor-button"></div></div>'},useData:!0}),attributes:function(){return{"data-se":this.model.get("factorName")}},children:function(){var e=[],t=this.model.get("enrolled"),n=this.model.get("required"),r=this.model.get("cardinality");if(this.options.showInlineSetupButton)return[[(0,a.createButton)({className:"button",title:this.getSetupButtonText(),click:function(){this.options.appState.trigger("navigate",l.default.createEnrollFactorUrl(this.model.get("provider"),this.model.get("factorType")))}}),".enroll-factor-button"]];t?e.push(['<span class="icon success-16-green"></span>',".enroll-factor-label"]):n&&e.push(['<span class="icon success-16-gray"></span>',".enroll-factor-label"]);var o=s.default.getCardinalityText(t,n,r);return o&&e.push([u({cardinalityText:o}),".enroll-factor-description"]),e},minimize:function(){this.$el.addClass("enroll-factor-row-min")},maximize:function(){this.$el.removeClass("enroll-factor-row-min")},getSetupButtonText:function(){return this.model.get("additionalEnrollment")?(0,a.loc)("enroll.choices.setup.another","login"):(0,a.loc)("enroll.choices.setup","login")}}),d=a.ListView.extend({className:"enroll-factor-list",item:c,itemSelector:".list-content",template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h3 class="list-title">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"listTitle")||(null!=t?a(t,"listTitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"listTitle",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:53}}}):i)+"</h3>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"listTitle"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:65}}}))?i:"")+'<ul class="list-content"></ul>'},useData:!0}),getTemplateData:function(){var e=a.ListView.prototype.getTemplateData.call(this);return a._.extend(e,this),e},postRender:function(){this.options.minimize&&this.invoke("minimize")}});t.default=d,e.exports=t.default},91537:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link goto js-skip" data-se="skip-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"enroll.choices.setup.skip"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:114}}}))+"</a>"},useData:!0}),className:"auth-footer clearfix",events:{"click .js-skip":function(e){e.preventDefault(),this.model.doTransaction((function(e){return e.skip()}))}}});t.default=i,e.exports=t.default},10268:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(38513)),a=i.default.extend({listTitle:o._.partial(o.loc,"enroll.choices.list.setup","login"),className:function(){return i.default.prototype.className+" enroll-required-factor-list"},postRender:function(){var e;i.default.prototype.postRender.apply(this,arguments),e=this.options.appState.get("factors").getFirstUnenrolledRequiredFactor(),this.find((function(t){return t.model===e})).maximize()}});t.default=a,e.exports=t.default},34361:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(2645)),l=r(n(39409)),u=a.View.extend({className:"scan-instructions clearfix",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="scan-instructions-details-wrapper"><div class="scan-instructions-details"><p>'+c((a=null!=(a=d(n,"instructions")||(null!=t?d(t,"instructions"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"instructions",hash:{},data:i,loc:{start:{line:1,column:89},end:{line:1,column:105}}}):a))+'</p></div></div><div class="scan-instructions-qrcode-wrapper"><div class="qrcode-wrap"><img data-se="qrcode" alt="'+c((a=null!=(a=d(n,"altQRCode")||(null!=t?d(t,"altQRCode"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altQRCode",hash:{},data:i,loc:{start:{line:1,column:219},end:{line:1,column:232}}}):a))+'" class="qrcode-image" src="'+c((a=null!=(a=d(n,"qrcode")||(null!=t?d(t,"qrcode"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"qrcode",hash:{},data:i,loc:{start:{line:1,column:260},end:{line:1,column:270}}}):a))+'"><div data-se="qrcode-success" class="qrcode-success"></div><div data-se="qrcode-error" class="qrcode-error"></div></div><a href="#" data-type="manual-setup" data-se="manual-setup" class="link manual-setup" aria-label="'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.aria.cannotScan"},data:i,loc:{start:{line:1,column:490},end:{line:1,column:549}}}))+'">'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.cannotScan"},data:i,loc:{start:{line:1,column:551},end:{line:1,column:604}}}))+'</a><a href="#" data-type="refresh-qrcode" data-se="refresh-qrcode" class="link refresh-qrcode">'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.refreshBarcode"},data:i,loc:{start:{line:1,column:700},end:{line:1,column:757}}}))+"</a></div>"},useData:!0}),events:{'click [data-type="manual-setup"]':function(e){var t=this;e.preventDefault();var n=l.default.createActivateFactorUrl(this.model.get("__provider__"),this.model.get("__factorType__"),"manual");"push"===this.model.get("__factorType__")?this.model.doTransaction((function(e){return e.prev().then((function(e){return a._.findWhere(e.factors,{factorType:"push",provider:"OKTA"}).enroll()}))})).then((function(){t.options.appState.trigger("navigate",n)})):this.options.appState.trigger("navigate",n)},'click [data-type="refresh-qrcode"]':function(e){e.preventDefault(),this.model.trigger("errors:clear");var t=this;this.model.doTransaction((function(e){return this.appState.get("isWaitingForActivation")?e.poll():e.activate()})).then((function(e){var n=e.data;"MFA_ENROLL_ACTIVATE"!==n.status&&"FACTOR_ENROLL_ACTIVATE"!==n.status||"WAITING"!==n.factorResult||a._.defer(a._.bind(t.render,t))}))}},initialize:function(){this.listenTo(this.options.appState,"change:lastAuthResponse",(function(){this.options.appState.get("isMfaEnrollActivate")?this.$el.toggleClass("qrcode-expired",!this.options.appState.get("isWaitingForActivation")):this.options.appState.get("isSuccessResponse")&&this.$el.addClass("qrcode-success")})),this.listenTo(this.model,"error",(function(){this.options.appState.get("isMfaEnrollActivate")&&this.$el.toggleClass("qrcode-expired",!0)}))},getTemplateData:function(){var e=s.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return{instructions:"GOOGLE"===this.model.get("__provider__")?(0,a.loc)("enroll.totp.setupGoogleAuthApp","login",[e]):(0,a.loc)("enroll.totp.setupApp","login",[e]),qrcode:this.options.appState.get("qrcode"),altQRCode:(0,a.loc)("mfa.altQrCode","login")}}});t.default=u,e.exports=t.default},21304:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(39694)),s=r(n(90570)),l=r(n(50160)),u={title:function(){var e=i.default.getFactorLabel(this.model.get("__provider__"),this.model.get("__factorType__"));return(0,o.loc)("enroll.totp.title","login",[e])},subtitle:o._.partial(o.loc,"enroll.totp.enterCode","login"),autoSave:!0,noButtonBar:!0,attributes:{"data-se":"step-sendcode"},formChildren:function(){return[a.default.Input({label:(0,o.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,explain:s.default.createInputExplain("mfa.challenge.enterCode.tooltip","mfa.challenge.enterCode.placeholder","login"),"explain-top":!0,name:"passCode",input:l.default,type:"tel"}),a.default.Toolbar({noCancelButton:!0,save:(0,o.loc)("oform.verify","login")})]}};t.default=u,e.exports=t.default},68457:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"mfa.backToFactors"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:106}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.options.appState.trigger("backToFactors"),this.back()}},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.get("prevLink")?this.model.doTransaction((function(e){return e.prev()})):this.options.appState.trigger("navigate","signin/enroll")}});t.default=s,e.exports=t.default},89104:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"mfa.backToFactors"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:106}}}))+'</a><a href="#" class="link help goto js-goto" data-se="goto-link">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"mfa.scanBarcode"},data:o,loc:{start:{line:1,column:173},end:{line:1,column:219}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()},"click .js-goto":function(e){e.preventDefault(),this.model.startTransaction((function(e){return e.tx.resume()}))}},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.get("prevLink")?this.model.doTransaction((function(e){return e.prev()})):this.options.appState.trigger("navigate","signin/enroll")}});t.default=s,e.exports=t.default},4940:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(39409));function s(e){var t=a.default.createActivateFactorUrl(e.get("activatedFactorProvider"),e.get("activatedFactorType"));e.trigger("navigate",t)}var l=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-back" data-se="back-link">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"mfa.backToFactors"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:106}}}))+'</a><a href="#" class="link help goto js-goto" data-se="goto-link">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"mfa.scanBarcode"},data:o,loc:{start:{line:1,column:173},end:{line:1,column:219}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .js-back":function(e){e.preventDefault(),this.back()},"click .js-goto":function(e){e.preventDefault();var t=i._.partial(s,this.options.appState);this.options.appState.unset("factorActivationType"),this.model.doTransaction((function(e){return e.prev().then((function(e){return i._.findWhere(e.factors,{factorType:"push",provider:"OKTA"}).enroll()}))})).then(t)}},back:function(){var e=this;e.options.appState.unset("factorActivationType"),e.options.appState.get("prevLink")?this.model.doTransaction((function(e){return e.prev()})).then((function(){e.options.appState.trigger("navigate","signin/enroll")})):e.options.appState.trigger("navigate","signin/enroll")}});t.default=l,e.exports=t.default},39838:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(90570)),l=a.internal.views.forms.inputs.TextBox.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="okta-form-label-inline o-form-label-inline">'+c((a=null!=(a=d(n,"countryCallingCode")||(null!=t?d(t,"countryCallingCode"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"countryCallingCode",hash:{},data:i,loc:{start:{line:1,column:57},end:{line:1,column:79}}}):a))+'</span><span class="okta-form-input-field input-fix o-form-control"><input type="'+c((a=null!=(a=d(n,"type")||(null!=t?d(t,"type"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"type",hash:{},data:i,loc:{start:{line:1,column:160},end:{line:1,column:168}}}):a))+'" placeholder="'+c((a=null!=(a=d(n,"placeholder")||(null!=t?d(t,"placeholder"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:183},end:{line:1,column:198}}}):a))+'" name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:206},end:{line:1,column:214}}}):a))+'" id="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:220},end:{line:1,column:231}}}):a))+'" value="'+c((a=null!=(a=d(n,"value")||(null!=t?d(t,"value"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"value",hash:{},data:i,loc:{start:{line:1,column:240},end:{line:1,column:249}}}):a))+'" autocomplete="'+c((a=null!=(a=d(n,"autocomplete")||(null!=t?d(t,"autocomplete"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"autocomplete",hash:{},data:i,loc:{start:{line:1,column:265},end:{line:1,column:281}}}):a))+'"></span>'},useData:!0}),initialize:function(){this.listenTo(this.model,"change:countryCallingCode",(function(){this.$(".o-form-label-inline").text(this.model.get("countryCallingCode"))}))},preRender:function(){this.options.countryCallingCode=this.model.get("countryCallingCode"),this.options.autocomplete=s.default.getAutocompleteValue(this.options.model.settings,"tel")},postRender:function(){var e=this;this.$el.removeClass("input-fix o-form-control"),a._.defer((function(){e.$el.parent().addClass("o-form-input-group")}))}});t.default=l,e.exports=t.default},80549:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(51730)),s=r(n(37197)),l=i.Form.extend({layout:"o-form-theme",autoSave:!0,noCancelButton:!0,title:function(){return(0,i.loc)("registration.form.title","login")},save:function(){return(0,i.loc)("registration.form.submit","login")},initialize:function(e){var t=this;this.options=e||{},this.schema=new a.default({profileSchemaAttributes:this.options.appState.get("policy").registration.profile}),this.schema.properties.each((function(e){var n=s.default.createInputOptions(e);t.addInput(n)}));var n=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="required-fields-label">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"label")||(null!=t?a(t,"label"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"label",hash:{},data:o,loc:{start:{line:1,column:36},end:{line:1,column:45}}}):i)+"</span>"},useData:!0})({label:(0,i.loc)("registration.required.fields.label","login")});this.add(n)}});t.default=l,e.exports=t.default},84977:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.internal.util.Util,l=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help js-skip" data-se="skip-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"password.expiring.later"},data:o,loc:{start:{line:1,column:78},end:{line:1,column:132}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"passwordWarn"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:143}}}))?i:"")+'<a href="#" class="link help goto js-signout" data-se="signout-link">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"signout"},data:o,loc:{start:{line:1,column:212},end:{line:1,column:250}}}))+"</a>"},useData:!0}),className:"auth-footer clearfix",events:{"click .js-signout":function(e){e.preventDefault();var t=this,n=t.settings.getAuthClient();this.model.doTransaction((function(e){return e.cancel()})).then((function(){return n.session.exists()})).then((function(e){if(e)return n.closeSession().catch((function(){}))})).then((function(){t.settings.get("backToSignInUri")?s.redirect(t.settings.get("backToSignInUri")):(t.state.set("navigateDir",a.default.DIRECTION_BACK),t.options.appState.trigger("navigate",""))}))},"click .js-skip":function(e){e.preventDefault(),this.model.doTransaction((function(e){return e.skip()}))}},getTemplateData:function(){return{passwordWarn:this.options.appState.get("isPwdExpiringSoon")}}});t.default=l,e.exports=t.default},96823:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(6321)),a=r(n(35546)),s=o.Form.extend({layout:"o-form-theme",className:"factor-verify-magiclink",autoSave:!0,noCancelButton:!0,initialize:function(){var e=this;this.title=this.model.get("factorLabel");var t=this.model.get("email")||this.options.appState.get("lastAuthResponse")._embedded.user.profile.login;this.subtitle="("+t+")",this.add((0,o.createButton)({attributes:{"data-se":"email-send-code"},className:"button email-request-button",title:(0,o.loc)("mfa.sendEmail","login"),click:function(){var t=this;e.clearErrors(),this.disable(),this.options.title=(0,o.loc)("mfa.sent","login"),this.render(),this.model.save().then((function(){return i.default.delay(a.default.API_RATE_LIMIT)})).then((function(){t.options.title=(0,o.loc)("mfa.resendEmail","login"),t.enable(),t.render()}))}}))}});t.default=s,e.exports=t.default},69834:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(25708)).default.extend({className:"idp-discovery-form",save:function(){return(0,o.loc)("oform.next","login")},saveId:"idp-discovery-submit",initialize:function(){this.listenTo(this,"save",o._.bind(this.model.save,this.model)),this.stateEnableChange()},inputs:function(){var e=[],t={className:"margin-btm-30",label:(0,o.loc)("primaryauth.username.placeholder","login"),inputId:"idp-discovery-username",disabled:!1};return e.push(o._.extend(this.getUsernameField(),t)),this.settings.get("features.rememberMe")&&e.push(this.getRemeberMeCheckbox()),e},focus:function(){this.model.get("username")?this.getInputs().toArray()[1]&&this.getInputs().toArray()[1].focus():this.getInputs().first().focus()}});t.default=i,e.exports=t.default},81824:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon error-24"></span><h4><strong>'+(null!=(i="function"==typeof(a=null!=(a=s(n,"message")||(null!=t?s(t,"message"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"message",hash:{},data:o,loc:{start:{line:1,column:47},end:{line:1,column:60}}}):a)?i:"")+"</strong></h4>"},useData:!0}),s=i.View.extend({template:a,className:"okta-infobox-error infobox infobox-error infobox-md margin-btm-25",attributes:{"data-se":"o-form-error-html"},message:"",initialize:function(e){e&&e.message&&(this.message=e.message)},getTemplateData:function(){return{message:this.message}}});t.default=s,e.exports=t.default},86139:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(50160));var a=o.Form.extend({autoSave:!0,noButtonBar:!0,scrollOnError:!1,layout:"o-form-theme",className:"mfa-verify-totp-inline",attributes:{"data-se":"factor-inline-totp"},initialize:function(){var e=this;this.listenTo(this.model,"error",(function(){this.clearErrors()})),this.add((0,o.createButton)({className:"link",attributes:{"data-se":"inline-totp-add"},title:(0,o.loc)("mfa.challenge.orEnterCode","login"),click:function(){this.remove(),function(e){e.addDivider(),e.addInput({label:(0,o.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top inline-input auth-passcode",name:"answer",input:i.default,type:"tel"}),e.add((0,o.createButton)({attributes:{"data-se":"inline-totp-verify"},className:"button inline-totp-verify margin-top-30",title:(0,o.loc)("mfa.challenge.verify","login"),click:function(){e.clearErrors(),e.isValid()&&e.model.manageTransaction((function(t,n){if("MFA_CHALLENGE"===t.status&&t.prev)return e.options.appState.set("trapMfaRequiredResponse",!0),t.prev().then((function(t){n(t),e.model.save()}));e.model.save()}))}})),e.at(1).focus()}(e)}}))}});t.default=a,e.exports=t.default},75166:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"number-challenge-view",template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p data-se="number-challenge-instruction">'+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"number",bundle:"login",code:"oktaverify.numberchallenge.instruction"},data:o,loc:{start:{line:1,column:73},end:{line:1,column:163}}}))?i:"")+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=c(n,"if").call(s,null!=t?c(t,"number"):t,{name:"if",hash:{includeZero:!0},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:174}}}))?i:"")+'<div class="phone"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">'+u("function"==typeof(a=null!=(a=c(n,"number")||(null!=t?c(t,"number"):t))?a:l)?a.call(s,{name:"number",hash:{},data:o,loc:{start:{line:1,column:300},end:{line:1,column:310}}}):a)+'</span></div><div class="phone--home-button"></div></div></div><p>'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"oktaverify.numberchallenge.explain"},data:o,loc:{start:{line:1,column:376},end:{line:1,column:441}}}))+"</p>"},useData:!0}),initialize:function(){var e=this;this.listenTo(this.options.appState,"change:isWaitingForNumberChallenge",(function(){"SUCCESS"!==e.options.appState.get("lastAuthResponse").status&&e.render()}))},getTemplateData:function(){var e=this.options.appState.get("lastAuthResponse");return this.options.appState.get("isWaitingForNumberChallenge")?{number:e._embedded.factor._embedded.challenge.correctAnswer}:{number:null}}});t.default=i,e.exports=t.default},54311:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(6321)),s=r(n(35546)),l=r(n(50160)),u=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"("+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"subtitle")||(null!=t?a(t,"subtitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:1},end:{line:1,column:13}}}):i)+")"},useData:!0}),c=i.View.extend({className:"okta-form-infobox-warning infobox infobox-warning login-timeout-warning",attributes:{"aria-live":"polite"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon warning-16"></span><p>'+(null!=(i="function"==typeof(a=null!=(a=s(n,"warning")||(null!=t?s(t,"warning"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"warning",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:53}}}):a)?i:"")+"</p>"},useData:!0})});function d(e){switch(e){case"sms":return{buttonDataSe:"sms-send-code",buttonClassName:"sms-request-button",formSubmit:(0,i.loc)("mfa.sendCode","login"),formRetry:(0,i.loc)("mfa.resendCode","login"),formSubmitted:(0,i.loc)("mfa.sent","login"),subtitle:u({subtitle:this.model.get("phoneNumber")}),warning:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<b>$1</b>",bundle:"login",code:"factor.sms.time.warning"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:70}}}))},useData:!0})};case"call":return{buttonDataSe:"make-call",buttonClassName:"call-request-button",formSubmit:(0,i.loc)("mfa.call","login"),formRetry:(0,i.loc)("mfa.redial","login"),formSubmitted:(0,i.loc)("mfa.calling","login"),subtitle:u({subtitle:this.model.get("phoneNumber")}),warning:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<b>$1</b>",bundle:"login",code:"factor.call.time.warning"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:71}}}))},useData:!0})};case"email":return{buttonDataSe:"email-send-code",buttonClassName:"email-request-button",formSubmit:(0,i.loc)("mfa.sendEmail","login"),formRetry:(0,i.loc)("mfa.resendEmail","login"),formSubmitted:(0,i.loc)("mfa.sent","login"),subtitle:u({subtitle:this.model.get("email")})};default:return{buttonDataSe:"",buttonClassName:"",formSubmit:"",formRetry:"",formSubmitted:""}}}var f=i.Form.extend({className:"mfa-verify-passcode",autoSave:!0,noCancelButton:!0,save:i._.partial(i.loc,"mfa.challenge.verify","login"),scrollOnError:!1,layout:"o-form-theme",disableSubmitButton:function(){return this.model.appState.get("isMfaChallenge")&&this.model.get("answer")},showWarning:function(e){this.clearWarnings(),this.add(c,".o-form-error-container",{options:{warning:e}})},clearWarnings:function(){this.$(".okta-form-infobox-warning").remove()},initialize:function(){var e=this;this.title=this.model.get("factorLabel");var t=this.model.get("factorType"),n=d.call(this,t),r=n.warning;this.$el.attr("data-se","factor-"+t),this.subtitle=n.subtitle,this.listenTo(this.model,"error",(function(){this.clearErrors()})),this.addInput({label:(0,i.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"answer",input:l.default,type:"tel"}),this.add((0,i.createButton)({attributes:{"data-se":n.buttonDataSe},className:"button "+n.buttonClassName,title:n.formSubmit,click:function(){var o=this;e.clearErrors(),this.disable(),e.clearWarnings(),this.options.title=n.formSubmitted,this.render(),this.model.set("answer",""),this.model.save().then((function(){return e.getInputs().first().render().focus(),a.default.delay(s.default.API_RATE_LIMIT)})).then((function(){o.options.title=n.formRetry,o.enable(),"call"!==t&&"sms"!==t||e.showWarning(r),o.render()}))}})),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})}});t.default=f,e.exports=t.default},89274:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=r.Form.extend({className:"mfa-verify-password",autoSave:!0,noCancelButton:!0,save:r._.partial(r.loc,"mfa.challenge.verify","login"),scrollOnError:!1,layout:"o-form-theme",attributes:{"data-se":"factor-password"},initialize:function(){this.title=this.model.get("factorLabel"),this.addInput({label:(0,r.loc)("mfa.challenge.password.placeholder","login"),"label-top":!0,className:"auth-passcode",name:"password",type:"password",params:{showPasswordToggle:!0}}),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})}});t.default=o,e.exports=t.default},99423:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(90570)),s=r(n(75166)),l=o.default.template({1:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return" ("+(null!=(i="function"==typeof(a=null!=(a=s(n,"deviceName")||(null!=t?s(t,"deviceName"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"deviceName",hash:{},data:o,loc:{start:{line:1,column:34},end:{line:1,column:50}}}):a)?i:"")+")"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(a=null!=(a=l(n,"factorName")||(null!=t?l(t,"factorName"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"factorName",hash:{},data:o,loc:{start:{line:1,column:0},end:{line:1,column:14}}}):a)+(null!=(i=l(n,"if").call(s,null!=t?l(t,"deviceName"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:14},end:{line:1,column:58}}}))?i:"")},useData:!0}),u=i.View.extend({className:"okta-form-infobox-warning infobox infobox-warning",attributes:{"aria-live":"polite"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon warning-16"></span><p>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"warning")||(null!=t?a(t,"warning"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"warning",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:51}}}):i)+"</p>"},useData:!0})}),c=i.Form.extend({className:"mfa-verify-push",autoSave:!0,noCancelButton:!0,save:i._.partial(i.loc,"oktaverify.send","login"),scrollOnError:!1,layout:"o-form-theme",attributes:{"data-se":"factor-push"},events:{submit:"submit"},initialize:function(){this.enabled=!0,this.listenTo(this.options.appState,"change:isMfaRejected",this.handleRejectStateChange),this.numberChallengeView=this.add(s.default).last(),this.listenTo(this.options.appState,"change:isWaitingForNumberChallenge",(function(e,t){t||"SUCCESS"===this.options.appState.get("lastAuthResponse").status?(this.clearWarnings(),this.$el.find(".button").hide(),this.numberChallengeView.$el.show()):(this.numberChallengeView.$el.hide(),this.$el.find(".button").show())})),this.listenTo(this.options.appState,"change:isMfaTimeout",(function(e,t){this.setSubmitState(t),t&&this.showError((0,i.loc)("oktaverify.timeout","login"))})),this.listenTo(this.options.appState,"change:isMfaRequired",(function(e,t){t&&(this.clearErrors(),this.clearWarnings())})),this.title=l({factorName:this.model.get("factorLabel"),deviceName:this.model.get("deviceName")})},setSubmitState:function(e){var t=this.$el.find(".button"),n=this.$el.find(".accessibility-text");this.enabled=e,e?(t.removeClass("link-button-disabled"),t.prop("value",(0,i.loc)("oktaverify.send","login")),t.prop("disabled",!1),n&&n.remove()):(t.addClass("link-button-disabled"),t.prop("value",(0,i.loc)("oktaverify.sent","login")),t.prop("disabled",!0),this.add("<span class='accessibility-text' role='alert'>".concat((0,i.loc)("oktaverify.sent","login"),"</span>")))},submit:function(e){void 0!==e&&e.preventDefault(),this.enabled&&(this.setSubmitState(!1),this.doSave())},postRender:function(){var e=this.options.appState.get("factorsPolicyInfo"),t=this.model.get("id");!!(this.settings.get("features.autoPush")&&e&&e[t])&&e[t].autoPushEnabled&&(this.model.set("autoPush",!0),i._.defer(i._.bind(this.submit,this)))},doSave:function(){var e,t=this;this.clearErrors(),this.clearWarnings(),this.model.isValid()&&(this.listenToOnce(this.model,"error",(function(){this.setSubmitState(!0),this.clearWarnings(),clearTimeout(e)})),this.trigger("save",this.model),e=a.default.callAfterTimeout((function(){t.options.appState.get("isWaitingForNumberChallenge")||t.showWarning((0,i.loc)("oktaverify.warning","login"))}),3e4))},showError:function(e){this.clearWarnings(),this.model.trigger("error",this.model,{responseJSON:{errorSummary:e}})},showWarning:function(e){this.clearWarnings(),this.add(u,".o-form-error-container",{options:{warning:e}})},clearWarnings:function(){this.$(".okta-form-infobox-warning").remove()},handleRejectStateChange:function(e,t){t&&(this.setSubmitState(t),this.setRejectedErrorMessage())},setRejectedErrorMessage:function(){"OKTA_VERIFY_UPGRADE_REQUIRED"===this.options.appState.get("lastAuthResponse").factorResultMessage?"IOS"===this.options.appState.get("factor").profile.platform?this.showError((0,i.loc)("oktaverify.rejected.upgradeRequired.ios","login")):this.showError((0,i.loc)("oktaverify.rejected.upgradeRequired.android","login")):this.showError((0,i.loc)("oktaverify.rejected","login"))}});t.default=c,e.exports=t.default},39877:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=r.Form.extend({className:"mfa-verify-question",autoSave:!0,noCancelButton:!0,save:r._.partial(r.loc,"mfa.challenge.verify","login"),scrollOnError:!1,layout:"o-form-theme",attributes:{"data-se":"factor-question"},initialize:function(){this.title=this.model.get("factorLabel"),this.addInput({label:this.model.get("securityQuestion"),"label-top":!0,placeholder:(0,r.loc)("mfa.challenge.answer.placeholder","login"),className:"auth-passcode",name:"answer",type:"password",params:{showPasswordToggle:!0}}),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"})}});t.default=o,e.exports=t.default},83344:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(53292)),s=r(n(50160)),l=function(){var e=this.model.get("email");return{factorEmail:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="mask-email">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"email")||(null!=t?a(t,"email"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"email",hash:{},data:o,loc:{start:{line:1,column:25},end:{line:1,column:34}}}):i)+"</span>"},useData:!0})({email:e})}},u=i.Form.extend({layout:"o-form-theme",className:"mfa-verify-email",title:i._.partial(i.loc,"email.mfa.title","login"),noButtonBar:!1,autoSave:!0,noCancelButton:!0,attributes:{"data-se":"factor-email"},save:function(){return this.options.appState.get("isMfaChallenge")?(0,i.loc)("mfa.challenge.verify","login"):(0,i.loc)("email.button.send","login")},events:Object.assign({},i.Form.prototype.events,{submit:function(e){e.preventDefault(),this.handleSubmit()}}),handleSubmit:function(){this.clearErrors(),this.options.appState.get("isMfaChallenge")?this.isValid()&&this.model.save():(this.model.set("answer",""),this.model.save().then(this.renderChallengView.bind(this)))},initialize:function(){i.Form.prototype.initialize.apply(this,arguments),this.add(i.View.extend({attributes:{"data-se":"mfa-send-email-content"},className:"mfa-send-email-content",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"factorEmail",bundle:"login",code:"email.mfa.description"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:78}}}))?i:""},useData:!0}),getTemplateData:l}))},renderChallengView:function(){this.removeChildren(),this.add(i.View.extend({className:"mfa-email-sent-content",attributes:{"data-se":"mfa-email-sent-content"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"factorEmail",bundle:"login",code:"email.mfa.email.sent.description"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:89}}}))?i:""},useData:!0}),getTemplateData:l})),this.add(a.default),this.addInput({label:(0,i.loc)("email.code.label","login"),"label-top":!0,name:"answer",input:s.default,wide:!0,type:"tel"}),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"}),this.render()}}),c=u;t.default=c,e.exports=t.default},61174:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(50160)),a=o.Form.extend({className:"mfa-verify-totp",autoSave:!0,noCancelButton:!0,save:o._.partial(o.loc,"mfa.challenge.verify","login"),scrollOnError:!1,layout:"o-form-theme",attributes:{"data-se":"factor-totp"},initialize:function(){var e=this,t=this.model.get("factorLabel"),n="RSA"===this.model.get("provider")||"DEL_OATH"===this.model.get("provider");this.title=t,this.model.get("isFactorTypeVerification")?this.subtitle=(0,o.loc)("mfa.challenge.totp.subtitle.multiple","login",[t]):this.subtitle=(0,o.loc)("mfa.challenge.title","login",[t]),this.addInput({label:(0,o.loc)("mfa.challenge.enterCode.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"answer",input:i.default,type:n?"password":"tel"}),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,placeholder:this.options.appState.get("rememberDeviceLabel"),className:"margin-btm-0",name:"rememberDevice",type:"checkbox"}),"RSA"!==this.model.get("provider")&&"DEL_OATH"!==this.model.get("provider")||this.listenTo(this.model,"error",(function(t,n){n&&409===n.status&&(e.$(".auth-passcode input").val(""),e.$(".auth-passcode input").trigger("change"),e.$(".auth-passcode input").focus())}))}});t.default=a,e.exports=t.default},27797:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(50160)),a=o.Form.extend({className:"mfa-verify-yubikey",autoSave:!0,noCancelButton:!0,save:o._.partial(o.loc,"mfa.challenge.verify","login"),scrollOnError:!1,layout:"o-form-theme",attributes:{"data-se":"factor-yubikey"},initialize:function(){var e=this.model.get("factorLabel");this.title=e,this.subtitle=(0,o.loc)("factor.totpHard.yubikey.description","login"),this.addInput({label:(0,o.loc)("factor.totpHard.yubikey.placeholder","login"),"label-top":!0,className:"o-form-fieldset o-form-label-top auth-passcode",name:"answer",input:i.default,inputId:"mfa-answer",type:"password"}),this.options.appState.get("allowRememberDevice")&&this.addInput({label:!1,"label-top":!0,className:"margin-btm-0",placeholder:this.options.appState.get("rememberDeviceLabel"),name:"rememberDevice",type:"checkbox"})}});t.default=a,e.exports=t.default},75422:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(2645)),a=r(n(15073)),s=r(n(2726)),l=o.internal.views.components.BaseDropDown;(0,o.$)(document).click((function(e){var t=(0,o.$)(e.target);t.closest(".option-selected").length>0&&t.closest(".dropdown").length>0||((0,o.$)(".dropdown .options").hide(),(0,o.$)(".dropdown a.option-selected").attr("aria-expanded",!1))}));var u=l.extend({className:"bg-helper icon-button",screenReaderText:function(){var e,t=this.options.appState.get("factors");return e=(t?i.default.findFactorInFactorsArray(t,this.options.provider,this.options.factorType):new a.default.Model(this.options.appState.get("factor"),this.toJSON())).get("factorLabel"),(0,o.loc)("mfa.factors.dropdown.sr.text","login",[e])},events:{"click a.option-selected":function(e){if(e.preventDefault(),o._.result(this,"disabled"))e.stopPropagation();else{var t=this.$(".options").toggle().is(":visible");this.$("a.option-selected").attr("aria-expanded",t),t&&this.$("#okta-dropdown-options").find("li.factor-option:first a").focus()}},"click .dropdown-disabled":function(e){e.preventDefault(),e.stopPropagation()}},initialize:function(){this.addOption(s.default.getDropdownOption("TITLE"));var e=this.options.appState.get("factors"),t=e.hasMultipleFactorsOfSameType("push");e.each((function(e){"token:software:totp"===e.get("factorType")&&t||(this.addOption(s.default.getDropdownOption(e.get("factorName")),{model:e}),this.listenTo(this.last(),"options:toggle",(function(){this.$(".options").hide(),this.$("a.option-selected").attr("aria-expanded",!1)})))}),this)}});t.default=u,e.exports=t.default},2726:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(39409)),s=o.default.template({1:function(e,t,n,r,o){var i,a,s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return" ("+(null!=(i="function"==typeof(a=null!=(a=s(n,"deviceName")||(null!=t?s(t,"deviceName"):t))?a:e.hooks.helperMissing)?a.call(null!=t?t:e.nullContext||{},{name:"deviceName",hash:{},data:o,loc:{start:{line:1,column:34},end:{line:1,column:50}}}):a)?i:"")+")"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(a=null!=(a=l(n,"factorName")||(null!=t?l(t,"factorName"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"factorName",hash:{},data:o,loc:{start:{line:1,column:0},end:{line:1,column:14}}}):a)+(null!=(i=l(n,"if").call(s,null!=t?l(t,"deviceName"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:14},end:{line:1,column:58}}}))?i:"")},useData:!0}),l=function(e){var t,n=e.get("factorType"),r=this.options.appState.get("factors");r.hasMultipleFactorsOfSameType(n)&&(t=r.getFactorIndex(n,e.get("id")));var o=a.default.createVerifyUrl(e.get("provider"),n,t),i=this;this.options.appState.trigger("factorSwitched"),this.model.manageTransaction((function(e,t){if("FACTOR_CHALLENGE"===e.status&&this.options.appState.set("trapMfaRequiredResponse",!0),"MFA_CHALLENGE"===e.status&&e.prev)return this.options.appState.set("trapMfaRequiredResponse",!0),e.prev().then((function(e){i.trigger("options:toggle"),t(e),i.options.appState.trigger("navigate",o)}));i.trigger("options:toggle"),i.options.appState.trigger("navigate",o)}))},u={TITLE:{title:i._.partial(i.loc,"mfa.factors.dropdown.title","login"),className:"dropdown-list-title",disabled:!0},OKTA_VERIFY:{icon:"factor-icon mfa-okta-verify-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},OKTA_VERIFY_PUSH:{icon:"factor-icon mfa-okta-verify-30",className:"factor-option",title:function(){return s({factorName:this.model.get("factorLabel"),deviceName:this.model.get("deviceName")})},action:function(){l.call(this,this.model)}},GOOGLE_AUTH:{icon:"factor-icon mfa-google-auth-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},CUSTOM_HOTP:{icon:"factor-icon mfa-hotp-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},SYMANTEC_VIP:{icon:"factor-icon mfa-symantec-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},RSA_SECURID:{icon:"factor-icon mfa-rsa-30",className:"factor-option",title:i._.partial(i.loc,"factor.totpHard.rsaSecurId","login"),action:function(){l.call(this,this.model)}},ON_PREM:{icon:"factor-icon mfa-onprem-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},DUO:{icon:"factor-icon mfa-duo-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},DUO_PUSH:{icon:"duo-push-16",className:"suboption factor-option",title:i._.partial(i.loc,"mfa.duoSecurity.push","login",["XXX-XXX-7890"])},DUO_SMS:{icon:"duo-sms-16",className:"suboption factor-option",title:i._.partial(i.loc,"mfa.duoSecurity.sms","login",["XXX-XXX-7890"])},DUO_CALL:{icon:"duo-call-16",className:"suboption factor-option",title:i._.partial(i.loc,"mfa.duoSecurity.call","login",["XXX-XXX-7890"])},YUBIKEY:{icon:"factor-icon mfa-yubikey-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},SMS:{icon:"factor-icon mfa-sms-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},CALL:{icon:"factor-icon mfa-call-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},QUESTION:{icon:"factor-icon mfa-question-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},PASSWORD:{icon:"factor-icon mfa-password-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},WINDOWS_HELLO:{icon:"factor-icon mfa-windows-hello-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},U2F:{icon:"factor-icon mfa-u2f-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},WEBAUTHN:{icon:"factor-icon mfa-webauthn-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},EMAIL:{icon:"factor-icon mfa-email-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},GENERIC_SAML:{icon:"factor-icon mfa-custom-factor-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},GENERIC_OIDC:{icon:"factor-icon mfa-custom-factor-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}},CUSTOM_CLAIMS:{icon:"factor-icon mfa-custom-factor-30",className:"factor-option",title:function(){return this.model.get("factorLabel")},action:function(){l.call(this,this.model)}}},c={getDropdownOption:function(e){return u[e]}};t.default=c,e.exports=t.default},65422:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(97329)),s=i.internal.util.Util,l=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="auth-divider"><span class="auth-divider-text">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"text")||(null!=t?a(t,"text"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"text",hash:{},data:o,loc:{start:{line:1,column:58},end:{line:1,column:66}}}):i)+"</span></div>"},useData:!0}),u=o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h2 data-se="o-form-head" class="okta-form-title o-form-head">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:62},end:{line:1,column:71}}}):i)+"</h2>"},useData:!0}),c=i.View.extend({className:"primary-auth-container",children:function(){var e=[],t=this.settings.get("configuredSocialIdps"),n=this.settings.get("piv"),r=this.settings.get("customButtons"),o=l({text:(0,i.loc)("socialauth.divider.text","login")});return this.settings.get("hasPivCard")&&e.push(this._createPivButton(n)),i._.each(t,(function(t){e.push(this._createSocialIdpButton(t))}),this),i._.each(r,(function(t){e.push(this._createCustomButton(t))}),this),this.settings.get("socialAuthPositionTop")?(e.unshift(u({title:(0,i.loc)("primaryauth.title","login")})),e.push(o)):e.unshift(o),e},_createSocialIdpButton:function(e){return(0,i.createButton)({attributes:{"data-se":e.dataAttr},className:e.className,title:function(){return e.text||(0,i.loc)(e.i18nKey)},click:function(t){if(t.preventDefault(),this.settings.get("oauth2Enabled"))a.default.getTokens(this.settings,{idp:e.id},this.options.currentController);else{var n,r=this.settings.get("baseUrl"),o=this.options.appState.get("lastAuthResponse");n=this.options.appState.get("usingDeviceFlow")?i.$.param({stateToken:null==o?void 0:o.stateToken}):i.$.param({fromURI:this.settings.get("relayState")});var l="".concat(r,"/sso/idps/").concat(e.id,"?").concat(n);s.redirect(l)}}})},_createPivButton:function(e){var t=e.className||"";return(0,i.createButton)({attributes:{"data-se":"piv-card-button"},className:t+" piv-button",title:e.text||(0,i.loc)("piv.cac.card","login"),click:function(e){e.preventDefault(),this.options.appState.trigger("navigate","signin/verify/piv")}})},_createCustomButton:function(e){return(0,i.createButton)({attributes:{"data-se":e.dataAttr},className:e.className+" default-custom-button",title:function(){return e.title||(0,i.loc)(e.i18nKey)},click:e.click})}});t.default=c,e.exports=t.default},25708:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31049)),a=n(6475),s=r(n(75104)),l=r(n(73771)),u=r(n(90570)),c=r(n(50160)),d=a.Form.extend({className:"primary-auth-form",noCancelButton:!0,attributes:{novalidate:"novalidate"},save:function(){return this.settings.get("features.passwordlessAuth")?(0,a.loc)("oform.next","login"):(0,a.loc)("primaryauth.submit","login")},saveId:"okta-signin-submit",layout:"o-form-theme",title:function(){var e=(0,a.loc)("primaryauth.title","login");return this.settings.get("socialAuthPositionTop")&&(e=""),e},initialize:function(){var e=this.settings.get("features.trackTypingPattern");this.listenTo(this,"save",(0,i.default)(o.default.mark((function t(){var n,r,i,a;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=this.options.appState,e&&(r=l.default.getTypingPattern(),n.set("typingPattern",r)),i={username:this.model.get("username")},this.settings.get("features.passwordlessAuth")||(i.password=this.model.get("password")),n.trigger("loading",!0),this.state.trigger("togglePrimaryAuthButton",!0),t.next=8,this.settings.processCreds(i);case 8:if(!this.settings.get("features.deviceFingerprinting")){t.next=18;break}return t.prev=9,t.next=12,s.default.generateDeviceFingerprint(this.settings.getAuthClient(),this.$el[0]);case 12:a=t.sent,n.set("deviceFingerprint",a),t.next=18;break;case 16:t.prev=16,t.t0=t.catch(9);case 18:this.model.save();case 19:case"end":return t.stop()}}),t,this,[[9,16]])})))),this.stateEnableChange(),this.stateUsernameChange()},stateEnableChange:function(){this.listenTo(this.state,"change:enabled",(function(e,t){t?this.enable():this.disable()}))},stateUsernameChange:function(){this.listenTo(this.state,"change:disableUsername",(function(e,t){t?this.$el.find("#okta-signin-username").attr("disabled",!0):this.$el.find("#okta-signin-username").removeAttr("disabled")}))},inputs:function(){var e=[];return e.push(this.getUsernameField()),this.settings.get("features.passwordlessAuth")||e.push(this.getPasswordField()),this.settings.get("features.rememberMe")&&e.push(this.getRemeberMeCheckbox()),e},getUsernameField:function(){var e=this;return{className:"margin-btm-5",label:(0,a.loc)("primaryauth.username.placeholder","login"),"label-top":!0,explain:function(){return!!e.isCustomized("primaryauth.username.tooltip")&&u.default.createInputExplain("primaryauth.username.tooltip","primaryauth.username.placeholder","login")},"explain-top":!0,name:"username",input:c.default,inputId:"okta-signin-username",type:"text",disabled:this.options.appState.get("disableUsername"),autoComplete:u.default.getAutocompleteValue(this.settings,"username"),render:function(){var e=this;function t(){e.$(this).removeAttr("aria-invalid").off("focusout",t).off("change",t)}this.$("input[name=".concat(this.options.name,"]")).attr({"aria-invalid":"false","aria-required":"true"}).prop({required:!0}).focusout(t).change(t)}}},getPasswordField:function(){var e=this,t={className:"margin-btm-30",label:(0,a.loc)("primaryauth.password.placeholder","login"),"label-top":!0,explain:function(){return!!e.isCustomized("primaryauth.password.tooltip")&&u.default.createInputExplain("primaryauth.password.tooltip","primaryauth.password.placeholder","login")},"explain-top":!0,name:"password",inputId:"okta-signin-password",validateOnlyIfDirty:!0,type:"password",autoComplete:u.default.getAutocompleteValue(this.settings,"current-password"),render:function(){var e=this;function t(){e.$(this).removeAttr("aria-invalid").off("focusout",t).off("change",t)}this.$("input[name=".concat(this.options.name,"]")).attr({"aria-invalid":"false","aria-required":"true"}).prop({required:!0}).focusout(t).change(t)}};return this.settings.get("features.showPasswordToggleOnSignInPage")&&(t.params={},t.params.showPasswordToggle=!0),t},isCustomized:function(e){var t=this.settings.get("language"),n=this.settings.get("i18n");return!!(n&&n[t]&&n[t][e])},getRemeberMeCheckbox:function(){return{label:!1,placeholder:(0,a.loc)("remember","login"),name:"remember",type:"checkbox","label-top":!0,className:"margin-btm-0",initialize:function(){this.listenTo(this.model,"change:remember",(function(e,t){this.$(":checkbox").prop("checked",t).trigger("updateState")}))}}},focus:function(){this.model.get("username")?this.settings.get("features.passwordlessAuth")||this.getInputs().toArray()[1].focus():this.getInputs().first().focus(),this.settings.get("features.trackTypingPattern")&&l.default.track("okta-signin-username")}});t.default=d,e.exports=t.default},41797:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.View.extend({index:"",message:"",class:function(){},className:function(){return"subschema-unsatisfied subschema-"+this.index},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="default-schema"><span class="icon icon-16"></span>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"message")||(null!=t?a(t,"message"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"message",hash:{},data:o,loc:{start:{line:1,column:60},end:{line:1,column:71}}}):i)+"</p>"},useData:!0}),getTemplateData:function(){return{message:this.message}}}),s=i.View.extend({className:"subschema",children:function(){return this.subSchemas.map((function(e,t){var n=e.get("description");return a.extend({index:t,message:n})}))}});t.default=s,e.exports=t.default},84757:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(35546)),a=o.View.extend({tagName:"main",className:"auth-container main-container",id:i.default.WIDGET_CONTAINER_ID,attributes:{"data-se":"auth-container",tabindex:"-1"},initialize:function(e){this.listenTo(e.appState,"change:beaconType",(function(e,t){this.$el.toggleClass("can-remove-beacon","security"===t)}))}});t.default=a,e.exports=t.default},17849:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="infobox"><span class="icon info-16"></span><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{arguments:"helpSupportNumber",bundle:"login",code:"contact.support"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:134}}}))+"</p></div>"},useData:!0}),className:"contact-support",getTemplateData:function(){return this.settings.pick("helpSupportNumber")}});t.default=i,e.exports=t.default},20109:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(15073)),s=r(n(6321)),l=r(n(2645)),u=r(n(75422)),c=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon auth-beacon-factor '+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"className")||(null!=t?a(t,"className"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"className",hash:{},data:o,loc:{start:{line:1,column:171},end:{line:1,column:184}}}):i)+'" data-se="factor-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div><div data-type="factor-types-dropdown" class="factors-dropdown-wrap"></div>'},useData:!0}),events:{"click .auth-beacon-factor":function(e){e.preventDefault(),e.stopPropagation();var t=this.$(".dropdown .options").toggle().is(":visible");this.$("a.option-selected").attr("aria-expanded",t),t&&this.$("#okta-dropdown-options").find("li.factor-option:first a").focus()}},initialize:function(){this.options.appState.set("beaconType","factor")},getTemplateData:function(){var e=this.options.appState.get("factors");return{className:(e?l.default.findFactorInFactorsArray(e,this.options.provider,this.options.factorType):new a.default.Model(this.options.appState.get("factor"))).get("iconClassName")||""}},postRender:function(){this.options.animate&&this.$(".auth-beacon-factor").fadeIn(200),this.options.appState.get("hasMultipleFactorsAvailable")&&this.add(u.default,'[data-type="factor-types-dropdown"]')},fadeOut:function(){var e=s.default.defer();return this.$(".auth-beacon-factor").fadeOut(200,(function(){e.resolve()})),e.promise},equals:function(e,t){return e&&this instanceof e&&t.provider===this.options.provider&&(t.factorType===this.options.factorType||l.default.isOktaVerify(t.provider,t.factorType)&&l.default.isOktaVerify(this.options.provider,this.options.factorType))}});t.default=c,e.exports=t.default},89365:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=a.internal.util.Util,l=a.View.extend({template:i.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<li><a href="#" data-se="unlock" class="link js-unlock">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"unlockaccount"},data:o,loc:{start:{line:1,column:440},end:{line:1,column:484}}}))+"</a></li>"},3:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<li><a href="'+d((s=null!=(s=f(n,"href")||(null!=t?f(t,"href"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"href",hash:{},data:i,loc:{start:{line:1,column:539},end:{line:1,column:547}}}):s))+'" class="link js-custom" rel="noopener noreferrer" '+(null!=(a=f(n,"if").call(l,null!=t?f(t,"target"):t,{name:"if",hash:{},fn:e.program(4,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:598},end:{line:1,column:638}}}))?a:"")+">"+d((s=null!=(s=f(n,"text")||(null!=t?f(t,"text"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"text",hash:{},data:i,loc:{start:{line:1,column:639},end:{line:1,column:647}}}):s))+"</a></li>"},4:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'target="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"target")||(null!=t?a(t,"target"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"target",hash:{},data:o,loc:{start:{line:1,column:620},end:{line:1,column:630}}}):i)+'"'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" data-se="needhelp" aria-expanded="false" aria-controls="help-links-container" class="link help js-help">'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"needhelp"},data:o,loc:{start:{line:1,column:116},end:{line:1,column:155}}}))+'</a><ul class="help-links js-help-links" id="help-links-container"><li><a href="#" data-se="forgot-password" class="link js-forgot-password">'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"forgotpassword"},data:o,loc:{start:{line:1,column:296},end:{line:1,column:341}}}))+"</a></li>"+(null!=(i=c(n,"if").call(s,null!=(i=null!=t?c(t,"features"):t)?c(i,"selfServiceUnlock"):i,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:350},end:{line:1,column:500}}}))?i:"")+(null!=(i=c(n,"each").call(s,null!=(i=null!=t?c(t,"helpLinks"):t)?c(i,"custom"):i,{name:"each",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:500},end:{line:1,column:665}}}))?i:"")+'<li><a href="'+u("function"==typeof(a=null!=(a=c(n,"helpLinkUrl")||(null!=t?c(t,"helpLinkUrl"):t))?a:l)?a.call(s,{name:"helpLinkUrl",hash:{},data:o,loc:{start:{line:1,column:678},end:{line:1,column:693}}}):a)+'" data-se="help-link" class="link js-help-link" rel="noopener noreferrer" target="_blank">'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"help"},data:o,loc:{start:{line:1,column:783},end:{line:1,column:818}}}))+"</a></li></ul>"},useData:!0}),className:"auth-footer",initialize:function(){this.listenTo(this.state,"change:enabled",(function(e,t){this.$(".link").toggleClass("o-form-disabled",!t)}))},getTemplateData:function(){var e,t=this.settings.get("helpLinks.help");return e=t||i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"baseUrl")||(null!=t?a(t,"baseUrl"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"baseUrl",hash:{},data:o,loc:{start:{line:1,column:0},end:{line:1,column:11}}}):i)+"/help/login"},useData:!0})({baseUrl:this.settings.get("baseUrl")}),a._.extend(this.settings.toJSON({verbose:!0}),{helpLinkUrl:e})},postRender:function(){this.$(".js-help-links").hide()},toggleLinks:function(e){var t=this;e.preventDefault(),this.$(".js-help-links").slideToggle(200,(function(){t.$(".js-help").attr("aria-expanded",t.$(".js-help-links").is(":visible"))}))},events:{"click .js-help":function(e){e.preventDefault(),this.state.get("enabled")&&this.toggleLinks(e)},"click .js-forgot-password":function(e){if(e.preventDefault(),this.state.get("enabled")){var t=this.settings.get("helpLinks.forgotPassword");t?s.redirect(t):this.options.appState.trigger("navigate","signin/forgot-password")}},"click .js-unlock":function(e){if(e.preventDefault(),this.state.get("enabled")){var t=this.settings.get("helpLinks.unlock");t?s.redirect(t):this.options.appState.trigger("navigate","signin/unlock")}}}});t.default=l,e.exports=t.default},71271:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=r(n(88522)),s=a.default.extend({template:i.default.template({1:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+c((a=null!=(a=d(n,"factorPageCustomLinkHref")||(null!=t?d(t,"factorPageCustomLinkHref"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorPageCustomLinkHref",hash:{},data:i,loc:{start:{line:1,column:40},end:{line:1,column:68}}}):a))+'" data-se="factor-page-custom-link" class="link js-factor-page-custom-link" rel="noopener noreferrer" target="_blank">'+c((a=null!=(a=d(n,"factorPageCustomLinkText")||(null!=t?d(t,"factorPageCustomLinkText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"factorPageCustomLinkText",hash:{},data:i,loc:{start:{line:1,column:186},end:{line:1,column:214}}}):a))+"</a>"},3:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link '+c((a=null!=(a=d(n,"linkClassName")||(null!=t?d(t,"linkClassName"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"linkClassName",hash:{},data:i,loc:{start:{line:1,column:265},end:{line:1,column:282}}}):a))+'" data-se="signout-link">'+c((a=null!=(a=d(n,"linkText")||(null!=t?d(t,"linkText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"linkText",hash:{},data:i,loc:{start:{line:1,column:307},end:{line:1,column:319}}}):a))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"hasFactorPageCustomLink"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:225}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"showLink"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:225},end:{line:1,column:330}}}))?i:"")},useData:!0}),className:"auth-footer clearfix",getTemplateData:function(){var e=a.default.prototype.getTemplateData.apply(this,arguments),t=this.settings.get("helpLinks.factorPage.href"),n=this.settings.get("helpLinks.factorPage.text"),r=!this.settings.get("features.hideSignOutLinkInMFA")&&!this.settings.get("features.mfaOnlyFlow");return Object.assign({},e,{hasFactorPageCustomLink:n&&t,factorPageCustomLinkHref:t,factorPageCustomLinkText:n,showLink:r})}});t.default=s,e.exports=t.default},83536:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=a.View.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="content-container"><span class="registration-label">'+c((a=null!=(a=d(n,"label")||(null!=t?d(t,"label"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"label",hash:{},data:i,loc:{start:{line:1,column:64},end:{line:1,column:73}}}):a))+'</span><a title="'+c((a=null!=(a=d(n,"text")||(null!=t?d(t,"text"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"text",hash:{},data:i,loc:{start:{line:1,column:90},end:{line:1,column:98}}}):a))+'" aria-label="'+c((a=null!=(a=d(n,"text")||(null!=t?d(t,"text"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"text",hash:{},data:i,loc:{start:{line:1,column:112},end:{line:1,column:120}}}):a))+'" class="registration-link" href="#">'+c((a=null!=(a=d(n,"text")||(null!=t?d(t,"text"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"text",hash:{},data:i,loc:{start:{line:1,column:157},end:{line:1,column:165}}}):a))+"</a></div>"},useData:!0}),className:"registration-container",events:{"click a.registration-link":"handleClickEvent"},handleClickEvent:function(e){e.preventDefault();var t=this.settings.get("registration.click");t?t():this.options.appState.get("isIdxStateToken")?this.options.appState.trigger("navigate","signin/enroll-user"):this.options.appState.trigger("navigate","signin/register")},getTemplateData:function(){return{label:(0,a.loc)("registration.signup.label","login"),text:(0,a.loc)("registration.signup.text","login")}}});t.default=s,e.exports=t.default},88522:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(12990)),a=r(n(2875)),s=n(6475),l=r(n(35546));function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var d=s.internal.util.Util,f=s.View.extend({template:a.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link '+c((a=null!=(a=d(n,"linkClassName")||(null!=t?d(t,"linkClassName"):t))?a:l,(0,i.default)(a)===u?a.call(s,{name:"linkClassName",hash:{},data:o,loc:{start:{line:1,column:24},end:{line:1,column:41}}}):a))+'" data-se="signout-link">'+c((a=null!=(a=d(n,"linkText")||(null!=t?d(t,"linkText"):t))?a:l,(0,i.default)(a)===u?a.call(s,{name:"linkText",hash:{},data:o,loc:{start:{line:1,column:66},end:{line:1,column:78}}}):a))+"</a>"},useData:!0}),className:"auth-footer clearfix",events:{'click a[data-se="signout-link"]':"handleSignout"},handleSignout:function(e){var t=this;e.preventDefault();var n=this.options.appState;n.trigger("signOut");var r=n.get("isSMSPasswordRecovery");this.model.doTransaction((function(e){return e.cancel().then(p)})).then((function(){t.settings.get("backToSignInUri")&&!r?d.redirect(t.settings.get("backToSignInUri")):(t.state.set("navigateDir",l.default.DIRECTION_BACK),n.trigger("navigate",""))}))},getTemplateData:function(){return{linkClassName:s._.isUndefined(this.options.linkClassName)?"goto":this.options.linkClassName,linkText:this.options.linkText||(0,s.loc)("goback","login")}}});function p(e){return c(c({},e),{},{data:null})}t.default=f,e.exports=t.default},41706:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"goback"},data:o,loc:{start:{line:1,column:50},end:{line:1,column:87}}}))+"</a>"},useData:!0}),className:"auth-footer",events:{"click .help":function(e){e.preventDefault(),this.back()}},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")}});t.default=s,e.exports=t.default},11205:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="link help" data-se="back-link">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"goback"},data:o,loc:{start:{line:1,column:66},end:{line:1,column:103}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"showLink"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:114}}}))?i:""},useData:!0}),className:"auth-footer",events:{"click .help":function(e){e.preventDefault(),this.back()}},back:function(){this.state.set("navigateDir",a.default.DIRECTION_BACK),this.options.appState.trigger("navigate","")},getTemplateData:function(){var e=this.model.appState.get("flashError");return{showLink:e.is&&e.is("terminal")}}});t.default=s,e.exports=t.default},1752:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="beacon-blank"></div><div class="bg-helper auth-beacon auth-beacon-security" data-se="loading-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>'},useData:!0}),equals:function(e){return e&&this instanceof e}});t.default=i,e.exports=t.default},9695:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"piv-beacon",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon smartcard" data-se="piv-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div>'},useData:!0}),equals:function(e){return e&&this instanceof e}});t.default=i,e.exports=t.default},25015:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(2645)),s=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="password-requirements--header">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"password.complexity.requirements.header"},data:o,loc:{start:{line:1,column:63},end:{line:1,column:133}}}))+'</div><ul class="password-requirements--list">'+(null!=(i=s(n,"each").call(a,null!=t?s(t,"requirements"):t,{name:"each",hash:{},fn:e.program(2,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:179},end:{line:1,column:268}}}))?i:"")+"</ul>"},2:function(e,t,n,r,o){return'<li class="password-requirements--list-item">'+e.escapeExpression(e.lambda(t,t))+"</li>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"requirements"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:280}}}))?i:""},useData:!0}),attributes:{"data-se":"password-requirements-html"},allRequirements:[],initialize:function(e){var t=e.policy;t&&(this.allRequirements=a.default.getPasswordComplexityDescriptionForHtmlList(t))},getTemplateData:function(){return{requirements:this.allRequirements}}});t.default=s,e.exports=t.default},94164:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31049)),a=r(n(2875)),s=n(6475),l=r(n(66757));function u(e,t){var n=t.get("securityImage"),r=t.get("securityImageDescription"),o=t.get("isUndefinedUser"),i=t.get("isNewUser"),a=!o&&!i;if(e.css("background-image",""),e.removeClass("new-user undefined-user"),i)e.addClass("new-user");else{if(!o)return a?(e.removeAttr("aria-describedby"),e.find(".accessibility-text").text(r),void e.css("background-image","url("+s._.escape(n)+")")):void 0;e.addClass("undefined-user")}}function c(e,t){(0,s.$)(window).on("resize.securityBeaconQtip",s._.debounce((function(){e.is(":visible")&&e.qtip("show")}),300)),e.qtip({prerender:!0,content:{text:(0,s.loc)("primaryauth.newUser.tooltip","login",[s._.escape(t)]),button:(0,s.loc)("primaryauth.newUser.tooltip.close","login")},style:{classes:"okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded",tip:{height:12,width:16}},position:{my:"top center",at:"center",target:(0,s.$)(".auth-beacon-security"),adjust:{method:"flip",scroll:!1,resize:!0},effect:!1},hide:{event:!1,fixed:!0},show:{event:!1,delay:200},events:{move:function(e,t){t.elements.target.is(":visible")||(t.set("hide.effect",!1),t.hide(),t.set("hide.effect",!0))}}}),setTimeout((function(){e.qtip("toggle",e.is(":visible"))}),0)}function d(e){e.qtip("destroy"),(0,s.$)(window).off("resize.securityBeaconQtip")}function f(e,t,n){return p.apply(this,arguments)}function p(){return(p=(0,i.default)(o.default.mark((function e(t,n,r){var i,a,s,f,p,h,m;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=t.find(".auth-beacon-security"),a=t.find(".js-auth-beacon-border"),s=!n.get("isUndefinedUser"),f=n.get("isNewUser"),p=t.find(".radial-progress-bar"),h=n.get("baseUrl").match(/https?:\/\/(.[^/]+)/)[1],m=200,r){e.next=11;break}return u(i,n),a.toggleClass("auth-beacon-border",s),e.abrupt("return");case 11:if(d(i),s){e.next=16;break}i.fadeOut(m,(function(){u(i,n),a.removeClass("auth-beacon-border"),i.fadeIn(m)})),e.next=21;break;case 16:return a.removeClass("auth-beacon-border"),e.next=19,l.default.radialProgressBar({$el:p,swap:function(){i.fadeOut(m,(function(){u(i,n),i.fadeIn(m)}))}});case 19:a.addClass("auth-beacon-border"),f&&c(i,h);case 21:case"end":return e.stop()}}),e)})))).apply(this,arguments)}var h=s.View.extend({template:a.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="beacon-blank"><div class="radial-progress-bar"><div class="circle left"></div><div class="circle right"></div></div></div><div aria-live="polite" role="img" class="bg-helper auth-beacon auth-beacon-security" data-se="security-beacon"><span class="accessibility-text"></span><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>'},useData:!0}),className:"js-security-beacon",initialize:function(e){this.update=s._.partial(f,this.$el,e.appState),this.listenTo(e.appState,"change:securityImage",this.update),this.listenTo(e.appState,"loading",(function(e){this.$el.toggleClass("beacon-loading",e),this.removeAntiPhishingMessage()})),this.options.appState.set("beaconType","security"),this.listenTo(e.appState,"navigate",this.removeAntiPhishingMessage)},postRender:function(){this.update(!1)},equals:function(e){return e&&this instanceof e},removeAntiPhishingMessage:function(){this.$el.find(".auth-beacon-security").qtip("destroy")}});t.default=h,e.exports=t.default},26069:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(35546)),a=o.View.extend({tagName:"a",className:"skip-to-content-link",attributes:{href:"#".concat(i.default.WIDGET_CONTAINER_ID)},initialize:function(){this.$el.append((0,o.loc)("skip.to.main.content","login"))}});t.default=a,e.exports=t.default},64521:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475).View.extend({className:"okta-waiting-spinner",attributes:{"data-se":"o-form-okta-waiting-spinner"},modelEvents:{"spinner:show":"show","spinner:hide":"hide"},initialize:function(e){e&&!1===e.visible&&this.hide()},show:function(){this.$el.removeClass("hide")},hide:function(){this.$el.addClass("hide")}});t.default=r,e.exports=t.default},50160:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475);n(48231);var i=r(n(34425)),a=o.internal.views.forms.inputs.TextBox,s=a.extend({postRender:function(){if("number"===this.options.type){var e=this.$("input");e.attr({pattern:"[0-9]*",inputmode:"numeric"})}a.prototype.postRender.apply(this,arguments)},focus:function(){if(!i.default.isIE())return a.prototype.focus.apply(this,arguments)}});t.default=s,e.exports=t.default},91482:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)).default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"clientURI")||(null!=t?a(t,"clientURI"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"clientURI",hash:{},data:o,loc:{start:{line:1,column:26},end:{line:1,column:39}}}):i)+'" class="client-logo-link" target="_blank">'},3:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo custom-logo" src="'+l("function"==typeof(i=null!=(i=u(n,"customLogo")||(null!=t?u(t,"customLogo"):t))?i:s)?i.call(a,{name:"customLogo",hash:{},data:o,loc:{start:{line:1,column:149},end:{line:1,column:163}}}):i)+'" alt="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"common.logo.alt"},data:o,loc:{start:{line:1,column:170},end:{line:1,column:216}}}))+'" aria-hidden="true" />'},5:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo default-logo" src="'+l("function"==typeof(i=null!=(i=u(n,"defaultLogo")||(null!=t?u(t,"defaultLogo"):t))?i:s)?i.call(a,{name:"defaultLogo",hash:{},data:o,loc:{start:{line:1,column:290},end:{line:1,column:305}}}):i)+'" alt="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"common.logo.alt"},data:o,loc:{start:{line:1,column:312},end:{line:1,column:358}}}))+'" aria-hidden="true" />'},7:function(e,t,n,r,o){return"</a>"},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="issuer"><span>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"issuer")||(null!=t?a(t,"issuer"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"issuer",hash:{},data:o,loc:{start:{line:1,column:566},end:{line:1,column:576}}}):i)+"</span></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:89}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"customLogo"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.program(5,o,0),data:o,loc:{start:{line:1,column:89},end:{line:1,column:388}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:388},end:{line:1,column:416}}}))?i:"")+'<h1><span class="title-text">'+(null!=(i=(s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{arguments:"appName",bundle:"login",code:"consent.required.text"},data:o,loc:{start:{line:1,column:445},end:{line:1,column:519}}}))?i:"")+"</span>"+(null!=(i=s(n,"if").call(a,null!=t?s(t,"issuer"):t,{name:"if",hash:{},fn:e.program(9,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:526},end:{line:1,column:596}}}))?i:"")+"</h1>"},useData:!0});t.default=o,e.exports=t.default},13871:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CONFIGURED_FLOW=void 0;t.CONFIGURED_FLOW={DEFAULT:"default",PROCEED:"proceed",LOGIN:"login",REGISTRATION:"signup",RESET_PASSWORD:"resetPassword",UNLOCK_ACCOUNT:"unlockAccount"}},92282:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.handleConfiguredFlow=function(e,t){return h.apply(this,arguments)};var o=r(n(70232)),i=r(n(31049)),a=n(13671),s=r(n(36894)),l=n(13955),u=n(13871);function c(e,t,n){return d.apply(this,arguments)}function d(){return(d=(0,i.default)(o.default.mark((function e(t,n,r){var i;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t.neededToProceed.find((function(e){return e.name===n}))){e.next=4;break}return s.default.warn("Expected remediation not found, Org may be misconfigured for this flow"),e.abrupt("return",t);case 4:return e.prev=4,e.next=7,t.proceed(n);case 7:return i=e.sent,e.abrupt("return",i);case 11:if(e.prev=11,e.t0=e.catch(4),"string"!=typeof e.t0||!e.t0.startsWith("Unknown remediation choice")){e.next=18;break}return s.default.warn("flow [".concat(r,"] not valid with current Org configurations")),e.abrupt("return",t);case 18:throw e.t0;case 19:case"end":return e.stop()}}),e,null,[[4,11]])})))).apply(this,arguments)}function f(e){return p.apply(this,arguments)}function p(){return p=(0,i.default)(o.default.mark((function e(t){var n,r=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:n=r.length>1&&void 0!==r[1]?r[1]:"default",e.t0=n,e.next=e.t0===u.CONFIGURED_FLOW.DEFAULT||e.t0===u.CONFIGURED_FLOW.PROCEED||e.t0===u.CONFIGURED_FLOW.LOGIN?4:e.t0===u.CONFIGURED_FLOW.REGISTRATION||e.t0===u.CONFIGURED_FLOW.RESET_PASSWORD?5:e.t0===u.CONFIGURED_FLOW.UNLOCK_ACCOUNT?6:9;break;case 4:case 5:return e.abrupt("return",t);case 6:return e.next=8,c(t,l.FORMS.UNLOCK_ACCOUNT,n);case 8:return e.abrupt("return",e.sent);case 9:throw s.default.warn("Unknown `flow` value: ".concat(n)),new a.ConfigError('Invalid "flow" configuration');case 11:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}function h(){return(h=(0,i.default)(o.default.mark((function e(t,n){var r,i,a;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.getAuthClient(),i=r.idx.getFlow(),e.next=4,f(t,i);case 4:return a=e.sent,e.abrupt("return",a);case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},98462:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(59155);Object.keys(r).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===r[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}}))}));var o=n(86183);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var i=n(92282);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var a=n(13871);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var s=n(57852);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}))},59155:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.interactionCodeFlow=function(e,t){return c.apply(this,arguments)};var o=r(n(70232)),i=r(n(31049)),a=r(n(35546)),s=n(13671),l=n(2659),u=n(45570);function c(){return(c=(0,i.default)(o.default.mark((function e(t,n){var r,i,c,d,f,p,h,m;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.interactionCode,i=t.getAuthClient(),e.next=4,i.idx.getSavedTransactionMeta();case 4:if(c=e.sent,d=i.options.state||(null==c?void 0:c.state),(f="remediation"===t.get("mode"))&&i.idx.clearTransactionMeta(),!("always"===t.get("redirect"))){e.next=16;break}if(p=t.get("redirectUri")){e.next=13;break}throw new s.ConfigError('"redirectUri" is required');case 13:return h=(0,l.toQueryString)({interaction_code:r,state:d}),window.location.assign(p+h),e.abrupt("return");case 16:if(!f){e.next=19;break}return t.callGlobalSuccess(a.default.SUCCESS,{interaction_code:r,state:d}),e.abrupt("return");case 19:if(c){e.next=21;break}throw new s.ConfigError("Could not load transaction data from storage");case 21:return m=c.codeVerifier,e.abrupt("return",i.token.exchangeCodeForTokens({codeVerifier:m,interactionCode:r}).then((function(e){var n=e.tokens;t.callGlobalSuccess(a.default.SUCCESS,{tokens:n})})).catch((function(e){var n=(0,u.getTypedOAuthError)(e);if(n instanceof u.RecoverableError&&n.is("terminal"))throw n;t.callGlobalError(e)})).finally((function(){i.idx.clearTransactionMeta()})));case 23:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},69977:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n="osw-oie-state-handle",r="osw-oie-last-initiated-login-url",o="osw-oie-resend-timestamp",i={removeStateHandle:function(){sessionStorage.removeItem(n),sessionStorage.removeItem(r)},setStateHandle:function(e){sessionStorage.setItem(n,e),sessionStorage.setItem(r,window.location.href)},getStateHandle:function(){return sessionStorage.getItem(n)},getLastInitiatedLoginUrl:function(){return sessionStorage.getItem(r)},removeResendTimestamp:function(){sessionStorage.removeItem(o)},setResendTimestamp:function(e){sessionStorage.setItem(o,e)},getResendTimestamp:function(){return sessionStorage.getItem(o)}};t.default=i,e.exports=t.default},16100:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45091)),i=n(19596),a=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return o.default.chain(t).filter((function(e){var t;return Array.isArray(null===(t=e.messages)||void 0===t?void 0:t.value)&&e.messages.value.length})).map((function(t){return{property:e?"".concat(e,".").concat(t.name):t.name,errorSummary:t.messages.value.map(i.getMessage),errorKey:t.messages.value.map(i.getMessageKey)}})).value()},s=function(e){var t=[];if(!e.remediation||!Array.isArray(e.remediation.value)||0===e.remediation.value.length)return t;var n=e.remediation.value[0].value;return Array.isArray(n)?(t.push(a(null,n)),o.default.each(n,(function(e){var n,r=e.name;Array.isArray(null===(n=e.form)||void 0===n?void 0:n.value)&&t.push(a(r,e.form.value)),Array.isArray(e.options)&&o.default.each(e.options,(function(e){var n,o;Array.isArray(null===(n=e.value)||void 0===n||null===(o=n.form)||void 0===o?void 0:o.value)&&t.push(a(r,e.value.form.value))}))})),function(e,t){if(!Array.isArray(e))return[];if(!o.default.isFunction(t)||1===e.length)return e;for(var n=[],r=0;r<e.length;r++){for(var i=!1,a=r+1;a<e.length;a++)if(t(e[r],e[a])){i=!0;break}i||n.push(e[r])}return n}(o.default.flatten(t),o.default.isEqual)):t},l=function(e){var t,n=[];return Array.isArray(null===(t=e.messages)||void 0===t?void 0:t.value)&&(n=e.messages.value.map(i.getMessageKey)),n},u={convertFormErrors:function(e){var t,n,r;return{responseJSON:{errorCauses:s(e),errorSummary:(t=e,r=[],Array.isArray(null===(n=t.messages)||void 0===n?void 0:n.value)&&(r=t.messages.value.map(i.getMessage)),r.join(". ")),errorSummaryKeys:l(e),errorIntent:e.intent}}},isIonErrorResponse:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e.version},isIdxSessionExpiredError:function(e){var t,n,r,o,i=null==e||null===(t=e.context)||void 0===t||null===(n=t.messages)||void 0===n||null===(r=n.value[0])||void 0===r||null===(o=r.i18n)||void 0===o?void 0:o.key;return i&&"idx.session.expired"===i}};t.default=u,e.exports=t.default},13955:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.TERMINAL_FORMS=t.ORG_PASSWORD_RECOVERY_LINK=t.INTERSTITIAL_REDIRECT_VIEW=t.ID_PROOFING_TYPE=t.IDP_FORM_TYPE=t.HINTS=t.FORM_NAME_TO_OPERATION_MAP=t.FORMS_WITH_STATIC_BACK_LINK=t.FORMS_WITHOUT_SIGNOUT=t.FORMS_FOR_VERIFICATION=t.FORMS=t.AUTHENTICATOR_METHODS=t.AUTHENTICATOR_KEY=t.ATTR_FORMAT=t.ACTIONS=void 0;var o,i=r(n(15985)),a=r(n(35546)),s={IDENTIFY:"identify",SELECT_IDENTIFY:"select-identify",IDENTIFY_RECOVERY:"identify-recovery",SELECT_ENROLL_PROFILE:"select-enroll-profile",ENROLL_PROFILE:"enroll-profile",ENROLL_PROFILE_UPDATE:"profile-update",UNLOCK_ACCOUNT:"unlock-account",REQUEST_ACTIVATION:"request-activation-email",CONSENT_ADMIN:"admin-consent",CONSENT_ENDUSER:"consent",CONSENT_GRANULAR:"granular-consent",CONSENT_EMAIL_CHALLENGE:"email-challenge-consent",SELECT_AUTHENTICATOR_AUTHENTICATE:"select-authenticator-authenticate",SELECT_AUTHENTICATOR_UNLOCK:"select-authenticator-unlock-account",AUTHENTICATOR_VERIFICATION_DATA:"authenticator-verification-data",CHALLENGE_AUTHENTICATOR:"challenge-authenticator",CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR:"challenge-webauthn-autofillui-authenticator",CHALLENGE_POLL:"challenge-poll",RESEND:"resend",SELECT_AUTHENTICATOR_ENROLL:"select-authenticator-enroll",SELECT_AUTHENTICATOR_ENROLL_DATA:"select-authenticator-enroll-data",AUTHENTICATOR_ENROLLMENT_DATA:"authenticator-enrollment-data",ENROLL_AUTHENTICATOR:"enroll-authenticator",SELECT_ENROLLMENT_CHANNEL:"select-enrollment-channel",ENROLLMENT_CHANNEL_DATA:"enrollment-channel-data",ENROLL_POLL:"enroll-poll",REENROLL_AUTHENTICATOR:"reenroll-authenticator",REENROLL_AUTHENTICATOR_WARNING:"reenroll-authenticator-warning",REENROLL_CUSTOM_PASSWORD_EXPIRY:"reenroll-custom-password-expiry",REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING:"reenroll-custom-password-expiry-warning",RESET_AUTHENTICATOR:"reset-authenticator",SKIP:"skip",POLL:"poll",FAILURE_REDIRECT:"failure-redirect",SUCCESS_REDIRECT:"success-redirect",REDIRECT_IDP:"redirect-idp",REDIRECT_IDVERIFY:"redirect-idverify",PIV_IDP:"piv-idp",DEVICE_CHALLENGE_POLL:"device-challenge-poll",DEVICE_APPLE_SSO_EXTENSION:"device-apple-sso-extension",CANCEL_TRANSACTION:"cancel-transaction",LAUNCH_AUTHENTICATOR:"launch-authenticator",LAUNCH_WEBAUTHN_AUTHENTICATOR:"launch-webauthn-authenticator",ENROLL_WEBAUTHN_RESIDENTKEY:"enroll-webauthn-residentkey",LAUNCH_PASSKEYS_AUTHENTICATOR:"launch-passkeys-authenticator",DEVICE_ENROLLMENT_TERMINAL:"device-enrollment-terminal",USER_CODE:"user-code",KEEP_ME_SIGNED_IN:"keep-me-signed-in",DEVICE_ASSURANCE_GRACE_PERIOD:"device-assurance-grace-period",TERMINAL:"terminal"};t.FORMS=s;var l=[s.IDENTIFY,s.SUCCESS_REDIRECT,s.ENROLL_PROFILE,s.DEVICE_ENROLLMENT_TERMINAL,s.CONSENT_ADMIN,s.CONSENT_ENDUSER,s.CONSENT_GRANULAR,s.CONSENT_EMAIL_CHALLENGE,s.USER_CODE,s.KEEP_ME_SIGNED_IN];t.FORMS_WITHOUT_SIGNOUT=l;var u=[s.SELECT_AUTHENTICATOR_ENROLL,s.SELECT_AUTHENTICATOR_AUTHENTICATE];t.FORMS_WITH_STATIC_BACK_LINK=u;var c=[s.SELECT_AUTHENTICATOR_AUTHENTICATE,s.CHALLENGE_AUTHENTICATOR,s.CHALLENGE_POLL,s.RESEND];t.FORMS_FOR_VERIFICATION=c;t.AUTHENTICATOR_KEY={EMAIL:"okta_email",PASSWORD:"okta_password",PHONE:"phone_number",WEBAUTHN:"webauthn",SECURITY_QUESTION:"security_question",OV:"okta_verify",GOOGLE_OTP:"google_otp",ON_PREM:"onprem_mfa",RSA:"rsa_token",DUO:"duo",IDP:"external_idp",CUSTOM_OTP:"custom_otp",SYMANTEC_VIP:"symantec_vip",YUBIKEY:"yubikey_token",CUSTOM_APP:"custom_app",SMARTCARD:"smart_card_idp",TAC:"tac"};t.AUTHENTICATOR_METHODS={PUSH:"push"};var d=(o={},(0,i.default)(o,s.SELECT_AUTHENTICATOR_UNLOCK,a.default.UNLOCK_ACCOUNT),(0,i.default)(o,s.IDENTIFY,a.default.PRIMARY_AUTH),(0,i.default)(o,s.IDENTIFY_RECOVERY,a.default.FORGOT_PASSWORD),o);t.FORM_NAME_TO_OPERATION_MAP=d;var f="currentAuthenticator-recover";t.ORG_PASSWORD_RECOVERY_LINK=f;var p={ENROLLED_PASSWORD_RECOVERY_LINK:"currentAuthenticatorEnrollment-recover",ORG_PASSWORD_RECOVERY_LINK:f};t.ACTIONS=p;t.HINTS={CAPTCHA:"captcha"};var h=[s.TERMINAL,s.DEVICE_ENROLLMENT_TERMINAL];t.TERMINAL_FORMS=h;t.IDP_FORM_TYPE={X509:"X509"};t.INTERSTITIAL_REDIRECT_VIEW={DEFAULT:"DEFAULT",NONE:"NONE"};t.ATTR_FORMAT={COUNTRY_CODE:"country-code"};t.ID_PROOFING_TYPE={IDV_PERSONA:"IDV_PERSONA",IDV_CLEAR:"IDV_CLEAR",IDV_INCODE:"IDV_INCODE",IDV_STANDARD:"IDV_STANDARD",IDV_OIN:"IDV_OIN"}},2715:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.getV1ClassName=t.getClassNameMapping=void 0;var o,i,a,s,l,u,c=r(n(15985)),d=n(13955),f=(u={},(0,c.default)(u,d.FORMS.IDENTIFY,(o={},(0,c.default)(o,d.FORMS.IDENTIFY,"primary-auth"),(0,c.default)(o,d.AUTHENTICATOR_KEY.PASSWORD,"primary-auth"),o)),(0,c.default)(u,d.FORMS.IDENTIFY_RECOVERY,(0,c.default)({},d.FORMS.IDENTIFY_RECOVERY,"forgot-password")),(0,c.default)(u,d.FORMS.ENROLL_PROFILE,(0,c.default)({},d.FORMS.ENROLL_PROFILE,"registration")),(0,c.default)(u,d.FORMS.CHALLENGE_AUTHENTICATOR,(i={},(0,c.default)(i,d.AUTHENTICATOR_KEY.EMAIL,"mfa-verify-passcode"),(0,c.default)(i,d.AUTHENTICATOR_KEY.PASSWORD,"mfa-verify-password"),(0,c.default)(i,"sms","mfa-verify-passcode"),(0,c.default)(i,"voice","mfa-verify-passcode"),(0,c.default)(i,d.AUTHENTICATOR_KEY.SECURITY_QUESTION,"mfa-verify-question"),(0,c.default)(i,d.AUTHENTICATOR_KEY.WEBAUTHN,"mfa-verify-webauthn"),(0,c.default)(i,d.AUTHENTICATOR_KEY.ON_PREM,"mfa-verify-totp"),(0,c.default)(i,d.AUTHENTICATOR_KEY.RSA,"mfa-verify-totp"),(0,c.default)(i,d.AUTHENTICATOR_KEY.OV,"mfa-verify"),(0,c.default)(i,d.AUTHENTICATOR_KEY.GOOGLE_OTP,"mfa-verify"),(0,c.default)(i,d.AUTHENTICATOR_KEY.DUO,"mfa-verify-duo"),(0,c.default)(i,d.AUTHENTICATOR_KEY.SYMANTEC_VIP,"mfa-verify"),(0,c.default)(i,d.AUTHENTICATOR_KEY.YUBIKEY,"mfa-verify"),(0,c.default)(i,d.AUTHENTICATOR_KEY.CUSTOM_APP,"mfa-verify"),i)),(0,c.default)(u,d.FORMS.CHALLENGE_POLL,(a={},(0,c.default)(a,d.AUTHENTICATOR_KEY.OV,"mfa-verify"),(0,c.default)(a,d.AUTHENTICATOR_KEY.CUSTOM_APP,"mfa-verify"),a)),(0,c.default)(u,d.FORMS.RESEND_PUSH,(s={},(0,c.default)(s,d.AUTHENTICATOR_KEY.OV,"mfa-verify"),(0,c.default)(s,d.AUTHENTICATOR_KEY.CUSTOM_APP,"mfa-verify"),s)),(0,c.default)(u,d.FORMS.ENROLL_AUTHENTICATOR,(l={},(0,c.default)(l,d.AUTHENTICATOR_KEY.EMAIL,"enroll-email"),(0,c.default)(l,d.AUTHENTICATOR_KEY.PASSWORD,"enroll-password"),(0,c.default)(l,"sms","enroll-sms"),(0,c.default)(l,"voice","enroll-call"),(0,c.default)(l,d.AUTHENTICATOR_KEY.SECURITY_QUESTION,"enroll-question"),(0,c.default)(l,d.AUTHENTICATOR_KEY.WEBAUTHN,"enroll-webauthn"),(0,c.default)(l,d.AUTHENTICATOR_KEY.ON_PREM,"enroll-onprem"),(0,c.default)(l,d.AUTHENTICATOR_KEY.RSA,"enroll-rsa"),(0,c.default)(l,d.AUTHENTICATOR_KEY.DUO,"enroll-duo"),(0,c.default)(l,d.AUTHENTICATOR_KEY.SYMANTEC_VIP,"enroll-symantec"),(0,c.default)(l,d.AUTHENTICATOR_KEY.YUBIKEY,"enroll-yubikey"),l)),(0,c.default)(u,d.FORMS.SELECT_AUTHENTICATOR_ENROLL,{"select-authenticator-enroll":"enroll-choices"}),(0,c.default)(u,d.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,(0,c.default)({},d.AUTHENTICATOR_KEY.PASSWORD,"forgot-password")),(0,c.default)(u,d.FORMS.REENROLL_AUTHENTICATOR,(0,c.default)({},d.AUTHENTICATOR_KEY.PASSWORD,"password-expired")),(0,c.default)(u,d.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY,(0,c.default)({},d.AUTHENTICATOR_KEY.PASSWORD,"custom-password-expired")),(0,c.default)(u,d.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING,(0,c.default)({},d.AUTHENTICATOR_KEY.PASSWORD,"custom-password-expiry-warning")),(0,c.default)(u,d.FORMS.RESET_AUTHENTICATOR,(0,c.default)({},d.AUTHENTICATOR_KEY.PASSWORD,"forgot-password")),(0,c.default)(u,d.FORMS.CONSENT_ADMIN,(0,c.default)({},d.FORMS.CONSENT_ADMIN,"admin-consent-required")),(0,c.default)(u,d.FORMS.CONSENT_ENDUSER,(0,c.default)({},d.FORMS.CONSENT_ENDUSER,"consent-required")),u),p=function(e,t,n,r){if(r&&e===d.FORMS.IDENTIFY)return"forgot-password";var o=e;return t===d.AUTHENTICATOR_KEY.PHONE?o="".concat(n):t&&(o="".concat(t)),f[e]&&f[e][o]?f[e][o]:null};t.getV1ClassName=p;t.getClassNameMapping=function(e,t,n,r){var o=e;t&&(o=o+"--"+t);var i=p(e,t,n,r),a=[o];return i&&a.push(i),a}},23002:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(16100)),a={buildErrorObject:function(e,t){return i.default.isIonErrorResponse(e)?i.default.convertFormErrors(e):e.errorSummary?{responseJSON:e}:("function"==typeof t&&t(e),{responseJSON:{errorSummary:(0,o.loc)("error.unsupported.response","login")}})},isRateLimitError:function(e){var t,n,r,o;return!((null===(t=e.responseJSON)||void 0===t||null===(n=t.errorSummaryKeys)||void 0===n||!n.includes("tooManyRequests"))&&("E0000047"!==(null===(r=e.responseJSON)||void 0===r?void 0:r.errorCode)||null!==(o=e.responseJSON)&&void 0!==o&&o.errorIntent))}};t.default=a,e.exports=t.default},43318:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0});var o={};t.default=void 0;var i=r(n(15985)),a=n(6475),s=r(n(36894)),l=n(13955),u=n(19596);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var f=function e(t,n){var r,o;if(!(!1===n.mutable&&n.name.indexOf("questionKey")<0)){s.default.info("i18n label transformer"),s.default.info("\t remediationName: ",t.name),s.default.info("\t uiSchema: ",JSON.stringify(n));var i=null===(r=t.relatesTo)||void 0===r||null===(o=r.value)||void 0===o?void 0:o.key,c=i?".".concat(t.relatesTo.value.key):"",f="".concat(t.name).concat(c,"."),p="".concat(f).concat(n.name);if("text"===n.type&&n.name.indexOf("questionKey")>=0&&"custom"!==n.value&&(p="".concat(p,".").concat(n.value)),"checkbox"===n.type&&n.placeholder&&(s.default.info("\t 1: ",p),n.placeholder=(0,u.getI18NValue)(p,n.placeholder)),n.label){s.default.info("\t 2: ",p);var h=(0,u.getI18NParams)(t,i);n.label=n.customLabel?n.label:(0,u.getI18NValue)(p,n.label,h,t)}a.$.isPlainObject(n.options)&&(n.options=a._.mapObject(n.options,(function(e,t){var n="".concat(p,".").concat(t);return s.default.info("\t 3: ",n),(0,u.getI18NValue)(n,e)}))),Array.isArray(n.options)&&n.options.forEach((function(e){if(e.label){var n;if(e.authenticatorKey){var r;n="".concat(p,".").concat(e.authenticatorKey);var o=null===(r=e.value)||void 0===r?void 0:r.methodType;e.authenticatorKey===l.AUTHENTICATOR_KEY.OV&&o&&(n="".concat(n,".").concat(o))}else n="string"==typeof e.value||"number"==typeof e.value?"".concat(p,".").concat(e.value):p;s.default.info("\t 4: ",n);var i=e.relatesTo?d(d({},t),{},{relatesTo:{value:e.relatesTo}}):t,a=(0,u.getI18NParams)(i,e.authenticatorKey);e.label=(0,u.getI18NValue)(n,e.label,a,i)}})),Array.isArray(n.optionsUiSchemas)&&n.optionsUiSchemas.forEach((function(n){n.forEach((function(n){return e(t,n)}))}))}};t.default=function(e){var t;return Array.isArray(e.remediations)&&e.remediations.filter((function(e){return Array.isArray(e.uiSchema)&&e.uiSchema.length})).forEach((function(e){e.uiSchema.forEach((function(t){return f(e,t)}))})),Array.isArray(null===(t=e.messages)||void 0===t?void 0:t.value)&&e.messages.value.forEach((function(e){e.message=(0,u.getMessage)(e)})),e}},19596:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.isCustomizedI18nKey=t.getMessageKey=t.getMessageFromBrowserError=t.getMessage=t.getI18nKey=t.getI18NValue=t.getI18NParams=t.doesI18NKeyExist=void 0;var o,i=r(n(66583)),a=r(n(15985)),s=r(n(52115)),l=r(n(36894)),u=n(71244),c=n(25795),d=n(13056),f=n(13955),p=n(60296);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}var m="authfactor.webauthn.error",v="passkeys.authfactor.webauthn.error",g="oie.webauthn.label",y=["enroll-authenticator.security_question.credentials.questionKey.","challenge-authenticator.security_question.credentials.questionKey."],b=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,a.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({"identify.identifier":"primaryauth.username.placeholder","select-authenticator-unlock-account.identifier":"primaryauth.username.placeholder","unlock-account.identifier":"primaryauth.username.placeholder","identify.credentials.passcode":"primaryauth.password.placeholder","identify.rememberMe":"oie.remember","enroll-profile.userProfile.rememberMe":"oie.remember","identify-recovery.identifier":"password.forgot.email.or.username.placeholder","select-authenticator-enroll.authenticator.duo":"factor.duo","select-authenticator-enroll.authenticator.google_otp":"oie.google_authenticator.label","select-authenticator-enroll.authenticator.okta_email":"oie.email.label","select-authenticator-enroll.authenticator.okta_password":"oie.password.label","select-authenticator-enroll.authenticator.okta_verify":"oie.okta_verify.label","select-authenticator-enroll.authenticator.phone_number":"oie.phone.label","select-authenticator-enroll.authenticator.rsa_token":"factor.totpHard.rsaSecurId","select-authenticator-enroll.authenticator.security_question":"oie.security.question.label","select-authenticator-enroll.authenticator.symantec_vip":"factor.totpHard.symantecVip","select-authenticator-enroll.authenticator.webauthn":g,"select-authenticator-enroll.authenticator.yubikey_token":"oie.yubikey.label","select-authenticator-authenticate.authenticator.duo":"factor.duo","select-authenticator-authenticate.authenticator.google_otp":"oie.google_authenticator.label","select-authenticator-authenticate.authenticator.okta_email":"oie.email.label","select-authenticator-authenticate.authenticator.okta_password":"oie.password.label","select-authenticator-authenticate.authenticator.okta_verify.push":"oie.okta_verify.push.title","select-authenticator-authenticate.authenticator.okta_verify.signed_nonce":"oie.okta_verify.signed_nonce.label","select-authenticator-authenticate.authenticator.okta_verify.totp":"oie.okta_verify.totp.title","select-authenticator-authenticate.authenticator.phone_number":"oie.phone.label","select-authenticator-authenticate.authenticator.rsa_token":"factor.totpHard.rsaSecurId","select-authenticator-authenticate.authenticator.security_question":"oie.security.question.label","select-authenticator-authenticate.authenticator.symantec_vip":"factor.totpHard.symantecVip","select-authenticator-authenticate.authenticator.webauthn":g,"select-authenticator-authenticate.authenticator.yubikey_token":"oie.yubikey.label","select-authenticator-authenticate.authenticator.custom_app":"oie.custom.app.authenticator.title","select-authenticator-authenticate.authenticator.tac":"oie.tac.label","select-authenticator-unlock-account.authenticator.okta_email":"oie.email.label","select-authenticator-unlock-account.authenticator.phone_number":"oie.phone.label","select-authenticator-unlock-account.authenticator.okta_verify.push":"oie.okta_verify.push.title","authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce":"oie.okta_verify.signed_nonce.label","authenticator-verification-data.okta_verify.authenticator.methodType.push":"oie.okta_verify.push.title","authenticator-verification-data.okta_verify.authenticator.methodType.totp":"oie.okta_verify.totp.title","authenticator-enrollment-data.phone_number.authenticator.phoneNumber":"mfa.phoneNumber.placeholder","authenticator-enrollment-data.phone_number.authenticator.methodType.sms":"oie.phone.enroll.sms.label","authenticator-enrollment-data.phone_number.authenticator.methodType.voice":"oie.phone.enroll.voice.label","enroll-authenticator.okta_password.credentials.passcode":"oie.password.passwordLabel","enroll-authenticator.okta_email.credentials.passcode":"mfa.challenge.enterCode.placeholder","enroll-authenticator.phone_number.credentials.passcode":"mfa.challenge.enterCode.placeholder","enroll-authenticator.security_question.sub_schema_local_credentials.0":"oie.security.question.questionKey.label","enroll-authenticator.security_question.sub_schema_local_credentials.1":"oie.security.question.createQuestion.label","enroll-authenticator.security_question.credentials.answer":"mfa.challenge.answer.placeholder","enroll-authenticator.security_question.credentials.question":"oie.security.question.createQuestion.label","enroll-authenticator.security_question.credentials.questionKey":"oie.security.question.questionKey.label","enroll-authenticator.google_otp.credentials.passcode":"oie.google_authenticator.otp.enterCodeText","enroll-authenticator.onprem_mfa.credentials.clientData":"enroll.onprem.username.placeholder","enroll-authenticator.onprem_mfa.credentials.passcode":"enroll.onprem.passcode.placeholder","enroll-authenticator.rsa_token.credentials.clientData":"enroll.onprem.username.placeholder","enroll-authenticator.rsa_token.credentials.passcode":"enroll.onprem.passcode.placeholder","enroll-authenticator.symantec_vip.credentials.credentialId":"enroll.symantecVip.credentialId.placeholder","enroll-authenticator.symantec_vip.credentials.passcode":"enroll.symantecVip.passcode1.placeholder","enroll-authenticator.symantec_vip.credentials.nextPasscode":"enroll.symantecVip.passcode2.placeholder","enroll-authenticator.yubikey_token.credentials.passcode":"oie.yubikey.passcode.label","enrollment-channel-data.email":"oie.enroll.okta_verify.channel.email.label","enrollment-channel-data.phoneNumber":"mfa.phoneNumber.placeholder","select-enrollment-channel.authenticator.channel.qrcode":"oie.enroll.okta_verify.select.channel.qrcode.label","select-enrollment-channel.authenticator.channel.email":"oie.enroll.okta_verify.select.channel.email.label","select-enrollment-channel.authenticator.channel.sms":"oie.enroll.okta_verify.select.channel.sms.label","challenge-authenticator.okta_email.credentials.passcode":"mfa.challenge.enterCode.placeholder","challenge-authenticator.okta_password.credentials.passcode":"mfa.challenge.password.placeholder","challenge-authenticator.phone_number.credentials.passcode":"mfa.challenge.enterCode.placeholder","challenge-authenticator.security_question.credentials.answer":"mfa.challenge.answer.placeholder","challenge-authenticator.okta_verify.credentials.totp":"oie.okta_verify.totp.enterCodeText","challenge-authenticator.google_otp.credentials.passcode":"oie.google_authenticator.otp.enterCodeText","challenge-authenticator.onprem_mfa.credentials.passcode":"mfa.challenge.enterCode.placeholder","challenge-authenticator.rsa_token.credentials.passcode":"mfa.challenge.enterCode.placeholder","challenge-authenticator.custom_otp.credentials.passcode":"oie.custom_otp.verify.passcode.label","challenge-authenticator.symantec_vip.credentials.passcode":"oie.symantecVip.verify.passcode.label","challenge-authenticator.tac.credentials.passcode":"oie.custom_otp.verify.passcode.label","challenge-authenticator.yubikey_token.credentials.passcode":"oie.yubikey.passcode.label","challenge-authenticator.credentials.passcode":"oie.password.label","reset-authenticator.okta_password.credentials.passcode":"oie.password.newPasswordLabel","reset-authenticator.okta_password.confirmPassword":"oie.password.confirmPasswordLabel","reset-authenticator.okta_password.credentials.revokeSessions":"password.reset.revokeSessions","reenroll-authenticator.okta_password.credentials.passcode":"oie.password.newPasswordLabel","reenroll-authenticator.okta_password.confirmPassword":"oie.password.confirmPasswordLabel","reenroll-authenticator.okta_password.credentials.revokeSessions":"password.reset.revokeSessions","reenroll-authenticator-warning.okta_password.credentials.passcode":"oie.password.newPasswordLabel","reenroll-authenticator-warning.okta_password.confirmPassword":"oie.password.confirmPasswordLabel","reenroll-authenticator-warning.okta_password.credentials.revokeSessions":"password.reset.revokeSessions","enroll-authenticator.okta_password.confirmPassword":"oie.password.confirmPasswordLabel","enroll-authenticator.okta_password.credentials.revokeSessions":"password.reset.revokeSessions",incorrectPassword:"oie.password.incorrect.message","profile-update.userProfile.secondEmail":"oie.user.profile.secondary.email","user-code.userCode":"device.code.activate.label","api.authn.poll.error.push_rejected":"oktaverify.rejected","oie.authenticator.duo.method.duo.verification_timeout":"oie.authenticator.duo.error","oie.authenticator.duo.method.duo.verification_failed":"oie.authenticator.duo.error","idx.email.verification.required":"registration.complete.confirm.text",tooManyRequests:"oie.tooManyRequests","api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE":"oie.post.password.update.auth.failure.error","security.access_denied":"errors.E0000006",E0000009:"errors.E0000009",E0000020:"errors.E0000020","api.factors.error.sms.invalid_phone":"oie.phone.invalid","app.ldap.password.reset.failed":"errors.E0000017","oie.selfservice.unlock_user.challenge.failed.permissions":"errors.E0000006","core.auth.factor.signedNonce.error.invalidEnrollment":"core.auth.factor.signedNonce.error","core.auth.factor.signedNonce.error.invalidFactor":"core.auth.factor.signedNonce.error","core.auth.factor.signedNonce.error.deletedDevice":"core.auth.factor.signedNonce.error","core.auth.factor.signedNonce.error.invalidDeviceStatus":"core.auth.factor.signedNonce.error.invalidDevice","challenge-poll.custom_app.autoChallenge":"autoPush","challenge-poll.okta_verify.autoChallenge":"autoPush","authenticator-verification-data.authenticator.autoChallenge":"autoPush","authenticator-verification-data.okta_verify.authenticator.autoChallenge":"autoPush","authenticator-verification-data.custom_app.authenticator.autoChallenge":"autoPush"},p.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS),w=(0,a.default)({},f.FORMS.ENROLL_AUTHENTICATOR,(o={},(0,a.default)(o,f.AUTHENTICATOR_KEY.ON_PREM,{getParam:c.getAuthenticatorDisplayName}),(0,a.default)(o,f.AUTHENTICATOR_KEY.RSA,{getParam:c.getAuthenticatorDisplayName}),o)),_={"registration.error.invalidLoginEmail":{Email:"Email"},"registration.error.doesNotMatchPattern":{Email:"Email"},"registration.error.notUniqueWithinOrg":{Email:"Email"}};t.getI18NParams=function(e,t){var n=[],r=e.name;if(t===f.AUTHENTICATOR_KEY.WEBAUTHN){var o,i,a=null==e||null===(o=e.relatesTo)||void 0===o||null===(i=o.value)||void 0===i?void 0:i.displayName;if((0,d.isCustomDisplayName)(a))return n.push(a),n}if(w[r]&&w[r][t]){var s=w[r][t].getParam(e);n.push(s)}return n};var O=function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(y.forEach((function(n){if(0===e.indexOf(n)){var r=e.replace(n,"");t="security.".concat(r)}})),"select-authenticator-enroll.authenticator.webauthn"===e||"select-authenticator-authenticate.authenticator.webauthn"===e){var r,o,i=null==n||null===(r=n.relatesTo)||void 0===r||null===(o=r.value)||void 0===o?void 0:o.displayName;if((0,d.isCustomDisplayName)(i))return null;t=(0,d.getWebAuthnI18nKey)(d.WEBAUTHN_I18N_KEYS.LABEL,i)}else b[e]&&(t=b[e]);return t&&!s.default.login[t]&&(l.default.warn("expect i18n key ".concat(t," for ").concat(e," but not found in 'login' bundle.")),t=null),t};t.getI18nKey=O;t.doesI18NKeyExist=function(e){return!!s.default.login[e]};t.getI18NValue=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,o=O(e,r);return o?(0,u.loc)(o,"login",n):(l.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(t)),t)};t.getMessage=function(e){var t;if(null!==(t=e.i18n)&&void 0!==t&&t.key){var n,r,o=e.i18n.key,i=e.i18n.params||[];if(1===i.length&&""===i[0]&&(i=[]),b[null===(n=e.i18n)||void 0===n?void 0:n.key])o=b[null===(r=e.i18n)||void 0===r?void 0:r.key];else if(_[o]){var a,c=null===(a=e.i18n.params)||void 0===a?void 0:a[0];o=function(e,t){var n=e;return _[n][t]?n+=".".concat(t):n+=".custom",n}(o,c),i=o.endsWith("custom")?[c]:[]}if(s.default.login[o])return l.default.info("Override messages using i18n key ".concat(o)),(0,u.loc)(o,"login",i);if(function(e){return e.startsWith(m)}(o))return(0,u.loc)(m,"login");if(function(e){return e.startsWith(v)}(o))return(0,u.loc)(v,"login");if(o.startsWith("device.assurance.custom.remediation."))return e.message}return l.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(e.message)),e.message};t.getMessageFromBrowserError=function(e){if(e.name){var t="oie.browser.error.".concat(e.name);if(s.default.login[t])return l.default.info("Override messages using i18n key ".concat(t)),(0,u.loc)(t,"login")}return e.message};t.getMessageKey=function(e){var t;return(null==e||null===(t=e.i18n)||void 0===t?void 0:t.key)||""};t.isCustomizedI18nKey=function(e,t){var n,r=null===(n=t.get("languageCode"))||void 0===n?void 0:n.toLowerCase(),o=t.get("i18n");return null!=o&&Object.entries(o).some((function(t){var n=(0,i.default)(t,2),o=n[0],a=n[1];return o.toLowerCase()===r&&!!a[e]}))}},74600:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(12990)),a=n(13955);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var u=function e(t){var n={};return Object.keys(t).forEach((function(r){if("object"===(0,i.default)(t[r])){var o=e(t[r]);Object.keys(o).forEach((function(e){n[r+"."+e]=o[e]}))}else n[r]=t[r]})),n},c=(0,o.default)({},a.FORMS.CONSENT_GRANULAR,(function(e){return e.optedScopes&&"string"!=typeof e.optedScopes?l(l({},e),{},{optedScopes:u(e.optedScopes)}):e})),d=function(e,t){var n=t.toJSON(),r=c[e];return void 0===r?n:r(n)};t.default=d,e.exports=t.default},31639:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(31752)),i=n(6475),a=n(13955),s=function(e){return i._.isObject(e)},l=function(e){return!!e.messages},u=function(e){var t={};return i._.each(e,(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1?arguments[1]:void 0;"remediation"!==n&&("array"===e.type&&(t[n]={value:e.value}),"object"===e.type&&(t[n]=e.value))})),t},c=function(e){var t=[],n=1===e.neededToProceed.length&&"skip"===e.neededToProceed[0].name;return(i._.isEmpty(e.neededToProceed)||n)&&(e.context.success?t.push({name:e.context.success.name,href:e.context.success.href,value:[]}):e.context.messages?t.push({name:a.FORMS.TERMINAL,value:[]}):e.context.deviceEnrollment&&t.push({name:a.FORMS.DEVICE_ENROLLMENT_TERMINAL,value:[]})),{remediations:[].concat(t,(0,o.default)(e.neededToProceed))}},d=function(e,t){var n=t.remediations;if(0===n.filter((function(e){return"identify"===e.name})).length)return t;var r=e.get("idps");if(Array.isArray(r)){var o={};n.forEach((function(e){e.name===a.FORMS.REDIRECT_IDP&&e.idp&&(o[e.idp.id]=!0)}));var i=e.get("baseUrl"),s=t.idx.context.stateHandle,l=r.filter((function(e){return!o[e.id]})).map((function(e){var t={id:e.id,name:e.text},n="".concat(i,"/sso/idps/").concat(e.id,"?stateToken=").concat(s);return e.className&&(t.className=e.className),{name:a.FORMS.REDIRECT_IDP,type:e.type,idp:t,href:n}}));t.remediations=n.concat(l)}return t},f=function(e,t,n){if(Array.isArray(t.remediations)){var r=t.remediations.filter((function(e){return e.name===a.FORMS.REDIRECT_IDP}));if(1!==r.length||1!==t.remediations.length)return;if(e.get("oauth2Enabled")&&!n)return;var o={name:a.FORMS.SUCCESS_REDIRECT,href:r[0].href,value:[]};t.remediations=[o]}},p=function(e){Array.isArray(e.remediations)&&e.remediations.forEach((function(t){var n,r;if(t.name===a.FORMS.REDIRECT_IDP&&(null==t||null===(n=t.relatesTo)||void 0===n||null===(r=n.value)||void 0===r?void 0:r.key)===a.AUTHENTICATOR_KEY.IDP){var o=Object.prototype.hasOwnProperty.call(e,"currentAuthenticatorEnrollment");t.name=o?"challenge-authenticator":"enroll-authenticator"}t.name===a.FORMS.REDIRECT_IDP&&t.type===a.IDP_FORM_TYPE.X509&&(t.name=a.FORMS.PIV_IDP)}))},h=function(e){var t=e.idx.context;return t.failure&&"failure-redirect"===t.failure.name},m=function(e,t){var n=t.idx.context,r=e.get("oauth2Enabled"),o="always"===e.get("redirect");if(!r||o){var i={name:a.FORMS.FAILURE_REDIRECT,href:n.failure.href,value:[]};t.remediations=[i]}},v=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;if(!s(t.rawIdxState))return null;var r=u(t.rawIdxState),o=c(t),i=Object.assign({},r,o,{idx:t});return l(i)&&h(i)&&m(e,i),d(e,i),p(i),l(i)||f(e,i,n),i};t.default=v,e.exports=t.default},58937:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n){return o._.compose(s.default,a.default.bind({},e),i.default.bind({},e))(t,n)};var o=n(6475),i=r(n(31639)),a=r(n(67285)),s=r(n(43318));e.exports=t.default},65298:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(13955),o=n(6475),i=function(e,t){var n,i,a,s,l,u,c,d,f,p,h;if([r.FORMS.CONSENT_ENDUSER,r.FORMS.CONSENT_ADMIN].includes(t.name)){var m=t.scopes.map((function(e){return{name:e.name,displayName:e.label,description:e.desc}}));return{type:t.name,scopes:m,options:e.options}}return Array.isArray(e.options)&&"radio"===(null===(n=e.options[0])||void 0===n||null===(i=n.value)||void 0===i||null===(a=i.value)||void 0===a?void 0:a.inputType)?(p=(f=e).label,h=f.required,{displayName:p,type:"radio",required:h,options:f.options[0].value.value.options,sublabel:h?null:(0,o.loc)("oie.form.field.optional","login")}):Array.isArray(e.options)&&"checkbox"===(null===(s=e.options[0])||void 0===s||null===(l=s.value)||void 0===l||null===(u=l.value)||void 0===u?void 0:u.inputType)?{placeholder:(d=e).label,label:!1,modelType:d.type,type:"checkbox",required:!0,value:!1}:{placeholder:(c=e).label,label:!1,modelType:c.type,type:"checkbox",required:c.required||!1}};t.default=i,e.exports=t.default},3877:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.createOVOptions=l,t.default=function(e,t,n,r,o){var i={};"authenticator"!==e.name||"select-authenticator-authenticate"!==t.name&&"select-authenticator-unlock-account"!==t.name?"authenticator"===e.name&&"select-authenticator-enroll"===t.name?Object.assign(i,{type:"authenticatorEnrollSelect",options:u(e.options)}):Array.isArray(e.options)&&(i.optionsUiSchemas=e.options.map((function(t){return r(n,{value:[{name:e.name,value:t.value}]},o)})),i.options=e.options.map((function(e,t){return{label:e.label,value:t}})),i.type="radio",i.value="0",i.name="sub_schema_local_".concat(e.name)):Object.assign(i,{type:"authenticatorVerifySelect",options:u(e.options)});return i};var o=r(n(15985)),i=r(n(31752)),a=n(6475),s=n(13955);function l(){var e,t,n,r,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],l=o.find((function(e){return e.relatesTo.key===s.AUTHENTICATOR_KEY.OV})),u=null==l||null===(e=l.value)||void 0===e||null===(t=e.form)||void 0===t||null===(n=t.value)||void 0===n?void 0:n.find((function(e){return"methodType"===e.name})),c=null==u?void 0:u.options;if(c){var d=[];c.forEach((function(e){var t=(0,i.default)(l.value.form.value),n=l.value.form.value.findIndex((function(e){return"methodType"===e.name})),o=Object.assign(a._.omit(u,"options"),e);o.required=!0,o.mutable=!1,t.splice(n,1,o);var s=Object.assign({},l,{label:e.label,value:{form:{value:t}}});"signed_nonce"===e.value?r=s:d.push(s)}));var f=o.findIndex((function(e){return e.relatesTo.key===s.AUTHENTICATOR_KEY.OV}));o.splice.apply(o,[f,1].concat(d)),r&&(l.relatesTo.deviceKnown?o.unshift(r):o.push(r))}}function u(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return l(e),e.map((function(e){var t,n,r,i=((null===(t=e.value)||void 0===t||null===(n=t.form)||void 0===n?void 0:n.value)||[]).filter((function(e){return!0===e.required&&!1===e.mutable})).reduce((function(e,t){return Object.assign(e,(0,o.default)({},t.name,t.value))}),{});return{label:e.label,value:i,relatesTo:e.relatesTo,authenticatorKey:null===(r=e.relatesTo)||void 0===r?void 0:r.key}}))}},71067:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(13955),a=r(n(73390)),s=r(n(77653)),l=function(e){var t={};return e.forEach((function(e){var n=e.value,r=e.label;t[n]=r})),t},u={type:"select",wide:!0},c=["text","radio","select"],d=function(e,t,n,r,d){var f,p={type:"text"};if(!0===e.secret&&Object.assign(p,function(e){return{type:"password",params:{showPasswordToggle:e.get("showPasswordToggle")}}}(d)),e.hint===i.HINTS.CAPTCHA&&Object.assign(p,{type:"captcha"}),"userProfile.timezone"===e.name&&(Object.assign(p,u),p.options=Object.assign({"":""},s.default)),Array.isArray(e.options)&&e.options[0]&&e.options[0].value){var h=e.options[0];"display"===h.label?function(e,t){var n,r=null==t||null===(n=t.value)||void 0===n?void 0:n.value;e.type=r.inputType,"radio"===r.inputType?e.options=r.options:"select"===r.inputType&&(e.wide=!0,r.format===i.ATTR_FORMAT.COUNTRY_CODE?e.options=Object.assign({"":""},a.default.getCountryCode()):e.options=Object.assign({"":""},l(r.options)))}(p,h):(f=e.name).indexOf("methodType")>=0||f.indexOf("channel")>=0?function(e,t){e.type="radio",t.value=t.options[0].value}(p,e):(p.type="select",p.wide=!0,p.options=l(e.options))}return!1===e.required&&c.includes(p.type)&&(p.sublabel=(0,o.loc)("oie.form.field.optional","login")),p};t.default=d,e.exports=t.default},67285:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(65298)),a=r(n(3877)),s={string:r(n(71067)).default,boolean:i.default,object:a.default},l=function e(t,n,r){return o._.chain(n.value||[]).filter((function(e){return!1!==e.visible})).map((function(e){var t,n;if(e.form?n=e.form:null!==(t=e.value)&&void 0!==t&&t.form&&(n=e.value.form),n){var r=e.name;return n.value.map((function(e){return Object.assign({},e,{name:r+"."+e.name})}))}return e})).flatten().value().map((function(o){var i={"label-top":!0,multirowError:!0,"data-se":"o-form-fieldset-".concat(o.name)},a=o.type||"string",l=(0,s[a])(o,n,t,e,r);return Object.assign({},o,i,l)}))},u=function(e,t){return t&&(t.remediations=t.remediations.map((function(n){return n.uiSchema=l(t,n,e),n}))),t};t.default=u,e.exports=t.default},75888:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(2875)),a=n(6475),s=n(13955),l=r(n(30471)),u=n(86725);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var f=a.View.extend({className:"authenticator-row clearfix",template:i.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="factor-icon authenticator-icon '+l("function"==typeof(i=null!=(i=u(n,"iconClassName")||(null!=t?u(t,"iconClassName"):t))?i:s)?i.call(a,{name:"iconClassName",hash:{},data:o,loc:{start:{line:1,column:100},end:{line:1,column:117}}}):i)+' custom-app-logo" role="img" aria-label="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.auth.logo.aria.label"},data:o,loc:{start:{line:1,column:158},end:{line:1,column:213}}}))+'"></div>'},3:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="factor-icon authenticator-icon '+l("function"==typeof(i=null!=(i=u(n,"iconClassName")||(null!=t?u(t,"iconClassName"):t))?i:s)?i.call(a,{name:"iconClassName",hash:{},data:o,loc:{start:{line:1,column:272},end:{line:1,column:289}}}):i)+'" role="img" aria-label="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.auth.logo.aria.label"},data:o,loc:{start:{line:1,column:314},end:{line:1,column:369}}}))+'"></div>'},5:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="authenticator-grace-period-required-icon"></span><div class="authenticator-grace-period-text-container"><p class="authenticator-grace-period-required-description">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"gracePeriodRequiredDescription")||(null!=t?l(t,"gracePeriodRequiredDescription"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"gracePeriodRequiredDescription",hash:{},data:o,loc:{start:{line:1,column:702},end:{line:1,column:736}}}):a)+"</p>"+(null!=(i=l(n,"if").call(s,null!=t?l(t,"gracePeriodExpiry"):t,{name:"if",hash:{},fn:e.program(6,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:740},end:{line:1,column:847}}}))?i:"")+"</div>"},6:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-grace-period-expiry-date">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"gracePeriodExpiry")||(null!=t?a(t,"gracePeriodExpiry"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"gracePeriodExpiry",hash:{},data:o,loc:{start:{line:1,column:815},end:{line:1,column:836}}}):i)+"</p>"},8:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"gracePeriodRemainingSkipsDescription"):t,{name:"if",hash:{},fn:e.program(9,o,0),inverse:e.program(11,o,0),data:o,loc:{start:{line:1,column:853},end:{line:1,column:1335}}}))?i:""},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="authenticator-grace-period-required-icon"></span><div class="authenticator-grace-period-text-container"><p class="authenticator-grace-period-skip-count-description">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"gracePeriodRemainingSkipsDescription")||(null!=t?a(t,"gracePeriodRemainingSkipsDescription"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"gracePeriodRemainingSkipsDescription",hash:{},data:o,loc:{start:{line:1,column:1079},end:{line:1,column:1119}}}):i)+"</p></div></span>"},11:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"description"):t,{name:"if",hash:{},fn:e.program(12,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1144},end:{line:1,column:1232}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"authenticatorUsageText"):t,{name:"if",hash:{},fn:e.program(14,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1232},end:{line:1,column:1335}}}))?i:"")},12:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-description--text">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"description")||(null!=t?a(t,"description"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"description",hash:{},data:o,loc:{start:{line:1,column:1206},end:{line:1,column:1221}}}):i)+"</p>"},14:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-usage-text">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"authenticatorUsageText")||(null!=t?a(t,"authenticatorUsageText"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"authenticatorUsageText",hash:{},data:o,loc:{start:{line:1,column:1298},end:{line:1,column:1324}}}):i)+"</p>"},16:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'data-se="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"buttonDataSeAttr")||(null!=t?a(t,"buttonDataSeAttr"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"buttonDataSeAttr",hash:{},data:o,loc:{start:{line:1,column:1409},end:{line:1,column:1429}}}):i)+'"'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="authenticator-icon-container">'+(null!=(i=l(n,"if").call(s,null!=t?l(t,"logoUri"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:42},end:{line:1,column:384}}}))?i:"")+'</div><div class="authenticator-description"><h3 class="authenticator-label no-translate">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"label")||(null!=t?l(t,"label"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"label",hash:{},data:o,loc:{start:{line:1,column:474},end:{line:1,column:483}}}):a)+"</h3>"+(null!=(i=l(n,"if").call(s,null!=t?l(t,"gracePeriodRequiredDescription"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.program(8,o,0),data:o,loc:{start:{line:1,column:488},end:{line:1,column:1342}}}))?i:"")+'<div class="authenticator-button" '+(null!=(i=l(n,"if").call(s,null!=t?l(t,"buttonDataSeAttr"):t,{name:"if",hash:{},fn:e.program(16,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1376},end:{line:1,column:1437}}}))?i:"")+"></div></div>"},useData:!0}),postRender:function(){a.View.prototype.postRender.apply(this,arguments),this.model.get("logoUri")&&(this.el.querySelector(".custom-app-logo").style.backgroundImage="url(".concat(this.model.get("logoUri"),")"))},children:function(){return[[(0,a.createButton)({className:"button select-factor",title:function(){return(0,a.loc)("oie.enroll.authenticator.button.text","login")},attributes:{"aria-label":this.model.get("ariaLabel")},click:function(){this.model.trigger("selectAuthenticator",this.model.get("value"))}}),".authenticator-button"]]},minimize:function(){this.$el.addClass("authenticator-row-min")},getTemplateData:function(){var e,t=this.model.get("relatesTo").allowedFor;if(t)switch(t){case u.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.ANY:e=(0,a.loc)("oie.enroll.authenticator.usage.text.access.recovery","login");break;case u.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.RECOVERY:e=(0,a.loc)("oie.enroll.authenticator.usage.text.recovery","login");break;case u.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.SSO:e=(0,a.loc)("oie.enroll.authenticator.usage.text.access","login")}var n=a.View.prototype.getTemplateData.apply(this,arguments);n.authenticatorUsageText=e;var r=this._getGracePeriodData();return d(d({},n),r)},_getGracePeriodData:function(){var e,t,n,r,o,i,s={},u=Date.now(),c=new Date(null===(e=this.model.get("relatesTo"))||void 0===e||null===(t=e.gracePeriod)||void 0===t?void 0:t.expiry).getTime();if(!isNaN(c)&&u<c){var d=l.default.calculateDaysBetween(u,c);s.gracePeriodRequiredDescription=1===d?(0,a.loc)("oie.enrollment.policy.grace.period.required.in.one.day","login"):d>1?(0,a.loc)("oie.enrollment.policy.grace.period.required.in.days","login",[d]):(0,a.loc)("oie.enrollment.policy.grace.period.required.today","login"),c&&(s.gracePeriodExpiry=l.default.formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(new Date(c),this.settings.get("languageTags"),!1))}else if(null!==(n=this.model.get("relatesTo"))&&void 0!==n&&null!==(r=n.gracePeriod)&&void 0!==r&&r.remainingSkips&&(null===(o=this.model.get("relatesTo"))||void 0===o||null===(i=o.gracePeriod)||void 0===i?void 0:i.remainingSkips)>0){var f,p,h,m;if(1===(null===(f=this.model.get("relatesTo"))||void 0===f||null===(p=f.gracePeriod)||void 0===p?void 0:p.remainingSkips))s.gracePeriodRemainingSkipsDescription=(0,a.loc)("oie.enrollment.policy.grace.period.required.in.one.skip","login");else s.gracePeriodRemainingSkipsDescription=(0,a.loc)("oie.enrollment.policy.grace.period.required.in.number.of.skips","login",[null===(h=this.model.get("relatesTo"))||void 0===h||null===(m=h.gracePeriod)||void 0===m?void 0:m.remainingSkips])}return s}}),p=a.ListView.extend({className:"authenticator-enroll-list authenticator-list",item:f,itemSelector:".list-content",initialize:function(){this.listenTo(this.collection,"selectAuthenticator",(function(e){this.model.set(this.options.name,e),this.options.appState.trigger("saveForm",this.model)})),this.hasOptionalFactors=this.options.appState.hasRemediationObject(s.FORMS.SKIP)},template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-list-subtitle">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"subtitle")||(null!=t?a(t,"subtitle"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"subtitle",hash:{},data:o,loc:{start:{line:1,column:134},end:{line:1,column:146}}}):i)+"</p>"},3:function(e,t,n,r,o){var i,a=e.lambda,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="authenticator-list-subtitle-link-container"><a href='+s(a(null!=(i=null!=t?l(t,"subtitleLinkOptions"):t)?l(i,"href"):i,t))+' target="_blank" rel="noopener noreferrer">'+s(a(null!=(i=null!=t?l(t,"subtitleLinkOptions"):t)?l(i,"label"):i,t))+"</a></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="list-content"><div class="authenticator-list-title">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"title")||(null!=t?l(t,"title"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"title",hash:{},data:o,loc:{start:{line:1,column:64},end:{line:1,column:73}}}):a)+"</div>"+(null!=(i=l(n,"if").call(s,null!=t?l(t,"subtitle"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:79},end:{line:1,column:157}}}))?i:"")+(null!=(i=l(n,"if").call(s,null!=t?l(t,"subtitleLinkOptions"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:157},end:{line:1,column:365}}}))?i:"")+"</div>"},useData:!0}),getTemplateData:function(){var e=this.hasOptionalFactors?(0,a.loc)("oie.setup.optional","login"):(0,a.loc)("oie.setup.required","login");return{title:this.options.listTitle||e,subtitle:this.options.listSubtitle||null,subtitleLinkOptions:this.options.listSubtitleLinkOptions||null}}});t.default=p,e.exports=t.default},82625:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=n(6475),a=n(13955),s=r(n(75888)),l=r(n(21876)),u=r(n(45112)),c=n(71101);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=i.View.extend({className:"authenticator-enroll-list-container",initialize:function(){var e,t=[],n=[];this.options.optionItems.forEach((function(e){var r,o,i,a,s,l,u,c,d,f,p,h=(null===(r=e.relatesTo)||void 0===r||null===(o=r.gracePeriod)||void 0===o?void 0:o.expiry)&&(d=null===(i=e.relatesTo)||void 0===i||null===(a=i.gracePeriod)||void 0===a?void 0:a.expiry,f=Date.now(),p=new Date(d).getTime(),!isNaN(p)&&f<p),m=(null===(s=e.relatesTo)||void 0===s||null===(l=s.gracePeriod)||void 0===l?void 0:l.remainingSkips)&&(null===(u=e.relatesTo)||void 0===u||null===(c=u.gracePeriod)||void 0===c?void 0:c.remainingSkips)>0;h||m?t.push(e):n.push(e)})),this.hasSkipRemediation=!!this.options.appState.hasRemediationObject(null===a.FORMS||void 0===a.FORMS?void 0:a.FORMS.SKIP),this.hasOnlyOptional=this.hasSkipRemediation&&0===(null==t?void 0:t.length),this.hasOnlyGracePeriod=this.hasSkipRemediation&&(null===(e=this.options.optionItems)||void 0===e?void 0:e.length)===(null==t?void 0:t.length),n.length&&this.add(new s.default(f(f({},this.options),{},{collection:new i.Collection(n),optionItems:n,listTitle:this.hasOnlyOptional?(0,i.loc)("oie.setup.optional.short","login"):(0,i.loc)("oie.setup.required.now","login")}))),t.length&&this.add(new s.default(f(f({},this.options),{},{collection:new i.Collection(t),optionItems:t,listTitle:(0,i.loc)("oie.setup.required.soon","login"),listSubtitle:(0,i.loc)("oie.setup.required.soon.description","login"),listSubtitleLinkOptions:(0,c.getGracePeriodRequiredSoonCustomLink)(this.options.settings)}))),this.hasOnlyGracePeriod?this.add(l.default):this.hasOnlyOptional&&this.add(u.default)}});t.default=p,e.exports=t.default},93831:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(71101),i=r.BaseFooter.extend({links:function(){return(0,o.getFactorPageCustomLink)(this.options.appState,this.options.settings).concat((0,o.getSwitchAuthenticatorLink)(this.options.appState))}});t.default=i,e.exports=t.default},40647:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=a.View.extend({className:"authenticator-row clearfix",template:i.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="factor-icon authenticator-icon '+l("function"==typeof(i=null!=(i=u(n,"iconClassName")||(null!=t?u(t,"iconClassName"):t))?i:s)?i.call(a,{name:"iconClassName",hash:{},data:o,loc:{start:{line:1,column:100},end:{line:1,column:117}}}):i)+' custom-logo" role="img" aria-label="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.auth.logo.aria.label"},data:o,loc:{start:{line:1,column:154},end:{line:1,column:209}}}))+'"></div>'},3:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="factor-icon authenticator-icon '+l("function"==typeof(i=null!=(i=u(n,"iconClassName")||(null!=t?u(t,"iconClassName"):t))?i:s)?i.call(a,{name:"iconClassName",hash:{},data:o,loc:{start:{line:1,column:268},end:{line:1,column:285}}}):i)+'" role="img" aria-label="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.auth.logo.aria.label"},data:o,loc:{start:{line:1,column:310},end:{line:1,column:365}}}))+'"></div>'},5:function(e,t,n,r,o){return"authenticator-label--small"},7:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-description--text '+c((a=null!=(a=d(n,"noTranslateClassName")||(null!=t?d(t,"noTranslateClassName"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"noTranslateClassName",hash:{},data:i,loc:{start:{line:1,column:603},end:{line:1,column:627}}}):a))+'">'+c((a=null!=(a=d(n,"description")||(null!=t?d(t,"description"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"description",hash:{},data:i,loc:{start:{line:1,column:629},end:{line:1,column:644}}}):a))+"</p>"},9:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="authenticator-enrollment-nickname '+c((a=null!=(a=d(n,"noTranslateClassName")||(null!=t?d(t,"noTranslateClassName"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"noTranslateClassName",hash:{},data:i,loc:{start:{line:1,column:715},end:{line:1,column:739}}}):a))+'">'+c((a=null!=(a=d(n,"nickname")||(null!=t?d(t,"nickname"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"nickname",hash:{},data:i,loc:{start:{line:1,column:741},end:{line:1,column:753}}}):a))+"</p>"},11:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'data-se="'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"buttonDataSeAttr")||(null!=t?a(t,"buttonDataSeAttr"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"buttonDataSeAttr",hash:{},data:o,loc:{start:{line:1,column:837},end:{line:1,column:857}}}):i)+'"'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="authenticator-icon-container">'+(null!=(i=l(n,"if").call(s,null!=t?l(t,"logoUri"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:42},end:{line:1,column:380}}}))?i:"")+'</div><div class="authenticator-description"><div><h3 class="authenticator-label no-translate '+(null!=(i=l(n,"if").call(s,null!=t?l(t,"description"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:474},end:{line:1,column:526}}}))?i:"")+'">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"label")||(null!=t?l(t,"label"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"label",hash:{},data:o,loc:{start:{line:1,column:528},end:{line:1,column:537}}}):a)+"</h3>"+(null!=(i=l(n,"if").call(s,null!=t?l(t,"description"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:542},end:{line:1,column:655}}}))?i:"")+(null!=(i=l(n,"if").call(s,null!=t?l(t,"nickname"):t,{name:"if",hash:{},fn:e.program(9,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:655},end:{line:1,column:764}}}))?i:"")+'</div><div class="authenticator-button" '+(null!=(i=l(n,"if").call(s,null!=t?l(t,"buttonDataSeAttr"):t,{name:"if",hash:{},fn:e.program(11,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:804},end:{line:1,column:865}}}))?i:"")+"></div></div>"},useData:!0}),postRender:function(){a.View.prototype.postRender.apply(this,arguments);var e=this.model.get("logoUri");e&&(this.el.querySelector(".custom-logo").style.backgroundImage="url(".concat(e,")"))},children:function(){return[[(0,a.createButton)({className:"button select-factor",title:function(){return(0,a.loc)("oie.verify.authenticator.button.text","login")},attributes:{"aria-label":this.model.get("ariaLabel")},click:function(){this.model.trigger("selectAuthenticator",this.model.get("value"))}}),".authenticator-button"]]},minimize:function(){this.$el.addClass("authenticator-row-min")}}),l=a.ListView.extend({className:"authenticator-verify-list authenticator-list",item:s,itemSelector:".list-content",initialize:function(){this.listenTo(this.collection,"selectAuthenticator",this.handleSelect),this.listenTo(this.model,"invalid",this.handleModelInvalid)},handleModelInvalid:function(e,t){this.options.name in t&&!this.model.get(this.options.name)&&this.showAuthenticatorRequiredError()},showAuthenticatorRequiredError:function(){var e=this.collection.length>1?(0,a.loc)("account.unlock.authenticatorRequired.multiple","login"):(0,a.loc)("account.unlock.authenticatorRequired.single","login");this.model.trigger("error",this.model,{responseJSON:{errorSummary:e}})},handleSelect:function(e){var t,n=this.model.validateField("identifier");this.model.trigger("clearFormError"),null!==(t=this.model.getPropertySchema("identifier"))&&void 0!==t&&t.required&&n?this.model.trigger("invalid",this.model,n):(this.model.set(this.options.name,e),this.options.appState.trigger("saveForm",this.model))},template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="list-content"></div>'},useData:!0})});t.default=l,e.exports=t.default},83966:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.BaseAuthenticatorBeacon=void 0;var o=n(6475),i=n(17587),a=r(n(93831)),s=r(n(99422)),l=n(25795),u=n(13955),c=s.default.extend({authenticatorKey:function(){return this.options.appState.get("authenticatorKey")},idvName:function(){var e,t,n=null===(e=this.options.appState.get("remediations"))||void 0===e?void 0:e.find((function(e){return e.name===u.FORMS.REDIRECT_IDVERIFY}));return null==n||null===(t=n.idp)||void 0===t?void 0:t.id},displayName:function(){var e,t;return(null===(e=this.options.appState.get("currentAuthenticator"))||void 0===e?void 0:e.displayName)||(null===(t=this.options.appState.get("currentAuthenticatorEnrollment"))||void 0===t?void 0:t.displayName)},getBeaconClassName:function(){var e=o._.result(this,"authenticatorKey"),t=o._.result(this,"idvName"),n=o._.result(this,"displayName");return(0,l.getIconClassNameForBeacon)(e,t,n)}});t.BaseAuthenticatorBeacon=c;var d=i.BaseView.extend({Header:i.BaseHeader.extend({HeaderBeacon:c}),Footer:a.default});t.default=d},9867:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(93831)),s=n(13056),l="Okta_Authenticator",u=i.View.extend({id:"help-description-container",className:"help-description js-help-description",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<h3>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.biometric.authenticator.title"},data:o,loc:{start:{line:1,column:4},end:{line:1,column:96}}}))+"</h3><br><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.biometric.authenticator.description1"},data:o,loc:{start:{line:1,column:108},end:{line:1,column:207}}}))+"</p><br><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.biometric.authenticator.description2"},data:o,loc:{start:{line:1,column:218},end:{line:1,column:317}}}))+"</p><br><h3>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.security.key.title"},data:o,loc:{start:{line:1,column:329},end:{line:1,column:410}}}))+"</h3><br><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.security.key.description"},data:o,loc:{start:{line:1,column:422},end:{line:1,column:509}}}))+"</p><br>"},useData:!0})}),c=i.View.extend({id:"help-description-container",className:"help-description js-help-description",template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:null!=t?i(t,"enrollmentStep1"):t},data:o,loc:{start:{line:1,column:58},end:{line:1,column:102}}}))+"</li><br>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.enrollment.step1"},data:o,loc:{start:{line:1,column:123},end:{line:1,column:202}}}))+"</li><br>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ol class="ov-enrollment-info">'+(null!=(i=u(n,"if").call(a,null!=t?u(t,"enrollmentStep1"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:31},end:{line:1,column:218}}}))?i:"")+"<li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.enrollment.step2"},data:o,loc:{start:{line:1,column:222},end:{line:1,column:301}}}))+"</li><br><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.enrollment.step3"},data:o,loc:{start:{line:1,column:314},end:{line:1,column:393}}}))+"</li><br><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.cant.verify.enrollment.step4"},data:o,loc:{start:{line:1,column:406},end:{line:1,column:485}}}))+"</><br></ol>"},useData:!0}),getTemplateData:function(){var e,t;return{enrollmentStep1:(0,s.getWebAuthnI18nKey)({DEFAULT:"oie.verify.webauthn.cant.verify.enrollment.step1",PASSKEYS:"oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1",CUSTOM:"oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1"},null===(e=this.options.currentViewState.relatesTo)||void 0===e||null===(t=e.value)||void 0===t?void 0:t.displayName)}}}),d=a.default.extend({links:function(){var e=a.default.prototype.links.apply(this,arguments),t=this.options.appState.get("app")&&this.options.appState.get("app").name===l?c:u;return e.unshift({label:(0,i.loc)("oie.verify.webauthn.cant.verify","login"),name:"cant-verify","aria-controls":"help-description-container",class:"link help js-help",type:"toggle-text-link",additionalOptions:{view:t,selector:".js-help-description"}}),e}});t.default=d,e.exports=t.default},89597:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(13955),i=n(83966),a=r.BaseHeader.extend({HeaderBeacon:i.BaseAuthenticatorBeacon.extend({authenticatorKey:o.AUTHENTICATOR_KEY.EMAIL})});t.default=a,e.exports=t.default},99422:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(78747),s=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="bg-helper auth-beacon auth-beacon-factor '+l("function"==typeof(i=null!=(i=u(n,"className")||(null!=t?u(t,"className"):t))?i:s)?i.call(a,{name:"className",hash:{},data:o,loc:{start:{line:1,column:245},end:{line:1,column:258}}}):i)+' custom-app-logo" data-se="factor-beacon" role="img" aria-label="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.auth.logo.aria.label"},data:o,loc:{start:{line:1,column:323},end:{line:1,column:378}}}))+'">'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="bg-helper auth-beacon auth-beacon-factor '+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"className")||(null!=t?a(t,"className"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"className",hash:{},data:o,loc:{start:{line:1,column:441},end:{line:1,column:454}}}):i)+'" data-se="factor-beacon">'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div data-type="beacon-container" class="beacon-container"><div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div>'+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"logoUri"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:177},end:{line:1,column:487}}}))?i:"")+'<div class="okta-sign-in-beacon-border auth-beacon-border"></div></div></div >'},useData:!0}),postRender:function(){i.View.prototype.postRender.apply(this,arguments);var e=this.getTemplateData();e.logoUri&&(this.el.querySelector(".custom-app-logo").style.backgroundImage="url(".concat(e.logoUri,")"))},getTemplateData:function(){var e,t,n,r=null===(e=this.options)||void 0===e?void 0:e.appState,o=null==r?void 0:r.get("remediations"),i=(null==r||null===(t=r.get("currentAuthenticator"))||void 0===t?void 0:t.logoUri)||(null==r||null===(n=r.get("currentAuthenticatorEnrollment"))||void 0===n?void 0:n.logoUri);if(!i&&o){var s=(0,a.getMetaInfoLinksForCustomIDV)(o);i=null==s?void 0:s.logoLink}return{className:this.getBeaconClassName()||"",logoUri:i}},getBeaconClassName:function(){return"undefined-user"}});t.default=s,e.exports=t.default},7667:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=n(13955),l=n(71101),u=r(n(87547)),c=a.BaseFooter.extend({showForgotPasswordLink:function(){return!this.options.appState.isIdentifierOnlyView()},footerInfo:function(){var e,t=(0,l.getSignUpLink)(this.options.appState,this.options.settings);return t.length&&(e=i.View.extend({className:"signup-info",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<span>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"registration.signup.label"},data:o,loc:{start:{line:1,column:6},end:{line:1,column:62}}}))+'</span><span class="signup-link"></span>'},useData:!0}),initialize:function(){this.add(u.default,".signup-link",{options:t[0]})}})),e},links:function(){var e,t=this.options,n=t.appState,r=t.settings;r.get("helpLinks.help")?e=r.get("helpLinks.help"):e=r.get("baseUrl")+"/help/login";var o=[{name:"help",label:(0,i.loc)("help","login"),href:e,target:"_blank"}],a=[];this.showForgotPasswordLink()&&(a=(0,l.getForgotPasswordLink)(n,r));var u=[];r.get("helpLinks.custom")&&r.get("helpLinks.custom").forEach((function(e){e.name="custom",e.label=e.text,u.push(e)}));var c=[];return r.get("helpLinks.unlock")?c.push({type:"link",label:(0,i.loc)("unlockaccount","login"),name:"unlock",href:r.get("helpLinks.unlock")}):n.hasRemediationObject(s.FORMS.UNLOCK_ACCOUNT)&&c.push({type:"link",label:(0,i.loc)("unlockaccount","login"),name:"unlock",actionPath:s.FORMS.UNLOCK_ACCOUNT}),a.concat(c).concat(o).concat(u)}});t.default=c,e.exports=t.default},87547:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"label")||(null!=t?a(t,"label"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"label",hash:{},data:o,loc:{start:{line:1,column:0},end:{line:1,column:9}}}):i)},useData:!0}),tagName:"a",attributes:function(){var e=this.options.href||"#",t="_blank"!==this.options.target||this.options.rel?this.options.rel:"noopener noreferrer";return{"data-se":this.options.name,href:e,target:this.options.target,rel:t}},className:function(){var e=["link"];if(this.options.name){var t=this.options.name.replace(/[ ]/g,"-");e.push("js-".concat(t))}return e.join(" ")},postRender:function(){var e=this;this.options.href||this.$el.click((function(t){t.preventDefault();var n=e.options,r=n.appState,o=n.formName,i=n.actionPath,a=n.clickHandler;a?a():o?r.trigger("switchForm",o):i&&r.trigger("invokeAction",i)}))}});t.default=i,e.exports=t.default},11098:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.internal.views.components.Notification,s=i.internal.util.Clipboard,l=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<div>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.explanation.mdm"},data:o,loc:{start:{line:1,column:5},end:{line:1,column:58}}}))+"</div><ol><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.step.copyLink"},data:o,loc:{start:{line:1,column:72},end:{line:1,column:127}}}))+'<a data-clipboard-text="'+l("function"==typeof(i=null!=(i=u(n,"enrollmentLink")||(null!=t?u(t,"enrollmentLink"):t))?i:s)?i.call(a,{name:"enrollmentLink",hash:{},data:o,loc:{start:{line:1,column:151},end:{line:1,column:169}}}):i)+'" class="button link-button copy-clipboard-button">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.copyLink"},data:o,loc:{start:{line:1,column:220},end:{line:1,column:270}}}))+"</a></li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.step.pasteLink"},data:o,loc:{start:{line:1,column:283},end:{line:1,column:339}}}))+"</li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",arguments:"vendor",bundle:"login",code:"enroll.mdm.step.followInstructions"},data:o,loc:{start:{line:1,column:348},end:{line:1,column:473}}}))+"</li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.step.relogin"},data:o,loc:{start:{line:1,column:482},end:{line:1,column:536}}}))+"</li></ol>"},useData:!0}),getTemplateData:function(){return this.options.appState.get("deviceEnrollment")},postRender:function(){var e=this;s.attach(".copy-clipboard-button").done((function(){var t=new a({message:(0,i.loc)("enroll.mdm.copyLink.success","login"),level:"success"});return e.el.prepend(t.render().el),!1}))}});t.default=l,e.exports=t.default},73204:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.getDeviceEnrollmentContext=t.IosAndAndroidLoopbackOdaTerminalView=t.AndroidAppLinkWithoutAccountOdaTerminalView=t.AndroidAppLinkWithAccountOdaTerminalView=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(35546)),l=a.internal.views.components.Notification,u=a.internal.util.Clipboard,c=function(e){var t=(e.platform||"").toLowerCase(),n=e.challengeMethod,r=e.name,o=t===s.default.IOS,i=t===s.default.ANDROID&&"APP_LINK"===n,a=t===s.default.ANDROID&&"LOOPBACK"===n;return{signInUrl:e.signInUrl,isIOS:o,enrollmentType:r,isAndroidLoopback:a,isAndroidAppLink:i,appStoreLink:o?s.default.OKTA_VERIFY_APPLE_APP_STORE_URL:s.default.OKTA_VERIFY_GOOGLE_PLAY_STORE_URL,orgName:e.orgName}};t.getDeviceEnrollmentContext=c;var d=a.View.extend({getTemplateData:function(){var e=this.options.appState.get("deviceEnrollment");return c(e)}}),f=d.extend({template:i.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.step.copyLink"},data:o,loc:{start:{line:1,column:120},end:{line:1,column:175}}}))+'<a data-clipboard-text="'+l("function"==typeof(i=null!=(i=u(n,"appStoreLink")||(null!=t?u(t,"appStoreLink"):t))?i:s)?i.call(a,{name:"appStoreLink",hash:{},data:o,loc:{start:{line:1,column:199},end:{line:1,column:215}}}):i)+'" class="button link-button copy-clipboard-button">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.copyLink"},data:o,loc:{start:{line:1,column:266},end:{line:1,column:316}}}))+"</a></li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.mdm.step.pasteLink"},data:o,loc:{start:{line:1,column:329},end:{line:1,column:385}}}))+"</li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step3"},data:o,loc:{start:{line:1,column:394},end:{line:1,column:441}}}))+"</li>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"enroll.oda.android.step1"},data:o,loc:{start:{line:1,column:482},end:{line:1,column:537}}}))+"</li>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c=e.escapeExpression,d="function",f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="explanation" data-se="subheader">'+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.explanation.p1"},data:i,loc:{start:{line:1,column:43},end:{line:1,column:95}}}))+"</p><ol>"+(null!=(a=f(n,"if").call(l,null!=t?f(t,"isIOS"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:103},end:{line:1,column:453}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"isAndroidLoopback"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:453},end:{line:1,column:549}}}))?a:"")+"<li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step1"},data:i,loc:{start:{line:1,column:553},end:{line:1,column:600}}}))+"</li><li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step2"},data:i,loc:{start:{line:1,column:609},end:{line:1,column:656}}}))+'<p class="org-signin-link"><span class="no-translate">'+c((s=null!=(s=f(n,"signInUrl")||(null!=t?f(t,"signInUrl"):t))?s:u,(0,o.default)(s)===d?s.call(l,{name:"signInUrl",hash:{},data:i,loc:{start:{line:1,column:710},end:{line:1,column:723}}}):s))+'</span></p><a data-clipboard-text="'+c((s=null!=(s=f(n,"signInUrl")||(null!=t?f(t,"signInUrl"):t))?s:u,(0,o.default)(s)===d?s.call(l,{name:"signInUrl",hash:{},data:i,loc:{start:{line:1,column:758},end:{line:1,column:771}}}):s))+'" class="button link-button copy-org-clipboard-button">'+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.org.copyLink"},data:i,loc:{start:{line:1,column:826},end:{line:1,column:880}}}))+"</a></li><li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step6"},data:i,loc:{start:{line:1,column:893},end:{line:1,column:940}}}))+"</li></ol>"},useData:!0}),postRender:function(){var e=this;u.attach(".copy-clipboard-button").done((function(){var t=new l({message:(0,a.loc)("enroll.mdm.copyLink.success","login"),level:"success"});return e.el.prepend(t.render().el),!1})),u.attach(".copy-org-clipboard-button").done((function(){var t=new l({message:(0,a.loc)("enroll.oda.org.copyLink.success","login"),level:"success"});return e.el.prepend(t.render().el),!1}))}});t.IosAndAndroidLoopbackOdaTerminalView=f;var p=d.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="explanation" data-se="subheader">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.explanation"},data:o,loc:{start:{line:1,column:43},end:{line:1,column:109}}}))+'</p><p class="subtitle">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.subtitile1 "},data:o,loc:{start:{line:1,column:133},end:{line:1,column:199}}}))+"</p><ul><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step1"},data:o,loc:{start:{line:1,column:211},end:{line:1,column:271}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step2"},data:o,loc:{start:{line:1,column:280},end:{line:1,column:340}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step3"},data:o,loc:{start:{line:1,column:349},end:{line:1,column:409}}}))+'</li></ul><p class="subtitle">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.subtitile2 "},data:o,loc:{start:{line:1,column:439},end:{line:1,column:505}}}))+"</p><ol><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step4"},data:o,loc:{start:{line:1,column:517},end:{line:1,column:577}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{arguments:"signInUrl",bundle:"login",code:"enroll.oda.with.account.step5"},data:o,loc:{start:{line:1,column:586},end:{line:1,column:668}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step6"},data:o,loc:{start:{line:1,column:677},end:{line:1,column:737}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.with.account.step7"},data:o,loc:{start:{line:1,column:746},end:{line:1,column:806}}}))+"</li></ol>"},useData:!0})});t.AndroidAppLinkWithAccountOdaTerminalView=p;var h=d.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c=e.escapeExpression,d="function",f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="explanation" data-se="subheader">'+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.without.account.explanation"},data:i,loc:{start:{line:1,column:43},end:{line:1,column:112}}}))+"</p><ol><li>"+(null!=(a=(f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{arguments:"appStoreLink",bundle:"login",code:"enroll.oda.without.account.step1"},data:i,loc:{start:{line:1,column:124},end:{line:1,column:214}}}))?a:"")+"</li><li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step1"},data:i,loc:{start:{line:1,column:223},end:{line:1,column:270}}}))+"</li><li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.step2"},data:i,loc:{start:{line:1,column:279},end:{line:1,column:326}}}))+'<p class="org-signin-link"><span class="no-translate">'+c((s=null!=(s=f(n,"signInUrl")||(null!=t?f(t,"signInUrl"):t))?s:u,(0,o.default)(s)===d?s.call(l,{name:"signInUrl",hash:{},data:i,loc:{start:{line:1,column:380},end:{line:1,column:393}}}):s))+'</span></p><a data-clipboard-text="'+c((s=null!=(s=f(n,"signInUrl")||(null!=t?f(t,"signInUrl"):t))?s:u,(0,o.default)(s)===d?s.call(l,{name:"signInUrl",hash:{},data:i,loc:{start:{line:1,column:428},end:{line:1,column:441}}}):s))+'" class="button link-button copy-org-clipboard-button">'+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.org.copyLink"},data:i,loc:{start:{line:1,column:496},end:{line:1,column:550}}}))+"</a></li><li>"+c((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.without.account.step4"},data:i,loc:{start:{line:1,column:563},end:{line:1,column:626}}}))+"</li></ol>"},useData:!0}),postRender:function(){var e=this;u.attach(".copy-org-clipboard-button").done((function(){var t=new l({message:(0,a.loc)("enroll.oda.org.copyLink.success","login"),level:"success"});return e.el.prepend(t.render().el),!1}))}});t.AndroidAppLinkWithoutAccountOdaTerminalView=h},76757:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(13955),i=n(83966),a=r.BaseHeader.extend({HeaderBeacon:i.BaseAuthenticatorBeacon.extend({authenticatorKey:o.AUTHENTICATOR_KEY.OV})});t.default=a,e.exports=t.default},21876:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(13955),i=(0,r.createButton)({className:"button-primary button skip-all",title:function(){return(0,r.loc)("oie.setup.remind.me.later","login")},click:function(){this.options.appState.trigger("invokeAction",o.FORMS.SKIP)}});t.default=i,e.exports=t.default},16002:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=n(43318),l=a.internal.views.forms.inputs.CheckBox.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<input type="checkbox" name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:29},end:{line:1,column:37}}}):a))+'" id="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:43},end:{line:1,column:54}}}):a))+'"/><label for="'+c((a=null!=(a=d(n,"inputId")||(null!=t?d(t,"inputId"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"inputId",hash:{},data:i,loc:{start:{line:1,column:69},end:{line:1,column:80}}}):a))+'" data-se-for-name="'+c((a=null!=(a=d(n,"name")||(null!=t?d(t,"name"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"name",hash:{},data:i,loc:{start:{line:1,column:100},end:{line:1,column:108}}}):a))+'"><b>'+c((a=null!=(a=d(n,"placeholder")||(null!=t?d(t,"placeholder"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"placeholder",hash:{},data:i,loc:{start:{line:1,column:113},end:{line:1,column:128}}}):a))+"</b><p>"+c((a=null!=(a=d(n,"desc")||(null!=t?d(t,"desc"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"desc",hash:{},data:i,loc:{start:{line:1,column:135},end:{line:1,column:143}}}):a))+"</p></label>"},useData:!0}),getLocalizedLabel:function(){var e="consent.scopes.".concat(this.options.options.scopeName,".label");return(0,s.doesI18NKeyExist)(e)?(0,a.loc)(e,"login"):this.options.placeholder||this.options.options.scopeName},getLocalizedDesc:function(){var e="consent.scopes.".concat(this.options.options.scopeName,".desc");return(0,s.doesI18NKeyExist)(e)?(0,a.loc)(e,"login"):this.options.options.desc},isCustomizedScope:function(){return!(0,s.doesI18NKeyExist)("consent.scopes.".concat(this.options.options.scopeName,".label"))},enable:function(){this.options.options.mutable&&this.$(":input").prop("disabled",!1)},editMode:function(){if(this.$el.html(this.template(a._.extend(a._.omit(this.options,"placeholder"),{placeholder:this.getLocalizedLabel(),desc:this.getLocalizedDesc()}))),this.$(":checkbox").prop("checked",this.getModelValue()||!1),this.$("input").customInput(),this.model.trigger("form:resize"),!this.options.options.mutable){var e=this.$("input").get(0);this.$(e.parentElement).addClass("o-form-read-mode"),this.$(":checkbox").prop("disabled",!0)}return("openid"===this.options.options.scopeName||this.isCustomizedScope())&&(this.$("label > b").addClass("no-translate"),this.isCustomizedScope()&&this.$("label > p").addClass("no-translate")),this}});t.default=l,e.exports=t.default},45112:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(13955),i=(0,r.createButton)({className:"button-primary button skip-all",title:function(){return(0,r.loc)("oie.optional.authenticator.button.title","login")},click:function(){this.options.appState.trigger("invokeAction",o.FORMS.SKIP)}});t.default=i,e.exports=t.default},16264:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(87547)),a=o.View.extend({initialize:function(){o.View.prototype.initialize.apply(this,arguments);var e=this.options.additionalOptions,t=this.options.name,n=Object.assign({},this.options,{type:"link","aria-expanded":!1,clickHandler:function(){(0,o.$)(e.selector).slideToggle(200,(function(){(0,o.$)(".js-".concat(t)).attr("aria-expanded",(0,o.$)(e.selector).is(":visible"))}))}});this.add(i.default,{options:n}),this.add(e.view)},postRender:function(){var e=this.options.additionalOptions;this.$(e.selector).hide()}});t.default=a,e.exports=t.default},8517:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(87547)),a=r(n(16264)),s=n(71101),l=o.View.extend({className:"auth-footer",links:[],footerInfo:null,hasBackToSignInLink:!0,initialize:function(){var e=this,t=o._.resultCtx(this,"links",this),n=o._.resultCtx(this,"footerInfo",this),r=o._.resultCtx(this,"hasBackToSignInLink",this);t=Array.isArray(t)?t.filter((function(e){return o.$.isPlainObject(e)})):[],this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get("features.hideSignOutLinkInMFA")||this.settings.get("features.mfaOnlyFlow"))&&r&&(t=t.concat((0,s.getSignOutLink)(this.options.settings))),t.forEach((function(t){var n=i.default;"toggle-text-link"===t.type&&(n=a.default),e.add(n,{options:t})})),n&&(this.add(o.View.extend({className:"footer-info"})),this.add(n,".footer-info"))}});t.default=l,e.exports=t.default},68013:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(52574)),i=r(n(71750)),a=i.default.extend(Object.assign({initialize:function(){i.default.prototype.initialize.apply(this,arguments),this.listenTo(this.options.appState,"change:dynamicRefreshInterval",this.updateRefreshInterval)},updateRefreshInterval:function(){this.polling&&(this.stopPolling(),this.startPolling(this.options.appState.get("dynamicRefreshInterval")))}},o.default));t.default=a,e.exports=t.default},27279:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(66757)),a=r(n(35546)),s=o.View.extend({HeaderBeacon:null,initialize:function(){this.HeaderBeacon&&this.add(this.HeaderBeacon)},postRender:function(){var e=(0,o.$)("#".concat(a.default.WIDGET_CONTAINER_ID));if(this.HeaderBeacon){e.removeClass("no-beacon");var t=this.$el.find('[data-type="beacon-container"]');i.default.explode(t)}else e.addClass("no-beacon")}});t.default=s,e.exports=t.default},55957:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=n(6475),a=function(e){var t=Object.assign({},i._.chain(e).pick("minLength","maxLength","required","value").defaults({type:"string",required:!0}).value());return e.modelType&&(t.type=e.modelType),(0,o.default)({},e.name,t)},s=function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},i=t.uiSchema||[];i.forEach((function(t){if(Array.isArray(t.optionsUiSchemas)){var i,s={};Number(t.value)>=0&&(i=t.value),n[t.name]&&(s={value:n[t.name]},i=Number(s.value)),Object.assign(o,a(Object.assign({},t,s))),i&&e({uiSchema:t.optionsUiSchemas[i]},n,r,o)}else Object.assign(r,a(t))}))},l={create:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={},r={formName:"string",useRedirect:"boolean"};s(e,t,n,r);var o=i.Model.extend({props:n,local:r});return o}};t.default=l,e.exports=t.default},59204:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(68013)),a=r(n(36894)),s=n(86725),l=r(n(34425)),u=n(66200),c=function(e){var t=Object.assign({method:"GET",contentType:"application/json"},e);return o.$.ajax(t)},d=i.default.extend({noButtonBar:!0,className:"ion-form device-challenge-poll",removed:!1,events:{"click #launch-ov":function(e){e.preventDefault(),this.doCustomURI()}},pollingCancelAction:s.AUTHENTICATOR_CANCEL_ACTION,initialize:function(){i.default.prototype.initialize.apply(this,arguments),this.removed=!1,this.listenTo(this.model,"error",this.onPollingFail),this.doChallenge(),this.startPolling()},doChallenge:function(){(0,u.doChallenge)(this)},onPollingFail:function(){this.$(".spinner").hide(),this.stopPolling()},remove:function(){i.default.prototype.remove.apply(this,arguments),this.removed=!0,this.stopProbing(),this.stopPolling()},getDeviceChallengePayload:function(){throw new Error("getDeviceChallengePayload needs to be implemented")},doLoopback:function(e){var t,n=this,r=void 0!==e.domain?e.domain:"",i=void 0!==e.httpsDomain?e.httpsDomain:"",d=void 0!==e.ports?e.ports:[],f=d.length,p=void 0!==e.challengeRequest?e.challengeRequest:"",h=void 0!==e.probeTimeoutMillis?e.probeTimeoutMillis:100,m=!1,v=!1,g=0,y=function(e,n){return"".concat(n,":").concat(t,"/").concat(e)},b=function(){return a.default.error("Something unexpected happened while we were checking port ".concat(t,".")),o.$.Deferred().reject()},w=function(t){return(r=y("probe",t),c({url:r,timeout:l.default.isAndroid()?3e3:h})).then((function(){return function(e){return c({url:e,method:"POST",data:JSON.stringify({challengeRequest:p}),timeout:s.CHALLENGE_TIMEOUT})}(y("challenge",t)).then((function(){return m=!0,!1!==e.enhancedPollingEnabled?(n.stopPolling(),void n.startPolling(1)):n.trigger("save",n.model)})).catch((function(e){g++,503!==e.status?(v=!0,(0,u.cancelPollingWithParams)(n.options.appState,n.pollingCancelAction,s.AUTHENTICATION_CANCEL_REASONS.OV_ERROR,e.status,!n.removed)):g===f&&(0,u.cancelPollingWithParams)(n.options.appState,n.pollingCancelAction,s.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE,null,!n.removed)}))})).catch(b);var r},_=Promise.resolve(),O=function(e,r,o){_=_.then((function(){if(!m&&!v)return t=e,w(r)})).catch((function(){g++,a.default.error("Authenticator is not listening on port ".concat(t,".")),o&&g===f&&(a.default.error("No available ports. Loopback server failed and polling is cancelled."),n.stopPolling(),(0,u.cancelPollingWithParams)(n.options.appState,n.pollingCancelAction,s.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE,null,!n.removed))}))};i&&(a.default.info("httpsDomain enabled, will probe and challenge https first"),f+=f,d.forEach((function(e){O(e,i,!1)}))),d.forEach((function(e){O(e,r,!0)}))},doCustomURI:function(){this.ulDom&&this.ulDom.remove();var e=(0,u.createInvisibleIFrame)("custom-uri-container",this.customURI);this.ulDom=this.add(e).last()},doChromeDTC:function(e){this.ulDom&&this.ulDom.remove();var t=(0,u.createInvisibleIFrame)("chrome-dtc-container",e.href);this.ulDom=this.add(t).last()},stopProbing:function(){this.checkPortXhr&&this.checkPortXhr.abort(),this.probingXhr&&this.probingXhr.abort()}}),f=d;t.default=f,e.exports=t.default},96167:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(27279)),s=r(n(71750)),l=r(n(55957)),u=r(n(8517)),c=n(2715),d=i.View.extend({Header:a.default,Body:s.default,Footer:u.default,className:function(){var e=this.options.appState,t=e.get("currentFormName"),n=e.get("authenticatorKey"),r=e.get("authenticatorMethodType"),o=e.get("isPasswordRecoveryFlow"),i=(0,c.getClassNameMapping)(t,n,r,o);return["siw-main-view"].concat(i).join(" ")},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="siw-main-header"></div><div class="siw-main-body"></div><div class="siw-main-footer"></div>'},useData:!0}),preRender:function(){i.View.prototype.preRender.apply(this,arguments),null!==this.Header&&this.add(this.Header,{selector:".siw-main-header",options:this.options}),this.renderForm(),this.add(this.Footer,{selector:".siw-main-footer",options:this.options})},renderForm:function(){var e,t=this;this.form&&(this.form.remove(),e=this.form.model.toJSON({verbose:!0}));var n=new(this.createModelClass(this.options.currentViewState,e,this.settings))({formName:this.options.currentViewState.name});e||(e=n.toJSON({verbose:!0})),this.model=n,this.form=this.add(this.Body,{selector:".siw-main-body",options:Object.assign({},this.options,{model:n,optionUiSchemaConfig:e})}).last(),i._.each(n.attributes,(function(e,r){r.match(/sub_schema_local_[^ ]+/)&&t.listenTo(n,"change:".concat(r),(function(){t.renderForm()}))}))},createModelClass:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return l.default.create(e,t)}});t.default=d,e.exports=t.default},17587:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"BaseFooter",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"BaseForm",{enumerable:!0,get:function(){return a.default}}),Object.defineProperty(t,"BaseFormWithPolling",{enumerable:!0,get:function(){return s.default}}),Object.defineProperty(t,"BaseHeader",{enumerable:!0,get:function(){return o.default}}),Object.defineProperty(t,"BaseModel",{enumerable:!0,get:function(){return u.default}}),Object.defineProperty(t,"BaseOktaVerifyChallengeView",{enumerable:!0,get:function(){return l.default}}),Object.defineProperty(t,"BaseView",{enumerable:!0,get:function(){return c.default}}),Object.defineProperty(t,"addCustomButton",{enumerable:!0,get:function(){return d.addCustomButton}}),Object.defineProperty(t,"createCustomButtons",{enumerable:!0,get:function(){return d.createCustomButtons}}),Object.defineProperty(t,"createIdpButtons",{enumerable:!0,get:function(){return d.createIdpButtons}});var o=r(n(27279)),i=r(n(8517)),a=r(n(71750)),s=r(n(68013)),l=r(n(59204)),u=r(n(55957)),c=r(n(96167)),d=n(88469)},25795:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.getAuthenticatorDataForEnroll=function(e){return d(e)},t.getAuthenticatorDataForVerification=function(e){return d(e,!0)},t.getAuthenticatorDisplayName=function(e){var t,n;return null===(t=e.relatesTo)||void 0===t||null===(n=t.value)||void 0===n?void 0:n.displayName},t.getIconClassNameForBeacon=function(e,t,n){if(e===s.AUTHENTICATOR_KEY.WEBAUTHN&&n===l.WEBAUTHN_DISPLAY_NAMES.PASSKEYS)return"mfa-passkeys";return d({authenticatorKey:e}).iconClassName||function(e){var t={};switch(e){case s.ID_PROOFING_TYPE.IDV_PERSONA:t={iconClassName:"mfa-idv-persona"};break;case s.ID_PROOFING_TYPE.IDV_CLEAR:t={iconClassName:"mfa-idv-clear"};break;case s.ID_PROOFING_TYPE.IDV_INCODE:t={iconClassName:"mfa-idv-incode"};break;case s.ID_PROOFING_TYPE.IDV_STANDARD:t={iconClassName:"mfa-idv-standard"};break;case s.ID_PROOFING_TYPE.IDV_OIN:t={iconClassName:"mfa-idv-oin"}}return t}(t).iconClassName},t.getOktaVerifyAriaLabel=h,t.getPasswordComplexityDescriptionForHtmlList=void 0,t.getVerifyEmailAriaLabel=f,t.getVerifyPhoneAriaLabel=p,t.getWebAuthnTitle=t.getWebAuthnAdditionalInstructions=void 0,t.removeRequirementsFromError=function(e){var t;if((null===(t=e.errorCauses)||void 0===t?void 0:t.length)>0&&Array.isArray(e.errorCauses[0].errorSummary)&&e.errorCauses[0].errorSummary.length>0){var n;e.errorCauses[0].errorSummary=e.errorCauses[0].errorSummary[0],"password.passwordRequirementsNotMet"===((null===(n=e.errorCauses[0].errorKey)||void 0===n?void 0:n.length)>0&&e.errorCauses[0].errorKey[0])&&(e.errorCauses[0].errorSummary=(0,i.loc)("registration.error.password.passwordRequirementsNotMet","login"))}return e};var o=r(n(45091)),i=n(71244),a=r(n(2645)),s=n(13955),l=n(13056),u=a.default.getPasswordComplexityDescriptionForHtmlList;t.getPasswordComplexityDescriptionForHtmlList=u;t.getWebAuthnTitle=function(e){var t,n,r=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=null==e||null===(t=e.relatesTo)||void 0===t||null===(n=t.value)||void 0===n?void 0:n.displayName,a=(0,l.getWebAuthnI18nParams)(o),s=r?l.WEBAUTHN_I18N_KEYS.VERIFY_TITLE:l.WEBAUTHN_I18N_KEYS.ENROLL_TITLE,u=(0,l.getWebAuthnI18nKey)(s,o);return(0,i.loc)(u,"login",a)};t.getWebAuthnAdditionalInstructions=function(e){var t,n;return(null==e||null===(t=e.relatesTo)||void 0===t||null===(n=t.value)||void 0===n?void 0:n.description)||null};var c=function(e){if(e.authenticatorKey){var t,n,r=null!==(t=e.value)&&void 0!==t&&t.methodType?"-"+(null===(n=e.value)||void 0===n?void 0:n.methodType):"";return e.authenticatorKey+r}return""},d=function(e,t){var n,r,a,u,d,m,v,g,y,b,w=e.authenticatorKey,_=o.default.isString(w)?w.toLowerCase():"",O={},k=t?null===(n=e.relatesTo)||void 0===n?void 0:n.nickname:void 0;switch(_){case s.AUTHENTICATOR_KEY.EMAIL:Object.assign(O,{description:t?(null===(r=e.relatesTo)||void 0===r||null===(a=r.profile)||void 0===a?void 0:a.email)||"":(0,i.loc)("oie.email.authenticator.description","login"),iconClassName:"mfa-okta-email",noTranslateClassName:t?"no-translate":"",buttonDataSeAttr:c(e),ariaLabel:t?f(null===(u=e.relatesTo)||void 0===u||null===(d=u.profile)||void 0===d?void 0:d.email):(0,i.loc)("oie.select.authenticator.enroll.email.label","login")});break;case s.AUTHENTICATOR_KEY.PASSWORD:Object.assign(O,{description:t?"":(0,i.loc)("oie.password.authenticator.description","login"),iconClassName:"mfa-okta-password",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.password.label","login"):(0,i.loc)("oie.select.authenticator.enroll.password.label","login")});break;case s.AUTHENTICATOR_KEY.PHONE:Object.assign(O,{nickname:k,description:t?null===(m=e.relatesTo)||void 0===m||null===(v=m.profile)||void 0===v?void 0:v.phoneNumber:(0,i.loc)("oie.phone.authenticator.description","login"),iconClassName:"mfa-okta-phone",noTranslateClassName:t?"no-translate":"",buttonDataSeAttr:c(e),ariaLabel:t?p(null===(g=e.relatesTo)||void 0===g||null===(y=g.profile)||void 0===y?void 0:y.phoneNumber):(0,i.loc)("oie.select.authenticator.enroll.phone.label","login")});break;case s.AUTHENTICATOR_KEY.SECURITY_QUESTION:Object.assign(O,{description:t?"":(0,i.loc)("oie.security.question.authenticator.description","login"),iconClassName:"mfa-okta-security-question",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.security.question.label","login"):(0,i.loc)("oie.select.authenticator.enroll.security.question.label","login")});break;case s.AUTHENTICATOR_KEY.WEBAUTHN:var x,E=null===(x=e.relatesTo)||void 0===x?void 0:x.displayName,T=(0,l.getWebAuthnI18nParams)(E),S=function(e,t,n){if(n)return"";if((0,l.isCustomDisplayName)(t)){var r,o=null===(r=e.relatesTo)||void 0===r?void 0:r.description;if(o)return o;var a=(0,l.getWebAuthnI18nKey)(l.WEBAUTHN_I18N_KEYS.DESCRIPTION,l.WEBAUTHN_DISPLAY_NAMES.DEFAULT);return(0,i.loc)(a,"login")}var s=(0,l.getWebAuthnI18nKey)(l.WEBAUTHN_I18N_KEYS.DESCRIPTION,t);return(0,i.loc)(s,"login",[])}(e,E,t),A=E===l.WEBAUTHN_DISPLAY_NAMES.PASSKEYS?"mfa-passkeys":"mfa-webauthn",P=t?(0,l.getWebAuthnI18nKey)(l.WEBAUTHN_I18N_KEYS.SELECT_VERIFY_LABEL,E):(0,l.getWebAuthnI18nKey)(l.WEBAUTHN_I18N_KEYS.SELECT_ENROLL_LABEL,E);Object.assign(O,{description:S,iconClassName:A,buttonDataSeAttr:c(e),ariaLabel:(0,i.loc)(P,"login",T)});break;case s.AUTHENTICATOR_KEY.OV:Object.assign(O,{description:t?(0,i.loc)("oie.okta_verify.label","login"):(0,i.loc)("oie.okta_verify.authenticator.description","login"),iconClassName:"mfa-okta-verify",buttonDataSeAttr:c(e),ariaLabel:h(t,null==e||null===(b=e.value)||void 0===b?void 0:b.methodType)});break;case s.AUTHENTICATOR_KEY.GOOGLE_OTP:Object.assign(O,{description:t?"":(0,i.loc)("oie.google_authenticator.authenticator.description","login"),iconClassName:"mfa-google-auth",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.ON_PREM:var C,R=(null===(C=e.relatesTo)||void 0===C?void 0:C.displayName)||(0,i.loc)("oie.on_prem.authenticator.default.vendorName","login");Object.assign(O,{description:t?"":(0,i.loc)("oie.on_prem.authenticator.description","login",[R]),iconClassName:"mfa-onprem",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.RSA:Object.assign(O,{description:t?"":(0,i.loc)("oie.rsa.authenticator.description","login"),iconClassName:"mfa-rsa",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.DUO:Object.assign(O,{description:t?"":(0,i.loc)("oie.duo.authenticator.description","login"),iconClassName:"mfa-duo",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.IDP:var I,N,M=null===(I=e.relatesTo)||void 0===I?void 0:I.displayName;Object.assign(O,{description:t?"":(0,i.loc)("oie.idp.authenticator.description","login",[M]),iconClassName:"mfa-custom-factor",buttonDataSeAttr:c(e),logoUri:(null==e||null===(N=e.relatesTo)||void 0===N?void 0:N.logoUri)||"",ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.CUSTOM_OTP:Object.assign(O,{description:t?"":(0,i.loc)("oie.custom_otp.description","login"),iconClassName:"mfa-hotp",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.SYMANTEC_VIP:var j,D=null===(j=e.relatesTo)||void 0===j?void 0:j.displayName;Object.assign(O,{description:t?"":(0,i.loc)("oie.symantecVip.authenticator.description","login",[D]),iconClassName:"mfa-symantec",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.YUBIKEY:Object.assign(O,{description:t?"":(0,i.loc)("oie.yubikey.authenticator.description","login"),iconClassName:"mfa-yubikey",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.CUSTOM_APP:var L,U,F;Object.assign(O,{description:t?null==e||null===(L=e.relatesTo)||void 0===L?void 0:L.displayName:(0,i.loc)("oie.custom.app.authenticator.description","login",[e.label]),noTranslateClassName:t?"no-translate":"",buttonDataSeAttr:c(e),iconClassName:"mfa-custom-app-logo",logoUri:(null==e||null===(U=e.relatesTo)||void 0===U?void 0:U.logoUri)||"",ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[null==e||null===(F=e.relatesTo)||void 0===F?void 0:F.displayName]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.SMARTCARD:Object.assign(O,{description:t?"":(0,i.loc)("oie.smartcard.authenticator.description","login"),iconClassName:"mfa-smartcard",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])});break;case s.AUTHENTICATOR_KEY.TAC:Object.assign(O,{description:t?"":(0,i.loc)("oie.tac.authenticator.description","login"),iconClassName:"mfa-tac",buttonDataSeAttr:c(e),ariaLabel:t?(0,i.loc)("oie.select.authenticator.verify.named.authenticator.label","login",[e.label]):(0,i.loc)("oie.select.authenticator.enroll.named.authenticator.label","login",[e.label])})}return O};function f(e){return e?(0,i.loc)("oie.select.authenticator.verify.email.with.email.label","login",[e]):(0,i.loc)("oie.select.authenticator.verify.email.label","login")}function p(e){return e?(0,i.loc)("oie.select.authenticator.verify.phone.with.phone.label","login",[e]):(0,i.loc)("oie.select.authenticator.verify.phone.label","login")}function h(e,t){if(!e)return(0,i.loc)("oie.select.authenticator.enroll.okta_verify.authenticator.label","login");var n=(0,i.loc)("oie.select.authenticator.verify.okta_verify.label","login");return void 0===t?n:{push:(0,i.loc)("oie.select.authenticator.okta_verify.push.label","login"),totp:(0,i.loc)("oie.select.authenticator.okta_verify.totp.label","login"),signed_nonce:(0,i.loc)("oie.select.authenticator.okta_verify.signed_nonce.label","login")}[t]||n}},66200:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.appendLoginHint=f,t.cancelPollingWithParams=function(e,t,n,r,o){var i={};i[c.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON]=n,i[c.LOOPBACK_RESPONSE_STATUS_CODE]=r,e.trigger("invokeAction",t,i,o)},t.createInvisibleIFrame=function(e,t){return a.View.extend({tagName:"iframe",id:e,attributes:{src:t},initialize:function(){this.el.style.display="none"}})},t.doChallenge=function(e,t){var n,r,v=e.getDeviceChallengePayload(),g=(v||{}).chromeLocalNetworkAccessDetails,y=null===(n=e.options)||void 0===n||null===(r=n.settings)||void 0===r?void 0:r.get("identifier"),b="hide";switch(v.challengeMethod){case s.default.LOOPBACK_CHALLENGE:e.title=(0,a.loc)("deviceTrust.sso.redirectText","login"),g?d.default.getChromeLNAPermissionState((function(t){return function(e,t,n){switch(e.removeChildren(),t){case"prompt":case"granted":default:m(e,(0,a.loc)("deviceTrust.sso.redirectText","login")),h(e,n);break;case"denied":var r,o,i;if(!(void 0===(null===(r=e.options)||void 0===r||null===(o=r.appState)||void 0===o?void 0:o.get("previousFormName"))))throw m(e,(0,a.loc)("chrome.lna.fastpass.requires.permission.title","login")),function(e,t){e.add((0,a.createCallout)({title:(0,a.loc)("chrome.lna.error.title","login"),content:new p({chromeLNAHelpLink:t}),type:"error"}))}(e,null===(i=n.chromeLocalNetworkAccessDetails)||void 0===i?void 0:i.chromeLNAHelpLink),new l.ChromeLNADeniedError("Chrome Local Network Access permission was denied for FastPass.");m(e,(0,a.loc)("deviceTrust.sso.redirectText","login")),h(e,n)}}(e,t,v)})):h(e,v);break;case s.default.CUSTOM_URI_CHALLENGE:e.title=(0,a.loc)("customUri.title","login"),e.add(a.View.extend({className:"skinny-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.prompt"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:67}}}))+"</p>"},useData:!0})})),e.add((0,a.createButton)({className:"ul-button button button-wide button-primary",title:(0,a.loc)("oktaVerify.open.button","login"),id:"launch-ov",click:function(){e.doCustomURI()}})),e.add(a.View.extend({className:"skinny-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.download.title"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:75}}}))+'</p><p><a href="'+l("function"==typeof(i=null!=(i=u(n,"downloadOVLink")||(null!=t?u(t,"downloadOVLink"):t))?i:s)?i.call(a,{name:"downloadOVLink",hash:{},data:o,loc:{start:{line:1,column:91},end:{line:1,column:109}}}):i)+'" target="_blank" id="download-ov" class="link">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.download.linkText"},data:o,loc:{start:{line:1,column:157},end:{line:1,column:232}}}))+"</a></p>"},useData:!0}),getTemplateData:function(){return{downloadOVLink:v.downloadHref}}})),e.customURI=f(v.href,y),e.doCustomURI();break;case s.default.UNIVERSAL_LINK_CHALLENGE:e.title=(0,a.loc)("universalLink.title","login"),e.add(a.View.extend({className:"universal-link-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="spinner"></div>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"universalLink.content"},data:o,loc:{start:{line:1,column:27},end:{line:1,column:79}}}))},useData:!0})})),e.add((0,a.createButton)({className:"ul-button button button-wide button-primary",title:(0,a.loc)("oktaVerify.open.button","login"),click:function(){var e=f(v.href,y);u.default.redirect(e)}}));break;case s.default.APP_LINK_CHALLENGE:e.title=(0,a.loc)("appLink.title","login"),e.add(a.View.extend({className:"app-link-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="spinner '+c((a=null!=(a=d(n,"hideClass")||(null!=t?d(t,"hideClass"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"hideClass",hash:{},data:i,loc:{start:{line:1,column:20},end:{line:1,column:33}}}):a))+'"></div><div class="appLinkContent '+c((a=null!=(a=d(n,"hideClass")||(null!=t?d(t,"hideClass"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"hideClass",hash:{},data:i,loc:{start:{line:1,column:68},end:{line:1,column:81}}}):a))+'">'+c((d(n,"i18n")||t&&d(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"appLink.content"},data:i,loc:{start:{line:1,column:83},end:{line:1,column:129}}}))+"</div>"},useData:!0}),getTemplateData:function(){return{hideClass:b}},postRender:function(){var e=this;t===c.IDENTIFIER_FLOW?(this.$(".spinner").removeClass(b),setTimeout(a._.bind((function(){var t={label:(0,a.loc)("goback","login")};e.options.appState.trigger("updateFooterLink",t),e.$(".spinner").addClass(b),e.$(".appLinkContent").removeClass(b)}),this),c.FASTPASS_FALLBACK_SPINNER_TIMEOUT)):this.$(".appLinkContent").removeClass(b)}})),e.add((0,a.createButton)({className:"".concat(b," al-button button button-wide button-primary"),title:(0,a.loc)("oktaVerify.open.button","login"),click:function(){var e=f(v.href,y);u.default.redirect(e,window,!0)},postRender:function(){var e=this;t===c.IDENTIFIER_FLOW?setTimeout(a._.bind((function(){e.$el.removeClass(b)}),this),c.FASTPASS_FALLBACK_SPINNER_TIMEOUT):this.$el.removeClass(b)}}));break;case s.default.CHROME_DTC:e.title=(0,a.loc)("deviceTrust.sso.redirectText","login"),e.add(a.View.extend({className:"chrome-dtc-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="spinner"></div>'},useData:!0})})),e.doChromeDTC(v)}},t.getBiometricsErrorOptions=function(e,t){var n,r,o;n=t?Object.values(null==e||null===(r=e.value[0])||void 0===r?void 0:r.i18n):null==e||null===(o=e.responseJSON)||void 0===o?void 0:o.errorSummaryKeys;var i=n&&n.includes(c.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE),s=n&&n.includes(c.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP),l=n&&n.includes(c.OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS),u=[];if(!i&&!s&&!l)return u;if(l)return u={type:"error",className:"okta-verify-uv-callout-content",title:(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.title","login"),subtitle:(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.description","login"),bullets:[(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point1","login"),(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point2","login")]};var d=[(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1","login"),(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2","login"),(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3","login")];s&&d.push((0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4","login"));return u={type:"error",className:"okta-verify-uv-callout-content",title:(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title","login"),subtitle:(0,a.loc)("oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description","login"),bullets:d}};var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=r(n(35546)),l=n(13671),u=r(n(90570)),c=n(86725),d=r(n(34425));function f(e,t){return e&&t&&(e+="&login_hint="+t),e}var p=a.View.extend({template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"chrome.lna.error.description.intro"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:65}}}))+'<ol class="chrome-lna-error-steps"><li>'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"chrome.lna.error.description.step1"},data:o,loc:{start:{line:1,column:104},end:{line:1,column:169}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"chrome.lna.error.description.step2"},data:o,loc:{start:{line:1,column:178},end:{line:1,column:243}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"chrome.lna.error.description.step3"},data:o,loc:{start:{line:1,column:252},end:{line:1,column:317}}}))+"</li></ol>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{$1:"<a href='#' target='_blank' rel='noopener noreferrer' class='chrome-lna-help-link'>$1</a>",bundle:"login",code:"chrome.lna.error.description.more.information"},data:o,loc:{start:{line:1,column:327},end:{line:1,column:498}}}))},useData:!0}),getTemplateData:function(){this.chromeLNAHelpLink=this.options.chromeLNAHelpLink},render:function(){a.View.prototype.render.apply(this,arguments),this.chromeLNAHelpLink&&this.$el.find(".chrome-lna-help-link").attr("href",this.chromeLNAHelpLink)}});function h(e,t){e.add(a.View.extend({className:"loopback-content",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div class="spinner"></div>'},useData:!0})})),e.doLoopback(t)}function m(e,t){e.title=t,e.$&&e.$(".okta-form-title").length&&e.$(".okta-form-title").text(t)}},86725:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.WIDGET_FOOTER_CLASS=t.WARNING_TIMEOUT=t.UNIVERSAL_LINK_POST_DELAY=t.SHOW_RESEND_TIMEOUT=t.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON=t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS=t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE=t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP=t.MS_PER_SEC=t.LOOPBACK_RESPONSE_STATUS_CODE=t.IDENTIFIER_FLOW=t.FASTPASS_FALLBACK_SPINNER_TIMEOUT=t.CHALLENGE_TIMEOUT=t.CANCEL_POLLING_ACTION=t.AUTHENTICATOR_CANCEL_ACTION=t.AUTHENTICATOR_ALLOWED_FOR_OPTIONS=t.AUTHENTICATION_CANCEL_REASONS=void 0;t.SHOW_RESEND_TIMEOUT=3e4;t.WARNING_TIMEOUT=3e4;t.CHALLENGE_TIMEOUT=3e5;t.MS_PER_SEC=1e3;t.UNIVERSAL_LINK_POST_DELAY=500;t.CANCEL_POLLING_ACTION="authenticatorChallenge-cancel";t.AUTHENTICATOR_CANCEL_ACTION="currentAuthenticator-cancel";t.WIDGET_FOOTER_CLASS="siw-main-footer";t.FASTPASS_FALLBACK_SPINNER_TIMEOUT=4e3;t.IDENTIFIER_FLOW="IDENTIFIER";t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP="oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop";t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS="oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows";t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE="oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile";t.AUTHENTICATOR_ALLOWED_FOR_OPTIONS={ANY:"any",SSO:"sso",RECOVERY:"recovery"};t.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON="reason";t.LOOPBACK_RESPONSE_STATUS_CODE="statusCode";t.AUTHENTICATION_CANCEL_REASONS={LOOPBACK_FAILURE:"OV_UNREACHABLE_BY_LOOPBACK",OV_ERROR:"OV_RETURNED_ERROR",USER_CANCELED:"USER_CANCELED"}},23376:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={generateDeviceFingerprint:function(e,t){return e.fingerprint({timeout:2e3,container:t})}},e.exports=t.default},64459:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.probeLoopbackAndExecute=t.isLoopbackDeviceRemediation=t.hasDeviceRemediationAction=void 0;var o=r(n(2875)),i=n(6475),a=r(n(35546)),s=r(n(36894)),l=r(n(90570)),u=n(43318),c=function(e){var t=Object.assign({method:"GET",contentType:"application/json"},e);return i.$.ajax(t)},d=function(e,t){switch(e.type){case"APP_LINK":l.default.executeOnVisiblePage((function(){l.default.redirect(e.href,window,!0)}));break;case"MESSAGE":var n=document.getElementById(a.default.WIDGET_CONTAINER_ID);if(!n)return void s.default.error("Cannot find okta-sign-in container to display message");var r=n.querySelectorAll('[data-se="'.concat(t,'"]'));r&&r[0]&&(r[0].outerHTML="idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install"===(i=e).message.i18n.key?o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",bundle:"login",code:"idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:194}}}))},useData:!0})():(0,u.getMessage)(i.message))}var i},f=function(e,t){return(n="".concat(e,"/").concat("probe"),r=t.probeTimeoutMillis,c({url:n,timeout:r})).then((function(){return function(e,t){return c({url:e,method:"GET",timeout:t})}("".concat(e,"/").concat(t.remediationPath,"/").concat(t.actionPath),t.probeTimeoutMillis).then((function(){t.isSuccess=!0}))})).catch((function(){return s.default.error("Something unexpected happened while we were checking url: ".concat(e,".")),i.$.Deferred().reject()}));var n,r};t.hasDeviceRemediationAction=function(e){return e.deviceRemediation&&e.deviceRemediation.value&&e.deviceRemediation.value.action};t.isLoopbackDeviceRemediation=function(e){return e&&"LOOPBACK"===e.remediationType};t.probeLoopbackAndExecute=function(e){var t=e.domain,n=e.ports,r=n.length,o=0,i={remediationPath:e.remediationPath,actionPath:e.action,probeTimeoutMillis:e.probeTimeoutMillis,isSuccess:!1},a=Promise.resolve();n.map((function(e){return"".concat(t,":").concat(e)})).forEach((function(t){i.isSuccess||(a=a.then((function(){return f(t,i)})).catch((function(){o+=1,s.default.error("Authenticator is not listening on: ".concat(t,".")),o>=r&&!i.isSuccess&&(s.default.error("No available ports. Loopback server failed and using fallback mechanism."),d(e.fallback,e.action))})))}))}},78747:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getHelpLinks=function(e){var t,n,r=o(e);switch(null==r?void 0:r.toUpperCase()){case"PERSONA":t="https://withpersona.com/legal/terms-of-use",n="https://withpersona.com/legal/privacy-policy";break;case"CLEAR":t="https://www.clearme.com/member-terms",n="https://www.clearme.com/privacy-policy";break;case"INCODE":t="https://incode.id/terms",n="https://incode.id/privacy";break;default:var a=i(e);t=null==a?void 0:a.termsOfUse,n=null==a?void 0:a.privacyPolicy}return{termsOfUse:t,privacyPolicy:n}},t.getIdvName=o,t.getMetaInfoLinksForCustomIDV=i;var r=n(13955);function o(e){return e.find((function(e){return e.name===r.FORMS.REDIRECT_IDVERIFY})).idp.name}function i(e){var t,n,o=e.find((function(e){return e.name===r.FORMS.REDIRECT_IDVERIFY}));return((null==o||null===(t=o.idp)||void 0===t?void 0:t.id)===r.ID_PROOFING_TYPE.IDV_STANDARD||(null==o||null===(n=o.idp)||void 0===n?void 0:n.id)===r.ID_PROOFING_TYPE.IDV_OIN)&&(null==o?void 0:o.idvMetadata)||void 0}},71101:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.goBackLink=t.getSwitchAuthenticatorLink=t.getSkipSetupLink=t.getSignUpLink=t.getSignOutLink=t.getReloadPageButtonLink=t.getGracePeriodRequiredSoonCustomLink=t.getForgotPasswordLink=t.getFactorPageCustomLink=t.getBackToSignInLink=void 0;var o=r(n(15985)),i=n(6475),a=n(13955);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var u=a.ACTIONS.ENROLLED_PASSWORD_RECOVERY_LINK,c=a.ACTIONS.ORG_PASSWORD_RECOVERY_LINK;t.getSwitchAuthenticatorLink=function(e){return e.getRemediationAuthenticationOptions(a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE).length>1?[{type:"link",label:(0,i.loc)("oie.verification.switch.authenticator","login"),name:"switchAuthenticator",formName:a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE}]:e.getRemediationAuthenticationOptions(a.FORMS.SELECT_AUTHENTICATOR_ENROLL).length>=1?[{type:"link",label:(0,i.loc)("oie.enroll.switch.authenticator","login"),name:"switchAuthenticator",formName:a.FORMS.SELECT_AUTHENTICATOR_ENROLL}]:[]};t.getForgotPasswordLink=function(e,t){var n={type:"link",label:(0,i.loc)("forgotpassword","login"),name:"forgot-password"},r=t.get("helpLinks.forgotPassword");return r?[Object.assign({},{href:r,label:(0,i.loc)("forgotpassword","login"),name:"forgot-password"})]:e.getActionByPath(c)?[Object.assign({},n,{actionPath:c})]:e.getActionByPath(u)?[Object.assign({},n,{actionPath:u})]:[]};t.goBackLink=function(e){return e.hasRemediationObject(a.FORMS.SELECT_AUTHENTICATOR_ENROLL)?[{type:"link",label:(0,i.loc)("oie.go.back","login"),name:"go-back",formName:a.FORMS.SELECT_AUTHENTICATOR_ENROLL}]:[]};t.getSkipSetupLink=function(e,t){return e.hasRemediationObject(a.FORMS.SKIP)?[{type:"link",label:null!=t?t:(0,i.loc)("oie.enroll.skip.setup","login"),name:"skip-setup",actionPath:a.FORMS.SKIP}]:[]};t.getSignOutLink=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null!=e&&e.get("backToSignInUri")?[{label:(0,i.loc)("goback","login"),name:"cancel",href:e.get("backToSignInUri")}]:[{actionPath:"cancel",label:t.label?t.label:(0,i.loc)("goback","login"),name:"cancel",type:"link"}]};t.getBackToSignInLink=function(e){var t=e.settings,n=e.appState,r={};return null!=t&&t.get("backToSignInUri")?r.href=t.get("backToSignInUri"):null!=t&&t.get("oauth2Enabled")?r.clickHandler=function(){n.trigger("restartLoginFlow")}:r.href=null==t?void 0:t.get("baseUrl"),[l({type:"link",label:(0,i.loc)("goback","login"),name:"go-back"},r)]};t.getReloadPageButtonLink=function(){return[{type:"link",label:(0,i.loc)("oie.try.again","login"),name:"try-again",href:window.location,className:"button button-primary text-align-c"}]};t.getSignUpLink=function(e,t){var n=[];if(e.hasRemediationObject(a.FORMS.SELECT_ENROLL_PROFILE)){var r={type:"link",label:(0,i.loc)("oie.registration.form.title","login"),name:"enroll"};i._.isFunction(t.get("registration.click"))?r.clickHandler=t.get("registration.click"):r.actionPath=a.FORMS.SELECT_ENROLL_PROFILE,n.push(r)}return n};t.getGracePeriodRequiredSoonCustomLink=function(e){var t,n=e.get("helpLinks.gracePeriodRequiredSoon.text"),r=e.get("helpLinks.gracePeriodRequiredSoon.href");return n&&r&&(t={type:"link",label:n,name:"gracePeriodRequiredSoonCustomLink",href:r,target:"_blank"}),t};t.getFactorPageCustomLink=function(e,t){var n=[],r=[a.FORMS.CHALLENGE_AUTHENTICATOR,a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,a.FORMS.CHALLENGE_POLL,a.FORMS.AUTHENTICATOR_VERIFICATION_DATA];if(!e.get("isPasswordRecovery")&&r.includes(e.get("currentFormName"))){var o=t.get("helpLinks.factorPage.text"),i=t.get("helpLinks.factorPage.href");o&&i&&n.push({type:"link",label:o,name:"factorPageHelpLink",href:i,target:"_blank"})}return n}},77653:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={GMT:"UTC",WET:"WET",CET:"CET",MET:"CET",ECT:"CET",EET:"EET",MIT:"Pacific/Apia",HST:"Pacific/Honolulu",AST:"America/Anchorage",PST:"America/Los_Angeles",MST:"America/Denver",PNT:"America/Phoenix",CST:"America/Chicago",EST:"America/New_York",IET:"America/Indiana/Indianapolis",PRT:"America/Puerto_Rico",CNT:"America/St_Johns",AGT:"America/Argentina/Buenos_Aires",BET:"America/Sao_Paulo",ART:"Africa/Cairo",CAT:"Africa/Harare",EAT:"Africa/Addis_Ababa",NET:"Asia/Yerevan",PLT:"Asia/Karachi",IST:"Asia/Kolkata",BST:"Asia/Dhaka",VST:"Asia/Ho_Chi_Minh",CTT:"Asia/Shanghai",JST:"Asia/Tokyo",ACT:"Australia/Darwin",AET:"Australia/Sydney",SST:"Pacific/Guadalcanal",NST:"Pacific/Auckland"},e.exports=t.default},57785:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=n(13955),s=r(n(91002)),l="security.access_denied_custom_message",u=i.BaseForm.extend({title:function(){var e=(0,o.loc)("oie.success.text.signingIn","login"),t=this.options.appState.get("app"),n=this.options.appState.get("user");if(!this.redirectView||this.redirectView===a.INTERSTITIAL_REDIRECT_VIEW.NONE)return e=(0,o.loc)("oie.success.text.signingIn.with.ellipsis","login");if(o._.isEmpty(t))return e;var r=t.label,i=t.name,s=(n||{}).identifier,l=r||i;return l&&s&&!this.settings.get("features.showIdentifier")?e=(0,o.loc)("oie.success.text.signingIn.with.appName.and.identifier","login",[l,s]):l&&(e=(0,o.loc)("oie.success.text.signingIn.with.appName","login",[l])),e},showMessages:function(){if(this.isUnlockSuccess()){var e=(0,o.loc)("oie.selfservice.unlock_user.landing.to.app.signing.in.message","login");this.add('<div class="ion-messages-container"><p>'.concat(e,"</p></div>"),".o-form-error-container")}else if(this.options.appState.containsMessageStartingWithI18nKey(l)){var t=this.options.appState.get("messages").value.find((function(e){return e.i18n.key===l})),n=t.message,r=t.links;this.add((0,o.createCallout)({type:"error",content:new s.default({message:n,links:r})}))}else i.BaseForm.prototype.showMessages.call(this)},isUnlockSuccess:function(){return this.options.appState.containsMessageWithI18nKey("oie.selfservice.unlock_user.landing.to.app.success.message")},noButtonBar:!0,initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),this.redirectView=this.settings.get("interstitialBeforeLoginRedirect"),this.model.set("useRedirect",!0),this.trigger("save",this.model)},render:function(){i.BaseForm.prototype.render.apply(this,arguments),this.redirectView===a.INTERSTITIAL_REDIRECT_VIEW.DEFAULT&&this.add('<div class="okta-waiting-spinner"></div>')}}),c=i.BaseView.extend({Body:u});t.default=c,e.exports=t.default},60342:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=n(71101),l=a.BaseForm.extend({className:"profile-update",title:function(){return(0,i.loc)("oie.profile.additional.title","login")},save:function(){return(0,i.loc)("enroll.choices.submit.finish","login")},getUISchema:function(){var e=a.BaseForm.prototype.getUISchema.apply(this,arguments);return e.forEach((function(e){"userProfile.secondEmail"===e.name&&(e.explain=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",bundle:"login",code:"oie.profile.additional.secondemail.subtitle"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:112}}}))?i:""},useData:!0})}))})),e},initialize:function(){a.BaseForm.prototype.initialize.apply(this,arguments)}}),u=a.BaseFooter.extend({className:"auth-footer side-by-side-links",links:function(){var e=this.options.currentViewState.uiSchema,t=e.filter((function(e){return!1===e.required}));if(e.length===t.length)return(0,s.getSkipSetupLink)(this.options.appState,(0,i.loc)("oie.enroll.skip.profile","login"));this.$el.removeClass(".side-by-side-links")}}),c=a.BaseView.extend({Body:l,Footer:u,postRender:function(){a.BaseView.prototype.postRender.apply(this,arguments),this.options.appState.getSchemaByName("userProfile.secondEmail")&&this.model.set("userProfile.secondEmail","")}});t.default=c,e.exports=t.default},56111:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=n(6475),a=n(17587),s=n(13955),l=n(25795),u=n(81554),c=r(n(21586));function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=a.BaseForm.extend({title:function(){if(this.options.appState.getCurrentViewState().href.endsWith("idp/idx/enroll/update")){var e,t=this.options.appState.attributes;return null!=t&&null!==(e=t.uiDisplay)&&void 0!==e&&e.label?(0,i.loc)("oie.registration.form.customize.label","login",[t.uiDisplay.label]):(0,i.loc)("oie.primaryauth.submit","login")}return(0,i.loc)("oie.registration.form.title","login")},save:function(){if(this.options.appState.getCurrentViewState().href.endsWith("idp/idx/enroll/update")){var e,t=this.options.appState.attributes;return null!=t&&null!==(e=t.uiDisplay)&&void 0!==e&&e.buttonLabel?(0,i.loc)("oie.registration.form.customize.buttonLabel","login",[t.uiDisplay.buttonLabel]):(0,i.loc)("oie.registration.form.update.submit","login")}return(0,i.loc)("oie.registration.form.submit","login")},saveForm:function(){var e=this;this.settings.preRegistrationSubmit(this.model.toJSON(),(function(t){e.model.attributes=f(f({},e.model.attributes),e.model.parse(t)),a.BaseForm.prototype.saveForm.call(e,e.model)}),(function(t){return e.model.trigger("error",e.model,{responseJSON:t})}))},triggerAfterError:function(e,t){var n;(null==t||null===(n=t.responseJSON)||void 0===n?void 0:n.errorCauses)&&Array.isArray(t.responseJSON.errorCauses)&&t.responseJSON.errorCauses.forEach((function(e){var t;null!==(t=e.errorKey)&&void 0!==t&&t.includes("password.passwordRequirementsNotMet")&&(e.errorSummary=(0,i.loc)("registration.error.password.passwordRequirementsNotMet","login"))})),this.options.appState.trigger("afterError",t)}}),h=a.BaseFooter.extend({links:function(){var e=[];return this.options.appState.hasRemediationObject(s.FORMS.SELECT_IDENTIFY)&&e.push({type:"link",label:(0,i.loc)("haveaccount","login"),name:"back",actionPath:s.FORMS.SELECT_IDENTIFY}),e}}),m=a.BaseView.extend({Body:p,Footer:h,createModelClass:function(e,t,n){var r=this,o=JSON.parse(JSON.stringify(e.uiSchema)),s=a.BaseView.prototype.createModelClass.apply(this,arguments,e);return s=s.extend({toJSON:function(){var t=i.Model.prototype.toJSON.call(this,arguments,e);if(t.userProfile){var n=e.uiSchema,r=t.userProfile;i._.each(r,(function(e,t){if(i._.isEmpty(e)){var o=n.find((function(e){return e.name==="userProfile.".concat(t)}));i._.isUndefined(o)||o.required||delete r[t]}}))}return t}}),n.parseRegistrationSchema(o,(function(n){i._.isEqual(n,e.uiSchema)||(e.uiSchema=n,s=a.BaseView.prototype.createModelClass.call(r,e,t))}),(function(e){s=s.extend({local:f({parseSchemaError:{value:e,type:"object"}},s.prototype.local)})})),s},postRender:function(){a.BaseView.prototype.postRender.apply(this,arguments);var e=this.model.get("parseSchemaError");e&&this.model.trigger("error",this.model,{responseJSON:e}),this.renderPasswordPolicySettings();var t=(0,a.createIdpButtons)(this.options);Array.isArray(t)&&t.length&&this._addIdpView(t)},renderPasswordPolicySettings:function(){var e,t,n,r=this.options.currentViewState.value.filter((function(e){return"credentials"===e.name}))[0],o=null==r||null===(e=r.form)||void 0===e?void 0:e.value;o&&o.filter((function(e){return"passcode"===e.name}))&&(0,u.generatePasswordPolicyHtml)(this,(0,l.getPasswordComplexityDescriptionForHtmlList)(null==r||null===(t=r.relatesTo)||void 0===t||null===(n=t.value)||void 0===n?void 0:n.settings),!1)},_addIdpView:function(e){var t=this.options.settings.get("idpDisplay"),n=t&&"PRIMARY"===t.toUpperCase();this.add(c.default,{prepend:n,selector:n?".o-form-fieldset-container":".o-form-button-bar",options:{idpButtons:e,isPrimaryIdpDisplay:n}})}});t.default=m,e.exports=t.default},57973:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31049)),a=r(n(15985)),s=n(6475),l=n(13955),u=n(17587),c=r(n(76587)),d=r(n(23376)),f=r(n(7667)),p=r(n(87547)),h=r(n(21586)),m=r(n(94438)),v=r(n(83201)),g=r(n(156)),y=r(n(66019)),b=n(43318),w=n(71101),_=r(n(26368)),O=r(n(91002)),k=r(n(90570)),x=r(n(49268));function E(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function T(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E(Object(n),!0).forEach((function(t){(0,a.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var S="security.access_denied_custom_message",A="WebAuthNAutofill component cleanup",P=u.BaseForm.extend({title:function(){return(0,s.loc)("primaryauth.title","login")},save:function(){return(0,s.loc)("oform.next","login")},focus:function(){if(u.BaseForm.prototype.focus.apply(this,arguments),this.settings.get("features.autoFocus")){var e=this.getInputs().filter((function(e){return"identifier"===e.options.name}))[0],t=this.getInputs().filter((function(e){return"credentials.passcode"===e.options.name}))[0];e&&e.model.get("identifier")&&t&&t.focus()}},initialize:function(){u.BaseForm.prototype.initialize.apply(this,arguments);var e=this.getUISchema();e.find((function(e){return"credentials.passcode"===e.name}))&&(this.save=(0,s.loc)("oie.primaryauth.submit","login")),this.listenTo(this.model,"errors:clear",(function(){this.clearErrors()})),this._shouldAddUsername(e)?this.model.set("identifier",this.settings.get("username")):!this.model.get("identifier")&&this._shouldApplyRememberMyUsername(e)&&this._applyRememberMyUsername()},saveForm:function(){var e=this,t=arguments;if(this.settings.get("features.deviceFingerprinting")){this.model.trigger("request");var n=this.settings.getAuthClient();d.default.generateDeviceFingerprint(n,this.$el[0]).then((function(t){e.options.appState.set("deviceFingerprint",t)})).catch((function(){})).finally((function(){u.BaseForm.prototype.saveForm.apply(e,t)}))}else u.BaseForm.prototype.saveForm.apply(this,arguments)},render:function(){u.BaseForm.prototype.render.apply(this,arguments),this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_AUTHENTICATOR)&&this.add(v.default,".o-form-fieldset-container",!1,!0,{isRequired:!1}),this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR)&&this.add(g.default,".o-form-fieldset-container",!1,!0,{isRequired:!1}),this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_PASSKEYS_AUTHENTICATOR)&&this.add(y.default,{selector:".o-form-fieldset-container",options:{getCredentialsAndInvokeAction:this.getCredentialsForModalAndInvokeAction,formView:this},prepend:!0});var e=(0,u.createIdpButtons)(this.options);Array.isArray(e)&&e.length&&(this._addForgotPasswordView(),this._addIdpView(e));var t=(0,u.createCustomButtons)(this.options.settings);Array.isArray(t)&&t.length&&this.add(m.default,{selector:".o-form-button-bar",options:{customButtons:t,addSeparateLine:!0}})},postRender:function(){u.BaseForm.prototype.postRender.apply(this,arguments),this.$el.find(".identifier-container").remove(),this._hasAutofillUIChallenge()&&this.getCredentialsAndInvokeAction()},getUISchema:function(){var e=this,t=u.BaseForm.prototype.getUISchema.apply(this,arguments),n=this.options.settings,r="primaryauth.username.tooltip",o="primaryauth.password.tooltip",i=t.map((function(t){var i=T({},t);if("identifier"===t.name){(0,b.isCustomizedI18nKey)(r,n)&&(i=T(T({},i),{},{explain:(0,s.loc)(r,"login"),"explain-top":!0}));var a=e._hasAutofillUIChallenge()&&x.default.isConditionalMediationAvailable()?"username webauthn":"username";i=T(T({},i),{},{autoComplete:k.default.getAutocompleteValue(e.options.settings,a)})}else"credentials.passcode"===t.name&&(i=T(T({},i),{},{autoComplete:k.default.getAutocompleteValue(e.options.settings,"current-password")}),(0,b.isCustomizedI18nKey)(o,n)&&(i=T(T({},i),{},{explain:(0,s.loc)(o,"login"),"explain-top":!0})));return i}));return!1===this.settings.get("features.showKeepMeSignedIn")&&(i=i.filter((function(e){return"rememberMe"!==e.name}))),i},showCustomFormErrorCallout:function(e,t){var n,r;if(null==e||null===(n=e.responseJSON)||void 0===n||null===(r=n.errorSummaryKeys)||void 0===r||!r.includes(S))return!1;var o=null==t?void 0:t.find((function(e){return e.i18n.key===S}));if(!o)return!1;var i=e.responseJSON.errorSummary,a={type:"error",content:new O.default({message:i,links:o.links})};return this.showMessages((0,s.createCallout)(a)),!0},remove:function(){u.BaseForm.prototype.remove.apply(this,arguments),this.webauthnAbortController&&(this.webauthnAbortController.abort(),this.webauthnAbortController=null)},remediateWithAssertion:function(e,t){var n;if(e&&t){var r=c.default.binToStr(null!==(n=e.response.userHandle)&&void 0!==n?n:"");if(s._.isEmpty(r)){var o=(0,s.loc)("oie.webauthn.error.invalidPasskey","login");this.model.trigger("error",this.model,this._generateErrorObject(o))}else{var i={clientData:c.default.binToStr(e.response.clientDataJSON),authenticatorData:c.default.binToStr(e.response.authenticatorData),signatureData:c.default.binToStr(e.response.signature),userHandle:r};this.options.appState.trigger("invokeAction",t,{credentials:i})}}},getCredential:function(e){var t=this;return(0,i.default)(o.default.mark((function n(){var r,i,a;return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:if((i=null===(r=t.options.appState.get("webauthnAutofillUIChallenge"))||void 0===r?void 0:r.challengeData)&&"undefined"!=typeof AbortController){n.next=3;break}return n.abrupt("return");case 3:return t.webauthnAbortController&&t.webauthnAbortController.abort(A),t.webauthnAbortController=new AbortController,a=s._.extend({},i,{challenge:c.default.strToBin(i.challenge)}),n.abrupt("return",navigator.credentials.get({mediation:e,publicKey:a,signal:t.webauthnAbortController.signal}));case 7:case"end":return n.stop()}}),n)})))()},_handleWebAuthnError:function(e){if(e!==A&&!x.default.isAbortError(e))if(x.default.isNotAllowedError(e)){var t=(0,s.loc)("signin.passkeys.error","login");this.model.trigger("error",this.model,this._generateErrorObject(t))}else if(this.webauthnAbortController){var n=(0,b.getMessageFromBrowserError)(e);this.model.trigger("error",this.model,this._generateErrorObject(n))}},getCredentialsAndInvokeAction:function(){var e=this;return(0,i.default)(o.default.mark((function t(){return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,x.default.isPasskeyAutofillAvailable();case 2:if(t.sent){t.next=4;break}return t.abrupt("return");case 4:return t.abrupt("return",e.getCredential("conditional").then((function(t){e.remediateWithAssertion(t,l.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR)}),(function(t){x.default.isRelyingPartyIdMismatchError(t)||e._handleWebAuthnError(t)})));case 5:case"end":return t.stop()}}),t)})))()},getCredentialsForModalAndInvokeAction:function(){var e=this;return(0,i.default)(o.default.mark((function t(){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(!e._isModalPasskeyInFlight){t.next=2;break}return t.abrupt("return");case 2:if(e._isModalPasskeyInFlight=!0,e.model.trigger("errors:clear"),x.default.isPasskeyAvailable()){t.next=9;break}return e._isModalPasskeyInFlight=!1,n=(0,s.loc)("signin.passkeys.error.NotSupportedError","login"),e.model.trigger("error",e.model,e._generateErrorObject(n)),t.abrupt("return");case 9:return t.abrupt("return",e.getCredential("optional").then((function(t){e.remediateWithAssertion(t,l.FORMS.LAUNCH_PASSKEYS_AUTHENTICATOR)}),(function(t){e._handleWebAuthnError(t)})).finally((function(){e._isModalPasskeyInFlight=!1})));case 10:case"end":return t.stop()}}),t)})))()},_generateErrorObject:function(e){return{responseJSON:{errorSummary:e}}},_addForgotPasswordView:function(){var e=(0,w.getForgotPasswordLink)(this.options.appState,this.options.settings);e.length&&(this.add('<div class="links-primary"></div>',{selector:".o-form-button-bar"}),this.add(p.default,{selector:".links-primary",options:e[0]}))},_addIdpView:function(e){var t=this.options.settings.get("idpDisplay"),n=t&&"PRIMARY"===t.toUpperCase();this.add(h.default,{prepend:n,selector:n?".o-form-fieldset-container":".o-form-button-bar",options:{idpButtons:e,isPrimaryIdpDisplay:n}})},_shouldAddUsername:function(e){return e.find((function(e){return"identifier"===e.name}))&&this.settings.get("username")},_shouldApplyRememberMyUsername:function(e){return e.find((function(e){return"identifier"===e.name}))&&this.settings.get("features.rememberMe")},_applyRememberMyUsername:function(){var e=_.default.getCookieUsername();e&&this.model.set("identifier",e)},_hasAutofillUIChallenge:function(){return this.options.appState.hasRemediationObject(l.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR)}}),C=u.BaseView.extend({Body:P,createModelClass:function(){var e=this,t=u.BaseView.prototype.createModelClass.apply(this,arguments),n="error.username.required",r="error.password.required",o=t.prototype.props,i=function(t){var i={},a=o.identifier&&!(null!=t&&t.identifier),l=o["credentials.passcode"]&&!(null!=t&&t["credentials.passcode"]);return a&&(0,b.isCustomizedI18nKey)(n,e.settings)&&(i.identifier=(0,s.loc)(n,"login")),l&&(0,b.isCustomizedI18nKey)(r,e.settings)&&(i["credentials.passcode"]=(0,s.loc)(r,"login")),i};return t.extend({validate:i})},initialize:function(){var e=this;this.Footer=f.default.extend({showForgotPasswordLink:function(){var t=(0,u.createIdpButtons)(e.options);return!(e.options.appState.isIdentifierOnlyView()||Array.isArray(t)&&0!==t.length)}})},postRender:function(){u.BaseView.prototype.postRender.apply(this,arguments);var e=this.options.appState;this.$el.find(".js-sign-up").click((function(){return e.trigger("invokeAction",l.FORMS.SELECT_ENROLL_PROFILE),!1}))}});t.default=C,e.exports=t.default},91485:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=n(6475),a=n(17587),s=r(n(90570));function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var c=a.BaseForm.extend({title:function(){return(0,i.loc)("password.reset.title.generic","login")},save:function(){return(0,i.loc)("oform.next","login")},getUISchema:function(){var e=this,t=a.BaseForm.prototype.getUISchema.apply(this,arguments),n=t.map((function(t){var n=u({},t);return"identifier"===t.name&&(n=u(u({},n),{},{autoComplete:s.default.getAutocompleteValue(e.options.settings,"username")})),n}));return n}}),d=a.BaseView.extend({Body:c,Footer:a.BaseFooter});t.default=d,e.exports=t.default},57571:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=n(86725),l=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="ion-messages-container"><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",arguments:"countDownCounterValue",bundle:"login",code:"poll.form.message"},data:o,loc:{start:{line:1,column:39},end:{line:1,column:157}}}))+'</p></div><div class="hide okta-waiting-spinner"></div>'},useData:!0}),getTemplateData:function(){return{countDownCounterValue:this.options}}}),u=a.BaseForm.extend(Object.assign({title:function(){return(0,i.loc)("poll.form.title","login")},noButtonBar:!0,initialize:function(){var e=this;a.BaseForm.prototype.initialize.apply(this,arguments);var t=this.options.appState.getCurrentViewState().refresh;this.refreshTimeout=setTimeout((function(){e.$el.find(".okta-waiting-spinner").show(),setTimeout((function(){return e.saveForm(e.model)}),200)}),t)},render:function(){a.BaseForm.prototype.render.apply(this,arguments),this.countDownCounterValue=Math.ceil(this.options.appState.getCurrentViewState().refresh/s.MS_PER_SEC),this.add(new l(this.countDownCounterValue)),this.startCountDown(".ion-messages-container span",s.MS_PER_SEC)},remove:function(){a.BaseForm.prototype.remove.apply(this,arguments),clearTimeout(this.refreshTimeout)},triggerAfterError:function(){a.BaseForm.prototype.triggerAfterError.apply(this,arguments),clearTimeout(this.refreshTimeout),this.stopCountDown(),this.$el.find(".o-form-fieldset-container").empty()},startCountDown:function(e,t){var n=this;this.countDown&&clearInterval(this.countDown),this.counterEl=this.$el.find(e),this.countDown=setInterval((function(){"0"!==n.counterEl.text()&&n.counterEl.text(n.counterEl.text()-1)}),t,this)},stopCountDown:function(){this.countDown&&clearInterval(this.countDown)}})),c=a.BaseView.extend({Body:u});t.default=c,e.exports=t.default},92017:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(57973)),i=o.default.extend({render:function(){o.default.prototype.render.apply(this,arguments),this.$el.find(".sign-in-with-idp .separation-line").hide(),this.$el.find(".button-primary").hide()}});t.default=i,e.exports=t.default},81261:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(6475),i=r.BaseForm.extend({title:function(){return(0,o.loc)("oie.select.authenticators.enroll.title","login")},subtitle:function(){var e=this.options.settings.get("brandName")?(0,o.loc)("oie.select.authenticators.enroll.subtitle.custom","login",[this.options.settings.get("brandName")]):(0,o.loc)("oie.select.authenticators.enroll.subtitle","login");return e},noButtonBar:!0}),a=r.BaseView.extend({Body:i});t.default=a,e.exports=t.default},21748:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.Body=void 0;var o=n(17587),i=n(6475),a=r(n(8517)),s=n(71101),l=o.BaseForm.extend({title:function(){return this.isPasswordRecoveryFlow()?(0,i.loc)("password.reset.title.generic","login"):(0,i.loc)("oie.select.authenticators.verify.title","login")},subtitle:function(){if(this.isPasswordRecoveryFlow())return(0,i.loc)("oie.password.reset.verification","login");if(!this.isUnlockSuccess())return(0,i.loc)("oie.select.authenticators.verify.subtitle","login");var e=(0,i.loc)("oie.select.authenticators.verify.subtitle","login");this.add('<div class="ion-messages-container"><p>'.concat(e,"</p></div>"),".o-form-error-container")},isPasswordRecoveryFlow:function(){return this.options.appState.get("isPasswordRecovery")},noButtonBar:!0,showMessages:function(){if(this.isUnlockSuccess()){var e={};return e.subtitle=(0,i.loc)("oie.selfservice.unlock_user.landing.to.app.success.message","login"),e.type="success",e=(0,i.createCallout)(e),void o.BaseForm.prototype.showMessages.call(this,e)}o.BaseForm.prototype.showMessages.call(this)},isUnlockSuccess:function(){return this.options.appState.containsMessageWithI18nKey("oie.selfservice.unlock_user.landing.to.app.success.message")}});t.Body=l;var u=o.BaseView.extend({Body:l,Footer:a.default.extend({links:function(){return(0,s.getFactorPageCustomLink)(this.options.appState,this.options.settings)}})});t.default=u},44822:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.REGISTRATION_NOT_ENABLED=t.FORGOT_PASSWORD_NOT_ENABLED=void 0;var o,i=r(n(15985)),a=r(n(31752)),s=n(6475),l=n(17587),u=n(71101),c=r(n(89597)),d=n(90959),f=r(n(91002)),p=r(n(11024)),h="idx.return.link.expired",m="idx.enter.otp.in.original.tab",v="idx.error.server.safe.mode",g="oie.selfservice.unlock_user.success.message",y="idx.return.to.original.tab",b="idx.operation.cancelled.on.other.device",w="idx.device.activated",_="idx.device.not.activated.consent.denied",O="idx.device.not.activated.internal.error",k="idx.transferred.to.new.tab",x="oie.registration.is.not.enabled";t.REGISTRATION_NOT_ENABLED=x;var E="oie.forgot.password.is.not.enabled";t.FORGOT_PASSWORD_NOT_ENABLED=E;var T=[k,"idx.return.stale","idx.return.error","idx.email.verification.required",y,h,b,"idx.operation.cancelled.by.user",m],S=[_,O],A=[w].concat(S),P=[g,y,k,b].concat((0,a.default)(A),["oie.selfservice.unlock_user.challenge.failed.permissions","oie.selfservice.reset.password.not.allowed",m]),C=(o={},(0,i.default)(o,h,"oie.email.return.link.expired.title"),(0,i.default)(o,g,"account.unlock.unlocked.title"),(0,i.default)(o,w,"device.code.activated.success.title"),(0,i.default)(o,x,"oie.registration.form.title"),(0,i.default)(o,E,"password.reset.title.generic"),(0,i.default)(o,"idx.expired.activation.token","oie.activation.request.email.title.expire"),(0,i.default)(o,"idx.request.activation.email","oie.activation.request.email.title.submitted"),(0,i.default)(o,"idx.activating.inactive.user","oie.activation.request.email.title.suspended"),(0,i.default)(o,"idx.missing.activation.token","oie.activation.request.email.title.invalid"),(0,i.default)(o,_,"device.code.activated.error.title"),(0,i.default)(o,O,"device.code.activated.error.title"),(0,i.default)(o,y,"oie.consent.enduser.email.allow.title"),(0,i.default)(o,m,"idx.return.link.otponly.your.verification.code"),o),R=l.BaseForm.extend({noButtonBar:!0,postRender:function(){if(l.BaseForm.prototype.postRender.apply(this,arguments),this.$el.addClass("terminal-state"),this.options.appState.containsMessageWithI18nKey(A)){var e=this.options.appState.containsMessageWithI18nKey(w)?"success-24-green":"error-24-red";this.$(".o-form-head").before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon '+e+'"></span></div>')}},title:function(){return this.getTerminalViewTitle()},getTerminalViewTitle:function(){var e=this;if(this.options.appState.containsMessageStartingWithI18nKey(v))return(0,s.loc)("oie.safe.mode.title","login");var t=Object.keys(C).find((function(t){return e.options.appState.containsMessageWithI18nKey(t)}));return t?(0,s.loc)(C[t],"login"):void 0},prepareMessageForCustomView:function(e){var t=!1;return this.options.appState.containsMessageWithI18nKey(m)?(this.add(d.OTPInformationTerminalView),t=!0):this.options.appState.containsMessageStartingWithI18nKey("security.access_denied_custom_message")?(this.add((0,s.createCallout)({type:"error",content:new f.default({message:e.value[0].message,links:e.value[0].links})})),t=!0):this.options.appState.containsMessageStartingWithI18nKey("idx.error.code.access_denied.device_assurance.remediation.")&&(this.add((0,s.createCallout)({type:"error",content:new p.default({messages:e.value})})),t=!0),t},showMessages:function(){var e,t=this.options.appState.get("messages"),n=!1;this.options.appState.containsMessageWithI18nKey(b)?(e=(0,s.loc)("idx.operation.cancelled.on.other.device","login"),t.value.push({message:(0,s.loc)("oie.consent.enduser.deny.description","login")})):this.options.appState.containsMessageWithI18nKey(y)?(e=(0,s.loc)("oie.consent.enduser.email.allow.description","login"),t.value.push({message:(0,s.loc)("oie.return.to.original.tab","login")})):this.options.appState.containsMessageWithI18nKey("tooManyRequests")?e=(0,s.loc)("oie.tooManyRequests","login"):this.options.appState.containsMessageWithI18nKey(h)?t.value[0].class="ERROR":n=this.prepareMessageForCustomView(t),e&&Array.isArray(null==t?void 0:t.value)&&(t.value[0].message=e),this.options.appState.set("messages",t),n||l.BaseForm.prototype.showMessages.call(this)}}),I=l.BaseFooter.extend({links:function(){return this.options.appState.containsMessageStartingWithI18nKey(v)?(0,u.getSkipSetupLink)(this.options.appState):this.options.appState.containsMessageWithI18nKey(S)?(0,u.getReloadPageButtonLink)():!(this.options.appState.hasActionObject("cancel")||this.options.appState.containsMessageWithI18nKey(P)||this.options.settings.get("features.hideSignOutLinkInMFA")||this.options.settings.get("features.mfaOnlyFlow"))?(0,u.getBackToSignInLink)(this.options):void 0}}),N=l.BaseView.extend({initialize:function(){l.BaseView.prototype.initialize.apply(this,arguments),this.options.appState.containsMessageWithI18nKey(T)&&(this.Header=c.default)},Body:R,Footer:I});t.default=N},99208:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(6475),i=r.BaseForm.extend({title:function(){return(0,o.loc)("oie.activation.request.email.title.expire","login")},save:function(){return(0,o.loc)("oie.activation.request.email.button","login")}}),a=r.BaseView.extend({Body:i});t.default=a,e.exports=t.default},99836:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(6475),i=r.BaseForm.extend({noButtonBar:!0,title:function(){return(0,o.loc)("oie.select.authenticators.verify.title","login")},subtitle:function(){return(0,o.loc)("oie.select.authenticators.verify.subtitle","login")}}),a=r.BaseView.extend({Body:i});t.default=a,e.exports=t.default},28141:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(6475),i=r.BaseForm.extend({title:function(){return(0,o.loc)("account.unlock.title","login")}}),a=r.BaseView.extend({initialize:function(){r.BaseView.prototype.initialize.apply(this,arguments),this.Body=i}});t.default=a,e.exports=t.default},19277:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(66583)),a=r(n(15985)),s=r(n(31049)),l=r(n(12990)),u=r(n(2875)),c=n(6475),d=r(n(35546)),f=r(n(90570)),p=n(86725);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,a.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v="OktaSignInWidgetOnCaptchaLoaded",g="OktaSignInWidgetOnCaptchaSolved",y=c.View.extend({className:"captcha-view",template:u.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div id ="captcha-container" class="'+c((i=null!=(i=d(n,"className")||(null!=t?d(t,"className"):t))?i:s,(0,l.default)(i)===u?i.call(a,{name:"className",hash:{},data:o,loc:{start:{line:1,column:63},end:{line:1,column:76}}}):i))+'" data-sitekey="'+c((i=null!=(i=d(n,"siteKey")||(null!=t?d(t,"siteKey"):t))?i:s,(0,l.default)(i)===u?i.call(a,{name:"siteKey",hash:{},data:o,loc:{start:{line:1,column:92},end:{line:1,column:103}}}):i))+'" data-callback="'+c((i=null!=(i=d(n,"onCaptchaSolvedCallback")||(null!=t?d(t,"onCaptchaSolvedCallback"):t))?i:s,(0,l.default)(i)===u?i.call(a,{name:"onCaptchaSolvedCallback",hash:{},data:o,loc:{start:{line:1,column:120},end:{line:1,column:147}}}):i))+'" data-size="invisible"></div>'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"isCaptchaConfigured"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:184}}}))?i:""},useData:!0}),getTemplateData:function(){var e;return this.captchaConfig?(e="ALTCHA"===this.captchaConfig.type?"altcha-captcha":"HCAPTCHA"===this.captchaConfig.type?"h-captcha":"g-recaptcha",{siteKey:this.captchaConfig.siteKey,isCaptchaConfigured:!0,onCaptchaSolvedCallback:g,className:e}):{}},initialize:function(){this.options.appState.get("captcha")&&(this.captchaConfig=this.options.appState.get("captcha"),this._addCaptcha())},remove:function(){c.View.prototype.remove.apply(this,arguments),"HCAPTCHA"===this.captchaConfig.type?window.hcaptcha=void 0:"RECAPTCHA_V2"===this.captchaConfig.type&&(window.grecaptcha=void 0)},_addCaptcha:function(){var e=this,t=function(t){var n=e._getCaptchaOject(),r=e.$el.find("#captcha-container").attr("data-captcha-id");n.reset(r);var o=e.options.name;e.model.set(o,t)},n=function(n){t(n),e.options.appState.trigger("saveForm",e.model)},r=function(){e.$el.find("#captcha-container").attr("data-captcha-id")||e.model.set(e.options.name,"tempToken")},a=function(){var t=(0,s.default)(o.default.mark((function t(n,r){var i,a,s,l,u;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(i=e.captchaConfig.challengeUrlForm){t.next=3;break}return t.abrupt("return",fetch(n,r));case 3:return a=i.accepts,s=i.method,l=i.value,u=m({},r),a&&(u.headers=m(m({},u.headers),{},{"Content-Type":a})),s&&(u.method=s),null!=l&&l.find((function(e){return"stateHandle"===(null==e?void 0:e.name)}))&&(u.body=JSON.stringify({stateHandle:e.options.appState.settings.options.stateToken})),t.abrupt("return",fetch(n,u));case 9:case"end":return t.stop()}}),t)})));return function(e,n){return t.apply(this,arguments)}}();"ALTCHA"===this.captchaConfig.type?window.OktaSignInWidgetOnCaptchaLoaded=function(){var n,o;r();var s=e.$el.find("#captcha-container"),l=document.createElement("altcha-widget"),u="".concat(null!==(n=e.options.settings.get("baseUrl"))&&void 0!==n?n:"").concat("/api/v1/altcha"),d=e.captchaConfig.challengeUrlForm;Object.entries({floating:!0,hidefooter:!0,hidelogo:!0,challengeurl:null!==(o=null==d?void 0:d.href)&&void 0!==o?o:u,strings:JSON.stringify({error:(0,c.loc)("altcha.error.label","login"),expired:(0,c.loc)("altcha.expired.label","login"),label:(0,c.loc)("altcha.label.label","login"),loading:(0,c.loc)("altcha.loading.label","login"),reload:(0,c.loc)("altcha.reload.label","login"),verify:(0,c.loc)("altcha.verify.label","login"),verificationRequired:(0,c.loc)("altcha.verificationRequired.label","login"),verified:(0,c.loc)("altcha.verified.label","login"),verifying:(0,c.loc)("altcha.verifying.label","login"),waitAlert:(0,c.loc)("altcha.waitAlert.label","login")})}).forEach((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return l.setAttribute(n,r)})),l.customfetch=a,l.addEventListener&&l.addEventListener("verified",(function(n){var r;r=n&&n.detail&&n.detail.payload||n,t(r),e.options.appState.trigger("altchaSolved"),s.empty()})),window.altcha=l,s.empty().append(l),s.attr("data-captcha-id","altcha"),e.options.appState.trigger("onCaptchaLoaded",l)}:window.OktaSignInWidgetOnCaptchaLoaded=function(){r();var t=e._getCaptchaOject(),o=t.render("captcha-container",{sitekey:e.captchaConfig.siteKey,callback:n});e.$el.find("#captcha-container").attr("data-captcha-id",o),e.options.appState.trigger("onCaptchaLoaded",t),"HCAPTCHA"===e.captchaConfig.type&&e._addHCaptchaFooter()},window.OktaSignInWidgetOnCaptchaSolved=n,"HCAPTCHA"===this.captchaConfig.type?this._loadCaptchaLib(this._getCaptchaUrl("https://hcaptcha.com/1/api.js","hcaptcha")):"RECAPTCHA_V2"===this.captchaConfig.type&&this._loadCaptchaLib(this._getCaptchaUrl("https://www.google.com/recaptcha/api.js","recaptcha")),"ALTCHA"===this.captchaConfig.type&&this._loadCaptchaLib(this._getCaptchaUrl("https://cdn.jsdelivr.net/gh/altcha-org/altcha/dist/altcha.min.js","altcha"))},_loadCaptchaLib:function(e){var t=document.createElement("script");t.src=e,t.async=!0,t.defer=!0,-1!==e.indexOf("altcha")&&(t.type="module",t.onload=window.OktaSignInWidgetOnCaptchaLoaded),document.getElementById(d.default.WIDGET_CONTAINER_ID).appendChild(t)},_addHCaptchaFooter:function(){var e=document.getElementsByClassName(p.WIDGET_FOOTER_CLASS);if(e.length){var t=u.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="captcha-footer"><span class="footer-text">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$2:"<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",$1:"<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",bundle:"login",code:"hcaptcha.footer.label"},data:o,loc:{start:{line:1,column:54},end:{line:1,column:238}}}))+"</span></div>"},useData:!0});e[0].insertAdjacentHTML("beforeend",t())}},_getCaptchaOject:function(){return"HCAPTCHA"===this.captchaConfig.type?window.hcaptcha:"RECAPTCHA_V2"===this.captchaConfig.type?window.grecaptcha:"ALTCHA"===this.captchaConfig.type&&null!==(e=window.altcha)&&void 0!==e?e:null;var e},_getCaptchaUrl:function(e,t){var n=this.options.settings.get("language"),r=this.options.settings.get("".concat(t,".scriptSource")),o=this.options.settings.get("".concat(t,".scriptParams")),i=r||e;if("altcha"===t)return i;var a=m(m({},o),{},{onload:v,render:"explicit",hl:n||navigator.language});return i+"?"+f.default.searchParamsToString(a)}});t.default=y,e.exports=t.default},51662:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(17587),i=n(6475),a=r(n(59247)),s=r(n(51087)),l=n(43318),u=o.BaseView.extend({Header:a.default,Body:s.default,createModelClass:function(e){var t=o.BaseView.prototype.createModelClass.apply(this,arguments),n=e.uiSchema,r=n[0].scopes,a="consent.scopes",s=r.map((function(e){var t=e.name,n=e.displayName,r=e.description,o="".concat(a,".").concat(t),s="".concat(o,".label"),u="".concat(o,".desc"),c=(0,l.doesI18NKeyExist)(s),d=(0,l.doesI18NKeyExist)(u);return{name:t,displayName:c?(0,i.loc)(s,"login"):n,description:d?(0,i.loc)(u,"login"):r,isCustomized:!c}}));return t.extend({props:{scopes:{type:"array",value:s}},local:{consent:{type:"boolean",value:!1}},toJSON:function(){return{consent:this.get("consent")}}})}});t.default=u,e.exports=t.default},59247:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=a.View.extend({className:"consent-title detail-row",titleText:function(){return(0,a.loc)("oie.consent.scopes.admin.title","login")},hasIssuer:!0,template:i.default.template({1:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+c((a=null!=(a=d(n,"clientURI")||(null!=t?d(t,"clientURI"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"clientURI",hash:{},data:i,loc:{start:{line:1,column:26},end:{line:1,column:39}}}):a))+'" class="client-logo-link" title="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:73},end:{line:1,column:84}}}):a))+'" target="_blank">'},3:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo custom-logo" src="'+c((a=null!=(a=d(n,"customLogo")||(null!=t?d(t,"customLogo"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"customLogo",hash:{},data:i,loc:{start:{line:1,column:169},end:{line:1,column:183}}}):a))+'" alt="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:190},end:{line:1,column:201}}}):a))+'" aria-hidden="true" />'},5:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo default-logo" src="'+c((a=null!=(a=d(n,"defaultLogo")||(null!=t?d(t,"defaultLogo"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"defaultLogo",hash:{},data:i,loc:{start:{line:1,column:275},end:{line:1,column:290}}}):a))+'" alt="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:297},end:{line:1,column:308}}}):a))+'" aria-hidden="true" />'},7:function(e,t,n,r,o){return"</a>"},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="issuer no-translate"><span>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"issuer")||(null!=t?a(t,"issuer"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"issuer",hash:{},data:o,loc:{start:{line:1,column:513},end:{line:1,column:523}}}):i)+"</span></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(a=f(n,"if").call(l,null!=t?f(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:0},end:{line:1,column:109}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"customLogo"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.program(5,i,0),data:i,loc:{start:{line:1,column:109},end:{line:1,column:338}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(7,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:338},end:{line:1,column:366}}}))?a:"")+'<h1><span class="title-text"><b class="no-translate">'+d((s=null!=(s=f(n,"appName")||(null!=t?f(t,"appName"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"appName",hash:{},data:i,loc:{start:{line:1,column:419},end:{line:1,column:430}}}):s))+"</b>&nbsp;"+d((s=null!=(s=f(n,"titleText")||(null!=t?f(t,"titleText"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"titleText",hash:{},data:i,loc:{start:{line:1,column:440},end:{line:1,column:453}}}):s))+"</span>"+(null!=(a=f(n,"if").call(l,null!=t?f(t,"issuer"):t,{name:"if",hash:{},fn:e.program(9,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:460},end:{line:1,column:543}}}))?a:"")+"</h1>"},useData:!0}),getTemplateData:function(){var e=this.options.appState,t=e.get("app"),n=t.label,r=t.clientUri,o=t.logo,i=e.get("authentication").issuer,s=null==o?void 0:o.href,l=(0,a.loc)("logo.for.the.app.alt.text","login"),u=a._.escape(n);return{customLogo:s,defaultLogo:"/img/logos/default.png",clientURI:null==r?void 0:r.href,issuer:this.hasIssuer?null==i?void 0:i.uri:null,altText:l,appName:u,titleText:this.titleText()}}});t.default=s,e.exports=t.default},51087:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(17587).BaseForm.extend({noButtonBar:!1,noCancelButton:!1,buttonOrder:["cancel","save"],save:function(){return(0,r.loc)("consent.required.consentButton","login")},cancel:function(){return(0,r.loc)("consent.required.cancelButton","login")},title:!1,events:{'click input[data-type="save"]':function(){this.setConsent(!0)}},setConsent:function(e){this.model.set("consent",e)},cancelForm:function(){this.setConsent(!1),this.options.appState.trigger("saveForm",this.model)}});t.default=o,e.exports=t.default},90959:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.OTPInformationTerminalView=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s={AUTHENTICATION:"idx.return.link.otponly.enter.code.on.sign.in.page",RECOVERY:"idx.return.link.otponly.enter.code.on.password.reset.page",UNLOCK_ACCOUNT:"idx.return.link.otponly.enter.code.on.account.unlock.page",ENROLLMENT:"idx.return.link.otponly.enter.code.on.sign.up.page"},l=function(e,t){var n,r,o,i,l,u,c=t.get("app"),d=t.get("client"),f=s[t.get("idx").context.intent],p=f?(0,a.loc)(f,"login"):(0,a.loc)("idx.enter.otp.in.original.tab","login");return null!=c&&c.label&&(o=(0,a.loc)("idx.return.link.otponly.app","login",[c.label])),d&&(l=(i=(0,a.loc)("idx.return.link.otponly.browser.on.os","login",[d.browser,d.os])).includes("Android")||i.includes("iOS"),u=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e.city||e.country?e.state?(0,a.loc)("geolocation.formatting.all","login",[e.city,e.state,e.country]):(0,a.loc)("geolocation.formatting.partial","login",[e.city,e.country]):null}(d.location)),{showRequestInfo:o||i||u,appName:o,browserOnOsString:i,isMobileDevice:l,geolocation:u,otp:e.get("otp")||(null===(n=t.get("currentAuthenticator"))||void 0===n||null===(r=n.contextualData)||void 0===r?void 0:r.otp),enterCodeOnFlowPage:p}},u=a.View.extend({getTemplateData:function(){return l(this.options.settings,this.options.appState)}}).extend({template:i.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-otp-only--info"><div class="okta-form-label">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"idx.return.link.otponly.request"},data:o,loc:{start:{line:1,column:198},end:{line:1,column:260}}}))+"</div></div>"},3:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-otp-only--info">'+(null!=(i=l(n,"if").call(s,null!=t?l(t,"isMobileDevice"):t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.program(6,o,0),data:o,loc:{start:{line:1,column:346},end:{line:1,column:540}}}))?i:"")+'<div data-se="otp-browser-os">'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"browserOnOsString")||(null!=t?l(t,"browserOnOsString"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"browserOnOsString",hash:{},data:o,loc:{start:{line:1,column:570},end:{line:1,column:591}}}):a)+"</div></div>"},4:function(e,t,n,r,o){return'<i class="enduser-email-otp-only--icon icon--smartphone" aria-hidden="true"></i>'},6:function(e,t,n,r,o){return'<i class="enduser-email-otp-only--icon icon--desktop" aria-hidden="true"></i>'},8:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-otp-only--info"><i class="enduser-email-otp-only--icon icon--app" aria-hidden="true"></i><div data-se="otp-app">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"appName")||(null!=t?a(t,"appName"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"appName",hash:{},data:o,loc:{start:{line:1,column:763},end:{line:1,column:774}}}):i)+"</div></div>"},10:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-otp-only--info"><i class="enduser-email-otp-only--icon icon--location" aria-hidden="true"></i><div data-se="otp-geolocation">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"geolocation")||(null!=t?a(t,"geolocation"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"geolocation",hash:{},data:o,loc:{start:{line:1,column:963},end:{line:1,column:978}}}):i)+"</div></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,i){var a,s,l=null!=t?t:e.nullContext||{},u=e.hooks.helperMissing,c="function",d=e.escapeExpression,f=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="enter-code-on-page">'+d((s=null!=(s=f(n,"enterCodeOnFlowPage")||(null!=t?f(t,"enterCodeOnFlowPage"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"enterCodeOnFlowPage",hash:{},data:i,loc:{start:{line:1,column:30},end:{line:1,column:53}}}):s))+"</p><h1 class='otp-value no-translate'>"+d((s=null!=(s=f(n,"otp")||(null!=t?f(t,"otp"):t))?s:u,(0,o.default)(s)===c?s.call(l,{name:"otp",hash:{},data:i,loc:{start:{line:1,column:92},end:{line:1,column:99}}}):s))+"</h1>"+(null!=(a=f(n,"if").call(l,null!=t?f(t,"showRequestInfo"):t,{name:"if",hash:{},fn:e.program(1,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:104},end:{line:1,column:279}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"browserOnOsString"):t,{name:"if",hash:{},fn:e.program(3,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:279},end:{line:1,column:610}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"appName"):t,{name:"if",hash:{},fn:e.program(8,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:610},end:{line:1,column:793}}}))?a:"")+(null!=(a=f(n,"if").call(l,null!=t?f(t,"geolocation"):t,{name:"if",hash:{},fn:e.program(10,i,0),inverse:e.noop,data:i,loc:{start:{line:1,column:793},end:{line:1,column:997}}}))?a:"")+"<br><p class='otp-warning'>"+d((f(n,"i18n")||t&&f(t,"i18n")||u).call(l,{name:"i18n",hash:{bundle:"login",code:"idx.return.link.otponly.warning.text"},data:i,loc:{start:{line:1,column:1024},end:{line:1,column:1091}}}))+"</p>"},useData:!0})});t.OTPInformationTerminalView=u},32617:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"consent-description detail-row",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"consent.required.description"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:62}}}))+"</p>"},useData:!0})});t.default=i,e.exports=t.default},57353:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(51662)),i=r(n(19098)),a=r(n(36740)),s=r(n(32617)),l=o.default.extend({Header:a.default,Footer:i.default,postRender:function(){var e=this.$el.find(".scope-list"),t=(new s.default).render().el;e.after(t)}});t.default=l,e.exports=t.default},19098:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"consent-footer",template:o.default.template({1:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u=e.escapeExpression,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a class="terms-of-service" href="'+u("function"==typeof(a=null!=(a=c(n,"termsOfService")||(null!=t?c(t,"termsOfService"):t))?a:l)?a.call(s,{name:"termsOfService",hash:{},data:o,loc:{start:{line:1,column:56},end:{line:1,column:74}}}):a)+'" target="_blank">'+u((c(n,"i18n")||t&&c(t,"i18n")||l).call(s,{name:"i18n",hash:{bundle:"login",code:"consent.required.termsOfService"},data:o,loc:{start:{line:1,column:92},end:{line:1,column:154}}}))+"</a>"+(null!=(i=c(n,"if").call(s,null!=t?c(t,"privacyPolicy"):t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:158},end:{line:1,column:226}}}))?i:"")},2:function(e,t,n,r,o){return'<span class="no-translate">&#8226</span>'},4:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a class="privacy-policy" href="'+l("function"==typeof(i=null!=(i=u(n,"privacyPolicy")||(null!=t?u(t,"privacyPolicy"):t))?i:s)?i.call(a,{name:"privacyPolicy",hash:{},data:o,loc:{start:{line:1,column:286},end:{line:1,column:303}}}):i)+'" target="_blank">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"consent.required.privacyPolicy"},data:o,loc:{start:{line:1,column:321},end:{line:1,column:382}}}))+"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"termsOfService"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:233}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"privacyPolicy"):t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:233},end:{line:1,column:393}}}))?i:"")},useData:!0}),getTemplateData:function(){var e=this.options.appState.get("app");return{termsOfService:e.termsOfService&&e.termsOfService.href,privacyPolicy:e.privacyPolicy&&e.privacyPolicy.href}}});t.default=i,e.exports=t.default},36740:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(59247)).default.extend({titleText:function(){return(0,o.loc)("oie.consent.scopes.enduser.title","login")},hasIssuer:!1});t.default=i,e.exports=t.default},68875:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=r(n(51087)),l=r(n(83966)),u=r(n(89597)),c=o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--desktop"></i><div>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"browser")||(null!=t?a(t,"browser"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"browser",hash:{},data:o,loc:{start:{line:1,column:131},end:{line:1,column:142}}}):i)+"</div></div>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--app"></i><div>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"app")||(null!=t?a(t,"app"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"app",hash:{},data:o,loc:{start:{line:1,column:284},end:{line:1,column:291}}}):i)+"</div></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"browser"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:161}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"app"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:161},end:{line:1,column:310}}}))?i:"")},useData:!0}),d=s.default.extend({className:"enduser-email-consent",title:function(){return(0,i.loc)("oie.consent.enduser.title","login")},save:function(){return(0,i.loc)("oie.consent.enduser.accept.label","login")},cancel:function(){return(0,i.loc)("oie.consent.enduser.deny.label","login")},initialize:function(){a.BaseForm.prototype.initialize.apply(this,arguments);var e=c(this.model.pick("browser","app"));this.add(e)},getUISchema:function(){var e=a.BaseForm.prototype.getUISchema.apply(this,arguments);return e.filter((function(e){return"consent"!==e.name}))}}),f=l.default.extend({Header:u.default,buttonOrder:["cancel","save"],postRender:function(){this.$el.find(".o-form-button-bar").find(".button-primary").removeClass("button-primary")},Body:d,createModelClass:function(e){var t=e.requestInfo,n=l.default.prototype.createModelClass.apply(this,arguments),r=t.find((function(e){return"browser"===e.name})),o=t.find((function(e){return"appName"===e.name})),i=Object.assign({browser:{type:"string",value:null==r?void 0:r.value},app:{type:"string",value:null==o?void 0:o.value}},n.prototype.local);return n.extend({local:i,toJSON:function(){return{consent:this.get("consent")}}})}});t.default=f,e.exports=t.default},81205:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(17587),s=n(6475),l=r(n(51087)),u=r(n(59247)),c=r(n(19098)),d=r(n(16002)),f=u.default.extend({hasIssuer:!1,template:i.default.template({1:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+c((a=null!=(a=d(n,"clientURI")||(null!=t?d(t,"clientURI"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"clientURI",hash:{},data:i,loc:{start:{line:1,column:26},end:{line:1,column:39}}}):a))+'" class="client-logo-link" title="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:73},end:{line:1,column:84}}}):a))+'" target="_blank">'},3:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo custom-logo" src="'+c((a=null!=(a=d(n,"customLogo")||(null!=t?d(t,"customLogo"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"customLogo",hash:{},data:i,loc:{start:{line:1,column:169},end:{line:1,column:183}}}):a))+'" alt="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:190},end:{line:1,column:201}}}):a))+'" aria-hidden />'},5:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<img class="client-logo default-logo" src="'+c((a=null!=(a=d(n,"defaultLogo")||(null!=t?d(t,"defaultLogo"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"defaultLogo",hash:{},data:i,loc:{start:{line:1,column:268},end:{line:1,column:283}}}):a))+'" alt="'+c((a=null!=(a=d(n,"altText")||(null!=t?d(t,"altText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"altText",hash:{},data:i,loc:{start:{line:1,column:290},end:{line:1,column:301}}}):a))+'" aria-hidden />'},7:function(e,t,n,r,o){return"</a>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:109}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"customLogo"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.program(5,o,0),data:o,loc:{start:{line:1,column:109},end:{line:1,column:324}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"clientURI"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:324},end:{line:1,column:352}}}))?i:"")+'<h1><span class="title-text">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{$2:"<p>$2</p>",$1:"<b class='no-translate'>$1</b>",arguments:"appName",bundle:"login",code:"oie.consent.scopes.granular.title"},data:o,loc:{start:{line:1,column:381},end:{line:1,column:517}}}))+"</span></h1>"},useData:!0})}),p=l.default.extend({cancel:a.BaseForm.prototype.cancel,getUISchema:function(){var e=a.BaseForm.prototype.getUISchema.apply(this,arguments);return e.forEach((function(e){"checkbox"===e.type&&s._.assign(e,{input:d.default,options:{desc:e.desc,mutable:e.mutable,scopeName:e.name.substring(e.name.indexOf(".")+1)}})})),e}}),h=s.View.extend({className:"consent-description",template:i.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.consent.scopes.granular.description"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:73}}}))+"</p>"},useData:!0})}),m=a.BaseView.extend({Header:f,Body:p,Footer:c.default,postRender:function(){var e=this.$el.find(".o-form-fieldset-container");e.before((new h).render().el),this.$(":disabled").each((function(){e.append((0,s.$)(this).closest(".o-form-fieldset"))}))}});t.default=m,e.exports=t.default},50066:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"custom-app-verify-resend-push",title:function(){return(0,o.loc)("oie.verify.custom_app.title","login",[this.options.appState.getAuthenticatorDisplayName()])},save:function(){return(0,o.loc)("oie.custom_app.push.resend","login")},showMessages:function(){var e={};this.options.appState.containsMessageWithI18nKey("oie.authenticator.custom_app.method.push.verify.enable.biometrics")&&(e.content=null,e.className="okta-verify-uv-callout-content",e.title=(0,o.loc)("oie.authenticator.custom_app.method.push.verify.enable.biometrics.title","login",[this.options.appState.getAuthenticatorDisplayName()]),e.subtitle=(0,o.loc)("oie.authenticator.custom_app.method.push.verify.enable.biometrics.description","login"),e.type="error",e.bullets=[(0,o.loc)("oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1","login"),(0,o.loc)("oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2","login",[this.options.appState.getAuthenticatorDisplayName()]),(0,o.loc)("oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3","login",[this.options.appState.getAuthenticatorDisplayName()])],e=(0,o.createCallout)(e)),i.BaseForm.prototype.showMessages.call(this,e)}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},64840:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"mfa-verify-custom-otp",title:function(){var e=this.options.appState.getAuthenticatorDisplayName()||(0,o.loc)("oie.custom_otp.authenticator.default.vendorName","login");return(0,o.loc)("oie.verify.custom_otp.title","login",[e])},subtitle:function(){return(0,o.loc)("oie.verify.custom_otp.description","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},58930:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(90570)),s=i.BaseForm.extend({title:function(){return(0,o.loc)("password.expired.title.generic","login")},subtitle:function(){return(0,o.loc)("password.expired.custom.subtitle","login")},noSubmitButton:!0,initialize:function(){var e=this.options.currentViewState,t=e.customExpiredPasswordName,n=e.customExpiredPasswordURL;this.add((0,o.createButton)({className:"button button-primary button-wide",title:o._.partial(o.loc,"password.expired.custom.submit","login",[t]),click:function(){a.default.redirect(n)}}))}}),l=i.BaseView.extend({Body:s});t.default=l,e.exports=t.default},2982:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(90570)),s=i.BaseForm.extend({className:"password-authenticator",subtitle:function(){return this.settings.get("brandName")?(0,o.loc)("password.expiring.soon.subtitle.specific","login",[this.settings.get("brandName")]):(0,o.loc)("password.expiring.soon.subtitle.generic","login")},title:function(){var e,t=(null===(e=this.options.appState.get("currentAuthenticator"))||void 0===e?void 0:e.settings).daysToExpiry;return t>0?(0,o.loc)("password.expiring.title","login",[t]):0===t?(0,o.loc)("password.expiring.today","login"):(0,o.loc)("password.expiring.soon","login")},noSubmitButton:!0,initialize:function(){var e=this.options.currentViewState,t=e.customExpiredPasswordName,n=e.customExpiredPasswordURL;this.add((0,o.createButton)({className:"button button-primary button-wide",title:o._.partial(o.loc,"password.expired.custom.submit","login",[t]),click:function(){a.default.redirect(n)}}))}}),l=i.BaseFooter.extend({links:function(){var e=[];return this.options.appState.hasRemediationObject("skip")&&e.push({type:"link",label:(0,o.loc)("password.expiring.later","login"),name:"skip",actionPath:"skip"}),e}}),u=i.BaseView.extend({Body:s,Footer:l});t.default=u,e.exports=t.default},73386:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(11024)),s=i.BaseForm.extend({title:function(){return(0,o.loc)("idx.device_assurance.grace_period.title","login")},save:function(){return(0,o.loc)("idx.device_assurance.grace_period.continue_to_app","login")},showMessages:function(){var e=this.options.appState.get("messages").value,t=this.settings.get("languageTags");e&&this.add((0,o.createCallout)({content:new a.default({messages:e,languageTags:t}),type:"warning"}))}}),l=i.BaseView.extend({initialize:function(){i.BaseView.prototype.initialize.apply(this,arguments),this.Body=s}});t.default=l,e.exports=t.default},59953:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(35546)),s=n(86725),l=r(n(87547)),u=n(66200),c=r(n(76757)),d=n(71101),f=r(n(91002)),p=i.BaseOktaVerifyChallengeView.extend({pollingCancelAction:s.CANCEL_POLLING_ACTION,getDeviceChallengePayload:function(){return this.options.currentViewState.relatesTo.value},doChallenge:function(){(0,u.doChallenge)(this,s.IDENTIFIER_FLOW)},onPollingFail:function(){i.BaseOktaVerifyChallengeView.prototype.onPollingFail.apply(this,arguments);var e={label:(0,o.loc)("loopback.polling.cancel.link.with.form.error","login")};this.options.appState.trigger("updateFooterLink",e)},showCustomFormErrorCallout:function(e,t){var n=e.responseJSON,r={type:"error",className:"okta-verify-uv-callout-content",subtitle:n.errorSummary};if(n.errorSummaryKeys&&n.errorSummaryKeys.some((function(e){return e.includes("auth.factor.signedNonce.error")}))&&(r.title=(0,o.loc)("user.fail.verifyIdentity","login")),n.errorSummaryKeys&&n.errorSummaryKeys.some((function(e){return e.includes("security.access_denied_custom_message")}))){var i=null==t?void 0:t.find((function(e){return"security.access_denied_custom_message"===e.i18n.key}));if(!i)return!1;r={type:"error",content:new f.default({message:n.errorSummary,links:i.links})}}return this.showMessages((0,o.createCallout)(r)),!0}}),h=i.BaseFooter.extend({initialize:function(){var e=this;this.listenTo(this.options.appState,"updateFooterLink",this.handleUpdateFooterLink),this.isFallbackApproach()&&!this.isFallbackDelayed()?i.BaseFooter.prototype.initialize.apply(this,arguments):this.backLink=this.add(l.default,{options:{name:"cancel-authenticator-challenge",label:(0,o.loc)("loopback.polling.cancel.link","login"),clickHandler:function(){(0,u.cancelPollingWithParams)(e.options.appState,s.CANCEL_POLLING_ACTION,s.AUTHENTICATION_CANCEL_REASONS.USER_CANCELED,null)}}}).last()},handleUpdateFooterLink:function(e){this.isFallbackApproach()&&!this.isFallbackDelayed()||(this.backLink&&this.backLink.remove(),this.backLink=this.add(l.default,{options:(0,d.getSignOutLink)(this.options.settings,e)[0]}).last())},isFallbackApproach:function(){return[a.default.CUSTOM_URI_CHALLENGE,a.default.UNIVERSAL_LINK_CHALLENGE,a.default.APP_LINK_CHALLENGE].includes(this.options.currentViewState.relatesTo.value.challengeMethod)},isFallbackDelayed:function(){return this.options.currentViewState.relatesTo.value.challengeMethod===a.default.APP_LINK_CHALLENGE}}),m=i.BaseView.extend({Header:c.default,Body:p,Footer:h});t.default=m,e.exports=t.default},14763:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(17587),i=o.BaseForm.extend({title:function(){return(0,r.loc)("device.code.activate.title","login")},subtitle:function(){return(0,r.loc)("device.code.activate.subtitle","login")},events:{'keyup input[name="userCode"]':function(e){e.preventDefault(),this.addHyphen(e)}},addHyphen:function(e){var t=e.target.value;t&&4===t.length&&!["Backspace","Delete","-"].includes(e.key)&&(e.target.value=t.concat("-"))}}),a=o.BaseView.extend({Body:i});t.default=a,e.exports=t.default},64623:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=n(73204),s=r(n(11098)),l=r(n(35546)),u=r(n(76757)),c=r(n(87547)),d=i.BaseForm.extend({noButtonBar:!0,className:"device-enrollment-terminal"}),f=i.BaseForm.extend({attributes:{"data-se":"android-app-link-setup-options-terminal"},title:function(){return(0,o.loc)("enroll.title.oda.with.account","login")},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments);var e=(0,a.getDeviceEnrollmentContext)(this.options.appState.get("deviceEnrollment"));this.model.set("hasOVAccount","no"),this.addInput({label:function(){return(0,o.loc)("enroll.subtitle.fastpass","login",[e.orgName])},"label-top":!0,options:{no:(0,o.loc)("enroll.option.noaccount.fastpass","login"),yes:(0,o.loc)("enroll.option.account.fastpass","login")},name:"hasOVAccount",type:"radio"})},saveForm:function(){this.$el.find(".o-form-error-container").empty(),this.options.appState.trigger("updateDeviceEnrollmentView","yes"===this.model.get("hasOVAccount"))}}),p=d.extend({attributes:{"data-se":"android-oda-app-link-with-ov-account-terminal"},title:function(){return(0,o.loc)("enroll.title.oda.with.account","login")},initialize:function(){d.prototype.initialize.apply(this,arguments),this.add(a.AndroidAppLinkWithAccountOdaTerminalView)}}),h=d.extend({attributes:{"data-se":"android-oda-app-link-without-ov-account-terminal"},title:function(){return(0,o.loc)("enroll.title.oda.without.account","login")},initialize:function(){d.prototype.initialize.apply(this,arguments),this.add(a.AndroidAppLinkWithoutAccountOdaTerminalView)}}),m=d.extend({attributes:{"data-se":"loopback-terminal"},title:function(){return(0,o.loc)("enroll.title.oda","login")},initialize:function(){d.prototype.initialize.apply(this,arguments),this.add(a.IosAndAndroidLoopbackOdaTerminalView)}}),v=d.extend({attributes:{"data-se":"mdm-terminal"},title:function(){return(0,o.loc)("enroll.title.mdm","login")},initialize:function(){d.prototype.initialize.apply(this,arguments),this.add(s.default)}}),g=c.default.extend({postRender:function(){var e=this;this.$el.click((function(t){t.preventDefault(),e.options.appState.trigger("switchBackToPreselect")}))}}),y=i.BaseView.extend({initialize:function(){i.BaseView.prototype.initialize.apply(this,arguments),this.listenTo(this.options.appState,"updateDeviceEnrollmentView",this.handleUpdateDeviceEnrollmentView),this.listenTo(this.options.appState,"switchBackToPreselect",this.handleSwitchBackToPreselect);var e=(0,a.getDeviceEnrollmentContext)(this.options.appState.get("deviceEnrollment"));switch(this.enrollmentType=(e.enrollmentType||"").toLowerCase(),this.enrollmentType){case l.default.ODA:this.Header=u.default,this.Body=e.isAndroidAppLink?f:m;break;case l.default.MDM:case l.default.WS1:this.Body=v}},handleUpdateDeviceEnrollmentView:function(e){this.Body=e?p:h,this.backLink=this.add(g,{options:{name:"back-to-preselect",label:(0,o.loc)("oform.back","login")}}).last(),this.renderForm()},handleSwitchBackToPreselect:function(){this.Body=f,this.backLink&&this.backLink.remove(),this.render()}});t.default=y,e.exports=t.default},63417:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(6475),i=r.BaseForm.extend({noButtonBar:!0,className:"ion-form device-challenge-poll",title:function(){return(0,o.loc)("deviceTrust.sso.redirectText","login")},initialize:function(){var e,t,n=this;r.BaseForm.prototype.initialize.apply(this,arguments),this.listenTo(this.model,"error",(function(){n.$(".spinner").hide()})),this.add('<div class="spinner"></div>');var o="get"===(null===(e=this.options.currentViewState)||void 0===e||null===(t=e.method)||void 0===t?void 0:t.toLowerCase());this.model.set("useRedirect",o),this.trigger("save",this.model)}}),a=r.BaseView.extend({Body:i});t.default=a,e.exports=t.default},88981:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(7667)),s=r(n(83201)),l=i.BaseForm.extend({title:function(){return(0,o.loc)("primaryauth.title","login")},noButtonBar:!0,initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),this.add(s.default,{selector:".o-form-fieldset-container",bubble:!1,prepend:!0,options:{isRequired:!0}})}}),u=a.default.extend({hasBackToSignInLink:!1}),c=i.BaseView.extend({Body:l,Footer:u});t.default=c,e.exports=t.default},5330:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(79084)),a=n(17587).BaseForm.extend({noButtonBar:!0,postRender:function(){var e=this,t=this.getContextualData(),n=this.add('<iframe frameborder="0" title="\''.concat(this.title(),"'\"></iframe>")).last();try{i.default.init({host:t.host,sig_request:t.signedToken,iframe:n.el,post_action:function(t){e.model.set("credentials.signatureData",t),e.saveForm(e.model)}})}catch(e){n.remove(),this.add((0,o.createCallout)({type:"error",subtitle:(0,o.loc)("oie.duo.iFrameError","login")}),".o-form-error-container")}},getContextualData:function(){}});t.default=a,e.exports=t.default},48167:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(5330)),a=r(n(83966)),s=i.default.extend({title:function(){return(0,o.loc)("oie.duo.verify.title","login")},getContextualData:function(){return this.options.appState.get("currentAuthenticatorEnrollment").contextualData}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},19220:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(5330)),a=r(n(83966)),s=i.default.extend({title:function(){return(0,o.loc)("oie.duo.enroll.title","login")},getContextualData:function(){return this.options.appState.get("currentAuthenticator").contextualData}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},64642:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.getCheckYourEmailEnrollTitle=function(){return s},t.getCheckYourEmailTitle=function(){return a},t.getEnterCodeLink=function(){return l};var o=r(n(2875)),i=n(6475),a=i.View.extend({className:"okta-form-subtitle",attributes:{"data-se":"o-form-explain"},template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"secondaryEmail"):t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.program(4,o,0),data:o,loc:{start:{line:1,column:13},end:{line:1,column:433}}}))?i:""},2:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$2:"<span class='strong no-translate'>$2</span>",$1:"<span class='strong no-translate'>$1</span>",arguments:"email;secondaryEmail",bundle:"login",code:"oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email"},data:o,loc:{start:{line:1,column:35},end:{line:1,column:269}}}))},4:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong no-translate'>$1</span>",arguments:"email",bundle:"login",code:"oie.email.verify.alternate.magicLinkToEmailAddress"},data:o,loc:{start:{line:1,column:277},end:{line:1,column:426}}}))},6:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.email.verify.alternate.magicLinkToYourEmail"},data:o,loc:{start:{line:1,column:441},end:{line:1,column:520}}}))},8:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.email.verify.alternate.instructions"},data:o,loc:{start:{line:1,column:557},end:{line:1,column:628}}}))},10:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.email.verify.alternate.verificationCode.instructions"},data:o,loc:{start:{line:1,column:636},end:{line:1,column:724}}}))},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"email"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(6,o,0),data:o,loc:{start:{line:1,column:0},end:{line:1,column:527}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"useEmailMagicLinkValue"):t,{name:"if",hash:{},fn:e.program(8,o,0),inverse:e.program(10,o,0),data:o,loc:{start:{line:1,column:527},end:{line:1,column:731}}}))?i:"")},useData:!0}),getTemplateData:function(){return this.options}}),s=i.View.extend({className:"okta-form-subtitle",attributes:{"data-se":"o-form-explain"},template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.email.enroll.subtitle"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:56}}}))},useData:!0})}),l=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<button class="button-link enter-auth-code-instead-link" >'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{code:"oie.email.verify.alternate.show.verificationCode.text"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:127}}}))+"</button>"},useData:!0})})},99283:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(22873)),s=r(n(83966)),l=r(n(25590)),u=r(n(68013)),c=r(n(23002)),d=l.default.extend({className:"hide resend-email-view",events:{"click a.resend-link":"handleResendLink"},modelEvents:{error:"handleError"},initialize:function(){this.add((0,o.createCallout)({content:"".concat((0,o.loc)("email.code.not.received","login"),"\n        <a class='resend-link'>").concat((0,o.loc)("email.button.resend","login"),"</a>"),type:"warning"}))},hideResendViewAndShowAfterTimeout:function(){this.$el.hasClass("hide")||this.$el.addClass("hide"),this.showCalloutAfterTimeout()},handleResendLink:function(e){null==e||e.preventDefault(),this.options.appState.trigger("invokeAction",this.options.resendEmailAction),this.hideResendViewAndShowAfterTimeout()},handleError:function(){this.hideResendViewAndShowAfterTimeout()}}),f=u.default.extend(Object.assign({save:function(){return(0,o.loc)("mfa.challenge.verify","login")},initialize:function(){u.default.prototype.initialize.apply(this,arguments),this.startPolling()},postRender:function(){i.BaseForm.prototype.postRender.apply(this,arguments),this.$el.find(".resend-email-view").length||this.add(d,{selector:".o-form-info-container",prepend:!0,options:{resendEmailAction:this.resendEmailAction}})},saveForm:function(){i.BaseForm.prototype.saveForm.apply(this,arguments),this.stopPolling()},remove:function(){i.BaseForm.prototype.remove.apply(this,arguments),this.stopPolling()},triggerAfterError:function(e,t){var n,r;i.BaseForm.prototype.triggerAfterError.apply(this,arguments);var o=!!this.polling;this.stopPolling(),null!==(n=t.responseJSON)&&void 0!==n&&null!==(r=n.errorSummaryKeys)&&void 0!==r&&r.includes("idx.session.expired")||(c.default.isRateLimitError(t)?(o&&setTimeout((function(){e.trigger("clearFormError")}),0),this.startPolling(6e4)):this.startPolling(this.options.appState.get("dynamicRefreshInterval")))}},a.default)),p=s.default.extend({Body:f});t.default=p,e.exports=t.default},10765:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(83966)),s=a.default.prototype.Body,l=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"secondaryEmail"):t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.program(4,o,0),data:o,loc:{start:{line:1,column:70},end:{line:1,column:471}}}))?i:""},2:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$2:"<span class='strong no-translate'>$2</span>",$1:"<span class='strong no-translate'>$1</span>",arguments:"email;secondaryEmail",bundle:"login",code:"oie.email.verify.subtitle.text.with.email.and.secondary.email"},data:o,loc:{start:{line:1,column:92},end:{line:1,column:316}}}))},4:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong no-translate'>$1</span>",arguments:"email",bundle:"login",code:"oie.email.verify.subtitle.text.with.email"},data:o,loc:{start:{line:1,column:324},end:{line:1,column:464}}}))},6:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.email.verify.subtitle.text.without.email"},data:o,loc:{start:{line:1,column:479},end:{line:1,column:555}}}))},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-subtitle" data-se="o-form-explain">'+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"email"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(6,o,0),data:o,loc:{start:{line:1,column:57},end:{line:1,column:562}}}))?i:"")+"</div>"},useData:!0}),getTemplateData:function(){var e,t,n,r;return{email:null===(e=this.options.appState.get("currentAuthenticatorEnrollment"))||void 0===e||null===(t=e.profile)||void 0===t?void 0:t.email,secondaryEmail:null===(n=this.options.appState.get("currentAuthenticatorEnrollment"))||void 0===n||null===(r=n.profile)||void 0===r?void 0:r.secondaryEmail}}}),u=s.extend({title:function(){return(0,i.loc)("oie.email.challenge.mfa.title","login")},save:function(){return(0,i.loc)("oie.email.verify.primaryButton","login")},postRender:function(){s.prototype.postRender.apply(this,arguments),this.add(l,{prepend:!0,selector:".o-form-info-container"})},getUISchema:function(){var e=s.prototype.getUISchema.apply(this,arguments);return e.filter((function(e){return"authenticator.methodType"!==e.name}))}}),c=a.default.extend({Body:u});t.default=c,e.exports=t.default},37437:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(99283)),i=n(64642),a=o.default.prototype.Body,s=a.extend(Object.assign({noButtonBar:!0,resendEmailAction:"currentAuthenticatorEnrollment-resend",events:{"click .enter-auth-code-instead-link":"showAuthCodeEntry"},initialize:function(){var e,t;a.prototype.initialize.apply(this,arguments);var n=(null===(e=this.options.currentViewState.relatesTo)||void 0===e||null===(t=e.value)||void 0===t?void 0:t.profile)||{},r=n.email,o=n.secondaryEmail,s=this.isUseEmailMagicLink();s&&this.add((0,i.getEnterCodeLink)(),{prepend:!0,selector:".o-form-error-container"}),this.add((0,i.getCheckYourEmailTitle)(),{prepend:!0,selector:".o-form-error-container",options:{email:r,secondaryEmail:o,useEmailMagicLinkValue:s}})},postRender:function(){a.prototype.postRender.apply(this,arguments),this.isUseEmailMagicLink()?this.showCodeEntryField(!1):this.noButtonBar=!1},isUseEmailMagicLink:function(){var e,t,n=null===(e=this.options.appState.get("currentAuthenticatorEnrollment"))||void 0===e||null===(t=e.contextualData)||void 0===t?void 0:t.useEmailMagicLink;return void 0===n||n},showAuthCodeEntry:function(){this.noButtonBar=!1,this.render(),this.showCodeEntryField(!0),this.removeEnterAuthCodeInsteadLink()},showCodeEntryField:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.$el.find(".o-form-fieldset-container");t.toggle(e)},removeEnterAuthCodeInsteadLink:function(){this.$el.find(".enter-auth-code-instead-link").remove()}})),l=o.default.extend({Body:s});t.default=l,e.exports=t.default},29118:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(99283)),i=n(64642),a=o.default.prototype.Body,s=a.extend(Object.assign({resendEmailAction:"currentAuthenticator-resend",initialize:function(){var e,t,n;a.prototype.initialize.apply(this,arguments);var r=(null===(e=this.options.appState.get("user"))||void 0===e||null===(t=e.profile)||void 0===t?void 0:t.email)||(null===(n=this.options.appState.get("user"))||void 0===n?void 0:n.identifier)||{},o=this.isUseEmailMagicLink();void 0!==o?(this.noButtonBar=!0,this.events["click .enter-auth-code-instead-link"]="showAuthCodeEntry",o&&this.add((0,i.getEnterCodeLink)(),{prepend:!0,selector:".o-form-error-container"}),this.add((0,i.getCheckYourEmailTitle)(),{prepend:!0,selector:".o-form-error-container",options:{email:r,useEmailMagicLinkValue:o}})):this.add((0,i.getCheckYourEmailEnrollTitle)(),{prepend:!0,selector:".o-form-error-container"})},postRender:function(){a.prototype.postRender.apply(this,arguments),void 0!==this.isUseEmailMagicLink()&&(this.isUseEmailMagicLink()?this.showCodeEntryField(!1):this.noButtonBar=!1)},isUseEmailMagicLink:function(){var e,t;return null===(e=this.options.appState.get("currentAuthenticator"))||void 0===e||null===(t=e.contextualData)||void 0===t?void 0:t.useEmailMagicLink},showAuthCodeEntry:function(){this.noButtonBar=!1,this.render(),this.showCodeEntryField(!0),this.removeEnterAuthCodeInsteadLink()},showCodeEntryField:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.$el.find(".o-form-fieldset-container");t.toggle(e)},removeEnterAuthCodeInsteadLink:function(){this.$el.find(".enter-auth-code-instead-link").remove()}})),l=o.default.extend({Body:s});t.default=l,e.exports=t.default},11024:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475),s=n(43318),l=r(n(30471)),u=n(71244),c=n(64459),d="idx.error.code.access_denied.device_assurance.remediation",f="".concat(d,".additional_help_"),p="".concat(d,".additional_help_custom"),h="".concat(d,".option_index"),m="".concat(d,".title"),v="".concat("idx.device_assurance.grace_period.warning",".title"),g="".concat(d,".explanation_");var y=a.View.extend({className:"end-user-remediation-messages-view",template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="end-user-remediation-title">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"title")||(null!=t?a(t,"title"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"title",hash:{},data:o,loc:{start:{line:1,column:53},end:{line:1,column:62}}}):i)+"</div>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="end-user-remediation-explanation">'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"explanation")||(null!=t?a(t,"explanation"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"explanation",hash:{},data:o,loc:{start:{line:1,column:140},end:{line:1,column:155}}}):i)+"</div>"},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="end-user-remediation-options">'+(null!=(i=a(n,"each").call(null!=t?t:e.nullContext||{},null!=t?a(t,"remediationOptions"):t,{name:"each",hash:{},fn:e.program(6,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:236},end:{line:1,column:605}}}))?i:"")+"</div>"},6:function(e,t,n,r,o){var i,a,s=null!=t?t:e.nullContext||{},l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="'+e.escapeExpression("function"==typeof(a=null!=(a=l(n,"className")||(null!=t?l(t,"className"):t))?a:e.hooks.helperMissing)?a.call(s,{name:"className",hash:{},data:o,loc:{start:{line:1,column:276},end:{line:1,column:289}}}):a)+'">'+(null!=(i=l(n,"if").call(s,null!=t?l(t,"link"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.program(9,o,0),data:o,loc:{start:{line:1,column:291},end:{line:1,column:590}}}))?i:"")+"</div>"},7:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="'+c((a=null!=(a=d(n,"link")||(null!=t?d(t,"link"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"link",hash:{},data:i,loc:{start:{line:1,column:312},end:{line:1,column:320}}}):a))+'" target="_blank" rel="noopener noreferrer">'+c((a=null!=(a=d(n,"message")||(null!=t?d(t,"message"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"message",hash:{},data:i,loc:{start:{line:1,column:364},end:{line:1,column:375}}}):a))+"</a>"},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"deviceRemediationAction"):t,{name:"if",hash:{},fn:e.program(10,o,0),inverse:e.program(12,o,0),data:o,loc:{start:{line:1,column:387},end:{line:1,column:583}}}))?i:""},10:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<button class="enduser-remediation-button-link" id="'+c((a=null!=(a=d(n,"deviceRemediationAction")||(null!=t?d(t,"deviceRemediationAction"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"deviceRemediationAction",hash:{},data:i,loc:{start:{line:1,column:470},end:{line:1,column:497}}}):a))+'" data-se="'+c((a=null!=(a=d(n,"deviceRemediationAction")||(null!=t?d(t,"deviceRemediationAction"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"deviceRemediationAction",hash:{},data:i,loc:{start:{line:1,column:508},end:{line:1,column:535}}}):a))+'">'+c((a=null!=(a=d(n,"message")||(null!=t?d(t,"message"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"message",hash:{},data:i,loc:{start:{line:1,column:537},end:{line:1,column:548}}}):a))+"</button>"},12:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression("function"==typeof(i=null!=(i=a(n,"message")||(null!=t?a(t,"message"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"message",hash:{},data:o,loc:{start:{line:1,column:565},end:{line:1,column:576}}}):i)},14:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",bundle:"login",code:"idx.error.code.access_denied.device_assurance.remediation.additional_help_custom"},data:o,loc:{start:{line:1,column:695},end:{line:1,column:897}}}))},16:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",bundle:"login",code:"idx.error.code.access_denied.device_assurance.remediation.additional_help_default"},data:o,loc:{start:{line:1,column:905},end:{line:1,column:1108}}}))},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"title"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:75}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"explanation"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:75},end:{line:1,column:168}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"remediationOptions"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:168},end:{line:1,column:618}}}))?i:"")+'<div class="end-user-remediation-help-and-contact">'+(null!=(i=s(n,"if").call(a,null!=t?s(t,"useCustomHelpText"):t,{name:"if",hash:{},fn:e.program(14,o,0),inverse:e.program(16,o,0),data:o,loc:{start:{line:1,column:669},end:{line:1,column:1115}}}))?i:"")+"</div>"},useData:!0}),getTemplateData:function(){var e=this,t=this.options.messages,n=[],r=null,o=null,i=!1;return t.forEach((function(t){var a=t.i18n,d=a.key,y=a.params,b=void 0===y?[]:y,w=t.links,_=t.message;if(d===m)r=(0,s.getMessage)(t);else if(d.startsWith(v)){if(b.length>0){var O=b[0],k=new Date(O),x=l.default.formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(k,e.options.languageTags);r=x?(0,u.loc)(d,"login",[x]):_}}else d.startsWith(g)?o=(0,s.getMessage)(t):d.startsWith(f)?(i=d===p,w&&w[0]&&w[0].url&&(e.additionalHelpUrl=w[0].url)):n.push(function(e){var t=null,n=null;return e.links&&e.links[0]&&e.links[0].url?t=e.links[0].url:(0,c.hasDeviceRemediationAction)(e)&&(n=e.deviceRemediation.value.action),{message:(0,s.getMessage)(e),link:t,deviceRemediationAction:n,className:e.i18n.key===h?"end-user-remediation-option":"end-user-remediation-action"}}(t))})),{title:r,explanation:o,remediationOptions:n,useCustomHelpText:i}},render:function(){a.View.prototype.render.apply(this,arguments),this.additionalHelpUrl&&this.$el.find(".additional-help").attr("href",this.additionalHelpUrl)},postRender:function(){var e=this;Array.isArray(this.options.messages)&&this.options.messages.filter((function(e){return(0,c.hasDeviceRemediationAction)(e)})).map((function(e){return e.deviceRemediation.value})).forEach((function(t){e.$el.find("#".concat(t.action)).click((function(e){e.preventDefault(),(0,c.isLoopbackDeviceRemediation)(t)&&(0,c.probeLoopbackAndExecute)(t)}))}))}});t.default=y,e.exports=t.default},60296:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS=void 0;t.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS={"enroll-profile.userProfile.login":"oie.user.profile.login","enroll-profile.userProfile.lastName":"oie.user.profile.lastname","enroll-profile.userProfile.firstName":"oie.user.profile.firstname","enroll-profile.userProfile.email":"oie.user.profile.primary.email","enroll-profile.userProfile.secondEmail":"oie.user.profile.secondary.email","enroll-profile.userProfile.middleName":"oie.user.profile.middleName","enroll-profile.userProfile.honorificPrefix":"oie.user.profile.honorificPrefix","enroll-profile.userProfile.honorificSuffix":"oie.user.profile.honorificSuffix","enroll-profile.userProfile.title":"oie.user.profile.title","enroll-profile.userProfile.displayName":"oie.user.profile.displayName","enroll-profile.userProfile.nickName":"oie.user.profile.nickName","enroll-profile.userProfile.profileUrl":"oie.user.profile.profileUrl","enroll-profile.userProfile.mobilePhone":"oie.user.profile.mobilePhone","enroll-profile.userProfile.primaryPhone":"oie.user.profile.primaryPhone","enroll-profile.userProfile.streetAddress":"oie.user.profile.streetAddress","enroll-profile.userProfile.city":"oie.user.profile.city","enroll-profile.userProfile.state":"oie.user.profile.state","enroll-profile.userProfile.zipCode":"oie.user.profile.zipCode","enroll-profile.userProfile.postalCode":"oie.user.profile.postalCode","enroll-profile.userProfile.countryCode":"oie.user.profile.countryCode","enroll-profile.userProfile.postalAddress":"oie.user.profile.postalAddress","enroll-profile.userProfile.preferredLanguage":"oie.user.profile.preferredLanguage","enroll-profile.userProfile.locale":"oie.user.profile.locale","enroll-profile.userProfile.timezone":"oie.user.profile.timezone","enroll-profile.userProfile.userType":"oie.user.profile.userType","enroll-profile.userProfile.employeeNumber":"oie.user.profile.employeeNumber","enroll-profile.userProfile.costCenter":"oie.user.profile.costCenter","enroll-profile.userProfile.organization":"oie.user.profile.organization","enroll-profile.userProfile.division":"oie.user.profile.division","enroll-profile.userProfile.department":"oie.user.profile.department","enroll-profile.userProfile.managerId":"oie.user.profile.managerId","enroll-profile.userProfile.manager":"oie.user.profile.manager","enroll-profile.credentials.passcode":"oie.password.label"}},7925:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"google-authenticator-challenge",title:function(){return(0,o.loc)("oie.verify.google_authenticator.otp.title","login")},subtitle:function(){return(0,o.loc)("oie.verify.google_authenticator.otp.description","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},12167:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=r(n(83966)),l=r(n(37974)),u=r(n(57298)),c="viewToDisplay",d="barcode",f="manual",p="enterCode",h=a.BaseForm.extend({title:function(){return(0,i.loc)("oie.enroll.google_authenticator.setup.title","login")},noButtonBar:!0,className:"oie-enroll-google-authenticator",enterCodeSubtitle:i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="google-authenticator-setup-info-title enter-code-title">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.enterCode.title"},data:o,loc:{start:{line:1,column:68},end:{line:1,column:146}}}))+"</div>"},useData:!0})}),getUISchema:function(){var e=this,t=a.BaseForm.prototype.getUISchema.apply(this,arguments),n=(0,a.addCustomButton)({className:"google-authenticator-next",title:(0,i.loc)("oform.next","login"),click:function(){e.model.set(c,p)}}),r=(0,a.addCustomButton)({className:"google-authenticator-verify",title:(0,i.loc)("oform.verify","login"),click:function(){e.$el.submit()}});return t[0].showWhen={viewToDisplay:p},t.unshift({View:this.enterCodeSubtitle,selector:".o-form-fieldset-container",showWhen:{viewToDisplay:p}}),t.push({View:l.default,selector:".o-form-fieldset-container",showWhen:{viewToDisplay:d}},{View:u.default,selector:".o-form-fieldset-container",showWhen:{viewToDisplay:f}},{label:!1,className:"shared-secret no-translate",type:"text",placeholder:this.options.appState.get("currentAuthenticator").contextualData.sharedSecret,disabled:!0,showWhen:{viewToDisplay:f}},{View:n,showWhen:{viewToDisplay:function(e){return e===d||e===f}}},{View:r,showWhen:{viewToDisplay:function(e){return e===p}}}),t}}),m=s.default.extend({Body:h,createModelClass:function(){var e=a.BaseView.prototype.createModelClass.apply(this,arguments),t=Object.assign({viewToDisplay:{value:"barcode",type:"string",required:!0,values:[d,f,p]}},e.prototype.local);return e.extend({local:t})}});t.default=m,e.exports=t.default},57298:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"oie-enroll-google-authenticator-manual-setup",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="google-authenticator-setup-info-title manual-setup-title">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.cannotScanBarcode.title"},data:o,loc:{start:{line:1,column:70},end:{line:1,column:156}}}))+'</div><p class="google-authenticator-setup-info">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.manualSetupInstructions"},data:o,loc:{start:{line:1,column:205},end:{line:1,column:291}}}))+"</p>"},useData:!0})});t.default=i,e.exports=t.default},37974:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"oie-enroll-google-authenticator-barcode",template:o.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="google-authenticator-setup-info-title barcode-setup-title">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.scanBarcode.title"},data:o,loc:{start:{line:1,column:83},end:{line:1,column:163}}}))+'</div><div class="qrcode-info-container"><p class="google-authenticator-setup-info">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.scanBarcode.description"},data:o,loc:{start:{line:1,column:247},end:{line:1,column:333}}}))+'</p><div class="qrcode-container"><img class="qrcode" src='+l("function"==typeof(i=null!=(i=u(n,"href")||(null!=t?u(t,"href"):t))?i:s)?i.call(a,{name:"href",hash:{},data:o,loc:{start:{line:1,column:391},end:{line:1,column:399}}}):i)+' alt="qr code"></img><a href="#" class="cannot-scan-link">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.google_authenticator.scanBarcode.cannotScan"},data:o,loc:{start:{line:1,column:457},end:{line:1,column:542}}}))+"</a></div></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"href"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:565}}}))?i:""},useData:!0}),getTemplateData:function(){var e;return{href:null===(e=this.options.appState.get("currentAuthenticator").contextualData.qrcode)||void 0===e?void 0:e.href}},events:{"click .cannot-scan-link":function(e){e.preventDefault(),this.options.model.set("viewToDisplay","manual")}}});t.default=i,e.exports=t.default},82640:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(2976),i=o.BaseIdPAuthenticatorBody.extend({title:function(){var e=this.options.appState.getAuthenticatorDisplayName();return(0,r.loc)("oie.idp.enroll.title","login",[e])},subtitle:function(){var e=this.options.appState.getAuthenticatorDisplayName();return(0,r.loc)("oie.idp.enroll.description","login",[e])},save:function(){return(0,r.loc)("mfa.enroll","login")}}),a=o.BaseIdpAuthenticatorView.extend({Body:i});t.default=a,e.exports=t.default},49065:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(2976),i=o.BaseIdPAuthenticatorBody.extend({title:function(){var e=this.options.appState.getAuthenticatorDisplayName();return(0,r.loc)("oie.idp.challenge.title","login",[e])},subtitle:function(){var e=this.options.appState.getAuthenticatorDisplayName();return(0,r.loc)("oie.idp.challenge.description","login",[e])},save:function(){return(0,r.loc)("mfa.challenge.verify","login")}}),a=o.BaseIdpAuthenticatorView.extend({Body:i});t.default=a,e.exports=t.default},2976:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.BaseIdpAuthenticatorView=t.BaseIdPAuthenticatorBody=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=n(13955),l=r(n(34425)),u=r(n(35546)),c=i.BaseForm.extend({initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),this.model.set("useRedirect",!0),this.add('<div class="okta-waiting-spinner"></div>')}});t.BaseIdPAuthenticatorBody=c;var d=a.default.extend({postRender:function(){a.default.prototype.postRender.apply(this,arguments);var e=this.options.appState.get("messages")||{};if(this.settings.get("features.skipIdpFactorVerificationBtn")&&!Array.isArray(e.value)&&this.model.get("formName")!==s.FORMS.REDIRECT_IDVERIFY){var t=this.options.appState,n=t.get("authenticatorKey"),r=t.get("currentAuthenticator")||t.get("currentAuthenticatorEnrollment");if(l.default.isSafari()&&"external_idp"===n&&null!=r&&r.logoUri){var i=(0,o.$)("#".concat(u.default.WIDGET_CONTAINER_ID));i.addClass("no-beacon"),this.$(".beacon-container").hide()}this.$(".o-form-button-bar").hide(),this.$(".okta-waiting-spinner").show(),this.form.trigger("save",this.model)}else this.$(".okta-waiting-spinner").hide(),this.$(".o-form-button-bar").show()}});t.BaseIdpAuthenticatorView=d},91671:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(2976),s=n(17587),l=n(78747),u=i.View.extend({tagName:"p",className:"privacy-footer",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{$2:"<a class='inline-link' data-se='privacy-policy' target='_blank' rel='noopener noreferrer'>$2</a>",$1:"<a class='inline-link' data-se='terms-of-use' target='_blank' rel='noopener noreferrer'>$1</a>",arguments:"idpName",bundle:"login",code:"oie.idv.idp.desc.termsOfUse"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:283}}}))+"</p><p>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{arguments:"idpName",bundle:"login",code:"oie.idv.idp.desc.agreement"},data:o,loc:{start:{line:1,column:290},end:{line:1,column:367}}}))+"</p>"},useData:!0}),getTemplateData:function(){return{idpName:(0,l.getIdvName)(this.options.appState.get("remediations"))}}}),c=a.BaseIdPAuthenticatorBody.extend({title:function(){return(0,i.loc)("oie.idv.idp.title","login",[(0,l.getIdvName)(this.options.appState.get("remediations"))])},subtitle:function(){return(0,i.loc)("oie.idv.idp.desc","login",[(0,l.getIdvName)(this.options.appState.get("remediations"))])},save:function(){return(0,i.loc)("oie.optional.authenticator.button.title","login")}}),d=a.BaseIdpAuthenticatorView.extend({Body:c,Footer:s.BaseFooter.extend({postRender:function(){this.add(u);var e=(0,l.getHelpLinks)(this.options.appState.get("remediations")),t=e.termsOfUse,n=e.privacyPolicy;this.$el.find('[data-se="terms-of-use"]').attr("href",t),this.$el.find('[data-se="privacy-policy"]').attr("href",n)}})});t.default=d,e.exports=t.default},1850:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(17587),i=o.BaseForm.extend({noSubmitButton:!0,title:function(){return(0,r.loc)("oie.kmsi.title","login")},subtitle:function(){return(0,r.loc)("oie.kmsi.subtitle","login")},saveForm:function(e){this.model.set("keepMeSignedIn",e),this.options.appState.trigger("saveForm",this.model)},getUISchema:function(){var e=this;return[{View:(0,r.createButton)({className:"button button-secondary",title:(0,r.loc)("oie.kmsi.accept","login"),attributes:{"data-se":"stay-signed-in-btn"},click:function(){e.saveForm(!0)}})},{View:(0,r.createButton)({className:"button button-secondary",title:(0,r.loc)("oie.kmsi.reject","login"),attributes:{"data-se":"do-not-stay-signed-in-btn"},click:function(){e.saveForm(!1)}})}]}}),a=o.BaseView.extend({Body:i});t.default=a,e.exports=t.default},58734:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend({className:"on-prem-authenticator-verify",modelEvents:{error:"_checkTokenChange"},title:function(){var e=this.options.appState.getAuthenticatorDisplayName()||(0,o.loc)("oie.on_prem.authenticator.default.vendorName","login");return(0,o.loc)("oie.on_prem.verify.title","login",[e])},_checkTokenChange:function(e,t){var n,r=null==t||null===(n=t.responseJSON)||void 0===n?void 0:n.errorSummaryKeys;r&&r.includes("errors.E0000113")&&(this.model.set("credentials.passcode",""),this.render())},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},79091:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend({className:"on-prem-authenticator-enroll",modelEvents:{error:"_checkTokenChange"},title:function(){var e=this.options.appState.getAuthenticatorDisplayName()||(0,o.loc)("oie.on_prem.authenticator.default.vendorName","login");return(0,o.loc)("oie.on_prem.enroll.title","login",[e])},_checkTokenChange:function(e,t){var n,r=null==t||null===(n=t.responseJSON)||void 0===n?void 0:n.errorSummaryKeys;r&&r.includes("errors.E0000113")&&(this.model.set("credentials.passcode",""),this.render())},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},32290:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(17587),i=n(66200),a=n(86725),s=o.BaseOktaVerifyChallengeView.extend({getDeviceChallengePayload:function(){return this.options.currentViewState.relatesTo.value.contextualData.challenge.value},showMessages:function(e){if(e instanceof r.View)o.BaseOktaVerifyChallengeView.prototype.showMessages.call(this,e);else{if(this.options.appState.containsMessageWithI18nKey([a.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE,a.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP,a.OV_UV_ENABLE_BIOMETRICS_FASTPASS_WINDOWS])){var t=this.options.appState.get("messages"),n=(0,i.getBiometricsErrorOptions)(t,!0);r._.isEmpty(n)||(e=(0,r.createCallout)(n))}o.BaseOktaVerifyChallengeView.prototype.showMessages.call(this,e)}},showCustomFormErrorCallout:function(e){var t=(0,i.getBiometricsErrorOptions)(e,!1);return!r._.isEmpty(t)&&(this.showMessages((0,r.createCallout)(t)),!0)}});t.default=s,e.exports=t.default},99214:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"okta-verify-resend-push",title:function(){return(0,o.loc)("oie.okta_verify.push.title","login")},save:function(){return(0,o.loc)("oie.okta_verify.push.resend","login")},showMessages:function(){var e={};this.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.force.upgrade.number_challenge")?e.title=(0,o.loc)("oie.numberchallenge.force.upgrade.title","login"):this.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.verify.enable.biometrics")&&(e.content=null,e.className="okta-verify-uv-callout-content",e.title=(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.title","login"),e.subtitle=(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.description","login"),e.type="error",e.bullets=[(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point1","login"),(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point2","login"),(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point3","login")],e=(0,o.createCallout)(e)),i.BaseForm.prototype.showMessages.call(this,e)}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},36529:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(83966)),i=n(17587),a=n(6475),s=n(66200),l=n(86725),u=i.BaseForm.extend({noButtonBar:!0,className:"ion-form device-challenge-poll",title:function(){return(0,a.loc)("deviceTrust.sso.redirectText","login")},initialize:function(){var e,t,n=this;i.BaseForm.prototype.initialize.apply(this,arguments),this.listenTo(this.model,"error",(function(){n.$(".spinner").hide()})),this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');var r="get"===(null===(e=this.options.currentViewState)||void 0===e||null===(t=e.method)||void 0===t?void 0:t.toLowerCase());this.model.set("useRedirect",r),this.trigger("save",this.model)},showMessages:function(e){if(e instanceof a.View)i.BaseForm.prototype.showMessages.call(this,e);else{if(this.options.appState.containsMessageWithI18nKey([l.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE,l.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP])){var t=this.options.appState.get("messages"),n=(0,s.getBiometricsErrorOptions)(t,!0);a._.isEmpty(n)||(e=(0,a.createCallout)(n))}i.BaseForm.prototype.showMessages.call(this,e)}},showCustomFormErrorCallout:function(e){var t=(0,s.getBiometricsErrorOptions)(e,!1);return!a._.isEmpty(t)&&(this.showMessages((0,a.createCallout)(t)),!0)}}),c=o.default.extend({Body:u});t.default=c,e.exports=t.default},90088:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"okta-verify-totp-challenge",title:function(){return(0,o.loc)("oie.okta_verify.totp.title","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")},showCustomFormErrorCallout:function(e){var t,n,r=null==e||null===(t=e.responseJSON)||void 0===t?void 0:t.errorSummaryKeys;if(r&&r.includes("oie.authenticator.oktaverify.method.totp.verify.enable.biometrics"))return n={type:"error",className:"okta-verify-uv-callout-content",title:(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.title","login"),subtitle:(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.description","login"),bullets:[(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point1","login"),(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point2","login"),(0,o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point3","login")]},this.showMessages((0,o.createCallout)(n)),!0}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},1705:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(83966)),i=n(70621),a=r(n(32290)),s=r(n(58474)),l=n(13955),u=o.default.extend({initialize:function(){var e,t,n;o.default.prototype.initialize.apply(this,arguments);var r=null===(e=this.options)||void 0===e||null===(t=e.appState)||void 0===t?void 0:t.get("currentAuthenticator"),u=null==r?void 0:r.methods[0];(null==u?void 0:u.type)===l.AUTHENTICATOR_METHODS.PUSH&&null!=r&&null!==(n=r.contextualData)&&void 0!==n&&n.correctAnswer?this.Body=s.default:(null==u?void 0:u.type)===l.AUTHENTICATOR_METHODS.PUSH?this.Body=i.Body:this.Body=a.default}});t.default=u,e.exports=t.default},67436:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(2875)),a=n(6475),s=n(13955),l=n(66200);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var d=a.internal.views.components.Notification,f=a.internal.util.Clipboard,p=a.View.extend({initialize:function(){var e=h(this.options.appState);if(e&&e.setupOVUrl&&e.isDesktop){this.ulDom&&this.ulDom.remove();var t=(0,l.createInvisibleIFrame)("custom-uri-container",e.setupOVUrl);this.ulDom=this.add(t).last()}},template:i.default.template({1:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ol class="qrcode-info ov-info"><li>'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.qrcode.step1.updated"},data:o,loc:{start:{line:1,column:48},end:{line:1,column:122}}}))+"</li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.qrcode.step2"},data:o,loc:{start:{line:1,column:131},end:{line:1,column:197}}}))+"</li><li>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",bundle:"login",code:"oie.enroll.okta_verify.qrcode.step3.updated"},data:o,loc:{start:{line:1,column:206},end:{line:1,column:316}}}))+'</li></ol><div class="qrcode-container"><img class="qrcode" src='+l("function"==typeof(i=null!=(i=u(n,"href")||(null!=t?u(t,"href"):t))?i:s)?i.call(a,{name:"href",hash:{},data:o,loc:{start:{line:1,column:380},end:{line:1,column:388}}}):i)+' alt="'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"mfa.altQrCode"},data:o,loc:{start:{line:1,column:394},end:{line:1,column:439}}}))+'"></img></div>'},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ul class="email-info ov-info"><li>'+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",arguments:"email",bundle:"login",code:"oie.enroll.okta_verify.email.info.updated"},data:o,loc:{start:{line:1,column:508},end:{line:1,column:636}}}))?i:"")+'</li><li class="switch-channel-content"></li></ul>'},5:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ul class="sms-info ov-info"><li>'+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",arguments:"phoneNumber",bundle:"login",code:"oie.enroll.okta_verify.sms.info.updated"},data:o,loc:{start:{line:1,column:745},end:{line:1,column:877}}}))?i:"")+'</li><li class="switch-channel-content"></li></ul>'},7:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="sameDevice-setup'+(null!=(i=l(n,"if").call(a,null!=t?l(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"if",hash:{},fn:e.program(8,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:990},end:{line:1,column:1056}}}))?i:"")+'"><p class="explanation" data-se="subheader">'+(null!=(i=l(n,"if").call(a,null!=(i=null!=t?l(t,"deviceMap"):t)?l(i,"isDesktop"):i,{name:"if",hash:{},fn:e.program(10,o,0),inverse:e.program(17,o,0),data:o,loc:{start:{line:1,column:1101},end:{line:1,column:1874}}}))?i:"")+'</p><ol class="ov-info">'+(null!=(i=l(n,"unless").call(a,null!=t?l(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"unless",hash:{},fn:e.program(19,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1898},end:{line:1,column:2312}}}))?i:"")+'<li><a href="'+s(e.lambda(null!=(i=null!=t?l(t,"deviceMap"):t)?l(i,"setupOVUrl"):i,t))+'" class="button button-primary setup-button">'+s((l(n,"i18n")||t&&l(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.title"},data:o,loc:{start:{line:1,column:2394},end:{line:1,column:2459}}}))+"</a></li>"+(null!=(i=l(n,"if").call(a,null!=t?l(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"if",hash:{},fn:e.program(22,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:2468},end:{line:1,column:2786}}}))?i:"")+(null!=(i=l(n,"if").call(a,null!=t?l(t,"showAnotherDeviceLink"):t,{name:"if",hash:{},fn:e.program(24,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:2786},end:{line:1,column:3125}}}))?i:"")+"</ol></div>"},8:function(e,t,n,r,o){return" ov-enrollment-enabled"},10:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="desktop-instructions ov-info">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.prompt"},data:o,loc:{start:{line:1,column:1170},end:{line:1,column:1287}}}))+'</div><div class="desktop-instructions">'+(null!=(i=s(n,"if").call(a,null!=t?s(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"if",hash:{},fn:e.program(11,o,0),inverse:e.program(13,o,0),data:o,loc:{start:{line:1,column:1327},end:{line:1,column:1583}}}))?i:"")+"</div>"+(null!=(i=s(n,"unless").call(a,null!=t?s(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"unless",hash:{},fn:e.program(15,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1589},end:{line:1,column:1765}}}))?i:"")},11:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span>$1</span>",bundle:"login",code:"customUri.required.content.prompt"},data:o,loc:{start:{line:1,column:1364},end:{line:1,column:1449}}}))},13:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.noPrompt"},data:o,loc:{start:{line:1,column:1457},end:{line:1,column:1576}}}))},15:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="desktop-instructions">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.makeSureHaveOV"},data:o,loc:{start:{line:1,column:1664},end:{line:1,column:1748}}}))+"</div>"},17:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue"},data:o,loc:{start:{line:1,column:1773},end:{line:1,column:1867}}}))},19:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=(i=null!=t?s(t,"deviceMap"):t)?s(i,"platformLC"):i,{name:"if",hash:{},fn:e.program(20,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:1939},end:{line:1,column:2176}}}))?i:"")+"<li>"+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.setup"},data:o,loc:{start:{line:1,column:2180},end:{line:1,column:2296}}}))+"</li>"},20:function(e,t,n,r,o){var i,a=e.escapeExpression,s=e.lambda,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li><a aria-label='"+a((l(n,"i18n")||t&&l(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.download.linkText"},data:o,loc:{start:{line:1,column:1986},end:{line:1,column:2061}}}))+"' href=\""+a(s(null!=(i=null!=t?l(t,"deviceMap"):t)?l(i,"downloadHref"):i,t))+'" class="app-store-logo '+a(s(null!=(i=null!=t?l(t,"deviceMap"):t)?l(i,"platformLC"):i,t))+'-app-store-logo"></a></li>'},22:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li><span>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.download.title"},data:o,loc:{start:{line:1,column:2515},end:{line:1,column:2587}}}))+'</span>&nbsp;<a href="'+l(e.lambda(null!=(i=null!=t?u(t,"deviceMap"):t)?u(i,"downloadHref"):i,t))+'" target="_blank" id="download-ov" class="download-ov-link">'+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"customUri.required.content.download.linkText"},data:o,loc:{start:{line:1,column:2695},end:{line:1,column:2770}}}))+"</a></li>"},24:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li>"+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=(i=null!=t?a(t,"deviceMap"):t)?a(i,"isDesktop"):i,{name:"if",hash:{},fn:e.program(25,o,0),inverse:e.program(27,o,0),data:o,loc:{start:{line:1,column:2819},end:{line:1,column:3113}}}))?i:"")+"</li>"},25:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a class='orOnMobileLink' href='#'>$1</a>",bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.orOnMobile"},data:o,loc:{start:{line:1,column:2846},end:{line:1,column:2973}}}))},27:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a class='orOnMobileLink' href='#'>$1</a>",bundle:"login",code:"oie.enroll.okta_verify.setup.customUri.orMobile"},data:o,loc:{start:{line:1,column:2981},end:{line:1,column:3106}}}))},29:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"sameDevice"):t,{name:"if",hash:{},fn:e.program(30,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:3144},end:{line:1,column:4021}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"deviceBootstrap"):t,{name:"if",hash:{},fn:e.program(32,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:4021},end:{line:1,column:4802}}}))?i:"")},30:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lambda,c=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="explanation" data-se="subheader">'+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.subtitle "},data:o,loc:{start:{line:1,column:3205},end:{line:1,column:3274}}}))+'</p><ol class="sameDevice-info ov-info"><li>'+(null!=(i=(c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{arguments:"sameDevice.downloadHref",bundle:"login",code:"enroll.oda.without.account.step1"},data:o,loc:{start:{line:1,column:3318},end:{line:1,column:3419}}}))?i:"")+"</li><li>"+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.openOv"},data:o,loc:{start:{line:1,column:3428},end:{line:1,column:3494}}}))+"</li><li>"+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.signInUrl"},data:o,loc:{start:{line:1,column:3503},end:{line:1,column:3572}}}))+"<br><br/><span class='semi-strong no-translate'>"+l(u(null!=(i=null!=t?c(t,"sameDevice"):t)?c(i,"orgUrl"):i,t))+'</span><a data-clipboard-text="'+l(u(null!=(i=null!=t?c(t,"sameDevice"):t)?c(i,"orgUrl"):i,t))+'" class="button link-button copy-org-clipboard-button">'+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"enroll.oda.org.copyLink"},data:o,loc:{start:{line:1,column:3748},end:{line:1,column:3802}}}))+"</a></li><li>"+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.followInstruction"},data:o,loc:{start:{line:1,column:3815},end:{line:1,column:3901}}}))+'</li></ol><p class="closing">'+l((c(n,"i18n")||t&&c(t,"i18n")||s).call(a,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.canBeClosed"},data:o,loc:{start:{line:1,column:3930},end:{line:1,column:4010}}}))+"</p>"},32:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="explanation" data-se="subheader">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.subtitle"},data:o,loc:{start:{line:1,column:4087},end:{line:1,column:4164}}}))+'</p><ol class="deviceBootstrap-info ov-info"><li>'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",arguments:"enrolledDeviceName",bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs"},data:o,loc:{start:{line:1,column:4213},end:{line:1,column:4367}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.selectAccount"},data:o,loc:{start:{line:1,column:4376},end:{line:1,column:4458}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{$1:"<span class='semi-strong'>$1</span>",bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.addAccount"},data:o,loc:{start:{line:1,column:4467},end:{line:1,column:4587}}}))+"</li><li>"+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.followInstruction"},data:o,loc:{start:{line:1,column:4596},end:{line:1,column:4682}}}))+'</li></ol><p class="closing">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.setup.skipAuth.canBeClosed"},data:o,loc:{start:{line:1,column:4711},end:{line:1,column:4791}}}))+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"href"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:460}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"email"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:460},end:{line:1,column:693}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"phoneNumber"):t,{name:"if",hash:{},fn:e.program(5,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:693},end:{line:1,column:934}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=(i=null!=t?s(t,"deviceMap"):t)?s(i,"setupOVUrl"):i,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.program(29,o,0),data:o,loc:{start:{line:1,column:934},end:{line:1,column:4809}}}))?i:"")},useData:!0}),getTemplateData:function(){var e,t=this.options.appState.get("currentAuthenticator").contextualData,n="",r=h(this.options.appState),o=!1;if(t&&null!=t&&t.devicebootstrap&&null!=t&&t.devicebootstrap.enrolledDevices){var i=null==t?void 0:t.devicebootstrap.enrolledDevices;n=Array.isArray(i)&&!a._.isEmpty(i)?i[0]:i}r.securityLevel&&"ANY"===r.securityLevel&&(o=!0);var s=this.options.settings.get("features.sameDeviceOVEnrollmentEnabled");return{href:null===(e=t.qrcode)||void 0===e?void 0:e.href,email:a._.escape(null==t?void 0:t.email),phoneNumber:a._.escape(null==t?void 0:t.phoneNumber),sameDevice:null==t?void 0:t.samedevice,deviceBootstrap:null==t?void 0:t.devicebootstrap,enrolledDeviceName:n,deviceMap:r,showAnotherDeviceLink:o,sameDeviceOVEnrollmentEnabled:s}},postRender:function(){var e=this,t=this.options&&this.options.appState,n=this.model;this.$(".orOnMobileLink").click((function(){var e;if(t&&n){var r="qrcode",o=t.get("remediations").find((function(e){return e.name===s.FORMS.SELECT_ENROLLMENT_CHANNEL}));if(o){var i=a._.find(o.uiSchema,(function(e){return"authenticator.id"===e.name}));if(i){var l=a._.find(o.uiSchema,(function(e){return"authenticator.channel"===e.name}));l&&(l.options=a._.filter(null==l?void 0:l.options,(function(e){return e.value===r})),l.value=(null===(e=l.options[0])||void 0===e?void 0:e.value)||r,l.sublabel=null,n.set("authenticator.channel",l.value),n.set("authenticator.id",i.value),n.set("formName",o.name),t.trigger("saveForm",n))}}}})),f.attach(".copy-org-clipboard-button").done((function(){var t=new d({message:(0,a.loc)("enroll.oda.org.copyLink.success","login"),level:"success"});return e.el.prepend(t.render().el),!1}))}});function h(e){var t,n;if(!e)return null;var r=e.get("currentAuthenticator").contextualData,o={};return null!==(t=r.samedevice)&&void 0!==t&&t.setupOVUrl?o=c({},r.samedevice):null!==(n=r.devicebootstrap)&&void 0!==n&&n.setupOVUrl&&(o=c({},r.devicebootstrap)),o.platform&&(o.platformLC=o.platform.toLowerCase(),o.isDesktop=!("ios"===o.platformLC||"android"===o.platformLC)),o}t.default=p,e.exports=t.default},41553:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(52574)),l=r(n(19654)),u=r(n(99519)),c=r(n(67436)),d=!0,f=i.BaseFormWithPolling.extend(Object.assign({title:function(){var e;switch(this.options.appState.get("currentAuthenticator").contextualData.selectedChannel){case"email":e=(0,o.loc)("oie.enroll.okta_verify.setup.email.title","login");break;case"sms":e=(0,o.loc)("oie.enroll.okta_verify.setup.sms.title","login");break;default:e=(0,o.loc)("oie.enroll.okta_verify.setup.title","login")}return e},className:"oie-enroll-ov-poll",noButtonBar:!0,initialize:function(){i.BaseFormWithPolling.prototype.initialize.apply(this,arguments),this.listenTo(this.model,"error",this.stopPolling),d&&this.startPolling()},showMessages:function(){var e={};this.options.appState.containsMessageWithI18nKey("oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible")||this.options.appState.containsMessageWithI18nKey("oie.authenticator.app.non_fips_compliant_enrollment_app_update_required")?e.title=(0,o.loc)("oie.okta_verify.enroll.force.upgrade.title","login"):this.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.enroll.enable.biometrics")&&(e.title=(0,o.loc)("oie.authenticator.app.method.push.enroll.enable.biometrics.title","login")),i.BaseFormWithPolling.prototype.showMessages.call(this,e)},getUISchema:function(){var e,t=[],n=this.options.appState.get("currentAuthenticator").contextualData.selectedChannel;return"qrcode"===n?(e=".qrcode-container",d=!0):["email","sms"].includes(n)?(e=".switch-channel-content",d=!0):["samedevice"].includes(n)?d=!0:["devicebootstrap"].includes(n)&&(d=!1),t.push({View:c.default}),t.push({View:u.default,options:{selectedChannel:n},selector:e}),["email","sms"].includes(n)&&t.push({View:l.default,selector:".o-form-error-container"}),t},remove:function(){i.BaseFormWithPolling.prototype.remove.apply(this,arguments),this.stopPolling()}},s.default)),p=a.default.extend({Body:f});t.default=p,e.exports=t.default},88930:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(73390)),l=r(n(99519)),u=i.BaseForm.extend({className:"oie-enroll-ov-data",title:function(){return"email"===this.options.appState.get("currentAuthenticator").contextualData.selectedChannel?(0,o.loc)("oie.enroll.okta_verify.enroll.channel.email.title","login"):(0,o.loc)("oie.enroll.okta_verify.enroll.channel.sms.title","login")},save:function(){return(0,o.loc)("oie.enroll.okta_verify.setupLink","login")},getUISchema:function(){var e=i.BaseForm.prototype.getUISchema.apply(this,arguments),t=o._.find(e,(function(e){return"phoneNumber"===e.name})),n=o._.findIndex(e,(function(e){return"phoneNumber"===e.name})),r={"label-top":!0,label:(0,o.loc)("mfa.country","login"),type:"select",options:s.default.getCountries(),name:"country",wide:!0},a={label:(0,o.loc)("mfa.phoneNumber.placeholder","login"),type:"group",modelType:"string","label-top":!0,name:"phoneCode",input:[{type:"label",label:"+".concat(this.model.get("phoneCode")),className:"country-code-label no-translate"},Object.assign({},t)]};-1!==n&&e.splice(n,1,r,a);var l={View:"email"===this.options.appState.get("currentAuthenticator").contextualData.selectedChannel?(0,o.loc)("oie.enroll.okta_verify.enroll.channel.email.subtitle","login"):(0,o.loc)("oie.enroll.okta_verify.channel.sms.description.updated","login"),selector:".o-form-fieldset-container"};return e.push(l),e},handlePhoneCodeChange:function(){this.el.querySelector(".country-code-label").innerText="+".concat(this.model.get("phoneCode"))},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),"sms"===this.options.appState.get("currentAuthenticator").contextualData.selectedChannel&&this.listenTo(this.model,"change:phoneCode",this.handlePhoneCodeChange.bind(this))}}),c=a.default.extend({Body:u,createModelClass:function(){var e=i.BaseView.prototype.createModelClass.apply(this,arguments);if("sms"!==this.options.appState.get("currentAuthenticator").contextualData.selectedChannel)return e;var t=Object.assign({country:{value:this.settings.get("defaultCountryCode"),type:"string"}},e.prototype.local),n=Object.assign({phoneCode:{deps:["country"],fn:function(e){return s.default.getCallingCodeForCountry(e)}}},e.prototype.derived);return e.extend({local:t,derived:n,toJSON:function(){var e=o.Model.prototype.toJSON.call(this,arguments),t=this.get("phoneCode"),n="+".concat(t).concat(e.phoneNumber);return e.phoneNumber=n,e}})},postRender:function(){this.add(l.default,"form")}});t.default=c,e.exports=t.default},17042:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475).View.extend({className:"number-challenge-section",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.hooks.helperMissing,l=e.escapeExpression,u=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+l((u(n,"i18n")||t&&u(t,"i18n")||s).call(a,{name:"i18n",hash:{$1:"<span class='strong'>$1</span>",arguments:"correctAnswer",bundle:"login",code:"oie.numberchallenge.instruction"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:127}}}))+'</p><div class="phone no-translate"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">'+l("function"==typeof(i=null!=(i=u(n,"correctAnswer")||(null!=t?u(t,"correctAnswer"):t))?i:s)?i.call(a,{name:"correctAnswer",hash:{},data:o,loc:{start:{line:1,column:270},end:{line:1,column:287}}}):i)+'</span></div><div class="phone--home-button"></div></div></div>'},useData:!0}),getTemplateData:function(){var e,t;return{correctAnswer:null===(e=this.options.appState.get("currentAuthenticator"))||void 0===e||null===(t=e.contextualData)||void 0===t?void 0:t.correctAnswer}}});t.default=i,e.exports=t.default},58474:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(52574)),s=r(n(32339)),l=r(n(17042)),u=i.BaseFormWithPolling.extend(Object.assign({noButtonBar:!0,className:"okta-verify-number-challenge",events:{"click a.resend-number-challenge":"handleResendNumberChallenge"},handleResendNumberChallenge:function(){this.options.appState.trigger("invokeAction","currentAuthenticator-resend"),this.options.appState.trigger("hideNumberChallengeWarning")},title:function(){return(0,o.loc)("oie.okta_verify.push.sent","login")},initialize:function(){i.BaseFormWithPolling.prototype.initialize.apply(this,arguments),this.add(l.default)},triggerAfterError:function(){i.BaseFormWithPolling.prototype.triggerAfterError.apply(this,arguments),this.stopPolling(),this.$el.find(".o-form-fieldset-container").empty()},postRender:function(){i.BaseFormWithPolling.prototype.postRender.apply(this,arguments),this.startPoll()},startPoll:function(){this.startPolling(),this.addWarning()},stopPoll:function(){this.stopPolling()},addWarning:function(){this.add(s.default,".o-form-error-container"),this.options.appState.trigger("showNumberChallengeWarning")},remove:function(){i.BaseFormWithPolling.prototype.remove.apply(this,arguments),this.stopPolling()}},a.default)),c=u;t.default=c,e.exports=t.default},19654:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(25590)).default.extend({className:"hide resend-ov-link-view",events:{"click a.resend-link":"handelResendLink"},initialize:function(){var e=this.options.appState.get("currentAuthenticator").contextualData.selectedChannel;this.add((0,i.createCallout)({content:"email"===e?o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.email.notReceived"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:73}}}))?i:""},useData:!0}):o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.sms.notReceived"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:71}}}))?i:""},useData:!0}),type:"warning"}))},handelResendLink:function(e){null==e||e.preventDefault(),this.options.appState.trigger("invokeAction","currentAuthenticator-resend"),this.$el.addClass("hide"),this.showCalloutAfterTimeout()}});t.default=a,e.exports=t.default},32339:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(86725),s=i.View.extend({initialize:function(){var e=this;this.listenTo(this.options.appState,"showNumberChallengeWarning",(function(){e.startWarningTimeout()})),this.listenTo(this.options.appState,"hideNumberChallengeWarning",(function(){e.clearWarning()}))},className:"resend-number-challenge-warning hide",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-form-infobox-warning infobox infobox-warning"><span class="icon warning-16"></span><p>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a href='#' class='resend-number-challenge'>$1</a>",bundle:"login",code:"oie.numberchallenge.warning"},data:o,loc:{start:{line:1,column:103},end:{line:1,column:217}}}))+"</p></div>"},useData:!0}),showWarning:function(){this.$el.removeClass("hide")},clearWarning:function(){this.$el.addClass("hide"),clearTimeout(this.warningTimeout),this.startWarningTimeout()},startWarningTimeout:function(){this.warningTimeout=setTimeout(i._.bind((function(){this.showWarning()}),this),a.WARNING_TIMEOUT)}});t.default=s,e.exports=t.default},50509:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(13955),s=i.View.extend({className:"ov-same-device-enroll-text",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{$1:"<a class='ov-same-device-enroll-link' href='#'>$1</a>",bundle:"login",code:"oie.enroll.okta_verify.select.channel.ovOnThisDevice"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:144}}}))?i:""},useData:!0}),postRender:function(){var e=this.options&&this.options.appState,t=this.model;this.$(".ov-same-device-enroll-link").click((function(){var n,r,o,i;if(e&&t){var s="samedevice",l=e.get("remediations").find((function(e){return e.name===a.FORMS.SELECT_ENROLLMENT_CHANNEL}));if(l){var u=null===(n=l.uiSchema)||void 0===n?void 0:n.find((function(e){return"authenticator.id"===e.name}));if(u){var c=null===(r=l.uiSchema)||void 0===r?void 0:r.find((function(e){return"authenticator.channel"===e.name}));c&&(c.options=null===(o=c.options)||void 0===o?void 0:o.filter((function(e){return e.value===s})),c.value=(null===(i=c.options[0])||void 0===i?void 0:i.value)||s,c.sublabel=null,t.set("authenticator.channel",c.value),t.set("authenticator.id",u.value),t.set("formName",l.name),e.trigger("saveForm",t))}}}}))}});t.default=s,e.exports=t.default},98355:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(31752)),i=n(6475),a=n(17587),s=r(n(83966)),l=r(n(34425)),u=r(n(50509)),c=a.BaseForm.extend({title:function(){return l.default.isAndroid()||l.default.isIOS()?(0,i.loc)("oie.enroll.okta_verify.setup.title","login"):(0,i.loc)("oie.enroll.okta_verify.select.channel.title.updated","login")},getUISchema:function(){var e,t=this,n=a.BaseForm.prototype.getUISchema.apply(this,arguments),r=i._.find(n,(function(e){return"authenticator.channel"===e.name}));r.options=i._.filter(null==r?void 0:r.options,(function(e){var n,r;return e.value!==(null===(n=t.options.appState.get("currentAuthenticator"))||void 0===n||null===(r=n.contextualData)||void 0===r?void 0:r.selectedChannel)&&"samedevice"!==e.value})),r.value=null===(e=r.options[0])||void 0===e?void 0:e.value,r.sublabel=null,this.model.set("authenticator.channel",r.value);var s={View:(0,i.loc)("oie.enroll.okta_verify.select.channel.subtitle","login"),selector:".o-form-fieldset-container"};return[s].concat((0,o.default)(n))}}),d=s.default.extend({Body:c,postRender:function(){var e,t,n=null===(e=this.options.currentViewState.value)||void 0===e?void 0:e.find((function(e){return"authenticator"===e.name})).value.form.value;(null==n||null===(t=n.find((function(e){return"channel"===e.name})).options)||void 0===t?void 0:t.find((function(e){return"samedevice"===e.value})))&&this.add(new u.default({model:this.model,settings:this.settings,appState:this.options.appState}),"form")}});t.default=d,e.exports=t.default},99519:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(13955),s=i.View.extend({className:"switch-channel-text",template:o.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"sameDeviceOVEnrollmentEnabled"):t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.program(4,o,0),data:o,loc:{start:{line:1,column:23},end:{line:1,column:325}}}))?i:""},2:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.okta_verify.switch.channel.link.text"},data:o,loc:{start:{line:1,column:60},end:{line:1,column:140}}}))?i:""},4:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<a href="#" class="switch-channel-link" aria-label="'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.aria.cannotScan"},data:o,loc:{start:{line:1,column:200},end:{line:1,column:259}}}))+'">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"enroll.totp.cannotScan"},data:o,loc:{start:{line:1,column:261},end:{line:1,column:314}}}))+"</a>"},6:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"isSameDeviceChannel"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.program(9,o,0),data:o,loc:{start:{line:1,column:325},end:{line:1,column:480}}}))?i:""},7:function(e,t,n,r,o){return""},9:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"isDeviceBootstrapChannel"):t,{name:"if",hash:{},fn:e.program(7,o,0),inverse:e.program(2,o,0),data:o,loc:{start:{line:1,column:356},end:{line:1,column:480}}}))?i:""},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"isQRcodeChannel"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(6,o,0),data:o,loc:{start:{line:1,column:0},end:{line:1,column:487}}}))?i:""},useData:!0}),getTemplateData:function(){var e=this.options.appState.get("currentAuthenticator").contextualData.selectedChannel;return{sameDeviceOVEnrollmentEnabled:this.settings.get("features.sameDeviceOVEnrollmentEnabled"),isQRcodeChannel:"qrcode"===e,isSameDeviceChannel:"samedevice"===e,isDeviceBootstrapChannel:"devicebootstrap"===e}},postRender:function(){var e=this;this.$el.find(".switch-channel-link").on("click",(function(t){var n=e.options.appState;t.preventDefault(),n.trigger("switchForm",a.FORMS.SELECT_ENROLLMENT_CHANNEL)}))}});t.default=s,e.exports=t.default},26097:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(93831)),s=r(n(83966)),l=n(71101),u=n(43318),c=i.BaseForm.extend({title:function(){return(0,o.loc)("oie.password.challenge.title","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")},getUISchema:function(){var e=i.BaseForm.prototype.getUISchema.apply(this,arguments),t=this.options.settings,n="primaryauth.password.tooltip",r=e.find((function(e){return"credentials.passcode"===e.name}));return r&&(0,u.isCustomizedI18nKey)(n,t)&&(r.explain=(0,o.loc)(n,"login"),r["explain-top"]=!0),e}}),d=a.default.extend({links:function(){var e=a.default.prototype.links.apply(this,arguments);return e=(0,l.getForgotPasswordLink)(this.options.appState,this.options.settings).concat(e),e}}),f=s.default.extend({Body:c,Footer:d});t.default=f,e.exports=t.default},75582:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=n(25795),l=n(81554);function u(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return c(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return c(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var d=i.BaseForm.extend({title:function(){return(0,o.loc)("oie.password.enroll.title","login")},save:function(){return(0,o.loc)("oform.next","login")},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments);var e=this.getPasswordPolicySettings();this.displayPasswordPolicy(e)},displayPasswordPolicy:function(e){if(e){var t=(0,s.getPasswordComplexityDescriptionForHtmlList)(e);(0,l.generatePasswordPolicyHtml)(this,t,!0)}},triggerAfterError:function(e,t){t.responseJSON=(0,s.removeRequirementsFromError)(t.responseJSON),this.options.appState.trigger("afterError",t)},getPasswordPolicySettings:function(){var e,t=this.options.currentViewState.relatesTo;return null==t||null===(e=t.value)||void 0===e?void 0:e.settings},getUISchema:function(){var e,t=i.BaseForm.prototype.getUISchema.apply(this,arguments),n={name:"confirmPassword",label:(0,o.loc)("oie.password.confirmPasswordLabel","login"),type:"password","label-top":!0,params:{showPasswordToggle:this.settings.get("showPasswordToggle")}},r=[],a=u(t);try{for(a.s();!(e=a.n()).done;){var s=e.value;r.push(s),"credentials.passcode"===s.name&&r.push(n)}}catch(e){a.e(e)}finally{a.f()}return r}}),f=a.default.extend({Body:d,createModelClass:function(){var e=i.BaseView.prototype.createModelClass.apply(this,arguments),t=Object.assign({confirmPassword:{type:"string",required:!0}},e.prototype.local);return e.extend({local:t,validate:function(){return this.get("credentials.passcode")!==this.get("confirmPassword")&&this.get("credential.value")!==this.get("confirmPassword")?{confirmPassword:(0,o.loc)("password.error.match","login")}:null}})}});t.default=f,e.exports=t.default},81554:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.generatePasswordPolicyHtml=void 0;var o=r(n(2875)),i=n(6475);t.generatePasswordPolicyHtml=function(e,t,n){e.add(i.View.extend({tagName:"section",template:o.default.template({1:function(e,t,n,r,o){return"<li>"+e.escapeExpression(e.lambda(t,t))+"</li>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="password-authenticator--heading">'+e.escapeExpression((s(n,"i18n")||t&&s(t,"i18n")||e.hooks.helperMissing).call(a,{name:"i18n",hash:{bundle:"login",code:"password.complexity.requirements.header"},data:o,loc:{start:{line:1,column:45},end:{line:1,column:115}}}))+'</div><ul class="password-authenticator--list">'+(null!=(i=s(n,"each").call(a,null!=t?s(t,"rulesList"):t,{name:"each",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:162},end:{line:1,column:207}}}))?i:"")+"</ul>"},useData:!0}),getTemplateData:function(){return{rulesList:t}},attributes:{"data-se":"password-authenticator--rules"}}),{prepend:n,selector:".o-form-fieldset-container"})}},62665:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(75582)),a=i.default.prototype.Body.extend({className:"password-authenticator",title:function(){var e=this.options.settings.get("brandName")?(0,o.loc)("password.expired.title.specific","login",[this.options.settings.get("brandName")]):(0,o.loc)("password.expired.title.generic","login");return e},save:function(){return(0,o.loc)("password.expired.submit","login")},getPasswordPolicySettings:function(){var e,t;return(null===(e=this.options.appState.get("recoveryAuthenticator"))||void 0===e?void 0:e.settings)||(null===(t=this.options.appState.get("enrollmentAuthenticator"))||void 0===t?void 0:t.settings)}}),s=i.default.extend({Body:a});t.default=s,e.exports=t.default},40973:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(75582)),s=a.default.prototype.Body.extend({className:"password-authenticator",subtitle:function(){if(this.options.settings.get("brandName"))return(0,o.loc)("password.expiring.subtitle.specific","login",[this.options.settings.get("brandName")])},title:function(){var e=(this.getPasswordPolicySettings()||{}).daysToExpiry;return e>0?(0,o.loc)("password.expiring.title","login",[e]):0===e?(0,o.loc)("password.expiring.today","login"):(0,o.loc)("password.expiring.soon","login")},save:function(){return(0,o.loc)("password.expired.submit","login")},showMessages:function(){if(this.options.settings.get("brandName"))return null;a.default.prototype.Body.prototype.showMessages.apply(this,arguments)}}),l=i.BaseFooter.extend({links:function(){var e=[];return this.options.appState.hasRemediationObject("skip")&&e.push({type:"link",label:(0,o.loc)("password.expiring.later","login"),name:"skip",actionPath:"skip"}),e}}),u=a.default.extend({Body:s,Footer:l});t.default=u,e.exports=t.default},13591:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(75582)),a=i.default.prototype.Body.extend({className:"password-authenticator",title:function(){var e=this.options.settings.get("brandName")?(0,o.loc)("password.reset.title.specific","login",[this.options.settings.get("brandName")]):(0,o.loc)("password.reset.title.generic","login");return e},save:function(){return(0,o.loc)("password.reset","login")}}),s=i.default.extend({Body:a});t.default=s,e.exports=t.default},65425:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend({className:"phone-authenticator-challenge",events:{"click a.phone-authenticator-challenge__link":"handleSecondaryLinkClick"},title:function(){return(0,o.loc)("oie.phone.verify.title","login")},save:function(){return"sms"===this.model.get("primaryMode")?(0,o.loc)("oie.phone.sms.primaryButton","login"):(0,o.loc)("oie.phone.call.primaryButton","login")},handleSecondaryLinkClick:function(e){e.preventDefault();var t=this.model.get("secondaryMode");this.model.set("authenticator.methodType",t),this.saveForm(this.model)},initialize:function(){var e=this;this.model.on("error",(function(){return e.model.set("authenticator.methodType",e.model.get("primaryMode"))})),i.BaseForm.prototype.initialize.apply(this,arguments);var t="sms"===this.model.get("primaryMode")?(0,o.loc)("oie.phone.verify.sms.sendText","login"):(0,o.loc)("oie.phone.verify.call.sendText","login"),n=(0,o.loc)("oie.phone.carrier.charges","login"),r=this.model.get("phoneNumber")!==(0,o.loc)("oie.phone.alternate.title","login"),a=r?"strong no-translate nowrap":"",s=r?this.model.get("nickname"):"",l=s?" (".concat(s,")"):"",u=l?"no-translate authenticator-verify-nickname":"",c=l?'<span class="'.concat(u||"",'">').concat(l,".</span>"):'<span class="no-translate">.</span>',d="".concat(t," ")+"<span ".concat(a?' class="'.concat(a,'"'):"",">").concat(this.model.escape("phoneNumber"),"</span>")+"".concat(c);this.add('<div class="okta-form-subtitle" data-se="o-form-explain">'+"".concat(d)+"<p>".concat(n,"</p>")+"</div>")},getUISchema:function(){var e=i.BaseForm.prototype.getUISchema.apply(this,arguments);return e.filter((function(e){return"authenticator.methodType"!==e.name}))},render:function(){i.BaseForm.prototype.render.apply(this,arguments);var e=this.model.get("secondaryMode");if(e){var t="sms"===e?(0,o.loc)("oie.phone.sms.secondaryButton","login"):(0,o.loc)("oie.phone.call.secondaryButton","login");this.add('<a href="#"\n            class="link phone-authenticator-challenge__link"\n            data-se="phone-authenticator-challenge__link">'.concat(t,"</a>"),".o-form-button-bar")}}}),l=a.default.extend({Body:s,createModelClass:function(e){var t=e.uiSchema,n=o._.find(t,(function(e){return"authenticator.methodType"===e.name})),r=n.options,a=this.options.currentViewState.relatesTo,s=(null==a?void 0:a.value)||{},l=s.profile,u=s.nickname,c=i.BaseView.prototype.createModelClass.apply(this,arguments),d=Object.assign({primaryMode:{value:r[0].value,type:"string"},secondaryMode:{value:r[1]&&r[1].value,type:"string"},phoneNumber:{value:null!=l&&l.phoneNumber?l.phoneNumber:(0,o.loc)("oie.phone.alternate.title","login"),type:"string"},nickname:{value:u||"",type:"string"}},c.prototype.local);return c.extend({local:d})}});t.default=l,e.exports=t.default},94257:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.ResendView=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(25590)).default.extend({className:"phone-authenticator-challenge__resend-warning hide",events:{"click a.resend-link":"handleResendLink"},modelEvents:{error:"handleError"},resendActionKey:"currentAuthenticatorEnrollment-resend",initialize:function(){var e="sms"===this.model.get("mode")?(0,o.loc)("oie.phone.verify.sms.resendText","login"):(0,o.loc)("oie.phone.verify.call.resendText","login"),t="sms"===this.model.get("mode")?(0,o.loc)("oie.phone.verify.sms.resendLinkText","login"):(0,o.loc)("oie.phone.verify.call.resendLinkText","login");this.add((0,o.createCallout)({content:"".concat(e,"&nbsp;<a class='resend-link'>").concat(t,"</a>"),type:"warning"}))},hideResendViewAndShowAfterTimeout:function(){this.el.classList.contains("hide")||this.el.classList.add("hide"),this.showCalloutAfterTimeout()},handleResendLink:function(e){null==e||e.preventDefault(),this.options.appState.trigger("invokeAction",this.resendActionKey),this.hideResendViewAndShowAfterTimeout()},handleError:function(){this.hideResendViewAndShowAfterTimeout()}});t.ResendView=s;var l=i.BaseForm.extend(Object.assign({className:"phone-authenticator-challenge",title:function(){return(0,o.loc)("oie.phone.verify.title","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments);var e="sms"===this.model.get("mode")?(0,o.loc)("oie.phone.verify.sms.codeSentText","login"):(0,o.loc)("mfa.calling","login"),t=(0,o.loc)("oie.phone.verify.enterCodeText","login"),n=(0,o.loc)("oie.phone.carrier.charges","login"),r=this.model.get("phoneNumber")!==(0,o.loc)("oie.phone.alternate.title","login"),a=r?"strong no-translate nowrap":"",s=r?this.model.get("nickname"):"",l=s?" (".concat(s,")"):"",u=l?"no-translate authenticator-verify-nickname":"",c=l?'<span class="'.concat(u||"",'"}>').concat(l,".</span>"):'<span class="no-translate">.</span>';this.add('<div class="okta-form-subtitle" data-se="o-form-explain">'+"".concat(e," ")+'<span class="'.concat(a,'">').concat(this.model.escape("phoneNumber"),"</span>")+"".concat(c)+"&nbsp;".concat(t)+"<p>".concat(n,"</p>")+"</div>",{prepend:!0,selector:".o-form-fieldset-container"})},postRender:function(){i.BaseForm.prototype.postRender.apply(this,arguments),this.add(s,{selector:".o-form-info-container",prepend:!0})}})),u=a.default.extend({Body:l,createModelClass:function(){var e=this.options.currentViewState.relatesTo,t=(null==e?void 0:e.value)||{},n=t.methods,r=t.profile,a=t.nickname,s=i.BaseView.prototype.createModelClass.apply(this,arguments),l=Object.assign({mode:{value:n[0].type,type:"string"},phoneNumber:{value:null!=r&&r.phoneNumber?r.phoneNumber:(0,o.loc)("oie.phone.alternate.title","login"),type:"string"},nickname:{value:a||"",type:"string"}},s.prototype.local);return s.extend({local:l})}});t.default=u},86598:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(73390)),l=i.BaseForm.extend({className:"phone-authenticator-enroll",title:function(){return(0,o.loc)("oie.phone.enroll.title","login")},subtitle:function(){return"voice"===this.model.get("authenticator.methodType")?(0,o.loc)("oie.phone.enroll.call.subtitle","login"):(0,o.loc)("oie.phone.enroll.sms.subtitle","login")},render:function(){i.BaseForm.prototype.render.apply(this,arguments),this.el.querySelector(".phone-authenticator-enroll__phone-code").innerText="+".concat(this.model.get("phoneCode"))},handlePhoneCodeChange:function(){this.el.querySelector(".phone-authenticator-enroll__phone-code").innerText="+".concat(this.model.get("phoneCode"))},save:function(){return"voice"===this.model.get("authenticator.methodType")?(0,o.loc)("oie.phone.call.primaryButton","login"):(0,o.loc)("oie.phone.sms.primaryButton","login")},getUISchema:function(){var e=i.BaseForm.prototype.getUISchema.apply(this,arguments),t=o._.findIndex(e,(function(e){return"authenticator.phoneNumber"===e.name})),n={"label-top":!0,label:(0,o.loc)("mfa.country","login"),type:"select",options:s.default.getCountries(),name:"country",wide:!0},r="okta-phone-number-input",a={label:(0,o.loc)("mfa.phoneNumber.placeholder","login"),inputId:r,type:"group",modelType:"string","label-top":!0,name:"phoneCode",className:"phone-authenticator-enroll__phone",input:[{type:"label",label:"+".concat(this.model.get("phoneCode")),className:"phone-authenticator-enroll__phone-code no-translate"},Object.assign({inputId:r},e[t])]},l={label:(0,o.loc)("phone.extention.label","login"),type:"text",className:"phone-authenticator-enroll__phone-ext","label-top":!0,name:"extension",showWhen:{"authenticator.methodType":"voice"}};-1!==t&&(e.splice(t,1,a),e.splice(t,0,n),e.splice(t+2,0,l));var u=o._.find(e,(function(e){return"authenticator.methodType"===e.name}));return u&&1===u.options.length&&(u.className="hide"),e},updateConditionalText:function(){this.el.querySelector(".okta-form-subtitle").innerText=this.subtitle(),this.el.querySelector('input[type="submit"]').value=this.save()},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),this.listenTo(this.model,"change:authenticator.methodType",this.updateConditionalText),this.listenTo(this.model,"change:phoneCode",this.handlePhoneCodeChange.bind(this))}}),u=a.default.extend({Body:l,createModelClass:function(){var e=i.BaseView.prototype.createModelClass.apply(this,arguments),t=Object.assign({country:{value:this.settings.get("defaultCountryCode"),type:"string"},extension:{type:"string"}},e.prototype.local),n=Object.assign({phoneCode:{deps:["country"],fn:function(e){return s.default.getCallingCodeForCountry(e)}}},e.prototype.derived);return e.extend({local:t,derived:n,toJSON:function(){var e=o.Model.prototype.toJSON.call(this,arguments),t=this.get("extension"),n=this.get("phoneCode"),r="+".concat(n).concat(e.authenticator.phoneNumber);return"voice"===e.authenticator.methodType&&null!=t&&t.trim().length&&(r="".concat(r,"x").concat(t)),e.authenticator.phoneNumber=r,e}})}});t.default=u,e.exports=t.default},15918:function(e,t,n){"use strict";var r=n(12990);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!==r(e)&&"function"!=typeof e)return{default:e};var n=s(t);if(n&&n.has(e))return n.get(e);var o={},i=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var a in e)if("default"!==a&&Object.prototype.hasOwnProperty.call(e,a)){var l=i?Object.getOwnPropertyDescriptor(e,a):null;l&&(l.get||l.set)?Object.defineProperty(o,a,l):o[a]=e[a]}o.default=e,n&&n.set(e,o);return o}(n(94257)),a=n(17587);function s(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,n=new WeakMap;return(s=function(e){return e?n:t})(e)}var l=i.ResendView.extend({className:"phone-authenticator-enroll--warning hide",resendActionKey:"currentAuthenticator-resend"}),u=i.default.prototype.Body.extend({className:"phone-authenticator-enroll",title:function(){return(0,o.loc)("oie.phone.enroll.title","login")},postRender:function(){a.BaseForm.prototype.postRender.apply(this,arguments),this.add(l,{selector:".o-form-info-container",prepend:!0})}}),c=i.default.extend({Body:u});t.default=c,e.exports=t.default},21606:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(39797)),l=i.BaseForm.extend({className:"piv-cac-card",modelEvents:{request:"startAuthentication",error:"stopAuthentication"},initialize:function(){i.BaseForm.prototype.initialize.apply(this,arguments),this.model.set("useRedirect",!0),this.addInstructions()},title:function(){return(0,o.loc)("piv.cac.title","login")},save:function(){return(0,o.loc)("retry","login")},addInstructions:function(){this.add("<div class='piv-verify-text'>\n        <p>".concat((0,o.loc)("piv.cac.card.insert","login"),"</p>\n        <div data-se='piv-waiting' class='okta-waiting-spinner'></div>\n      </div>"))},startAuthentication:function(){this.$(".okta-waiting-spinner").show(),this.$(".o-form-button-bar").hide()},stopAuthentication:function(){this.$(".okta-waiting-spinner").hide(),this.$(".o-form-button-bar").show()}}),u=a.default.extend({Header:s.default,Body:l,postRender:function(){a.default.prototype.postRender.apply(this,arguments);var e=this.options.appState.get("messages")||{};Array.isArray(e.value)?this.form.stopAuthentication():(this.form.startAuthentication(),this.form.trigger("save",this.model))}});t.default=u,e.exports=t.default},39797:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(17587),i=r(n(99422)),a=o.BaseHeader.extend({HeaderBeacon:i.default.extend({getBeaconClassName:function(){return"smartcard"}})});t.default=a,e.exports=t.default},9699:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend({title:function(){return(0,o.loc)("oie.security.question.challenge.title","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")},getUISchema:function(){var e=i.BaseForm.prototype.getUISchema.apply(this,arguments),t=e.filter((function(e){return e.name.indexOf("questionKey")>=0})),n=e.filter((function(e){return e.name.indexOf("answer")>=0}));return 1===t.length&&1===n.length&&(n[0].label=t[0].label),e}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},14425:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend({title:function(){return(0,o.loc)("oie.security.question.enroll.title","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},25590:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(86725),a=r(n(69977)),s=o.View.extend({postRender:function(){this.showCalloutAfterTimeout()},showCalloutAfterTimeout:function(){var e=this;a.default.getResendTimestamp()||a.default.setResendTimestamp(Date.now()),this.showMeInterval=setInterval((function(){var t=a.default.getResendTimestamp();Date.now()-t>=i.SHOW_RESEND_TIMEOUT&&(e.$el.removeClass("hide"),clearInterval(e.showMeInterval),a.default.removeResendTimestamp())}),250)},remove:function(){var e,t;o.View.prototype.remove.apply(this,arguments),clearInterval(this.showMeInterval);var n=this.options.appState.get("currentFormName"),r=(null===(e=this.options.appState.get("currentAuthenticator"))||void 0===e?void 0:e.resend)||(null===(t=this.options.appState.get("currentAuthenticatorEnrollment"))||void 0===t?void 0:t.resend),i=this.options.model.get("formName")!==n;!a.default.getResendTimestamp()||r&&!i||a.default.removeResendTimestamp()}});t.default=s,e.exports=t.default},14709:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(17587),i=r(n(83966)),a=r(n(70845)),s=r(n(59583)),l=i.default.extend({initialize:function(){i.default.prototype.initialize.apply(this,arguments),this.isPushOnlyWithAutoChallengeFlow()?this.Body=a.default:(this.Body=s.default,this.Footer=o.BaseFooter)},isPushOnlyWithAutoChallengeFlow:function(){var e=this.options.appState.getSchemaByName("authenticator.methodType"),t=this.options.appState.getSchemaByName("authenticator.autoChallenge"),n=null==e?void 0:e.options;return t&&1===n.length&&"push"===n[0].value}});t.default=l,e.exports=t.default},59583:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(40647)),s=n(25795),l=n(21748),u=n(13955),c=l.Body.extend({getUISchema:function(){var e=this,t=i.BaseForm.prototype.getUISchema.apply(this,arguments),n=t.find((function(e){return"authenticator.methodType"===e.name}));this._sortMethodOptionsIfDeviceKnown(n.options);var r=n.options.map((function(t){return Object.assign({},t,(0,s.getAuthenticatorDataForVerification)({authenticatorKey:e.isOV()?u.AUTHENTICATOR_KEY.OV:u.AUTHENTICATOR_KEY.CUSTOM_APP,value:{methodType:t.value}}))}));return[{View:a.default,options:{name:n.name,collection:new o.Collection(r)}}]},_sortMethodOptionsIfDeviceKnown:function(e){var t,n,r,o;if(null===(t=this.options)||void 0===t||null===(n=t.currentViewState)||void 0===n||null===(r=n.relatesTo)||void 0===r||null===(o=r.value)||void 0===o?void 0:o.deviceKnown){var i=e.findIndex((function(e){return"signed_nonce"===e.value}));if(i>0){var a=e[i];e.splice(i,1),e.unshift(a)}}},isOV:function(){return this.options.appState.get("authenticatorKey")===u.AUTHENTICATOR_KEY.OV}}),d=c;t.default=d,e.exports=t.default},70845:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(17587),o=n(13955),i=n(6475),a=r.BaseForm.extend(Object.assign({className:function(){return this.isOV()?"okta-verify-send-push-form":"custom-app-send-push-form"},save:function(){return this.options.appState.get("authenticatorKey")===o.AUTHENTICATOR_KEY.OV?(0,i.loc)("oie.okta_verify.sendPushButton","login"):(0,i.loc)("oie.custom_app.sendPushButton","login")},title:function(){return this.isOV()?(0,i.loc)("oie.okta_verify.push.title","login"):(0,i.loc)("oie.custom_app.push.title","login")},render:function(){r.BaseForm.prototype.render.apply(this,arguments);var e=this.$el.find('[data-se="o-form-fieldset-authenticator.autoChallenge"]');e.length&&this.$el.find(".o-form-button-bar").after(e)},getUISchema:function(){var e=r.BaseForm.prototype.getUISchema.apply(this,arguments);return e.filter((function(e){return"authenticator.methodType"!==e.name}))},isOV:function(){return this.options.appState.get("authenticatorKey")===o.AUTHENTICATOR_KEY.OV}})),s=a;t.default=s,e.exports=t.default},70621:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.Body=void 0;var o=r(n(2875)),i=n(6475),a=n(17587),s=r(n(52574)),l=n(86725),u=r(n(83966)),c=n(13955),d=i.View.extend({className:"okta-form-infobox-warning infobox infobox-warning",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<span class="icon warning-16"></span><p>'+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"warning")||(null!=t?a(t,"warning"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"warning",hash:{},data:o,loc:{start:{line:1,column:40},end:{line:1,column:51}}}):i)+"</p>"},useData:!0})}),f=a.BaseFormWithPolling.extend(Object.assign({noButtonBar:!0,title:function(){return this.isOV()?(0,i.loc)("oie.okta_verify.push.title","login"):(0,i.loc)("oie.verify.custom_app.title","login",[this.options.appState.getAuthenticatorDisplayName()])},initialize:function(){a.BaseFormWithPolling.prototype.initialize.apply(this,arguments),(this.isOV()||this.isCustomApp())&&this.isAutoChallengeSupported()&&(this.hasSavingState=!1),this.listenTo(this.model,"error",this.stopPoll),this.addView()},addView:function(){this.add((0,i.createButton)({className:"button button-wide button-primary send-push link-button-disabled",title:this.isOV()?(0,i.loc)("oie.okta_verify.push.sent","login"):(0,i.loc)("oie.custom_app.push.sent","login"),click:function(e){e.preventDefault()}})),this.add("<span class='accessibility-text' role='alert'>\n        ".concat(this.isOV()?(0,i.loc)("oie.okta_verify.push.sent","login"):(0,i.loc)("oie.custom_app.push.sent","login"),"</span>"))},render:function(){a.BaseFormWithPolling.prototype.render.apply(this,arguments);var e=this.$el.find('[data-se="o-form-fieldset-autoChallenge"]');this.isAutoChallengeSupported()?(this.isOV()||this.isCustomApp())&&e.length&&this.$el.find(".o-form-fieldset-container").append(e):e.length&&e.hide()},postRender:function(){a.BaseFormWithPolling.prototype.postRender.apply(this,arguments);var e=this.isOV()?"okta-verify-push-challenge":" custom-app-push-challenge";this.$el.addClass(e),this.startPoll()},startPoll:function(){var e=this;this.startPolling(),this.warningTimeout=setTimeout((function(){var t=e.isOV()?(0,i.loc)("oktaverify.warning","login"):(0,i.loc)("oie.custom_app.push.warning","login",[e.options.appState.getAuthenticatorDisplayName()]);e.showWarning(t)}),l.WARNING_TIMEOUT)},stopPoll:function(){this.stopPolling(),this.clearWarning()},showWarning:function(e){this.clearWarning(),this.add(d,".o-form-error-container",{options:{warning:e}})},clearWarning:function(){this.$(".o-form-error-container div").hasClass("okta-form-infobox-warning")&&this.$(".okta-form-infobox-warning").remove(),clearTimeout(this.warningTimeout)},remove:function(){a.BaseFormWithPolling.prototype.remove.apply(this,arguments),this.stopPoll()},isOV:function(){return this.options.appState.get("authenticatorKey")===c.AUTHENTICATOR_KEY.OV},isCustomApp:function(){return this.options.appState.get("authenticatorKey")===c.AUTHENTICATOR_KEY.CUSTOM_APP},isAutoChallengeSupported:function(){return null!==this.options.appState.getSchemaByName("autoChallenge")&&void 0!==this.options.appState.getSchemaByName("autoChallenge")}},s.default));t.Body=f;var p=u.default.extend({Body:f});t.default=p},91002:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(2875)),a=n(6475).View.extend({className:"custom-access-denied-error-message",template:i.default.template({1:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"message")||(null!=t?a(t,"message"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"message",hash:{},data:o,loc:{start:{line:1,column:18},end:{line:1,column:29}}}):i)+"</p>"},3:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<ul class="custom-links">'+(null!=(i=a(n,"each").call(null!=t?t:e.nullContext||{},null!=t?a(t,"links"):t,{name:"each",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:78},end:{line:1,column:182}}}))?i:"")+"</ul>"},4:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<li><a href="+c((a=null!=(a=d(n,"url")||(null!=t?d(t,"url"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"url",hash:{},data:i,loc:{start:{line:1,column:105},end:{line:1,column:112}}}):a))+' target="_blank" rel="noopener noreferrer">'+c((a=null!=(a=d(n,"label")||(null!=t?d(t,"label"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"label",hash:{},data:i,loc:{start:{line:1,column:155},end:{line:1,column:164}}}):a))+"</a></li>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"message"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:40}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"links"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:40},end:{line:1,column:194}}}))?i:"")},useData:!0}),getTemplateData:function(){return{message:this.options.message,links:this.options.links}}});t.default=a,e.exports=t.default},22873:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o={title:function(){return(0,r.loc)("oie.email.mfa.title","login")}};t.default=o,e.exports=t.default},52574:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(6475),o=n(86725),i={startPolling:function(e){this.fixedPollingInterval=this.options.currentViewState.refresh,this.dynamicPollingInterval=e,this.countDownCounterValue=Math.ceil(this.pollingInterval/o.MS_PER_SEC),this.fixedPollingInterval?this._startRemediationPolling():this._startAuthenticatorPolling()},_startAuthenticatorPolling:function(){var e=this;["currentAuthenticator","currentAuthenticatorEnrollment"].some((function(t){if(e.options.appState.has(t)){var n,o=e.options.appState.get(t),i="".concat(t,"-poll"),a=e.dynamicPollingInterval||(null==o||null===(n=o.poll)||void 0===n?void 0:n.refresh);return r._.isNumber(a)&&(e.polling=setTimeout((function(){e.options.appState.trigger("invokeAction",i)}),a)),!0}return!1}))},_startRemediationPolling:function(){var e=this,t=this.dynamicPollingInterval||this.fixedPollingInterval;r._.isNumber(t)&&(this.polling=setTimeout((function(){e.options.appState.trigger("saveForm",e.model)}),t))},stopPolling:function(){this.polling&&(clearTimeout(this.polling),this.polling=null)}};t.default=i,e.exports=t.default},94438:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.View.extend({className:"custom-buttons",template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="separation-line"><span>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"socialauth.divider.text"},data:o,loc:{start:{line:1,column:58},end:{line:1,column:112}}}))+"</span></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"addSeparateLine"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:132}}}))?i:"")+'<div class="okta-custom-buttons-container primary-auth-container"></div>'},useData:!0}),initialize:function(e){var t=this;e.customButtons.forEach((function(e){t.add((0,i.createButton)(e),".okta-custom-buttons-container")}))},getTemplateData:function(){var e=i.View.prototype.getTemplateData.apply(this,arguments);return Object.assign(e,{addSeparateLine:this.options.addSeparateLine})}});t.default=a,e.exports=t.default},83201:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(90570)),s=r(n(35546)),l=n(86725),u=n(13955),c=n(66200),d=i.View.extend({className:"sign-in-with-device-option",template:o.default.template({1:function(e,t,n,r,o){return'<div class="signin-with-ov-description"></div>'},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="separation-line"><span>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"authbutton.divider.text"},data:o,loc:{start:{line:1,column:201},end:{line:1,column:255}}}))+"</span></div>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-verify-container">'+(null!=(i=s(n,"if").call(a,null!=t?s(t,"signInWithDeviceIsRequired"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:35},end:{line:1,column:122}}}))?i:"")+"</div>"+(null!=(i=s(n,"unless").call(a,null!=t?s(t,"signInWithDeviceIsRequired"):t,{name:"unless",hash:{},fn:e.program(3,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:128},end:{line:1,column:279}}}))?i:"")},useData:!0}),initialize:function(){var e,t=this.options.appState,n=t.hasRemediationObject(u.FORMS.LAUNCH_AUTHENTICATOR),r=null==n||null===(e=n.relatesTo)||void 0===e?void 0:e.value;this.add((0,i.createButton)({className:"button",icon:"okta-verify-authenticator",title:(0,i.loc)("oktaVerify.button","login"),click:function(){var e=this;this.model.get("identifier")&&this.options.settings.set("identifier",encodeURIComponent(this.model.get("identifier")));var n=(null==r?void 0:r.challengeMethod)===s.default.UNIVERSAL_LINK_CHALLENGE;if(n){var o,i,d=(0,c.appendLoginHint)(r.href,null===(o=this.options)||void 0===o||null===(i=o.settings)||void 0===i?void 0:i.get("identifier"));a.default.redirect(d)}var f=(null==r?void 0:r.challengeMethod)===s.default.APP_LINK_CHALLENGE;if(f){var p,h,m=(0,c.appendLoginHint)(r.href,null===(p=this.options)||void 0===p||null===(h=p.settings)||void 0===h?void 0:h.get("identifier"));a.default.redirect(m,window,!0)}a.default.callAfterTimeout((function(){e.options.isRequired?t.trigger("saveForm",e.model):t.trigger("invokeAction",u.FORMS.LAUNCH_AUTHENTICATOR,{rememberMe:e.model.get("rememberMe")})}),n||f?l.UNIVERSAL_LINK_POST_DELAY:0)}}),".okta-verify-container")},getTemplateData:function(){return{signInWithDeviceIsRequired:!!this.options.isRequired}},postRender:function(){if(this.options.isRequired){var e,t,n=null===(e=this.options.appState.attributes)||void 0===e||null===(t=e.app)||void 0===t?void 0:t.label,r=n?(0,i.loc)("oktaVerify.appDescription","login",[n]):(0,i.loc)("oktaVerify.description","login");this.$el.find(".signin-with-ov-description").text(r)}}});t.default=d,e.exports=t.default},21586:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.View.extend({className:"sign-in-with-idp",template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="separation-line"><span>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"socialauth.divider.text"},data:o,loc:{start:{line:1,column:64},end:{line:1,column:118}}}))+"</span></div>"},3:function(e,t,n,r,o){var i=null!=t?t:e.nullContext||{},a=e.hooks.helperMissing,s=e.escapeExpression,l=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-piv-container"></div><div class="idp-discovery-container"><label class="idp-discovery-search-label">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"idps.search.label"},data:o,loc:{start:{line:1,column:282},end:{line:1,column:330}}}))+'</label><div class="idp-discovery-search-wrapper"><input type="search" class="idp-discovery-search-input" data-se="idp-search-input" aria-label="'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"idps.search.label"},data:o,loc:{start:{line:1,column:475},end:{line:1,column:523}}}))+'" placeholder="'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"idps.search.typeahead.placeholder"},data:o,loc:{start:{line:1,column:538},end:{line:1,column:602}}}))+'" autocomplete="off"></div><div class="okta-idps-container" data-se="idp-list-container"></div><div class="idp-no-results" data-se="idp-no-results">'+s((l(n,"i18n")||t&&l(t,"i18n")||a).call(i,{name:"i18n",hash:{bundle:"login",code:"idps.search.no.results"},data:o,loc:{start:{line:1,column:750},end:{line:1,column:803}}}))+"</div></div>"},5:function(e,t,n,r,o){return'<div class="okta-idps-container"></div>'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=null!=t?t:e.nullContext||{},s=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return(null!=(i=s(n,"if").call(a,null!=t?s(t,"isSecondaryIdpDisplay"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:0},end:{line:1,column:138}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"showSearchContainer"):t,{name:"if",hash:{},fn:e.program(3,o,0),inverse:e.program(5,o,0),data:o,loc:{start:{line:1,column:138},end:{line:1,column:869}}}))?i:"")+(null!=(i=s(n,"if").call(a,null!=t?s(t,"isPrimaryIdpDisplay"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:869},end:{line:1,column:1005}}}))?i:"")},useData:!0}),events:{"input .idp-discovery-search-input":"_filterIdps"},initialize:function(){var e=this,t=this.options.idpButtons,n=t.length>10;t.forEach((function(t){var r=t.className&&t.className.includes("piv-button"),o=n&&r?".okta-piv-container":".okta-idps-container";e.add((0,i.createButton)(t),o)}))},_filterIdps:function(e){var t=e.target.value.toLowerCase().trim(),n=0;this.$(".okta-idps-container .link-button").each((function(e,r){var o=(r.textContent||"").toLowerCase().trim(),i=!t||o.includes(t);r.style.display=i?"":"none",i&&n++})),n>0?(this.$(".okta-idps-container").show(),this.$(".idp-no-results").hide()):(this.$(".okta-idps-container").hide(),this.$(".idp-no-results").show())},getTemplateData:function(){var e=i.View.prototype.getTemplateData.apply(this,arguments),t=this.options.idpButtons,n=t.length>0;return Object.assign(e,{isPrimaryIdpDisplay:n&&this.options.isPrimaryIdpDisplay,isSecondaryIdpDisplay:n&&!this.options.isPrimaryIdpDisplay,showSearchContainer:t.length>10})}});t.default=a,e.exports=t.default},66019:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.View.extend({className:"sign-in-with-passkeys-option",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-passkeys-container"></div><div class="separation-line"><span>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"authbutton.divider.text"},data:o,loc:{start:{line:1,column:78},end:{line:1,column:132}}}))+"</span></div>"},useData:!0}),initialize:function(){var e=this;this.add((0,i.createButton)({className:"button",icon:"okta-passkeys-authenticator",title:(0,i.loc)("signinWithPasskeys.button","login"),click:function(){e.options.getCredentialsAndInvokeAction.call(e.options.formView)}}),".okta-passkeys-container")}});t.default=a,e.exports=t.default},156:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(13955),s=i.View.extend({className:"sign-in-with-webauthn-option",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-webauthn-container"></div><div class="separation-line"><span>'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"authbutton.divider.text"},data:o,loc:{start:{line:1,column:78},end:{line:1,column:132}}}))+"</span></div>"},useData:!0}),initialize:function(){var e=this;this.add((0,i.createButton)({className:"button",icon:"okta-webauthn-authenticator",title:(0,i.loc)("signinWithWebAuthn.button","login"),click:function(){e.options.appState.trigger("invokeAction",a.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR)}}),".okta-webauthn-container")}});t.default=s,e.exports=t.default},2854:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=r(n(71750)),a=r(n(83966)),s=i.default.extend({title:function(){var e=this.options.appState.getAuthenticatorDisplayName();return this.options.appState.isAuthenticatorChallenge()?(0,o.loc)("oie.symantecVip.challenge.title","login",[e]):(0,o.loc)("oie.symantecVip.enroll.title","login",[e])},subtitle:function(){var e=this.options.appState.getAuthenticatorDisplayName();return this.options.appState.isAuthenticatorChallenge()?(0,o.loc)("oie.symantecVip.challenge.description","login",[e]):(0,o.loc)("oie.symantecVip.enroll.description","login",[e])},save:function(){return this.options.appState.isAuthenticatorChallenge()?(0,o.loc)("mfa.challenge.verify","login"):(0,o.loc)("mfa.enroll","login")}}),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},91153:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=i.BaseForm.extend(Object.assign({className:"tac-authenticator-challenge",title:function(){return(0,o.loc)("oie.verify.tac.title","login")},subtitle:function(){return(0,o.loc)("oie.verify.tac.description","login")},save:function(){return(0,o.loc)("mfa.challenge.verify","login")}})),l=a.default.extend({Body:s});t.default=l,e.exports=t.default},98380:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(25795),s=r(n(33705)),l=n(13056),u=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="idx-webauthn-verify-text">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:null!=t?i(t,"verifyI18nKey"):t},data:o,loc:{start:{line:1,column:57},end:{line:1,column:99}}}))+"</p>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="idx-webauthn-verify-text">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.instructions"},data:o,loc:{start:{line:1,column:147},end:{line:1,column:210}}}))+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"verifyI18nKey"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:0},end:{line:1,column:221}}}))?i:""},useData:!0}),initialize:function(){var e=this.options.currentViewState.relatesTo;"required"===(null==e?void 0:e.value.contextualData.challengeData).userVerification&&this.add((0,i.createCallout)({className:"uv-required-callout",size:"slim",type:"warning",subtitle:(0,i.loc)("oie.verify.webauthn.uv.required.instructions","login")}));var t=(0,a.getWebAuthnAdditionalInstructions)(this.options.currentViewState);t&&this.add(s.default,{options:{description:t}}),this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>')},getTemplateData:function(){var e,t;return{verifyI18nKey:(0,l.getWebAuthnI18nKey)({DEFAULT:"oie.verify.webauthn.instructions",PASSKEYS:"oie.verify.webauthn.passkeysRebrand.instructions",CUSTOM:"oie.verify.webauthn.passkeysRebrand.instructions"},null===(e=this.options.currentViewState.relatesTo)||void 0===e||null===(t=e.value)||void 0===t?void 0:t.displayName)}}});t.default=u,e.exports=t.default},30836:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(76587)),l=r(n(49268)),u=r(n(34425)),c=r(n(98380)),d=n(43318),f=r(n(9867)),p=n(13955),h=r(n(21286)),m=n(25795),v=n(13056),g=i.BaseForm.extend({title:function(){return(0,m.getWebAuthnTitle)(this.options.currentViewState,!0)},className:"oie-verify-webauthn",getUISchema:function(){var e=this,t=[];if(l.default.isNewApiAvailable()){var n=(0,o.createButton)({className:"retry-webauthn button-primary default-custom-button",title:(0,o.loc)("mfa.challenge.verify","login"),click:function(){e.getCredentialsAndSave()}});t.push({View:c.default},{View:n}),this._canSetupWebAuthnResidentKey()&&t.push({View:h.default})}else{var r,i;t.push({View:(0,o.createCallout)({className:"webauthn-not-supported",type:"error",subtitle:(0,o.loc)((0,v.getWebAuthnI18nKey)({DEFAULT:"oie.webauthn.error.not.supported",PASSKEYS:"oie.webauthn.passkeysRebrand.error.not.supported",CUSTOM:"oie.webauthn.passkeysRebrand.error.not.supported"},null===(r=this.options.currentViewState.relatesTo)||void 0===r||null===(i=r.value)||void 0===i?void 0:i.displayName)||"oie.webauthn.error.not.supported","login")})})}return t},remove:function(){i.BaseForm.prototype.remove.apply(this,arguments),this.webauthnAbortController&&(this.webauthnAbortController.abort(),this.webauthnAbortController=null)},noButtonBar:!0,modelEvents:{error:"_stopVerification"},getCredentialsAndSave:function(){var e,t=this;this.clearErrors(),this._startVerification(),"undefined"!=typeof AbortController&&(this.webauthnAbortController=new AbortController);var n=this.options.currentViewState.relatesTo,r=(null==n?void 0:n.value)||{},i=[];((null===(e=this.options.appState.get("authenticatorEnrollments"))||void 0===e?void 0:e.value)||[]).forEach((function(e){"webauthn"===e.key&&i.push({type:"public-key",id:s.default.strToBin(e.credentialId)})}));var a=r.contextualData.challengeData,l=o._.extend({},a,{allowCredentials:i,challenge:s.default.strToBin(a.challenge)});navigator.credentials.get({publicKey:l,signal:this.webauthnAbortController&&this.webauthnAbortController.signal}).then((function(e){var n,r={clientData:s.default.binToStr(e.response.clientDataJSON),authenticatorData:s.default.binToStr(e.response.authenticatorData),signatureData:s.default.binToStr(e.response.signature)};t.options.appState.getSchemaByName("credentials.userHandle")&&o._.extend(r,{userHandle:s.default.binToStr(null!==(n=e.response.userHandle)&&void 0!==n?n:"")});t.model.set({credentials:r}),t.saveForm(t.model)}),(function(e){t.webauthnAbortController&&t.model.trigger("error",t.model,{responseJSON:{errorSummary:(0,d.getMessageFromBrowserError)(e)}})})).finally((function(){t.webauthnAbortController=null}))},_startVerification:function(){this.$(".okta-waiting-spinner").show(),this.$(".retry-webauthn").hide(),this.$(".setup-webauthn-residentkey-text").hide(),this.$(".retry-webauthn")[0].textContent=(0,o.loc)("retry","login")},_stopVerification:function(){this.$(".okta-waiting-spinner").hide(),this.$(".retry-webauthn").show(),this.$(".setup-webauthn-residentkey-text").show()},_canSetupWebAuthnResidentKey:function(){return this.options.appState.hasRemediationObject(p.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY)}}),y=a.default.extend({Body:g,Footer:f.default,postRender:function(){a.default.prototype.postRender.apply(this,arguments),l.default.isNewApiAvailable()&&!u.default.isSafari()&&this.form.getCredentialsAndSave()}});t.default=y,e.exports=t.default},21286:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=n(13955),s=i.View.extend({className:"setup-webauthn-residentkey-text",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<div>"+(null!=(i=(a(n,"i18n")||t&&a(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.webauthn.rk.link"},data:o,loc:{start:{line:1,column:5},end:{line:1,column:65}}}))?i:"")+"</div>"},useData:!0}),events:{"click .setup-webauthn-residentkey-link":function(e){e.preventDefault(),this.options.appState.trigger("invokeAction",a.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY)}}});t.default=s,e.exports=t.default},46523:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(34425)),s=n(25795),l=r(n(33705)),u=n(13056),c=i.View.extend({template:o.default.template({1:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="idx-webauthn-enroll-text">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:null!=t?i(t,"enrollI18nKey"):t},data:o,loc:{start:{line:1,column:57},end:{line:1,column:99}}}))+"</p>"},3:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<p class="idx-webauthn-enroll-text">'+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.webauthn.instructions"},data:o,loc:{start:{line:1,column:147},end:{line:1,column:210}}}))+"</p>"},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"enrollI18nKey"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.program(3,o,0),data:o,loc:{start:{line:1,column:0},end:{line:1,column:221}}}))?i:""},useData:!0}),initialize:function(){var e=this.options.currentViewState.relatesTo,t=null==e?void 0:e.value.contextualData.activationData;a.default.isEdge()&&this.add(i.View.extend({tagName:"p",className:"idx-webauthn-enroll-text-edge",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.enroll.webauthn.instructions.edge"},data:o,loc:{start:{line:1,column:0},end:{line:1,column:68}}}))},useData:!0})})),"required"===t.authenticatorSelection.userVerification&&this.add((0,i.createCallout)({className:"uv-required-callout",size:"slim",type:"warning",subtitle:(0,i.loc)("oie.enroll.webauthn.uv.required.instructions","login")}));var n=(0,s.getWebAuthnAdditionalInstructions)(this.options.currentViewState);n&&this.add(l.default,{options:{description:n}}),this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>')},getTemplateData:function(){var e,t;return{enrollI18nKey:(0,u.getWebAuthnI18nKey)({DEFAULT:"oie.enroll.webauthn.instructions",PASSKEYS:"oie.enroll.webauthn.passkeysRebrand.instructions",CUSTOM:"oie.enroll.webauthn.passkeysRebrand.instructions"},null===(e=this.options.currentViewState.relatesTo)||void 0===e||null===(t=e.value)||void 0===t?void 0:t.displayName)}}});t.default=c,e.exports=t.default},65387:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(6475),i=n(17587),a=r(n(83966)),s=r(n(49268)),l=r(n(76587)),u=r(n(46523)),c=n(43318),d=n(25795),f=n(13056);var p=i.BaseForm.extend({title:function(){return(0,d.getWebAuthnTitle)(this.options.currentViewState,!1)},className:"oie-enroll-webauthn",modelEvents:{error:"_stopEnrollment"},getUISchema:function(){var e,t,n=this,r=[];s.default.isNewApiAvailable()?(r.push({View:u.default}),r.push({View:(0,o.createButton)({className:"webauthn-setup button button-primary button-wide",title:(0,o.loc)("oie.enroll.webauthn.save","login"),click:function(){n.triggerWebauthnPrompt()}})})):r.push({View:(0,o.createCallout)({className:"webauthn-not-supported",type:"error",subtitle:(0,f.getWebAuthnI18nKey)({DEFAULT:(0,o.loc)("oie.webauthn.error.not.supported","login"),PASSKEYS:(0,o.loc)("oie.webauthn.passkeysRebrand.error.not.supported","login"),CUSTOM:(0,o.loc)("oie.webauthn.passkeysRebrand.error.not.supported","login")},null===(e=this.options.currentViewState.relatesTo)||void 0===e||null===(t=e.value)||void 0===t?void 0:t.displayName)})});return r},triggerWebauthnPrompt:function(){var e=this;this.$el.find(".o-form-error-container").empty(),this._startEnrollment();var t=this.options.currentViewState.relatesTo,n=null==t?void 0:t.value.contextualData.activationData;if(s.default.isNewApiAvailable()){var r,i=!0===(null===(r=n.authenticatorSelection)||void 0===r?void 0:r.requireResidentKey)?[]:function(){var e=[];return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).forEach((function(t){"webauthn"===t.key&&e.push({type:"public-key",id:l.default.strToBin(t.credentialId)})})),e}(this.options.appState.get("authenticatorEnrollments").value),a=o._.extend({},n,{challenge:l.default.strToBin(n.challenge),user:{id:l.default.strToBin(n.user.id),name:n.user.name,displayName:n.user.displayName},excludeCredentials:i});"undefined"!=typeof AbortController&&(this.webauthnAbortController=new AbortController),navigator.credentials.create({publicKey:a,signal:this.webauthnAbortController&&this.webauthnAbortController.signal}).then((function(t){e.model.set({credentials:{clientData:l.default.binToStr(t.response.clientDataJSON),attestation:l.default.binToStr(t.response.attestationObject),transports:s.default.processWebAuthnResponse(t.response.getTransports,t.response),clientExtensions:s.default.processWebAuthnResponse(t.getClientExtensionResults,t)}}),e.saveForm(e.model)})).catch((function(t){e.model.trigger("error",e.model,{responseJSON:{errorSummary:(0,c.getMessageFromBrowserError)(t)}})})).finally((function(){e.webauthnAbortController=null}))}},_startEnrollment:function(){this.$(".okta-waiting-spinner").show(),this.$(".webauthn-setup").hide()},_stopEnrollment:function(){this.$(".okta-waiting-spinner").hide(),this.$(".webauthn-setup").show()}}),h=a.default.extend({Body:p,postRender:function(){a.default.prototype.postRender.apply(this,arguments),this.$el.find('.o-form-button-bar [type="submit"]').remove()}});t.default=h,e.exports=t.default},33705:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=i.View.extend({className:"oie-webauthn-additional-instructions",initialize:function(){var e=this.options.description;e&&(this.add(i.View.extend({className:"additional-instructions-title",template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"<p>"+e.escapeExpression((i(n,"i18n")||t&&i(t,"i18n")||e.hooks.helperMissing).call(null!=t?t:e.nullContext||{},{name:"i18n",hash:{bundle:"login",code:"oie.verify.webauthn.instructions.additional"},data:o,loc:{start:{line:1,column:3},end:{line:1,column:77}}}))+"</p>"},useData:!0})})),this.add((0,i.createCallout)({subtitle:e,className:"additional-instructions-callout"})))}});t.default=a,e.exports=t.default},23986:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(2875)),i=n(6475),a=r(n(71750)),s=r(n(83966)),l=i.View.extend({template:o.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){return'<div aria-hidden="true" class="yubikey-demo"></div>'},useData:!0})}),u=a.default.extend({title:function(){return this.options.appState.isAuthenticatorChallenge()?(0,i.loc)("oie.yubikey.challenge.title","login"):(0,i.loc)("oie.yubikey.enroll.title","login")},subtitle:function(){return(0,i.loc)("oie.yubikey.description","login")},save:function(){return(0,i.loc)("mfa.challenge.verify","login")},getUISchema:function(){var e=a.default.prototype.getUISchema.apply(this,arguments);return e.unshift({View:l,selector:".o-form-fieldset-container"}),e}}),c=s.default.extend({Body:u});t.default=c,e.exports=t.default},22544:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=o.$.extend(!0,{},e.authParams,o._.pick(t,a.default.AUTH_PARAMS)),r=Object.assign({},e,t),s=r.el,l=r.clientId,u=r.redirectUri,c=Object.assign({},{el:s,clientId:l,redirectUri:u,authParams:n});if(!c.el)throw new i.ConfigError('"el" is required');if(!c.clientId)throw new i.ConfigError('"clientId" is required');if(!c.redirectUri)throw new i.ConfigError('"redirectUri" is required');return c};var o=n(6475),i=n(13671),a=r(n(97329));e.exports=t.default},99083:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n,r,a,s,l){var u,c,d=new Promise((function(e,t){u=e,c=t})),f=o.$.extend(!0,{},t,n,{authClient:r,hooks:l,globalSuccessFn:function(e){a&&a(e),e&&e.status===i.default.SUCCESS&&u(e)},globalErrorFn:function(e){s&&s(e),c(e)}}),p=new e(f);return p.start(),{router:p,routerOptions:f,promise:d}};var o=n(6475),i=r(n(35546));e.exports=t.default},78998:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.OktaAuth=void 0;var r=n(2659),o=n(50356),i=(0,r.mixinAuthn)(o.OktaAuth);t.OktaAuth=i},50356:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.OktaAuth=void 0;var r=n(2659),o=(0,r.createIdxOptionsConstructor)(),i=(0,r.createIdxStorageManager)(),a=(0,r.createIdxTransactionManager)(),s=(0,r.createOktaAuthOAuth)(i,o,a),l=(0,r.mixinIdx)(s);t.OktaAuth=l},92484:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r=n(3528).OktaSignIn;t.default=r,e.exports=t.default},3528:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0});var o={OktaSignIn:!0};t.default=t.OktaSignIn=void 0;var i=r(n(78463)),a=r(n(39131)),s=r(n(35075)),l=r(n(35432)),u=r(n(2132)),c=n(78998),d=n(22390),f=n(44371),p=n(8347);function h(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,u.default)(e);if(t){var o=(0,u.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,l.default)(this,n)}}Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var m=function(e){(0,s.default)(n,e);var t=h(n);function n(e){return(0,a.default)(this,n),t.call(this,e)}return(0,i.default)(n)}((0,f.createOktaSignIn)(c.OktaAuth,d.routerClassFactory));t.OktaSignIn=m;var v=m;t.default=v},76404:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(39131)),i=r(n(78463)),a=r(n(35075)),s=r(n(35432)),l=r(n(2132)),u=n(6475),c=n(53736);function d(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,l.default)(e);if(t){var o=(0,l.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,s.default)(this,n)}}var f=function(e){(0,a.default)(n,e);var t=d(n);function n(){return(0,o.default)(this,n),t.apply(this,arguments)}return(0,i.default)(n,[{key:"mergeHook",value:function(e,t){var n=this.get("hooks")||{};(0,c.mergeHook)(n,e,t),this.set("hooks",n)}},{key:"getHook",value:function(e){return(this.get("hooks")||{})[e]}}]),n}(u.Model);t.default=f,e.exports=t.default},27447:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(39131)),i=r(n(78463)),a=r(n(35075)),s=r(n(35432)),l=r(n(2132)),u=r(n(2875)),c=n(6475),d=r(n(7174)),f=r(n(6321)),p=r(n(34425)),h=n(13671),m=r(n(78719)),v=r(n(36894)),g=r(n(90570)),y=r(n(73390)),b=n(19838);function w(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,l.default)(e);if(t){var o=(0,l.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,s.default)(this,n)}}var _=c.internal.util.Util,O=u.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return"https://global.oktacdn.com/okta-signin-widget/"+e.escapeExpression("function"==typeof(i=null!=(i=a(n,"version")||(null!=t?a(t,"version"):t))?i:e.hooks.helperMissing)?i.call(null!=t?t:e.nullContext||{},{name:"version",hash:{},data:o,loc:{start:{line:1,column:46},end:{line:1,column:57}}}):i)},useData:!0}),k={authClient:["object",!1,void 0],baseUrl:["string",!0],recoveryToken:["string",!1,void 0],stateToken:["string",!1,void 0],username:["string",!1],relayState:["string",!1],signOutLink:["string",!1],backToSignInLink:["string",!1],redirect:{type:"string",values:["never","always","auto"],value:"auto"},flow:["string",!1,"default"],transformUsername:["function",!1],globalSuccessFn:"function",globalErrorFn:"function",processCreds:"function",hooks:"object",logo:"string",logoText:["string",!1],helpSupportNumber:"string",proxyIdxResponse:["object",!1],overrideExistingStateToken:["boolean",!1,!1],"features.router":["boolean",!0,!1],"features.securityImage":["boolean",!0,!1],"features.rememberMe":["boolean",!0,!0],"features.autoPush":["boolean",!0,!1],"features.smsRecovery":["boolean",!0,!1],"features.callRecovery":["boolean",!0,!1],"features.emailRecovery":["boolean",!1,!0],"features.webauthn":["boolean",!0,!1],"features.selfServiceUnlock":["boolean",!0,!1],"features.multiOptionalFactorEnroll":["boolean",!0,!1],"features.deviceFingerprinting":["boolean",!1,!1],"features.hideSignOutLinkInMFA":["boolean",!1,!1],"features.skipIdpFactorVerificationBtn":["boolean",!1,!1],"features.hideBackToSignInForReset":["boolean",!1,!1],"features.customExpiredPassword":["boolean",!0,!1],"features.registration":["boolean",!1,!1],"features.idpDiscovery":["boolean",!1,!1],"features.passwordlessAuth":["boolean",!1,!1],"features.showPasswordToggleOnSignInPage":["boolean",!1,!1],"features.trackTypingPattern":["boolean",!1,!1],"features.redirectByFormSubmit":["boolean",!1,!1],"features.useDeviceFingerprintForSecurityImage":["boolean",!1,!0],"features.showPasswordRequirementsAsHtmlList":["boolean",!1,!1],"features.mfaOnlyFlow":["boolean",!1,!1],"features.scrollOnError":["boolean",!1,!0],"features.showKeepMeSignedIn":["boolean",!1,!0],"features.showIdentifier":["boolean",!1,!0],"features.autoFocus":["boolean",!1,!0],"features.sameDeviceOVEnrollmentEnabled":["boolean",!1,!1],"features.showSessionRevocation":["boolean",!1,!1],"features.disableAutocomplete":["boolean",!1,!1],defaultCountryCode:["string",!1,"US"],language:["any",!1],i18n:["object",!1],"assets.baseUrl":["string",!1],"assets.rewrite":{type:"function",value:c._.identity},"assets.languages":["array",!1],issuer:"string",clientId:"string",redirectUri:"string",state:"string",nonce:"string",scopes:"array",codeChallenge:"string",codeChallengeMethod:["string",!1],oAuthTimeout:["number",!1],authScheme:["string",!1,"OAUTH2"],idps:["array",!1,[]],idpDisplay:{type:"string",values:["PRIMARY","SECONDARY"],value:"SECONDARY"},initialPopupPath:["string",!1],"helpLinks.help":"string","helpLinks.forgotPassword":"string","helpLinks.unlock":"string","helpLinks.custom":"array","helpLinks.factorPage.href":"string","helpLinks.factorPage.text":"string","helpLinks.gracePeriodRequiredSoon.href":"string","helpLinks.gracePeriodRequiredSoon.text":"string",customButtons:["array",!1,[]],policyId:"string","registration.click":"function","registration.parseSchema":"function","registration.preSubmit":"function","registration.postSubmit":"function","consent.cancel":"function","idpDiscovery.requestContext":"string","colors.brand":"string",cspNonce:"string",brandName:"string",piv:["object",!1,{}],otp:"string",useClassicEngine:["boolean",!1,!1],"hcaptcha.scriptSource":["string",!1],"hcaptcha.scriptParams":["object",!1,{}],"recaptcha.scriptSource":["string",!1]},x={backToSignInUri:{deps:["backToSignInLink","signOutLink"],fn:function(e,t){return e||t}},showPasswordToggle:{deps:["features.showPasswordToggleOnSignInPage"],fn:function(){var e,t,n,r,o=null!==(e=null===(t=this.options)||void 0===t||null===(n=t.features)||void 0===n?void 0:n.showPasswordToggleOnSignInPage)&&void 0!==e?e:null===(r=this.options)||void 0===r?void 0:r["features.showPasswordToggleOnSignInPage"];return null==o||o},cache:!0},redirectUtilFn:{deps:["features.redirectByFormSubmit"],fn:function(e){return e?g.default.redirectWithFormGet.bind(g.default):_.redirect.bind(_)},cache:!0},supportedLanguages:{deps:["i18n","language","assets.languages"],fn:function(e,t,n){var r=n||d.default.supportedLanguages;return c._.union(r,c._.keys(e),c._.isString(t)?[t]:[])},cache:!0},languageCode:{deps:["language","supportedLanguages"],fn:function(e,t){var n=p.default.getUserLanguages();n.forEach((function(e,t){"nl"===e?n[t]="nl-NL":"pt"===e&&(n[t]="pt-BR")}));var r=c._.clone(n),o=g.default.toLower(t);c._.isString(e)?r.unshift(e):c._.isFunction(e)&&r.unshift(e(t,n)),r.push(d.default.defaultLanguage);var i,a,s=g.default.toLower(g.default.expandLanguages(r));for(i=0;i<s.length;i++)if((a=o.indexOf(s[i]))>-1)return t[a]}},languageTags:{deps:["language","supportedLanguages"],fn:b.getLanguageTags},countryCode:{deps:["defaultCountryCode"],fn:function(e){var t=y.default.getCountries();return Object.keys(t).includes(e)?e:"US"}},mode:{deps:["codeChallenge"],fn:function(e){return e?"remediation":"relying-party"}},oauth2Enabled:{deps:["clientId","authScheme","authClient"],fn:function(e,t,n){return!e&&n&&(e=n.options.clientId),!!e&&"oauth2"===t.toLowerCase()},cache:!0},oauthRedirectUri:{deps:["redirectUri"],fn:function(e){if(e)return e;var t=window.location.origin;if(!t){var n=window.location.href,r=window.location.pathname;""!==r&&(t=n.substring(0,n.lastIndexOf(r)))}return encodeURI(t)}},configuredSocialIdps:{deps:["idps"],fn:function(e){return c._.map(e,(function(e){var t=c._.clone(e),n=t.type&&t.type.toLowerCase();return n&&c._.contains(m.default.SUPPORTED_SOCIAL_IDPS,n)||(n="general-idp",t.text=t.text||"{ Please provide a text value }"),t.className=["social-auth-button","social-auth-"+n+"-button ",t.className?t.className:""].join(" "),t.dataAttr="social-auth-"+n+"-button",t.i18nKey="socialauth."+n+".label",t}))},cache:!0},hasPivCard:{deps:["piv"],fn:function(e){return e&&e.certAuthUrl},cache:!0},socialAuthPositionTop:{deps:["configuredSocialIdps","hasPivCard","idpDisplay"],fn:function(e,t,n){return(!c._.isEmpty(e)||t)&&"PRIMARY"===n.toUpperCase()},cache:!0},hasConfiguredButtons:{deps:["configuredSocialIdps","customButtons","hasPivCard"],fn:function(e,t,n){return!c._.isEmpty(e)||!c._.isEmpty(t)||n},cache:!0}},E=function(e){(0,a.default)(n,e);var t=w(n);function n(e,r){var i;(0,o.default)(this,n);var a=(i=t.call(this,e,r)).getAuthClient();return i.setAcceptLanguageHeader(a),i}return(0,i.default)(n,[{key:"get",value:function(e){return c.Model.prototype.get.call(this,e)}},{key:"preinitialize",value:function(){this.local=k,this.derived=x;for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];c.Model.prototype.preinitialize.apply(this,t)}},{key:"initialize",value:function(e){var t=e=e||{},n=t.colors,r=t.authClient,o=t.flow,i=e.baseUrl;if(!i){if(r)i=r.getIssuerOrigin();else{var a,s=e.authParams,l=e.issuer;i=null===(a=l=l||(null==s?void 0:s.issuer))||void 0===a?void 0:a.split("/oauth2/")[0]}this.set("baseUrl",i)}r&&o&&r.idx.setFlow(o),i?n&&c._.isString(n.brand)&&!n.brand.match(/^#[0-9A-Fa-f]{6}$/)?this.callGlobalError(new h.ConfigError((0,c.loc)("error.invalid.colors.brand"))):p.default.corsIsNotSupported()&&this.callGlobalError(new h.UnsupportedBrowserError((0,c.loc)("error.unsupported.cors"))):this.callGlobalError(new h.ConfigError((0,c.loc)("error.required.baseUrl")))}},{key:"setAcceptLanguageHeader",value:function(e){e&&e.http.setRequestHeader("Accept-Language",this.get("languageCode"))}},{key:"setAuthClient",value:function(e){this.set("authClient",e),this.setAcceptLanguageHeader(e)}},{key:"getAuthClient",value:function(){return this.get("authClient")}},{key:"set",value:function(){try{for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return c.Model.prototype.set.apply(this,t)}catch(e){var r=e.message?e.message:e;this.callGlobalError(new h.ConfigError(r))}}},{key:"callGlobalSuccess",value:function(e,t){var n=c._.extend(t,{status:e});c._.defer(c._.partial(this.get("globalSuccessFn"),n))}},{key:"callGlobalError",value:function(e){var t=this.get("globalErrorFn")||this.options.globalErrorFn;if(!t)throw e;t(e)}},{key:"transformUsername",value:function(e,t){var n=this.get("transformUsername");return n&&c._.isFunction(n)?n(e,t):e}},{key:"processCreds",value:function(e){var t=this.get("processCreds");return f.default.Promise((function(n){c._.isFunction(t)?2===t.length?t(e,n):(t(e),n()):n()}))}},{key:"parseRegistrationSchema",value:function(e,t,n){var r=this.get("registration.parseSchema");c._.isFunction(r)?r(e,(function(e){t(e)}),(function(e){(e=e||{errorSummary:(0,c.loc)("registration.default.callbackhook.error")}).callback="parseSchema",n(e)})):t(e)}},{key:"preRegistrationSubmit",value:function(e,t,n){var r=this.get("registration.preSubmit");c._.isFunction(r)?r(e,(function(e){t(e)}),(function(e){(e=e||{errorSummary:(0,c.loc)("registration.default.callbackhook.error")}).callback="preSubmit",n(e)})):t(e)}},{key:"postRegistrationSubmit",value:function(e,t,n){var r=this.get("registration.postSubmit");c._.isFunction(r)?r(e,(function(e){t(e)}),(function(e){(e=e||{errorSummary:(0,c.loc)("registration.default.callbackhook.error")}).callback="postSubmit",n(e)})):t(e)}},{key:"parse",value:function(e){if(e.labels||e.country){v.default.deprecate('Use "i18n" instead of "labels" and "country"');var t=e.labels||{};c._.each(e.country,(function(e,n){t["country."+n]=e})),e.i18n={},c._.each(d.default.supportedLanguages,(function(n){e.i18n[n]=t})),delete e.labels,delete e.country}e.assets||(e.assets={});var n=e.assets.baseUrl;return n?"/"===n[n.length-1]&&(e.assets.baseUrl=n.substring(0,n.length-1)):e.assets.baseUrl=O({version:d.default.version}),e}},{key:"isDsTheme",value:function(){return!1}}]),n}(c.Model);t.default=E,e.exports=t.default},22390:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.routerClassFactory=function(e){var t,n=!e.stateToken&&!e.clientId&&!e.proxyIdxResponse,r=e.stateToken&&o.default.isV1StateToken(e.stateToken),s=e.clientId&&!0===e.useClassicEngine;t=n||r||s?i.default:a.default;return t};var o=r(n(90570)),i=r(n(26207)),a=r(n(80585))},26963:function(){},80079:function(){},91322:function(){},72600:function(){},5122:function(){},8347:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(80079);Object.keys(r).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===r[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}}))}));var o=n(26963);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var i=n(91322);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var a=n(72600);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var s=n(5122);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=n(73006);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var u=n(16065);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=n(47341);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var d=n(64694);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}))},16065:function(){},73006:function(){},47341:function(){},64694:function(){},34425:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31752)),a=r(n(31049)),s=n(13671),l={},u="withCredentials"in new window.XMLHttpRequest,c=void 0!==window.XDomainRequest;l.corsIsNotSupported=function(){return!(u||c)},l.corsIsNotEnabled=function(e){return 0===e.status},l.localStorageIsNotSupported=function(){var e="test";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!1}catch(e){return!0}},l.supportsPushState=function(e){return!(!(e=e||window).history||!e.history.pushState)},l.isIE=function(){return/(msie|trident)/i.test(navigator.userAgent)},l.isFirefox=function(){return navigator.userAgent.toLowerCase().indexOf("firefox")>-1},l.isEdge=function(){return navigator.userAgent.toLowerCase().indexOf("edge")>-1},l.isSafari=function(){return navigator.userAgent.toLowerCase().indexOf("safari")>-1&&-1===navigator.userAgent.toLowerCase().indexOf("chrome")},l.isMac=function(){return navigator.platform.toUpperCase().indexOf("MAC")>=0},l.isAndroid=function(){return/android/i.test(navigator.userAgent)&&!/windows phone/i.test(navigator.userAgent)},l.isIOS=function(){return/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream},l.getChromeLNAPermissionState=function(){var e=(0,a.default)(o.default.mark((function e(t){var n;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(navigator.permissions&&"function"==typeof navigator.permissions.query){e.next=3;break}return t(void 0),e.abrupt("return");case 3:return e.prev=3,e.prev=4,e.next=7,navigator.permissions.query({name:"loopback-network"});case 7:n=e.sent,e.next=15;break;case 10:return e.prev=10,e.t0=e.catch(4),e.next=14,navigator.permissions.query({name:"local-network-access"});case 14:n=e.sent;case 15:t(n.state),e.next=23;break;case 18:if(e.prev=18,e.t1=e.catch(3),!(e.t1 instanceof s.ChromeLNADeniedError)){e.next=22;break}throw e.t1;case 22:t(void 0);case 23:case"end":return e.stop()}}),e,null,[[3,18],[4,10]])})));return function(t){return e.apply(this,arguments)}}(),l.getUserLanguages=function(){if(navigator.languages)return(0,i.default)(navigator.languages);var e=[];return["language","userLanguage","browserLanguage","systemLanguage"].forEach((function(t){navigator[t]&&e.push(navigator[t])})),e};var d=l;t.default=d,e.exports=t.default},52115:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(66583)),a=r(n(31049)),s=r(n(7174)),l=r(n(21147)),u=r(n(83755)),c=r(n(74752)),d=r(n(45091)),f=r(n(34425)),p=r(n(36894)),h="osw.languages";function m(e){if(!e)return{};var t={};return d.default.each(d.default.keys(e),(function(n){t[n.toLowerCase()]=e[n]})),d.default.mapObject(t,(function(e){var t={login:{},country:{}};if(!d.default.isObject(e))throw new Error('Invalid format for "i18n"');return d.default.each(e,(function(e,n){var r=n.split(/^country\./);r.length>1?t.country[r[1]]=e:t.login[r[0]]=e})),t}))}function v(){var e=JSON.parse(localStorage.getItem(h));return e&&e.version===s.default.version||(e={version:s.default.version}),e}function g(e,t,n){var r=v();r[e]={login:t,country:n},localStorage.setItem(h,JSON.stringify(r))}function y(e,t,n){var r=t.replace("-","_"),o=n.rewrite(encodeURI("/labels/json/".concat(e,"_").concat(r,".json")));return(0,l.default)(n.baseUrl+o,{method:"GET",headers:{Accept:"application/json"},mode:"cors"}).then((function(e){return e.text()})).then((function(e){return JSON.parse(e)}))}function b(e,t,n){return w.apply(this,arguments)}function w(){return(w=(0,a.default)(o.default.mark((function e(t,n,r){var a,l,u,c,h,m;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t!==s.default.defaultLanguage&&d.default.contains(r,t)){e.next=2;break}return e.abrupt("return",{});case 2:if(!(a=!f.default.localStorageIsNotSupported())){e.next=7;break}if(!(l=v())[t]){e.next=7;break}return e.abrupt("return",l[t]);case 7:return e.prev=7,e.next=10,Promise.all([y("login",t,n),y("country",t,n)]);case 10:return u=e.sent,c=(0,i.default)(u,2),h=c[0],m=c[1],a&&g(t,h,m),e.abrupt("return",{login:h,country:m});case 18:return e.prev=18,e.t0=e.catch(7),p.default.warn("Unable to load language: "+t),e.abrupt("return",{});case 22:case"end":return e.stop()}}),e,null,[[7,18]])})))).apply(this,arguments)}var _,O={login:c.default,country:u.default,courage:c.default,currentLanguage:null,isLoaded:function(e){return this.currentLanguage===e},remove:function(){this.currentLanguage=null},loadLanguage:(_=(0,a.default)(o.default.mark((function e(t,n,r,i){var a,s,l;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return a=m(n),s=t.toLowerCase(),e.next=4,b(t,r,i);case 4:l=e.sent,this.login=d.default.extend({},c.default,l.login),this.country=d.default.extend({},u.default,l.country),this.courage=d.default.extend({},c.default,l.login),a[s]&&(d.default.extend(this.login,a[s].login),d.default.extend(this.country,a[s].country),d.default.extend(this.courage,a[s].login)),this.currentLanguage=t;case 10:case"end":return e.stop()}}),e,this)}))),function(e,t,n,r){return _.apply(this,arguments)})};t.default=O,e.exports=t.default},13671:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.WebauthnAbortError=t.WebAuthnError=t.UnsupportedBrowserError=t.U2FError=t.RegistrationError=t.OAuthError=t.ConfiguredFlowError=t.ConfigError=t.ChromeLNADeniedError=t.AuthStopPollInitiationError=void 0;var o=r(n(78463)),i=r(n(39131)),a=r(n(77111)),s=r(n(35075)),l=r(n(35432)),u=r(n(2132)),c=r(n(19457)),d=n(71244),f=r(n(35546));function p(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,u.default)(e);if(t){var o=(0,u.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,l.default)(this,n)}}var h=function(e){(0,s.default)(n,e);var t=p(n);function n(e){var r;return(0,i.default)(this,n),r=t.call(this,e),Object.setPrototypeOf((0,a.default)(r),(this instanceof n?this.constructor:void 0).prototype),r}return(0,o.default)(n)}((0,c.default)(Error)),m=function(e){(0,s.default)(n,e);var t=p(n);function n(e){var r;return(0,i.default)(this,n),(r=t.call(this,e||(0,d.loc)("error.config"))).name=f.default.CONFIG_ERROR,r}return(0,o.default)(n)}(h);t.ConfigError=m;var v=function(e){(0,s.default)(n,e);var t=p(n);function n(e){var r;return(0,i.default)(this,n),(r=t.call(this,e||(0,d.loc)("error.unsupported.browser"))).name=f.default.UNSUPPORTED_BROWSER_ERROR,r}return(0,o.default)(n)}(h);t.UnsupportedBrowserError=v;var g=function(e){(0,s.default)(n,e);var t=p(n);function n(){var e;(0,i.default)(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return(e=t.call.apply(t,[this].concat(o))).name=f.default.OAUTH_ERROR,e}return(0,o.default)(n)}(h);t.OAuthError=g;var y=function(e){(0,s.default)(n,e);var t=p(n);function n(){var e;(0,i.default)(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return(e=t.call.apply(t,[this].concat(o))).name=f.default.REGISTRATION_FAILED,e}return(0,o.default)(n)}(h);t.RegistrationError=y;var b=function(e){(0,s.default)(n,e);var t=p(n);function n(){var e;(0,i.default)(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return(e=t.call.apply(t,[this].concat(o))).name=f.default.AUTH_STOP_POLL_INITIATION_ERROR,e}return(0,o.default)(n)}(h);t.AuthStopPollInitiationError=b;var w=function(e){(0,s.default)(n,e);var t=p(n);function n(e){var r,o,a;return(0,i.default)(this,n),(a=t.call(this,null===(r=e.xhr)||void 0===r||null===(o=r.responseJSON)||void 0===o?void 0:o.errorSummary)).name=f.default.U2F_ERROR,a.xhr=e.xhr,a}return(0,o.default)(n)}(h);t.U2FError=w;var _=function(e){(0,s.default)(n,e);var t=p(n);function n(e){var r,o,a;return(0,i.default)(this,n),(a=t.call(this,null===(r=e.xhr)||void 0===r||null===(o=r.responseJSON)||void 0===o?void 0:o.errorSummary)).name=f.default.WEB_AUTHN_ERROR,a.xhr=e.xhr,a}return(0,o.default)(n)}(h);t.WebAuthnError=_;var O=function(e){(0,s.default)(n,e);var t=p(n);function n(){var e;(0,i.default)(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return(e=t.call.apply(t,[this].concat(o))).name=f.default.WEBAUTHN_ABORT_ERROR,e}return(0,o.default)(n)}(h);t.WebauthnAbortError=O;var k=function(e){(0,s.default)(n,e);var t=p(n);function n(e,r){var o;return(0,i.default)(this,n),(o=t.call(this,e)).name=f.default.CONFIGURED_FLOW_ERROR,o.flowSetting=r,o}return(0,o.default)(n)}(h);t.ConfiguredFlowError=k;var x=function(e){(0,s.default)(n,e);var t=p(n);function n(){var e;(0,i.default)(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return(e=t.call.apply(t,[this].concat(o))).name=f.default.CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR,e}return(0,o.default)(n)}(h);t.ChromeLNADeniedError=x},19838:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.loadLanguage=t.getLanguageTags=void 0;var o=r(n(31752)),i=r(n(66583)),a=r(n(52115)),s=r(n(7174)),l=r(n(34425)),u=r(n(90570));t.getLanguageTags=function(e,t){var n,r=l.default.getUserLanguages().map((function(e){return"nl"===e?"nl-nl":"pt"===e?"pt-br":e.toLowerCase()})),a=new Map,c=function(e){if(e){var t=e.split("-"),n=(0,i.default)(t,1)[0];if(a.has(n)){var r,o=null!==(r=a.get(n))&&void 0!==r?r:new Set;o.add(e),a.set(n,o)}else a.set(n,new Set([e]))}},d=r.filter((function(e){return t.some((function(t){return e.startsWith(t.toLowerCase())}))}));if(d.forEach(c),u.default.expandLanguages(d).forEach(c),void 0!==e){if("string"==typeof e)n=e.toLowerCase();else if("function"==typeof e){var f;n=null===(f=e(t,r))||void 0===f?void 0:f.toLowerCase()}u.default.expandLanguages([n]).forEach(c)}u.default.expandLanguages([s.default.defaultLanguage.toLowerCase()]).forEach(c);var p=[];if(n){var h,m=n.split("-"),v=(0,i.default)(m,1)[0];p.push.apply(p,(0,o.default)(null!==(h=a.get(v))&&void 0!==h?h:[])),a.delete(v)}return a.forEach((function(e){p.push.apply(p,(0,o.default)(e))})),p};t.loadLanguage=function(e,t){var n=e.get("languageCode")||t.get("languageCode")||s.default.defaultLanguage,r=t.get("i18n"),o=t.get("assets.baseUrl"),i=t.get("assets.rewrite"),l=t.get("supportedLanguages"),u=setTimeout((function(){e.trigger("loading",!0)}),200);return a.default.loadLanguage(n,r,{baseUrl:o,rewrite:i},l).then((function(){clearTimeout(u),e.trigger("loading",!1),e.trigger("removeLoading")}))}},45570:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.UserNotAssignedError=t.TypedOAuthError=t.RecoverableError=t.NonRecoverableError=t.MfaRequiredError=t.JITProfileProvisioningError=t.ClockDriftError=void 0,t.getTypedOAuthError=function(e){switch(e.errorCode){case"access_denied":return new y(e);case"jit_failure_missing_fields":case"jit_failure_invalid_login_format":case"jit_failure_values_not_match_pattern":case"jit_failure_values_too_long":case"jit_failure_invalid_locale":return new b(e);case"login_required":if("The client specified not to prompt, but the client app requires re-authentication or MFA."===e.message)return new w(e);case"INTERNAL":if("The JWT was issued in the future"===e.message)return new g(e);default:return new m(e,Object)}};var o=r(n(35075)),i=r(n(35432)),a=r(n(2132)),s=r(n(78463)),l=r(n(39131)),u=n(71244),c=n(13671);function d(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,a.default)(e);if(t){var o=(0,a.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,i.default)(this,n)}}var f=(0,s.default)((function e(){(0,l.default)(this,e),this.inline=!0})),p=(0,s.default)((function e(){(0,l.default)(this,e),this.terminal=!0})),h=function(e){(0,o.default)(n,e);var t=d(n);function n(e,r){var o;return(0,l.default)(this,n),(o=t.call(this,e.message)).errorType=new r,o.orginalError=e,o.errorDetails={errorSummary:o.getErrorSummary(),errorCode:e.errorCode,errorCauses:"errorCauses"in e?e.errorCauses:void 0},o}return(0,s.default)(n,[{key:"getErrorSummary",value:function(){return this.orginalError.errorSummary}},{key:"is",value:function(e){var t;return Boolean(null===(t=Object.getOwnPropertyDescriptor(this.errorType,e))||void 0===t?void 0:t.value)}}]),n}(c.OAuthError);t.TypedOAuthError=h;var m=function(e){(0,o.default)(n,e);var t=d(n);function n(){return(0,l.default)(this,n),t.apply(this,arguments)}return(0,s.default)(n)}(h);t.RecoverableError=m;var v=function(e){(0,o.default)(n,e);var t=d(n);function n(){return(0,l.default)(this,n),t.apply(this,arguments)}return(0,s.default)(n)}(h);t.NonRecoverableError=v;var g=function(e){(0,o.default)(n,e);var t=d(n);function n(e){return(0,l.default)(this,n),t.call(this,e,p)}return(0,s.default)(n,[{key:"getErrorSummary",value:function(){return(0,u.loc)("error.unsynced.clock","login")}}]),n}(m);t.ClockDriftError=g;var y=function(e){(0,o.default)(n,e);var t=d(n);function n(e){return(0,l.default)(this,n),t.call(this,e,f)}return(0,s.default)(n)}(m);t.UserNotAssignedError=y;var b=function(e){(0,o.default)(n,e);var t=d(n);function n(e){return(0,l.default)(this,n),t.call(this,e,f)}return(0,s.default)(n,[{key:"getErrorSummary",value:function(){return(0,u.loc)("error.jit_failure","login")}}]),n}(m);t.JITProfileProvisioningError=b;var w=function(e){(0,o.default)(n,e);var t=d(n);function n(e){return(0,l.default)(this,n),t.call(this,e,f)}return(0,s.default)(n,[{key:"getErrorSummary",value:function(){return(0,u.loc)("error.mfa.required","login")}}]),n}(v);t.MfaRequiredError=w},71244:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.loc=t.doesTranslationExist=void 0;var o=r(n(12990)),i=r(n(52115));t.doesTranslationExist=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"login",n=a(t);return!(null==n||!n[e])};t.loc=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"login",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],o=a(t);if(!o)return s(e,t,"bundle"),"L10N_ERROR["+t+"]";var i=o[e];try{return(i=u(i,n=n&&n.slice?n.slice(0):[]))||(s(e,t,"key"),"L10N_ERROR["+e+"]")}catch(n){return r||s(e,t,"parameters"),"L10N_ERROR["+e+"]"}};function a(e){if(!e){var t=Object.keys(i.default).filter((function(e){return"object"===(0,o.default)(e)}))[0];return i.default[t]}var n,r,a=function(e){if(/-/.test(e)){var t=e.split("-");return t[1]=t[1].toUpperCase(),t.join("_")}return e}((null===(n=window)||void 0===n||null===(r=n.okta)||void 0===r?void 0:r.locale)||"en");return i.default["".concat(e,"_").concat(a)]||i.default[e]}function s(e,t,n){var r=l("okta-i18n-error",{detail:{type:"l10n-error",key:e,bundleName:t,reason:n}});r&&document.dispatchEvent(r)}var l=function(e,t){if("function"==typeof window.CustomEvent)return new CustomEvent(e,t);if(!window.CustomEvent){t=t||{bubbles:!1,cancelable:!1,detail:null};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}};function u(e,t){function n(){throw new Error("Mismatch number of variables: "+e+", "+JSON.stringify(t))}for(var r=e,o=e,i=0,a=t.length;i<a;i++){var s=String(t[i]),l=new RegExp("\\{"+i+"\\}","g");o=o.replace(l,s),null!=s&&o!==r||n(),r=o}return/\{[\d+]\}/.test(o)&&n(),o}},13056:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.isCustomDisplayName=t.getWebAuthnI18nParams=t.getWebAuthnI18nKey=t.WEBAUTHN_I18N_KEYS=t.WEBAUTHN_DISPLAY_NAMES=void 0;var o=r(n(12990)),i={DEFAULT:"Security Key or Biometric",PASSKEYS:"Passkeys"};t.WEBAUTHN_DISPLAY_NAMES=i;t.WEBAUTHN_I18N_KEYS={ENROLL_TITLE:{DEFAULT:"oie.enroll.webauthn.title",PASSKEYS:"oie.enroll.webauthn.passkeysRebrand.passkeys.title",CUSTOM:"oie.enroll.webauthn.passkeysRebrand.custom.title"},VERIFY_TITLE:{DEFAULT:"oie.verify.webauth.title",PASSKEYS:"oie.verify.webauth.passkeysRebrand.passkeys.title",CUSTOM:"oie.verify.webauth.passkeysRebrand.custom.title"},DESCRIPTION:{DEFAULT:"oie.webauthn.description",PASSKEYS:"oie.webauthn.passkeysRebrand.passkeys.description",CUSTOM:"oie.webauthn.description"},SELECT_ENROLL_LABEL:{DEFAULT:"oie.select.authenticator.enroll.webauthn.label",PASSKEYS:"oie.select.authenticator.enroll.webauthn.passkeysRebrand.passkeys.label",CUSTOM:"oie.select.authenticator.enroll.webauthn.passkeysRebrand.custom.label"},SELECT_VERIFY_LABEL:{DEFAULT:"oie.select.authenticator.verify.webauthn.label",PASSKEYS:"oie.select.authenticator.verify.webauthn.passkeysRebrand.passkeys.label",CUSTOM:"oie.select.authenticator.verify.webauthn.passkeysRebrand.custom.label"},LABEL:{DEFAULT:"oie.webauthn.label",PASSKEYS:"oie.webauthn.passkeysRebrand.passkeys.label",CUSTOM:"oie.webauthn.label"},ENROLL_INSTRUCTIONS:{DEFAULT:"oie.enroll.webauthn.instructions",PASSKEYS:"oie.enroll.webauthn.passkeysRebrand.instructions",CUSTOM:"oie.enroll.webauthn.passkeysRebrand.instructions"},VERIFY_INSTRUCTIONS:{DEFAULT:"oie.verify.webauthn.instructions",PASSKEYS:"oie.verify.webauthn.passkeysRebrand.instructions",CUSTOM:"oie.verify.webauthn.passkeysRebrand.instructions"}};var a=function(e){return Boolean(e&&e!==i.DEFAULT&&e!==i.PASSKEYS)};t.isCustomDisplayName=a;t.getWebAuthnI18nKey=function(e,t){return"string"==typeof e?e:e&&"object"===(0,o.default)(e)?t===i.PASSKEYS&&e.PASSKEYS?e.PASSKEYS:a(t)&&e.CUSTOM?e.CUSTOM:e.DEFAULT||null:null};t.getWebAuthnI18nParams=function(e){return a(e)&&e?[e]:[]}},26207:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(45385)),i=r(n(91939)),a=r(n(61525)),s=r(n(24687)),l=r(n(98318)),u=r(n(93100)),c=r(n(93788)),d=r(n(43252)),f=r(n(76920)),p=r(n(4374)),h=r(n(90192)),m=r(n(66493)),v=r(n(87459)),g=r(n(83567)),y=r(n(40471)),b=r(n(25523)),w=r(n(6418)),_=r(n(98702)),O=r(n(33874)),k=r(n(70567)),x=r(n(32436)),E=r(n(41438)),T=r(n(87312)),S=r(n(85584)),A=r(n(43125)),P=r(n(63824)),C=r(n(53177)),R=r(n(38889)),I=r(n(2093)),N=r(n(61437)),M=r(n(94408)),j=r(n(40635)),D=r(n(32992)),L=r(n(47685)),U=r(n(26e3)),F=r(n(29161)),B=r(n(31539)),V=r(n(37210)),Z=r(n(23947)),H=r(n(33243)),q=r(n(46615)),W=r(n(79518)),K=r(n(79636)),$=r(n(30929)),z=r(n(94617)),Y=r(n(78070)),G=r(n(72468)),J=r(n(15629)),Q=r(n(68358)),X=r(n(38864)),ee=r(n(92835)),te=r(n(45375)),ne=r(n(25152)),re=r(n(73269)),oe=r(n(75996)),ie=r(n(67934)),ae=r(n(20109)),se=r(n(9695)),le=r(n(94164)),ue=r(n(35546)),ce=ie.default.extend({routes:{"":"defaultAuth",signin:"primaryAuth","signin/okta/:username":"primaryAuth","signin/verify/duo/web":"verifyDuo","signin/verify/piv":"verifyPIV","signin/poll":"poll","signin/verify/fido/webauthn":"verifyWebauthn","signin/verify/webauthn":"verifyWebauthn","signin/verify/fido/u2f":"verifyU2F","signin/verify/u2f":"verifyU2F","signin/verify/generic_saml/assertion:saml2":"verifySAMLFactor","signin/verify/generic_oidc/assertion:oidc":"verifyOIDCFactor","signin/verify/custom/claims_provider":"verifyClaimsFactor","signin/verify/:factorType":"verifyNoProvider","signin/verify/:provider/:factorType(/:factorIndex)":"verify","signin/enroll":"enrollChoices","signin/enroll/duo/web":"enrollDuo","signin/enroll/okta/question":"enrollQuestion","signin/enroll/okta/password":"enrollPassword","signin/enroll/okta/sms":"enrollSms","signin/enroll/okta/call":"enrollCall","signin/enroll/okta/email":"enrollEmail","signin/enroll-activate/okta/sms":"enrollSms","signin/enroll-activate/okta/call":"enrollCall","signin/enroll/rsa/token":"enrollRsa","signin/enroll/del_oath/token":"enrollOnPrem","signin/enroll/symantec/token":"enrollSymantecVip","signin/enroll/yubico/token:hardware":"enrollYubikey","signin/enroll/fido/webauthn":"enrollWebauthn","signin/enroll/fido/u2f":"enrollU2F","signin/enroll/generic_saml/assertion:saml2":"enrollSAMLFactor","signin/enroll/generic_oidc/assertion:oidc":"enrollOIDCFactor","signin/enroll/custom/claims_provider":"enrollClaimsFactor","signin/enroll/custom/token:hotp":"enrollHotpFactor","signin/enroll/:provider/:factorType":"enrollTotpFactor","signin/enroll-activate/okta/email":"enrollActivateEmail","signin/enroll-activate/okta/push":"scanBarcodePushFactor","signin/enroll-activate/okta/push/manual":"manualSetupPushFactor","signin/enroll-activate/okta/push/sent":"activationLinkSent","signin/enroll-activate/okta/token:software:totp/passcode":"enterPasscodeInPushEnrollmentFlow","signin/enroll-activate/custom/claims_provider":"enrollActivateClaimsFactor","signin/enroll-activate/:provider/:factorType":"scanBarcodeTotpFactor","signin/enroll-activate/:provider/:factorType/activate":"activateTotpFactor","signin/enroll-activate/:provider/:factorType/manual":"manualSetupTotpFactor","signin/password-expired":"passwordExpired","signin/custom-password-expired":"customPasswordExpired","signin/forgot-password":"forgotPassword","signin/recovery-challenge":"recoveryChallenge","signin/recovery-emailed":"recoveryEmailSent","signin/recovery-question":"recoveryQuestion","signin/password-reset":"passwordReset","signin/reset-password/:token":"recoveryLoading","signin/user-unlock/:token":"recoveryLoading","signin/recovery/:token":"recoveryLoading","signin/unlock-emailed":"unlockEmailSent","signin/unlock":"unlockAccount","signin/account-unlocked":"accountUnlocked","signin/refresh-auth-state(/:token)":"refreshAuthState","signin/register":"register","signin/register-complete":"registerComplete","signin/error":"errorState","signin/consent":"consentRequired","signin/admin-consent":"adminConsentRequired","signin/enroll-user":"enrollUser","signin/device-activate-complete":"deviceActivateComplete","signin/device-activate":"deviceActivate","signin/idp-discovery-check":"idpDiscoveryCheck","*wildcard":"defaultAuth"},stateLessRouteHandlers:["defaultAuth","idpDiscovery","primaryAuth","forgotPassword","recoveryLoading","unlockAccount","refreshAuthState","register","registerComplete","errorState","verifyPIV"],defaultAuth:function(){window.location.hash!=="#".concat(ue.default.WIDGET_CONTAINER_ID)?this.settings.get("features.idpDiscovery")?this.idpDiscovery():this.primaryAuth():document.getElementById(ue.default.WIDGET_CONTAINER_ID).focus()},idpDiscoveryCheck:function(){this.render(j.default,{Beacon:le.default})},idpDiscovery:function(){this.render(M.default,{Beacon:le.default})},primaryAuth:function(e){this.render(Z.default,{Beacon:le.default,username:e})},verifyDuo:function(){this.render(X.default,{provider:"DUO",factorType:"web",Beacon:ae.default})},verifyPIV:function(){this.render(ee.default,{Beacon:se.default})},poll:function(){this.render(V.default)},verifyWebauthn:function(){this.settings.get("features.webauthn")?this.render(ne.default,{provider:"FIDO",factorType:"webauthn",Beacon:ae.default}):this.render(re.default,{provider:"FIDO",factorType:"webauthn",Beacon:ae.default})},verifyU2F:function(){this.render(te.default,{provider:"FIDO",factorType:"u2f",Beacon:ae.default})},verifySAMLFactor:function(){this.render(Q.default,{provider:"GENERIC_SAML",factorType:"assertion:saml2",Beacon:ae.default})},verifyOIDCFactor:function(){this.render(Q.default,{provider:"GENERIC_OIDC",factorType:"assertion:oidc",Beacon:ae.default})},verifyClaimsFactor:function(){this.render(Q.default,{provider:"CUSTOM",factorType:"claims_provider",Beacon:ae.default})},verify:function(e,t,n){this.render(U.default,{provider:e.toUpperCase(),factorType:t,factorIndex:n,Beacon:ae.default})},verifyNoProvider:function(e){this.render(U.default,{factorType:e,Beacon:ae.default})},enrollChoices:function(){this.render(v.default,{Beacon:le.default})},enrollDuo:function(){this.render(y.default,{provider:"DUO",factorType:"web",Beacon:ae.default})},enrollQuestion:function(){this.render(k.default,{provider:"OKTA",factorType:"question",Beacon:ae.default})},enrollPassword:function(){this.render(O.default,{provider:"OKTA",factorType:"password",Beacon:ae.default})},enrollSms:function(){this.render(m.default,{provider:"OKTA",factorType:"sms",Beacon:ae.default})},enrollCall:function(){this.render(m.default,{provider:"OKTA",factorType:"call",Beacon:ae.default})},enrollEmail:function(){this.render(b.default,{provider:"OKTA",factorType:"email",Beacon:ae.default})},enrollActivateEmail:function(){this.render(h.default,{provider:"OKTA",factorType:"email",Beacon:ae.default})},enrollRsa:function(){this.render(_.default,{provider:"RSA",factorType:"token",Beacon:ae.default})},enrollOnPrem:function(){this.render(_.default,{provider:"DEL_OATH",factorType:"token",Beacon:ae.default})},enrollSymantecVip:function(){this.render(x.default,{provider:"SYMANTEC",factorType:"token",Beacon:ae.default})},enrollYubikey:function(){this.render(C.default,{provider:"YUBICO",factorType:"token:hardware",Beacon:ae.default})},enrollSAMLFactor:function(){this.render(g.default,{provider:"GENERIC_SAML",factorType:"assertion:saml2",Beacon:ae.default})},enrollOIDCFactor:function(){this.render(g.default,{provider:"GENERIC_OIDC",factorType:"assertion:oidc",Beacon:ae.default})},enrollClaimsFactor:function(){this.render(g.default,{provider:"CUSTOM",factorType:"claims_provider",Beacon:ae.default})},enrollActivateClaimsFactor:function(){this.render(p.default,{provider:"CUSTOM",factorType:"claims_provider",Beacon:ae.default})},enrollTotpFactor:function(e,t){this.render(E.default,{provider:e.toUpperCase(),factorType:t,Beacon:ae.default})},enrollHotpFactor:function(){this.render(w.default,{provider:"CUSTOM",factorType:"token:hotp",Beacon:ae.default})},enrollWebauthn:function(){this.settings.get("features.webauthn")?this.render(A.default,{provider:"FIDO",factorType:"webauthn",Beacon:ae.default}):this.render(P.default,{provider:"FIDO",factorType:"webauthn",Beacon:ae.default})},enrollU2F:function(){this.render(T.default,{provider:"FIDO",factorType:"u2f",Beacon:ae.default})},scanBarcodeTotpFactor:function(e,t){this.render(l.default,{provider:e.toUpperCase(),factorType:t,Beacon:ae.default})},scanBarcodePushFactor:function(){this.render(s.default,{provider:"OKTA",factorType:"push",Beacon:ae.default})},activateTotpFactor:function(e,t){this.render(i.default,{provider:e.toUpperCase(),factorType:t,Beacon:ae.default})},manualSetupTotpFactor:function(e,t){this.render(L.default,{provider:e.toUpperCase(),factorType:t,Beacon:ae.default})},manualSetupPushFactor:function(){this.render(D.default,{provider:"OKTA",factorType:"push",Beacon:ae.default})},activationLinkSent:function(){this.render(R.default,{provider:"OKTA",factorType:"push",Beacon:ae.default})},enterPasscodeInPushEnrollmentFlow:function(){this.render(I.default,{provider:"OKTA",factorType:"token:software:totp",Beacon:ae.default})},passwordExpired:function(){this.render(F.default,{Beacon:le.default})},customPasswordExpired:function(){this.render(c.default,{Beacon:le.default})},forgotPassword:function(){this.render(N.default)},recoveryChallenge:function(){this.render(q.default,{Beacon:le.default})},recoveryEmailSent:function(){this.render(H.default,{Beacon:le.default})},unlockEmailSent:function(){this.render(J.default,{Beacon:le.default})},recoveryQuestion:function(){this.render(K.default,{Beacon:le.default})},passwordReset:function(){this.render(B.default,{Beacon:le.default})},recoveryLoading:function(e){this.render(W.default,{token:e,Beacon:le.default})},unlockAccount:function(){this.render(G.default)},accountUnlocked:function(){this.render(o.default,{Beacon:le.default})},refreshAuthState:function(e){this.render($.default,{token:e,Beacon:le.default})},register:function(){this.render(Y.default)},registerComplete:function(){this.render(z.default)},errorState:function(){this.render(oe.default,{Beacon:le.default})},consentRequired:function(){this.render(u.default)},adminConsentRequired:function(){this.render(a.default)},enrollUser:function(){this.render(S.default)},deviceActivate:function(){this.render(d.default)},deviceActivateComplete:function(){this.render(f.default)}});t.default=ce,e.exports=t.default},4449:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(12990)),i=r(n(39131)),a=r(n(78463)),s=r(n(35075)),l=r(n(35432)),u=r(n(2132)),c=r(n(2875)),d=n(6475),f=r(n(66757)),p=r(n(1752));function h(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,u.default)(e);if(t){var o=(0,u.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,l.default)(this,n)}}var m="no-beacon",v="beacon-small beacon-loading";function g(e){return e&&e.equals(p.default)}function y(e){e.currentBeacon&&(e.currentBeacon.remove(),e.currentBeacon=null)}function b(e,t,n,r){e.add(t,{selector:n,options:r}),e.currentBeacon=e.first()}var w=function(e){(0,s.default)(n,e);var t=h(n);function n(){return(0,i.default)(this,n),t.apply(this,arguments)}return(0,a.default)(n,[{key:"preinitialize",value:function(){this.currentBeacon=null,this.template=c.default.template({1:function(e,t,n,r,i){var a,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<h1><img src="'+c((a=null!=(a=d(n,"logo")||(null!=t?d(t,"logo"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"logo",hash:{},data:i,loc:{start:{line:1,column:71},end:{line:1,column:79}}}):a))+'" class="auth-org-logo" alt="'+c((a=null!=(a=d(n,"logoText")||(null!=t?d(t,"logoText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"logoText",hash:{},data:i,loc:{start:{line:1,column:108},end:{line:1,column:120}}}):a))+' logo" aria-label="'+c((a=null!=(a=d(n,"logoText")||(null!=t?d(t,"logoText"):t))?a:l,(0,o.default)(a)===u?a.call(s,{name:"logoText",hash:{},data:i,loc:{start:{line:1,column:139},end:{line:1,column:151}}}):a))+' logo"></h1>'},compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,a=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="okta-sign-in-header auth-header">'+(null!=(i=a(n,"if").call(null!=t?t:e.nullContext||{},null!=t?a(t,"logo"):t,{name:"if",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o,loc:{start:{line:1,column:45},end:{line:1,column:170}}}))?i:"")+'<div data-type="beacon-container" class="beacon-container"></div></div><div class="auth-content"><div class="auth-content-inner"></div></div>'},useData:!0});for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];d.View.prototype.preinitialize.apply(this,t)}},{key:"initialize",value:function(e){e.settings.get("features.securityImage")||(this.$el.addClass(m),this.listenTo(e.appState,"loading",this.setLoadingBeacon),this.listenTo(e.appState,"removeLoading",this.removeLoadingBeacon))}},{key:"setBeacon",value:function(e,t){var n=this,r='[data-type="beacon-container"]',o=this.$(r),i=function(e,t,n){return e||t?!e&&n.loading?"load":e&&g(e)?t?"swap":"unload":e&&e.equals(t,n)?"same":!e&&t?"add":e&&!t?"remove":e instanceof t?"fade":"swap":"none"}(this.currentBeacon,e,t);switch(i){case"none":return void this.$el.addClass(m);case"same":return;case"add":return this.$el.removeClass(m),b(this,e,r,t),f.default.explode(o);case"remove":return this.$el.addClass(m),f.default.implode(o).then((function(){y(n)})).done();case"fade":if(!this.currentBeacon.fadeOut)throw new Error('The current beacon is missing the "fadeOut" method');return t.animate=!0,this.currentBeacon.fadeOut().then((function(){y(n),b(n,e,r,t)})).done();case"swap":return f.default.swapBeacons({$el:o,swap:function(){var i=g(n.currentBeacon);y(n),n.$el.removeClass(m),i&&o.removeClass(v),b(n,e,r,t)}}).done();case"load":return o.addClass(v),b(this,e,r,t),f.default.explode(o);case"unload":return this.removeLoadingBeacon();default:throw new Error('the "'+i+'" is not recognized')}}},{key:"setLoadingBeacon",value:function(e){e&&!g(this.currentBeacon)&&this.setBeacon(p.default,{loading:!0})}},{key:"removeLoadingBeacon",value:function(){var e=this;if(g(this.currentBeacon)){var t=this.$('[data-type="beacon-container"]');return f.default.implode(t).then((function(){y(e),t.removeClass(v)})).done()}}},{key:"getTemplateData",value:function(){return this.settings.toJSON({verbose:!0})}},{key:"getContentEl",value:function(){return this.$(".auth-content-inner")}}]),n}(d.View);t.default=w,e.exports=t.default},76785:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(15985)),a=r(n(31049)),s=r(n(39131)),l=r(n(78463)),u=r(n(35075)),c=r(n(35432)),d=r(n(2132)),f=n(6475),p=r(n(27447)),h=r(n(52115)),m=r(n(34425)),v=r(n(28766)),g=r(n(35546)),y=n(13671),b=r(n(36894)),w=n(19838),_=r(n(84757)),O=r(n(4449)),k=r(n(81325)),x=r(n(69977)),E=n(98462),T=r(n(26368)),S=n(86007),A=r(n(16100));function P(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function C(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?P(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):P(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function R(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,d.default)(e);if(t){var o=(0,d.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,c.default)(this,n)}}var I=function(e){(0,u.default)(c,e);var t,n,r,i=R(c);function c(e){var t;(0,s.default)(this,c),(t=i.call(this,e)).Events=f.Backbone.Events,t.hasControllerRendered=!1,e.globalSuccessFn||(e.globalSuccessFn=function(){}),e.globalErrorFn||(e.globalErrorFn=function(e){b.default.error(e)}),t.settings=new p.default(f._.omit(e,"el","hooks"),{parse:!0}),e.el||t.settings.callGlobalError(new y.ConfigError((0,f.loc)("error.required.el"))),(0,f.$)("body > div").on("click",(function(){})),t.hooks=e.hooks,t.appState=new k.default({},{settings:t.settings,hooks:t.hooks});var n=new _.default({appState:t.appState});return(0,f.$)(e.el).append(n.render().$el),t.el="#".concat(g.default.WIDGET_CONTAINER_ID),t.header=new O.default({el:t.el,appState:t.appState,settings:t.settings}),t.hide(),t.listenTo(t.appState,"change:deviceFingerprint",t.updateDeviceFingerprint),t.listenTo(t.appState,"restartLoginFlow",t.restartLoginFlow),t}return(0,l.default)(c,[{key:"updateDeviceFingerprint",value:function(){var e=this.settings.getAuthClient(),t=this.appState.get("deviceFingerprint");t&&e.http.setRequestHeader("X-Device-Fingerprint",t)}},{key:"handleIdxResponseFailure",value:(r=(0,a.default)(o.default.mark((function e(){var t,n=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=n.length>0&&void 0!==n[0]?n[0]:{error:"unknown",details:void 0},t=(0,S.formatError)(t),e.next=4,(0,E.updateAppState)(this.appState,t.details);case 4:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"handleError",value:(n=(0,a.default)(o.default.mark((function e(){var t,n,r=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=r.length>0&&void 0!==r[0]?r[0]:{error:"unknown",details:void 0},n=(0,S.formatError)(C({},t)),e.next=4,(0,E.updateAppState)(this.appState,n.details);case 4:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"render",value:(t=(0,a.default)(o.default.mark((function e(t){var n,r,i,a,s,l,u,c=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=c.length>1&&void 0!==c[1]?c[1]:{},x.default.getLastInitiatedLoginUrl()!==window.location.href&&x.default.removeStateHandle(),this.header.rendered()||(this.el=this.header.render().getContentEl()),h.default.isLoaded(this.settings.get("languageCode"))){e.next=6;break}return e.next=6,(0,w.loadLanguage)(this.appState,this.settings);case 6:return e.prev=6,e.next=9,(0,E.startLoginFlow)(this.settings);case 9:if(!(i=e.sent).error){e.next=15;break}return e.next=13,this.handleIdxResponseFailure(i.error);case 13:e.next=22;break;case 15:if(!this.settings.get("flow")||this.hasControllerRendered){e.next=19;break}return e.next=18,(0,E.handleConfiguredFlow)(i,this.settings);case 18:i=e.sent;case 19:return!i.requestDidSucceed&&A.default.isIdxSessionExpiredError(i)&&this.settings.getAuthClient().transactionManager.clear(),e.next=22,(0,E.updateAppState)(this.appState,i);case 22:e.next=33;break;case 24:if(e.prev=24,e.t0=e.catch(6),null===(a=e.t0.is)||void 0===a||!a.call(e.t0,"terminal")){e.next=30;break}this.appState.setNonIdxError(e.t0),e.next=33;break;case 30:return r=e.t0,e.next=33,this.handleError(e.t0);case 33:return e.prev=33,this.settings.unset("stateToken"),this.settings.unset("proxyIdxResponse"),e.finish(33);case 37:this.settings.get("colors.brand")&&!v.default.isLoaded()&&(s={brand:this.settings.get("colors.brand")},l=this.settings.get("cspNonce"),v.default.addStyle(s,l)),this.show(),this.unload(),u=f._.extend({el:this.el,settings:this.settings,appState:this.appState},n),this.controller=new t(u),this.listenTo(this.controller,"all",this.trigger),this.controller.render(),this.hasControllerRendered=!0,r&&this.settings.callGlobalError(r);case 46:case"end":return e.stop()}}),e,this,[[6,24,33,37]])}))),function(e){return t.apply(this,arguments)})},{key:"updateIdentifierCookie",value:function(e){if(this.settings.get("features.rememberMe")){var t,n=null==e||null===(t=e.context)||void 0===t?void 0:t.user,r=((null==n?void 0:n.value)||{}).identifier;r&&T.default.setUsernameCookie(r)}else T.default.removeUsernameCookie()}},{key:"hasAuthenticationSucceeded",value:function(e){var t,n;return(null==e||null===(t=e.rawIdxState)||void 0===t?void 0:t.success)||(null==e||null===(n=e.rawIdxState)||void 0===n?void 0:n.successWithInteractionCode)}},{key:"restartLoginFlow",value:function(e){var t;this.settings.getAuthClient().transactionManager.clear(),this.appState.set("idx",void 0);var n=this.settings.getAuthClient();delete n.options.recoveryToken,this.settings.unset("recoveryToken"),this.settings.unset("otp"),this.controller.stopListening(),n.idx.setFlow(null!==(t=null!=e?e:this.settings.get("flow"))&&void 0!==t?t:"default"),this.render(this.controller.constructor)}},{key:"start",value:function(){var e=m.default.supportsPushState();f.Router.prototype.start.call(this,{pushState:e})}},{key:"hide",value:function(){this.header.$el.hide()}},{key:"show",value:function(){this.header.$el.show()}},{key:"remove",value:function(){this.unload(),this.header.$el.remove(),this.stopListening(this.appState),this.stopListening(this.settings),h.default.remove(),f.Backbone.history.stop()}}]),c}(f.Router);I.prototype.Events=f.Backbone.Events;var N=I;t.default=N,e.exports=t.default},80585:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(15985)),i=r(n(39131)),a=r(n(78463)),s=r(n(35075)),l=r(n(35432)),u=r(n(2132)),c=r(n(76785)),d=r(n(56640));function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,u.default)(e);if(t){var o=(0,u.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,l.default)(this,n)}}var h={"":"defaultAuth","*wildcard":"defaultAuth"},m=function(e){(0,s.default)(n,e);var t=p(n);function n(e){return(0,i.default)(this,n),t.call(this,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({routes:h},e))}return(0,a.default)(n,[{key:"defaultAuth",value:function(){this.render(d.default)}}]),n}(c.default);t.default=m,e.exports=t.default},47550:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.emailVerifyCallback=function(e){return u.apply(this,arguments)};var o=r(n(70232)),i=r(n(15985)),a=r(n(31049));function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function u(){return(u=(0,a.default)(o.default.mark((function e(t){var n,r,i,a,s,u,c;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.getAuthClient(),r={exchangeCodeForTokens:!1},e.next=4,n.idx.getSavedTransactionMeta();case 4:if((i=e.sent)&&i.interactionHandle){e.next=9;break}return s={neededToProceed:[],rawIdxState:{messages:a={type:"array",value:[{message:"Enter the OTP in your original browser or device.",i18n:{key:"idx.enter.otp.in.original.tab"},class:"INFO"}]}},context:{messages:a}},e.abrupt("return",s);case 9:return u=t.get("otp"),e.next=12,n.idx.proceed(l(l({},r),{},{otp:u}));case 12:return c=e.sent,e.abrupt("return",c);case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},86007:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.formatError=function(e){"string"==typeof e&&(e=new Error(e));if(o(e))return a(e);if(i(e))return s(e);if(l(e))return u(e);if(c(e))return d(e);return e=f(e)},t.formatIDXError=f,t.formatInvalidActivationTokenError=s,t.formatInvalidRecoveryTokenError=a,t.formatOIEConfigurationError=d,t.formatOIENotEnabledError=u,t.isInvalidActivationTokenError=i,t.isInvalidRecoveryTokenError=o,t.isOIEConfigurationError=c,t.isOIENotEnabledError=l;var r=n(6475);function o(e){return"invalid_request"===(null==e?void 0:e.error)&&"The recovery token is invalid"===e.error_description}function i(e){return"invalid_request"===(null==e?void 0:e.error)&&"The activation token is invalid"===e.error_description}function a(e){var t=f(e),n=t.details,r={type:"array",value:[{message:e.error_description,i18n:{key:"oie.invalid.recovery.token"},class:"ERROR"}]};return n.rawIdxState.messages=r,n.context.messages=r,t}function s(e){var t=f(e),n=t.details,r={type:"array",value:[{message:e.error_description,i18n:{key:"idx.missing.activation.token"},class:"ERROR"}]};return n.rawIdxState.messages=r,n.context.messages=r,t}function l(e){return"access_denied"===(null==e?void 0:e.error)&&e.error_description}function u(e){var t=f(e).details,n={type:"array",value:[{message:e.error_description,i18n:{key:"oie.feature.disabled"},class:"ERROR"}]};return t.rawIdxState.messages=n,t.context.messages=n,e}function c(e){return(null==e?void 0:e.error)&&e.error_description}function d(e){var t=f(e).details,n={type:"array",value:[{message:(0,r.loc)("oie.configuration.error","login"),class:"ERROR",i18n:void 0}]};return t.rawIdxState.messages=n,t.context.messages=n,e}function f(e){var t=e;t.details=t.details||{};var n=t.details;if(n.rawIdxState=n.rawIdxState||{},n.context=n.context||{},n.neededToProceed=n.neededToProceed||[],!n.rawIdxState.messages){var o={type:"array",value:[{message:(0,r.loc)("oform.error.unexpected","login"),class:"ERROR",i18n:void 0}]};n.rawIdxState.messages=o,n.context.messages=o}return t}},86183:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.startLoginFlow=h;var o=r(n(70232)),i=r(n(15985)),a=r(n(31049)),s=n(13671),l=n(47550),u=r(n(69977)),c=n(13871);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(){var e=(0,a.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",Promise.resolve({rawIdxState:t.get("proxyIdxResponse"),context:t.get("proxyIdxResponse"),neededToProceed:[]}));case 1:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}();function h(e){return m.apply(this,arguments)}function m(){return(m=(0,a.default)(o.default.mark((function e(t){var n,r,i,a,d,m,v,g,y,b,w;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=t.getAuthClient(),r=t.toJSON({verbose:!0}),i=r.authParams,a=t.get("nonce")||(null==i?void 0:i.nonce),d=f({exchangeCodeForTokens:!1},a&&{nonce:a}),!t.get("proxyIdxResponse")){e.next=6;break}return e.abrupt("return",p(t));case 6:if(t.get("overrideExistingStateToken")&&u.default.removeStateHandle(),!t.get("otp")){e.next=9;break}return e.abrupt("return",(0,l.emailVerifyCallback)(t));case 9:if(!t.get("oauth2Enabled")){e.next=19;break}return e.next=12,n.idx.getSavedTransactionMeta();case 12:if(e.sent){e.next=18;break}if(!(m=n.idx.getFlow())||m!==c.CONFIGURED_FLOW.PROCEED){e.next=17;break}throw new s.ConfiguredFlowError("Unable to proceed: saved transaction could not be loaded",m);case 17:return e.abrupt("return",n.idx.start(d));case 18:return e.abrupt("return",n.idx.proceed(d));case 19:if(!(v=u.default.getStateHandle())){e.next=36;break}return e.prev=21,e.next=24,n.idx.start(f(f({},d),{},{stateHandle:v}));case 24:if(b=e.sent,!((null===(g=b.context)||void 0===g||null===(y=g.messages)||void 0===y?void 0:y.value.length)>0)){e.next=28;break}throw new Error("saved stateToken is invalid");case 28:return t.set("stateToken",v),e.abrupt("return",b);case 32:return e.prev=32,e.t0=e.catch(21),u.default.removeStateHandle(),e.abrupt("return",h(t));case 36:if(!(w=t.get("stateToken"))){e.next=39;break}return e.abrupt("return",n.idx.start(f(f({},d),{},{stateHandle:w})));case 39:throw new s.ConfigError('Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.');case 40:case"end":return e.stop()}}),e,null,[[21,32]])})))).apply(this,arguments)}},57852:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.updateAppState=function(e,t){return c.apply(this,arguments)};var o=r(n(70232)),i=r(n(31049)),a=r(n(69977)),s=n(59155),l=n(13955),u=r(n(58937));function c(){return(c=(0,i.default)(o.default.mark((function e(t,n){var r,i,c,d,f;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.settings,i=t.get("idx"),!r.get("oauth2Enabled")){e.next=13;break}if(!n.interactionCode){e.next=11;break}return a.default.removeStateHandle(),e.next=8,(0,s.interactionCodeFlow)(r,n);case 8:return c=e.sent,t.unset("currentFormName",{silent:!0}),e.abrupt("return",c);case 11:e.next=15;break;case 13:i&&a.default.setStateHandle(null==n||null===(d=n.context)||void 0===d?void 0:d.stateHandle),t.get("currentFormName")===l.FORMS.CANCEL_TRANSACTION&&a.default.removeStateHandle();case 15:return f=(0,u.default)(r,n,i),e.next=18,t.setIonResponse(f);case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},56640:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(15985)),a=r(n(31049)),s=n(6475),l=r(n(68133)),u=r(n(16100)),c=r(n(23002)),d=n(2715),f=n(13955),p=r(n(74600)),h=r(n(90570)),m=r(n(69977)),v=n(2659),g=n(13871),y=n(13671),b=n(98462),w=r(n(26368));function _(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function O(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?_(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):_(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var k=s.Controller.extend({className:"form-controller",appStateEvents:{"change:currentFormName":"handleFormNameChange",afterError:"handleAfterError",invokeAction:"handleInvokeAction",saveForm:"handleSaveForm",switchForm:"handleSwitchForm"},preRender:function(){this.removeChildren()},postRender:function(){var e=this.options.appState.getCurrentViewState();if(e){this.clearMetadata();var t=e.name;"identify"===t&&this.options.settings.get("flow")===g.CONFIGURED_FLOW.RESET_PASSWORD&&(t="identify-recovery");var n=l.default.create(t,this.options.appState.get("authenticatorKey"));try{this.formView=this.add(n,{options:{currentViewState:e}}).last()}catch(e){return void this.options.settings.callGlobalError(e)}this.triggerAfterRenderEvent()}},clearMetadata:function(){var e=this.options.appState.get("currentFormName");f.TERMINAL_FORMS.includes(e)&&m.default.removeStateHandle()},triggerAfterRenderEvent:function(){var e=this.createAfterEventContext();this.trigger("afterRender",e)},handleFormNameChange:function(){this.$el.click(),this.render()},handleAfterError:function(e){var t=this.createAfterEventContext(),n={xhr:e,errorSummary:e.responseJSON&&e.responseJSON.errorSummary};this.trigger("afterError",t,n)},createAfterEventContext:function(){var e=this.options.appState.get("currentFormName"),t=this.options.appState.get("authenticatorKey"),n=this.options.appState.get("authenticatorMethodType"),r=this.options.appState.get("isPasswordRecoveryFlow"),o={controller:(0,d.getV1ClassName)(e,t,n,r),formName:e};return t&&(o.authenticatorKey=t),n&&(o.methodType=n),o},handleSwitchForm:function(e){this.options.appState.get("messages")&&this.options.appState.unset("messages"),this.options.appState.set("currentFormName",e)},handleInvokeAction:function(){var e=arguments,t=this;return(0,a.default)(o.default.mark((function n(){var r,i,a,l,u,c,d,p,h,v;return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:if(r=e.length>0&&void 0!==e[0]?e[0]:"",i=e.length>1&&void 0!==e[1]?e[1]:{},a=!(e.length>2&&void 0!==e[2])||e[2],l=t.options,u=l.appState,c=l.settings,r!==f.ORG_PASSWORD_RECOVERY_LINK||!c.get("oauth2Enabled")){n.next=7;break}return u.trigger("restartLoginFlow","resetPassword"),n.abrupt("return");case 7:if(d=u.get("idx"),p=d.context.stateHandle,h={exchangeCodeForTokens:!1,stateHandle:p},"cancel"!==r){n.next=17;break}if(c.getAuthClient().transactionManager.clear({clearIdxResponse:!1}),m.default.removeStateHandle(),u.clearAppStateCache(),!c.get("oauth2Enabled")){n.next=17;break}return u.trigger("restartLoginFlow"),n.abrupt("return");case 17:if(![f.FORMS.LAUNCH_AUTHENTICATOR,f.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR,f.FORMS.LAUNCH_PASSKEYS_AUTHENTICATOR].includes(r)||!i){n.next=22;break}h=O(O({},h),{},{actions:[{name:r,params:i}]}),n.next=36;break;case 22:if(!d.neededToProceed.find((function(e){return e.name===r}))){n.next=26;break}h=O(O({},h),{},{step:r}),n.next=36;break;case 26:if(!s._.isFunction(d.actions[r])){n.next=30;break}h=O(O({},h),{},{actions:[{name:r,params:i}]}),n.next=36;break;case 30:if(v=new y.ConfigError("Invalid action selected: ".concat(r)),t.options.settings.callGlobalError(v),!a){n.next=35;break}return n.next=35,t.showFormErrors(t.formView.model,v,t.formView.form);case 35:return n.abrupt("return");case 36:return n.next=38,t.invokeAction(h);case 38:case"end":return n.stop()}}),n)})))()},invokeAction:function(e){var t=this;return(0,a.default)(o.default.mark((function n(){var r,i,a,s,l,d,f,p,h,m,v;return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:return r=t.options.settings.getAuthClient(),n.prev=1,n.next=4,r.idx.proceed(e);case 4:!1===(i=n.sent).requestDidSucceed&&(a=i),n.next=11;break;case 8:n.prev=8,n.t0=n.catch(1),a=n.t0;case 11:if(!a){n.next=21;break}if(h=a.rawIdxState||a,m=c.default.buildErrorObject(h),v=null===(s=e.actions)||void 0===s||null===(l=s[0])||void 0===l||null===(d=l.name)||void 0===d?void 0:d.endsWith("-poll"),u.default.isIonErrorResponse(h)||c.default.isRateLimitError(m)||!v||"function"!=typeof(null===(f=t.formView)||void 0===f||null===(p=f.form)||void 0===p?void 0:p.startPolling)){n.next=18;break}return t.formView.form.startPolling(),n.abrupt("return");case 18:return n.next=20,t.showFormErrors(t.formView.model,a,t.formView.form);case 20:return n.abrupt("return");case 21:return n.next=23,t.handleIdxResponse(i);case 23:case"end":return n.stop()}}),n,null,[[1,8]])})))()},handleSaveForm:function(e){var t=this;return(0,a.default)(o.default.mark((function n(){var r,i,a,s,l,c,d,y,b,_,k,x,E;return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:if(r=e.get("formName"),t.toggleFormButtonState(!0),e.trigger("request"),!e.get("useRedirect")){n.next=8;break}return m.default.removeStateHandle(),i=t.options.appState.getCurrentViewState(),h.default.executeOnVisiblePage((function(){h.default.redirectWithFormGet(i.href)})),n.abrupt("return");case 8:if(a=(0,p.default)(r,e),s=a.identifier,l=t.transformIdentifier(r,a),t.options.settings.get("features.rememberMe")?s&&w.default.setUsernameCookie(s):w.default.removeUsernameCookie(),t.options.appState.hasRemediationObject(r)){n.next=17;break}return t.options.settings.callGlobalError('Cannot find http action for "'.concat(r,'".')),n.next=16,t.showFormErrors(t.formView.model,"Cannot find action to proceed.",t.formView.form);case 16:case 33:case 37:return n.abrupt("return");case 17:return"identify"===r&&t.options.settings.get("flow")===g.CONFIGURED_FLOW.RESET_PASSWORD&&(l.authenticator="okta_password"),c=t.options.settings.getAuthClient(),d={exchangeCodeForTokens:!1},n.prev=20,y=t.options.appState.get("idx"),b=y.context.stateHandle,n.next=25,c.idx.proceed(O(O({},d),{},{step:r,stateHandle:b},l));case 25:if((_=n.sent).status!==v.IdxStatus.FAILURE){n.next=28;break}throw _.error;case 28:if(!u.default.isIdxSessionExpiredError(_)){n.next=34;break}return t.settings.getAuthClient().transactionManager.clear(),n.next=33,t.handleIdxResponse(_);case 34:if(!1!==_.requestDidSucceed||_.stepUp){n.next=38;break}return n.next=37,t.showFormErrors(e,_,t.formView.form);case 38:if(k=t.handleIdxResponse.bind(t,_),r!==f.FORMS.ENROLL_PROFILE){n.next=43;break}t.settings.postRegistrationSubmit(null==l||null===(x=l.userProfile)||void 0===x?void 0:x.email,k,(function(t){e.trigger("error",e,{responseJSON:t})})),n.next=45;break;case 43:return n.next=45,k();case 45:n.next=55;break;case 47:if(n.prev=47,n.t0=n.catch(20),null===(E=n.t0.is)||void 0===E||!E.call(n.t0,"terminal")){n.next=53;break}t.options.appState.setNonIdxError(n.t0),n.next=55;break;case 53:return n.next=55,t.showFormErrors(e,n.t0,t.formView.form);case 55:return n.prev=55,t.toggleFormButtonState(!1),n.finish(55);case 58:case"end":return n.stop()}}),n,null,[[20,47,55,58]])})))()},transformIdentifier:function(e,t){if(Object.prototype.hasOwnProperty.call(t,"identifier")){var n=f.FORM_NAME_TO_OPERATION_MAP[e];t.identifier=this.settings.transformUsername(t.identifier,n)}return t},showFormErrors:function(e,t,n){var r=this;return(0,a.default)(o.default.mark((function i(){var a,l,u,d,f;return o.default.wrap((function(o){for(;;)switch(o.prev=o.next){case 0:u=!0,e.trigger("clearFormError"),t||(t="FormController - unknown error found",r.options.settings.callGlobalError(t)),null!==(a=t)&&void 0!==a&&a.rawIdxState&&(l=t,t=t.rawIdxState),d=c.default.buildErrorObject(t,(function(e){h.default.logConsoleError(e)})),s._.isFunction(null==n?void 0:n.showCustomFormErrorCallout)&&(u=!n.showCustomFormErrorCallout(d,null===(f=l)||void 0===f?void 0:f.messages)),e.trigger("error",e,d,u),l=Object.assign({},l,{hasFormError:!0});case 8:case"end":return o.stop()}}),i)})))()},handleIdxResponse:function(e){var t=this;return(0,a.default)(o.default.mark((function n(){return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:return n.next=2,(0,b.updateAppState)(t.options.appState,e);case 2:case"end":return n.stop()}}),n)})))()},toggleFormButtonState:function(e){this.$el.find(".o-form-button-bar .button").toggleClass("link-button-disabled",e)}});t.default=k,e.exports=t.default},62215:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"_",{enumerable:!0,get:function(){return i._}});var o=r(n(12990)),i=n(6475);i._.mixin({nestedOmit:function(e,t){var n=i._.omit(e,t);return t.includes(n.name)&&(n=i._.omit(n,"value")),i._.each(n,(function(e,r){Array.isArray(e)?n[r]=e.map((function(e){return i._.nestedOmit(e,t)})):"object"===(0,o.default)(e)&&(n[r]=i._.nestedOmit(e,t))})),n}})},81325:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(70232)),i=r(n(31049)),a=r(n(31752)),s=r(n(39131)),l=r(n(78463)),u=r(n(35075)),c=r(n(35432)),d=r(n(2132)),f=n(6475),p=r(n(36894)),h=n(13955),m=n(3877),v=n(62215),g=n(53736),y=r(n(34425));function b(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,d.default)(e);if(t){var o=(0,d.default)(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return(0,c.default)(this,n)}}var w={user:"object",currentFormName:"string",previousFormName:"string",idx:"object",remediations:"array",dynamicRefreshInterval:"number",deviceFingerprint:"string",hooks:"object"},_={authenticatorProfile:{deps:["currentAuthenticator","currentAuthenticatorEnrollment"],fn:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{profile:void 0},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{profile:void 0};return e.profile||t.profile||{}}},authenticatorKey:{deps:["currentAuthenticator","currentAuthenticatorEnrollment"],fn:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{key:void 0},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{key:void 0};return e.key||t.key||""}},authenticatorMethodType:{deps:["currentAuthenticator","currentAuthenticatorEnrollment"],fn:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{methods:void 0},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{methods:void 0};return e.methods&&e.methods[0].type||t.methods&&t.methods[0].type||""}},isPasswordRecovery:{deps:["recoveryAuthenticator"],fn:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{type:void 0};return"password"===(null==e?void 0:e.type)}}},O=function(e){(0,u.default)(r,e);var t,n=b(r);function r(e,t){var o;return(0,s.default)(this,r),(o=n.call(this,e,t)).settings=t.settings,o.hooks=t.hooks,o}return(0,l.default)(r,[{key:"get",value:function(e){return f.Model.prototype.get.call(this,e)}},{key:"preinitialize",value:function(){this.local=w,this.derived=_;for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];f.Model.prototype.preinitialize.apply(this,t)}},{key:"isIdentifierOnlyView",value:function(){var e,t,n;return!(null!==(e=this.get("remediations"))&&void 0!==e&&null!==(t=e.find((function(e){return"identify"===e.name})))&&void 0!==t&&null!==(n=t.uiSchema)&&void 0!==n&&n.find((function(e){return"credentials.passcode"===e.name})))}},{key:"hasRemediationObject",value:function(e){return this.get("idx").neededToProceed.find((function(t){return t.name===e}))}},{key:"hasActionObject",value:function(e){var t,n;return!(null===(t=this.get("idx"))||void 0===t||null===(n=t.actions)||void 0===n||!n[e])}},{key:"getRemediationAuthenticationOptions",value:function(e){var t=this.hasRemediationObject(e);if(!t)return[];var n=t.value.find((function(e){return"authenticator"===e.name})),r=(null==n?void 0:n.options)||[];return r=(0,a.default)(r),(0,m.createOVOptions)(r),r}},{key:"getActionByPath",value:function(e){var t,n=e.split(".");t=1===n.length?this.get("idx").actions:this.get(n.shift());var r=n.shift();return t&&v._.isFunction(t[r])?t[r]:null}},{key:"getCurrentViewState",value:function(){var e=this.get("currentFormName");if(e){var t=this.get("remediations").filter((function(t){return t.name===e}))[0];if(!t){p.default.error("Panic!!"),p.default.error("\tCannot find view state for form ".concat(e,"."));var n=this.get("remediations").map((function(e){return e.name}));p.default.error("\tAll available form names: ".concat(n))}return t}}},{key:"getSchemaByName",value:function(e){var t=this.getCurrentViewState();if(t)return t.uiSchema.find((function(t){return t.name===e}))}},{key:"getAuthenticatorDisplayName",value:function(){var e=this.get("currentAuthenticator")||{},t=this.get("currentAuthenticatorEnrollment")||{};return e.displayName||t.displayName}},{key:"isAuthenticatorChallenge",value:function(){var e=this.get("currentFormName");return h.FORMS_FOR_VERIFICATION.includes(e)}},{key:"shouldReRenderView",value:function(e){var t;if(null!=e&&null!==(t=e.idx)&&void 0!==t&&t.hasFormError)return!1;var n=this.has("idx")?this.get("idx").rawIdxState:null,r=v._.isEqual(v._.nestedOmit(e.idx.rawIdxState,["expiresAt","refresh","stateHandle","headers"]),v._.nestedOmit(n,["expiresAt","refresh","stateHandle","headers"]));return r&&this.set("dynamicRefreshInterval",this.getRefreshInterval(e)),this._isReRenderRequired(r,e,n)}},{key:"getRefreshInterval",value:function(e){var t,n,r,o,i=this.get("currentFormName");return e.remediations.filter((function(e){return e.name===i}))[0].refresh||(null===(t=e.currentAuthenticatorEnrollment)||void 0===t||null===(n=t.poll)||void 0===n?void 0:n.refresh)||(null===(r=e.currentAuthenticator)||void 0===r||null===(o=r.poll)||void 0===o?void 0:o.refresh)}},{key:"shouldShowSignOutLinkInCurrentForm",value:function(e){var t=this.get("idx")&&this.get("idx").actions,n=this.get("currentFormName");return!e&&v._.isFunction(null==t?void 0:t.cancel)&&!h.FORMS_WITHOUT_SIGNOUT.includes(n)}},{key:"containsMessageWithI18nKey",value:function(e){Array.isArray(e)||(e=[e]);var t=this.get("messages");return t&&Array.isArray(t.value)&&t.value.some((function(t){var n;return v._.contains(e,null===(n=t.i18n)||void 0===n?void 0:n.key)}))}},{key:"containsMessageStartingWithI18nKey",value:function(e){var t=this.get("messages");return t&&Array.isArray(t.value)&&t.value.some((function(t){var n;return null===(n=t.i18n)||void 0===n?void 0:n.key.startsWith(e)}))}},{key:"clearAppStateCache",value:function(){var e={};for(var t in this.attributes)"currentFormName"!==t&&(e[t]=void 0);this.set(e,Object.assign({},{unset:!0,silent:!0})),this.trigger("cache:clear")}},{key:"chooseRemediation",value:function(e){var t,n;if(!v._.isEmpty(e.remediations)){var r=e.remediations[0];return"enroll-poll"===r.name&&this.get("authenticatorKey")===h.AUTHENTICATOR_KEY.OV&&(y.default.isAndroid()||y.default.isIOS())&&"qrcode"===(null===(t=e.currentAuthenticator)||void 0===t||null===(n=t.contextualData)||void 0===n?void 0:n.selectedChannel)?e.remediations.find((function(e){return"select-enrollment-channel"===e.name})):r}}},{key:"setIonResponse",value:(t=(0,i.default)(o.default.mark((function e(t){var n,r,i,a,s,l;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=this.shouldReRenderView(t),this.clearAppStateCache(),this.set(t),!n){e.next=15;break}return i=this.chooseRemediation(t),a=null,i?a=i.name:(p.default.error("Panic!!"),p.default.error("\tNo remediation found."),p.default.error("\tHere is the entire response"),p.default.error(JSON.stringify(t,null,2))),s=null===(r=this.hooks)||void 0===r?void 0:r.getHook(a),e.next=10,(0,g.executeHooksBefore)(s);case 10:return l=this.get("currentFormName"),this.unset("currentFormName",{silent:!0}),this.set({currentFormName:a,previousFormName:l}),e.next=15,(0,g.executeHooksAfter)(s);case 15:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"setNonIdxError",value:function(e){this.set("remediations",[{name:h.FORMS.TERMINAL}]),this.set("messages",{value:[{message:e.errorDetails.errorSummary,class:"ERROR"}]}),this.set("currentFormName",h.FORMS.TERMINAL)}},{key:"getUser",value:function(){return this.get("user")}},{key:"_isReRenderRequired",value:function(e,t,n){var r,o=!0;return(null===(r=this.get("idx"))||void 0===r?void 0:r.hasFormError)&&this._isChallengeAuthenticatorPoll(t,n)&&(o=!1),e&&(o=!1,("poll"===this.get("currentFormName")||h.FORMS_WITH_STATIC_BACK_LINK.includes(this.get("currentFormName"))||this.containsMessageWithI18nKey("idx.unknown.user"))&&(o=!0)),o}},{key:"_isChallengeAuthenticatorPoll",value:function(e,t){var n,r=v._.isEqual(v._.nestedOmit(e.idx.rawIdxState,["expiresAt","refresh","stateHandle","headers"]),v._.nestedOmit(t,["expiresAt","refresh","stateHandle","messages","headers"])),o="challenge-authenticator"===this.get("currentFormName"),i=(null===(n=this.get("currentAuthenticatorEnrollment"))||void 0===n?void 0:n.key)===h.AUTHENTICATOR_KEY.EMAIL;return r&&o&&i}}]),r}(f.Model);t.default=O,e.exports=t.default},68133:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o,i,a,s,l,u,c,d,f,p=r(n(15985)),h=r(n(36894)),m=n(13955),v=n(17587),g=r(n(57973)),y=r(n(92017)),b=r(n(91671)),w=r(n(91485)),_=r(n(44822)),O=r(n(57785)),k=r(n(57571)),x=r(n(51662)),E=r(n(57353)),T=r(n(81205)),S=r(n(68875)),A=r(n(59953)),P=r(n(63417)),C=r(n(88981)),R=r(n(64623)),I=r(n(56111)),N=r(n(60342)),M=r(n(99208)),j=r(n(81261)),D=r(n(21748)),L=r(n(99836)),U=r(n(75582)),F=r(n(26097)),B=r(n(62665)),V=r(n(40973)),Z=r(n(13591)),H=r(n(15918)),q=r(n(86598)),W=r(n(94257)),K=r(n(65425)),$=r(n(14425)),z=r(n(9699)),Y=r(n(65387)),G=r(n(30836)),J=r(n(29118)),Q=r(n(37437)),X=r(n(10765)),ee=r(n(41553)),te=r(n(98355)),ne=r(n(88930)),re=r(n(1705)),oe=r(n(90088)),ie=r(n(99214)),ae=r(n(14709)),se=r(n(36529)),le=r(n(12167)),ue=r(n(7925)),ce=r(n(79091)),de=r(n(58734)),fe=r(n(19220)),pe=r(n(48167)),he=r(n(49065)),me=r(n(82640)),ve=r(n(64840)),ge=r(n(2854)),ye=r(n(14763)),be=r(n(21606)),we=r(n(23986)),_e=r(n(70621)),Oe=r(n(50066)),ke=r(n(58930)),xe=r(n(2982)),Ee=r(n(91153)),Te=r(n(1850)),Se=r(n(28141)),Ae=r(n(73386)),Pe="_",Ce=(f={},(0,p.default)(f,m.FORMS.IDENTIFY,(0,p.default)({},Pe,g.default)),(0,p.default)(f,m.FORMS.IDENTIFY_RECOVERY,(0,p.default)({},Pe,w.default)),(0,p.default)(f,m.FORMS.DEVICE_CHALLENGE_POLL,(0,p.default)({},Pe,A.default)),(0,p.default)(f,m.FORMS.LAUNCH_AUTHENTICATOR,(0,p.default)({},Pe,C.default)),(0,p.default)(f,m.FORMS.DEVICE_APPLE_SSO_EXTENSION,(o={},(0,p.default)(o,Pe,P.default),(0,p.default)(o,m.AUTHENTICATOR_KEY.OV,se.default),o)),(0,p.default)(f,m.FORMS.CANCEL_TRANSACTION,(0,p.default)({},Pe,P.default)),(0,p.default)(f,m.FORMS.ENROLL_PROFILE,(0,p.default)({},Pe,I.default)),(0,p.default)(f,m.FORMS.ENROLL_PROFILE_UPDATE,(0,p.default)({},Pe,N.default)),(0,p.default)(f,m.FORMS.POLL,(0,p.default)({},Pe,k.default)),(0,p.default)(f,m.FORMS.REQUEST_ACTIVATION,(0,p.default)({},Pe,M.default)),(0,p.default)(f,m.FORMS.SELECT_AUTHENTICATOR_ENROLL,(0,p.default)({},Pe,j.default)),(0,p.default)(f,m.FORMS.AUTHENTICATOR_ENROLLMENT_DATA,(i={},(0,p.default)(i,m.AUTHENTICATOR_KEY.PHONE,q.default),(0,p.default)(i,m.AUTHENTICATOR_KEY.EMAIL,X.default),i)),(0,p.default)(f,m.FORMS.CONSENT_ADMIN,(0,p.default)({},Pe,x.default)),(0,p.default)(f,m.FORMS.CONSENT_ENDUSER,(0,p.default)({},Pe,E.default)),(0,p.default)(f,m.FORMS.CONSENT_GRANULAR,(0,p.default)({},Pe,T.default)),(0,p.default)(f,m.FORMS.CONSENT_EMAIL_CHALLENGE,(0,p.default)({},Pe,S.default)),(0,p.default)(f,m.FORMS.ENROLL_AUTHENTICATOR,(a={},(0,p.default)(a,m.AUTHENTICATOR_KEY.DUO,fe.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.EMAIL,J.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.GOOGLE_OTP,le.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.IDP,me.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.ON_PREM,ce.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.PASSWORD,U.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.PHONE,H.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.RSA,ce.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.SECURITY_QUESTION,$.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.SYMANTEC_VIP,ge.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.WEBAUTHN,Y.default),(0,p.default)(a,m.AUTHENTICATOR_KEY.YUBIKEY,we.default),a)),(0,p.default)(f,m.FORMS.CHALLENGE_AUTHENTICATOR,(s={},(0,p.default)(s,m.AUTHENTICATOR_KEY.CUSTOM_OTP,ve.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.DUO,pe.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.EMAIL,Q.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.GOOGLE_OTP,ue.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.IDP,he.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.ON_PREM,de.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.OV,oe.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.PASSWORD,F.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.PHONE,W.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.RSA,de.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.SECURITY_QUESTION,z.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.SYMANTEC_VIP,ge.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.TAC,Ee.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.WEBAUTHN,G.default),(0,p.default)(s,m.AUTHENTICATOR_KEY.YUBIKEY,we.default),s)),(0,p.default)(f,m.FORMS.ENROLL_POLL,(0,p.default)({},m.AUTHENTICATOR_KEY.OV,ee.default)),(0,p.default)(f,m.FORMS.SELECT_ENROLLMENT_CHANNEL,(0,p.default)({},m.AUTHENTICATOR_KEY.OV,te.default)),(0,p.default)(f,m.FORMS.ENROLLMENT_CHANNEL_DATA,(0,p.default)({},m.AUTHENTICATOR_KEY.OV,ne.default)),(0,p.default)(f,m.FORMS.REENROLL_AUTHENTICATOR,(0,p.default)({},m.AUTHENTICATOR_KEY.PASSWORD,B.default)),(0,p.default)(f,m.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY,(0,p.default)({},m.AUTHENTICATOR_KEY.PASSWORD,ke.default)),(0,p.default)(f,m.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING,(0,p.default)({},m.AUTHENTICATOR_KEY.PASSWORD,xe.default)),(0,p.default)(f,m.FORMS.REENROLL_AUTHENTICATOR_WARNING,(0,p.default)({},m.AUTHENTICATOR_KEY.PASSWORD,V.default)),(0,p.default)(f,m.FORMS.RESET_AUTHENTICATOR,(l={},(0,p.default)(l,m.AUTHENTICATOR_KEY.PASSWORD,Z.default),(0,p.default)(l,m.AUTHENTICATOR_KEY.GOOGLE_OTP,le.default),l)),(0,p.default)(f,m.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,(0,p.default)({},Pe,D.default)),(0,p.default)(f,m.FORMS.SELECT_AUTHENTICATOR_UNLOCK,(0,p.default)({},Pe,L.default)),(0,p.default)(f,m.FORMS.UNLOCK_ACCOUNT,(0,p.default)({},Pe,Se.default)),(0,p.default)(f,m.FORMS.CHALLENGE_POLL,(u={},(0,p.default)(u,m.AUTHENTICATOR_KEY.OV,re.default),(0,p.default)(u,m.AUTHENTICATOR_KEY.CUSTOM_APP,_e.default),u)),(0,p.default)(f,m.FORMS.RESEND,(c={},(0,p.default)(c,m.AUTHENTICATOR_KEY.OV,ie.default),(0,p.default)(c,m.AUTHENTICATOR_KEY.CUSTOM_APP,Oe.default),c)),(0,p.default)(f,m.FORMS.AUTHENTICATOR_VERIFICATION_DATA,(d={},(0,p.default)(d,m.AUTHENTICATOR_KEY.PHONE,K.default),(0,p.default)(d,m.AUTHENTICATOR_KEY.OV,ae.default),(0,p.default)(d,m.AUTHENTICATOR_KEY.EMAIL,X.default),(0,p.default)(d,m.AUTHENTICATOR_KEY.CUSTOM_APP,ae.default),d)),(0,p.default)(f,m.FORMS.FAILURE_REDIRECT,(0,p.default)({},Pe,O.default)),(0,p.default)(f,m.FORMS.SUCCESS_REDIRECT,(0,p.default)({},Pe,O.default)),(0,p.default)(f,m.FORMS.REDIRECT_IDP,(0,p.default)({},Pe,y.default)),(0,p.default)(f,m.FORMS.REDIRECT_IDVERIFY,(0,p.default)({},Pe,b.default)),(0,p.default)(f,m.FORMS.PIV_IDP,(0,p.default)({},Pe,be.default)),(0,p.default)(f,m.FORMS.DEVICE_ENROLLMENT_TERMINAL,(0,p.default)({},Pe,R.default)),(0,p.default)(f,m.FORMS.USER_CODE,(0,p.default)({},Pe,ye.default)),(0,p.default)(f,m.FORMS.KEEP_ME_SIGNED_IN,(0,p.default)({},Pe,Te.default)),(0,p.default)(f,m.FORMS.TERMINAL,(0,p.default)({},Pe,_.default)),(0,p.default)(f,m.FORMS.DEVICE_ASSURANCE_GRACE_PERIOD,(0,p.default)({},Pe,Ae.default)),f),Re={create:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Pe,n=Ce[e];if(!n)return h.default.warn("Cannot find customized View for ".concat(e,".")),v.BaseView;var r=n[t]||n._;return r||(h.default.warn("Cannot find customized View for ".concat(e," + ").concat(t,".")),v.BaseView)}};t.default=Re,e.exports=t.default},71750:function(e,t,n){"use strict";var r=n(1654),o=n(12990);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(15985)),a=r(n(12990)),s=r(n(2875)),l=n(6475),u=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var n=c(t);if(n&&n.has(e))return n.get(e);var r={},i=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var a in e)if("default"!==a&&Object.prototype.hasOwnProperty.call(e,a)){var s=i?Object.getOwnPropertyDescriptor(e,a):null;s&&(s.get||s.set)?Object.defineProperty(r,a,s):r[a]=e[a]}r.default=e,n&&n.set(e,r);return r}(n(88469));function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,n=new WeakMap;return(c=function(e){return e?n:t})(e)}function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}var f=l.internal.views.forms.helpers.FormUtil,p=l.Form.extend({layout:"o-form-theme",className:"ion-form",hasSavingState:!0,autoSave:!1,noCancelButton:!0,title:function(){return(0,l.loc)("oform.title.authenticate","login")},save:function(){return(0,l.loc)("oform.next","login")},modelEvents:{clearFormError:"handleClearFormError",error:"triggerAfterError"},initialize:function(){var e=this,t=this.getUISchema().map(u.create);this.showMessages(),this.listenTo(this.options.appState,"onCaptchaLoaded",(function(t){e.captchaObject=t})),this.listenTo(this.options.appState,"altchaSolved",(function(){e.trigger("save",e.model)})),t.forEach((function(t){e.addInputOrView(t)})),this.listenTo(this,"save",this.saveForm),this.listenTo(this,"cancel",this.cancelForm)},focus:function(){if(this.settings.get("features.autoFocus")){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];l.Form.prototype.focus.apply(this,t)}},handleClearFormError:function(){var e=this.$(".o-form-error-container");e.empty(),e.hasClass("o-form-has-errors")&&this.clearErrors()},triggerAfterError:function(e,t){this.options.appState.trigger("afterError",t)},saveForm:function(e){this.$el.find(".o-form-error-container").empty(),this.captchaObject&&"ALTCHA-WIDGET"!==(this.captchaObject.tagName||"").toUpperCase()?this.captchaObject.execute():this.options.appState.trigger("saveForm",e)},postRender:function(){var e=this.$el.find(".o-form-info-container");e.length||(this.add('<div class="o-form-info-container"></div>'),e=this.$el.find(".o-form-info-container")),this.$el.find(".o-form-error-container").attr("role","alert").before(e),this.addIdentifier()},addIdentifier:function(){var e=(this.options.appState.get("user")||{}).identifier;if(e&&this.settings.get("features.showIdentifier")){var t=this.$el.find('[data-se="o-form-head"]'),n=s.default.template({compiler:[8,">= 4.3.0"],main:function(e,t,n,r,o){var i,s=null!=t?t:e.nullContext||{},l=e.hooks.helperMissing,u="function",c=e.escapeExpression,d=e.lookupProperty||function(e,t){if(Object.prototype.hasOwnProperty.call(e,t))return e[t]};return'<div class="identifier-container"><span class="identifier no-translate" data-se="identifier" title="'+c((i=null!=(i=d(n,"identifier")||(null!=t?d(t,"identifier"):t))?i:l,(0,a.default)(i)===u?i.call(s,{name:"identifier",hash:{},data:o,loc:{start:{line:1,column:100},end:{line:1,column:114}}}):i))+'">'+c((i=null!=(i=d(n,"identifier")||(null!=t?d(t,"identifier"):t))?i:l,(0,a.default)(i)===u?i.call(s,{name:"identifier",hash:{},data:o,loc:{start:{line:1,column:116},end:{line:1,column:130}}}):i))+"</span></div>"},useData:!0})({identifier:e});t.length?t.after(n):this.$el.find(".o-form-error-container").after(n)}},cancelForm:function(){this.options.appState.trigger("invokeAction","cancel")},getUISchema:function(){return Array.isArray(this.options.currentViewState.uiSchema)?this.options.currentViewState.uiSchema:[]},addInputOrView:function(e){if(!1!==e.visible&&(!1!==e.mutable||!0===e.visible)&&(e.View?(this.add(e.View,l._.omit(e,"View","showWhen")),e.showWhen&&f.applyShowWhen(this.last(),e.showWhen)):this.addInput(e),Array.isArray(e.optionsUiSchemas)&&this.options.optionUiSchemaConfig[e.name])){var t=Number(this.options.optionUiSchemaConfig[e.name]);(e.optionsUiSchemas[t]||[]).forEach(this.addInputOrView.bind(this))}},showCustomFormErrorCallout:null,showMessages:function(e){var t=this,n=this.options.appState.get("messages")||{},r=".o-form-error-container";!Array.isArray(n.value)||e instanceof l.View?e instanceof l.View&&this.add(e,r):(this.add('<div class="ion-messages-container"></div>',r),n.value.forEach((function(n){if(null!=n&&n.class&&"INFO"!==n.class){var o,a=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({class:null!==(o=null==n?void 0:n.class)&&void 0!==o?o:"",message:null==n?void 0:n.message,title:""},e);t.add((0,l.createCallout)({content:a.message,type:a.class.toLowerCase(),title:a.title}),r),e=null}else t.add("<p>".concat(n.message,"</p>"),".ion-messages-container")})))}});t.default=p,e.exports=t.default},88469:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.isTextOverflowing=t.createIdpButtons=t.createCustomButtons=t.create=t.addCustomButton=void 0;var o,i=r(n(31752)),a=r(n(15985)),s=n(6475),l=r(n(82625)),u=r(n(40647)),c=n(25795),d=n(13955),f=r(n(78719)),p=r(n(29531)),h=r(n(99629)),m=r(n(19277));function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function g(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,a.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var y=function(e,t){var n=document.createElement("div");n.style.position="absolute",n.style.left="-9999px",n.style.whiteSpace="nowrap",n.innerHTML=e,document.body.appendChild(n);var r=n.clientWidth;return document.body.removeChild(n),r>t};t.isTextOverflowing=y;var b=(o={authenticatorEnrollSelect:function(e){var t=(e.options||[]).map((function(e){return Object.assign({},e,(0,c.getAuthenticatorDataForEnroll)(e))}));return{View:l.default,options:{name:e.name,optionItems:t,collection:new s.Collection(t)}}},authenticatorVerifySelect:function(e){var t=e.options||[],n=new Set;return t=t.filter((function(e){var t;if(e.authenticatorKey===d.AUTHENTICATOR_KEY.WEBAUTHN)t=n.has(e.authenticatorKey),n.add(e.authenticatorKey);else if(e.authenticatorKey===d.AUTHENTICATOR_KEY.CUSTOM_APP){var r,o;t=n.has(null==e||null===(r=e.value)||void 0===r?void 0:r.id),n.add(null==e||null===(o=e.value)||void 0===o?void 0:o.id)}return!t})),t=t.map((function(e){return Object.assign({},e,(0,c.getAuthenticatorDataForVerification)(e))})),{View:u.default,options:{name:e.name,collection:new s.Collection(t)}}}},(0,a.default)(o,"admin-consent",(function(){return{View:p.default}})),(0,a.default)(o,"consent",(function(){return{View:h.default}})),(0,a.default)(o,"captcha",(function(e){return{View:m.default,options:{name:e.name}}})),o);t.create=function(e){return(b[e.type]||s._.identity)(e)};t.createIdpButtons=function(e){var t=e.settings,n=e.appState,r=n.get("remediations").filter((function(e){return e.name===d.FORMS.REDIRECT_IDP}));if(!Array.isArray(r))return[];var o=function(e,t){if(t.get("remediations").filter((function(e){return e.name===d.FORMS.PIV_IDP})).length<1)return[];var n=e.get("piv");return[{attributes:{"data-se":"piv-card-button"},className:(n.className||"")+" piv-button",title:n.text||(0,s.loc)("piv.cac.card","login"),click:function(e){e.preventDefault(),t.trigger("switchForm",d.FORMS.PIV_IDP)}}]}(t,n),a=r.map((function(e){var t,n,r,o=null===(t=e.type)||void 0===t?void 0:t.toLowerCase();s._.contains(f.default.SUPPORTED_SOCIAL_IDPS,o)?n=(0,s.loc)("socialauth.".concat(o,".label"),"login"):(o="general-idp",n=(0,s.loc)("customauth.sign.in.with.label","login",[null===(r=e.idp)||void 0===r?void 0:r.name]));var i=["social-auth-button","social-auth-".concat(o,"-button")];"general-idp"===o&&i.push("no-translate"),e.idp.className&&i.push(e.idp.className);var a={attributes:{"data-se":"social-auth-".concat(o,"-button")},className:i.join(" "),title:n,href:e.href};return y(n,186)&&(a.attributes.title=n),a}));return[].concat((0,i.default)(o),(0,i.default)(a))};t.createCustomButtons=function(e){return e.get("customButtons").map((function(e){return{attributes:{"data-se":e.dataAttr},className:e.className+" default-custom-button",title:e.title||(0,s.loc)(e.i18nKey,"login"),click:e.click}}))};t.addCustomButton=function(e){return(0,s.createButton)(g(g({},e),{},{className:"".concat(e.className," default-custom-button button-primary")}))}},44371:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.createOktaSignIn=function(e,t){return function(){function n(r){var i,l,c;((0,o.default)(this,n),s.default.debugMessage("\n          The Okta Sign-In Widget is running in development mode.\n          When you are ready to publish your app, embed the minified version to turn on production mode.\n          See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n        "),r.stateToken)||(r.stateToken=null===(i=window)||void 0===i||null===(l=i.oktaData)||void 0===l||null===(c=l.signIn)||void 0===c?void 0:c.stateToken);if(this.options=r,this.authClient=(0,u.default)(e,r),!0!==r.useClassicEngine&&this.authClient.options.clientId&&!1===this.authClient.isPKCE())throw new a.ConfigError("OAuth2 with interaction code flow requires PKCE to be enabled on the authClient.");this.hooks=new f.default({hooks:r.hooks}),this.Router=t(r),this._eventCallbackMap=new WeakMap,this.Router.prototype.Events.listenTo.call(this,this.Router.prototype,"all",this.trigger),this.once("afterRender",(function(e){this.trigger("ready",e)}))}return(0,i.default)(n,[{key:"renderEl",value:function(e,t,n){if(this.router)throw new Error("An instance of the widget has already been rendered. Call remove() first.");var r=(0,d.default)(this.Router,this.options,e,this.authClient,t,n,this.hooks);return this.router=r.router,r.promise}},{key:"hide",value:function(){this.router&&this.router.hide()}},{key:"show",value:function(){this.router&&this.router.show()}},{key:"remove",value:function(){this.router&&(this.router.remove(),this.router=void 0)}},{key:"showSignInToGetTokens",value:function(e){var t=Object.assign((0,c.default)(this.options,e),{redirect:"never"}),n=this.renderEl(t).then((function(e){return e.tokens})),r=this.router.settings.getAuthClient();if(r.isAuthorizationCodeFlow()&&!r.isPKCE())throw new a.ConfigError('"showSignInToGetTokens()" should not be used for authorization_code flow. Use "showSignInAndRedirect()" instead');return n}},{key:"showSignInAndRedirect",value:function(e){var t=Object.assign((0,c.default)(this.options,e),{redirect:"always"});return this.renderEl(t).then((function(){}))}},{key:"showSignIn",value:function(e){var t=Object.assign((0,c.default)(this.options,e));return this.renderEl(t)}},{key:"before",value:function(e,t){this.hooks.mergeHook(e,{before:[t]})}},{key:"after",value:function(e,t){this.hooks.mergeHook(e,{after:[t]})}},{key:"getUser",value:function(){var e,t;return null===(e=this.router)||void 0===e||null===(t=e.appState)||void 0===t?void 0:t.getUser()}},{key:"on",value:function(e,t){if(p.includes(e)){var n=t;t=function(){try{for(var t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];n.apply(this,r)}catch(t){l.default.error('[okta-signin-widget] "'.concat(e,'" event handler error:'),t)}},this._eventCallbackMap.set(n,t)}this.Router.prototype.Events.on.call(this,e,t)}},{key:"off",value:function(e,t){t&&(t=this._eventCallbackMap.get(t)||t),this.Router.prototype.Events.off.call(this,e,t)}},{key:"once",value:function(e,t){this.Router.prototype.Events.once.call(this,e,t)}},{key:"stopListening",value:function(e,t){this.Router.prototype.Events.stopListening.call(this,e,t)}},{key:"listenTo",value:function(e,t,n){this.Router.prototype.Events.listenTo.call(this,e,t,n)}},{key:"trigger",value:function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];this.Router.prototype.Events.trigger.apply(this,[e].concat(n))}}]),n}()};var o=r(n(39131)),i=r(n(78463)),a=n(13671),s=r(n(90570)),l=r(n(36894)),u=r(n(53419)),c=r(n(22544)),d=r(n(99083)),f=r(n(76404)),p=["ready","afterError","afterRender"]},53419:function(e,t,n){"use strict";var r=n(1654);Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.authClient,r=t.authParams;if(!n){var o=t.issuer,l=t.clientId,c=t.redirectUri,d=t.state,f=t.scopes,p=t.flow,h=t.codeChallenge,m=t.codeChallengeMethod,v=t.recoveryToken;(r=u({issuer:o,clientId:l,redirectUri:c,state:d,scopes:f,flow:p,codeChallenge:h,codeChallengeMethod:m,transformErrorXHR:a.default.transformErrorXHR,recoveryToken:v,pollDelay:500},r)).issuer||(r.issuer=t.baseUrl+"/oauth2/default"),n=new e(r)}if(!n._oktaUserAgent)throw new i.ConfigError("The passed in authClient should be version 5.4.0 or above.");n._oktaUserAgent.addEnvironment("okta-signin-widget-".concat(s.default.version));return n};var o=r(n(15985)),i=n(13671),a=r(n(90570)),s=r(n(7174));function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,o.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}e.exports=t.default},2659:function(e){
/*! For license information please see default.js.LICENSE.txt */
self,e.exports=function(){var e={9748:function(e,t,n){"use strict";n.d(t,{b:function(){return k}});var r=n(5385),o=n(9123),i=n(1971);function a(e,t){var n={};return Object.assign(n,t),!n.stateToken&&e.stateToken&&(n.stateToken=e.stateToken),n}function s(e,t){return t=a(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn",t,{withCredentials:!0})}function l(e){return!!c(e)}function u(e,t,n,o,i){return i=Object.assign({withCredentials:!0},i),(0,r.v_)(e,n,o,i).then((function(e){return t.createTransaction(e)}))}function c(e){return e.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME)}var d=n(3144),f=n(5671),p=n(4942),h=n(3193),m=n(4771),v=n(6718);function g(e,t,n,i,s,l){if(Array.isArray(s))return function(r,a){if(!r)throw new o.Z("Must provide a link name");var u=(0,h.sE)(s,{name:r});if(!u)throw new o.Z("No link found for that name");return g(e,t,n,i,u,l)(a)};if(s.hints&&s.hints.allow&&1===s.hints.allow.length)switch(s.hints.allow[0]){case"GET":return function(){return(0,r.U2)(e,s.href,{withCredentials:!0})};case"POST":return function(r){l&&l.isPolling&&(l.isPolling=!1);var c=a(n,r);"MFA_ENROLL"!==n.status&&"FACTOR_ENROLL"!==n.status||Object.assign(c,{factorType:i.factorType,provider:i.provider});var d={},f=c.autoPush;if(void 0!==f){if("function"==typeof f)try{d.autoPush=!!f()}catch(e){return Promise.reject(new o.Z("AutoPush resulted in an error."))}else null!==f&&(d.autoPush=!!f);c=(0,h.CE)(c,"autoPush")}var p=c.rememberDevice;if(void 0!==p){if("function"==typeof p)try{d.rememberDevice=!!p()}catch(e){return Promise.reject(new o.Z("RememberDevice resulted in an error."))}else null!==p&&(d.rememberDevice=!!p);c=(0,h.CE)(c,"rememberDevice")}else c.profile&&void 0!==c.profile.updatePhone&&(c.profile.updatePhone&&(d.updatePhone=!0),c.profile=(0,h.CE)(c.profile,"updatePhone"));var m=s.href+(0,v.UK)(d);return u(e,t,m,c)}}}var y=n(8750),b=n(6573);function w(e,t,n){return function(s){var l,u,c,d;(0,m.hj)(s)?l=s:(0,m.Kn)(s)&&(l=s.delay,u=s.rememberDevice,c=s.autoPush,d=s.transactionCallBack),l||0===l||(l=i.DEFAULT_POLLING_DELAY);var f=(0,h.Rg)(t,"next","poll");n.isPolling=!0;var p=0;return function i(){return n.isPolling?function(){var n={};if("function"==typeof c)try{n.autoPush=!!c()}catch(e){return Promise.reject(new o.Z("AutoPush resulted in an error."))}else null!=c&&(n.autoPush=!!c);if("function"==typeof u)try{n.rememberDevice=!!u()}catch(e){return Promise.reject(new o.Z("RememberDevice resulted in an error."))}else null!=u&&(n.rememberDevice=!!u);var i=f.href+(0,v.UK)(n);return(0,r.v_)(e,i,function(e){return a(e)}(t),{saveAuthnState:!1,withCredentials:!0,pollingIntent:!0})}().then((function(t){if(p=0,t.factorResult&&"WAITING"===t.factorResult){if(!n.isPolling)throw new b.Z;return"function"==typeof d&&d(t),(0,y.gw)(l).then(i)}return n.isPolling=!1,e.tx.createTransaction(t)})).catch((function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&p<=4){var t=1e3*Math.pow(2,p);return p++,(0,y.gw)(t).then(i)}throw e})):Promise.reject(new b.Z)}().catch((function(e){throw n.isPolling=!1,e}))}}function _(e,t,n,r,o){if(r=r||n,r=(0,h.d9)(r),Array.isArray(r)){for(var i=[],a=0,s=r.length;a<s;a++)i.push(_(e,t,n,r[a],o));return i}var l=r._embedded||{};for(var u in l)Object.prototype.hasOwnProperty.call(l,u)&&((0,m.Kn)(l[u])||Array.isArray(l[u]))&&(l[u]=_(e,t,n,l[u],o));var c=function(e,t,n,r,o){var i={};for(var a in r._links)if(Object.prototype.hasOwnProperty.call(r._links,a)){var s=r._links[a];if("next"===a&&(a=s.name),s.type)i[a]=s;else if("poll"===a)i.poll=w(e,n,o);else{var l=g(e,t,n,r,s,o);l&&(i[a]=l)}}return i}(e,t,n,r,o);return Object.assign(l,c),r=(0,h.CE)(r,"_embedded","_links"),Object.assign(r,l),r}var O=(0,d.Z)((function e(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;(0,f.Z)(this,e),(0,p.Z)(this,"next",void 0),(0,p.Z)(this,"cancel",void 0),(0,p.Z)(this,"skip",void 0),(0,p.Z)(this,"unlock",void 0),(0,p.Z)(this,"changePassword",void 0),(0,p.Z)(this,"resetPassword",void 0),(0,p.Z)(this,"answer",void 0),(0,p.Z)(this,"recovery",void 0),(0,p.Z)(this,"verify",void 0),(0,p.Z)(this,"resend",void 0),(0,p.Z)(this,"activate",void 0),(0,p.Z)(this,"poll",void 0),(0,p.Z)(this,"prev",void 0),(0,p.Z)(this,"data",void 0),(0,p.Z)(this,"stateToken",void 0),(0,p.Z)(this,"sessionToken",void 0),(0,p.Z)(this,"status",void 0),(0,p.Z)(this,"user",void 0),(0,p.Z)(this,"factor",void 0),(0,p.Z)(this,"factors",void 0),(0,p.Z)(this,"policy",void 0),(0,p.Z)(this,"scopes",void 0),(0,p.Z)(this,"target",void 0),(0,p.Z)(this,"authentication",void 0),this.data=void 0,this.status=void 0,r&&(this.data=r,Object.assign(this,_(t,n,r,r,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==r.status||r._links||(this.cancel=function(){return Promise.resolve(n.createTransaction())}))}));function k(e){var t={status:s.bind(null,e),resume:function(n){return function(e,t,n){if(!n||!n.stateToken){var r=c(e);if(!r)return Promise.reject(new o.Z("No transaction to resume"));n={stateToken:r}}return s(e,n).then((function(e){return t.createTransaction(e)}))}(e,t,n)},exists:l.bind(null,e),introspect:function(n){return function(e,t,n){if(!n||!n.stateToken){var i=c(e);if(!i)return Promise.reject(new o.Z("No transaction to evaluate"));n={stateToken:i}}return function(e,t){return t=a(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t,{withCredentials:!0})}(e,n).then((function(e){return t.createTransaction(e)}))}(e,t,n)},createTransaction:function(n){return new O(e,t,n)},postToTransaction:function(n,r,o){return u(e,t,n,r,o)}};return t}},3398:function(e,t,n){"use strict";n.d(t,{b:function(){return r.b},t:function(){return o.t}});var r=n(9748),o=n(3164)},3164:function(e,t,n){"use strict";n.d(t,{t:function(){return y}});var r=n(4925),o=n(5861),i=n(5671),a=n(3144),s=n(7326),l=n(136),u=n(2963),c=n(1120),d=n(4942),f=n(4687),p=n.n(f),h=n(3193),m=n(8719),v=n(9748),g=["multiOptionalFactorEnroll"];function y(e){return function(e){(0,l.Z)(w,e);var t,n,f,y,b=(f=w,y=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,c.Z)(f);if(y){var n=(0,c.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,u.Z)(this,e)});function w(){var e;(0,i.Z)(this,w);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=b.call.apply(b,[this].concat(n)),(0,d.Z)((0,s.Z)(e),"tx",void 0),(0,d.Z)((0,s.Z)(e),"authn",void 0),(0,d.Z)((0,s.Z)(e),"fingerprint",void 0),e.authn=e.tx=(0,v.b)((0,s.Z)(e)),e.fingerprint=m.Z.bind(null,(0,s.Z)(e)),e}return(0,a.Z)(w,[{key:"signIn",value:(n=(0,o.Z)(p().mark((function e(t){var n,r=this;return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=(0,h.d9)(t||{}),n=function(e){return delete t.sendFingerprint,r.tx.postToTransaction("/api/v1/authn",t,e)},t.sendFingerprint){e.next=4;break}return e.abrupt("return",n());case 4:return e.abrupt("return",this.fingerprint().then((function(e){return n({headers:{"X-Device-Fingerprint":e}})})));case 5:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"signInWithCredentials",value:(t=(0,o.Z)(p().mark((function e(t){return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.signIn(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"forgotPassword",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/password",e)}},{key:"unlockAccount",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/unlock",e)}},{key:"verifyRecoveryToken",value:function(e){var t=e.multiOptionalFactorEnroll,n=(0,r.Z)(e,g);return t&&(n.options={multiOptionalFactorEnroll:t}),this.tx.postToTransaction("/api/v1/authn/recovery/token",n)}}]),w}(e)}},9893:function(e,t,n){"use strict";n.d(t,{a:function(){return d}});var r=n(3144),o=n(5671),i=n(4942),a=n(3193),s=n(415),l=n(1971),u=n(4279),c=n.n(u);function d(e){var t=(0,r.Z)((function t(){(0,o.Z)(this,t),(0,i.Z)(this,"options",void 0),(0,i.Z)(this,"emitter",void 0),(0,i.Z)(this,"features",void 0);var n=new e(arguments.length&&(arguments.length<=0?void 0:arguments[0])||{});this.options=(0,a.YY)(n),this.emitter=new(c()),this.features=s}));return(0,i.Z)(t,"features",s),(0,i.Z)(t,"constants",l),t.features=t.prototype.features=s,Object.assign(t,{constants:l}),t}},3306:function(e,t,n){"use strict";n.d(t,{X:function(){return o.X},a:function(){return r.a}});var r=n(9893),o=n(5093)},5093:function(e,t,n){"use strict";n.d(t,{X:function(){return a}});var r=n(3144),o=n(5671),i=n(4942);function a(){return(0,r.Z)((function e(t){(0,o.Z)(this,e),(0,i.Z)(this,"devMode",void 0),this.devMode=!!t.devMode}))}},4858:function(e,t,n){"use strict";function r(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}n.d(t,{Z:function(){return c}});var o=function e(t,n){function o(e,o,i){if("undefined"!=typeof document){"number"==typeof(i=r({},n,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),e=encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var a="";for(var s in i)i[s]&&(a+="; "+s,!0!==i[s]&&(a+="="+i[s].split(";")[0]));return document.cookie=e+"="+t.write(o,e)+a}}return Object.create({set:o,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],r={},o=0;o<n.length;o++){var i=n[o].split("="),a=i.slice(1).join("=");try{var s=decodeURIComponent(i[0]);if(r[s]=t.read(a,s),e===s)break}catch(e){}}return e?r[e]:r}},remove:function(e,t){o(e,"",r({},t,{expires:-1}))},withAttributes:function(t){return e(this.converter,r({},this.attributes,t))},withConverter:function(t){return e(r({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(t)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"}),i=o,a=n(9123),s=n(146),l=n(415),u={browserHasLocalStorage:function(){try{var e=this.getLocalStorage();return this.testStorage(e)}catch(e){return!1}},browserHasSessionStorage:function(){try{var e=this.getSessionStorage();return this.testStorage(e)}catch(e){return!1}},testStorageType:function(e){var t=!1;switch(e){case"sessionStorage":t=this.browserHasSessionStorage();break;case"localStorage":t=this.browserHasLocalStorage();break;case"cookie":case"memory":t=!0;break;default:t=!1}return t},getStorageByType:function(e,t){var n;switch(e){case"sessionStorage":n=this.getSessionStorage();break;case"localStorage":n=this.getLocalStorage();break;case"cookie":n=this.getCookieStorage(t);break;case"memory":n=this.getInMemoryStorage();break;default:throw new a.Z("Unrecognized storage option: ".concat(e))}return n},findStorageType:function(e){var t,n;return t=(e=e.slice()).shift(),(n=e.length?e[0]:null)?this.testStorageType(t)?t:((0,s.ZK)("This browser doesn't support ".concat(t,". Switching to ").concat(n,".")),this.findStorageType(e)):t},getLocalStorage:function(){return(0,l.isIE11OrLess)()&&!window.onstorage&&(window.onstorage=function(){}),localStorage},getSessionStorage:function(){return sessionStorage},getCookieStorage:function(e){var t=this,n=e.secure,r=e.sameSite,o=e.sessionCookie;if(void 0===n||void 0===r)throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');var i={getItem:this.storage.get,setItem:function(e,i){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"2200-01-01T00:00:00.000Z";a=o?null:a,t.storage.set(e,i,a,{secure:n,sameSite:r})},removeItem:function(e){t.storage.delete(e)}};return e.useSeparateCookies?{getItem:function(e){var t=i.getItem(),n={};return Object.keys(t).forEach((function(r){0===r.indexOf(e)&&(n[r.replace("".concat(e,"_"),"")]=JSON.parse(t[r]))})),JSON.stringify(n)},setItem:function(e,t){var n=JSON.parse(this.getItem(e));t=JSON.parse(t),Object.keys(t).forEach((function(r){var o=e+"_"+r,a=JSON.stringify(t[r]);i.setItem(o,a),delete n[r]})),Object.keys(n).forEach((function(t){i.removeItem(e+"_"+t)}))},removeItem:function(e){var t=JSON.parse(this.getItem(e));Object.keys(t).forEach((function(t){i.removeItem(e+"_"+t)}))}}:i},inMemoryStore:{},getInMemoryStorage:function(){var e=this;return{getItem:function(t){return e.inMemoryStore[t]},setItem:function(t,n){e.inMemoryStore[t]=n}}},testStorage:function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},storage:{set:function(e,t,n,r){var o=r.sameSite,s=r.secure;if(void 0===s||void 0===o)throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');var l={path:r.path||"/",secure:s,sameSite:o};return Date.parse(n)&&(l.expires=new Date(n)),i.set(e,t,l),this.get(e)},get:function(e){return arguments.length?i.get(e):i.get()},delete:function(e){return i.remove(e,{path:"/"})}}},c=u},8719:function(e,t,n){"use strict";n.d(t,{Z:function(){return s}});var r=n(9123),o=n(415),i=n(4970),a=function(e,t){return t.source===e.contentWindow};function s(e,t){var n;if(!(0,o.isFingerprintSupported)())return Promise.reject(new r.Z("Fingerprinting is not supported on this device"));var s,l,u,c=null!==(n=null==t?void 0:t.container)&&void 0!==n?n:document.body;return new Promise((function(n,o){(l=document.createElement("iframe")).style.display="none",u=function(t){if(a(l,t)&&t&&t.data&&t.origin===e.getIssuerOrigin()){var i,s,u;try{i=JSON.parse(t.data)}catch(e){return}if(i)return"FingerprintAvailable"===i.type?n(i.fingerprint):"FingerprintServiceReady"!==i.type?o(new r.Z("No data")):void(null===(s=l)||void 0===s||null===(u=s.contentWindow)||void 0===u||u.postMessage(JSON.stringify({type:"GetFingerprint"}),t.origin))}},(0,i.NH)(window,"message",u),l.src=e.getIssuerOrigin()+"/auth/services/devicefingerprint",c.appendChild(l),s=setTimeout((function(){o(new r.Z("Fingerprinting timed out"))}),(null==t?void 0:t.timeout)||15e3)})).finally((function(){var e;clearTimeout(s),(0,i.ys)(window,"message",u),c.contains(l)&&(null===(e=l.parentElement)||void 0===e||e.removeChild(l))}))}},1971:function(e,t,n){"use strict";n.r(t),n.d(t,{ACCESS_TOKEN_STORAGE_KEY:function(){return m},CACHE_STORAGE_NAME:function(){return u},DEFAULT_CACHE_DURATION:function(){return s},DEFAULT_CODE_CHALLENGE_METHOD:function(){return _},DEFAULT_MAX_CLOCK_SKEW:function(){return a},DEFAULT_POLLING_DELAY:function(){return o},IDX_API_VERSION:function(){return O},IDX_RESPONSE_STORAGE_NAME:function(){return h},ID_TOKEN_STORAGE_KEY:function(){return v},IOS_MAX_RETRY_COUNT:function(){return i},MAX_VERIFIER_LENGTH:function(){return w},MIN_VERIFIER_LENGTH:function(){return b},ORIGINAL_URI_STORAGE_NAME:function(){return p},PKCE_STORAGE_NAME:function(){return c},REFERRER_PATH_STORAGE_KEY:function(){return y},REFRESH_TOKEN_STORAGE_KEY:function(){return g},SHARED_TRANSACTION_STORAGE_NAME:function(){return f},STATE_TOKEN_KEY_NAME:function(){return r},TOKEN_STORAGE_NAME:function(){return l},TRANSACTION_STORAGE_NAME:function(){return d}});var r="oktaStateToken",o=500,i=3,a=300,s=86400,l="okta-token-storage",u="okta-cache-storage",c="okta-pkce-storage",d="okta-transaction-storage",f="okta-shared-transaction-storage",p="okta-original-uri-storage",h="okta-idx-response-storage",m="accessToken",v="idToken",g="refreshToken",y="referrerPath",b=43,w=128,_="S256",O="1.0.0"},1018:function(e,t,n){"use strict";n.d(t,{E:function(){return w},a:function(){return g}});var r=n(5861),o=n(5671),i=n(3144),a=n(4942),s=n(4687),l=n.n(s),u=n(3615),c=n.n(u),d=n(9123),f=n(7088),p=n(3548),h=n(146);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var g=null,y={updateAuthStatePromise:null,canceledTimes:0},b="authStateChange",w=function(){function e(t){var n=this;if((0,o.Z)(this,e),(0,a.Z)(this,"_sdk",void 0),(0,a.Z)(this,"_pending",void 0),(0,a.Z)(this,"_authState",void 0),(0,a.Z)(this,"_prevAuthState",void 0),(0,a.Z)(this,"_logOptions",void 0),(0,a.Z)(this,"_transformQueue",void 0),!t.emitter)throw new d.Z("Emitter should be initialized before AuthStateManager");this._sdk=t,this._pending=v({},y),this._authState=g,this._logOptions={},this._prevAuthState=null,this._transformQueue=new p.b({quiet:!0}),t.tokenManager.on(f.O3,(function(e,t){n._setLogOptions({event:f.O3,key:e,token:t}),n.updateAuthState()})),t.tokenManager.on(f.FT,(function(e,t){n._setLogOptions({event:f.FT,key:e,token:t}),n.updateAuthState()}))}var t;return(0,i.Z)(e,[{key:"_setLogOptions",value:function(e){this._logOptions=e}},{key:"getAuthState",value:function(){return this._authState}},{key:"getPreviousAuthState",value:function(){return this._prevAuthState}},{key:"updateAuthState",value:(t=(0,r.Z)(l().mark((function e(){var t,n,r,o,i,a,s,u=this;return l().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this._sdk.options,n=t.transformAuthState,r=t.devMode,o=function(e){var t=u._logOptions,n=t.event,r=t.key,o=t.token;(0,h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n," Status:").concat(e)),(0,h.dr)().log(r,o),(0,h.dr)().log("Current authState",u._authState),(0,h.dr)().groupEnd(),u._logOptions={}},i=function(e){var t,n;n=e,(t=u._authState)&&t.isAuthenticated===n.isAuthenticated&&JSON.stringify(t.idToken)===JSON.stringify(n.idToken)&&JSON.stringify(t.accessToken)===JSON.stringify(n.accessToken)&&t.error===n.error?r&&o("unchanged"):(u._prevAuthState=u._authState,u._authState=e,u._sdk.emitter.emit(b,v({},e)),r&&o("emitted"))},a=function e(t){return u._pending.updateAuthStatePromise.then((function(){var n=u._pending.updateAuthStatePromise;return n&&n!==t?e(n):u.getAuthState()}))},!this._pending.updateAuthStatePromise){e.next=11;break}if(!(this._pending.canceledTimes>=10)){e.next=10;break}return r&&o("terminated"),e.abrupt("return",a(this._pending.updateAuthStatePromise));case 10:this._pending.updateAuthStatePromise.cancel();case 11:return s=new(c())((function(e,t,a){a.shouldReject=!1,a((function(){u._pending.updateAuthStatePromise=null,u._pending.canceledTimes=u._pending.canceledTimes+1,r&&o("canceled")}));var l=function(t){s.isCanceled?e():(i(t),e(),u._pending=v({},y))};u._sdk.isAuthenticated().then((function(){if(s.isCanceled)e();else{var t=u._sdk.tokenManager.getTokensSync(),r=t.accessToken,o=t.idToken,i=t.refreshToken,a={accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!(!r||!o)};(n?u._transformQueue.push(n,null,u._sdk,a):Promise.resolve(a)).then((function(e){return l(e)})).catch((function(e){return l({accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!1,error:e})}))}}))})),this._pending.updateAuthStatePromise=s,e.abrupt("return",a(s));case 14:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"subscribe",value:function(e){this._sdk.emitter.on(b,e)}},{key:"unsubscribe",value:function(e){this._sdk.emitter.off(b,e)}}]),e}()},9046:function(e,t,n){"use strict";n.d(t,{W:function(){return ge}});var r=n(885),o=n(2982),i=n(5861),a=n(5671),s=n(3144),l=n(4942),u=n(4687),c=n.n(u);Promise.resolve(!1);var d=Promise.resolve(!0),f=Promise.resolve();function p(e,t){return e||(e=0),new Promise((function(n){return setTimeout((function(){return n(t)}),e)}))}function h(){return Math.random().toString(36).substring(2)}var m=0,v=0;function g(){var e=(new Date).getTime();return e===m?1e3*e+ ++v:(m=e,v=0,1e3*e)}var y={create:function(e){var t={messagesCallback:null,bc:new BroadcastChannel(e),subFns:[]};return t.bc.onmessage=function(e){t.messagesCallback&&t.messagesCallback(e.data)},t},close:function(e){e.bc.close(),e.subFns=[]},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){try{return e.bc.postMessage(t,!1),f}catch(e){return Promise.reject(e)}},canBeUsed:function(){if("undefined"==typeof window&&"undefined"==typeof self||"function"!=typeof BroadcastChannel)return!1;if(BroadcastChannel._pubkey)throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");return!0},type:"native",averageResponseTime:function(){return 150},microSeconds:g},b=function(){function e(e){this.ttl=e,this.map=new Map,this._to=!1}return e.prototype.has=function(e){return this.map.has(e)},e.prototype.add=function(e){var t=this;this.map.set(e,w()),this._to||(this._to=!0,setTimeout((function(){t._to=!1,function(e){for(var t=w()-e.ttl,n=e.map[Symbol.iterator]();;){var r=n.next().value;if(!r)return;var o=r[0];if(!(r[1]<t))return;e.map.delete(o)}}(t)}),0))},e.prototype.clear=function(){this.map.clear()},e}();function w(){return(new Date).getTime()}function _(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=JSON.parse(JSON.stringify(e));return void 0===t.webWorkerSupport&&(t.webWorkerSupport=!0),t.idb||(t.idb={}),t.idb.ttl||(t.idb.ttl=45e3),t.idb.fallbackInterval||(t.idb.fallbackInterval=150),e.idb&&"function"==typeof e.idb.onclose&&(t.idb.onclose=e.idb.onclose),t.localstorage||(t.localstorage={}),t.localstorage.removeTimeout||(t.localstorage.removeTimeout=6e4),e.methods&&(t.methods=e.methods),t.node||(t.node={}),t.node.ttl||(t.node.ttl=12e4),t.node.maxParallelWrites||(t.node.maxParallelWrites=2048),void 0===t.node.useFastPath&&(t.node.useFastPath=!0),t}var O="messages",k={durability:"relaxed"};function x(){if("undefined"!=typeof indexedDB)return indexedDB;if("undefined"!=typeof window){if(void 0!==window.mozIndexedDB)return window.mozIndexedDB;if(void 0!==window.webkitIndexedDB)return window.webkitIndexedDB;if(void 0!==window.msIndexedDB)return window.msIndexedDB}return!1}function E(e){e.commit&&e.commit()}function T(e){e.closed||S(e).then((function(){return p(e.options.idb.fallbackInterval)})).then((function(){return T(e)}))}function S(e){return e.closed?f:e.messagesCallback?function(e,t){var n=e.transaction(O,"readonly",k),r=n.objectStore(O),o=[],i=IDBKeyRange.bound(t+1,1/0);if(r.getAll){var a=r.getAll(i);return new Promise((function(e,t){a.onerror=function(e){return t(e)},a.onsuccess=function(t){e(t.target.result)}}))}return new Promise((function(e,a){var s=function(){try{return i=IDBKeyRange.bound(t+1,1/0),r.openCursor(i)}catch(e){return r.openCursor()}}();s.onerror=function(e){return a(e)},s.onsuccess=function(r){var i=r.target.result;i?i.value.id<t+1?i.continue(t+1):(o.push(i.value),i.continue()):(E(n),e(o))}}))}(e.db,e.lastCursorId).then((function(t){var n=t.filter((function(e){return!!e})).map((function(t){return t.id>e.lastCursorId&&(e.lastCursorId=t.id),t})).filter((function(t){return function(e,t){return!(e.uuid===t.uuid||t.eMIs.has(e.id)||e.data.time<t.messagesCallbackTime)}(t,e)})).sort((function(e,t){return e.time-t.time}));return n.forEach((function(t){e.messagesCallback&&(e.eMIs.add(t.id),e.messagesCallback(t.data))})),f})):f}var A={create:function(e,t){return t=_(t),function(e){var t="pubkey.broadcast-channel-0-"+e,n=x().open(t);return n.onupgradeneeded=function(e){e.target.result.createObjectStore(O,{keyPath:"id",autoIncrement:!0})},new Promise((function(e,t){n.onerror=function(e){return t(e)},n.onsuccess=function(){e(n.result)}}))}(e).then((function(n){var r={closed:!1,lastCursorId:0,channelName:e,options:t,uuid:h(),eMIs:new b(2*t.idb.ttl),writeBlockPromise:f,messagesCallback:null,readQueuePromises:[],db:n};return n.onclose=function(){r.closed=!0,t.idb.onclose&&t.idb.onclose()},T(r),r}))},close:function(e){e.closed=!0,e.db.close()},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t,S(e)},postMessage:function(e,t){return e.writeBlockPromise=e.writeBlockPromise.then((function(){return function(e,t,n){var r={uuid:t,time:(new Date).getTime(),data:n},o=e.transaction([O],"readwrite",k);return new Promise((function(e,t){o.oncomplete=function(){return e()},o.onerror=function(e){return t(e)},o.objectStore(O).add(r),E(o)}))}(e.db,e.uuid,t)})).then((function(){0===Math.floor(11*Math.random()+0)&&function(e){return(t=e.db,n=e.options.idb.ttl,r=(new Date).getTime()-n,o=t.transaction(O,"readonly",k),i=o.objectStore(O),a=[],new Promise((function(e){i.openCursor().onsuccess=function(t){var n=t.target.result;if(n){var i=n.value;i.time<r?(a.push(i),n.continue()):(E(o),e(a))}else e(a)}}))).then((function(t){return function(e,t){if(e.closed)return Promise.resolve([]);var n=e.db.transaction(O,"readwrite",k).objectStore(O);return Promise.all(t.map((function(e){var t=n.delete(e);return new Promise((function(e){t.onsuccess=function(){return e()}}))})))}(e,t.map((function(e){return e.id})))}));var t,n,r,o,i,a}(e)})),e.writeBlockPromise},canBeUsed:function(){return!!x()},type:"idb",averageResponseTime:function(e){return 2*e.idb.fallbackInterval},microSeconds:g};function P(){var e;if("undefined"==typeof window)return null;try{e=window.localStorage,e=window["ie8-eventlistener/storage"]||window.localStorage}catch(e){}return e}function C(e){return"pubkey.broadcastChannel-"+e}function R(){var e=P();if(!e)return!1;try{var t="__broadcastchannel_check";e.setItem(t,"works"),e.removeItem(t)}catch(e){return!1}return!0}var I={create:function(e,t){if(t=_(t),!R())throw new Error("BroadcastChannel: localstorage cannot be used");var n=h(),r=new b(t.localstorage.removeTimeout),o={channelName:e,uuid:n,eMIs:r};return o.listener=function(e,t){var i=C(e),a=function(e){var t;e.key===i&&(t=JSON.parse(e.newValue),o.messagesCallback&&t.uuid!==n&&t.token&&!r.has(t.token)&&(t.data.time&&t.data.time<o.messagesCallbackTime||(r.add(t.token),o.messagesCallback(t.data))))};return window.addEventListener("storage",a),a}(e),o},close:function(e){var t;t=e.listener,window.removeEventListener("storage",t)},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){p().then((function(){var r=C(e.channelName),o={token:h(),time:(new Date).getTime(),data:t,uuid:e.uuid},i=JSON.stringify(o);P().setItem(r,i);var a=document.createEvent("Event");a.initEvent("storage",!0,!0),a.key=r,a.newValue=i,window.dispatchEvent(a),n()}))}))},canBeUsed:R,type:"localstorage",averageResponseTime:function(){var e=navigator.userAgent.toLowerCase();return e.includes("safari")&&!e.includes("chrome")?240:120},microSeconds:g},N=g,M=new Set,j={create:function(e){var t={name:e,messagesCallback:null};return M.add(t),t},close:function(e){M.delete(e)},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){return setTimeout((function(){Array.from(M).filter((function(t){return t.name===e.name})).filter((function(t){return t!==e})).filter((function(e){return!!e.messagesCallback})).forEach((function(e){return e.messagesCallback(t)})),n()}),5)}))},canBeUsed:function(){return!0},type:"simulate",averageResponseTime:function(){return 5},microSeconds:N},D=[y,A,I],L=new Set,U=0,F=function(e,t){var n,r,o;this.id=U++,L.add(this),this.name=e,this.options=_(t),this.method=function(e){var t=[].concat(e.methods,D).filter(Boolean);if(e.type){if("simulate"===e.type)return j;var n=t.find((function(t){return t.type===e.type}));if(n)return n;throw new Error("method-type "+e.type+" not found")}e.webWorkerSupport||(t=t.filter((function(e){return"idb"!==e.type})));var r=t.find((function(e){return e.canBeUsed()}));if(r)return r;throw new Error("No usable method found in "+JSON.stringify(D.map((function(e){return e.type}))))}(this.options),this._iL=!1,this._onML=null,this._addEL={message:[],internal:[]},this._uMP=new Set,this._befC=[],this._prepP=null,(o=r=(n=this).method.create(n.name,n.options))&&"function"==typeof o.then?(n._prepP=r,r.then((function(e){n._state=e}))):n._state=r};function B(e,t,n){var r={time:e.method.microSeconds(),type:t,data:n};return(e._prepP?e._prepP:f).then((function(){var t=e.method.postMessage(e._state,r);return e._uMP.add(t),t.catch().then((function(){return e._uMP.delete(t)})),t}))}function V(e){return e._addEL.message.length>0||e._addEL.internal.length>0}function Z(e,t,n){e._addEL[t].push(n),function(e){if(!e._iL&&V(e)){var t=function(t){e._addEL[t.type].forEach((function(e){var n=e.time-1e5;t.time>=n&&e.fn(t.data)}))},n=e.method.microSeconds();e._prepP?e._prepP.then((function(){e._iL=!0,e.method.onMessage(e._state,t,n)})):(e._iL=!0,e.method.onMessage(e._state,t,n))}}(e)}function H(e,t,n){e._addEL[t]=e._addEL[t].filter((function(e){return e!==n})),function(e){if(e._iL&&!V(e)){e._iL=!1;var t=e.method.microSeconds();e.method.onMessage(e._state,null,t)}}(e)}F._pubkey=!0,F.prototype={postMessage:function(e){if(this.closed)throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed "+JSON.stringify(e));return B(this,"message",e)},postInternal:function(e){return B(this,"internal",e)},set onmessage(e){var t={time:this.method.microSeconds(),fn:e};H(this,"message",this._onML),e&&"function"==typeof e?(this._onML=t,Z(this,"message",t)):this._onML=null},addEventListener:function(e,t){Z(this,e,{time:this.method.microSeconds(),fn:t})},removeEventListener:function(e,t){H(this,e,this._addEL[e].find((function(e){return e.fn===t})))},close:function(){var e=this;if(!this.closed){L.delete(this),this.closed=!0;var t=this._prepP?this._prepP:f;return this._onML=null,this._addEL.message=[],t.then((function(){return Promise.all(Array.from(e._uMP))})).then((function(){return Promise.all(e._befC.map((function(e){return e()})))})).then((function(){return e.method.close(e._state)}))}},get type(){return this.method.type},get isClosed(){return this.closed}};var q="[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0)?function(e){process.on("exit",(function(){return e()})),process.on("beforeExit",(function(){return e().then((function(){return process.exit()}))})),process.on("SIGINT",(function(){return e().then((function(){return process.exit()}))})),process.on("uncaughtException",(function(t){return e().then((function(){process.exit(101)}))}))}:function(e){if("function"==typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope){var t=self.close.bind(self);self.close=function(){return e(),t()}}else{if("function"!=typeof window.addEventListener)return;window.addEventListener("beforeunload",(function(){e()}),!0),window.addEventListener("unload",(function(){e()}),!0)}},W=new Set,K=!1;function $(){var e=[];return W.forEach((function(t){e.push(t()),W.delete(t)})),Promise.all(e)}function z(e,t){var n={context:"leader",action:t,token:e.token};return e.broadcastChannel.postInternal(n)}function Y(e){e.isLeader=!0,e._hasLeader=!0;var t=function(e){if(K||(K=!0,q($)),"function"!=typeof e)throw new Error("Listener is no function");return W.add(e),{remove:function(){return W.delete(e)},run:function(){return W.delete(e),e()}}}((function(){return e.die()}));e._unl.push(t);var n=function(t){"leader"===t.context&&"apply"===t.action&&z(e,"tell"),"leader"!==t.context||"tell"!==t.action||e._dpLC||(e._dpLC=!0,e._dpL(),z(e,"tell"))};return e.broadcastChannel.addEventListener("internal",n),e._lstns.push(n),z(e,"tell")}var G=function(e,t){var n=this;this.broadcastChannel=e,e._befC.push((function(){return n.die()})),this._options=t,this.isLeader=!1,this.isDead=!1,this.token=h(),this._lstns=[],this._unl=[],this._dpL=function(){},this._dpLC=!1,this._wKMC={},this.lN="pubkey-bc||"+e.method.type+"||"+e.name};G.prototype={hasLeader:function(){var e=this;return navigator.locks.query().then((function(t){var n=t.held?t.held.filter((function(t){return t.name===e.lN})):[];return!!(n&&n.length>0)}))},awaitLeadership:function(){var e=this;if(!this._wLMP){this._wKMC.c=new AbortController;var t=new Promise((function(t,n){e._wKMC.res=t,e._wKMC.rej=n}));this._wLMP=new Promise((function(n){navigator.locks.request(e.lN,{signal:e._wKMC.c.signal},(function(){return e._wKMC.c=void 0,Y(e),n(),t})).catch((function(){}))}))}return this._wLMP},set onduplicate(e){},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this.isLeader=!1),this.isDead=!0,this._wKMC.res&&this._wKMC.res(),this._wKMC.c&&this._wKMC.c.abort("LeaderElectionWebLock.die() called"),z(this,"death")}};var J=function(e,t){var n=this;this.broadcastChannel=e,this._options=t,this.isLeader=!1,this._hasLeader=!1,this.isDead=!1,this.token=h(),this._aplQ=f,this._aplQC=0,this._unl=[],this._lstns=[],this._dpL=function(){},this._dpLC=!1;var r=function(e){"leader"===e.context&&("death"===e.action&&(n._hasLeader=!1),"tell"===e.action&&(n._hasLeader=!0))};this.broadcastChannel.addEventListener("internal",r),this._lstns.push(r)};function Q(e,t){if(e._leaderElector)throw new Error("BroadcastChannel already has a leader-elector");t=function(e,t){return e||(e={}),(e=JSON.parse(JSON.stringify(e))).fallbackInterval||(e.fallbackInterval=3e3),e.responseTime||(e.responseTime=t.method.averageResponseTime(t.options)),e}(t,e);var n="undefined"!=typeof navigator&&void 0!==navigator.locks&&"function"==typeof navigator.locks.request?new G(e,t):new J(e,t);return e._befC.push((function(){return n.die()})),e._leaderElector=n,n}J.prototype={hasLeader:function(){return Promise.resolve(this._hasLeader)},applyOnce:function(e){var t=this;return this.isLeader?p(0,!0):this.isDead?p(0,!1):this._aplQC>1?this._aplQ:(this._aplQC=this._aplQC+1,this._aplQ=this._aplQ.then((function(){return function(){if(t.isLeader)return d;var n,r=!1,o=new Promise((function(e){n=function(){r=!0,e()}})),i=function(e){"leader"===e.context&&e.token!=t.token&&("apply"===e.action&&e.token>t.token&&n(),"tell"===e.action&&(n(),t._hasLeader=!0))};t.broadcastChannel.addEventListener("internal",i);var a=e?4*t._options.responseTime:t._options.responseTime;return z(t,"apply").then((function(){return Promise.race([p(a),o.then((function(){return Promise.reject(new Error)}))])})).then((function(){return z(t,"apply")})).then((function(){return Promise.race([p(a),o.then((function(){return Promise.reject(new Error)}))])})).catch((function(){})).then((function(){return t.broadcastChannel.removeEventListener("internal",i),!r&&Y(t).then((function(){return!0}))}))}()})).then((function(){t._aplQC=t._aplQC-1})),this._aplQ.then((function(){return t.isLeader})))},awaitLeadership:function(){return this._aLP||(this._aLP=(e=this).isLeader?f:new Promise((function(t){var n=!1;function r(){n||(n=!0,e.broadcastChannel.removeEventListener("internal",o),t(!0))}e.applyOnce().then((function(){e.isLeader&&r()})),function t(){return p(e._options.fallbackInterval).then((function(){if(!e.isDead&&!n)return e.isLeader?void r():e.applyOnce(!0).then((function(){e.isLeader?r():t()}))}))}();var o=function(t){"leader"===t.context&&"death"===t.action&&(e._hasLeader=!1,e.applyOnce().then((function(){e.isLeader&&r()})))};e.broadcastChannel.addEventListener("internal",o),e._lstns.push(o)}))),this._aLP;var e},set onduplicate(e){this._dpL=e},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this._hasLeader=!1,this.isLeader=!1),this.isDead=!0,z(this,"death")}};var X=n(415),ee=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,a.Z)(this,e),(0,l.Z)(this,"options",void 0),(0,l.Z)(this,"channel",void 0),(0,l.Z)(this,"elector",void 0),(0,l.Z)(this,"started",!1),this.options=t,this.onLeaderDuplicate=this.onLeaderDuplicate.bind(this),this.onLeader=this.onLeader.bind(this)}var t,n,r;return(0,s.Z)(e,[{key:"onLeaderDuplicate",value:function(){}},{key:"onLeader",value:(r=(0,i.Z)(c().mark((function e(){var t,n;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null===(t=(n=this.options).onLeader)||void 0===t?void 0:t.call(n);case 2:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.isLeader)}},{key:"hasLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.hasLeader)}},{key:"start",value:(n=(0,i.Z)(c().mark((function e(){var t;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(t=this.options.electionChannelName,this.channel=new F(t),this.elector=Q(this.channel),this.elector.onduplicate=this.onLeaderDuplicate,this.elector.awaitLeadership().then(this.onLeader),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=11;break}if(!this.elector){e.next=5;break}return e.next=4,this.elector.die();case 4:this.elector=void 0;case 5:if(!this.channel){e.next=10;break}return this.channel.postInternal=function(){return Promise.resolve()},e.next=9,this.channel.close();case 9:this.channel=void 0;case 10:this.started=!1;case 11:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return(0,X.isBrowser)()&&!this.started}}]),e}(),te=n(9123),ne=n(6488),re=n(7088),oe=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,l.Z)(this,"tokenManager",void 0),(0,l.Z)(this,"options",void 0),(0,l.Z)(this,"renewTimeQueue",void 0),(0,l.Z)(this,"started",!1),this.tokenManager=t,this.options=n,this.renewTimeQueue=[],this.onTokenExpiredHandler=this.onTokenExpiredHandler.bind(this)}var t,n;return(0,s.Z)(e,[{key:"shouldThrottleRenew",value:function(){var e=!1;if(this.renewTimeQueue.push(Date.now()),this.renewTimeQueue.length>=10){var t=this.renewTimeQueue.shift();e=this.renewTimeQueue[this.renewTimeQueue.length-1]-t<3e4}return e}},{key:"requiresLeadership",value:function(){return!!this.options.syncStorage&&(0,X.isBrowser)()}},{key:"processExpiredTokens",value:function(){var e=this,t=this.tokenManager.getStorage().getStorage();Object.keys(t).forEach((function(n){var r=t[n];!(0,ne.z9)(r)&&e.tokenManager.hasExpired(r)&&e.onTokenExpiredHandler(n)}))}},{key:"onTokenExpiredHandler",value:function(e){if(this.options.autoRenew)if(this.shouldThrottleRenew()){var t=new te.Z("Too many token renew requests");this.tokenManager.emitError(t)}else this.tokenManager.renew(e).catch((function(){}));else this.options.autoRemove&&this.tokenManager.remove(e)}},{key:"canStart",value:function(){return!(!this.options.autoRenew&&!this.options.autoRemove||this.started)}},{key:"start",value:(n=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(this.tokenManager.on(re.$Y,this.onTokenExpiredHandler),this.tokenManager.isStarted()&&this.processExpiredTokens(),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.started&&(this.tokenManager.off(re.$Y,this.onTokenExpiredHandler),this.renewTimeQueue=[],this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"isStarted",value:function(){return this.started}}]),e}(),ie=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,l.Z)(this,"tokenManager",void 0),(0,l.Z)(this,"options",void 0),(0,l.Z)(this,"channel",void 0),(0,l.Z)(this,"started",!1),(0,l.Z)(this,"enablePostMessage",!0),this.tokenManager=t,this.options=n,this.onTokenAddedHandler=this.onTokenAddedHandler.bind(this),this.onTokenRemovedHandler=this.onTokenRemovedHandler.bind(this),this.onTokenRenewedHandler=this.onTokenRenewedHandler.bind(this),this.onSetStorageHandler=this.onSetStorageHandler.bind(this),this.onSyncMessageHandler=this.onSyncMessageHandler.bind(this)}var t,n;return(0,s.Z)(e,[{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return!!this.options.syncStorage&&(0,X.isBrowser)()&&!this.started}},{key:"start",value:(n=(0,i.Z)(c().mark((function e(){var t;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.canStart()){e.next=2;break}return e.abrupt("return");case 2:t=this.options.syncChannelName,e.prev=3,this.channel=new F(t),e.next=10;break;case 7:throw e.prev=7,e.t0=e.catch(3),new te.Z("SyncStorageService is not supported in current browser.");case 10:this.tokenManager.on(re.O3,this.onTokenAddedHandler),this.tokenManager.on(re.FT,this.onTokenRemovedHandler),this.tokenManager.on(re.E,this.onTokenRenewedHandler),this.tokenManager.on(re.zr,this.onSetStorageHandler),this.channel.addEventListener("message",this.onSyncMessageHandler),this.started=!0;case 16:case"end":return e.stop()}}),e,this,[[3,7]])}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(c().mark((function e(){var t,n;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=10;break}return this.tokenManager.off(re.O3,this.onTokenAddedHandler),this.tokenManager.off(re.FT,this.onTokenRemovedHandler),this.tokenManager.off(re.E,this.onTokenRenewedHandler),this.tokenManager.off(re.zr,this.onSetStorageHandler),null===(t=this.channel)||void 0===t||t.removeEventListener("message",this.onSyncMessageHandler),e.next=8,null===(n=this.channel)||void 0===n?void 0:n.close();case 8:this.channel=void 0,this.started=!1;case 10:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"onTokenAddedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:re.O3,key:e,token:t}))}},{key:"onTokenRemovedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:re.FT,key:e,token:t}))}},{key:"onTokenRenewedHandler",value:function(e,t,n){var r;this.enablePostMessage&&(null===(r=this.channel)||void 0===r||r.postMessage({type:re.E,key:e,token:t,oldToken:n}))}},{key:"onSetStorageHandler",value:function(e){var t;null===(t=this.channel)||void 0===t||t.postMessage({type:re.zr,storage:e})}},{key:"onSyncMessageHandler",value:function(e){switch(this.enablePostMessage=!1,e.type){case re.zr:this.tokenManager.getStorage().setStorage(e.storage);break;case re.O3:this.tokenManager.emitAdded(e.key,e.token),this.tokenManager.setExpireEventTimeout(e.key,e.token);break;case re.FT:this.tokenManager.clearExpireEventTimeout(e.key),this.tokenManager.emitRemoved(e.key,e.token);break;case re.E:this.tokenManager.emitRenewed(e.key,e.token,e.oldToken)}this.enablePostMessage=!0}}]),e}(),ae=function(){return Math.floor(Date.now()/1e3)},se=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,l.Z)(this,"tokenManager",void 0),(0,l.Z)(this,"started",!1),(0,l.Z)(this,"options",void 0),(0,l.Z)(this,"lastHidden",-1),(0,l.Z)(this,"onPageVisbilityChange",void 0),this.tokenManager=t,this.options=n,this.onPageVisbilityChange=this._onPageVisbilityChange.bind(this)}var t,n;return(0,s.Z)(e,[{key:"_onPageVisbilityChange",value:function(){if(document.hidden)this.lastHidden=ae();else if(this.lastHidden>0&&ae()-this.lastHidden>=this.options.tabInactivityDuration){var e=this.tokenManager.getTokensSync(),t=e.accessToken,n=e.idToken;if(t&&this.tokenManager.hasExpired(t)){var r=this.tokenManager.getStorageKeyByType("accessToken");this.tokenManager.renew(r).catch((function(){}))}else if(n&&this.tokenManager.hasExpired(n)){var o=this.tokenManager.getStorageKeyByType("idToken");this.tokenManager.renew(o).catch((function(){}))}}}},{key:"start",value:(n=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&document&&(document.addEventListener("visibilitychange",this.onPageVisbilityChange),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:document&&(document.removeEventListener("visibilitychange",this.onPageVisbilityChange),this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"canStart",value:function(){return(0,X.isBrowser)()&&!!this.options.autoRenew&&!!this.options.renewOnTabActivation&&!this.started}},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}}]),e}(),le=n(3193);function ue(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ce(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ue(Object(n),!0).forEach((function(t){(0,l.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ue(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function de(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return fe(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?fe(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function fe(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var pe="autoRenew",he="syncStorage",me="leaderElection",ve="renewOnTabActivation",ge=function(){function e(t){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,l.Z)(this,"sdk",void 0),(0,l.Z)(this,"options",void 0),(0,l.Z)(this,"services",void 0),(0,l.Z)(this,"started",void 0),this.sdk=t,this.onLeader=this.onLeader.bind(this);var o=t.tokenManager.getOptions(),i=o.autoRenew,s=o.autoRemove,u=o.syncStorage;r.electionChannelName=r.electionChannelName||r.broadcastChannelName,this.options=Object.assign({},e.defaultOptions,{autoRenew:i,autoRemove:s,syncStorage:u},{electionChannelName:"".concat(t.options.clientId,"-election"),syncChannelName:"".concat(t.options.clientId,"-sync")},(0,le.YY)(r)),this.started=!1,this.services=new Map,e.knownServices.forEach((function(e){var t=n.createService(e);t&&n.services.set(e,t)}))}var t,n,u,d,f;return(0,s.Z)(e,[{key:"onLeader",value:(f=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=3;break}return e.next=3,this.startServices();case 3:case"end":return e.stop()}}),e,this)}))),function(){return f.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return null===(e=this.getService(me))||void 0===e?void 0:e.isLeader()}},{key:"isLeaderRequired",value:function(){return(0,o.Z)(this.services.values()).some((function(e){return e.canStart()&&e.requiresLeadership()}))}},{key:"start",value:(d=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,this.startServices();case 4:this.started=!0;case 5:case"end":return e.stop()}}),e,this)}))),function(){return d.apply(this,arguments)})},{key:"stop",value:(u=(0,i.Z)(c().mark((function e(){return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.stopServices();case 2:this.started=!1;case 3:case"end":return e.stop()}}),e,this)}))),function(){return u.apply(this,arguments)})},{key:"getService",value:function(e){return this.services.get(e)}},{key:"startServices",value:(n=(0,i.Z)(c().mark((function e(){var t,n,o,i,a;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=de(this.services.entries()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=10;break}if(o=(0,r.Z)(n.value,2),i=o[0],a=o[1],!this.canStartService(i,a)){e.next=8;break}return e.next=8,a.start();case 8:e.next=3;break;case 10:e.next=15;break;case 12:e.prev=12,e.t0=e.catch(1),t.e(e.t0);case 15:return e.prev=15,t.f(),e.finish(15);case 18:case"end":return e.stop()}}),e,this,[[1,12,15,18]])}))),function(){return n.apply(this,arguments)})},{key:"stopServices",value:(t=(0,i.Z)(c().mark((function e(){var t,n,r;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=de(this.services.values()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=9;break}return r=n.value,e.next=7,r.stop();case 7:e.next=3;break;case 9:e.next=14;break;case 11:e.prev=11,e.t0=e.catch(1),t.e(e.t0);case 14:return e.prev=14,t.f(),e.finish(14);case 17:case"end":return e.stop()}}),e,this,[[1,11,14,17]])}))),function(){return t.apply(this,arguments)})},{key:"canStartService",value:function(e,t){var n=t.canStart()&&!t.isStarted();return e===me?n&&(n=this.isLeaderRequired()):t.requiresLeadership()&&n&&(n=this.isLeader()),n}},{key:"createService",value:function(e){var t,n=this.sdk.tokenManager;switch(e){case me:t=new ee(ce(ce({},this.options),{},{onLeader:this.onLeader}));break;case pe:t=new oe(n,ce({},this.options));break;case he:t=new ie(n,ce({},this.options));break;case ve:t=new se(n,ce({},this.options));break;default:throw new Error("Unknown service ".concat(e))}return t}}]),e}();(0,l.Z)(ge,"knownServices",[pe,he,me,ve]),(0,l.Z)(ge,"defaultOptions",{autoRenew:!0,autoRemove:!0,syncStorage:!0,renewOnTabActivation:!0,tabInactivityDuration:1800})},6599:function(e,t,n){"use strict";n.d(t,{W:function(){return r.W}});var r=n(9046)},1578:function(e,t,n){"use strict";n.d(t,{K:function(){return u}});var r=n(9893),o=n(265),i=n(279),a=n(2724),s=n(8386),l=n(3980);function u(e,t,n){var u=(0,r.a)(t),c=(0,o.H)(u,e),d=(0,i.A)(c),f=(0,l.Z)(d),p=(0,a.J)(f,n);return(0,s.i)(p)}},3961:function(e,t,n){"use strict";n.r(t),n.d(t,{AuthStateManager:function(){return r.E},INITIAL_AUTH_STATE:function(){return r.a},ServiceManager:function(){return d.W},createCoreOptionsConstructor:function(){return o.n},createCoreStorageManager:function(){return s.a},createOktaAuthCore:function(){return i.K},mixinCore:function(){return a.i}});var r=n(1018),o=n(9133),i=n(1578),a=n(8386),s=n(2647),l=n(8553),u={};for(var c in l)["default","AuthStateManager","INITIAL_AUTH_STATE","createCoreOptionsConstructor","createOktaAuthCore","mixinCore","createCoreStorageManager"].indexOf(c)<0&&(u[c]=function(e){return l[e]}.bind(0,c));n.d(t,u);var d=n(6599)},8386:function(e,t,n){"use strict";n.d(t,{i:function(){return g}});var r=n(5861),o=n(5671),i=n(3144),a=n(7326),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(4687),f=n.n(d),p=n(5372),h=n(1018),m=n(9046),v=n(9123);function g(e){return function(e){(0,s.Z)(_,e);var t,n,d,g,y,b,w=(y=_,b=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,u.Z)(y);if(b){var n=(0,u.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,l.Z)(this,e)});function _(){var e;(0,o.Z)(this,_);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=w.call.apply(w,[this].concat(n)),(0,c.Z)((0,a.Z)(e),"authStateManager",void 0),(0,c.Z)((0,a.Z)(e),"serviceManager",void 0),e.authStateManager=new h.E((0,a.Z)(e)),e.serviceManager=new m.W((0,a.Z)(e),e.options.services),e}return(0,i.Z)(_,[{key:"start",value:(g=(0,r.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.serviceManager.start();case 2:if(this.tokenManager.start(),this.token.isLoginRedirect()){e.next=6;break}return e.next=6,this.authStateManager.updateAuthState();case 6:case"end":return e.stop()}}),e,this)}))),function(){return g.apply(this,arguments)})},{key:"stop",value:(d=(0,r.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.tokenManager.stop(),e.next=3,this.serviceManager.stop();case 3:case"end":return e.stop()}}),e,this)}))),function(){return d.apply(this,arguments)})},{key:"handleRedirect",value:(n=(0,r.Z)(f().mark((function e(t){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.handleLoginRedirect(void 0,t);case 2:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"handleLoginRedirect",value:(t=(0,r.Z)(f().mark((function e(t,n){var r,o,i;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=this.options.state,!t){e.next=6;break}this.tokenManager.setTokens(t),n=n||this.getOriginalUri(this.options.state),e.next=25;break;case 6:if(!this.isLoginRedirect()){e.next=24;break}return e.prev=7,e.next=10,(0,p.Tp)(this,{});case 10:return o=e.sent,r=o.state,n=n||this.getOriginalUri(r),e.next=15,this.storeTokensFromRedirect();case 15:e.next=22;break;case 17:return e.prev=17,e.t0=e.catch(7),e.next=21,this.authStateManager.updateAuthState();case 21:throw e.t0;case 22:e.next=25;break;case 24:return e.abrupt("return");case 25:return e.next=27,this.authStateManager.updateAuthState();case 27:if(this.removeOriginalUri(r),!(i=this.options.restoreOriginalUri)){e.next=34;break}return e.next=32,i(this,n);case 32:e.next=35;break;case 34:n&&window.location.replace(n);case 35:case"end":return e.stop()}}),e,this,[[7,17]])}))),function(e,n){return t.apply(this,arguments)})},{key:"handleIDPPopupRedirect",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.location.href,t=(0,p.Tp)(this,{responseMode:"query",url:e});if(!t.state)throw new v.Z("Unable to parse auth code params");var n=new BroadcastChannel("popup-callback:".concat(t.state));n.postMessage(t),n.close()}}]),_}(e)}},9133:function(e,t,n){"use strict";n.d(t,{n:function(){return d}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(9453);function d(){return function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e){var t;return(0,o.Z)(this,d),t=c.call(this,e),(0,u.Z)((0,i.Z)(t),"services",void 0),(0,u.Z)((0,i.Z)(t),"transformAuthState",void 0),t.services=e.services,t.transformAuthState=e.transformAuthState,t}return(0,r.Z)(d)}((0,c.m)())}},2647:function(e,t,n){"use strict";n.d(t,{a:function(){return o}});var r=n(2333);function o(){return(0,r.a)()}},5675:function(){},8553:function(e,t,n){"use strict";n.r(t);var r=n(5675),o={};for(var i in r)"default"!==i&&(o[i]=function(e){return r[e]}.bind(0,i));n.d(t,o)},7987:function(e,t,n){"use strict";n.d(t,{Df:function(){return s},EL:function(){return c},NL:function(){return i},Wy:function(){return l},aR:function(){return a},dX:function(){return d},k8:function(){return u},kQ:function(){return f}});var r=n(9123),o=n(7594);function i(e){return a((0,o.r3)(e))}function a(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function s(e){return e.replace(/-/g,"+").replace(/_/g,"/")}function l(e){var t=s(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw new r.Z("Not a valid Base64Url")}var n=(0,o.ty)(t);try{return decodeURIComponent(escape(n))}catch(e){return n}}function u(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}function c(e){return(0,o.ty)(s(e))}function d(e){return Uint8Array.from(c(e),(function(e){return e.charCodeAt(0)}))}function f(e){return(0,o.r3)(new Uint8Array(e).reduce((function(e,t){return e+String.fromCharCode(t)}),""))}},7594:function(e,t,n){"use strict";n.d(t,{KP:function(){return i},r3:function(){return o},ty:function(){return r}});var r=function(e){return atob(e)},o=function(e){return btoa(e)},i="undefined"==typeof crypto?null:crypto},9718:function(e,t,n){"use strict";n.r(t),n.d(t,{atob:function(){return u.ty},base64ToBase64Url:function(){return r.aR},base64UrlDecode:function(){return r.EL},base64UrlToBase64:function(){return r.Df},base64UrlToBuffer:function(){return r.dX},base64UrlToString:function(){return r.Wy},btoa:function(){return u.r3},bufferToBase64Url:function(){return r.kQ},getOidcHash:function(){return o.X},stringToBase64Url:function(){return r.NL},stringToBuffer:function(){return r.k8},verifyToken:function(){return l.W},webcrypto:function(){return u.KP}});var r=n(7987),o=n(5698),i=n(6332),a={};for(var s in i)["default","base64ToBase64Url","base64UrlDecode","base64UrlToBase64","base64UrlToBuffer","base64UrlToString","bufferToBase64Url","stringToBase64Url","stringToBuffer","getOidcHash"].indexOf(s)<0&&(a[s]=function(e){return i[e]}.bind(0,s));n.d(t,a);var l=n(3154),u=n(1)},5698:function(e,t,n){"use strict";n.d(t,{X:function(){return i}});var r=n(7987),o=n(7594);function i(e){var t=(new TextEncoder).encode(e);return o.KP.subtle.digest("SHA-256",t).then((function(e){var t=new Uint8Array(e).slice(0,16),n=String.fromCharCode.apply(null,t);return(0,r.NL)(n)}))}},6332:function(){},3154:function(e,t,n){"use strict";n.d(t,{W:function(){return a}});var r=n(3193),o=n(7987),i=n(7594);function a(e,t){t=(0,r.d9)(t);var n={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}};return delete t.use,i.KP.subtle.importKey("jwk",t,n,!0,["verify"]).then((function(t){var r=e.split("."),a=(0,o.k8)(r[0]+"."+r[1]),s=(0,o.EL)(r[2]),l=(0,o.k8)(s);return i.KP.subtle.verify(n,t,l,a)}))}},1:function(e,t,n){"use strict";n.d(t,{KP:function(){return r.KP},r3:function(){return r.r3},ty:function(){return r.ty}});var r=n(7594)},3983:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e,t,n){var r;(0,o.Z)(this,d);var a=e.errorSummary;return r=c.call(this,a),(0,u.Z)((0,i.Z)(r),"errorSummary",void 0),(0,u.Z)((0,i.Z)(r),"errorCode",void 0),(0,u.Z)((0,i.Z)(r),"errorLink",void 0),(0,u.Z)((0,i.Z)(r),"errorId",void 0),(0,u.Z)((0,i.Z)(r),"errorCauses",void 0),(0,u.Z)((0,i.Z)(r),"xhr",void 0),(0,u.Z)((0,i.Z)(r),"meta",void 0),r.name="AuthApiError",r.errorSummary=e.errorSummary,r.errorCode=e.errorCode,r.errorLink=e.errorLink,r.errorId=e.errorId,r.errorCauses=e.errorCauses,t&&(r.xhr=t),n&&(r.meta=n),r}return(0,r.Z)(d)}(n(6245).Z)},6573:function(e,t,n){"use strict";n.d(t,{Z:function(){return l}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.call(this,"The poll was stopped by the sdk")}return(0,r.Z)(u)}(n(6245).Z)},9123:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e,t){var n;return(0,o.Z)(this,d),n=c.call(this,e),(0,u.Z)((0,i.Z)(n),"errorSummary",void 0),(0,u.Z)((0,i.Z)(n),"errorCode",void 0),(0,u.Z)((0,i.Z)(n),"errorLink",void 0),(0,u.Z)((0,i.Z)(n),"errorId",void 0),(0,u.Z)((0,i.Z)(n),"errorCauses",void 0),(0,u.Z)((0,i.Z)(n),"xhr",void 0),n.name="AuthSdkError",n.errorCode="INTERNAL",n.errorSummary=e,n.errorLink="INTERNAL",n.errorId="INTERNAL",n.errorCauses=[],t&&(n.xhr=t),n}return(0,r.Z)(d)}(n(6245).Z)},6245:function(e,t,n){"use strict";n.d(t,{Z:function(){return f}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(9611);function c(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(c=function(){return!!e})()}function d(e){var t="function"==typeof Map?new Map:void 0;return d=function(e){if(null===e||!function(e){try{return-1!==Function.toString.call(e).indexOf("[native code]")}catch(t){return"function"==typeof e}}(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,n)}function n(){return function(e,t,n){if(c())return Reflect.construct.apply(null,arguments);var r=[null];r.push.apply(r,t);var o=new(e.bind.apply(e,r));return n&&(0,u.Z)(o,n.prototype),o}(e,arguments,(0,l.Z)(this).constructor)}return n.prototype=Object.create(e.prototype,{constructor:{value:n,enumerable:!1,writable:!0,configurable:!0}}),(0,u.Z)(n,e)},d(e)}var f=function(e){(0,a.Z)(c,e);var t,n,u=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function c(e){var t;return(0,o.Z)(this,c),t=u.call(this,e),Object.setPrototypeOf((0,i.Z)(t),(this instanceof c?this.constructor:void 0).prototype),t}return(0,r.Z)(c)}(d(Error))},2886:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e,t,n){var r;return(0,o.Z)(this,d),r=c.call(this,t),(0,u.Z)((0,i.Z)(r),"errorCode",void 0),(0,u.Z)((0,i.Z)(r),"errorSummary",void 0),(0,u.Z)((0,i.Z)(r),"error",void 0),(0,u.Z)((0,i.Z)(r),"error_description",void 0),(0,u.Z)((0,i.Z)(r),"resp",null),r.name="OAuthError",r.errorCode=e,r.errorSummary=t,r.error=e,r.error_description=t,n&&(r.resp=n),r}return(0,r.Z)(d)}(n(6245).Z)},3114:function(e,t,n){"use strict";n.d(t,{Z:function(){return f}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(6245),d=n(4771),f=function(e){(0,a.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function f(e,t,n){var o,a;return(0,r.Z)(this,f),a=c.call(this,null!==(o=t.error)&&void 0!==o?o:f.UNKNOWN_ERROR),(0,u.Z)((0,i.Z)(a),"scheme",void 0),(0,u.Z)((0,i.Z)(a),"parameters",void 0),(0,u.Z)((0,i.Z)(a),"name","WWWAuthError"),(0,u.Z)((0,i.Z)(a),"resp",null),a.scheme=e,a.parameters=t,n&&(a.resp=n),a}return(0,o.Z)(f,[{key:"error",get:function(){return this.parameters.error}},{key:"errorCode",get:function(){return this.error}},{key:"error_description",get:function(){return this.parameters.error_description}},{key:"errorDescription",get:function(){return this.error_description}},{key:"errorSummary",get:function(){return this.errorDescription}},{key:"realm",get:function(){return this.parameters.realm}}],[{key:"parseHeader",value:function(e){if(!e)return null;for(var t,n=/(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g,r=e.indexOf(" "),o=e.slice(0,r),i=e.slice(r+1),a={};null!==(t=n.exec(i));){var s;a[t[1]]=null!==(s=t[2])&&void 0!==s?s:t[3]}return new f(o,a)}},{key:"getWWWAuthenticateHeader",value:function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return(0,d.mf)(null==t?void 0:t.get)?t.get("WWW-Authenticate"):null!==(e=t["www-authenticate"])&&void 0!==e?e:t["WWW-Authenticate"]}}]),f}(c.Z);(0,u.Z)(f,"UNKNOWN_ERROR","UNKNOWN_WWW_AUTH_ERROR")},5728:function(e,t,n){"use strict";n.r(t),n.d(t,{AuthApiError:function(){return r.Z},AuthPollStopError:function(){return o.Z},AuthSdkError:function(){return i.Z},OAuthError:function(){return a.Z},WWWAuthError:function(){return s.Z},isAuthApiError:function(){return d},isOAuthError:function(){return f},isWWWAuthError:function(){return p}});var r=n(3983),o=n(6573),i=n(9123),a=n(2886),s=n(3114),l=n(1243),u={};for(var c in l)["default","isAuthApiError","isOAuthError","isWWWAuthError","AuthApiError","AuthPollStopError","AuthSdkError","OAuthError","WWWAuthError"].indexOf(c)<0&&(u[c]=function(e){return l[e]}.bind(0,c));function d(e){return e instanceof r.Z}function f(e){return e instanceof a.Z}function p(e){return e instanceof s.Z}n.d(t,u)},1243:function(){},6736:function(e,t,n){"use strict";n.r(t),n.d(t,{ACCESS_TOKEN_STORAGE_KEY:function(){return i.ACCESS_TOKEN_STORAGE_KEY},BaseStorageManager:function(){return p.W8},CACHE_STORAGE_NAME:function(){return i.CACHE_STORAGE_NAME},DEFAULT_CACHE_DURATION:function(){return i.DEFAULT_CACHE_DURATION},DEFAULT_CODE_CHALLENGE_METHOD:function(){return i.DEFAULT_CODE_CHALLENGE_METHOD},DEFAULT_MAX_CLOCK_SKEW:function(){return i.DEFAULT_MAX_CLOCK_SKEW},DEFAULT_POLLING_DELAY:function(){return i.DEFAULT_POLLING_DELAY},IDX_API_VERSION:function(){return i.IDX_API_VERSION},IDX_RESPONSE_STORAGE_NAME:function(){return i.IDX_RESPONSE_STORAGE_NAME},ID_TOKEN_STORAGE_KEY:function(){return i.ID_TOKEN_STORAGE_KEY},IOS_MAX_RETRY_COUNT:function(){return i.IOS_MAX_RETRY_COUNT},MAX_VERIFIER_LENGTH:function(){return i.MAX_VERIFIER_LENGTH},MIN_VERIFIER_LENGTH:function(){return i.MIN_VERIFIER_LENGTH},ORIGINAL_URI_STORAGE_NAME:function(){return i.ORIGINAL_URI_STORAGE_NAME},OktaUserAgent:function(){return c.ed},PKCE_STORAGE_NAME:function(){return i.PKCE_STORAGE_NAME},PromiseQueue:function(){return h.bo},REFERRER_PATH_STORAGE_KEY:function(){return i.REFERRER_PATH_STORAGE_KEY},REFRESH_TOKEN_STORAGE_KEY:function(){return i.REFRESH_TOKEN_STORAGE_KEY},SHARED_TRANSACTION_STORAGE_NAME:function(){return i.SHARED_TRANSACTION_STORAGE_NAME},STATE_TOKEN_KEY_NAME:function(){return i.STATE_TOKEN_KEY_NAME},SavedObject:function(){return p._e},TOKEN_STORAGE_NAME:function(){return i.TOKEN_STORAGE_NAME},TRANSACTION_STORAGE_NAME:function(){return i.TRANSACTION_STORAGE_NAME},bind:function(){return h.ak},clone:function(){return h.d9},closeSession:function(){return f.RJ},createBaseOptionsConstructor:function(){return o.X},createHttpOptionsConstructor:function(){return c.ZM},createOktaAuthBase:function(){return o.a},createSessionApi:function(){return f.MG},createStorageOptionsConstructor:function(){return p.Tp},crypto:function(){return r},delay:function(){return h.gw},deprecate:function(){return h.Rn},deprecateWrap:function(){return h.VA},extend:function(){return h.l7},find:function(){return h.sE},genRandomString:function(){return h.uh},get:function(){return c.U2},getConsole:function(){return h.dr},getLink:function(){return h.Rg},getNativeConsole:function(){return h.sW},getSession:function(){return f.Gg},httpRequest:function(){return c.c3},isAbsoluteUrl:function(){return h.sD},isFunction:function(){return h.mf},isNumber:function(){return h.hj},isObject:function(){return h.Kn},isPromise:function(){return h.tI},isString:function(){return h.HD},isoToUTCString:function(){return h.ng},logServerSideMemoryStorageWarning:function(){return p.Vp},mixinHttp:function(){return c.Am},mixinSession:function(){return f.Zg},mixinStorage:function(){return p.Ho},omit:function(){return h.CE},post:function(){return c.v_},refreshSession:function(){return f.dx},removeNils:function(){return h.YY},removeTrailingSlash:function(){return h.Qj},sessionExists:function(){return f.sH},setCookieAndRedirect:function(){return f.OT},setRequestHeader:function(){return c.rn},split2:function(){return h.YQ},toAbsoluteUrl:function(){return h.BY},toQueryString:function(){return h.UK},toRelativeUrl:function(){return h.QN},warn:function(){return h.ZK}});var r=n(9718),o=n(3306),i=n(1971),a=n(3961),s={};for(var l in a)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","IOS_MAX_RETRY_COUNT","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME"].indexOf(l)<0&&(s[l]=function(e){return a[e]}.bind(0,l));n.d(t,s);var u=n(5728);for(var l in s={},u)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","IOS_MAX_RETRY_COUNT","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","AuthStateManager","INITIAL_AUTH_STATE","ServiceManager","createCoreOptionsConstructor","createCoreStorageManager","createOktaAuthCore","mixinCore"].indexOf(l)<0&&(s[l]=function(e){return u[e]}.bind(0,l));n.d(t,s);var c=n(4777),d=n(9443);for(var l in s={},d)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","IOS_MAX_RETRY_COUNT","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","AuthStateManager","INITIAL_AUTH_STATE","ServiceManager","createCoreOptionsConstructor","createCoreStorageManager","createOktaAuthCore","mixinCore","AuthApiError","AuthPollStopError","AuthSdkError","OAuthError","WWWAuthError","isAuthApiError","isOAuthError","isWWWAuthError","OktaUserAgent","createHttpOptionsConstructor","get","httpRequest","mixinHttp","post","setRequestHeader"].indexOf(l)<0&&(s[l]=function(e){return d[e]}.bind(0,l));n.d(t,s);var f=n(8041),p=n(9927),h=n(305)},415:function(e,t,n){"use strict";n.r(t),n.d(t,{getUserAgent:function(){return s},hasTextEncoder:function(){return f},isBrowser:function(){return i},isDPoPSupported:function(){return v},isFingerprintSupported:function(){return l},isHTTPS:function(){return h},isIE11OrLess:function(){return a},isIOS:function(){return g},isLocalhost:function(){return m},isPKCESupported:function(){return p},isPopupPostMessageSupported:function(){return u},isTokenVerifySupported:function(){return d}});var r=n(7594),o=/windows phone|iemobile|wpdesktop/i;function i(){return"undefined"!=typeof document&&"undefined"!=typeof window}function a(){if(!i())return!1;var e=document.documentMode;return!!e&&e<=11}function s(){return navigator.userAgent}function l(){var e=s();return e&&!o.test(e)}function u(){if(!i())return!1;var e=document.documentMode,t=e&&e<10;return void 0!==window.postMessage&&!t}function c(){return void 0!==r.KP&&null!==r.KP&&void 0!==r.KP.subtle&&"undefined"!=typeof Uint8Array}function d(){return c()}function f(){return"undefined"!=typeof TextEncoder}function p(){return d()&&f()}function h(){return!!i()&&"https:"===window.location.protocol}function m(){return i()&&"localhost"===window.location.hostname}function v(){return!a()&&void 0!==window.indexedDB&&f()&&c()}function g(){return i()&&"undefined"!=typeof navigator&&void 0!==navigator.userAgent&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream}},287:function(e,t,n){"use strict";n.d(t,{e:function(){return s}});var r=n(5671),o=n(3144),i=n(4942),a=n(415),s=function(){function e(){(0,r.Z)(this,e),(0,i.Z)(this,"environments",void 0),this.environments=["okta-auth-js/".concat("7.14.0")],this.maybeAddNodeEnvironment()}return(0,o.Z)(e,[{key:"addEnvironment",value:function(e){this.environments.push(e)}},{key:"getHttpHeader",value:function(){return{"X-Okta-User-Agent-Extended":this.environments.join(" ")}}},{key:"getVersion",value:function(){return"7.14.0"}},{key:"maybeAddNodeEnvironment",value:function(){if(!(0,a.isBrowser)()&&process&&process.versions){var e=process.versions.node;this.environments.push("nodejs/".concat(e))}}}]),e}()},2281:function(e,t,n){"use strict";function r(e,t,n){e.options.headers=e.options.headers||{},e.options.headers[t]=n}n.d(t,{r:function(){return r}})},4777:function(e,t,n){"use strict";n.d(t,{Am:function(){return a.A},U2:function(){return i.U2},ZM:function(){return s.Z},c3:function(){return i.c3},ed:function(){return o.e},rn:function(){return r.r},v_:function(){return i.v_}});var r=n(2281),o=n(287),i=n(5385),a=n(279),s=n(8817)},279:function(e,t,n){"use strict";n.d(t,{A:function(){return h}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(287),d=n(2281),f=n(6718),p=n(5385);function h(e){return function(e){(0,a.Z)(m,e);var t,n,h=(t=m,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function m(){var e;(0,r.Z)(this,m);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=h.call.apply(h,[this].concat(n)),(0,u.Z)((0,i.Z)(e),"_oktaUserAgent",void 0),(0,u.Z)((0,i.Z)(e),"http",void 0),e._oktaUserAgent=new c.e,e.http={setRequestHeader:d.r.bind(null,(0,i.Z)(e))},e}return(0,o.Z)(m,[{key:"setHeaders",value:function(e){this.options.headers=Object.assign({},this.options.headers,e)}},{key:"getIssuerOrigin",value:function(){return this.options.issuer.split("/oauth2/")[0]}},{key:"webfinger",value:function(e){var t="/.well-known/webfinger"+(0,f.UK)(e);return(0,p.U2)(this,t,{headers:{Accept:"application/jrd+json"}})}}]),m}(e)}},8817:function(e,t,n){"use strict";n.d(t,{Z:function(){return y}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(3849),d=n(885),f=n(1002),p=n(4098),h=n.n(p);function m(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var v=/application\/\w*\+?json/,g=function(e,t,r){var o=r.data,i=r.headers||{},a=i["Content-Type"]||i["content-type"]||"";o&&"string"!=typeof o&&(v.test(a)?o=JSON.stringify(o):"application/x-www-form-urlencoded"===a&&(o=Object.entries(o).map((function(e){var t=(0,d.Z)(e,2),n=t[0],r=t[1];return"".concat(n,"=").concat(encodeURIComponent(r))})).join("&")));var s=(n.g.fetch||h())(t,{method:e,headers:r.headers,body:o,credentials:r.withCredentials?"include":"omit"});return s.finally||(s=Promise.resolve(s)),s.then((function(e){var t=!e.ok,n=e.status;return function(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch((function(e){return{error:e,errorSummary:"Could not parse server response"}})):e.text()}(e).then((function(t){return function(e,t,n){var r,o="object"===(0,f.Z)(t),i={},a=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return m(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?m(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}(n.headers.entries());try{for(a.s();!(r=a.n()).done;){var s=r.value;i[s[0]]=s[1]}}catch(e){a.e(e)}finally{a.f()}var l={responseText:o?JSON.stringify(t):t,status:e,headers:i};return o&&(l.responseType="json",l.responseJSON=t),l}(n,t,e)})).then((function(e){var n;if(t||null!==(n=e.responseJSON)&&void 0!==n&&n.error)throw e;return e}))}))};function y(){return function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e){var t;return(0,o.Z)(this,d),t=c.call(this,e),(0,u.Z)((0,i.Z)(t),"issuer",void 0),(0,u.Z)((0,i.Z)(t),"transformErrorXHR",void 0),(0,u.Z)((0,i.Z)(t),"headers",void 0),(0,u.Z)((0,i.Z)(t),"httpRequestClient",void 0),(0,u.Z)((0,i.Z)(t),"httpRequestInterceptors",void 0),(0,u.Z)((0,i.Z)(t),"pollDelay",void 0),t.issuer=e.issuer,t.transformErrorXHR=e.transformErrorXHR,t.headers=e.headers,t.httpRequestClient=e.httpRequestClient||g,t.httpRequestInterceptors=e.httpRequestInterceptors,t.pollDelay=e.pollDelay,t}return(0,r.Z)(d)}((0,c.T)())}},5385:function(e,t,n){"use strict";n.d(t,{U2:function(){return w},c3:function(){return b},v_:function(){return _}});var r=n(1002),o=n(4942),i=n(4771),a=n(3193),s=n(6718),l=n(1971),u=n(3983),c=n(3114),d=n(2886),f=n(415);function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v,g=0;(0,f.isBrowser)()&&(g=Date.now(),v=function(){document.hidden||(g=Date.now())},document.addEventListener("visibilitychange",v));var y=function(e,t){var n,r,o,s;if(t instanceof Error)return new u.Z({errorSummary:t.message});var l,f=t,p={};if(f.responseText&&(0,i.HD)(f.responseText))try{p=JSON.parse(f.responseText)}catch(e){p={errorSummary:"Unknown error"}}f.status>=500&&(p.errorSummary="Unknown error"),e.options.transformErrorXHR&&(f=e.options.transformErrorXHR((0,a.d9)(f)));var h=null!==(n=c.Z.getWWWAuthenticateHeader(null===(r=f)||void 0===r?void 0:r.headers))&&void 0!==n?n:"";if(l=p.error&&p.error_description?new d.Z(p.error,p.error_description,f):new u.Z(p,f,{wwwAuthHeader:h}),h&&(null===(o=f)||void 0===o?void 0:o.status)>=400&&(null===(s=f)||void 0===s?void 0:s.status)<500){var v=c.Z.parseHeader(h);if(403===f.status&&"insufficient_authentication_context"===(null==v?void 0:v.error)){var g=v.parameters,y=g.max_age,b=g.acr_values;l=new u.Z({errorSummary:v.error,errorCauses:[{errorSummary:v.errorDescription}]},f,m({max_age:+y},b&&{acr_values:b}))}else"DPoP"===(null==v?void 0:v.scheme)&&(l=v)}return l};function b(e,t){var n;if(t=t||{},e.options.httpRequestInterceptors){var o,s=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return p(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?p(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}(e.options.httpRequestInterceptors);try{for(s.s();!(o=s.n()).done;)(0,o.value)(t)}catch(T){s.e(T)}finally{s.f()}}var u=t.url,c=t.method,d=t.args,h=t.saveAuthnState,v=t.accessToken,b=!0===t.withCredentials,w=e.options.storageUtil.storage,_=e.storageManager.getHttpCache(e.options.cookies),O=t.pollingIntent,k=null!==(n=e.options.pollDelay)&&void 0!==n?n:0;if(t.cacheResponse){var x=_.getStorage()[u];if(x&&Date.now()/1e3<x.expiresAt)return Promise.resolve(x.response)}var E=m({Accept:"application/json","Content-Type":"application/json"},e._oktaUserAgent.getHttpHeader());Object.assign(E,e.options.headers,t.headers),E=(0,a.YY)(E),v&&(0,i.HD)(v)&&(E.Authorization="Bearer "+v);var T,S,A,P={headers:E,data:d||void 0,withCredentials:b};if(O&&(0,f.isBrowser)()&&k>0){var C,R,I,N=0;R=function(){var e=Date.now()-g;return e<k?new Promise((function(t){return setTimeout((function(){document.hidden?t(C()):t()}),k-e)})):Promise.resolve()},C=function(){var e;return document.hidden?new Promise((function(t){e=function(){document.hidden||(document.removeEventListener("visibilitychange",e),t(R()))},document.addEventListener("visibilitychange",e)})):R()};var M=function(){return e.options.httpRequestClient(c,u,P).catch((function(e){if("Load failed"===(null==e?void 0:e.message)&&N<l.IOS_MAX_RETRY_COUNT)return N++,I();throw e}))};A=(I=function(){return C().then(M)})()}else A=e.options.httpRequestClient(c,u,P);return A.then((function(n){return(S=n.responseText)&&(0,i.HD)(S)&&(S=JSON.parse(S))&&"object"===(0,r.Z)(S)&&!S.headers&&(Array.isArray(S)?S.forEach((function(e){e.headers=n.headers})):S.headers=n.headers),h&&(S.stateToken||w.delete(l.STATE_TOKEN_KEY_NAME)),S&&S.stateToken&&S.expiresAt&&w.set(l.STATE_TOKEN_KEY_NAME,S.stateToken,S.expiresAt,e.options.cookies),S&&t.cacheResponse&&_.updateStorage(u,{expiresAt:Math.floor(Date.now()/1e3)+l.DEFAULT_CACHE_DURATION,response:S}),S})).catch((function(t){throw"E0000011"===(T=y(e,t)).errorCode&&w.delete(l.STATE_TOKEN_KEY_NAME),T}))}function w(e,t,n){var r={url:t=(0,s.sD)(t)?t:e.getIssuerOrigin()+t,method:"GET"};return Object.assign(r,n),b(e,r)}function _(e,t,n,r){var o={url:t=(0,s.sD)(t)?t:e.getIssuerOrigin()+t,method:"POST",args:n,saveAuthnState:!0};return Object.assign(o,r),b(e,o)}},3334:function(e,t,n){"use strict";n.d(t,{v:function(){return d}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),s=n(2963),l=n(1120),u=n(1646),c=n(480);function d(){return function(e){(0,a.Z)(d,e);var t,n,u=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e){return(0,r.Z)(this,d),u.call(this,e)}return(0,o.Z)(d,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,i.Z)((0,l.Z)(d.prototype),"clear",this).call(this,e),!1!==e.clearIdxResponse&&this.clearIdxResponse()}},{key:"saveIdxResponse",value:function(e){if(this.saveLastResponse){var t=this.storageManager.getIdxResponseStorage();t&&t.setStorage(e)}}},{key:"loadIdxResponse",value:function(e){if(!this.saveLastResponse)return null;var t=this.storageManager.getIdxResponseStorage();if(!t)return null;var n=t.getStorage();if(!n||!(0,c.P)(n.rawIdxResponse))return null;if(e){var r=e.stateHandle,o=e.interactionHandle;if(!e.useGenericRemediator&&r&&n.stateHandle!==r)return null;if(o&&n.interactionHandle!==o)return null}return n}},{key:"clearIdxResponse",value:function(){if(this.saveLastResponse){var e=this.storageManager.getIdxResponseStorage();null==e||e.clearStorage()}}}]),d}((0,u.P)())}},1286:function(e,t,n){"use strict";n.d(t,{Y:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(7595),l=n(3377);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){return f.apply(this,arguments)}function f(){return f=(0,o.Z)(a().mark((function e(t){var n,r=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return(n=r.length>1&&void 0!==r[1]?r[1]:{}).password&&!n.authenticator&&(n.authenticator=s.pc.OKTA_PASSWORD),e.abrupt("return",(0,l.K)(t,c(c({},n),{},{flow:"authenticate"})));case 3:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},7644:function(e,t,n){"use strict";n.d(t,{_:function(){return a}});var r=n(3144),o=n(5671),i=n(4942),a=(0,r.Z)((function e(t){(0,o.Z)(this,e),(0,i.Z)(this,"meta",void 0),this.meta=t}))},9582:function(e,t,n){"use strict";n.d(t,{a:function(){return d}});var r=n(4942),o=n(5671),i=n(3144),a=n(136),s=n(2963),l=n(1120);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var d=function(e){(0,a.Z)(u,e);var t,n,r=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function u(){return(0,o.Z)(this,u),r.apply(this,arguments)}return(0,i.Z)(u,[{key:"canVerify",value:function(e){return!!(e.credentials||e.password||e.passcode)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.password,r=e.passcode,o=e.revokeSessions;if(t||n||r)return t||{passcode:r||n,revokeSessions:o}}},{key:"getInputs",value:function(e){var t,n,r=[c(c({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"password",type:"string",required:e.required})];return(null===(n=e.form)||void 0===n?void 0:n.value.find((function(e){return"revokeSessions"===e.name})))&&r.push({name:"revokeSessions",type:"boolean",label:"Sign me out of all other devices",required:!1}),r}}]),u}(n(7644)._)},9344:function(e,t,n){"use strict";n.d(t,{LL:function(){return i},PN:function(){return a},h_:function(){return s}});var r=n(7595);function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function i(e){var t;if((0,r.H)(e))t=e;else{if("string"!=typeof e)throw new Error("Invalid format for authenticator");t={key:e}}return t}function a(e,t){return!!(e&&t&&(e.id&&t.id?e.id===t.id:e.key&&t.key&&e.key===t.key))}function s(e,t){var n,r,i=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return o(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?o(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,i=function(){};return{s:i,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,s=!0,l=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return s=e.done,e},e:function(e){l=!0,a=e},f:function(){try{s||null==n.return||n.return()}finally{if(l)throw a}}}}(e);try{var a=function(){var e=r.value;if(n=t.find((function(t){var n=t.relatesTo;return n.key&&n.key===e.key})))return"break"};for(i.s();!(r=i.n()).done&&"break"!==a(););}catch(e){i.e(e)}finally{i.f()}return n}},9192:function(e,t,n){"use strict";n.d(t,{a:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377),l=n(7738);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e,t){return f.apply(this,arguments)}function f(){return(f=(0,o.Z)(a().mark((function e(t,n){var r,o;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.transactionManager.load(),o=(0,l.s)(t,r.flow),e.abrupt("return",(0,s.K)(t,c(c(c({},n),o),{},{actions:["cancel"]})));case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},7985:function(e,t,n){"use strict";n.d(t,{GA:function(){return g},Jn:function(){return b},gc:function(){return v},mo:function(){return y}});var r=n(5861),o=n(3144),i=n(5671),a=n(7326),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(4687),f=n.n(d),p=n(6245),h=n(1969),m=function(e){(0,s.Z)(d,e);var t,n,r=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function d(e,t){var n;return(0,i.Z)(this,d),n=r.call(this,"Enter the OTP code in the originating client: ".concat(t)),(0,c.Z)((0,a.Z)(n),"state",void 0),(0,c.Z)((0,a.Z)(n),"otp",void 0),n.name="EmailVerifyCallbackError",n.state=e,n.otp=t,n}return(0,o.Z)(d)}(p.Z);function v(e){return"EmailVerifyCallbackError"===e.name}function g(e){return/(otp=)/i.test(e)&&/(state=)/i.test(e)}function y(e){return(0,h.v)(e)}function b(e,t){return w.apply(this,arguments)}function w(){return(w=(0,r.Z)(f().mark((function e(t,n){var r,o,i;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!g(n)){e.next=9;break}if(r=y(n),o=r.state,i=r.otp,!t.idx.canProceed({state:o})){e.next=8;break}return e.next=5,t.idx.proceed({state:o,otp:i});case 5:return e.abrupt("return",e.sent);case 8:throw new m(o,i);case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2144:function(e,t,n){"use strict";n.d(t,{Y:function(){return i}});var r=n(1578),o=n(8137);function i(e,t,n){var i=(0,r.K)(e,t,n);return(0,o.B)(i)}},8717:function(e,t,n){"use strict";n.d(t,{F:function(){return H}});var r={};n.r(r),n.d(r,{AuthenticatorEnrollmentData:function(){return U.q},AuthenticatorVerificationData:function(){return L.q},ChallengeAuthenticator:function(){return E.J},ChallengePoll:function(){return T.U},EnrollAuthenticator:function(){return _.q},EnrollPoll:function(){return O.T},EnrollProfile:function(){return A.w},EnrollmentChannelData:function(){return x.t},GenericRemediator:function(){return B.P},Identify:function(){return P.h},ReEnrollAuthenticator:function(){return C.j},ReEnrollAuthenticatorWarning:function(){return R.i},RedirectIdp:function(){return I.O},Remediator:function(){return w.n},ResetAuthenticator:function(){return S.G},SelectAuthenticatorAuthenticate:function(){return N.X},SelectAuthenticatorEnroll:function(){return M.j},SelectAuthenticatorUnlockAccount:function(){return j.G},SelectEnrollProfile:function(){return D.j},SelectEnrollmentChannel:function(){return k.V},Skip:function(){return F.h}});var o=n(8221),i=n(9912),a=n(1286),s=n(9192),l=n(7985),u=n(5021),c=n(5923),d=n(6131),f=n(2660),p=n(9310),h=n(2845),m=n(9214),v=n(8826),g=n(2473),y=n(2620),b=n(8277),w=n(3118),_=n(3857),O=n(2288),k=n(3403),x=n(3679),E=n(4560),T=n(1104),S=n(1019),A=n(7522),P=n(8628),C=n(9024),R=n(8107),I=n(8490),N=n(7311),M=n(9865),j=n(5272),D=n(4713),L=n(5278),U=n(2541),F=n(8443),B=n(9732),V=n(7738),Z=n(5031);function H(e){(0,Z.TC)({remediators:r,getFlowSpecification:V.s});var t=g.Y.bind(null,e);return{interact:d.E.bind(null,e),introspect:f.L.bind(null,e),makeIdxResponse:c._T.bind(null,e),authenticate:a.Y.bind(null,e),register:v.z.bind(null,e),start:t,startTransaction:t,poll:p.$.bind(null,e),proceed:h.x.bind(null,e),cancel:s.a.bind(null,e),recoverPassword:m.M.bind(null,e),handleInteractionCodeRedirect:u.X.bind(null,e),isInteractionRequired:o.wc.bind(null,e),isInteractionRequiredError:i.Cf,handleEmailVerifyCallback:l.Jn.bind(null,e),isEmailVerifyCallback:l.GA,parseEmailVerifyCallback:l.mo,isEmailVerifyCallbackError:l.gc,getSavedTransactionMeta:y.uN.bind(null,e),createTransactionMeta:y.Xc.bind(null,e),getTransactionMeta:y.Co.bind(null,e),saveTransactionMeta:y.r0.bind(null,e),clearTransactionMeta:y.Jm.bind(null,e),isTransactionMetaValid:y.Wf,setFlow:function(t){e.options.flow=t},getFlow:function(){return e.options.flow},canProceed:h.C.bind(null,e),unlockAccount:b.l.bind(null,e)}}},7738:function(e,t,n){"use strict";n.d(t,{s:function(){return T}});var r=n(8628),o=n(7311),i=n(9865),a=n(2541),s=n(5278),l=n(3857),u=n(4560),c=n(1104),d=n(9024),f=n(8107),p=n(2288),h=n(3403),m=n(3679),v=n(8490),g=n(8443),y={identify:r.h,"select-authenticator-authenticate":o.X,"select-authenticator-enroll":i.j,"authenticator-enrollment-data":a.q,"authenticator-verification-data":s.q,"enroll-authenticator":l.q,"challenge-authenticator":u.J,"challenge-poll":c.U,"reenroll-authenticator":d.j,"reenroll-authenticator-warning":f.i,"enroll-poll":p.T,"select-enrollment-channel":h.V,"enrollment-channel-data":m.t,"redirect-idp":v.O,skip:g.h},b=n(1019),w={identify:r.h,"identify-recovery":r.h,"select-authenticator-authenticate":o.X,"select-authenticator-enroll":i.j,"challenge-authenticator":u.J,"authenticator-verification-data":s.q,"authenticator-enrollment-data":a.q,"reset-authenticator":b.G,"reenroll-authenticator":d.j,"reenroll-authenticator-warning":f.i,"enroll-poll":p.T},_=n(4713),O=n(7522),k={"select-enroll-profile":_.j,"enroll-profile":O.w,"authenticator-enrollment-data":a.q,"select-authenticator-enroll":i.j,"enroll-poll":p.T,"select-enrollment-channel":h.V,"enrollment-channel-data":m.t,"enroll-authenticator":l.q,skip:g.h},x=n(5272),E={identify:r.h,"select-authenticator-unlock-account":x.G,"select-authenticator-authenticate":o.X,"challenge-authenticator":u.J,"challenge-poll":c.U,"authenticator-verification-data":s.q,"reenroll-authenticator-warning":f.i};function T(e){var t,n,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default",o=!0;switch(r){case"register":case"signup":case"enrollProfile":t=k,o=!1;break;case"recoverPassword":case"resetPassword":t=w,n=["currentAuthenticator-recover","currentAuthenticatorEnrollment-recover"],o=!1;break;case"unlockAccount":t=E,o=!1,n=["unlock-account"];break;default:t=y}return{flow:r,remediators:t,actions:n,withCredentials:o}}},5021:function(e,t,n){"use strict";n.d(t,{X:function(){return l}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(2886);function l(e,t){return u.apply(this,arguments)}function u(){return(u=(0,r.Z)(i().mark((function e(t,n){var r,o,l,u,c,d,f,p,h,m;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.transactionManager.load()){e.next=3;break}throw new a.Z("No transaction data was found in storage");case 3:if(o=r.codeVerifier,l=r.state,u=new URL(n),c=u.searchParams,d=c.get("state"),f=c.get("interaction_code"),!(p=c.get("error"))){e.next=10;break}throw new s.Z(p,c.get("error_description"));case 10:if(d===l){e.next=12;break}throw new a.Z("State in redirect uri does not match with transaction state");case 12:if(f){e.next=14;break}throw new a.Z("Unable to parse interaction_code from the url");case 14:return e.next=16,t.token.exchangeCodeForTokens({interactionCode:f,codeVerifier:o});case 16:h=e.sent,m=h.tokens,t.tokenManager.setTokens(m);case 19:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},5923:function(e,t,n){"use strict";n.d(t,{_T:function(){return U},A0:function(){return L}});var r=n(1971),o=n(5861),i=n(2982),a=n(4687),s=n.n(a),l=n(885),u=n(4942),c=n(4925),d=n(1002),f=n(5385);function p(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return h(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?h(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function h(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var m=function(e){return!1!==e.mutable},v=function(e){var t={},n=[],r={};if(!e.value)return n.push(e),{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r};var o,i=p(e.value);try{for(i.s();!(o=i.n()).done;){var a,s,l=o.value;m(l)?(n.push(l),null!==(a=l.value)&&void 0!==a&&a&&(t[l.name]=l.value)):r[l.name]=null!==(s=l.value)&&void 0!==s?s:""}}catch(e){i.e(e)}finally{i.f()}return{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r}},g=n(3983);function y(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?y(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):y(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var w=function(e,t){var n=t.actionDefinition,r=t.defaultParamsForAction,i=void 0===r?{}:r,a=t.immutableParamsForAction,l=void 0===a?{}:a,u=t.toPersist,c=void 0===u?{}:u,d=n.href;return(0,o.Z)(s().mark((function t(){var r,o,a,u,p,h,m,v,y,w,_,O=arguments;return s().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=O.length>0&&void 0!==O[0]?O[0]:{},o={"Content-Type":"application/json",Accept:n.accepts||"application/ion+json"},a=JSON.stringify(b(b(b({},i),r),l)),t.prev=3,h={url:d,method:n.method,headers:o,args:a,withCredentials:null===(u=null==c?void 0:c.withCredentials)||void 0===u||u},("poll"===n.name||(null===(p=n.name)||void 0===p?void 0:p.endsWith("-poll")))&&(h.pollingIntent=!0),t.next=9,(0,f.c3)(e,h);case 9:return m=t.sent,t.abrupt("return",e.idx.makeIdxResponse(b({},m),c,!0));case 13:if(t.prev=13,t.t0=t.catch(3),t.t0 instanceof g.Z&&null!==t.t0&&void 0!==t.t0&&t.t0.xhr){t.next=17;break}throw t.t0;case 17:return v=t.t0.xhr,y=v.responseJSON||JSON.parse(v.responseText),w=v.headers["WWW-Authenticate"]||v.headers["www-authenticate"],_=e.idx.makeIdxResponse(b({},y),c,!1),401===v.status&&'Oktadevicejwt realm="Okta Device"'===w&&(_.stepUp=!0),t.abrupt("return",_);case 23:case"end":return t.stop()}}),t,null,[[3,13]])})))},_=function(e,t,n){var r=w,o=function(e){var t,n=[],r={},o={},i=p(e=Array.isArray(e)?e:[e]);try{for(i.s();!(t=i.n()).done;){var a=t.value,s=v(a),l=s.defaultParamsForAction,u=s.neededParamsForAction,c=s.immutableParamsForAction;n.push(u),r[a.name]=l,o[a.name]=c}}catch(e){i.e(e)}finally{i.f()}return{defaultParams:r,neededParams:n,immutableParams:o}}(t),i=o.defaultParams,a=o.neededParams,s=o.immutableParams,l=r(e,{actionDefinition:t,defaultParamsForAction:i[t.name],immutableParamsForAction:s[t.name],toPersist:n});return l.neededParams=a,l};function O(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function k(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?O(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):O(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var x=n(136),E=n(9611);function T(){T=function(e,t){return new n(e,void 0,t)};var e=RegExp.prototype,t=new WeakMap;function n(e,r,o){var i=new RegExp(e,r);return t.set(i,o||t.get(e)),(0,E.Z)(i,n.prototype)}function r(e,n){var r=t.get(n);return Object.keys(r).reduce((function(t,n){var o=r[n];if("number"==typeof o)t[n]=e[o];else{for(var i=0;void 0===e[o[i]]&&i+1<o.length;)i++;t[n]=e[o[i]]}return t}),Object.create(null))}return(0,x.Z)(n,RegExp),n.prototype.exec=function(t){var n=e.exec.call(this,t);return n&&(n.groups=r(n,this)),n},n.prototype[Symbol.replace]=function(n,o){if("string"==typeof o){var i=t.get(this);return e[Symbol.replace].call(this,n,o.replace(/\$<([^>]+)>/g,(function(e,t){return"$"+i[t]})))}if("function"==typeof o){var a=this;return e[Symbol.replace].call(this,n,(function(){var e=arguments;return"object"!=(0,d.Z)(e[e.length-1])&&(e=[].slice.call(e)).push(r(e,a)),o.apply(this,e)}))}return e[Symbol.replace].call(this,n,o)},T.apply(this,arguments)}var S=T(/\$?(\w+)|(?:\[(\d+)\])/g,{step:1,index:2}),A=n(9123),P=["value","type"];function C(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function R(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?C(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):C(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var I={remediation:!0,context:!0},N=function e(t,n){Object.keys(n).forEach((function(r){if("relatesTo"===r){var o=Array.isArray(n[r])?n[r][0]:n[r];if("string"==typeof o){var i=function(e){for(var t,n=e.path,r=e.json,o=[];null!==(t=S.exec(n));){var i,a,s,l,u,c=null!==(i=null===(a=t)||void 0===a||null===(s=a.groups)||void 0===s?void 0:s.step)&&void 0!==i?i:null===(l=t)||void 0===l||null===(u=l.groups)||void 0===u?void 0:u.index;c&&o.push(c)}if(!(o.length<1)){for(var f=o.pop(),p=r,h=0,m=o;h<m.length;h++){var v=m[h];if(Object.prototype.hasOwnProperty.call(p,v)){if("object"!==(0,d.Z)(p[v]))return;p=p[v]}}return p[f]}}({path:o,json:t});if(i)return void(n[r]=i);throw new A.Z("Cannot resolve relatesTo: ".concat(o))}}Array.isArray(n[r])&&n[r].forEach((function(n){return e(t,n)}))}))},M=function(e,t){var n,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=(null===(n=t.remediation)||void 0===n?void 0:n.value)||[];o.forEach((function(e){var n;if("launch-authenticator"!==e.name||"authenticatorChallenge"!==(null==e||null===(n=e.relatesTo)||void 0===n?void 0:n[0])||null!=t&&t.authenticatorChallenge)return N(t,e);delete e.relatesTo}));var i=o.map((function(t){return function(e,t,n){if(t.rel){var r=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return t.reduce((function(t,r){return k(k({},t),{},(0,u.Z)({},r.name,_(e,r,n)))}),{})}(e,[t],n),o=r[t.name];return R(R({},t),{},{action:o})}return t}(e,t,r)})),a=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r={},o={};return Object.keys(t).filter((function(e){return!I[e]})).forEach((function(i){if("object"===(0,d.Z)(t[i])&&t[i])if(t[i].rel)r[t[i].name]=_(e,t[i],n);else{var a=t[i],s=a.value,u=a.type,f=(0,c.Z)(a,P);o[i]=R({type:u},f),"object"===u?(o[i].value={},Object.entries(s).forEach((function(t){var a=(0,l.Z)(t,2),s=a[0],u=a[1];u.rel?r["".concat(i,"-").concat(s.name||s)]=_(e,u,n):o[i].value[s]=u}))):o[i].value=s}else o[i]=t[i]})),{context:o,actions:r}}(e,t,r);return{remediations:i,context:a.context,actions:a.actions}},j={makeIdxState:function(e,t,n,r){var a,l,u,c,d=t,f=M(e,t,n),p=f.remediations,h=f.context,m=f.actions,v=(0,i.Z)(p),g=(c=(0,o.Z)(s().mark((function e(t){var n,r,o=arguments;return s().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=p.find((function(e){return e.name===t}))){e.next=4;break}return e.abrupt("return",Promise.reject("Unknown remediation choice: [".concat(t,"]")));case 4:if("function"==typeof r.action){e.next=7;break}return e.abrupt("return",Promise.reject("Current remediation cannot make form submit action: [".concat(t,"]")));case 7:return e.abrupt("return",r.action(n));case 8:case"end":return e.stop()}}),e)}))),function(e){return c.apply(this,arguments)});return{proceed:g,neededToProceed:v,actions:m,context:h,rawIdxState:d,interactionCode:null===(a=d.successWithInteractionCode)||void 0===a||null===(l=a.value)||void 0===l||null===(u=l.find((function(e){return"interaction_code"===e.name})))||void 0===u?void 0:u.value,toPersist:n,requestDidSucceed:r}}},D=function(e){switch(e){case"1.0.0":return j;case void 0:case null:throw new Error("Api version is required");default:throw new Error("Unknown api version: ".concat(e,".  Use an exact semver version."))}};function L(e){if(!e)throw new Error("version is required");if((null!=e?e:"").replace(/[^0-9a-zA-Z._-]/,"")!==e||!e)throw new Error("invalid version supplied - version is required and uses semver syntax");D(e)}function U(e,t,n,o){var i,a=null!==(i=null==t?void 0:t.version)&&void 0!==i?i:r.IDX_API_VERSION;return L(a),(0,D(a).makeIdxState)(e,t,n,o)}},9999:function(e,t,n){"use strict";n.d(t,{pc:function(){return Z.pc},Fw:function(){return Z.Fw},Qd:function(){return Z.Qd},YR:function(){return r.Y},Ch:function(){return u.C},al:function(){return o.a},Jm:function(){return m.Jm},F4:function(){return v.F},SL:function(){return B.S},aT:function(){return V.a},vK:function(){return H.v},UB:function(){return U},Yn:function(){return g.Y},Xc:function(){return m.Xc},uN:function(){return m.uN},Co:function(){return m.Co},Jn:function(){return i.Jn},Xx:function(){return f.X},$0:function(){return m.$0},EW:function(){return a.E},L8:function(){return s.L},H:function(){return Z.H},GA:function(){return i.GA},gc:function(){return i.gc},Wf:function(){return m.Wf},bl:function(){return m.bl},UC:function(){return m.UC},B_:function(){return F.B},mo:function(){return i.mo},$l:function(){return l.$},xc:function(){return u.x},M4:function(){return d.M},z2:function(){return c.z},r0:function(){return m.r0},Yr:function(){return p.Y},le:function(){return h.l}});var r=n(1286),o=n(9192),i=n(7985),a=n(6131),s=n(2660),l=n(9310),u=n(2845),c=n(8826),d=n(9214),f=n(5021),p=n(2473),h=n(8277),m=n(2620),v=n(8717),g=n(2144),y=n(3144),b=n(5671),w=n(7326),_=n(136),O=n(2963),k=n(1120),x=n(4942),E=n(5923),T=n(8719),S=n(8716);function A(e){var t;return t=function(e){(0,_.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,k.Z)(t);if(n){var o=(0,k.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function o(){var e,t,n;(0,b.Z)(this,o);for(var i=arguments.length,a=new Array(i),s=0;s<i;s++)a[s]=arguments[s];return e=r.call.apply(r,[this].concat(a)),(0,x.Z)((0,w.Z)(e),"idx",void 0),(0,x.Z)((0,w.Z)(e),"fingerprint",void 0),e.idx=(t=(0,w.Z)(e),n=p.Y.bind(null,t),{makeIdxResponse:E._T.bind(null,t),start:n,startTransaction:n,proceed:u.x.bind(null,t),canProceed:u.C.bind(null,t),getSavedTransactionMeta:m.uN.bind(null,t),createTransactionMeta:m.Xc.bind(null,t),getTransactionMeta:m.Co.bind(null,t),saveTransactionMeta:m.r0.bind(null,t),clearTransactionMeta:m.Jm.bind(null,t),isTransactionMetaValid:m.Wf}),e.fingerprint=T.Z.bind(null,(0,w.Z)(e)),e}return(0,y.Z)(o)}(e),(0,x.Z)(t,"webauthn",S),t}var P=n(9893),C=n(265),R=n(279),I=n(3980),N=n(1237),M=n(8707),j=n(6898),D=n(8221);function L(e,t){return function(e){(0,_.Z)(i,e);var n,r,o=(n=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,k.Z)(n);if(r){var o=(0,k.Z)(this).constructor;e=Reflect.construct(t,arguments,o)}else e=t.apply(this,arguments);return(0,O.Z)(this,e)});function i(){var e,n;(0,b.Z)(this,i);for(var r=arguments.length,a=new Array(r),s=0;s<r;s++)a[s]=arguments[s];return e=o.call.apply(o,[this].concat(a)),(0,x.Z)((0,w.Z)(e),"token",void 0),(0,x.Z)((0,w.Z)(e),"transactionManager",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.token=(n=(0,w.Z)(e),{prepareTokenParams:j.wu.bind(null,n),exchangeCodeForTokens:M.r.bind(null,n),decode:N.T}),e}return(0,y.Z)(i,[{key:"isLoginRedirect",value:function(){return(0,D.gM)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,D.wV)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}}]),i}(e)}function U(e,t,n){var r=(0,P.a)(t),o=(0,C.H)(r,e),i=(0,R.A)(o);return A(L((0,I.Z)(i),n))}var F=n(8137),B=n(4602),V=n(4143),Z=n(7595),H=n(3334)},6131:function(e,t,n){"use strict";n.d(t,{E:function(){return h}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(2620),l=n(7599),u=n(3193),c=n(5385);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function p(e){return{meta:e,interactionHandle:e.interactionHandle,state:e.state}}function h(e){return m.apply(this,arguments)}function m(){return m=(0,o.Z)(a().mark((function e(t){var n,r,o,i,d,h,m,v,g,y,b,w,_,O,k,x,E,T,S,A,P,C,R,I,N,M=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=M.length>1&&void 0!==M[1]?M[1]:{},o=(0,u.YY)(o),i=(0,s.uN)(t,o),null===(n=i)||void 0===n||!n.interactionHandle){e.next=5;break}return e.abrupt("return",p(i));case 5:return e.next=7,(0,s.Xc)(t,f(f({},i),o));case 7:return i=e.sent,d=(0,l.zf)(t),m=(h=i).clientId,v=h.redirectUri,g=h.state,y=h.scopes,b=h.withCredentials,w=h.codeChallenge,_=h.codeChallengeMethod,O=h.activationToken,k=h.recoveryToken,x=h.maxAge,E=h.acrValues,T=h.nonce,S=o.clientSecret||t.options.clientSecret,b=null===(r=b)||void 0===r||r,A="".concat(d,"/v1/interact"),P=f(f(f(f(f(f({client_id:m,scope:y.join(" "),redirect_uri:v,code_challenge:w,code_challenge_method:_,state:g},O&&{activation_token:O}),k&&{recovery_token:k}),S&&{client_secret:S}),x&&{max_age:x}),E&&{acr_values:E}),T&&{nonce:T}),C={"Content-Type":"application/x-www-form-urlencoded"},e.next=17,(0,c.c3)(t,{method:"POST",url:A,headers:C,withCredentials:b,args:P});case 17:return R=e.sent,I=R.interaction_handle,N=f(f({},i),{},{interactionHandle:I,withCredentials:b,state:g,scopes:y,recoveryToken:k,activationToken:O}),(0,s.r0)(t,N),e.abrupt("return",p(N));case 22:case"end":return e.stop()}}),e)}))),m.apply(this,arguments)}},2660:function(e,t,n){"use strict";n.d(t,{L:function(){return f}});var r=n(5861),o=n(4687),i=n.n(o),a=n(5923),s=n(480),l=n(7599),u=n(1971),c=n(5385),d=n(5728);function f(e){return p.apply(this,arguments)}function p(){return p=(0,r.Z)(i().mark((function e(t){var n,r,o,f,p,h,m,v,g,y,b,w,_,O,k=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=k.length>1&&void 0!==k[1]?k[1]:{},(f=t.transactionManager.loadIdxResponse(n))&&(r=f.rawIdxResponse,o=f.requestDidSucceed),r){e.next=27;break}return h=n.version||u.IDX_API_VERSION,m=(0,l.Xp)(t),v=n.interactionHandle,g=n.stateHandle,y=null===(p=n.withCredentials)||void 0===p||p,e.prev=8,o=!0,(0,a.A0)(h),b="".concat(m,"/idp/idx/introspect"),w=g?{stateToken:g}:{interactionHandle:v},_={"Content-Type":"application/ion+json; okta-version=".concat(h),Accept:"application/ion+json; okta-version=".concat(h)},e.next=16,(0,c.c3)(t,{method:"POST",url:b,headers:_,withCredentials:y,args:w});case 16:r=e.sent,e.next=27;break;case 19:if(e.prev=19,e.t0=e.catch(8),!((0,d.isAuthApiError)(e.t0)&&e.t0.xhr&&(0,s.P)(e.t0.xhr.responseJSON))){e.next=26;break}r=e.t0.xhr.responseJSON,o=!1,e.next=27;break;case 26:throw e.t0;case 27:return O=n.withCredentials,e.abrupt("return",(0,a._T)(t,r,{withCredentials:O},o));case 29:case"end":return e.stop()}}),e,null,[[8,19]])}))),p.apply(this,arguments)}},8137:function(e,t,n){"use strict";n.d(t,{B:function(){return p}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(8717),d=n(8719),f=n(8716);function p(e){var t;return t=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function p(){var e;(0,o.Z)(this,p);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=f.call.apply(f,[this].concat(n)),(0,u.Z)((0,i.Z)(e),"idx",void 0),(0,u.Z)((0,i.Z)(e),"fingerprint",void 0),e.idx=(0,c.F)((0,i.Z)(e)),e.fingerprint=d.Z.bind(null,(0,i.Z)(e)),e}return(0,r.Z)(p)}(e),(0,u.Z)(t,"webauthn",f),t}},4602:function(e,t,n){"use strict";n.d(t,{S:function(){return d}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(9133);function d(){return function(e){(0,a.Z)(d,e);var t,n,c=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function d(e){var t;return(0,o.Z)(this,d),t=c.call(this,e),(0,u.Z)((0,i.Z)(t),"flow",void 0),(0,u.Z)((0,i.Z)(t),"activationToken",void 0),(0,u.Z)((0,i.Z)(t),"recoveryToken",void 0),(0,u.Z)((0,i.Z)(t),"idx",void 0),t.flow=e.flow,t.activationToken=e.activationToken,t.recoveryToken=e.recoveryToken,t.idx=e.idx,t}return(0,r.Z)(d)}((0,c.n)())}},9310:function(e,t,n){"use strict";n.d(t,{$:function(){return u}});var r=n(5861),o=n(4687),i=n.n(o),a=n(2845),s=n(2620),l=n(146);function u(e){return c.apply(this,arguments)}function c(){return c=(0,r.Z)(i().mark((function e(t){var n,o,c,d,f,p,h,m=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return c=(o=m.length>1&&void 0!==m[1]?m[1]:{}).withCredentials,d=o.exchangeCodeForTokens,e.next=4,(0,a.x)(t,{startPolling:!0,withCredentials:c,exchangeCodeForTokens:d});case 4:if(f=e.sent,p=(0,s.uN)(t),null!=(h=null==p||null===(n=p.remediations)||void 0===n?void 0:n.find((function(e){return e.includes("poll")})))&&h.length||(0,l.ZK)("No polling remediations available at the current IDX flow stage"),!Number.isInteger(o.refresh)){e.next=10;break}return e.abrupt("return",new Promise((function(e,n){setTimeout((0,r.Z)(i().mark((function r(){var o,a,s;return i().wrap((function(r){for(;;)switch(r.prev=r.next){case 0:try{s=null===(o=f.nextStep)||void 0===o||null===(a=o.poll)||void 0===a?void 0:a.refresh,e(s?u(t,{refresh:s}):f)}catch(e){n(e)}case 1:case"end":return r.stop()}}),r)}))),o.refresh)})));case 10:return e.abrupt("return",f);case 11:case"end":return e.stop()}}),e)}))),c.apply(this,arguments)}},2845:function(e,t,n){"use strict";n.d(t,{C:function(){return f},x:function(){return p}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377),l=n(2620),u=n(9123);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function f(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!(!(0,l.uN)(e,t)&&!t.stateHandle)}function p(e){return h.apply(this,arguments)}function h(){return h=(0,o.Z)(a().mark((function e(t){var n,r,o,i,c=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(f(t,n=c.length>1&&void 0!==c[1]?c[1]:{})){e.next=3;break}throw new u.Z("Unable to proceed: saved transaction could not be loaded");case 3:return r=n.flow,o=n.state,r||(i=(0,l.uN)(t,{state:o}),r=null==i?void 0:i.flow),e.abrupt("return",(0,s.K)(t,d(d({},n),{},{flow:r})));case 6:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}},9214:function(e,t,n){"use strict";n.d(t,{M:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377),l=n(7738);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){return f.apply(this,arguments)}function f(){return f=(0,o.Z)(a().mark((function e(t){var n,r,o=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:{},r=(0,l.s)(t,"recoverPassword"),e.abrupt("return",(0,s.K)(t,c(c({},n),r)));case 3:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},8826:function(e,t,n){"use strict";n.d(t,{z:function(){return h}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377),l=n(2620),u=n(2473),c=n(9123),d=n(7595);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function h(e){return m.apply(this,arguments)}function m(){return m=(0,o.Z)(a().mark((function e(t){var n,r,o,i=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=i.length>1&&void 0!==i[1]?i[1]:{},(0,l.$0)(t)){e.next=8;break}return e.next=4,(0,u.Y)(t,p(p({},n),{},{flow:"register",autoRemediate:!1}));case 4:if(r=e.sent,o=r.enabledFeatures,n.activationToken||!o||o.includes(d.Fw.REGISTRATION)){e.next=8;break}throw new c.Z("Registration is not supported based on your current org configuration.");case 8:return e.abrupt("return",(0,s.K)(t,p(p({},n),{},{flow:"register"})));case 9:case"end":return e.stop()}}),e)}))),m.apply(this,arguments)}},2541:function(e,t,n){"use strict";n.d(t,{q:function(){return h}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(4794),d=n(6064);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var h=function(e){(0,a.Z)(c,e);var t,n,u=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function c(){return(0,r.Z)(this,c),u.apply(this,arguments)}return(0,o.Z)(c,[{key:"mapAuthenticator",value:function(){var e=this.getAuthenticatorData();return{id:(0,d.zg)(this.remediation).form.value.find((function(e){return"id"===e.name})).value,methodType:e.methodType,phoneNumber:e.phoneNumber}}},{key:"getInputAuthenticator",value:function(e){return[{name:"methodType",type:"string"},{name:"phoneNumber",label:"Phone Number",type:"string"}].map((function(t){return p(p({},e.form.value.find((function(e){return e.name===t.name}))),t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){e=(0,i.Z)((0,l.Z)(c.prototype),"mapAuthenticatorDataFromValues",this).call(this,e);var t=this.values.phoneNumber;if(e||t)return p(p({},e&&e),t&&{phoneNumber:t})}}]),c}(c.a);(0,u.Z)(h,"remediationName","authenticator-enrollment-data")},5278:function(e,t,n){"use strict";n.d(t,{q:function(){return p}});var r=n(2982),o=n(5671),i=n(3144),a=n(1752),s=n(136),l=n(2963),u=n(1120),c=n(4942);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,s.Z)(p,e);var t,n,d=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function p(){return(0,o.Z)(this,p),d.apply(this,arguments)}return(0,i.Z)(p,[{key:"mapAuthenticator",value:function(){return this.getAuthenticatorData()}},{key:"getInputAuthenticator",value:function(){var e=this.getAuthenticatorFromRemediation(),t=e.form.value.find((function(e){return"methodType"===e.name}));return t&&t.options?{name:"methodType",type:"string",required:!0,options:t.options}:(0,r.Z)(e.form.value)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,a.Z)((0,u.Z)(p.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"authenticator"!==e})).reduce((function(t,n){return f(f({},t),{},(0,c.Z)({},n,e.values[n]))}),{})}}]),p}(n(4794).a);(0,c.Z)(p,"remediationName","authenticator-verification-data")},4794:function(e,t,n){"use strict";n.d(t,{a:function(){return v}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(3118),f=n(7595),p=n(9344);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=function(e){(0,s.Z)(h,e);var t,n,d=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function h(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,r.Z)(this,h),t=d.call(this,e,n),(0,c.Z)((0,i.Z)(t),"authenticator",void 0),t.authenticator=t.getAuthenticator(),t.formatAuthenticatorData(),t}return(0,o.Z)(h,[{key:"formatAuthenticatorData",value:function(){var e=this;if(this.getAuthenticatorData())this.values.authenticatorsData=this.values.authenticatorsData.map((function(t){return(0,p.PN)(e.authenticator,t)?e.mapAuthenticatorDataFromValues(t):t}));else{var t=this.mapAuthenticatorDataFromValues();t&&this.values.authenticatorsData.push(t)}}},{key:"getAuthenticatorData",value:function(){var e=this;return this.values.authenticatorsData.find((function(t){return(0,p.PN)(e.authenticator,t)}))}},{key:"canRemediate",value:function(){var e=this;return this.values.authenticatorsData.some((function(t){return(0,p.PN)(e.authenticator,t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){var t=this.values,n=t.methodType,r=t.authenticator;!n&&(0,f.H)(r)&&(n=null==r?void 0:r.methodType);var o=this.authenticator,i=m(m({id:o.id,enrollmentId:o.enrollmentId},e&&e),n&&{methodType:n});return i.methodType?i:null}},{key:"getAuthenticatorFromRemediation",value:function(){return this.remediation.value.find((function(e){return"authenticator"===e.name}))}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,a.Z)((0,u.Z)(h.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticatorsData.filter((function(t){return!0!==(0,p.PN)(e.authenticator,t)}));return m(m({},this.values),{},{authenticatorsData:t})}}]),h}(d.n)},3118:function(e,t,n){"use strict";n.d(t,{n:function(){return p}});var r=n(2982),o=n(1002),i=n(5671),a=n(3144),s=n(4942),l=n(6064),u=n(9344);function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.Z)(this,e),(0,s.Z)(this,"remediation",void 0),(0,s.Z)(this,"values",void 0),(0,s.Z)(this,"options",void 0),(0,s.Z)(this,"map",void 0),this.values=f({},n),this.options=f({},r),this.formatAuthenticators(),this.remediation=t}return(0,a.Z)(e,[{key:"formatAuthenticators",value:function(){if(this.values.authenticators=this.values.authenticators||[],this.values.authenticators=this.values.authenticators.map((function(e){return(0,u.LL)(e)})),this.values.authenticator){var e=(0,u.LL)(this.values.authenticator);this.values.authenticators.some((function(t){return(0,u.PN)(e,t)}))||this.values.authenticators.push(e)}this.values.authenticatorsData=this.values.authenticators.reduce((function(e,t){return"object"===(0,o.Z)(t)&&Object.keys(t).length>1&&e.push(t),e}),this.values.authenticatorsData||[])}},{key:"getName",value:function(){return this.remediation.name}},{key:"canRemediate",value:function(e){var t=this;return!(0,l.QG)(this.remediation).find((function(e){return!t.hasData(e)}))}},{key:"getData",value:function(e){var t=this;if(!e){var n=(0,l.ix)(this.remediation).reduce((function(e,n){return e[n]=t.getData(n),e}),{});return n}if("function"==typeof this["map".concat((0,l.Qs)(e))]){var r=this["map".concat((0,l.Qs)(e))](this.remediation.value.find((function(t){return t.name===e})));if(r)return r}if(this.map&&this.map[e])for(var o=this.map[e],i=0;i<o.length;i++){var a=this.values[o[i]];if(a)return a}return this.values[e]}},{key:"hasData",value:function(e){return!!this.getData(e)}},{key:"getNextStep",value:function(e,t){var n=this.getName(),r=this.getInputs(),o=this.getAuthenticator(),i=null==o?void 0:o.type;return f(f({name:n,inputs:r},i&&{type:i}),o&&{authenticator:o})}},{key:"getInputs",value:function(){var e=this,t=[];return(this.remediation.value||[]).forEach((function(n){var r,o=n.name,i=n.type,a=n.visible,s=n.messages;if(!1!==a){if("function"==typeof e["getInput".concat((0,l.Qs)(o))])r=e["getInput".concat((0,l.Qs)(o))](n);else if("object"!==i){var u,c=(e.map?e.map[o]:null)||[];u=1===c.length?c[0]:c.find((function(t){return Object.keys(e.values).includes(t)})),u&&(r=f(f({},n),{},{name:u}))}r||(r=n),Array.isArray(r)?r.forEach((function(e){return t.push(e)})):(s&&(r.messages=s),t.push(r))}})),t}},{key:"getValuesAfterProceed",value:function(){var e,t=this.remediation.value||[],n=this.getInputs(),o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return c(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?c(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}([].concat((0,r.Z)(t),(0,r.Z)(n)));try{for(o.s();!(e=o.n()).done;){var i=e.value;delete this.values[i.name]}}catch(e){o.e(e)}finally{o.f()}return this.values}},{key:"getAuthenticator",value:function(){var e,t,n=null===(e=this.remediation.relatesTo)||void 0===e?void 0:e.value;if(n){var r=(0,l.zg)(this.remediation);if(!r)return n;var o=r.form.value.find((function(e){return"id"===e.name})).value,i=null===(t=r.form.value.find((function(e){return"enrollmentId"===e.name})))||void 0===t?void 0:t.value;return f(f({},n),{},{id:o,enrollmentId:i})}}}],[{key:"getMessages",value:function(e){var t,n;if(e.value)return null===(t=e.value[0])||void 0===t||null===(n=t.form)||void 0===n?void 0:n.value.reduce((function(e,t){return t.messages&&(e=[].concat((0,r.Z)(e),(0,r.Z)(t.messages.value))),e}),[])}}]),e}();(0,s.Z)(p,"remediationName",void 0)},9164:function(e,t,n){"use strict";n.d(t,{n:function(){return y}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(3118),f=n(6064),p=n(7595),h=n(9344);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var y=function(e){(0,s.Z)(m,e);var t,n,d=(t=m,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function m(){var e;(0,r.Z)(this,m);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=d.call.apply(d,[this].concat(n)),(0,c.Z)((0,i.Z)(e),"selectedAuthenticator",void 0),(0,c.Z)((0,i.Z)(e),"selectedOption",void 0),e}return(0,o.Z)(m,[{key:"findMatchedOption",value:function(e,t){var n,r,o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return g(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?g(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}(e);try{var i=function(){var e=r.value;if(n=t.find((function(t){var n=t.relatesTo;return n.key&&n.key===e.key})))return"break"};for(o.s();!(r=o.n()).done&&"break"!==i(););}catch(e){o.e(e)}finally{o.f()}return n}},{key:"canRemediate",value:function(e){var t=this.values,n=t.authenticators,r=t.authenticator,o=(0,f.zg)(this.remediation).options;if(!n||!n.length)return!1;if((0,p.H)(r)&&r.id)return!0;var i=this.findMatchedOption(n,o);if(i){var a,s,l=(null==e?void 0:e.currentAuthenticator)&&(null==e?void 0:e.currentAuthenticator.value.id)===(null===(a=i.relatesTo)||void 0===a?void 0:a.id),u=(null==e?void 0:e.currentAuthenticatorEnrollment)&&(null==e?void 0:e.currentAuthenticatorEnrollment.value.id)===(null===(s=i.relatesTo)||void 0===s?void 0:s.id);return!l&&!u}return!1}},{key:"mapAuthenticator",value:function(e){var t=this.values,n=t.authenticators,r=t.authenticator;if((0,p.H)(r)&&r.id)return this.selectedAuthenticator=r,r;var o=e.options,i=(0,h.h_)(n,o);return this.selectedAuthenticator=i.relatesTo,this.selectedOption=i,{id:null==i?void 0:i.value.form.value.find((function(e){return"id"===e.name})).value}}},{key:"getInputAuthenticator",value:function(e){return{name:"authenticator",type:"string",options:e.options.map((function(e){return{label:e.label,value:e.relatesTo.key}}))}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,a.Z)((0,u.Z)(m.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticators.filter((function(t){return!0!==(0,h.PN)(t,e.selectedAuthenticator)}));return v(v({},this.values),{},{authenticators:t})}}]),m}(d.n)},9883:function(e,t,n){"use strict";n.d(t,{Q:function(){return E}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(3118),f=n(7644);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var m=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){return!!(e.credentials||e.verificationCode||e.otp)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.verificationCode,r=e.otp;if(t||n||r)return t||{passcode:n||r}}},{key:"getInputs",value:function(e){var t;return h(h({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"verificationCode",type:"string",required:e.required})}}]),a}(f._),v=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"mapCredentials",value:function(e){var t=e.verificationCode;if(t)return{totp:t}}}]),a}(m),g=n(9582),y=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials;if(t&&t.questionKey&&t.answer)return!0;var n=e.questionKey,r=e.question,o=e.answer;return!(!n||!o)||!(!r||!o)}},{key:"mapCredentials",value:function(e){var t=e.questionKey,n=e.question,r=e.answer;if(r&&(t||n))return{questionKey:n?"custom":t,question:n,answer:r}}},{key:"getInputs",value:function(){return[{name:"questionKey",type:"string",required:!0},{name:"question",type:"string",label:"Create a security question"},{name:"answer",type:"string",label:"Answer",required:!0}]}}]),a}(f._),b=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials;return!(!t||!t.answer)||!!e.answer}},{key:"mapCredentials",value:function(e){var t=e.answer;if(t)return{questionKey:this.meta.contextualData.enrolledQuestion.questionKey,answer:t}}},{key:"getInputs",value:function(){return[{name:"answer",type:"string",label:"Answer",required:!0}]}}]),a}(f._),w=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.attestation;return!(!n||!r)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.clientData,r=e.attestation;if(t||n||r)return t||{clientData:n,attestation:r}}},{key:"getInputs",value:function(){return[{name:"clientData",type:"string",required:!0,visible:!1,label:"Client Data"},{name:"attestation",type:"string",required:!0,visible:!1,label:"Attestation"}]}}]),a}(f._),_=function(e){(0,s.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.authenticatorData,o=t.signatureData;return!!(n&&r&&o)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.authenticatorData,r=e.clientData,o=e.signatureData;if(t||n||r||o)return t||{authenticatorData:n,clientData:r,signatureData:o}}},{key:"getInputs",value:function(){return[{name:"authenticatorData",type:"string",label:"Authenticator Data",required:!0,visible:!1},{name:"clientData",type:"string",label:"Client Data",required:!0,visible:!1},{name:"signatureData",type:"string",label:"Signature Data",required:!0,visible:!1}]}}]),a}(f._),O=n(7595);function k(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function x(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?k(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):k(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var E=function(e){(0,s.Z)(f,e);var t,n,d=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function f(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,r.Z)(this,f),t=d.call(this,e,n),(0,c.Z)((0,i.Z)(t),"authenticator",void 0),t.authenticator=function(e){var t,n,r=e.relatesTo,o=(null==r?void 0:r.value)||{};switch(o.key){case O.pc.OKTA_PASSWORD:return new g.a(o);case O.pc.SECURITY_QUESTION:return null!==(t=o.contextualData)&&void 0!==t&&t.enrolledQuestion?new b(o):new y(o);case O.pc.OKTA_VERIFY:return new v(o);case O.pc.WEBAUTHN:return null!==(n=o.contextualData)&&void 0!==n&&n.challengeData?new _(o):new w(o);default:return new m(o)}}(e),t}return(0,o.Z)(f,[{key:"getNextStep",value:function(e,t){var n,r=(0,a.Z)((0,u.Z)(f.prototype),"getNextStep",this).call(this,e,t),o=null==t||null===(n=t.authenticatorEnrollments)||void 0===n?void 0:n.value;return x(x({},r),{},{authenticatorEnrollments:o})}},{key:"canRemediate",value:function(){return this.authenticator.canVerify(this.values)}},{key:"mapCredentials",value:function(){return this.authenticator.mapCredentials(this.values)}},{key:"getInputCredentials",value:function(e){return this.authenticator.getInputs(e)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,a.Z)((0,u.Z)(f.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"credentials"!==e})).reduce((function(t,n){return x(x({},t),{},(0,c.Z)({},n,e.values[n]))}),{})}}]),f}(d.n)},4560:function(e,t,n){"use strict";n.d(t,{J:function(){return u}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.apply(this,arguments)}return(0,r.Z)(u)}(n(9883).Q);(0,l.Z)(u,"remediationName","challenge-authenticator")},1104:function(e,t,n){"use strict";n.d(t,{U:function(){return u}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,r.Z)(this,u),l.apply(this,arguments)}return(0,o.Z)(u,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"challenge-poll"===this.options.step}}]),u}(n(2288).T);(0,l.Z)(u,"remediationName","challenge-poll")},3857:function(e,t,n){"use strict";n.d(t,{q:function(){return u}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.apply(this,arguments)}return(0,r.Z)(u)}(n(9883).Q);(0,l.Z)(u,"remediationName","enroll-authenticator")},2288:function(e,t,n){"use strict";n.d(t,{T:function(){return f}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),s=n(2963),l=n(1120),u=n(4942);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var f=function(e){(0,a.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function f(){return(0,r.Z)(this,f),c.apply(this,arguments)}return(0,o.Z)(f,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"enroll-poll"===this.options.step}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,l.Z)(f.prototype),"getNextStep",this).call(this,e,t),r=this.getAuthenticator();return!r&&null!=t&&t.currentAuthenticator&&(r=t.currentAuthenticator.value),d(d({},n),{},{authenticator:r,poll:{required:!0,refresh:this.remediation.refresh}})}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return"startPolling"!==e})).reduce((function(t,n){return d(d({},t),{},(0,u.Z)({},n,e.values[n]))}),{})}}]),f}(n(3118).n);(0,u.Z)(f,"remediationName","enroll-poll")},7522:function(e,t,n){"use strict";n.d(t,{w:function(){return m}});var r=n(2982),o=n(5671),i=n(3144),a=n(7326),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(3118),f=n(9582);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var m=function(e){(0,s.Z)(p,e);var t,n,d=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function p(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return(0,o.Z)(this,p),t=d.call(this,e,n,r),(0,c.Z)((0,a.Z)(t),"authenticator",null),t.getCredentialsFromRemediation()&&(t.authenticator=t.authenticator=new f.a({})),t}return(0,i.Z)(p,[{key:"canRemediate",value:function(){if(this.authenticator&&!this.authenticator.canVerify(this.values))return!1;var e=this.getData().userProfile;return!!e&&this.remediation.value.find((function(e){return"userProfile"===e.name})).form.value.reduce((function(t,n){return n.required&&(t=t&&!!e[n.name]),t}),!0)}},{key:"getCredentialsFromRemediation",value:function(){return this.remediation.value.find((function(e){return"credentials"===e.name}))}},{key:"mapUserProfile",value:function(e){var t=this,n=e.form.value.map((function(e){return e.name})).reduce((function(e,n){return t.values[n]?h(h({},e),{},(0,c.Z)({},n,t.values[n])):e}),{});if(0!==Object.keys(n).length)return n}},{key:"mapCredentials",value:function(){var e=this.authenticator&&this.authenticator.mapCredentials(this.values);if(e)return e}},{key:"getInputUserProfile",value:function(e){return(0,r.Z)(e.form.value)}},{key:"getInputCredentials",value:function(e){return(0,r.Z)(e.form.value)}},{key:"getErrorMessages",value:function(e){return e.value[0].form.value.reduce((function(e,t){return t.messages&&e.push(t.messages.value[0].message),e}),[])}}]),p}(d.n);(0,c.Z)(m,"remediationName","enroll-profile")},3679:function(e,t,n){"use strict";n.d(t,{t:function(){return f}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),s=n(2963),l=n(1120),u=n(4942);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var f=function(e){(0,a.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function f(){return(0,r.Z)(this,f),c.apply(this,arguments)}return(0,o.Z)(f,[{key:"getInputEmail",value:function(){return[{name:"email",type:"string",required:!0,label:"Email"}]}},{key:"getInputPhoneNumber",value:function(){return[{name:"phoneNumber",type:"string",required:!0,label:"Phone Number"}]}},{key:"canRemediate",value:function(){return Boolean(this.values.email||this.values.phoneNumber)}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,l.Z)(f.prototype),"getNextStep",this).call(this,e,t),r=t.currentAuthenticator.value;return d(d({},n),{},{authenticator:r})}},{key:"getData",value:function(){return{stateHandle:this.values.stateHandle,email:this.values.email,phoneNumber:this.values.phoneNumber}}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return!["email","phoneNumber"].includes(e)})).reduce((function(t,n){return d(d({},t),{},(0,u.Z)({},n,e.values[n]))}),{})}}]),f}(n(3118).n);(0,u.Z)(f,"remediationName","enrollment-channel-data")},9732:function(e,t,n){"use strict";n.d(t,{P:function(){return w}});var r=n(5861),o=n(4942),i=n(4925),a=n(5671),s=n(3144),l=n(136),u=n(2963),c=n(1120),d=n(4687),f=n.n(d),p=n(3118),h=n(1002),m=n(885);function v(e){if(Array.isArray(e))return e.map((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e?e:v(e)}));for(var t={},n=0,r=Object.entries(e);n<r.length;n++){var o=(0,m.Z)(r[n],2),i=o[0],a=o[1];if(null!=a)if("object"===(0,h.Z)(a)){var s=Object.keys(a);if(["value","form"].includes(i)&&1===s.length&&["value","form"].includes(s[0])){var l=v(a);Object.entries(l).forEach((function(e){var n=(0,m.Z)(e,2),r=n[0],o=n[1];t[r]=o}))}else t[i]=v(a)}else t[i]=a}return t}var g=["href","method","rel","accepts","produces","value","action"];function y(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?y(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):y(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var w=function(e){(0,l.Z)(d,e);var t,n,o=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function d(){return(0,a.Z)(this,d),o.apply(this,arguments)}return(0,s.Z)(d,[{key:"canRemediate",value:function(){return!("function"!=typeof this.remediation.action||"poll"!==this.remediation.name&&!this.remediation.name.endsWith("-poll")&&!this.options.step)}},{key:"getData",value:function(){var e=this;return this.getInputs().reduce((function(t,n){var r=n.name;return t[r]=e.values[r],t}),{})}},{key:"getNextStep",value:function(e,t){var n,o=this.getName(),a=this.getInputs(),s=this.remediation,l=(s.href,s.method,s.rel,s.accepts,s.produces,s.value,s.action),u=(0,i.Z)(s,g);return l?b(b(b({},u),!!a.length&&{inputs:a}),{},{action:(n=(0,r.Z)(f().mark((function t(n){return f().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed(b({step:o},n)));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})}):b({},this.remediation)}},{key:"getInputs",value:function(){return(this.remediation.value||[]).filter((function(e){return"stateHandle"!==e.name})).map(v).map((function(e){return e.type=e.type||"string",e}))}}]),d}(p.n)},8628:function(e,t,n){"use strict";n.d(t,{h:function(){return f}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var f=function(e){(0,a.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function f(){var e;(0,r.Z)(this,f);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=c.call.apply(c,[this].concat(n)),(0,u.Z)((0,i.Z)(e),"map",{identifier:["username"]}),e}return(0,o.Z)(f,[{key:"canRemediate",value:function(){return!!this.getData().identifier}},{key:"mapCredentials",value:function(){var e=this.values,t=e.credentials,n=e.password;if(t||n)return t||{passcode:n}}},{key:"getInputCredentials",value:function(e){return d(d({},e.form.value[0]),{},{name:"password",required:e.required})}}]),f}(n(3118).n);(0,u.Z)(f,"remediationName","identify")},9024:function(e,t,n){"use strict";n.d(t,{j:function(){return d}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(4942);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,l.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var d=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,r.Z)(this,u),l.apply(this,arguments)}return(0,o.Z)(u,[{key:"mapCredentials",value:function(){var e=this.values.newPassword;if(e)return{passcode:e}}},{key:"getInputCredentials",value:function(e){var t="password"===this.getAuthenticator().type?"newPassword":"verificationCode";return c(c({},e.form.value[0]),{},{name:t})}}]),u}(n(3118).n);(0,l.Z)(d,"remediationName","reenroll-authenticator")},8107:function(e,t,n){"use strict";n.d(t,{i:function(){return u}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.apply(this,arguments)}return(0,r.Z)(u)}(n(9024).j);(0,l.Z)(u,"remediationName","reenroll-authenticator-warning")},8490:function(e,t,n){"use strict";n.d(t,{O:function(){return u}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,r.Z)(this,u),l.apply(this,arguments)}return(0,o.Z)(u,[{key:"canRemediate",value:function(){return!1}},{key:"getNextStep",value:function(){var e=this.remediation;return{name:e.name,type:e.type,idp:e.idp,href:e.href}}}]),u}(n(3118).n);(0,l.Z)(u,"remediationName","redirect-idp")},1019:function(e,t,n){"use strict";n.d(t,{G:function(){return u}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.apply(this,arguments)}return(0,r.Z)(u)}(n(9883).Q);(0,l.Z)(u,"remediationName","reset-authenticator")},7311:function(e,t,n){"use strict";n.d(t,{X:function(){return p}});var r=n(2982),o=n(3144),i=n(5671),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(9164),d=n(6064),f=n(7595),p=function(e){(0,a.Z)(c,e);var t,n,u=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function c(e){var t,n,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.Z)(this,c);var s="recoverPassword"===(n=u.call(this,e,o,a)).options.flow;return(null===(t=(0,d.zg)(e).options)||void 0===t?void 0:t.some((function(e){var t=e.relatesTo;return(null==t?void 0:t.key)===f.pc.OKTA_PASSWORD})))&&(s||n.values.password)&&(n.values.authenticators=[].concat((0,r.Z)(n.values.authenticators||[]),[{key:f.pc.OKTA_PASSWORD}])),n}return(0,o.Z)(c)}(c.n);(0,u.Z)(p,"remediationName","select-authenticator-authenticate")},9865:function(e,t,n){"use strict";n.d(t,{j:function(){return u}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,o.Z)(this,u),l.apply(this,arguments)}return(0,r.Z)(u)}(n(9164).n);(0,l.Z)(u,"remediationName","select-authenticator-enroll")},5272:function(e,t,n){"use strict";n.d(t,{G:function(){return p}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),s=n(136),l=n(2963),u=n(1120),c=n(4942);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,s.Z)(p,e);var t,n,d=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function p(){var e;(0,r.Z)(this,p);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=d.call.apply(d,[this].concat(n)),(0,c.Z)((0,i.Z)(e),"authenticator",void 0),(0,c.Z)((0,i.Z)(e),"map",{identifier:["username"]}),e}return(0,o.Z)(p,[{key:"canRemediate",value:function(){return!!this.getData("identifier")&&(0,a.Z)((0,u.Z)(p.prototype),"canRemediate",this).call(this)}},{key:"mapAuthenticator",value:function(e){var t,n,r,o=(0,a.Z)((0,u.Z)(p.prototype),"mapAuthenticator",this).call(this,e),i=null===(t=this.selectedOption)||void 0===t?void 0:t.value.form.value.find((function(e){return"methodType"===e.name})),s=this.values.methodType||(null==i?void 0:i.value)||(null==i||null===(n=i.options)||void 0===n||null===(r=n[0])||void 0===r?void 0:r.value);return s?f(f({},o),{},{methodType:s}):o}},{key:"getInputUsername",value:function(){return{name:"username",type:"string"}}}]),p}(n(9164).n);(0,c.Z)(p,"remediationName","select-authenticator-unlock-account")},4713:function(e,t,n){"use strict";n.d(t,{j:function(){return u}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,r.Z)(this,u),l.apply(this,arguments)}return(0,o.Z)(u,[{key:"canRemediate",value:function(){return!0}}]),u}(n(3118).n);(0,l.Z)(u,"remediationName","select-enroll-profile")},3403:function(e,t,n){"use strict";n.d(t,{V:function(){return f}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),s=n(2963),l=n(1120),u=n(4942);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var f=function(e){(0,a.Z)(f,e);var t,n,c=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function f(){return(0,r.Z)(this,f),c.apply(this,arguments)}return(0,o.Z)(f,[{key:"canRemediate",value:function(){if(this.values.channel)return!0;if(this.values.authenticator){var e=this.values.authenticator,t=e.id,n=e.channel;if(t&&n)return!0}return!1}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,l.Z)(f.prototype),"getNextStep",this).call(this,e,t),r=t.currentAuthenticator.value;return d(d({},n),{},{authenticator:r})}},{key:"getData",value:function(){var e;return{authenticator:{id:this.remediation.value[0].value.form.value[0].value,channel:(null===(e=this.values.authenticator)||void 0===e?void 0:e.channel)||this.values.channel},stateHandle:this.values.stateHandle}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,i.Z)((0,l.Z)(f.prototype),"getValuesAfterProceed",this).call(this),delete this.values.authenticators;var t=this.values.channel?"channel":"authenticator";return Object.keys(this.values).filter((function(e){return e!==t})).reduce((function(t,n){return d(d({},t),{},(0,u.Z)({},n,e.values[n]))}),{})}}]),f}(n(3118).n);(0,u.Z)(f,"remediationName","select-enrollment-channel")},8443:function(e,t,n){"use strict";n.d(t,{h:function(){return u}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(4942),u=function(e){(0,i.Z)(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function u(){return(0,r.Z)(this,u),l.apply(this,arguments)}return(0,o.Z)(u,[{key:"canRemediate",value:function(){return!!this.values.skip||"skip"===this.options.step}}]),u}(n(3118).n);(0,l.Z)(u,"remediationName","skip")},6064:function(e,t,n){"use strict";function r(e){var t;return null===(t=e.value)||void 0===t?void 0:t.map((function(e){return e.name}))}function o(e){var t;return null===(t=e.value)||void 0===t?void 0:t.reduce((function(e,t){return t.required&&e.push(t.name),e}),[])}function i(e){return e.charAt(0).toUpperCase()+e.substring(1)}function a(e){return e.value.find((function(e){return"authenticator"===e.name}))}n.d(t,{QG:function(){return o},Qs:function(){return i},ix:function(){return r},zg:function(){return a}})},3377:function(e,t,n){"use strict";n.d(t,{K:function(){return D}});var r=n(5861),o=n(4942),i=n(4687),a=n.n(i),s=n(6131),l=n(2660),u=n(1002),c=n(2982),d=n(9123),f=n(5031);function p(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return h(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?h(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function h(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){return Object.keys(t.actions).find((function(t){return!!e.resend&&t.includes("-resend")}))}function y(e){return v(v({},e),{},{resend:void 0})}function b(e,t){var n=e.actions||[];return n=n.filter((function(e){return"string"==typeof e?e!==t:e.name!==t})),v(v({},e),{},{actions:n})}function w(e,t,n,r){return _.apply(this,arguments)}function _(){return(_=(0,r.Z)(a().mark((function e(t,n,r,o){var i,s,l,h,m,_,O,k,x,E,T,S,A,P,C,R,I,N;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(s=(i=n).neededToProceed,l=i.interactionCode,h=o.flow,!l){e.next=4;break}return e.abrupt("return",{idxResponse:n});case 4:if(m=(0,f.l6)(n,r,o),_=g(r,n),O=o.actions||[],!(k=[].concat((0,c.Z)(O),(0,c.Z)(_&&[_]||[])))){e.next=28;break}x=p(k),e.prev=10,T=a().mark((function e(){var i,l,u,c;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=E.value,l={},"string"!=typeof i&&(l=i.params||{},i=i.name),u=y(r),c=b(o,i),"function"!=typeof n.actions[i]){e.next=14;break}return e.next=8,n.actions[i](l);case 8:if(!1!==(n=e.sent).requestDidSucceed){e.next=11;break}return e.abrupt("return",{v:(0,f.Tc)(t,n,o)});case 11:if("cancel"!==i){e.next=13;break}return e.abrupt("return",{v:{idxResponse:n,canceled:!0}});case 13:return e.abrupt("return",{v:w(t,n,u,c)});case 14:if(!s.find((function(e){return e.name===i}))){e.next=22;break}return e.next=18,n.proceed(i,l);case 18:if(!1!==(n=e.sent).requestDidSucceed){e.next=21;break}return e.abrupt("return",{v:(0,f.Tc)(t,n,o)});case 21:return e.abrupt("return",{v:w(t,n,r,c)});case 22:case"end":return e.stop()}}),e)})),x.s();case 13:if((E=x.n()).done){e.next=20;break}return e.delegateYield(T(),"t0",15);case 15:if(S=e.t0,"object"!==(0,u.Z)(S)){e.next=18;break}return e.abrupt("return",S.v);case 18:e.next=13;break;case 20:e.next=25;break;case 22:e.prev=22,e.t1=e.catch(10),x.e(e.t1);case 25:return e.prev=25,x.f(),e.finish(25);case 28:if(!(A=(0,f.xn)(n))){e.next=31;break}return e.abrupt("return",{idxResponse:n,terminal:A});case 31:if(m){e.next=43;break}if(!o.step){e.next=40;break}return r=(0,f.Ax)(n,o.step,r),e.next=36,n.proceed(o.step,r);case 36:if(!1!==(n=e.sent).requestDidSucceed){e.next=39;break}return e.abrupt("return",(0,f.Tc)(t,n,o));case 39:return e.abrupt("return",{idxResponse:n});case 40:if("default"!==h){e.next=42;break}return e.abrupt("return",{idxResponse:n});case 42:throw new d.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(s.reduce((function(e,t){return e?e+" ,"+t.name:t.name}),""),"]\n    "));case 43:if(m.canRemediate()){e.next=46;break}return P=(0,f.TR)(t,m,n),e.abrupt("return",{idxResponse:n,nextStep:P});case 46:return C=m.getName(),R=m.getData(),e.next=50,n.proceed(C,R);case 50:if(!1!==(n=e.sent).requestDidSucceed){e.next=53;break}return e.abrupt("return",(0,f.Tc)(t,n,o));case 53:if(r=m.getValuesAfterProceed(),!(o=v(v({},o),{},{step:void 0})).useGenericRemediator||n.interactionCode||(0,f.xn)(n)){e.next=59;break}return I=(0,f.l6)(n,r,o),N=(0,f.TR)(t,I,n),e.abrupt("return",{idxResponse:n,nextStep:N});case 59:return e.abrupt("return",w(t,n,r,o));case 60:case"end":return e.stop()}}),e,null,[[10,22,25,28]])})))).apply(this,arguments)}var O=n(7595),k=n(2620);function x(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function E(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?x(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):x(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function T(e){var t=E({},e);return["flow","remediators","actions","withCredentials","step","useGenericRemediator","exchangeCodeForTokens"].forEach((function(e){delete t[e]})),t}function S(e,t){var n,r,o=t.options,i=o=E(E({},e.options.idx),o),a=i.flow,s=i.withCredentials,l=i.remediators,u=i.actions,c=O.Qd.PENDING;if(a=a||(null===(n=(r=e.idx).getFlow)||void 0===n?void 0:n.call(r))||"default"){var d,p;null===(d=(p=e.idx).setFlow)||void 0===d||d.call(p,a);var h=(0,f.sH)(e,a);s=void 0!==s?s:h.withCredentials,l=l||h.remediators,u=u||h.actions}return E(E({},t),{},{options:E(E({},o),{},{flow:a,withCredentials:s,remediators:l,actions:u}),status:c})}function A(e,t){return P.apply(this,arguments)}function P(){return(P=(0,r.Z)(a().mark((function e(t,n){var r,o,i,u,c,d,f,p,h,m,v,g,y,b,w,_,O;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=r.stateHandle,i=r.withCredentials,u=r.version,c=r.state,d=r.scopes,f=r.recoveryToken,p=r.activationToken,h=r.maxAge,m=r.acrValues,v=r.nonce,g=r.useGenericRemediator,b=(0,k.uN)(t,{state:c,recoveryToken:f,activationToken:p}),!o){e.next=9;break}return e.next=6,(0,l.L)(t,{withCredentials:i,version:u,stateHandle:o,useGenericRemediator:g});case 6:y=e.sent,e.next=20;break;case 9:if(_=null===(w=b)||void 0===w?void 0:w.interactionHandle){e.next=17;break}return t.transactionManager.clear(),e.next=14,(0,s.E)(t,{withCredentials:i,state:c,scopes:d,activationToken:p,recoveryToken:f,maxAge:h,acrValues:m,nonce:v});case 14:O=e.sent,_=O.interactionHandle,b=O.meta;case 17:return e.next=19,(0,l.L)(t,{withCredentials:i,version:u,interactionHandle:_,useGenericRemediator:g});case 19:y=e.sent;case 20:return e.abrupt("return",E(E({},n),{},{idxResponse:y,meta:b}));case 21:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function C(e,t){return R.apply(this,arguments)}function R(){return(R=(0,r.Z)(a().mark((function e(t,n){var r,o,i,s,l,u,c,d,f,p,h,m,v;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.idxResponse,o=n.options,i=n.values,s=o.autoRemediate,l=o.remediators,u=o.actions,c=o.flow,d=o.step,f=o.useGenericRemediator,!1!==s&&(l||u||d)){e.next=5;break}return e.abrupt("return",n);case 5:return i=E(E({},i),{},{stateHandle:r.rawIdxState.stateHandle}),e.next=8,w(t,r,i,{remediators:l,actions:u,flow:c,step:d,useGenericRemediator:f});case 8:return p=e.sent,h=p.idxResponse,m=p.nextStep,v=p.canceled,r=h,e.abrupt("return",E(E({},n),{},{idxResponse:r,nextStep:m,canceled:v}));case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function I(e,t){return N.apply(this,arguments)}function N(){return(N=(0,r.Z)(a().mark((function e(t,n){var r,o,i,s,l,u,c,d,f,p,h;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.meta,o=n.idxResponse,i=o.interactionCode,l=(s=r).clientId,u=s.codeVerifier,c=s.ignoreSignature,d=s.redirectUri,f=s.urls,p=s.scopes,e.next=5,t.token.exchangeCodeForTokens({interactionCode:i,clientId:l,codeVerifier:u,ignoreSignature:c,redirectUri:d,scopes:p},f);case 5:return h=e.sent,e.abrupt("return",h.tokens);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function M(e,t){return j.apply(this,arguments)}function j(){return(j=(0,r.Z)(a().mark((function e(t,n){var r,o,i,s,l,u,c,d,p,h,m,v,g,y,b,w;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=n.idxResponse,i=n.canceled,s=n.status,l=r.exchangeCodeForTokens,u=!1,c=!1,d=!0,o&&(u=!(!o.requestDidSucceed&&!o.stepUp),m=(0,f.KM)(o),v=(0,f.kw)(t,o,r.useGenericRemediator),g=(0,f.lx)(o,r),y=(0,f.xn)(o)),!y){e.next=15;break}s=O.Qd.TERMINAL,b=Object.keys(o.actions).length>0,w=!!g.find((function(e){return"ERROR"===e.class})),b||w||!0!==o.requestDidSucceed?u=!!b:c=!0,d=!1,e.next=32;break;case 15:if(!i){e.next=20;break}s=O.Qd.CANCELED,c=!0,e.next=32;break;case 20:if(null==o||!o.interactionCode){e.next=32;break}if(p=o.interactionCode,!1!==l){e.next=27;break}s=O.Qd.SUCCESS,c=!1,e.next=32;break;case 27:return e.next=29,I(t,n);case 29:h=e.sent,s=O.Qd.SUCCESS,c=!0;case 32:return e.abrupt("return",E(E({},n),{},{status:s,interactionCode:p,tokens:h,shouldSaveResponse:u,shouldClearTransaction:c,clearSharedStorage:d,enabledFeatures:m,availableSteps:v,messages:g,terminal:y}));case 33:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function D(e){return L.apply(this,arguments)}function L(){return L=(0,r.Z)(a().mark((function e(t){var n,r,o,i,s,l,u,c,d,f,p,h,m,v,g,y,b,w,_,O,x,P,R,I,N,j,D,L,U=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r={options:n=U.length>1&&void 0!==U[1]?U[1]:{},values:T(n)},r=S(t,r),e.next=5,A(t,r);case 5:return r=e.sent,e.next=8,C(t,r);case 8:return r=e.sent,e.next=11,M(t,r);case 11:return r=e.sent,i=(o=r).idxResponse,s=o.meta,l=o.shouldSaveResponse,u=o.shouldClearTransaction,c=o.clearSharedStorage,d=o.status,f=o.enabledFeatures,p=o.availableSteps,h=o.tokens,m=o.nextStep,v=o.messages,g=o.error,y=o.interactionCode,u?t.transactionManager.clear({clearSharedStorage:c}):((0,k.r0)(t,E({},s)),l&&(_=(w=i).rawIdxState,O=w.requestDidSucceed,t.transactionManager.saveIdxResponse({rawIdxResponse:_,requestDidSucceed:O,stateHandle:null===(b=i.context)||void 0===b?void 0:b.stateHandle,interactionHandle:null==s?void 0:s.interactionHandle}))),P=(x=i||{}).actions,R=x.context,I=x.neededToProceed,N=x.proceed,j=x.rawIdxState,D=x.requestDidSucceed,L=x.stepUp,e.abrupt("return",E(E(E(E(E(E(E(E(E({status:d},s&&{meta:s}),f&&{enabledFeatures:f}),p&&{availableSteps:p}),h&&{tokens:h}),m&&{nextStep:m}),v&&v.length&&{messages:v}),g&&{error:g}),L&&{stepUp:L}),{},{interactionCode:y,actions:P,context:R,neededToProceed:I,proceed:N,rawIdxState:j,requestDidSucceed:D}));case 16:case"end":return e.stop()}}),e)}))),L.apply(this,arguments)}},2473:function(e,t,n){"use strict";n.d(t,{Y:function(){return c}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function c(e){return d.apply(this,arguments)}function d(){return d=(0,o.Z)(a().mark((function e(t){var n,r=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.length>1&&void 0!==r[1]?r[1]:{},t.transactionManager.clear(),e.abrupt("return",(0,s.K)(t,u({exchangeCodeForTokens:!1},n)));case 3:case"end":return e.stop()}}),e)}))),d.apply(this,arguments)}},4143:function(e,t,n){"use strict";n.d(t,{a:function(){return h}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(5763),u=n(1971),c=n(2647),d=n(415),f=n(146),p=n(9123);function h(){return function(e){(0,i.Z)(h,e);var t,n,c=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function h(e,t,n){return(0,r.Z)(this,h),c.call(this,e,t,n)}return(0,o.Z)(h,[{key:"getIdxResponseStorage",value:function(e){var t;if((0,d.isBrowser)())try{t=this.storageUtil.getStorageByType("memory",e)}catch(e){(0,f.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic")}else{var n=this.getTransactionStorage(e);n&&(t={getItem:function(e){var t=n.getStorage();return t&&t[e]?t[e]:null},setItem:function(e,t){var r=n.getStorage();if(!r)throw new p.Z("Transaction has been cleared, failed to save idxState");r[e]=t,n.setStorage(r)},removeItem:function(e){var t=n.getStorage();t&&(delete t[e],n.setStorage(t))}})}return t?new l._(t,u.IDX_RESPONSE_STORAGE_NAME):null}}]),h}((0,c.a)())}},2620:function(e,t,n){"use strict";n.d(t,{$0:function(){return h},Co:function(){return v},Jm:function(){return b},UC:function(){return O},Wf:function(){return w},Xc:function(){return f},bl:function(){return _},r0:function(){return y},uN:function(){return m}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3193),l=n(146),u=n(2865);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function f(e){return p.apply(this,arguments)}function p(){return p=(0,o.Z)(a().mark((function e(t){var n,r,o,i,s,l,c,f,p,h,m,v,g,y,b,w,_,O=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=O.length>1&&void 0!==O[1]?O[1]:{},e.next=3,t.token.prepareTokenParams(n);case 3:return r=e.sent,o=(0,u.H)(t,r),i=d(d({},t.options),n),s=i.flow,l=void 0===s?"default":s,c=i.withCredentials,f=void 0===c||c,p=i.activationToken,h=void 0===p?void 0:p,m=i.recoveryToken,v=void 0===m?void 0:m,g=i.maxAge,y=void 0===g?void 0:g,b=i.acrValues,w=void 0===b?void 0:b,_=d(d({},o),{},{flow:l,withCredentials:f,activationToken:h,recoveryToken:v,maxAge:y,acrValues:w}),e.abrupt("return",_);case 8:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}function h(e,t){var n=m(e,t);return!(null==n||!n.interactionHandle)}function m(e,t){var n;t=(0,s.YY)(t),t=d(d({},e.options),t);try{n=e.transactionManager.load(t)}catch(e){}if(n)return w(n,t)?n:void(0,l.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.")}function v(e,t){return g.apply(this,arguments)}function g(){return(g=(0,o.Z)(a().mark((function e(t,n){var r;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=(0,s.YY)(n),n=d(d({},t.options),n),!(r=m(t,n))){e.next=5;break}return e.abrupt("return",r);case 5:return e.abrupt("return",f(t,n));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function y(e,t){e.transactionManager.save(t,{muteWarning:!0})}function b(e){e.transactionManager.clear()}function w(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!1!==O(e,t,["issuer","clientId","redirectUri","state","codeChallenge","codeChallengeMethod","activationToken","recoveryToken"])&&!1!==_(e,t.flow)}function _(e,t){return!(t&&"default"!==t&&"proceed"!==t)||t===e.flow}function O(e,t,n){return!n.some((function(n){var r=t[n];if(r&&r!==e[n])return!0}))}},7595:function(e,t,n){"use strict";var r,o,i;function a(e){return e&&(e.key||e.id)}n.d(t,{Fw:function(){return i},H:function(){return a},Qd:function(){return r},pc:function(){return o}}),function(e){e.SUCCESS="SUCCESS",e.PENDING="PENDING",e.FAILURE="FAILURE",e.TERMINAL="TERMINAL",e.CANCELED="CANCELED"}(r||(r={})),function(e){e.OKTA_PASSWORD="okta_password",e.OKTA_EMAIL="okta_email",e.PHONE_NUMBER="phone_number",e.GOOGLE_AUTHENTICATOR="google_otp",e.SECURITY_QUESTION="security_question",e.OKTA_VERIFY="okta_verify",e.WEBAUTHN="webauthn"}(o||(o={})),function(e){e.PASSWORD_RECOVERY="recover-password",e.REGISTRATION="enroll-profile",e.SOCIAL_IDP="redirect-idp",e.ACCOUNT_UNLOCK="unlock-account"}(i||(i={}))},480:function(e,t,n){"use strict";function r(e){return e&&e.version}n.d(t,{P:function(){return r}})},8277:function(e,t,n){"use strict";n.d(t,{l:function(){return h}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(3377),l=n(2620),u=n(2473),c=n(9123),d=n(7595);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function h(e){return m.apply(this,arguments)}function m(){return m=(0,o.Z)(a().mark((function e(t){var n,r,o,i=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((n=i.length>1&&void 0!==i[1]?i[1]:{}).flow="unlockAccount",(0,l.$0)(t)){e.next=9;break}return e.next=5,(0,u.Y)(t,p(p({},n),{},{autoRemediate:!1}));case 5:if(r=e.sent,!(o=r.enabledFeatures)||o.includes(d.Fw.ACCOUNT_UNLOCK)){e.next=9;break}throw new c.Z("Self Service Account Unlock is not supported based on your current org configuration.");case 9:return e.abrupt("return",(0,s.K)(t,p({},n)));case 10:case"end":return e.stop()}}),e)}))),m.apply(this,arguments)}},5031:function(e,t,n){"use strict";n.d(t,{Ax:function(){return S},KM:function(){return E},TC:function(){return w},TR:function(){return C},Tc:function(){return R},kw:function(){return T},l6:function(){return P},lx:function(){return x},sH:function(){return _},xn:function(){return O}});var r=n(4942),o=n(4925),i=n(5861),a=n(885),s=n(2982),l=n(4687),u=n.n(l),c=n(8750),d=n(146),f=n(9732),p=n(7595),h=["href","method","rel","accepts","produces"];function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return y(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?y(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function y(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var b={remediators:{},getFlowSpecification:function(e){return{remediators:{}}}};function w(e){Object.assign(b,e)}function _(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default";return b.getFlowSpecification(e,t)}function O(e){var t=e.neededToProceed,n=e.interactionCode;return!t.length&&!n}function k(e){if(e&&Array.isArray(e))return e.reduce((function(e,t){if(t.messages&&(e=[].concat((0,s.Z)(e),(0,s.Z)(t.messages.value))),t.form){var n=k(t.form.value)||[];e=[].concat((0,s.Z)(e),(0,s.Z)(n))}if(t.options){var r=[];t.options.forEach((function(e){e.value&&"string"!=typeof e.value&&(r=[].concat((0,s.Z)(r),[e.value]))}));var o=k(r)||[];e=[].concat((0,s.Z)(e),(0,s.Z)(o))}return e}),[])}function x(e,t){var n,r=[],o=e.rawIdxState,i=e.neededToProceed,a=null===(n=o.messages)||void 0===n?void 0:n.value.map((function(e){return e}));if(a&&(r=[].concat((0,s.Z)(r),(0,s.Z)(a))),!t.useGenericRemediator){var l,u=g(i);try{for(u.s();!(l=u.n()).done;){var c=k(l.value.value);c&&(r=[].concat((0,s.Z)(r),(0,s.Z)(c)))}}catch(e){u.e(e)}finally{u.f()}}var d={};return r.reduce((function(e,t){var n,r=null===(n=t.i18n)||void 0===n?void 0:n.key;return r&&d[r]&&t.message===d[r].message?e:(d[r]=t,e=[].concat((0,s.Z)(e),[t]))}),[])}function E(e){var t=[],n=e.actions,r=e.neededToProceed;return n["currentAuthenticator-recover"]&&t.push(p.Fw.PASSWORD_RECOVERY),r.some((function(e){return"select-enroll-profile"===e.name}))&&t.push(p.Fw.REGISTRATION),r.some((function(e){return"redirect-idp"===e.name}))&&t.push(p.Fw.SOCIAL_IDP),r.some((function(e){return"unlock-account"===e.name}))&&t.push(p.Fw.ACCOUNT_UNLOCK),t}function T(e,t,n){var r,s=[],l=Object.values(b.remediators).reduce((function(e,t){return t.remediationName&&(e[t.remediationName]=t),e}),{}),d=g(t.neededToProceed);try{for(d.s();!(r=d.n()).done;){var f=r.value,p=A(f,{useGenericRemediator:n,remediators:l});if(p){var m=new p(f);s.push(m.getNextStep(e,t.context))}}}catch(e){d.e(e)}finally{d.f()}for(var y=function(){var n,r=(0,a.Z)(_[w],1)[0],l={name:r,action:(n=(0,i.Z)(u().mark((function t(n){return u().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed({actions:[{name:r,params:n}]}));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})};if(r.startsWith("currentAuthenticator")){var d,f=(0,c.YQ)(r,"-"),p=(0,a.Z)(f,2),m=p[0],g=p[1],y=t.rawIdxState[m].value[g],b=(y.href,y.method,y.rel,y.accepts,y.produces,(0,o.Z)(y,h)),O=null===(d=y.value)||void 0===d?void 0:d.filter((function(e){return"stateHandle"!==e.name}));l=v(v(v({},b),O&&{value:O}),l)}s.push(l)},w=0,_=Object.entries(t.actions||{});w<_.length;w++)y();return s}function S(e,t,n){var r=(e.neededToProceed||[]).find((function(e){return e.name===t}));return r?r.value.reduce((function(e,t){var r=t.name,o=t.value;return e[r]="stateHandle"===r?o:n[r],e}),{}):((0,d.ZK)('filterValuesForRemediation: "'.concat(t,'" did not match any remediations')),n)}function A(e,t){var n=t.useGenericRemediator,r=t.remediators;if(e)return n?f.P:r[e.name]}function P(e,t,n){var r,o=n.remediators,i=n.useGenericRemediator,a=e.neededToProceed,s=e.context;if(!n.step){var l=[];if(i)l.push(new f.P(a[0],t,n));else{var u,c=g(a);try{for(c.s();!(u=c.n()).done;){var p=u.value;if(Object.keys(o).includes(p.name)){if((r=new(A(p,n))(p,t,n)).canRemediate(s))return r;l.push(r)}}}catch(e){c.e(e)}finally{c.f()}}return l[0]}var h=a.find((function(e){return e.name===n.step}));if(h){var m=A(h,n);return m?new m(h,t,n):void 0}(0,d.ZK)('step "'.concat(n.step,'" did not match any remediations'))}function C(e,t,n){var r=t.getNextStep(e,n.context),o=function(e){return e.neededToProceed.some((function(e){return"skip"===e.name}))}(n),i=function(e){return Object.keys(e.actions).some((function(e){return e.includes("resend")}))}(n);return v(v(v({},r),o&&{canSkip:o}),i&&{canResend:i})}function R(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=O(t),o=x(t,n);if(r)return{idxResponse:t,terminal:r,messages:o};var i=P(t,{},n),a=i&&C(e,i,t);return v({idxResponse:t,messages:o},a&&{nextStep:a})}},8716:function(e,t,n){"use strict";n.r(t),n.d(t,{buildCredentialCreationOptions:function(){return l},buildCredentialRequestOptions:function(){return u},getAssertion:function(){return d},getAttestation:function(){return c}});var r=n(4942),o=n(7987);function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function a(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var s=function(){var e=[];return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).forEach((function(t){"webauthn"===t.key&&e.push({type:"public-key",id:(0,o.dX)(t.credentialId)})})),e},l=function(e,t){return{publicKey:{rp:e.rp,user:{id:(0,o.dX)(e.user.id),name:e.user.name,displayName:e.user.displayName},challenge:(0,o.dX)(e.challenge),pubKeyCredParams:e.pubKeyCredParams,attestation:e.attestation,authenticatorSelection:e.authenticatorSelection,excludeCredentials:s(t)}}},u=function(e,t){return{publicKey:a({challenge:(0,o.dX)(e.challenge),userVerification:e.userVerification,allowCredentials:s(t)},e.rpId&&{rpId:e.rpId})}},c=function(e){var t=e.response;return{id:e.id,clientData:(0,o.kQ)(t.clientDataJSON),attestation:(0,o.kQ)(t.attestationObject)}},d=function(e){var t=e.response;return{id:e.id,clientData:(0,o.kQ)(t.clientDataJSON),authenticatorData:(0,o.kQ)(t.authenticatorData),signatureData:(0,o.kQ)(t.signature)}}},9108:function(e,t,n){"use strict";n.r(t),n.d(t,{addEmail:function(){return V},addPhone:function(){return Y},deleteEmail:function(){return Z},deletePassword:function(){return oe},deletePhone:function(){return G},enrollPassword:function(){return ne},getEmail:function(){return B},getEmailChallenge:function(){return q},getEmails:function(){return F},getPassword:function(){return te},getPhone:function(){return z},getPhones:function(){return $},getProfile:function(){return N},getProfileSchema:function(){return j},sendEmailChallenge:function(){return H},sendPhoneChallenge:function(){return J},updatePassword:function(){return re},updateProfile:function(){return M},verifyEmailChallenge:function(){return W},verifyPhoneChallenge:function(){return Q}});var r=n(5861),o=n(4687),i=n.n(o),a=n(4942),s=n(1002),l=n(4925),u=n(3144),c=n(5671),d=["headers"],f=(0,u.Z)((function e(t,n){var r=this;(0,c.Z)(this,e),(0,a.Z)(this,"headers",void 0);var o=n.res,i=o.headers,s=(0,l.Z)(o,d);i&&(this.headers=i),Object.keys(s).forEach((function(e){"_links"!==e&&(r[e]=s[e])}))})),p=n(5385),h=n(9123);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){return y.apply(this,arguments)}function y(){return y=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s,l,u,c,d,m,g,y,b,w,_,O,k,x=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=x.length>2&&void 0!==x[2]?x[2]:f,o=t.tokenManager.getTokensSync(),a=o.accessToken,s=n.accessToken||a,l=t.getIssuerOrigin(),u=n.url,c=n.method,d=n.payload,m=u.startsWith(l)?u:"".concat(l).concat(u),s){e.next=8;break}throw new h.Z("AccessToken is required to request MyAccount API endpoints.");case 8:if(g=s,y=v({headers:{Accept:"*/*;okta-version=1.0.0"},url:m,method:c},d&&{args:d}),!t.options.dpop){e.next=22;break}if("string"!=typeof g){e.next=13;break}throw new h.Z("AccessToken object must be provided when using dpop");case 13:return e.next=15,t.getDPoPAuthorizationHeaders({method:c,url:m,accessToken:g});case 15:b=e.sent,w=b.Authorization,_=b.Dpop,y.headers.Authorization=w,y.headers.Dpop=_,e.next=24;break;case 22:g="string"==typeof g?g:g.accessToken,y.accessToken=g;case 24:return e.next=26,(0,p.c3)(t,y);case 26:return O=e.sent,k=Array.isArray(O)?O.map((function(e){return new r(t,{res:e,accessToken:g})})):new r(t,{res:O,accessToken:g}),e.abrupt("return",k);case 29:case"end":return e.stop()}}),e)}))),y.apply(this,arguments)}function b(e){for(var t=e.oktaAuth,n=e.accessToken,o=e.methodName,a=e.links,l=arguments.length>1&&void 0!==arguments[1]?arguments[1]:f,u=function(){var e,s=d[c];if(s.toLowerCase()===o){var u=a.self;return{v:(e=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",g(t,{accessToken:n,url:u.href,method:s,payload:r},l));case 1:case"end":return e.stop()}}),e)}))),function(t){return e.apply(this,arguments)})}}},c=0,d=["GET","POST","PUT","DELETE"];c<d.length;c++){var p=u();if("object"===(0,s.Z)(p))return p.v}var m,v=a[o];if(!v)throw new h.Z("No link is found with methodName: ".concat(o));return m=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",g(t,{accessToken:n,url:v.href,method:v.hints.allow[0],payload:r},l));case 1:case"end":return e.stop()}}),e)}))),function(e){return m.apply(this,arguments)}}var w,_,O,k,x,E,T,S=n(7326),A=n(136),P=n(2963),C=n(1120),R=function(e){(0,A.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function o(e,t){var n;(0,c.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,S.Z)(n),"createdAt",void 0),(0,a.Z)((0,S.Z)(n),"modifiedAt",void 0),(0,a.Z)((0,S.Z)(n),"profile",void 0);var i=t.res,s=i.createdAt,l=i.modifiedAt,u=i.profile;return n.createdAt=s,n.modifiedAt=l,n.profile=u,n}return(0,u.Z)(o)}(f),I=function(e){(0,A.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function o(e,t){var n;return(0,c.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,S.Z)(n),"properties",void 0),n.properties=t.res.properties,n}return(0,u.Z)(o)}(f),N=(w=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/profile",method:"GET",accessToken:null==n?void 0:n.accessToken},R);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return w.apply(this,arguments)}),M=(_=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).payload,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/profile",method:"PUT",payload:o,accessToken:a},R);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return _.apply(this,arguments)}),j=(O=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/profile/schema",method:"GET",accessToken:null==n?void 0:n.accessToken},I);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return O.apply(this,arguments)}),D=function(e){(0,A.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function o(e,t){var n;(0,c.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,S.Z)(n),"id",void 0),(0,a.Z)((0,S.Z)(n),"expiresAt",void 0),(0,a.Z)((0,S.Z)(n),"profile",void 0),(0,a.Z)((0,S.Z)(n),"status",void 0);var i=t.res,s=i.id,l=i.profile,u=i.expiresAt,d=i.status;return n.id=s,n.expiresAt=u,n.profile=l,n.status=d,n}return(0,u.Z)(o)}(f),L=function(e){(0,A.Z)(s,e);var t,n,o=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function s(e,t){var n;(0,c.Z)(this,s),n=o.call(this,e,t),(0,a.Z)((0,S.Z)(n),"id",void 0),(0,a.Z)((0,S.Z)(n),"expiresAt",void 0),(0,a.Z)((0,S.Z)(n),"profile",void 0),(0,a.Z)((0,S.Z)(n),"status",void 0),(0,a.Z)((0,S.Z)(n),"poll",void 0),(0,a.Z)((0,S.Z)(n),"verify",void 0);var l=t.accessToken,u=t.res,d=u.id,f=u.expiresAt,p=u.profile,h=u.status,m=u._links;return n.id=d,n.expiresAt=f,n.profile=p,n.status=h,n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:l,methodName:"poll",links:m},D),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.verify=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:l,methodName:"verify",links:m},s),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}(),n}return(0,u.Z)(s)}(f),U=function(e){(0,A.Z)(s,e);var t,n,o=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function s(e,t){var n;(0,c.Z)(this,s),n=o.call(this,e,t),(0,a.Z)((0,S.Z)(n),"id",void 0),(0,a.Z)((0,S.Z)(n),"profile",void 0),(0,a.Z)((0,S.Z)(n),"roles",void 0),(0,a.Z)((0,S.Z)(n),"status",void 0),(0,a.Z)((0,S.Z)(n),"get",void 0),(0,a.Z)((0,S.Z)(n),"delete",void 0),(0,a.Z)((0,S.Z)(n),"challenge",void 0),(0,a.Z)((0,S.Z)(n),"poll",void 0),(0,a.Z)((0,S.Z)(n),"verify",void 0);var l,u=t.accessToken,d=t.res,f=d.id,p=d.profile,h=d.roles,m=d.status,v=d._links;return n.id=f,n.profile=p,n.roles=h,n.status=m,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:u,methodName:"get",links:v},s),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:u,methodName:"delete",links:v}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:u,methodName:"challenge",links:v},L),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),v.poll&&(n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:u,methodName:"poll",links:v},D),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),v.verify&&(n.verify=(l=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:u,methodName:"verify",links:v}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return l.apply(this,arguments)})),n}return(0,u.Z)(s)}(f),F=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/emails",method:"GET",accessToken:null==n?void 0:n.accessToken},U);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),B=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o),method:"GET",accessToken:a},U);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),V=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/emails",method:"POST",payload:a,accessToken:o},U);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Z=(k=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o),method:"DELETE",accessToken:a});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return k.apply(this,arguments)}),H=(x=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge"),method:"POST",accessToken:a},L);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return x.apply(this,arguments)}),q=(E=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s,l;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,s=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a),method:"POST",accessToken:s},L);case 3:return l=e.sent,e.abrupt("return",l);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return E.apply(this,arguments)}),W=(T=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s,l,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,s=r.payload,l=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a,"/verify"),method:"POST",payload:s,accessToken:l});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return T.apply(this,arguments)}),K=function(e){(0,A.Z)(s,e);var t,n,o=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function s(e,t){var n;(0,c.Z)(this,s),n=o.call(this,e,t),(0,a.Z)((0,S.Z)(n),"id",void 0),(0,a.Z)((0,S.Z)(n),"profile",void 0),(0,a.Z)((0,S.Z)(n),"status",void 0),(0,a.Z)((0,S.Z)(n),"get",void 0),(0,a.Z)((0,S.Z)(n),"delete",void 0),(0,a.Z)((0,S.Z)(n),"challenge",void 0),(0,a.Z)((0,S.Z)(n),"verify",void 0);var l,u=t.res,d=t.accessToken,f=u.id,p=u.profile,h=u.status,m=u._links;return n.id=f,n.profile=p,n.status=h,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:d,methodName:"get",links:m},s),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:d,methodName:"delete",links:m}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(l=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:d,methodName:"challenge",links:m}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return l.apply(this,arguments)}),m.verify&&(n.verify=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:d,methodName:"verify",links:m}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()),n}return(0,u.Z)(s)}(f),$=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/phones",method:"GET",accessToken:null==n?void 0:n.accessToken},K);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),z=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(a),method:"GET",accessToken:o},K);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Y=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/phones",method:"POST",payload:a,accessToken:o},K);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),G=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(o),method:"DELETE",accessToken:a});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),J=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s,l;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,s=r.payload,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(a,"/challenge"),method:"POST",payload:s,accessToken:o});case 3:return l=e.sent,e.abrupt("return",l);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Q=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s,l;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.payload,s=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(o,"/verify"),method:"POST",payload:a,accessToken:s});case 3:return l=e.sent,e.abrupt("return",l);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),X=n(8008),ee=function(e){(0,A.Z)(s,e);var t,n,o=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,C.Z)(t);if(n){var o=(0,C.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,P.Z)(this,e)});function s(e,t){var n;(0,c.Z)(this,s),n=o.call(this,e,t),(0,a.Z)((0,S.Z)(n),"id",void 0),(0,a.Z)((0,S.Z)(n),"created",void 0),(0,a.Z)((0,S.Z)(n),"lastUpdated",void 0),(0,a.Z)((0,S.Z)(n),"status",void 0),(0,a.Z)((0,S.Z)(n),"get",void 0),(0,a.Z)((0,S.Z)(n),"enroll",void 0),(0,a.Z)((0,S.Z)(n),"update",void 0),(0,a.Z)((0,S.Z)(n),"delete",void 0);var l,u=t.res,d=t.accessToken,f=u.id,p=u.status,h=u.created,m=u.lastUpdated,v=u._links;return n.id=f,n.status=p,n.created=h,n.lastUpdated=m,n.status==X.Fn.NOT_ENROLLED?n.enroll=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:d,methodName:"enroll",links:v},s),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}():(n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:d,methodName:"get",links:v},s),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.update=(l=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:d,methodName:"put",links:v},s),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return l.apply(this,arguments)}),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:d,methodName:"delete",links:v}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),n}return(0,u.Z)(s)}(f),te=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/password",method:"GET",accessToken:null==n?void 0:n.accessToken},ee);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),ne=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/password",method:"POST",payload:a,accessToken:o},ee);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),re=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/password",method:"PUT",payload:a,accessToken:o},ee);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),oe=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/password",method:"DELETE",accessToken:null==n?void 0:n.accessToken});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},1132:function(e,t,n){"use strict";n.d(t,{aw:function(){return s.aw},Fn:function(){return s.Fn},qb:function(){return s.qb},no:function(){return r.addEmail},Z1:function(){return r.addPhone},Xc:function(){return a},nd:function(){return r.deleteEmail},QN:function(){return r.deletePassword},qj:function(){return r.deletePhone},xg:function(){return r.enrollPassword},OD:function(){return r.getEmail},hG:function(){return r.getEmailChallenge},G5:function(){return r.getEmails},Ij:function(){return r.getPassword},u_:function(){return r.getPhone},Po:function(){return r.getPhones},Ai:function(){return r.getProfile},aF:function(){return r.getProfileSchema},HT:function(){return i.H},ME:function(){return r.sendEmailChallenge},dv:function(){return r.sendPhoneChallenge},gQ:function(){return r.updatePassword},ck:function(){return r.updateProfile},T8:function(){return r.verifyEmailChallenge},Lo:function(){return r.verifyPhoneChallenge}});var r=n(9108),o=n(1578),i=n(6794);function a(e,t,n){var r=(0,o.K)(e,t,n);return(0,i.H)(r)}var s=n(8008)},6794:function(e,t,n){"use strict";n.d(t,{H:function(){return f}});var r=n(885),o=n(3144),i=n(5671),a=n(7326),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(9108);function f(e){return function(e){(0,s.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function p(){var e;(0,i.Z)(this,p);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=f.call.apply(f,[this].concat(n)),(0,c.Z)((0,a.Z)(e),"myaccount",void 0),e.myaccount=Object.entries(d).filter((function(e){return"default"!==(0,r.Z)(e,1)[0]})).reduce((function(t,n){var o=(0,r.Z)(n,2),i=o[0],s=o[1];return t[i]=s.bind(null,(0,a.Z)(e)),t}),{}),e}return(0,o.Z)(p)}(e)}},8008:function(e,t,n){"use strict";var r,o,i;n.d(t,{Fn:function(){return i},aw:function(){return r},qb:function(){return o}}),function(e){e.PRIMARY="PRIMARY",e.SECONDARY="SECONDARY"}(r||(r={})),function(e){e.VERIFIED="VERIFIED",e.UNVERIFIED="UNVERIFIED"}(o||(o={})),function(e){e.NOT_ENROLLED="NOT_ENROLLED",e.ACTIVE="ACTIVE"}(i||(i={}))},2427:function(e,t,n){"use strict";n.d(t,{M:function(){return _}});var r=n(5861),o=n(1002),i=n(5671),a=n(3144),s=n(4942),l=n(4687),u=n.n(l),c=n(3193),d=n(9123),f=n(2482),p=n(415),h=function(){function e(t){(0,i.Z)(this,e),(0,s.Z)(this,"localOffset",void 0),this.localOffset=parseInt(t||0)}return(0,a.Z)(e,[{key:"now",value:function(){return(Date.now()+this.localOffset)/1e3}}],[{key:"create",value:function(){return new e(0)}}]),e}(),m=n(7088),v=n(6488),g=n(1971);function y(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?y(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):y(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var w={autoRenew:!0,autoRemove:!0,syncStorage:!0,clearPendingRemoveTokens:!0,storage:void 0,expireEarlySeconds:30,storageKey:g.TOKEN_STORAGE_NAME},_=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if((0,i.Z)(this,e),(0,s.Z)(this,"sdk",void 0),(0,s.Z)(this,"clock",void 0),(0,s.Z)(this,"emitter",void 0),(0,s.Z)(this,"storage",void 0),(0,s.Z)(this,"state",void 0),(0,s.Z)(this,"options",void 0),this.sdk=t,this.emitter=t.emitter,!this.emitter)throw new d.Z("Emitter should be initialized before TokenManager");n=Object.assign({},w,(0,c.YY)(n)),(0,p.isLocalhost)()||(n.expireEarlySeconds=w.expireEarlySeconds),this.options=n;var r=(0,c.YY)({storageKey:n.storageKey,secure:n.secure});"object"===(0,o.Z)(n.storage)?r.storageProvider=n.storage:n.storage&&(r.storageType=n.storage),this.storage=t.storageManager.getTokenStorage(b(b({},r),{},{useSeparateCookies:!0})),this.clock=h.create(),this.state={expireTimeouts:{},renewPromise:null}}var t,n,l;return(0,a.Z)(e,[{key:"on",value:function(e,t,n){n?this.emitter.on(e,t,n):this.emitter.on(e,t)}},{key:"off",value:function(e,t){t?this.emitter.off(e,t):this.emitter.off(e)}},{key:"start",value:function(){this.options.clearPendingRemoveTokens&&this.clearPendingRemoveTokens(),this.setExpireEventTimeoutAll(),this.state.started=!0}},{key:"stop",value:function(){this.clearExpireEventTimeoutAll(),this.state.started=!1}},{key:"isStarted",value:function(){return!!this.state.started}},{key:"getOptions",value:function(){return(0,c.d9)(this.options)}},{key:"getExpireTime",value:function(e){var t=this.options.expireEarlySeconds||0;return e.expiresAt-t}},{key:"hasExpired",value:function(e){return this.getExpireTime(e)<=this.clock.now()}},{key:"emitExpired",value:function(e,t){this.emitter.emit(m.$Y,e,t)}},{key:"emitRenewed",value:function(e,t,n){this.emitter.emit(m.E,e,t,n)}},{key:"emitAdded",value:function(e,t){this.emitter.emit(m.O3,e,t)}},{key:"emitRemoved",value:function(e,t){this.emitter.emit(m.FT,e,t)}},{key:"emitError",value:function(e){this.emitter.emit(m.$I,e)}},{key:"clearExpireEventTimeout",value:function(e){clearTimeout(this.state.expireTimeouts[e]),delete this.state.expireTimeouts[e],this.state.renewPromise=null}},{key:"clearExpireEventTimeoutAll",value:function(){var e=this.state.expireTimeouts;for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&this.clearExpireEventTimeout(t)}},{key:"setExpireEventTimeout",value:function(e,t){var n=this;if(!(0,v.z9)(t)){var r=this.getExpireTime(t),o=1e3*Math.max(r-this.clock.now(),0);this.clearExpireEventTimeout(e);var i=setTimeout((function(){n.emitExpired(e,t)}),o);this.state.expireTimeouts[e]=i}}},{key:"setExpireEventTimeoutAll",value:function(){var e=this.storage.getStorage();for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var n=e[t];this.setExpireEventTimeout(t,n)}}},{key:"resetExpireEventTimeoutAll",value:function(){this.clearExpireEventTimeoutAll(),this.setExpireEventTimeoutAll()}},{key:"add",value:function(e,t){var n=this.storage.getStorage();(0,f.R)(t),n[e]=t,this.storage.setStorage(n),this.emitSetStorageEvent(),this.emitAdded(e,t),this.setExpireEventTimeout(e,t)}},{key:"getSync",value:function(e){return this.storage.getStorage()[e]}},{key:"get",value:(l=(0,r.Z)(u().mark((function e(t){return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getSync(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return l.apply(this,arguments)})},{key:"getTokensSync",value:function(){var e={},t=this.storage.getStorage();return Object.keys(t).forEach((function(n){var r=t[n];(0,v.hv)(r)?e.accessToken=r:(0,v.sI)(r)?e.idToken=r:(0,v.z9)(r)&&(e.refreshToken=r)})),e}},{key:"getTokens",value:(n=(0,r.Z)(u().mark((function e(){return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getTokensSync());case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"getStorageKeyByType",value:function(e){var t=this.storage.getStorage();return Object.keys(t).filter((function(n){var r=t[n];return(0,v.hv)(r)&&"accessToken"===e||(0,v.sI)(r)&&"idToken"===e||(0,v.z9)(r)&&"refreshToken"===e}))[0]}},{key:"getTokenType",value:function(e){if((0,v.hv)(e))return"accessToken";if((0,v.sI)(e))return"idToken";if((0,v.z9)(e))return"refreshToken";throw new d.Z("Unknown token type")}},{key:"emitSetStorageEvent",value:function(){if((0,p.isIE11OrLess)()){var e=this.storage.getStorage();this.emitter.emit(m.zr,e)}}},{key:"getStorage",value:function(){return this.storage}},{key:"setTokens",value:function(e,t,n,r){var o=this,i=function(e,i){var a=o.getTokenType(i);"accessToken"===a?t&&t(e,i):"idToken"===a?n&&n(e,i):"refreshToken"===a&&r&&r(e,i)},a=function(e,t){o.emitAdded(e,t),o.setExpireEventTimeout(e,t),i(e,t)},s=function(e,t){o.clearExpireEventTimeout(e),o.emitRemoved(e,t),i(e,t)},l=["idToken","accessToken","refreshToken"],u=this.getTokensSync();l.forEach((function(t){var n=e[t];n&&(0,f.R)(n,t)}));var c=l.reduce((function(t,n){var r=e[n];return r&&(t[o.getStorageKeyByType(n)||n]=r),t}),{});this.storage.setStorage(c),this.emitSetStorageEvent(),l.forEach((function(t){var n,r,l,c=e[t],d=u[t],f=o.getStorageKeyByType(t)||t;c&&d?(s(f,d),a(f,c),n=f,r=c,l=d,o.emitRenewed(n,r,l),o.clearExpireEventTimeout(n),o.setExpireEventTimeout(n,r),i(n,r)):c?a(f,c):d&&s(f,d)}))}},{key:"remove",value:function(e){this.clearExpireEventTimeout(e);var t=this.storage.getStorage(),n=t[e];delete t[e],this.storage.setStorage(t),this.emitSetStorageEvent(),this.emitRemoved(e,n)}},{key:"renewToken",value:(t=(0,r.Z)(u().mark((function e(t){var n;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",null===(n=this.sdk.token)||void 0===n?void 0:n.renew(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"validateToken",value:function(e){return(0,f.R)(e)}},{key:"renew",value:function(e){var t=this;if(this.state.renewPromise)return this.state.renewPromise;try{var n=this.getSync(e),r=void 0!==n;if(!n&&"accessToken"===e){var o=this.getStorageKeyByType("refreshToken");r=void 0!==this.getSync(o)}if(!r)throw new d.Z("The tokenManager has no token for the key: "+e)}catch(e){return this.emitError(e),Promise.reject(e)}return this.clearExpireEventTimeout(e),this.state.renewPromise=this.sdk.token.renewTokens().then((function(r){if(t.setTokens(r),!n&&"accessToken"===e){var o=r.accessToken;return t.emitRenewed(e,o,null),o}return r[t.getTokenType(n)]})).catch((function(n){throw t.remove(e),n.tokenKey=e,t.emitError(n),n})).finally((function(){t.state.renewPromise=null}))}},{key:"clear",value:function(){var e=this,t=this.getTokensSync();this.clearExpireEventTimeoutAll(),this.storage.clearStorage(),this.emitSetStorageEvent(),Object.keys(t).forEach((function(n){e.emitRemoved(n,t[n])}))}},{key:"clearPendingRemoveTokens",value:function(){var e=this,t=this.storage.getStorage(),n={};Object.keys(t).forEach((function(e){t[e].pendingRemove&&(n[e]=t[e],delete t[e])})),this.storage.setStorage(t),this.emitSetStorageEvent(),Object.keys(n).forEach((function(t){e.clearExpireEventTimeout(t),e.emitRemoved(t,n[t])}))}},{key:"updateRefreshToken",value:function(e){var t=this.getStorageKeyByType("refreshToken")||g.REFRESH_TOKEN_STORAGE_KEY,n=this.storage.getStorage();(0,f.R)(e),n[t]=e,this.storage.setStorage(n),this.emitSetStorageEvent()}},{key:"removeRefreshToken",value:function(){var e=this.getStorageKeyByType("refreshToken")||g.REFRESH_TOKEN_STORAGE_KEY;this.remove(e)}},{key:"addPendingRemoveFlags",value:function(){var e=this.getTokensSync();Object.keys(e).forEach((function(t){e[t].pendingRemove=!0})),this.setTokens(e)}}]),e}()},1646:function(e,t,n){"use strict";n.d(t,{P:function(){return u}});var r=n(5671),o=n(3144),i=n(4942),a=n(4319),s=n(146),l=18e5;function u(){return function(){function e(t){(0,r.Z)(this,e),(0,i.Z)(this,"options",void 0),(0,i.Z)(this,"storageManager",void 0),(0,i.Z)(this,"enableSharedStorage",void 0),(0,i.Z)(this,"saveLastResponse",void 0),this.storageManager=t.storageManager,this.enableSharedStorage=!1!==t.enableSharedStorage,this.saveLastResponse=!1!==t.saveLastResponse,this.options=t}return(0,o.Z)(e,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage(),n=t.getStorage();if(t.clearStorage(),this.enableSharedStorage&&!1!==e.clearSharedStorage){var r=e.state||(null==n?void 0:n.state);r&&function(e,t){var n=e.getSharedTansactionStorage(),r=n.getStorage();delete r[t],n.setStorage(r)}(this.storageManager,r)}}},{key:"save",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this.storageManager.getTransactionStorage(),r=n.getStorage();(0,a.mH)(r)&&!t.muteWarning&&(0,s.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."),n.setStorage(e),this.enableSharedStorage&&e.state&&function(e,t,n){var r=e.getSharedTansactionStorage(),o=r.getStorage();o[t]={dateCreated:Date.now(),transaction:n},r.setStorage(o)}(this.storageManager,e.state,e)}},{key:"exists",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{return!!this.load(e)}catch(e){return!1}}},{key:"load",value:function(){var e,t,n,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.enableSharedStorage&&r.state&&(t=this.storageManager.getSharedTansactionStorage(),n=t.getStorage(),Object.keys(n).forEach((function(e){var t=n[e];Date.now()-t.dateCreated>l&&delete n[e]})),t.setStorage(n),e=function(e,t){var n=e.getSharedTansactionStorage().getStorage()[t];return n&&n.transaction&&(0,a.mH)(n.transaction)?n.transaction:null}(this.storageManager,r.state),(0,a.mH)(e))?e:(e=this.storageManager.getTransactionStorage().getStorage(),(0,a.mH)(e)?e:null)}}]),e}()}},1237:function(e,t,n){"use strict";n.d(t,{T:function(){return i}});var r=n(9123),o=n(7987);function i(e){var t,n=e.split(".");try{t={header:JSON.parse((0,o.Wy)(n[0])),payload:JSON.parse((0,o.Wy)(n[1])),signature:n[2]}}catch(e){throw new r.Z("Malformed token")}return t}},7659:function(e,t,n){"use strict";n.d(t,{SO:function(){return p},V7:function(){return P},aW:function(){return j},ao:function(){return N},cE:function(){return L},lk:function(){return E},sd:function(){return S},vX:function(){return R}});var r=n(2982),o=n(5861),i=n(4687),a=n.n(i),s=n(7987),l=n(7594),u=n(5728),c=n(9123),d="OktaAuthJs",f="DPoPKeys";function p(e){return((0,u.isOAuthError)(e)||(0,u.isWWWAuthError)(e))&&"use_dpop_nonce"===e.errorCode}function h(e,t,n){return m.apply(this,arguments)}function m(){return(m=(0,o.Z)(a().mark((function e(t,n,r){var o,i,u;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(0,s.NL)(JSON.stringify(t)),i=(0,s.NL)(JSON.stringify(n)),e.next=4,l.KP.subtle.sign({name:r.algorithm.name},r,(0,s.k8)("".concat(o,".").concat(i)));case 4:return u=e.sent,e.abrupt("return","".concat(o,".").concat(i,".").concat((0,s.aR)((0,s.kQ)(u))));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function v(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:32;return(0,r.Z)(l.KP.getRandomValues(new Uint8Array(e))).map((function(e){return e.toString(16)})).join("")}function g(){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(){var t;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t={name:"RSASSA-PKCS1-v1_5",hash:"SHA-256",modulusLength:2048,publicExponent:new Uint8Array([1,0,1])},e.abrupt("return",l.KP.subtle.generateKey(t,!1,["sign","verify"]));case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e){return w.apply(this,arguments)}function w(){return(w=(0,o.Z)(a().mark((function e(t){var n,r;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=(new TextEncoder).encode(t),e.next=3,l.KP.subtle.digest("SHA-256",n);case 3:return r=e.sent,e.abrupt("return",(0,l.r3)(String.fromCharCode.apply(null,new Uint8Array(r))).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""));case 5:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function _(e){return O.apply(this,arguments)}function O(){return O=(0,o.Z)(a().mark((function e(t){var n,r,o,i,s=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(n=s.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=s[o];return e.next=3,new Promise((function(e,t){try{var n=window.indexedDB.open(d,1);n.onerror=function(){t(n.error)},n.onupgradeneeded=function(){n.result.createObjectStore(f)},n.onsuccess=function(){var r=n.result,o=r.transaction(f,"readwrite");o.onerror=function(){t(o.error)};var i=o.objectStore(f);e(i),o.oncomplete=function(){r.close()}}}catch(e){t(e)}}));case 3:return i=e.sent,e.abrupt("return",new Promise((function(e,n){var o=i[t].apply(i,r);o.onsuccess=function(){e(o)},o.onerror=function(){n(o.error)}})));case 5:case"end":return e.stop()}}),e)}))),O.apply(this,arguments)}function k(e,t){return x.apply(this,arguments)}function x(){return(x=(0,o.Z)(a().mark((function e(t,n){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,_("add",n,t);case 2:return e.abrupt("return",n);case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function E(e){return T.apply(this,arguments)}function T(){return(T=(0,o.Z)(a().mark((function e(t){var n;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!t){e.next=6;break}return e.next=3,_("get",t);case 3:if(!(n=e.sent).result){e.next=6;break}return e.abrupt("return",n.result);case 6:throw new c.Z("Unable to locate dpop key pair required for refresh".concat(t?" (".concat(t,")"):""));case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function S(e){return A.apply(this,arguments)}function A(){return(A=(0,o.Z)(a().mark((function e(t){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,_("delete",t);case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function P(){return C.apply(this,arguments)}function C(){return(C=(0,o.Z)(a().mark((function e(){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,_("clear");case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function R(){return I.apply(this,arguments)}function I(){return(I=(0,o.Z)(a().mark((function e(){var t,n;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=v(4),e.next=3,g();case 3:return n=e.sent,e.next=6,k(t,n);case 6:return e.abrupt("return",{keyPair:n,keyPairId:t});case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function N(e,t){return M.apply(this,arguments)}function M(){return(M=(0,o.Z)(a().mark((function e(t,n){var r,o,i,s,l;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=!1,i=n.accessToken,s=n.refreshToken,"access"===t&&i&&"DPoP"===i.tokenType&&!s&&(o=!0),"refresh"===t&&s&&!i&&(o=!0),l=null!==(r=null==i?void 0:i.dpopPairId)&&void 0!==r?r:null==s?void 0:s.dpopPairId,!o||!l){e.next=8;break}return e.next=8,S(l);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function j(e){return D.apply(this,arguments)}function D(){return(D=(0,o.Z)(a().mark((function e(t){var n,r,o,i,s,u,c,d,f,p,m,g,y,w;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.keyPair,r=t.url,o=t.method,i=t.nonce,s=t.accessToken,e.next=3,l.KP.subtle.exportKey("jwk",n.publicKey);case 3:if(u=e.sent,c=u.kty,d=u.crv,f=u.e,p=u.n,m=u.x,g=u.y,y={alg:"RS256",typ:"dpop+jwt",jwk:{kty:c,crv:d,e:f,n:p,x:m,y:g}},w={htm:o,htu:r,iat:Math.floor(Date.now()/1e3),jti:v()},i&&(w.nonce=i),!s){e.next=17;break}return e.next=16,b(s);case 16:w.ath=e.sent;case 17:return e.abrupt("return",h(y,w,n.privateKey));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function L(e){return U.apply(this,arguments)}function U(){return(U=(0,o.Z)(a().mark((function e(t){var n,r,o,i,s;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.keyPair,r=t.url,o=t.method,i=t.nonce,s={keyPair:n,url:r,method:o},i&&(s.nonce=i),e.abrupt("return",j(s));case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2206:function(e,t,n){"use strict";n.d(t,{R:function(){return d},_:function(){return c}});var r=n(4942),o=n(4771),i=n(3193),a=n(6718),s=n(9123);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function c(e){if(!e.clientId)throw new s.Z("A clientId must be specified in the OktaAuth constructor to get a token");if((0,o.HD)(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new s.Z("Multiple OAuth responseTypes must be defined as an array");var t={client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state,acr_values:e.acrValues,enroll_amr_values:e.enrollAmrValues};if(t=(0,i.YY)(t),["idp_scope","response_type","enroll_amr_values"].forEach((function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))})),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new s.Z("openid scope must be specified in the scopes argument when requesting an id_token");return e.scopes&&(t.scope=e.scopes.join(" ")),t}function d(e){var t=c(e);return(0,a.UK)(u(u({},t),e.extraParams&&u({},e.extraParams)))}},2642:function(e,t,n){"use strict";n.d(t,{Dp:function(){return o.D},ES:function(){return i.E},R0:function(){return r.R},_6:function(){return r._},km:function(){return i.k},ti:function(){return o.t}});var r=n(2206),o=n(9231),i=n(52)},9231:function(e,t,n){"use strict";n.d(t,{D:function(){return b},t:function(){return g}});var r=n(885),o=n(5861),i=n(4687),a=n.n(i),s=n(9123),l=n(3983),u=n(3193),c=n(6718),d=n(5385),f=n(7659);function p(e){if(!e.clientId)throw new s.Z("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new s.Z("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode&&!e.interactionCode)throw new s.Z("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new s.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token')}function h(e,t){var n=(0,u.YY)({client_id:t.clientId,redirect_uri:t.redirectUri,grant_type:t.interactionCode?"interaction_code":"authorization_code",code_verifier:t.codeVerifier});t.interactionCode?n.interaction_code=t.interactionCode:t.authorizationCode&&(n.code=t.authorizationCode);var r=e.options.clientSecret;return r&&(n.client_secret=r),(0,c.UK)(n).slice(1)}function m(e,t){return v.apply(this,arguments)}function v(){return(v=(0,o.Z)(a().mark((function e(t,n){var r,o,i,u,c,p,h,v,g,y,b;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.url,o=n.data,i=n.nonce,u=n.dpopKeyPair,c="POST",p={"Content-Type":"application/x-www-form-urlencoded"},!t.options.dpop){e.next=10;break}if(u){e.next=6;break}throw new s.Z("DPoP is configured but no key pair was provided");case 6:return e.next=8,(0,f.cE)({url:r,method:c,nonce:i,keyPair:u});case 8:h=e.sent,p.DPoP=h;case 10:return e.prev=10,e.next=13,(0,d.c3)(t,{url:r,method:c,args:o,headers:p});case 13:return v=e.sent,e.abrupt("return",v);case 17:if(e.prev=17,e.t0=e.catch(10),!(0,f.SO)(e.t0)||i){e.next=24;break}if(y=null===(g=e.t0.resp)||void 0===g?void 0:g.headers["dpop-nonce"]){e.next=23;break}throw new l.Z({errorSummary:"No `dpop-nonce` header found when required"},null!==(b=e.t0.resp)&&void 0!==b?b:void 0);case 23:return e.abrupt("return",m(t,{url:r,data:o,dpopKeyPair:u,nonce:y}));case 24:throw e.t0;case 25:case"end":return e.stop()}}),e,null,[[10,17]])})))).apply(this,arguments)}function g(e,t,n){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n,r){var o,i;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return p(n),o=h(t,n),i={url:r.tokenUrl,data:o,dpopKeyPair:null==n?void 0:n.dpopKeyPair},e.abrupt("return",m(t,i));case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e,t,n){return w.apply(this,arguments)}function w(){return(w=(0,o.Z)(a().mark((function e(t,n,o){var i,s,l;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return i=Object.entries({client_id:n.clientId,grant_type:"refresh_token",scope:o.scopes.join(" "),refresh_token:o.refreshToken}).map((function(e){var t=(0,r.Z)(e,2),n=t[0],o=t[1];return n+"="+encodeURIComponent(o)})).join("&"),s=o.tokenUrl,n.extraParams&&Object.keys(n.extraParams).length>=1&&(s+=(0,c.UK)(n.extraParams)),l={url:s,data:i,dpopKeyPair:null==n?void 0:n.dpopKeyPair},e.abrupt("return",m(t,l));case 5:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},52:function(e,t,n){"use strict";n.d(t,{E:function(){return a},k:function(){return s}});var r=n(5385),o=n(3193),i=n(9123);function a(e,t){var n=t||e.options.issuer;return(0,r.U2)(e,n+"/.well-known/openid-configuration",{cacheResponse:!0})}function s(e,t,n){var s=e.storageManager.getHttpCache(e.options.cookies);return a(e,t).then((function(t){var a=t.jwks_uri,l=s.getStorage()[a];if(l&&Date.now()/1e3<l.expiresAt){var u=(0,o.sE)(l.response.keys,{kid:n});if(u)return u}return s.clearStorage(a),(0,r.U2)(e,a,{cacheResponse:!0}).then((function(e){var t=(0,o.sE)(e.keys,{kid:n});if(t)return t;throw new i.Z("The key id, "+n+", was not found in the server's keys")}))}))}},8707:function(e,t,n){"use strict";n.d(t,{r:function(){return f}});var r=n(5861),o=n(4687),i=n.n(o),a=n(7599),s=n(7756),l=n(3193),u=n(9231),c=n(8676),d=n(7659);function f(e,t,n){return p.apply(this,arguments)}function p(){return(p=(0,r.Z)(i().mark((function e(t,n,r){var o,f,p,h,m,v,g,y,b,w,_,O,k,x,E,T,S,A,P,C,R,I;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=r||(0,a.Fc)(t,n),n=Object.assign({},(0,s.D)(t),(0,l.d9)(n)),f=(o=n).authorizationCode,p=o.interactionCode,h=o.codeVerifier,m=o.clientId,v=o.redirectUri,g=o.scopes,y=o.ignoreSignature,b=o.state,w=o.acrValues,_=o.dpop,O=o.dpopPairId,k=o.extraParams,x={clientId:m,redirectUri:v,authorizationCode:f,interactionCode:p,codeVerifier:h,dpop:_},E=["token"],-1!==g.indexOf("openid")&&E.push("id_token"),T={clientId:m,redirectUri:v,scopes:g,responseType:E,ignoreSignature:y,acrValues:w,extraParams:k},e.prev=7,!_){e.next=26;break}if(!O){e.next=18;break}return e.next=12,(0,d.lk)(O);case 12:S=e.sent,x.dpopKeyPair=S,T.dpop=_,T.dpopPairId=O,e.next=26;break;case 18:return e.next=20,(0,d.vX)();case 20:A=e.sent,P=A.keyPair,C=A.keyPairId,x.dpopKeyPair=P,T.dpop=_,T.dpopPairId=C;case 26:return e.next=28,(0,u.t)(t,x,r);case 28:return R=e.sent,e.next=31,(0,c.s)(t,T,R,r);case 31:return(I=e.sent).code=f,I.state=b,e.abrupt("return",I);case 35:return e.prev=35,t.transactionManager.clear(),e.finish(35);case 38:case"end":return e.stop()}}),e,null,[[7,,35,38]])})))).apply(this,arguments)}},5324:function(e,t,n){"use strict";n.d(t,{$:function(){return E},o:function(){return x}});var r=n(3548),o=n(1237),i=n(8707),a=n(6844),s=n(7625),l=n(9770),u=n(6803),c=n(5372),d=n(2476),f=n(6268),p=n(781),h=n(6466),m=n(8113),v=n(6898),g=n(8221),y=n(1260),b=n(3193),w=n(6757),_=n(8080),O=n(2206);function k(e,t){t=(0,b.d9)(t)||{};var n=(0,w.U)(e,t),r=(0,_.A)(e,n),o=r.urls.authorizeUrl+(0,O.R)(n);e.transactionManager.save(r),e.options.setLocation?e.options.setLocation(o):window.location.assign(o)}function x(e,t){var n=function(e){return r.b.prototype.push.bind(t,e,null)},b=n(u.H.bind(null,e)),w=n(c.ko.bind(null,e)),_=Object.assign(w,{_getHistory:function(){return window.history},_getLocation:function(){return window.location},_getDocument:function(){return window.document}}),O={prepareTokenParams:v.wu.bind(null,e),exchangeCodeForTokens:i.r.bind(null,e),getWithoutPrompt:s.y.bind(null,e),getWithPopup:l.d.bind(null,e),getWithIDPPopup:l.y.bind(null,e),getWithRedirect:b,parseFromUrl:_,decode:o.T,revoke:h.P.bind(null,e),renew:d.$.bind(null,e),renewTokensWithRefresh:p.R.bind(null,e),renewTokens:f.I.bind(null,e),getUserInfo:function(t,n){return(0,a.b)(e,t,n)},verify:y.W.bind(null,e),isLoginRedirect:g.gM.bind(null,e),introspect:m.j.bind(null,e)};return["getWithoutPrompt","getWithPopup","revoke","renew","renewTokensWithRefresh","renewTokens"].forEach((function(e){O[e]=n(O[e])})),O}function E(e){return{authorize:{enrollAuthenticator:k.bind(null,e)}}}},231:function(e,t,n){"use strict";n.d(t,{$V:function(){return r.$},zr:function(){return u},o5:function(){return r.o}});var r=n(5324),o=n(9893),i=n(265),a=n(3980),s=n(279),l=n(2724);function u(e,t,n){var r=(0,o.a)(t),u=(0,i.H)(r,e),c=(0,s.A)(u),d=(0,a.Z)(c);return(0,l.J)(d,n)}},3253:function(e,t,n){"use strict";n.d(t,{L:function(){return u}});var r=n(7599),o=n(4970),i=n(9123),a=n(6898),s=n(2206),l=n(8676);function u(e,t){if(arguments.length>2)return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));var n=(t=t||{}).popupWindow;return t.popupWindow=void 0,(0,a.wu)(e,t).then((function(a){var u,c;switch(t.sessionToken?Object.assign(a,{prompt:"none",responseMode:"okta_post_message",display:null}):t.idp&&Object.assign(a,{display:"popup"}),c=(0,r.Fc)(e,a),u=(t.codeVerifier?c.tokenUrl:c.authorizeUrl)+(0,s.R)(a),a.sessionToken||null===a.display?"IFRAME":"popup"===a.display?t.idpPopup?"IDP_POPUP":"POPUP":"IMPLICIT"){case"IFRAME":var d=(0,o.iC)(e,t.timeout,a.state),f=(0,o.Rl)(u);return d.then((function(t){return(0,l.s)(e,a,t,c)})).finally((function(){var e;document.body.contains(f)&&(null===(e=f.parentElement)||void 0===e||e.removeChild(f))}));case"POPUP":var p;if("okta_post_message"===a.responseMode){if(!e.features.isPopupPostMessageSupported())throw new i.Z("This browser doesn't have full postMessage support");p=(0,o.iC)(e,t.timeout,a.state)}return n&&n.location.assign(u),new Promise((function(e,t){var r=setInterval((function(){n&&!n.closed||(clearInterval(r),t(new i.Z("Unable to parse OAuth flow response")))}),100);p.then((function(t){clearInterval(r),e(t)})).catch((function(e){clearInterval(r),t(e)}))})).then((function(t){return(0,l.s)(e,a,t,c)})).finally((function(){n&&!n.closed&&n.close()}));case"IDP_POPUP":var h=(0,o.It)(e,t.timeout,t.channel,a.state);if(!n)throw new i.Z("Unable to open popup window");return n.location.assign(u),h.then((function(t){return(0,l.s)(e,a,t,c)}));default:throw new i.Z("The full page redirect flow is not supported")}}))}},6844:function(e,t,n){"use strict";n.d(t,{b:function(){return m}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(9123),l=n(3114),u=n(2886),c=n(3983),d=n(5385),f=n(6488);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function m(e,t,n){return v.apply(this,arguments)}function v(){return(v=(0,o.Z)(a().mark((function e(t,n,r){var o,i;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n){e.next=4;break}return e.next=3,t.tokenManager.getTokens();case 3:n=e.sent.accessToken;case 4:if(r){e.next=8;break}return e.next=7,t.tokenManager.getTokens();case 7:r=e.sent.idToken;case 8:if(n&&(0,f.hv)(n)){e.next=10;break}return e.abrupt("return",Promise.reject(new s.Z("getUserInfo requires an access token object")));case 10:if(r&&(0,f.sI)(r)){e.next=12;break}return e.abrupt("return",Promise.reject(new s.Z("getUserInfo requires an ID token object")));case 12:if(o={url:n.userinfoUrl,method:"GET",accessToken:n.accessToken},!t.options.dpop){e.next=19;break}return e.next=16,t.getDPoPAuthorizationHeaders(h(h({},o),{},{accessToken:n}));case 16:i=e.sent,o.headers=i,delete o.accessToken;case 19:return e.abrupt("return",(0,d.c3)(t,o).then((function(e){return e.sub===r.claims.sub?e:Promise.reject(new s.Z("getUserInfo request was rejected due to token mismatch"))})).catch((function(e){if(e instanceof l.Z&&!t.options.dpop){var n=e.error,r=e.errorDescription;throw new u.Z(n,r)}if(!t.options.dpop){var o,i=e;if(e instanceof c.Z&&null!=e&&null!==(o=e.meta)&&void 0!==o&&o.wwwAuthHeader&&(i=l.Z.parseHeader(e.meta.wwwAuthHeader)),i instanceof l.Z){var a=i,s=a.error,d=a.errorDescription;throw new u.Z(s,d)}}throw e})));case 20:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9770:function(e,t,n){"use strict";n.d(t,{d:function(){return c},y:function(){return d}});var r=n(4925),o=n(9123),i=n(3193),a=n(3253),s=n(4970),l=n(7599),u=["initialPath"];function c(e,t){if(arguments.length>2)return Promise.reject(new o.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));var n=t,l=n.initialPath,c=(0,r.Z)(n,u),d=(0,s.pU)(null!=l?l:"/",c);return t=(0,i.d9)(c)||{},Object.assign(c,{display:"popup",responseMode:"okta_post_message",popupWindow:d}),(0,a.L)(e,c)}function d(e,t){try{if(!BroadcastChannel)throw new o.Z("Modern browser with `BroadcastChannel` support is required to use this method");if(!t.redirectUri)throw new o.Z("`redirectUri` is a required param for `getWithIDPPopup`");t.state||(t.state=(0,l.aV)());var n,r=(0,s.pU)("/",t),u=new BroadcastChannel("popup-callback:".concat(t.state));return t=(0,i.d9)(t)||{},Object.assign(t,{display:"popup",responseMode:"query",popupWindow:r,idpPopup:!0,channel:u}),{promise:new Promise((function(r,o){return n=o,(0,a.L)(e,t).then((function(e){return r(e)})).catch((function(e){return o(e)}))})),cancel:function(){u.close(),n(new o.Z("Popup flow canceled"))}}}catch(e){return{promise:Promise.reject(e),cancel:function(){}}}}},6803:function(e,t,n){"use strict";n.d(t,{H:function(){return d}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(3193),l=n(6898),u=n(2865),c=n(2206);function d(e,t){return f.apply(this,arguments)}function f(){return f=(0,r.Z)(i().mark((function e(t,n){var r,o,d,f=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(f.length>2)){e.next=2;break}return e.abrupt("return",Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));case 2:return n=(0,s.d9)(n)||{},e.next=5,(0,l.wu)(t,n);case 5:r=e.sent,o=(0,u.H)(t,r),d=o.urls.authorizeUrl+(0,c.R)(r),t.transactionManager.save(o),t.options.setLocation?t.options.setLocation(d):window.location.assign(d);case 10:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},7625:function(e,t,n){"use strict";n.d(t,{y:function(){return a}});var r=n(9123),o=n(3193),i=n(3253);function a(e,t){return arguments.length>2?Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=(0,o.d9)(t)||{},Object.assign(t,{prompt:"none",responseMode:"okta_post_message",display:null}),(0,i.L)(e,t))}},8676:function(e,t,n){"use strict";n.d(t,{s:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(3193),s=n(7599),l=n(2886),u=n(9123),c=n(1260),d=n(7756);function f(e,t){if(e.error&&e.error_description)throw new l.Z(e.error,e.error_description);if(e.state!==t.state)throw new u.Z("OAuth flow response state doesn't match request state")}function p(e,t,n,r){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n,r,o){var l,p,h,m,v,g,y,b,w,_,O,k,x,E,T,S;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!1===t.options.pkce||!r.code&&!r.interaction_code){e.next=3;break}return e.abrupt("return",t.token.exchangeCodeForTokens(Object.assign({},n,{authorizationCode:r.code,interactionCode:r.interaction_code}),o));case 3:if(n=n||(0,d.D)(t),o=o||(0,s.Fc)(t,n),l=n.responseType||[],Array.isArray(l)||"none"===l||(l=[l]),p=r.scope?r.scope.split(" "):(0,a.d9)(n.scopes),h=n.clientId||t.options.clientId,f(r,n),!n.dpop){e.next=14;break}if((null!==(m=null===(v=t.options)||void 0===v?void 0:v.dpopOptions)&&void 0!==m?m:{allowBearerTokens:!1}).allowBearerTokens||"DPoP"===r.token_type){e.next=14;break}throw new u.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');case 14:if(g={},y=r.expires_in,b=r.token_type,w=r.access_token,_=r.id_token,O=r.refresh_token,k=Math.floor(Date.now()/1e3),w&&(x=t.token.decode(w),g.accessToken={accessToken:w,claims:x.payload,expiresAt:Number(y)+k,tokenType:b,scopes:p,authorizeUrl:o.authorizeUrl,userinfoUrl:o.userinfoUrl},n.dpopPairId&&(g.accessToken.dpopPairId=n.dpopPairId),n.extraParams&&(g.accessToken.extraParams=n.extraParams)),O&&(g.refreshToken={refreshToken:O,expiresAt:Number(y)+k,scopes:p,tokenUrl:o.tokenUrl,authorizeUrl:o.authorizeUrl,issuer:o.issuer},n.dpopPairId&&(g.refreshToken.dpopPairId=n.dpopPairId),n.extraParams&&(g.refreshToken.extraParams=n.extraParams)),!_){e.next=32;break}return E=t.token.decode(_),T={idToken:_,claims:E.payload,expiresAt:E.payload.exp-E.payload.iat+k,scopes:p,authorizeUrl:o.authorizeUrl,issuer:o.issuer,clientId:h},n.extraParams&&(T.extraParams=n.extraParams),S={clientId:h,issuer:o.issuer,nonce:n.nonce,accessToken:w,acrValues:n.acrValues},void 0!==n.ignoreSignature&&(S.ignoreSignature=n.ignoreSignature),e.next=31,(0,c.W)(t,T,S);case 31:g.idToken=T;case 32:if(-1===l.indexOf("token")||g.accessToken){e.next=34;break}throw new u.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');case 34:if(-1===l.indexOf("id_token")||g.idToken){e.next=36;break}throw new u.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');case 36:return e.abrupt("return",{tokens:g,state:r.state,code:r.code,responseType:l});case 37:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9443:function(e,t,n){"use strict";n.r(t),n.d(t,{TokenManager:function(){return d.M},addIDPPopupLisenter:function(){return p.It},addListener:function(){return p.NH},addPostMessageListener:function(){return p.iC},assertPKCESupport:function(){return p.vz},buildAuthorizeParams:function(){return a.R0},convertTokenParamsToOAuthParams:function(){return a._6},createEndpoints:function(){return r.$V},createEnrollAuthenticatorMeta:function(){return p.AW},createOAuthMeta:function(){return p.H},createOAuthOptionsConstructor:function(){return s.m},createOAuthStorageManager:function(){return i.a},createOktaAuthOAuth:function(){return r.zr},createTokenAPI:function(){return r.o5},createTransactionManager:function(){return f.P},decodeToken:function(){return h.T},exchangeCodeForTokens:function(){return O.r},generateNonce:function(){return p.PY},generateState:function(){return p.aV},getDefaultEnrollAuthenticatorParams:function(){return p.cE},getDefaultTokenParams:function(){return p.Dx},getHashOrSearch:function(){return p.O2},getKey:function(){return a.km},getOAuthBaseUrl:function(){return p.zf},getOAuthDomain:function(){return p.Xp},getOAuthUrls:function(){return p.Fc},getToken:function(){return k.L},getUserInfo:function(){return w.b},getWellKnown:function(){return a.ES},getWithIDPPopup:function(){return E.y},getWithPopup:function(){return E.d},getWithRedirect:function(){return T.H},getWithoutPrompt:function(){return x.y},handleOAuthResponse:function(){return _.s},hasAuthorizationCode:function(){return p.ZP},hasErrorInUrl:function(){return p.hg},hasInteractionCode:function(){return p.d_},hasResponseType:function(){return p.wV},hasTokensInHash:function(){return p.kU},isAuthorizationCodeError:function(){return p.tC},isCodeFlow:function(){return p.Ik},isInteractionRequired:function(){return p.wc},isInteractionRequiredError:function(){return p.Cf},isLoginRedirect:function(){return p.gM},isRedirectUri:function(){return p.Qs},isRefreshTokenError:function(){return p.Yo},isRefreshTokenInvalidError:function(){return p.$E},isSameRefreshToken:function(){return p.q0},loadFrame:function(){return p.Rl},loadPopup:function(){return p.pU},mixinOAuth:function(){return o.J},oidcIntrospect:function(){return A.j},parseFromUrl:function(){return S.ko},pkce:function(){return p.U5},postRefreshToken:function(){return a.Dp},postToTokenEndpoint:function(){return a.ti},prepareEnrollAuthenticatorParams:function(){return p.Uc},preparePKCE:function(){return p.mi},prepareTokenParams:function(){return p.wu},removeListener:function(){return p.ys},renewToken:function(){return v.$},renewTokens:function(){return y.I},renewTokensWithRefresh:function(){return g.R},revokeToken:function(){return m.P},urlParamsToObject:function(){return p.vL},validateClaims:function(){return p.pj},validateCodeChallengeMethod:function(){return p.br},validateToken:function(){return p.Rp},verifyToken:function(){return b.W}});var r=n(231),o=n(2724),i=n(2333),a=n(2642),s=n(3775),l=n(8927),u={};for(var c in l)["default","decodeToken","revokeToken","renewToken","renewTokensWithRefresh","renewTokens","verifyToken","getUserInfo","handleOAuthResponse","exchangeCodeForTokens","getToken","getWithoutPrompt","getWithPopup","getWithIDPPopup","getWithRedirect","parseFromUrl","oidcIntrospect","createEndpoints","createOktaAuthOAuth","createTokenAPI","mixinOAuth","createOAuthStorageManager","buildAuthorizeParams","convertTokenParamsToOAuthParams","getKey","getWellKnown","postRefreshToken","postToTokenEndpoint","createOAuthOptionsConstructor"].indexOf(c)<0&&(u[c]=function(e){return l[e]}.bind(0,c));n.d(t,u);var d=n(2427),f=n(1646),p=n(8785),h=n(1237),m=n(6466),v=n(2476),g=n(781),y=n(6268),b=n(1260),w=n(6844),_=n(8676),O=n(8707),k=n(3253),x=n(7625),E=n(9770),T=n(6803),S=n(5372),A=n(8113)},8113:function(e,t,n){"use strict";n.d(t,{j:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(52),l=n(5385),u=n(6718),c=n(7594),d=n(6488),f={accessToken:"access_token",idToken:"id_token",refreshToken:"refresh_token"};function p(e,t,n){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n,r){var o,p,h,m,v,g,y,b,w,_;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(p=t.options.clientId,h=t.options.clientSecret,r||(r=t.tokenManager.getTokens()[n]),r){e.next=5;break}throw new a.Z("unable to find ".concat(n," in storage or fn params"));case 5:if(o=(o=n!==d.T6.ACCESS?null===(m=r)||void 0===m?void 0:m.issuer:null===(v=r)||void 0===v||null===(g=v.claims)||void 0===g?void 0:g.iss)||t.options.issuer,p){e.next=9;break}throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");case 9:if(o){e.next=11;break}throw new a.Z("Unable to find issuer");case 11:return e.next=13,(0,s.E)(t,o);case 13:return y=e.sent,b=y.introspection_endpoint,w=h?(0,c.r3)("".concat(p,":").concat(h)):(0,c.r3)(p),_=(0,u.UK)({token_type_hint:f[n],token:r[n]}).slice(1),e.abrupt("return",(0,l.v_)(t,b,_,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+w}}));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2724:function(e,t,n){"use strict";n.d(t,{J:function(){return I}});var r=n(4925),o=n(5861),i=n(5671),a=n(3144),s=n(7326),l=n(1752),u=n(136),c=n(2963),d=n(1120),f=n(4942),p=n(4687),h=n.n(p),m=n(5385),v=n(3548),g=n(4771),y=n(9718),b=n(3611),w=n(5324),_=n(2427),O=n(8221),k=n(7599),x=n(7659),E=n(9123),T=n(3114),S=n(1971),A=n(4858),P=["originalUri"];function C(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function R(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?C(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):C(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function I(e,t){var n,p=function(e){(0,u.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,d.Z)(t);if(n){var o=(0,d.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function o(){return(0,i.Z)(this,o),r.apply(this,arguments)}return(0,a.Z)(o,[{key:"setOriginalUri",value:function(e,t){A.Z.getSessionStorage().setItem(S.REFERRER_PATH_STORAGE_KEY,e),(t=t||this.options.state)&&this.storageManager.getOriginalUriStorage().setItem(t,e)}},{key:"getOriginalUri",value:function(e){if(e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage().getItem(e);if(t)return t}var n=A.Z.getSessionStorage();return n&&n.getItem(S.REFERRER_PATH_STORAGE_KEY)||void 0}},{key:"removeOriginalUri",value:function(e){if(A.Z.getSessionStorage().removeItem(S.REFERRER_PATH_STORAGE_KEY),e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage();t.removeItem&&t.removeItem(e)}}}]),o}(e);return n=function(e){(0,u.Z)(B,e);var n,p,y,S,A,C,I,N,M,j,D,L,U,F=(L=B,U=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,d.Z)(L);if(U){var n=(0,d.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,c.Z)(this,e)});function B(){var e;(0,i.Z)(this,B);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return e=F.call.apply(F,[this].concat(r)),(0,f.Z)((0,s.Z)(e),"token",void 0),(0,f.Z)((0,s.Z)(e),"tokenManager",void 0),(0,f.Z)((0,s.Z)(e),"transactionManager",void 0),(0,f.Z)((0,s.Z)(e),"pkce",void 0),(0,f.Z)((0,s.Z)(e),"endpoints",void 0),(0,f.Z)((0,s.Z)(e),"_pending",void 0),(0,f.Z)((0,s.Z)(e),"_tokenQueue",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.pkce={DEFAULT_CODE_CHALLENGE_METHOD:b.Z.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:b.Z.generateVerifier,computeChallenge:b.Z.computeChallenge},e._pending={handleLogin:!1},e._tokenQueue=new v.b,e.token=(0,w.o)((0,s.Z)(e),e._tokenQueue),e.tokenManager=new _.M((0,s.Z)(e),e.options.tokenManager),e.endpoints=(0,w.$)((0,s.Z)(e)),e}return(0,a.Z)(B,[{key:"clearStorage",value:function(){(0,l.Z)((0,d.Z)(B.prototype),"clearStorage",this).call(this),this.tokenManager.clear()}},{key:"isAuthenticated",value:(D=(0,o.Z)(h().mark((function e(){var t,n,r,o,i,a,s,l,u,c,d=arguments;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=d.length>0&&void 0!==d[0]?d[0]:{},n=this.tokenManager.getOptions(),r=n.autoRenew,o=n.autoRemove,i=t.onExpiredToken?"renew"===t.onExpiredToken:r,a=t.onExpiredToken?"remove"===t.onExpiredToken:o,s=this.tokenManager.getTokensSync(),!(l=s.accessToken)||!this.tokenManager.hasExpired(l)){e.next=19;break}if(l=void 0,!i){e.next=18;break}return e.prev=8,e.next=11,this.tokenManager.renew("accessToken");case 11:l=e.sent,e.next=16;break;case 14:e.prev=14,e.t0=e.catch(8);case 16:e.next=19;break;case 18:a&&this.tokenManager.remove("accessToken");case 19:if(u=this.tokenManager.getTokensSync(),!(c=u.idToken)||!this.tokenManager.hasExpired(c)){e.next=34;break}if(c=void 0,!i){e.next=33;break}return e.prev=23,e.next=26,this.tokenManager.renew("idToken");case 26:c=e.sent,e.next=31;break;case 29:e.prev=29,e.t1=e.catch(23);case 31:e.next=34;break;case 33:a&&this.tokenManager.remove("idToken");case 34:return e.abrupt("return",!(!l||!c));case 35:case"end":return e.stop()}}),e,this,[[8,14],[23,29]])}))),function(){return D.apply(this,arguments)})},{key:"signInWithRedirect",value:(j=(0,o.Z)(h().mark((function e(){var t,n,o,i,a=arguments;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=(t=a.length>0&&void 0!==a[0]?a[0]:{}).originalUri,o=(0,r.Z)(t,P),!this._pending.handleLogin){e.next=4;break}return e.abrupt("return");case 4:return this._pending.handleLogin=!0,e.prev=5,n&&this.setOriginalUri(n),i=Object.assign({scopes:this.options.scopes||["openid","email","profile"]},o),e.next=10,this.token.getWithRedirect(i);case 10:return e.prev=10,this._pending.handleLogin=!1,e.finish(10);case 13:case"end":return e.stop()}}),e,this,[[5,,10,13]])}))),function(){return j.apply(this,arguments)})},{key:"getUser",value:(M=(0,o.Z)(h().mark((function e(){var t,n,r;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=this.tokenManager.getTokensSync(),n=t.idToken,r=t.accessToken,e.abrupt("return",this.token.getUserInfo(r,n));case 2:case"end":return e.stop()}}),e,this)}))),function(){return M.apply(this,arguments)})},{key:"getIdToken",value:function(){var e=this.tokenManager.getTokensSync().idToken;return e?e.idToken:void 0}},{key:"getAccessToken",value:function(){var e=this.tokenManager.getTokensSync().accessToken;return e?e.accessToken:void 0}},{key:"getRefreshToken",value:function(){var e=this.tokenManager.getTokensSync().refreshToken;return e?e.refreshToken:void 0}},{key:"getOrRenewAccessToken",value:(N=(0,o.Z)(h().mark((function e(){var t,n,r,o,i;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this.tokenManager.getTokensSync(),!(n=t.accessToken)||this.tokenManager.hasExpired(n)){e.next=3;break}return e.abrupt("return",n.accessToken);case 3:return e.prev=3,o=this.tokenManager.getStorageKeyByType("accessToken"),e.next=7,this.tokenManager.renew(null!=o?o:"accessToken");case 7:return i=e.sent,e.abrupt("return",null!==(r=null==i?void 0:i.accessToken)&&void 0!==r?r:null);case 11:return e.prev=11,e.t0=e.catch(3),this.emitter.emit("error",e.t0),e.abrupt("return",null);case 15:case"end":return e.stop()}}),e,this,[[3,11]])}))),function(){return N.apply(this,arguments)})},{key:"storeTokensFromRedirect",value:(I=(0,o.Z)(h().mark((function e(){var t,n;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.token.parseFromUrl();case 2:t=e.sent,n=t.tokens,"none"!==t.responseType&&this.tokenManager.setTokens(n);case 6:case"end":return e.stop()}}),e,this)}))),function(){return I.apply(this,arguments)})},{key:"isLoginRedirect",value:function(){return(0,O.gM)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,O.wV)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}},{key:"invokeApiMethod",value:(C=(0,o.Z)(h().mark((function e(t){var n;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t.accessToken){e.next=5;break}return e.next=3,this.tokenManager.getTokens();case 3:n=e.sent.accessToken,t.accessToken=null==n?void 0:n.accessToken;case 5:return e.abrupt("return",(0,m.c3)(this,t));case 6:case"end":return e.stop()}}),e,this)}))),function(e){return C.apply(this,arguments)})},{key:"revokeAccessToken",value:(A=(0,o.Z)(h().mark((function e(t){var n,r;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=10;break}return e.next=3,this.tokenManager.getTokens();case 3:if(n=e.sent,t=n.accessToken,r=this.tokenManager.getStorageKeyByType("accessToken"),this.tokenManager.remove(r),!this.options.dpop){e.next=10;break}return e.next=10,(0,x.ao)("access",n);case 10:if(t){e.next=12;break}return e.abrupt("return",Promise.resolve(null));case 12:return e.abrupt("return",this.token.revoke(t));case 13:case"end":return e.stop()}}),e,this)}))),function(e){return A.apply(this,arguments)})},{key:"revokeRefreshToken",value:(S=(0,o.Z)(h().mark((function e(t){var n,r;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=10;break}return e.next=3,this.tokenManager.getTokens();case 3:if(n=e.sent,t=n.refreshToken,r=this.tokenManager.getStorageKeyByType("refreshToken"),this.tokenManager.remove(r),!this.options.dpop){e.next=10;break}return e.next=10,(0,x.ao)("refresh",n);case 10:if(t){e.next=12;break}return e.abrupt("return",Promise.resolve(null));case 12:return e.abrupt("return",this.token.revoke(t));case 13:case"end":return e.stop()}}),e,this)}))),function(e){return S.apply(this,arguments)})},{key:"getSignOutRedirectUrl",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.idToken,n=e.postLogoutRedirectUri,r=e.state;if(t||(t=this.tokenManager.getTokensSync().idToken),!t)return"";void 0===n&&(n=this.options.postLogoutRedirectUri);var o=(0,k.Fc)(this).logoutUrl,i=t.idToken,a=o+"?id_token_hint="+encodeURIComponent(i);return n&&(a+="&post_logout_redirect_uri="+encodeURIComponent(n)),r&&(a+="&state="+encodeURIComponent(r)),a}},{key:"signOut",value:(y=(0,o.Z)(h().mark((function e(t){var n,r,o,i,a,s,l,u,c,d,f,p,m,v,g,y;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=Object.assign({},t),a=window.location.origin,s=window.location.href,l=null===t.postLogoutRedirectUri?null:t.postLogoutRedirectUri||this.options.postLogoutRedirectUri||a,u=null===(n=t)||void 0===n?void 0:n.state,c=t.accessToken,d=t.refreshToken,f=!1!==t.revokeAccessToken,(p=!1!==t.revokeRefreshToken)&&void 0===d&&(d=this.tokenManager.getTokensSync().refreshToken),f&&void 0===c&&(c=this.tokenManager.getTokensSync().accessToken),t.idToken||(t.idToken=this.tokenManager.getTokensSync().idToken),!p||!d){e.next=15;break}return e.next=15,this.revokeRefreshToken(d);case 15:if(!f||!c){e.next=18;break}return e.next=18,this.revokeAccessToken(c);case 18:if(m=null!==(r=null===(o=c)||void 0===o?void 0:o.dpopPairId)&&void 0!==r?r:null===(i=d)||void 0===i?void 0:i.dpopPairId,!this.options.dpop||!m){e.next=22;break}return e.next=22,(0,x.sd)(m);case 22:if(v=this.getSignOutRedirectUrl(R(R({},t),{},{postLogoutRedirectUri:l}))){e.next=33;break}return e.next=26,this.closeSession();case 26:return g=e.sent,y=new URL(l||a),u&&y.searchParams.append("state",u),l===s?window.location.href=y.href:window.location.assign(y.href),e.abrupt("return",g);case 33:return t.clearTokensBeforeRedirect?this.tokenManager.clear():this.tokenManager.addPendingRemoveFlags(),window.location.assign(v),e.abrupt("return",!0);case 36:case"end":return e.stop()}}),e,this)}))),function(e){return y.apply(this,arguments)})},{key:"getDPoPAuthorizationHeaders",value:(p=(0,o.Z)(h().mark((function e(t){var n,r,o,i;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.options.dpop){e.next=2;break}throw new E.Z("DPoP is not configured for this client instance");case 2:if((r=t.accessToken)||(r=this.tokenManager.getTokensSync().accessToken),r){e.next=6;break}throw new E.Z("AccessToken is required to generate a DPoP Proof");case 6:return e.next=8,(0,x.lk)(null===(n=r)||void 0===n?void 0:n.dpopPairId);case 8:return o=e.sent,e.next=11,(0,x.aW)(R(R({},t),{},{keyPair:o,accessToken:r.accessToken}));case 11:return i=e.sent,e.abrupt("return",{Authorization:"DPoP ".concat(r.accessToken),Dpop:i});case 13:case"end":return e.stop()}}),e,this)}))),function(e){return p.apply(this,arguments)})},{key:"clearDPoPStorage",value:(n=(0,o.Z)(h().mark((function e(){var t,n,r,o,i=arguments;return h().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(i.length>0&&void 0!==i[0]&&i[0])){e.next=3;break}return e.abrupt("return",(0,x.V7)());case 3:return e.next=5,this.tokenManager.getTokens();case 5:if(r=e.sent,!(o=(null===(t=r.accessToken)||void 0===t?void 0:t.dpopPairId)||(null===(n=r.refreshToken)||void 0===n?void 0:n.dpopPairId))){e.next=10;break}return e.next=10,(0,x.sd)(o);case 10:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"parseUseDPoPNonceError",value:function(e){var t=T.Z.getWWWAuthenticateHeader(e),n=T.Z.parseHeader(null!=t?t:"");if((0,x.SO)(n)){var r,o,i=null;return(0,g.mf)(null==e?void 0:e.get)&&(i=e.get("DPoP-Nonce")),null!==(r=null!==(o=i)&&void 0!==o?o:e["dpop-nonce"])&&void 0!==r?r:e["DPoP-Nonce"]}return null}}]),B}(p),(0,f.Z)(n,"crypto",y),n}},9453:function(e,t,n){"use strict";n.d(t,{m:function(){return y}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(1971),d=n(6718),f=n(415),p=n(8817),h=!0,m=n(9123);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function g(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function y(){return function(e){(0,a.Z)(v,e);var t,n,p=(t=v,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function v(e){var t;return(0,o.Z)(this,v),t=p.call(this,e),(0,u.Z)((0,i.Z)(t),"issuer",void 0),(0,u.Z)((0,i.Z)(t),"authorizeUrl",void 0),(0,u.Z)((0,i.Z)(t),"userinfoUrl",void 0),(0,u.Z)((0,i.Z)(t),"tokenUrl",void 0),(0,u.Z)((0,i.Z)(t),"revokeUrl",void 0),(0,u.Z)((0,i.Z)(t),"logoutUrl",void 0),(0,u.Z)((0,i.Z)(t),"pkce",void 0),(0,u.Z)((0,i.Z)(t),"clientId",void 0),(0,u.Z)((0,i.Z)(t),"redirectUri",void 0),(0,u.Z)((0,i.Z)(t),"responseType",void 0),(0,u.Z)((0,i.Z)(t),"responseMode",void 0),(0,u.Z)((0,i.Z)(t),"state",void 0),(0,u.Z)((0,i.Z)(t),"scopes",void 0),(0,u.Z)((0,i.Z)(t),"ignoreSignature",void 0),(0,u.Z)((0,i.Z)(t),"codeChallenge",void 0),(0,u.Z)((0,i.Z)(t),"codeChallengeMethod",void 0),(0,u.Z)((0,i.Z)(t),"acrValues",void 0),(0,u.Z)((0,i.Z)(t),"maxAge",void 0),(0,u.Z)((0,i.Z)(t),"dpop",void 0),(0,u.Z)((0,i.Z)(t),"dpopOptions",void 0),(0,u.Z)((0,i.Z)(t),"tokenManager",void 0),(0,u.Z)((0,i.Z)(t),"postLogoutRedirectUri",void 0),(0,u.Z)((0,i.Z)(t),"restoreOriginalUri",void 0),(0,u.Z)((0,i.Z)(t),"transactionManager",void 0),(0,u.Z)((0,i.Z)(t),"clientSecret",void 0),(0,u.Z)((0,i.Z)(t),"setLocation",void 0),(0,u.Z)((0,i.Z)(t),"ignoreLifetime",void 0),(0,u.Z)((0,i.Z)(t),"maxClockSkew",void 0),function(e){var t=(e=e||{}).scopes;if(t&&!Array.isArray(t))throw new m.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');var n=e.issuer;if(!n)throw new m.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(n))throw new m.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==n.indexOf("-admin.okta"))throw new m.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})')}(e),t.issuer=(0,d.Qj)(e.issuer),t.tokenUrl=(0,d.Qj)(e.tokenUrl),t.authorizeUrl=(0,d.Qj)(e.authorizeUrl),t.userinfoUrl=(0,d.Qj)(e.userinfoUrl),t.revokeUrl=(0,d.Qj)(e.revokeUrl),t.logoutUrl=(0,d.Qj)(e.logoutUrl),t.pkce=!1!==e.pkce,t.clientId=e.clientId,t.redirectUri=e.redirectUri,(0,f.isBrowser)()&&(t.redirectUri=(0,d.BY)(e.redirectUri,window.location.origin)),t.responseType=e.responseType,t.responseMode=e.responseMode,t.state=e.state,t.scopes=e.scopes,t.ignoreSignature=!!e.ignoreSignature,t.codeChallenge=e.codeChallenge,t.codeChallengeMethod=e.codeChallengeMethod,t.acrValues=e.acrValues,t.maxAge=e.maxAge,t.dpop=!0===e.dpop,t.dpopOptions=g({allowBearerTokens:!1},e.dpopOptions),t.tokenManager=e.tokenManager,t.postLogoutRedirectUri=e.postLogoutRedirectUri,t.restoreOriginalUri=e.restoreOriginalUri,t.transactionManager=g({enableSharedStorage:h},e.transactionManager),t.clientSecret=e.clientSecret,t.setLocation=e.setLocation,t.ignoreLifetime=!!e.ignoreLifetime,e.maxClockSkew||0===e.maxClockSkew?t.maxClockSkew=e.maxClockSkew:t.maxClockSkew=c.DEFAULT_MAX_CLOCK_SKEW,t}return(0,r.Z)(v)}((0,p.Z)())}},3775:function(e,t,n){"use strict";n.d(t,{m:function(){return r.m}});var r=n(9453)},5372:function(e,t,n){"use strict";n.d(t,{Tp:function(){return f},ko:function(){return h}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(1969),l=n(9912),u=n(4771),c=n(8676);function d(e){var t=e.options.pkce?"query":"fragment";return e.options.responseMode||t}function f(e,t){t=t||{},(0,u.HD)(t)&&(t={url:t});var n,r=t.url,o=t.responseMode||d(e),i=e.token.parseFromUrl._getLocation();if(!(n="query"===o?r?r.substring(r.indexOf("?")):i.search:r?r.substring(r.indexOf("#")):i.hash))throw new a.Z("Unable to parse a token from the url");return(0,s.v)(n)}function p(e,t){"query"===(t.responseMode||d(e))?function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.hash):r.search=""}(e):function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.search):r.hash=""}(e)}function h(e,t){return m.apply(this,arguments)}function m(){return(m=(0,r.Z)(i().mark((function e(t,n){var r,o,s,d;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=n||{},(0,u.HD)(n)&&(n={url:n}),r=f(t,n),o=r.state,s=t.transactionManager.load({state:o})){e.next=9;break}if(!t.options.pkce){e.next=8;break}throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",void 0);case 8:throw new a.Z("Unable to retrieve OAuth redirect params from storage");case 9:return d=s.urls,delete s.urls,n.url||p(t,n),e.abrupt("return",(0,c.s)(t,s,r,d).catch((function(e){throw(0,l.Cf)(e)||t.transactionManager.clear({state:o}),e})).then((function(e){return t.transactionManager.clear({state:o}),e})));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2476:function(e,t,n){"use strict";n.d(t,{$:function(){return f}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(6488),l=n(7625),u=n(781);function c(){throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken")}function d(e,t){return(0,s.sI)(e)?t.idToken:(0,s.hv)(e)?t.accessToken:void c()}function f(e,t){return p.apply(this,arguments)}function p(){return(p=(0,r.Z)(i().mark((function e(t,n){var r,o,a,f,p,h,m,v,g;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((0,s.sI)(n)||(0,s.hv)(n)||c(),!(r=t.tokenManager.getTokensSync()).refreshToken){e.next=7;break}return e.next=5,(0,u.R)(t,{scopes:n.scopes},r.refreshToken);case 5:return r=e.sent,e.abrupt("return",d(n,r));case 7:return o=t.options.pkce?"code":(0,s.hv)(n)?"token":"id_token",f=(a=n).scopes,p=a.authorizeUrl,h=a.userinfoUrl,m=a.issuer,v=a.dpopPairId,g=a.extraParams,e.abrupt("return",(0,l.y)(t,{responseType:o,scopes:f,authorizeUrl:p,userinfoUrl:h,issuer:m,dpopPairId:v,extraParams:g}).then((function(e){return d(n,e.tokens)})));case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},6268:function(e,t,n){"use strict";n.d(t,{I:function(){return c}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),s=n(7625),l=n(781),u=n(7756);function c(e,t){return d.apply(this,arguments)}function d(){return(d=(0,r.Z)(i().mark((function e(t,n){var r,o,c,d,f,p,h,m,v,g,y,b,w;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(c=null!==(r=null===(o=n)||void 0===o?void 0:o.tokens)&&void 0!==r?r:t.tokenManager.getTokensSync()).refreshToken){e.next=3;break}return e.abrupt("return",(0,l.R)(t,n||{},c.refreshToken));case 3:if(c.accessToken||c.idToken){e.next=5;break}throw new a.Z("renewTokens() was called but there is no existing token");case 5:if(d=c.accessToken||{},f=c.idToken||{},p=d.scopes||f.scopes){e.next=10;break}throw new a.Z("renewTokens: invalid tokens: could not read scopes");case 10:if(h=d.authorizeUrl||f.authorizeUrl){e.next=13;break}throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");case 13:return m=d.userinfoUrl||t.options.userinfoUrl,v=f.issuer||t.options.issuer,g=null==d?void 0:d.dpopPairId,y=(null==d?void 0:d.extraParams)||(null==f?void 0:f.extraParams),n=Object.assign({scopes:p,authorizeUrl:h,userinfoUrl:m,issuer:v,dpopPairId:g,extraParams:y},n),t.options.pkce?n.responseType="code":(b=(0,u.D)(t),w=b.responseType,n.responseType=w),e.abrupt("return",(0,s.y)(t,n).then((function(e){return e.tokens})));case 20:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},781:function(e,t,n){"use strict";n.d(t,{R:function(){return v}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(9123),l=n(7599),u=n(6635),c=n(8676),d=n(9231),f=n(7659),p=n(9912);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function m(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function v(e,t,n){return g.apply(this,arguments)}function g(){return(g=(0,o.Z)(a().mark((function e(t,n,r){var o,i,h,v,g,y,b,w,_,O,k;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=t.options,i=o.clientId,h=o.dpop,i){e.next=3;break}throw new s.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");case 3:if(e.prev=3,v=Object.assign({},n,{clientId:i}),r.extraParams&&(v.extraParams=r.extraParams),g=m({},v),!h){e.next=14;break}return e.next=10,(0,f.lk)(null==r?void 0:r.dpopPairId);case 10:y=e.sent,g.dpopKeyPair=y,v.dpop=h,v.dpopPairId=r.dpopPairId;case 14:return e.next=16,(0,d.D)(t,g,r);case 16:return b=e.sent,w=(0,l.Fc)(t,n),e.next=20,(0,c.s)(t,v,b,w);case 20:return _=e.sent,O=_.tokens,(k=O.refreshToken)&&!(0,u.q)(k,r)&&t.tokenManager.updateRefreshToken(k),e.abrupt("return",O);case 27:throw e.prev=27,e.t0=e.catch(3),(0,p.$E)(e.t0)&&t.tokenManager.removeRefreshToken(),e.t0;case 31:case"end":return e.stop()}}),e,null,[[3,27]])})))).apply(this,arguments)}},6466:function(e,t,n){"use strict";n.d(t,{P:function(){return d}});var r=n(5861),o=n(4687),i=n.n(o),a=n(5385),s=n(6718),l=n(7599),u=n(7594),c=n(9123);function d(e,t){return f.apply(this,arguments)}function f(){return(f=(0,r.Z)(i().mark((function e(t,n){var r,o,d,f,p,h,m;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r="",o="",n&&(r=n.accessToken,o=n.refreshToken),r||o){e.next=5;break}throw new c.Z("A valid access or refresh token object is required");case 5:if(d=t.options.clientId,f=t.options.clientSecret,d){e.next=9;break}throw new c.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");case 9:return p=(0,l.Fc)(t).revokeUrl,h=(0,s.UK)({token_type_hint:o?"refresh_token":"access_token",token:o||r}).slice(1),m=f?(0,u.r3)("".concat(d,":").concat(f)):(0,u.r3)(d),e.abrupt("return",(0,a.v_)(t,p,h,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+m}}));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2333:function(e,t,n){"use strict";n.d(t,{a:function(){return d}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),s=n(1120),l=n(5437),u=n(5763),c=n(1971);function d(){return function(e){(0,i.Z)(f,e);var t,n,d=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function f(e,t,n){return(0,r.Z)(this,f),d.call(this,e,t,n)}return(0,o.Z)(f,[{key:"getTransactionStorage",value:function(e){e=this.getOptionsForSection("transaction",e),(0,l.V)(e);var t=this.getStorage(e),n=e.storageKey||c.TRANSACTION_STORAGE_NAME;return new u._(t,n)}},{key:"getSharedTansactionStorage",value:function(e){e=this.getOptionsForSection("shared-transaction",e),(0,l.V)(e);var t=this.getStorage(e),n=e.storageKey||c.SHARED_TRANSACTION_STORAGE_NAME;return new u._(t,n)}},{key:"getOriginalUriStorage",value:function(e){e=this.getOptionsForSection("original-uri",e),(0,l.V)(e);var t=this.getStorage(e),n=e.storageKey||c.ORIGINAL_URI_STORAGE_NAME;return new u._(t,n)}}]),f}(l.W)}},6488:function(e,t,n){"use strict";var r;function o(e){return!!(e&&(e.accessToken||e.idToken||e.refreshToken)&&Array.isArray(e.scopes))}function i(e){return e&&e.accessToken}function a(e){return e&&e.idToken}function s(e){return e&&e.refreshToken}n.d(t,{T6:function(){return r},hD:function(){return o},hv:function(){return i},sI:function(){return a},z9:function(){return s}}),function(e){e.ACCESS="accessToken",e.ID="idToken",e.REFRESH="refreshToken"}(r||(r={}))},7088:function(e,t,n){"use strict";n.d(t,{$I:function(){return s},$Y:function(){return r},E:function(){return o},FT:function(){return a},O3:function(){return i},zr:function(){return l}});var r="expired",o="renewed",i="added",a="removed",s="error",l="set_storage"},4319:function(e,t,n){"use strict";n.d(t,{G5:function(){return i},ZT:function(){return a},mH:function(){return u},rZ:function(){return l},sG:function(){return s}});var r=n(1002);function o(e){return!(!e||"object"!==(0,r.Z)(e)||0===Object.values(e).length)}function i(e){return!(!o(e)||!e.redirectUri&&!e.responseType)}function a(e){return!!i(e)&&!!e.codeVerifier}function s(e){return!!a(e)&&!!e.interactionHandle}function l(e){return!!o(e)&&void 0===Object.values(e).find((function(e){return"string"!=typeof e}))}function u(e){return!(!i(e)&&!l(e))}},7615:function(){},8927:function(e,t,n){"use strict";n.r(t),n.d(t,{EVENT_ADDED:function(){return s.O3},EVENT_ERROR:function(){return s.$I},EVENT_EXPIRED:function(){return s.$Y},EVENT_REMOVED:function(){return s.FT},EVENT_RENEWED:function(){return s.E},EVENT_SET_STORAGE:function(){return s.zr},TokenKind:function(){return a.T6},isAccessToken:function(){return a.hv},isCustomAuthTransactionMeta:function(){return l.rZ},isIDToken:function(){return a.sI},isIdxTransactionMeta:function(){return l.sG},isOAuthTransactionMeta:function(){return l.G5},isPKCETransactionMeta:function(){return l.ZT},isRefreshToken:function(){return a.z9},isToken:function(){return a.hD},isTransactionMeta:function(){return l.mH}});var r=n(9263),o={};for(var i in r)"default"!==i&&(o[i]=function(e){return r[e]}.bind(0,i));n.d(t,o);var a=n(6488),s=n(7088),l=n(4319),u=n(7615);for(var i in o={},u)["default","TokenKind","isAccessToken","isIDToken","isRefreshToken","isToken","EVENT_ADDED","EVENT_ERROR","EVENT_EXPIRED","EVENT_REMOVED","EVENT_RENEWED","EVENT_SET_STORAGE","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta"].indexOf(i)<0&&(o[i]=function(e){return u[e]}.bind(0,i));n.d(t,o)},9263:function(){},4970:function(e,t,n){"use strict";n.d(t,{It:function(){return p},NH:function(){return l},Rl:function(){return c},iC:function(){return f},pU:function(){return d},ys:function(){return u}});var r=n(4942),o=n(1002),i=n(9123);function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}var s=12e4;function l(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n)}function u(e,t,n){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}function c(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)}function d(e,t){var n=t.popupTitle||"External Identity Provider User Authentication";return window.open(e,n,"toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600")}function f(e,t,n){var r,o;return new Promise((function(a,u){r=function(t){if(t.data&&t.data.state===n)return t.origin!==e.getIssuerOrigin()?u(new i.Z("The request does not match client configuration")):void a(t.data)},l(window,"message",r),o=setTimeout((function(){u(new i.Z("OAuth flow timed out"))}),t||s)})).finally((function(){clearTimeout(o),u(window,"message",r)}))}function p(e,t,n,l){var u,c=new Promise((function(e,c){n.onmessage=function(t){if(t.isTrusted&&t.data)return"object"===(0,o.Z)(t.data)&&l===t.data.state?e(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},t.data)):void c(new i.Z("Unable to complete auth code exchange"))},u=setTimeout((function(){c(new i.Z("OAuth flow timed out"))}),t||s)}));return c.finally((function(){clearTimeout(u),n.close()}))}},5078:function(e,t,n){"use strict";n.d(t,{c:function(){return a}});var r=n(7599),o=n(415),i=n(3193);function a(e){var t=e.options,n=t.clientId,a=t.redirectUri,s=t.responseMode,l=t.state,u=(0,o.isBrowser)()?window.location.href:void 0;return(0,i.YY)({clientId:n,redirectUri:a||u,responseMode:s,state:l||(0,r.aV)(),responseType:"none",prompt:"enroll_authenticator"})}},7756:function(e,t,n){"use strict";n.d(t,{D:function(){return a}});var r=n(7599),o=n(415),i=n(3193);function a(e){var t=e.options,n=t.pkce,a=t.clientId,s=t.redirectUri,l=t.responseType,u=t.responseMode,c=t.scopes,d=t.acrValues,f=t.maxAge,p=t.state,h=t.ignoreSignature,m=t.dpop,v=(0,o.isBrowser)()?window.location.href:void 0;return(0,i.YY)({pkce:n,clientId:a,redirectUri:s||v,responseType:l||["token","id_token"],responseMode:u,state:p||(0,r.aV)(),nonce:(0,r.NH)(),scopes:c||["openid","email"],acrValues:d,maxAge:f,ignoreSignature:h,dpop:m})}},8080:function(e,t,n){"use strict";n.d(t,{A:function(){return o}});var r=n(7599);function o(e,t){return{issuer:e.options.issuer,urls:(0,r.Fc)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,state:t.state,acrValues:t.acrValues,enrollAmrValues:t.enrollAmrValues}}},9912:function(e,t,n){"use strict";n.d(t,{$E:function(){return a},Cf:function(){return o},tC:function(){return i}});var r=n(5728);function o(e){return"OAuthError"===e.name&&"interaction_required"===e.errorCode}function i(e,t){if("AuthApiError"!==t.name)return!1;var n=t.xhr,r=null==n?void 0:n.responseJSON;return e.options.pkce&&"invalid_grant"===(null==r?void 0:r.error)}function a(e){return(0,r.isOAuthError)(e)&&"invalid_grant"===e.errorCode&&"The refresh token is invalid or expired."===e.errorSummary}},8785:function(e,t,n){"use strict";n.d(t,{$E:function(){return a.$E},AW:function(){return c.A},Cf:function(){return a.Cf},Dx:function(){return o.D},Fc:function(){return l.Fc},H:function(){return u.H},Ik:function(){return s.Ik},It:function(){return r.It},NH:function(){return r.NH},O2:function(){return s.O2},PY:function(){return l.NH},Qs:function(){return s.Qs},Rl:function(){return r.Rl},Rp:function(){return g.R},U5:function(){return d.Z},Uc:function(){return p.U},Xp:function(){return l.Xp},Yo:function(){return h.Y},ZP:function(){return s.ZP},aV:function(){return l.aV},br:function(){return f.br},cE:function(){return i.c},d_:function(){return s.d_},gM:function(){return s.gM},hg:function(){return s.hg},iC:function(){return r.iC},kU:function(){return s.kU},mi:function(){return f.mi},pU:function(){return r.pU},pj:function(){return v.p},q0:function(){return h.q},tC:function(){return a.tC},vL:function(){return m.v},vz:function(){return f.vz},wV:function(){return s.wV},wc:function(){return s.wc},wu:function(){return f.wu},ys:function(){return r.ys},zf:function(){return l.zf}});var r=n(4970),o=n(7756),i=n(5078),a=n(9912),s=n(8221),l=n(7599),u=n(2865),c=n(8080),d=n(3611),f=n(6898),p=n(6757),h=n(6635),m=n(1969),v=n(6003),g=n(2482)},8221:function(e,t,n){"use strict";function r(e){return/((id|access)_token=)/i.test(e)}function o(e){return/(code=)/i.test(e)}function i(e){return/(interaction_code=)/i.test(e)}function a(e){return/(error=)/i.test(e)||/(error_description)/i.test(e)}function s(e,t){var n=t.options;return!(!e||!n.redirectUri)&&0===e.indexOf(n.redirectUri)}function l(e){return e.pkce||"code"===e.responseType||"query"===e.responseMode}function u(e,t){return Array.isArray(t.responseType)&&t.responseType.length?t.responseType.indexOf(e)>=0:t.responseType===e}function c(e){return l(e)&&"fragment"!==e.responseMode?window.location.search:window.location.hash}function d(e){if(!s(window.location.href,e))return!1;var t=l(e.options),n=c(e.options);return!!a(n)||(t?o(n)||i(n):r(window.location.hash))}function f(e,t){if(!t){if(!d(e))return!1;t=c(e.options)}return/(error=interaction_required)/i.test(t)}n.d(t,{Ik:function(){return l},O2:function(){return c},Qs:function(){return s},ZP:function(){return o},d_:function(){return i},gM:function(){return d},hg:function(){return a},kU:function(){return r},wV:function(){return u},wc:function(){return f}})},7599:function(e,t,n){"use strict";n.d(t,{Fc:function(){return d},NH:function(){return s},Xp:function(){return c},aV:function(){return a},zf:function(){return u}});var r=n(8750),o=n(6718),i=n(9123);function a(){return(0,r.uh)(64)}function s(){return(0,r.uh)(64)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,o.Qj)(t.issuer)||e.options.issuer}function u(e){var t=l(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return t.indexOf("/oauth2")>0?t:t+"/oauth2"}function c(e){return l(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).split("/oauth2")[0]}function d(e,t){if(arguments.length>2)throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var n=(0,o.Qj)(t.authorizeUrl)||e.options.authorizeUrl,r=l(e,t),a=(0,o.Qj)(t.userinfoUrl)||e.options.userinfoUrl,s=(0,o.Qj)(t.tokenUrl)||e.options.tokenUrl,c=(0,o.Qj)(t.logoutUrl)||e.options.logoutUrl,d=(0,o.Qj)(t.revokeUrl)||e.options.revokeUrl,f=u(e,t);return{issuer:r,authorizeUrl:n=n||f+"/v1/authorize",userinfoUrl:a=a||f+"/v1/userinfo",tokenUrl:s=s||f+"/v1/token",revokeUrl:d=d||f+"/v1/revoke",logoutUrl:c=c||f+"/v1/logout"}}},2865:function(e,t,n){"use strict";n.d(t,{H:function(){return s}});var r=n(4942),o=n(7599);function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function a(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function s(e,t){var n={issuer:e.options.issuer,urls:(0,o.Fc)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,scopes:t.scopes,state:t.state,nonce:t.nonce,ignoreSignature:t.ignoreSignature,acrValues:t.acrValues,extraParams:t.extraParams};return!1===t.pkce?n:a(a({},n),{},{codeVerifier:t.codeVerifier,codeChallengeMethod:t.codeChallengeMethod,codeChallenge:t.codeChallenge})}},3611:function(e,t,n){"use strict";var r=n(7594),o=n(7987),i=n(1971);function a(e){return("0"+e.toString(16)).substr(-2)}t.Z={DEFAULT_CODE_CHALLENGE_METHOD:i.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:function(e){var t,n,o=e||"";return o.length<i.MIN_VERIFIER_LENGTH&&(o+=(t=i.MIN_VERIFIER_LENGTH-o.length,n=new Uint8Array(Math.ceil(t/2)),r.KP.getRandomValues(n),Array.from(n,a).join("").slice(0,t))),encodeURIComponent(o).slice(0,i.MAX_VERIFIER_LENGTH)},computeChallenge:function(e){var t=(new TextEncoder).encode(e);return r.KP.subtle.digest("SHA-256",t).then((function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return(0,o.NL)(t)}))}}},6757:function(e,t,n){"use strict";n.d(t,{U:function(){return l}});var r=n(4942),o=n(9123),i=n(5078);function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e,t){return function(e){if(!(e=s(s({},e),{},{responseType:"none",prompt:"enroll_authenticator",maxAge:0})).enrollAmrValues)throw new o.Z("enroll_amr_values must be specified");if(!e.acrValues)throw new o.Z("acr_values must be specified");return delete e.scopes,delete e.nonce,e}(s(s({},(0,i.c)(e)),t))}},6898:function(e,t,n){"use strict";n.d(t,{br:function(){return m},mi:function(){return g},vz:function(){return h},wu:function(){return b}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),s=n(52),l=n(9123),u=n(7756),c=n(1971),d=n(3611);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function h(e){if(!e.features.isPKCESupported()){var t="PKCE requires a modern browser with encryption support running in a secure context.";throw e.features.isHTTPS()||(t+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(t+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),new l.Z(t)}}function m(e,t){return v.apply(this,arguments)}function v(){return(v=(0,o.Z)(a().mark((function e(t,n){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=n||t.options.codeChallengeMethod||c.DEFAULT_CODE_CHALLENGE_METHOD,e.next=3,(0,s.E)(t);case 3:if(-1!==(e.sent.code_challenge_methods_supported||[]).indexOf(n)){e.next=7;break}throw new l.Z("Invalid code_challenge_method");case 7:return e.abrupt("return",n);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function g(e,t){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n){var r,o,i,s;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=(r=n).codeVerifier,i=r.codeChallenge,s=r.codeChallengeMethod,i=i||t.options.codeChallenge){e.next=8;break}return h(t),o=o||d.Z.generateVerifier(),e.next=7,d.Z.computeChallenge(o);case 7:i=e.sent;case 8:return e.next=10,m(t,s);case 10:return s=e.sent,n=p(p({},n),{},{responseType:"code",codeVerifier:o,codeChallenge:i,codeChallengeMethod:s}),e.abrupt("return",n);case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e){return w.apply(this,arguments)}function w(){return w=(0,o.Z)(a().mark((function e(t){var n,r,o=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=(0,u.D)(t),!(n=p(p({},r),n)).dpop||t.features.isDPoPSupported()){e.next=5;break}throw new l.Z("DPoP has been configured, but is not supported by browser");case 5:if(!1!==n.pkce){e.next=7;break}return e.abrupt("return",n);case 7:return e.abrupt("return",g(t,n));case 8:case"end":return e.stop()}}),e)}))),w.apply(this,arguments)}},6635:function(e,t,n){"use strict";n.d(t,{Y:function(){return i},q:function(){return o}});var r=n(5728);function o(e,t){return e.refreshToken===t.refreshToken}function i(e){return!(!(0,r.isAuthApiError)(e)||!e.xhr||!e.xhr.responseJSON||"invalid_grant"!==e.xhr.responseJSON.error)}},1969:function(e,t,n){"use strict";function r(e){var t=/\+/g,n=/([^&=]+)=?([^&]*)/g,r=e||"";"#"===r.charAt(0)&&"/"===r.charAt(1)&&(r=r.substring(2)),"#"!==r.charAt(0)&&"?"!==r.charAt(0)||(r=r.substring(1));for(var o,i={};o=n.exec(r);){var a=o[1],s=o[2];i[a]="id_token"===a||"access_token"===a||"code"===a?s:decodeURIComponent(s.replace(t," "))}return i}n.d(t,{v:function(){return r}})},6003:function(e,t,n){"use strict";n.d(t,{p:function(){return o}});var r=n(9123);function o(e,t,n){var o=n.clientId,i=n.issuer,a=n.nonce,s=n.acrValues;if(!t||!i||!o)throw new r.Z("The jwt, iss, and aud arguments are all required");if(a&&t.nonce!==a)throw new r.Z("OAuth flow response nonce doesn't match request nonce");var l=Math.floor(Date.now()/1e3);if(t.iss!==i)throw new r.Z("The issuer ["+t.iss+"] does not match ["+i+"]");if(Array.isArray(t.aud)&&t.aud.indexOf(o)<0||!Array.isArray(t.aud)&&t.aud!==o)throw new r.Z("The audience ["+t.aud+"] does not match ["+o+"]");if(s&&t.acr!==s)throw new r.Z("The acr ["+t.acr+"] does not match acr_values ["+s+"]");if(t.iat>t.exp)throw new r.Z("The JWT expired before it was issued");if(!e.options.ignoreLifetime){if(l-e.options.maxClockSkew>t.exp)throw new r.Z("The JWT expired and is no longer valid");if(t.iat>l+e.options.maxClockSkew)throw new r.Z("The JWT was issued in the future")}}},2482:function(e,t,n){"use strict";n.d(t,{R:function(){return i}});var r=n(9123),o=n(6488);function i(e,t){if(!(0,o.sI)(e)&&!(0,o.hv)(e)&&!(0,o.z9)(e))throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");if("accessToken"===t&&!(0,o.hv)(e))throw new r.Z("invalid accessToken");if("idToken"===t&&!(0,o.sI)(e))throw new r.Z("invalid idToken");if("refreshToken"===t&&!(0,o.z9)(e))throw new r.Z("invalid refreshToken")}},1260:function(e,t,n){"use strict";n.d(t,{W:function(){return f}});var r=n(5861),o=n(4687),i=n.n(o),a=n(52),s=n(6003),l=n(9123),u=n(1237),c=n(3154),d=n(5698);function f(e,t,n){return p.apply(this,arguments)}function p(){return(p=(0,r.Z)(i().mark((function e(t,n,r){var o,f,p,h,m,v;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n&&n.idToken){e.next=2;break}throw new l.Z("Only idTokens may be verified");case 2:return o=(0,u.T)(n.idToken),f=(null==r?void 0:r.issuer)||t.options.issuer,e.next=6,(0,a.E)(t,f);case 6:if(p=e.sent,h=p.issuer,m=Object.assign({clientId:t.options.clientId,ignoreSignature:t.options.ignoreSignature},r,{issuer:h}),(0,s.p)(t,o.payload,m),1!=m.ignoreSignature&&t.features.isTokenVerifySupported()){e.next=12;break}return e.abrupt("return",n);case 12:return e.next=14,(0,a.k)(t,n.issuer,o.header.kid);case 14:return v=e.sent,e.next=17,c.W(n.idToken,v);case 17:if(e.sent){e.next=20;break}throw new l.Z("The token signature is not valid");case 20:if(!(r&&r.accessToken&&n.claims.at_hash)){e.next=26;break}return e.next=23,d.X(r.accessToken);case 23:if(e.sent===n.claims.at_hash){e.next=26;break}throw new l.Z("Token hash verification failed");case 26:return e.abrupt("return",n);case 27:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},3719:function(e,t,n){"use strict";n.d(t,{Gg:function(){return s},OT:function(){return c},RJ:function(){return l},dx:function(){return u},sH:function(){return a}});var r=n(3193),o=n(6718),i=n(5385);function a(e){return e.session.get().then((function(e){return"ACTIVE"===e.status})).catch((function(){return!1}))}function s(e){return(0,i.U2)(e,"/api/v1/sessions/me",{withCredentials:!0}).then((function(t){var n=(0,r.CE)(t,"_links");return n.refresh=function(){return(0,i.v_)(e,(0,r.Rg)(t,"refresh").href,{},{withCredentials:!0})},n.user=function(){return(0,i.U2)(e,(0,r.Rg)(t,"user").href,{withCredentials:!0})},n})).catch((function(){return{status:"INACTIVE"}}))}function l(e){return(0,i.c3)(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE",withCredentials:!0})}function u(e){return(0,i.v_)(e,"/api/v1/sessions/me/lifecycle/refresh",{},{withCredentials:!0})}function c(e,t,n){n=n||window.location.href,window.location.assign(e.getIssuerOrigin()+"/login/sessionCookieRedirect"+(0,o.UK)({checkAccountSetupComplete:!0,token:t,redirectUrl:n}))}},2815:function(e,t,n){"use strict";n.d(t,{M:function(){return o}});var r=n(3719);function o(e){return{close:r.RJ.bind(null,e),exists:r.sH.bind(null,e),get:r.Gg.bind(null,e),refresh:r.dx.bind(null,e),setCookieAndRedirect:r.OT.bind(null,e)}}},8041:function(e,t,n){"use strict";n.d(t,{Gg:function(){return r.Gg},MG:function(){return o.M},OT:function(){return r.OT},RJ:function(){return r.RJ},Zg:function(){return i.Z},dx:function(){return r.dx},sH:function(){return r.sH}});var r=n(3719),o=n(2815),i=n(3980)},3980:function(e,t,n){"use strict";n.d(t,{Z:function(){return h}});var r=n(5861),o=n(5671),i=n(3144),a=n(7326),s=n(136),l=n(2963),u=n(1120),c=n(4942),d=n(4687),f=n.n(d),p=n(2815);function h(e){return function(e){(0,s.Z)(h,e);var t,n,d=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,l.Z)(this,e)});function h(){var e;(0,o.Z)(this,h);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=d.call.apply(d,[this].concat(n)),(0,c.Z)((0,a.Z)(e),"session",void 0),e.session=(0,p.M)((0,a.Z)(e)),e}return(0,i.Z)(h,[{key:"closeSession",value:function(){var e=this;return this.session.close().then((0,r.Z)(f().mark((function t(){return f().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return e.clearStorage(),t.abrupt("return",!0);case 2:case"end":return t.stop()}}),t)})))).catch((function(e){if("AuthApiError"===e.name&&"E0000007"===e.errorCode)return!1;throw e}))}}]),h}(e)}},5437:function(e,t,n){"use strict";n.d(t,{V:function(){return c},W:function(){return d}});var r=n(5671),o=n(3144),i=n(4942),a=n(1971),s=n(5763),l=n(415),u=n(146);function c(e){(0,l.isBrowser)()||e.storageProvider||e.storageKey||(0,u.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.")}var d=function(){function e(t,n,o){(0,r.Z)(this,e),(0,i.Z)(this,"storageManagerOptions",void 0),(0,i.Z)(this,"cookieOptions",void 0),(0,i.Z)(this,"storageUtil",void 0),this.storageManagerOptions=t,this.cookieOptions=n,this.storageUtil=o}return(0,o.Z)(e,[{key:"getOptionsForSection",value:function(e,t){return Object.assign({},this.storageManagerOptions[e],t)}},{key:"getStorage",value:function(e){if((e=Object.assign({},this.cookieOptions,e)).storageProvider)return e.storageProvider;var t=e,n=t.storageType,r=t.storageTypes;if("sessionStorage"===n&&(e.sessionCookie=!0),n&&r){var o=r.indexOf(n);o>=0&&(r=r.slice(o),n=void 0)}return n||(n=this.storageUtil.findStorageType(r)),this.storageUtil.getStorageByType(n,e)}},{key:"getTokenStorage",value:function(e){c(e=this.getOptionsForSection("token",e));var t=this.getStorage(e),n=e.storageKey||a.TOKEN_STORAGE_NAME;return new s._(t,n)}},{key:"getHttpCache",value:function(e){e=this.getOptionsForSection("cache",e);var t=this.getStorage(e),n=e.storageKey||a.CACHE_STORAGE_NAME;return new s._(t,n)}}]),e}()},5763:function(e,t,n){"use strict";n.d(t,{_:function(){return s}});var r=n(5671),o=n(3144),i=n(4942),a=n(9123),s=function(){function e(t,n){if((0,r.Z)(this,e),(0,i.Z)(this,"storageProvider",void 0),(0,i.Z)(this,"storageName",void 0),!t)throw new a.Z('"storage" is required');if("string"!=typeof n||!n.length)throw new a.Z('"storageName" is required');this.storageName=n,this.storageProvider=t}return(0,o.Z)(e,[{key:"getItem",value:function(e){return this.getStorage()[e]}},{key:"setItem",value:function(e,t){return this.updateStorage(e,t)}},{key:"removeItem",value:function(e){return this.clearStorage(e)}},{key:"getStorage",value:function(){var e=this.storageProvider.getItem(this.storageName);e=e||"{}";try{return JSON.parse(e)}catch(e){throw new a.Z("Unable to parse storage string: "+this.storageName)}}},{key:"setStorage",value:function(e){try{var t=e?JSON.stringify(e):"{}";this.storageProvider.setItem(this.storageName,t)}catch(e){throw new a.Z("Unable to set storage: "+this.storageName)}}},{key:"clearStorage",value:function(e){if(e){var t=this.getStorage();delete t[e],this.setStorage(t)}else this.storageProvider.removeItem?this.storageProvider.removeItem(this.storageName):this.setStorage()}},{key:"updateStorage",value:function(e,t){var n=this.getStorage();n[e]=t,this.setStorage(n)}}]),e}()},9927:function(e,t,n){"use strict";n.d(t,{Ho:function(){return i.H},Tp:function(){return r.T},Vp:function(){return o.V},W8:function(){return o.W},_e:function(){return a._}});var r=n(3849),o=n(5437),i=n(265),a=n(5763)},265:function(e,t,n){"use strict";n.d(t,{H:function(){return c}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942);function c(e,t){return function(e){(0,a.Z)(f,e);var n,c,d=(n=f,c=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,l.Z)(n);if(c){var r=(0,l.Z)(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return(0,s.Z)(this,e)});function f(){var e;(0,r.Z)(this,f);for(var n=arguments.length,o=new Array(n),a=0;a<n;a++)o[a]=arguments[a];e=d.call.apply(d,[this].concat(o)),(0,u.Z)((0,i.Z)(e),"storageManager",void 0);var s=e.options,l=s.storageManager,c=s.cookies,p=s.storageUtil;return e.storageManager=new t(l,c,p),e}return(0,o.Z)(f,[{key:"clearStorage",value:function(){}}]),f}(e)}},3849:function(e,t,n){"use strict";n.d(t,{T:function(){return g}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),s=n(2963),l=n(1120),u=n(4942),c=n(5093),d=n(146),f=n(4858),p={token:{storageTypes:["localStorage","sessionStorage","cookie"]},cache:{storageTypes:["localStorage","sessionStorage","cookie"]},transaction:{storageTypes:["sessionStorage","localStorage","cookie"]},"shared-transaction":{storageTypes:["localStorage"]},"original-uri":{storageTypes:["localStorage"]}},h=n(415);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(){return function(e){(0,a.Z)(m,e);var t,n,c=(t=m,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function m(e){var t;return(0,o.Z)(this,m),t=c.call(this,e),(0,u.Z)((0,i.Z)(t),"cookies",void 0),(0,u.Z)((0,i.Z)(t),"storageUtil",void 0),(0,u.Z)((0,i.Z)(t),"storageManager",void 0),t.cookies=function(){var e=arguments.length>1?arguments[1]:void 0,t=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).cookies||{};return void 0===t.secure&&(t.secure=e),void 0===t.sameSite&&(t.sameSite=t.secure?"none":"lax"),t.secure&&!e&&((0,d.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),t.secure=!1),"none"!==t.sameSite||t.secure||(t.sameSite="lax"),t}(e,(0,h.isHTTPS)()),t.storageUtil=e.storageUtil||Object.assign({},f.Z,{inMemoryStore:{}}),t.storageManager=v(v({},p),e.storageManager),t}return(0,r.Z)(m)}((0,c.X)())}},3548:function(e,t,n){"use strict";n.d(t,{b:function(){return l}});var r=n(5671),o=n(3144),i=n(4942),a=n(4771),s=n(146),l=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{quiet:!1};(0,r.Z)(this,e),(0,i.Z)(this,"queue",void 0),(0,i.Z)(this,"running",void 0),(0,i.Z)(this,"options",void 0),this.queue=[],this.running=!1,this.options=t}return(0,o.Z)(e,[{key:"push",value:function(e,t){for(var n=this,r=arguments.length,o=new Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];return new Promise((function(r,i){n.queue.length>0&&!1!==n.options.quiet&&(0,s.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."),n.queue.push({method:e,thisObject:t,args:o,resolve:r,reject:i}),n.run()}))}},{key:"run",value:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),n=t.method.apply(t.thisObject,t.args);(0,a.tI)(n)?n.then(t.resolve,t.reject).finally((function(){e.running=!1,e.run()})):(t.resolve(n),this.running=!1,this.run())}}}]),e}()},146:function(e,t,n){"use strict";function r(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0}function o(){var e=r();return e&&e.log?e:{log:function(){},warn:function(){},group:function(){},groupEnd:function(){}}}function i(e){o().warn("[okta-auth-sdk] WARN: "+e)}function a(e){o().warn("[okta-auth-sdk] DEPRECATION: "+e)}function s(e,t){return function(){return a(e),t.apply(null,arguments)}}n.d(t,{Rn:function(){return a},VA:function(){return s},ZK:function(){return i},dr:function(){return o},sW:function(){return r}})},305:function(e,t,n){"use strict";n.d(t,{BY:function(){return l.BY},CE:function(){return i.CE},HD:function(){return s.HD},Kn:function(){return s.Kn},QN:function(){return l.QN},Qj:function(){return l.Qj},Rg:function(){return i.Rg},Rn:function(){return r.Rn},UK:function(){return l.UK},VA:function(){return r.VA},YQ:function(){return o.YQ},YY:function(){return i.YY},ZK:function(){return r.ZK},ak:function(){return i.ak},bo:function(){return a.b},d9:function(){return i.d9},dr:function(){return r.dr},gw:function(){return o.gw},hj:function(){return s.hj},l7:function(){return i.l7},mf:function(){return s.mf},ng:function(){return o.ng},sD:function(){return l.sD},sE:function(){return i.sE},sW:function(){return r.sW},tI:function(){return s.tI},uh:function(){return o.uh}});var r=n(146),o=n(8750),i=n(3193),a=n(3548),s=n(4771),l=n(6718)},8750:function(e,t,n){"use strict";function r(e){var t=e.match(/\d+/g),n=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(n).toUTCString()}function o(e){for(var t="",n=0;n<e;++n)t+="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61*Math.random())];return t}function i(e){return new Promise((function(t){setTimeout(t,e)}))}function a(e,t){var n=e.split(t);return[n[0],n.splice(1,n.length).join(t)]}n.d(t,{YQ:function(){return a},gw:function(){return i},ng:function(){return r},uh:function(){return o}})},3193:function(e,t,n){"use strict";function r(e,t){var n=Array.prototype.slice.call(arguments,2);return function(){var r=Array.prototype.slice.call(arguments);return r=n.concat(r),e.apply(t,r)}}function o(){var e=arguments[0];return[].slice.call(arguments,1).forEach((function(t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&void 0!==t[n]&&(e[n]=t[n])})),e}function i(e){var t={};for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var r=e[n];null!=r&&(t[n]=r)}return t}function a(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e}function s(e){for(var t={},n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&-1==r.indexOf(i)&&(t[i]=e[i]);return a(t)}function l(e,t){for(var n=e.length;n--;){var r=e[n],o=!0;for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&r[i]!==t[i]){o=!1;break}if(o)return r}}function u(e,t,n){if(e&&e._links){var r=a(e._links[t]);return r&&r.name&&n?r.name===n?r:void 0:r}}n.d(t,{CE:function(){return s},Rg:function(){return u},YY:function(){return i},ak:function(){return r},d9:function(){return a},l7:function(){return o},sE:function(){return l}})},4771:function(e,t,n){"use strict";function r(e){return"[object String]"===Object.prototype.toString.call(e)}function o(e){return"[object Object]"===Object.prototype.toString.call(e)}function i(e){return"[object Number]"===Object.prototype.toString.call(e)}function a(e){return!!e&&"[object Function]"==={}.toString.call(e)}function s(e){return e&&e.finally&&"function"==typeof e.finally}n.d(t,{HD:function(){return r},Kn:function(){return o},hj:function(){return i},mf:function(){return a},tI:function(){return s}})},6718:function(e,t,n){"use strict";function r(e){return/^[a-z][a-z0-9+.-]*:/i.test(e)}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)?e:(t=s(t),"/"===e[0]?"".concat(t).concat(e):"".concat(t,"/").concat(e))}function i(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)&&(e=e.substring(t.length)),"/"===e[0]?e:"/".concat(e)}function a(e){var t=[];if(null!==e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&void 0!==e[n]&&null!==e[n]&&t.push(n+"="+encodeURIComponent(e[n]));return t.length?"?"+t.join("&"):""}function s(e){if(e)return e.replace(/^\s+|\s+$/gm,"").replace(/\/+$/,"")}n.d(t,{BY:function(){return o},QN:function(){return i},Qj:function(){return s},UK:function(){return a},sD:function(){return r}})},3615:function(e,t,n){"use strict";var r=n(6690),o=n(9728),i=n(1655),a=n(4993),s=n(3808);function l(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var u=function(e){i(u,e);var t,n,l=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=s(t);if(n){var o=s(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return a(this,e)});function u(e){var t;return r(this,u),(t=l.call(this,e||"Promise was canceled")).name="CancelError",t}return o(u,[{key:"isCanceled",get:function(){return!0}}]),u}(n(3496)(Error)),c=function(){function e(t){var n=this;r(this,e),this._cancelHandlers=[],this._isPending=!0,this._isCanceled=!1,this._rejectOnCancel=!0,this._promise=new Promise((function(e,r){n._reject=r;var o=function(e){if(!n._isPending)throw new Error("The `onCancel` handler was attached after the promise settled.");n._cancelHandlers.push(e)};return Object.defineProperties(o,{shouldReject:{get:function(){return n._rejectOnCancel},set:function(e){n._rejectOnCancel=e}}}),t((function(t){n._isCanceled&&o.shouldReject||(n._isPending=!1,e(t))}),(function(e){n._isPending=!1,r(e)}),o)}))}return o(e,[{key:"then",value:function(e,t){return this._promise.then(e,t)}},{key:"catch",value:function(e){return this._promise.catch(e)}},{key:"finally",value:function(e){return this._promise.finally(e)}},{key:"cancel",value:function(e){if(this._isPending&&!this._isCanceled){if(this._isCanceled=!0,this._cancelHandlers.length>0)try{var t,n=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return l(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?l(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}(this._cancelHandlers);try{for(n.s();!(t=n.n()).done;)(0,t.value)()}catch(e){n.e(e)}finally{n.f()}}catch(e){return void this._reject(e)}this._rejectOnCancel&&this._reject(new u(e))}}},{key:"isCanceled",get:function(){return this._isCanceled}}],[{key:"fn",value:function(t){return function(){for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return new e((function(e,n,o){r.push(o),t.apply(void 0,r).then(e,n)}))}}}]),e}();Object.setPrototypeOf(c.prototype,Promise.prototype),e.exports=c,e.exports.CancelError=u},4098:function(e,t){var n="undefined"!=typeof self?self:this,r=function(){function e(){this.fetch=!1,this.DOMException=n.DOMException}return e.prototype=n,new e}();!function(e){!function(t){var n={searchParams:"URLSearchParams"in e,iterable:"Symbol"in e&&"iterator"in Symbol,blob:"FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in e,arrayBuffer:"ArrayBuffer"in e};if(n.arrayBuffer)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],o=ArrayBuffer.isView||function(e){return e&&r.indexOf(Object.prototype.toString.call(e))>-1};function i(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function a(e){return"string"!=typeof e&&(e=String(e)),e}function s(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return n.iterable&&(t[Symbol.iterator]=function(){return t}),t}function l(e){this.map={},e instanceof l?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function u(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function c(e){return new Promise((function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}}))}function d(e){var t=new FileReader,n=c(t);return t.readAsArrayBuffer(e),n}function f(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function p(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:n.blob&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:n.formData&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():n.arrayBuffer&&n.blob&&(t=e)&&DataView.prototype.isPrototypeOf(t)?(this._bodyArrayBuffer=f(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):n.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(e)||o(e))?this._bodyArrayBuffer=f(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},n.blob&&(this.blob=function(){var e=u(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?u(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(d)}),this.text=function(){var e,t,n,r=u(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,n=c(t=new FileReader),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},n.formData&&(this.formData=function(){return this.text().then(v)}),this.json=function(){return this.text().then(JSON.parse)},this}l.prototype.append=function(e,t){e=i(e),t=a(t);var n=this.map[e];this.map[e]=n?n+", "+t:t},l.prototype.delete=function(e){delete this.map[i(e)]},l.prototype.get=function(e){return e=i(e),this.has(e)?this.map[e]:null},l.prototype.has=function(e){return this.map.hasOwnProperty(i(e))},l.prototype.set=function(e,t){this.map[i(e)]=a(t)},l.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this)},l.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n)})),s(e)},l.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),s(e)},l.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t])})),s(e)},n.iterable&&(l.prototype[Symbol.iterator]=l.prototype.entries);var h=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function m(e,t){var n,r,o=(t=t||{}).body;if(e instanceof m){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new l(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new l(t.headers)),this.method=(r=(n=t.method||this.method||"GET").toUpperCase(),h.indexOf(r)>-1?r:n),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function v(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),o=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(o))}})),t}function g(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new l(t.headers),this.url=t.url||"",this._initBody(e)}m.prototype.clone=function(){return new m(this,{body:this._bodyInit})},p.call(m.prototype),p.call(g.prototype),g.prototype.clone=function(){return new g(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new l(this.headers),url:this.url})},g.error=function(){var e=new g(null,{status:0,statusText:""});return e.type="error",e};var y=[301,302,303,307,308];g.redirect=function(e,t){if(-1===y.indexOf(t))throw new RangeError("Invalid status code");return new g(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function b(e,r){return new Promise((function(o,i){var a=new m(e,r);if(a.signal&&a.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var s=new XMLHttpRequest;function u(){s.abort()}s.onload=function(){var e,t,n={status:s.status,statusText:s.statusText,headers:(e=s.getAllResponseHeaders()||"",t=new l,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var o=n.join(":").trim();t.append(r,o)}})),t)};n.url="responseURL"in s?s.responseURL:n.headers.get("X-Request-URL");var r="response"in s?s.response:s.responseText;o(new g(r,n))},s.onerror=function(){i(new TypeError("Network request failed"))},s.ontimeout=function(){i(new TypeError("Network request failed"))},s.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},s.open(a.method,a.url,!0),"include"===a.credentials?s.withCredentials=!0:"omit"===a.credentials&&(s.withCredentials=!1),"responseType"in s&&n.blob&&(s.responseType="blob"),a.headers.forEach((function(e,t){s.setRequestHeader(t,e)})),a.signal&&(a.signal.addEventListener("abort",u),s.onreadystatechange=function(){4===s.readyState&&a.signal.removeEventListener("abort",u)}),s.send(void 0===a._bodyInit?null:a._bodyInit)}))}b.polyfill=!0,e.fetch||(e.fetch=b,e.Headers=l,e.Request=m,e.Response=g),t.Headers=l,t.Request=m,t.Response=g,t.fetch=b,Object.defineProperty(t,"__esModule",{value:!0})}({})}(r),r.fetch.ponyfill=!0,delete r.fetch.polyfill;var o=r;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t},4279:function(e){function t(){}t.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function o(){r.off(e,o),t.apply(n,arguments)}return o._=t,this.on(e,o,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,o=n.length;r<o;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],o=[];if(r&&t)for(var i=0,a=r.length;i<a;i++)r[i].fn!==t&&r[i].fn._!==t&&o.push(r[i]);return o.length?n[e]=o:delete n[e],this}},e.exports=t},6115:function(e){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},6690:function(e){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},3515:function(e,t,n){var r=n(9617),o=n(6015);e.exports=function(e,t,n){if(r())return Reflect.construct.apply(null,arguments);var i=[null];i.push.apply(i,t);var a=new(e.bind.apply(e,i));return n&&o(a,n.prototype),a},e.exports.__esModule=!0,e.exports.default=e.exports},9728:function(e,t,n){var r=n(4062);function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,r(o.key),o)}}e.exports=function(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},3808:function(e){function t(n){return e.exports=t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},1655:function(e,t,n){var r=n(6015);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&r(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},6035:function(e){e.exports=function(e){try{return-1!==Function.toString.call(e).indexOf("[native code]")}catch(t){return"function"==typeof e}},e.exports.__esModule=!0,e.exports.default=e.exports},9617:function(e){function t(){try{var n=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(n){}return(e.exports=t=function(){return!!n},e.exports.__esModule=!0,e.exports.default=e.exports)()}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},4993:function(e,t,n){var r=n(8698).default,o=n(6115);e.exports=function(e,t){if(t&&("object"==r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},7061:function(e,t,n){var r=n(8698).default;function o(){"use strict";e.exports=o=function(){return n},e.exports.__esModule=!0,e.exports.default=e.exports;var t,n={},i=Object.prototype,a=i.hasOwnProperty,s=Object.defineProperty||function(e,t,n){e[t]=n.value},l="function"==typeof Symbol?Symbol:{},u=l.iterator||"@@iterator",c=l.asyncIterator||"@@asyncIterator",d=l.toStringTag||"@@toStringTag";function f(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{f({},"")}catch(t){f=function(e,t,n){return e[t]=n}}function p(e,t,n,r){var o=t&&t.prototype instanceof w?t:w,i=Object.create(o.prototype),a=new N(r||[]);return s(i,"_invoke",{value:P(e,n,a)}),i}function h(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}n.wrap=p;var m="suspendedStart",v="suspendedYield",g="executing",y="completed",b={};function w(){}function _(){}function O(){}var k={};f(k,u,(function(){return this}));var x=Object.getPrototypeOf,E=x&&x(x(M([])));E&&E!==i&&a.call(E,u)&&(k=E);var T=O.prototype=w.prototype=Object.create(k);function S(e){["next","throw","return"].forEach((function(t){f(e,t,(function(e){return this._invoke(t,e)}))}))}function A(e,t){function n(o,i,s,l){var u=h(e[o],e,i);if("throw"!==u.type){var c=u.arg,d=c.value;return d&&"object"==r(d)&&a.call(d,"__await")?t.resolve(d.__await).then((function(e){n("next",e,s,l)}),(function(e){n("throw",e,s,l)})):t.resolve(d).then((function(e){c.value=e,s(c)}),(function(e){return n("throw",e,s,l)}))}l(u.arg)}var o;s(this,"_invoke",{value:function(e,r){function i(){return new t((function(t,o){n(e,r,t,o)}))}return o=o?o.then(i,i):i()}})}function P(e,n,r){var o=m;return function(i,a){if(o===g)throw Error("Generator is already running");if(o===y){if("throw"===i)throw a;return{value:t,done:!0}}for(r.method=i,r.arg=a;;){var s=r.delegate;if(s){var l=C(s,r);if(l){if(l===b)continue;return l}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(o===m)throw o=y,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);o=g;var u=h(e,n,r);if("normal"===u.type){if(o=r.done?y:v,u.arg===b)continue;return{value:u.arg,done:r.done}}"throw"===u.type&&(o=y,r.method="throw",r.arg=u.arg)}}}function C(e,n){var r=n.method,o=e.iterator[r];if(o===t)return n.delegate=null,"throw"===r&&e.iterator.return&&(n.method="return",n.arg=t,C(e,n),"throw"===n.method)||"return"!==r&&(n.method="throw",n.arg=new TypeError("The iterator does not provide a '"+r+"' method")),b;var i=h(o,e.iterator,n.arg);if("throw"===i.type)return n.method="throw",n.arg=i.arg,n.delegate=null,b;var a=i.arg;return a?a.done?(n[e.resultName]=a.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,b):a:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,b)}function R(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function I(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function N(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(R,this),this.reset(!0)}function M(e){if(e||""===e){var n=e[u];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var o=-1,i=function n(){for(;++o<e.length;)if(a.call(e,o))return n.value=e[o],n.done=!1,n;return n.value=t,n.done=!0,n};return i.next=i}}throw new TypeError(r(e)+" is not iterable")}return _.prototype=O,s(T,"constructor",{value:O,configurable:!0}),s(O,"constructor",{value:_,configurable:!0}),_.displayName=f(O,d,"GeneratorFunction"),n.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===_||"GeneratorFunction"===(t.displayName||t.name))},n.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,O):(e.__proto__=O,f(e,d,"GeneratorFunction")),e.prototype=Object.create(T),e},n.awrap=function(e){return{__await:e}},S(A.prototype),f(A.prototype,c,(function(){return this})),n.AsyncIterator=A,n.async=function(e,t,r,o,i){void 0===i&&(i=Promise);var a=new A(p(e,t,r,o),i);return n.isGeneratorFunction(t)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},S(T),f(T,d,"Generator"),f(T,u,(function(){return this})),f(T,"toString",(function(){return"[object Generator]"})),n.keys=function(e){var t=Object(e),n=[];for(var r in t)n.push(r);return n.reverse(),function e(){for(;n.length;){var r=n.pop();if(r in t)return e.value=r,e.done=!1,e}return e.done=!0,e}},n.values=M,N.prototype={constructor:N,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(I),!e)for(var n in this)"t"===n.charAt(0)&&a.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function r(r,o){return s.type="throw",s.arg=e,n.next=r,o&&(n.method="next",n.arg=t),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],s=i.completion;if("root"===i.tryLoc)return r("end");if(i.tryLoc<=this.prev){var l=a.call(i,"catchLoc"),u=a.call(i,"finallyLoc");if(l&&u){if(this.prev<i.catchLoc)return r(i.catchLoc,!0);if(this.prev<i.finallyLoc)return r(i.finallyLoc)}else if(l){if(this.prev<i.catchLoc)return r(i.catchLoc,!0)}else{if(!u)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return r(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&a.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,b):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),b},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),I(n),b}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;I(n)}return o}}throw Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:M(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),b}},n}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},6015:function(e){function t(n,r){return e.exports=t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n,r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},5036:function(e,t,n){var r=n(8698).default;e.exports=function(e,t){if("object"!=r(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=r(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)},e.exports.__esModule=!0,e.exports.default=e.exports},4062:function(e,t,n){var r=n(8698).default,o=n(5036);e.exports=function(e){var t=o(e,"string");return"symbol"==r(t)?t:t+""},e.exports.__esModule=!0,e.exports.default=e.exports},8698:function(e){function t(n){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},3496:function(e,t,n){var r=n(3808),o=n(6015),i=n(6035),a=n(3515);function s(t){var n="function"==typeof Map?new Map:void 0;return e.exports=s=function(e){if(null===e||!i(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},e.exports.__esModule=!0,e.exports.default=e.exports,s(t)}e.exports=s,e.exports.__esModule=!0,e.exports.default=e.exports},4687:function(e,t,n){var r=n(7061)();e.exports=r;try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},907:function(e,t,n){"use strict";function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}n.d(t,{Z:function(){return r}})},7326:function(e,t,n){"use strict";function r(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}n.d(t,{Z:function(){return r}})},5861:function(e,t,n){"use strict";function r(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function o(e){return function(){var t=this,n=arguments;return new Promise((function(o,i){var a=e.apply(t,n);function s(e){r(a,o,i,s,l,"next",e)}function l(e){r(a,o,i,s,l,"throw",e)}s(void 0)}))}}n.d(t,{Z:function(){return o}})},5671:function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}n.d(t,{Z:function(){return r}})},3144:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(9142);function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,(0,r.Z)(o.key),o)}}function i(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}},4942:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(9142);function o(e,t,n){return(t=(0,r.Z)(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},1752:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(1120);function o(){return o="undefined"!=typeof Reflect&&Reflect.get?Reflect.get.bind():function(e,t,n){var o=function(e,t){for(;!{}.hasOwnProperty.call(e,t)&&null!==(e=(0,r.Z)(e)););return e}(e,t);if(o){var i=Object.getOwnPropertyDescriptor(o,t);return i.get?i.get.call(arguments.length<3?e:n):i.value}},o.apply(null,arguments)}},1120:function(e,t,n){"use strict";function r(e){return r=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},r(e)}n.d(t,{Z:function(){return r}})},136:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(9611);function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&(0,r.Z)(e,t)}},4925:function(e,t,n){"use strict";function r(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}n.d(t,{Z:function(){return r}})},2963:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(1002),o=n(7326);function i(e,t){if(t&&("object"==(0,r.Z)(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return(0,o.Z)(e)}},9611:function(e,t,n){"use strict";function r(e,t){return r=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},r(e,t)}n.d(t,{Z:function(){return r}})},885:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(181);function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i,a,s=[],l=!0,u=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1}else for(;!(l=(r=i.call(n)).done)&&(s.push(r.value),s.length!==t);l=!0);}catch(e){u=!0,o=e}finally{try{if(!l&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(u)throw o}}return s}}(e,t)||(0,r.Z)(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},2982:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(907),o=n(181);function i(e){return function(e){if(Array.isArray(e))return(0,r.Z)(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||(0,o.Z)(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},9142:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(1002);function o(e){var t=function(e,t){if("object"!=(0,r.Z)(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,"string");if("object"!=(0,r.Z)(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==(0,r.Z)(t)?t:t+""}},1002:function(e,t,n){"use strict";function r(e){return r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(e)}n.d(t,{Z:function(){return r}})},181:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(907);function o(e,t){if(e){if("string"==typeof e)return(0,r.Z)(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?(0,r.Z)(e,t):void 0}}}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var i=t[r]={exports:{}};return e[r].call(i.exports,i,i.exports,n),i.exports}n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,{a:t}),t},n.d=function(e,t){for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return function(){"use strict";n.r(r),n.d(r,{AuthenticatorKey:function(){return v.pc},EmailRole:function(){return g.aw},IdxFeature:function(){return v.Fw},IdxStatus:function(){return v.Qd},OktaAuth:function(){return x},PasswordStatus:function(){return g.Fn},Status:function(){return g.qb},addEmail:function(){return g.no},addPhone:function(){return g.Z1},authenticate:function(){return v.YR},canProceed:function(){return v.Ch},cancel:function(){return v.al},clearTransactionMeta:function(){return v.Jm},createAuthnTransactionAPI:function(){return y.b},createIdxAPI:function(){return v.F4},createIdxOptionsConstructor:function(){return v.SL},createIdxStorageManager:function(){return v.aT},createIdxTransactionManager:function(){return v.vK},createMinimalOktaAuthIdx:function(){return v.UB},createOktaAuthIdx:function(){return v.Yn},createOktaAuthMyAccount:function(){return g.Xc},createTransactionMeta:function(){return v.Xc},deleteEmail:function(){return g.nd},deletePassword:function(){return g.QN},deletePhone:function(){return g.qj},enrollPassword:function(){return g.xg},getEmail:function(){return g.OD},getEmailChallenge:function(){return g.hG},getEmails:function(){return g.G5},getPassword:function(){return g.Ij},getPhone:function(){return g.u_},getPhones:function(){return g.Po},getProfile:function(){return g.Ai},getProfileSchema:function(){return g.aF},getSavedTransactionMeta:function(){return v.uN},getTransactionMeta:function(){return v.Co},handleEmailVerifyCallback:function(){return v.Jn},handleInteractionCodeRedirect:function(){return v.Xx},hasSavedInteractionHandle:function(){return v.$0},interact:function(){return v.EW},introspect:function(){return v.L8},isAuthenticator:function(){return v.H},isEmailVerifyCallback:function(){return v.GA},isEmailVerifyCallbackError:function(){return v.gc},isTransactionMetaValid:function(){return v.Wf},isTransactionMetaValidForFlow:function(){return v.bl},isTransactionMetaValidForOptions:function(){return v.UC},mixinAuthn:function(){return y.t},mixinIdx:function(){return v.B_},mixinMyAccount:function(){return g.HT},parseEmailVerifyCallback:function(){return v.mo},poll:function(){return v.$l},proceed:function(){return v.xc},recoverPassword:function(){return v.M4},register:function(){return v.z2},saveTransactionMeta:function(){return v.r0},sendEmailChallenge:function(){return g.ME},sendPhoneChallenge:function(){return g.dv},startTransaction:function(){return v.Yr},unlockAccount:function(){return v.le},updatePassword:function(){return g.gQ},updateProfile:function(){return g.ck},verifyEmailChallenge:function(){return g.T8},verifyPhoneChallenge:function(){return g.Lo}});var e=n(3144),t=n(5671),o=n(136),i=n(2963),a=n(1120),s=n(4602),l=n(4143),u=n(3334),c=n(2144),d=n(6794),f=n(3164),p=n(6736),h={};for(var m in p)["default","OktaAuth"].indexOf(m)<0&&(h[m]=function(e){return p[e]}.bind(0,m));n.d(r,h);var v=n(9999),g=n(1132),y=n(3398),b=(0,s.S)(),w=(0,l.a)(),_=(0,u.v)(),O=(0,c.Y)(w,b,_),k=(0,d.H)(O),x=function(n){(0,o.Z)(u,n);var r,s,l=(r=u,s=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,a.Z)(r);if(s){var n=(0,a.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,i.Z)(this,e)});function u(e){return(0,t.Z)(this,u),l.call(this,e)}return(0,e.Z)(u)}((0,f.t)(k));r.default=x}(),r}()},35676:function(e,t,n){var r,o,i;o=[e,n(27444)],r=function(e,t){"use strict";var n=r(t);function r(e){return e&&e.__esModule?e:{default:e}}var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=function(){function e(t){i(this,e),this.resolveOptions(t),this.initSelection()}return a(e,[{key:"resolveOptions",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=e.action,this.container=e.container,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""}},{key:"initSelection",value:function(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function(){var e=this,t="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return e.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[t?"right":"left"]="-9999px";var r=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=r+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,n.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function(){this.selectedText=(0,n.default)(this.target),this.copyText()}},{key:"copyText",value:function(){var e=void 0;try{e=document.execCommand(this.action)}catch(t){e=!1}this.handleResult(e)}},{key:"handleResult",value:function(e){this.emitter.emit(e?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function(){this.removeFake()}},{key:"action",set:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function(){return this._action}},{key:"target",set:function(e){if(void 0!==e){if(!e||"object"!==(void 0===e?"undefined":o(e))||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=e}},get:function(){return this._target}}]),e}();e.exports=s},void 0===(i="function"==typeof r?r.apply(t,o):r)||(e.exports=i)},35237:function(e,t,n){var r,o,i;o=[e,n(35676),n(10226),n(21617)],r=function(e,t,n,r){"use strict";var o=s(t),i=s(n),a=s(r);function s(e){return e&&e.__esModule?e:{default:e}}var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};function u(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();function d(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function f(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}var p=function(e){function t(e,n){u(this,t);var r=d(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return r.resolveOptions(n),r.listenClick(e),r}return f(t,e),c(t,[{key:"resolveOptions",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText,this.container="object"===l(e.container)?e.container:document.body}},{key:"listenClick",value:function(e){var t=this;this.listener=(0,a.default)(e,"click",(function(e){return t.onClick(e)}))}},{key:"onClick",value:function(e){var t=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new o.default({action:this.action(t),target:this.target(t),text:this.text(t),container:this.container,trigger:t,emitter:this})}},{key:"defaultAction",value:function(e){return h("action",e)}},{key:"defaultTarget",value:function(e){var t=h("target",e);if(t)return document.querySelector(t)}},{key:"defaultText",value:function(e){return h("text",e)}},{key:"destroy",value:function(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],t="string"==typeof e?[e]:e,n=!!document.queryCommandSupported;return t.forEach((function(e){n=n&&!!document.queryCommandSupported(e)})),n}}]),t}(i.default);function h(e,t){var n="data-clipboard-"+e;if(t.hasAttribute(n))return t.getAttribute(n)}e.exports=p},void 0===(i="function"==typeof r?r.apply(t,o):r)||(e.exports=i)},16451:function(e,t,n){var r=n(54068);e.exports=r},93582:function(e,t,n){var r=n(18209);e.exports=r},10233:function(e,t,n){var r=n(7866);e.exports=r},80048:function(e,t,n){var r=n(82903);e.exports=r},97558:function(e,t,n){var r=n(25207);e.exports=r},53371:function(e,t,n){var r=n(15836);e.exports=r},75626:function(e,t,n){var r=n(31227);e.exports=r},96087:function(e,t,n){var r=n(57650);e.exports=r},72836:function(e,t,n){var r=n(71081);e.exports=r},91645:function(e,t,n){var r=n(9956);e.exports=r},90524:function(e,t,n){var r=n(47255);e.exports=r},16508:function(e,t,n){var r=n(67437);e.exports=r},74621:function(e,t,n){var r=n(55458);e.exports=r},27892:function(e,t,n){var r=n(52653);e.exports=r},69601:function(e,t,n){n(90079);var r=n(40926);e.exports=r("Array","findIndex")},93504:function(e,t,n){n(97514);var r=n(40926);e.exports=r("Array","find")},79391:function(e,t,n){n(58281),n(11765);var r=n(11206);e.exports=r.Array.from},47446:function(e,t,n){n(58028);var r=n(40926);e.exports=r("Array","includes")},89452:function(e,t,n){n(18756);var r=n(11206);e.exports=r.Object.assign},15369:function(e,t,n){n(13489);var r=n(11206);e.exports=r.Object.entries},95680:function(e,t,n){n(81755),n(25384);var r=n(11206);e.exports=r.Object.fromEntries},79749:function(e,t,n){n(37309);var r=n(11206);e.exports=r.Object.keys},87362:function(e,t,n){n(96698);var r=n(11206);e.exports=r.Object.setPrototypeOf},83043:function(e,t,n){n(59883);var r=n(11206);e.exports=r.Object.values},42075:function(e,t,n){n(94910),n(81755),n(14032),n(68067),n(77074),n(44455),n(80986),n(58281);var r=n(11206);e.exports=r.Promise},48506:function(e,t,n){n(81755),n(14032),n(76014),n(58281);var r=n(11206);e.exports=r.Set},47762:function(e,t,n){n(46358);var r=n(40926);e.exports=r("String","endsWith")},5694:function(e,t,n){n(47458);var r=n(40926);e.exports=r("String","includes")},5671:function(e,t,n){n(93875);var r=n(40926);e.exports=r("String","startsWith")},4154:function(e,t,n){n(81755),n(14032),n(58281),n(69330);var r=n(75960);e.exports=r.f("iterator")},99988:function(e,t,n){n(14032),n(58281),n(83326),n(50711),n(94095),n(73663),n(29883),n(35471),n(21012),n(88997),n(97464),n(93706),n(31519),n(2857),n(94715),n(13624),n(62514),n(24597),n(88042),n(4660),n(92451),n(44206),n(66288),n(13250),n(3858),n(84538),n(64793),n(74202),n(52529),n(91132)},72534:function(e,t,n){n(45004),n(29690),n(56912),n(99988);var r=n(32010);e.exports=r.Uint8Array},20845:function(e,t,n){n(81755),n(14032),n(78643);var r=n(11206);e.exports=r.WeakMap},560:function(e,t,n){e.exports=n(9374)},26397:function(e,t,n){e.exports=n(44719)},88150:function(e,t,n){e.exports=n(66668)},24611:function(e,t,n){e.exports=n(99473)},58603:function(e,t,n){e.exports=n(37617)},91512:function(e,t,n){e.exports=n(7390)},44799:function(e,t,n){e.exports=n(3509)},88991:function(e,t,n){e.exports=n(65081)},89691:function(e,t,n){e.exports=n(27253)},75497:function(e,t,n){e.exports=n(38483)},53950:function(e,t,n){e.exports=n(63300)},58245:function(e,t,n){e.exports=n(24267)},27672:function(e,t,n){e.exports=n(15766)},87971:function(e,t,n){e.exports=n(26673)},20697:function(e,t,n){e.exports=n(98619)},18470:function(e,t,n){e.exports=n(85416)},70257:function(e,t,n){e.exports=n(84015)},9374:function(e,t,n){var r=n(16451);e.exports=r},44719:function(e,t,n){var r=n(93582);e.exports=r},66668:function(e,t,n){var r=n(10233);e.exports=r},99473:function(e,t,n){var r=n(80048);e.exports=r},37617:function(e,t,n){var r=n(97558);e.exports=r},7390:function(e,t,n){var r=n(53371);e.exports=r},3509:function(e,t,n){var r=n(75626);e.exports=r},65081:function(e,t,n){n(27217);var r=n(11206);e.exports=r.Object.iterateEntries},27253:function(e,t,n){n(60573);var r=n(11206);e.exports=r.Object.iterateKeys},38483:function(e,t,n){n(8843);var r=n(11206);e.exports=r.Object.iterateValues},63300:function(e,t,n){var r=n(96087);e.exports=r},24267:function(e,t,n){var r=n(72836);e.exports=r},15766:function(e,t,n){var r=n(91645);e.exports=r},26673:function(e,t,n){var r=n(90524);e.exports=r},98619:function(e,t,n){var r=n(16508);e.exports=r},85416:function(e,t,n){var r=n(74621);e.exports=r},84015:function(e,t,n){var r=n(27892);e.exports=r},32631:function(e,t,n){var r=n(94578),o=n(68664),i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not a function")}},69075:function(e,t,n){var r=n(20884),o=n(68664),i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not a constructor")}},58659:function(e,t,n){var r=n(94578),o=String,i=TypeError;e.exports=function(e){if("object"==typeof e||r(e))return e;throw i("Can't set "+o(e)+" as a prototype")}},71156:function(e,t,n){var r=n(38688),o=n(10819),i=n(95892).f,a=r("unscopables"),s=Array.prototype;null==s[a]&&i(s,a,{configurable:!0,value:o(null)}),e.exports=function(e){s[a][e]=!0}},2868:function(e,t,n){var r=n(70176),o=TypeError;e.exports=function(e,t){if(r(t,e))return e;throw o("Incorrect invocation")}},34984:function(e,t,n){var r=n(24517),o=String,i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not an object")}},33002:function(e){e.exports="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof DataView},60687:function(e,t,n){var r=n(47044);e.exports=r((function(){if("function"==typeof ArrayBuffer){var e=new ArrayBuffer(8);Object.isExtensible(e)&&Object.defineProperty(e,"a",{value:8})}}))},95089:function(e,t,n){"use strict";var r,o,i,a=n(33002),s=n(15567),l=n(32010),u=n(94578),c=n(24517),d=n(20340),f=n(52564),p=n(68664),h=n(48914),m=n(79855),v=n(95892).f,g=n(70176),y=n(69548),b=n(3840),w=n(38688),_=n(46859),O=n(70172),k=O.enforce,x=O.get,E=l.Int8Array,T=E&&E.prototype,S=l.Uint8ClampedArray,A=S&&S.prototype,P=E&&y(E),C=T&&y(T),R=Object.prototype,I=l.TypeError,N=w("toStringTag"),M=_("TYPED_ARRAY_TAG"),j="TypedArrayConstructor",D=a&&!!b&&"Opera"!==f(l.opera),L=!1,U={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},F={BigInt64Array:8,BigUint64Array:8},B=function(e){var t=y(e);if(c(t)){var n=x(t);return n&&d(n,j)?n.TypedArrayConstructor:B(t)}},V=function(e){if(!c(e))return!1;var t=f(e);return d(U,t)||d(F,t)};for(r in U)(i=(o=l[r])&&o.prototype)?k(i).TypedArrayConstructor=o:D=!1;for(r in F)(i=(o=l[r])&&o.prototype)&&(k(i).TypedArrayConstructor=o);if((!D||!u(P)||P===Function.prototype)&&(P=function(){throw I("Incorrect invocation")},D))for(r in U)l[r]&&b(l[r],P);if((!D||!C||C===R)&&(C=P.prototype,D))for(r in U)l[r]&&b(l[r].prototype,C);if(D&&y(A)!==C&&b(A,C),s&&!d(C,N))for(r in L=!0,v(C,N,{get:function(){return c(this)?this[M]:void 0}}),U)l[r]&&h(l[r],M,r);e.exports={NATIVE_ARRAY_BUFFER_VIEWS:D,TYPED_ARRAY_TAG:L&&M,aTypedArray:function(e){if(V(e))return e;throw I("Target is not a typed array")},aTypedArrayConstructor:function(e){if(u(e)&&(!b||g(P,e)))return e;throw I(p(e)+" is not a typed array constructor")},exportTypedArrayMethod:function(e,t,n,r){if(s){if(n)for(var o in U){var i=l[o];if(i&&d(i.prototype,e))try{delete i.prototype[e]}catch(n){try{i.prototype[e]=t}catch(e){}}}C[e]&&!n||m(C,e,n?t:D&&T[e]||t,r)}},exportTypedArrayStaticMethod:function(e,t,n){var r,o;if(s){if(b){if(n)for(r in U)if((o=l[r])&&d(o,e))try{delete o[e]}catch(e){}if(P[e]&&!n)return;try{return m(P,e,n?t:D&&P[e]||t)}catch(e){}}for(r in U)!(o=l[r])||o[e]&&!n||m(o,e,t)}},getTypedArrayConstructor:B,isView:function(e){if(!c(e))return!1;var t=f(e);return"DataView"===t||d(U,t)||d(F,t)},isTypedArray:V,TypedArray:P,TypedArrayPrototype:C}},69351:function(e,t,n){"use strict";var r=n(32010),o=n(38347),i=n(15567),a=n(33002),s=n(7081),l=n(48914),u=n(85994),c=n(47044),d=n(2868),f=n(26882),p=n(23417),h=n(71265),m=n(64397),v=n(69548),g=n(3840),y=n(6611).f,b=n(95892).f,w=n(72864),_=n(45258),O=n(15216),k=n(70172),x=s.PROPER,E=s.CONFIGURABLE,T=k.get,S=k.set,A="ArrayBuffer",P="DataView",C="Wrong index",R=r.ArrayBuffer,I=R,N=I&&I.prototype,M=r.DataView,j=M&&M.prototype,D=Object.prototype,L=r.Array,U=r.RangeError,F=o(w),B=o([].reverse),V=m.pack,Z=m.unpack,H=function(e){return[255&e]},q=function(e){return[255&e,e>>8&255]},W=function(e){return[255&e,e>>8&255,e>>16&255,e>>24&255]},K=function(e){return e[3]<<24|e[2]<<16|e[1]<<8|e[0]},$=function(e){return V(e,23,4)},z=function(e){return V(e,52,8)},Y=function(e,t){b(e.prototype,t,{get:function(){return T(this)[t]}})},G=function(e,t,n,r){var o=h(n),i=T(e);if(o+t>i.byteLength)throw U(C);var a=T(i.buffer).bytes,s=o+i.byteOffset,l=_(a,s,s+t);return r?l:B(l)},J=function(e,t,n,r,o,i){var a=h(n),s=T(e);if(a+t>s.byteLength)throw U(C);for(var l=T(s.buffer).bytes,u=a+s.byteOffset,c=r(+o),d=0;d<t;d++)l[u+d]=c[i?d:t-d-1]};if(a){var Q=x&&R.name!==A;if(c((function(){R(1)}))&&c((function(){new R(-1)}))&&!c((function(){return new R,new R(1.5),new R(NaN),1!=R.length||Q&&!E})))Q&&E&&l(R,"name",A);else{(I=function(e){return d(this,N),new R(h(e))}).prototype=N;for(var X,ee=y(R),te=0;ee.length>te;)(X=ee[te++])in I||l(I,X,R[X]);N.constructor=I}g&&v(j)!==D&&g(j,D);var ne=new M(new I(2)),re=o(j.setInt8);ne.setInt8(0,2147483648),ne.setInt8(1,2147483649),!ne.getInt8(0)&&ne.getInt8(1)||u(j,{setInt8:function(e,t){re(this,e,t<<24>>24)},setUint8:function(e,t){re(this,e,t<<24>>24)}},{unsafe:!0})}else N=(I=function(e){d(this,N);var t=h(e);S(this,{bytes:F(L(t),0),byteLength:t}),i||(this.byteLength=t)}).prototype,j=(M=function(e,t,n){d(this,j),d(e,N);var r=T(e).byteLength,o=f(t);if(o<0||o>r)throw U("Wrong offset");if(o+(n=void 0===n?r-o:p(n))>r)throw U("Wrong length");S(this,{buffer:e,byteLength:n,byteOffset:o}),i||(this.buffer=e,this.byteLength=n,this.byteOffset=o)}).prototype,i&&(Y(I,"byteLength"),Y(M,"buffer"),Y(M,"byteLength"),Y(M,"byteOffset")),u(j,{getInt8:function(e){return G(this,1,e)[0]<<24>>24},getUint8:function(e){return G(this,1,e)[0]},getInt16:function(e){var t=G(this,2,e,arguments.length>1?arguments[1]:void 0);return(t[1]<<8|t[0])<<16>>16},getUint16:function(e){var t=G(this,2,e,arguments.length>1?arguments[1]:void 0);return t[1]<<8|t[0]},getInt32:function(e){return K(G(this,4,e,arguments.length>1?arguments[1]:void 0))},getUint32:function(e){return K(G(this,4,e,arguments.length>1?arguments[1]:void 0))>>>0},getFloat32:function(e){return Z(G(this,4,e,arguments.length>1?arguments[1]:void 0),23)},getFloat64:function(e){return Z(G(this,8,e,arguments.length>1?arguments[1]:void 0),52)},setInt8:function(e,t){J(this,1,e,H,t)},setUint8:function(e,t){J(this,1,e,H,t)},setInt16:function(e,t){J(this,2,e,q,t,arguments.length>2?arguments[2]:void 0)},setUint16:function(e,t){J(this,2,e,q,t,arguments.length>2?arguments[2]:void 0)},setInt32:function(e,t){J(this,4,e,W,t,arguments.length>2?arguments[2]:void 0)},setUint32:function(e,t){J(this,4,e,W,t,arguments.length>2?arguments[2]:void 0)},setFloat32:function(e,t){J(this,4,e,$,t,arguments.length>2?arguments[2]:void 0)},setFloat64:function(e,t){J(this,8,e,z,t,arguments.length>2?arguments[2]:void 0)}});O(I,A),O(M,P),e.exports={ArrayBuffer:I,DataView:M}},92642:function(e,t,n){"use strict";var r=n(43162),o=n(74841),i=n(45495),a=n(10303),s=Math.min;e.exports=[].copyWithin||function(e,t){var n=r(this),l=i(n),u=o(e,l),c=o(t,l),d=arguments.length>2?arguments[2]:void 0,f=s((void 0===d?l:o(d,l))-c,l-u),p=1;for(c<u&&u<c+f&&(p=-1,c+=f-1,u+=f-1);f-- >0;)c in n?n[u]=n[c]:a(n,u),u+=p,c+=p;return n}},72864:function(e,t,n){"use strict";var r=n(43162),o=n(74841),i=n(45495);e.exports=function(e){for(var t=r(this),n=i(t),a=arguments.length,s=o(a>1?arguments[1]:void 0,n),l=a>2?arguments[2]:void 0,u=void 0===l?n:o(l,n);u>s;)t[s++]=e;return t}},34269:function(e,t,n){var r=n(45495);e.exports=function(e,t){for(var n=0,o=r(t),i=new e(o);o>n;)i[n]=t[n++];return i}},95717:function(e,t,n){"use strict";var r=n(25567),o=n(2834),i=n(43162),a=n(97738),s=n(89564),l=n(20884),u=n(45495),c=n(38639),d=n(15892),f=n(13872),p=Array;e.exports=function(e){var t=i(e),n=l(this),h=arguments.length,m=h>1?arguments[1]:void 0,v=void 0!==m;v&&(m=r(m,h>2?arguments[2]:void 0));var g,y,b,w,_,O,k=f(t),x=0;if(!k||this===p&&s(k))for(g=u(t),y=n?new this(g):p(g);g>x;x++)O=v?m(t[x],x):t[x],c(y,x,O);else for(_=(w=d(t,k)).next,y=n?new this:[];!(b=o(_,w)).done;x++)O=v?a(w,m,[b.value,x],!0):b.value,c(y,x,O);return y.length=x,y}},12636:function(e,t,n){var r=n(98086),o=n(74841),i=n(45495),a=function(e){return function(t,n,a){var s,l=r(t),u=i(l),c=o(a,u);if(e&&n!=n){for(;u>c;)if((s=l[c++])!=s)return!0}else for(;u>c;c++)if((e||c in l)&&l[c]===n)return e||c||0;return!e&&-1}};e.exports={includes:a(!0),indexOf:a(!1)}},88828:function(e,t,n){var r=n(25567),o=n(7514),i=n(43162),a=n(45495),s=function(e){var t=1==e;return function(n,s,l){for(var u,c=i(n),d=o(c),f=r(s,l),p=a(d);p-- >0;)if(f(u=d[p],p,c))switch(e){case 0:return u;case 1:return p}return t?-1:void 0}};e.exports={findLast:s(0),findLastIndex:s(1)}},91102:function(e,t,n){var r=n(25567),o=n(38347),i=n(7514),a=n(43162),s=n(45495),l=n(45744),u=o([].push),c=function(e){var t=1==e,n=2==e,o=3==e,c=4==e,d=6==e,f=7==e,p=5==e||d;return function(h,m,v,g){for(var y,b,w=a(h),_=i(w),O=r(m,v),k=s(_),x=0,E=g||l,T=t?E(h,k):n||f?E(h,0):void 0;k>x;x++)if((p||x in _)&&(b=O(y=_[x],x,w),e))if(t)T[x]=b;else if(b)switch(e){case 3:return!0;case 5:return y;case 6:return x;case 2:u(T,y)}else switch(e){case 4:return!1;case 7:u(T,y)}return d?-1:o||c?c:T}};e.exports={forEach:c(0),map:c(1),filter:c(2),some:c(3),every:c(4),find:c(5),findIndex:c(6),filterReject:c(7)}},84320:function(e,t,n){"use strict";var r=n(58448),o=n(98086),i=n(26882),a=n(45495),s=n(81007),l=Math.min,u=[].lastIndexOf,c=!!u&&1/[1].lastIndexOf(1,-0)<0,d=s("lastIndexOf"),f=c||!d;e.exports=f?function(e){if(c)return r(u,this,arguments)||0;var t=o(this),n=a(t),s=n-1;for(arguments.length>1&&(s=l(s,i(arguments[1]))),s<0&&(s=n+s);s>=0;s--)if(s in t&&t[s]===e)return s||0;return-1}:u},81007:function(e,t,n){"use strict";var r=n(47044);e.exports=function(e,t){var n=[][e];return!!n&&r((function(){n.call(null,t||function(){return 1},1)}))}},32843:function(e,t,n){var r=n(32631),o=n(43162),i=n(7514),a=n(45495),s=TypeError,l=function(e){return function(t,n,l,u){r(n);var c=o(t),d=i(c),f=a(c),p=e?f-1:0,h=e?-1:1;if(l<2)for(;;){if(p in d){u=d[p],p+=h;break}if(p+=h,e?p<0:f<=p)throw s("Reduce of empty array with no initial value")}for(;e?p>=0:f>p;p+=h)p in d&&(u=n(u,d[p],p,c));return u}};e.exports={left:l(!1),right:l(!0)}},45258:function(e,t,n){var r=n(74841),o=n(45495),i=n(38639),a=Array,s=Math.max;e.exports=function(e,t,n){for(var l=o(e),u=r(t,l),c=r(void 0===n?l:n,l),d=a(s(c-u,0)),f=0;u<c;u++,f++)i(d,f,e[u]);return d.length=f,d}},73163:function(e,t,n){var r=n(38347);e.exports=r([].slice)},43977:function(e,t,n){var r=n(45258),o=Math.floor,i=function(e,t){var n=e.length,l=o(n/2);return n<8?a(e,t):s(e,i(r(e,0,l),t),i(r(e,l),t),t)},a=function(e,t){for(var n,r,o=e.length,i=1;i<o;){for(r=i,n=e[i];r&&t(e[r-1],n)>0;)e[r]=e[--r];r!==i++&&(e[r]=n)}return e},s=function(e,t,n,r){for(var o=t.length,i=n.length,a=0,s=0;a<o||s<i;)e[a+s]=a<o&&s<i?r(t[a],n[s])<=0?t[a++]:n[s++]:a<o?t[a++]:n[s++];return e};e.exports=i},98578:function(e,t,n){var r=n(59113),o=n(20884),i=n(24517),a=n(38688)("species"),s=Array;e.exports=function(e){var t;return r(e)&&(t=e.constructor,(o(t)&&(t===s||r(t.prototype))||i(t)&&null===(t=t[a]))&&(t=void 0)),void 0===t?s:t}},45744:function(e,t,n){var r=n(98578);e.exports=function(e,t){return new(r(e))(0===t?0:t)}},97738:function(e,t,n){var r=n(34984),o=n(50194);e.exports=function(e,t,n,i){try{return i?t(r(n)[0],n[1]):t(n)}catch(t){o(e,"throw",t)}}},46769:function(e,t,n){var r=n(38688)("iterator"),o=!1;try{var i=0,a={next:function(){return{done:!!i++}},return:function(){o=!0}};a[r]=function(){return this},Array.from(a,(function(){throw 2}))}catch(e){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var i={};i[r]=function(){return{next:function(){return{done:n=!0}}}},e(i)}catch(e){}return n}},93975:function(e,t,n){var r=n(38347),o=r({}.toString),i=r("".slice);e.exports=function(e){return i(o(e),8,-1)}},52564:function(e,t,n){var r=n(24663),o=n(94578),i=n(93975),a=n(38688)("toStringTag"),s=Object,l="Arguments"==i(function(){return arguments}());e.exports=r?i:function(e){var t,n,r;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t]}catch(e){}}(t=s(e),a))?n:l?i(t):"Object"==(r=i(t))&&o(t.callee)?"Arguments":r}},9649:function(e,t,n){"use strict";var r=n(95892).f,o=n(10819),i=n(85994),a=n(25567),s=n(2868),l=n(35576),u=n(80383),c=n(11231),d=n(19110),f=n(51334),p=n(15567),h=n(62148).fastKey,m=n(70172),v=m.set,g=m.getterFor;e.exports={getConstructor:function(e,t,n,c){var d=e((function(e,r){s(e,f),v(e,{type:t,index:o(null),first:void 0,last:void 0,size:0}),p||(e.size=0),l(r)||u(r,e[c],{that:e,AS_ENTRIES:n})})),f=d.prototype,m=g(t),y=function(e,t,n){var r,o,i=m(e),a=b(e,t);return a?a.value=n:(i.last=a={index:o=h(t,!0),key:t,value:n,previous:r=i.last,next:void 0,removed:!1},i.first||(i.first=a),r&&(r.next=a),p?i.size++:e.size++,"F"!==o&&(i.index[o]=a)),e},b=function(e,t){var n,r=m(e),o=h(t);if("F"!==o)return r.index[o];for(n=r.first;n;n=n.next)if(n.key==t)return n};return i(f,{clear:function(){for(var e=m(this),t=e.index,n=e.first;n;)n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete t[n.index],n=n.next;e.first=e.last=void 0,p?e.size=0:this.size=0},delete:function(e){var t=this,n=m(t),r=b(t,e);if(r){var o=r.next,i=r.previous;delete n.index[r.index],r.removed=!0,i&&(i.next=o),o&&(o.previous=i),n.first==r&&(n.first=o),n.last==r&&(n.last=i),p?n.size--:t.size--}return!!r},forEach:function(e){for(var t,n=m(this),r=a(e,arguments.length>1?arguments[1]:void 0);t=t?t.next:n.first;)for(r(t.value,t.key,this);t&&t.removed;)t=t.previous},has:function(e){return!!b(this,e)}}),i(f,n?{get:function(e){var t=b(this,e);return t&&t.value},set:function(e,t){return y(this,0===e?0:e,t)}}:{add:function(e){return y(this,e=0===e?0:e,e)}}),p&&r(f,"size",{get:function(){return m(this).size}}),d},setStrong:function(e,t,n){var r=t+" Iterator",o=g(t),i=g(r);c(e,t,(function(e,t){v(this,{type:r,target:e,state:o(e),kind:t,last:void 0})}),(function(){for(var e=i(this),t=e.kind,n=e.last;n&&n.removed;)n=n.previous;return e.target&&(e.last=n=n?n.next:e.state.first)?d("keys"==t?n.key:"values"==t?n.value:[n.key,n.value],!1):(e.target=void 0,d(void 0,!0))}),n?"entries":"values",!n,!0),f(t)}}},79206:function(e,t,n){"use strict";var r=n(38347),o=n(85994),i=n(62148).getWeakData,a=n(2868),s=n(34984),l=n(35576),u=n(24517),c=n(80383),d=n(91102),f=n(20340),p=n(70172),h=p.set,m=p.getterFor,v=d.find,g=d.findIndex,y=r([].splice),b=0,w=function(e){return e.frozen||(e.frozen=new _)},_=function(){this.entries=[]},O=function(e,t){return v(e.entries,(function(e){return e[0]===t}))};_.prototype={get:function(e){var t=O(this,e);if(t)return t[1]},has:function(e){return!!O(this,e)},set:function(e,t){var n=O(this,e);n?n[1]=t:this.entries.push([e,t])},delete:function(e){var t=g(this.entries,(function(t){return t[0]===e}));return~t&&y(this.entries,t,1),!!~t}},e.exports={getConstructor:function(e,t,n,r){var d=e((function(e,o){a(e,p),h(e,{type:t,id:b++,frozen:void 0}),l(o)||c(o,e[r],{that:e,AS_ENTRIES:n})})),p=d.prototype,v=m(t),g=function(e,t,n){var r=v(e),o=i(s(t),!0);return!0===o?w(r).set(t,n):o[r.id]=n,e};return o(p,{delete:function(e){var t=v(this);if(!u(e))return!1;var n=i(e);return!0===n?w(t).delete(e):n&&f(n,t.id)&&delete n[t.id]},has:function(e){var t=v(this);if(!u(e))return!1;var n=i(e);return!0===n?w(t).has(e):n&&f(n,t.id)}}),o(p,n?{get:function(e){var t=v(this);if(u(e)){var n=i(e);return!0===n?w(t).get(e):n?n[t.id]:void 0}},set:function(e,t){return g(this,e,t)}}:{add:function(e){return g(this,e,!0)}}),d}}},36673:function(e,t,n){"use strict";var r=n(56475),o=n(32010),i=n(38347),a=n(39599),s=n(79855),l=n(62148),u=n(80383),c=n(2868),d=n(94578),f=n(35576),p=n(24517),h=n(47044),m=n(46769),v=n(15216),g=n(51868);e.exports=function(e,t,n){var y=-1!==e.indexOf("Map"),b=-1!==e.indexOf("Weak"),w=y?"set":"add",_=o[e],O=_&&_.prototype,k=_,x={},E=function(e){var t=i(O[e]);s(O,e,"add"==e?function(e){return t(this,0===e?0:e),this}:"delete"==e?function(e){return!(b&&!p(e))&&t(this,0===e?0:e)}:"get"==e?function(e){return b&&!p(e)?void 0:t(this,0===e?0:e)}:"has"==e?function(e){return!(b&&!p(e))&&t(this,0===e?0:e)}:function(e,n){return t(this,0===e?0:e,n),this})};if(a(e,!d(_)||!(b||O.forEach&&!h((function(){(new _).entries().next()})))))k=n.getConstructor(t,e,y,w),l.enable();else if(a(e,!0)){var T=new k,S=T[w](b?{}:-0,1)!=T,A=h((function(){T.has(1)})),P=m((function(e){new _(e)})),C=!b&&h((function(){for(var e=new _,t=5;t--;)e[w](t,t);return!e.has(-0)}));P||((k=t((function(e,t){c(e,O);var n=g(new _,e,k);return f(t)||u(t,n[w],{that:n,AS_ENTRIES:y}),n}))).prototype=O,O.constructor=k),(A||C)&&(E("delete"),E("has"),y&&E("get")),(C||S)&&E(w),b&&O.clear&&delete O.clear}return x[e]=k,r({global:!0,constructor:!0,forced:k!=_},x),v(k,e),b||n.setStrong(k,e,y),k}},2675:function(e,t,n){var r=n(20340),o=n(21594),i=n(72062),a=n(95892);e.exports=function(e,t,n){for(var s=o(t),l=a.f,u=i.f,c=0;c<s.length;c++){var d=s[c];r(e,d)||n&&r(n,d)||l(e,d,u(t,d))}}},91151:function(e,t,n){var r=n(38688)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,"/./"[e](t)}catch(e){}}return!1}},68494:function(e,t,n){var r=n(47044);e.exports=!r((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype}))},19110:function(e){e.exports=function(e,t){return{value:e,done:t}}},48914:function(e,t,n){var r=n(15567),o=n(95892),i=n(97841);e.exports=r?function(e,t,n){return o.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},97841:function(e){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},38639:function(e,t,n){"use strict";var r=n(63918),o=n(95892),i=n(97841);e.exports=function(e,t,n){var a=r(t);a in e?o.f(e,a,i(0,n)):e[a]=n}},16395:function(e,t,n){var r=n(7344),o=n(95892);e.exports=function(e,t,n){return n.get&&r(n.get,t,{getter:!0}),n.set&&r(n.set,t,{setter:!0}),o.f(e,t,n)}},79855:function(e,t,n){var r=n(94578),o=n(95892),i=n(7344),a=n(63036);e.exports=function(e,t,n,s){s||(s={});var l=s.enumerable,u=void 0!==s.name?s.name:t;if(r(n)&&i(n,u,s),s.global)l?e[t]=n:a(t,n);else{try{s.unsafe?e[t]&&(l=!0):delete e[t]}catch(e){}l?e[t]=n:o.f(e,t,{value:n,enumerable:!1,configurable:!s.nonConfigurable,writable:!s.nonWritable})}return e}},85994:function(e,t,n){var r=n(79855);e.exports=function(e,t,n){for(var o in t)r(e,o,t[o],n);return e}},63036:function(e,t,n){var r=n(32010),o=Object.defineProperty;e.exports=function(e,t){try{o(r,e,{value:t,configurable:!0,writable:!0})}catch(n){r[e]=t}return t}},10303:function(e,t,n){"use strict";var r=n(68664),o=TypeError;e.exports=function(e,t){if(!delete e[t])throw o("Cannot delete property "+r(t)+" of "+r(e))}},15567:function(e,t,n){var r=n(47044);e.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},5410:function(e){var t="object"==typeof document&&document.all,n=void 0===t&&void 0!==t;e.exports={all:t,IS_HTMLDDA:n}},12072:function(e,t,n){var r=n(32010),o=n(24517),i=r.document,a=o(i)&&o(i.createElement);e.exports=function(e){return a?i.createElement(e):{}}},23327:function(e){e.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},67797:function(e,t,n){var r=n(12072)("span").classList,o=r&&r.constructor&&r.constructor.prototype;e.exports=o===Object.prototype?void 0:o},3809:function(e,t,n){var r=n(40715).match(/firefox\/(\d+)/i);e.exports=!!r&&+r[1]},3157:function(e,t,n){var r=n(95953),o=n(95053);e.exports=!r&&!o&&"object"==typeof window&&"object"==typeof document},95953:function(e){e.exports="object"==typeof Deno&&Deno&&"object"==typeof Deno.version},21983:function(e,t,n){var r=n(40715);e.exports=/MSIE|Trident/.test(r)},70573:function(e,t,n){var r=n(40715),o=n(32010);e.exports=/ipad|iphone|ipod/i.test(r)&&void 0!==o.Pebble},17716:function(e,t,n){var r=n(40715);e.exports=/(?:ipad|iphone|ipod).*applewebkit/i.test(r)},95053:function(e,t,n){var r=n(93975),o=n(32010);e.exports="process"==r(o.process)},664:function(e,t,n){var r=n(40715);e.exports=/web0s(?!.*chrome)/i.test(r)},40715:function(e,t,n){var r=n(38486);e.exports=r("navigator","userAgent")||""},70091:function(e,t,n){var r,o,i=n(32010),a=n(40715),s=i.process,l=i.Deno,u=s&&s.versions||l&&l.version,c=u&&u.v8;c&&(o=(r=c.split("."))[0]>0&&r[0]<4?1:+(r[0]+r[1])),!o&&a&&(!(r=a.match(/Edge\/(\d+)/))||r[1]>=74)&&(r=a.match(/Chrome\/(\d+)/))&&(o=+r[1]),e.exports=o},41731:function(e,t,n){var r=n(40715).match(/AppleWebKit\/(\d+)\./);e.exports=!!r&&+r[1]},40926:function(e,t,n){var r=n(32010),o=n(38347);e.exports=function(e,t){return o(r[e].prototype[t])}},2416:function(e){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},52362:function(e,t,n){var r=n(38347),o=Error,i=r("".replace),a=String(o("zxcasd").stack),s=/\n\s*at [^:]*:[^\n]*/,l=s.test(a);e.exports=function(e,t){if(l&&"string"==typeof e&&!o.prepareStackTrace)for(;t--;)e=i(e,s,"");return e}},45144:function(e,t,n){var r=n(47044),o=n(97841);e.exports=!r((function(){var e=Error("a");return!("stack"in e)||(Object.defineProperty(e,"stack",o(1,7)),7!==e.stack)}))},56475:function(e,t,n){var r=n(32010),o=n(72062).f,i=n(48914),a=n(79855),s=n(63036),l=n(2675),u=n(39599);e.exports=function(e,t){var n,c,d,f,p,h=e.target,m=e.global,v=e.stat;if(n=m?r:v?r[h]||s(h,{}):(r[h]||{}).prototype)for(c in t){if(f=t[c],d=e.dontCallGetSet?(p=o(n,c))&&p.value:n[c],!u(m?c:h+(v?".":"#")+c,e.forced)&&void 0!==d){if(typeof f==typeof d)continue;l(f,d)}(e.sham||d&&d.sham)&&i(f,"sham",!0),a(n,c,f,e)}}},47044:function(e){e.exports=function(e){try{return!!e()}catch(e){return!0}}},55481:function(e,t,n){var r=n(47044);e.exports=!r((function(){return Object.isExtensible(Object.preventExtensions({}))}))},58448:function(e,t,n){var r=n(3081),o=Function.prototype,i=o.apply,a=o.call;e.exports="object"==typeof Reflect&&Reflect.apply||(r?a.bind(i):function(){return a.apply(i,arguments)})},25567:function(e,t,n){var r=n(85233),o=n(32631),i=n(3081),a=r(r.bind);e.exports=function(e,t){return o(e),void 0===t?e:i?a(e,t):function(){return e.apply(t,arguments)}}},3081:function(e,t,n){var r=n(47044);e.exports=!r((function(){var e=function(){}.bind();return"function"!=typeof e||e.hasOwnProperty("prototype")}))},2834:function(e,t,n){var r=n(3081),o=Function.prototype.call;e.exports=r?o.bind(o):function(){return o.apply(o,arguments)}},7081:function(e,t,n){var r=n(15567),o=n(20340),i=Function.prototype,a=r&&Object.getOwnPropertyDescriptor,s=o(i,"name"),l=s&&"something"===function(){}.name,u=s&&(!r||r&&a(i,"name").configurable);e.exports={EXISTS:s,PROPER:l,CONFIGURABLE:u}},85233:function(e,t,n){var r=n(93975),o=n(38347);e.exports=function(e){if("Function"===r(e))return o(e)}},38347:function(e,t,n){var r=n(3081),o=Function.prototype,i=o.call,a=r&&o.bind.bind(i,i);e.exports=r?a:function(e){return function(){return i.apply(e,arguments)}}},38486:function(e,t,n){var r=n(32010),o=n(94578),i=function(e){return o(e)?e:void 0};e.exports=function(e,t){return arguments.length<2?i(r[e]):r[e]&&r[e][t]}},13872:function(e,t,n){var r=n(52564),o=n(51839),i=n(35576),a=n(15366),s=n(38688)("iterator");e.exports=function(e){if(!i(e))return o(e,s)||o(e,"@@iterator")||a[r(e)]}},15892:function(e,t,n){var r=n(2834),o=n(32631),i=n(34984),a=n(68664),s=n(13872),l=TypeError;e.exports=function(e,t){var n=arguments.length<2?s(e):t;if(o(n))return i(r(n,e));throw l(a(e)+" is not iterable")}},51839:function(e,t,n){var r=n(32631),o=n(35576);e.exports=function(e,t){var n=e[t];return o(n)?void 0:r(n)}},32010:function(e){var t=function(e){return e&&e.Math==Math&&e};e.exports=t("object"==typeof globalThis&&globalThis)||t("object"==typeof window&&window)||t("object"==typeof self&&self)||t("object"==typeof global&&global)||function(){return this}()||Function("return this")()},20340:function(e,t,n){var r=n(38347),o=n(43162),i=r({}.hasOwnProperty);e.exports=Object.hasOwn||function(e,t){return i(o(e),t)}},90682:function(e){e.exports={}},61144:function(e,t,n){var r=n(32010);e.exports=function(e,t){var n=r.console;n&&n.error&&(1==arguments.length?n.error(e):n.error(e,t))}},520:function(e,t,n){var r=n(38486);e.exports=r("document","documentElement")},18904:function(e,t,n){var r=n(15567),o=n(47044),i=n(12072);e.exports=!r&&!o((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},64397:function(e){var t=Array,n=Math.abs,r=Math.pow,o=Math.floor,i=Math.log,a=Math.LN2;e.exports={pack:function(e,s,l){var u,c,d,f=t(l),p=8*l-s-1,h=(1<<p)-1,m=h>>1,v=23===s?r(2,-24)-r(2,-77):0,g=e<0||0===e&&1/e<0?1:0,y=0;for((e=n(e))!=e||e===1/0?(c=e!=e?1:0,u=h):(u=o(i(e)/a),e*(d=r(2,-u))<1&&(u--,d*=2),(e+=u+m>=1?v/d:v*r(2,1-m))*d>=2&&(u++,d/=2),u+m>=h?(c=0,u=h):u+m>=1?(c=(e*d-1)*r(2,s),u+=m):(c=e*r(2,m-1)*r(2,s),u=0));s>=8;)f[y++]=255&c,c/=256,s-=8;for(u=u<<s|c,p+=s;p>0;)f[y++]=255&u,u/=256,p-=8;return f[--y]|=128*g,f},unpack:function(e,t){var n,o=e.length,i=8*o-t-1,a=(1<<i)-1,s=a>>1,l=i-7,u=o-1,c=e[u--],d=127&c;for(c>>=7;l>0;)d=256*d+e[u--],l-=8;for(n=d&(1<<-l)-1,d>>=-l,l+=t;l>0;)n=256*n+e[u--],l-=8;if(0===d)d=1-s;else{if(d===a)return n?NaN:c?-1/0:1/0;n+=r(2,t),d-=s}return(c?-1:1)*n*r(2,d-t)}}},7514:function(e,t,n){var r=n(38347),o=n(47044),i=n(93975),a=Object,s=r("".split);e.exports=o((function(){return!a("z").propertyIsEnumerable(0)}))?function(e){return"String"==i(e)?s(e,""):a(e)}:a},51868:function(e,t,n){var r=n(94578),o=n(24517),i=n(3840);e.exports=function(e,t,n){var a,s;return i&&r(a=t.constructor)&&a!==n&&o(s=a.prototype)&&s!==n.prototype&&i(e,s),e}},10447:function(e,t,n){var r=n(38347),o=n(94578),i=n(55480),a=r(Function.toString);o(i.inspectSource)||(i.inspectSource=function(e){return a(e)}),e.exports=i.inspectSource},87811:function(e,t,n){var r=n(24517),o=n(48914);e.exports=function(e,t){r(t)&&"cause"in t&&o(e,"cause",t.cause)}},62148:function(e,t,n){var r=n(56475),o=n(38347),i=n(90682),a=n(24517),s=n(20340),l=n(95892).f,u=n(6611),c=n(8807),d=n(31685),f=n(46859),p=n(55481),h=!1,m=f("meta"),v=0,g=function(e){l(e,m,{value:{objectID:"O"+v++,weakData:{}}})},y=e.exports={enable:function(){y.enable=function(){},h=!0;var e=u.f,t=o([].splice),n={};n[m]=1,e(n).length&&(u.f=function(n){for(var r=e(n),o=0,i=r.length;o<i;o++)if(r[o]===m){t(r,o,1);break}return r},r({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:c.f}))},fastKey:function(e,t){if(!a(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!s(e,m)){if(!d(e))return"F";if(!t)return"E";g(e)}return e[m].objectID},getWeakData:function(e,t){if(!s(e,m)){if(!d(e))return!0;if(!t)return!1;g(e)}return e[m].weakData},onFreeze:function(e){return p&&h&&d(e)&&!s(e,m)&&g(e),e}};i[m]=!0},70172:function(e,t,n){var r,o,i,a=n(2591),s=n(32010),l=n(24517),u=n(48914),c=n(20340),d=n(55480),f=n(82194),p=n(90682),h="Object already initialized",m=s.TypeError,v=s.WeakMap;if(a||d.state){var g=d.state||(d.state=new v);g.get=g.get,g.has=g.has,g.set=g.set,r=function(e,t){if(g.has(e))throw m(h);return t.facade=e,g.set(e,t),t},o=function(e){return g.get(e)||{}},i=function(e){return g.has(e)}}else{var y=f("state");p[y]=!0,r=function(e,t){if(c(e,y))throw m(h);return t.facade=e,u(e,y,t),t},o=function(e){return c(e,y)?e[y]:{}},i=function(e){return c(e,y)}}e.exports={set:r,get:o,has:i,enforce:function(e){return i(e)?o(e):r(e,{})},getterFor:function(e){return function(t){var n;if(!l(t)||(n=o(t)).type!==e)throw m("Incompatible receiver, "+e+" required");return n}}}},89564:function(e,t,n){var r=n(38688),o=n(15366),i=r("iterator"),a=Array.prototype;e.exports=function(e){return void 0!==e&&(o.Array===e||a[i]===e)}},59113:function(e,t,n){var r=n(93975);e.exports=Array.isArray||function(e){return"Array"==r(e)}},75542:function(e,t,n){var r=n(52564),o=n(38347)("".slice);e.exports=function(e){return"Big"===o(r(e),0,3)}},94578:function(e,t,n){var r=n(5410),o=r.all;e.exports=r.IS_HTMLDDA?function(e){return"function"==typeof e||e===o}:function(e){return"function"==typeof e}},20884:function(e,t,n){var r=n(38347),o=n(47044),i=n(94578),a=n(52564),s=n(38486),l=n(10447),u=function(){},c=[],d=s("Reflect","construct"),f=/^\s*(?:class|function)\b/,p=r(f.exec),h=!f.exec(u),m=function(e){if(!i(e))return!1;try{return d(u,c,e),!0}catch(e){return!1}},v=function(e){if(!i(e))return!1;switch(a(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}try{return h||!!p(f,l(e))}catch(e){return!0}};v.sham=!0,e.exports=!d||o((function(){var e;return m(m.call)||!m(Object)||!m((function(){e=!0}))||e}))?v:m},39599:function(e,t,n){var r=n(47044),o=n(94578),i=/#|\.prototype\./,a=function(e,t){var n=l[s(e)];return n==c||n!=u&&(o(t)?r(t):!!t)},s=a.normalize=function(e){return String(e).replace(i,".").toLowerCase()},l=a.data={},u=a.NATIVE="N",c=a.POLYFILL="P";e.exports=a},17506:function(e,t,n){var r=n(24517),o=Math.floor;e.exports=Number.isInteger||function(e){return!r(e)&&isFinite(e)&&o(e)===e}},35576:function(e){e.exports=function(e){return null==e}},24517:function(e,t,n){var r=n(94578),o=n(5410),i=o.all;e.exports=o.IS_HTMLDDA?function(e){return"object"==typeof e?null!==e:r(e)||e===i}:function(e){return"object"==typeof e?null!==e:r(e)}},63432:function(e){e.exports=!1},28831:function(e,t,n){var r=n(24517),o=n(93975),i=n(38688)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},46290:function(e,t,n){var r=n(38486),o=n(94578),i=n(70176),a=n(9567),s=Object;e.exports=a?function(e){return"symbol"==typeof e}:function(e){var t=r("Symbol");return o(t)&&i(t.prototype,s(e))}},80383:function(e,t,n){var r=n(25567),o=n(2834),i=n(34984),a=n(68664),s=n(89564),l=n(45495),u=n(70176),c=n(15892),d=n(13872),f=n(50194),p=TypeError,h=function(e,t){this.stopped=e,this.result=t},m=h.prototype;e.exports=function(e,t,n){var v,g,y,b,w,_,O,k=n&&n.that,x=!(!n||!n.AS_ENTRIES),E=!(!n||!n.IS_RECORD),T=!(!n||!n.IS_ITERATOR),S=!(!n||!n.INTERRUPTED),A=r(t,k),P=function(e){return v&&f(v,"normal",e),new h(!0,e)},C=function(e){return x?(i(e),S?A(e[0],e[1],P):A(e[0],e[1])):S?A(e,P):A(e)};if(E)v=e.iterator;else if(T)v=e;else{if(!(g=d(e)))throw p(a(e)+" is not iterable");if(s(g)){for(y=0,b=l(e);b>y;y++)if((w=C(e[y]))&&u(m,w))return w;return new h(!1)}v=c(e,g)}for(_=E?e.next:v.next;!(O=o(_,v)).done;){try{w=C(O.value)}catch(e){f(v,"throw",e)}if("object"==typeof w&&w&&u(m,w))return w}return new h(!1)}},50194:function(e,t,n){var r=n(2834),o=n(34984),i=n(51839);e.exports=function(e,t,n){var a,s;o(e);try{if(!(a=i(e,"return"))){if("throw"===t)throw n;return n}a=r(a,e)}catch(e){s=!0,a=e}if("throw"===t)throw n;if(s)throw a;return o(a),n}},83157:function(e,t,n){"use strict";var r=n(5844).IteratorPrototype,o=n(10819),i=n(97841),a=n(15216),s=n(15366),l=function(){return this};e.exports=function(e,t,n,u){var c=t+" Iterator";return e.prototype=o(r,{next:i(+!u,n)}),a(e,c,!1,!0),s[c]=l,e}},11231:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(63432),a=n(7081),s=n(94578),l=n(83157),u=n(69548),c=n(3840),d=n(15216),f=n(48914),p=n(79855),h=n(38688),m=n(15366),v=n(5844),g=a.PROPER,y=a.CONFIGURABLE,b=v.IteratorPrototype,w=v.BUGGY_SAFARI_ITERATORS,_=h("iterator"),O="keys",k="values",x="entries",E=function(){return this};e.exports=function(e,t,n,a,h,v,T){l(n,t,a);var S,A,P,C=function(e){if(e===h&&j)return j;if(!w&&e in N)return N[e];switch(e){case O:case k:case x:return function(){return new n(this,e)}}return function(){return new n(this)}},R=t+" Iterator",I=!1,N=e.prototype,M=N[_]||N["@@iterator"]||h&&N[h],j=!w&&M||C(h),D="Array"==t&&N.entries||M;if(D&&(S=u(D.call(new e)))!==Object.prototype&&S.next&&(i||u(S)===b||(c?c(S,b):s(S[_])||p(S,_,E)),d(S,R,!0,!0),i&&(m[R]=E)),g&&h==k&&M&&M.name!==k&&(!i&&y?f(N,"name",k):(I=!0,j=function(){return o(M,this)})),h)if(A={values:C(k),keys:v?j:C(O),entries:C(x)},T)for(P in A)(w||I||!(P in N))&&p(N,P,A[P]);else r({target:t,proto:!0,forced:w||I},A);return i&&!T||N[_]===j||p(N,_,j,{name:h}),m[t]=j,A}},5844:function(e,t,n){"use strict";var r,o,i,a=n(47044),s=n(94578),l=n(24517),u=n(10819),c=n(69548),d=n(79855),f=n(38688),p=n(63432),h=f("iterator"),m=!1;[].keys&&("next"in(i=[].keys())?(o=c(c(i)))!==Object.prototype&&(r=o):m=!0),!l(r)||a((function(){var e={};return r[h].call(e)!==e}))?r={}:p&&(r=u(r)),s(r[h])||d(r,h,(function(){return this})),e.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:m}},15366:function(e){e.exports={}},45495:function(e,t,n){var r=n(23417);e.exports=function(e){return r(e.length)}},7344:function(e,t,n){var r=n(47044),o=n(94578),i=n(20340),a=n(15567),s=n(7081).CONFIGURABLE,l=n(10447),u=n(70172),c=u.enforce,d=u.get,f=Object.defineProperty,p=a&&!r((function(){return 8!==f((function(){}),"length",{value:8}).length})),h=String(String).split("String"),m=e.exports=function(e,t,n){"Symbol("===String(t).slice(0,7)&&(t="["+String(t).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),n&&n.getter&&(t="get "+t),n&&n.setter&&(t="set "+t),(!i(e,"name")||s&&e.name!==t)&&(a?f(e,"name",{value:t,configurable:!0}):e.name=t),p&&n&&i(n,"arity")&&e.length!==n.arity&&f(e,"length",{value:n.arity});try{n&&i(n,"constructor")&&n.constructor?a&&f(e,"prototype",{writable:!1}):e.prototype&&(e.prototype=void 0)}catch(e){}var r=c(e);return i(r,"source")||(r.source=h.join("string"==typeof t?t:"")),e};Function.prototype.toString=m((function(){return o(this)&&d(this).source||l(this)}),"toString")},52384:function(e){var t=Math.ceil,n=Math.floor;e.exports=Math.trunc||function(e){var r=+e;return(r>0?n:t)(r)}},59804:function(e,t,n){var r,o,i,a,s,l,u,c,d=n(32010),f=n(25567),p=n(72062).f,h=n(6616).set,m=n(17716),v=n(70573),g=n(664),y=n(95053),b=d.MutationObserver||d.WebKitMutationObserver,w=d.document,_=d.process,O=d.Promise,k=p(d,"queueMicrotask"),x=k&&k.value;x||(r=function(){var e,t;for(y&&(e=_.domain)&&e.exit();o;){t=o.fn,o=o.next;try{t()}catch(e){throw o?a():i=void 0,e}}i=void 0,e&&e.enter()},m||y||g||!b||!w?!v&&O&&O.resolve?((u=O.resolve(void 0)).constructor=O,c=f(u.then,u),a=function(){c(r)}):y?a=function(){_.nextTick(r)}:(h=f(h,d),a=function(){h(r)}):(s=!0,l=w.createTextNode(""),new b(r).observe(l,{characterData:!0}),a=function(){l.data=s=!s})),e.exports=x||function(e){var t={fn:e,next:void 0};i&&(i.next=t),o||(o=t,a()),i=t}},56614:function(e,t,n){"use strict";var r=n(32631),o=TypeError,i=function(e){var t,n;this.promise=new e((function(e,r){if(void 0!==t||void 0!==n)throw o("Bad Promise constructor");t=e,n=r})),this.resolve=r(t),this.reject=r(n)};e.exports.f=function(e){return new i(e)}},86392:function(e,t,n){var r=n(25096);e.exports=function(e,t){return void 0===e?arguments.length<2?"":t:r(e)}},93666:function(e,t,n){var r=n(28831),o=TypeError;e.exports=function(e){if(r(e))throw o("The method doesn't accept regular expressions");return e}},87146:function(e,t,n){"use strict";var r=n(15567),o=n(38347),i=n(2834),a=n(47044),s=n(84675),l=n(61146),u=n(55574),c=n(43162),d=n(7514),f=Object.assign,p=Object.defineProperty,h=o([].concat);e.exports=!f||a((function(){if(r&&1!==f({b:1},f(p({},"a",{enumerable:!0,get:function(){p(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},t={},n=Symbol(),o="abcdefghijklmnopqrst";return e[n]=7,o.split("").forEach((function(e){t[e]=e})),7!=f({},e)[n]||s(f({},t)).join("")!=o}))?function(e,t){for(var n=c(e),o=arguments.length,a=1,f=l.f,p=u.f;o>a;)for(var m,v=d(arguments[a++]),g=f?h(s(v),f(v)):s(v),y=g.length,b=0;y>b;)m=g[b++],r&&!i(p,v,m)||(n[m]=v[m]);return n}:f},10819:function(e,t,n){var r,o=n(34984),i=n(10196),a=n(2416),s=n(90682),l=n(520),u=n(12072),c=n(82194),d=c("IE_PROTO"),f=function(){},p=function(e){return"<script>"+e+"</"+"script>"},h=function(e){e.write(p("")),e.close();var t=e.parentWindow.Object;return e=null,t},m=function(){try{r=new ActiveXObject("htmlfile")}catch(e){}var e,t;m="undefined"!=typeof document?document.domain&&r?h(r):((t=u("iframe")).style.display="none",l.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(p("document.F=Object")),e.close(),e.F):h(r);for(var n=a.length;n--;)delete m.prototype[a[n]];return m()};s[d]=!0,e.exports=Object.create||function(e,t){var n;return null!==e?(f.prototype=o(e),n=new f,f.prototype=null,n[d]=e):n=m(),void 0===t?n:i.f(n,t)}},10196:function(e,t,n){var r=n(15567),o=n(59757),i=n(95892),a=n(34984),s=n(98086),l=n(84675);t.f=r&&!o?Object.defineProperties:function(e,t){a(e);for(var n,r=s(t),o=l(t),u=o.length,c=0;u>c;)i.f(e,n=o[c++],r[n]);return e}},95892:function(e,t,n){var r=n(15567),o=n(18904),i=n(59757),a=n(34984),s=n(63918),l=TypeError,u=Object.defineProperty,c=Object.getOwnPropertyDescriptor,d="enumerable",f="configurable",p="writable";t.f=r?i?function(e,t,n){if(a(e),t=s(t),a(n),"function"==typeof e&&"prototype"===t&&"value"in n&&p in n&&!n.writable){var r=c(e,t);r&&r.writable&&(e[t]=n.value,n={configurable:f in n?n.configurable:r.configurable,enumerable:d in n?n.enumerable:r.enumerable,writable:!1})}return u(e,t,n)}:u:function(e,t,n){if(a(e),t=s(t),a(n),o)try{return u(e,t,n)}catch(e){}if("get"in n||"set"in n)throw l("Accessors not supported");return"value"in n&&(e[t]=n.value),e}},72062:function(e,t,n){var r=n(15567),o=n(2834),i=n(55574),a=n(97841),s=n(98086),l=n(63918),u=n(20340),c=n(18904),d=Object.getOwnPropertyDescriptor;t.f=r?d:function(e,t){if(e=s(e),t=l(t),c)try{return d(e,t)}catch(e){}if(u(e,t))return a(!o(i.f,e,t),e[t])}},8807:function(e,t,n){var r=n(93975),o=n(98086),i=n(6611).f,a=n(45258),s="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];e.exports.f=function(e){return s&&"Window"==r(e)?function(e){try{return i(e)}catch(e){return a(s)}}(e):i(o(e))}},6611:function(e,t,n){var r=n(64429),o=n(2416).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o)}},61146:function(e,t){t.f=Object.getOwnPropertySymbols},69548:function(e,t,n){var r=n(20340),o=n(94578),i=n(43162),a=n(82194),s=n(68494),l=a("IE_PROTO"),u=Object,c=u.prototype;e.exports=s?u.getPrototypeOf:function(e){var t=i(e);if(r(t,l))return t[l];var n=t.constructor;return o(n)&&t instanceof n?n.prototype:t instanceof u?c:null}},31685:function(e,t,n){var r=n(47044),o=n(24517),i=n(93975),a=n(60687),s=Object.isExtensible,l=r((function(){s(1)}));e.exports=l||a?function(e){return!!o(e)&&((!a||"ArrayBuffer"!=i(e))&&(!s||s(e)))}:s},70176:function(e,t,n){var r=n(38347);e.exports=r({}.isPrototypeOf)},98125:function(e,t,n){"use strict";var r=n(70172),o=n(83157),i=n(19110),a=n(20340),s=n(84675),l=n(43162),u="Object Iterator",c=r.set,d=r.getterFor(u);e.exports=o((function(e,t){var n=l(e);c(this,{type:u,mode:t,object:n,keys:s(n),index:0})}),"Object",(function(){for(var e=d(this),t=e.keys;;){if(null===t||e.index>=t.length)return e.object=e.keys=null,i(void 0,!0);var n=t[e.index++],r=e.object;if(a(r,n)){switch(e.mode){case"keys":return i(n,!1);case"values":return i(r[n],!1)}return i([n,r[n]],!1)}}}))},64429:function(e,t,n){var r=n(38347),o=n(20340),i=n(98086),a=n(12636).indexOf,s=n(90682),l=r([].push);e.exports=function(e,t){var n,r=i(e),u=0,c=[];for(n in r)!o(s,n)&&o(r,n)&&l(c,n);for(;t.length>u;)o(r,n=t[u++])&&(~a(c,n)||l(c,n));return c}},84675:function(e,t,n){var r=n(64429),o=n(2416);e.exports=Object.keys||function(e){return r(e,o)}},55574:function(e,t){"use strict";var n={}.propertyIsEnumerable,r=Object.getOwnPropertyDescriptor,o=r&&!n.call({1:2},1);t.f=o?function(e){var t=r(this,e);return!!t&&t.enumerable}:n},3840:function(e,t,n){var r=n(38347),o=n(34984),i=n(58659);e.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,n={};try{(e=r(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),t=n instanceof Array}catch(e){}return function(n,r){return o(n),i(r),t?e(n,r):n.__proto__=r,n}}():void 0)},80754:function(e,t,n){var r=n(15567),o=n(38347),i=n(84675),a=n(98086),s=o(n(55574).f),l=o([].push),u=function(e){return function(t){for(var n,o=a(t),u=i(o),c=u.length,d=0,f=[];c>d;)n=u[d++],r&&!s(o,n)||l(f,e?[n,o[n]]:o[n]);return f}};e.exports={entries:u(!0),values:u(!1)}},52598:function(e,t,n){"use strict";var r=n(24663),o=n(52564);e.exports=r?{}.toString:function(){return"[object "+o(this)+"]"}},39629:function(e,t,n){var r=n(2834),o=n(94578),i=n(24517),a=TypeError;e.exports=function(e,t){var n,s;if("string"===t&&o(n=e.toString)&&!i(s=r(n,e)))return s;if(o(n=e.valueOf)&&!i(s=r(n,e)))return s;if("string"!==t&&o(n=e.toString)&&!i(s=r(n,e)))return s;throw a("Can't convert object to primitive value")}},21594:function(e,t,n){var r=n(38486),o=n(38347),i=n(6611),a=n(61146),s=n(34984),l=o([].concat);e.exports=r("Reflect","ownKeys")||function(e){var t=i.f(s(e)),n=a.f;return n?l(t,n(e)):t}},11206:function(e,t,n){var r=n(32010);e.exports=r},61900:function(e){e.exports=function(e){try{return{error:!1,value:e()}}catch(e){return{error:!0,value:e}}}},15911:function(e,t,n){var r=n(32010),o=n(35695),i=n(94578),a=n(39599),s=n(10447),l=n(38688),u=n(3157),c=n(95953),d=n(63432),f=n(70091),p=o&&o.prototype,h=l("species"),m=!1,v=i(r.PromiseRejectionEvent),g=a("Promise",(function(){var e=s(o),t=e!==String(o);if(!t&&66===f)return!0;if(d&&(!p.catch||!p.finally))return!0;if(!f||f<51||!/native code/.test(e)){var n=new o((function(e){e(1)})),r=function(e){e((function(){}),(function(){}))};if((n.constructor={})[h]=r,!(m=n.then((function(){}))instanceof r))return!0}return!t&&(u||c)&&!v}));e.exports={CONSTRUCTOR:g,REJECTION_EVENT:v,SUBCLASSING:m}},35695:function(e,t,n){var r=n(32010);e.exports=r.Promise},28617:function(e,t,n){var r=n(34984),o=n(24517),i=n(56614);e.exports=function(e,t){if(r(e),o(t)&&t.constructor===e)return t;var n=i.f(e);return(0,n.resolve)(t),n.promise}},9706:function(e,t,n){var r=n(35695),o=n(46769),i=n(15911).CONSTRUCTOR;e.exports=i||!o((function(e){r.all(e).then(void 0,(function(){}))}))},74034:function(e){var t=function(){this.head=null,this.tail=null};t.prototype={add:function(e){var t={item:e,next:null};this.head?this.tail.next=t:this.head=t,this.tail=t},get:function(){var e=this.head;if(e)return this.head=e.next,this.tail===e&&(this.tail=null),e.item}},e.exports=t},83943:function(e,t,n){var r=n(35576),o=TypeError;e.exports=function(e){if(r(e))throw o("Can't call method on "+e);return e}},51334:function(e,t,n){"use strict";var r=n(38486),o=n(95892),i=n(38688),a=n(15567),s=i("species");e.exports=function(e){var t=r(e),n=o.f;a&&t&&!t[s]&&n(t,s,{configurable:!0,get:function(){return this}})}},15216:function(e,t,n){var r=n(95892).f,o=n(20340),i=n(38688)("toStringTag");e.exports=function(e,t,n){e&&!n&&(e=e.prototype),e&&!o(e,i)&&r(e,i,{configurable:!0,value:t})}},82194:function(e,t,n){var r=n(464),o=n(46859),i=r("keys");e.exports=function(e){return i[e]||(i[e]=o(e))}},55480:function(e,t,n){var r=n(32010),o=n(63036),i="__core-js_shared__",a=r[i]||o(i,{});e.exports=a},464:function(e,t,n){var r=n(63432),o=n(55480);(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.26.1",mode:r?"pure":"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE",source:"https://github.com/zloirock/core-js"})},27754:function(e,t,n){var r=n(34984),o=n(69075),i=n(35576),a=n(38688)("species");e.exports=function(e,t){var n,s=r(e).constructor;return void 0===s||i(n=r(s)[a])?t:o(n)}},69510:function(e,t,n){var r=n(38347),o=n(26882),i=n(25096),a=n(83943),s=r("".charAt),l=r("".charCodeAt),u=r("".slice),c=function(e){return function(t,n){var r,c,d=i(a(t)),f=o(n),p=d.length;return f<0||f>=p?e?"":void 0:(r=l(d,f))<55296||r>56319||f+1===p||(c=l(d,f+1))<56320||c>57343?e?s(d,f):r:e?u(d,f,f+2):c-56320+(r-55296<<10)+65536}};e.exports={codeAt:c(!1),charAt:c(!0)}},84588:function(e,t,n){"use strict";var r=n(38347),o=2147483647,i=/[^\0-\u007E]/,a=/[.\u3002\uFF0E\uFF61]/g,s="Overflow: input needs wider integers to process",l=RangeError,u=r(a.exec),c=Math.floor,d=String.fromCharCode,f=r("".charCodeAt),p=r([].join),h=r([].push),m=r("".replace),v=r("".split),g=r("".toLowerCase),y=function(e){return e+22+75*(e<26)},b=function(e,t,n){var r=0;for(e=n?c(e/700):e>>1,e+=c(e/t);e>455;)e=c(e/35),r+=36;return c(r+36*e/(e+38))},w=function(e){var t=[];e=function(e){for(var t=[],n=0,r=e.length;n<r;){var o=f(e,n++);if(o>=55296&&o<=56319&&n<r){var i=f(e,n++);56320==(64512&i)?h(t,((1023&o)<<10)+(1023&i)+65536):(h(t,o),n--)}else h(t,o)}return t}(e);var n,r,i=e.length,a=128,u=0,m=72;for(n=0;n<e.length;n++)(r=e[n])<128&&h(t,d(r));var v=t.length,g=v;for(v&&h(t,"-");g<i;){var w=o;for(n=0;n<e.length;n++)(r=e[n])>=a&&r<w&&(w=r);var _=g+1;if(w-a>c((o-u)/_))throw l(s);for(u+=(w-a)*_,a=w,n=0;n<e.length;n++){if((r=e[n])<a&&++u>o)throw l(s);if(r==a){for(var O=u,k=36;;){var x=k<=m?1:k>=m+26?26:k-m;if(O<x)break;var E=O-x,T=36-x;h(t,d(y(x+E%T))),O=c(E/T),k+=36}h(t,d(y(O))),m=b(u,_,g==v),u=0,g++}}u++,a++}return p(t,"")};e.exports=function(e){var t,n,r=[],o=v(m(g(e),a,"."),".");for(t=0;t<o.length;t++)n=o[t],h(r,u(i,n)?"xn--"+w(n):n);return p(r,".")}},8302:function(e,t,n){var r=n(70091),o=n(47044);e.exports=!!Object.getOwnPropertySymbols&&!o((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&r&&r<41}))},6616:function(e,t,n){var r,o,i,a,s=n(32010),l=n(58448),u=n(25567),c=n(94578),d=n(20340),f=n(47044),p=n(520),h=n(73163),m=n(12072),v=n(25051),g=n(17716),y=n(95053),b=s.setImmediate,w=s.clearImmediate,_=s.process,O=s.Dispatch,k=s.Function,x=s.MessageChannel,E=s.String,T=0,S={},A="onreadystatechange";try{r=s.location}catch(e){}var P=function(e){if(d(S,e)){var t=S[e];delete S[e],t()}},C=function(e){return function(){P(e)}},R=function(e){P(e.data)},I=function(e){s.postMessage(E(e),r.protocol+"//"+r.host)};b&&w||(b=function(e){v(arguments.length,1);var t=c(e)?e:k(e),n=h(arguments,1);return S[++T]=function(){l(t,void 0,n)},o(T),T},w=function(e){delete S[e]},y?o=function(e){_.nextTick(C(e))}:O&&O.now?o=function(e){O.now(C(e))}:x&&!g?(a=(i=new x).port2,i.port1.onmessage=R,o=u(a.postMessage,a)):s.addEventListener&&c(s.postMessage)&&!s.importScripts&&r&&"file:"!==r.protocol&&!f(I)?(o=I,s.addEventListener("message",R,!1)):o=A in m("script")?function(e){p.appendChild(m("script")).onreadystatechange=function(){p.removeChild(this),P(e)}}:function(e){setTimeout(C(e),0)}),e.exports={set:b,clear:w}},74841:function(e,t,n){var r=n(26882),o=Math.max,i=Math.min;e.exports=function(e,t){var n=r(e);return n<0?o(n+t,0):i(n,t)}},7683:function(e,t,n){var r=n(2644),o=TypeError;e.exports=function(e){var t=r(e,"number");if("number"==typeof t)throw o("Can't convert number to bigint");return BigInt(t)}},71265:function(e,t,n){var r=n(26882),o=n(23417),i=RangeError;e.exports=function(e){if(void 0===e)return 0;var t=r(e),n=o(t);if(t!==n)throw i("Wrong length or index");return n}},98086:function(e,t,n){var r=n(7514),o=n(83943);e.exports=function(e){return r(o(e))}},26882:function(e,t,n){var r=n(52384);e.exports=function(e){var t=+e;return t!=t||0===t?0:r(t)}},23417:function(e,t,n){var r=n(26882),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},43162:function(e,t,n){var r=n(83943),o=Object;e.exports=function(e){return o(r(e))}},80670:function(e,t,n){var r=n(64913),o=RangeError;e.exports=function(e,t){var n=r(e);if(n%t)throw o("Wrong offset");return n}},64913:function(e,t,n){var r=n(26882),o=RangeError;e.exports=function(e){var t=r(e);if(t<0)throw o("The argument can't be less than 0");return t}},2644:function(e,t,n){var r=n(2834),o=n(24517),i=n(46290),a=n(51839),s=n(39629),l=n(38688),u=TypeError,c=l("toPrimitive");e.exports=function(e,t){if(!o(e)||i(e))return e;var n,l=a(e,c);if(l){if(void 0===t&&(t="default"),n=r(l,e,t),!o(n)||i(n))return n;throw u("Can't convert object to primitive value")}return void 0===t&&(t="number"),s(e,t)}},63918:function(e,t,n){var r=n(2644),o=n(46290);e.exports=function(e){var t=r(e,"string");return o(t)?t:t+""}},24663:function(e,t,n){var r={};r[n(38688)("toStringTag")]="z",e.exports="[object z]"===String(r)},25096:function(e,t,n){var r=n(52564),o=String;e.exports=function(e){if("Symbol"===r(e))throw TypeError("Cannot convert a Symbol value to a string");return o(e)}},68664:function(e){var t=String;e.exports=function(e){try{return t(e)}catch(e){return"Object"}}},98828:function(e,t,n){"use strict";var r=n(56475),o=n(32010),i=n(2834),a=n(15567),s=n(28834),l=n(95089),u=n(69351),c=n(2868),d=n(97841),f=n(48914),p=n(17506),h=n(23417),m=n(71265),v=n(80670),g=n(63918),y=n(20340),b=n(52564),w=n(24517),_=n(46290),O=n(10819),k=n(70176),x=n(3840),E=n(6611).f,T=n(83590),S=n(91102).forEach,A=n(51334),P=n(95892),C=n(72062),R=n(70172),I=n(51868),N=R.get,M=R.set,j=R.enforce,D=P.f,L=C.f,U=Math.round,F=o.RangeError,B=u.ArrayBuffer,V=B.prototype,Z=u.DataView,H=l.NATIVE_ARRAY_BUFFER_VIEWS,q=l.TYPED_ARRAY_TAG,W=l.TypedArray,K=l.TypedArrayPrototype,$=l.aTypedArrayConstructor,z=l.isTypedArray,Y="BYTES_PER_ELEMENT",G="Wrong length",J=function(e,t){$(e);for(var n=0,r=t.length,o=new e(r);r>n;)o[n]=t[n++];return o},Q=function(e,t){D(e,t,{get:function(){return N(this)[t]}})},X=function(e){var t;return k(V,e)||"ArrayBuffer"==(t=b(e))||"SharedArrayBuffer"==t},ee=function(e,t){return z(e)&&!_(t)&&t in e&&p(+t)&&t>=0},te=function(e,t){return t=g(t),ee(e,t)?d(2,e[t]):L(e,t)},ne=function(e,t,n){return t=g(t),!(ee(e,t)&&w(n)&&y(n,"value"))||y(n,"get")||y(n,"set")||n.configurable||y(n,"writable")&&!n.writable||y(n,"enumerable")&&!n.enumerable?D(e,t,n):(e[t]=n.value,e)};a?(H||(C.f=te,P.f=ne,Q(K,"buffer"),Q(K,"byteOffset"),Q(K,"byteLength"),Q(K,"length")),r({target:"Object",stat:!0,forced:!H},{getOwnPropertyDescriptor:te,defineProperty:ne}),e.exports=function(e,t,n){var a=e.match(/\d+$/)[0]/8,l=e+(n?"Clamped":"")+"Array",u="get"+e,d="set"+e,p=o[l],g=p,y=g&&g.prototype,b={},_=function(e,t){D(e,t,{get:function(){return function(e,t){var n=N(e);return n.view[u](t*a+n.byteOffset,!0)}(this,t)},set:function(e){return function(e,t,r){var o=N(e);n&&(r=(r=U(r))<0?0:r>255?255:255&r),o.view[d](t*a+o.byteOffset,r,!0)}(this,t,e)},enumerable:!0})};H?s&&(g=t((function(e,t,n,r){return c(e,y),I(w(t)?X(t)?void 0!==r?new p(t,v(n,a),r):void 0!==n?new p(t,v(n,a)):new p(t):z(t)?J(g,t):i(T,g,t):new p(m(t)),e,g)})),x&&x(g,W),S(E(p),(function(e){e in g||f(g,e,p[e])})),g.prototype=y):(g=t((function(e,t,n,r){c(e,y);var o,s,l,u=0,d=0;if(w(t)){if(!X(t))return z(t)?J(g,t):i(T,g,t);o=t,d=v(n,a);var f=t.byteLength;if(void 0===r){if(f%a)throw F(G);if((s=f-d)<0)throw F(G)}else if((s=h(r)*a)+d>f)throw F(G);l=s/a}else l=m(t),o=new B(s=l*a);for(M(e,{buffer:o,byteOffset:d,byteLength:s,length:l,view:new Z(o)});u<l;)_(e,u++)})),x&&x(g,W),y=g.prototype=O(K)),y.constructor!==g&&f(y,"constructor",g),j(y).TypedArrayConstructor=g,q&&f(y,q,l);var k=g!=p;b[l]=g,r({global:!0,constructor:!0,forced:k,sham:!H},b),Y in g||f(g,Y,a),Y in y||f(y,Y,a),A(l)}):e.exports=function(){}},28834:function(e,t,n){var r=n(32010),o=n(47044),i=n(46769),a=n(95089).NATIVE_ARRAY_BUFFER_VIEWS,s=r.ArrayBuffer,l=r.Int8Array;e.exports=!a||!o((function(){l(1)}))||!o((function(){new l(-1)}))||!i((function(e){new l,new l(null),new l(1.5),new l(e)}),!0)||o((function(){return 1!==new l(new s(2),1,void 0).length}))},59610:function(e,t,n){var r=n(34269),o=n(34815);e.exports=function(e,t){return r(o(e),t)}},83590:function(e,t,n){var r=n(25567),o=n(2834),i=n(69075),a=n(43162),s=n(45495),l=n(15892),u=n(13872),c=n(89564),d=n(75542),f=n(95089).aTypedArrayConstructor,p=n(7683);e.exports=function(e){var t,n,h,m,v,g,y,b,w=i(this),_=a(e),O=arguments.length,k=O>1?arguments[1]:void 0,x=void 0!==k,E=u(_);if(E&&!c(E))for(b=(y=l(_,E)).next,_=[];!(g=o(b,y)).done;)_.push(g.value);for(x&&O>2&&(k=r(k,arguments[2])),n=s(_),h=new(f(w))(n),m=d(h),t=0;n>t;t++)v=x?k(_[t],t):_[t],h[t]=m?p(v):+v;return h}},34815:function(e,t,n){var r=n(95089),o=n(27754),i=r.aTypedArrayConstructor,a=r.getTypedArrayConstructor;e.exports=function(e){return i(o(e,a(e)))}},46859:function(e,t,n){var r=n(38347),o=0,i=Math.random(),a=r(1..toString);e.exports=function(e){return"Symbol("+(void 0===e?"":e)+")_"+a(++o+i,36)}},36559:function(e,t,n){var r=n(47044),o=n(38688),i=n(63432),a=o("iterator");e.exports=!r((function(){var e=new URL("b?a=1&b=2&c=3","http://a"),t=e.searchParams,n="";return e.pathname="c%20d",t.forEach((function(e,r){t.delete("b"),n+=r+e})),i&&!e.toJSON||!t.sort||"http://a/c%20d?a=1&c=3"!==e.href||"3"!==t.get("c")||"a=1"!==String(new URLSearchParams("?a=1"))||!t[a]||"a"!==new URL("https://a@b").username||"b"!==new URLSearchParams(new URLSearchParams("a=b")).get("a")||"xn--e1aybc"!==new URL("http://тест").host||"#%D0%B1"!==new URL("http://a#б").hash||"a1c3"!==n||"x"!==new URL("http://x",void 0).host}))},9567:function(e,t,n){var r=n(8302);e.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},59757:function(e,t,n){var r=n(15567),o=n(47044);e.exports=r&&o((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype}))},25051:function(e){var t=TypeError;e.exports=function(e,n){if(e<n)throw t("Not enough arguments");return e}},2591:function(e,t,n){var r=n(32010),o=n(94578),i=r.WeakMap;e.exports=o(i)&&/native code/.test(String(i))},28966:function(e,t,n){var r=n(11206),o=n(20340),i=n(75960),a=n(95892).f;e.exports=function(e){var t=r.Symbol||(r.Symbol={});o(t,e)||a(t,e,{value:i.f(e)})}},75960:function(e,t,n){var r=n(38688);t.f=r},38688:function(e,t,n){var r=n(32010),o=n(464),i=n(20340),a=n(46859),s=n(8302),l=n(9567),u=o("wks"),c=r.Symbol,d=c&&c.for,f=l?c:c&&c.withoutSetter||a;e.exports=function(e){if(!i(u,e)||!s&&"string"!=typeof u[e]){var t="Symbol."+e;s&&i(c,e)?u[e]=c[e]:u[e]=l&&d?d(t):f(t)}return u[e]}},62664:function(e,t,n){"use strict";var r=n(56475),o=n(70176),i=n(69548),a=n(3840),s=n(2675),l=n(10819),u=n(48914),c=n(97841),d=n(52362),f=n(87811),p=n(80383),h=n(86392),m=n(38688),v=n(45144),g=m("toStringTag"),y=Error,b=[].push,w=function(e,t){var n,r=arguments.length>2?arguments[2]:void 0,s=o(_,this);a?n=a(y(),s?i(this):_):(n=s?this:l(_),u(n,g,"Error")),void 0!==t&&u(n,"message",h(t)),v&&u(n,"stack",d(n.stack,1)),f(n,r);var c=[];return p(e,b,{that:c}),u(n,"errors",c),n};a?a(w,y):s(w,y,{name:!0});var _=w.prototype=l(y.prototype,{constructor:c(1,w),message:c(1,""),name:c(1,"AggregateError")});r({global:!0,constructor:!0,arity:2},{AggregateError:w})},94910:function(e,t,n){n(62664)},45004:function(e,t,n){"use strict";var r=n(56475),o=n(32010),i=n(69351),a=n(51334),s="ArrayBuffer",l=i.ArrayBuffer;r({global:!0,constructor:!0,forced:o.ArrayBuffer!==l},{ArrayBuffer:l}),a(s)},29690:function(e,t,n){"use strict";var r=n(56475),o=n(85233),i=n(47044),a=n(69351),s=n(34984),l=n(74841),u=n(23417),c=n(27754),d=a.ArrayBuffer,f=a.DataView,p=f.prototype,h=o(d.prototype.slice),m=o(p.getUint8),v=o(p.setUint8);r({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:i((function(){return!new d(2).slice(1,void 0).byteLength}))},{slice:function(e,t){if(h&&void 0===t)return h(s(this),e);for(var n=s(this).byteLength,r=l(e,n),o=l(void 0===t?n:t,n),i=new(c(this,d))(u(o-r)),a=new f(this),p=new f(i),g=0;r<o;)v(p,g++,m(a,r++));return i}})},90079:function(e,t,n){"use strict";var r=n(56475),o=n(91102).findIndex,i=n(71156),a="findIndex",s=!0;a in[]&&Array(1).findIndex((function(){s=!1})),r({target:"Array",proto:!0,forced:s},{findIndex:function(e){return o(this,e,arguments.length>1?arguments[1]:void 0)}}),i(a)},97514:function(e,t,n){"use strict";var r=n(56475),o=n(91102).find,i=n(71156),a="find",s=!0;a in[]&&Array(1).find((function(){s=!1})),r({target:"Array",proto:!0,forced:s},{find:function(e){return o(this,e,arguments.length>1?arguments[1]:void 0)}}),i(a)},11765:function(e,t,n){var r=n(56475),o=n(95717);r({target:"Array",stat:!0,forced:!n(46769)((function(e){Array.from(e)}))},{from:o})},58028:function(e,t,n){"use strict";var r=n(56475),o=n(12636).includes,i=n(47044),a=n(71156);r({target:"Array",proto:!0,forced:i((function(){return!Array(1).includes()}))},{includes:function(e){return o(this,e,arguments.length>1?arguments[1]:void 0)}}),a("includes")},81755:function(e,t,n){"use strict";var r=n(98086),o=n(71156),i=n(15366),a=n(70172),s=n(95892).f,l=n(11231),u=n(19110),c=n(63432),d=n(15567),f="Array Iterator",p=a.set,h=a.getterFor(f);e.exports=l(Array,"Array",(function(e,t){p(this,{type:f,target:r(e),index:0,kind:t})}),(function(){var e=h(this),t=e.target,n=e.kind,r=e.index++;return!t||r>=t.length?(e.target=void 0,u(void 0,!0)):u("keys"==n?r:"values"==n?t[r]:[r,t[r]],!1)}),"values");var m=i.Arguments=i.Array;if(o("keys"),o("values"),o("entries"),!c&&d&&"values"!==m.name)try{s(m,"name",{value:"values"})}catch(e){}},18756:function(e,t,n){var r=n(56475),o=n(87146);r({target:"Object",stat:!0,arity:2,forced:Object.assign!==o},{assign:o})},13489:function(e,t,n){var r=n(56475),o=n(80754).entries;r({target:"Object",stat:!0},{entries:function(e){return o(e)}})},25384:function(e,t,n){var r=n(56475),o=n(80383),i=n(38639);r({target:"Object",stat:!0},{fromEntries:function(e){var t={};return o(e,(function(e,n){i(t,e,n)}),{AS_ENTRIES:!0}),t}})},37309:function(e,t,n){var r=n(56475),o=n(43162),i=n(84675);r({target:"Object",stat:!0,forced:n(47044)((function(){i(1)}))},{keys:function(e){return i(o(e))}})},96698:function(e,t,n){n(56475)({target:"Object",stat:!0},{setPrototypeOf:n(3840)})},14032:function(e,t,n){var r=n(24663),o=n(79855),i=n(52598);r||o(Object.prototype,"toString",i,{unsafe:!0})},59883:function(e,t,n){var r=n(56475),o=n(80754).values;r({target:"Object",stat:!0},{values:function(e){return o(e)}})},77074:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(32631),a=n(56614),s=n(61900),l=n(80383);r({target:"Promise",stat:!0},{allSettled:function(e){var t=this,n=a.f(t),r=n.resolve,u=n.reject,c=s((function(){var n=i(t.resolve),a=[],s=0,u=1;l(e,(function(e){var i=s++,l=!1;u++,o(n,t,e).then((function(e){l||(l=!0,a[i]={status:"fulfilled",value:e},--u||r(a))}),(function(e){l||(l=!0,a[i]={status:"rejected",reason:e},--u||r(a))}))})),--u||r(a)}));return c.error&&u(c.value),n.promise}})},12334:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(32631),a=n(56614),s=n(61900),l=n(80383);r({target:"Promise",stat:!0,forced:n(9706)},{all:function(e){var t=this,n=a.f(t),r=n.resolve,u=n.reject,c=s((function(){var n=i(t.resolve),a=[],s=0,c=1;l(e,(function(e){var i=s++,l=!1;c++,o(n,t,e).then((function(e){l||(l=!0,a[i]=e,--c||r(a))}),u)})),--c||r(a)}));return c.error&&u(c.value),n.promise}})},44455:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(32631),a=n(38486),s=n(56614),l=n(61900),u=n(80383),c="No one promise resolved";r({target:"Promise",stat:!0},{any:function(e){var t=this,n=a("AggregateError"),r=s.f(t),d=r.resolve,f=r.reject,p=l((function(){var r=i(t.resolve),a=[],s=0,l=1,p=!1;u(e,(function(e){var i=s++,u=!1;l++,o(r,t,e).then((function(e){u||p||(p=!0,d(e))}),(function(e){u||p||(u=!0,a[i]=e,--l||f(new n(a,c)))}))})),--l||f(new n(a,c))}));return p.error&&f(p.value),r.promise}})},26354:function(e,t,n){"use strict";var r=n(56475),o=n(63432),i=n(15911).CONSTRUCTOR,a=n(35695),s=n(38486),l=n(94578),u=n(79855),c=a&&a.prototype;if(r({target:"Promise",proto:!0,forced:i,real:!0},{catch:function(e){return this.then(void 0,e)}}),!o&&l(a)){var d=s("Promise").prototype.catch;c.catch!==d&&u(c,"catch",d,{unsafe:!0})}},94729:function(e,t,n){"use strict";var r,o,i,a=n(56475),s=n(63432),l=n(95053),u=n(32010),c=n(2834),d=n(79855),f=n(3840),p=n(15216),h=n(51334),m=n(32631),v=n(94578),g=n(24517),y=n(2868),b=n(27754),w=n(6616).set,_=n(59804),O=n(61144),k=n(61900),x=n(74034),E=n(70172),T=n(35695),S=n(15911),A=n(56614),P="Promise",C=S.CONSTRUCTOR,R=S.REJECTION_EVENT,I=S.SUBCLASSING,N=E.getterFor(P),M=E.set,j=T&&T.prototype,D=T,L=j,U=u.TypeError,F=u.document,B=u.process,V=A.f,Z=V,H=!!(F&&F.createEvent&&u.dispatchEvent),q="unhandledrejection",W=function(e){var t;return!(!g(e)||!v(t=e.then))&&t},K=function(e,t){var n,r,o,i=t.value,a=1==t.state,s=a?e.ok:e.fail,l=e.resolve,u=e.reject,d=e.domain;try{s?(a||(2===t.rejection&&J(t),t.rejection=1),!0===s?n=i:(d&&d.enter(),n=s(i),d&&(d.exit(),o=!0)),n===e.promise?u(U("Promise-chain cycle")):(r=W(n))?c(r,n,l,u):l(n)):u(i)}catch(e){d&&!o&&d.exit(),u(e)}},$=function(e,t){e.notified||(e.notified=!0,_((function(){for(var n,r=e.reactions;n=r.get();)K(n,e);e.notified=!1,t&&!e.rejection&&Y(e)})))},z=function(e,t,n){var r,o;H?((r=F.createEvent("Event")).promise=t,r.reason=n,r.initEvent(e,!1,!0),u.dispatchEvent(r)):r={promise:t,reason:n},!R&&(o=u["on"+e])?o(r):e===q&&O("Unhandled promise rejection",n)},Y=function(e){c(w,u,(function(){var t,n=e.facade,r=e.value;if(G(e)&&(t=k((function(){l?B.emit("unhandledRejection",r,n):z(q,n,r)})),e.rejection=l||G(e)?2:1,t.error))throw t.value}))},G=function(e){return 1!==e.rejection&&!e.parent},J=function(e){c(w,u,(function(){var t=e.facade;l?B.emit("rejectionHandled",t):z("rejectionhandled",t,e.value)}))},Q=function(e,t,n){return function(r){e(t,r,n)}},X=function(e,t,n){e.done||(e.done=!0,n&&(e=n),e.value=t,e.state=2,$(e,!0))},ee=function(e,t,n){if(!e.done){e.done=!0,n&&(e=n);try{if(e.facade===t)throw U("Promise can't be resolved itself");var r=W(t);r?_((function(){var n={done:!1};try{c(r,t,Q(ee,n,e),Q(X,n,e))}catch(t){X(n,t,e)}})):(e.value=t,e.state=1,$(e,!1))}catch(t){X({done:!1},t,e)}}};if(C&&(L=(D=function(e){y(this,L),m(e),c(r,this);var t=N(this);try{e(Q(ee,t),Q(X,t))}catch(e){X(t,e)}}).prototype,(r=function(e){M(this,{type:P,done:!1,notified:!1,parent:!1,reactions:new x,rejection:!1,state:0,value:void 0})}).prototype=d(L,"then",(function(e,t){var n=N(this),r=V(b(this,D));return n.parent=!0,r.ok=!v(e)||e,r.fail=v(t)&&t,r.domain=l?B.domain:void 0,0==n.state?n.reactions.add(r):_((function(){K(r,n)})),r.promise})),o=function(){var e=new r,t=N(e);this.promise=e,this.resolve=Q(ee,t),this.reject=Q(X,t)},A.f=V=function(e){return e===D||undefined===e?new o(e):Z(e)},!s&&v(T)&&j!==Object.prototype)){i=j.then,I||d(j,"then",(function(e,t){var n=this;return new D((function(e,t){c(i,n,e,t)})).then(e,t)}),{unsafe:!0});try{delete j.constructor}catch(e){}f&&f(j,L)}a({global:!0,constructor:!0,wrap:!0,forced:C},{Promise:D}),p(D,P,!1,!0),h(P)},80986:function(e,t,n){"use strict";var r=n(56475),o=n(63432),i=n(35695),a=n(47044),s=n(38486),l=n(94578),u=n(27754),c=n(28617),d=n(79855),f=i&&i.prototype;if(r({target:"Promise",proto:!0,real:!0,forced:!!i&&a((function(){f.finally.call({then:function(){}},(function(){}))}))},{finally:function(e){var t=u(this,s("Promise")),n=l(e);return this.then(n?function(n){return c(t,e()).then((function(){return n}))}:e,n?function(n){return c(t,e()).then((function(){throw n}))}:e)}}),!o&&l(i)){var p=s("Promise").prototype.finally;f.finally!==p&&d(f,"finally",p,{unsafe:!0})}},68067:function(e,t,n){n(94729),n(12334),n(26354),n(96184),n(30094),n(10689)},96184:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(32631),a=n(56614),s=n(61900),l=n(80383);r({target:"Promise",stat:!0,forced:n(9706)},{race:function(e){var t=this,n=a.f(t),r=n.reject,u=s((function(){var a=i(t.resolve);l(e,(function(e){o(a,t,e).then(n.resolve,r)}))}));return u.error&&r(u.value),n.promise}})},30094:function(e,t,n){"use strict";var r=n(56475),o=n(2834),i=n(56614);r({target:"Promise",stat:!0,forced:n(15911).CONSTRUCTOR},{reject:function(e){var t=i.f(this);return o(t.reject,void 0,e),t.promise}})},10689:function(e,t,n){"use strict";var r=n(56475),o=n(38486),i=n(63432),a=n(35695),s=n(15911).CONSTRUCTOR,l=n(28617),u=o("Promise"),c=i&&!s;r({target:"Promise",stat:!0,forced:i||s},{resolve:function(e){return l(c&&this===u?a:this,e)}})},4344:function(e,t,n){"use strict";n(36673)("Set",(function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}}),n(9649))},76014:function(e,t,n){n(4344)},46358:function(e,t,n){"use strict";var r,o=n(56475),i=n(85233),a=n(72062).f,s=n(23417),l=n(25096),u=n(93666),c=n(83943),d=n(91151),f=n(63432),p=i("".endsWith),h=i("".slice),m=Math.min,v=d("endsWith");o({target:"String",proto:!0,forced:!!(f||v||(r=a(String.prototype,"endsWith"),!r||r.writable))&&!v},{endsWith:function(e){var t=l(c(this));u(e);var n=arguments.length>1?arguments[1]:void 0,r=t.length,o=void 0===n?r:m(s(n),r),i=l(e);return p?p(t,i,o):h(t,o-i.length,o)===i}})},47458:function(e,t,n){"use strict";var r=n(56475),o=n(38347),i=n(93666),a=n(83943),s=n(25096),l=n(91151),u=o("".indexOf);r({target:"String",proto:!0,forced:!l("includes")},{includes:function(e){return!!~u(s(a(this)),s(i(e)),arguments.length>1?arguments[1]:void 0)}})},58281:function(e,t,n){"use strict";var r=n(69510).charAt,o=n(25096),i=n(70172),a=n(11231),s=n(19110),l="String Iterator",u=i.set,c=i.getterFor(l);a(String,"String",(function(e){u(this,{type:l,string:o(e),index:0})}),(function(){var e,t=c(this),n=t.string,o=t.index;return o>=n.length?s(void 0,!0):(e=r(n,o),t.index+=e.length,s(e,!1))}))},93875:function(e,t,n){"use strict";var r,o=n(56475),i=n(85233),a=n(72062).f,s=n(23417),l=n(25096),u=n(93666),c=n(83943),d=n(91151),f=n(63432),p=i("".startsWith),h=i("".slice),m=Math.min,v=d("startsWith");o({target:"String",proto:!0,forced:!!(f||v||(r=a(String.prototype,"startsWith"),!r||r.writable))&&!v},{startsWith:function(e){var t=l(c(this));u(e);var n=s(m(arguments.length>1?arguments[1]:void 0,t.length)),r=l(e);return p?p(t,r,n):h(t,n,n+r.length)===r}})},69330:function(e,t,n){n(28966)("iterator")},94095:function(e,t,n){"use strict";var r=n(95089),o=n(45495),i=n(26882),a=r.aTypedArray;(0,r.exportTypedArrayMethod)("at",(function(e){var t=a(this),n=o(t),r=i(e),s=r>=0?r:n+r;return s<0||s>=n?void 0:t[s]}))},73663:function(e,t,n){"use strict";var r=n(38347),o=n(95089),i=r(n(92642)),a=o.aTypedArray;(0,o.exportTypedArrayMethod)("copyWithin",(function(e,t){return i(a(this),e,t,arguments.length>2?arguments[2]:void 0)}))},29883:function(e,t,n){"use strict";var r=n(95089),o=n(91102).every,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("every",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},35471:function(e,t,n){"use strict";var r=n(95089),o=n(72864),i=n(7683),a=n(52564),s=n(2834),l=n(38347),u=n(47044),c=r.aTypedArray,d=r.exportTypedArrayMethod,f=l("".slice);d("fill",(function(e){var t=arguments.length;c(this);var n="Big"===f(a(this),0,3)?i(e):+e;return s(o,this,n,t>1?arguments[1]:void 0,t>2?arguments[2]:void 0)}),u((function(){var e=0;return new Int8Array(2).fill({valueOf:function(){return e++}}),1!==e})))},21012:function(e,t,n){"use strict";var r=n(95089),o=n(91102).filter,i=n(59610),a=r.aTypedArray;(0,r.exportTypedArrayMethod)("filter",(function(e){var t=o(a(this),e,arguments.length>1?arguments[1]:void 0);return i(this,t)}))},97464:function(e,t,n){"use strict";var r=n(95089),o=n(91102).findIndex,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("findIndex",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},31519:function(e,t,n){"use strict";var r=n(95089),o=n(88828).findLastIndex,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("findLastIndex",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},93706:function(e,t,n){"use strict";var r=n(95089),o=n(88828).findLast,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("findLast",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},88997:function(e,t,n){"use strict";var r=n(95089),o=n(91102).find,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("find",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},2857:function(e,t,n){"use strict";var r=n(95089),o=n(91102).forEach,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("forEach",(function(e){o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},83326:function(e,t,n){"use strict";var r=n(28834);(0,n(95089).exportTypedArrayStaticMethod)("from",n(83590),r)},94715:function(e,t,n){"use strict";var r=n(95089),o=n(12636).includes,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("includes",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},13624:function(e,t,n){"use strict";var r=n(95089),o=n(12636).indexOf,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("indexOf",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},91132:function(e,t,n){"use strict";var r=n(32010),o=n(47044),i=n(38347),a=n(95089),s=n(81755),l=n(38688)("iterator"),u=r.Uint8Array,c=i(s.values),d=i(s.keys),f=i(s.entries),p=a.aTypedArray,h=a.exportTypedArrayMethod,m=u&&u.prototype,v=!o((function(){m[l].call([1])})),g=!!m&&m.values&&m[l]===m.values&&"values"===m.values.name,y=function(){return c(p(this))};h("entries",(function(){return f(p(this))}),v),h("keys",(function(){return d(p(this))}),v),h("values",y,v||!g,{name:"values"}),h(l,y,v||!g,{name:"values"})},62514:function(e,t,n){"use strict";var r=n(95089),o=n(38347),i=r.aTypedArray,a=r.exportTypedArrayMethod,s=o([].join);a("join",(function(e){return s(i(this),e)}))},24597:function(e,t,n){"use strict";var r=n(95089),o=n(58448),i=n(84320),a=r.aTypedArray;(0,r.exportTypedArrayMethod)("lastIndexOf",(function(e){var t=arguments.length;return o(i,a(this),t>1?[e,arguments[1]]:[e])}))},88042:function(e,t,n){"use strict";var r=n(95089),o=n(91102).map,i=n(34815),a=r.aTypedArray;(0,r.exportTypedArrayMethod)("map",(function(e){return o(a(this),e,arguments.length>1?arguments[1]:void 0,(function(e,t){return new(i(e))(t)}))}))},50711:function(e,t,n){"use strict";var r=n(95089),o=n(28834),i=r.aTypedArrayConstructor;(0,r.exportTypedArrayStaticMethod)("of",(function(){for(var e=0,t=arguments.length,n=new(i(this))(t);t>e;)n[e]=arguments[e++];return n}),o)},92451:function(e,t,n){"use strict";var r=n(95089),o=n(32843).right,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("reduceRight",(function(e){var t=arguments.length;return o(i(this),e,t,t>1?arguments[1]:void 0)}))},4660:function(e,t,n){"use strict";var r=n(95089),o=n(32843).left,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("reduce",(function(e){var t=arguments.length;return o(i(this),e,t,t>1?arguments[1]:void 0)}))},44206:function(e,t,n){"use strict";var r=n(95089),o=r.aTypedArray,i=r.exportTypedArrayMethod,a=Math.floor;i("reverse",(function(){for(var e,t=this,n=o(t).length,r=a(n/2),i=0;i<r;)e=t[i],t[i++]=t[--n],t[n]=e;return t}))},66288:function(e,t,n){"use strict";var r=n(32010),o=n(2834),i=n(95089),a=n(45495),s=n(80670),l=n(43162),u=n(47044),c=r.RangeError,d=r.Int8Array,f=d&&d.prototype,p=f&&f.set,h=i.aTypedArray,m=i.exportTypedArrayMethod,v=!u((function(){var e=new Uint8ClampedArray(2);return o(p,e,{length:1,0:3},1),3!==e[1]})),g=v&&i.NATIVE_ARRAY_BUFFER_VIEWS&&u((function(){var e=new d(2);return e.set(1),e.set("2",1),0!==e[0]||2!==e[1]}));m("set",(function(e){h(this);var t=s(arguments.length>1?arguments[1]:void 0,1),n=l(e);if(v)return o(p,this,n,t);var r=this.length,i=a(n),u=0;if(i+t>r)throw c("Wrong length");for(;u<i;)this[t+u]=n[u++]}),!v||g)},13250:function(e,t,n){"use strict";var r=n(95089),o=n(34815),i=n(47044),a=n(73163),s=r.aTypedArray;(0,r.exportTypedArrayMethod)("slice",(function(e,t){for(var n=a(s(this),e,t),r=o(this),i=0,l=n.length,u=new r(l);l>i;)u[i]=n[i++];return u}),i((function(){new Int8Array(1).slice()})))},3858:function(e,t,n){"use strict";var r=n(95089),o=n(91102).some,i=r.aTypedArray;(0,r.exportTypedArrayMethod)("some",(function(e){return o(i(this),e,arguments.length>1?arguments[1]:void 0)}))},84538:function(e,t,n){"use strict";var r=n(32010),o=n(85233),i=n(47044),a=n(32631),s=n(43977),l=n(95089),u=n(3809),c=n(21983),d=n(70091),f=n(41731),p=l.aTypedArray,h=l.exportTypedArrayMethod,m=r.Uint16Array,v=m&&o(m.prototype.sort),g=!(!v||i((function(){v(new m(2),null)}))&&i((function(){v(new m(2),{})}))),y=!!v&&!i((function(){if(d)return d<74;if(u)return u<67;if(c)return!0;if(f)return f<602;var e,t,n=new m(516),r=Array(516);for(e=0;e<516;e++)t=e%4,n[e]=515-e,r[e]=e-2*t+3;for(v(n,(function(e,t){return(e/4|0)-(t/4|0)})),e=0;e<516;e++)if(n[e]!==r[e])return!0}));h("sort",(function(e){return void 0!==e&&a(e),y?v(this,e):s(p(this),function(e){return function(t,n){return void 0!==e?+e(t,n)||0:n!=n?-1:t!=t?1:0===t&&0===n?1/t>0&&1/n<0?1:-1:t>n}}(e))}),!y||g)},64793:function(e,t,n){"use strict";var r=n(95089),o=n(23417),i=n(74841),a=n(34815),s=r.aTypedArray;(0,r.exportTypedArrayMethod)("subarray",(function(e,t){var n=s(this),r=n.length,l=i(e,r);return new(a(n))(n.buffer,n.byteOffset+l*n.BYTES_PER_ELEMENT,o((void 0===t?r:i(t,r))-l))}))},74202:function(e,t,n){"use strict";var r=n(32010),o=n(58448),i=n(95089),a=n(47044),s=n(73163),l=r.Int8Array,u=i.aTypedArray,c=i.exportTypedArrayMethod,d=[].toLocaleString,f=!!l&&a((function(){d.call(new l(1))}));c("toLocaleString",(function(){return o(d,f?s(u(this)):u(this),s(arguments))}),a((function(){return[1,2].toLocaleString()!=new l([1,2]).toLocaleString()}))||!a((function(){l.prototype.toLocaleString.call([1,2])})))},52529:function(e,t,n){"use strict";var r=n(95089).exportTypedArrayMethod,o=n(47044),i=n(32010),a=n(38347),s=i.Uint8Array,l=s&&s.prototype||{},u=[].toString,c=a([].join);o((function(){u.call({})}))&&(u=function(){return c(this)});var d=l.toString!=u;r("toString",u,d)},56912:function(e,t,n){n(98828)("Uint8",(function(e){return function(t,n,r){return e(this,t,n,r)}}))},39833:function(e,t,n){"use strict";var r,o=n(32010),i=n(38347),a=n(85994),s=n(62148),l=n(36673),u=n(79206),c=n(24517),d=n(31685),f=n(70172).enforce,p=n(2591),h=!o.ActiveXObject&&"ActiveXObject"in o,m=function(e){return function(){return e(this,arguments.length?arguments[0]:void 0)}},v=l("WeakMap",m,u);if(p&&h){r=u.getConstructor(m,"WeakMap",!0),s.enable();var g=v.prototype,y=i(g.delete),b=i(g.has),w=i(g.get),_=i(g.set);a(g,{delete:function(e){if(c(e)&&!d(e)){var t=f(this);return t.frozen||(t.frozen=new r),y(this,e)||t.frozen.delete(e)}return y(this,e)},has:function(e){if(c(e)&&!d(e)){var t=f(this);return t.frozen||(t.frozen=new r),b(this,e)||t.frozen.has(e)}return b(this,e)},get:function(e){if(c(e)&&!d(e)){var t=f(this);return t.frozen||(t.frozen=new r),b(this,e)?w(this,e):t.frozen.get(e)}return w(this,e)},set:function(e,t){if(c(e)&&!d(e)){var n=f(this);n.frozen||(n.frozen=new r),b(this,e)?_(this,e,t):n.frozen.set(e,t)}else _(this,e,t);return this}})}},78643:function(e,t,n){n(39833)},27217:function(e,t,n){"use strict";var r=n(56475),o=n(98125);r({target:"Object",stat:!0,forced:!0},{iterateEntries:function(e){return new o(e,"entries")}})},60573:function(e,t,n){"use strict";var r=n(56475),o=n(98125);r({target:"Object",stat:!0,forced:!0},{iterateKeys:function(e){return new o(e,"keys")}})},8843:function(e,t,n){"use strict";var r=n(56475),o=n(98125);r({target:"Object",stat:!0,forced:!0},{iterateValues:function(e){return new o(e,"values")}})},94712:function(e,t,n){var r=n(32010),o=n(23327),i=n(67797),a=n(81755),s=n(48914),l=n(38688),u=l("iterator"),c=l("toStringTag"),d=a.values,f=function(e,t){if(e){if(e[u]!==d)try{s(e,u,d)}catch(t){e[u]=d}if(e[c]||s(e,c,t),o[t])for(var n in a)if(e[n]!==a[n])try{s(e,n,a[n])}catch(t){e[n]=a[n]}}};for(var p in o)f(r[p]&&r[p].prototype,p);f(i,"DOMTokenList")},79945:function(e,t,n){"use strict";n(81755);var r=n(56475),o=n(32010),i=n(2834),a=n(38347),s=n(15567),l=n(36559),u=n(79855),c=n(85994),d=n(15216),f=n(83157),p=n(70172),h=n(2868),m=n(94578),v=n(20340),g=n(25567),y=n(52564),b=n(34984),w=n(24517),_=n(25096),O=n(10819),k=n(97841),x=n(15892),E=n(13872),T=n(25051),S=n(38688),A=n(43977),P=S("iterator"),C="URLSearchParams",R="URLSearchParamsIterator",I=p.set,N=p.getterFor(C),M=p.getterFor(R),j=Object.getOwnPropertyDescriptor,D=function(e){if(!s)return o[e];var t=j(o,e);return t&&t.value},L=D("fetch"),U=D("Request"),F=D("Headers"),B=U&&U.prototype,V=F&&F.prototype,Z=o.RegExp,H=o.TypeError,q=o.decodeURIComponent,W=o.encodeURIComponent,K=a("".charAt),$=a([].join),z=a([].push),Y=a("".replace),G=a([].shift),J=a([].splice),Q=a("".split),X=a("".slice),ee=/\+/g,te=Array(4),ne=function(e){return te[e-1]||(te[e-1]=Z("((?:%[\\da-f]{2}){"+e+"})","gi"))},re=function(e){try{return q(e)}catch(t){return e}},oe=function(e){var t=Y(e,ee," "),n=4;try{return q(t)}catch(e){for(;n;)t=Y(t,ne(n--),re);return t}},ie=/[!'()~]|%20/g,ae={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+"},se=function(e){return ae[e]},le=function(e){return Y(W(e),ie,se)},ue=f((function(e,t){I(this,{type:R,iterator:x(N(e).entries),kind:t})}),"Iterator",(function(){var e=M(this),t=e.kind,n=e.iterator.next(),r=n.value;return n.done||(n.value="keys"===t?r.key:"values"===t?r.value:[r.key,r.value]),n}),!0),ce=function(e){this.entries=[],this.url=null,void 0!==e&&(w(e)?this.parseObject(e):this.parseQuery("string"==typeof e?"?"===K(e,0)?X(e,1):e:_(e)))};ce.prototype={type:C,bindURL:function(e){this.url=e,this.update()},parseObject:function(e){var t,n,r,o,a,s,l,u=E(e);if(u)for(n=(t=x(e,u)).next;!(r=i(n,t)).done;){if(a=(o=x(b(r.value))).next,(s=i(a,o)).done||(l=i(a,o)).done||!i(a,o).done)throw H("Expected sequence with length 2");z(this.entries,{key:_(s.value),value:_(l.value)})}else for(var c in e)v(e,c)&&z(this.entries,{key:c,value:_(e[c])})},parseQuery:function(e){if(e)for(var t,n,r=Q(e,"&"),o=0;o<r.length;)(t=r[o++]).length&&(n=Q(t,"="),z(this.entries,{key:oe(G(n)),value:oe($(n,"="))}))},serialize:function(){for(var e,t=this.entries,n=[],r=0;r<t.length;)e=t[r++],z(n,le(e.key)+"="+le(e.value));return $(n,"&")},update:function(){this.entries.length=0,this.parseQuery(this.url.query)},updateURL:function(){this.url&&this.url.update()}};var de=function(){h(this,fe);var e=arguments.length>0?arguments[0]:void 0;I(this,new ce(e))},fe=de.prototype;if(c(fe,{append:function(e,t){T(arguments.length,2);var n=N(this);z(n.entries,{key:_(e),value:_(t)}),n.updateURL()},delete:function(e){T(arguments.length,1);for(var t=N(this),n=t.entries,r=_(e),o=0;o<n.length;)n[o].key===r?J(n,o,1):o++;t.updateURL()},get:function(e){T(arguments.length,1);for(var t=N(this).entries,n=_(e),r=0;r<t.length;r++)if(t[r].key===n)return t[r].value;return null},getAll:function(e){T(arguments.length,1);for(var t=N(this).entries,n=_(e),r=[],o=0;o<t.length;o++)t[o].key===n&&z(r,t[o].value);return r},has:function(e){T(arguments.length,1);for(var t=N(this).entries,n=_(e),r=0;r<t.length;)if(t[r++].key===n)return!0;return!1},set:function(e,t){T(arguments.length,1);for(var n,r=N(this),o=r.entries,i=!1,a=_(e),s=_(t),l=0;l<o.length;l++)(n=o[l]).key===a&&(i?J(o,l--,1):(i=!0,n.value=s));i||z(o,{key:a,value:s}),r.updateURL()},sort:function(){var e=N(this);A(e.entries,(function(e,t){return e.key>t.key?1:-1})),e.updateURL()},forEach:function(e){for(var t,n=N(this).entries,r=g(e,arguments.length>1?arguments[1]:void 0),o=0;o<n.length;)r((t=n[o++]).value,t.key,this)},keys:function(){return new ue(this,"keys")},values:function(){return new ue(this,"values")},entries:function(){return new ue(this,"entries")}},{enumerable:!0}),u(fe,P,fe.entries,{name:"entries"}),u(fe,"toString",(function(){return N(this).serialize()}),{enumerable:!0}),d(de,C),r({global:!0,constructor:!0,forced:!l},{URLSearchParams:de}),!l&&m(F)){var pe=a(V.has),he=a(V.set),me=function(e){if(w(e)){var t,n=e.body;if(y(n)===C)return t=e.headers?new F(e.headers):new F,pe(t,"content-type")||he(t,"content-type","application/x-www-form-urlencoded;charset=UTF-8"),O(e,{body:k(0,_(n)),headers:k(0,t)})}return e};if(m(L)&&r({global:!0,enumerable:!0,dontCallGetSet:!0,forced:!0},{fetch:function(e){return L(e,arguments.length>1?me(arguments[1]):{})}}),m(U)){var ve=function(e){return h(this,B),new U(e,arguments.length>1?me(arguments[1]):{})};B.constructor=ve,ve.prototype=B,r({global:!0,constructor:!0,dontCallGetSet:!0,forced:!0},{Request:ve})}}e.exports={URLSearchParams:de,getState:N}},97027:function(e,t,n){n(79945)},66709:function(e,t,n){"use strict";n(58281);var r,o=n(56475),i=n(15567),a=n(36559),s=n(32010),l=n(25567),u=n(38347),c=n(79855),d=n(16395),f=n(2868),p=n(20340),h=n(87146),m=n(95717),v=n(45258),g=n(69510).codeAt,y=n(84588),b=n(25096),w=n(15216),_=n(25051),O=n(79945),k=n(70172),x=k.set,E=k.getterFor("URL"),T=O.URLSearchParams,S=O.getState,A=s.URL,P=s.TypeError,C=s.parseInt,R=Math.floor,I=Math.pow,N=u("".charAt),M=u(/./.exec),j=u([].join),D=u(1..toString),L=u([].pop),U=u([].push),F=u("".replace),B=u([].shift),V=u("".split),Z=u("".slice),H=u("".toLowerCase),q=u([].unshift),W="Invalid scheme",K="Invalid host",$="Invalid port",z=/[a-z]/i,Y=/[\d+-.a-z]/i,G=/\d/,J=/^0x/i,Q=/^[0-7]+$/,X=/^\d+$/,ee=/^[\da-f]+$/i,te=/[\0\t\n\r #%/:<>?@[\\\]^|]/,ne=/[\0\t\n\r #/:<>?@[\\\]^|]/,re=/^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,oe=/[\t\n\r]/g,ie=function(e){var t,n,r,o;if("number"==typeof e){for(t=[],n=0;n<4;n++)q(t,e%256),e=R(e/256);return j(t,".")}if("object"==typeof e){for(t="",r=function(e){for(var t=null,n=1,r=null,o=0,i=0;i<8;i++)0!==e[i]?(o>n&&(t=r,n=o),r=null,o=0):(null===r&&(r=i),++o);return o>n&&(t=r,n=o),t}(e),n=0;n<8;n++)o&&0===e[n]||(o&&(o=!1),r===n?(t+=n?":":"::",o=!0):(t+=D(e[n],16),n<7&&(t+=":")));return"["+t+"]"}return e},ae={},se=h({},ae,{" ":1,'"':1,"<":1,">":1,"`":1}),le=h({},se,{"#":1,"?":1,"{":1,"}":1}),ue=h({},le,{"/":1,":":1,";":1,"=":1,"@":1,"[":1,"\\":1,"]":1,"^":1,"|":1}),ce=function(e,t){var n=g(e,0);return n>32&&n<127&&!p(t,e)?e:encodeURIComponent(e)},de={ftp:21,file:null,http:80,https:443,ws:80,wss:443},fe=function(e,t){var n;return 2==e.length&&M(z,N(e,0))&&(":"==(n=N(e,1))||!t&&"|"==n)},pe=function(e){var t;return e.length>1&&fe(Z(e,0,2))&&(2==e.length||"/"===(t=N(e,2))||"\\"===t||"?"===t||"#"===t)},he=function(e){return"."===e||"%2e"===H(e)},me={},ve={},ge={},ye={},be={},we={},_e={},Oe={},ke={},xe={},Ee={},Te={},Se={},Ae={},Pe={},Ce={},Re={},Ie={},Ne={},Me={},je={},De=function(e,t,n){var r,o,i,a=b(e);if(t){if(o=this.parse(a))throw P(o);this.searchParams=null}else{if(void 0!==n&&(r=new De(n,!0)),o=this.parse(a,null,r))throw P(o);(i=S(new T)).bindURL(this),this.searchParams=i}};De.prototype={type:"URL",parse:function(e,t,n){var o,i,a,s,l,u=this,c=t||me,d=0,f="",h=!1,g=!1,y=!1;for(e=b(e),t||(u.scheme="",u.username="",u.password="",u.host=null,u.port=null,u.path=[],u.query=null,u.fragment=null,u.cannotBeABaseURL=!1,e=F(e,re,"")),e=F(e,oe,""),o=m(e);d<=o.length;){switch(i=o[d],c){case me:if(!i||!M(z,i)){if(t)return W;c=ge;continue}f+=H(i),c=ve;break;case ve:if(i&&(M(Y,i)||"+"==i||"-"==i||"."==i))f+=H(i);else{if(":"!=i){if(t)return W;f="",c=ge,d=0;continue}if(t&&(u.isSpecial()!=p(de,f)||"file"==f&&(u.includesCredentials()||null!==u.port)||"file"==u.scheme&&!u.host))return;if(u.scheme=f,t)return void(u.isSpecial()&&de[u.scheme]==u.port&&(u.port=null));f="","file"==u.scheme?c=Ae:u.isSpecial()&&n&&n.scheme==u.scheme?c=ye:u.isSpecial()?c=Oe:"/"==o[d+1]?(c=be,d++):(u.cannotBeABaseURL=!0,U(u.path,""),c=Ne)}break;case ge:if(!n||n.cannotBeABaseURL&&"#"!=i)return W;if(n.cannotBeABaseURL&&"#"==i){u.scheme=n.scheme,u.path=v(n.path),u.query=n.query,u.fragment="",u.cannotBeABaseURL=!0,c=je;break}c="file"==n.scheme?Ae:we;continue;case ye:if("/"!=i||"/"!=o[d+1]){c=we;continue}c=ke,d++;break;case be:if("/"==i){c=xe;break}c=Ie;continue;case we:if(u.scheme=n.scheme,i==r)u.username=n.username,u.password=n.password,u.host=n.host,u.port=n.port,u.path=v(n.path),u.query=n.query;else if("/"==i||"\\"==i&&u.isSpecial())c=_e;else if("?"==i)u.username=n.username,u.password=n.password,u.host=n.host,u.port=n.port,u.path=v(n.path),u.query="",c=Me;else{if("#"!=i){u.username=n.username,u.password=n.password,u.host=n.host,u.port=n.port,u.path=v(n.path),u.path.length--,c=Ie;continue}u.username=n.username,u.password=n.password,u.host=n.host,u.port=n.port,u.path=v(n.path),u.query=n.query,u.fragment="",c=je}break;case _e:if(!u.isSpecial()||"/"!=i&&"\\"!=i){if("/"!=i){u.username=n.username,u.password=n.password,u.host=n.host,u.port=n.port,c=Ie;continue}c=xe}else c=ke;break;case Oe:if(c=ke,"/"!=i||"/"!=N(f,d+1))continue;d++;break;case ke:if("/"!=i&&"\\"!=i){c=xe;continue}break;case xe:if("@"==i){h&&(f="%40"+f),h=!0,a=m(f);for(var w=0;w<a.length;w++){var _=a[w];if(":"!=_||y){var O=ce(_,ue);y?u.password+=O:u.username+=O}else y=!0}f=""}else if(i==r||"/"==i||"?"==i||"#"==i||"\\"==i&&u.isSpecial()){if(h&&""==f)return"Invalid authority";d-=m(f).length+1,f="",c=Ee}else f+=i;break;case Ee:case Te:if(t&&"file"==u.scheme){c=Ce;continue}if(":"!=i||g){if(i==r||"/"==i||"?"==i||"#"==i||"\\"==i&&u.isSpecial()){if(u.isSpecial()&&""==f)return K;if(t&&""==f&&(u.includesCredentials()||null!==u.port))return;if(s=u.parseHost(f))return s;if(f="",c=Re,t)return;continue}"["==i?g=!0:"]"==i&&(g=!1),f+=i}else{if(""==f)return K;if(s=u.parseHost(f))return s;if(f="",c=Se,t==Te)return}break;case Se:if(!M(G,i)){if(i==r||"/"==i||"?"==i||"#"==i||"\\"==i&&u.isSpecial()||t){if(""!=f){var k=C(f,10);if(k>65535)return $;u.port=u.isSpecial()&&k===de[u.scheme]?null:k,f=""}if(t)return;c=Re;continue}return $}f+=i;break;case Ae:if(u.scheme="file","/"==i||"\\"==i)c=Pe;else{if(!n||"file"!=n.scheme){c=Ie;continue}if(i==r)u.host=n.host,u.path=v(n.path),u.query=n.query;else if("?"==i)u.host=n.host,u.path=v(n.path),u.query="",c=Me;else{if("#"!=i){pe(j(v(o,d),""))||(u.host=n.host,u.path=v(n.path),u.shortenPath()),c=Ie;continue}u.host=n.host,u.path=v(n.path),u.query=n.query,u.fragment="",c=je}}break;case Pe:if("/"==i||"\\"==i){c=Ce;break}n&&"file"==n.scheme&&!pe(j(v(o,d),""))&&(fe(n.path[0],!0)?U(u.path,n.path[0]):u.host=n.host),c=Ie;continue;case Ce:if(i==r||"/"==i||"\\"==i||"?"==i||"#"==i){if(!t&&fe(f))c=Ie;else if(""==f){if(u.host="",t)return;c=Re}else{if(s=u.parseHost(f))return s;if("localhost"==u.host&&(u.host=""),t)return;f="",c=Re}continue}f+=i;break;case Re:if(u.isSpecial()){if(c=Ie,"/"!=i&&"\\"!=i)continue}else if(t||"?"!=i)if(t||"#"!=i){if(i!=r&&(c=Ie,"/"!=i))continue}else u.fragment="",c=je;else u.query="",c=Me;break;case Ie:if(i==r||"/"==i||"\\"==i&&u.isSpecial()||!t&&("?"==i||"#"==i)){if(".."===(l=H(l=f))||"%2e."===l||".%2e"===l||"%2e%2e"===l?(u.shortenPath(),"/"==i||"\\"==i&&u.isSpecial()||U(u.path,"")):he(f)?"/"==i||"\\"==i&&u.isSpecial()||U(u.path,""):("file"==u.scheme&&!u.path.length&&fe(f)&&(u.host&&(u.host=""),f=N(f,0)+":"),U(u.path,f)),f="","file"==u.scheme&&(i==r||"?"==i||"#"==i))for(;u.path.length>1&&""===u.path[0];)B(u.path);"?"==i?(u.query="",c=Me):"#"==i&&(u.fragment="",c=je)}else f+=ce(i,le);break;case Ne:"?"==i?(u.query="",c=Me):"#"==i?(u.fragment="",c=je):i!=r&&(u.path[0]+=ce(i,ae));break;case Me:t||"#"!=i?i!=r&&("'"==i&&u.isSpecial()?u.query+="%27":u.query+="#"==i?"%23":ce(i,ae)):(u.fragment="",c=je);break;case je:i!=r&&(u.fragment+=ce(i,se))}d++}},parseHost:function(e){var t,n,r;if("["==N(e,0)){if("]"!=N(e,e.length-1))return K;if(t=function(e){var t,n,r,o,i,a,s,l=[0,0,0,0,0,0,0,0],u=0,c=null,d=0,f=function(){return N(e,d)};if(":"==f()){if(":"!=N(e,1))return;d+=2,c=++u}for(;f();){if(8==u)return;if(":"!=f()){for(t=n=0;n<4&&M(ee,f());)t=16*t+C(f(),16),d++,n++;if("."==f()){if(0==n)return;if(d-=n,u>6)return;for(r=0;f();){if(o=null,r>0){if(!("."==f()&&r<4))return;d++}if(!M(G,f()))return;for(;M(G,f());){if(i=C(f(),10),null===o)o=i;else{if(0==o)return;o=10*o+i}if(o>255)return;d++}l[u]=256*l[u]+o,2!=++r&&4!=r||u++}if(4!=r)return;break}if(":"==f()){if(d++,!f())return}else if(f())return;l[u++]=t}else{if(null!==c)return;d++,c=++u}}if(null!==c)for(a=u-c,u=7;0!=u&&a>0;)s=l[u],l[u--]=l[c+a-1],l[c+--a]=s;else if(8!=u)return;return l}(Z(e,1,-1)),!t)return K;this.host=t}else if(this.isSpecial()){if(e=y(e),M(te,e))return K;if(t=function(e){var t,n,r,o,i,a,s,l=V(e,".");if(l.length&&""==l[l.length-1]&&l.length--,(t=l.length)>4)return e;for(n=[],r=0;r<t;r++){if(""==(o=l[r]))return e;if(i=10,o.length>1&&"0"==N(o,0)&&(i=M(J,o)?16:8,o=Z(o,8==i?1:2)),""===o)a=0;else{if(!M(10==i?X:8==i?Q:ee,o))return e;a=C(o,i)}U(n,a)}for(r=0;r<t;r++)if(a=n[r],r==t-1){if(a>=I(256,5-t))return null}else if(a>255)return null;for(s=L(n),r=0;r<n.length;r++)s+=n[r]*I(256,3-r);return s}(e),null===t)return K;this.host=t}else{if(M(ne,e))return K;for(t="",n=m(e),r=0;r<n.length;r++)t+=ce(n[r],ae);this.host=t}},cannotHaveUsernamePasswordPort:function(){return!this.host||this.cannotBeABaseURL||"file"==this.scheme},includesCredentials:function(){return""!=this.username||""!=this.password},isSpecial:function(){return p(de,this.scheme)},shortenPath:function(){var e=this.path,t=e.length;!t||"file"==this.scheme&&1==t&&fe(e[0],!0)||e.length--},serialize:function(){var e=this,t=e.scheme,n=e.username,r=e.password,o=e.host,i=e.port,a=e.path,s=e.query,l=e.fragment,u=t+":";return null!==o?(u+="//",e.includesCredentials()&&(u+=n+(r?":"+r:"")+"@"),u+=ie(o),null!==i&&(u+=":"+i)):"file"==t&&(u+="//"),u+=e.cannotBeABaseURL?a[0]:a.length?"/"+j(a,"/"):"",null!==s&&(u+="?"+s),null!==l&&(u+="#"+l),u},setHref:function(e){var t=this.parse(e);if(t)throw P(t);this.searchParams.update()},getOrigin:function(){var e=this.scheme,t=this.port;if("blob"==e)try{return new Le(e.path[0]).origin}catch(e){return"null"}return"file"!=e&&this.isSpecial()?e+"://"+ie(this.host)+(null!==t?":"+t:""):"null"},getProtocol:function(){return this.scheme+":"},setProtocol:function(e){this.parse(b(e)+":",me)},getUsername:function(){return this.username},setUsername:function(e){var t=m(b(e));if(!this.cannotHaveUsernamePasswordPort()){this.username="";for(var n=0;n<t.length;n++)this.username+=ce(t[n],ue)}},getPassword:function(){return this.password},setPassword:function(e){var t=m(b(e));if(!this.cannotHaveUsernamePasswordPort()){this.password="";for(var n=0;n<t.length;n++)this.password+=ce(t[n],ue)}},getHost:function(){var e=this.host,t=this.port;return null===e?"":null===t?ie(e):ie(e)+":"+t},setHost:function(e){this.cannotBeABaseURL||this.parse(e,Ee)},getHostname:function(){var e=this.host;return null===e?"":ie(e)},setHostname:function(e){this.cannotBeABaseURL||this.parse(e,Te)},getPort:function(){var e=this.port;return null===e?"":b(e)},setPort:function(e){this.cannotHaveUsernamePasswordPort()||(""==(e=b(e))?this.port=null:this.parse(e,Se))},getPathname:function(){var e=this.path;return this.cannotBeABaseURL?e[0]:e.length?"/"+j(e,"/"):""},setPathname:function(e){this.cannotBeABaseURL||(this.path=[],this.parse(e,Re))},getSearch:function(){var e=this.query;return e?"?"+e:""},setSearch:function(e){""==(e=b(e))?this.query=null:("?"==N(e,0)&&(e=Z(e,1)),this.query="",this.parse(e,Me)),this.searchParams.update()},getSearchParams:function(){return this.searchParams.facade},getHash:function(){var e=this.fragment;return e?"#"+e:""},setHash:function(e){""!=(e=b(e))?("#"==N(e,0)&&(e=Z(e,1)),this.fragment="",this.parse(e,je)):this.fragment=null},update:function(){this.query=this.searchParams.serialize()||null}};var Le=function(e){var t=f(this,Ue),n=_(arguments.length,1)>1?arguments[1]:void 0,r=x(t,new De(e,!1,n));i||(t.href=r.serialize(),t.origin=r.getOrigin(),t.protocol=r.getProtocol(),t.username=r.getUsername(),t.password=r.getPassword(),t.host=r.getHost(),t.hostname=r.getHostname(),t.port=r.getPort(),t.pathname=r.getPathname(),t.search=r.getSearch(),t.searchParams=r.getSearchParams(),t.hash=r.getHash())},Ue=Le.prototype,Fe=function(e,t){return{get:function(){return E(this)[e]()},set:t&&function(e){return E(this)[t](e)},configurable:!0,enumerable:!0}};if(i&&(d(Ue,"href",Fe("serialize","setHref")),d(Ue,"origin",Fe("getOrigin")),d(Ue,"protocol",Fe("getProtocol","setProtocol")),d(Ue,"username",Fe("getUsername","setUsername")),d(Ue,"password",Fe("getPassword","setPassword")),d(Ue,"host",Fe("getHost","setHost")),d(Ue,"hostname",Fe("getHostname","setHostname")),d(Ue,"port",Fe("getPort","setPort")),d(Ue,"pathname",Fe("getPathname","setPathname")),d(Ue,"search",Fe("getSearch","setSearch")),d(Ue,"searchParams",Fe("getSearchParams")),d(Ue,"hash",Fe("getHash","setHash"))),c(Ue,"toJSON",(function(){return E(this).serialize()}),{enumerable:!0}),c(Ue,"toString",(function(){return E(this).serialize()}),{enumerable:!0}),A){var Be=A.createObjectURL,Ve=A.revokeObjectURL;Be&&c(Le,"createObjectURL",l(Be,A)),Ve&&c(Le,"revokeObjectURL",l(Ve,A))}w(Le,"URL"),o({global:!0,constructor:!0,forced:!a,sham:!i},{URL:Le})},5111:function(e,t,n){n(66709)},41863:function(e,t,n){"use strict";var r=n(56475),o=n(2834);r({target:"URL",proto:!0,enumerable:!0},{toJSON:function(){return o(URL.prototype.toString,this)}})},54068:function(e,t,n){var r=n(69601);e.exports=r},18209:function(e,t,n){var r=n(93504);e.exports=r},7866:function(e,t,n){var r=n(79391);e.exports=r},82903:function(e,t,n){var r=n(47446);e.exports=r},25207:function(e,t,n){var r=n(89452);e.exports=r},15836:function(e,t,n){var r=n(15369);e.exports=r},31227:function(e,t,n){var r=n(95680);n(94712),e.exports=r},57650:function(e,t,n){var r=n(79749);e.exports=r},71081:function(e,t,n){var r=n(87362);e.exports=r},9956:function(e,t,n){var r=n(83043);e.exports=r},86797:function(e,t,n){var r=n(48506);n(94712),e.exports=r},47255:function(e,t,n){var r=n(47762);e.exports=r},67437:function(e,t,n){var r=n(5694);e.exports=r},55458:function(e,t,n){var r=n(5671);e.exports=r},52653:function(e,t,n){var r=n(4154);n(94712),e.exports=r},61068:function(e,t,n){var r=n(20845);n(94712),e.exports=r},33268:function(e,t,n){n(5111),n(41863),n(97027);var r=n(11206);e.exports=r.URL},21147:function(e,t){var n="undefined"!=typeof self?self:this,r=function(){function e(){this.fetch=!1,this.DOMException=n.DOMException}return e.prototype=n,new e}();!function(e){!function(t){var n="URLSearchParams"in e,r="Symbol"in e&&"iterator"in Symbol,o="FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),i="FormData"in e,a="ArrayBuffer"in e;if(a)var s=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(e){return e&&s.indexOf(Object.prototype.toString.call(e))>-1};function u(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function c(e){return"string"!=typeof e&&(e=String(e)),e}function d(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return r&&(t[Symbol.iterator]=function(){return t}),t}function f(e){this.map={},e instanceof f?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function p(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function h(e){return new Promise((function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}}))}function m(e){var t=new FileReader,n=h(t);return t.readAsArrayBuffer(e),n}function v(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function g(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:i&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():a&&o&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=v(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):a&&(ArrayBuffer.prototype.isPrototypeOf(e)||l(e))?this._bodyArrayBuffer=v(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},o&&(this.blob=function(){var e=p(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?p(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(m)}),this.text=function(){var e,t,n,r=p(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,t=new FileReader,n=h(t),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},i&&(this.formData=function(){return this.text().then(w)}),this.json=function(){return this.text().then(JSON.parse)},this}f.prototype.append=function(e,t){e=u(e),t=c(t);var n=this.map[e];this.map[e]=n?n+", "+t:t},f.prototype.delete=function(e){delete this.map[u(e)]},f.prototype.get=function(e){return e=u(e),this.has(e)?this.map[e]:null},f.prototype.has=function(e){return this.map.hasOwnProperty(u(e))},f.prototype.set=function(e,t){this.map[u(e)]=c(t)},f.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this)},f.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n)})),d(e)},f.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),d(e)},f.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t])})),d(e)},r&&(f.prototype[Symbol.iterator]=f.prototype.entries);var y=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function b(e,t){var n,r,o=(t=t||{}).body;if(e instanceof b){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new f(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new f(t.headers)),this.method=(n=t.method||this.method||"GET",r=n.toUpperCase(),y.indexOf(r)>-1?r:n),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function w(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),o=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(o))}})),t}function _(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new f(t.headers),this.url=t.url||"",this._initBody(e)}b.prototype.clone=function(){return new b(this,{body:this._bodyInit})},g.call(b.prototype),g.call(_.prototype),_.prototype.clone=function(){return new _(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new f(this.headers),url:this.url})},_.error=function(){var e=new _(null,{status:0,statusText:""});return e.type="error",e};var O=[301,302,303,307,308];_.redirect=function(e,t){if(-1===O.indexOf(t))throw new RangeError("Invalid status code");return new _(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function k(e,n){return new Promise((function(r,i){var a=new b(e,n);if(a.signal&&a.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var s=new XMLHttpRequest;function l(){s.abort()}s.onload=function(){var e,t,n={status:s.status,statusText:s.statusText,headers:(e=s.getAllResponseHeaders()||"",t=new f,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var o=n.join(":").trim();t.append(r,o)}})),t)};n.url="responseURL"in s?s.responseURL:n.headers.get("X-Request-URL");var o="response"in s?s.response:s.responseText;r(new _(o,n))},s.onerror=function(){i(new TypeError("Network request failed"))},s.ontimeout=function(){i(new TypeError("Network request failed"))},s.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},s.open(a.method,a.url,!0),"include"===a.credentials?s.withCredentials=!0:"omit"===a.credentials&&(s.withCredentials=!1),"responseType"in s&&o&&(s.responseType="blob"),a.headers.forEach((function(e,t){s.setRequestHeader(t,e)})),a.signal&&(a.signal.addEventListener("abort",l),s.onreadystatechange=function(){4===s.readyState&&a.signal.removeEventListener("abort",l)}),s.send(void 0===a._bodyInit?null:a._bodyInit)}))}k.polyfill=!0,e.fetch||(e.fetch=k,e.Headers=f,e.Request=b,e.Response=_),t.Headers=f,t.Request=b,t.Response=_,t.fetch=k,Object.defineProperty(t,"__esModule",{value:!0})}({})}(r),r.fetch.ponyfill=!0,delete r.fetch.polyfill;var o=r;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t},66150:function(e){if("undefined"!=typeof Element&&!Element.prototype.matches){var t=Element.prototype;t.matches=t.matchesSelector||t.mozMatchesSelector||t.msMatchesSelector||t.oMatchesSelector||t.webkitMatchesSelector}e.exports=function(e,t){for(;e&&9!==e.nodeType;){if("function"==typeof e.matches&&e.matches(t))return e;e=e.parentNode}}},88458:function(e,t,n){var r=n(66150);function o(e,t,n,r,o){var a=i.apply(this,arguments);return e.addEventListener(n,a,o),{destroy:function(){e.removeEventListener(n,a,o)}}}function i(e,t,n,o){return function(n){n.delegateTarget=r(n.target,t),n.delegateTarget&&o.call(e,n)}}e.exports=function(e,t,n,r,i){return"function"==typeof e.addEventListener?o.apply(null,arguments):"function"==typeof n?o.bind(null,document).apply(null,arguments):("string"==typeof e&&(e=document.querySelectorAll(e)),Array.prototype.map.call(e,(function(e){return o(e,t,n,r,i)})))}},23582:function(){!function(e){"use strict";function t(e){for(var t=0,n=Math.min(65536,e.length+1),r=new Uint16Array(n),o=[],i=0;;){var a=t<e.length;if(!a||i>=n-1){var s=r.subarray(0,i);if(o.push(String.fromCharCode.apply(null,s)),!a)return o.join("");e=e.subarray(t),t=0,i=0}var l=e[t++];if(0==(128&l))r[i++]=l;else if(192==(224&l)){var u=63&e[t++];r[i++]=(31&l)<<6|u}else if(224==(240&l)){u=63&e[t++];var c=63&e[t++];r[i++]=(31&l)<<12|u<<6|c}else if(240==(248&l)){var d=(7&l)<<18|(u=63&e[t++])<<12|(c=63&e[t++])<<6|63&e[t++];d>65535&&(d-=65536,r[i++]=d>>>10&1023|55296,d=56320|1023&d),r[i++]=d}}}var n="Failed to ",r=function(e,t,r){if(e)throw new Error("".concat(n).concat(t,": the '").concat(r,"' option is unsupported."))},o="function"==typeof Buffer&&Buffer.from,i=o?function(e){return Buffer.from(e)}:function(e){for(var t=0,n=e.length,r=0,o=Math.max(32,n+(n>>>1)+7),i=new Uint8Array(o>>>3<<3);t<n;){var a=e.charCodeAt(t++);if(a>=55296&&a<=56319){if(t<n){var s=e.charCodeAt(t);56320==(64512&s)&&(++t,a=((1023&a)<<10)+(1023&s)+65536)}if(a>=55296&&a<=56319)continue}if(r+4>i.length){o+=8,o=(o*=1+t/e.length*2)>>>3<<3;var l=new Uint8Array(o);l.set(i),i=l}if(0!=(4294967168&a)){if(0==(4294965248&a))i[r++]=a>>>6&31|192;else if(0==(4294901760&a))i[r++]=a>>>12&15|224,i[r++]=a>>>6&63|128;else{if(0!=(4292870144&a))continue;i[r++]=a>>>18&7|240,i[r++]=a>>>12&63|128,i[r++]=a>>>6&63|128}i[r++]=63&a|128}else i[r++]=a}return i.slice?i.slice(0,r):i.subarray(0,r)};function a(){this.encoding="utf-8"}a.prototype.encode=function(e,t){return r(t&&t.stream,"encode","stream"),i(e)};var s=!o&&"function"==typeof Blob&&"function"==typeof URL&&"function"==typeof URL.createObjectURL,l=["utf-8","utf8","unicode-1-1-utf-8"],u=t;o?u=function(e,t){return(e instanceof Buffer?e:Buffer.from(e.buffer,e.byteOffset,e.byteLength)).toString(t)}:s&&(u=function(e){try{return function(e){var t;try{var n=new Blob([e],{type:"text/plain;charset=UTF-8"});t=URL.createObjectURL(n);var r=new XMLHttpRequest;return r.open("GET",t,!1),r.send(),r.responseText}finally{t&&URL.revokeObjectURL(t)}}(e)}catch(n){return t(e)}});var c="construct 'TextDecoder'",d="".concat(n," ").concat(c,": the ");function f(e,t){if(r(t&&t.fatal,c,"fatal"),e=e||"utf-8",!(o?Buffer.isEncoding(e):-1!==l.indexOf(e.toLowerCase())))throw new RangeError("".concat(d," encoding label provided ('").concat(e,"') is invalid."));this.encoding=e,this.fatal=!1,this.ignoreBOM=!1}f.prototype.decode=function(e,t){var n;return r(t&&t.stream,"decode","stream"),n=e instanceof Uint8Array?e:e.buffer instanceof ArrayBuffer?new Uint8Array(e.buffer):new Uint8Array(e),u(n,this.encoding)},e.TextEncoder=e.TextEncoder||a,e.TextDecoder=e.TextDecoder||f}("undefined"!=typeof window?window:"undefined"!=typeof global?global:this)},20534:function(e,t){t.node=function(e){return void 0!==e&&e instanceof HTMLElement&&1===e.nodeType},t.nodeList=function(e){var n=Object.prototype.toString.call(e);return void 0!==e&&("[object NodeList]"===n||"[object HTMLCollection]"===n)&&"length"in e&&(0===e.length||t.node(e[0]))},t.string=function(e){return"string"==typeof e||e instanceof String},t.fn=function(e){return"[object Function]"===Object.prototype.toString.call(e)}},21617:function(e,t,n){var r=n(20534),o=n(88458);e.exports=function(e,t,n){if(!e&&!t&&!n)throw new Error("Missing required arguments");if(!r.string(t))throw new TypeError("Second argument must be a String");if(!r.fn(n))throw new TypeError("Third argument must be a Function");if(r.node(e))return function(e,t,n){return e.addEventListener(t,n),{destroy:function(){e.removeEventListener(t,n)}}}(e,t,n);if(r.nodeList(e))return function(e,t,n){return Array.prototype.forEach.call(e,(function(e){e.addEventListener(t,n)})),{destroy:function(){Array.prototype.forEach.call(e,(function(e){e.removeEventListener(t,n)}))}}}(e,t,n);if(r.string(e))return function(e,t,n){return o(document.body,e,t,n)}(e,t,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}},79602:function(e,t){var n;
/*!
 * jQuery JavaScript Library v3.6.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-08-26T17:52Z
 */!function(t,n){"use strict";"object"==typeof e.exports?e.exports=t.document?n(t,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return n(e)}:n(t)}("undefined"!=typeof window?window:this,(function(r,o){"use strict";var i=[],a=Object.getPrototypeOf,s=i.slice,l=i.flat?function(e){return i.flat.call(e)}:function(e){return i.concat.apply([],e)},u=i.push,c=i.indexOf,d={},f=d.toString,p=d.hasOwnProperty,h=p.toString,m=h.call(Object),v={},g=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},b=r.document,w={type:!0,src:!0,nonce:!0,noModule:!0};function _(e,t,n){var r,o,i=(n=n||b).createElement("script");if(i.text=e,t)for(r in w)(o=t[r]||t.getAttribute&&t.getAttribute(r))&&i.setAttribute(r,o);n.head.appendChild(i).parentNode.removeChild(i)}function O(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?d[f.call(e)]||"object":typeof e}var k="3.6.1",x=function(e,t){return new x.fn.init(e,t)};function E(e){var t=!!e&&"length"in e&&e.length,n=O(e);return!g(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&t>0&&t-1 in e)}x.fn=x.prototype={jquery:k,constructor:x,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=x.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return x.each(this,e)},map:function(e){return this.pushStack(x.map(this,(function(t,n){return e.call(t,n,t)})))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(x.grep(this,(function(e,t){return(t+1)%2})))},odd:function(){return this.pushStack(x.grep(this,(function(e,t){return t%2})))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:i.sort,splice:i.splice},x.extend=x.fn.extend=function(){var e,t,n,r,o,i,a=arguments[0]||{},s=1,l=arguments.length,u=!1;for("boolean"==typeof a&&(u=a,a=arguments[s]||{},s++),"object"==typeof a||g(a)||(a={}),s===l&&(a=this,s--);s<l;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(u&&r&&(x.isPlainObject(r)||(o=Array.isArray(r)))?(n=a[t],i=o&&!Array.isArray(n)?[]:o||x.isPlainObject(n)?n:{},o=!1,a[t]=x.extend(u,i,r)):void 0!==r&&(a[t]=r));return a},x.extend({expando:"jQuery"+(k+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==f.call(e))&&(!(t=a(e))||"function"==typeof(n=p.call(t,"constructor")&&t.constructor)&&h.call(n)===m)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){_(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(E(e))for(n=e.length;r<n&&!1!==t.call(e[r],r,e[r]);r++);else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(E(Object(e))?x.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:c.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,o=e.length;r<n;r++)e[o++]=t[r];return e.length=o,e},grep:function(e,t,n){for(var r=[],o=0,i=e.length,a=!n;o<i;o++)!t(e[o],o)!==a&&r.push(e[o]);return r},map:function(e,t,n){var r,o,i=0,a=[];if(E(e))for(r=e.length;i<r;i++)null!=(o=t(e[i],i,n))&&a.push(o);else for(i in e)null!=(o=t(e[i],i,n))&&a.push(o);return l(a)},guid:1,support:v}),"function"==typeof Symbol&&(x.fn[Symbol.iterator]=i[Symbol.iterator]),x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),(function(e,t){d["[object "+t+"]"]=t.toLowerCase()}));var T=
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
function(e){var t,n,r,o,i,a,s,l,u,c,d,f,p,h,m,v,g,y,b,w="sizzle"+1*new Date,_=e.document,O=0,k=0,x=le(),E=le(),T=le(),S=le(),A=function(e,t){return e===t&&(d=!0),0},P={}.hasOwnProperty,C=[],R=C.pop,I=C.push,N=C.push,M=C.slice,j=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},D="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",U="(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",F="\\[[\\x20\\t\\r\\n\\f]*("+U+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+U+"))|)"+L+"*\\]",B=":("+U+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+F+")*)|.*)\\)|)",V=new RegExp(L+"+","g"),Z=new RegExp("^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$","g"),H=new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"),q=new RegExp("^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"),W=new RegExp(L+"|>"),K=new RegExp(B),$=new RegExp("^"+U+"$"),z={ID:new RegExp("^#("+U+")"),CLASS:new RegExp("^\\.("+U+")"),TAG:new RegExp("^("+U+"|[*])"),ATTR:new RegExp("^"+F),PSEUDO:new RegExp("^"+B),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)","i"),bool:new RegExp("^(?:"+D+")$","i"),needsContext:new RegExp("^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,G=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,Q=/^[^{]+\{\s*\[native \w/,X=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,oe=function(e,t){return t?"\0"===e?"�":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},ie=function(){f()},ae=we((function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()}),{dir:"parentNode",next:"legend"});try{N.apply(C=M.call(_.childNodes),_.childNodes),C[_.childNodes.length].nodeType}catch(e){N={apply:C.length?function(e,t){I.apply(e,M.call(t))}:function(e,t){for(var n=e.length,r=0;e[n++]=t[r++];);e.length=n-1}}}function se(e,t,r,o){var i,s,u,c,d,h,g,y=t&&t.ownerDocument,_=t?t.nodeType:9;if(r=r||[],"string"!=typeof e||!e||1!==_&&9!==_&&11!==_)return r;if(!o&&(f(t),t=t||p,m)){if(11!==_&&(d=X.exec(e)))if(i=d[1]){if(9===_){if(!(u=t.getElementById(i)))return r;if(u.id===i)return r.push(u),r}else if(y&&(u=y.getElementById(i))&&b(t,u)&&u.id===i)return r.push(u),r}else{if(d[2])return N.apply(r,t.getElementsByTagName(e)),r;if((i=d[3])&&n.getElementsByClassName&&t.getElementsByClassName)return N.apply(r,t.getElementsByClassName(i)),r}if(n.qsa&&!S[e+" "]&&(!v||!v.test(e))&&(1!==_||"object"!==t.nodeName.toLowerCase())){if(g=e,y=t,1===_&&(W.test(e)||q.test(e))){for((y=ee.test(e)&&ge(t.parentNode)||t)===t&&n.scope||((c=t.getAttribute("id"))?c=c.replace(re,oe):t.setAttribute("id",c=w)),s=(h=a(e)).length;s--;)h[s]=(c?"#"+c:":scope")+" "+be(h[s]);g=h.join(",")}try{return N.apply(r,y.querySelectorAll(g)),r}catch(t){S(e,!0)}finally{c===w&&t.removeAttribute("id")}}}return l(e.replace(Z,"$1"),t,r,o)}function le(){var e=[];return function t(n,o){return e.push(n+" ")>r.cacheLength&&delete t[e.shift()],t[n+" "]=o}}function ue(e){return e[w]=!0,e}function ce(e){var t=p.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function de(e,t){for(var n=e.split("|"),o=n.length;o--;)r.attrHandle[n[o]]=t}function fe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function pe(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function he(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function me(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&ae(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function ve(e){return ue((function(t){return t=+t,ue((function(n,r){for(var o,i=e([],n.length,t),a=i.length;a--;)n[o=i[a]]&&(n[o]=!(r[o]=n[o]))}))}))}function ge(e){return e&&void 0!==e.getElementsByTagName&&e}for(t in n=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},f=se.setDocument=function(e){var t,o,a=e?e.ownerDocument||e:_;return a!=p&&9===a.nodeType&&a.documentElement?(h=(p=a).documentElement,m=!i(p),_!=p&&(o=p.defaultView)&&o.top!==o&&(o.addEventListener?o.addEventListener("unload",ie,!1):o.attachEvent&&o.attachEvent("onunload",ie)),n.scope=ce((function(e){return h.appendChild(e).appendChild(p.createElement("div")),void 0!==e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length})),n.attributes=ce((function(e){return e.className="i",!e.getAttribute("className")})),n.getElementsByTagName=ce((function(e){return e.appendChild(p.createComment("")),!e.getElementsByTagName("*").length})),n.getElementsByClassName=Q.test(p.getElementsByClassName),n.getById=ce((function(e){return h.appendChild(e).id=w,!p.getElementsByName||!p.getElementsByName(w).length})),n.getById?(r.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},r.find.ID=function(e,t){if(void 0!==t.getElementById&&m){var n=t.getElementById(e);return n?[n]:[]}}):(r.filter.ID=function(e){var t=e.replace(te,ne);return function(e){var n=void 0!==e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},r.find.ID=function(e,t){if(void 0!==t.getElementById&&m){var n,r,o,i=t.getElementById(e);if(i){if((n=i.getAttributeNode("id"))&&n.value===e)return[i];for(o=t.getElementsByName(e),r=0;i=o[r++];)if((n=i.getAttributeNode("id"))&&n.value===e)return[i]}return[]}}),r.find.TAG=n.getElementsByTagName?function(e,t){return void 0!==t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],o=0,i=t.getElementsByTagName(e);if("*"===e){for(;n=i[o++];)1===n.nodeType&&r.push(n);return r}return i},r.find.CLASS=n.getElementsByClassName&&function(e,t){if(void 0!==t.getElementsByClassName&&m)return t.getElementsByClassName(e)},g=[],v=[],(n.qsa=Q.test(p.querySelectorAll))&&(ce((function(e){var t;h.appendChild(e).innerHTML="<a id='"+w+"'></a><select id='"+w+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\[[\\x20\\t\\r\\n\\f]*(?:value|"+D+")"),e.querySelectorAll("[id~="+w+"-]").length||v.push("~="),(t=p.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||v.push("\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+w+"+*").length||v.push(".#.+[+~]"),e.querySelectorAll("\\\f"),v.push("[\\r\\n\\f]")})),ce((function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=p.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),h.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")}))),(n.matchesSelector=Q.test(y=h.matches||h.webkitMatchesSelector||h.mozMatchesSelector||h.oMatchesSelector||h.msMatchesSelector))&&ce((function(e){n.disconnectedMatch=y.call(e,"*"),y.call(e,"[s!='']:x"),g.push("!=",B)})),v=v.length&&new RegExp(v.join("|")),g=g.length&&new RegExp(g.join("|")),t=Q.test(h.compareDocumentPosition),b=t||Q.test(h.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},A=t?function(e,t){if(e===t)return d=!0,0;var r=!e.compareDocumentPosition-!t.compareDocumentPosition;return r||(1&(r=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===r?e==p||e.ownerDocument==_&&b(_,e)?-1:t==p||t.ownerDocument==_&&b(_,t)?1:c?j(c,e)-j(c,t):0:4&r?-1:1)}:function(e,t){if(e===t)return d=!0,0;var n,r=0,o=e.parentNode,i=t.parentNode,a=[e],s=[t];if(!o||!i)return e==p?-1:t==p?1:o?-1:i?1:c?j(c,e)-j(c,t):0;if(o===i)return fe(e,t);for(n=e;n=n.parentNode;)a.unshift(n);for(n=t;n=n.parentNode;)s.unshift(n);for(;a[r]===s[r];)r++;return r?fe(a[r],s[r]):a[r]==_?-1:s[r]==_?1:0},p):p},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(f(e),n.matchesSelector&&m&&!S[t+" "]&&(!g||!g.test(t))&&(!v||!v.test(t)))try{var r=y.call(e,t);if(r||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return r}catch(e){S(t,!0)}return se(t,p,null,[e]).length>0},se.contains=function(e,t){return(e.ownerDocument||e)!=p&&f(e),b(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=p&&f(e);var o=r.attrHandle[t.toLowerCase()],i=o&&P.call(r.attrHandle,t.toLowerCase())?o(e,t,!m):void 0;return void 0!==i?i:n.attributes||!m?e.getAttribute(t):(i=e.getAttributeNode(t))&&i.specified?i.value:null},se.escape=function(e){return(e+"").replace(re,oe)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,r=[],o=0,i=0;if(d=!n.detectDuplicates,c=!n.sortStable&&e.slice(0),e.sort(A),d){for(;t=e[i++];)t===e[i]&&(o=r.push(i));for(;o--;)e.splice(r[o],1)}return c=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r++];)n+=o(t);return n},r=se.selectors={cacheLength:50,createPseudo:ue,match:z,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return z.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&K.test(n)&&(t=a(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=x[e+" "];return t||(t=new RegExp("(^|[\\x20\\t\\r\\n\\f])"+e+"("+L+"|$)"))&&x(e,(function(e){return t.test("string"==typeof e.className&&e.className||void 0!==e.getAttribute&&e.getAttribute("class")||"")}))},ATTR:function(e,t,n){return function(r){var o=se.attr(r,e);return null==o?"!="===t:!t||(o+="","="===t?o===n:"!="===t?o!==n:"^="===t?n&&0===o.indexOf(n):"*="===t?n&&o.indexOf(n)>-1:"$="===t?n&&o.slice(-n.length)===n:"~="===t?(" "+o.replace(V," ")+" ").indexOf(n)>-1:"|="===t&&(o===n||o.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,r,o){var i="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===o?function(e){return!!e.parentNode}:function(t,n,l){var u,c,d,f,p,h,m=i!==a?"nextSibling":"previousSibling",v=t.parentNode,g=s&&t.nodeName.toLowerCase(),y=!l&&!s,b=!1;if(v){if(i){for(;m;){for(f=t;f=f[m];)if(s?f.nodeName.toLowerCase()===g:1===f.nodeType)return!1;h=m="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?v.firstChild:v.lastChild],a&&y){for(b=(p=(u=(c=(d=(f=v)[w]||(f[w]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]||[])[0]===O&&u[1])&&u[2],f=p&&v.childNodes[p];f=++p&&f&&f[m]||(b=p=0)||h.pop();)if(1===f.nodeType&&++b&&f===t){c[e]=[O,p,b];break}}else if(y&&(b=p=(u=(c=(d=(f=t)[w]||(f[w]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]||[])[0]===O&&u[1]),!1===b)for(;(f=++p&&f&&f[m]||(b=p=0)||h.pop())&&((s?f.nodeName.toLowerCase()!==g:1!==f.nodeType)||!++b||(y&&((c=(d=f[w]||(f[w]={}))[f.uniqueID]||(d[f.uniqueID]={}))[e]=[O,b]),f!==t)););return(b-=o)===r||b%r==0&&b/r>=0}}},PSEUDO:function(e,t){var n,o=r.pseudos[e]||r.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return o[w]?o(t):o.length>1?(n=[e,e,"",t],r.setFilters.hasOwnProperty(e.toLowerCase())?ue((function(e,n){for(var r,i=o(e,t),a=i.length;a--;)e[r=j(e,i[a])]=!(n[r]=i[a])})):function(e){return o(e,0,n)}):o}},pseudos:{not:ue((function(e){var t=[],n=[],r=s(e.replace(Z,"$1"));return r[w]?ue((function(e,t,n,o){for(var i,a=r(e,null,o,[]),s=e.length;s--;)(i=a[s])&&(e[s]=!(t[s]=i))})):function(e,o,i){return t[0]=e,r(t,null,i,n),t[0]=null,!n.pop()}})),has:ue((function(e){return function(t){return se(e,t).length>0}})),contains:ue((function(e){return e=e.replace(te,ne),function(t){return(t.textContent||o(t)).indexOf(e)>-1}})),lang:ue((function(e){return $.test(e||"")||se.error("unsupported lang: "+e),e=e.replace(te,ne).toLowerCase(),function(t){var n;do{if(n=m?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-")}while((t=t.parentNode)&&1===t.nodeType);return!1}})),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===h},focus:function(e){return e===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:me(!1),disabled:me(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!r.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve((function(){return[0]})),last:ve((function(e,t){return[t-1]})),eq:ve((function(e,t,n){return[n<0?n+t:n]})),even:ve((function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e})),odd:ve((function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e})),lt:ve((function(e,t,n){for(var r=n<0?n+t:n>t?t:n;--r>=0;)e.push(r);return e})),gt:ve((function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e}))}},r.pseudos.nth=r.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})r.pseudos[t]=pe(t);for(t in{submit:!0,reset:!0})r.pseudos[t]=he(t);function ye(){}function be(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function we(e,t,n){var r=t.dir,o=t.next,i=o||r,a=n&&"parentNode"===i,s=k++;return t.first?function(t,n,o){for(;t=t[r];)if(1===t.nodeType||a)return e(t,n,o);return!1}:function(t,n,l){var u,c,d,f=[O,s];if(l){for(;t=t[r];)if((1===t.nodeType||a)&&e(t,n,l))return!0}else for(;t=t[r];)if(1===t.nodeType||a)if(c=(d=t[w]||(t[w]={}))[t.uniqueID]||(d[t.uniqueID]={}),o&&o===t.nodeName.toLowerCase())t=t[r]||t;else{if((u=c[i])&&u[0]===O&&u[1]===s)return f[2]=u[2];if(c[i]=f,f[2]=e(t,n,l))return!0}return!1}}function _e(e){return e.length>1?function(t,n,r){for(var o=e.length;o--;)if(!e[o](t,n,r))return!1;return!0}:e[0]}function Oe(e,t,n,r,o){for(var i,a=[],s=0,l=e.length,u=null!=t;s<l;s++)(i=e[s])&&(n&&!n(i,r,o)||(a.push(i),u&&t.push(s)));return a}function ke(e,t,n,r,o,i){return r&&!r[w]&&(r=ke(r)),o&&!o[w]&&(o=ke(o,i)),ue((function(i,a,s,l){var u,c,d,f=[],p=[],h=a.length,m=i||function(e,t,n){for(var r=0,o=t.length;r<o;r++)se(e,t[r],n);return n}(t||"*",s.nodeType?[s]:s,[]),v=!e||!i&&t?m:Oe(m,f,e,s,l),g=n?o||(i?e:h||r)?[]:a:v;if(n&&n(v,g,s,l),r)for(u=Oe(g,p),r(u,[],s,l),c=u.length;c--;)(d=u[c])&&(g[p[c]]=!(v[p[c]]=d));if(i){if(o||e){if(o){for(u=[],c=g.length;c--;)(d=g[c])&&u.push(v[c]=d);o(null,g=[],u,l)}for(c=g.length;c--;)(d=g[c])&&(u=o?j(i,d):f[c])>-1&&(i[u]=!(a[u]=d))}}else g=Oe(g===a?g.splice(h,g.length):g),o?o(null,a,g,l):N.apply(a,g)}))}function xe(e){for(var t,n,o,i=e.length,a=r.relative[e[0].type],s=a||r.relative[" "],l=a?1:0,c=we((function(e){return e===t}),s,!0),d=we((function(e){return j(t,e)>-1}),s,!0),f=[function(e,n,r){var o=!a&&(r||n!==u)||((t=n).nodeType?c(e,n,r):d(e,n,r));return t=null,o}];l<i;l++)if(n=r.relative[e[l].type])f=[we(_e(f),n)];else{if((n=r.filter[e[l].type].apply(null,e[l].matches))[w]){for(o=++l;o<i&&!r.relative[e[o].type];o++);return ke(l>1&&_e(f),l>1&&be(e.slice(0,l-1).concat({value:" "===e[l-2].type?"*":""})).replace(Z,"$1"),n,l<o&&xe(e.slice(l,o)),o<i&&xe(e=e.slice(o)),o<i&&be(e))}f.push(n)}return _e(f)}return ye.prototype=r.filters=r.pseudos,r.setFilters=new ye,a=se.tokenize=function(e,t){var n,o,i,a,s,l,u,c=E[e+" "];if(c)return t?0:c.slice(0);for(s=e,l=[],u=r.preFilter;s;){for(a in n&&!(o=H.exec(s))||(o&&(s=s.slice(o[0].length)||s),l.push(i=[])),n=!1,(o=q.exec(s))&&(n=o.shift(),i.push({value:n,type:o[0].replace(Z," ")}),s=s.slice(n.length)),r.filter)!(o=z[a].exec(s))||u[a]&&!(o=u[a](o))||(n=o.shift(),i.push({value:n,type:a,matches:o}),s=s.slice(n.length));if(!n)break}return t?s.length:s?se.error(e):E(e,l).slice(0)},s=se.compile=function(e,t){var n,o=[],i=[],s=T[e+" "];if(!s){for(t||(t=a(e)),n=t.length;n--;)(s=xe(t[n]))[w]?o.push(s):i.push(s);s=T(e,function(e,t){var n=t.length>0,o=e.length>0,i=function(i,a,s,l,c){var d,h,v,g=0,y="0",b=i&&[],w=[],_=u,k=i||o&&r.find.TAG("*",c),x=O+=null==_?1:Math.random()||.1,E=k.length;for(c&&(u=a==p||a||c);y!==E&&null!=(d=k[y]);y++){if(o&&d){for(h=0,a||d.ownerDocument==p||(f(d),s=!m);v=e[h++];)if(v(d,a||p,s)){l.push(d);break}c&&(O=x)}n&&((d=!v&&d)&&g--,i&&b.push(d))}if(g+=y,n&&y!==g){for(h=0;v=t[h++];)v(b,w,a,s);if(i){if(g>0)for(;y--;)b[y]||w[y]||(w[y]=R.call(l));w=Oe(w)}N.apply(l,w),c&&!i&&w.length>0&&g+t.length>1&&se.uniqueSort(l)}return c&&(O=x,u=_),b};return n?ue(i):i}(i,o)),s.selector=e}return s},l=se.select=function(e,t,n,o){var i,l,u,c,d,f="function"==typeof e&&e,p=!o&&a(e=f.selector||e);if(n=n||[],1===p.length){if((l=p[0]=p[0].slice(0)).length>2&&"ID"===(u=l[0]).type&&9===t.nodeType&&m&&r.relative[l[1].type]){if(!(t=(r.find.ID(u.matches[0].replace(te,ne),t)||[])[0]))return n;f&&(t=t.parentNode),e=e.slice(l.shift().value.length)}for(i=z.needsContext.test(e)?0:l.length;i--&&(u=l[i],!r.relative[c=u.type]);)if((d=r.find[c])&&(o=d(u.matches[0].replace(te,ne),ee.test(l[0].type)&&ge(t.parentNode)||t))){if(l.splice(i,1),!(e=o.length&&be(l)))return N.apply(n,o),n;break}}return(f||s(e,p))(o,t,!m,n,!t||ee.test(e)&&ge(t.parentNode)||t),n},n.sortStable=w.split("").sort(A).join("")===w,n.detectDuplicates=!!d,f(),n.sortDetached=ce((function(e){return 1&e.compareDocumentPosition(p.createElement("fieldset"))})),ce((function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")}))||de("type|href|height|width",(function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)})),n.attributes&&ce((function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")}))||de("value",(function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue})),ce((function(e){return null==e.getAttribute("disabled")}))||de(D,(function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null})),se}(r);x.find=T,x.expr=T.selectors,x.expr[":"]=x.expr.pseudos,x.uniqueSort=x.unique=T.uniqueSort,x.text=T.getText,x.isXMLDoc=T.isXML,x.contains=T.contains,x.escapeSelector=T.escape;var S=function(e,t,n){for(var r=[],o=void 0!==n;(e=e[t])&&9!==e.nodeType;)if(1===e.nodeType){if(o&&x(e).is(n))break;r.push(e)}return r},A=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},P=x.expr.match.needsContext;function C(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var R=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function I(e,t,n){return g(t)?x.grep(e,(function(e,r){return!!t.call(e,r,e)!==n})):t.nodeType?x.grep(e,(function(e){return e===t!==n})):"string"!=typeof t?x.grep(e,(function(e){return c.call(t,e)>-1!==n})):x.filter(t,e,n)}x.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?x.find.matchesSelector(r,e)?[r]:[]:x.find.matches(e,x.grep(t,(function(e){return 1===e.nodeType})))},x.fn.extend({find:function(e){var t,n,r=this.length,o=this;if("string"!=typeof e)return this.pushStack(x(e).filter((function(){for(t=0;t<r;t++)if(x.contains(o[t],this))return!0})));for(n=this.pushStack([]),t=0;t<r;t++)x.find(e,o[t],n);return r>1?x.uniqueSort(n):n},filter:function(e){return this.pushStack(I(this,e||[],!1))},not:function(e){return this.pushStack(I(this,e||[],!0))},is:function(e){return!!I(this,"string"==typeof e&&P.test(e)?x(e):e||[],!1).length}});var N,M=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(x.fn.init=function(e,t,n){var r,o;if(!e)return this;if(n=n||N,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&e.length>=3?[null,e,null]:M.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof x?t[0]:t,x.merge(this,x.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:b,!0)),R.test(r[1])&&x.isPlainObject(t))for(r in t)g(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(o=b.getElementById(r[2]))&&(this[0]=o,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):g(e)?void 0!==n.ready?n.ready(e):e(x):x.makeArray(e,this)}).prototype=x.fn,N=x(b);var j=/^(?:parents|prev(?:Until|All))/,D={children:!0,contents:!0,next:!0,prev:!0};function L(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e}x.fn.extend({has:function(e){var t=x(e,this),n=t.length;return this.filter((function(){for(var e=0;e<n;e++)if(x.contains(this,t[e]))return!0}))},closest:function(e,t){var n,r=0,o=this.length,i=[],a="string"!=typeof e&&x(e);if(!P.test(e))for(;r<o;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&x.find.matchesSelector(n,e))){i.push(n);break}return this.pushStack(i.length>1?x.uniqueSort(i):i)},index:function(e){return e?"string"==typeof e?c.call(x(e),this[0]):c.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(x.uniqueSort(x.merge(this.get(),x(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),x.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return S(e,"parentNode")},parentsUntil:function(e,t,n){return S(e,"parentNode",n)},next:function(e){return L(e,"nextSibling")},prev:function(e){return L(e,"previousSibling")},nextAll:function(e){return S(e,"nextSibling")},prevAll:function(e){return S(e,"previousSibling")},nextUntil:function(e,t,n){return S(e,"nextSibling",n)},prevUntil:function(e,t,n){return S(e,"previousSibling",n)},siblings:function(e){return A((e.parentNode||{}).firstChild,e)},children:function(e){return A(e.firstChild)},contents:function(e){return null!=e.contentDocument&&a(e.contentDocument)?e.contentDocument:(C(e,"template")&&(e=e.content||e),x.merge([],e.childNodes))}},(function(e,t){x.fn[e]=function(n,r){var o=x.map(this,t,n);return"Until"!==e.slice(-5)&&(r=n),r&&"string"==typeof r&&(o=x.filter(r,o)),this.length>1&&(D[e]||x.uniqueSort(o),j.test(e)&&o.reverse()),this.pushStack(o)}}));var U=/[^\x20\t\r\n\f]+/g;function F(e){return e}function B(e){throw e}function V(e,t,n,r){var o;try{e&&g(o=e.promise)?o.call(e).done(t).fail(n):e&&g(o=e.then)?o.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}x.Callbacks=function(e){e="string"==typeof e?function(e){var t={};return x.each(e.match(U)||[],(function(e,n){t[n]=!0})),t}(e):x.extend({},e);var t,n,r,o,i=[],a=[],s=-1,l=function(){for(o=o||e.once,r=t=!0;a.length;s=-1)for(n=a.shift();++s<i.length;)!1===i[s].apply(n[0],n[1])&&e.stopOnFalse&&(s=i.length,n=!1);e.memory||(n=!1),t=!1,o&&(i=n?[]:"")},u={add:function(){return i&&(n&&!t&&(s=i.length-1,a.push(n)),function t(n){x.each(n,(function(n,r){g(r)?e.unique&&u.has(r)||i.push(r):r&&r.length&&"string"!==O(r)&&t(r)}))}(arguments),n&&!t&&l()),this},remove:function(){return x.each(arguments,(function(e,t){for(var n;(n=x.inArray(t,i,n))>-1;)i.splice(n,1),n<=s&&s--})),this},has:function(e){return e?x.inArray(e,i)>-1:i.length>0},empty:function(){return i&&(i=[]),this},disable:function(){return o=a=[],i=n="",this},disabled:function(){return!i},lock:function(){return o=a=[],n||t||(i=n=""),this},locked:function(){return!!o},fireWith:function(e,n){return o||(n=[e,(n=n||[]).slice?n.slice():n],a.push(n),t||l()),this},fire:function(){return u.fireWith(this,arguments),this},fired:function(){return!!r}};return u},x.extend({Deferred:function(e){var t=[["notify","progress",x.Callbacks("memory"),x.Callbacks("memory"),2],["resolve","done",x.Callbacks("once memory"),x.Callbacks("once memory"),0,"resolved"],["reject","fail",x.Callbacks("once memory"),x.Callbacks("once memory"),1,"rejected"]],n="pending",o={state:function(){return n},always:function(){return i.done(arguments).fail(arguments),this},catch:function(e){return o.then(null,e)},pipe:function(){var e=arguments;return x.Deferred((function(n){x.each(t,(function(t,r){var o=g(e[r[4]])&&e[r[4]];i[r[1]]((function(){var e=o&&o.apply(this,arguments);e&&g(e.promise)?e.promise().progress(n.notify).done(n.resolve).fail(n.reject):n[r[0]+"With"](this,o?[e]:arguments)}))})),e=null})).promise()},then:function(e,n,o){var i=0;function a(e,t,n,o){return function(){var s=this,l=arguments,u=function(){var r,u;if(!(e<i)){if((r=n.apply(s,l))===t.promise())throw new TypeError("Thenable self-resolution");u=r&&("object"==typeof r||"function"==typeof r)&&r.then,g(u)?o?u.call(r,a(i,t,F,o),a(i,t,B,o)):(i++,u.call(r,a(i,t,F,o),a(i,t,B,o),a(i,t,F,t.notifyWith))):(n!==F&&(s=void 0,l=[r]),(o||t.resolveWith)(s,l))}},c=o?u:function(){try{u()}catch(r){x.Deferred.exceptionHook&&x.Deferred.exceptionHook(r,c.stackTrace),e+1>=i&&(n!==B&&(s=void 0,l=[r]),t.rejectWith(s,l))}};e?c():(x.Deferred.getStackHook&&(c.stackTrace=x.Deferred.getStackHook()),r.setTimeout(c))}}return x.Deferred((function(r){t[0][3].add(a(0,r,g(o)?o:F,r.notifyWith)),t[1][3].add(a(0,r,g(e)?e:F)),t[2][3].add(a(0,r,g(n)?n:B))})).promise()},promise:function(e){return null!=e?x.extend(e,o):o}},i={};return x.each(t,(function(e,r){var a=r[2],s=r[5];o[r[1]]=a.add,s&&a.add((function(){n=s}),t[3-e][2].disable,t[3-e][3].disable,t[0][2].lock,t[0][3].lock),a.add(r[3].fire),i[r[0]]=function(){return i[r[0]+"With"](this===i?void 0:this,arguments),this},i[r[0]+"With"]=a.fireWith})),o.promise(i),e&&e.call(i,i),i},when:function(e){var t=arguments.length,n=t,r=Array(n),o=s.call(arguments),i=x.Deferred(),a=function(e){return function(n){r[e]=this,o[e]=arguments.length>1?s.call(arguments):n,--t||i.resolveWith(r,o)}};if(t<=1&&(V(e,i.done(a(n)).resolve,i.reject,!t),"pending"===i.state()||g(o[n]&&o[n].then)))return i.then();for(;n--;)V(o[n],a(n),i.reject);return i.promise()}});var Z=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;x.Deferred.exceptionHook=function(e,t){r.console&&r.console.warn&&e&&Z.test(e.name)&&r.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},x.readyException=function(e){r.setTimeout((function(){throw e}))};var H=x.Deferred();function q(){b.removeEventListener("DOMContentLoaded",q),r.removeEventListener("load",q),x.ready()}x.fn.ready=function(e){return H.then(e).catch((function(e){x.readyException(e)})),this},x.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--x.readyWait:x.isReady)||(x.isReady=!0,!0!==e&&--x.readyWait>0||H.resolveWith(b,[x]))}}),x.ready.then=H.then,"complete"===b.readyState||"loading"!==b.readyState&&!b.documentElement.doScroll?r.setTimeout(x.ready):(b.addEventListener("DOMContentLoaded",q),r.addEventListener("load",q));var W=function(e,t,n,r,o,i,a){var s=0,l=e.length,u=null==n;if("object"===O(n))for(s in o=!0,n)W(e,t,s,n[s],!0,i,a);else if(void 0!==r&&(o=!0,g(r)||(a=!0),u&&(a?(t.call(e,r),t=null):(u=t,t=function(e,t,n){return u.call(x(e),n)})),t))for(;s<l;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return o?e:u?t.call(e):l?t(e[0],n):i},K=/^-ms-/,$=/-([a-z])/g;function z(e,t){return t.toUpperCase()}function Y(e){return e.replace(K,"ms-").replace($,z)}var G=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function J(){this.expando=x.expando+J.uid++}J.uid=1,J.prototype={cache:function(e){var t=e[this.expando];return t||(t={},G(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,o=this.cache(e);if("string"==typeof t)o[Y(t)]=n;else for(r in t)o[Y(r)]=t[r];return o},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][Y(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(Y):(t=Y(t))in r?[t]:t.match(U)||[]).length;for(;n--;)delete r[t[n]]}(void 0===t||x.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!x.isEmptyObject(t)}};var Q=new J,X=new J,ee=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,te=/[A-Z]/g;function ne(e,t,n){var r;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(te,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n=function(e){return"true"===e||"false"!==e&&("null"===e?null:e===+e+""?+e:ee.test(e)?JSON.parse(e):e)}(n)}catch(e){}X.set(e,t,n)}else n=void 0;return n}x.extend({hasData:function(e){return X.hasData(e)||Q.hasData(e)},data:function(e,t,n){return X.access(e,t,n)},removeData:function(e,t){X.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),x.fn.extend({data:function(e,t){var n,r,o,i=this[0],a=i&&i.attributes;if(void 0===e){if(this.length&&(o=X.get(i),1===i.nodeType&&!Q.get(i,"hasDataAttrs"))){for(n=a.length;n--;)a[n]&&0===(r=a[n].name).indexOf("data-")&&(r=Y(r.slice(5)),ne(i,r,o[r]));Q.set(i,"hasDataAttrs",!0)}return o}return"object"==typeof e?this.each((function(){X.set(this,e)})):W(this,(function(t){var n;if(i&&void 0===t)return void 0!==(n=X.get(i,e))||void 0!==(n=ne(i,e))?n:void 0;this.each((function(){X.set(this,e,t)}))}),null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each((function(){X.remove(this,e)}))}}),x.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Q.get(e,t),n&&(!r||Array.isArray(n)?r=Q.access(e,t,x.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=x.queue(e,t),r=n.length,o=n.shift(),i=x._queueHooks(e,t);"inprogress"===o&&(o=n.shift(),r--),o&&("fx"===t&&n.unshift("inprogress"),delete i.stop,o.call(e,(function(){x.dequeue(e,t)}),i)),!r&&i&&i.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:x.Callbacks("once memory").add((function(){Q.remove(e,[t+"queue",n])}))})}}),x.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?x.queue(this[0],e):void 0===t?this:this.each((function(){var n=x.queue(this,e,t);x._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&x.dequeue(this,e)}))},dequeue:function(e){return this.each((function(){x.dequeue(this,e)}))},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,o=x.Deferred(),i=this,a=this.length,s=function(){--r||o.resolveWith(i,[i])};for("string"!=typeof e&&(t=e,e=void 0),e=e||"fx";a--;)(n=Q.get(i[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),o.promise(t)}});var re=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,oe=new RegExp("^(?:([+-])=|)("+re+")([a-z%]*)$","i"),ie=["Top","Right","Bottom","Left"],ae=b.documentElement,se=function(e){return x.contains(e.ownerDocument,e)},le={composed:!0};ae.getRootNode&&(se=function(e){return x.contains(e.ownerDocument,e)||e.getRootNode(le)===e.ownerDocument});var ue=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&se(e)&&"none"===x.css(e,"display")};function ce(e,t,n,r){var o,i,a=20,s=r?function(){return r.cur()}:function(){return x.css(e,t,"")},l=s(),u=n&&n[3]||(x.cssNumber[t]?"":"px"),c=e.nodeType&&(x.cssNumber[t]||"px"!==u&&+l)&&oe.exec(x.css(e,t));if(c&&c[3]!==u){for(l/=2,u=u||c[3],c=+l||1;a--;)x.style(e,t,c+u),(1-i)*(1-(i=s()/l||.5))<=0&&(a=0),c/=i;c*=2,x.style(e,t,c+u),n=n||[]}return n&&(c=+c||+l||0,o=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=u,r.start=c,r.end=o)),o}var de={};function fe(e){var t,n=e.ownerDocument,r=e.nodeName,o=de[r];return o||(t=n.body.appendChild(n.createElement(r)),o=x.css(t,"display"),t.parentNode.removeChild(t),"none"===o&&(o="block"),de[r]=o,o)}function pe(e,t){for(var n,r,o=[],i=0,a=e.length;i<a;i++)(r=e[i]).style&&(n=r.style.display,t?("none"===n&&(o[i]=Q.get(r,"display")||null,o[i]||(r.style.display="")),""===r.style.display&&ue(r)&&(o[i]=fe(r))):"none"!==n&&(o[i]="none",Q.set(r,"display",n)));for(i=0;i<a;i++)null!=o[i]&&(e[i].style.display=o[i]);return e}x.fn.extend({show:function(){return pe(this,!0)},hide:function(){return pe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each((function(){ue(this)?x(this).show():x(this).hide()}))}});var he,me,ve=/^(?:checkbox|radio)$/i,ge=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,ye=/^$|^module$|\/(?:java|ecma)script/i;he=b.createDocumentFragment().appendChild(b.createElement("div")),(me=b.createElement("input")).setAttribute("type","radio"),me.setAttribute("checked","checked"),me.setAttribute("name","t"),he.appendChild(me),v.checkClone=he.cloneNode(!0).cloneNode(!0).lastChild.checked,he.innerHTML="<textarea>x</textarea>",v.noCloneChecked=!!he.cloneNode(!0).lastChild.defaultValue,he.innerHTML="<option></option>",v.option=!!he.lastChild;var be={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function we(e,t){var n;return n=void 0!==e.getElementsByTagName?e.getElementsByTagName(t||"*"):void 0!==e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&C(e,t)?x.merge([e],n):n}function _e(e,t){for(var n=0,r=e.length;n<r;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}be.tbody=be.tfoot=be.colgroup=be.caption=be.thead,be.th=be.td,v.option||(be.optgroup=be.option=[1,"<select multiple='multiple'>","</select>"]);var Oe=/<|&#?\w+;/;function ke(e,t,n,r,o){for(var i,a,s,l,u,c,d=t.createDocumentFragment(),f=[],p=0,h=e.length;p<h;p++)if((i=e[p])||0===i)if("object"===O(i))x.merge(f,i.nodeType?[i]:i);else if(Oe.test(i)){for(a=a||d.appendChild(t.createElement("div")),s=(ge.exec(i)||["",""])[1].toLowerCase(),l=be[s]||be._default,a.innerHTML=l[1]+x.htmlPrefilter(i)+l[2],c=l[0];c--;)a=a.lastChild;x.merge(f,a.childNodes),(a=d.firstChild).textContent=""}else f.push(t.createTextNode(i));for(d.textContent="",p=0;i=f[p++];)if(r&&x.inArray(i,r)>-1)o&&o.push(i);else if(u=se(i),a=we(d.appendChild(i),"script"),u&&_e(a),n)for(c=0;i=a[c++];)ye.test(i.type||"")&&n.push(i);return d}var xe=/^([^.]*)(?:\.(.+)|)/;function Ee(){return!0}function Te(){return!1}function Se(e,t){return e===function(){try{return b.activeElement}catch(e){}}()==("focus"===t)}function Ae(e,t,n,r,o,i){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ae(e,s,n,r,t[s],i);return e}if(null==r&&null==o?(o=n,r=n=void 0):null==o&&("string"==typeof n?(o=r,r=void 0):(o=r,r=n,n=void 0)),!1===o)o=Te;else if(!o)return e;return 1===i&&(a=o,o=function(e){return x().off(e),a.apply(this,arguments)},o.guid=a.guid||(a.guid=x.guid++)),e.each((function(){x.event.add(this,t,o,r,n)}))}function Pe(e,t,n){n?(Q.set(e,t,!1),x.event.add(e,t,{namespace:!1,handler:function(e){var r,o,i=Q.get(this,t);if(1&e.isTrigger&&this[t]){if(i.length)(x.event.special[t]||{}).delegateType&&e.stopPropagation();else if(i=s.call(arguments),Q.set(this,t,i),r=n(this,t),this[t](),i!==(o=Q.get(this,t))||r?Q.set(this,t,!1):o={},i!==o)return e.stopImmediatePropagation(),e.preventDefault(),o&&o.value}else i.length&&(Q.set(this,t,{value:x.event.trigger(x.extend(i[0],x.Event.prototype),i.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Q.get(e,t)&&x.event.add(e,t,Ee)}x.event={global:{},add:function(e,t,n,r,o){var i,a,s,l,u,c,d,f,p,h,m,v=Q.get(e);if(G(e))for(n.handler&&(n=(i=n).handler,o=i.selector),o&&x.find.matchesSelector(ae,o),n.guid||(n.guid=x.guid++),(l=v.events)||(l=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(t){return void 0!==x&&x.event.triggered!==t.type?x.event.dispatch.apply(e,arguments):void 0}),u=(t=(t||"").match(U)||[""]).length;u--;)p=m=(s=xe.exec(t[u])||[])[1],h=(s[2]||"").split(".").sort(),p&&(d=x.event.special[p]||{},p=(o?d.delegateType:d.bindType)||p,d=x.event.special[p]||{},c=x.extend({type:p,origType:m,data:r,handler:n,guid:n.guid,selector:o,needsContext:o&&x.expr.match.needsContext.test(o),namespace:h.join(".")},i),(f=l[p])||((f=l[p]=[]).delegateCount=0,d.setup&&!1!==d.setup.call(e,r,h,a)||e.addEventListener&&e.addEventListener(p,a)),d.add&&(d.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),o?f.splice(f.delegateCount++,0,c):f.push(c),x.event.global[p]=!0)},remove:function(e,t,n,r,o){var i,a,s,l,u,c,d,f,p,h,m,v=Q.hasData(e)&&Q.get(e);if(v&&(l=v.events)){for(u=(t=(t||"").match(U)||[""]).length;u--;)if(p=m=(s=xe.exec(t[u])||[])[1],h=(s[2]||"").split(".").sort(),p){for(d=x.event.special[p]||{},f=l[p=(r?d.delegateType:d.bindType)||p]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=i=f.length;i--;)c=f[i],!o&&m!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(f.splice(i,1),c.selector&&f.delegateCount--,d.remove&&d.remove.call(e,c));a&&!f.length&&(d.teardown&&!1!==d.teardown.call(e,h,v.handle)||x.removeEvent(e,p,v.handle),delete l[p])}else for(p in l)x.event.remove(e,p+t[u],n,r,!0);x.isEmptyObject(l)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,r,o,i,a,s=new Array(arguments.length),l=x.event.fix(e),u=(Q.get(this,"events")||Object.create(null))[l.type]||[],c=x.event.special[l.type]||{};for(s[0]=l,t=1;t<arguments.length;t++)s[t]=arguments[t];if(l.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,l)){for(a=x.event.handlers.call(this,l,u),t=0;(o=a[t++])&&!l.isPropagationStopped();)for(l.currentTarget=o.elem,n=0;(i=o.handlers[n++])&&!l.isImmediatePropagationStopped();)l.rnamespace&&!1!==i.namespace&&!l.rnamespace.test(i.namespace)||(l.handleObj=i,l.data=i.data,void 0!==(r=((x.event.special[i.origType]||{}).handle||i.handler).apply(o.elem,s))&&!1===(l.result=r)&&(l.preventDefault(),l.stopPropagation()));return c.postDispatch&&c.postDispatch.call(this,l),l.result}},handlers:function(e,t){var n,r,o,i,a,s=[],l=t.delegateCount,u=e.target;if(l&&u.nodeType&&!("click"===e.type&&e.button>=1))for(;u!==this;u=u.parentNode||this)if(1===u.nodeType&&("click"!==e.type||!0!==u.disabled)){for(i=[],a={},n=0;n<l;n++)void 0===a[o=(r=t[n]).selector+" "]&&(a[o]=r.needsContext?x(o,this).index(u)>-1:x.find(o,this,null,[u]).length),a[o]&&i.push(r);i.length&&s.push({elem:u,handlers:i})}return u=this,l<t.length&&s.push({elem:u,handlers:t.slice(l)}),s},addProp:function(e,t){Object.defineProperty(x.Event.prototype,e,{enumerable:!0,configurable:!0,get:g(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[x.expando]?e:new x.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return ve.test(t.type)&&t.click&&C(t,"input")&&Pe(t,"click",Ee),!1},trigger:function(e){var t=this||e;return ve.test(t.type)&&t.click&&C(t,"input")&&Pe(t,"click"),!0},_default:function(e){var t=e.target;return ve.test(t.type)&&t.click&&C(t,"input")&&Q.get(t,"click")||C(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},x.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},x.Event=function(e,t){if(!(this instanceof x.Event))return new x.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ee:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&x.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[x.expando]=!0},x.Event.prototype={constructor:x.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ee,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ee,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ee,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},x.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},x.event.addProp),x.each({focus:"focusin",blur:"focusout"},(function(e,t){x.event.special[e]={setup:function(){return Pe(this,e,Se),!1},trigger:function(){return Pe(this,e),!0},_default:function(t){return Q.get(t.target,e)},delegateType:t}})),x.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},(function(e,t){x.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,o=e.relatedTarget,i=e.handleObj;return o&&(o===r||x.contains(r,o))||(e.type=i.origType,n=i.handler.apply(this,arguments),e.type=t),n}}})),x.fn.extend({on:function(e,t,n,r){return Ae(this,e,t,n,r)},one:function(e,t,n,r){return Ae(this,e,t,n,r,1)},off:function(e,t,n){var r,o;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,x(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(o in e)this.off(o,t,e[o]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each((function(){x.event.remove(this,e,n,t)}))}});var Ce=/<script|<style|<link/i,Re=/checked\s*(?:[^=]|=\s*.checked.)/i,Ie=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Ne(e,t){return C(e,"table")&&C(11!==t.nodeType?t:t.firstChild,"tr")&&x(e).children("tbody")[0]||e}function Me(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function je(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function De(e,t){var n,r,o,i,a,s;if(1===t.nodeType){if(Q.hasData(e)&&(s=Q.get(e).events))for(o in Q.remove(t,"handle events"),s)for(n=0,r=s[o].length;n<r;n++)x.event.add(t,o,s[o][n]);X.hasData(e)&&(i=X.access(e),a=x.extend({},i),X.set(t,a))}}function Le(e,t){var n=t.nodeName.toLowerCase();"input"===n&&ve.test(e.type)?t.checked=e.checked:"input"!==n&&"textarea"!==n||(t.defaultValue=e.defaultValue)}function Ue(e,t,n,r){t=l(t);var o,i,a,s,u,c,d=0,f=e.length,p=f-1,h=t[0],m=g(h);if(m||f>1&&"string"==typeof h&&!v.checkClone&&Re.test(h))return e.each((function(o){var i=e.eq(o);m&&(t[0]=h.call(this,o,i.html())),Ue(i,t,n,r)}));if(f&&(i=(o=ke(t,e[0].ownerDocument,!1,e,r)).firstChild,1===o.childNodes.length&&(o=i),i||r)){for(s=(a=x.map(we(o,"script"),Me)).length;d<f;d++)u=o,d!==p&&(u=x.clone(u,!0,!0),s&&x.merge(a,we(u,"script"))),n.call(e[d],u,d);if(s)for(c=a[a.length-1].ownerDocument,x.map(a,je),d=0;d<s;d++)u=a[d],ye.test(u.type||"")&&!Q.access(u,"globalEval")&&x.contains(c,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?x._evalUrl&&!u.noModule&&x._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},c):_(u.textContent.replace(Ie,""),u,c))}return e}function Fe(e,t,n){for(var r,o=t?x.filter(t,e):e,i=0;null!=(r=o[i]);i++)n||1!==r.nodeType||x.cleanData(we(r)),r.parentNode&&(n&&se(r)&&_e(we(r,"script")),r.parentNode.removeChild(r));return e}x.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,o,i,a,s=e.cloneNode(!0),l=se(e);if(!(v.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||x.isXMLDoc(e)))for(a=we(s),r=0,o=(i=we(e)).length;r<o;r++)Le(i[r],a[r]);if(t)if(n)for(i=i||we(e),a=a||we(s),r=0,o=i.length;r<o;r++)De(i[r],a[r]);else De(e,s);return(a=we(s,"script")).length>0&&_e(a,!l&&we(e,"script")),s},cleanData:function(e){for(var t,n,r,o=x.event.special,i=0;void 0!==(n=e[i]);i++)if(G(n)){if(t=n[Q.expando]){if(t.events)for(r in t.events)o[r]?x.event.remove(n,r):x.removeEvent(n,r,t.handle);n[Q.expando]=void 0}n[X.expando]&&(n[X.expando]=void 0)}}}),x.fn.extend({detach:function(e){return Fe(this,e,!0)},remove:function(e){return Fe(this,e)},text:function(e){return W(this,(function(e){return void 0===e?x.text(this):this.empty().each((function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)}))}),null,e,arguments.length)},append:function(){return Ue(this,arguments,(function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Ne(this,e).appendChild(e)}))},prepend:function(){return Ue(this,arguments,(function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Ne(this,e);t.insertBefore(e,t.firstChild)}}))},before:function(){return Ue(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this)}))},after:function(){return Ue(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)}))},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(x.cleanData(we(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map((function(){return x.clone(this,e,t)}))},html:function(e){return W(this,(function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Ce.test(e)&&!be[(ge.exec(e)||["",""])[1].toLowerCase()]){e=x.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(x.cleanData(we(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)}),null,e,arguments.length)},replaceWith:function(){var e=[];return Ue(this,arguments,(function(t){var n=this.parentNode;x.inArray(this,e)<0&&(x.cleanData(we(this)),n&&n.replaceChild(t,this))}),e)}}),x.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},(function(e,t){x.fn[e]=function(e){for(var n,r=[],o=x(e),i=o.length-1,a=0;a<=i;a++)n=a===i?this:this.clone(!0),x(o[a])[t](n),u.apply(r,n.get());return this.pushStack(r)}}));var Be=new RegExp("^("+re+")(?!px)[a-z%]+$","i"),Ve=/^--/,Ze=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=r),t.getComputedStyle(e)},He=function(e,t,n){var r,o,i={};for(o in t)i[o]=e.style[o],e.style[o]=t[o];for(o in r=n.call(e),t)e.style[o]=i[o];return r},qe=new RegExp(ie.join("|"),"i"),We=new RegExp("^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$","g");function Ke(e,t,n){var r,o,i,a,s=Ve.test(t),l=e.style;return(n=n||Ze(e))&&(a=n.getPropertyValue(t)||n[t],s&&(a=a.replace(We,"$1")),""!==a||se(e)||(a=x.style(e,t)),!v.pixelBoxStyles()&&Be.test(a)&&qe.test(t)&&(r=l.width,o=l.minWidth,i=l.maxWidth,l.minWidth=l.maxWidth=l.width=a,a=n.width,l.width=r,l.minWidth=o,l.maxWidth=i)),void 0!==a?a+"":a}function $e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(c){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",c.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",ae.appendChild(u).appendChild(c);var e=r.getComputedStyle(c);n="1%"!==e.top,l=12===t(e.marginLeft),c.style.right="60%",a=36===t(e.right),o=36===t(e.width),c.style.position="absolute",i=12===t(c.offsetWidth/3),ae.removeChild(u),c=null}}function t(e){return Math.round(parseFloat(e))}var n,o,i,a,s,l,u=b.createElement("div"),c=b.createElement("div");c.style&&(c.style.backgroundClip="content-box",c.cloneNode(!0).style.backgroundClip="",v.clearCloneStyle="content-box"===c.style.backgroundClip,x.extend(v,{boxSizingReliable:function(){return e(),o},pixelBoxStyles:function(){return e(),a},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),l},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,o;return null==s&&(e=b.createElement("table"),t=b.createElement("tr"),n=b.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",ae.appendChild(e).appendChild(t).appendChild(n),o=r.getComputedStyle(t),s=parseInt(o.height,10)+parseInt(o.borderTopWidth,10)+parseInt(o.borderBottomWidth,10)===t.offsetHeight,ae.removeChild(e)),s}}))}();var ze=["Webkit","Moz","ms"],Ye=b.createElement("div").style,Ge={};function Je(e){var t=x.cssProps[e]||Ge[e];return t||(e in Ye?e:Ge[e]=function(e){for(var t=e[0].toUpperCase()+e.slice(1),n=ze.length;n--;)if((e=ze[n]+t)in Ye)return e}(e)||e)}var Qe=/^(none|table(?!-c[ea]).+)/,Xe={position:"absolute",visibility:"hidden",display:"block"},et={letterSpacing:"0",fontWeight:"400"};function tt(e,t,n){var r=oe.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function nt(e,t,n,r,o,i){var a="width"===t?1:0,s=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=x.css(e,n+ie[a],!0,o)),r?("content"===n&&(l-=x.css(e,"padding"+ie[a],!0,o)),"margin"!==n&&(l-=x.css(e,"border"+ie[a]+"Width",!0,o))):(l+=x.css(e,"padding"+ie[a],!0,o),"padding"!==n?l+=x.css(e,"border"+ie[a]+"Width",!0,o):s+=x.css(e,"border"+ie[a]+"Width",!0,o));return!r&&i>=0&&(l+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-i-l-s-.5))||0),l}function rt(e,t,n){var r=Ze(e),o=(!v.boxSizingReliable()||n)&&"border-box"===x.css(e,"boxSizing",!1,r),i=o,a=Ke(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Be.test(a)){if(!n)return a;a="auto"}return(!v.boxSizingReliable()&&o||!v.reliableTrDimensions()&&C(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===x.css(e,"display",!1,r))&&e.getClientRects().length&&(o="border-box"===x.css(e,"boxSizing",!1,r),(i=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+nt(e,t,n||(o?"border":"content"),i,r,a)+"px"}function ot(e,t,n,r,o){return new ot.prototype.init(e,t,n,r,o)}x.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ke(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var o,i,a,s=Y(t),l=Ve.test(t),u=e.style;if(l||(t=Je(s)),a=x.cssHooks[t]||x.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(o=a.get(e,!1,r))?o:u[t];"string"===(i=typeof n)&&(o=oe.exec(n))&&o[1]&&(n=ce(e,t,o),i="number"),null!=n&&n==n&&("number"!==i||l||(n+=o&&o[3]||(x.cssNumber[s]?"":"px")),v.clearCloneStyle||""!==n||0!==t.indexOf("background")||(u[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(l?u.setProperty(t,n):u[t]=n))}},css:function(e,t,n,r){var o,i,a,s=Y(t);return Ve.test(t)||(t=Je(s)),(a=x.cssHooks[t]||x.cssHooks[s])&&"get"in a&&(o=a.get(e,!0,n)),void 0===o&&(o=Ke(e,t,r)),"normal"===o&&t in et&&(o=et[t]),""===n||n?(i=parseFloat(o),!0===n||isFinite(i)?i||0:o):o}}),x.each(["height","width"],(function(e,t){x.cssHooks[t]={get:function(e,n,r){if(n)return!Qe.test(x.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?rt(e,t,r):He(e,Xe,(function(){return rt(e,t,r)}))},set:function(e,n,r){var o,i=Ze(e),a=!v.scrollboxSize()&&"absolute"===i.position,s=(a||r)&&"border-box"===x.css(e,"boxSizing",!1,i),l=r?nt(e,t,r,s,i):0;return s&&a&&(l-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(i[t])-nt(e,t,"border",!1,i)-.5)),l&&(o=oe.exec(n))&&"px"!==(o[3]||"px")&&(e.style[t]=n,n=x.css(e,t)),tt(0,n,l)}}})),x.cssHooks.marginLeft=$e(v.reliableMarginLeft,(function(e,t){if(t)return(parseFloat(Ke(e,"marginLeft"))||e.getBoundingClientRect().left-He(e,{marginLeft:0},(function(){return e.getBoundingClientRect().left})))+"px"})),x.each({margin:"",padding:"",border:"Width"},(function(e,t){x.cssHooks[e+t]={expand:function(n){for(var r=0,o={},i="string"==typeof n?n.split(" "):[n];r<4;r++)o[e+ie[r]+t]=i[r]||i[r-2]||i[0];return o}},"margin"!==e&&(x.cssHooks[e+t].set=tt)})),x.fn.extend({css:function(e,t){return W(this,(function(e,t,n){var r,o,i={},a=0;if(Array.isArray(t)){for(r=Ze(e),o=t.length;a<o;a++)i[t[a]]=x.css(e,t[a],!1,r);return i}return void 0!==n?x.style(e,t,n):x.css(e,t)}),e,t,arguments.length>1)}}),x.Tween=ot,ot.prototype={constructor:ot,init:function(e,t,n,r,o,i){this.elem=e,this.prop=n,this.easing=o||x.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=i||(x.cssNumber[n]?"":"px")},cur:function(){var e=ot.propHooks[this.prop];return e&&e.get?e.get(this):ot.propHooks._default.get(this)},run:function(e){var t,n=ot.propHooks[this.prop];return this.options.duration?this.pos=t=x.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):ot.propHooks._default.set(this),this}},ot.prototype.init.prototype=ot.prototype,ot.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=x.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){x.fx.step[e.prop]?x.fx.step[e.prop](e):1!==e.elem.nodeType||!x.cssHooks[e.prop]&&null==e.elem.style[Je(e.prop)]?e.elem[e.prop]=e.now:x.style(e.elem,e.prop,e.now+e.unit)}}},ot.propHooks.scrollTop=ot.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},x.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},x.fx=ot.prototype.init,x.fx.step={};var it,at,st=/^(?:toggle|show|hide)$/,lt=/queueHooks$/;function ut(){at&&(!1===b.hidden&&r.requestAnimationFrame?r.requestAnimationFrame(ut):r.setTimeout(ut,x.fx.interval),x.fx.tick())}function ct(){return r.setTimeout((function(){it=void 0})),it=Date.now()}function dt(e,t){var n,r=0,o={height:e};for(t=t?1:0;r<4;r+=2-t)o["margin"+(n=ie[r])]=o["padding"+n]=e;return t&&(o.opacity=o.width=e),o}function ft(e,t,n){for(var r,o=(pt.tweeners[t]||[]).concat(pt.tweeners["*"]),i=0,a=o.length;i<a;i++)if(r=o[i].call(n,t,e))return r}function pt(e,t,n){var r,o,i=0,a=pt.prefilters.length,s=x.Deferred().always((function(){delete l.elem})),l=function(){if(o)return!1;for(var t=it||ct(),n=Math.max(0,u.startTime+u.duration-t),r=1-(n/u.duration||0),i=0,a=u.tweens.length;i<a;i++)u.tweens[i].run(r);return s.notifyWith(e,[u,r,n]),r<1&&a?n:(a||s.notifyWith(e,[u,1,0]),s.resolveWith(e,[u]),!1)},u=s.promise({elem:e,props:x.extend({},t),opts:x.extend(!0,{specialEasing:{},easing:x.easing._default},n),originalProperties:t,originalOptions:n,startTime:it||ct(),duration:n.duration,tweens:[],createTween:function(t,n){var r=x.Tween(e,u.opts,t,n,u.opts.specialEasing[t]||u.opts.easing);return u.tweens.push(r),r},stop:function(t){var n=0,r=t?u.tweens.length:0;if(o)return this;for(o=!0;n<r;n++)u.tweens[n].run(1);return t?(s.notifyWith(e,[u,1,0]),s.resolveWith(e,[u,t])):s.rejectWith(e,[u,t]),this}}),c=u.props;for(!function(e,t){var n,r,o,i,a;for(n in e)if(o=t[r=Y(n)],i=e[n],Array.isArray(i)&&(o=i[1],i=e[n]=i[0]),n!==r&&(e[r]=i,delete e[n]),(a=x.cssHooks[r])&&"expand"in a)for(n in i=a.expand(i),delete e[r],i)n in e||(e[n]=i[n],t[n]=o);else t[r]=o}(c,u.opts.specialEasing);i<a;i++)if(r=pt.prefilters[i].call(u,e,c,u.opts))return g(r.stop)&&(x._queueHooks(u.elem,u.opts.queue).stop=r.stop.bind(r)),r;return x.map(c,ft,u),g(u.opts.start)&&u.opts.start.call(e,u),u.progress(u.opts.progress).done(u.opts.done,u.opts.complete).fail(u.opts.fail).always(u.opts.always),x.fx.timer(x.extend(l,{elem:e,anim:u,queue:u.opts.queue})),u}x.Animation=x.extend(pt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return ce(n.elem,e,oe.exec(t),n),n}]},tweener:function(e,t){g(e)?(t=e,e=["*"]):e=e.match(U);for(var n,r=0,o=e.length;r<o;r++)n=e[r],pt.tweeners[n]=pt.tweeners[n]||[],pt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,o,i,a,s,l,u,c,d="width"in t||"height"in t,f=this,p={},h=e.style,m=e.nodeType&&ue(e),v=Q.get(e,"fxshow");for(r in n.queue||(null==(a=x._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,f.always((function(){f.always((function(){a.unqueued--,x.queue(e,"fx").length||a.empty.fire()}))}))),t)if(o=t[r],st.test(o)){if(delete t[r],i=i||"toggle"===o,o===(m?"hide":"show")){if("show"!==o||!v||void 0===v[r])continue;m=!0}p[r]=v&&v[r]||x.style(e,r)}if((l=!x.isEmptyObject(t))||!x.isEmptyObject(p))for(r in d&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(u=v&&v.display)&&(u=Q.get(e,"display")),"none"===(c=x.css(e,"display"))&&(u?c=u:(pe([e],!0),u=e.style.display||u,c=x.css(e,"display"),pe([e]))),("inline"===c||"inline-block"===c&&null!=u)&&"none"===x.css(e,"float")&&(l||(f.done((function(){h.display=u})),null==u&&(c=h.display,u="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",f.always((function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]}))),l=!1,p)l||(v?"hidden"in v&&(m=v.hidden):v=Q.access(e,"fxshow",{display:u}),i&&(v.hidden=!m),m&&pe([e],!0),f.done((function(){for(r in m||pe([e]),Q.remove(e,"fxshow"),p)x.style(e,r,p[r])}))),l=ft(m?v[r]:0,r,f),r in v||(v[r]=l.start,m&&(l.end=l.start,l.start=0))}],prefilter:function(e,t){t?pt.prefilters.unshift(e):pt.prefilters.push(e)}}),x.speed=function(e,t,n){var r=e&&"object"==typeof e?x.extend({},e):{complete:n||!n&&t||g(e)&&e,duration:e,easing:n&&t||t&&!g(t)&&t};return x.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in x.fx.speeds?r.duration=x.fx.speeds[r.duration]:r.duration=x.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){g(r.old)&&r.old.call(this),r.queue&&x.dequeue(this,r.queue)},r},x.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ue).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var o=x.isEmptyObject(e),i=x.speed(t,n,r),a=function(){var t=pt(this,x.extend({},e),i);(o||Q.get(this,"finish"))&&t.stop(!0)};return a.finish=a,o||!1===i.queue?this.each(a):this.queue(i.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=t,t=e,e=void 0),t&&this.queue(e||"fx",[]),this.each((function(){var t=!0,o=null!=e&&e+"queueHooks",i=x.timers,a=Q.get(this);if(o)a[o]&&a[o].stop&&r(a[o]);else for(o in a)a[o]&&a[o].stop&&lt.test(o)&&r(a[o]);for(o=i.length;o--;)i[o].elem!==this||null!=e&&i[o].queue!==e||(i[o].anim.stop(n),t=!1,i.splice(o,1));!t&&n||x.dequeue(this,e)}))},finish:function(e){return!1!==e&&(e=e||"fx"),this.each((function(){var t,n=Q.get(this),r=n[e+"queue"],o=n[e+"queueHooks"],i=x.timers,a=r?r.length:0;for(n.finish=!0,x.queue(this,e,[]),o&&o.stop&&o.stop.call(this,!0),t=i.length;t--;)i[t].elem===this&&i[t].queue===e&&(i[t].anim.stop(!0),i.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish}))}}),x.each(["toggle","show","hide"],(function(e,t){var n=x.fn[t];x.fn[t]=function(e,r,o){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(dt(t,!0),e,r,o)}})),x.each({slideDown:dt("show"),slideUp:dt("hide"),slideToggle:dt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},(function(e,t){x.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}})),x.timers=[],x.fx.tick=function(){var e,t=0,n=x.timers;for(it=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||x.fx.stop(),it=void 0},x.fx.timer=function(e){x.timers.push(e),x.fx.start()},x.fx.interval=13,x.fx.start=function(){at||(at=!0,ut())},x.fx.stop=function(){at=null},x.fx.speeds={slow:600,fast:200,_default:400},x.fn.delay=function(e,t){return e=x.fx&&x.fx.speeds[e]||e,t=t||"fx",this.queue(t,(function(t,n){var o=r.setTimeout(t,e);n.stop=function(){r.clearTimeout(o)}}))},function(){var e=b.createElement("input"),t=b.createElement("select").appendChild(b.createElement("option"));e.type="checkbox",v.checkOn=""!==e.value,v.optSelected=t.selected,(e=b.createElement("input")).value="t",e.type="radio",v.radioValue="t"===e.value}();var ht,mt=x.expr.attrHandle;x.fn.extend({attr:function(e,t){return W(this,x.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each((function(){x.removeAttr(this,e)}))}}),x.extend({attr:function(e,t,n){var r,o,i=e.nodeType;if(3!==i&&8!==i&&2!==i)return void 0===e.getAttribute?x.prop(e,t,n):(1===i&&x.isXMLDoc(e)||(o=x.attrHooks[t.toLowerCase()]||(x.expr.match.bool.test(t)?ht:void 0)),void 0!==n?null===n?void x.removeAttr(e,t):o&&"set"in o&&void 0!==(r=o.set(e,n,t))?r:(e.setAttribute(t,n+""),n):o&&"get"in o&&null!==(r=o.get(e,t))?r:null==(r=x.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!v.radioValue&&"radio"===t&&C(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,o=t&&t.match(U);if(o&&1===e.nodeType)for(;n=o[r++];)e.removeAttribute(n)}}),ht={set:function(e,t,n){return!1===t?x.removeAttr(e,n):e.setAttribute(n,n),n}},x.each(x.expr.match.bool.source.match(/\w+/g),(function(e,t){var n=mt[t]||x.find.attr;mt[t]=function(e,t,r){var o,i,a=t.toLowerCase();return r||(i=mt[a],mt[a]=o,o=null!=n(e,t,r)?a:null,mt[a]=i),o}}));var vt=/^(?:input|select|textarea|button)$/i,gt=/^(?:a|area)$/i;function yt(e){return(e.match(U)||[]).join(" ")}function bt(e){return e.getAttribute&&e.getAttribute("class")||""}function wt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(U)||[]}x.fn.extend({prop:function(e,t){return W(this,x.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each((function(){delete this[x.propFix[e]||e]}))}}),x.extend({prop:function(e,t,n){var r,o,i=e.nodeType;if(3!==i&&8!==i&&2!==i)return 1===i&&x.isXMLDoc(e)||(t=x.propFix[t]||t,o=x.propHooks[t]),void 0!==n?o&&"set"in o&&void 0!==(r=o.set(e,n,t))?r:e[t]=n:o&&"get"in o&&null!==(r=o.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=x.find.attr(e,"tabindex");return t?parseInt(t,10):vt.test(e.nodeName)||gt.test(e.nodeName)&&e.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),v.optSelected||(x.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),x.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],(function(){x.propFix[this.toLowerCase()]=this})),x.fn.extend({addClass:function(e){var t,n,r,o,i,a;return g(e)?this.each((function(t){x(this).addClass(e.call(this,t,bt(this)))})):(t=wt(e)).length?this.each((function(){if(r=bt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(i=0;i<t.length;i++)o=t[i],n.indexOf(" "+o+" ")<0&&(n+=o+" ");a=yt(n),r!==a&&this.setAttribute("class",a)}})):this},removeClass:function(e){var t,n,r,o,i,a;return g(e)?this.each((function(t){x(this).removeClass(e.call(this,t,bt(this)))})):arguments.length?(t=wt(e)).length?this.each((function(){if(r=bt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(i=0;i<t.length;i++)for(o=t[i];n.indexOf(" "+o+" ")>-1;)n=n.replace(" "+o+" "," ");a=yt(n),r!==a&&this.setAttribute("class",a)}})):this:this.attr("class","")},toggleClass:function(e,t){var n,r,o,i,a=typeof e,s="string"===a||Array.isArray(e);return g(e)?this.each((function(n){x(this).toggleClass(e.call(this,n,bt(this),t),t)})):"boolean"==typeof t&&s?t?this.addClass(e):this.removeClass(e):(n=wt(e),this.each((function(){if(s)for(i=x(this),o=0;o<n.length;o++)r=n[o],i.hasClass(r)?i.removeClass(r):i.addClass(r);else void 0!==e&&"boolean"!==a||((r=bt(this))&&Q.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===e?"":Q.get(this,"__className__")||""))})))},hasClass:function(e){var t,n,r=0;for(t=" "+e+" ";n=this[r++];)if(1===n.nodeType&&(" "+yt(bt(n))+" ").indexOf(t)>-1)return!0;return!1}});var _t=/\r/g;x.fn.extend({val:function(e){var t,n,r,o=this[0];return arguments.length?(r=g(e),this.each((function(n){var o;1===this.nodeType&&(null==(o=r?e.call(this,n,x(this).val()):e)?o="":"number"==typeof o?o+="":Array.isArray(o)&&(o=x.map(o,(function(e){return null==e?"":e+""}))),(t=x.valHooks[this.type]||x.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,o,"value")||(this.value=o))}))):o?(t=x.valHooks[o.type]||x.valHooks[o.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(o,"value"))?n:"string"==typeof(n=o.value)?n.replace(_t,""):null==n?"":n:void 0}}),x.extend({valHooks:{option:{get:function(e){var t=x.find.attr(e,"value");return null!=t?t:yt(x.text(e))}},select:{get:function(e){var t,n,r,o=e.options,i=e.selectedIndex,a="select-one"===e.type,s=a?null:[],l=a?i+1:o.length;for(r=i<0?l:a?i:0;r<l;r++)if(((n=o[r]).selected||r===i)&&!n.disabled&&(!n.parentNode.disabled||!C(n.parentNode,"optgroup"))){if(t=x(n).val(),a)return t;s.push(t)}return s},set:function(e,t){for(var n,r,o=e.options,i=x.makeArray(t),a=o.length;a--;)((r=o[a]).selected=x.inArray(x.valHooks.option.get(r),i)>-1)&&(n=!0);return n||(e.selectedIndex=-1),i}}}}),x.each(["radio","checkbox"],(function(){x.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=x.inArray(x(e).val(),t)>-1}},v.checkOn||(x.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})})),v.focusin="onfocusin"in r;var Ot=/^(?:focusinfocus|focusoutblur)$/,kt=function(e){e.stopPropagation()};x.extend(x.event,{trigger:function(e,t,n,o){var i,a,s,l,u,c,d,f,h=[n||b],m=p.call(e,"type")?e.type:e,v=p.call(e,"namespace")?e.namespace.split("."):[];if(a=f=s=n=n||b,3!==n.nodeType&&8!==n.nodeType&&!Ot.test(m+x.event.triggered)&&(m.indexOf(".")>-1&&(v=m.split("."),m=v.shift(),v.sort()),u=m.indexOf(":")<0&&"on"+m,(e=e[x.expando]?e:new x.Event(m,"object"==typeof e&&e)).isTrigger=o?2:3,e.namespace=v.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+v.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:x.makeArray(t,[e]),d=x.event.special[m]||{},o||!d.trigger||!1!==d.trigger.apply(n,t))){if(!o&&!d.noBubble&&!y(n)){for(l=d.delegateType||m,Ot.test(l+m)||(a=a.parentNode);a;a=a.parentNode)h.push(a),s=a;s===(n.ownerDocument||b)&&h.push(s.defaultView||s.parentWindow||r)}for(i=0;(a=h[i++])&&!e.isPropagationStopped();)f=a,e.type=i>1?l:d.bindType||m,(c=(Q.get(a,"events")||Object.create(null))[e.type]&&Q.get(a,"handle"))&&c.apply(a,t),(c=u&&a[u])&&c.apply&&G(a)&&(e.result=c.apply(a,t),!1===e.result&&e.preventDefault());return e.type=m,o||e.isDefaultPrevented()||d._default&&!1!==d._default.apply(h.pop(),t)||!G(n)||u&&g(n[m])&&!y(n)&&((s=n[u])&&(n[u]=null),x.event.triggered=m,e.isPropagationStopped()&&f.addEventListener(m,kt),n[m](),e.isPropagationStopped()&&f.removeEventListener(m,kt),x.event.triggered=void 0,s&&(n[u]=s)),e.result}},simulate:function(e,t,n){var r=x.extend(new x.Event,n,{type:e,isSimulated:!0});x.event.trigger(r,null,t)}}),x.fn.extend({trigger:function(e,t){return this.each((function(){x.event.trigger(e,t,this)}))},triggerHandler:function(e,t){var n=this[0];if(n)return x.event.trigger(e,t,n,!0)}}),v.focusin||x.each({focus:"focusin",blur:"focusout"},(function(e,t){var n=function(e){x.event.simulate(t,e.target,x.event.fix(e))};x.event.special[t]={setup:function(){var r=this.ownerDocument||this.document||this,o=Q.access(r,t);o||r.addEventListener(e,n,!0),Q.access(r,t,(o||0)+1)},teardown:function(){var r=this.ownerDocument||this.document||this,o=Q.access(r,t)-1;o?Q.access(r,t,o):(r.removeEventListener(e,n,!0),Q.remove(r,t))}}}));var xt=r.location,Et={guid:Date.now()},Tt=/\?/;x.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new r.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||x.error("Invalid XML: "+(n?x.map(n.childNodes,(function(e){return e.textContent})).join("\n"):e)),t};var St=/\[\]$/,At=/\r?\n/g,Pt=/^(?:submit|button|image|reset|file)$/i,Ct=/^(?:input|select|textarea|keygen)/i;function Rt(e,t,n,r){var o;if(Array.isArray(t))x.each(t,(function(t,o){n||St.test(e)?r(e,o):Rt(e+"["+("object"==typeof o&&null!=o?t:"")+"]",o,n,r)}));else if(n||"object"!==O(t))r(e,t);else for(o in t)Rt(e+"["+o+"]",t[o],n,r)}x.param=function(e,t){var n,r=[],o=function(e,t){var n=g(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!x.isPlainObject(e))x.each(e,(function(){o(this.name,this.value)}));else for(n in e)Rt(n,e[n],t,o);return r.join("&")},x.fn.extend({serialize:function(){return x.param(this.serializeArray())},serializeArray:function(){return this.map((function(){var e=x.prop(this,"elements");return e?x.makeArray(e):this})).filter((function(){var e=this.type;return this.name&&!x(this).is(":disabled")&&Ct.test(this.nodeName)&&!Pt.test(e)&&(this.checked||!ve.test(e))})).map((function(e,t){var n=x(this).val();return null==n?null:Array.isArray(n)?x.map(n,(function(e){return{name:t.name,value:e.replace(At,"\r\n")}})):{name:t.name,value:n.replace(At,"\r\n")}})).get()}});var It=/%20/g,Nt=/#.*$/,Mt=/([?&])_=[^&]*/,jt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Dt=/^(?:GET|HEAD)$/,Lt=/^\/\//,Ut={},Ft={},Bt="*/".concat("*"),Vt=b.createElement("a");function Zt(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,o=0,i=t.toLowerCase().match(U)||[];if(g(n))for(;r=i[o++];)"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function Ht(e,t,n,r){var o={},i=e===Ft;function a(s){var l;return o[s]=!0,x.each(e[s]||[],(function(e,s){var u=s(t,n,r);return"string"!=typeof u||i||o[u]?i?!(l=u):void 0:(t.dataTypes.unshift(u),a(u),!1)})),l}return a(t.dataTypes[0])||!o["*"]&&a("*")}function qt(e,t){var n,r,o=x.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((o[n]?e:r||(r={}))[n]=t[n]);return r&&x.extend(!0,e,r),e}Vt.href=xt.href,x.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:xt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Bt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":x.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?qt(qt(e,x.ajaxSettings),t):qt(x.ajaxSettings,e)},ajaxPrefilter:Zt(Ut),ajaxTransport:Zt(Ft),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var n,o,i,a,s,l,u,c,d,f,p=x.ajaxSetup({},t),h=p.context||p,m=p.context&&(h.nodeType||h.jquery)?x(h):x.event,v=x.Deferred(),g=x.Callbacks("once memory"),y=p.statusCode||{},w={},_={},O="canceled",k={readyState:0,getResponseHeader:function(e){var t;if(u){if(!a)for(a={};t=jt.exec(i);)a[t[1].toLowerCase()+" "]=(a[t[1].toLowerCase()+" "]||[]).concat(t[2]);t=a[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return u?i:null},setRequestHeader:function(e,t){return null==u&&(e=_[e.toLowerCase()]=_[e.toLowerCase()]||e,w[e]=t),this},overrideMimeType:function(e){return null==u&&(p.mimeType=e),this},statusCode:function(e){var t;if(e)if(u)k.always(e[k.status]);else for(t in e)y[t]=[y[t],e[t]];return this},abort:function(e){var t=e||O;return n&&n.abort(t),E(0,t),this}};if(v.promise(k),p.url=((e||p.url||xt.href)+"").replace(Lt,xt.protocol+"//"),p.type=t.method||t.type||p.method||p.type,p.dataTypes=(p.dataType||"*").toLowerCase().match(U)||[""],null==p.crossDomain){l=b.createElement("a");try{l.href=p.url,l.href=l.href,p.crossDomain=Vt.protocol+"//"+Vt.host!=l.protocol+"//"+l.host}catch(e){p.crossDomain=!0}}if(p.data&&p.processData&&"string"!=typeof p.data&&(p.data=x.param(p.data,p.traditional)),Ht(Ut,p,t,k),u)return k;for(d in(c=x.event&&p.global)&&0==x.active++&&x.event.trigger("ajaxStart"),p.type=p.type.toUpperCase(),p.hasContent=!Dt.test(p.type),o=p.url.replace(Nt,""),p.hasContent?p.data&&p.processData&&0===(p.contentType||"").indexOf("application/x-www-form-urlencoded")&&(p.data=p.data.replace(It,"+")):(f=p.url.slice(o.length),p.data&&(p.processData||"string"==typeof p.data)&&(o+=(Tt.test(o)?"&":"?")+p.data,delete p.data),!1===p.cache&&(o=o.replace(Mt,"$1"),f=(Tt.test(o)?"&":"?")+"_="+Et.guid+++f),p.url=o+f),p.ifModified&&(x.lastModified[o]&&k.setRequestHeader("If-Modified-Since",x.lastModified[o]),x.etag[o]&&k.setRequestHeader("If-None-Match",x.etag[o])),(p.data&&p.hasContent&&!1!==p.contentType||t.contentType)&&k.setRequestHeader("Content-Type",p.contentType),k.setRequestHeader("Accept",p.dataTypes[0]&&p.accepts[p.dataTypes[0]]?p.accepts[p.dataTypes[0]]+("*"!==p.dataTypes[0]?", "+Bt+"; q=0.01":""):p.accepts["*"]),p.headers)k.setRequestHeader(d,p.headers[d]);if(p.beforeSend&&(!1===p.beforeSend.call(h,k,p)||u))return k.abort();if(O="abort",g.add(p.complete),k.done(p.success),k.fail(p.error),n=Ht(Ft,p,t,k)){if(k.readyState=1,c&&m.trigger("ajaxSend",[k,p]),u)return k;p.async&&p.timeout>0&&(s=r.setTimeout((function(){k.abort("timeout")}),p.timeout));try{u=!1,n.send(w,E)}catch(e){if(u)throw e;E(-1,e)}}else E(-1,"No Transport");function E(e,t,a,l){var d,f,b,w,_,O=t;u||(u=!0,s&&r.clearTimeout(s),n=void 0,i=l||"",k.readyState=e>0?4:0,d=e>=200&&e<300||304===e,a&&(w=function(e,t,n){for(var r,o,i,a,s=e.contents,l=e.dataTypes;"*"===l[0];)l.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(o in s)if(s[o]&&s[o].test(r)){l.unshift(o);break}if(l[0]in n)i=l[0];else{for(o in n){if(!l[0]||e.converters[o+" "+l[0]]){i=o;break}a||(a=o)}i=i||a}if(i)return i!==l[0]&&l.unshift(i),n[i]}(p,k,a)),!d&&x.inArray("script",p.dataTypes)>-1&&x.inArray("json",p.dataTypes)<0&&(p.converters["text script"]=function(){}),w=function(e,t,n,r){var o,i,a,s,l,u={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)u[a.toLowerCase()]=e.converters[a];for(i=c.shift();i;)if(e.responseFields[i]&&(n[e.responseFields[i]]=t),!l&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),l=i,i=c.shift())if("*"===i)i=l;else if("*"!==l&&l!==i){if(!(a=u[l+" "+i]||u["* "+i]))for(o in u)if((s=o.split(" "))[1]===i&&(a=u[l+" "+s[0]]||u["* "+s[0]])){!0===a?a=u[o]:!0!==u[o]&&(i=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e.throws)t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+l+" to "+i}}}return{state:"success",data:t}}(p,w,k,d),d?(p.ifModified&&((_=k.getResponseHeader("Last-Modified"))&&(x.lastModified[o]=_),(_=k.getResponseHeader("etag"))&&(x.etag[o]=_)),204===e||"HEAD"===p.type?O="nocontent":304===e?O="notmodified":(O=w.state,f=w.data,d=!(b=w.error))):(b=O,!e&&O||(O="error",e<0&&(e=0))),k.status=e,k.statusText=(t||O)+"",d?v.resolveWith(h,[f,O,k]):v.rejectWith(h,[k,O,b]),k.statusCode(y),y=void 0,c&&m.trigger(d?"ajaxSuccess":"ajaxError",[k,p,d?f:b]),g.fireWith(h,[k,O]),c&&(m.trigger("ajaxComplete",[k,p]),--x.active||x.event.trigger("ajaxStop")))}return k},getJSON:function(e,t,n){return x.get(e,t,n,"json")},getScript:function(e,t){return x.get(e,void 0,t,"script")}}),x.each(["get","post"],(function(e,t){x[t]=function(e,n,r,o){return g(n)&&(o=o||r,r=n,n=void 0),x.ajax(x.extend({url:e,type:t,dataType:o,data:n,success:r},x.isPlainObject(e)&&e))}})),x.ajaxPrefilter((function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")})),x._evalUrl=function(e,t,n){return x.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){x.globalEval(e,t,n)}})},x.fn.extend({wrapAll:function(e){var t;return this[0]&&(g(e)&&(e=e.call(this[0])),t=x(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map((function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e})).append(this)),this},wrapInner:function(e){return g(e)?this.each((function(t){x(this).wrapInner(e.call(this,t))})):this.each((function(){var t=x(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)}))},wrap:function(e){var t=g(e);return this.each((function(n){x(this).wrapAll(t?e.call(this,n):e)}))},unwrap:function(e){return this.parent(e).not("body").each((function(){x(this).replaceWith(this.childNodes)})),this}}),x.expr.pseudos.hidden=function(e){return!x.expr.pseudos.visible(e)},x.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},x.ajaxSettings.xhr=function(){try{return new r.XMLHttpRequest}catch(e){}};var Wt={0:200,1223:204},Kt=x.ajaxSettings.xhr();v.cors=!!Kt&&"withCredentials"in Kt,v.ajax=Kt=!!Kt,x.ajaxTransport((function(e){var t,n;if(v.cors||Kt&&!e.crossDomain)return{send:function(o,i){var a,s=e.xhr();if(s.open(e.type,e.url,e.async,e.username,e.password),e.xhrFields)for(a in e.xhrFields)s[a]=e.xhrFields[a];for(a in e.mimeType&&s.overrideMimeType&&s.overrideMimeType(e.mimeType),e.crossDomain||o["X-Requested-With"]||(o["X-Requested-With"]="XMLHttpRequest"),o)s.setRequestHeader(a,o[a]);t=function(e){return function(){t&&(t=n=s.onload=s.onerror=s.onabort=s.ontimeout=s.onreadystatechange=null,"abort"===e?s.abort():"error"===e?"number"!=typeof s.status?i(0,"error"):i(s.status,s.statusText):i(Wt[s.status]||s.status,s.statusText,"text"!==(s.responseType||"text")||"string"!=typeof s.responseText?{binary:s.response}:{text:s.responseText},s.getAllResponseHeaders()))}},s.onload=t(),n=s.onerror=s.ontimeout=t("error"),void 0!==s.onabort?s.onabort=n:s.onreadystatechange=function(){4===s.readyState&&r.setTimeout((function(){t&&n()}))},t=t("abort");try{s.send(e.hasContent&&e.data||null)}catch(e){if(t)throw e}},abort:function(){t&&t()}}})),x.ajaxPrefilter((function(e){e.crossDomain&&(e.contents.script=!1)})),x.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return x.globalEval(e),e}}}),x.ajaxPrefilter("script",(function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")})),x.ajaxTransport("script",(function(e){var t,n;if(e.crossDomain||e.scriptAttrs)return{send:function(r,o){t=x("<script>").attr(e.scriptAttrs||{}).prop({charset:e.scriptCharset,src:e.url}).on("load error",n=function(e){t.remove(),n=null,e&&o("error"===e.type?404:200,e.type)}),b.head.appendChild(t[0])},abort:function(){n&&n()}}}));var $t,zt=[],Yt=/(=)\?(?=&|$)|\?\?/;x.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=zt.pop()||x.expando+"_"+Et.guid++;return this[e]=!0,e}}),x.ajaxPrefilter("json jsonp",(function(e,t,n){var o,i,a,s=!1!==e.jsonp&&(Yt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Yt.test(e.data)&&"data");if(s||"jsonp"===e.dataTypes[0])return o=e.jsonpCallback=g(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,s?e[s]=e[s].replace(Yt,"$1"+o):!1!==e.jsonp&&(e.url+=(Tt.test(e.url)?"&":"?")+e.jsonp+"="+o),e.converters["script json"]=function(){return a||x.error(o+" was not called"),a[0]},e.dataTypes[0]="json",i=r[o],r[o]=function(){a=arguments},n.always((function(){void 0===i?x(r).removeProp(o):r[o]=i,e[o]&&(e.jsonpCallback=t.jsonpCallback,zt.push(o)),a&&g(i)&&i(a[0]),a=i=void 0})),"script"})),v.createHTMLDocument=(($t=b.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===$t.childNodes.length),x.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(v.createHTMLDocument?((r=(t=b.implementation.createHTMLDocument("")).createElement("base")).href=b.location.href,t.head.appendChild(r)):t=b),i=!n&&[],(o=R.exec(e))?[t.createElement(o[1])]:(o=ke([e],t,i),i&&i.length&&x(i).remove(),x.merge([],o.childNodes)));var r,o,i},x.fn.load=function(e,t,n){var r,o,i,a=this,s=e.indexOf(" ");return s>-1&&(r=yt(e.slice(s)),e=e.slice(0,s)),g(t)?(n=t,t=void 0):t&&"object"==typeof t&&(o="POST"),a.length>0&&x.ajax({url:e,type:o||"GET",dataType:"html",data:t}).done((function(e){i=arguments,a.html(r?x("<div>").append(x.parseHTML(e)).find(r):e)})).always(n&&function(e,t){a.each((function(){n.apply(this,i||[e.responseText,t,e])}))}),this},x.expr.pseudos.animated=function(e){return x.grep(x.timers,(function(t){return e===t.elem})).length},x.offset={setOffset:function(e,t,n){var r,o,i,a,s,l,u=x.css(e,"position"),c=x(e),d={};"static"===u&&(e.style.position="relative"),s=c.offset(),i=x.css(e,"top"),l=x.css(e,"left"),("absolute"===u||"fixed"===u)&&(i+l).indexOf("auto")>-1?(a=(r=c.position()).top,o=r.left):(a=parseFloat(i)||0,o=parseFloat(l)||0),g(t)&&(t=t.call(e,n,x.extend({},s))),null!=t.top&&(d.top=t.top-s.top+a),null!=t.left&&(d.left=t.left-s.left+o),"using"in t?t.using.call(e,d):c.css(d)}},x.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each((function(t){x.offset.setOffset(this,e,t)}));var t,n,r=this[0];return r?r.getClientRects().length?(t=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],o={top:0,left:0};if("fixed"===x.css(r,"position"))t=r.getBoundingClientRect();else{for(t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;e&&(e===n.body||e===n.documentElement)&&"static"===x.css(e,"position");)e=e.parentNode;e&&e!==r&&1===e.nodeType&&((o=x(e).offset()).top+=x.css(e,"borderTopWidth",!0),o.left+=x.css(e,"borderLeftWidth",!0))}return{top:t.top-o.top-x.css(r,"marginTop",!0),left:t.left-o.left-x.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map((function(){for(var e=this.offsetParent;e&&"static"===x.css(e,"position");)e=e.offsetParent;return e||ae}))}}),x.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},(function(e,t){var n="pageYOffset"===t;x.fn[e]=function(r){return W(this,(function(e,r,o){var i;if(y(e)?i=e:9===e.nodeType&&(i=e.defaultView),void 0===o)return i?i[t]:e[r];i?i.scrollTo(n?i.pageXOffset:o,n?o:i.pageYOffset):e[r]=o}),e,r,arguments.length)}})),x.each(["top","left"],(function(e,t){x.cssHooks[t]=$e(v.pixelPosition,(function(e,n){if(n)return n=Ke(e,t),Be.test(n)?x(e).position()[t]+"px":n}))})),x.each({Height:"height",Width:"width"},(function(e,t){x.each({padding:"inner"+e,content:t,"":"outer"+e},(function(n,r){x.fn[r]=function(o,i){var a=arguments.length&&(n||"boolean"!=typeof o),s=n||(!0===o||!0===i?"margin":"border");return W(this,(function(t,n,o){var i;return y(t)?0===r.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(i=t.documentElement,Math.max(t.body["scroll"+e],i["scroll"+e],t.body["offset"+e],i["offset"+e],i["client"+e])):void 0===o?x.css(t,n,s):x.style(t,n,o,s)}),t,a?o:void 0,a)}}))})),x.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],(function(e,t){x.fn[t]=function(e){return this.on(t,e)}})),x.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),(function(e,t){x.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}));var Gt=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;x.proxy=function(e,t){var n,r,o;if("string"==typeof t&&(n=e[t],t=e,e=n),g(e))return r=s.call(arguments,2),o=function(){return e.apply(t||this,r.concat(s.call(arguments)))},o.guid=e.guid=e.guid||x.guid++,o},x.holdReady=function(e){e?x.readyWait++:x.ready(!0)},x.isArray=Array.isArray,x.parseJSON=JSON.parse,x.nodeName=C,x.isFunction=g,x.isWindow=y,x.camelCase=Y,x.type=O,x.now=Date.now,x.isNumeric=function(e){var t=x.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},x.trim=function(e){return null==e?"":(e+"").replace(Gt,"$1")},void 0===(n=function(){return x}.apply(t,[]))||(e.exports=n);var Jt=r.jQuery,Qt=r.$;return x.noConflict=function(e){return r.$===x&&(r.$=Qt),e&&r.jQuery===x&&(r.jQuery=Jt),x},void 0===o&&(r.jQuery=r.$=x),x}))},6321:function(e){
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
!function(t){"use strict";"function"==typeof bootstrap?bootstrap("promise",t):e.exports=t()}((function(){"use strict";var e=!1;try{throw new Error}catch(t){e=!!t.stack}var t,n=O(),r=function(){},o=function(){var e={task:void 0,next:null},t=e,n=!1,r=void 0,i=!1,a=[];function s(){for(var t,r;e.next;)t=(e=e.next).task,e.task=void 0,(r=e.domain)&&(e.domain=void 0,r.enter()),l(t,r);for(;a.length;)l(t=a.pop());n=!1}function l(e,t){try{e()}catch(e){if(i)throw t&&t.exit(),setTimeout(s,0),t&&t.enter(),e;setTimeout((function(){throw e}),0)}t&&t.exit()}if(o=function(e){t=t.next={task:e,domain:i&&process.domain,next:null},n||(n=!0,r())},"object"==typeof process&&"[object process]"===process.toString()&&process.nextTick)i=!0,r=function(){process.nextTick(s)};else if("function"==typeof setImmediate)r="undefined"!=typeof window?setImmediate.bind(window,s):function(){setImmediate(s)};else if("undefined"!=typeof MessageChannel){var u=new MessageChannel;u.port1.onmessage=function(){r=c,u.port1.onmessage=s,s()};var c=function(){u.port2.postMessage(0)};r=function(){setTimeout(s,0),c()}}else r=function(){setTimeout(s,0)};return o.runAfter=function(e){a.push(e),n||(n=!0,r())},o}(),i=Function.call;function a(e){return function(){return i.apply(e,arguments)}}var s,l=a(Array.prototype.slice),u=a(Array.prototype.reduce||function(e,t){var n=0,r=this.length;if(1===arguments.length)for(;;){if(n in this){t=this[n++];break}if(++n>=r)throw new TypeError}for(;n<r;n++)n in this&&(t=e(t,this[n],n));return t}),c=a(Array.prototype.indexOf||function(e){for(var t=0;t<this.length;t++)if(this[t]===e)return t;return-1}),d=a(Array.prototype.map||function(e,t){var n=this,r=[];return u(n,(function(o,i,a){r.push(e.call(t,i,a,n))}),void 0),r}),f=Object.create||function(e){function t(){}return t.prototype=e,new t},p=a(Object.prototype.hasOwnProperty),h=Object.keys||function(e){var t=[];for(var n in e)p(e,n)&&t.push(n);return t},m=a(Object.prototype.toString);function v(e){return"[object StopIteration]"===m(e)||e instanceof s}s="undefined"!=typeof ReturnValue?ReturnValue:function(e){this.value=e};var g="From previous event:";function y(t,n){if(e&&n.stack&&"object"==typeof t&&null!==t&&t.stack&&-1===t.stack.indexOf(g)){for(var r=[],o=n;o;o=o.source)o.stack&&r.unshift(o.stack);r.unshift(t.stack);var i=r.join("\nFrom previous event:\n");t.stack=function(e){for(var t=e.split("\n"),n=[],r=0;r<t.length;++r){var o=t[r];_(o)||b(o)||!o||n.push(o)}return n.join("\n")}(i)}}function b(e){return-1!==e.indexOf("(module.js:")||-1!==e.indexOf("(node.js:")}function w(e){var t=/at .+ \((.+):(\d+):(?:\d+)\)$/.exec(e);if(t)return[t[1],Number(t[2])];var n=/at ([^ ]+):(\d+):(?:\d+)$/.exec(e);if(n)return[n[1],Number(n[2])];var r=/.*@(.+):(\d+)$/.exec(e);return r?[r[1],Number(r[2])]:void 0}function _(e){var r=w(e);if(!r)return!1;var o=r[0],i=r[1];return o===t&&i>=n&&i<=W}function O(){if(e)try{throw new Error}catch(e){var n=e.stack.split("\n"),r=w(n[0].indexOf("@")>0?n[1]:n[2]);if(!r)return;return t=r[0],r[1]}}function k(e){return e instanceof S?e:R(e)?function(e){var t=x();return k.nextTick((function(){try{e.then(t.resolve,t.reject,t.notify)}catch(e){t.reject(e)}})),t.promise}(e):F(e)}function x(){var t,n=[],r=[],o=f(x.prototype),i=f(S.prototype);if(i.promiseDispatch=function(e,o,i){var a=l(arguments);n?(n.push(a),"when"===o&&i[1]&&r.push(i[1])):k.nextTick((function(){t.promiseDispatch.apply(t,a)}))},i.valueOf=function(){if(n)return i;var e=P(t);return C(e)&&(t=e),e},i.inspect=function(){return t?t.inspect():{state:"pending"}},k.longStackSupport&&e)try{throw new Error}catch(e){i.stack=e.stack.substring(e.stack.indexOf("\n")+1)}function a(e){t=e,i.source=e,u(n,(function(t,n){k.nextTick((function(){e.promiseDispatch.apply(e,n)}))}),void 0),n=void 0,r=void 0}return o.promise=i,o.resolve=function(e){t||a(k(e))},o.fulfill=function(e){t||a(F(e))},o.reject=function(e){t||a(U(e))},o.notify=function(e){t||u(r,(function(t,n){k.nextTick((function(){n(e)}))}),void 0)},o}function E(e){if("function"!=typeof e)throw new TypeError("resolver must be a function.");var t=x();try{e(t.resolve,t.reject,t.notify)}catch(e){t.reject(e)}return t.promise}function T(e){return E((function(t,n){for(var r=0,o=e.length;r<o;r++)k(e[r]).then(t,n)}))}function S(e,t,n){void 0===t&&(t=function(e){return U(new Error("Promise does not support operation: "+e))}),void 0===n&&(n=function(){return{state:"unknown"}});var r=f(S.prototype);if(r.promiseDispatch=function(n,o,i){var a;try{a=e[o]?e[o].apply(r,i):t.call(r,o,i)}catch(e){a=U(e)}n&&n(a)},r.inspect=n,n){var o=n();"rejected"===o.state&&(r.exception=o.reason),r.valueOf=function(){var e=n();return"pending"===e.state||"rejected"===e.state?r:e.value}}return r}function A(e,t,n,r){return k(e).then(t,n,r)}function P(e){if(C(e)){var t=e.inspect();if("fulfilled"===t.state)return t.value}return e}function C(e){return e instanceof S}function R(e){return(t=e)===Object(t)&&"function"==typeof e.then;var t}k.resolve=k,k.nextTick=o,k.longStackSupport=!1,"object"==typeof process&&process&&__webpack_require__.i({"NODE_ENV":"stage","API_URL":"https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1","BASE_URL":"https://cargillcustomer.stage.cglcloud.in","LOGIN_REDIRECT_URL":"https://cargillcustomer.stage.cglcloud.in/LoggingIn","ORG_URL":"https://cargillcustomer-uat.oktapreview.com/","CUSTOM_ORG_URL":"https://login-stage.mycargill.com/","KEY_ID":"0oa10r32yuaNJCfrw0h8","ONECARGILL_APPLICATION_GROUP_ID":"00gf1pyoc1uSmFbNl0h7","ONECARGILL_ADMIN_GROUP_ID":"00gf4o186i1L3hcDw0h7","SSO_URL":"sso/saml2/0oaerr17abt1nX0gO0h7?fromURI=https%3A%2F%2Fcargillcustomer-deprecated.stage.cglcloud.in%2FLogin","CUSTOM_SSO_URL":"sso/saml2/0oauwh443dqUyH3pe0h7?fromURI=https%3A%2F%2Fidentityservices-deprecated.stage.mycargill.com%2FLogin","APPS_MANDATE_PHONE":["0oag15jfabJvKVyJn0h7"],"CAPTCHA_SITEKEY":"6LdSQasZAAAAAF1410vaTDMpUNtKrqs1RtOZuiLC","APP_ID_RECAPTCHA_EXCEPTION":"0oajg4rnuyNU834TA0h7","GROUP_ID_RECAPTCHA_EXCEPTION":"00gt5ticy6WkSIieU0h7","CONTACT_MAILID":"DXP-Okta-Development-Team-All@Cargill.com","SERVICE_ACCOUNT_GROUP_ID":"00ggpp1iegUC0PZjc0h7","MM_CLIENT_ID":"0oa1ekuqo4jWD7LFU0h8","MM_REDIRECT_URL":"https://shop.stg.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true","MM_REDIRECT_URL_SANDBOX":"https://loc-mm-shop-main.milkmoovement.services/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true","MM_REDIRECT_URL_DEV":"https://shop.dev.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true"})&&__webpack_require__.i({"NODE_ENV":"stage","API_URL":"https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1","BASE_URL":"https://cargillcustomer.stage.cglcloud.in","LOGIN_REDIRECT_URL":"https://cargillcustomer.stage.cglcloud.in/LoggingIn","ORG_URL":"https://cargillcustomer-uat.oktapreview.com/","CUSTOM_ORG_URL":"https://login-stage.mycargill.com/","KEY_ID":"0oa10r32yuaNJCfrw0h8","ONECARGILL_APPLICATION_GROUP_ID":"00gf1pyoc1uSmFbNl0h7","ONECARGILL_ADMIN_GROUP_ID":"00gf4o186i1L3hcDw0h7","SSO_URL":"sso/saml2/0oaerr17abt1nX0gO0h7?fromURI=https%3A%2F%2Fcargillcustomer-deprecated.stage.cglcloud.in%2FLogin","CUSTOM_SSO_URL":"sso/saml2/0oauwh443dqUyH3pe0h7?fromURI=https%3A%2F%2Fidentityservices-deprecated.stage.mycargill.com%2FLogin","APPS_MANDATE_PHONE":["0oag15jfabJvKVyJn0h7"],"CAPTCHA_SITEKEY":"6LdSQasZAAAAAF1410vaTDMpUNtKrqs1RtOZuiLC","APP_ID_RECAPTCHA_EXCEPTION":"0oajg4rnuyNU834TA0h7","GROUP_ID_RECAPTCHA_EXCEPTION":"00gt5ticy6WkSIieU0h7","CONTACT_MAILID":"DXP-Okta-Development-Team-All@Cargill.com","SERVICE_ACCOUNT_GROUP_ID":"00ggpp1iegUC0PZjc0h7","MM_CLIENT_ID":"0oa1ekuqo4jWD7LFU0h8","MM_REDIRECT_URL":"https://shop.stg.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true","MM_REDIRECT_URL_SANDBOX":"https://loc-mm-shop-main.milkmoovement.services/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true","MM_REDIRECT_URL_DEV":"https://shop.dev.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true"}).Q_DEBUG&&(k.longStackSupport=!0),k.defer=x,x.prototype.makeNodeResolver=function(){var e=this;return function(t,n){t?e.reject(t):arguments.length>2?e.resolve(l(arguments,1)):e.resolve(n)}},k.Promise=E,k.promise=E,E.race=T,E.all=Z,E.reject=U,E.resolve=k,k.passByCopy=function(e){return e},S.prototype.passByCopy=function(){return this},k.join=function(e,t){return k(e).join(t)},S.prototype.join=function(e){return k([this,e]).spread((function(e,t){if(e===t)return e;throw new Error("Can't join: not the same: "+e+" "+t)}))},k.race=T,S.prototype.race=function(){return this.then(k.race)},k.makePromise=S,S.prototype.toString=function(){return"[object Promise]"},S.prototype.then=function(e,t,n){var r=this,o=x(),i=!1;return k.nextTick((function(){r.promiseDispatch((function(t){i||(i=!0,o.resolve(function(t){try{return"function"==typeof e?e(t):t}catch(e){return U(e)}}(t)))}),"when",[function(e){i||(i=!0,o.resolve(function(e){if("function"==typeof t){y(e,r);try{return t(e)}catch(e){return U(e)}}return U(e)}(e)))}])})),r.promiseDispatch(void 0,"when",[void 0,function(e){var t,r=!1;try{t=function(e){return"function"==typeof n?n(e):e}(e)}catch(e){if(r=!0,!k.onerror)throw e;k.onerror(e)}r||o.notify(t)}]),o.promise},k.tap=function(e,t){return k(e).tap(t)},S.prototype.tap=function(e){return e=k(e),this.then((function(t){return e.fcall(t).thenResolve(t)}))},k.when=A,S.prototype.thenResolve=function(e){return this.then((function(){return e}))},k.thenResolve=function(e,t){return k(e).thenResolve(t)},S.prototype.thenReject=function(e){return this.then((function(){throw e}))},k.thenReject=function(e,t){return k(e).thenReject(t)},k.nearer=P,k.isPromise=C,k.isPromiseAlike=R,k.isPending=function(e){return C(e)&&"pending"===e.inspect().state},S.prototype.isPending=function(){return"pending"===this.inspect().state},k.isFulfilled=function(e){return!C(e)||"fulfilled"===e.inspect().state},S.prototype.isFulfilled=function(){return"fulfilled"===this.inspect().state},k.isRejected=function(e){return C(e)&&"rejected"===e.inspect().state},S.prototype.isRejected=function(){return"rejected"===this.inspect().state};var I,N=[],M=[],j=[],D=!0;function L(){N.length=0,M.length=0,D||(D=!0)}function U(e){var t=S({when:function(t){return t&&function(e){if(D){var t=c(M,e);-1!==t&&("object"==typeof process&&"function"==typeof process.emit&&k.nextTick.runAfter((function(){var n=c(j,e);-1!==n&&(process.emit("rejectionHandled",N[t],e),j.splice(n,1))})),M.splice(t,1),N.splice(t,1))}}(this),t?t(e):this}},(function(){return this}),(function(){return{state:"rejected",reason:e}}));return function(e,t){D&&("object"==typeof process&&"function"==typeof process.emit&&k.nextTick.runAfter((function(){-1!==c(M,e)&&(process.emit("unhandledRejection",t,e),j.push(e))})),M.push(e),t&&void 0!==t.stack?N.push(t.stack):N.push("(no stack) "+t))}(t,e),t}function F(e){return S({when:function(){return e},get:function(t){return e[t]},set:function(t,n){e[t]=n},delete:function(t){delete e[t]},post:function(t,n){return null==t?e.apply(void 0,n):e[t].apply(e,n)},apply:function(t,n){return e.apply(t,n)},keys:function(){return h(e)}},void 0,(function(){return{state:"fulfilled",value:e}}))}function B(e,t,n){return k(e).spread(t,n)}function V(e,t,n){return k(e).dispatch(t,n)}function Z(e){return A(e,(function(e){var t=0,n=x();return u(e,(function(r,o,i){var a;C(o)&&"fulfilled"===(a=o.inspect()).state?e[i]=a.value:(++t,A(o,(function(r){e[i]=r,0==--t&&n.resolve(e)}),n.reject,(function(e){n.notify({index:i,value:e})})))}),void 0),0===t&&n.resolve(e),n.promise}))}function H(e){if(0===e.length)return k.resolve();var t=k.defer(),n=0;return u(e,(function(r,o,i){var a=e[i];n++,A(a,(function(e){t.resolve(e)}),(function(){0===--n&&t.reject(new Error("Can't get fulfillment value from any promise, all promises were rejected."))}),(function(e){t.notify({index:i,value:e})}))}),void 0),t.promise}function q(e){return A(e,(function(e){return e=d(e,k),A(Z(d(e,(function(e){return A(e,r,r)}))),(function(){return e}))}))}k.resetUnhandledRejections=L,k.getUnhandledReasons=function(){return N.slice()},k.stopUnhandledRejectionTracking=function(){L(),D=!1},L(),k.reject=U,k.fulfill=F,k.master=function(e){return S({isDef:function(){}},(function(t,n){return V(e,t,n)}),(function(){return k(e).inspect()}))},k.spread=B,S.prototype.spread=function(e,t){return this.all().then((function(t){return e.apply(void 0,t)}),t)},k.async=function(e){return function(){function t(e,t){var i;if("undefined"==typeof StopIteration){try{i=n[e](t)}catch(e){return U(e)}return i.done?k(i.value):A(i.value,r,o)}try{i=n[e](t)}catch(e){return v(e)?k(e.value):U(e)}return A(i,r,o)}var n=e.apply(this,arguments),r=t.bind(t,"next"),o=t.bind(t,"throw");return r()}},k.spawn=function(e){k.done(k.async(e)())},k.return=function(e){throw new s(e)},k.promised=function(e){return function(){return B([this,Z(arguments)],(function(t,n){return e.apply(t,n)}))}},k.dispatch=V,S.prototype.dispatch=function(e,t){var n=this,r=x();return k.nextTick((function(){n.promiseDispatch(r.resolve,e,t)})),r.promise},k.get=function(e,t){return k(e).dispatch("get",[t])},S.prototype.get=function(e){return this.dispatch("get",[e])},k.set=function(e,t,n){return k(e).dispatch("set",[t,n])},S.prototype.set=function(e,t){return this.dispatch("set",[e,t])},k.del=k.delete=function(e,t){return k(e).dispatch("delete",[t])},S.prototype.del=S.prototype.delete=function(e){return this.dispatch("delete",[e])},k.mapply=k.post=function(e,t,n){return k(e).dispatch("post",[t,n])},S.prototype.mapply=S.prototype.post=function(e,t){return this.dispatch("post",[e,t])},k.send=k.mcall=k.invoke=function(e,t){return k(e).dispatch("post",[t,l(arguments,2)])},S.prototype.send=S.prototype.mcall=S.prototype.invoke=function(e){return this.dispatch("post",[e,l(arguments,1)])},k.fapply=function(e,t){return k(e).dispatch("apply",[void 0,t])},S.prototype.fapply=function(e){return this.dispatch("apply",[void 0,e])},k.try=k.fcall=function(e){return k(e).dispatch("apply",[void 0,l(arguments,1)])},S.prototype.fcall=function(){return this.dispatch("apply",[void 0,l(arguments)])},k.fbind=function(e){var t=k(e),n=l(arguments,1);return function(){return t.dispatch("apply",[this,n.concat(l(arguments))])}},S.prototype.fbind=function(){var e=this,t=l(arguments);return function(){return e.dispatch("apply",[this,t.concat(l(arguments))])}},k.keys=function(e){return k(e).dispatch("keys",[])},S.prototype.keys=function(){return this.dispatch("keys",[])},k.all=Z,S.prototype.all=function(){return Z(this)},k.any=H,S.prototype.any=function(){return H(this)},k.allResolved=(I=q,function(){return"undefined"!=typeof console&&console.warn,I.apply(I,arguments)}),S.prototype.allResolved=function(){return q(this)},k.allSettled=function(e){return k(e).allSettled()},S.prototype.allSettled=function(){return this.then((function(e){return Z(d(e,(function(e){function t(){return e.inspect()}return(e=k(e)).then(t,t)})))}))},k.fail=k.catch=function(e,t){return k(e).then(void 0,t)},S.prototype.fail=S.prototype.catch=function(e){return this.then(void 0,e)},k.progress=function(e,t){return k(e).then(void 0,void 0,t)},S.prototype.progress=function(e){return this.then(void 0,void 0,e)},k.fin=k.finally=function(e,t){return k(e).finally(t)},S.prototype.fin=S.prototype.finally=function(e){return e=k(e),this.then((function(t){return e.fcall().then((function(){return t}))}),(function(t){return e.fcall().then((function(){throw t}))}))},k.done=function(e,t,n,r){return k(e).done(t,n,r)},S.prototype.done=function(e,t,n){var r=function(e){k.nextTick((function(){if(y(e,o),!k.onerror)throw e;k.onerror(e)}))},o=e||t||n?this.then(e,t,n):this;"object"==typeof process&&process&&process.domain&&(r=process.domain.bind(r)),o.then(void 0,r)},k.timeout=function(e,t,n){return k(e).timeout(t,n)},S.prototype.timeout=function(e,t){var n=x(),r=setTimeout((function(){t&&"string"!=typeof t||((t=new Error(t||"Timed out after "+e+" ms")).code="ETIMEDOUT"),n.reject(t)}),e);return this.then((function(e){clearTimeout(r),n.resolve(e)}),(function(e){clearTimeout(r),n.reject(e)}),n.notify),n.promise},k.delay=function(e,t){return void 0===t&&(t=e,e=void 0),k(e).delay(t)},S.prototype.delay=function(e){return this.then((function(t){var n=x();return setTimeout((function(){n.resolve(t)}),e),n.promise}))},k.nfapply=function(e,t){return k(e).nfapply(t)},S.prototype.nfapply=function(e){var t=x(),n=l(e);return n.push(t.makeNodeResolver()),this.fapply(n).fail(t.reject),t.promise},k.nfcall=function(e){var t=l(arguments,1);return k(e).nfapply(t)},S.prototype.nfcall=function(){var e=l(arguments),t=x();return e.push(t.makeNodeResolver()),this.fapply(e).fail(t.reject),t.promise},k.nfbind=k.denodeify=function(e){var t=l(arguments,1);return function(){var n=t.concat(l(arguments)),r=x();return n.push(r.makeNodeResolver()),k(e).fapply(n).fail(r.reject),r.promise}},S.prototype.nfbind=S.prototype.denodeify=function(){var e=l(arguments);return e.unshift(this),k.denodeify.apply(void 0,e)},k.nbind=function(e,t){var n=l(arguments,2);return function(){var r=n.concat(l(arguments)),o=x();function i(){return e.apply(t,arguments)}return r.push(o.makeNodeResolver()),k(i).fapply(r).fail(o.reject),o.promise}},S.prototype.nbind=function(){var e=l(arguments,0);return e.unshift(this),k.nbind.apply(void 0,e)},k.nmapply=k.npost=function(e,t,n){return k(e).npost(t,n)},S.prototype.nmapply=S.prototype.npost=function(e,t){var n=l(t||[]),r=x();return n.push(r.makeNodeResolver()),this.dispatch("post",[e,n]).fail(r.reject),r.promise},k.nsend=k.nmcall=k.ninvoke=function(e,t){var n=l(arguments,2),r=x();return n.push(r.makeNodeResolver()),k(e).dispatch("post",[t,n]).fail(r.reject),r.promise},S.prototype.nsend=S.prototype.nmcall=S.prototype.ninvoke=function(e){var t=l(arguments,1),n=x();return t.push(n.makeNodeResolver()),this.dispatch("post",[e,t]).fail(n.reject),n.promise},k.nodeify=function(e,t){return k(e).nodeify(t)},S.prototype.nodeify=function(e){if(!e)return this;this.then((function(t){k.nextTick((function(){e(null,t)}))}),(function(t){k.nextTick((function(){e(t)}))}))},k.noConflict=function(){throw new Error("Q.noConflict only works when Q is used as a global")};var W=O();return k}))},74270:function(e){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t=function(e){"use strict";var t,n=Object.prototype,r=n.hasOwnProperty,o=Object.defineProperty||function(e,t,n){e[t]=n.value},i="function"==typeof Symbol?Symbol:{},a=i.iterator||"@@iterator",s=i.asyncIterator||"@@asyncIterator",l=i.toStringTag||"@@toStringTag";function u(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{u({},"")}catch(e){u=function(e,t,n){return e[t]=n}}function c(e,t,n,r){var i=t&&t.prototype instanceof v?t:v,a=Object.create(i.prototype),s=new P(r||[]);return o(a,"_invoke",{value:E(e,n,s)}),a}function d(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}e.wrap=c;var f="suspendedStart",p="executing",h="completed",m={};function v(){}function g(){}function y(){}var b={};u(b,a,(function(){return this}));var w=Object.getPrototypeOf,_=w&&w(w(C([])));_&&_!==n&&r.call(_,a)&&(b=_);var O=y.prototype=v.prototype=Object.create(b);function k(e){["next","throw","return"].forEach((function(t){u(e,t,(function(e){return this._invoke(t,e)}))}))}function x(e,t){function n(o,i,a,s){var l=d(e[o],e,i);if("throw"!==l.type){var u=l.arg,c=u.value;return c&&"object"==typeof c&&r.call(c,"__await")?t.resolve(c.__await).then((function(e){n("next",e,a,s)}),(function(e){n("throw",e,a,s)})):t.resolve(c).then((function(e){u.value=e,a(u)}),(function(e){return n("throw",e,a,s)}))}s(l.arg)}var i;o(this,"_invoke",{value:function(e,r){function o(){return new t((function(t,o){n(e,r,t,o)}))}return i=i?i.then(o,o):o()}})}function E(e,t,n){var r=f;return function(o,i){if(r===p)throw new Error("Generator is already running");if(r===h){if("throw"===o)throw i;return R()}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var s=T(a,n);if(s){if(s===m)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===f)throw r=h,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=p;var l=d(e,t,n);if("normal"===l.type){if(r=n.done?h:"suspendedYield",l.arg===m)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(r=h,n.method="throw",n.arg=l.arg)}}}function T(e,n){var r=n.method,o=e.iterator[r];if(o===t)return n.delegate=null,"throw"===r&&e.iterator.return&&(n.method="return",n.arg=t,T(e,n),"throw"===n.method)||"return"!==r&&(n.method="throw",n.arg=new TypeError("The iterator does not provide a '"+r+"' method")),m;var i=d(o,e.iterator,n.arg);if("throw"===i.type)return n.method="throw",n.arg=i.arg,n.delegate=null,m;var a=i.arg;return a?a.done?(n[e.resultName]=a.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,m):a:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,m)}function S(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function A(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function P(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(S,this),this.reset(!0)}function C(e){if(e){var n=e[a];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var o=-1,i=function n(){for(;++o<e.length;)if(r.call(e,o))return n.value=e[o],n.done=!1,n;return n.value=t,n.done=!0,n};return i.next=i}}return{next:R}}function R(){return{value:t,done:!0}}return g.prototype=y,o(O,"constructor",{value:y,configurable:!0}),o(y,"constructor",{value:g,configurable:!0}),g.displayName=u(y,l,"GeneratorFunction"),e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===g||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,y):(e.__proto__=y,u(e,l,"GeneratorFunction")),e.prototype=Object.create(O),e},e.awrap=function(e){return{__await:e}},k(x.prototype),u(x.prototype,s,(function(){return this})),e.AsyncIterator=x,e.async=function(t,n,r,o,i){void 0===i&&(i=Promise);var a=new x(c(t,n,r,o),i);return e.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},k(O),u(O,l,"Generator"),u(O,a,(function(){return this})),u(O,"toString",(function(){return"[object Generator]"})),e.keys=function(e){var t=Object(e),n=[];for(var r in t)n.push(r);return n.reverse(),function e(){for(;n.length;){var r=n.pop();if(r in t)return e.value=r,e.done=!1,e}return e.done=!0,e}},e.values=C,P.prototype={constructor:P,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(A),!e)for(var n in this)"t"===n.charAt(0)&&r.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function o(r,o){return s.type="throw",s.arg=e,n.next=r,o&&(n.method="next",n.arg=t),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],s=a.completion;if("root"===a.tryLoc)return o("end");if(a.tryLoc<=this.prev){var l=r.call(a,"catchLoc"),u=r.call(a,"finallyLoc");if(l&&u){if(this.prev<a.catchLoc)return o(a.catchLoc,!0);if(this.prev<a.finallyLoc)return o(a.finallyLoc)}else if(l){if(this.prev<a.catchLoc)return o(a.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return o(a.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n];if(o.tryLoc<=this.prev&&r.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=e,a.arg=t,i?(this.method="next",this.next=i.finallyLoc,m):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),m},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),A(n),m}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;A(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:C(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),m}},e}(e.exports);try{regeneratorRuntime=t}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=t:Function("r","regeneratorRuntime = r")(t)}},27444:function(e){e.exports=function(e){var t;if("SELECT"===e.nodeName)e.focus(),t=e.value;else if("INPUT"===e.nodeName||"TEXTAREA"===e.nodeName){var n=e.hasAttribute("readonly");n||e.setAttribute("readonly",""),e.select(),e.setSelectionRange(0,e.value.length),n||e.removeAttribute("readonly"),t=e.value}else{e.hasAttribute("contenteditable")&&e.focus();var r=window.getSelection(),o=document.createRange();o.selectNodeContents(e),r.removeAllRanges(),r.addRange(o),t=r.toString()}return t}},10226:function(e){function t(){}t.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function o(){r.off(e,o),t.apply(n,arguments)}return o._=t,this.on(e,o,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,o=n.length;r<o;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],o=[];if(r&&t)for(var i=0,a=r.length;i<a;i++)r[i].fn!==t&&r[i].fn._!==t&&o.push(r[i]);return o.length?n[e]=o:delete n[e],this}},e.exports=t,e.exports.TinyEmitter=t},83147:function(){"use strict";
//Copyright 2014-2015 Google Inc. All rights reserved.
//license that can be found in the LICENSE file or at
//https://developers.google.com/open-source/licenses/bsd
!function(){var e="chrome"in window&&window.navigator.userAgent.indexOf("Edge")<0;if(!("u2f"in window)&&e){var t,n=window.u2f={};n.EXTENSION_ID="kmendfapggjehodndflmmgagdbamhnfd",n.MessageTypes={U2F_REGISTER_REQUEST:"u2f_register_request",U2F_REGISTER_RESPONSE:"u2f_register_response",U2F_SIGN_REQUEST:"u2f_sign_request",U2F_SIGN_RESPONSE:"u2f_sign_response",U2F_GET_API_VERSION_REQUEST:"u2f_get_api_version_request",U2F_GET_API_VERSION_RESPONSE:"u2f_get_api_version_response"},n.ErrorCodes={OK:0,OTHER_ERROR:1,BAD_REQUEST:2,CONFIGURATION_UNSUPPORTED:3,DEVICE_INELIGIBLE:4,TIMEOUT:5},n.U2fRequest,n.U2fResponse,n.Error,n.Transport,n.Transports,n.SignRequest,n.SignResponse,n.RegisterRequest,n.RegisterResponse,n.RegisteredKey,n.GetJsApiVersionResponse,n.getMessagePort=function(e){if("undefined"!=typeof chrome&&chrome.runtime){var t={type:n.MessageTypes.U2F_SIGN_REQUEST,signRequests:[]};chrome.runtime.sendMessage(n.EXTENSION_ID,t,(function(){chrome.runtime.lastError?n.getIframePort_(e):n.getChromeRuntimePort_(e)}))}else n.isAndroidChrome_()?n.getAuthenticatorPort_(e):n.isIosChrome_()?n.getIosPort_(e):n.getIframePort_(e)},n.isAndroidChrome_=function(){var e=navigator.userAgent;return-1!=e.indexOf("Chrome")&&-1!=e.indexOf("Android")},n.isIosChrome_=function(){return["iPhone","iPad","iPod"].indexOf(navigator.platform)>-1},n.getChromeRuntimePort_=function(e){var t=chrome.runtime.connect(n.EXTENSION_ID,{includeTlsChannelId:!0});setTimeout((function(){e(new n.WrappedChromeRuntimePort_(t))}),0)},n.getAuthenticatorPort_=function(e){setTimeout((function(){e(new n.WrappedAuthenticatorPort_)}),0)},n.getIosPort_=function(e){setTimeout((function(){e(new n.WrappedIosPort_)}),0)},n.WrappedChromeRuntimePort_=function(e){this.port_=e},n.formatSignRequest_=function(e,r,o,i,a){if(void 0===t||t<1.1){for(var s=[],l=0;l<o.length;l++)s[l]={version:o[l].version,challenge:r,keyHandle:o[l].keyHandle,appId:e};return{type:n.MessageTypes.U2F_SIGN_REQUEST,signRequests:s,timeoutSeconds:i,requestId:a}}return{type:n.MessageTypes.U2F_SIGN_REQUEST,appId:e,challenge:r,registeredKeys:o,timeoutSeconds:i,requestId:a}},n.formatRegisterRequest_=function(e,r,o,i,a){if(void 0===t||t<1.1){for(var s=0;s<o.length;s++)o[s].appId=e;var l=[];for(s=0;s<r.length;s++)l[s]={version:r[s].version,challenge:o[0],keyHandle:r[s].keyHandle,appId:e};return{type:n.MessageTypes.U2F_REGISTER_REQUEST,signRequests:l,registerRequests:o,timeoutSeconds:i,requestId:a}}return{type:n.MessageTypes.U2F_REGISTER_REQUEST,appId:e,registerRequests:o,registeredKeys:r,timeoutSeconds:i,requestId:a}},n.WrappedChromeRuntimePort_.prototype.postMessage=function(e){this.port_.postMessage(e)},n.WrappedChromeRuntimePort_.prototype.addEventListener=function(e,t){var n=e.toLowerCase();"message"!=n&&"onmessage"!=n||this.port_.onMessage.addListener((function(e){t({data:e})}))},n.WrappedAuthenticatorPort_=function(){this.requestId_=-1,this.requestObject_=null},n.WrappedAuthenticatorPort_.prototype.postMessage=function(e){var t=n.WrappedAuthenticatorPort_.INTENT_URL_BASE_+";S.request="+encodeURIComponent(JSON.stringify(e))+";end";document.location=t},n.WrappedAuthenticatorPort_.prototype.getPortType=function(){return"WrappedAuthenticatorPort_"},n.WrappedAuthenticatorPort_.prototype.addEventListener=function(e,t){if("message"==e.toLowerCase()){window.addEventListener("message",this.onRequestUpdate_.bind(this,t),!1)}},n.WrappedAuthenticatorPort_.prototype.onRequestUpdate_=function(e,t){var n=JSON.parse(t.data),r=(n.intentURL,n.errorCode,null);n.hasOwnProperty("data")&&(r=JSON.parse(n.data)),e({data:r})},n.WrappedAuthenticatorPort_.INTENT_URL_BASE_="intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE",n.WrappedIosPort_=function(){},n.WrappedIosPort_.prototype.postMessage=function(e){var t=JSON.stringify(e),n="u2f://auth?"+encodeURI(t);location.replace(n)},n.WrappedIosPort_.prototype.getPortType=function(){return"WrappedIosPort_"},n.WrappedIosPort_.prototype.addEventListener=function(e,t){e.toLowerCase()},n.getIframePort_=function(e){var t="chrome-extension://"+n.EXTENSION_ID,r=document.createElement("iframe");r.src=t+"/u2f-comms.html",r.setAttribute("style","display:none"),document.body.appendChild(r);var o=new MessageChannel,i=function(t){"ready"==t.data&&(o.port1.removeEventListener("message",i),e(o.port1))};o.port1.addEventListener("message",i),o.port1.start(),r.addEventListener("load",(function(){r.contentWindow.postMessage("init",t,[o.port2])}))},n.EXTENSION_TIMEOUT_SEC=30,n.port_=null,n.waitingForPort_=[],n.reqCounter_=0,n.callbackMap_={},n.getPortSingleton_=function(e){n.port_?e(n.port_):(0==n.waitingForPort_.length&&n.getMessagePort((function(e){for(n.port_=e,n.port_.addEventListener("message",n.responseHandler_);n.waitingForPort_.length;)n.waitingForPort_.shift()(n.port_)})),n.waitingForPort_.push(e))},n.responseHandler_=function(e){var t=e.data,r=t.requestId;if(r&&n.callbackMap_[r]){var o=n.callbackMap_[r];delete n.callbackMap_[r],o(t.responseData)}},n.sign=function(e,r,o,i,a){void 0===t?n.getApiVersion((function(s){t=void 0===s.js_api_version?0:s.js_api_version,n.sendSignRequest(e,r,o,i,a)})):n.sendSignRequest(e,r,o,i,a)},n.sendSignRequest=function(e,t,r,o,i){n.getPortSingleton_((function(a){var s=++n.reqCounter_;n.callbackMap_[s]=o;var l=void 0!==i?i:n.EXTENSION_TIMEOUT_SEC,u=n.formatSignRequest_(e,t,r,l,s);a.postMessage(u)}))},n.register=function(e,r,o,i,a){void 0===t?n.getApiVersion((function(s){t=void 0===s.js_api_version?0:s.js_api_version,n.sendRegisterRequest(e,r,o,i,a)})):n.sendRegisterRequest(e,r,o,i,a)},n.sendRegisterRequest=function(e,t,r,o,i){n.getPortSingleton_((function(a){var s=++n.reqCounter_;n.callbackMap_[s]=o;var l=void 0!==i?i:n.EXTENSION_TIMEOUT_SEC,u=n.formatRegisterRequest_(e,r,t,l,s);a.postMessage(u)}))},n.getApiVersion=function(e,t){n.getPortSingleton_((function(r){if(r.getPortType){var o;switch(r.getPortType()){case"WrappedIosPort_":case"WrappedAuthenticatorPort_":o=1.1;break;default:o=0}e({js_api_version:o})}else{var i=++n.reqCounter_;n.callbackMap_[i]=e;var a={type:n.MessageTypes.U2F_GET_API_VERSION_REQUEST,timeoutSeconds:void 0!==t?t:n.EXTENSION_TIMEOUT_SEC,requestId:i};r.postMessage(a)}}))}}}()},69765:function(e,t){var n;
/**
 * @file Web Cryptography API shim
 * @author Artem S Vybornov <vybornov@gmail.com>
 * @license MIT
 */!function(r,o){n=function(){return function(e){"use strict";if("function"!=typeof Promise)throw"Promise support required";var t=e.crypto||e.msCrypto;if(!t)return;var n=t.subtle||t.webkitSubtle;if(!n)return;var r=e.Crypto||t.constructor||Object,o=e.SubtleCrypto||n.constructor||Object,i=(e.CryptoKey||e.Key,e.navigator.userAgent.indexOf("Edge/")>-1),a=!!e.msCrypto&&!i,s=!t.subtle&&!!t.webkitSubtle;if(!a&&!s)return;function l(e){return btoa(e).replace(/\=+$/,"").replace(/\+/g,"-").replace(/\//g,"_")}function u(e){return e=(e+="===").slice(0,-e.length%4),atob(e.replace(/-/g,"+").replace(/_/g,"/"))}function c(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}function d(e){return e instanceof ArrayBuffer&&(e=new Uint8Array(e)),String.fromCharCode.apply(String,e)}function f(e){var t={name:(e.name||e||"").toUpperCase().replace("V","v")};switch(t.name){case"SHA-1":case"SHA-256":case"SHA-384":case"SHA-512":break;case"AES-CBC":case"AES-GCM":case"AES-KW":e.length&&(t.length=e.length);break;case"HMAC":e.hash&&(t.hash=f(e.hash)),e.length&&(t.length=e.length);break;case"RSAES-PKCS1-v1_5":e.publicExponent&&(t.publicExponent=new Uint8Array(e.publicExponent)),e.modulusLength&&(t.modulusLength=e.modulusLength);break;case"RSASSA-PKCS1-v1_5":case"RSA-OAEP":e.hash&&(t.hash=f(e.hash)),e.publicExponent&&(t.publicExponent=new Uint8Array(e.publicExponent)),e.modulusLength&&(t.modulusLength=e.modulusLength);break;default:throw new SyntaxError("Bad algorithm name")}return t}function p(e){return{HMAC:{"SHA-1":"HS1","SHA-256":"HS256","SHA-384":"HS384","SHA-512":"HS512"},"RSASSA-PKCS1-v1_5":{"SHA-1":"RS1","SHA-256":"RS256","SHA-384":"RS384","SHA-512":"RS512"},"RSAES-PKCS1-v1_5":{"":"RSA1_5"},"RSA-OAEP":{"SHA-1":"RSA-OAEP","SHA-256":"RSA-OAEP-256"},"AES-KW":{128:"A128KW",192:"A192KW",256:"A256KW"},"AES-GCM":{128:"A128GCM",192:"A192GCM",256:"A256GCM"},"AES-CBC":{128:"A128CBC",192:"A192CBC",256:"A256CBC"}}[e.name][(e.hash||{}).name||e.length||""]}function h(e){(e instanceof ArrayBuffer||e instanceof Uint8Array)&&(e=JSON.parse(decodeURIComponent(escape(d(e)))));var t={kty:e.kty,alg:e.alg,ext:e.ext||e.extractable};switch(t.kty){case"oct":t.k=e.k;case"RSA":["n","e","d","p","q","dp","dq","qi","oth"].forEach((function(n){n in e&&(t[n]=e[n])}));break;default:throw new TypeError("Unsupported key type")}return t}function m(e){var t=h(e);return a&&(t.extractable=t.ext,delete t.ext),c(unescape(encodeURIComponent(JSON.stringify(t)))).buffer}function v(e){var t=w(e),n=!1;t.length>2&&(n=!0,t.shift());var r={ext:!0};if("1.2.840.113549.1.1.1"!==t[0][0])throw new TypeError("Unsupported key type");var o=["n","e","d","p","q","dp","dq","qi"],i=w(t[1]);n&&i.shift();for(var a=0;a<i.length;a++)i[a][0]||(i[a]=i[a].subarray(1)),r[o[a]]=l(d(i[a]));return r.kty="RSA",r}function g(e){var t,n=[["",null]],r=!1;if("RSA"!==e.kty)throw new TypeError("Unsupported key type");for(var o=["n","e","d","p","q","dp","dq","qi"],i=[],a=0;a<o.length&&o[a]in e;a++){var s=i[a]=c(u(e[o[a]]));128&s[0]&&(i[a]=new Uint8Array(s.length+1),i[a].set(s,1))}return i.length>2&&(r=!0,i.unshift(new Uint8Array([0]))),n[0][0]="1.2.840.113549.1.1.1",t=i,n.push(new Uint8Array(_(t)).buffer),r?n.unshift(new Uint8Array([0])):n[1]={tag:3,value:n[1]},new Uint8Array(_(n)).buffer}var y={KoZIhvcNAQEB:"1.2.840.113549.1.1.1"},b={"1.2.840.113549.1.1.1":"KoZIhvcNAQEB"};function w(e,t){if(e instanceof ArrayBuffer&&(e=new Uint8Array(e)),t||(t={pos:0,end:e.length}),t.end-t.pos<2||t.end>e.length)throw new RangeError("Malformed DER");var n,r=e[t.pos++],o=e[t.pos++];if(o>=128){if(o&=127,t.end-t.pos<o)throw new RangeError("Malformed DER");for(var i=0;o--;)i<<=8,i|=e[t.pos++];o=i}if(t.end-t.pos<o)throw new RangeError("Malformed DER");switch(r){case 2:n=e.subarray(t.pos,t.pos+=o);break;case 3:if(e[t.pos++])throw new Error("Unsupported bit string");o--;case 4:n=new Uint8Array(e.subarray(t.pos,t.pos+=o)).buffer;break;case 5:n=null;break;case 6:var a=btoa(d(e.subarray(t.pos,t.pos+=o)));if(!(a in y))throw new Error("Unsupported OBJECT ID "+a);n=y[a];break;case 48:n=[];for(var s=t.pos+o;t.pos<s;)n.push(w(e,t));break;default:throw new Error("Unsupported DER tag 0x"+r.toString(16))}return n}function _(e,t){t||(t=[]);var n=0,r=0,o=t.length+2;if(t.push(0,0),e instanceof Uint8Array){n=2,r=e.length;for(var i=0;i<r;i++)t.push(e[i])}else if(e instanceof ArrayBuffer){n=4,r=e.byteLength,e=new Uint8Array(e);for(i=0;i<r;i++)t.push(e[i])}else if(null===e)n=5,r=0;else if("string"==typeof e&&e in b){var a=c(atob(b[e]));n=6,r=a.length;for(i=0;i<r;i++)t.push(a[i])}else if(e instanceof Array){for(i=0;i<e.length;i++)_(e[i],t);n=48,r=t.length-o}else{if(!("object"==typeof e&&3===e.tag&&e.value instanceof ArrayBuffer))throw new Error("Unsupported DER value "+e);n=3,r=(e=new Uint8Array(e.value)).byteLength,t.push(0);for(i=0;i<r;i++)t.push(e[i]);r++}if(r>=128){var s=r;r=4;for(t.splice(o,0,s>>24&255,s>>16&255,s>>8&255,255&s);r>1&&!(s>>24);)s<<=8,r--;r<4&&t.splice(o,4-r),r|=128}return t.splice(o-2,2,n,r),t}function O(e,t,n,r){Object.defineProperties(this,{_key:{value:e},type:{value:e.type,enumerable:!0},extractable:{value:void 0===n?e.extractable:n,enumerable:!0},algorithm:{value:void 0===t?e.algorithm:t,enumerable:!0},usages:{value:void 0===r?e.usages:r,enumerable:!0}})}function k(e){return"verify"===e||"encrypt"===e||"wrapKey"===e}function x(e){return"sign"===e||"decrypt"===e||"unwrapKey"===e}if(["generateKey","importKey","unwrapKey"].forEach((function(e){var r=n[e];n[e]=function(o,i,l){var d,g,y,b,w=[].slice.call(arguments);switch(e){case"generateKey":d=f(o),g=i,y=l;break;case"importKey":d=f(l),g=w[3],y=w[4],"jwk"===o&&((i=h(i)).alg||(i.alg=p(d)),i.key_ops||(i.key_ops="oct"!==i.kty?"d"in i?y.filter(x):y.filter(k):y.slice()),w[1]=m(i));break;case"unwrapKey":d=w[4],g=w[5],y=w[6],w[2]=l._key}if("generateKey"===e&&"HMAC"===d.name&&d.hash)return d.length=d.length||{"SHA-1":512,"SHA-256":512,"SHA-384":1024,"SHA-512":1024}[d.hash.name],n.importKey("raw",t.getRandomValues(new Uint8Array(d.length+7>>3)),d,g,y);if(s&&"generateKey"===e&&"RSASSA-PKCS1-v1_5"===d.name&&(!d.modulusLength||d.modulusLength>=2048))return(o=f(o)).name="RSAES-PKCS1-v1_5",delete o.hash,n.generateKey(o,!0,["encrypt","decrypt"]).then((function(e){return Promise.all([n.exportKey("jwk",e.publicKey),n.exportKey("jwk",e.privateKey)])})).then((function(e){return e[0].alg=e[1].alg=p(d),e[0].key_ops=y.filter(k),e[1].key_ops=y.filter(x),Promise.all([n.importKey("jwk",e[0],d,!0,e[0].key_ops),n.importKey("jwk",e[1],d,g,e[1].key_ops)])})).then((function(e){return{publicKey:e[0],privateKey:e[1]}}));if((s||a&&"SHA-1"===(d.hash||{}).name)&&"importKey"===e&&"jwk"===o&&"HMAC"===d.name&&"oct"===i.kty)return n.importKey("raw",c(u(i.k)),l,w[3],w[4]);if(s&&"importKey"===e&&("spki"===o||"pkcs8"===o))return n.importKey("jwk",v(i),l,w[3],w[4]);if(a&&"unwrapKey"===e)return n.decrypt(w[3],l,i).then((function(e){return n.importKey(o,e,w[4],w[5],w[6])}));try{b=r.apply(n,w)}catch(e){return Promise.reject(e)}return a&&(b=new Promise((function(e,t){b.onabort=b.onerror=function(e){t(e)},b.oncomplete=function(t){e(t.target.result)}}))),b=b.then((function(e){return"HMAC"===d.name&&(d.length||(d.length=8*e.algorithm.length)),0==d.name.search("RSA")&&(d.modulusLength||(d.modulusLength=(e.publicKey||e).algorithm.modulusLength),d.publicExponent||(d.publicExponent=(e.publicKey||e).algorithm.publicExponent)),e=e.publicKey&&e.privateKey?{publicKey:new O(e.publicKey,d,g,y.filter(k)),privateKey:new O(e.privateKey,d,g,y.filter(x))}:new O(e,d,g,y)}))}})),["exportKey","wrapKey"].forEach((function(e){var t=n[e];n[e]=function(r,o,i){var u,f=[].slice.call(arguments);switch(e){case"exportKey":f[1]=o._key;break;case"wrapKey":f[1]=o._key,f[2]=i._key}if((s||a&&"SHA-1"===(o.algorithm.hash||{}).name)&&"exportKey"===e&&"jwk"===r&&"HMAC"===o.algorithm.name&&(f[0]="raw"),!s||"exportKey"!==e||"spki"!==r&&"pkcs8"!==r||(f[0]="jwk"),a&&"wrapKey"===e)return n.exportKey(r,o).then((function(e){return"jwk"===r&&(e=c(unescape(encodeURIComponent(JSON.stringify(h(e)))))),n.encrypt(f[3],i,e)}));try{u=t.apply(n,f)}catch(e){return Promise.reject(e)}return a&&(u=new Promise((function(e,t){u.onabort=u.onerror=function(e){t(e)},u.oncomplete=function(t){e(t.target.result)}}))),"exportKey"===e&&"jwk"===r&&(u=u.then((function(e){return(s||a&&"SHA-1"===(o.algorithm.hash||{}).name)&&"HMAC"===o.algorithm.name?{kty:"oct",alg:p(o.algorithm),key_ops:o.usages.slice(),ext:!0,k:l(d(e))}:((e=h(e)).alg||(e.alg=p(o.algorithm)),e.key_ops||(e.key_ops="public"===o.type?o.usages.filter(k):"private"===o.type?o.usages.filter(x):o.usages.slice()),e)}))),!s||"exportKey"!==e||"spki"!==r&&"pkcs8"!==r||(u=u.then((function(e){return e=g(h(e))}))),u}})),["encrypt","decrypt","sign","verify"].forEach((function(e){var t=n[e];n[e]=function(r,o,i,s){if(a&&(!i.byteLength||s&&!s.byteLength))throw new Error("Empty input is not allowed");var l,u=[].slice.call(arguments),c=f(r);if(!a||"sign"!==e&&"verify"!==e||"RSASSA-PKCS1-v1_5"!==r&&"HMAC"!==r||(u[0]={name:r}),a&&o.algorithm.hash&&(u[0].hash=u[0].hash||o.algorithm.hash),a&&"decrypt"===e&&"AES-GCM"===c.name){var d=r.tagLength>>3;u[2]=(i.buffer||i).slice(0,i.byteLength-d),r.tag=(i.buffer||i).slice(i.byteLength-d)}a&&"AES-GCM"===c.name&&void 0===u[0].tagLength&&(u[0].tagLength=128),u[1]=o._key;try{l=t.apply(n,u)}catch(e){return Promise.reject(e)}return a&&(l=new Promise((function(t,n){l.onabort=l.onerror=function(e){n(e)},l.oncomplete=function(n){n=n.target.result;if("encrypt"===e&&n instanceof AesGcmEncryptResult){var r=n.ciphertext,o=n.tag;(n=new Uint8Array(r.byteLength+o.byteLength)).set(new Uint8Array(r),0),n.set(new Uint8Array(o),r.byteLength),n=n.buffer}t(n)}}))),l}})),a){var E=n.digest;n.digest=function(e,t){if(!t.byteLength)throw new Error("Empty input is not allowed");var r;try{r=E.call(n,e,t)}catch(e){return Promise.reject(e)}return r=new Promise((function(e,t){r.onabort=r.onerror=function(e){t(e)},r.oncomplete=function(t){e(t.target.result)}}))},e.crypto=Object.create(t,{getRandomValues:{value:function(e){return t.getRandomValues(e)}},subtle:{value:n}}),e.CryptoKey=O}s&&(t.subtle=n,e.Crypto=r,e.SubtleCrypto=o,e.CryptoKey=O)}(r)}.apply(t,[]),void 0===n||(e.exports=n)}("undefined"!=typeof self?self:this)},48231:function(e,t,n){"use strict";n.r(t);var r=n(79602),o=n.n(r);
/*
 * qTip2 - Pretty powerful tooltips - v3.0.3-5-g
 * http://qtip2.com
 *
 * Copyright (c) 2017 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 24 2017 01:22 UTC+0000
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
!function(e,t,n){o().fn.qtip||function(r){var o,i,a,s,l,u=!0,c=!1,d=null,f="x",p="y",h="width",m="height",v="top",g="left",y="bottom",b="right",w="center",_="flipinvert",O="shift",k={},x="qtip",E="data-hasqtip",T="data-qtip-id",S=["ui-widget","ui-tooltip"],A="."+x,P="click dblclick mousedown mouseup mousemove mouseleave mouseenter".split(" "),C=x+"-fixed",R=x+"-default",I=x+"-focus",N=x+"-hover",M=x+"-disabled",j="_replacedByqTip",D="oldtitle",L={ie:function(){var e,n;for(e=4,n=t.createElement("div");(n.innerHTML="\x3c!--[if gt IE "+e+"]><i></i><![endif]--\x3e")&&n.getElementsByTagName("i")[0];e+=1);return e>4?e:NaN}(),iOS:parseFloat((""+(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent)||[0,""])[1]).replace("undefined","3_2").replace("_",".").replace("_",""))||c};function U(e,t,n,o){this.id=n,this.target=e,this.tooltip=d,this.elements={target:e},this._id=x+"-"+n,this.timers={img:{}},this.options=t,this.plugins={},this.cache={event:{},target:r(),disabled:c,attr:o,onTooltip:c,lastClass:""},this.rendered=this.destroyed=this.disabled=this.waiting=this.hiddenDuringWait=this.positioning=this.triggering=c}function F(e){return e===d||"object"!==r.type(e)}function B(e){return!(r.isFunction(e)||e&&e.attr||e.length||"object"===r.type(e)&&(e.jquery||e.then))}function V(e){var t,n,o,i;return F(e)?c:(F(e.metadata)&&(e.metadata={type:e.metadata}),"content"in e&&(F(t=e.content)||t.jquery||t.done?(n=B(t)?c:t,t=e.content={text:n}):n=t.text,"ajax"in t&&(o=t.ajax,i=o&&o.once!==c,delete t.ajax,t.text=function(e,t){var a=n||r(this).attr(t.options.content.attr)||"Loading...",s=r.ajax(r.extend({},o,{context:t})).then(o.success,d,o.error).then((function(e){return e&&i&&t.set("content.text",e),e}),(function(e,n,r){t.destroyed||0===e.status||t.set("content.text",n+": "+r)}));return i?a:(t.set("content.text",a),s)}),"title"in t&&(r.isPlainObject(t.title)&&(t.button=t.title.button,t.title=t.title.text),B(t.title||c)&&(t.title=c))),"position"in e&&F(e.position)&&(e.position={my:e.position,at:e.position}),"show"in e&&F(e.show)&&(e.show=e.show.jquery?{target:e.show}:e.show===u?{ready:u}:{event:e.show}),"hide"in e&&F(e.hide)&&(e.hide=e.hide.jquery?{target:e.hide}:{event:e.hide}),"style"in e&&F(e.style)&&(e.style={classes:e.style}),r.each(k,(function(){this.sanitize&&this.sanitize(e)})),e)}function Z(e,t){for(var n,r=0,o=e,i=t.split(".");o=o[i[r++]];)r<i.length&&(n=o);return[n||e,i.pop()]}function H(e,t){var n,r,o;for(n in this.checks)if(this.checks.hasOwnProperty(n))for(r in this.checks[n])this.checks[n].hasOwnProperty(r)&&(o=new RegExp(r,"i").exec(e))&&(t.push(o),("builtin"===n||this.plugins[n])&&this.checks[n][r].apply(this.plugins[n]||this,t))}(i=U.prototype)._when=function(e){return r.when.apply(r,e)},i.render=function(e){if(this.rendered||this.destroyed)return this;var t=this,n=this.options,i=this.cache,a=this.elements,s=n.content.text,l=n.content.title,d=n.content.button,f=n.position,p=[];return r.attr(this.target[0],"aria-describedby",this._id),i.posClass=this._createPosClass((this.position={my:f.my,at:f.at}).my),this.tooltip=a.tooltip=r("<div/>",{id:this._id,class:[x,R,n.style.classes,i.posClass].join(" "),width:n.style.width||"",height:n.style.height||"",tracking:"mouse"===f.target&&f.adjust.mouse,role:"alert","aria-live":"polite","aria-atomic":c,"aria-describedby":this._id+"-content","aria-hidden":u}).toggleClass(M,this.disabled).attr(T,this.id).data(x,this).appendTo(f.container).append(a.content=r("<div />",{class:x+"-content",id:this._id+"-content","aria-atomic":u})),this.rendered=-1,this.positioning=u,l&&(this._createTitle(),r.isFunction(l)||p.push(this._updateTitle(l,c))),d&&this._createButton(),r.isFunction(s)||p.push(this._updateContent(s,c)),this.rendered=u,this._setWidget(),r.each(k,(function(e){var n;"render"===this.initialize&&(n=this(t))&&(t.plugins[e]=n)})),this._unassignEvents(),this._assignEvents(),this._when(p).then((function(){t._trigger("render"),t.positioning=c,t.hiddenDuringWait||!n.show.ready&&!e||t.toggle(u,i.event,c),t.hiddenDuringWait=c})),o.api[this.id]=this,this},i.destroy=function(e){if(this.destroyed)return this.target;function t(){if(!this.destroyed){this.destroyed=u;var e,t=this.target,n=t.attr(D);for(e in this.rendered&&this.tooltip.stop(1,0).find("*").remove().end().remove(),r.each(this.plugins,(function(){this.destroy&&this.destroy()})),this.timers)this.timers.hasOwnProperty(e)&&clearTimeout(this.timers[e]);t.removeData(x).removeAttr(T).removeAttr(E).removeAttr("aria-describedby"),this.options.suppress&&n&&t.attr("title",n).removeAttr(D),this._unassignEvents(),this.options=this.elements=this.cache=this.timers=this.plugins=this.mouse=d,delete o.api[this.id]}}return e===u&&"hide"!==this.triggering||!this.rendered?t.call(this):(this.tooltip.one("tooltiphidden",r.proxy(t,this)),!this.triggering&&this.hide()),this.target},s=i.checks={builtin:{"^id$":function(e,t,n,i){var a=n===u?o.nextid:n,s=x+"-"+a;a!==c&&a.length>0&&!r("#"+s).length?(this._id=s,this.rendered&&(this.tooltip[0].id=this._id,this.elements.content[0].id=this._id+"-content",this.elements.title[0].id=this._id+"-title")):e[t]=i},"^prerender":function(e,t,n){n&&!this.rendered&&this.render(this.options.show.ready)},"^content.text$":function(e,t,n){this._updateContent(n)},"^content.attr$":function(e,t,n,r){this.options.content.text===this.target.attr(r)&&this._updateContent(this.target.attr(n))},"^content.title$":function(e,t,n){if(!n)return this._removeTitle();n&&!this.elements.title&&this._createTitle(),this._updateTitle(n)},"^content.button$":function(e,t,n){this._updateButton(n)},"^content.title.(text|button)$":function(e,t,n){this.set("content."+t,n)},"^position.(my|at)$":function(e,t,n){"string"==typeof n&&(this.position[t]=e[t]=new a(n,"at"===t))},"^position.container$":function(e,t,n){this.rendered&&this.tooltip.appendTo(n)},"^show.ready$":function(e,t,n){n&&(!this.rendered&&this.render(u)||this.toggle(u))},"^style.classes$":function(e,t,n,r){this.rendered&&this.tooltip.removeClass(r).addClass(n)},"^style.(width|height)":function(e,t,n){this.rendered&&this.tooltip.css(t,n)},"^style.widget|content.title":function(){this.rendered&&this._setWidget()},"^style.def":function(e,t,n){this.rendered&&this.tooltip.toggleClass(R,!!n)},"^events.(render|show|move|hide|focus|blur)$":function(e,t,n){this.rendered&&this.tooltip[(r.isFunction(n)?"":"un")+"bind"]("tooltip"+t,n)},"^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)":function(){if(this.rendered){var e=this.options.position;this.tooltip.attr("tracking","mouse"===e.target&&e.adjust.mouse),this._unassignEvents(),this._assignEvents()}}}},i.get=function(e){if(this.destroyed)return this;var t=Z(this.options,e.toLowerCase()),n=t[0][t[1]];return n.precedance?n.string():n};var q=/^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,W=/^prerender|show\.ready/i;i.set=function(e,t){if(this.destroyed)return this;var n,o=this.rendered,i=c,a=this.options;return"string"==typeof e?(n=e,(e={})[n]=t):e=r.extend({},e),r.each(e,(function(t,n){if(o&&W.test(t))delete e[t];else{var s,l=Z(a,t.toLowerCase());s=l[0][l[1]],l[0][l[1]]=n&&n.nodeType?r(n):n,i=q.test(t)||i,e[t]=[l[0],l[1],n,s]}})),V(a),this.positioning=u,r.each(e,r.proxy(H,this)),this.positioning=c,this.rendered&&this.tooltip[0].offsetWidth>0&&i&&this.reposition("mouse"===a.position.target?d:this.cache.event),this},i._update=function(e,t){var n=this,o=this.cache;return this.rendered&&e?(r.isFunction(e)&&(e=e.call(this.elements.target,o.event,this)||""),r.isFunction(e.then)?(o.waiting=u,e.then((function(e){return o.waiting=c,n._update(e,t)}),d,(function(e){return n._update(e,t)}))):e===c||!e&&""!==e?c:(e.jquery&&e.length>0?t.empty().append(e.css({display:"block",visibility:"visible"})):t.html(e),this._waitForContent(t).then((function(e){n.rendered&&n.tooltip[0].offsetWidth>0&&n.reposition(o.event,!e.length)})))):c},i._waitForContent=function(e){var t=this.cache;return t.waiting=u,(r.fn.imagesLoaded?e.imagesLoaded():(new r.Deferred).resolve([])).done((function(){t.waiting=c})).promise()},i._updateContent=function(e,t){this._update(e,this.elements.content,t)},i._updateTitle=function(e,t){this._update(e,this.elements.title,t)===c&&this._removeTitle(c)},i._createTitle=function(){var e=this.elements,t=this._id+"-title";e.titlebar&&this._removeTitle(),e.titlebar=r("<div />",{class:x+"-titlebar "+(this.options.style.widget?$("header"):"")}).append(e.title=r("<div />",{id:t,class:x+"-title","aria-atomic":u})).insertBefore(e.content).delegate(".qtip-close","mousedown keydown mouseup keyup mouseout",(function(e){r(this).toggleClass("ui-state-active ui-state-focus","down"===e.type.substr(-4))})).delegate(".qtip-close","mouseover mouseout",(function(e){r(this).toggleClass("ui-state-hover","mouseover"===e.type)})),this.options.content.button&&this._createButton()},i._removeTitle=function(e){var t=this.elements;t.title&&(t.titlebar.remove(),t.titlebar=t.title=t.button=d,e!==c&&this.reposition())},i._createPosClass=function(e){return x+"-pos-"+(e||this.options.position.my).abbrev()},i.reposition=function(n,o){if(!this.rendered||this.positioning||this.destroyed)return this;this.positioning=u;var i,a,s,l,d=this.cache,f=this.tooltip,p=this.options.position,h=p.target,m=p.my,_=p.at,O=p.viewport,x=p.container,E=p.adjust,T=E.method.split(" "),S=f.outerWidth(c),A=f.outerHeight(c),P=0,C=0,R=f.css("position"),I={left:0,top:0},N=f[0].offsetWidth>0,M=n&&"scroll"===n.type,j=r(e),D=x[0].ownerDocument,U=this.mouse;if(r.isArray(h)&&2===h.length)_={x:g,y:v},I={left:h[0],top:h[1]};else if("mouse"===h)_={x:g,y:v},(!E.mouse||this.options.hide.distance)&&d.origin&&d.origin.pageX?n=d.origin:!n||n&&("resize"===n.type||"scroll"===n.type)?n=d.event:U&&U.pageX&&(n=U),"static"!==R&&(I=x.offset()),D.body.offsetWidth!==(e.innerWidth||D.documentElement.clientWidth)&&(a=r(t.body).offset()),I={left:n.pageX-I.left+(a&&a.left||0),top:n.pageY-I.top+(a&&a.top||0)},E.mouse&&M&&U&&(I.left-=(U.scrollX||0)-j.scrollLeft(),I.top-=(U.scrollY||0)-j.scrollTop());else{if("event"===h?n&&n.target&&"scroll"!==n.type&&"resize"!==n.type?d.target=r(n.target):n.target||(d.target=this.elements.target):"event"!==h&&(d.target=r(h.jquery?h:this.elements.target)),h=d.target,0===(h=r(h).eq(0)).length)return this;h[0]===t||h[0]===e?(P=L.iOS?e.innerWidth:h.width(),C=L.iOS?e.innerHeight:h.height(),h[0]===e&&(I={top:(O||h).scrollTop(),left:(O||h).scrollLeft()})):k.imagemap&&h.is("area")?i=k.imagemap(this,h,_,k.viewport?T:c):k.svg&&h&&h[0].ownerSVGElement?i=k.svg(this,h,_,k.viewport?T:c):(P=h.outerWidth(c),C=h.outerHeight(c),I=h.offset()),i&&(P=i.width,C=i.height,a=i.offset,I=i.position),I=this.reposition.offset(h,I,x),(L.iOS>3.1&&L.iOS<4.1||L.iOS>=4.3&&L.iOS<4.33||!L.iOS&&"fixed"===R)&&(I.left-=j.scrollLeft(),I.top-=j.scrollTop()),(!i||i&&i.adjustable!==c)&&(I.left+=_.x===b?P:_.x===w?P/2:0,I.top+=_.y===y?C:_.y===w?C/2:0)}return I.left+=E.x+(m.x===b?-S:m.x===w?-S/2:0),I.top+=E.y+(m.y===y?-A:m.y===w?-A/2:0),k.viewport?(s=I.adjusted=k.viewport(this,I,p,P,C,S,A),a&&s.left&&(I.left+=a.left),a&&s.top&&(I.top+=a.top),s.my&&(this.position.my=s.my)):I.adjusted={left:0,top:0},d.posClass!==(l=this._createPosClass(this.position.my))&&(d.posClass=l,f.removeClass(d.posClass).addClass(l)),this._trigger("move",[I,O.elem||O],n)?(delete I.adjusted,o===c||!N||isNaN(I.left)||isNaN(I.top)||"mouse"===h||!r.isFunction(p.effect)?f.css(I):r.isFunction(p.effect)&&(p.effect.call(f,this,r.extend({},I)),f.queue((function(e){r(this).css({opacity:"",height:""}),L.ie&&this.style.removeAttribute("filter"),e()}))),this.positioning=c,this):this},i.reposition.offset=function(e,n,o){if(!o[0])return n;var i,a,s,l,u=r(e[0].ownerDocument),c=!!L.ie&&"CSS1Compat"!==t.compatMode,d=o[0];function f(e,t){n.left+=t*e.scrollLeft(),n.top+=t*e.scrollTop()}do{"static"!==(a=r.css(d,"position"))&&("fixed"===a?(s=d.getBoundingClientRect(),f(u,-1)):((s=r(d).position()).left+=parseFloat(r.css(d,"borderLeftWidth"))||0,s.top+=parseFloat(r.css(d,"borderTopWidth"))||0),n.left-=s.left+(parseFloat(r.css(d,"marginLeft"))||0),n.top-=s.top+(parseFloat(r.css(d,"marginTop"))||0),i||"hidden"===(l=r.css(d,"overflow"))||"visible"===l||"BODY"===r.prop(d,"tagName")||(i=r(d)))}while(d=d.offsetParent);return i&&(i[0]!==u[0]||c)&&f(i,1),n};var K=(a=i.reposition.Corner=function(e,t){e=(""+e).replace(/([A-Z])/," $1").replace(/middle/gi,w).toLowerCase(),this.x=(e.match(/left|right/i)||e.match(/center/)||["inherit"])[0].toLowerCase(),this.y=(e.match(/top|bottom|center/i)||["inherit"])[0].toLowerCase(),this.forceY=!!t;var n=e.charAt(0);this.precedance="t"===n||"b"===n?p:f}).prototype;function $(e){return S.concat("").join(e?"-"+e+" ":" ")}function z(e,t){if(t>0)return setTimeout(r.proxy(e,this),t);e.call(this)}function Y(e){this.tooltip.hasClass(M)||(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this.timers.show=z.call(this,(function(){this.toggle(u,e)}),this.options.show.delay))}function G(e){if(!this.tooltip.hasClass(M)&&!this.destroyed){var t=r(e.relatedTarget),n=t.closest(A)[0]===this.tooltip[0],o=t[0]===this.options.show.target[0];if(clearTimeout(this.timers.show),clearTimeout(this.timers.hide),this!==t[0]&&"mouse"===this.options.position.target&&n||this.options.hide.fixed&&/mouse(out|leave|move)/.test(e.type)&&(n||o))try{e.preventDefault(),e.stopImmediatePropagation()}catch(e){}else this.timers.hide=z.call(this,(function(){this.toggle(c,e)}),this.options.hide.delay,this)}}function J(e){!this.tooltip.hasClass(M)&&this.options.hide.inactive&&(clearTimeout(this.timers.inactive),this.timers.inactive=z.call(this,(function(){this.hide(e)}),this.options.hide.inactive))}function Q(e){this.rendered&&this.tooltip[0].offsetWidth>0&&this.reposition(e)}function X(e,n,i){r(t.body).delegate(e,(n.split?n:n.join("."+x+" "))+"."+x,(function(){var e=o.api[r.attr(this,T)];e&&!e.disabled&&i.apply(e,arguments)}))}function ee(e,n,i){var s,l,f,p,h,m=r(t.body),v=e[0]===t?m:e,g=e.metadata?e.metadata(i.metadata):d,y="html5"===i.metadata.type&&g?g[i.metadata.name]:d,b=e.data(i.metadata.name||"qtipopts");try{b="string"==typeof b?r.parseJSON(b):b}catch(e){}if(l=(p=r.extend(u,{},o.defaults,i,"object"==typeof b?V(b):d,V(y||g))).position,p.id=n,"boolean"==typeof p.content.text){if(f=e.attr(p.content.attr),p.content.attr===c||!f)return c;p.content.text=f}if(l.container.length||(l.container=m),l.target===c&&(l.target=v),p.show.target===c&&(p.show.target=v),p.show.solo===u&&(p.show.solo=l.container.closest("body")),p.hide.target===c&&(p.hide.target=v),p.position.viewport===u&&(p.position.viewport=l.container),l.container=l.container.eq(0),l.at=new a(l.at,u),l.my=new a(l.my),e.data(x))if(p.overwrite)e.qtip("destroy",!0);else if(p.overwrite===c)return c;return e.attr(E,n),p.suppress&&(h=e.attr("title"))&&e.removeAttr("title").attr(D,h).attr("title",""),s=new U(e,p,n,!!f),e.data(x,s),s}K.invert=function(e,t){this[e]=this[e]===g?b:this[e]===b?g:t||this[e]},K.string=function(e){var t=this.x,n=this.y,r=t!==n?"center"===t||"center"!==n&&(this.precedance===p||this.forceY)?[n,t]:[t,n]:[t];return!1!==e?r.join(" "):r},K.abbrev=function(){var e=this.string(!1);return e[0].charAt(0)+(e[1]&&e[1].charAt(0)||"")},K.clone=function(){return new a(this.string(),this.forceY)},i.toggle=function(e,n){var o=this.cache,i=this.options,a=this.tooltip;if(n){if(/over|enter/.test(n.type)&&o.event&&/out|leave/.test(o.event.type)&&i.show.target.add(n.target).length===i.show.target.length&&a.has(n.relatedTarget).length)return this;o.event=r.event.fix(n)}if(this.waiting&&!e&&(this.hiddenDuringWait=u),!this.rendered)return e?this.render(1):this;if(this.destroyed||this.disabled)return this;var s,f,p,h=e?"show":"hide",m=this.options[h],v=this.options.position,g=this.options.content,y=this.tooltip.css("width"),b=this.tooltip.is(":visible"),w=e||1===m.target.length,_=!n||m.target.length<2||o.target[0]===n.target;return(typeof e).search("boolean|number")&&(e=!b),f=(s=!a.is(":animated")&&b===e&&_)?d:!!this._trigger(h,[90]),this.destroyed||(f!==c&&e&&this.focus(n),!f||s||(r.attr(a[0],"aria-hidden",!e),e?(this.mouse&&(o.origin=r.event.fix(this.mouse)),r.isFunction(g.text)&&this._updateContent(g.text,c),r.isFunction(g.title)&&this._updateTitle(g.title,c),!l&&"mouse"===v.target&&v.adjust.mouse&&(r(t).bind("mousemove."+x,this._storeMouse),l=u),y||a.css("width",a.outerWidth(c)),this.reposition(n,arguments[2]),y||a.css("width",""),m.solo&&("string"==typeof m.solo?r(m.solo):r(A,m.solo)).not(a).not(m.target).qtip("hide",new r.Event("tooltipsolo"))):(clearTimeout(this.timers.show),delete o.origin,l&&!r(A+'[tracking="true"]:visible',m.solo).not(a).length&&(r(t).unbind("mousemove."+x),l=c),this.blur(n)),p=r.proxy((function(){e?(L.ie&&a[0].style.removeAttribute("filter"),a.css("overflow",""),"string"==typeof m.autofocus&&r(this.options.show.autofocus,a).focus(),this.options.show.target.trigger("qtip-"+this.id+"-inactive")):a.css({display:"",visibility:"",opacity:"",left:"",top:""}),this._trigger(e?"visible":"hidden")}),this),m.effect===c||w===c?(a[h](),p()):r.isFunction(m.effect)?(a.stop(1,1),m.effect.call(a,this),a.queue("fx",(function(e){p(),e()}))):a.fadeTo(90,e?1:0,p),e&&m.target.trigger("qtip-"+this.id+"-inactive"))),this},i.show=function(e){return this.toggle(u,e)},i.hide=function(e){return this.toggle(c,e)},i.focus=function(e){if(!this.rendered||this.destroyed)return this;var t=r(A),n=this.tooltip,i=parseInt(n[0].style.zIndex,10),a=o.zindex+t.length;return n.hasClass(I)||this._trigger("focus",[a],e)&&(i!==a&&(t.each((function(){this.style.zIndex>i&&(this.style.zIndex=this.style.zIndex-1)})),t.filter("."+I).qtip("blur",e)),n.addClass(I)[0].style.zIndex=a),this},i.blur=function(e){return!this.rendered||this.destroyed||(this.tooltip.removeClass(I),this._trigger("blur",[this.tooltip.css("zIndex")],e)),this},i.disable=function(e){return this.destroyed||("toggle"===e?e=!(this.rendered?this.tooltip.hasClass(M):this.disabled):"boolean"!=typeof e&&(e=u),this.rendered&&this.tooltip.toggleClass(M,e).attr("aria-disabled",e),this.disabled=!!e),this},i.enable=function(){return this.disable(c)},i._createButton=function(){var e=this,t=this.elements,n=t.tooltip,o=this.options.content.button,i="string"==typeof o?o:"Close tooltip";t.button&&t.button.remove(),o.jquery?t.button=o:t.button=r("<a />",{class:"qtip-close "+(this.options.style.widget?"":x+"-icon"),title:i,"aria-label":i}).prepend(r("<span />",{class:"ui-icon ui-icon-close",html:"&times;"})),t.button.appendTo(t.titlebar||n).attr("role","button").click((function(t){return n.hasClass(M)||e.hide(t),c}))},i._updateButton=function(e){if(!this.rendered)return c;var t=this.elements.button;e?this._createButton():t.remove()},i._setWidget=function(){var e=this.options.style.widget,t=this.elements,n=t.tooltip,r=n.hasClass(M);n.removeClass(M),M=e?"ui-state-disabled":"qtip-disabled",n.toggleClass(M,r),n.toggleClass("ui-helper-reset "+$(),e).toggleClass(R,this.options.style.def&&!e),t.content&&t.content.toggleClass($("content"),e),t.titlebar&&t.titlebar.toggleClass($("header"),e),t.button&&t.button.toggleClass(x+"-icon",!e)},i._storeMouse=function(e){return(this.mouse=r.event.fix(e)).type="mousemove",this},i._bind=function(e,t,n,o,i){if(e&&n&&t.length){var a="."+this._id+(o?"-"+o:"");return r(e).bind((t.split?t:t.join(a+" "))+a,r.proxy(n,i||this)),this}},i._unbind=function(e,t){return e&&r(e).unbind("."+this._id+(t?"-"+t:"")),this},i._trigger=function(e,t,n){var o=new r.Event("tooltip"+e);return o.originalEvent=n&&r.extend({},n)||this.cache.event||d,this.triggering=e,this.tooltip.trigger(o,[this].concat(t||[])),this.triggering=c,!o.isDefaultPrevented()},i._bindEvents=function(e,t,n,o,i,a){var s=n.filter(o).add(o.filter(n)),l=[];s.length&&(r.each(t,(function(t,n){var o=r.inArray(n,e);o>-1&&l.push(e.splice(o,1)[0])})),l.length&&(this._bind(s,l,(function(e){(this.rendered&&this.tooltip[0].offsetWidth>0?a:i).call(this,e)})),n=n.not(s),o=o.not(s))),this._bind(n,e,i),this._bind(o,t,a)},i._assignInitialEvents=function(e){var t=this.options,n=t.show.target,o=t.hide.target,i=t.show.event?r.trim(""+t.show.event).split(" "):[],a=t.hide.event?r.trim(""+t.hide.event).split(" "):[];function s(e){if(this.disabled||this.destroyed)return c;this.cache.event=e&&r.event.fix(e),this.cache.target=e&&r(e.target),clearTimeout(this.timers.show),this.timers.show=z.call(this,(function(){this.render("object"==typeof e||t.show.ready)}),t.prerender?0:t.show.delay)}this._bind(this.elements.target,["remove","removeqtip"],(function(){this.destroy(!0)}),"destroy"),/mouse(over|enter)/i.test(t.show.event)&&!/mouse(out|leave)/i.test(t.hide.event)&&a.push("mouseleave"),this._bind(n,"mousemove",(function(e){this._storeMouse(e),this.cache.onTarget=u})),this._bindEvents(i,a,n,o,s,(function(){if(!this.timers)return c;clearTimeout(this.timers.show)})),(t.show.ready||t.prerender)&&s.call(this,e)},i._assignEvents=function(){var n=this,i=this.options,a=i.position,s=this.tooltip,l=i.show.target,u=i.hide.target,d=a.container,f=a.viewport,p=r(t),h=r(e),m=i.show.event?r.trim(""+i.show.event).split(" "):[],v=i.hide.event?r.trim(""+i.hide.event).split(" "):[];r.each(i.events,(function(e,t){n._bind(s,"toggle"===e?["tooltipshow","tooltiphide"]:["tooltip"+e],t,null,s)})),/mouse(out|leave)/i.test(i.hide.event)&&"window"===i.hide.leave&&this._bind(p,["mouseout","blur"],(function(e){/select|option/.test(e.target.nodeName)||e.relatedTarget||this.hide(e)})),i.hide.fixed?u=u.add(s.addClass(C)):/mouse(over|enter)/i.test(i.show.event)&&this._bind(u,"mouseleave",(function(){clearTimeout(this.timers.show)})),(""+i.hide.event).indexOf("unfocus")>-1&&this._bind(d.closest("html"),["mousedown","touchstart"],(function(e){var t=r(e.target),n=this.rendered&&!this.tooltip.hasClass(M)&&this.tooltip[0].offsetWidth>0,o=t.parents(A).filter(this.tooltip[0]).length>0;t[0]===this.target[0]||t[0]===this.tooltip[0]||o||this.target.has(t[0]).length||!n||this.hide(e)})),"number"==typeof i.hide.inactive&&(this._bind(l,"qtip-"+this.id+"-inactive",J,"inactive"),this._bind(u.add(s),o.inactiveEvents,J)),this._bindEvents(m,v,l,u,Y,G),this._bind(l.add(s),"mousemove",(function(e){if("number"==typeof i.hide.distance){var t=this.cache.origin||{},n=this.options.hide.distance,r=Math.abs;(r(e.pageX-t.pageX)>=n||r(e.pageY-t.pageY)>=n)&&this.hide(e)}this._storeMouse(e)})),"mouse"===a.target&&a.adjust.mouse&&(i.hide.event&&this._bind(l,["mouseenter","mouseleave"],(function(e){if(!this.cache)return c;this.cache.onTarget="mouseenter"===e.type})),this._bind(p,"mousemove",(function(e){this.rendered&&this.cache.onTarget&&!this.tooltip.hasClass(M)&&this.tooltip[0].offsetWidth>0&&this.reposition(e)}))),(a.adjust.resize||f.length)&&this._bind(r.event.special.resize?f:h,"resize",Q),a.adjust.scroll&&this._bind(h.add(a.container),"scroll",Q)},i._unassignEvents=function(){var n=this.options,o=n.show.target,i=n.hide.target,a=r.grep([this.elements.target[0],this.rendered&&this.tooltip[0],n.position.container[0],n.position.viewport[0],n.position.container.closest("html")[0],e,t],(function(e){return"object"==typeof e}));o&&o.toArray&&(a=a.concat(o.toArray())),i&&i.toArray&&(a=a.concat(i.toArray())),this._unbind(a)._unbind(a,"destroy")._unbind(a,"inactive")},r((function(){X(A,["mouseenter","mouseleave"],(function(e){var t="mouseenter"===e.type,n=r(e.currentTarget),o=r(e.relatedTarget||e.target),i=this.options;t?(this.focus(e),n.hasClass(C)&&!n.hasClass(M)&&clearTimeout(this.timers.hide)):"mouse"===i.position.target&&i.position.adjust.mouse&&i.hide.event&&i.show.target&&!o.closest(i.show.target[0]).length&&this.hide(e),n.toggleClass(N,t)})),X("["+T+"]",P,J)})),o=r.fn.qtip=function(e,t,i){var a=(""+e).toLowerCase(),s=d,l=r.makeArray(arguments).slice(1),f=l[l.length-1],p=this[0]?r.data(this[0],x):d;return!arguments.length&&p||"api"===a?p:"string"==typeof e?(this.each((function(){var e=r.data(this,x);if(!e)return u;if(f&&f.timeStamp&&(e.cache.event=f),!t||"option"!==a&&"options"!==a)e[a]&&e[a].apply(e,l);else{if(i===n&&!r.isPlainObject(t))return s=e.get(t),c;e.set(t,i)}})),s!==d?s:this):"object"!=typeof e&&arguments.length?void 0:(p=V(r.extend(u,{},e)),this.each((function(e){var t,n;if(n=!(n=r.isArray(p.id)?p.id[e]:p.id)||n===c||n.length<1||o.api[n]?o.nextid++:n,(t=ee(r(this),n,p))===c)return u;o.api[n]=t,r.each(k,(function(){"initialize"===this.initialize&&this(t)})),t._assignInitialEvents(f)})))},r.qtip=U,o.api={},r.each({attr:function(e,t){if(this.length){var n=this[0],o="title",i=r.data(n,"qtip");if(e===o&&i&&i.options&&"object"==typeof i&&"object"==typeof i.options&&i.options.suppress)return arguments.length<2?r.attr(n,D):(i&&i.options.content.attr===o&&i.cache.attr&&i.set("content.text",t),this.attr(D,t))}return r.fn["attr"+j].apply(this,arguments)},clone:function(e){var t=r.fn["clone"+j].apply(this,arguments);return e||t.filter("["+D+"]").attr("title",(function(){return r.attr(this,D)})).removeAttr(D),t}},(function(e,t){if(!t||r.fn[e+j])return u;var n=r.fn[e+j]=r.fn[e];r.fn[e]=function(){return t.apply(this,arguments)||n.apply(this,arguments)}})),r.ui||(r["cleanData"+j]=r.cleanData,r.cleanData=function(e){for(var t,n=0;(t=r(e[n])).length;n++)if(t.attr(E))try{t.triggerHandler("removeqtip")}catch(e){}r["cleanData"+j].apply(this,arguments)}),o.version="3.0.3-5-g",o.nextid=0,o.inactiveEvents=P,o.zindex=15e3,o.defaults={prerender:c,id:c,overwrite:u,suppress:u,content:{text:u,attr:"title",title:c,button:c},position:{my:"top left",at:"bottom right",target:c,container:c,viewport:c,adjust:{x:0,y:0,mouse:u,scroll:u,resize:u,method:"flipinvert flipinvert"},effect:function(e,t){r(this).animate(t,{duration:200,queue:c})}},show:{target:c,event:"mouseenter",effect:u,delay:90,solo:c,ready:c,autofocus:c},hide:{target:c,event:"mouseleave",effect:u,delay:0,fixed:c,inactive:c,leave:"window",distance:c},style:{classes:"",widget:c,width:c,height:c,def:u},events:{render:d,move:d,show:d,hide:d,toggle:d,visible:d,hidden:d,focus:d,blur:d}};var te,ne,re,oe,ie,ae="margin",se="border",le="color",ue="background-color",ce="transparent",de=" !important",fe=!!t.createElement("canvas").getContext,pe=/rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;function he(e){return e.charAt(0).toUpperCase()+e.slice(1)}var me,ve={},ge=["Webkit","O","Moz","ms"];function ye(e,t){var r,o,i=t.charAt(0).toUpperCase()+t.slice(1),a=(t+" "+ge.join(i+" ")+i).split(" "),s=0;if(ve[t])return e.css(ve[t]);for(;r=a[s++];)if((o=e.css(r))!==n)return ve[t]=r,o}function be(e,t){return Math.ceil(parseFloat(ye(e,t)))}function we(e,t){this._ns="tip",this.options=t,this.offset=t.offset,this.size=[t.width,t.height],this.qtip=e,this.init(e)}fe?(oe=e.devicePixelRatio||1,ie=(me=t.createElement("canvas").getContext("2d")).backingStorePixelRatio||me.webkitBackingStorePixelRatio||me.mozBackingStorePixelRatio||me.msBackingStorePixelRatio||me.oBackingStorePixelRatio||1,re=oe/ie):ne=function(e,t,n){return"<qtipvml:"+e+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(t||"")+' style="behavior: url(#default#VML); '+(n||"")+'" />'},r.extend(we.prototype,{init:function(e){var t,n;n=this.element=e.elements.tip=r("<div />",{class:x+"-tip"}).prependTo(e.tooltip),fe?((t=r("<canvas />").appendTo(this.element)[0].getContext("2d")).lineJoin="miter",t.miterLimit=1e5,t.save()):(t=ne("shape",'coordorigin="0,0"',"position:absolute;"),this.element.html(t+t),e._bind(r("*",n).add(n),["click","mousedown"],(function(e){e.stopPropagation()}),this._ns)),e._bind(e.tooltip,"tooltipmove",this.reposition,this._ns,this),this.create()},_swapDimensions:function(){this.size[0]=this.options.height,this.size[1]=this.options.width},_resetDimensions:function(){this.size[0]=this.options.width,this.size[1]=this.options.height},_useTitle:function(e){var t=this.qtip.elements.titlebar;return t&&(e.y===v||e.y===w&&this.element.position().top+this.size[1]/2+this.options.offset<t.outerHeight(u))},_parseCorner:function(e){var t=this.qtip.options.position.my;return e===c||t===c?e=c:e===u?e=new a(t.string()):e.string||((e=new a(e)).fixed=u),e},_parseWidth:function(e,t,n){var r=this.qtip.elements,o=se+he(t)+"Width";return(n?be(n,o):be(r.content,o)||be(this._useTitle(e)&&r.titlebar||r.content,o)||be(r.tooltip,o))||0},_parseRadius:function(e){var t=this.qtip.elements,n=se+he(e.y)+he(e.x)+"Radius";return L.ie<9?0:be(this._useTitle(e)&&t.titlebar||t.content,n)||be(t.tooltip,n)||0},_invalidColour:function(e,t,n){var r=e.css(t);return!r||n&&r===e.css(n)||pe.test(r)?c:r},_parseColours:function(e){var t=this.qtip.elements,n=this.element.css("cssText",""),o=se+he(e[e.precedance])+he(le),i=this._useTitle(e)&&t.titlebar||t.content,a=this._invalidColour,s=[];return s[0]=a(n,ue)||a(i,ue)||a(t.content,ue)||a(t.tooltip,ue)||n.css(ue),s[1]=a(n,o,le)||a(i,o,le)||a(t.content,o,le)||a(t.tooltip,o,le)||t.tooltip.css(o),r("*",n).add(n).css("cssText",ue+":"+ce+de+";"+se+":0"+de+";"),s},_calculateSize:function(e){var t,n,r=e.precedance===p,o=this.options.width,i=this.options.height,a="c"===e.abbrev(),s=(r?o:i)*(a?.5:1),l=Math.pow,u=Math.round,c=Math.sqrt(l(s,2)+l(i,2)),d=[this.border/s*c,this.border/i*c];return d[2]=Math.sqrt(l(d[0],2)-l(this.border,2)),d[3]=Math.sqrt(l(d[1],2)-l(this.border,2)),n=[u((t=(c+d[2]+d[3]+(a?0:d[0]))/c)*o),u(t*i)],r?n:n.reverse()},_calculateTip:function(e,t,n){n=n||1;var r=(t=t||this.size)[0]*n,o=t[1]*n,i=Math.ceil(r/2),a=Math.ceil(o/2),s={br:[0,0,r,o,r,0],bl:[0,0,r,0,0,o],tr:[0,o,r,0,r,o],tl:[0,0,0,o,r,o],tc:[0,o,i,0,r,o],bc:[0,0,r,0,i,o],rc:[0,0,r,a,0,o],lc:[r,0,r,o,0,a]};return s.lt=s.br,s.rt=s.bl,s.lb=s.tr,s.rb=s.tl,s[e.abbrev()]},_drawCoords:function(e,t){e.beginPath(),e.moveTo(t[0],t[1]),e.lineTo(t[2],t[3]),e.lineTo(t[4],t[5]),e.closePath()},create:function(){var e=this.corner=(fe||L.ie)&&this._parseCorner(this.options.corner);return this.enabled=!!this.corner&&"c"!==this.corner.abbrev(),this.enabled&&(this.qtip.cache.corner=e.clone(),this.update()),this.element.toggle(this.enabled),this.corner},update:function(t,n){if(!this.enabled)return this;var o,i,s,l,d,_,O,k,x=this.qtip.elements,E=this.element,T=E.children(),S=this.options,A=this.size,P=S.mimic,C=Math.round;t||(t=this.qtip.cache.corner||this.corner),P===c?P=t:((P=new a(P)).precedance=t.precedance,"inherit"===P.x?P.x=t.x:"inherit"===P.y?P.y=t.y:P.x===P.y&&(P[t.precedance]=t[t.precedance])),i=P.precedance,t.precedance===f?this._swapDimensions():this._resetDimensions(),(o=this.color=this._parseColours(t))[1]!==ce?(k=this.border=this._parseWidth(t,t[t.precedance]),S.border&&k<1&&!pe.test(o[1])&&(o[0]=o[1]),this.border=k=S.border!==u?S.border:k):this.border=k=0,O=this.size=this._calculateSize(t),E.css({width:O[0],height:O[1],lineHeight:O[1]+"px"}),_=t.precedance===p?[C(P.x===g?k:P.x===b?O[0]-A[0]-k:(O[0]-A[0])/2),C(P.y===v?O[1]-A[1]:0)]:[C(P.x===g?O[0]-A[0]:0),C(P.y===v?k:P.y===y?O[1]-A[1]-k:(O[1]-A[1])/2)],fe?((s=T[0].getContext("2d")).restore(),s.save(),s.clearRect(0,0,6e3,6e3),l=this._calculateTip(P,A,re),d=this._calculateTip(P,this.size,re),T.attr(h,O[0]*re).attr(m,O[1]*re),T.css(h,O[0]).css(m,O[1]),this._drawCoords(s,d),s.fillStyle=o[1],s.fill(),s.translate(_[0]*re,_[1]*re),this._drawCoords(s,l),s.fillStyle=o[0],s.fill()):(l="m"+(l=this._calculateTip(P))[0]+","+l[1]+" l"+l[2]+","+l[3]+" "+l[4]+","+l[5]+" xe",_[2]=k&&/^(r|b)/i.test(t.string())?8===L.ie?2:1:0,T.css({coordsize:O[0]+k+" "+O[1]+k,antialias:""+(P.string().indexOf(w)>-1),left:_[0]-_[2]*Number(i===f),top:_[1]-_[2]*Number(i===p),width:O[0]+k,height:O[1]+k}).each((function(e){var t=r(this);t[t.prop?"prop":"attr"]({coordsize:O[0]+k+" "+O[1]+k,path:l,fillcolor:o[0],filled:!!e,stroked:!e}).toggle(!(!k&&!e)),!e&&t.html(ne("stroke",'weight="'+2*k+'px" color="'+o[1]+'" miterlimit="1000" joinstyle="miter"'))}))),e.opera&&setTimeout((function(){x.tip.css({display:"inline-block",visibility:"visible"})}),1),n!==c&&this.calculate(t,O)},calculate:function(e,t){if(!this.enabled)return c;var n,o,i=this,a=this.qtip.elements,s=this.element,l=this.options.offset,u={};return e=e||this.corner,n=e.precedance,t=t||this._calculateSize(e),o=[e.x,e.y],n===f&&o.reverse(),r.each(o,(function(r,o){var s,c,d;o===w?(u[s=n===p?g:v]="50%",u[ae+"-"+s]=-Math.round(t[n===p?0:1]/2)+l):(s=i._parseWidth(e,o,a.tooltip),c=i._parseWidth(e,o,a.content),d=i._parseRadius(e),u[o]=Math.max(-i.border,r?c:l+(d>s?d:-s)))})),u[e[n]]-=t[n===f?0:1],s.css({margin:"",top:"",bottom:"",left:"",right:""}).css(u),u},reposition:function(e,t,r){if(this.enabled){var o,i,a=t.cache,s=this.corner.clone(),l=r.adjusted,d=t.options.position.adjust.method.split(" "),h=d[0],m=d[1]||d[0],_={left:c,top:c,x:0,y:0},k={};this.corner.fixed!==u&&(x(h,f,p,g,b),x(m,p,f,v,y),s.string()===a.corner.string()&&a.cornerTop===l.top&&a.cornerLeft===l.left||this.update(s,c)),(o=this.calculate(s)).right!==n&&(o.left=-o.right),o.bottom!==n&&(o.top=-o.bottom),o.user=this.offset,_.left=h===O&&!!l.left,_.left&&E(f,g,b),_.top=m===O&&!!l.top,_.top&&E(p,v,y),this.element.css(k).toggle(!(_.x&&_.y||s.x===w&&_.y||s.y===w&&_.x)),r.left-=o.left.charAt?o.user:h!==O||_.top||!_.left&&!_.top?o.left+this.border:0,r.top-=o.top.charAt?o.user:m!==O||_.left||!_.left&&!_.top?o.top+this.border:0,a.cornerLeft=l.left,a.cornerTop=l.top,a.corner=s.clone()}function x(e,t,n,r,o){e===O&&s.precedance===t&&l[r]&&s[n]!==w?s.precedance=s.precedance===f?p:f:e!==O&&l[r]&&(s[t]=s[t]===w?l[r]>0?r:o:s[t]===r?o:r)}function E(e,t,a){s[e]===w?k[ae+"-"+t]=_[e]=o[ae+"-"+t]-l[t]:(i=o[a]!==n?[l[t],-o[t]]:[-l[t],o[t]],(_[e]=Math.max(i[0],i[1]))>i[0]&&(r[t]-=l[t],_[t]=c),k[o[a]!==n?a:t]=_[e])}},destroy:function(){this.qtip._unbind(this.qtip.tooltip,this._ns),this.qtip.elements.tip&&this.qtip.elements.tip.find("*").remove().end().remove()}}),(te=k.tip=function(e){return new we(e,e.options.style.tip)}).initialize="render",te.sanitize=function(e){if(e.style&&"tip"in e.style){var t=e.style.tip;"object"!=typeof t&&(t=e.style.tip={corner:t}),/string|boolean/i.test(typeof t.corner)||(t.corner=u)}},s.tip={"^position.my|style.tip.(corner|mimic|border)$":function(){this.create(),this.qtip.reposition()},"^style.tip.(height|width)$":function(e){this.size=[e.width,e.height],this.update(),this.qtip.reposition()},"^content.title|style.(classes|widget)$":function(){this.update()}},r.extend(u,o.defaults,{style:{tip:{corner:u,mimic:c,width:6,height:6,border:u,offset:0}}});var _e,Oe,ke="qtip-modal",xe="."+ke;function Ee(e,t){this.options=t,this._ns="-modal",this.qtip=e,this.init(e)}Oe=new(Oe=function(){var e,n,o,i=this,a={};function s(e){if(r.expr[":"].focusable)return r.expr[":"].focusable;var t,n,o,i=!isNaN(r.attr(e,"tabindex")),a=e.nodeName&&e.nodeName.toLowerCase();return"area"===a?(n=(t=e.parentNode).name,!(!e.href||!n||"map"!==t.nodeName.toLowerCase())&&!!(o=r("img[usemap=#"+n+"]")[0])&&o.is(":visible")):/input|select|textarea|button|object/.test(a)?!e.disabled:"a"===a&&e.href||i}function l(e){a.length<1&&e.length?e.not("body").blur():a.first().focus()}function f(t){if(o.is(":visible")){var n=r(t.target),i=e.tooltip,a=n.closest(A);(a.length<1?c:parseInt(a[0].style.zIndex,10)>parseInt(i[0].style.zIndex,10))||n.closest(A)[0]===i[0]||l(n)}}r.extend(i,{init:function(){return o=i.elem=r("<div />",{id:"qtip-overlay",html:"<div></div>",mousedown:function(){return c}}).hide(),r(t.body).bind("focusin"+xe,f),r(t).bind("keydown"+xe,(function(t){e&&e.options.show.modal.escape&&27===t.keyCode&&e.hide(t)})),o.bind("click"+xe,(function(t){e&&e.options.show.modal.blur&&e.hide(t)})),i},update:function(t){e=t,a=t.options.show.modal.stealfocus!==c?t.tooltip.find("*").filter((function(){return s(this)})):[]},toggle:function(a,s,f){var p=a.tooltip,h=a.options.show.modal,m=h.effect,v=s?"show":"hide",g=o.is(":visible"),y=r(xe).filter(":visible:not(:animated)").not(p);return i.update(a),s&&h.stealfocus!==c&&l(r(":focus")),o.toggleClass("blurs",h.blur),s&&o.appendTo(t.body),o.is(":animated")&&g===s&&n!==c||!s&&y.length||(o.stop(u,c),r.isFunction(m)?m.call(o,s):m===c?o[v]():o.fadeTo(parseInt(f,10)||90,s?1:0,(function(){s||o.hide()})),s||o.queue((function(e){o.css({left:"",top:""}),r(xe).length||o.detach(),e()})),n=s,e.destroyed&&(e=d)),i}}),i.init()}),r.extend(Ee.prototype,{init:function(e){var t=e.tooltip;if(!this.options.on)return this;e.elements.overlay=Oe.elem,t.addClass(ke).css("z-index",o.modal_zindex+r(xe).length),e._bind(t,["tooltipshow","tooltiphide"],(function(e,n,o){var i=e.originalEvent;if(e.target===t[0])if(i&&"tooltiphide"===e.type&&/mouse(leave|enter)/.test(i.type)&&r(i.relatedTarget).closest(Oe.elem[0]).length)try{e.preventDefault()}catch(e){}else(!i||i&&"tooltipsolo"!==i.type)&&this.toggle(e,"tooltipshow"===e.type,o)}),this._ns,this),e._bind(t,"tooltipfocus",(function(e,n){if(!e.isDefaultPrevented()&&e.target===t[0]){var i=r(xe),a=o.modal_zindex+i.length,s=parseInt(t[0].style.zIndex,10);Oe.elem[0].style.zIndex=a-1,i.each((function(){this.style.zIndex>s&&(this.style.zIndex-=1)})),i.filter("."+I).qtip("blur",e.originalEvent),t.addClass(I)[0].style.zIndex=a,Oe.update(n);try{e.preventDefault()}catch(e){}}}),this._ns,this),e._bind(t,"tooltiphide",(function(e){e.target===t[0]&&r(xe).filter(":visible").not(t).last().qtip("focus",e)}),this._ns,this)},toggle:function(e,t,n){if(e&&e.isDefaultPrevented())return this;Oe.toggle(this.qtip,!!t,n)},destroy:function(){this.qtip.tooltip.removeClass(ke),this.qtip._unbind(this.qtip.tooltip,this._ns),Oe.toggle(this.qtip,c),delete this.qtip.elements.overlay}}),(_e=k.modal=function(e){return new Ee(e,e.options.show.modal)}).sanitize=function(e){e.show&&("object"!=typeof e.show.modal?e.show.modal={on:!!e.show.modal}:void 0===e.show.modal.on&&(e.show.modal.on=u))},o.modal_zindex=o.zindex-200,_e.initialize="render",s.modal={"^show.modal.(on|blur)$":function(){this.destroy(),this.init(),this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth>0)}},r.extend(u,o.defaults,{show:{modal:{on:c,effect:u,blur:u,stealfocus:u,escape:u}}}),k.viewport=function(n,r,o,i,a,s,l){var u,d,k,x,E,T,S,A,P=o.target,C=n.elements.tooltip,R=o.my,I=o.at,N=o.adjust,M=N.method.split(" "),j=M[0],D=M[1]||M[0],L=o.viewport,U=o.container,F={left:0,top:0};if(!L.jquery||P[0]===e||P[0]===t.body||"none"===N.method)return F;function B(e,t,n,o,i,a,s,l,u){var c=r[i],f=R[e],p=I[e],m=n===O,v=f===i?u:f===a?-u:-u/2,g=p===i?l:p===a?-l:-l/2,y=S[i]+A[i]-(x?0:k[i]),b=y-c,P=c+u-(s===h?E:T)-y,C=v-(R.precedance===e||f===R[t]?g:0)-(p===w?l/2:0);return m?(C=(f===i?1:-1)*v,r[i]+=b>0?b:P>0?-P:0,r[i]=Math.max(-k[i]+A[i],c-C,Math.min(Math.max(-k[i]+A[i]+(s===h?E:T),c+C),r[i],"center"===f?c-v:1e9))):(o*=n===_?2:0,b>0&&(f!==i||P>0)?(r[i]-=C+o,d.invert(e,i)):P>0&&(f!==a||b>0)&&(r[i]-=(f===w?-C:C)+o,d.invert(e,a)),r[i]<S[i]&&-r[i]>P&&(r[i]=c,d=R.clone())),r[i]-c}return k=U.offset()||F,x="static"===U.css("position"),u="fixed"===C.css("position"),E=L[0]===e?L.width():L.outerWidth(c),T=L[0]===e?L.height():L.outerHeight(c),S={left:u?0:L.scrollLeft(),top:u?0:L.scrollTop()},A=L.offset()||F,"shift"===j&&"shift"===D||(d=R.clone()),F={left:"none"!==j?B(f,p,j,N.x,g,b,h,i,s):0,top:"none"!==D?B(p,f,D,N.y,v,y,m,a,l):0,my:d}},k.polys={polygon:function(e,t){var n,r,o,i={width:0,height:0,position:{top:1e10,right:0,bottom:0,left:1e10},adjustable:c},a=0,s=[],l=1,u=1,d=0,f=0;for(a=e.length;a--;)(n=[parseInt(e[--a],10),parseInt(e[a+1],10)])[0]>i.position.right&&(i.position.right=n[0]),n[0]<i.position.left&&(i.position.left=n[0]),n[1]>i.position.bottom&&(i.position.bottom=n[1]),n[1]<i.position.top&&(i.position.top=n[1]),s.push(n);if(r=i.width=Math.abs(i.position.right-i.position.left),o=i.height=Math.abs(i.position.bottom-i.position.top),"c"===t.abbrev())i.position={left:i.position.left+i.width/2,top:i.position.top+i.height/2};else{for(;r>0&&o>0&&l>0&&u>0;)for(r=Math.floor(r/2),o=Math.floor(o/2),t.x===g?l=r:t.x===b?l=i.width-r:l+=Math.floor(r/2),t.y===v?u=o:t.y===y?u=i.height-o:u+=Math.floor(o/2),a=s.length;a--&&!(s.length<2);)d=s[a][0]-i.position.left,f=s[a][1]-i.position.top,(t.x===g&&d>=l||t.x===b&&d<=l||t.x===w&&(d<l||d>i.width-l)||t.y===v&&f>=u||t.y===y&&f<=u||t.y===w&&(f<u||f>i.height-u))&&s.splice(a,1);i.position={left:s[0][0],top:s[0][1]}}return i},rect:function(e,t,n,r){return{width:Math.abs(n-e),height:Math.abs(r-t),position:{left:Math.min(e,n),top:Math.min(t,r)}}},_angles:{tc:1.5,tr:7/4,tl:5/4,bc:.5,br:1/4,bl:3/4,rc:2,lc:1,c:0},ellipse:function(e,t,n,r,o){var i=k.polys._angles[o.abbrev()],a=0===i?0:n*Math.cos(i*Math.PI),s=r*Math.sin(i*Math.PI);return{width:2*n-Math.abs(a),height:2*r-Math.abs(s),position:{left:e+a,top:t+s},adjustable:c}},circle:function(e,t,n,r){return k.polys.ellipse(e,t,n,n,r)}},k.svg=function(e,n,o){for(var i,a,s,l,u,d,f,p,h,m=n[0],v=r(m.ownerSVGElement),g=m.ownerDocument,y=(parseInt(n.css("stroke-width"),10)||0)/2;!m.getBBox;)m=m.parentNode;if(!m.getBBox||!m.parentNode)return c;switch(m.nodeName){case"ellipse":case"circle":p=k.polys.ellipse(m.cx.baseVal.value,m.cy.baseVal.value,(m.rx||m.r).baseVal.value+y,(m.ry||m.r).baseVal.value+y,o);break;case"line":case"polygon":case"polyline":for(p=[],d=-1,l=(f=m.points||[{x:m.x1.baseVal.value,y:m.y1.baseVal.value},{x:m.x2.baseVal.value,y:m.y2.baseVal.value}]).numberOfItems||f.length;++d<l;)u=f.getItem?f.getItem(d):f[d],p.push.apply(p,[u.x,u.y]);p=k.polys.polygon(p,o);break;default:p={width:(p=m.getBBox()).width,height:p.height,position:{left:p.x,top:p.y}}}return h=p.position,(v=v[0]).createSVGPoint&&(a=m.getScreenCTM(),(f=v.createSVGPoint()).x=h.left,f.y=h.top,s=f.matrixTransform(a),h.left=s.x,h.top=s.y),g!==t&&"mouse"!==e.position.target&&(i=r((g.defaultView||g.parentWindow).frameElement).offset())&&(h.left+=i.left,h.top+=i.top),g=r(g),h.left+=g.scrollLeft(),h.top+=g.scrollTop(),p},k.imagemap=function(e,t,n){t.jquery||(t=r(t));var o,i,a,s,l,u=(t.attr("shape")||"rect").toLowerCase().replace("poly","polygon"),d=r('img[usemap="#'+t.parent("map").attr("name")+'"]'),f=r.trim(t.attr("coords")).replace(/,$/,"").split(",");if(!d.length)return c;if("polygon"===u)s=k.polys.polygon(f,n);else{if(!k.polys[u])return c;for(a=-1,l=f.length,i=[];++a<l;)i.push(parseInt(f[a],10));s=k.polys[u].apply(this,i.concat(n))}return(o=d.offset()).left+=Math.ceil((d.outerWidth(c)-d.width())/2),o.top+=Math.ceil((d.outerHeight(c)-d.height())/2),s.position.left+=o.left,s.position.top+=o.top,s};var Te='<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';function Se(e){this._ns="ie6",this.qtip=e,this.init(e)}r.extend(Se.prototype,{_scroll:function(){var t=this.qtip.elements.overlay;t&&(t[0].style.top=r(e).scrollTop()+"px")},init:function(n){var o=n.tooltip;r("select, object").length<1&&(this.bgiframe=n.elements.bgiframe=r(Te).appendTo(o),n._bind(o,"tooltipmove",this.adjustBGIFrame,this._ns,this)),this.redrawContainer=r("<div/>",{id:x+"-rcontainer"}).appendTo(t.body),n.elements.overlay&&n.elements.overlay.addClass("qtipmodal-ie6fix")&&(n._bind(e,["scroll","resize"],this._scroll,this._ns,this),n._bind(o,["tooltipshow"],this._scroll,this._ns,this)),this.redraw()},adjustBGIFrame:function(){var e,t,n=this.qtip.tooltip,r={height:n.outerHeight(c),width:n.outerWidth(c)},o=this.qtip.plugins.tip,i=this.qtip.elements.tip;t={left:-(t=parseInt(n.css("borderLeftWidth"),10)||0),top:-t},o&&i&&(t[(e="x"===o.corner.precedance?[h,g]:[m,v])[1]]-=i[e[0]]()),this.bgiframe.css(t).css(r)},redraw:function(){if(this.qtip.rendered<1||this.drawing)return this;var e,t,n,r,o=this.qtip.tooltip,i=this.qtip.options.style,a=this.qtip.options.position.container;return this.qtip.drawing=1,i.height&&o.css(m,i.height),i.width?o.css(h,i.width):(o.css(h,"").appendTo(this.redrawContainer),(t=o.width())%2<1&&(t+=1),e=((n=o.css("maxWidth")||"")+(r=o.css("minWidth")||"")).indexOf("%")>-1?a.width()/100:0,t=(n=(n.indexOf("%")>-1?e:1*parseInt(n,10))||t)+(r=(r.indexOf("%")>-1?e:1*parseInt(r,10))||0)?Math.min(Math.max(t,r),n):t,o.css(h,Math.round(t)).appendTo(a)),this.drawing=0,this},destroy:function(){this.bgiframe&&this.bgiframe.remove(),this.qtip._unbind([e,this.qtip.tooltip],this._ns)}}),(k.ie6=function(e){return 6===L.ie?new Se(e):c}).initialize="render",s.ie6={"^content|style$":function(){this.redraw()}}}(o())}(window,document)},48915:function(e){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r},e.exports.__esModule=!0,e.exports.default=e.exports},73783:function(e){e.exports=function(e){if(Array.isArray(e))return e},e.exports.__esModule=!0,e.exports.default=e.exports},4233:function(e,t,n){var r=n(48915);e.exports=function(e){if(Array.isArray(e))return r(e)},e.exports.__esModule=!0,e.exports.default=e.exports},77111:function(e){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},31049:function(e){function t(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}e.exports=function(e){return function(){var n=this,r=arguments;return new Promise((function(o,i){var a=e.apply(n,r);function s(e){t(a,o,i,s,l,"next",e)}function l(e){t(a,o,i,s,l,"throw",e)}s(void 0)}))}},e.exports.__esModule=!0,e.exports.default=e.exports},39131:function(e){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},54562:function(e,t,n){var r=n(85344),o=n(80594);function i(t,n,a){return o()?(e.exports=i=Reflect.construct.bind(),e.exports.__esModule=!0,e.exports.default=e.exports):(e.exports=i=function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&r(i,n.prototype),i},e.exports.__esModule=!0,e.exports.default=e.exports),i.apply(null,arguments)}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports},78463:function(e,t,n){var r=n(84676);function o(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,r(o.key),o)}}e.exports=function(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},15985:function(e,t,n){var r=n(84676);e.exports=function(e,t,n){return(t=r(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},e.exports.__esModule=!0,e.exports.default=e.exports},2132:function(e){function t(n){return e.exports=t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},35075:function(e,t,n){var r=n(85344);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&r(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},1654:function(e){e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.__esModule=!0,e.exports.default=e.exports},1412:function(e){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")},e.exports.__esModule=!0,e.exports.default=e.exports},80594:function(e){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}},e.exports.__esModule=!0,e.exports.default=e.exports},26135:function(e){e.exports=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)},e.exports.__esModule=!0,e.exports.default=e.exports},96448:function(e){e.exports=function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i,a,s=[],l=!0,u=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1}else for(;!(l=(r=i.call(n)).done)&&(s.push(r.value),s.length!==t);l=!0);}catch(e){u=!0,o=e}finally{try{if(!l&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(u)throw o}}return s}},e.exports.__esModule=!0,e.exports.default=e.exports},99340:function(e){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},32449:function(e){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},35432:function(e,t,n){var r=n(12990).default,o=n(77111);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},58541:function(e,t,n){var r=n(12990).default;function o(){"use strict";/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */e.exports=o=function(){return t},e.exports.__esModule=!0,e.exports.default=e.exports;var t={},n=Object.prototype,i=n.hasOwnProperty,a=Object.defineProperty||function(e,t,n){e[t]=n.value},s="function"==typeof Symbol?Symbol:{},l=s.iterator||"@@iterator",u=s.asyncIterator||"@@asyncIterator",c=s.toStringTag||"@@toStringTag";function d(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{d({},"")}catch(e){d=function(e,t,n){return e[t]=n}}function f(e,t,n,r){var o=t&&t.prototype instanceof m?t:m,i=Object.create(o.prototype),s=new A(r||[]);return a(i,"_invoke",{value:x(e,n,s)}),i}function p(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}t.wrap=f;var h={};function m(){}function v(){}function g(){}var y={};d(y,l,(function(){return this}));var b=Object.getPrototypeOf,w=b&&b(b(P([])));w&&w!==n&&i.call(w,l)&&(y=w);var _=g.prototype=m.prototype=Object.create(y);function O(e){["next","throw","return"].forEach((function(t){d(e,t,(function(e){return this._invoke(t,e)}))}))}function k(e,t){function n(o,a,s,l){var u=p(e[o],e,a);if("throw"!==u.type){var c=u.arg,d=c.value;return d&&"object"==r(d)&&i.call(d,"__await")?t.resolve(d.__await).then((function(e){n("next",e,s,l)}),(function(e){n("throw",e,s,l)})):t.resolve(d).then((function(e){c.value=e,s(c)}),(function(e){return n("throw",e,s,l)}))}l(u.arg)}var o;a(this,"_invoke",{value:function(e,r){function i(){return new t((function(t,o){n(e,r,t,o)}))}return o=o?o.then(i,i):i()}})}function x(e,t,n){var r="suspendedStart";return function(o,i){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===o)throw i;return C()}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var s=E(a,n);if(s){if(s===h)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var l=p(e,t,n);if("normal"===l.type){if(r=n.done?"completed":"suspendedYield",l.arg===h)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(r="completed",n.method="throw",n.arg=l.arg)}}}function E(e,t){var n=t.method,r=e.iterator[n];if(void 0===r)return t.delegate=null,"throw"===n&&e.iterator.return&&(t.method="return",t.arg=void 0,E(e,t),"throw"===t.method)||"return"!==n&&(t.method="throw",t.arg=new TypeError("The iterator does not provide a '"+n+"' method")),h;var o=p(r,e.iterator,t.arg);if("throw"===o.type)return t.method="throw",t.arg=o.arg,t.delegate=null,h;var i=o.arg;return i?i.done?(t[e.resultName]=i.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,h):i:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,h)}function T(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function S(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function A(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(T,this),this.reset(!0)}function P(e){if(e){var t=e[l];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function t(){for(;++n<e.length;)if(i.call(e,n))return t.value=e[n],t.done=!1,t;return t.value=void 0,t.done=!0,t};return r.next=r}}return{next:C}}function C(){return{value:void 0,done:!0}}return v.prototype=g,a(_,"constructor",{value:g,configurable:!0}),a(g,"constructor",{value:v,configurable:!0}),v.displayName=d(g,c,"GeneratorFunction"),t.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===v||"GeneratorFunction"===(t.displayName||t.name))},t.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,g):(e.__proto__=g,d(e,c,"GeneratorFunction")),e.prototype=Object.create(_),e},t.awrap=function(e){return{__await:e}},O(k.prototype),d(k.prototype,u,(function(){return this})),t.AsyncIterator=k,t.async=function(e,n,r,o,i){void 0===i&&(i=Promise);var a=new k(f(e,n,r,o),i);return t.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},O(_),d(_,c,"Generator"),d(_,l,(function(){return this})),d(_,"toString",(function(){return"[object Generator]"})),t.keys=function(e){var t=Object(e),n=[];for(var r in t)n.push(r);return n.reverse(),function e(){for(;n.length;){var r=n.pop();if(r in t)return e.value=r,e.done=!1,e}return e.done=!0,e}},t.values=P,A.prototype={constructor:A,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(S),!e)for(var t in this)"t"===t.charAt(0)&&i.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function n(n,r){return a.type="throw",a.arg=e,t.next=n,r&&(t.method="next",t.arg=void 0),!!r}for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r],a=o.completion;if("root"===o.tryLoc)return n("end");if(o.tryLoc<=this.prev){var s=i.call(o,"catchLoc"),l=i.call(o,"finallyLoc");if(s&&l){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);if(this.prev<o.finallyLoc)return n(o.finallyLoc)}else if(s){if(this.prev<o.catchLoc)return n(o.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return n(o.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=e,a.arg=t,o?(this.method="next",this.next=o.finallyLoc,h):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),h},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),S(n),h}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;S(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:P(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),h}},t}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},85344:function(e){function t(n,r){return e.exports=t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n,r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},66583:function(e,t,n){var r=n(73783),o=n(96448),i=n(36030),a=n(99340);e.exports=function(e,t){return r(e)||o(e,t)||i(e,t)||a()},e.exports.__esModule=!0,e.exports.default=e.exports},31752:function(e,t,n){var r=n(4233),o=n(26135),i=n(36030),a=n(32449);e.exports=function(e){return r(e)||o(e)||i(e)||a()},e.exports.__esModule=!0,e.exports.default=e.exports},8705:function(e,t,n){var r=n(12990).default;e.exports=function(e,t){if("object"!==r(e)||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!==r(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)},e.exports.__esModule=!0,e.exports.default=e.exports},84676:function(e,t,n){var r=n(12990).default,o=n(8705);e.exports=function(e){var t=o(e,"string");return"symbol"===r(t)?t:String(t)},e.exports.__esModule=!0,e.exports.default=e.exports},12990:function(e){function t(n){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},36030:function(e,t,n){var r=n(48915);e.exports=function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports},19457:function(e,t,n){var r=n(2132),o=n(85344),i=n(1412),a=n(54562);function s(t){var n="function"==typeof Map?new Map:void 0;return e.exports=s=function(e){if(null===e||!i(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},e.exports.__esModule=!0,e.exports.default=e.exports,s(t)}e.exports=s,e.exports.__esModule=!0,e.exports.default=e.exports},70232:function(e,t,n){var r=n(58541)();e.exports=r;try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},45091:function(e,t,n){"use strict";n.r(t),n.d(t,{VERSION:function(){return o},after:function(){return It},all:function(){return Qt},allKeys:function(){return he},any:function(){return Xt},assign:function(){return Ie},before:function(){return Nt},bind:function(){return wt},bindAll:function(){return kt},chain:function(){return vt},chunk:function(){return Dn},clone:function(){return De},collect:function(){return Kt},compact:function(){return En},compose:function(){return Rt},constant:function(){return Q},contains:function(){return en},countBy:function(){return mn},create:function(){return je},debounce:function(){return At},default:function(){return Vn},defaults:function(){return Ne},defer:function(){return Tt},delay:function(){return Et},detect:function(){return Ht},difference:function(){return Sn},drop:function(){return kn},each:function(){return Wt},escape:function(){return ot},every:function(){return Qt},extend:function(){return Re},extendOwn:function(){return Ie},filter:function(){return Gt},find:function(){return Ht},findIndex:function(){return Lt},findKey:function(){return jt},findLastIndex:function(){return Ut},findWhere:function(){return qt},first:function(){return On},flatten:function(){return Tn},foldl:function(){return zt},foldr:function(){return Yt},forEach:function(){return Wt},functions:function(){return Pe},get:function(){return Ve},groupBy:function(){return pn},has:function(){return Ze},head:function(){return On},identity:function(){return He},include:function(){return en},includes:function(){return en},indexBy:function(){return hn},indexOf:function(){return Vt},initial:function(){return _n},inject:function(){return zt},intersection:function(){return Rn},invert:function(){return Ae},invoke:function(){return tn},isArguments:function(){return Y},isArray:function(){return K},isArrayBuffer:function(){return L},isBoolean:function(){return A},isDataView:function(){return W},isDate:function(){return N},isElement:function(){return P},isEmpty:function(){return le},isEqual:function(){return pe},isError:function(){return j},isFinite:function(){return G},isFunction:function(){return B},isMap:function(){return Oe},isMatch:function(){return ue},isNaN:function(){return J},isNull:function(){return T},isNumber:function(){return I},isObject:function(){return E},isRegExp:function(){return M},isSet:function(){return xe},isString:function(){return R},isSymbol:function(){return D},isTypedArray:function(){return oe},isUndefined:function(){return S},isWeakMap:function(){return ke},isWeakSet:function(){return Ee},iteratee:function(){return ze},keys:function(){return se},last:function(){return xn},lastIndexOf:function(){return Zt},map:function(){return Kt},mapObject:function(){return Ge},matcher:function(){return qe},matches:function(){return qe},max:function(){return on},memoize:function(){return xt},methods:function(){return Pe},min:function(){return an},mixin:function(){return Un},negate:function(){return Ct},noop:function(){return Je},now:function(){return tt},object:function(){return Mn},omit:function(){return wn},once:function(){return Mt},pairs:function(){return Se},partial:function(){return bt},partition:function(){return vn},pick:function(){return bn},pluck:function(){return nn},property:function(){return We},propertyOf:function(){return Qe},random:function(){return et},range:function(){return jn},reduce:function(){return zt},reduceRight:function(){return Yt},reject:function(){return Jt},rest:function(){return kn},restArguments:function(){return x},result:function(){return pt},sample:function(){return un},select:function(){return Gt},shuffle:function(){return cn},size:function(){return gn},some:function(){return Xt},sortBy:function(){return dn},sortedIndex:function(){return Ft},tail:function(){return kn},take:function(){return On},tap:function(){return Le},template:function(){return ft},templateSettings:function(){return at},throttle:function(){return St},times:function(){return Xe},toArray:function(){return ln},toPath:function(){return Ue},transpose:function(){return In},unescape:function(){return it},union:function(){return Cn},uniq:function(){return Pn},unique:function(){return Pn},uniqueId:function(){return mt},unzip:function(){return In},values:function(){return Te},where:function(){return rn},without:function(){return An},wrap:function(){return Pt},zip:function(){return Nn}});var r={};n.r(r),n.d(r,{VERSION:function(){return o},after:function(){return It},all:function(){return Qt},allKeys:function(){return he},any:function(){return Xt},assign:function(){return Ie},before:function(){return Nt},bind:function(){return wt},bindAll:function(){return kt},chain:function(){return vt},chunk:function(){return Dn},clone:function(){return De},collect:function(){return Kt},compact:function(){return En},compose:function(){return Rt},constant:function(){return Q},contains:function(){return en},countBy:function(){return mn},create:function(){return je},debounce:function(){return At},default:function(){return Fn},defaults:function(){return Ne},defer:function(){return Tt},delay:function(){return Et},detect:function(){return Ht},difference:function(){return Sn},drop:function(){return kn},each:function(){return Wt},escape:function(){return ot},every:function(){return Qt},extend:function(){return Re},extendOwn:function(){return Ie},filter:function(){return Gt},find:function(){return Ht},findIndex:function(){return Lt},findKey:function(){return jt},findLastIndex:function(){return Ut},findWhere:function(){return qt},first:function(){return On},flatten:function(){return Tn},foldl:function(){return zt},foldr:function(){return Yt},forEach:function(){return Wt},functions:function(){return Pe},get:function(){return Ve},groupBy:function(){return pn},has:function(){return Ze},head:function(){return On},identity:function(){return He},include:function(){return en},includes:function(){return en},indexBy:function(){return hn},indexOf:function(){return Vt},initial:function(){return _n},inject:function(){return zt},intersection:function(){return Rn},invert:function(){return Ae},invoke:function(){return tn},isArguments:function(){return Y},isArray:function(){return K},isArrayBuffer:function(){return L},isBoolean:function(){return A},isDataView:function(){return W},isDate:function(){return N},isElement:function(){return P},isEmpty:function(){return le},isEqual:function(){return pe},isError:function(){return j},isFinite:function(){return G},isFunction:function(){return B},isMap:function(){return Oe},isMatch:function(){return ue},isNaN:function(){return J},isNull:function(){return T},isNumber:function(){return I},isObject:function(){return E},isRegExp:function(){return M},isSet:function(){return xe},isString:function(){return R},isSymbol:function(){return D},isTypedArray:function(){return oe},isUndefined:function(){return S},isWeakMap:function(){return ke},isWeakSet:function(){return Ee},iteratee:function(){return ze},keys:function(){return se},last:function(){return xn},lastIndexOf:function(){return Zt},map:function(){return Kt},mapObject:function(){return Ge},matcher:function(){return qe},matches:function(){return qe},max:function(){return on},memoize:function(){return xt},methods:function(){return Pe},min:function(){return an},mixin:function(){return Un},negate:function(){return Ct},noop:function(){return Je},now:function(){return tt},object:function(){return Mn},omit:function(){return wn},once:function(){return Mt},pairs:function(){return Se},partial:function(){return bt},partition:function(){return vn},pick:function(){return bn},pluck:function(){return nn},property:function(){return We},propertyOf:function(){return Qe},random:function(){return et},range:function(){return jn},reduce:function(){return zt},reduceRight:function(){return Yt},reject:function(){return Jt},rest:function(){return kn},restArguments:function(){return x},result:function(){return pt},sample:function(){return un},select:function(){return Gt},shuffle:function(){return cn},size:function(){return gn},some:function(){return Xt},sortBy:function(){return dn},sortedIndex:function(){return Ft},tail:function(){return kn},take:function(){return On},tap:function(){return Le},template:function(){return ft},templateSettings:function(){return at},throttle:function(){return St},times:function(){return Xe},toArray:function(){return ln},toPath:function(){return Ue},transpose:function(){return In},unescape:function(){return it},union:function(){return Cn},uniq:function(){return Pn},unique:function(){return Pn},uniqueId:function(){return mt},unzip:function(){return In},values:function(){return Te},where:function(){return rn},without:function(){return An},wrap:function(){return Pt},zip:function(){return Nn}});var o="1.13.8",i="object"==typeof self&&self.self===self&&self||"object"==typeof global&&global.global===global&&global||Function("return this")()||{},a=Array.prototype,s=Object.prototype,l="undefined"!=typeof Symbol?Symbol.prototype:null,u=a.push,c=a.slice,d=s.toString,f=s.hasOwnProperty,p="undefined"!=typeof ArrayBuffer,h="undefined"!=typeof DataView,m=Array.isArray,v=Object.keys,g=Object.create,y=p&&ArrayBuffer.isView,b=isNaN,w=isFinite,_=!{toString:null}.propertyIsEnumerable("toString"),O=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],k=Math.pow(2,53)-1;function x(e,t){return t=null==t?e.length-1:+t,function(){for(var n=Math.max(arguments.length-t,0),r=Array(n),o=0;o<n;o++)r[o]=arguments[o+t];switch(t){case 0:return e.call(this,r);case 1:return e.call(this,arguments[0],r);case 2:return e.call(this,arguments[0],arguments[1],r)}var i=Array(t+1);for(o=0;o<t;o++)i[o]=arguments[o];return i[t]=r,e.apply(this,i)}}function E(e){var t=typeof e;return"function"===t||"object"===t&&!!e}function T(e){return null===e}function S(e){return void 0===e}function A(e){return!0===e||!1===e||"[object Boolean]"===d.call(e)}function P(e){return!(!e||1!==e.nodeType)}function C(e){var t="[object "+e+"]";return function(e){return d.call(e)===t}}var R=C("String"),I=C("Number"),N=C("Date"),M=C("RegExp"),j=C("Error"),D=C("Symbol"),L=C("ArrayBuffer"),U=C("Function"),F=i.document&&i.document.childNodes;"object"!=typeof Int8Array&&"function"!=typeof F&&(U=function(e){return"function"==typeof e||!1});var B=U,V=C("Object"),Z=h&&(!/\[native code\]/.test(String(DataView))||V(new DataView(new ArrayBuffer(8)))),H="undefined"!=typeof Map&&V(new Map),q=C("DataView");var W=Z?function(e){return null!=e&&B(e.getInt8)&&L(e.buffer)}:q,K=m||C("Array");function $(e,t){return null!=e&&f.call(e,t)}var z=C("Arguments");!function(){z(arguments)||(z=function(e){return $(e,"callee")})}();var Y=z;function G(e){return!D(e)&&w(e)&&!isNaN(parseFloat(e))}function J(e){return I(e)&&b(e)}function Q(e){return function(){return e}}function X(e){return function(t){var n=e(t);return"number"==typeof n&&n>=0&&n<=k}}function ee(e){return function(t){return null==t?void 0:t[e]}}var te=ee("byteLength"),ne=X(te),re=/\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;var oe=p?function(e){return y?y(e)&&!W(e):ne(e)&&re.test(d.call(e))}:Q(!1),ie=ee("length");function ae(e,t){t=function(e){for(var t={},n=e.length,r=0;r<n;++r)t[e[r]]=!0;return{contains:function(e){return!0===t[e]},push:function(n){return t[n]=!0,e.push(n)}}}(t);var n=O.length,r=e.constructor,o=B(r)&&r.prototype||s,i="constructor";for($(e,i)&&!t.contains(i)&&t.push(i);n--;)(i=O[n])in e&&e[i]!==o[i]&&!t.contains(i)&&t.push(i)}function se(e){if(!E(e))return[];if(v)return v(e);var t=[];for(var n in e)$(e,n)&&t.push(n);return _&&ae(e,t),t}function le(e){if(null==e)return!0;var t=ie(e);return"number"==typeof t&&(K(e)||R(e)||Y(e))?0===t:0===ie(se(e))}function ue(e,t){var n=se(t),r=n.length;if(null==e)return!r;for(var o=Object(e),i=0;i<r;i++){var a=n[i];if(t[a]!==o[a]||!(a in o))return!1}return!0}function ce(e){return e instanceof ce?e:this instanceof ce?void(this._wrapped=e):new ce(e)}function de(e){return new Uint8Array(e.buffer||e,e.byteOffset||0,te(e))}ce.VERSION=o,ce.prototype.value=function(){return this._wrapped},ce.prototype.valueOf=ce.prototype.toJSON=ce.prototype.value,ce.prototype.toString=function(){return String(this._wrapped)};var fe="[object DataView]";function pe(e,t){for(var n=[{a:e,b:t}],r=[],o=[];n.length;){var i=n.pop();if(!0!==i){if((e=i.a)===(t=i.b)){if(0!==e||1/e==1/t)continue;return!1}if(null==e||null==t)return!1;if(e!=e){if(t!=t)continue;return!1}var a=typeof e;if("function"!==a&&"object"!==a&&"object"!=typeof t)return!1;e instanceof ce&&(e=e._wrapped),t instanceof ce&&(t=t._wrapped);var s=d.call(e);if(s!==d.call(t))return!1;if(Z&&"[object Object]"==s&&W(e)){if(!W(t))return!1;s=fe}switch(s){case"[object RegExp]":case"[object String]":if(""+e==""+t)continue;return!1;case"[object Number]":n.push({a:+e,b:+t});continue;case"[object Date]":case"[object Boolean]":if(+e==+t)continue;return!1;case"[object Symbol]":if(l.valueOf.call(e)===l.valueOf.call(t))continue;return!1;case"[object ArrayBuffer]":case fe:n.push({a:de(e),b:de(t)});continue}var u="[object Array]"===s;if(!u&&oe(e)){if(te(e)!==te(t))return!1;if(e.buffer===t.buffer&&e.byteOffset===t.byteOffset)continue;u=!0}if(!u){if("object"!=typeof e||"object"!=typeof t)return!1;var c=e.constructor,f=t.constructor;if(c!==f&&!(B(c)&&c instanceof c&&B(f)&&f instanceof f)&&"constructor"in e&&"constructor"in t)return!1}for(var p=r.length;p--;)if(r[p]===e){if(o[p]===t)break;return!1}if(!(p>=0))if(r.push(e),o.push(t),n.push(!0),u){if((p=e.length)!==t.length)return!1;for(;p--;)n.push({a:e[p],b:t[p]})}else{var h,m=se(e);if(p=m.length,se(t).length!==p)return!1;for(;p--;){if(!$(t,h=m[p]))return!1;n.push({a:e[h],b:t[h]})}}}else r.pop(),o.pop()}return!0}function he(e){if(!E(e))return[];var t=[];for(var n in e)t.push(n);return _&&ae(e,t),t}function me(e){var t=ie(e);return function(n){if(null==n)return!1;var r=he(n);if(ie(r))return!1;for(var o=0;o<t;o++)if(!B(n[e[o]]))return!1;return e!==we||!B(n[ve])}}var ve="forEach",ge=["clear","delete"],ye=["get","has","set"],be=ge.concat(ve,ye),we=ge.concat(ye),_e=["add"].concat(ge,ve,"has"),Oe=H?me(be):C("Map"),ke=H?me(we):C("WeakMap"),xe=H?me(_e):C("Set"),Ee=C("WeakSet");function Te(e){for(var t=se(e),n=t.length,r=Array(n),o=0;o<n;o++)r[o]=e[t[o]];return r}function Se(e){for(var t=se(e),n=t.length,r=Array(n),o=0;o<n;o++)r[o]=[t[o],e[t[o]]];return r}function Ae(e){for(var t={},n=se(e),r=0,o=n.length;r<o;r++)t[e[n[r]]]=n[r];return t}function Pe(e){var t=[];for(var n in e)B(e[n])&&t.push(n);return t.sort()}function Ce(e,t){return function(n){var r=arguments.length;if(t&&(n=Object(n)),r<2||null==n)return n;for(var o=1;o<r;o++)for(var i=arguments[o],a=e(i),s=a.length,l=0;l<s;l++){var u=a[l];t&&void 0!==n[u]||(n[u]=i[u])}return n}}var Re=Ce(he),Ie=Ce(se),Ne=Ce(he,!0);function Me(e){if(!E(e))return{};if(g)return g(e);var t=function(){};t.prototype=e;var n=new t;return t.prototype=null,n}function je(e,t){var n=Me(e);return t&&Ie(n,t),n}function De(e){return E(e)?K(e)?e.slice():Re({},e):e}function Le(e,t){return t(e),e}function Ue(e){return K(e)?e:[e]}function Fe(e){return ce.toPath(e)}function Be(e,t){for(var n=t.length,r=0;r<n;r++){if(null==e)return;e=e[t[r]]}return n?e:void 0}function Ve(e,t,n){var r=Be(e,Fe(t));return S(r)?n:r}function Ze(e,t){for(var n=(t=Fe(t)).length,r=0;r<n;r++){var o=t[r];if(!$(e,o))return!1;e=e[o]}return!!n}function He(e){return e}function qe(e){return e=Ie({},e),function(t){return ue(t,e)}}function We(e){return e=Fe(e),function(t){return Be(t,e)}}function Ke(e,t,n){if(void 0===t)return e;switch(null==n?3:n){case 1:return function(n){return e.call(t,n)};case 3:return function(n,r,o){return e.call(t,n,r,o)};case 4:return function(n,r,o,i){return e.call(t,n,r,o,i)}}return function(){return e.apply(t,arguments)}}function $e(e,t,n){return null==e?He:B(e)?Ke(e,t,n):E(e)&&!K(e)?qe(e):We(e)}function ze(e,t){return $e(e,t,1/0)}function Ye(e,t,n){return ce.iteratee!==ze?ce.iteratee(e,t):$e(e,t,n)}function Ge(e,t,n){t=Ye(t,n);for(var r=se(e),o=r.length,i={},a=0;a<o;a++){var s=r[a];i[s]=t(e[s],s,e)}return i}function Je(){}function Qe(e){return null==e?Je:function(t){return Ve(e,t)}}function Xe(e,t,n){var r=Array(Math.max(0,e));t=Ke(t,n,1);for(var o=0;o<e;o++)r[o]=t(o);return r}function et(e,t){return null==t&&(t=e,e=0),e+Math.floor(Math.random()*(t-e+1))}ce.toPath=Ue,ce.iteratee=ze;var tt=Date.now||function(){return(new Date).getTime()};function nt(e){var t=function(t){return e[t]},n="(?:"+se(e).join("|")+")",r=RegExp(n),o=RegExp(n,"g");return function(e){return e=null==e?"":""+e,r.test(e)?e.replace(o,t):e}}var rt={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},ot=nt(rt),it=nt(Ae(rt)),at=ce.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g},st=/(.)^/,lt={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},ut=/\\|'|\r|\n|\u2028|\u2029/g;function ct(e){return"\\"+lt[e]}var dt=/^\s*(\w|\$)+\s*$/;function ft(e,t,n){!t&&n&&(t=n),t=Ne({},t,ce.templateSettings);var r=RegExp([(t.escape||st).source,(t.interpolate||st).source,(t.evaluate||st).source].join("|")+"|$","g"),o=0,i="__p+='";e.replace(r,(function(t,n,r,a,s){return i+=e.slice(o,s).replace(ut,ct),o=s+t.length,n?i+="'+\n((__t=("+n+"))==null?'':_.escape(__t))+\n'":r?i+="'+\n((__t=("+r+"))==null?'':__t)+\n'":a&&(i+="';\n"+a+"\n__p+='"),t})),i+="';\n";var a,s=t.variable;if(s){if(!dt.test(s))throw new Error("variable is not a bare identifier: "+s)}else i="with(obj||{}){\n"+i+"}\n",s="obj";i="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{a=new Function(s,"_",i)}catch(e){throw e.source=i,e}var l=function(e){return a.call(this,e,ce)};return l.source="function("+s+"){\n"+i+"}",l}function pt(e,t,n){var r=(t=Fe(t)).length;if(!r)return B(n)?n.call(e):n;for(var o=0;o<r;o++){var i=null==e?void 0:e[t[o]];void 0===i&&(i=n,o=r),e=B(i)?i.call(e):i}return e}var ht=0;function mt(e){var t=++ht+"";return e?e+t:t}function vt(e){var t=ce(e);return t._chain=!0,t}function gt(e,t,n,r,o){if(!(r instanceof t))return e.apply(n,o);var i=Me(e.prototype),a=e.apply(i,o);return E(a)?a:i}var yt=x((function(e,t){var n=yt.placeholder,r=function(){for(var o=0,i=t.length,a=Array(i),s=0;s<i;s++)a[s]=t[s]===n?arguments[o++]:t[s];for(;o<arguments.length;)a.push(arguments[o++]);return gt(e,r,this,this,a)};return r}));yt.placeholder=ce;var bt=yt,wt=x((function(e,t,n){if(!B(e))throw new TypeError("Bind must be called on a function");var r=x((function(o){return gt(e,r,t,this,n.concat(o))}));return r})),_t=X(ie);function Ot(e,t,n){t||0===t||(t=1/0);for(var r=[],o=0,i=0,a=ie(e)||0,s=[];;)if(i>=a){if(!s.length)break;var l=s.pop();i=l.i,e=l.v,a=ie(e)}else{var u=e[i++];s.length>=t?r[o++]=u:_t(u)&&(K(u)||Y(u))?(s.push({i:i,v:e}),i=0,a=ie(e=u)):n||(r[o++]=u)}return r}var kt=x((function(e,t){var n=(t=Ot(t,!1,!1)).length;if(n<1)throw new Error("bindAll must be passed function names");for(;n--;){var r=t[n];e[r]=wt(e[r],e)}return e}));function xt(e,t){var n=function(r){var o=n.cache,i=""+(t?t.apply(this,arguments):r);return $(o,i)||(o[i]=e.apply(this,arguments)),o[i]};return n.cache={},n}var Et=x((function(e,t,n){return setTimeout((function(){return e.apply(null,n)}),t)})),Tt=bt(Et,ce,1);function St(e,t,n){var r,o,i,a,s=0;n||(n={});var l=function(){s=!1===n.leading?0:tt(),r=null,a=e.apply(o,i),r||(o=i=null)},u=function(){var u=tt();s||!1!==n.leading||(s=u);var c=t-(u-s);return o=this,i=arguments,c<=0||c>t?(r&&(clearTimeout(r),r=null),s=u,a=e.apply(o,i),r||(o=i=null)):r||!1===n.trailing||(r=setTimeout(l,c)),a};return u.cancel=function(){clearTimeout(r),s=0,r=o=i=null},u}function At(e,t,n){var r,o,i,a,s,l=function(){var u=tt()-o;t>u?r=setTimeout(l,t-u):(r=null,n||(a=e.apply(s,i)),r||(i=s=null))},u=x((function(u){return s=this,i=u,o=tt(),r||(r=setTimeout(l,t),n&&(a=e.apply(s,i))),a}));return u.cancel=function(){clearTimeout(r),r=i=s=null},u}function Pt(e,t){return bt(t,e)}function Ct(e){return function(){return!e.apply(this,arguments)}}function Rt(){var e=arguments,t=e.length-1;return function(){for(var n=t,r=e[t].apply(this,arguments);n--;)r=e[n].call(this,r);return r}}function It(e,t){return function(){if(--e<1)return t.apply(this,arguments)}}function Nt(e,t){var n;return function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=null),n}}var Mt=bt(Nt,2);function jt(e,t,n){t=Ye(t,n);for(var r,o=se(e),i=0,a=o.length;i<a;i++)if(t(e[r=o[i]],r,e))return r}function Dt(e){return function(t,n,r){n=Ye(n,r);for(var o=ie(t),i=e>0?0:o-1;i>=0&&i<o;i+=e)if(n(t[i],i,t))return i;return-1}}var Lt=Dt(1),Ut=Dt(-1);function Ft(e,t,n,r){for(var o=(n=Ye(n,r,1))(t),i=0,a=ie(e);i<a;){var s=Math.floor((i+a)/2);n(e[s])<o?i=s+1:a=s}return i}function Bt(e,t,n){return function(r,o,i){var a=0,s=ie(r);if("number"==typeof i)e>0?a=i>=0?i:Math.max(i+s,a):s=i>=0?Math.min(i+1,s):i+s+1;else if(n&&i&&s)return r[i=n(r,o)]===o?i:-1;if(o!=o)return(i=t(c.call(r,a,s),J))>=0?i+a:-1;for(i=e>0?a:s-1;i>=0&&i<s;i+=e)if(r[i]===o)return i;return-1}}var Vt=Bt(1,Lt,Ft),Zt=Bt(-1,Ut);function Ht(e,t,n){var r=(_t(e)?Lt:jt)(e,t,n);if(void 0!==r&&-1!==r)return e[r]}function qt(e,t){return Ht(e,qe(t))}function Wt(e,t,n){var r,o;if(t=Ke(t,n),_t(e))for(r=0,o=e.length;r<o;r++)t(e[r],r,e);else{var i=se(e);for(r=0,o=i.length;r<o;r++)t(e[i[r]],i[r],e)}return e}function Kt(e,t,n){t=Ye(t,n);for(var r=!_t(e)&&se(e),o=(r||e).length,i=Array(o),a=0;a<o;a++){var s=r?r[a]:a;i[a]=t(e[s],s,e)}return i}function $t(e){var t=function(t,n,r,o){var i=!_t(t)&&se(t),a=(i||t).length,s=e>0?0:a-1;for(o||(r=t[i?i[s]:s],s+=e);s>=0&&s<a;s+=e){var l=i?i[s]:s;r=n(r,t[l],l,t)}return r};return function(e,n,r,o){var i=arguments.length>=3;return t(e,Ke(n,o,4),r,i)}}var zt=$t(1),Yt=$t(-1);function Gt(e,t,n){var r=[];return t=Ye(t,n),Wt(e,(function(e,n,o){t(e,n,o)&&r.push(e)})),r}function Jt(e,t,n){return Gt(e,Ct(Ye(t)),n)}function Qt(e,t,n){t=Ye(t,n);for(var r=!_t(e)&&se(e),o=(r||e).length,i=0;i<o;i++){var a=r?r[i]:i;if(!t(e[a],a,e))return!1}return!0}function Xt(e,t,n){t=Ye(t,n);for(var r=!_t(e)&&se(e),o=(r||e).length,i=0;i<o;i++){var a=r?r[i]:i;if(t(e[a],a,e))return!0}return!1}function en(e,t,n,r){return _t(e)||(e=Te(e)),("number"!=typeof n||r)&&(n=0),Vt(e,t,n)>=0}var tn=x((function(e,t,n){var r,o;return B(t)?o=t:(t=Fe(t),r=t.slice(0,-1),t=t[t.length-1]),Kt(e,(function(e){var i=o;if(!i){if(r&&r.length&&(e=Be(e,r)),null==e)return;i=e[t]}return null==i?i:i.apply(e,n)}))}));function nn(e,t){return Kt(e,We(t))}function rn(e,t){return Gt(e,qe(t))}function on(e,t,n){var r,o,i=-1/0,a=-1/0;if(null==t||"number"==typeof t&&"object"!=typeof e[0]&&null!=e)for(var s=0,l=(e=_t(e)?e:Te(e)).length;s<l;s++)null!=(r=e[s])&&r>i&&(i=r);else t=Ye(t,n),Wt(e,(function(e,n,r){((o=t(e,n,r))>a||o===-1/0&&i===-1/0)&&(i=e,a=o)}));return i}function an(e,t,n){var r,o,i=1/0,a=1/0;if(null==t||"number"==typeof t&&"object"!=typeof e[0]&&null!=e)for(var s=0,l=(e=_t(e)?e:Te(e)).length;s<l;s++)null!=(r=e[s])&&r<i&&(i=r);else t=Ye(t,n),Wt(e,(function(e,n,r){((o=t(e,n,r))<a||o===1/0&&i===1/0)&&(i=e,a=o)}));return i}var sn=/[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;function ln(e){return e?K(e)?c.call(e):R(e)?e.match(sn):_t(e)?Kt(e,He):Te(e):[]}function un(e,t,n){if(null==t||n)return _t(e)||(e=Te(e)),e[et(e.length-1)];var r=ln(e),o=ie(r);t=Math.max(Math.min(t,o),0);for(var i=o-1,a=0;a<t;a++){var s=et(a,i),l=r[a];r[a]=r[s],r[s]=l}return r.slice(0,t)}function cn(e){return un(e,1/0)}function dn(e,t,n){var r=0;return t=Ye(t,n),nn(Kt(e,(function(e,n,o){return{value:e,index:r++,criteria:t(e,n,o)}})).sort((function(e,t){var n=e.criteria,r=t.criteria;if(n!==r){if(n>r||void 0===n)return 1;if(n<r||void 0===r)return-1}return e.index-t.index})),"value")}function fn(e,t){return function(n,r,o){var i=t?[[],[]]:{};return r=Ye(r,o),Wt(n,(function(t,o){var a=r(t,o,n);e(i,t,a)})),i}}var pn=fn((function(e,t,n){$(e,n)?e[n].push(t):e[n]=[t]})),hn=fn((function(e,t,n){e[n]=t})),mn=fn((function(e,t,n){$(e,n)?e[n]++:e[n]=1})),vn=fn((function(e,t,n){e[n?0:1].push(t)}),!0);function gn(e){return null==e?0:_t(e)?e.length:se(e).length}function yn(e,t,n){return t in n}var bn=x((function(e,t){var n={},r=t[0];if(null==e)return n;B(r)?(t.length>1&&(r=Ke(r,t[1])),t=he(e)):(r=yn,t=Ot(t,!1,!1),e=Object(e));for(var o=0,i=t.length;o<i;o++){var a=t[o],s=e[a];r(s,a,e)&&(n[a]=s)}return n})),wn=x((function(e,t){var n,r=t[0];return B(r)?(r=Ct(r),t.length>1&&(n=t[1])):(t=Kt(Ot(t,!1,!1),String),r=function(e,n){return!en(t,n)}),bn(e,r,n)}));function _n(e,t,n){return c.call(e,0,Math.max(0,e.length-(null==t||n?1:t)))}function On(e,t,n){return null==e||e.length<1?null==t||n?void 0:[]:null==t||n?e[0]:_n(e,e.length-t)}function kn(e,t,n){return c.call(e,null==t||n?1:t)}function xn(e,t,n){return null==e||e.length<1?null==t||n?void 0:[]:null==t||n?e[e.length-1]:kn(e,Math.max(0,e.length-t))}function En(e){return Gt(e,Boolean)}function Tn(e,t){return Ot(e,t,!1)}var Sn=x((function(e,t){return t=Ot(t,!0,!0),Gt(e,(function(e){return!en(t,e)}))})),An=x((function(e,t){return Sn(e,t)}));function Pn(e,t,n,r){A(t)||(r=n,n=t,t=!1),null!=n&&(n=Ye(n,r));for(var o=[],i=[],a=0,s=ie(e);a<s;a++){var l=e[a],u=n?n(l,a,e):l;t&&!n?(a&&i===u||o.push(l),i=u):n?en(i,u)||(i.push(u),o.push(l)):en(o,l)||o.push(l)}return o}var Cn=x((function(e){return Pn(Ot(e,!0,!0))}));function Rn(e){for(var t=[],n=arguments.length,r=0,o=ie(e);r<o;r++){var i=e[r];if(!en(t,i)){var a;for(a=1;a<n&&en(arguments[a],i);a++);a===n&&t.push(i)}}return t}function In(e){for(var t=e&&on(e,ie).length||0,n=Array(t),r=0;r<t;r++)n[r]=nn(e,r);return n}var Nn=x(In);function Mn(e,t){for(var n={},r=0,o=ie(e);r<o;r++)t?n[e[r]]=t[r]:n[e[r][0]]=e[r][1];return n}function jn(e,t,n){null==t&&(t=e||0,e=0),n||(n=t<e?-1:1);for(var r=Math.max(Math.ceil((t-e)/n),0),o=Array(r),i=0;i<r;i++,e+=n)o[i]=e;return o}function Dn(e,t){if(null==t||t<1)return[];for(var n=[],r=0,o=e.length;r<o;)n.push(c.call(e,r,r+=t));return n}function Ln(e,t){return e._chain?ce(t).chain():t}function Un(e){return Wt(Pe(e),(function(t){var n=ce[t]=e[t];ce.prototype[t]=function(){var e=[this._wrapped];return u.apply(e,arguments),Ln(this,n.apply(ce,e))}})),ce}Wt(["pop","push","reverse","shift","sort","splice","unshift"],(function(e){var t=a[e];ce.prototype[e]=function(){var n=this._wrapped;return null!=n&&(t.apply(n,arguments),"shift"!==e&&"splice"!==e||0!==n.length||delete n[0]),Ln(this,n)}})),Wt(["concat","join","slice"],(function(e){var t=a[e];ce.prototype[e]=function(){var e=this._wrapped;return null!=e&&(e=t.apply(e,arguments)),Ln(this,e)}}));var Fn=ce,Bn=Un(r);Bn._=Bn;var Vn=Bn},83755:function(e){"use strict";e.exports=JSON.parse('{"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"Virgin Islands, British","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CO":"Colombia","KM":"Comoros","CG":"Congo","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d\'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","CD":"Congo, the Democratic Republic of the","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","TL":"Timor-Leste","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea, Republic of","XK":"Kosovo, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"Korea, Democratic People\'s Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"São Tomé and Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","VI":"Virgin Islands, U.S.","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Holy See (Vatican City State)","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}')},74752:function(e){"use strict";e.exports=JSON.parse('{"signout":"Sign Out","signin":"Sign In","signup":"Sign Up","remember":"Remember me","rememberDevice":"Trust this device","rememberDevice.timebased":"Do not challenge me on this device for the next {0}","rememberDevice.devicebased":"Do not challenge me on this device again","autoPush":"Send push automatically","unlockaccount":"Unlock account?","haveaccount":"Already have an account?","needhelp":"Need help signing in?","forgotpassword":"Forgot password?","help":"Help","retry":"Retry","iphone":"iPhone","android":"Android","goback":"Back to sign in","closeWindow":"You can close this window","country.option.label":"{0} ({1})","phone.extention.label":"Extension","select.default_value":"Select an option","select.filter.no_match":"No results found for \\"{0}\\"","sensitive.input.show":"Show","sensitive.input.hide":"Hide","processing.alt.text":"Processing...","logo.default.alt.text":"Logo","identifier.icon.alt.text":"User","icon.title.application":"Application","icon.title.browser":"Browser","icon.title.mobileBrowser":"Mobile browser","icon.title.location":"Location","icon.title.mobileDevice":"Mobile Device","skip.to.main.content":"Skip to main content","minutes.oneMinute":"minute","minutes":"{0} minutes","hours":"{0} hours","days":"{0} days","error.config":"There was a configuration error","error.required.authParams":"Missing parameters for the configured authentication scheme - \\"OAUTH2\\"","error.required.baseUrl":"\\"baseUrl\\" is a required widget parameter","error.required.success":"A success handler is required","error.required.el":"\\"el\\" is a required widget parameter","error.invalid.colors.brand":"\\"colors.brand\\" must be in six-digit hex format","error.unsupported.browser":"Unsupported browser","error.unsupported.cors":"Unsupported browser - missing CORS support","error.unsupported.localStorage":"Unsupported browser - missing localStorage support","error.enabled.cors":"There was an error sending the request - have you enabled CORS?","error.expired.session":"Your session has expired. Please try to sign in again.","error.mfa.only.expired.session":"Unable to authenticate at this time.","error.auth.lockedOut":"Your account is locked. Please contact your administrator.","error.oauth.idToken":"There was a problem generating the id_token for the user. Please try again.","error.network.connection":"Unable to connect to the server. Please check your network connection.","error.username.required":"Please enter a username","error.password.required":"Please enter a password","error.mfa.required":"The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.","error.unsupported.response":"There was an unsupported response from server.","error.jit_failure":"Unable to sign in, please try another sign in method.","error.unsynced.clock":"Unable to sign in. Please check that your device\'s clock is accurate and try again.","errors.E0000004":"Unable to sign in","errors.E0000069":"Your account is locked because of too many authentication attempts.","errors.E0000047":"You exceeded the maximum number of requests. Try again in a while.","errors.E0000079":"The operation is not allowed. Please refresh the page to proceed.","errors.E0000001":"Api validation failed: {0}","errors.E0000002":"The request was not valid: {0}","errors.E0000003":"The request body was not well-formed.","errors.E0000005":"Invalid session","errors.E0000006":"You do not have permission to perform the requested action","errors.E0000007":"Not found: {0}","errors.E0000008":"The requested path was not found","errors.E0000009":"Internal Server Error","errors.E0000010":"Service is in read only mode","errors.E0000011":"Invalid token provided","errors.E0000012":"Unsupported media type","errors.E0000013":"Invalid client app id","errors.E0000015":"You do not have permission to access the feature you are requesting","errors.E0000016":"Activation failed because the user is already active","errors.E0000017":"Password reset failed","errors.E0000018":"Bad request.  Accept and/or Content-Type headers are likely not set.","errors.E0000019":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000020":"Bad request.","errors.E0000021":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000022":"The endpoint does not support the provided HTTP method","errors.E0000023":"Operation failed because user profile is mastered under another system","errors.E0000024":"Bad request.  This operation on app metadata is not yet supported.","errors.E0000025":"App version assignment failed.","errors.E0000026":"This endpoint has been deprecated.","errors.E0000027":"Group push bad request : {0}","errors.E0000028":"The request is missing a required parameter.","errors.E0000029":"Invalid paging request.","errors.E0000030":"Bad request. Invalid date. Dates must be of the form yyyy-MM-dd\'\'T\'\'HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.","errors.E0000031":"Invalid search criteria.","errors.E0000032":"Unlock is not allowed for this user.","errors.E0000033":"Bad request. Can\'t specify a search query and filter in the same request.","errors.E0000034":"Forgot password not allowed on specified user.","errors.E0000035":"Change password not allowed on specified user.","errors.E0000036":"Change recovery question not allowed on specified user.","errors.E0000037":"Type mismatch exception.","errors.E0000038":"This operation is not allowed in the user\'\'s current status.","errors.E0000039":"Operation on application settings failed.","errors.E0000040":"Application label must not be the same as an existing application label.","errors.E0000041":"Credentials should not be set on this resource based on the scheme.","errors.E0000042":"Setting the error page redirect URL failed.","errors.E0000043":"Self service application assignment is not enabled.","errors.E0000044":"Self service application assignment is not supported.","errors.E0000045":"Field mapping bad request.","errors.E0000046":"Deactivate application for user forbidden.","errors.E0000048":"Entity not found exception.","errors.E0000049":"Invalid SCIM data from SCIM implementation.","errors.E0000050":"Invalid SCIM data from client.","errors.E0000051":"No response from SCIM implementation.","errors.E0000052":"Endpoint not implemented.","errors.E0000053":"Invalid SCIM filter.","errors.E0000054":"Invalid pagination properties.","errors.E0000055":"Duplicate group.","errors.E0000056":"Delete application forbidden.","errors.E0000057":"Access to this application is denied due to a policy.","errors.E0000058":"Access to this application requires MFA: {0}","errors.E0000059":"The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.","errors.E0000060":"Unsupported operation.","errors.E0000061":"Tab error: {0}","errors.E0000062":"The specified user is already assigned to the application.","errors.E0000063":"Invalid combination of parameters specified.","errors.E0000064":"Password is expired and must be changed.","errors.E0000065":"Internal error processing app metadata.","errors.E0000066":"APNS is not configured, contact your admin","errors.E0000067":"Factors Service Error.","errors.E0000070":"Waiting for ACK","errors.E0000071":"Unsupported OS Version: {0}","errors.E0000072":"MIM policy settings have disallowed enrollment for this user","errors.E0000073":"User rejected authentication","errors.E0000074":"Factor Service Error","errors.E0000075":"Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.","errors.E0000076":"Cannot modify the app user because it is mastered by an external app.","errors.E0000077":"Cannot modify the {0} attribute because it is read-only.","errors.E0000078":"Cannot modify the {0} attribute because it is immutable.","errors.E0000081":"Cannot modify the {0} attribute because it is a reserved attribute for this application.","errors.E0000082":"Each code can only be used once. Please wait for a new code and try again.","errors.E0000083":"PassCode is valid but exceeded time window.","errors.E0000084":"App evaluation error.","errors.E0000085":"You do not have permission to access your account at this time.","errors.E0000086":"This policy cannot be activated at this time.","errors.E0000087":"The recovery question answer did not match our records.","errors.E0000090":"The role specified is already assigned to the user.","errors.E0000091":"The provided role type was not the same as required role type.","errors.E0000092":"Access to this application requires re-authentication: {0}","errors.E0000093":"Target count limit exceeded","errors.E0000094":"The provided filter is unsupported.","errors.E0000095":"Recovery not allowed for unknown user.","errors.E0000096":"This certificate has already been uploaded with kid={0}.","errors.E0000097":"There is no verified phone number on file.","errors.E0000098":"This phone number is invalid.","errors.E0000099":"Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.","errors.E0000100":"Unable to perform search query.","errors.E0000101":"Upload failed because of a problem with your ipa file, {0}","errors.E0000102":"YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again","errors.E0000103":"Action on device already in queue or in progress","errors.E0000104":"Device is already locked and cannot be locked again","errors.E0000105":"You have accessed an account recovery link that has expired or been previously used.","errors.E0000106":"Wait for token to change, then enter the new tokencode.","errors.E0000107":"The entity is not in the expected state for the requested transition.","errors.E0000109":"An SMS message was recently sent. Please wait 30 seconds before trying again.","errors.E0000110":"You have accessed a link that has expired or has been previously used.","errors.E0000111":"Cannot modify the {0} object because it is read-only.","errors.E0000112":"Cannot update this user because they are still being activated. Please try again in a few minutes.","errors.E0000113":"{0}.","errors.E0000114":"A user with this login already exists in the current organization.","errors.E0000115":"Upload failed, {0}","errors.E0000116":"{0}","errors.E0000119":"Your account is locked. Please contact your administrator.","errors.E0000124":"Could not create user. To create a user and expire their password immediately, a password must be specified","errors.E0000125":"Could not create user. To create a user and expire their password immediately, \\"activate\\" must be true","errors.E0000133":"A phone call was recently made. Please wait 30 seconds before trying again.","errors.E0000207":"The username and/or the password you entered is incorrect. Please try again.","oform.next":"Next","oform.verify":"Verify","oform.send":"Send","oform.back":"Back","oform.title.authenticate":"Authenticate","oform.save":"Save","oform.cancel":"Cancel","oform.edit":"Edit","oform.previous":"Previous","oform.error.icon.ariaLabel":"Error","oform.errorbanner.title":"We found some errors. Please review the form and make corrections.","oform.errormsg.title":"Please review the form to correct the following errors:","oform.error.unexpected":"There was an unexpected internal error. Please try again.","oform.error.webfinger":"Unable to determine user identification method. Please contact your administrator for assistance.","oform.selectInput.country":"{0} selected","model.validation.field.blank":"This field cannot be left blank","model.validation.field.wrong.type":"This field is of the wrong type","model.validation.field.invalid":"This field has an invalid value","model.validation.field.value.not.allowed":"This field value is not allowed","model.validation.field.array.minItems":"This array does not have enough items","model.validation.field.array.maxItems":"This array contains too many items","model.validation.field.array.unique":"This array can only have unique values","model.validation.field.string.minLength":"This field cannot be less than the minimum required characters","model.validation.field.string.maxLength":"This field cannot exceed the maximum allowed characters","model.validation.field.invalid.format.email":"This value is not a valid email address","model.validation.field.invalid.format.uri":"This value is not a valid URI","model.validation.field.invalid.format.ipv4":"This value is not a valid IPv4 address","model.validation.field.invalid.format.hostname":"This value is not a valid hostname","model.validation.field.username":"Please check your username","schema.validation.field.value.must.string":"Value must be a string","schema.validation.field.value.must.number":"Value must be a number","schema.validation.field.value.must.integer":"Value must be an integer","schema.validation.field.value.must.object":"Value must be an object","universal-directory.profiles.attribute.source.oktamastered":"Inherit from Okta","universal-directory.profiles.attribute.source.override":"Override profile source","universal-directory.profiles.attribute.form.union.disable.display":"Combine values across groups","universal-directory.profiles.attribute.source.inherit":"Inherit from profile source","universal-directory.profiles.attribute.enduser.permission.readonly":"Read Only","universal-directory.profiles.attribute.enduser.permission.hide":"Hide","universal-directory.profiles.attribute.enduser.permission.readwrite":"Read-Write","universal-directory.profiles.attribute.form.union.enable.display":"Use Group Priority","factor.totpSoft.oktaVerify":"Okta Verify","factor.totpSoft.googleAuthenticator":"Google Authenticator","factor.totpSoft.description":"Enter single-use code from the mobile app.","factor.totpHard.rsaSecurId":"RSA SecurID","factor.totpHard.symantecVip":"Symantec VIP","factor.totpHard.description":"Enter a single-use code from a hardware token.","factor.totpHard.yubikey":"YubiKey","factor.totpHard.yubikey.description":"Insert your YubiKey and tap it to get a verification code.","factor.totpHard.yubikey.placeholder":"Click here, then tap your YubiKey","factor.oktaVerifyPush":"Okta Verify","factor.push.description":"Use a push notification sent to the mobile app.","factor.duo":"Duo Security","factor.duo.description":"Use Push Notification, SMS, or Voice call to authenticate.","factor.sms":"SMS Authentication","factor.sms.description":"Enter a single-use code sent to your mobile phone.","factor.sms.time.warning":"Haven\'t received an SMS? To try again, click <$1>Re-send code</$1>.","factor.call":"Voice Call Authentication","factor.call.description":"Use a phone to authenticate by following voice instructions.","factor.call.time.warning":"Haven\'t received a voice call? To try again, click <$1>Redial</$1>.","factor.securityQuestion":"Security Question","factor.securityQuestion.description":"Use the answer to a security question to authenticate.","factor.windowsHello":"Windows Hello","factor.windowsHello.signin.description":"Sign in to Okta using Windows Hello.","factor.windowsHello.signin.description.generic":"Sign in using Windows Hello.","factor.windowsHello.signin.description.specific":"Sign in to {0} using Windows Hello.","factor.u2f":"Security Key (U2F)","factor.u2f.description":"Use a Universal 2nd Factor (U2F) security key to sign on to Okta.","factor.u2f.description.generic":"Use a Universal 2nd Factor (U2F) security key to sign in.","factor.u2f.description.specific":"Use a Universal 2nd Factor (U2F) security key to sign in to {0}.","factor.email":"Email Authentication","factor.email.description":"Enter a verification code sent to your email.","factor.password":"Password","factor.customFactor.description":"Redirect to a third party MFA provider to sign in to Okta.","factor.customFactor.description.generic":"Redirect to a third party MFA provider to sign in.","factor.customFactor.description.specific":"Redirect to a third party MFA provider to sign in to {0}.","factor.webauthn.biometric":"Security Key or Biometric Authenticator","factor.webauthn.biometric.description":"Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)","factor.hotp.description":"Enter a single-use code from an authenticator.","mfa.challenge.verify":"Verify","mfa.challenge.answer.placeholder":"Answer","mfa.challenge.answer.tooltip":"Answer","mfa.challenge.answer.showAnswer":"Show","mfa.challenge.answer.hideAnswer":"Hide","mfa.challenge.enterCode.placeholder":"Enter Code","mfa.challenge.enterCode.tooltip":"Enter Code","mfa.challenge.password.placeholder":"Password","mfa.backToFactors":"Back to factor list","mfa.enroll":"Enroll","mfa.setupOptions":"Setup Options","mfa.country":"Country/region","mfa.phoneNumber.placeholder":"Phone number","mfa.phoneNumber.ext.placeholder":"Extension","mfa.sendCode":"Send code","mfa.sent":"Sent","mfa.resendCode":"Re-send code","mfa.call":"Call","mfa.calling":"Calling","mfa.redial":"Redial","mfa.sendEmail":"Send email","mfa.resendEmail":"Re-send email","mfa.scanBarcode":"Scan QR code","mfa.altQrCode":"QR code. If you can\'t scan, click on the link below to select an alternative activation method","mfa.noAccessToEmail":"Can\'t access email","password.reset":"Reset Password","password.oldPassword.placeholder":"Old password","password.oldPassword.tooltip":"Old password","password.newPassword.placeholder":"New password","password.newPassword.tooltip":"New password","password.confirmPassword.placeholder":"Repeat password","password.confirmPassword.tooltip":"Repeat password","password.error.match":"New passwords must match","password.enroll.error.match":"Passwords must match","recovery.sms.hint":"SMS can only be used if a mobile phone number has been configured.","recovery.mobile.hint":"{0} can only be used if a mobile phone number has been configured.","recovery.sms":"SMS","recovery.call":"Voice Call","recovery.smsOrCall":"SMS or Voice Call","verify.choices.description":"Verify with one of the following factors.","email.button.send":"Send me the code","email.button.resend":"Send again","email.code.label":"Verification code","email.code.not.received":"Haven\'t received an email?","email.enroll.title":"Set up Email Authentication","email.enroll.description":"Send a verification code to your registered email.","email.enroll.enterCode":"Enter code","email.link.terminal.msg":"To finish signing in, return to the screen where you requested the email link.","email.mfa.title":"Verify with Email Authentication","email.mfa.description":"Send a verification code to {0}.","email.mfa.email.sent.description":"A verification code was sent to {0}. Check your email and enter the code below.","email.mfa.email.sent.description.sentText":"A verification code was sent to","email.mfa.email.sent.description.emailCodeText":"Check your email and enter the code below.","email.unregistered_email.error":"Enter the email where you received the Welcome instructions from your administrator.","enroll.choices.title":"Set up multifactor authentication","enroll.choices.description":"Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account","enroll.choices.description.generic":"Your company requires multifactor authentication to add an additional layer of security when signing in to your account","enroll.choices.description.specific":"Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account","enroll.choices.description.gracePeriod.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.","enroll.choices.description.gracePeriod.oneDay.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.","enroll.choices.optional":"You can configure any additional optional factor or click finish","enroll.choices.list.setup":"Setup required","enroll.choices.list.enrolled":"Enrolled factors","enroll.choices.list.optional":"Additional optional factors","enroll.choices.setup":"Setup","enroll.choices.setup.another":"Set up another","enroll.choices.submit.finish":"Finish","enroll.choices.submit.configure":"Configure factor","enroll.choices.submit.next":"Configure next factor","enroll.choices.cardinality.setup":"({0} set up)","enroll.choices.cardinality.setup.remaining":"({0} of {1} set up)","enroll.choices.setup.skip":"Skip set up","enroll.securityQuestion.setup":"Setup secret question authentication","security.disliked_food":"What is the food you least liked as a child?","security.name_of_first_plush_toy":"What is the name of your first stuffed animal?","security.first_award":"What did you earn your first medal or award for?","security.favorite_security_question":"What is your favorite security question?","security.favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","security.first_computer_game":"What was the first computer game you played?","security.favorite_movie_quote":"What is your favorite movie quote?","security.first_sports_team_mascot":"What was the mascot of the first sports team you played on?","security.first_music_purchase":"What music album or song did you first purchase?","security.favorite_art_piece":"What is your favorite piece of art?","security.grandmother_favorite_desert":"What was your grandmother\'s favorite dessert?","security.first_thing_cooked":"What was the first thing you learned to cook?","security.childhood_dream_job":"What was your dream job as a child?","security.first_kiss_location":"Where did you have your first kiss?","security.place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","security.favorite_vacation_location":"Where did you go for your favorite vacation?","security.new_years_two_thousand":"Where were you on New Year\'s Eve in the year 2000?","security.favorite_speaker_actor":"Who is your favorite speaker/orator?","security.favorite_book_movie_character":"Who is your favorite book/movie character?","security.favorite_sports_player":"Who is your favorite sports player?","enroll.password.setup":"Select a password","save.password":"Save password","enroll.sms.setup":"Receive a code via SMS to authenticate","enroll.sms.try_again":"The number you entered seems invalid. If the number is correct, please try again.","enroll.call.setup":"Follow phone call instructions to authenticate","enroll.onprem.username.placeholder":"Enter {0} username","enroll.onprem.username.tooltip":"Enter {0} username","enroll.onprem.passcode.placeholder":"Enter {0} passcode","enroll.onprem.passcode.tooltip":"Enter {0} passcode","enroll.symantecVip.subtitle":"Enter Credential ID and two consecutive generated codes","enroll.symantecVip.credentialId.placeholder":"Enter credential ID","enroll.symantecVip.credentialId.tooltip":"Enter credential ID","enroll.symantecVip.passcode1.placeholder":"Security code 1","enroll.symantecVip.passcode1.tooltip":"Security code 1","enroll.symantecVip.passcode2.placeholder":"Security code 2","enroll.symantecVip.passcode2.tooltip":"Security code 2","enroll.yubikey.title":"Setup YubiKey","enroll.yubikey.subtitle":"Insert your YubiKey into a USB port and tap it to generate a verification code","enroll.totp.title":"Setup {0}","enroll.totp.selectDevice":"Select your device type","enroll.totp.downloadApp":"Download <a href=\\"{0}\\" class=\\"inline-link\\">{1} from the {2}</a> onto your mobile device.","enroll.hotp.restricted":"Contact your administrator to continue enrollment.","enroll.duo.title":"Setup Duo Security","enroll.windowsHello.title":"Enroll Windows Hello","enroll.windowsHello.subtitle":"Click below to enroll Windows Hello as a second form of authentication","enroll.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","enroll.windowsHello.save":"Enroll Windows Hello","enroll.windowsHello.error.notWindows":"Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.","enroll.windowsHello.error.notConfiguredHtml":"Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.","verify.windowsHello.subtitle":"Verify your identity with Windows Hello","verify.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","verify.windowsHello.subtitle.signingIn":"Signing in to Okta...","verify.windowsHello.subtitle.signingIn.generic":"Signing in...","verify.windowsHello.subtitle.signingIn.specific":"Signing in to {0}...","verify.windowsHello.save":"Verify with Windows Hello","verify.windowsHello.error.notFound":"Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.","verify.windowsHello.error.notFound.selectAnother":"Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.","enroll.u2f.title":"Setup Security Key (U2F)","enroll.u2f.save":"Register Security Key","enroll.u2f.general2":"Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer\'s Bluetooth.","enroll.u2f.general3":"Click the button below to register","enroll.u2f.instructions":"Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.","enroll.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, press the button.","u2f.error.factorNotSupported":"Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.","u2f.error.factorNotSupported.oneFactor":"Security Key (U2F) is not supported on this browser. Contact your admin for assistance.","u2f.error.other":"An unknown error has occured. Try again or select another factor.","u2f.error.other.oneFactor":"An unknown error has occured. Try again or contact your admin for assistance.","u2f.error.badRequest":"There was an error with the U2F request. Try again or select another factor.","u2f.error.badRequest.oneFactor":"There was an error with the U2F request. Try again or contact your admin for assistance.","u2f.error.unsupported":"The security key is unsupported. Select another factor.","u2f.error.unsupported.oneFactor":"The security key is unsupported. Contact your admin for assistance.","u2f.error.timeout":"You have timed out of the authentication period. Please try again.","verify.u2f.instructions":"Insert your Security Key. If it has a button or gold disk, tap it.","verify.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, turn on your computer\'s Bluetooth and press the button.","verify.u2f.retry":"Retry","enroll.customFactor.subtitle":"Clicking below will redirect to MFA enrollment with {0}","enroll.customFactor.save":"Enroll","verify.customFactor.subtitle":"Clicking below will redirect to verification with {0}","verify.customFactor.subtitle.redirect":"Redirecting to {0}...","enroll.webauthn.biometric.title":"Set up security key or biometric authenticator","enroll.webauthn.save":"Enroll","enroll.webauthn.biometric.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","enroll.webauthn.biometric.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'<b>Cancel</b>\' in the prompt before continuing.","verify.webauthn.biometric.instructions":"Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.","webauthn.biometric.error.factorNotSupported":"Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.","webauthn.biometric.error.factorNotSupported.oneFactor":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","enroll.webauthn.instructions.noSupportForBiometric":"Note: Some browsers may not support biometric authenticators.","authfactor.webauthn.error":"You are currently unable to use a Security key or biometric authenticator. Try again.","passkeys.authfactor.webauthn.error":"You are currently unable to use a passkey. Try again.","enroll.totp.enterCode":"Enter code displayed from the application","enroll.totp.setupApp":"Launch {0} on your mobile device and select “Add an account”. Scan the QR code to continue.","enroll.totp.setupGoogleAuthApp":"Launch {0}, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","enroll.totp.cannotScan":"Can\'t scan?","enroll.totp.aria.cannotScan":"Setup without scanning a QR code.","enroll.totp.refreshBarcode":"Refresh code","enroll.totp.cannotScanBarcode":"Can\'t scan QR code?","enroll.totp.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.generic":"To set up manually enter your Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.specific":"To set up manually enter your {0} Account username and then input the following in the Secret Key Field","enroll.totp.sharedSecretInstructions":"Enter your Okta Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.generic":"Enter your Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.specific":"Enter your {0} Account username and enter the following in the Secret Key Field","enroll.totp.sendSms":"Send activation link via SMS","enroll.totp.sendEmail":"Send activation link via email","enroll.totp.setupManually":"Setup manually without push notification","enroll.totp.sharedSecretInstructions.aria.secretKey":"setup key {0}","enroll.totp.enrollViaEmail.title":"Activation email sent!","enroll.totp.enrollViaEmail.msg":"Open the email from your mobile device.","enroll.totp.enrollViaSms.title":"SMS sent!","enroll.totp.enrollViaSms.msg":"View the SMS on your mobile device.","recoveryChallenge.sms.title":"Enter verification code sent via SMS","recoveryChallenge.call.title":"Enter verification code received via Voice Call","mfa.factors.dropdown.title":"Select an authentication factor","mfa.factors.dropdown.sr.text":"Select Authentication Factor - {0} Factor Selected","mfa.duoSecurity.push":"Push — {0}","mfa.duoSecurity.sms":"SMS — {0}","mfa.duoSecurity.call":"Call — {0}","mfa.switch":"Switch Factor","mfa.challenge.title":"Enter your {0} passcode","mfa.challenge.orEnterCode":"Or enter code","mfa.challenge.totp.subtitle.multiple":"Enter code from any registered {0} device.","mfa.emailVerification.checkEmail":"To finish signing in, click the link in your email.","mfa.emailVerification.title":"Sign in using a link sent to your email.","mfa.emailVerification.subtitle":"Emails will be sent to {0}","mfa.emailVerification.otc.finish":"To finish signing in, enter the code which was emailed to you.","oktaverify.send":"Send Push","oktaverify.resend":"Re-send Push","oktaverify.sent":"Push sent!","oktaverify.rejected":"You have chosen to reject this login.","oktaverify.rejected.upgradeRequired.ios":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.","oktaverify.rejected.upgradeRequired.android":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.","oktaverify.timeout":"Your push notification has expired.","oktaverify.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify App on your phone.","oktaverify.numberchallenge.instruction":"On your phone, tap <span class=\\"challenge-number\\">{0}</span> on Okta Verify prompt to continue.","oktaverify.numberchallenge.explain":"This extra step helps us make sure it\'s really you signing in.","primaryauth.title":"Sign In","primaryauth.username.placeholder":"Username","primaryauth.username.tooltip":"Username","primaryauth.password.placeholder":"Password","primaryauth.password.tooltip":"Password","primaryauth.submit":"Sign In","primaryauth.newUser.tooltip":"This is the first time you are connecting to {0} from this browser","primaryauth.newUser.tooltip.close":"Close","oktaVerify.description":"To access this resource, your organization requires you to sign in with Okta FastPass.","oktaVerify.appDescription":"To access {0}, your organization requires you to sign in with Okta FastPass.","oktaVerify.button":"Sign in with Okta FastPass","signinWithWebAuthn.button":"Sign in with security key or biometrics","idpDiscovery.email.placeholder":"Email","password.forgot.email.or.username.placeholder":"Email or Username","password.forgot.email.or.username.tooltip":"Email or Username","password.forgot.sendText":"Reset via SMS","password.forgot.sendEmail":"Reset via Email","password.forgot.call":"Reset via Voice Call","password.forgot.emailSent.title":"Email sent!","password.forgot.emailSent.desc":"Email has been sent to {0} with instructions on resetting your password.","password.forgot.question.title":"Answer Forgotten Password Challenge","password.forgot.question.submit":"Reset Password","password.forgot.code.notReceived":"Didn\'t receive a code? Reset via email","password.forgot.noFactorsEnabled":"No password reset options available. Please contact your administrator.","password.reset.title":"Reset your Okta password","password.reset.title.generic":"Reset your password","password.reset.title.specific":"Reset your {0} password","password.complexity.requirements":"Password requirements: {0}.","password.complexity.history":"Your password cannot be any of your last {0} password(s).","password.complexity.minAgeMinutes":"At least {0} minute(s) must have elapsed since you last changed your password.","password.complexity.minAgeHours":"At least {0} hour(s) must have elapsed since you last changed your password.","password.complexity.minAgeDays":"At least {0} day(s) must have elapsed since you last changed your password.","password.reset.verification":"Verify with one of the following factors to reset your password.","password.reset.revokeSessions":"Sign me out of all other devices.","password.complexity.length":"at least {0} characters","password.complexity.list.element":", {0}","password.complexity.lowercase":"a lowercase letter","password.complexity.uppercase":"an uppercase letter","password.complexity.number":"a number","password.complexity.symbol":"a symbol","password.complexity.no_username":"no parts of your username","password.complexity.no_first_name":"does not include your first name","password.complexity.no_last_name":"does not include your last name","password.complexity.adRequirements":"at least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.maxConsecutiveRepeatingCharacters":"maximum {0} consecutive repeating characters","password.complexity.requirements.header":"Password requirements:","password.complexity.length.description":"At least {0} characters","password.complexity.lowercase.description":"A lowercase letter","password.complexity.uppercase.description":"An uppercase letter","password.complexity.number.description":"A number","password.complexity.symbol.description":"A symbol","password.complexity.no_username.description":"No parts of your username","password.complexity.no_first_name.description":"Does not include your first name","password.complexity.no_last_name.description":"Does not include your last name","password.complexity.history.one.description":"Password can\'t be the same as your last password","password.complexity.adRequirements.description":"At least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.maxConsecutiveRepeatingCharacters.description":"Maximum {0} consecutive repeating characters","password.complexity.history.description":"Password can\'t be the same as your last {0} passwords","password.complexity.minAgeMinutes.description":"At least {0} minute(s) must have elapsed since you last changed your password","password.complexity.minAgeHours.description":"At least {0} hour(s) must have elapsed since you last changed your password","password.complexity.minAgeDays.description":"At least {0} day(s) must have elapsed since you last changed your password","password.expired.submit":"Change Password","password.expired.title":"Your Okta password has expired","password.expired.title.generic":"Your password has expired","password.expired.title.specific":"Your {0} password has expired","password.expiring.later":"Remind me later","password.expiring.title":"Your password will expire in {0} days","password.expiring.today":"Your password will expire later today","password.expiring.soon":"Your password is expiring soon","password.expiring.subtitle":"When password expires you may be locked out of Okta Mobile, mobile email, and other services.","password.expiring.subtitle.generic":"When password expires you will be locked out of your account.","password.expiring.subtitle.specific":"When password expires you will be locked out of your {0} account.","password.expired.custom.submit":"Go to {0}","password.expired.custom.subtitle":"This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.generic":"When password expires you will be locked out of your account. This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.specific":"When password expires you will be locked out of your {0} account. This password is set on another website. Click the button below to go there and set a new password.","hcaptcha.footer.label":"This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.","altcha.error.label":"Verification failed. Try again later.","altcha.expired.label":"Verification expired. Try again.","altcha.label.label":"I\'m not a robot","altcha.loading.label":"Loading...","altcha.reload.label":"Reload","altcha.verify.label":"Verify","altcha.verificationRequired.label":"Verification required!","altcha.verified.label":"Verified","altcha.verifying.label":"Verifying...","altcha.waitAlert.label":"Verifying... please wait.","account.unlock.title":"Unlock account","account.unlock.email.or.username.placeholder":"Email or username","account.unlock.email.or.username.tooltip":"Email or username","account.unlock.sendText":"Send SMS","account.unlock.voiceCall":"Voice Call","account.unlock.sendEmail":"Send Email","account.unlock.emailSent.title":"Email sent!","account.unlock.emailSent.desc":"Email has been sent to {0} with instructions on unlocking your account.","account.unlock.question.title":"Answer Unlock Account Challenge","account.unlock.question.submit":"Unlock Account","account.unlock.unlocked.title":"Account successfully unlocked!","account.unlock.unlocked.desc":"You can log in using your existing username and password.","account.unlock.code.notReceived":"Didn\'t receive a code? Unlock via email","account.unlock.noFactorsEnabled":"No unlock options available. Please contact your administrator.","account.unlock.authenticatorRequired.single":"To unlock your account, select the following authenticator.","account.unlock.authenticatorRequired.multiple":"To unlock your account, select one of the following authenticators.","contact.support":"If you didn\'t provide a secondary email address or don\'t have access to email, please contact your administrator at {0}","customauth.sign.in.with.label":"Sign in with {0}","socialauth.divider.text":"OR","socialauth.facebook.label":"Sign in with Facebook","socialauth.google.label":"Sign in with Google","socialauth.linkedin.label":"Sign in with LinkedIn","socialauth.microsoft.label":"Sign in with Microsoft","socialauth.apple.label":"Sign in with Apple","socialauth.github.label":"Sign in with GitHub","socialauth.gitlab.label":"Sign in with GitLab","socialauth.yahoo.label":"Sign in with Yahoo","socialauth.line.label":"Sign in with LINE","socialauth.paypal.label":"Sign in with PayPal","socialauth.paypal_sandbox.label":"Sign in with PayPal Sandbox","socialauth.salesforce.label":"Sign in with Salesforce","socialauth.amazon.label":"Sign in with Amazon","socialauth.yahoojp.label":"Sign in with Yahoo Japan","socialauth.discord.label":"Sign in with Discord","socialauth.adobe.label":"Sign in with Adobe","socialauth.orcid.label":"Sign in with ORCiD","socialauth.spotify.label":"Sign in with Spotify","socialauth.xero.label":"Sign in with Xero","socialauth.quickbooks.label":"Sign in with Quickbooks","socialauth.popup.title":"External Identity Provider User Authentication","idps.search.label":"Search for sign in","idps.search.no.results":"No results found","idps.search.typeahead.placeholder":"Type to search","idps.search.results.count":"{0} results found","authbutton.divider.text":"or","registration.signup.label":"Don\'t have an account?","registration.signup.text":"Sign up","registration.complete.title":"Verification email sent","registration.complete.confirm.text":"To finish signing in, check your email.","registration.form.title":"Create Account","registration.form.submit":"Register","registration.passwordComplexity.minLength":"At least {0} character(s)","registration.passwordComplexity.minLower":"At least {0} lowercase letter(s)","registration.passwordComplexity.minUpper":"At least {0} uppercase letter(s)","registration.passwordComplexity.minNumber":"At least {0} number(s)","registration.passwordComplexity.minSymbol":"At least {0} symbol(s)","registration.passwordComplexity.excludeUsername":"Does not contain part of username","registration.passwordComplexity.excludeAttribute":"Does not contain \'{0}\'","registration.required.fields.label":"* indicates required field","registration.default.callbackhook.error":"We could not process your registration at this time. Please try again later.","registration.error.userName.invalidEmail":"Invalid email address","registration.error.password.passwordRequirementsNotMet":"Password requirements were not met","registration.error.password.passwordRequirementsNotMet.prefix":"Password requirements were not met:","registration.error.userName.notUniqueWithinOrg":"An account with that {0} already exists","registration.error.notUniqueWithinOrg.Email":"A user with this Email already exists","registration.error.notUniqueWithinOrg.custom":"A user with this {0} already exists","registration.error.invalidLoginEmail.Email":"\'Email\' must be in the form of an email address","registration.error.invalidLoginEmail.custom":"\'{0}\' must be in the form of an email address","registration.error.doesNotMatchPattern.Email":"Provided value for property \'Email\' does not match required pattern","registration.error.doesNotMatchPattern.custom":"Provided value for property \'{0}\' does not match required pattern","registration.error.generic":"There was an error creating your account. Please try registering again.","registration.error.request.not.completed":"Your request could not be completed. Try again later.","registration.model.validation.field.string.too.short":"Please enter something at least {0} characters long","registration.model.validation.field.string.too.long":"Please enter something shorter than {0} characters","piv.card":"PIV Card","piv.card.insert":"Please insert your PIV card and select the user certificate.","piv.card.error":"Certificate authentication failed. Contact your admin.","piv.card.error.empty":"No certificate selected. Choose a certificate and try again.","piv.card.error.invalid":"Certificate validation failed. Choose another certificate and try again.","piv.cac.card":"Sign in with PIV / CAC card","piv.cac.title":"PIV / CAC card","piv.cac.card.insert":"Please insert your PIV / CAC card and select the user certificate.","piv.cac.error":"There was an error signing in. Click the button below to try again.","unsupported.oneDrive.title":"Your OneDrive version is not supported","unsupported.oneDrive.desc":"Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta","unsupported.oneDrive.action":"Learn how to upgrade","unsupported.cookies.title":"Cookies are required","unsupported.cookies.desc":"Cookies are disabled on your browser. Please enable Cookies and refresh this page.","unsupported.cookies.action":"Refresh","deviceTrust.sso.text":"Sign in to access company resources","deviceTrust.sso.subtitle.2":"Your company uses Okta Mobile to get you approved to access this app.","deviceTrust.sso.button":"Sign in with Okta Mobile","deviceTrust.sso.expire.title":"Oops let\'s get you back on track","deviceTrust.sso.redirectText":"Verifying your identity","deviceTrust.sso.expire.subtitle":"Unfortunately the steps required to sign in took longer than expected and your attempt timed out.","deviceTrust.sso.expire.button":"Sign in using Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.title":"Get Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.subtitle":"Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.","core.auth.factor.signedNonce.error.invalidDevice":"Your device or account was invalidated. If this is unexpected, contact your administrator for help.","core.auth.factor.signedNonce.error":"Your device or account was invalidated. Re-enroll your account on Okta Verify and try again.","user.fail.verifyIdentity":"Couldn’t verify your identity","loopback.polling.cancel.link":"Cancel and take me to sign in","loopback.polling.cancel.link.with.form.error":"Take me to sign in","customUri.subtitle":"Launching Okta Verify...","customUri.content":"<div class=\\"skinny-content\\"> If nothing prompts from the browser, <a href=\\"#\\" id=\\"launch-ov\\" class=\\"link\\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>","customUri.title":"Click \\"Open Okta Verify\\" on the browser prompt","customUri.required.content.prompt":"Didn’t get a prompt?","customUri.required.content.download.title":"Don’t have Okta Verify?","customUri.required.content.download.linkText":"Download here","customUri.required.content.button":"Launch Okta Verify","universalLink.title":"Sign in with Okta FastPass","universalLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","appLink.title":"Sign in with Okta FastPass","appLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","oktaVerify.open.button":"Open Okta Verify","oktaVerify.reopen.button":"Reopen Okta Verify","consent.required.text":"<b>{0}</b> would like to access:","consent.required.description":"By clicking Allow Access, you allow the actions listed above.","consent.required.termsOfService":"Terms of Service","consent.required.privacyPolicy":"Privacy Policy","consent.required.consentButton":"Allow Access","consent.required.cancelButton":"Don\'t Allow","granular.consent.scopes.title":"<$1>{0}</$1> <$2>wants to access your account</$2>","granular.consent.scopes.description":"Allowing access will share","admin.consent.group.user.group":"User and groups","admin.consent.group.resource.policy":"Resource and policies","admin.consent.group.hook":"Hooks","admin.consent.group.system":"System","polling.title":"There are too many users trying to sign in right now. We will automatically retry in {0} seconds.","poll.form.title":"Unable to complete your request","poll.form.message":"We will automatically retry in <$1>{0}</$1> seconds.","cert.authentication.title":"Certificate authentication","common.logo.alt":"aria logo","oie.authenticator.enroll.error.fail":"Unable to enroll authenticator. Try again.","oie.authenticator.verify.error.fail":"Unable to verify authenticator. Try again.","oie.configuration.error":"Something went wrong. Potential misconfiguration detected. Please contact support.","oie.auth.logo.aria.label":"Authenticator logo","oie.challenge.answer.showAnswer":"Show answer","oie.challenge.answer.hideAnswer":"Hide answer","oie.form.field.optional":"Optional","oie.form.field.optional.description":"Fields are required unless marked optional.","oie.password.label":"Password","oie.password.newPasswordLabel":"New password","oie.password.authenticator.description":"Choose a password for your account","oie.password.challenge.title":"Verify with your password","oie.password.enroll.title":"Set up password","oie.password.passwordLabel":"Enter password","oie.password.confirmPasswordLabel":"Re-enter password","oie.password.showPassword":"Show password","oie.password.showConfirmPassword":"Show re-entered password","oie.password.hidePassword":"Hide password","oie.password.hideConfirmPassword":"Hide re-entered password","oie.password.reset.verification":"Verify with one of the following security methods to reset your password.","idx.password.expiring.message":"When your password expires, you will have to change your password before you can login to your {0} account.","oie.password.incorrect.message":"Password is incorrect","oie.selfservice.reset.password.not.allowed":"Reset password is not allowed at this time. Please contact support for assistance.","password.common":"This password was found in a list of commonly used passwords. Please try another password.","idx.recovery.completed":"You can now sign in with your existing username and new password.","oie.phone.label":"Phone","oie.phone.authenticator.description":"Verify with a code sent to your phone","oie.phone.enroll.sms.label":"SMS","oie.phone.enroll.voice.label":"Voice call","oie.phone.enroll.title":"Set up phone authentication","oie.phone.enroll.call.subtitle":"Enter your phone number to receive a verification code via voice call.","oie.phone.enroll.sms.subtitle":"Enter your phone number to receive a verification code via SMS.","oie.phone.sms.primaryButton":"Receive a code via SMS","oie.phone.sms.secondaryButton":"Receive an SMS instead","oie.phone.call.primaryButton":"Receive a code via voice call","oie.phone.call.secondaryButton":"Receive a voice call instead","oie.phone.verify.sms.resendText":"Haven\'t received an SMS?","oie.phone.verify.sms.codeSentText":"A code was sent to","oie.phone.verify.sms.sendText":"Send a code via SMS to","oie.phone.verify.call.sendText":"Send a code via voice call to","oie.phone.verify.call.resendText":"Haven\'t received a call?","oie.phone.verify.call.resendLinkText":"Call again","oie.phone.verify.sms.resendLinkText":"Send again","oie.phone.verify.enterCodeText":"Enter the code below to verify.","oie.phone.verify.title":"Verify with your phone","oie.phone.alternate.title":"your phone","oie.phone.carrier.charges":"Carrier messaging charges may apply","oie.phone.invalid":"Invalid Phone Number.","oie.phone.verify.sms.sendText.with.phone.with.nickname":"Send a code via SMS to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.call.sendText.with.phone.with.nickname":"Send a code via voice call to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.sms.sendText.with.phone.without.nickname":"Send a code via SMS to <$1>{0}</$1>.","oie.phone.verify.call.sendText.with.phone.without.nickname":"Send a code via voice call to <$1>{0}</$1>.","oie.phone.verify.sms.sendText.without.phone":"Send a code via SMS to your phone.","oie.phone.verify.call.sendText.without.phone":"Send a code via voice call to your phone.","oie.phone.verify.sms.codeSentText.with.phone.with.nickname":"A code was sent to <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.with.nickname":"Calling <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.with.phone.without.nickname":"A code was sent to <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.without.nickname":"Calling <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.without.phone":"A code was sent to your phone. Enter the code below to verify.","oie.phone.verify.mfa.calling.without.phone":"Calling your phone. Enter the code below to verify.","oie.email.label":"Email","oie.email.authenticator.description":"Verify with a link or code sent to your email","oie.email.mfa.title":"Verify with your email","oie.email.challenge.mfa.title":"Get a verification email","oie.email.verify.primaryButton":"Send me an email","oie.email.verify.subtitle.text.with.email":"Send a verification email to <$1>{0}</$1> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.with.email.and.secondary.email":"Send a verification email to <$1>{0}</$1> and <$2>{1}</$2> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.without.email":"Send a verification email by clicking on \\"Send me an email\\".","oie.email.verify.alternate.magicLinkToEmailAddress":"We sent an email to <$1>{0}</$1>. ","oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email":"We sent an email to <$1>{0}</$1> and <$2>{1}</$2>. ","oie.email.verify.alternate.magicLinkToYourEmail":"We sent you a verification email. ","oie.email.verify.alternate.instructions":"Click the verification link in your email to continue or enter the code below.","oie.email.verify.alternate.show.verificationCode.text":"Enter a verification code instead","oie.email.verify.alternate.verificationCode.instructions":"Enter the verification code in the text box.","oie.email.enroll.subtitle":"Please check your email and enter the code below.","oie.email.return.link.expired.title":"Verify with your email","oie.profile.additional.title":"Additional Profile information","oie.profile.additional.secondemail.subtitle":"Use a second email to <$1> recover your account </$1> in case you become locked out. This email must be verified after setup.","signinWithPasskeys.button":"Sign in with a passkey","signin.passkeys.error":"Could not sign in with a passkey. Try again, or sign in another way to add a passkey to your account.","signin.passkeys.error.NotSupportedError":"This browser doesn\'t support passkeys. Use a supported browser or sign in another way.","signin.passkeys.error.SecurityError":"The relying party ID is not a registrable domain suffix of, nor equal to the current domain. Subsequently, an attempt to fetch the .well-known/webauthn resource of the claimed RP ID failed.","oie.webauthn.label":"Security Key or Biometric Authenticator","oie.webauthn.passkeysRebrand.passkeys.label":"Passkeys","oie.webauthn.description":"Use a security key or a biometric authenticator to sign in","oie.webauthn.passkeysRebrand.passkeys.description":"Use a passkey to sign in with biometrics or a security key.","oie.enroll.webauthn.title":"Set up security key or biometric authenticator","oie.enroll.webauthn.passkeysRebrand.passkeys.title":"Set up a passkey","oie.enroll.webauthn.passkeysRebrand.custom.title":"Set up {0}","oie.enroll.webauthn.instructions":"You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.","oie.enroll.webauthn.passkeysRebrand.instructions":"You will be prompted to register a passkey. Follow the instructions to complete set up.","oie.enroll.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to setup this authenticator.","oie.enroll.webauthn.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'Cancel\' in the prompt before continuing.","oie.enroll.webauthn.save":"Set up","oie.webauthn.error.not.supported":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","oie.webauthn.passkeysRebrand.error.not.supported":"Passkeys are not supported on this browser. Contact your admin for assistance.","oie.webauthn.error.invalidPasskey":"Invalid passkey.","oie.verify.webauth.title":"Verify with Security Key or Biometric Authenticator","oie.verify.webauth.passkeysRebrand.passkeys.title":"Verify with a passkey","oie.verify.webauth.passkeysRebrand.custom.title":"Verify with {0}","oie.verify.webauthn.instructions":"You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.","oie.verify.webauthn.passkeysRebrand.instructions":"You will be prompted to use a passkey. Follow the instructions to complete verification.","oie.verify.webauthn.instructions.additional":"Additional instructions from your administrator:","oie.verify.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to sign in with this authenticator.","oie.verify.webauthn.cant.verify":"Can\'t verify?","oie.verify.webauthn.cant.verify.biometric.authenticator.title":"Are you trying to use a biometric authenticator?","oie.verify.webauthn.cant.verify.biometric.authenticator.description1":"Biometric authenticators (fingerprint, face recognition, PIN) will only work on the same device on which they were set up.","oie.verify.webauthn.cant.verify.biometric.authenticator.description2":"If available, set up another security method on the device you used to set up your biometric authenticator.","oie.verify.webauthn.cant.verify.security.key.title":"Are you trying to use a security key?","oie.verify.webauthn.cant.verify.security.key.description":"If you have set up a security key, insert it in a USB port when prompted by the browser and tap on the button or gold disk. Security keys can work on multiple devices.","oie.verify.webauthn.cant.verify.enrollment.step1":"Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your security key or biometric authenticator","oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1":"Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your passkey","oie.verify.webauthn.cant.verify.enrollment.step2":"Go to Settings > Security Methods","oie.verify.webauthn.cant.verify.enrollment.step3":"On Okta Verify, click \\"Set up\\"","oie.verify.webauthn.cant.verify.enrollment.step4":"Scan the QR code using Okta Verify and follow instructions to finish enrolling your account","oie.enroll.webauthn.rk.link":"If you haven\'t set up your security key or biometric authentication, you can complete the process after you sign in using <a href=\\"#\\" class=\\"setup-webauthn-residentkey-link\\">this link</a>.","oie.select.authenticator.verify.email.label":"Select Email.","oie.select.authenticator.verify.email.with.email.label":"Select Email - {0}.","oie.select.authenticator.verify.password.label":"Select Password.","oie.select.authenticator.verify.phone.label":"Select Phone.","oie.select.authenticator.verify.phone.with.phone.label":"Select Phone - {0}.","oie.select.authenticator.verify.webauthn.label":"Select Security Key or Biometric Authenticator.","oie.select.authenticator.verify.webauthn.passkeysRebrand.passkeys.label":"Select a passkey.","oie.select.authenticator.verify.webauthn.passkeysRebrand.custom.label":"Select {0}.","oie.select.authenticator.verify.security.question.label":"Select Security Question.","oie.select.authenticator.okta_verify.totp.label":"Select to enter a code from the Okta Verify app.","oie.select.authenticator.okta_verify.push.label":"Select to get a push notification to the Okta Verify app.","oie.select.authenticator.okta_verify.signed_nonce.label":"Select Okta Verify.","oie.select.authenticator.verify.okta_verify.label":"Select Okta Verify.","oie.select.authenticator.verify.named.authenticator.label":"Select {0}.","oie.select.authenticator.enroll.email.label":"Set up Email.","oie.select.authenticator.enroll.password.label":"Set up Password.","oie.select.authenticator.enroll.phone.label":"Set up Phone.","oie.select.authenticator.enroll.webauthn.label":"Set up Security Key or Biometric Authenticator.","oie.select.authenticator.enroll.webauthn.passkeysRebrand.passkeys.label":"Set up a passkey.","oie.select.authenticator.enroll.webauthn.passkeysRebrand.custom.label":"Set up {0}.","oie.select.authenticator.enroll.security.question.label":"Set up Security Question.","oie.select.authenticator.enroll.okta_verify.authenticator.label":"Set up Okta Verify.","oie.select.authenticator.enroll.named.authenticator.label":"Set up {0}.","oie.security.question.label":"Security Question","oie.security.question.enroll.title":"Set up security question","oie.security.question.challenge.title":"Verify with your Security Question","oie.security.question.questionKey.label":"Choose a security question","oie.security.question.createQuestion.label":"Create my own security question","oie.security.question.authenticator.description":"Choose a security question and answer that will be used for signing in","securityQuestion.answer.tooShort.arg":"The security question answer must be at least {0} characters in length","oie.okta_verify.label":"Okta Verify","oie.enroll.okta_verify.setup.subtitle":"To continue, you\'ll need an Okta Verify account on this device.","oie.enroll.okta_verify.setup.download":"If you don\'t have Okta Verify installed, <$1>download the app</$1>.","oie.enroll.okta_verify.setup.openOv":"Open Okta Verify and follow the steps to add your account.","oie.enroll.okta_verify.setup.signInUrl":"When prompted, choose Sign In, then enter the sign-in URL:","oie.enroll.okta_verify.setup.instructions":"Follow the instructions to set up Okta Verify on this device, then return here and refresh this page.","oie.okta_verify.authenticator.description":"Okta Verify is an authenticator app, installed on your phone or computer, used to prove your identity","oie.enroll.okta_verify.setup.title":"Set up Okta Verify","oie.enroll.okta_verify.setup.email.title":"Check your email","oie.enroll.okta_verify.setup.sms.title":"Check your text messages","oie.enroll.okta_verify.setup.skipAuth.subtitle":"To set up Okta Verify on additional devices, you can copy an existing Okta Verify account onto a new device.","oie.enroll.okta_verify.setup.skipAuth.openOv":"Open Okta Verify on any of your other Okta Verify devices (<$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs":"Open Okta Verify on any of your other Okta Verify devices (Such as your <$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.selectAccount":"In the app, select your account.","oie.enroll.okta_verify.setup.skipAuth.addAccount":"Choose <$1>Add Account to Another Device.</$1>","oie.enroll.okta_verify.setup.skipAuth.followInstruction":"Follow the rest of the instructions shown in Okta Verify.","oie.enroll.okta_verify.setup.skipAuth.canBeClosed":"This screen can be closed at any time.","oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue":"To continue, make sure you have the Okta Verify app.","oie.enroll.okta_verify.setup.customUri.setup":"Once Okta Verify is installed, return to this page and tap <$1>Set up Okta Verify</$1>.","oie.enroll.okta_verify.setup.customUri.prompt":"Click <$1>\\"Open Okta Verify\\"</$1> on the browser prompt to set up Okta Verify.","oie.enroll.okta_verify.setup.customUri.noPrompt":"<$1>Didn\'t see the prompt?</$1>","oie.enroll.okta_verify.setup.customUri.makeSureHaveOV":"Make sure you have Okta Verify installed.","oie.enroll.okta_verify.setup.customUri.orMobile":"Or <$1>set up Okta Verify on another mobile device</$1>","oie.enroll.okta_verify.setup.customUri.orOnMobile":"Or <$1>set up Okta Verify on a mobile device</$1>","oie.enroll.okta_verify.select.channel.description":"Which option do you want to try?","oie.enroll.okta_verify.select.channel.qrcode.label":"Scan a QR code","oie.enroll.okta_verify.select.channel.subtitle":"How would you like to set up Okta Verify?","oie.enroll.okta_verify.select.channel.email.label":"Email me a setup link","oie.enroll.okta_verify.select.channel.sms.label":"Text me a setup link","oie.enroll.okta_verify.select.channel.ovOnThisDevice":"Or <$1>set up Okta Verify on this device</$1>","oie.enroll.okta_verify.select.channel.title":"More options","oie.enroll.okta_verify.select.channel.title.updated":"Set up Okta Verify on another mobile device","oie.enroll.okta_verify.channel.email.label":"Email","oie.enroll.okta_verify.enroll.channel.email.title":"Set up Okta Verify via email link","oie.enroll.okta_verify.enroll.channel.email.subtitle":"Make sure you can access the email on the receiving device","oie.enroll.okta_verify.enroll.channel.sms.title":"Set up Okta Verify via SMS","oie.enroll.okta_verify.channel.email.description":"Make sure you can access the email on your mobile device.","oie.enroll.okta_verify.channel.sms.description":"Make sure you can access the text on your mobile device.","oie.enroll.okta_verify.channel.sms.description.updated":"Make sure you can access the text on the receiving device","oie.enroll.okta_verify.qrcode.title":"Set up Okta Verify via QR code","oie.enroll.okta_verify.qrcode.step1":"On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).","oie.enroll.okta_verify.qrcode.step1.updated":"On your other device, download the Okta Verify app from the App Store® (iPhone® and iPad®) or on Google Play (Android® devices).","oie.enroll.okta_verify.qrcode.step2":"Open the app and follow the instructions to add your account","oie.enroll.okta_verify.qrcode.step3.updated":"When prompted, tap <$1>Scan a QR code</$1>, then scan the QR code below:","oie.enroll.okta_verify.qrcode.step3":"When prompted, tap Scan a QR code, then scan the QR code below:","oie.enroll.okta_verify.qrcode.cannotScan":"Can\'t scan?","oie.enroll.okta_verify.switch.channel.link.text":"Or <a href=\\"#\\" class=\\"switch-channel-link\\">try a different way</a> to set up Okta Verify.","oie.enroll.okta_verify.email.info":"We sent an email to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.email.info.updated":"We sent an email to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.email.notReceived":"Haven’t received an email? Check your spam folder or <a href=\\"#\\" class=\\"resend-link\\">send again</a>","oie.enroll.okta_verify.sms.info":"We sent an SMS to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.sms.info.updated":"We sent an SMS to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.sms.notReceived":"Haven’t received an SMS? <a href=\\"#\\" class=\\"resend-link\\">Send again</a>","oie.enroll.okta_verify.setupLink":"Send me the setup link","oie.okta_verify.totp.title":"Enter a code","oie.okta_verify.totp.enterCodeText":"Enter code from Okta Verify app","oie.okta_verify.push.title":"Get a push notification","oie.okta_verify.push.sent":"Push notification sent","oie.okta_verify.push.sent.respond_to_continue":"Respond on your mobile device to continue.","oie.okta_verify.push.resend":"Resend push notification","oie.okta_verify.sendPushButton":"Send push","oie.okta_verify.signed_nonce.label":"Use Okta FastPass","oie.okta_verify.enroll.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible":"The device used to set up Okta Verify does not meet your organization’s security requirements because it is not FIPS compliant. Contact your administrator for help.","oie.authenticator.app.non_fips_compliant_enrollment_app_update_required":"The Okta Verify version on the device used does not meet your organization’s security requirements. To add your account, update Okta Verify to the latest version, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.app.method.push.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.app.method.push.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.app.method.push.enroll.enable.biometrics":"Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.","oie.authenticator.app.method.push.enroll.enable.biometrics.title":"Enable biometrics to add an account in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date, biometrics are enabled for your account in Okta Verify and your device\'s biometric sensors are accessible, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title":"Biometrics needed for Okta Verify","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4":"Your device\'s biometric sensors are accessible","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows":"Your response was received, but your organization requires Windows Hello confirmation. Make sure Okta Verify is up-to-date and enable Windows Hello confirmation in Okta Verify, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.title":"Enable Windows Hello confirmation in Okta Verify","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.description":"To meet your organization\'s requirements, try the following, then return here and sign in again:","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point1":"Make sure Okta Verify is up-to-date","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point2":"In Okta Verify, enable Windows Hello confirmation for your account","oie.google_authenticator.label":"Google Authenticator","oie.google_authenticator.authenticator.description":"Enter a temporary code generated from the Google Authenticator app.","oie.enroll.google_authenticator.setup.title":"Set up Google Authenticator","oie.enroll.google_authenticator.scanBarcode.title":"Scan QR code","oie.enroll.google_authenticator.scanBarcode.description":"Launch Google Authenticator, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","oie.enroll.google_authenticator.scanBarcode.cannotScan":"Can\'t scan?","oie.enroll.google_authenticator.cannotScanBarcode.title":"Can\'t scan QR code?","oie.enroll.google_authenticator.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","oie.enroll.google_authenticator.enterCode.title":"Enter code displayed from application","oie.verify.google_authenticator.otp.title":"Verify with Google Authenticator","oie.verify.google_authenticator.otp.description":"Enter the temporary code generated in your Google Authenticator app","oie.google_authenticator.otp.enterCodeText":"Enter code","oie.verify.custom_otp.title":"Verify with {0}","oie.verify.custom_otp.description":"Enter the code generated on your authenticator and verify.","oie.custom_otp.description":"Enter a temporary code generated from an authenticator device.","oie.custom_otp.authenticator.default.vendorName":"Custom OTP Authenticator","oie.custom_otp.verify.passcode.label":"Enter code","oie.verify.custom_app.title":"Verify with {0}","oie.custom_app.push.sent":"Push notification sent","oie.custom_app.push.resend":"Resend push notification","oie.custom_app.push.warning":"Haven\'t received a push notification yet? Try opening {0} on your phone.","oie.authenticator.custom_app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics—like a fingerprint or facial scan—for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.title":"Enable biometrics in {0}","oie.authenticator.custom_app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics—like a fingerprint or facial scan—for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2":"{0} is up-to-date","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3":"In {0}, biometrics are enabled for your account","oie.custom_app.sendPushButton":"Send push","oie.custom_app.push.title":"Get a push notification","oie.on_prem.authenticator.description":"Verify by entering a code generated by {0}.","oie.on_prem.authenticator.default.vendorName":"Custom On-prem Authenticator","oie.on_prem.enroll.title":"Set up {0}","oie.on_prem.verify.title":"Verify with {0}","oie.numberchallenge.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.","oie.numberchallenge.instruction":"On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.","oie.numberchallenge.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.method.push.force.upgrade.number_challenge":"Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.","oie.rsa.authenticator.description":"Verify by entering a code generated by RSA SecurID","oie.duo.authenticator.description":"Verify your identity using Duo Security.","oie.duo.enroll.title":"Set up Duo Security","oie.duo.verify.title":"Verify with Duo Security","oie.duo.iFrameError":"Error loading Duo. Try again or contact your admin for assistance.","oie.authenticator.duo.error":"We were unable to verify with Duo. Try again.","oie.idp.authenticator.description":"Redirect to verify with {0}.","oie.idp.enroll.title":"Set up {0}","oie.idp.enroll.description":"You will be redirected to enroll in {0}","oie.idp.challenge.title":"Verify with {0}","oie.idp.challenge.description":"You will be redirected to verify with {0}","idx.identity.provider.auth.error":"There was a problem signing you into your identity provider. Please contact your administrator for help.","oie.idv.idp.title":"Verify your identity with {0}","oie.idv.idp.desc":"Verify your identity with {0} to continue and share your verification results with Okta. You may need a valid government-issued ID.","oie.idv.idp.desc.termsOfUse":"{0}\'s <$1>Terms of Use</$1> and <$2>Privacy Policy</$2> will apply to {0}\'s verification of your identity. ","oie.idv.idp.desc.agreement":"By clicking \\"Continue\\", I agree that {0} will share my verification results with Okta.","oie.idv.persona":"Persona","oie.idv.clear":"Clear","oie.idv.incode":"Incode","oie.idv.customIDV":"Custom IDV","oie.symantecVip.authenticator.description":"Verify by entering a temporary code from the {0} app.","oie.symantecVip.enroll.title":"Set up {0}","oie.symantecVip.enroll.description":"From the {0} app, enter your credential ID and two consecutive generated codes","oie.symantecVip.challenge.title":"Verify with {0}","oie.symantecVip.challenge.description":"Enter the generated security code from the {0} app.","oie.symantecVip.verify.passcode.label":"Enter security code","oie.yubikey.label":"YubiKey Authenticator","oie.yubikey.authenticator.description":"Verify your identity using YubiKey","oie.yubikey.enroll.title":"Set up YubiKey","oie.yubikey.challenge.title":"Verify with YubiKey","oie.yubikey.description":"Use your YubiKey to insert a verification code.","oie.yubikey.passcode.label":"Insert then tap your YubiKey","oie.custom.app.authenticator.title":"Get a push notification","oie.custom.app.authenticator.description":"{0} is an authenticator app, installed on your phone, used to prove your identity","oie.smartcard.authenticator.description":"Use a physical smart card, such as PIV or CAC, to sign in","oie.tac.label":"Temporary Access Code","oie.verify.tac.title":"Verify with Temporary Access Code","oie.verify.tac.description":"Enter the code provided by your administrator. Contact your administrator if you need a new code.","oie.tac.authenticator.description":"Enter a code provided by your administrator to sign in","oie.select.authenticators.enroll.title":"Set up security methods","oie.select.authenticators.enroll.subtitle":"Security methods help protect your account by ensuring only you have access.","oie.select.authenticators.enroll.subtitle.custom":"Security methods help protect your {0} account by ensuring only you have access.","oie.setup.required":"Set up required","oie.setup.optional":"Set up optional","oie.setup.required.now":"Required now","oie.setup.required.soon":"Required soon","oie.setup.optional.short":"Optional","oie.setup.required.soon.description":"When the deadline passes, you won’t be able to sign in until you complete setup.","oie.setup.remind.me.later":"Remind me later","oie.optional.authenticator.button.title":"Continue","oie.verify.authenticator.button.text":"Select","oie.enroll.authenticator.button.text":"Set up","oie.enroll.authenticator.usage.text.access.recovery":"Used for access or recovery","oie.enroll.authenticator.usage.text.recovery":"Used for recovery","oie.enroll.authenticator.usage.text.access":"Used for access","oie.select.authenticators.verify.title":"Verify it\'s you with a security method","oie.select.authenticators.verify.subtitle":"Select from the following options","oie.success.text.signingIn":"Signing in","oie.success.text.signingIn.with.ellipsis":"Signing in...","oie.success.text.signingIn.with.appName":"Signing in to {0}","oie.success.text.signingIn.with.appName.android.ov.enrollment":"To continue, tap \\"Open Okta Verify\\"","oie.success.text.signingIn.with.appName.and.identifier":"Signing in to {0} as {1}","oie.go.back":"Go back","oie.enroll.switch.authenticator":"Return to authenticator list","oie.enroll.skip.setup":"Skip set up","oie.enroll.skip.profile":"Skip Profile","oie.verification.switch.authenticator":"Verify with something else","oie.remember":"Keep me signed in","oie.try.again":"Try again","enroll.title.oda":"Download Okta Verify","enroll.title.oda.with.account":"Additional setup required to use Okta FastPass","enroll.title.oda.without.account":"Set up an Okta Verify account","enroll.title.mdm":"Additional setup required","enroll.subtitle.fastpass":"On this device, do you already have an Okta Verify account for {0}?","enroll.option.noaccount.fastpass":"No, I don’t have an account","enroll.option.account.fastpass":"Yes, I already have an account","enroll.explanation.p1":"To sign in using Okta Verify, you will need to set up Okta Verify on this device.","enroll.explanation.p2":"In the app, follow the instructions to add an organizational account. When prompted, choose <span class=\\"semi-strong\\">Sign In</span>, then enter the <span class=\\"semi-strong\\">sign-in URL</span>:","enroll.oda.android.step1":"On Google Play, download the Okta Verify app.","enroll.oda.step1":"Open Okta Verify and follow the steps to add your account.","enroll.oda.step2":"When prompted, choose Sign In, then enter the sign-in URL:","enroll.oda.step3":"Download the Okta Verify app.","enroll.oda.step6":"Finish setting up your account in Okta Verify, then try accessing this app again.","enroll.oda.with.account.explanation":"Okta FastPass is a security method that can sign you in without needing your username.","enroll.oda.with.account.subtitile1":"Already have Okta FastPass enabled for your account?","enroll.oda.with.account.subtitile2":"Need to set up Okta FastPass for your account?","enroll.oda.with.account.step1":"Make sure your Okta Verify is up-to-date, then try signing in again.","enroll.oda.with.account.step2":"If your device has a work profile, make sure you are signing in from the same profile that Okta Verify is installed in.","enroll.oda.with.account.step3":"On certain browsers and applications, Okta FastPass is not supported.","enroll.oda.with.account.step4":"On this device, open the Okta Verify app.","enroll.oda.with.account.step5":"On the list of accounts, tap your account for {0}.","enroll.oda.with.account.step6":"Under the “Okta FastPass” section, tap Setup, then follow the instructions.","enroll.oda.with.account.step7":"After your setup is complete, return here to try signing in again.","enroll.oda.without.account.explanation":"To sign in with Okta FastPass, you’ll need to set up Okta Verify on this device.","enroll.oda.without.account.step1":"If you don’t have Okta Verify installed, <a href=\\"{0}\\" target=\\"_blank\\" class=\\"download-ov-link\\" id=\\"download-ov\\">download the app.</a>","enroll.oda.without.account.step4":"Finish setting up your account in Okta Verify, then try signing in again.","enroll.appleStore":"the App Store","enroll.googleStore":"Google Play","enroll.copy.ios":"Apple®, App Store, and the Apple logo are trademarks of Apple Inc.","enroll.copy.android":"Google Play and the Google Play logo are trademarks of Google LLC.","enroll.explanation.mdm":"To access this app, your device needs to meet your organization\'s security requirements. Follow the instructions below to continue.","enroll.oda.org.copyLink":"Copy sign-in URL to clipboard","enroll.oda.org.copyLink.success":"Sign-in URL copied.","enroll.mdm.copyLink":"Copy link to clipboard","enroll.mdm.copyLink.success":"Link copied.","enroll.mdm.step.copyLink":"Tap the Copy Link button below.","enroll.mdm.step.pasteLink":"On this device, open your browser, then paste the copied link into the address bar.","enroll.mdm.step.followInstructions":"Follow the instructions in your browser to set up <$1>{0}</$1>.","enroll.mdm.step.relogin":"Logout and re-login and then try accessing the app again.","oie.safe.mode.title":"Authenticator set up unavailable","idx.error.server.safe.mode.enrollment.unavailable":"Set up is temporarily unavailable due to server maintenance. Try again later.","oie.primaryauth.submit":"Sign in","oie.registration.form.title":"Sign up","oie.registration.form.submit":"Sign Up","oie.registration.form.update.submit":"Submit","oie.registration.form.customize.label":"{0}","oie.registration.form.customize.buttonLabel":"{0}","oie.user.profile.login":"Username","oie.user.profile.lastname":"Last name","oie.user.profile.firstname":"First name","oie.user.profile.primary.email":"Email","oie.user.profile.secondary.email":"Secondary email","oie.user.profile.middleName":"Middle name","oie.user.profile.honorificPrefix":"Honorific prefix","oie.user.profile.honorificSuffix":"Honorific suffix","oie.user.profile.primaryEmail":"Primary email","oie.user.profile.title":"Title","oie.user.profile.displayName":"Display name","oie.user.profile.nickName":"Nickname","oie.user.profile.profileUrl":"Profile URL","oie.user.profile.mobilePhone":"Mobile phone","oie.user.profile.primaryPhone":"Primary phone","oie.user.profile.streetAddress":"Street address","oie.user.profile.city":"City","oie.user.profile.state":"State","oie.user.profile.zipCode":"ZIP Code","oie.user.profile.postalCode":"Postal code","oie.user.profile.countryCode":"Country code","oie.user.profile.postalAddress":"Postal address","oie.user.profile.preferredLanguage":"Preferred language","oie.user.profile.locale":"Locale","oie.user.profile.timezone":"Time zone","oie.user.profile.userType":"User type","oie.user.profile.employeeNumber":"Employee number","oie.user.profile.costCenter":"Cost center","oie.user.profile.organization":"Organization","oie.user.profile.division":"Division","oie.user.profile.department":"Department","oie.user.profile.managerId":"Manager ID","oie.user.profile.manager":"Manager","oie.selfservice.unlock_user.landing.to.app.success.message":"Account successfully unlocked! Verify your account with a security method to continue.","oie.selfservice.unlock_user.landing.to.app.signing.in.message":"Account successfully unlocked!","oie.selfservice.unlock_user.success.message":"You can log in using your existing username and password.","oie.selfservice.unlock_user.failed.message":"We are unable to unlock your account at this time, please contact your administrator","oie.selfservice.user.unlock.not.allowed":"Self Service Unlock is not allowed at this time. Please contact support for assistance.","oie.kmsi.title":"Keep me signed in","oie.kmsi.subtitle":"Sign in and enter security methods less frequently.","oie.kmsi.accept":"Stay signed in","oie.kmsi.reject":"Don\'t stay signed in","idx.session.expired":"You have been logged out due to inactivity. Refresh or return to the sign in screen.","oie.registration.is.not.enabled":"Sign up is not enabled for this organization.","oie.forgot.password.is.not.enabled":"Forgot password is not enabled for this organization.","idx.return.error":"Could not process this email link. Return to the screen where you requested it.","idx.return.stale":"This email link is out of date. Return to the screen where you requested it.","idx.invalid.forgot.password.token":"Your reset password token is no longer valid.","idx.invalid.reset.password.token":"Your reset password token is no longer valid. Contact your administrator to obtain a new token.","idx.reset.password.activating.user":"Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.","core.system.transaction_resource_not_found":"Verification timed out. Please try again","tagsNotAllowed":"The field must not contain HTML tags","api.authn.error.PASSCODE_INVALID":"Invalid code. Try again.","oie.feature.disabled":"The requested feature is not enabled in this environment.","authfactor.challenge.suspended_factor":"This factor is suspended for your account due to too many failed attempts","oie.post.password.update.auth.failure.error":"Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.","oie.assurance.unsatisfiable":"Unable to login to \\"{0}\\" at this time. For assistance, please contact your administrator.","errors.E0000150":"You have reached the limit of sms requests, please try again later.","errors.E0000151":"You have reached the limit of call requests, please try again later.","oie.invalid.recovery.token":"The recovery token is invalid.","oie.consent.scopes.admin.title":"would like to access:","oie.consent.scopes.enduser.title":"would like to:","oie.consent.scopes.granular.title":"<$1>{0}</$1> <$2>wants to access</$2>","oie.consent.scopes.granular.description":"Allowing access will share","oie.consent.enduser.accept.label":"Yes, it\'s me","oie.consent.enduser.deny.label":"No, it\'s not me","oie.consent.enduser.title":"Did you just try to sign in?","oie.consent.enduser.email.allow.title":"Success! Return to the original tab or window","oie.consent.enduser.email.allow.description":"To continue, please return to the original browser tab or window you used to verify.","oie.consent.enduser.deny.description":"Close this window anytime.","oie.return.to.original.tab":"Close this window anytime.","idx.operation.cancelled.by.user":"Operation cancelled by user.","idx.transferred.to.new.tab":"Flow continued in a new tab.","idx.return.link.expired":"This email link has expired. To resend it, return to the screen where you requested it.","idx.return.link.otponly.your.verification.code":"Your verification code","idx.return.link.otponly.enter.code.on.page":"Enter this code on the {0} page.","idx.return.link.otponly.enter.code.on.page.sign.in":"sign-in","idx.return.link.otponly.enter.code.on.page.password.reset":"password reset","idx.return.link.otponly.enter.code.on.page.account.unlock":"account unlock","idx.return.link.otponly.enter.code.on.page.registration":"sign up","idx.return.link.otponly.enter.code.on.sign.in.page":"Enter this code on the sign-in page.","idx.return.link.otponly.enter.code.on.password.reset.page":"Enter this code on the password reset page.","idx.return.link.otponly.enter.code.on.account.unlock.page":"Enter this code on the account unlock page.","idx.return.link.otponly.enter.code.on.sign.up.page":"Enter this code on the sign up page.","idx.return.link.otponly.request":"Request from:","idx.return.link.otponly.warning.text":"If you didn’t request this code, you can ignore this message. Your account is safe and can only be accessed with this code.","idx.enter.otp.in.original.tab":"Enter the OTP in your original authentication location.","idx.return.link.otponly.app":"{0}","idx.return.link.otponly.browser.on.os":"{0} on {1}","geolocation.formatting.all":"{0}, {1}, {2}","geolocation.formatting.partial":"{0}, {1}","consent.scopes.email.label":"View your email address.","consent.scopes.profile.label":"View your profile information.","consent.scopes.phone.label":"View your phone number.","consent.scopes.address.label":"View your address.","consent.scopes.offlineAccess.label":"Keep you signed in to the app.","consent.scopes.onlineAccess.label":"Keep you signed in to the app.","consent.scopes.deviceSSO.label":"Request device secret.","consent.scopes.openid.desc":"Signals that a request is an OpenID request.","consent.scopes.profile.desc":"The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.","consent.scopes.email.desc":"This allows the app to view your email address.","consent.scopes.address.desc":"This allows the app to view your address, such as: street address, city, state, and zip code.","consent.scopes.phone.desc":"This allows the app to view your phone number.","consent.scopes.offlineAccess.desc":"This keeps you signed in to the app, even when you are not using it.","consent.scopes.onlineAccess.desc":"This allows the app to access your data only when you are logged in to the application.","consent.scopes.deviceSSO.desc":"This allows you to single sign on between native client applications on your device.","consent.scopes.okta.users.manage.desc":"Allows the app to create new users and to manage all users\'\' profile and credentials information.","consent.scopes.okta.users.manage.self.desc":"Allows the app to manage the signed-in user\'\'s profile and credentials.","consent.scopes.okta.users.read.desc":"Allows the app to read the existing users\'\' profiles and credentials.","consent.scopes.okta.users.read.self.desc":"Allows the app to read the signed-in user\'\'s profile and credentials.","consent.scopes.okta.linkedObjects.manage.desc":"Allows the app to manage linked object definitions in your Okta organization.","consent.scopes.okta.linkedObjects.read.desc":"Allows the app to read linked object definitions in your Okta organization.","consent.scopes.okta.myAccount.manage.desc":"Allows the end-user to manage their account profile.","consent.scopes.okta.myAccount.read.desc":"Allows the end-user to read their account profile.","consent.scopes.okta.riskEvents.manage.desc":"Allows the app to publish risk events to your Okta organization.","consent.scopes.okta.clients.manage.desc":"Allows the app to manage clients in your Okta organization.","consent.scopes.okta.clients.read.desc":"Allows the app to read information about clients in your Okta organization.","consent.scopes.okta.clients.register.desc":"Allows the app to create new clients in your Okta organization.","consent.scopes.okta.authorizationServers.manage.desc":"Allows the app to create and manage Authorization Servers in your Okta organization.","consent.scopes.okta.authorizationServers.read.desc":"Allows the app to read information about Authorization Servers in your Okta organization.","consent.scopes.okta.groups.manage.desc":"Allows the app to manage existing groups in your Okta organization.","consent.scopes.okta.groups.read.desc":"Allows the app to read information about groups and their members in your Okta organization.","consent.scopes.okta.groups.register.desc":"Allows the app to create new groups in your Okta organization.","consent.scopes.okta.events.read.desc":"Allows the app to read information about deprecated Events v1 API entries in your Okta organization.","consent.scopes.okta.logs.read.desc":"Allows the app to read information about System Log entries in your Okta organization.","consent.scopes.okta.inlineHooks.manage.desc":"Allows the app to create and manage Inline Hooks in your Okta organization.","consent.scopes.okta.inlineHooks.read.desc":"Allows the app to read information about Inline Hooks in your Okta organization.","consent.scopes.okta.eventHooks.manage.desc":"Allows the app to create and manage Event Hooks in your Okta organization.","consent.scopes.okta.eventHooks.read.desc":"Allows the app to read information about Event Hooks in your Okta organization.","consent.scopes.okta.apps.manage.desc":"Allows the app to create and manage Apps in your Okta organization.","consent.scopes.okta.apps.read.desc":"Allows the app to read information about Apps in your Okta organization.","consent.scopes.okta.schemas.manage.desc":"Allows the app to create and manage Schemas in your Okta organization.","consent.scopes.okta.schemas.read.desc":"Allows the app to read information about Schemas in your Okta organization.","consent.scopes.okta.idps.manage.desc":"Allows the app to create and manage Identity Providers in your Okta organization.","consent.scopes.okta.idps.read.desc":"Allows the app to read information about Identity Providers in your Okta organization.","consent.scopes.okta.roles.manage.desc":"Allows the app to manage administrative role assignments for users in your Okta organization.","consent.scopes.okta.roles.read.desc":"Allows the app to read administrative role assignments for users in your Okta organization.","consent.scopes.okta.policies.manage.desc":"Allows the app to manage policies in your Okta organization.","consent.scopes.okta.policies.read.desc":"Allows the app to read information about policies in your Okta organization.","consent.scopes.okta.orgs.manage.desc":"Allows the app to manage organization-specific details for your Okta organization.","consent.scopes.okta.orgs.read.desc":"Allows the app to read organization-specific details about your Okta organization.","consent.scopes.okta.captchas.manage.desc":"Allows the app to create and manage CAPTCHAs in your Okta organization.","consent.scopes.okta.captchas.read.desc":"Allows the app to read information about CAPTCHAs in your Okta organization.","consent.scopes.okta.sessions.manage.desc":"Allows the app to manage all sessions in your Okta organization.","consent.scopes.okta.sessions.read.desc":"Allows the app to read all sessions in your Okta organization.","consent.scopes.okta.trustedOrigins.manage.desc":"Allows the app to manage all Trusted Origins in your Okta organization.","consent.scopes.okta.trustedOrigins.read.desc":"Allows the app to read all Trusted Origins in your Okta organization.","consent.scopes.okta.templates.manage.desc":"Allows the app to manage all custom templates in your Okta organization.","consent.scopes.okta.templates.read.desc":"Allows the app to read all custom templates in your Okta organization.","consent.scopes.okta.factors.manage.desc":"Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).","consent.scopes.okta.factors.read.desc":"Allows the app to read org factors information.","consent.scopes.okta.authenticators.manage.desc":"Allows the app to manage all security methods (e.g. enrollments, reset).","consent.scopes.okta.authenticators.read.desc":"Allows the app to read org security method information.","consent.scopes.okta.authenticators.manage.self.desc":"Allows the app to manage users own security methods (e.g. enrollments, reset).","consent.scopes.idSnapshot.read.desc":"Allows the app to read your identity snapshot attestation.","consent.scopes.idSnapshot.manage.desc":"Allows the app to create and manage your identity snapshot attestation.","logo.for.the.app.alt.text":"Logo for the app","device.code.activate.title":"Activate your device","device.code.activate.subtitle":"Follow the instructions on your device to get an activation code","device.code.activate.label":"Activation Code","device.code.activated.success.title":"Device activated","device.code.activated.error.title":"Device not activated","idx.device.activated":"Follow the instructions on your device for next steps","idx.device.not.activated.consent.denied":"Your device cannot be activated because you did not allow access","idx.device.not.activated.internal.error":"Your device cannot be activated because of an internal error","idx.invalid.device.code":"Invalid code. Try again.","idx.operation.cancelled.on.other.device":"Access denied on other device.","idx.expired.activation.token":"Your account activation link is no longer valid. Request a new activation email below.","idx.missing.activation.token":"This can happen if you have already activated your account, or if the URL you are trying to use is invalid. Contact your administrator for further assistance.","idx.activating.inactive.user":"Your account has been temporarily suspended. Contact your administrator for further assistance.","idx.request.activation.email":"New activation link requested. If your information matches our records, you will receive a new activation link in your inbox soon.","oie.activation.request.email.title.expire":"Activation link has expired","oie.activation.request.email.title.invalid":"Activation link no longer valid","oie.activation.request.email.title.suspended":"Account suspended","oie.activation.request.email.title.submitted":"Request submitted","oie.activation.request.email.button":"Request activation email","oie.browser.error.NotAllowedError":"The operation either timed out or was not allowed.","authfactor.challenge.soft_token.invalid_passcode":"Your code doesn\'t match our records. Please try again.","authfactor.challenge.soft_token.used_passcode":"Each code can only be used once. Please wait for a new code and try again.","oie.tooManyRequests":"Too many attempts. Try again later.","E0000010":"Server is unable to respond at the moment.","idx.error.registration.unavailable":"Registration is currently unavailable.","idx.error.user.not.assigned.to.app":"User is not assigned to this application.","idx.error.code.user_not_assigned":"You are not allowed to access this app. To request access, contact an admin.","idx.error.code.access_denied.device_assurance.remediation.title":"Your device doesn\'t meet the security requirements","idx.error.code.access_denied.device_assurance.remediation.explanation_one_rule":"To sign in, make the following updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.explanation_multiple_rules":"To sign in, pick an option and make the updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.option_index":"Option {0}:","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version":"Update to Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.at_least":"Update to at least Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly":"Update to exactly Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.one_of_the_following":"Update to one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.device_disk_encrypted":"Encrypt your device","idx.error.code.access_denied.device_assurance.remediation.android.use_lock_screen":"Enable lock screen","idx.error.code.access_denied.device_assurance.remediation.android.use_biometric_lock_screen":"Enable lock screen and biometrics","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version":"Update to iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.at_least":"Update to at least iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly":"Update to exactly iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.one_of_the_following":"Update to one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.ios.use_biometric_lock_screen":"Set a passcode for the lock screen and enable Touch ID or Face ID","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version":"Update to macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.at_least":"Update to at least macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly":"Update to exactly macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.one_of_the_following":"Update to one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.macos.device_disk_encrypted":"Turn on FileVault","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version":"Update to Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.at_least":"Update to at least Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly":"Update to exactly Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.one_of_the_following":"Update to one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.device_disk_encrypted":"Encrypt all internal disks with BitLocker","idx.error.code.access_denied.device_assurance.remediation.windows.use_biometric_lock_screen":"Enable Windows Hello for the lock screen","idx.error.code.access_denied.device_assurance.remediation.device.must.be.managed":"Use a device managed by your organization","idx.error.code.access_denied.device_assurance.remediation.additional_help_default":"For more information, follow the instructions on <$1>the help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.additional_help_custom":"For more information, follow the instructions on <$1>your organization\'s help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.chrome.antivirus":"Enable antivirus software","idx.error.code.access_denied.device_assurance.remediation.chrome.disk_encrypted":"Turn on disk encryption","idx.error.code.access_denied.device_assurance.remediation.chrome.os_firewall":"Turn on your device\'s firewall","idx.error.code.access_denied.device_assurance.remediation.chrome.screen_lock_secured":"Turn on automatic screen saver and screen locking when idle","idx.error.code.access_denied.device_assurance.remediation.chrome.upgrade_browser_version":"Update Chrome browser to {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.upgrade_os_version":"Update to ChromeOS {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.verified_mode":"Switch your device to verified mode","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.developer_mode":"Switch your device to developer mode","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_required":"Please ensure Google Play Protect is enabled and that a scan has been performed, then try accessing this application again","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_scan_threshold":"There is a problem with your Google Play Protect system scan. Please open Google Play and take action on the warnings displayed","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.version_update_available":"Your device has an OS update available. Please update your device then log in again","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_usb_debugging":"Turn off USB debugging from Developer Options","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.lock_screen_complexity":"Your lock screen doesn\'t meet complexity requirements","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_network_proxy":"Your device is using a network proxy. Please disable it then try again","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.unsecured_wifi_network":"Your WiFi network isn\'t secure. Please disconnect and try again from your phone\'s mobile cellular connection","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required":"Install the Android Device Policy app on this device","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install":"Go to <$1>Settings in Okta Verify</$1> and follow the instructions to install the Android Device Policy app","idx.device_assurance.grace_period.title":"Device assurance reminder","idx.device_assurance.grace_period.warning.title.due_by_date":"Your device doesn\'t meet the security requirements. Fix the issue by {0} to prevent lockout.","idx.device_assurance.grace_period.continue_to_app":"Continue to app","oie.enrollment.policy.grace.period.required.today":"Required today","oie.enrollment.policy.grace.period.required.in.days":"Required in {0} days","oie.enrollment.policy.grace.period.required.in.one.day":"Required in 1 day","oie.enrollment.policy.grace.period.required.in.number.of.skips":"{0} skips remaining","oie.enrollment.policy.grace.period.required.in.one.skip":"1 skip remaining","api.policy.okta.account.management.insufficient.authenticators.unable.to.sign.in":"Unable to sign in. Contact support for assistance.","chrome.lna.fastpass.requires.permission.title":"Okta FastPass requires network permission","chrome.lna.error.title":"Unable to sign in","chrome.lna.error.description.intro":"The browser is blocking communication with Okta Verify.","chrome.lna.error.description.step1":"Go to your browser\'s site settings","chrome.lna.error.description.step2":"Find “Local network access” or “Apps on device”","chrome.lna.error.description.step3":"Change the permission from “Block” to “Allow” and reload this page","chrome.lna.error.description.more.information":"For more information, follow the instructions on the <$1>Local app access</$1> page or contact your administrator for help."}')},7174:function(e){"use strict";e.exports=JSON.parse('{"defaultLanguage":"en","version":"7.44.1","supportedLanguages":["en","cs","da","de","el","es","eu","fi","fr","ht","hu","id","in","it","ja","ko","ms","nb","nl-NL","ok-PL","ok-SK","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}')}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var i=t[r]={exports:{}};return e[r].call(i.exports,i,i.exports,n),i.exports}return n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,{a:t}),t},n.d=function(e,t){for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n(21576),n(74270),n(92484)}()}));
//# sourceMappingURL=okta-sign-in.min.js.map
//# debugId=ab99c15a-8a52-5c2c-813d-d31ebc5cc76d

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(121), __webpack_require__(554).Buffer, __webpack_require__(647).setImmediate))

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return script; });
/* unused harmony export NavigationGuardMixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__okta_okta_auth_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__okta_okta_auth_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__okta_okta_auth_js__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _oktaAuth;
var _onAuthRequired;
var _router;
var originalUriTracker;
var guardSecureRoute = function (authState) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!authState.isAuthenticated) return [3 /*break*/, 4];
                _oktaAuth.setOriginalUri(originalUriTracker);
                if (!_onAuthRequired) return [3 /*break*/, 2];
                return [4 /*yield*/, _onAuthRequired(_oktaAuth)];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, _oktaAuth.signInWithRedirect()];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
var AuthStateMixin = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            authState: _oktaAuth.authStateManager.getAuthState()
        };
    },
    created: function () {
        // subscribe to the latest authState
        _oktaAuth.authStateManager.subscribe(this.$_oktaVue_handleAuthStateUpdate);
        if (!_oktaAuth.token.isLoginRedirect()) {
            // trigger an initial change event to make sure authState is latest
            _oktaAuth.authStateManager.updateAuthState();
        }
    },
    beforeDestroy: function () {
        _oktaAuth.authStateManager.unsubscribe(this.$_oktaVue_handleAuthStateUpdate);
    },
    // private property naming convention follows
    // https://vuejs.org/v2/style-guide/#Private-property-names-essential
    methods: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        $_oktaVue_handleAuthStateUpdate: function (authState) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.authState = Object.assign(this.authState, authState);
                    return [2 /*return*/];
                });
            });
        }
    }
});
var NavigationGuardMixin = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    beforeCreate: function () {
        // assign router for the default restoreOriginalUri callback
        _router = this.$router;
    },
    // "beforeRouteEnter" does NOT have access to `this` component instance
    beforeRouteEnter: function (to, from, next) {
        return __awaiter(this, void 0, void 0, function () {
            var isAuthenticated, authState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!to.matched.some(function (record) { return record.meta.requiresAuth; })) return [3 /*break*/, 5];
                        // track the originalUri for guardSecureRoute
                        originalUriTracker = to.fullPath;
                        // subscribe to authState change to protect secure routes when authState change
                        // all secure routes should subscribe before enter the route
                        _oktaAuth.authStateManager.subscribe(guardSecureRoute);
                        return [4 /*yield*/, _oktaAuth.isAuthenticated()];
                    case 1:
                        isAuthenticated = _a.sent();
                        if (!!isAuthenticated) return [3 /*break*/, 3];
                        authState = _oktaAuth.authStateManager.getAuthState();
                        return [4 /*yield*/, guardSecureRoute(authState)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        next();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        next();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    beforeRouteLeave: function (to, from, next) {
        _oktaAuth.authStateManager.unsubscribe(guardSecureRoute);
        next();
    }
});
function install(Vue, _a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, oktaAuth = _b.oktaAuth, onAuthRequired = _b.onAuthRequired;
    if (!oktaAuth) {
        throw new __WEBPACK_IMPORTED_MODULE_1__okta_okta_auth_js__["AuthSdkError"]('No oktaAuth instance passed to OktaVue.');
    }
    // customize user agent
    oktaAuth.userAgent = {"name":"@okta/okta-vue","version":"3.1.0"}.name + "/" + {"name":"@okta/okta-vue","version":"3.1.0"}.version + " " + oktaAuth.userAgent;
    // add default restoreOriginalUri callback
    if (!oktaAuth.options.restoreOriginalUri) {
        oktaAuth.options.restoreOriginalUri = function (oktaAuth, originalUri) { return __awaiter(_this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                // If a router is available, provide a default implementation
                if (_router) {
                    path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__okta_okta_auth_js__["toRelativeUrl"])(originalUri, window.location.origin);
                    _router.replace({ path: path });
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        }); };
    }
    _oktaAuth = oktaAuth;
    _onAuthRequired = onAuthRequired;
    Vue.mixin(AuthStateMixin);
    Vue.mixin(NavigationGuardMixin);
    // add oktaAuth instance to Vue
    Vue.prototype.$auth = oktaAuth;
}
var OktaVue = { install: install };

var script = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'LoginCallback',
    beforeMount: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$auth.handleLoginRedirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    render: function () {
        // typescript not allow empty render function, here's the workaround for renderless component
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.$scopedSlots.default && this.$scopedSlots.default({});
    }
});

script.__file = "src/components/LoginCallback.vue";

/* harmony default export */ __webpack_exports__["a"] = (OktaVue);

//# sourceMappingURL=okta-vue.esm.js.map


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var bind = __webpack_require__(284);
var Axios = __webpack_require__(508);
var defaults = __webpack_require__(162);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(281);
axios.CancelToken = __webpack_require__(507);
axios.isCancel = __webpack_require__(282);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(522);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(281);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(162);
var utils = __webpack_require__(35);
var InterceptorManager = __webpack_require__(509);
var dispatchRequest = __webpack_require__(510);
var isAbsoluteURL = __webpack_require__(518);
var combineURLs = __webpack_require__(516);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var transformData = __webpack_require__(513);
var isCancel = __webpack_require__(282);
var defaults = __webpack_require__(162);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(283);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(562), __esModule: true };

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(563), __esModule: true };

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(551);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, Tether) {/*!
 * Bootstrap v4.0.0-alpha.6 (https://getbootstrap.com)
 * Copyright 2011-2017 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.')
}

+function ($) {
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] >= 4)) {
    throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0')
  }
}(jQuery);


+function () {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Util = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var transition = false;

  var MAX_UID = 1000000;

  var TransitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd otransitionend',
    transition: 'transitionend'
  };

  // shoutout AngusCroll (https://goo.gl/pxwQGp)
  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function isElement(obj) {
    return (obj[0] || obj).nodeType;
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: transition.end,
      delegateType: transition.end,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
        return undefined;
      }
    };
  }

  function transitionEndTest() {
    if (window.QUnit) {
      return false;
    }

    var el = document.createElement('bootstrap');

    for (var name in TransitionEndEvent) {
      if (el.style[name] !== undefined) {
        return {
          end: TransitionEndEvent[name]
        };
      }
    }

    return false;
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;

    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });

    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);

    return this;
  }

  function setTransitionEndSupport() {
    transition = transitionEndTest();

    $.fn.emulateTransitionEnd = transitionEndEmulator;

    if (Util.supportsTransitionEnd()) {
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
  }

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Util = {

    TRANSITION_END: 'bsTransitionEnd',

    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));
      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector) {
        selector = element.getAttribute('href') || '';
        selector = /^#[a-z]/i.test(selector) ? selector : null;
      }

      return selector;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(transition.end);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(transition);
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (configTypes.hasOwnProperty(property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
          }
        }
      }
    }
  };

  setTransitionEndSupport();

  return Util;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Alert = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'alert';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.alert';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Selector = {
    DISMISS: '[data-dismiss="alert"]'
  };

  var Event = {
    CLOSE: 'close' + EVENT_KEY,
    CLOSED: 'closed' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    ALERT: 'alert',
    FADE: 'fade',
    SHOW: 'show'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Alert = function () {
    function Alert(element) {
      _classCallCheck(this, Alert);

      this._element = element;
    }

    // getters

    // public

    Alert.prototype.close = function close(element) {
      element = element || this._element;

      var rootElement = this._getRootElement(element);
      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    Alert.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    };

    // private

    Alert.prototype._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = $(selector)[0];
      }

      if (!parent) {
        parent = $(element).closest('.' + ClassName.ALERT)[0];
      }

      return parent;
    };

    Alert.prototype._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $.Event(Event.CLOSE);

      $(element).trigger(closeEvent);
      return closeEvent;
    };

    Alert.prototype._removeElement = function _removeElement(element) {
      var _this2 = this;

      $(element).removeClass(ClassName.SHOW);

      if (!Util.supportsTransitionEnd() || !$(element).hasClass(ClassName.FADE)) {
        this._destroyElement(element);
        return;
      }

      $(element).one(Util.TRANSITION_END, function (event) {
        return _this2._destroyElement(element, event);
      }).emulateTransitionEnd(TRANSITION_DURATION);
    };

    Alert.prototype._destroyElement = function _destroyElement(element) {
      $(element).detach().trigger(Event.CLOSED).remove();
    };

    // static

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);
        var data = $element.data(DATA_KEY);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Alert;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Alert._jQueryInterface;
  $.fn[NAME].Constructor = Alert;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Alert._jQueryInterface;
  };

  return Alert;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Button = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'button';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.button';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var ClassName = {
    ACTIVE: 'active',
    BUTTON: 'btn',
    FOCUS: 'focus'
  };

  var Selector = {
    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
    DATA_TOGGLE: '[data-toggle="buttons"]',
    INPUT: 'input',
    ACTIVE: '.active',
    BUTTON: '.btn'
  };

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUS_BLUR_DATA_API: 'focus' + EVENT_KEY + DATA_API_KEY + ' ' + ('blur' + EVENT_KEY + DATA_API_KEY)
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Button = function () {
    function Button(element) {
      _classCallCheck(this, Button);

      this._element = element;
    }

    // getters

    // public

    Button.prototype.toggle = function toggle() {
      var triggerChangeEvent = true;
      var rootElement = $(this._element).closest(Selector.DATA_TOGGLE)[0];

      if (rootElement) {
        var input = $(this._element).find(Selector.INPUT)[0];

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && $(this._element).hasClass(ClassName.ACTIVE)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = $(rootElement).find(Selector.ACTIVE)[0];

              if (activeElement) {
                $(activeElement).removeClass(ClassName.ACTIVE);
              }
            }
          }

          if (triggerChangeEvent) {
            input.checked = !$(this._element).hasClass(ClassName.ACTIVE);
            $(input).trigger('change');
          }

          input.focus();
        }
      }

      this._element.setAttribute('aria-pressed', !$(this._element).hasClass(ClassName.ACTIVE));

      if (triggerChangeEvent) {
        $(this._element).toggleClass(ClassName.ACTIVE);
      }
    };

    Button.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    };

    // static

    Button._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Button(this);
          $(this).data(DATA_KEY, data);
        }

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Button;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    event.preventDefault();

    var button = event.target;

    if (!$(button).hasClass(ClassName.BUTTON)) {
      button = $(button).closest(Selector.BUTTON);
    }

    Button._jQueryInterface.call($(button), 'toggle');
  }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    var button = $(event.target).closest(Selector.BUTTON)[0];
    $(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Button._jQueryInterface;
  $.fn[NAME].Constructor = Button;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Button._jQueryInterface;
  };

  return Button;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Carousel = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'carousel';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.carousel';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var Default = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true
  };

  var DefaultType = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean'
  };

  var Direction = {
    NEXT: 'next',
    PREV: 'prev',
    LEFT: 'left',
    RIGHT: 'right'
  };

  var Event = {
    SLIDE: 'slide' + EVENT_KEY,
    SLID: 'slid' + EVENT_KEY,
    KEYDOWN: 'keydown' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY,
    LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    CAROUSEL: 'carousel',
    ACTIVE: 'active',
    SLIDE: 'slide',
    RIGHT: 'carousel-item-right',
    LEFT: 'carousel-item-left',
    NEXT: 'carousel-item-next',
    PREV: 'carousel-item-prev',
    ITEM: 'carousel-item'
  };

  var Selector = {
    ACTIVE: '.active',
    ACTIVE_ITEM: '.active.carousel-item',
    ITEM: '.carousel-item',
    NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
    INDICATORS: '.carousel-indicators',
    DATA_SLIDE: '[data-slide], [data-slide-to]',
    DATA_RIDE: '[data-ride="carousel"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Carousel = function () {
    function Carousel(element, config) {
      _classCallCheck(this, Carousel);

      this._items = null;
      this._interval = null;
      this._activeElement = null;

      this._isPaused = false;
      this._isSliding = false;

      this._config = this._getConfig(config);
      this._element = $(element)[0];
      this._indicatorsElement = $(this._element).find(Selector.INDICATORS)[0];

      this._addEventListeners();
    }

    // getters

    // public

    Carousel.prototype.next = function next() {
      if (this._isSliding) {
        throw new Error('Carousel is sliding');
      }
      this._slide(Direction.NEXT);
    };

    Carousel.prototype.nextWhenVisible = function nextWhenVisible() {
      // Don't call next when the page isn't visible
      if (!document.hidden) {
        this.next();
      }
    };

    Carousel.prototype.prev = function prev() {
      if (this._isSliding) {
        throw new Error('Carousel is sliding');
      }
      this._slide(Direction.PREVIOUS);
    };

    Carousel.prototype.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if ($(this._element).find(Selector.NEXT_PREV)[0] && Util.supportsTransitionEnd()) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    Carousel.prototype.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    Carousel.prototype.to = function to(index) {
      var _this3 = this;

      this._activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $(this._element).one(Event.SLID, function () {
          return _this3.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? Direction.NEXT : Direction.PREVIOUS;

      this._slide(direction, this._items[index]);
    };

    Carousel.prototype.dispose = function dispose() {
      $(this._element).off(EVENT_KEY);
      $.removeData(this._element, DATA_KEY);

      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    };

    // private

    Carousel.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Carousel.prototype._addEventListeners = function _addEventListeners() {
      var _this4 = this;

      if (this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN, function (event) {
          return _this4._keydown(event);
        });
      }

      if (this._config.pause === 'hover' && !('ontouchstart' in document.documentElement)) {
        $(this._element).on(Event.MOUSEENTER, function (event) {
          return _this4.pause(event);
        }).on(Event.MOUSELEAVE, function (event) {
          return _this4.cycle(event);
        });
      }
    };

    Carousel.prototype._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;
        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
        default:
          return;
      }
    };

    Carousel.prototype._getItemIndex = function _getItemIndex(element) {
      this._items = $.makeArray($(element).parent().find(Selector.ITEM));
      return this._items.indexOf(element);
    };

    Carousel.prototype._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === Direction.NEXT;
      var isPrevDirection = direction === Direction.PREVIOUS;
      var activeIndex = this._getItemIndex(activeElement);
      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === Direction.PREVIOUS ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;

      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    Carousel.prototype._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var slideEvent = $.Event(Event.SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName
      });

      $(this._element).trigger(slideEvent);

      return slideEvent;
    };

    Carousel.prototype._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        $(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $(nextIndicator).addClass(ClassName.ACTIVE);
        }
      }
    };

    Carousel.prototype._slide = function _slide(direction, element) {
      var _this5 = this;

      var activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var isCycling = Boolean(this._interval);

      var directionalClassName = void 0;
      var orderClassName = void 0;
      var eventDirectionName = void 0;

      if (direction === Direction.NEXT) {
        directionalClassName = ClassName.LEFT;
        orderClassName = ClassName.NEXT;
        eventDirectionName = Direction.LEFT;
      } else {
        directionalClassName = ClassName.RIGHT;
        orderClassName = ClassName.PREV;
        eventDirectionName = Direction.RIGHT;
      }

      if (nextElement && $(nextElement).hasClass(ClassName.ACTIVE)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      var slidEvent = $.Event(Event.SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName
      });

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.SLIDE)) {

        $(nextElement).addClass(orderClassName);

        Util.reflow(nextElement);

        $(activeElement).addClass(directionalClassName);
        $(nextElement).addClass(directionalClassName);

        $(activeElement).one(Util.TRANSITION_END, function () {
          $(nextElement).removeClass(directionalClassName + ' ' + orderClassName).addClass(ClassName.ACTIVE);

          $(activeElement).removeClass(ClassName.ACTIVE + ' ' + orderClassName + ' ' + directionalClassName);

          _this5._isSliding = false;

          setTimeout(function () {
            return $(_this5._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        $(activeElement).removeClass(ClassName.ACTIVE);
        $(nextElement).addClass(ClassName.ACTIVE);

        this._isSliding = false;
        $(this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    };

    // static

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        } else if (_config.interval) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $(selector)[0];

      if (!target || !$(target).hasClass(ClassName.CAROUSEL)) {
        return;
      }

      var config = $.extend({}, $(target).data(), $(this).data());
      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($(target), config);

      if (slideIndex) {
        $(target).data(DATA_KEY).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Carousel;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);

  $(window).on(Event.LOAD_DATA_API, function () {
    $(Selector.DATA_RIDE).each(function () {
      var $carousel = $(this);
      Carousel._jQueryInterface.call($carousel, $carousel.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Carousel._jQueryInterface;
  $.fn[NAME].Constructor = Carousel;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Carousel._jQueryInterface;
  };

  return Carousel;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Collapse = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'collapse';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.collapse';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;

  var Default = {
    toggle: true,
    parent: ''
  };

  var DefaultType = {
    toggle: 'boolean',
    parent: 'string'
  };

  var Event = {
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };

  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };

  var Selector = {
    ACTIVES: '.card > .show, .card > .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Collapse = function () {
    function Collapse(element, config) {
      _classCallCheck(this, Collapse);

      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    }

    // getters

    // public

    Collapse.prototype.toggle = function toggle() {
      if ($(this._element).hasClass(ClassName.SHOW)) {
        this.hide();
      } else {
        this.show();
      }
    };

    Collapse.prototype.show = function show() {
      var _this6 = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if ($(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var actives = void 0;
      var activesData = void 0;

      if (this._parent) {
        actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
        if (!actives.length) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $(actives).data(DATA_KEY);
        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $.Event(Event.SHOW);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($(actives), 'hide');
        if (!activesData) {
          $(actives).data(DATA_KEY, null);
        }
      }

      var dimension = this._getDimension();

      $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);

      this._element.style[dimension] = 0;
      this._element.setAttribute('aria-expanded', true);

      if (this._triggerArray.length) {
        $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $(_this6._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);

        _this6._element.style[dimension] = '';

        _this6.setTransitioning(false);

        $(_this6._element).trigger(Event.SHOWN);
      };

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = 'scroll' + capitalizedDimension;

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);

      this._element.style[dimension] = this._element[scrollSize] + 'px';
    };

    Collapse.prototype.hide = function hide() {
      var _this7 = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if (!$(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var startEvent = $.Event(Event.HIDE);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();
      var offsetDimension = dimension === Dimension.WIDTH ? 'offsetWidth' : 'offsetHeight';

      this._element.style[dimension] = this._element[offsetDimension] + 'px';

      Util.reflow(this._element);

      $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

      this._element.setAttribute('aria-expanded', false);

      if (this._triggerArray.length) {
        $(this._triggerArray).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this7.setTransitioning(false);
        $(_this7._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
      };

      this._element.style[dimension] = '';

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
    };

    Collapse.prototype.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    Collapse.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    };

    // private

    Collapse.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      config.toggle = Boolean(config.toggle); // coerce string values
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Collapse.prototype._getDimension = function _getDimension() {
      var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
    };

    Collapse.prototype._getParent = function _getParent() {
      var _this8 = this;

      var parent = $(this._config.parent)[0];
      var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';

      $(parent).find(selector).each(function (i, element) {
        _this8._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });

      return parent;
    };

    Collapse.prototype._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      if (element) {
        var isOpen = $(element).hasClass(ClassName.SHOW);
        element.setAttribute('aria-expanded', isOpen);

        if (triggerArray.length) {
          $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
        }
      }
    };

    // static

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? $(selector)[0] : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);
        var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data && _config.toggle && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Collapse;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();

    var target = Collapse._getTargetFromElement(this);
    var data = $(target).data(DATA_KEY);
    var config = data ? 'toggle' : $(this).data();

    Collapse._jQueryInterface.call($(target), config);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Dropdown = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'dropdown';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.dropdown';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUSIN_DATA_API: 'focusin' + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    BACKDROP: 'dropdown-backdrop',
    DISABLED: 'disabled',
    SHOW: 'show'
  };

  var Selector = {
    BACKDROP: '.dropdown-backdrop',
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    ROLE_MENU: '[role="menu"]',
    ROLE_LISTBOX: '[role="listbox"]',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, ' + '[role="listbox"] li:not(.disabled) a'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Dropdown = function () {
    function Dropdown(element) {
      _classCallCheck(this, Dropdown);

      this._element = element;

      this._addEventListeners();
    }

    // getters

    // public

    Dropdown.prototype.toggle = function toggle() {
      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return false;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      Dropdown._clearMenus();

      if (isActive) {
        return false;
      }

      if ('ontouchstart' in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {

        // if mobile we use a backdrop because click events don't delegate
        var dropdown = document.createElement('div');
        dropdown.className = ClassName.BACKDROP;
        $(dropdown).insertBefore(this);
        $(dropdown).on('click', Dropdown._clearMenus);
      }

      var relatedTarget = {
        relatedTarget: this
      };
      var showEvent = $.Event(Event.SHOW, relatedTarget);

      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return false;
      }

      this.focus();
      this.setAttribute('aria-expanded', true);

      $(parent).toggleClass(ClassName.SHOW);
      $(parent).trigger($.Event(Event.SHOWN, relatedTarget));

      return false;
    };

    Dropdown.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._element).off(EVENT_KEY);
      this._element = null;
    };

    // private

    Dropdown.prototype._addEventListeners = function _addEventListeners() {
      $(this._element).on(Event.CLICK, this.toggle);
    };

    // static

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Dropdown(this);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config].call(this);
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
        return;
      }

      var backdrop = $(Selector.BACKDROP)[0];
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }

      var toggles = $.makeArray($(Selector.DATA_TOGGLE));

      for (var i = 0; i < toggles.length; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (!$(parent).hasClass(ClassName.SHOW)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'focusin') && $.contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $.Event(Event.HIDE, relatedTarget);
        $(parent).trigger(hideEvent);
        if (hideEvent.isDefaultPrevented()) {
          continue;
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent = void 0;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = $(selector)[0];
      }

      return parent || element.parentNode;
    };

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {

        if (event.which === ESCAPE_KEYCODE) {
          var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
          $(toggle).trigger('focus');
        }

        $(this).trigger('click');
        return;
      }

      var items = $(parent).find(Selector.VISIBLE_ITEMS).get();

      if (!items.length) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Dropdown;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.FOCUSIN_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
    e.stopPropagation();
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Dropdown._jQueryInterface;
  $.fn[NAME].Constructor = Dropdown;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Dropdown._jQueryInterface;
  };

  return Dropdown;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Modal = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'modal';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.modal';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 300;
  var BACKDROP_TRANSITION_DURATION = 150;
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };

  var DefaultType = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    RESIZE: 'resize' + EVENT_KEY,
    CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
    KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
    MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
    MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Modal = function () {
    function Modal(element, config) {
      _classCallCheck(this, Modal);

      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = $(element).find(Selector.DIALOG)[0];
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._originalBodyPadding = 0;
      this._scrollbarWidth = 0;
    }

    // getters

    // public

    Modal.prototype.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    Modal.prototype.show = function show(relatedTarget) {
      var _this9 = this;

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
      }
      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: relatedTarget
      });

      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();
      this._setScrollbar();

      $(document.body).addClass(ClassName.OPEN);

      this._setEscapeEvent();
      this._setResizeEvent();

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
        return _this9.hide(event);
      });

      $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
        $(_this9._element).one(Event.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this9._element)) {
            _this9._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this9._showElement(relatedTarget);
      });
    };

    Modal.prototype.hide = function hide(event) {
      var _this10 = this;

      if (event) {
        event.preventDefault();
      }

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
      if (transition) {
        this._isTransitioning = true;
      }

      var hideEvent = $.Event(Event.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;

      this._setEscapeEvent();
      this._setResizeEvent();

      $(document).off(Event.FOCUSIN);

      $(this._element).removeClass(ClassName.SHOW);

      $(this._element).off(Event.CLICK_DISMISS);
      $(this._dialog).off(Event.MOUSEDOWN_DISMISS);

      if (transition) {
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this10._hideModal(event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        this._hideModal();
      }
    };

    Modal.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      $(window, document, this._element, this._backdrop).off(EVENT_KEY);

      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._originalBodyPadding = null;
      this._scrollbarWidth = null;
    };

    // private

    Modal.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Modal.prototype._showElement = function _showElement(relatedTarget) {
      var _this11 = this;

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // don't move modals dom position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';
      this._element.removeAttribute('aria-hidden');
      this._element.scrollTop = 0;

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this11._config.focus) {
          _this11._element.focus();
        }
        _this11._isTransitioning = false;
        $(_this11._element).trigger(shownEvent);
      };

      if (transition) {
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        transitionComplete();
      }
    };

    Modal.prototype._enforceFocus = function _enforceFocus() {
      var _this12 = this;

      $(document).off(Event.FOCUSIN) // guard against infinite focus loop
      .on(Event.FOCUSIN, function (event) {
        if (document !== event.target && _this12._element !== event.target && !$(_this12._element).has(event.target).length) {
          _this12._element.focus();
        }
      });
    };

    Modal.prototype._setEscapeEvent = function _setEscapeEvent() {
      var _this13 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE) {
            _this13.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event.KEYDOWN_DISMISS);
      }
    };

    Modal.prototype._setResizeEvent = function _setResizeEvent() {
      var _this14 = this;

      if (this._isShown) {
        $(window).on(Event.RESIZE, function (event) {
          return _this14._handleUpdate(event);
        });
      } else {
        $(window).off(Event.RESIZE);
      }
    };

    Modal.prototype._hideModal = function _hideModal() {
      var _this15 = this;

      this._element.style.display = 'none';
      this._element.setAttribute('aria-hidden', 'true');
      this._isTransitioning = false;
      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName.OPEN);
        _this15._resetAdjustments();
        _this15._resetScrollbar();
        $(_this15._element).trigger(Event.HIDDEN);
      });
    };

    Modal.prototype._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    Modal.prototype._showBackdrop = function _showBackdrop(callback) {
      var _this16 = this;

      var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

      if (this._isShown && this._config.backdrop) {
        var doAnimate = Util.supportsTransitionEnd() && animate;

        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName.BACKDROP;

        if (animate) {
          $(this._backdrop).addClass(animate);
        }

        $(this._backdrop).appendTo(document.body);

        $(this._element).on(Event.CLICK_DISMISS, function (event) {
          if (_this16._ignoreBackdropClick) {
            _this16._ignoreBackdropClick = false;
            return;
          }
          if (event.target !== event.currentTarget) {
            return;
          }
          if (_this16._config.backdrop === 'static') {
            _this16._element.focus();
          } else {
            _this16.hide();
          }
        });

        if (doAnimate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName.SHOW);

        if (!callback) {
          return;
        }

        if (!doAnimate) {
          callback();
          return;
        }

        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName.SHOW);

        var callbackRemove = function callbackRemove() {
          _this16._removeBackdrop();
          if (callback) {
            callback();
          }
        };

        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    };

    // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------

    Modal.prototype._handleUpdate = function _handleUpdate() {
      this._adjustDialog();
    };

    Modal.prototype._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + 'px';
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    Modal.prototype._checkScrollbar = function _checkScrollbar() {
      this._isBodyOverflowing = document.body.clientWidth < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    Modal.prototype._setScrollbar = function _setScrollbar() {
      var bodyPadding = parseInt($(Selector.FIXED_CONTENT).css('padding-right') || 0, 10);

      this._originalBodyPadding = document.body.style.paddingRight || '';

      if (this._isBodyOverflowing) {
        document.body.style.paddingRight = bodyPadding + this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetScrollbar = function _resetScrollbar() {
      document.body.style.paddingRight = this._originalBodyPadding;
    };

    Modal.prototype._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    };

    // static

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Modal.Default, $(this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Modal;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var _this17 = this;

    var target = void 0;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = $(selector)[0];
    }

    var config = $(target).data(DATA_KEY) ? 'toggle' : $.extend({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event.HIDDEN, function () {
        if ($(_this17).is(':visible')) {
          _this17.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Modal._jQueryInterface;
  $.fn[NAME].Constructor = Modal;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Modal._jQueryInterface;
  };

  return Modal;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var ScrollSpy = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'scrollspy';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.scrollspy';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Default = {
    offset: 10,
    method: 'auto',
    target: ''
  };

  var DefaultType = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };

  var Event = {
    ACTIVATE: 'activate' + EVENT_KEY,
    SCROLL: 'scroll' + EVENT_KEY,
    LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    DROPDOWN_ITEM: 'dropdown-item',
    DROPDOWN_MENU: 'dropdown-menu',
    NAV_LINK: 'nav-link',
    NAV: 'nav',
    ACTIVE: 'active'
  };

  var Selector = {
    DATA_SPY: '[data-spy="scroll"]',
    ACTIVE: '.active',
    LIST_ITEM: '.list-item',
    LI: 'li',
    LI_DROPDOWN: 'li.dropdown',
    NAV_LINKS: '.nav-link',
    DROPDOWN: '.dropdown',
    DROPDOWN_ITEMS: '.dropdown-item',
    DROPDOWN_TOGGLE: '.dropdown-toggle'
  };

  var OffsetMethod = {
    OFFSET: 'offset',
    POSITION: 'position'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var ScrollSpy = function () {
    function ScrollSpy(element, config) {
      var _this18 = this;

      _classCallCheck(this, ScrollSpy);

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + ' ' + Selector.NAV_LINKS + ',' + (this._config.target + ' ' + Selector.DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;

      $(this._scrollElement).on(Event.SCROLL, function (event) {
        return _this18._process(event);
      });

      this.refresh();
      this._process();
    }

    // getters

    // public

    ScrollSpy.prototype.refresh = function refresh() {
      var _this19 = this;

      var autoMethod = this._scrollElement !== this._scrollElement.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;

      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;

      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;

      this._offsets = [];
      this._targets = [];

      this._scrollHeight = this._getScrollHeight();

      var targets = $.makeArray($(this._selector));

      targets.map(function (element) {
        var target = void 0;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = $(targetSelector)[0];
        }

        if (target && (target.offsetWidth || target.offsetHeight)) {
          // todo (fat): remove sketch reliance on jQuery position/offset
          return [$(target)[offsetMethod]().top + offsetBase, targetSelector];
        }
        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this19._offsets.push(item[0]);
        _this19._targets.push(item[1]);
      });
    };

    ScrollSpy.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._scrollElement).off(EVENT_KEY);

      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    };

    // private

    ScrollSpy.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      if (typeof config.target !== 'string') {
        var id = $(config.target).attr('id');
        if (!id) {
          id = Util.getUID(NAME);
          $(config.target).attr('id', id);
        }
        config.target = '#' + id;
      }

      Util.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    ScrollSpy.prototype._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    ScrollSpy.prototype._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    ScrollSpy.prototype._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.offsetHeight;
    };

    ScrollSpy.prototype._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;
      var scrollHeight = this._getScrollHeight();
      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }
        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;
        this._clear();
        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (this._offsets[i + 1] === undefined || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    ScrollSpy.prototype._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',');
      queries = queries.map(function (selector) {
        return selector + '[data-target="' + target + '"],' + (selector + '[href="' + target + '"]');
      });

      var $link = $(queries.join(','));

      if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
        $link.addClass(ClassName.ACTIVE);
      } else {
        // todo (fat) this is kinda sus...
        // recursively add actives to tested nav-links
        $link.parents(Selector.LI).find('> ' + Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
      }

      $(this._scrollElement).trigger(Event.ACTIVATE, {
        relatedTarget: target
      });
    };

    ScrollSpy.prototype._clear = function _clear() {
      $(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
    };

    // static

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return ScrollSpy;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(window).on(Event.LOAD_DATA_API, function () {
    var scrollSpys = $.makeArray($(Selector.DATA_SPY));

    for (var i = scrollSpys.length; i--;) {
      var $spy = $(scrollSpys[i]);
      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = ScrollSpy._jQueryInterface;
  $.fn[NAME].Constructor = ScrollSpy;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return ScrollSpy._jQueryInterface;
  };

  return ScrollSpy;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tab = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tab';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tab';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    A: 'a',
    LI: 'li',
    DROPDOWN: '.dropdown',
    LIST: 'ul:not(.dropdown-menu), ol:not(.dropdown-menu), nav:not(.dropdown-menu)',
    FADE_CHILD: '> .nav-item .fade, > .fade',
    ACTIVE: '.active',
    ACTIVE_CHILD: '> .nav-item > .active, > .active',
    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"]',
    DROPDOWN_TOGGLE: '.dropdown-toggle',
    DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Tab = function () {
    function Tab(element) {
      _classCallCheck(this, Tab);

      this._element = element;
    }

    // getters

    // public

    Tab.prototype.show = function show() {
      var _this20 = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName.ACTIVE) || $(this._element).hasClass(ClassName.DISABLED)) {
        return;
      }

      var target = void 0;
      var previous = void 0;
      var listElement = $(this._element).closest(Selector.LIST)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        previous = $.makeArray($(listElement).find(Selector.ACTIVE));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $.Event(Event.HIDE, {
        relatedTarget: this._element
      });

      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: previous
      });

      if (previous) {
        $(previous).trigger(hideEvent);
      }

      $(this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = $(selector)[0];
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $.Event(Event.HIDDEN, {
          relatedTarget: _this20._element
        });

        var shownEvent = $.Event(Event.SHOWN, {
          relatedTarget: previous
        });

        $(previous).trigger(hiddenEvent);
        $(_this20._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    Tab.prototype.dispose = function dispose() {
      $.removeClass(this._element, DATA_KEY);
      this._element = null;
    };

    // private

    Tab.prototype._activate = function _activate(element, container, callback) {
      var _this21 = this;

      var active = $(container).find(Selector.ACTIVE_CHILD)[0];
      var isTransitioning = callback && Util.supportsTransitionEnd() && (active && $(active).hasClass(ClassName.FADE) || Boolean($(container).find(Selector.FADE_CHILD)[0]));

      var complete = function complete() {
        return _this21._transitionComplete(element, active, isTransitioning, callback);
      };

      if (active && isTransitioning) {
        $(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      if (active) {
        $(active).removeClass(ClassName.SHOW);
      }
    };

    Tab.prototype._transitionComplete = function _transitionComplete(element, active, isTransitioning, callback) {
      if (active) {
        $(active).removeClass(ClassName.ACTIVE);

        var dropdownChild = $(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $(dropdownChild).removeClass(ClassName.ACTIVE);
        }

        active.setAttribute('aria-expanded', false);
      }

      $(element).addClass(ClassName.ACTIVE);
      element.setAttribute('aria-expanded', true);

      if (isTransitioning) {
        Util.reflow(element);
        $(element).addClass(ClassName.SHOW);
      } else {
        $(element).removeClass(ClassName.FADE);
      }

      if (element.parentNode && $(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {

        var dropdownElement = $(element).closest(Selector.DROPDOWN)[0];
        if (dropdownElement) {
          $(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    };

    // static

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Tab;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    Tab._jQueryInterface.call($(this), 'show');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tab._jQueryInterface;
  $.fn[NAME].Constructor = Tab;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tab._jQueryInterface;
  };

  return Tab;
}(jQuery);

/* global Tether */

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tooltip = function ($) {

  /**
   * Check for Tether dependency
   * Tether - http://tether.io/
   */
  if (typeof Tether === 'undefined') {
    throw new Error('Bootstrap tooltips require Tether (http://tether.io/)');
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tooltip';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tether';

  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: '0 0',
    constraints: [],
    container: false
  };

  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: 'string',
    constraints: 'array',
    container: '(string|element|boolean)'
  };

  var AttachmentMap = {
    TOP: 'bottom center',
    RIGHT: 'middle left',
    BOTTOM: 'top center',
    LEFT: 'middle right'
  };

  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY
  };

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner'
  };

  var TetherClass = {
    element: false,
    enabled: false
  };

  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Tooltip = function () {
    function Tooltip(element, config) {
      _classCallCheck(this, Tooltip);

      // private
      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._isTransitioning = false;
      this._tether = null;

      // protected
      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    }

    // getters

    // public

    Tooltip.prototype.enable = function enable() {
      this._isEnabled = true;
    };

    Tooltip.prototype.disable = function disable() {
      this._isEnabled = false;
    };

    Tooltip.prototype.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    Tooltip.prototype.toggle = function toggle(event) {
      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {

        if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
          this._leave(null, this);
          return;
        }

        this._enter(null, this);
      }
    };

    Tooltip.prototype.dispose = function dispose() {
      clearTimeout(this._timeout);

      this.cleanupTether();

      $.removeData(this.element, this.constructor.DATA_KEY);

      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;
      this._tether = null;

      this.element = null;
      this.config = null;
      this.tip = null;
    };

    Tooltip.prototype.show = function show() {
      var _this22 = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);
      if (this.isWithContent() && this._isEnabled) {
        if (this._isTransitioning) {
          throw new Error('Tooltip is transitioning');
        }
        $(this.element).trigger(showEvent);

        var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);

        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);

        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        var container = this.config.container === false ? document.body : $(this.config.container);

        $(tip).data(this.constructor.DATA_KEY, this).appendTo(container);

        $(this.element).trigger(this.constructor.Event.INSERTED);

        this._tether = new Tether({
          attachment: attachment,
          element: tip,
          target: this.element,
          classes: TetherClass,
          classPrefix: CLASS_PREFIX,
          offset: this.config.offset,
          constraints: this.config.constraints,
          addTargetClasses: false
        });

        Util.reflow(tip);
        this._tether.position();

        $(tip).addClass(ClassName.SHOW);

        var complete = function complete() {
          var prevHoverState = _this22._hoverState;
          _this22._hoverState = null;
          _this22._isTransitioning = false;

          $(_this22.element).trigger(_this22.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this22._leave(null, _this22);
          }
        };

        if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          this._isTransitioning = true;
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
          return;
        }

        complete();
      }
    };

    Tooltip.prototype.hide = function hide(callback) {
      var _this23 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);
      if (this._isTransitioning) {
        throw new Error('Tooltip is transitioning');
      }
      var complete = function complete() {
        if (_this23._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this23.element.removeAttribute('aria-describedby');
        $(_this23.element).trigger(_this23.constructor.Event.HIDDEN);
        _this23._isTransitioning = false;
        _this23.cleanupTether();

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName.SHOW);

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    // protected

    Tooltip.prototype.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    Tooltip.prototype.getTipElement = function getTipElement() {
      return this.tip = this.tip || $(this.config.template)[0];
    };

    Tooltip.prototype.setContent = function setContent() {
      var $tip = $(this.getTipElement());

      this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());

      $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

      this.cleanupTether();
    };

    Tooltip.prototype.setElementContent = function setElementContent($element, content) {
      var html = this.config.html;
      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
        // content is a DOM node or a jQuery
        if (html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }
      } else {
        $element[html ? 'html' : 'text'](content);
      }
    };

    Tooltip.prototype.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    };

    Tooltip.prototype.cleanupTether = function cleanupTether() {
      if (this._tether) {
        this._tether.destroy();
      }
    };

    // private

    Tooltip.prototype._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    Tooltip.prototype._setListeners = function _setListeners() {
      var _this24 = this;

      var triggers = this.config.trigger.split(' ');

      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this24.element).on(_this24.constructor.Event.CLICK, _this24.config.selector, function (event) {
            return _this24.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this24.constructor.Event.MOUSEENTER : _this24.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this24.constructor.Event.MOUSELEAVE : _this24.constructor.Event.FOCUSOUT;

          $(_this24.element).on(eventIn, _this24.config.selector, function (event) {
            return _this24._enter(event);
          }).on(eventOut, _this24.config.selector, function (event) {
            return _this24._leave(event);
          });
        }

        $(_this24.element).closest('.modal').on('hide.bs.modal', function () {
          return _this24.hide();
        });
      });

      if (this.config.selector) {
        this.config = $.extend({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    Tooltip.prototype._fixTitle = function _fixTitle() {
      var titleType = _typeof(this.element.getAttribute('data-original-title'));
      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    Tooltip.prototype._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;

      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);

      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    Tooltip.prototype._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;

      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);

      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    Tooltip.prototype._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    Tooltip.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, this.constructor.Default, $(this.element).data(), config);

      if (config.delay && typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);

      return config;
    };

    Tooltip.prototype._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    // static

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Popover = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'popover';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.popover';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Default = $.extend({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<h3 class="popover-title"></h3>' + '<div class="popover-content"></div></div>'
  });

  var DefaultType = $.extend({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TITLE: '.popover-title',
    CONTENT: '.popover-content'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Popover = function (_Tooltip) {
    _inherits(Popover, _Tooltip);

    function Popover() {
      _classCallCheck(this, Popover);

      return _possibleConstructorReturn(this, _Tooltip.apply(this, arguments));
    }

    // overrides

    Popover.prototype.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    Popover.prototype.getTipElement = function getTipElement() {
      return this.tip = this.tip || $(this.config.template)[0];
    };

    Popover.prototype.setContent = function setContent() {
      var $tip = $(this.getTipElement());

      // we use append for html objects to maintain js events
      this.setElementContent($tip.find(Selector.TITLE), this.getTitle());
      this.setElementContent($tip.find(Selector.CONTENT), this._getContent());

      $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

      this.cleanupTether();
    };

    // private

    Popover.prototype._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || (typeof this.config.content === 'function' ? this.config.content.call(this.element) : this.config.content);
    };

    // static

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

        if (!data && /destroy|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: 'VERSION',


      // getters

      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Popover;
  }(Tooltip);

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Popover._jQueryInterface;
  $.fn[NAME].Constructor = Popover;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Popover._jQueryInterface;
  };

  return Popover;
}(jQuery);

}();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(307)))

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(552)
var ieee754 = __webpack_require__(636)
var isArray = __webpack_require__(638)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(589);
module.exports = __webpack_require__(23).Array.from;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(23);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(591);
module.exports = __webpack_require__(23).Object.assign;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(592);
var $Object = __webpack_require__(23).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(593);
module.exports = __webpack_require__(23).Object.keys;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(192);
__webpack_require__(120);
__webpack_require__(193);
__webpack_require__(594);
__webpack_require__(597);
__webpack_require__(598);
module.exports = __webpack_require__(23).Promise;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(192);
__webpack_require__(120);
__webpack_require__(193);
__webpack_require__(595);
__webpack_require__(601);
__webpack_require__(600);
__webpack_require__(599);
module.exports = __webpack_require__(23).Set;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(596);
__webpack_require__(192);
__webpack_require__(602);
__webpack_require__(603);
module.exports = __webpack_require__(23).Symbol;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(193);
module.exports = __webpack_require__(191).f('iterator');


/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(91);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(77);
var toLength = __webpack_require__(118);
var toAbsoluteIndex = __webpack_require__(587);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(55);
var IObject = __webpack_require__(180);
var toObject = __webpack_require__(97);
var toLength = __webpack_require__(118);
var asc = __webpack_require__(569);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var isArray = __webpack_require__(293);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(568);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(43).f;
var create = __webpack_require__(116);
var redefineAll = __webpack_require__(185);
var ctx = __webpack_require__(55);
var anInstance = __webpack_require__(175);
var forOf = __webpack_require__(91);
var $iterDefine = __webpack_require__(181);
var step = __webpack_require__(296);
var setSpecies = __webpack_require__(302);
var DESCRIPTORS = __webpack_require__(49);
var fastKey = __webpack_require__(182).fastKey;
var validate = __webpack_require__(305);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(176);
var from = __webpack_require__(565);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var $export = __webpack_require__(32);
var meta = __webpack_require__(182);
var fails = __webpack_require__(64);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(185);
var forOf = __webpack_require__(91);
var anInstance = __webpack_require__(175);
var isObject = __webpack_require__(42);
var setToStringTag = __webpack_require__(96);
var dP = __webpack_require__(43).f;
var each = __webpack_require__(567)(0);
var DESCRIPTORS = __webpack_require__(49);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(43);
var createDesc = __webpack_require__(95);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(94);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(117);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 575 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(116);
var descriptor = __webpack_require__(95);
var setToStringTag = __webpack_require__(96);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(56)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var macrotask = __webpack_require__(304).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(90)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(94);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(117);
var toObject = __webpack_require__(97);
var IObject = __webpack_require__(180);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(64)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(43);
var anObject = __webpack_require__(54);
var getKeys = __webpack_require__(94);

module.exports = __webpack_require__(49) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(117);
var createDesc = __webpack_require__(95);
var toIObject = __webpack_require__(77);
var toPrimitive = __webpack_require__(189);
var has = __webpack_require__(65);
var IE8_DOM_DEFINE = __webpack_require__(291);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(49) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(77);
var gOPN = __webpack_require__(297).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(65);
var toObject = __webpack_require__(97);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(32);
var core = __webpack_require__(23);
var fails = __webpack_require__(64);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(32);
var aFunction = __webpack_require__(89);
var ctx = __webpack_require__(55);
var forOf = __webpack_require__(91);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(32);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(188);
var defined = __webpack_require__(177);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(188);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(55);
var $export = __webpack_require__(32);
var toObject = __webpack_require__(97);
var call = __webpack_require__(294);
var isArrayIter = __webpack_require__(292);
var toLength = __webpack_require__(118);
var createProperty = __webpack_require__(573);
var getIterFn = __webpack_require__(306);

$export($export.S + $export.F * !__webpack_require__(295)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(564);
var step = __webpack_require__(296);
var Iterators = __webpack_require__(92);
var toIObject = __webpack_require__(77);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(181)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(32);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(578) });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(32);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(116) });


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(97);
var $keys = __webpack_require__(94);

__webpack_require__(583)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(93);
var global = __webpack_require__(26);
var ctx = __webpack_require__(55);
var classof = __webpack_require__(176);
var $export = __webpack_require__(32);
var isObject = __webpack_require__(42);
var aFunction = __webpack_require__(89);
var anInstance = __webpack_require__(175);
var forOf = __webpack_require__(91);
var speciesConstructor = __webpack_require__(303);
var task = __webpack_require__(304).set;
var microtask = __webpack_require__(577)();
var newPromiseCapabilityModule = __webpack_require__(183);
var perform = __webpack_require__(299);
var userAgent = __webpack_require__(588);
var promiseResolve = __webpack_require__(300);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(185)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(96)($Promise, PROMISE);
__webpack_require__(302)(PROMISE);
Wrapper = __webpack_require__(23)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(295)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(570);
var validate = __webpack_require__(305);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(572)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(26);
var has = __webpack_require__(65);
var DESCRIPTORS = __webpack_require__(49);
var $export = __webpack_require__(32);
var redefine = __webpack_require__(301);
var META = __webpack_require__(182).KEY;
var $fails = __webpack_require__(64);
var shared = __webpack_require__(187);
var setToStringTag = __webpack_require__(96);
var uid = __webpack_require__(119);
var wks = __webpack_require__(28);
var wksExt = __webpack_require__(191);
var wksDefine = __webpack_require__(190);
var enumKeys = __webpack_require__(574);
var isArray = __webpack_require__(293);
var anObject = __webpack_require__(54);
var isObject = __webpack_require__(42);
var toIObject = __webpack_require__(77);
var toPrimitive = __webpack_require__(189);
var createDesc = __webpack_require__(95);
var _create = __webpack_require__(116);
var gOPNExt = __webpack_require__(581);
var $GOPD = __webpack_require__(580);
var $DP = __webpack_require__(43);
var $keys = __webpack_require__(94);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(297).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(117).f = $propertyIsEnumerable;
  __webpack_require__(184).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(93)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(32);
var core = __webpack_require__(23);
var global = __webpack_require__(26);
var speciesConstructor = __webpack_require__(303);
var promiseResolve = __webpack_require__(300);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(32);
var newPromiseCapability = __webpack_require__(183);
var perform = __webpack_require__(299);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(584)('Set');


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(585)('Set');


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(32);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(571)('Set') });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190)('asyncIterator');


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190)('observable');


/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! FileSaver.js v1.3.6
 *
 * A saveAs() FileSaver implementation.
 *
 * By Travis Clarke, https://travismclarke.com
 * By Eli Grey, http://eligrey.com
 *
 * License: MIT (https://github.com/clarketm/FileSaver.js/blob/master/LICENSE.md)
 */

;(function (root, factory) {
    if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        module.exports = root.document ? factory(root, true) : function (w) {
            if (!w.document) {
                throw new Error("FileSaver requires a window with a document");
            }
            return factory(w);
        };
    } else {
        factory(root);
    }
}(window || this, function (window, noGlobal) {
        "use strict";
        // IE <10 is explicitly unsupported
        if (typeof window === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
            return;
        }
        var
            doc = window.document
            // only get URL when necessary in case Blob.js hasn't overridden it yet
            , get_URL = function () {
                return window.URL || window.webkitURL || window;
            }
            , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
            , can_use_save_link = "download" in save_link
            , click = function (node) {
                var event = new MouseEvent("click");
                node.dispatchEvent(event);
            }
            , is_safari = /constructor/i.test(window.HTMLElement) || window.safari
            , is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent)
            , throw_outside = function (ex) {
                (window.setImmediate || window.setTimeout)(function () {
                    throw ex;
                }, 0);
            }
            , force_saveable_type = "application/octet-stream"
            // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
            , arbitrary_revoke_timeout = 1000 * 40 // in ms
            , revoke = function (file) {
                var revoker = function () {
                    if (typeof file === "string") { // file is an object URL
                        get_URL().revokeObjectURL(file);
                    } else { // file is a File
                        file.remove();
                    }
                };
                setTimeout(revoker, arbitrary_revoke_timeout);
            }
            , dispatch = function (filesaver, event_types, event) {
                event_types = [].concat(event_types);
                var i = event_types.length;
                while (i--) {
                    var listener = filesaver["on" + event_types[i]];
                    if (typeof listener === "function") {
                        try {
                            listener.call(filesaver, event || filesaver);
                        } catch (ex) {
                            throw_outside(ex);
                        }
                    }
                }
            }
            , auto_bom = function (blob) {
                // prepend BOM for UTF-8 XML and text/* types (including HTML)
                // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
                if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
                    return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
                }
                return blob;
            }
            , FileSaver = function (blob, name, no_auto_bom) {
                if (!no_auto_bom) {
                    blob = auto_bom(blob);
                }
                // First try a.download, then web filesystem, then object URLs
                var
                    filesaver = this
                    , type = blob.type
                    , force = type === force_saveable_type
                    , object_url
                    , dispatch_all = function () {
                        dispatch(filesaver, "writestart progress write writeend".split(" "));
                    }
                    // on any filesys errors revert to saving with object URLs
                    , fs_error = function () {
                        if ((is_chrome_ios || (force && is_safari)) && window.FileReader) {
                            // Safari doesn't allow downloading of blob urls
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                                var popup = window.open(url, '_blank');
                                if (!popup) window.location.href = url;
                                url = undefined; // release reference before dispatching
                                filesaver.readyState = filesaver.DONE;
                                dispatch_all();
                            };
                            reader.readAsDataURL(blob);
                            filesaver.readyState = filesaver.INIT;
                            return;
                        }
                        // don't create more object URLs than needed
                        if (!object_url) {
                            object_url = get_URL().createObjectURL(blob);
                        }
                        if (force) {
                            window.location.href = object_url;
                        } else {
                            var opened = window.open(object_url, "_blank");
                            if (!opened) {
                                // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                                window.location.href = object_url;
                            }
                        }
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                        revoke(object_url);
                    }
                    ;
                filesaver.readyState = filesaver.INIT;

                if (can_use_save_link) {
                    object_url = get_URL().createObjectURL(blob);
                    setTimeout(function () {
                        save_link.href = object_url;
                        save_link.download = name;
                        click(save_link);
                        dispatch_all();
                        revoke(object_url);
                        filesaver.readyState = filesaver.DONE;
                    });
                    return;
                }

                fs_error();
            }
            , FS_proto = FileSaver.prototype
            , saveAs = function (blob, name, no_auto_bom) {
                return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
            }
            ;
        // IE 10+ (native saveAs)
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            saveAs = function (blob, name, no_auto_bom) {
                name = name || blob.name || "download";

                if (!no_auto_bom) {
                    blob = auto_bom(blob);
                }
                return navigator.msSaveOrOpenBlob(blob, name);
            };
        }

        FS_proto.abort = function () {
        };
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;

        FS_proto.error =
            FS_proto.onwritestart =
                FS_proto.onprogress =
                    FS_proto.onwrite =
                        FS_proto.onabort =
                            FS_proto.onerror =
                                FS_proto.onwriteend =
                                    null;

        if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return saveAs;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }

        if (typeof noGlobal === 'undefined') {
            window.saveAs = saveAs;
        }
        return saveAs;
    }
));


/***/ }),
/* 636 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 638 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
* Detect Element Resize
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

(function () {
	var attachEvent = document.attachEvent,
		stylesCreated = false;
	
	if (!attachEvent) {
		var requestFrame = (function(){
			var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
								function(fn){ return window.setTimeout(fn, 20); };
			return function(fn){ return raf(fn); };
		})();
		
		var cancelFrame = (function(){
			var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
								   window.clearTimeout;
		  return function(id){ return cancel(id); };
		})();

		function resetTriggers(element){
			var triggers = element.__resizeTriggers__,
				expand = triggers.firstElementChild,
				contract = triggers.lastElementChild,
				expandChild = expand.firstElementChild;
			contract.scrollLeft = contract.scrollWidth;
			contract.scrollTop = contract.scrollHeight;
			expandChild.style.width = expand.offsetWidth + 1 + 'px';
			expandChild.style.height = expand.offsetHeight + 1 + 'px';
			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
		};

		function checkTriggers(element){
			return element.offsetWidth != element.__resizeLast__.width ||
						 element.offsetHeight != element.__resizeLast__.height;
		}
		
		function scrollListener(e){
			var element = this;
			resetTriggers(this);
			if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
			this.__resizeRAF__ = requestFrame(function(){
				if (checkTriggers(element)) {
					element.__resizeLast__.width = element.offsetWidth;
					element.__resizeLast__.height = element.offsetHeight;
					element.__resizeListeners__.forEach(function(fn){
						fn.call(element, e);
					});
				}
			});
		};
		
		/* Detect CSS Animations support to detect element display/re-attach */
		var animation = false,
			animationstring = 'animation',
			keyframeprefix = '',
			animationstartevent = 'animationstart',
			domPrefixes = 'Webkit Moz O ms'.split(' '),
			startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
			pfx  = '';
		{
			var elm = document.createElement('fakeelement');
			if( elm.style.animationName !== undefined ) { animation = true; }    
			
			if( animation === false ) {
				for( var i = 0; i < domPrefixes.length; i++ ) {
					if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
						pfx = domPrefixes[ i ];
						animationstring = pfx + 'Animation';
						keyframeprefix = '-' + pfx.toLowerCase() + '-';
						animationstartevent = startEvents[ i ];
						animation = true;
						break;
					}
				}
			}
		}
		
		var animationName = 'resizeanim';
		var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
		var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	function createStyles() {
		if (!stylesCreated) {
			//opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
			var css = (animationKeyframes ? animationKeyframes : '') +
					'.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
					'.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');
			
			style.type = 'text/css';
			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
			stylesCreated = true;
		}
	}
	
	window.addResizeListener = function(element, fn){
		if (attachEvent) element.attachEvent('onresize', fn);
		else {
			if (!element.__resizeTriggers__) {
				if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
				createStyles();
				element.__resizeLast__ = {};
				element.__resizeListeners__ = [];
				(element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
				element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
																						'<div class="contract-trigger"></div>';
				element.appendChild(element.__resizeTriggers__);
				resetTriggers(element);
				element.addEventListener('scroll', scrollListener, true);
				
				/* Listen for a css animation to detect element display/re-attach */
				animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
					if(e.animationName == animationName)
						resetTriggers(element);
				});
			}
			element.__resizeListeners__.push(fn);
		}
	};
	
	window.removeResizeListener = function(element, fn){
		if (attachEvent) element.detachEvent('onresize', fn);
		else {
			element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
			if (!element.__resizeListeners__.length) {
					element.removeEventListener('scroll', scrollListener);
					element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
			}
		}
	}
})();

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (true) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(641);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(121)))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! Copyright (c) Jonas Mosbech - https://github.com/jmosbech/StickyTableHeaders
	MIT license info: https://github.com/jmosbech/StickyTableHeaders/blob/master/license.txt */

;(function ($, window, undefined) {
	'use strict';

	var name = 'stickyTableHeaders',
		id = 0,
		defaults = {
			fixedOffset: 0,
			leftOffset: 0,
			marginTop: 0,
			objDocument: document,
			objHead: 'head',
			objWindow: window,
			scrollableArea: window,
			cacheHeaderHeight: false,
			zIndex: 3
		};

	function Plugin (el, options) {
		// To avoid scope issues, use 'base' instead of 'this'
		// to reference this class from internal events and functions.
		var base = this;

		// Access to jQuery and DOM versions of element
		base.$el = $(el);
		base.el = el;
		base.id = id++;

		// Listen for destroyed, call teardown
		base.$el.bind('destroyed',
			$.proxy(base.teardown, base));

		// Cache DOM refs for performance reasons
		base.$clonedHeader = null;
		base.$originalHeader = null;

		// Cache header height for performance reasons
		base.cachedHeaderHeight = null;

		// Keep track of state
		base.isSticky = false;
		base.hasBeenSticky = false;
		base.leftOffset = null;
		base.topOffset = null;

		base.init = function () {
			base.setOptions(options);

			base.$el.each(function () {
				var $this = $(this);

				// remove padding on <table> to fix issue #7
				$this.css('padding', 0);

				base.$originalHeader = $('thead:first', this);
				base.$clonedHeader = base.$originalHeader.clone();
				$this.trigger('clonedHeader.' + name, [base.$clonedHeader]);

				base.$clonedHeader.addClass('tableFloatingHeader');
				base.$clonedHeader.css({display: 'none', opacity: 0.0});

				base.$originalHeader.addClass('tableFloatingHeaderOriginal');

				base.$originalHeader.after(base.$clonedHeader);

				base.$printStyle = $('<style type="text/css" media="print">' +
					'.tableFloatingHeader{display:none !important;}' +
					'.tableFloatingHeaderOriginal{position:static !important;}' +
					'</style>');
				base.$head.append(base.$printStyle);
			});
			
			base.$clonedHeader.find("input, select").attr("disabled", true);

			base.updateWidth();
			base.toggleHeaders();
			base.bind();
		};

		base.destroy = function (){
			base.$el.unbind('destroyed', base.teardown);
			base.teardown();
		};

		base.teardown = function(){
			if (base.isSticky) {
				base.$originalHeader.css('position', 'static');
			}
			$.removeData(base.el, 'plugin_' + name);
			base.unbind();

			base.$clonedHeader.remove();
			base.$originalHeader.removeClass('tableFloatingHeaderOriginal');
			base.$originalHeader.css('visibility', 'visible');
			base.$printStyle.remove();

			base.el = null;
			base.$el = null;
		};

		base.bind = function(){
			base.$scrollableArea.on('scroll.' + name, base.toggleHeaders);
			if (!base.isWindowScrolling) {
				base.$window.on('scroll.' + name + base.id, base.setPositionValues);
				base.$window.on('resize.' + name + base.id, base.toggleHeaders);
			}
			base.$scrollableArea.on('resize.' + name, base.toggleHeaders);
			base.$scrollableArea.on('resize.' + name, base.updateWidth);
		};

		base.unbind = function(){
			// unbind window events by specifying handle so we don't remove too much
			base.$scrollableArea.off('.' + name, base.toggleHeaders);
			if (!base.isWindowScrolling) {
				base.$window.off('.' + name + base.id, base.setPositionValues);
				base.$window.off('.' + name + base.id, base.toggleHeaders);
			}
			base.$scrollableArea.off('.' + name, base.updateWidth);
		};

		// We debounce the functions bound to the scroll and resize events
		base.debounce = function (fn, delay) {
			var timer = null;
			return function () {
				var context = this, args = arguments;
				clearTimeout(timer);
				timer = setTimeout(function () {
					fn.apply(context, args);
				}, delay);
			};
		};

		base.toggleHeaders = base.debounce(function () {
			if (base.$el) {
				base.$el.each(function () {
					var $this = $(this),
						newLeft,
						newTopOffset = base.isWindowScrolling ? (
									isNaN(base.options.fixedOffset) ?
									base.options.fixedOffset.outerHeight() :
									base.options.fixedOffset
								) :
								base.$scrollableArea.offset().top + (!isNaN(base.options.fixedOffset) ? base.options.fixedOffset : 0),
						offset = $this.offset(),

						scrollTop = base.$scrollableArea.scrollTop() + newTopOffset,
						scrollLeft = base.$scrollableArea.scrollLeft(),

						headerHeight,

						scrolledPastTop = base.isWindowScrolling ?
								scrollTop > offset.top :
								newTopOffset > offset.top,
						notScrolledPastBottom;

					if (scrolledPastTop) {
						headerHeight = base.options.cacheHeaderHeight ? base.cachedHeaderHeight : base.$clonedHeader.height();
						notScrolledPastBottom = (base.isWindowScrolling ? scrollTop : 0) <
							(offset.top + $this.height() - headerHeight - (base.isWindowScrolling ? 0 : newTopOffset));
					}

					if (scrolledPastTop && notScrolledPastBottom) {
						newLeft = offset.left - scrollLeft + base.options.leftOffset;
						base.$originalHeader.css({
							'position': 'fixed',
							'margin-top': base.options.marginTop,
                                                        'top': 0,
							'left': newLeft,
							'z-index': base.options.zIndex
						});
						base.leftOffset = newLeft;
						base.topOffset = newTopOffset;
						base.$clonedHeader.css('display', '');
						if (!base.isSticky) {
							base.isSticky = true;
							// make sure the width is correct: the user might have resized the browser while in static mode
							base.updateWidth();
							$this.trigger('enabledStickiness.' + name);
						}
						base.setPositionValues();
					} else if (base.isSticky) {
						base.$originalHeader.css('position', 'static');
						base.$clonedHeader.css('display', 'none');
						base.isSticky = false;
						base.resetWidth($('td,th', base.$clonedHeader), $('td,th', base.$originalHeader));
						$this.trigger('disabledStickiness.' + name);
					}
				});
			}
		}, 0);

		base.setPositionValues = base.debounce(function () {
			var winScrollTop = base.$window.scrollTop(),
				winScrollLeft = base.$window.scrollLeft();
			if (!base.isSticky ||
					winScrollTop < 0 || winScrollTop + base.$window.height() > base.$document.height() ||
					winScrollLeft < 0 || winScrollLeft + base.$window.width() > base.$document.width()) {
				return;
			}
			base.$originalHeader.css({
				'top': base.topOffset - (base.isWindowScrolling ? 0 : winScrollTop),
				'left': base.leftOffset - (base.isWindowScrolling ? 0 : winScrollLeft)
			});
		}, 0);

		base.updateWidth = base.debounce(function () {
			if (!base.isSticky) {
				return;
			}
			// Copy cell widths from clone
			if (!base.$originalHeaderCells) {
				base.$originalHeaderCells = $('th,td', base.$originalHeader);
			}
			if (!base.$clonedHeaderCells) {
				base.$clonedHeaderCells = $('th,td', base.$clonedHeader);
			}
			var cellWidths = base.getWidth(base.$clonedHeaderCells);
			base.setWidth(cellWidths, base.$clonedHeaderCells, base.$originalHeaderCells);

			// Copy row width from whole table
			base.$originalHeader.css('width', base.$clonedHeader.width());

			// If we're caching the height, we need to update the cached value when the width changes
			if (base.options.cacheHeaderHeight) {
				base.cachedHeaderHeight = base.$clonedHeader.height();
			}
		}, 0);

		base.getWidth = function ($clonedHeaders) {
			var widths = [];
			$clonedHeaders.each(function (index) {
				var width, $this = $(this);

				if ($this.css('box-sizing') === 'border-box') {
					var boundingClientRect = $this[0].getBoundingClientRect();
					if(boundingClientRect.width) {
						width = boundingClientRect.width; // #39: border-box bug
					} else {
						width = boundingClientRect.right - boundingClientRect.left; // ie8 bug: getBoundingClientRect() does not have a width property
					}
				} else {
					var $origTh = $('th', base.$originalHeader);
					if ($origTh.css('border-collapse') === 'collapse') {
						if (window.getComputedStyle) {
							width = parseFloat(window.getComputedStyle(this, null).width);
						} else {
							// ie8 only
							var leftPadding = parseFloat($this.css('padding-left'));
							var rightPadding = parseFloat($this.css('padding-right'));
							// Needs more investigation - this is assuming constant border around this cell and it's neighbours.
							var border = parseFloat($this.css('border-width'));
							width = $this.outerWidth() - leftPadding - rightPadding - border;
						}
					} else {
						width = $this.width();
					}
				}

				widths[index] = width;
			});
			return widths;
		};

		base.setWidth = function (widths, $clonedHeaders, $origHeaders) {
			$clonedHeaders.each(function (index) {
				var width = widths[index];
				$origHeaders.eq(index).css({
					'min-width': width,
					'max-width': width
				});
			});
		};

		base.resetWidth = function ($clonedHeaders, $origHeaders) {
			$clonedHeaders.each(function (index) {
				var $this = $(this);
				$origHeaders.eq(index).css({
					'min-width': $this.css('min-width'),
					'max-width': $this.css('max-width')
				});
			});
		};

		base.setOptions = function (options) {
			base.options = $.extend({}, defaults, options);
			base.$window = $(base.options.objWindow);
			base.$head = $(base.options.objHead);
			base.$document = $(base.options.objDocument);
			base.$scrollableArea = $(base.options.scrollableArea);
			base.isWindowScrolling = base.$scrollableArea[0] === base.$window[0];
		};

		base.updateOptions = function (options) {
			base.setOptions(options);
			// scrollableArea might have changed
			base.unbind();
			base.bind();
			base.updateWidth();
			base.toggleHeaders();
		};

		// Run initializer
		base.init();
	}

	// A plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[name] = function ( options ) {
		return this.each(function () {
			var instance = $.data(this, 'plugin_' + name);
			if (instance) {
				if (typeof options === 'string') {
					instance[options].apply(instance);
				} else {
					instance.updateOptions(options);
				}
			} else if(options !== 'destroy') {
				$.data(this, 'plugin_' + name, new Plugin( this, options ));
			}
		});
	};

})(jQuery, window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 646 */
/***/ (function(module, exports) {

/*! store2 - v2.5.6 - 2017-09-26
* Copyright (c) 2017 Nathan Bubna; Licensed (MIT OR GPL-3.0) */
;(function(window, define) {
    var _ = {
        version: "2.5.6",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    o[p] = api[p];
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (typeof data === "function"){ return store.transact(key, data, overwrite); }// fn=data, alt=overwrite
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_safariPrivate_';
                area.setItem(testKey, 'sucks');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.inherit(_.storageAPI, { items: {}, name: 'fake' });
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, noSession) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!noSession){ store.area('session', _.areas.session); }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, _and) {// _and is purely for internal use (see keys())
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, _and || this.get(key)) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return _and || this;
            },
            keys: function() {
                return this.each(function(k, list){ list.push(k); }, []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key));
                return s !== null ? _.parse(s) : alt || s;// support alt for easy default mgmt
            },
            getAll: function() {
                return this.each(function(k, all){ all[k] = this.get(k); }, {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt),
                    ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            remove: function(key) {
                var d = this.get(key);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.items){ this.removeItem(k); } },
            toString: function(){ return this.length+' items in '+this.name+'Storage'; }
        }// end _.storageAPI
    };

    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());

    if (typeof define === 'function' && define.amd !== undefined) {
        define('store2', [], function () {
            return store;
        });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = store;
    } else {
        // expose the primary store fn to the global object and save conflicts
        if (window.store){ _.conflict = window.store; }
        window.store = store;
    }

})(this, this.define);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(644);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
; (function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.2',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass)
                    .attr('aria-live', 'polite')
                    .attr('role', 'alert');

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null)
                        source = "";

                    return new String(source)
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setSequence();
                }

                function handleEvents() {
                    $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }
                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass('toast-close-button').attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass('toast-progress');
                        $toastElement.prepend($progressElement);
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(327)));


/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * vue-good-table v1.21.0
 * https://github.com/xaksis/vue-good-table
 * Released under the MIT License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueGoodTable"] = factory();
	else
		root["VueGoodTable"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 253);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toDate;
var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument is null, it is treated as an invalid date.
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {*} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {}

  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits)
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone)
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset()
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(patterns.dateTimeDelimeter)
  var timeString

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits]
  var patternYYYYY = patterns.YYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = patterns.HH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = patterns.timezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneObject;
function cloneObject (dirtyObject) {
  dirtyObject = dirtyObject || {}
  var object = {}

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      object[property] = dirtyObject[property]
    }
  }

  return object
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareAsc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var diff = dateLeft.getTime() - dateRight.getTime()

  if (diff < 0) {
    return -1
  } else if (diff > 0) {
    return 1
  // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__ = __webpack_require__(1);



/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var startOfWeekOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__["a" /* default */])(dirtyOptions)
  startOfWeekOptions.weekStartsOn = 1
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDate, startOfWeekOptions)
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(48)('wks');
var uid = __webpack_require__(50);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(3);



/**
 * @name getISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear, dirtyOptions)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear, dirtyOptions)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(28)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(19);
var createDesc = __webpack_require__(46);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(38);


var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var startOfDayLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var startOfDayRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(216);






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 */
var locale = {
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
}

/* harmony default export */ __webpack_exports__["a"] = (locale);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(3);



/**
 * @name startOfISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of an ISO year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuary, dirtyOptions)
  return date
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _diacriticless = __webpack_require__(83);

var _diacriticless2 = _interopRequireDefault(_diacriticless);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  format: function defaultFormat(x) {
    return x;
  },
  filterPredicate: function defaultFilter(rowval, filter) {
    if (typeof rowval === 'undefined' || rowval === null) {
      return false;
    }

    var rowValue = (0, _diacriticless2.default)(String(rowval).toLowerCase());

    var searchTerm = (0, _diacriticless2.default)(filter.toLowerCase());

    return rowValue.search(searchTerm) > -1;
  },

  compare: function compare(x, y) {
    function cook(d) {
      if (typeof d === 'undefined' || d === null) return '';
      return d.toLowerCase();
    }
    x = cook(x);
    y = cook(y);
    return x < y ? -1 : x > y ? 1 : 0;
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(107);
var toPrimitive = __webpack_require__(122);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = 1

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = date.getUTCDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setUTCDate(date.getUTCDate() - diff)
  date.setUTCHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDaysInMonth_index_js__ = __webpack_require__(37);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth, dirtyOptions)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)
  return dateLeft.getTime() - dateRight.getTime()
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}
  var locale = options.locale
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn)
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, options)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, false, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = clone;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(250), __webpack_require__(251)(module)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(24);

var _lodash2 = _interopRequireDefault(_lodash);

var _default = __webpack_require__(15);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var number = (0, _lodash2.default)(_default2.default);

number.isRight = true;

number.filterPredicate = function defaultFilter(rowval, filter) {
  return number.compare(rowval, filter) === 0;
};

number.compare = function compareNumbers(x, y) {
  function cook(d) {
    if (d === undefined || d === null) return -Infinity;
    return d.indexOf('.') >= 0 ? parseFloat(d) : parseInt(d);
  }

  x = typeof x === 'number' ? x : cook(x);
  y = typeof y === 'number' ? y : cook(y);
  return x < y ? -1 : x > y ? 1 : 0;
};

exports.default = number;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(4);
var ctx = __webpack_require__(105);
var hide = __webpack_require__(9);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(48)('keys');
var uid = __webpack_require__(50);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(43);
var defined = __webpack_require__(26);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(20);



// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setUTCFullYear(year, 0, 4)
  fourthOfJanuary.setUTCHours(0, 0, 0, 0)
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary, dirtyOptions)
  return date
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);


/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  var days = amount * 7
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(dirtyDate, days, dirtyOptions)
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(2);




/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions)
  var difference = Math.abs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions) === -sign
  return sign * (difference - isLastMonthNotFull)
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(22);


/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, dirtyOptions) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__ = __webpack_require__(56);


/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the mintues subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(40);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(110);
var $export = __webpack_require__(27);
var redefine = __webpack_require__(118);
var hide = __webpack_require__(9);
var has = __webpack_require__(17);
var Iterators = __webpack_require__(18);
var $iterCreate = __webpack_require__(108);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(115);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(116);
var enumBugKeys = __webpack_require__(42);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(19).f;
var has = __webpack_require__(17);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(26);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(33);




var MILLISECONDS_IN_WEEK = 604800000

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date, dirtyOptions).getTime() - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date, dirtyOptions).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(20);



// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getUTCFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0)
  var startOfNextYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear, dirtyOptions)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0)
  var startOfThisYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear, dirtyOptions)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(11);


var MILLISECONDS_IN_HOUR = 3600000

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR, dirtyOptions)
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addISOYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setISOYear_index_js__ = __webpack_require__(75);



/**
 * @name addISOYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the ISO week-numbering years added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setISOYear_index_js__["a" /* default */])(dirtyDate, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions) + amount, dirtyOptions)
}


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(11);


var MILLISECONDS_IN_MINUTE = 60000

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE, dirtyOptions)
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__ = __webpack_require__(21);


/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  var months = amount * 3
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__["a" /* default */])(dirtyDate, months, dirtyOptions)
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(11);


/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * 1000, dirtyOptions)
}


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__ = __webpack_require__(21);


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__["a" /* default */])(dirtyDate, amount * 12, dirtyOptions)
}


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarISOYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__ = __webpack_require__(7);


/**
 * @name differenceInCalendarISOYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)
}


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(2);




/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full days
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions)
  var difference = Math.abs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions) === -sign
  return sign * (difference - isLastDayNotFull)
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setHours(23, 59, 59, 999)
  return date
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}

  var locale = options.locale
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn)
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, options)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_index_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_addUTCMinutes_index_js__ = __webpack_require__(132);







var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g
var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 * | Long format             | LT    | 05:30 a.m.                       |
 * |                         | LTS   | 05:30:15 a.m.                    |
 * |                         | L     | 07/02/1995                       |
 * |                         | l     | 7/2/1995                         |
 * |                         | LL    | July 2 1995                      |
 * |                         | ll    | Jul 2 1995                       |
 * |                         | LLL   | July 2 1995 05:30 a.m.           |
 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var formatStr = String(dirtyFormatStr)
  var options = dirtyOptions || {}

  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__["a" /* default */]

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var localeFormatters = locale.formatters || {}
  var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp
  var formatLong = locale.formatLong

  var originalDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, options)

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a" /* default */])(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = originalDate.getTimezoneOffset()
  var utcDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_addUTCMinutes_index_js__["a" /* default */])(originalDate, -timezoneOffset, options)

  var formatterOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__["a" /* default */])(options)
  formatterOptions.locale = locale
  formatterOptions.formatters = __WEBPACK_IMPORTED_MODULE_3__lib_formatters_index_js__["a" /* default */]

  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
  // Right now, please don't use it in locales. If you have to use an original date,
  // please restore it from `date`, adding a timezone offset to it.
  formatterOptions._originalDate = originalDate

  var result = formatStr
    .replace(longFormattingTokensRegExp, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString(substring)
      }

      return formatLong(substring)
    })
    .replace(formattingTokensRegExp, function (substring) {
      var formatter = localeFormatters[substring] || __WEBPACK_IMPORTED_MODULE_3__lib_formatters_index_js__["a" /* default */][substring]

      if (formatter) {
        return formatter(utcDate, formatterOptions)
      } else {
        return cleanEscapedString(substring)
      }
    })

  return result
}

function cleanEscapedString (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the day of ISO week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfISOYear_index_js__ = __webpack_require__(14);




var MILLISECONDS_IN_WEEK = 604800000

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(date, dirtyOptions).getTime() - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__startOfISOYear_index_js__["a" /* default */])(date, dirtyOptions).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLeapYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is in the leap year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(23);


/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Boolean} the dates are in the same week
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfWeek = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  return !isNaN(date)
}


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Date} the last day of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}
  var locale = options.locale
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn)
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOYear_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(12);




/**
 * @name setISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the ISO week-numbering year setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var isoYear = Number(dirtyISOYear)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a" /* default */])(date, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOYear_index_js__["a" /* default */])(date, dirtyOptions), dirtyOptions)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOYear_index_js__["a" /* default */])(fourthOfJanuary, dirtyOptions)
  date.setDate(date.getDate() + diff)
  return date
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDaysInMonth_index_js__ = __webpack_require__(37);



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the month setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth, dirtyOptions)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfHour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setMinutes(0, 0, 0)
  return date
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfMinute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setSeconds(0, 0)
  return date
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfSecond;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setMilliseconds(0)
  return date
}


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var cleanDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subISOYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addISOYears_index_js__ = __webpack_require__(55);


/**
 * @name subISOYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addISOYears_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// all diacritics
var diacritics = 
	{
		'a' : ['a','à','á','â','ã','ä','å','æ','ā','ă','ą','ǎ','ǟ','ǡ','ǻ','ȁ','ȃ','ȧ','ɐ','ɑ','ɒ','ͣ','а','ӑ','ӓ','ᵃ','ᵄ','ᶏ','ḁ','ẚ','ạ','ả','ấ','ầ','ẩ','ẫ','ậ','ắ','ằ','ẳ','ẵ','ặ','ₐ','ⱥ','ａ'],
		'A' : ['A','À','Á','Â','Ã','Ä','Å','Ā','Ă','Ą','Ǎ','Ǟ','Ǡ','Ǻ','Ȁ','Ȃ','Ȧ','Ⱥ','А','Ӑ','Ӓ','ᴀ','ᴬ','Ḁ','Ạ','Ả','Ấ','Ầ','Ẩ','Ẫ','Ậ','Ắ','Ằ','Ẳ','Ẵ','Ặ','Ａ'],
		 
		'b' : ['b','ƀ','ƃ','ɓ','ᖯ','ᵇ','ᵬ','ᶀ','ḃ','ḅ','ḇ','ｂ'],
		'B' : ['B','Ɓ','Ƃ','Ƀ','ʙ','ᛒ','ᴃ','ᴮ','ᴯ','Ḃ','Ḅ','Ḇ','Ｂ'],
		 
		'c' : ['c','ç','ć','ĉ','ċ','č','ƈ','ȼ','ɕ','ͨ','ᴄ','ᶜ','ḉ','ↄ','ｃ'],
		'C' : ['C','Ç','Ć','Ĉ','Ċ','Č','Ƈ','Ȼ','ʗ','Ḉ','Ｃ'],
		
		'd' : ['d','ď','đ','Ƌ','ƌ','ȡ','ɖ','ɗ','ͩ','ᵈ','ᵭ','ᶁ','ᶑ','ḋ','ḍ','ḏ','ḑ','ḓ','ｄ'],
		'D' : ['D','Ď','Đ','Ɖ','Ɗ','ᴰ','Ḋ','Ḍ','Ḏ','Ḑ','Ḓ','Ｄ'],
		
		'e' : ['e','è','é','ê','ë','ē','ĕ','ė','ę','ě','ǝ','ȅ','ȇ','ȩ','ɇ','ɘ','ͤ','ᵉ','ᶒ','ḕ','ḗ','ḙ','ḛ','ḝ','ẹ','ẻ','ẽ','ế','ề','ể','ễ','ệ','ₑ','ｅ'],
		'E' : ['E','È','É','Ê','Ë','Ē','Ĕ','Ė','Ę','Ě','Œ','Ǝ','Ɛ','Ȅ','Ȇ','Ȩ','Ɇ','ɛ','ɜ','ɶ','Є','Э','э','є','Ӭ','ӭ','ᴇ','ᴈ','ᴱ','ᴲ','ᵋ','ᵌ','ᶓ','ᶔ','ᶟ','Ḕ','Ḗ','Ḙ','Ḛ','Ḝ','Ẹ','Ẻ','Ẽ','Ế','Ề','Ể','Ễ','Ệ','Ｅ','𐐁','𐐩'],
		
		'f' : ['f','ƒ','ᵮ','ᶂ','ᶠ','ḟ','ｆ'],
		'F' : ['F','Ƒ','Ḟ','ⅎ','Ｆ'],
		
		'g' : ['g','ĝ','ğ','ġ','ģ','ǥ','ǧ','ǵ','ɠ','ɡ','ᵍ','ᵷ','ᵹ','ᶃ','ᶢ','ḡ','ｇ'],
		'G' : ['G','Ĝ','Ğ','Ġ','Ģ','Ɠ','Ǥ','Ǧ','Ǵ','ɢ','ʛ','ᴳ','Ḡ','Ｇ'],
		
		'h' : ['h','ĥ','ħ','ƕ','ȟ','ɥ','ɦ','ʮ','ʯ','ʰ','ʱ','ͪ','Һ','һ','ᑋ','ᶣ','ḣ','ḥ','ḧ','ḩ','ḫ','ⱨ','ｈ'],
		'H' : ['H','Ĥ','Ħ','Ȟ','ʜ','ᕼ','ᚺ','ᚻ','ᴴ','Ḣ','Ḥ','Ḧ','Ḩ','Ḫ','Ⱨ','Ｈ'],
		
		'i' : ['i','ì','í','î','ï','ĩ','ī','ĭ','į','ǐ','ȉ','ȋ','ɨ','ͥ','ᴉ','ᵎ','ᵢ','ᶖ','ᶤ','ḭ','ḯ','ỉ','ị','ｉ'],
		'I' : ['I','Ì','Í','Î','Ï','Ĩ','Ī','Ĭ','Į','İ','Ǐ','Ȉ','Ȋ','ɪ','І','ᴵ','ᵻ','ᶦ','ᶧ','Ḭ','Ḯ','Ỉ','Ị','Ｉ'],
		
		'j' : ['j','ĵ','ǰ','ɉ','ʝ','ʲ','ᶡ','ᶨ','ｊ'],
		'J' : ['J','Ĵ','ᴊ','ᴶ','Ｊ'],
		
		'k' : ['k','ķ','ƙ','ǩ','ʞ','ᵏ','ᶄ','ḱ','ḳ','ḵ','ⱪ','ｋ'],
		'K' : ['K','Ķ','Ƙ','Ǩ','ᴷ','Ḱ','Ḳ','Ḵ','Ⱪ','Ｋ'],
		
		'l' : ['l','ĺ','ļ','ľ','ŀ','ł','ƚ','ȴ','ɫ','ɬ','ɭ','ˡ','ᶅ','ᶩ','ᶪ','ḷ','ḹ','ḻ','ḽ','ℓ','ⱡ'],
		'L' : ['L','Ĺ','Ļ','Ľ','Ŀ','Ł','Ƚ','ʟ','ᴌ','ᴸ','ᶫ','Ḷ','Ḹ','Ḻ','Ḽ','Ⱡ','Ɫ'],
		
		'm' : ['m','ɯ','ɰ','ɱ','ͫ','ᴟ','ᵐ','ᵚ','ᵯ','ᶆ','ᶬ','ᶭ','ḿ','ṁ','ṃ','㎡','㎥','ｍ'],
		'M' : ['M','Ɯ','ᴍ','ᴹ','Ḿ','Ṁ','Ṃ','Ｍ'],
		
		'n' : ['n','ñ','ń','ņ','ň','ŉ','ƞ','ǹ','ȵ','ɲ','ɳ','ᵰ','ᶇ','ᶮ','ᶯ','ṅ','ṇ','ṉ','ṋ','ⁿ','ｎ'],
		'N' : ['N','Ñ','Ń','Ņ','Ň','Ɲ','Ǹ','Ƞ','ɴ','ᴎ','ᴺ','ᴻ','ᶰ','Ṅ','Ṇ','Ṉ','Ṋ','Ｎ'],
		
		'o' : ['o','ò','ó','ô','õ','ö','ø','ō','ŏ','ő','ơ','ǒ','ǫ','ǭ','ǿ','ȍ','ȏ','ȫ','ȭ','ȯ','ȱ','ɵ','ͦ','о','ӧ','ө','ᴏ','ᴑ','ᴓ','ᴼ','ᵒ','ᶱ','ṍ','ṏ','ṑ','ṓ','ọ','ỏ','ố','ồ','ổ','ỗ','ộ','ớ','ờ','ở','ỡ','ợ','ₒ','ｏ','𐐬'],
		'O' : ['O','Ò','Ó','Ô','Õ','Ö','Ø','Ō','Ŏ','Ő','Ɵ','Ơ','Ǒ','Ǫ','Ǭ','Ǿ','Ȍ','Ȏ','Ȫ','Ȭ','Ȯ','Ȱ','О','Ӧ','Ө','Ṍ','Ṏ','Ṑ','Ṓ','Ọ','Ỏ','Ố','Ồ','Ổ','Ỗ','Ộ','Ớ','Ờ','Ở','Ỡ','Ợ','Ｏ','𐐄'],
		
		'p' : ['p','ᵖ','ᵱ','ᵽ','ᶈ','ṕ','ṗ','ｐ'],
		'P' : ['P','Ƥ','ᴘ','ᴾ','Ṕ','Ṗ','Ᵽ','Ｐ'],
		
		'q' : ['q','ɋ','ʠ','ᛩ','ｑ'],
		'Q' : ['Q','Ɋ','Ｑ'],
		
		'r' : ['r','ŕ','ŗ','ř','ȑ','ȓ','ɍ','ɹ','ɻ','ʳ','ʴ','ʵ','ͬ','ᵣ','ᵲ','ᶉ','ṙ','ṛ','ṝ','ṟ'],
		'R' : ['R','Ŕ','Ŗ','Ř','Ʀ','Ȑ','Ȓ','Ɍ','ʀ','ʁ','ʶ','ᚱ','ᴙ','ᴚ','ᴿ','Ṙ','Ṛ','Ṝ','Ṟ','Ɽ'],
		
		's' : ['s','ś','ŝ','ş','š','ș','ʂ','ᔆ','ᶊ','ṡ','ṣ','ṥ','ṧ','ṩ','ｓ'],
		'S' : ['S','Ś','Ŝ','Ş','Š','Ș','ȿ','ˢ','ᵴ','Ṡ','Ṣ','Ṥ','Ṧ','Ṩ','Ｓ'],
		
		't' : ['t','ţ','ť','ŧ','ƫ','ƭ','ț','ʇ','ͭ','ᵀ','ᵗ','ᵵ','ᶵ','ṫ','ṭ','ṯ','ṱ','ẗ','ｔ'],
		'T' : ['T','Ţ','Ť','Ƭ','Ʈ','Ț','Ⱦ','ᴛ','ᵀ','Ṫ','Ṭ','Ṯ','Ṱ','Ｔ'],
	 	
		'u' : ['u','ù','ú','û','ü','ũ','ū','ŭ','ů','ű','ų','ư','ǔ','ǖ','ǘ','ǚ','ǜ','ȕ','ȗ','ͧ','ߎ','ᵘ','ᵤ','ṳ','ṵ','ṷ','ṹ','ṻ','ụ','ủ','ứ','ừ','ử','ữ','ự','ｕ'],
		'U' : ['U','Ù','Ú','Û','Ü','Ũ','Ū','Ŭ','Ů','Ű','Ų','Ư','Ǔ','Ǖ','Ǘ','Ǚ','Ǜ','Ȕ','Ȗ','Ʉ','ᴜ','ᵁ','ᵾ','Ṳ','Ṵ','Ṷ','Ṹ','Ṻ','Ụ','Ủ','Ứ','Ừ','Ử','Ữ','Ự','Ｕ'],
		
		'v' : ['v','ʋ','ͮ','ᵛ','ᵥ','ᶹ','ṽ','ṿ','ⱱ','ｖ','ⱴ'],
		'V' : ['V','Ʋ','Ʌ','ʌ','ᴠ','ᶌ','Ṽ','Ṿ','Ｖ'],
		
		'w' : ['w','ŵ','ʷ','ᵂ','ẁ','ẃ','ẅ','ẇ','ẉ','ẘ','ⱳ','ｗ'],
		'W' : ['W','Ŵ','ʍ','ᴡ','Ẁ','Ẃ','Ẅ','Ẇ','Ẉ','Ⱳ','Ｗ'],
		
		'x' : ['x','̽','͓','ᶍ','ͯ','ẋ','ẍ','ₓ','ｘ'],
		'X' : ['X','ˣ','ͯ','Ẋ','Ẍ','☒','✕','✖','✗','✘','Ｘ'],
		
		'y' : ['y','ý','ÿ','ŷ','ȳ','ɏ','ʸ','ẏ','ỳ','ỵ','ỷ','ỹ','ｙ'],
		'Y' : ['Y','Ý','Ŷ','Ÿ','Ƴ','ƴ','Ȳ','Ɏ','ʎ','ʏ','Ẏ','Ỳ','Ỵ','Ỷ','Ỹ','Ｙ'],
		
		'z' : ['z','ź','ż','ž','ƶ','ȥ','ɀ','ʐ','ʑ','ᙆ','ᙇ','ᶻ','ᶼ','ᶽ','ẑ','ẓ','ẕ','ⱬ','ｚ'],
		'Z' : ['Z','Ź','Ż','Ž','Ƶ','Ȥ','ᴢ','ᵶ','Ẑ','Ẓ','Ẕ','Ⱬ','Ｚ']
	};

/*
 * Main function of the module which removes all diacritics from the received text
 */
module.exports = function (text) {
    var result = [];

	// iterate over all the characters of the received text
    for(var i=0; i<text.length; i++) {
        var searchChar = text.charAt(i);
        var foundChar = false;

		// iterate over all the diacritics
        for(var key in diacritics) {
            var indexChar = diacritics[key].indexOf(searchChar);
			
			// check if the current character is a diacritic
            if (indexChar !== -1) {
				// as the character is a diacritic, adds into the result array, the key of the found diacritic
                result.push(key);
                foundChar = true;
                break;
            }
        }

        // check if the character was not found
        if (!foundChar) {
			// as the character was not found, returns it
            result.push(searchChar);
        }
    }

    return result.join("");
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(249)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueGoodTable = undefined;

var _Table = __webpack_require__(244);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodTablePlugin = {
  install: function install(Vue) {
    Vue.component(_Table2.default.name, _Table2.default);
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(GoodTablePlugin);
}

exports.default = GoodTablePlugin;
exports.VueGoodTable = _Table2.default;

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-good-pagination',
  props: {
    styleClass: { default: 'table table-bordered' },
    total: { default: null },
    perPage: {},
    rtl: { default: false },
    customRowsPerPageDropdown: { default: function _default() {
        return [];
      } },
    paginateDropdownAllowAll: { default: true },

    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      rowsPerPageOptions: [],
      defaultRowsPerPageDropdown: [10, 20, 30, 40, 50]
    };
  },

  watch: {
    perPage: function perPage() {
      if (this.perPage) {
        this.currentPerPage = this.perPage;
      } else {
        this.currentPerPage = 10;
      }
      this.perPageChanged();
    },
    customRowsPerPageDropdown: function customRowsPerPageDropdown() {
      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.lenght !== 0) this.rowsPerPageOptions = this.customRowsPerPageDropdown;
    }
  },

  computed: {
    paginatedInfo: function paginatedInfo() {
      if (this.currentPerPage === -1) {
        return '1 - ' + this.total + ' ' + this.ofText + ' ' + this.total;
      }
      var first = (this.currentPage - 1) * this.currentPerPage + 1 ? (this.currentPage - 1) * this.currentPerPage + 1 : 1;

      if (first > this.total) {
        this.currentPage = 1;
        first = 1;
      }

      var last = Math.min(this.total, this.currentPerPage * this.currentPage);
      return first + ' - ' + last + ' ' + this.ofText + ' ' + this.total;
    },
    nextIsPossible: function nextIsPossible() {
      return this.currentPerPage === -1 ? false : this.total > this.currentPerPage * this.currentPage;
    },
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  },

  methods: {
    reset: function reset() {},
    nextPage: function nextPage() {
      if (this.currentPerPage === -1) return;
      if (this.nextIsPossible) ++this.currentPage;
      this.pageChanged();
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) --this.currentPage;
      this.pageChanged();
    },
    pageChanged: function pageChanged() {
      this.$emit('page-changed', { currentPage: this.currentPage });
    },
    perPageChanged: function perPageChanged(event) {
      if (event) {
        this.currentPerPage = parseInt(event.target.value);
      }
      this.$emit('per-page-changed', { currentPerPage: this.currentPerPage });
    },
    getRowsPerPageDropdown: function getRowsPerPageDropdown() {
      return this.rowsPerPageOptions;
    }
  },

  mounted: function mounted() {
    this.rowsPerPageOptions = this.defaultRowsPerPageDropdown;

    if (this.perPage) {
      this.currentPerPage = this.perPage;
      this.rowsPerPageOptions.push(this.perPage);
    }

    if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0) this.rowsPerPageOptions = this.customRowsPerPageDropdown;
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pagination_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_foreach__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_foreach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_foreach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_default__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__types_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_diacriticless__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_diacriticless___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_diacriticless__);











var dataTypes = {};
var coreDataTypes = __webpack_require__(252);
__WEBPACK_IMPORTED_MODULE_5_lodash_foreach___default()(coreDataTypes.keys(), function (key) {
  var compName = key.replace(/^\.\//, "").replace(/\.js/, "");
  dataTypes[compName] = coreDataTypes(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-good-table',
  components: {
    VueGoodPagination: __WEBPACK_IMPORTED_MODULE_4__Pagination_vue___default.a
  },
  props: {
    styleClass: { default: 'table table-bordered' },
    title: '',
    columns: {},
    rows: {},
    onClick: {},
    sortable: { default: true },
    lineNumbers: { default: false },
    defaultSortBy: { default: null },
    responsive: { default: true },
    rtl: { default: false },
    rowStyleClass: { default: null, type: [Function, String] },

    paginate: { default: false },
    perPage: {},
    customRowsPerPageDropdown: { default: function _default() {
        return [];
      } },
    paginateOnTop: { default: false },
    paginateDropdownAllowAll: { default: true },

    globalSearch: { default: false },
    searchTrigger: { default: null },
    externalSearchQuery: { default: null },
    globalSearchFn: { type: Function, default: null },

    globalSearchPlaceholder: { default: 'Search Table' },
    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      sortColumn: -1,
      sortType: 'asc',
      globalSearchTerm: '',
      columnFilters: {},
      filteredRows: [],
      timer: null,
      forceSearch: false,
      sortChanged: false,
      dataTypes: dataTypes || {}
    };
  },

  methods: {
    pageChangedEvent: function pageChangedEvent() {
      return {
        currentPage: this.currentPage,
        currentPerPage: this.currentPerPage,
        total: Math.floor(this.rows.length / this.currentPerPage)
      };
    },
    pageChanged: function pageChanged(pagination) {
      this.currentPage = pagination.currentPage;
      var pageChangedEvent = this.pageChangedEvent();
      this.$emit('pageChanged', pageChangedEvent);
    },
    perPageChanged: function perPageChanged(pagination) {
      this.currentPerPage = pagination.currentPerPage;
      var perPageChangedEvent = this.pageChangedEvent();
      this.$emit('perPageChanged', perPageChangedEvent);
    },
    sort: function sort(index) {
      if (!this.isSortableColumn(index)) return;
      if (this.sortColumn === index) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortType = 'asc';
        this.sortColumn = index;
      }
      this.sortChanged = true;
    },
    click: function click(row, index) {
      if (this.onClick) this.onClick(row, index);
    },
    searchTable: function searchTable() {
      if (this.searchTrigger == 'enter') {
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },
    collect: function collect(obj, field) {
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');
        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined') return undefined;else result = result[splitter[i]];
        }return result;
      }

      if (typeof field === 'function') return field(obj);else if (typeof field === 'string') return dig(obj, field);else return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      var value = this.collect(obj, column.field);
      if (value === undefined) return '';

      if (column.formatFn && typeof column.formatFn === 'function') {
        return column.formatFn(value);
      }

      var type = column.typeDef;
      return type.format(value, column);
    },
    formattedRow: function formattedRow(row) {
      var formattedRow = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.typedColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          if (col.field) {
            formattedRow[col.field] = this.collectFormatted(row, col);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formattedRow;
    },
    isSortableColumn: function isSortableColumn(index) {
      var sortable = this.columns[index].sortable;
      var isSortable = typeof sortable === 'boolean' ? sortable : this.sortable;
      return isSortable;
    },
    getHeaderClasses: function getHeaderClasses(column, index) {
      var isSortable = this.isSortableColumn(index);
      var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.getClasses(index, 'th'), {
        'sorting': isSortable,
        'sorting-desc': isSortable && this.sortColumn === index && this.sortType === 'desc',
        'sorting-asc': isSortable && this.sortColumn === index && this.sortType === 'asc'
      });
      return classes;
    },
    getClasses: function getClasses(index, element) {
      var _typedColumns$index = this.typedColumns[index],
          typeDef = _typedColumns$index.typeDef,
          custom = _typedColumns$index[element + 'Class'];

      var isRight = typeDef.isRight;
      if (this.rtl) isRight = true;
      var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'right-align': isRight,
        'left-align': !isRight
      }, custom, !!custom);
      return classes;
    },
    updateFilters: function updateFilters(column, value) {
      var _this = this;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$set(_this.columnFilters, column.field, value);
      }, 400);
    },
    filterRows: function filterRows() {
      var _this2 = this;

      var computedRows = this.originalRows;

      if (this.hasFilterRow) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.typedColumns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var col = _step2.value;

            if (col.filterable && this.columnFilters[col.field]) {
              computedRows = computedRows.filter(function (row) {
                if (col.filter) {
                  return col.filter(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                } else {
                  var typeDef = col.typeDef;
                  return typeDef.filterPredicate(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.filteredRows = computedRows;
    },
    getPlaceholder: function getPlaceholder(column) {
      var placeholder = column.placeholder || 'Filter ' + column.label;
      return placeholder;
    },
    getCurrentIndex: function getCurrentIndex(index) {
      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    getRowStyleClass: function getRowStyleClass(row) {
      var classes = '';
      this.onClick ? classes += 'clickable' : '';
      var rowStyleClasses = void 0;
      if (typeof this.rowStyleClass === 'function') {
        rowStyleClasses = this.rowStyleClass(row);
      } else {
        rowStyleClasses = this.rowStyleClass;
      }
      if (rowStyleClasses) {
        classes += ' ' + rowStyleClasses;
      }
      return classes;
    },
    populateInitialFilters: function populateInitialFilters() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.columns), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var col = _step3.value;

          if (typeof col.filterValue !== 'undefined' && col.filterValue !== null) {
            this.updateFilters(col, col.filterValue);
            this.$set(col, 'filterValue', undefined);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  },

  watch: {
    columnFilters: {
      handler: function handler() {
        this.filterRows();
      },
      deep: true
    },
    rows: {
      handler: function handler() {
        this.filterRows();
      },
      deep: true
    },
    columns: {
      handler: function handler() {
        this.populateInitialFilters();
      },
      deep: true
    }
  },

  computed: {
    tableStyleClasses: function tableStyleClasses() {
      var classes = this.styleClass;
      classes += this.responsive ? ' responsive' : '';
      return classes;
    },
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.globalSearch && !!this.globalSearchTerm && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },
    hasFilterRow: function hasFilterRow() {
      if (!this.globalSearch) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.columns), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var col = _step4.value;

            if (col.filterable) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      return false;
    },
    processedRows: function processedRows() {
      var _this3 = this;

      var computedRows = this.filteredRows;

      if (this.globalSearchAllowed) {
        var filteredRows = [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.originalRows), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var row = _step5.value;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.columns), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var col = _step6.value;

                if (col.globalSearchDisabled) {
                  continue;
                }

                if (this.globalSearchFn) {
                  var foundMatch = this.globalSearchFn(row, col, this.collectFormatted(row, col), this.searchTerm);
                  if (foundMatch) {
                    filteredRows.push(row);
                    break;
                  }
                } else {
                  var tableValue = this.collectFormatted(row, col);
                  if (typeof tableValue !== 'undefined' && tableValue !== null) {
                    tableValue = __WEBPACK_IMPORTED_MODULE_7_diacriticless___default()(String(tableValue).toLowerCase());

                    var searchTerm = __WEBPACK_IMPORTED_MODULE_7_diacriticless___default()(this.searchTerm.toLowerCase());

                    if (tableValue.search(searchTerm) > -1) {
                      filteredRows.push(row);
                      break;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        computedRows = filteredRows;
      }

      if (this.sortColumn !== -1 && this.isSortableColumn(this.sortColumn) && (this.searchTrigger !== 'enter' || this.sortChanged)) {

        this.sortChanged = false;

        computedRows = computedRows.sort(function (x, y) {
          if (!_this3.columns[_this3.sortColumn]) return 0;

          var xvalue = _this3.collect(x, _this3.columns[_this3.sortColumn].field);
          var yvalue = _this3.collect(y, _this3.columns[_this3.sortColumn].field);

          var sortFn = _this3.columns[_this3.sortColumn].sortFn;
          if (sortFn && typeof sortFn === 'function') {
            return sortFn(xvalue, yvalue, _this3.columns[_this3.sortColumn]) * (_this3.sortType === 'desc' ? -1 : 1);
          }

          var typeDef = _this3.typedColumns[_this3.sortColumn].typeDef;
          return typeDef.compare(xvalue, yvalue, _this3.columns[_this3.sortColumn]) * (_this3.sortType === 'desc' ? -1 : 1);
        });
      }

      if (this.searchTrigger === 'enter') {
        this.filteredRows = computedRows;
      }

      return computedRows;
    },
    paginated: function paginated() {
      var paginatedRows = this.processedRows;

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage;

        if (pageStart >= this.processedRows.length || this.currentPerPage === -1) {
          this.currentPage = 1;
          pageStart = 0;
        }

        var pageEnd = paginatedRows.length + 1;

        if (this.currentPerPage !== -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      }
      return paginatedRows;
    },
    originalRows: function originalRows() {
      var rows = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.rows));

      for (var index = 0; index < rows.length; index++) {
        rows[index].originalIndex = index;
      }

      return rows;
    },
    typedColumns: function typedColumns() {
      var columns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.columns, []);
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(columns), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var column = _step7.value;

          column.typeDef = this.dataTypes[column.type] || __WEBPACK_IMPORTED_MODULE_6__types_default___default.a;
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return columns;
    }
  },

  mounted: function mounted() {
    this.filteredRows = this.originalRows;

    this.populateInitialFilters();

    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }

    if (this.defaultSortBy) {
      for (var index = 0; index < this.columns.length; index++) {
        var col = this.columns[index];
        if (col.field === this.defaultSortBy.field) {
          this.sortColumn = index;
          this.sortType = this.defaultSortBy.type || 'asc';
          this.sortChanged = true;
          break;
        }
      }
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _esm = __webpack_require__(176);

var _lodash = __webpack_require__(24);

var _lodash2 = _interopRequireDefault(_lodash);

var _default = __webpack_require__(15);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var date = (0, _lodash2.default)(_default2.default);

date.isRight = true;

date.compare = function compare(x, y, column) {
  function cook(d) {
    if (column && column.inputFormat) {
      return (0, _esm.parse)('' + d, '' + column.inputFormat, new Date());
    }
    return d;
  }
  x = cook(x);
  y = cook(y);
  if (!(0, _esm.isValid)(x)) {
    return -1;
  }
  if (!(0, _esm.isValid)(y)) {
    return 1;
  }
  return (0, _esm.compareAsc)(x, y);
};

date.format = function formatDate(v, column) {
  var date = (0, _esm.parse)(v, column.inputFormat, new Date());
  return (0, _esm.format)(date, column.outputFormat);
};

exports.default = date;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(24);

var _lodash2 = _interopRequireDefault(_lodash);

var _number = __webpack_require__(25);

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decimal = (0, _lodash2.default)(_number2.default);
decimal.format = function formatDecimal(v) {
  return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};

exports.default = decimal;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(24);

var _lodash2 = _interopRequireDefault(_lodash);

var _number = __webpack_require__(25);

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var percentage = (0, _lodash2.default)(_number2.default);

percentage.format = function formatPercent(v) {
  return parseFloat(v * 100).toFixed(2) + '%';
};

exports.default = percentage;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(100), __esModule: true };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(95);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
__webpack_require__(128);
module.exports = __webpack_require__(124);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(4);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(126);
module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(127);
var $Object = __webpack_require__(4).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(32);
var toLength = __webpack_require__(121);
var toAbsoluteIndex = __webpack_require__(120);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(40);
var TAG = __webpack_require__(6)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(101);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(28)(function () {
  return Object.defineProperty(__webpack_require__(41)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(112);
var descriptor = __webpack_require__(46);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(114);
var pIE = __webpack_require__(117);
var toObject = __webpack_require__(49);
var IObject = __webpack_require__(43);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(28)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(113);
var enumBugKeys = __webpack_require__(42);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(41)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(106).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(19);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(45);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(17);
var toObject = __webpack_require__(49);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(17);
var toIObject = __webpack_require__(32);
var arrayIndexOf = __webpack_require__(103)(false);
var IE_PROTO = __webpack_require__(30)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(26);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(31);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(29);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(104);
var ITERATOR = __webpack_require__(6)('iterator');
var Iterators = __webpack_require__(18);
module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var get = __webpack_require__(123);
module.exports = __webpack_require__(4).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(102);
var step = __webpack_require__(109);
var Iterators = __webpack_require__(18);
var toIObject = __webpack_require__(32);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(44)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(27);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(111) });


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(27);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(19).f });


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(119)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(44)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
var global = __webpack_require__(5);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(18);
var TO_STRING_TAG = __webpack_require__(6)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(51)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Utility styles\n************************************************/\n.right-align[data-v-a440e668]{\n  text-align: right;\n}\n.left-align[data-v-a440e668]{\n  text-align: left;\n}\n.center-align[data-v-a440e668]{\n  text-align: center;\n}\n.pull-left[data-v-a440e668]{\n  float:  left !important;\n}\n.pull-right[data-v-a440e668]{\n  float:  right !important;\n}\n.clearfix[data-v-a440e668]::after {\n  display: block;\n  content: \"\";\n  clear: both;\n}\n\n/* Table footer specific styles\n************************************************/\n.table-footer[data-v-a440e668]{\n  /* background-color: rgba(35,41,53, 0.03); */\n  background-color: rgba(35,41,53,0.05);\n  border: 1px solid #DDD;\n  margin:  0;\n  padding:  1rem;\n  font-size: 14px;\n  color:  rgba(0, 0, 0, 0.44);\n}\n.table-footer>div[data-v-a440e668]{\n  display: inline-block;\n}\n.pagination-controls>*[data-v-a440e668]{\n  display: inline-block;\n}\n.pagination-controls a[data-v-a440e668]{\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.66);\n  font-size: 14px;\n  font-weight: 600;\n  opacity: 0.8;\n}\n.pagination-controls a.disabled[data-v-a440e668],\n.pagination-controls a.disabled[data-v-a440e668]:hover {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.pagination-controls a[data-v-a440e668]:hover{\n  opacity: 1;\n}\n.pagination-controls a span[data-v-a440e668]{\n  display: inline-block;\n  vertical-align: middle;\n}\n.pagination-controls .info[data-v-a440e668]{\n  margin:  0px 15px;\n  font-size: 13px;\n  font-weight: bold;\n  color:  rgba(0, 0, 0, 0.40);\n}\n.pagination-controls a .chevron[data-v-a440e668]{\n  width:  24px;\n  height:  24px;\n  border-radius: 15%;\n  /* border:  1px solid rgba(35,41,53,0.2);\n  background-color: #fff; */\n  position:  relative;\n  margin:  0px 8px;\n}\n.pagination-controls .chevron[data-v-a440e668]::after{\n  content:  '';\n  position:  absolute;\n  display:  block;\n  left:  50%;\n  top:  50%;\n  margin-top:  -6px;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n}\n.pagination-controls .chevron.left[data-v-a440e668]::after{\n  border-right:  6px solid rgba(0, 0, 0, 0.66);\n  margin-left:  -3px;\n}\n.pagination-controls .chevron.right[data-v-a440e668]::after{\n  border-left:  6px solid rgba(0, 0, 0, 0.66);\n  margin-left:  -3px;\n}\n.table-footer select[data-v-a440e668] {\n  display: inline-block;\n  background-color: transparent;\n  width: auto;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  height: auto;\n  font-size: 14px;\n  margin-left: 8px;\n  color:  rgba(0, 0, 0, 0.55);\n  font-weight: bold;\n}\n.table-footer .perpage-count[data-v-a440e668]{\n  color:  rgba(0, 0, 0, 0.55);\n  font-weight: bold;\n}\n@media only screen and (max-width: 750px) {\n  /* on small screens hide the info */\n.pagination-controls .info[data-v-a440e668]{\n    display:  none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(51)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Utility styles\n************************************************/\n.right-align[data-v-d89f00e8]{\n  text-align: right;\n}\n.left-align[data-v-d89f00e8]{\n  text-align: left;\n}\n.center-align[data-v-d89f00e8]{\n  text-align: center;\n}\n.pull-left[data-v-d89f00e8]{\n  float:  left !important;\n}\n.pull-right[data-v-d89f00e8]{\n  float:  right !important;\n}\n.clearfix[data-v-d89f00e8]::after {\n  display: block;\n  content: \"\";\n  clear: both;\n}\n\n/* Table specific styles\n************************************************/\ntable[data-v-d89f00e8]{\n    border-collapse: collapse;\n    background-color: transparent;\n    margin-bottom:  0px;\n}\n.table[data-v-d89f00e8]{\n    width: 100%;\n    max-width: 100%;\n    table-layout: auto;\n}\n.table.table-striped tbody tr[data-v-d89f00e8]:nth-of-type(odd) {\n      background-color: rgba(35,41,53,.05);\n}\n.table.table-bordered td[data-v-d89f00e8], .table-bordered th[data-v-d89f00e8] {\n      border: 1px solid #DDD;\n}\n.table td[data-v-d89f00e8], .table th[data-v-d89f00e8]:not(.line-numbers) {\n    padding: .75rem 1.5rem .75rem .75rem;\n    vertical-align: top;\n    border-top: 1px solid #ddd;\n}\n.rtl .table td[data-v-d89f00e8], .rtl .table th[data-v-d89f00e8]:not(.line-numbers) {\n    padding: .75rem .75rem .75rem 1.5rem;\n}\n.table.condensed td[data-v-d89f00e8], .table.condensed th[data-v-d89f00e8] {\n    padding: .4rem .4rem .4rem .4rem;\n}\n.table thead th[data-v-d89f00e8], .table.condensed thead th[data-v-d89f00e8] {\n    vertical-align: bottom;\n    border-bottom:  2px solid #ddd;\n    padding-right: 1.5rem;\n    background-color: rgba(35,41,53,0.03);\n}\n.rtl .table thead th[data-v-d89f00e8], .rtl .table.condensed thead th[data-v-d89f00e8] {\n    padding-left:  1.5rem;\n    padding-right:  .75rem;\n}\ntr.clickable[data-v-d89f00e8] {\n    cursor: pointer;\n}\n.table input[type=\"text\"][data-v-d89f00e8], .table select[data-v-d89f00e8]{\n    box-sizing: border-box;\n    display: block;\n    width: calc(100%);\n    height: 34px;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #555;\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgba(35,41,53,.075);\n    box-shadow: inset 0 1px 1px rgba(35,41,53,.075);\n    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\n    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n}\ntable th.sorting-asc[data-v-d89f00e8],\n  table th.sorting-desc[data-v-d89f00e8] {\n    color: rgba(0, 0, 0, 0.66);\n    position: relative;\n}\ntable th.sorting[data-v-d89f00e8]:after,\n  table th.sorting-asc[data-v-d89f00e8]:after  {\n    font-family: 'Material Icons';\n    position:  absolute;\n    height:  0px;\n    width:  0px;\n    content: '';\n    display: none;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid rgba(0, 0, 0, 0.66);\n    margin-top:  6px;\n    margin-left:  5px;\n}\n.rtl table th.sorting[data-v-d89f00e8]:after,\n  .rtl table th.sorting-asc[data-v-d89f00e8]:after{\n    margin-right:  5px;\n    margin-left:  0px;\n}\ntable th.sorting[data-v-d89f00e8]:hover:after{\n    display: inline-block;\n    border-bottom-color: rgba(35,41,53,0.25);\n}\ntable th.sorting-asc[data-v-d89f00e8]:after,\n  table th.sorting-desc[data-v-d89f00e8]:after {\n    display: inline-block;\n}\ntable th.sorting-desc[data-v-d89f00e8]:after {\n    border-top:  6px solid rgba(0, 0, 0, 0.66);\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: none;\n    margin-top:  8px;\n}\n.responsive[data-v-d89f00e8] {\n  width: 100%;\n  overflow-x: auto;\n}\n\n/* Table header specific styles\n************************************************/\n.table-header[data-v-d89f00e8]{\n  padding:  .75rem;\n}\n.table-header .table-title[data-v-d89f00e8]{\n  margin:  0px;\n  font-size: 18px;\n}\n\n  /* Global Search\n  **********************************************/\n.global-search[data-v-d89f00e8]{\n    position:  relative;\n    padding-left: 40px;\n}\n.global-search-icon[data-v-d89f00e8]{\n    position:  absolute;\n    left:  0px;\n    max-width:  32px;\n}\n.global-search-icon > img[data-v-d89f00e8]{\n    max-width:  100%;\n    margin-top:  8px;\n    opacity: 0.5;\n}\ntable .global-search-input[data-v-d89f00e8]{\n   width:  calc(100% - 30px);\n}\n\n  /* Line numbers\n  **********************************************/\ntable th.line-numbers[data-v-d89f00e8], .table.condensed th.line-numbers[data-v-d89f00e8]{\n    background-color: rgba(35,41,53,0.05);\n    padding-left:  3px;\n    padding-right:  3px;\n    word-wrap: break-word;\n    width: 45px;\n    text-align: center;\n}\n.good-table.rtl[data-v-d89f00e8]{\n    direction: rtl;\n}\n.text-disabled[data-v-d89f00e8]{\n    color:  #aaa;\n}\n\n/* magnifying glass css */\n.magnifying-glass[data-v-d89f00e8]\n{\n  margin-top: 3px;\n  display: block;\n  width: 18px;\n  height: 18px;\n  border: 3px solid #ccc;\n  position: relative;\n  border-radius: 50%;\n}\n.magnifying-glass[data-v-d89f00e8]::before\n{\n  content: \"\";\n  display: block;\n  position: absolute;\n  right: -10px;\n  bottom: -6px;\n  background: #ccc;\n  width: 10px;\n  height: 5px;\n  border-radius: 2px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      -o-transform: rotate(45deg);\n}\n\n", ""]);

// exports


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addUTCMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function addUTCMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var amount = Number(dirtyAmount)
  date.setUTCMinutes(date.getUTCMinutes() + amount)
  return date
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


var MILLISECONDS_IN_DAY = 86400000

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var timestamp = date.getTime()
  date.setUTCMonth(0, 1)
  date.setUTCHours(0, 0, 0, 0)
  var startOfYearTimestamp = date.getTime()
  var difference = timestamp - startOfYearTimestamp
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  var options = dirtyOptions || {}
  var locale = options.locale
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn)
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = Number(dirtyDay)

  var currentDay = date.getUTCDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay

  date.setUTCDate(date.getUTCDate() + diff)
  return date
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  var day = Number(dirtyDay)

  if (day % 7 === 0) {
    day = day - 7
  }

  var weekStartsOn = 1
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var currentDay = date.getUTCDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay

  date.setUTCDate(date.getUTCDate() + diff)
  return date
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getUTCISOWeek_index_js__ = __webpack_require__(52);



// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var isoWeek = Number(dirtyISOWeek)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getUTCISOWeek_index_js__["a" /* default */])(date, dirtyOptions) - isoWeek
  date.setUTCDate(date.getUTCDate() - diff * 7)
  return date
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeekYear_index_js__ = __webpack_require__(33);



var MILLISECONDS_IN_DAY = 86400000

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeekYear (dirtyDate, dirtyISOYear, dirtyOptions) {
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var isoYear = Number(dirtyISOYear)
  var dateStartOfYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeekYear_index_js__["a" /* default */])(date, dirtyOptions)
  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4)
  fourthOfJanuary.setUTCHours(0, 0, 0, 0)
  date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeekYear_index_js__["a" /* default */])(fourthOfJanuary, dirtyOptions)
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = areIntervalsOverlapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval?
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
 * @param {Options} [options] - the object with options. See [Options]{@link docs/types/Options}
 * @returns {Boolean} whether the time intervals are overlapping
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
 *   {start: new Date(2014, 0, 17), end: new Date(2014, 0, 21)}
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
 *   {start: new Date(2014, 0, 21), end: new Date(2014, 0, 22)}
 * )
 * //=> false
 */
function areIntervalsOverlapping (dirtyIntervalLeft, dirtyIntervalRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var intervalLeft = dirtyIntervalLeft || {}
  var intervalRight = dirtyIntervalRight || {}
  var leftStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.start, dirtyOptions).getTime()
  var leftEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.end, dirtyOptions).getTime()
  var rightStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.start, dirtyOptions).getTime()
  var rightEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.end, dirtyOptions).getTime()

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval')
  }

  return leftStartTime < rightEndTime && rightStartTime < leftEndTime
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closestIndexTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateToCompare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare, dirtyOptions)

  if (isNaN(dateToCompare)) {
    return NaN
  }

  var timeToCompare = dateToCompare.getTime()

  var datesArray
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = []

  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray

  // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray)
  }

  var result
  var minDistance
  datesArray.forEach(function (dirtyDate, index) {
    var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)

    if (isNaN(currentDate)) {
      result = NaN
      minDistance = NaN
      return
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closestTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateToCompare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare, dirtyOptions)

  if (isNaN(dateToCompare)) {
    return new Date(NaN)
  }

  var timeToCompare = dateToCompare.getTime()

  var datesArray
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = []

  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray

  // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray)
  }

  var result
  var minDistance
  datesArray.forEach(function (dirtyDate) {
    var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)

    if (isNaN(currentDate)) {
      result = new Date(NaN)
      minDistance = NaN
      return
    }

    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareDesc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var diff = dateLeft.getTime() - dateRight.getTime()

  if (diff > 0) {
    return -1
  } else if (diff < 0) {
    return 1
  // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff
  }
}


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarISOWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeek_index_js__ = __webpack_require__(3);


var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar ISO weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var startOfISOWeekLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeek_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var startOfISOWeekRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeek_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(0);



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of calendar quarters
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a" /* default */])(dateLeft, dirtyOptions) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a" /* default */])(dateRight, dirtyOptions)

  return yearDiff * 4 + quarterDiff
}


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(23);


var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var startOfWeekLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(22);


var MILLISECONDS_IN_HOUR = 3600000

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, dirtyOptions) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInISOYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOYears_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subISOYears_index_js__ = __webpack_require__(82);





/**
 * @name differenceInISOYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions)
  var difference = Math.abs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOYears_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions))
  dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__subISOYears_index_js__["a" /* default */])(dateLeft, sign * difference, dirtyOptions)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions) === -sign
  return sign * (difference - isLastISOYearNotFull)
}


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(22);


var MILLISECONDS_IN_MINUTE = 60000

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, dirtyOptions) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__ = __webpack_require__(35);


/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, dirtyOptions) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__ = __webpack_require__(63);


/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, dirtyOptions) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(2);




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions)
  var difference = Math.abs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight, dirtyOptions) === -sign
  return sign * (difference - isLastYearNotFull)
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eachDayOfInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDayOfInterval (dirtyInterval, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var interval = dirtyInterval || {}
  var startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start, dirtyOptions)
  var endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end, dirtyOptions)

  var endTime = endDate.getTime()

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(currentDate, dirtyOptions))
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dates
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfHour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of an hour
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setMinutes(59, 59, 999)
  return date
}


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__ = __webpack_require__(1);



/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var endOfWeekOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__["a" /* default */])(dirtyOptions)
  endOfWeekOptions.weekStartsOn = 1
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__["a" /* default */])(dirtyDate, endOfWeekOptions)
}


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(3);



/**
 * @name endOfISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear, dirtyOptions)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfMinute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a minute
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setSeconds(59, 999)
  return date
}


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfSecond;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a second
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setMilliseconds(999)
  return date
}


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(53);




var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getUTCMonth() + 1
  },

  // Month: 1st, 2nd, ..., 12th
  'Mo': function (date, options) {
    var month = date.getUTCMonth() + 1
    return options.locale.localize.ordinalNumber(month, {unit: 'month'})
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getUTCMonth() + 1, 2)
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'short'})
  },

  // Month: January, February, ..., December
  'MMMM': function (date, options) {
    return options.locale.localize.month(date.getUTCMonth(), {type: 'long'})
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getUTCMonth() + 1) / 3)
  },

  // Quarter: 1st, 2nd, 3rd, 4th
  'Qo': function (date, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3)
    return options.locale.localize.ordinalNumber(quarter, {unit: 'quarter'})
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getUTCDate()
  },

  // Day of month: 1st, 2nd, ..., 31st
  'Do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDate(), {unit: 'dayOfMonth'})
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getUTCDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date)
  },

  // Day of year: 1st, 2nd, ..., 366th
  'DDDo': function (date, options) {
    return options.locale.localize.ordinalNumber(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date), {unit: 'dayOfYear'})
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date), 3)
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'narrow'})
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'short'})
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': function (date, options) {
    return options.locale.localize.weekday(date.getUTCDay(), {type: 'long'})
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getUTCDay()
  },

  // Day of week: 0th, 1st, 2nd, ..., 6th
  'do': function (date, options) {
    return options.locale.localize.ordinalNumber(date.getUTCDay(), {unit: 'dayOfWeek'})
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getUTCDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date)
  },

  // ISO week: 1st, 2nd, ..., 53th
  'Wo': function (date, options) {
    return options.locale.localize.ordinalNumber(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date), {unit: 'isoWeek'})
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getUTCFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getUTCHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getUTCHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getUTCHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getUTCMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getUTCMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getUTCSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getUTCSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getUTCMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getUTCMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date, options) {
    var originalDate = options._originalDate || date
    return formatTimezone(originalDate.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date, options) {
    var originalDate = options._originalDate || date
    return formatTimezone(originalDate.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date, options) {
    var originalDate = options._originalDate || date
    return Math.floor(originalDate.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date, options) {
    var originalDate = options._originalDate || date
    return originalDate.getTime()
  },

  // AM, PM
  'A': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'uppercase'})
  },

  // am, pm
  'a': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'lowercase'})
  },

  // a.m., p.m.
  'aa': function (date, options) {
    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'long'})
  }
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

/* harmony default export */ __webpack_exports__["a"] = (formatters);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differenceInMonths_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locale_en_US_index_js__ = __webpack_require__(13);







var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} date - the date
 * @param {Date|String|Number} baseDate - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = formatDistance(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = formatDistance(
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = formatDistance(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function formatDistance (dirtyDate, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_5__locale_en_US_index_js__["a" /* default */]

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property')
  }

  var comparison = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a" /* default */])(dirtyDate, dirtyBaseDate, options)

  if (isNaN(comparison)) {
    return 'Invalid Date'
  }

  var localizeOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__["a" /* default */])(options)
  localizeOptions.addSuffix = Boolean(options.addSuffix)
  localizeOptions.comparison = comparison

  var dateLeft
  var dateRight
  if (comparison > 0) {
    dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)
    dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate, options)
  } else {
    dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate, options)
    dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)
  }

  var seconds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__["a" /* default */])(dateRight, dateLeft, options)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions)
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions)
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return locale.formatDistance('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return locale.formatDistance('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return locale.formatDistance('aboutXMonths', months, localizeOptions)
  }

  months = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__differenceInMonths_index_js__["a" /* default */])(dateRight, dateLeft, options)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions)
    }
  }
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistanceStrict;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_cloneObject_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_en_US_index_js__ = __webpack_require__(13);






var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} date - the date
 * @param {Date|String|Number} baseDate - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='floor'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 's', 'm', 'h', 'd', 'M' or 'Y'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = formatDistanceStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = formatDistanceStrict(
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = formatDistanceStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = formatDistanceStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', roundingMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = formatDistanceStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function formatDistanceStrict (dirtyDate, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_4__locale_en_US_index_js__["a" /* default */]

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property')
  }

  var comparison = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a" /* default */])(dirtyDate, dirtyBaseDate, options)

  if (isNaN(comparison)) {
    return 'Invalid Date'
  }

  var localizeOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_cloneObject_index_js__["a" /* default */])(options)
  localizeOptions.addSuffix = Boolean(options.addSuffix)
  localizeOptions.comparison = comparison

  var dateLeft
  var dateRight
  if (comparison > 0) {
    dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)
    dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate, options)
  } else {
    dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate, options)
    dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)
  }

  var roundingMethod = options.roundingMethod === undefined ? 'floor' : String(options.roundingMethod)
  var roundingMethodFn

  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'")
  }

  var seconds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__["a" /* default */])(dateRight, dateLeft, dirtyOptions)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = roundingMethodFn(seconds / 60) - offset

  var unit
  if (options.unit === undefined) {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  } else {
    unit = String(options.unit)
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return locale.formatDistance('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return locale.formatDistance('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    var hours = roundingMethodFn(minutes / 60)
    return locale.formatDistance('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    var days = roundingMethodFn(minutes / MINUTES_IN_DAY)
    return locale.formatDistance('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    var months = roundingMethodFn(minutes / MINUTES_IN_MONTH)
    return locale.formatDistance('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    var years = roundingMethodFn(minutes / MINUTES_IN_YEAR)
    return locale.formatDistance('xYears', years, localizeOptions)
  }

  throw new RangeError("unit must be 's', 'm', 'h', 'd', 'M' or 'Y'")
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_index_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subMinutes_index_js__ = __webpack_require__(39);






/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 a.m. |
 * | Last day                  | yesterday at 04:30 a.m.   |
 * | Same day                  | today at 04:30 a.m.       |
 * | Next day                  | tomorrow at 04:30 a.m.    |
 * | Next 6 days               | Sunday at 04:30 a.m.      |
 * | Other                     | 12/31/2017                |
 *
 * @param {Date|String|Number} date - the date to format
 * @param {Date|String|Number} baseDate - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the date in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.locale` must contain `formatRelative` property
 */
function formatRelative (dirtyDate, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var baseDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyBaseDate, dirtyOptions)

  var options = dirtyOptions || {}
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__["a" /* default */]

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  if (!locale.formatRelative) {
    throw new RangeError('locale must contain formatRelative property')
  }

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a" /* default */])(date, baseDate, options)

  if (isNaN(diff)) {
    return 'Invalid Date'
  }

  var token
  if (diff < -6) {
    token = 'other'
  } else if (diff < -1) {
    token = 'lastWeek'
  } else if (diff < 0) {
    token = 'yesterday'
  } else if (diff < 1) {
    token = 'today'
  } else if (diff < 2) {
    token = 'tomorrow'
  } else if (diff < 7) {
    token = 'nextWeek'
  } else {
    token = 'other'
  }

  var utcDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__subMinutes_index_js__["a" /* default */])(date, date.getTimezoneOffset(), options)
  var utcBaseDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__subMinutes_index_js__["a" /* default */])(baseDate, date.getTimezoneOffset(), options)
  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, options)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__format_index_js__["a" /* default */])(date, formatStr, options)
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the day of week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = date.getDay()
  return day
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(12);




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the day of year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a" /* default */])(date, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a" /* default */])(date, dirtyOptions), dirtyOptions)
  var dayOfYear = diff + 1
  return dayOfYear
}


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__ = __webpack_require__(71);



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of days in a year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)

  if (isNaN(date)) {
    return NaN
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__["a" /* default */])(date, dirtyOptions) ? 366 : 365
}


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var hours = date.getHours()
  return hours
}


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeeksInYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(34);



var MILLISECONDS_IN_WEEK = 604800000

/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of ISO weeks in a year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var thisYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var nextYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a" /* default */])(thisYear, 60, dirtyOptions), dirtyOptions)
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the milliseconds
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var minutes = date.getMinutes()
  return minutes
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var month = date.getMonth()
  return month
}


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOverlappingDaysInIntervals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the number of days that overlap in two time intervals
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
 *   {start: new Date(2014, 0, 17), end: new Date(2014, 0, 21)}
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   {start: new Date(2014, 0, 10), end: new Date(2014, 0, 20)},
 *   {start: new Date(2014, 0, 21), end: new Date(2014, 0, 22)}
 * )
 * //=> 0
 */
function getOverlappingDaysInIntervals (dirtyIntervalLeft, dirtyIntervalRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var intervalLeft = dirtyIntervalLeft || {}
  var intervalRight = dirtyIntervalRight || {}
  var leftStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.start, dirtyOptions).getTime()
  var leftEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.end, dirtyOptions).getTime()
  var rightStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.start, dirtyOptions).getTime()
  var rightEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.end, dirtyOptions).getTime()

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval')
  }

  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = rightStartTime < leftStartTime
    ? leftStartTime
    : rightStartTime

  var overlapEndDate = rightEndTime > leftEndTime
    ? leftEndTime
    : rightEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var seconds = date.getSeconds()
  return seconds
}


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var timestamp = date.getTime()
  return timestamp
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()
  return year
}


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addDays", function() { return __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addHours", function() { return __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addISOYears_index_js__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addISOYears", function() { return __WEBPACK_IMPORTED_MODULE_2__addISOYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addMilliseconds_index_js__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_3__addMilliseconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addMinutes_index_js__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addMinutes", function() { return __WEBPACK_IMPORTED_MODULE_4__addMinutes_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addMonths_index_js__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addMonths", function() { return __WEBPACK_IMPORTED_MODULE_5__addMonths_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addQuarters_index_js__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addQuarters", function() { return __WEBPACK_IMPORTED_MODULE_6__addQuarters_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addSeconds_index_js__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addSeconds", function() { return __WEBPACK_IMPORTED_MODULE_7__addSeconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addWeeks_index_js__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addWeeks", function() { return __WEBPACK_IMPORTED_MODULE_8__addWeeks_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addYears_index_js__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addYears", function() { return __WEBPACK_IMPORTED_MODULE_9__addYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__areIntervalsOverlapping_index_js__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areIntervalsOverlapping", function() { return __WEBPACK_IMPORTED_MODULE_10__areIntervalsOverlapping_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__closestIndexTo_index_js__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closestIndexTo", function() { return __WEBPACK_IMPORTED_MODULE_11__closestIndexTo_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__closestTo_index_js__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closestTo", function() { return __WEBPACK_IMPORTED_MODULE_12__closestTo_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__compareAsc_index_js__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compareAsc", function() { return __WEBPACK_IMPORTED_MODULE_13__compareAsc_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__compareDesc_index_js__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compareDesc", function() { return __WEBPACK_IMPORTED_MODULE_14__compareDesc_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__differenceInCalendarDays_index_js__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarDays", function() { return __WEBPACK_IMPORTED_MODULE_15__differenceInCalendarDays_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__differenceInCalendarISOWeeks_index_js__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOWeeks", function() { return __WEBPACK_IMPORTED_MODULE_16__differenceInCalendarISOWeeks_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__differenceInCalendarISOYears_index_js__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOYears", function() { return __WEBPACK_IMPORTED_MODULE_17__differenceInCalendarISOYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__differenceInCalendarMonths_index_js__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarMonths", function() { return __WEBPACK_IMPORTED_MODULE_18__differenceInCalendarMonths_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__differenceInCalendarQuarters_index_js__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarQuarters", function() { return __WEBPACK_IMPORTED_MODULE_19__differenceInCalendarQuarters_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarWeeks_index_js__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarWeeks", function() { return __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarWeeks_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarYears_index_js__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInCalendarYears", function() { return __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__differenceInDays_index_js__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInDays", function() { return __WEBPACK_IMPORTED_MODULE_22__differenceInDays_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__differenceInHours_index_js__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInHours", function() { return __WEBPACK_IMPORTED_MODULE_23__differenceInHours_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__differenceInISOYears_index_js__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInISOYears", function() { return __WEBPACK_IMPORTED_MODULE_24__differenceInISOYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__differenceInMilliseconds_index_js__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_25__differenceInMilliseconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__differenceInMinutes_index_js__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInMinutes", function() { return __WEBPACK_IMPORTED_MODULE_26__differenceInMinutes_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__differenceInMonths_index_js__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInMonths", function() { return __WEBPACK_IMPORTED_MODULE_27__differenceInMonths_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__differenceInQuarters_index_js__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInQuarters", function() { return __WEBPACK_IMPORTED_MODULE_28__differenceInQuarters_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__differenceInSeconds_index_js__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInSeconds", function() { return __WEBPACK_IMPORTED_MODULE_29__differenceInSeconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__differenceInWeeks_index_js__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInWeeks", function() { return __WEBPACK_IMPORTED_MODULE_30__differenceInWeeks_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__differenceInYears_index_js__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "differenceInYears", function() { return __WEBPACK_IMPORTED_MODULE_31__differenceInYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__eachDayOfInterval_index_js__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eachDayOfInterval", function() { return __WEBPACK_IMPORTED_MODULE_32__eachDayOfInterval_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__endOfDay_index_js__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfDay", function() { return __WEBPACK_IMPORTED_MODULE_33__endOfDay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__endOfHour_index_js__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfHour", function() { return __WEBPACK_IMPORTED_MODULE_34__endOfHour_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__endOfISOWeek_index_js__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_35__endOfISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__endOfISOYear_index_js__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfISOYear", function() { return __WEBPACK_IMPORTED_MODULE_36__endOfISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__endOfMinute_index_js__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfMinute", function() { return __WEBPACK_IMPORTED_MODULE_37__endOfMinute_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__endOfMonth_index_js__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfMonth", function() { return __WEBPACK_IMPORTED_MODULE_38__endOfMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__endOfQuarter_index_js__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfQuarter", function() { return __WEBPACK_IMPORTED_MODULE_39__endOfQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__endOfSecond_index_js__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfSecond", function() { return __WEBPACK_IMPORTED_MODULE_40__endOfSecond_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__endOfWeek_index_js__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfWeek", function() { return __WEBPACK_IMPORTED_MODULE_41__endOfWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__endOfYear_index_js__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "endOfYear", function() { return __WEBPACK_IMPORTED_MODULE_42__endOfYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__format_index_js__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_43__format_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__formatDistance_index_js__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatDistance", function() { return __WEBPACK_IMPORTED_MODULE_44__formatDistance_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__formatDistanceStrict_index_js__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatDistanceStrict", function() { return __WEBPACK_IMPORTED_MODULE_45__formatDistanceStrict_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__formatRelative_index_js__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatRelative", function() { return __WEBPACK_IMPORTED_MODULE_46__formatRelative_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__getDate_index_js__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDate", function() { return __WEBPACK_IMPORTED_MODULE_47__getDate_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__getDay_index_js__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDay", function() { return __WEBPACK_IMPORTED_MODULE_48__getDay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__getDayOfYear_index_js__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDayOfYear", function() { return __WEBPACK_IMPORTED_MODULE_49__getDayOfYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__getDaysInMonth_index_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDaysInMonth", function() { return __WEBPACK_IMPORTED_MODULE_50__getDaysInMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__getDaysInYear_index_js__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDaysInYear", function() { return __WEBPACK_IMPORTED_MODULE_51__getDaysInYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__getHours_index_js__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getHours", function() { return __WEBPACK_IMPORTED_MODULE_52__getHours_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__getISODay_index_js__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getISODay", function() { return __WEBPACK_IMPORTED_MODULE_53__getISODay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__getISOWeek_index_js__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_54__getISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__getISOWeeksInYear_index_js__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getISOWeeksInYear", function() { return __WEBPACK_IMPORTED_MODULE_55__getISOWeeksInYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__getISOYear_index_js__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getISOYear", function() { return __WEBPACK_IMPORTED_MODULE_56__getISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__getMilliseconds_index_js__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_57__getMilliseconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__getMinutes_index_js__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getMinutes", function() { return __WEBPACK_IMPORTED_MODULE_58__getMinutes_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__getMonth_index_js__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getMonth", function() { return __WEBPACK_IMPORTED_MODULE_59__getMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__getOverlappingDaysInIntervals_index_js__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getOverlappingDaysInIntervals", function() { return __WEBPACK_IMPORTED_MODULE_60__getOverlappingDaysInIntervals_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__getQuarter_index_js__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getQuarter", function() { return __WEBPACK_IMPORTED_MODULE_61__getQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__getSeconds_index_js__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getSeconds", function() { return __WEBPACK_IMPORTED_MODULE_62__getSeconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__getTime_index_js__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTime", function() { return __WEBPACK_IMPORTED_MODULE_63__getTime_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__getYear_index_js__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getYear", function() { return __WEBPACK_IMPORTED_MODULE_64__getYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__isAfter_index_js__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isAfter", function() { return __WEBPACK_IMPORTED_MODULE_65__isAfter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__isBefore_index_js__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBefore", function() { return __WEBPACK_IMPORTED_MODULE_66__isBefore_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__isEqual_index_js__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_67__isEqual_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__isFirstDayOfMonth_index_js__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFirstDayOfMonth", function() { return __WEBPACK_IMPORTED_MODULE_68__isFirstDayOfMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__isFriday_index_js__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFriday", function() { return __WEBPACK_IMPORTED_MODULE_69__isFriday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__isLastDayOfMonth_index_js__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isLastDayOfMonth", function() { return __WEBPACK_IMPORTED_MODULE_70__isLastDayOfMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__isLeapYear_index_js__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isLeapYear", function() { return __WEBPACK_IMPORTED_MODULE_71__isLeapYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__isMonday_index_js__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMonday", function() { return __WEBPACK_IMPORTED_MODULE_72__isMonday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__isSameDay_index_js__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameDay", function() { return __WEBPACK_IMPORTED_MODULE_73__isSameDay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__isSameHour_index_js__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameHour", function() { return __WEBPACK_IMPORTED_MODULE_74__isSameHour_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__isSameISOWeek_index_js__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_75__isSameISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__isSameISOYear_index_js__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameISOYear", function() { return __WEBPACK_IMPORTED_MODULE_76__isSameISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__isSameMinute_index_js__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameMinute", function() { return __WEBPACK_IMPORTED_MODULE_77__isSameMinute_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__isSameMonth_index_js__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameMonth", function() { return __WEBPACK_IMPORTED_MODULE_78__isSameMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__isSameQuarter_index_js__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameQuarter", function() { return __WEBPACK_IMPORTED_MODULE_79__isSameQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__isSameSecond_index_js__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameSecond", function() { return __WEBPACK_IMPORTED_MODULE_80__isSameSecond_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__isSameWeek_index_js__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameWeek", function() { return __WEBPACK_IMPORTED_MODULE_81__isSameWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__isSameYear_index_js__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSameYear", function() { return __WEBPACK_IMPORTED_MODULE_82__isSameYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__isSaturday_index_js__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSaturday", function() { return __WEBPACK_IMPORTED_MODULE_83__isSaturday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__isSunday_index_js__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSunday", function() { return __WEBPACK_IMPORTED_MODULE_84__isSunday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__isThursday_index_js__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isThursday", function() { return __WEBPACK_IMPORTED_MODULE_85__isThursday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__isTuesday_index_js__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTuesday", function() { return __WEBPACK_IMPORTED_MODULE_86__isTuesday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__isValid_index_js__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValid", function() { return __WEBPACK_IMPORTED_MODULE_87__isValid_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__isWednesday_index_js__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWednesday", function() { return __WEBPACK_IMPORTED_MODULE_88__isWednesday_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__isWeekend_index_js__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeekend", function() { return __WEBPACK_IMPORTED_MODULE_89__isWeekend_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__isWithinInterval_index_js__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWithinInterval", function() { return __WEBPACK_IMPORTED_MODULE_90__isWithinInterval_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__lastDayOfISOWeek_index_js__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_91__lastDayOfISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__lastDayOfISOYear_index_js__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfISOYear", function() { return __WEBPACK_IMPORTED_MODULE_92__lastDayOfISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__lastDayOfMonth_index_js__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfMonth", function() { return __WEBPACK_IMPORTED_MODULE_93__lastDayOfMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__lastDayOfQuarter_index_js__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfQuarter", function() { return __WEBPACK_IMPORTED_MODULE_94__lastDayOfQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__lastDayOfWeek_index_js__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfWeek", function() { return __WEBPACK_IMPORTED_MODULE_95__lastDayOfWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__lastDayOfYear_index_js__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastDayOfYear", function() { return __WEBPACK_IMPORTED_MODULE_96__lastDayOfYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__max_index_js__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_97__max_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__min_index_js__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_98__min_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__parse_index_js__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_99__parse_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__setDate_index_js__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDate", function() { return __WEBPACK_IMPORTED_MODULE_100__setDate_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__setDay_index_js__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDay", function() { return __WEBPACK_IMPORTED_MODULE_101__setDay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__setDayOfYear_index_js__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDayOfYear", function() { return __WEBPACK_IMPORTED_MODULE_102__setDayOfYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__setHours_index_js__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setHours", function() { return __WEBPACK_IMPORTED_MODULE_103__setHours_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__setISODay_index_js__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setISODay", function() { return __WEBPACK_IMPORTED_MODULE_104__setISODay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__setISOWeek_index_js__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_105__setISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__setISOYear_index_js__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setISOYear", function() { return __WEBPACK_IMPORTED_MODULE_106__setISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__setMilliseconds_index_js__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_107__setMilliseconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__setMinutes_index_js__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setMinutes", function() { return __WEBPACK_IMPORTED_MODULE_108__setMinutes_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__setMonth_index_js__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setMonth", function() { return __WEBPACK_IMPORTED_MODULE_109__setMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__setQuarter_index_js__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setQuarter", function() { return __WEBPACK_IMPORTED_MODULE_110__setQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__setSeconds_index_js__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setSeconds", function() { return __WEBPACK_IMPORTED_MODULE_111__setSeconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__setYear_index_js__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setYear", function() { return __WEBPACK_IMPORTED_MODULE_112__setYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__startOfDay_index_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfDay", function() { return __WEBPACK_IMPORTED_MODULE_113__startOfDay_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__startOfHour_index_js__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfHour", function() { return __WEBPACK_IMPORTED_MODULE_114__startOfHour_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__startOfISOWeek_index_js__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfISOWeek", function() { return __WEBPACK_IMPORTED_MODULE_115__startOfISOWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__startOfISOYear_index_js__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfISOYear", function() { return __WEBPACK_IMPORTED_MODULE_116__startOfISOYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__startOfMinute_index_js__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfMinute", function() { return __WEBPACK_IMPORTED_MODULE_117__startOfMinute_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__startOfMonth_index_js__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfMonth", function() { return __WEBPACK_IMPORTED_MODULE_118__startOfMonth_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__startOfQuarter_index_js__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfQuarter", function() { return __WEBPACK_IMPORTED_MODULE_119__startOfQuarter_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__startOfSecond_index_js__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfSecond", function() { return __WEBPACK_IMPORTED_MODULE_120__startOfSecond_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__startOfWeek_index_js__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfWeek", function() { return __WEBPACK_IMPORTED_MODULE_121__startOfWeek_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__startOfYear_index_js__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "startOfYear", function() { return __WEBPACK_IMPORTED_MODULE_122__startOfYear_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__subDays_index_js__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subDays", function() { return __WEBPACK_IMPORTED_MODULE_123__subDays_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__subHours_index_js__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subHours", function() { return __WEBPACK_IMPORTED_MODULE_124__subHours_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__subISOYears_index_js__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subISOYears", function() { return __WEBPACK_IMPORTED_MODULE_125__subISOYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__subMilliseconds_index_js__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_126__subMilliseconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__subMinutes_index_js__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subMinutes", function() { return __WEBPACK_IMPORTED_MODULE_127__subMinutes_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__subMonths_index_js__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subMonths", function() { return __WEBPACK_IMPORTED_MODULE_128__subMonths_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__subQuarters_index_js__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subQuarters", function() { return __WEBPACK_IMPORTED_MODULE_129__subQuarters_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__subSeconds_index_js__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subSeconds", function() { return __WEBPACK_IMPORTED_MODULE_130__subSeconds_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__subWeeks_index_js__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subWeeks", function() { return __WEBPACK_IMPORTED_MODULE_131__subWeeks_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__subYears_index_js__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subYears", function() { return __WEBPACK_IMPORTED_MODULE_132__subYears_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__toDate_index_js__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toDate", function() { return __WEBPACK_IMPORTED_MODULE_133__toDate_index_js__["a"]; });
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.









































































































































/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAfter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var dateToCompare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare, dirtyOptions)
  return date.getTime() > dateToCompare.getTime()
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var dateToCompare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare, dirtyOptions)
  return date.getTime() < dateToCompare.getTime()
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyLeftDate, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyRightDate, dirtyOptions)
  return dateLeft.getTime() === dateRight.getTime()
}


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFirstDayOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is the first day of a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDate() === 1
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFriday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Friday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 5
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLastDayOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(65);




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__["a" /* default */])(date, dirtyOptions).getTime() === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a" /* default */])(date, dirtyOptions).getTime()
}


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMonday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Monday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 1
}


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(38);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameHour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__ = __webpack_require__(77);


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same hour
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__ = __webpack_require__(1);



/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same ISO week
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var isSameWeekOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__["a" /* default */])(dirtyOptions)
  isSameWeekOptions.weekStartsOn = 1
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, isSameWeekOptions)
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__ = __webpack_require__(14);


/**
 * @name isSameISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfISOYear_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameMinute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__ = __webpack_require__(78);


/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same minute
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(79);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfQuarter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfQuarter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameSecond;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__ = __webpack_require__(80);


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same second
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeftStartOfSecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfSecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft, dirtyOptions)
  var dateRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight, dirtyOptions)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSaturday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Saturday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 6
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSunday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Sunday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 0
}


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isThursday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Thursday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 4
}


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTuesday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Tuesday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 2
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWednesday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is Wednesday
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getDay() === 3
}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWeekend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date falls on a weekend
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = date.getDay()
  return day === 0 || day === 6
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWithinInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(
 *   new Date(2014, 0, 3),
 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(
 *   new Date(2014, 0, 10),
 *   {start: new Date(2014, 0, 1), end: new Date(2014, 0, 7)}
 * )
 * //=> false
 */
function isWithinInterval (dirtyDate, dirtyInterval, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var interval = dirtyInterval || {}
  var time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions).getTime()
  var startTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start, dirtyOptions).getTime()
  var endTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end, dirtyOptions).getTime()

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval')
  }

  return time >= startTime && time <= endTime
}


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__ = __webpack_require__(1);



/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of an ISO week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var lastDayOfWeekOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_cloneObject_index_js__["a" /* default */])(dirtyOptions)
  lastDayOfWeekOptions.weekStartsOn = 1
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__["a" /* default */])(dirtyDate, lastDayOfWeekOptions)
}


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfISOYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(3);



/**
 * @name lastDayOfISOYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getISOYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuary, dirtyOptions)
  date.setDate(date.getDate() - 1)
  return date
}


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g

function buildShortLongFormat (format) {
  return format.replace(tokensToBeShortedPattern, function (token) {
    return token.slice(1)
  })
}

/**
 * @name buildFormatLongFn
 * @category Locale Helpers
 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 *
 * @description
 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
 * Returns a function which takes one of the following tokens as the argument:
 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
 * and returns a long format string written as `format` token strings.
 * See [format]{@link https://date-fns.org/docs/format}
 *
 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
 * by shortening some of the tokens from corresponding unshortened formats
 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
 *
 * @param {Object} obj - the object with long formats written as `format` token strings
 * @param {String} obj.LT - time format: hours and minutes
 * @param {String} obj.LTS - time format: hours, minutes and seconds
 * @param {String} obj.L - short date format: numeric day, month and year
 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
 * @param {String} obj.LL - long date format: day, month in words, and year
 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
 * @param {String} obj.LLL - long date and time format
 * @param {String} [obj.lll] - long date and time format (shortened)
 * @param {String} obj.LLLL - long date, time and weekday format
 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
 * @returns {Function} `formatLong` property of the locale
 *
 * @example
 * // For `en-US` locale:
 * locale.formatLong = buildFormatLongFn({
 *   LT: 'h:mm aa',
 *   LTS: 'h:mm:ss aa',
 *   L: 'MM/DD/YYYY',
 *   LL: 'MMMM D YYYY',
 *   LLL: 'MMMM D YYYY h:mm aa',
 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
 * })
 */
function buildFormatLongFn (obj) {
  var formatLongLocale = {
    LTS: obj.LTS,
    LT: obj.LT,
    L: obj.L,
    LL: obj.LL,
    LLL: obj.LLL,
    LLLL: obj.LLLL,
    l: obj.l || buildShortLongFormat(obj.L),
    ll: obj.ll || buildShortLongFormat(obj.LL),
    lll: obj.lll || buildShortLongFormat(obj.LLL),
    llll: obj.llll || buildShortLongFormat(obj.LLLL)
  }

  return function (token) {
    return formatLongLocale[token]
  }
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeArrayFn;
/**
 * @name buildLocalizeArrayFn
 * @category Locale Helpers
 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @returns {Function} the resulting function
 *
 * @example
 * var weekdayValues = {
 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
 * }
 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
 */
function buildLocalizeArrayFn (values, defaultType) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {}
    var type = options.type ? String(options.type) : defaultType
    return values[type] || values[defaultType]
  }
}


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
/**
 * @name buildLocalizeFn
 * @category Locale Helpers
 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
 *
 * @description
 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
 * used by `format` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 *
 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
 * `localize.month` takes the month index (0 - January).
 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
 *
 * @param {Object} values - the object with arrays of values
 * @param {String} defaultType - the default type for the localize function
 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
 *   and converts it into value array index
 * @returns {Function} the resulting function
 *
 * @example
 * var timeOfDayValues = {
 *   uppercase: ['AM', 'PM'],
 *   lowercase: ['am', 'pm'],
 *   long: ['a.m.', 'p.m.']
 * }
 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
 *   // 0 is a.m. array index, 1 is p.m. array index
 *   return (hours / 12) >= 1 ? 1 : 0
 * })
 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
 * locale.localize.timeOfDay(5) //=> 'a.m.'
 */
function buildLocalizeFn (values, defaultType, indexCallback) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {}
    var type = options.type ? String(options.type) : defaultType
    var valuesArray = values[type] || values[defaultType]
    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex)
    return valuesArray[index]
  }
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
/**
 * @name buildMatchFn
 * @category Locale Helpers
 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
 * The result of the match function will be passed into corresponding parser function
 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
 *
 * @param {Object} values - the object with RegExps
 * @param {String} defaultType - the default type for the match function
 * @returns {Function} the resulting function
 *
 * @example
 * var matchWeekdaysPatterns = {
 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
 * }
 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
 */
function buildMatchFn (patterns, defaultType) {
  return function (dirtyString, dirtyOptions) {
    var options = dirtyOptions || {}
    var type = options.type ? String(options.type) : defaultType
    var pattern = patterns[type] || patterns[defaultType]
    var string = String(dirtyString)
    return string.match(pattern)
  }
}


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
/**
 * @name buildMatchPatternFn
 * @category Locale Helpers
 * @summary Build match function from a single RegExp.
 *
 * @description
 * Build match function from a single RegExp.
 * Usually used for building `match.ordinalNumbers` property of the locale.
 *
 * @param {Object} pattern - the RegExp
 * @returns {Function} the resulting function
 *
 * @example
 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
 */
function buildMatchPatternFn (pattern) {
  return function (dirtyString) {
    var string = String(dirtyString)
    return string.match(pattern)
  }
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildParseFn;
/**
 * @name buildParseFn
 * @category Locale Helpers
 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
 *
 * @description
 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
 * The argument of the resulting function is the result of the corresponding match function
 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
 *
 * @param {Object} values - the object with arrays of RegExps
 * @param {String} defaultType - the default type for the parser function
 * @returns {Function} the resulting function
 *
 * @example
 * var parseWeekdayPatterns = {
 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
 * }
 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
 * var matchResult = locale.match.weekdays('Friday')
 * locale.match.weekday(matchResult) //=> 5
 */
function buildParseFn (patterns, defaultType) {
  return function (matchResult, dirtyOptions) {
    var options = dirtyOptions || {}
    var type = options.type ? String(options.type) : defaultType
    var patternsArray = patterns[type] || patterns[defaultType]
    var string = matchResult[1]

    return patternsArray.findIndex(function (pattern) {
      return pattern.test(string)
    })
  }
}


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDecimal;
/**
 * @name parseDecimal
 * @category Locale Helpers
 * @summary Parses the match result into decimal number.
 *
 * @description
 * Parses the match result into decimal number.
 * Uses the string matched with the first set of parentheses of match RegExp.
 *
 * @param {Array} matchResult - the object returned by matching function
 * @returns {Number} the parsed value
 *
 * @example
 * locale.match = {
 *   ordinalNumbers: (dirtyString) {
 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
 *   },
 *   ordinalNumber: parseDecimal
 * }
 */
function parseDecimal (matchResult) {
  return parseInt(matchResult[1], 10)
}


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
}

function formatDistance (token, count, options) {
  options = options || {}

  var result
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token]
  } else if (count === 1) {
    result = formatDistanceLocale[token].one
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count)
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(205);


var formatLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
  LT: 'h:mm aa',
  LTS: 'h:mm:ss aa',
  L: 'MM/DD/YYYY',
  LL: 'MMMM D YYYY',
  LLL: 'MMMM D YYYY h:mm aa',
  LLLL: 'dddd, MMMM D YYYY h:mm aa'
})

/* harmony default export */ __webpack_exports__["a"] = (formatLong);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: '[last] dddd [at] LT',
  yesterday: '[yesterday at] LT',
  today: '[today at] LT',
  tomorrow: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  other: 'L'
}

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildLocalizeArrayFn_index_js__ = __webpack_require__(206);



// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var weekdayValues = {
  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
}

var monthValues = {
  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
}

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var timeOfDayValues = {
//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
//   }
//
// And later:
//
//   var localize = {
//     // The callback takes the hours as the argument and returns the array index
//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
//       if (hours >= 17) {
//         return 3
//       } else if (hours >= 12) {
//         return 2
//       } else if (hours >= 4) {
//         return 1
//       } else {
//         return 0
//       }
//     }),
//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
//   }
var timeOfDayValues = {
  uppercase: ['AM', 'PM'],
  lowercase: ['am', 'pm'],
  long: ['a.m.', 'p.m.']
}

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber)

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
  // 'dayOfMonth' or 'dayOfWeek'

  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,
  weekday: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])(weekdayValues, 'long'),
  weekdays: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildLocalizeArrayFn_index_js__["a" /* default */])(weekdayValues, 'long'),
  month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])(monthValues, 'long'),
  months: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildLocalizeArrayFn_index_js__["a" /* default */])(monthValues, 'long'),
  timeOfDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])(timeOfDayValues, 'long', function (hours) {
    return (hours / 12) >= 1 ? 1 : 0
  }),
  timesOfDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildLocalizeArrayFn_index_js__["a" /* default */])(timeOfDayValues, 'long')
}

/* harmony default export */ __webpack_exports__["a"] = (localize);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildParseFn_index_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_buildMatchPatternFn_index_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_parseDecimal_index_js__ = __webpack_require__(211);





var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i

var matchWeekdaysPatterns = {
  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}

var parseWeekdayPatterns = {
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}

var matchMonthsPatterns = {
  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}

var parseMonthPatterns = {
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}

// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
// Use the system which is used the most commonly in the locale.
// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
//
//   var matchTimesOfDayPatterns = {
//     long: /^((in the)? (night|morning|afternoon|evening?))/i
//   }
//
//   var parseTimeOfDayPatterns = {
//     any: [/(night|morning)/i, /(afternoon|evening)/i]
//   }
var matchTimesOfDayPatterns = {
  short: /^(am|pm)/i,
  long: /^([ap]\.?\s?m\.?)/i
}

var parseTimeOfDayPatterns = {
  any: [/^a/i, /^p/i]
}

var match = {
  ordinalNumbers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_buildMatchPatternFn_index_js__["a" /* default */])(matchOrdinalNumbersPattern),
  ordinalNumber: __WEBPACK_IMPORTED_MODULE_3__lib_parseDecimal_index_js__["a" /* default */],
  weekdays: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])(matchWeekdaysPatterns, 'long'),
  weekday: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildParseFn_index_js__["a" /* default */])(parseWeekdayPatterns, 'any'),
  months: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])(matchMonthsPatterns, 'long'),
  month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildParseFn_index_js__["a" /* default */])(parseMonthPatterns, 'any'),
  timesOfDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])(matchTimesOfDayPatterns, 'long'),
  timeOfDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_buildParseFn_index_js__["a" /* default */])(parseTimeOfDayPatterns, 'any')
}

/* harmony default export */ __webpack_exports__["a"] = (match);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *  [
 *    new Date(1989, 6, 10),
 *    new Date(1987, 1, 11),
 *    new Date(1995, 6, 2),
 *    new Date(1990, 0, 1)
 *  ]
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max (dirtyDatesArray, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var datesArray
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = []

  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray

  // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray)
  }

  var result
  datesArray.forEach(function (dirtyDate) {
    var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)

    if (result === undefined || result < currentDate || isNaN(currentDate)) {
      result = currentDate
    }
  })

  return result
}


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name min
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {Date[]|String[]|Number[]} datesArray - the dates to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the earliest of the dates
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *  [
 *    new Date(1989, 6, 10),
 *    new Date(1987, 1, 11),
 *    new Date(1995, 6, 2),
 *    new Date(1990, 0, 1)
 *  ]
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min (dirtyDatesArray, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var datesArray
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = []

  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray

  // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray)
  }

  var result
  datesArray.forEach(function (dirtyDate) {
    var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)

    if (result === undefined || result > currentDate || isNaN(currentDate)) {
      result = currentDate
    }
  })

  return result
}


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var patterns = {
  'M': /^(1[0-2]|0?\d)/, // 0 to 12
  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  'YYYY': /^(\d{1,4})/, // 0 to 9999
  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  'm': /^([0-5]?\d)/, // 0 to 59
  'Z': /^([+-])(\d{2}):(\d{2})/,
  'ZZ': /^([+-])(\d{2})(\d{2})/,
  singleDigit: /^(\d)/,
  twoDigits: /^(\d{2})/,
  threeDigits: /^(\d{3})/,
  fourDigits: /^(\d{4})/,
  anyDigits: /^(\d+)/
}

function parseDecimal (matchResult) {
  return parseInt(matchResult[1], 10)
}

var parsers = {
  // Year: 00, 01, ..., 99
  'YY': {
    unit: 'twoDigitYear',
    match: patterns.twoDigits,
    parse: function (matchResult) {
      return parseDecimal(matchResult)
    }
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': {
    unit: 'year',
    match: patterns.YYYY,
    parse: parseDecimal
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': {
    unit: 'isoYear',
    match: patterns.twoDigits,
    parse: function (matchResult) {
      return parseDecimal(matchResult) + 1900
    }
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': {
    unit: 'isoYear',
    match: patterns.YYYY,
    parse: parseDecimal
  },

  // Quarter: 1, 2, 3, 4
  'Q': {
    unit: 'quarter',
    match: patterns.singleDigit,
    parse: parseDecimal
  },

  // Ordinal quarter
  'Qo': {
    unit: 'quarter',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'quarter'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'quarter'})
    }
  },

  // Month: 1, 2, ..., 12
  'M': {
    unit: 'month',
    match: patterns.M,
    parse: function (matchResult) {
      return parseDecimal(matchResult) - 1
    }
  },

  // Ordinal month
  'Mo': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'month'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'month'}) - 1
    }
  },

  // Month: 01, 02, ..., 12
  'MM': {
    unit: 'month',
    match: patterns.twoDigits,
    parse: function (matchResult) {
      return parseDecimal(matchResult) - 1
    }
  },

  // Month: Jan, Feb, ..., Dec
  'MMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.month(matchResult, {type: 'short'})
    }
  },

  // Month: January, February, ..., December
  'MMMM': {
    unit: 'month',
    match: function (string, options) {
      return options.locale.match.months(string, {type: 'long'}) ||
        options.locale.match.months(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.month(matchResult, {type: 'long'})

      if (parseResult == null) {
        parseResult = options.locale.match.month(matchResult, {type: 'short'})
      }

      return parseResult
    }
  },

  // ISO week: 1, 2, ..., 53
  'W': {
    unit: 'isoWeek',
    match: patterns.W,
    parse: parseDecimal
  },

  // Ordinal ISO week
  'Wo': {
    unit: 'isoWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'isoWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'isoWeek'})
    }
  },

  // ISO week: 01, 02, ..., 53
  'WW': {
    unit: 'isoWeek',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // Day of week: 0, 1, ..., 6
  'd': {
    unit: 'dayOfWeek',
    match: patterns.singleDigit,
    parse: parseDecimal
  },

  // Ordinal day of week
  'do': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfWeek'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfWeek'})
    }
  },

  // Day of week: Su, Mo, ..., Sa
  'dd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.weekday(matchResult, {type: 'narrow'})
    }
  },

  // Day of week: Sun, Mon, ..., Sat
  'ddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'short'})

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'})
      }

      return parseResult
    }
  },

  // Day of week: Sunday, Monday, ..., Saturday
  'dddd': {
    unit: 'dayOfWeek',
    match: function (string, options) {
      return options.locale.match.weekdays(string, {type: 'long'}) ||
        options.locale.match.weekdays(string, {type: 'short'}) ||
        options.locale.match.weekdays(string, {type: 'narrow'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.weekday(matchResult, {type: 'long'})

      if (parseResult == null) {
        parseResult = options.locale.match.weekday(matchResult, {type: 'short'})

        if (parseResult == null) {
          parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'})
        }
      }

      return parseResult
    }
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': {
    unit: 'dayOfISOWeek',
    match: patterns.singleDigit,
    parse: function (matchResult) {
      return parseDecimal(matchResult)
    }
  },

  // Day of month: 1, 2, ..., 31
  'D': {
    unit: 'dayOfMonth',
    match: patterns.D,
    parse: parseDecimal
  },

  // Ordinal day of month
  'Do': {
    unit: 'dayOfMonth',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfMonth'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfMonth'})
    }
  },

  // Day of month: 01, 02, ..., 31
  'DD': {
    unit: 'dayOfMonth',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // Day of year: 1, 2, ..., 366
  'DDD': {
    unit: 'dayOfYear',
    match: patterns.DDD,
    parse: parseDecimal
  },

  // Ordinal day of year
  'DDDo': {
    unit: 'dayOfYear',
    match: function (string, options) {
      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfYear'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfYear'})
    }
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': {
    unit: 'dayOfYear',
    match: patterns.threeDigits,
    parse: parseDecimal
  },

  // AM, PM
  'A': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      return options.locale.match.timeOfDay(matchResult, {type: 'short'})
    }
  },

  // a.m., p.m.
  'aa': {
    unit: 'timeOfDay',
    match: function (string, options) {
      return options.locale.match.timesOfDay(string, {type: 'long'}) ||
        options.locale.match.timesOfDay(string, {type: 'short'})
    },
    parse: function (matchResult, options) {
      var parseResult = options.locale.match.timeOfDay(matchResult, {type: 'long'})

      if (parseResult == null) {
        parseResult = options.locale.match.timeOfDay(matchResult, {type: 'short'})
      }

      return parseResult
    }
  },

  // Hour: 0, 1, ... 23
  'H': {
    unit: 'hours',
    match: patterns.H,
    parse: parseDecimal
  },

  // Hour: 00, 01, ..., 23
  'HH': {
    unit: 'hours',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // Hour: 1, 2, ..., 12
  'h': {
    unit: 'timeOfDayHours',
    match: patterns.M,
    parse: parseDecimal
  },

  // Hour: 01, 02, ..., 12
  'hh': {
    unit: 'timeOfDayHours',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // Minute: 0, 1, ..., 59
  'm': {
    unit: 'minutes',
    match: patterns.m,
    parse: parseDecimal
  },

  // Minute: 00, 01, ..., 59
  'mm': {
    unit: 'minutes',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // Second: 0, 1, ..., 59
  's': {
    unit: 'seconds',
    match: patterns.m,
    parse: parseDecimal
  },

  // Second: 00, 01, ..., 59
  'ss': {
    unit: 'seconds',
    match: patterns.twoDigits,
    parse: parseDecimal
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': {
    unit: 'milliseconds',
    match: patterns.singleDigit,
    parse: function (matchResult) {
      return parseDecimal(matchResult) * 100
    }
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': {
    unit: 'milliseconds',
    match: patterns.twoDigits,
    parse: function (matchResult) {
      return parseDecimal(matchResult) * 10
    }
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': {
    unit: 'milliseconds',
    match: patterns.threeDigits,
    parse: parseDecimal
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': {
    unit: 'timezone',
    match: patterns.Z,
    parse: function (matchResult) {
      var sign = matchResult[1]
      var hours = parseInt(matchResult[2], 10)
      var minutes = parseInt(matchResult[3], 10)
      var absoluteOffset = hours * 60 + minutes
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': {
    unit: 'timezone',
    match: patterns.ZZ,
    parse: function (matchResult) {
      var sign = matchResult[1]
      var hours = parseInt(matchResult[2], 10)
      var minutes = parseInt(matchResult[3], 10)
      var absoluteOffset = hours * 60 + minutes
      return (sign === '+') ? absoluteOffset : -absoluteOffset
    }
  },

  // Seconds timestamp: 512969520
  'X': {
    unit: 'timestamp',
    match: patterns.anyDigits,
    parse: function (matchResult) {
      return parseDecimal(matchResult) * 1000
    }
  },

  // Milliseconds timestamp: 512969520900
  'x': {
    unit: 'timestamp',
    match: patterns.anyDigits,
    parse: parseDecimal
  }
}

parsers['a'] = parsers['A']

/* harmony default export */ __webpack_exports__["a"] = (parsers);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_setUTCDay_index_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCISODay_index_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISOWeek_index_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeekYear_index_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeekYear_index_js__ = __webpack_require__(33);







var MILLISECONDS_IN_MINUTE = 60000

function setTimeOfDay (hours, timeOfDay) {
  var isAM = timeOfDay === 0

  if (isAM) {
    if (hours === 12) {
      return 0
    }
  } else {
    if (hours !== 12) {
      return 12 + hours
    }
  }

  return hours
}

var units = {
  twoDigitYear: {
    priority: 10,
    set: function (dateValues, value) {
      var century = Math.floor(dateValues.date.getUTCFullYear() / 100)
      var year = century * 100 + value
      dateValues.date.setUTCFullYear(year, 0, 1)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  year: {
    priority: 10,
    set: function (dateValues, value) {
      dateValues.date.setUTCFullYear(value, 0, 1)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  isoYear: {
    priority: 10,
    set: function (dateValues, value, options) {
      dateValues.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeekYear_index_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeekYear_index_js__["a" /* default */])(dateValues.date, value, options), options)
      return dateValues
    }
  },

  quarter: {
    priority: 20,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth((value - 1) * 3, 1)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  month: {
    priority: 30,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(value, 1)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  isoWeek: {
    priority: 40,
    set: function (dateValues, value, options) {
      dateValues.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_startOfUTCISOWeek_index_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_setUTCISOWeek_index_js__["a" /* default */])(dateValues.date, value, options), options)
      return dateValues
    }
  },

  dayOfWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_setUTCDay_index_js__["a" /* default */])(dateValues.date, value, options)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  dayOfISOWeek: {
    priority: 50,
    set: function (dateValues, value, options) {
      dateValues.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCISODay_index_js__["a" /* default */])(dateValues.date, value, options)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  dayOfMonth: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCDate(value)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  dayOfYear: {
    priority: 50,
    set: function (dateValues, value) {
      dateValues.date.setUTCMonth(0, value)
      dateValues.date.setUTCHours(0, 0, 0, 0)
      return dateValues
    }
  },

  timeOfDay: {
    priority: 60,
    set: function (dateValues, value, options) {
      dateValues.timeOfDay = value
      return dateValues
    }
  },

  hours: {
    priority: 70,
    set: function (dateValues, value, options) {
      dateValues.date.setUTCHours(value, 0, 0, 0)
      return dateValues
    }
  },

  timeOfDayHours: {
    priority: 70,
    set: function (dateValues, value, options) {
      var timeOfDay = dateValues.timeOfDay
      if (timeOfDay != null) {
        value = setTimeOfDay(value, timeOfDay)
      }
      dateValues.date.setUTCHours(value, 0, 0, 0)
      return dateValues
    }
  },

  minutes: {
    priority: 80,
    set: function (dateValues, value) {
      dateValues.date.setUTCMinutes(value, 0, 0)
      return dateValues
    }
  },

  seconds: {
    priority: 90,
    set: function (dateValues, value) {
      dateValues.date.setUTCSeconds(value, 0)
      return dateValues
    }
  },

  milliseconds: {
    priority: 100,
    set: function (dateValues, value) {
      dateValues.date.setUTCMilliseconds(value)
      return dateValues
    }
  },

  timezone: {
    priority: 110,
    set: function (dateValues, value) {
      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE)
      return dateValues
    }
  },

  timestamp: {
    priority: 120,
    set: function (dateValues, value) {
      dateValues.date = new Date(value)
      return dateValues
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (units);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMinutes_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_parsers_index_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_units_index_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__ = __webpack_require__(1);







var TIMEZONE_UNIT_PRIORITY = 110
var MILLISECONDS_IN_MINUTE = 60000

var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g
var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format.
 *
 * Accepted format tokens:
 * | Unit                    | Priority | Token | Input examples                   |
 * |-------------------------|----------|-------|----------------------------------|
 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
 * |                         |          | MM    | 01, 02, ..., 12                  |
 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
 * |                         |          | MMMM  | January, February, ..., December |
 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         |          | WW    | 01, 02, ..., 53                  |
 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
 * |                         |          | do    | 0th, 1st, ..., 6th               |
 * |                         |          | dd    | Su, Mo, ..., Sa                  |
 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
 * |                         |          | DD    | 01, 02, ..., 31                  |
 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         |          | DDDD  | 001, 002, ..., 366               |
 * | Time of day             | 60       | A     | AM, PM                           |
 * |                         |          | a     | am, pm                           |
 * |                         |          | aa    | a.m., p.m.                       |
 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
 * |                         |          | HH    | 00, 01, ... 23                   |
 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
 * |                         |          | hh    | 01, 02, ..., 12                  |
 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
 * |                         |          | mm    | 00, 01, ..., 59                  |
 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
 * |                         |          | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | 120      | X     | 512969520                        |
 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
 *
 * Values will be assigned to the date in the ascending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
 * | Token | Input examples                 |
 * |-------|--------------------------------|
 * | LT    | 05:30 a.m.                     |
 * | LTS   | 05:30:15 a.m.                  |
 * | L     | 07/02/1995                     |
 * | l     | 7/2/1995                       |
 * | LL    | July 2 1995                    |
 * | ll    | Jul 2 1995                     |
 * | LLL   | July 2 1995 05:30 a.m.         |
 * | lll   | Jul 2 1995 05:30 a.m.          |
 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
 *
 * The characters wrapped in square brackets in the format string are escaped.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/DD/YYYY',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in English locale in the context of 2010 year:
 * import eoLocale from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   'Do [de] MMMM',
 *   new Date(2010, 0, 1)
 *   {locale: eoLocale}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse (dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present')
  }

  var dateString = String(dirtyDateString)
  var options = dirtyOptions || {}

  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__["a" /* default */]
  var localeParsers = locale.parsers || {}
  var localeUnits = locale.units || {}

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var formatString = String(dirtyFormatString)
    .replace(longFormattingTokensRegExp, function (substring) {
      if (substring[0] === '[') {
        return substring
      }

      if (substring[0] === '\\') {
        return cleanEscapedString(substring)
      }

      return locale.formatLong(substring)
    })

  if (formatString === '') {
    if (dateString === '') {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__["a" /* default */])(options)
  subFnOptions.locale = locale

  var tokens = formatString.match(locale.parsingTokensRegExp || defaultParsingTokensRegExp)
  var tokensLength = tokens.length

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }]

  var i
  for (i = 0; i < tokensLength; i++) {
    var token = tokens[i]
    var parser = localeParsers[token] || __WEBPACK_IMPORTED_MODULE_3__lib_parsers_index_js__["a" /* default */][token]
    if (parser) {
      var matchResult

      if (parser.match instanceof RegExp) {
        matchResult = parser.match.exec(dateString)
      } else {
        matchResult = parser.match(dateString, subFnOptions)
      }

      if (!matchResult) {
        return new Date(NaN)
      }

      var unitName = parser.unit
      var unit = localeUnits[unitName] || __WEBPACK_IMPORTED_MODULE_4__lib_units_index_js__["a" /* default */][unitName]

      setters.push({
        priority: unit.priority,
        set: unit.set,
        value: parser.parse(matchResult, subFnOptions),
        index: setters.length
      })

      var substring = matchResult[0]
      dateString = dateString.slice(substring.length)
    } else {
      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i]
      if (dateString.indexOf(head) === 0) {
        dateString = dateString.slice(head.length)
      } else {
        return new Date(NaN)
      }
    }
  }

  var uniquePrioritySetters = setters
    .map(function (setter) {
      return setter.priority
    })
    .sort(function (a, b) {
      return a - b
    })
    .filter(function (priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function (priority) {
      return setters
        .filter(function (setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function (setterArray) {
      return setterArray[0]
    })

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyBaseDate, options)

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__subMinutes_index_js__["a" /* default */])(date, date.getTimezoneOffset())

  var dateValues = {date: utcDate}

  var settersLength = uniquePrioritySetters.length
  for (i = 0; i < settersLength; i++) {
    var setter = uniquePrioritySetters[i]
    dateValues = setter.set(dateValues, setter.value, subFnOptions)
  }

  return dateValues.date
}

function dateToSystemTimezone (dateValues) {
  var date = dateValues.date
  var time = date.getTime()

  // Get the system timezone offset at (moment of time - offset)
  var offset = date.getTimezoneOffset()

  // Get the system timezone offset at the exact moment of time
  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()

  // Convert date in timezone "UTC+00:00" to the system timezone
  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE)

  return dateValues
}

function cleanEscapedString (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the day of the month setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(10);



/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {Date} the new date with the day of the week setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {}
  var locale = options.locale
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn)
  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn)

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, options)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a" /* default */])(date, diff, options)
}


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the day of the year setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the hours setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getISODay_index_js__ = __webpack_require__(68);




/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the day of the ISO week setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var day = Number(dirtyDay)
  var currentDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getISODay_index_js__["a" /* default */])(date, dirtyOptions)
  var diff = day - currentDay
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a" /* default */])(date, diff, dirtyOptions)
}


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getISOWeek_index_js__ = __webpack_require__(69);



/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the ISO week setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var isoWeek = Number(dirtyISOWeek)
  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getISOWeek_index_js__["a" /* default */])(date, dirtyOptions) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the minutes setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__ = __webpack_require__(76);



/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the quarter setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__["a" /* default */])(date, date.getMonth() + diff * 3, dirtyOptions)
}


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the seconds setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the year setted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  var year = Number(dirtyYear)

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date)) {
    return new Date(NaN)
  }

  date.setFullYear(year)
  return date
}


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(0);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate, dirtyOptions)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(10);


/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__ = __webpack_require__(54);


/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addHours_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(11);


/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__ = __webpack_require__(21);


/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addMonths_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__ = __webpack_require__(57);


/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addSeconds_index_js__ = __webpack_require__(58);


/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addSeconds_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__ = __webpack_require__(34);


/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addYears_index_js__ = __webpack_require__(59);


/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = Number(dirtyAmount)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__addYears_index_js__["a" /* default */])(dirtyDate, -amount, dirtyOptions)
}


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(247)
}
var Component = __webpack_require__(84)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a440e668",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/Users/akshay/Projects/learn/vue/plugins/vue-good-table-v1/vue-good-table/src/components/Pagination.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Pagination.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a440e668", Component.options)
  } else {
    hotAPI.reload("data-v-a440e668", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(248)
}
var Component = __webpack_require__(84)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d89f00e8",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/Users/akshay/Projects/learn/vue/plugins/vue-good-table-v1/vue-good-table/src/components/Table.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Table.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d89f00e8", Component.options)
  } else {
    hotAPI.reload("data-v-d89f00e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-footer clearfix"
  }, [_c('div', {
    staticClass: "datatable-length pull-left"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.rowsPerPageText))]), _vm._v(" "), _c('select', {
    staticClass: "browser-default",
    on: {
      "change": _vm.perPageChanged
    }
  }, [_vm._l((_vm.getRowsPerPageDropdown()), function(option) {
    return _c('option', {
      key: 'rows-dropdown-option-' + option,
      domProps: {
        "selected": (_vm.perPage && _vm.currentPerPage === option) || _vm.currentPerPage === option,
        "value": option
      }
    }, [_vm._v("\n          " + _vm._s(option) + "\n        ")])
  }), _vm._v(" "), (_vm.paginateDropdownAllowAll) ? _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.allText))]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-controls pull-right"
  }, [_c('a', {
    staticClass: "page-btn",
    class: {
      disabled: !_vm.prevIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.previousPage($event)
      }
    }
  }, [_c('span', {
    staticClass: "chevron",
    class: {
      'left': !_vm.rtl, 'right': _vm.rtl
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevText))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.paginatedInfo))]), _vm._v(" "), _c('a', {
    staticClass: "page-btn",
    class: {
      disabled: !_vm.nextIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.nextPage($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nextText))]), _vm._v(" "), _c('span', {
    staticClass: "chevron",
    class: {
      'right': !_vm.rtl, 'left': _vm.rtl
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a440e668", module.exports)
  }
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-table",
    class: {
      'rtl': _vm.rtl
    }
  }, [(_vm.title || _vm.$slots['table-actions']) ? _c('div', {
    staticClass: "table-header clearfix"
  }, [_c('h2', {
    staticClass: "table-title pull-left"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "actions pull-right"
  }, [_vm._t("table-actions")], 2)]) : _vm._e(), _vm._v(" "), (_vm.paginate && _vm.paginateOnTop) ? _c('vue-good-pagination', {
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.processedRows.length,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "allText": _vm.allText
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'responsive': _vm.responsive
    }
  }, [_c('table', {
    ref: "table",
    class: _vm.tableStyleClasses
  }, [_c('thead', [(_vm.globalSearch && _vm.externalSearchQuery == null) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.lineNumbers ? _vm.columns.length + 1 : _vm.columns.length
    }
  }, [_c('div', {
    staticClass: "global-search"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalSearchTerm),
      expression: "globalSearchTerm"
    }],
    staticClass: "form-control global-search-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.globalSearchPlaceholder
    },
    domProps: {
      "value": (_vm.globalSearchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalSearchTerm = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.lineNumbers) ? _c('th', {
    staticClass: "line-numbers"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (!column.hidden) ? _c('th', {
      key: index,
      class: _vm.getHeaderClasses(column, index),
      style: ({
        width: column.width ? column.width : 'auto'
      }),
      on: {
        "click": function($event) {
          _vm.sort(index)
        }
      }
    }, [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(column.label))])], {
      column: column
    })], 2) : _vm._e()
  }), _vm._v(" "), _vm._t("thead-tr")], 2), _vm._v(" "), (_vm.hasFilterRow) ? _c('tr', [(_vm.lineNumbers) ? _c('th') : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (!column.hidden) ? _c('th', {
      key: index
    }, [(column.filterable) ? _c('div', {
      class: _vm.getHeaderClasses(column, index)
    }, [(!column.filterDropdown) ? _c('input', {
      attrs: {
        "type": "text",
        "placeholder": _vm.getPlaceholder(column)
      },
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "input": function($event) {
          _vm.updateFilters(column, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (column.filterDropdown && typeof(column.filterOptions[0]) !== 'object') ? _c('select', {
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "change": function($event) {
          _vm.updateFilters(column, $event.target.value)
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l((column.filterOptions), function(option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option
        }
      }, [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
    })], 2) : _vm._e(), _vm._v(" "), (column.filterDropdown && typeof(column.filterOptions[0]) === 'object') ? _c('select', {
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "change": function($event) {
          _vm.updateFilters(column, $event.target.value)
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l((column.filterOptions), function(option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paginated), function(row, index) {
    return _c('tr', {
      key: index,
      class: _vm.getRowStyleClass(row),
      on: {
        "click": function($event) {
          _vm.click(row, index)
        }
      }
    }, [(_vm.lineNumbers) ? _c('th', {
      staticClass: "line-numbers"
    }, [_vm._v(_vm._s(_vm.getCurrentIndex(index)))]) : _vm._e(), _vm._v(" "), _vm._t("table-row-before", null, {
      row: row,
      index: index
    }), _vm._v(" "), _vm._t("table-row", _vm._l((_vm.columns), function(column, i) {
      return (!column.hidden && column.field) ? _c('td', {
        key: i,
        class: _vm.getClasses(i, 'td')
      }, [(!column.html) ? _c('span', [_vm._v(_vm._s(_vm.collectFormatted(row, column)))]) : _vm._e(), _vm._v(" "), (column.html) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.collect(row, column.field))
        }
      }) : _vm._e()]) : _vm._e()
    }), {
      row: row,
      formattedRow: _vm.formattedRow(row),
      index: index
    }), _vm._v(" "), _vm._t("table-row-after", null, {
      row: row,
      index: index
    })], 2)
  }), _vm._v(" "), (_vm.processedRows.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_vm._t("emptystate", [_c('div', {
    staticClass: "center-align text-disabled"
  }, [_vm._v("\n                  No data for table.\n                ")])])], 2)]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.paginate && !_vm.paginateOnTop) ? _c('vue-good-pagination', {
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.processedRows.length,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "allText": _vm.allText
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "global-search-icon"
  }, [_c('div', {
    staticClass: "magnifying-glass"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d89f00e8", module.exports)
  }
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(85)("219bb374", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a440e668\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Pagination.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a440e668\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Pagination.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(85)("4dfb852a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d89f00e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Table.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d89f00e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Table.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./date.js": 89,
	"./decimal.js": 90,
	"./default.js": 15,
	"./number.js": 25,
	"./percentage.js": 91
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(86);


/***/ })
/******/ ]);
});

/***/ }),
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationFailureType */
/* unused harmony export RouterLink */
/* unused harmony export RouterView */
/* unused harmony export START_LOCATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRouter$1; });
/* unused harmony export isNavigationFailure */
/* unused harmony export version */
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (true) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "stage" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/(?:\s*\/)+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (true) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if ("stage" !== 'production' && !this.custom) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (true) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (true) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'}\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if ("stage" !== 'production' && alias === path) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("stage" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (true) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "stage" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1$1.ensureURL();
      this$1$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1$1.ready) {
        this$1$1.ready = true;
        this$1$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1$1.ready = true;
          this$1$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1$1.errorCbs.length) {
        this$1$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (true) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1$1.replace(to);
          } else {
            this$1$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1$1.pending = null;
      onComplete(route);
      if (this$1$1.router.app) {
        this$1$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1$1.base);
      if (this$1$1.current === START && location === this$1$1._startLocation) {
        return
      }

      this$1$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index + 1).concat(route);
        this$1$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1$1.current;
        this$1$1.index = targetIndex;
        this$1$1.updateRoute(route);
        this$1$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (true) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1$1 = this;

  "stage" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1$1.apps.indexOf(app);
    if (index > -1) { this$1$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1$1.app === app) { this$1$1.app = this$1$1.apps[0] || null; }

    if (!this$1$1.app) { this$1$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (true) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

var VueRouter$1 = VueRouter;

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

// We cannot remove this as it would be a breaking change
VueRouter.install = install;
VueRouter.version = '3.6.5';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

var version = '3.6.5';




/***/ }),
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.4.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (true) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (true) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (true) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

function assertRawModule (path, rawModule) {
  ['getters', 'actions', 'mutations'].forEach(function (key) {
    if (!rawModule[key]) { return }

    forEachValue(rawModule[key], function (value, type) {
      assert(
        typeof value === 'function',
        makeAssertionMessage(path, key, type, value)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value) {
  var buf = key + " should be function but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";

  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (true) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state();
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (true) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    "stage" !== 'production' &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var entry = this._actions[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }
  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  var subs = this._subscribers;
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (true) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule) {
  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path));
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var namespacedType = namespace + key;
    registerAction(store, namespacedType, action, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("stage" !== 'production' && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("stage" !== 'production' && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (true) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (true) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (true) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (true) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if ("stage" !== 'production' && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if ("stage" !== 'production' && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.4.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @file Web Cryptography API shim
 * @author Artem S Vybornov <vybornov@gmail.com>
 * @license MIT
 */
(function (global, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return factory(global);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS-like environments that support module.exports
        module.exports = factory(global);
    } else {
        factory(global);
    }
}(typeof self !== 'undefined' ? self : this, function (global) {
    'use strict';

    if ( typeof Promise !== 'function' )
        throw "Promise support required";

    var _crypto = global.crypto || global.msCrypto;
    if ( !_crypto ) return;

    var _subtle = _crypto.subtle || _crypto.webkitSubtle;
    if ( !_subtle ) return;

    var _Crypto     = global.Crypto || _crypto.constructor || Object,
        _SubtleCrypto = global.SubtleCrypto || _subtle.constructor || Object,
        _CryptoKey  = global.CryptoKey || global.Key || Object;

    var isEdge = global.navigator.userAgent.indexOf('Edge/') > -1;
    var isIE    = !!global.msCrypto && !isEdge;
    var isWebkit = !_crypto.subtle && !!_crypto.webkitSubtle;
    if ( !isIE && !isWebkit ) return;

    function s2a ( s ) {
        return btoa(s).replace(/\=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
    }

    function a2s ( s ) {
        s += '===', s = s.slice( 0, -s.length % 4 );
        return atob( s.replace(/-/g, '+').replace(/_/g, '/') );
    }

    function s2b ( s ) {
        var b = new Uint8Array(s.length);
        for ( var i = 0; i < s.length; i++ ) b[i] = s.charCodeAt(i);
        return b;
    }

    function b2s ( b ) {
        if ( b instanceof ArrayBuffer ) b = new Uint8Array(b);
        return String.fromCharCode.apply( String, b );
    }

    function alg ( a ) {
        var r = { 'name': (a.name || a || '').toUpperCase().replace('V','v') };
        switch ( r.name ) {
            case 'SHA-1':
            case 'SHA-256':
            case 'SHA-384':
            case 'SHA-512':
                break;
            case 'AES-CBC':
            case 'AES-GCM':
            case 'AES-KW':
                if ( a.length ) r['length'] = a.length;
                break;
            case 'HMAC':
                if ( a.hash ) r['hash'] = alg(a.hash);
                if ( a.length ) r['length'] = a.length;
                break;
            case 'RSAES-PKCS1-v1_5':
                if ( a.publicExponent ) r['publicExponent'] = new Uint8Array(a.publicExponent);
                if ( a.modulusLength ) r['modulusLength'] = a.modulusLength;
                break;
            case 'RSASSA-PKCS1-v1_5':
            case 'RSA-OAEP':
                if ( a.hash ) r['hash'] = alg(a.hash);
                if ( a.publicExponent ) r['publicExponent'] = new Uint8Array(a.publicExponent);
                if ( a.modulusLength ) r['modulusLength'] = a.modulusLength;
                break;
            default:
                throw new SyntaxError("Bad algorithm name");
        }
        return r;
    };

    function jwkAlg ( a ) {
        return {
            'HMAC': {
                'SHA-1': 'HS1',
                'SHA-256': 'HS256',
                'SHA-384': 'HS384',
                'SHA-512': 'HS512',
            },
            'RSASSA-PKCS1-v1_5': {
                'SHA-1': 'RS1',
                'SHA-256': 'RS256',
                'SHA-384': 'RS384',
                'SHA-512': 'RS512',
            },
            'RSAES-PKCS1-v1_5': {
                '': 'RSA1_5',
            },
            'RSA-OAEP': {
                'SHA-1': 'RSA-OAEP',
                'SHA-256': 'RSA-OAEP-256',
            },
            'AES-KW': {
                '128': 'A128KW',
                '192': 'A192KW',
                '256': 'A256KW',
            },
            'AES-GCM': {
                '128': 'A128GCM',
                '192': 'A192GCM',
                '256': 'A256GCM',
            },
            'AES-CBC': {
                '128': 'A128CBC',
                '192': 'A192CBC',
                '256': 'A256CBC',
            },
        }[a.name][ ( a.hash || {} ).name || a.length || '' ];
    }

    function b2jwk ( k ) {
        if ( k instanceof ArrayBuffer || k instanceof Uint8Array ) k = JSON.parse( decodeURIComponent( escape( b2s(k) ) ) );
        var jwk = { 'kty': k.kty, 'alg': k.alg, 'ext': k.ext || k.extractable };
        switch ( jwk.kty ) {
            case 'oct':
                jwk.k = k.k;
            case 'RSA':
                [ 'n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi', 'oth' ].forEach( function ( x ) { if ( x in k ) jwk[x] = k[x] } );
                break;
            default:
                throw new TypeError("Unsupported key type");
        }
        return jwk;
    }

    function jwk2b ( k ) {
        var jwk = b2jwk(k);
        if ( isIE ) jwk['extractable'] = jwk.ext, delete jwk.ext;
        return s2b( unescape( encodeURIComponent( JSON.stringify(jwk) ) ) ).buffer;
    }

    function pkcs2jwk ( k ) {
        var info = b2der(k), prv = false;
        if ( info.length > 2 ) prv = true, info.shift(); // remove version from PKCS#8 PrivateKeyInfo structure
        var jwk = { 'ext': true };
        switch ( info[0][0] ) {
            case '1.2.840.113549.1.1.1':
                var rsaComp = [ 'n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi' ],
                    rsaKey  = b2der( info[1] );
                if ( prv ) rsaKey.shift(); // remove version from PKCS#1 RSAPrivateKey structure
                for ( var i = 0; i < rsaKey.length; i++ ) {
                    if ( !rsaKey[i][0] ) rsaKey[i] = rsaKey[i].subarray(1);
                    jwk[ rsaComp[i] ] = s2a( b2s( rsaKey[i] ) );
                }
                jwk['kty'] = 'RSA';
                break;
            default:
                throw new TypeError("Unsupported key type");
        }
        return jwk;
    }

    function jwk2pkcs ( k ) {
        var key, info = [ [ '', null ] ], prv = false;
        switch ( k.kty ) {
            case 'RSA':
                var rsaComp = [ 'n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi' ],
                    rsaKey = [];
                for ( var i = 0; i < rsaComp.length; i++ ) {
                    if ( !( rsaComp[i] in k ) ) break;
                    var b = rsaKey[i] = s2b( a2s( k[ rsaComp[i] ] ) );
                    if ( b[0] & 0x80 ) rsaKey[i] = new Uint8Array(b.length + 1), rsaKey[i].set( b, 1 );
                }
                if ( rsaKey.length > 2 ) prv = true, rsaKey.unshift( new Uint8Array([0]) ); // add version to PKCS#1 RSAPrivateKey structure
                info[0][0] = '1.2.840.113549.1.1.1';
                key = rsaKey;
                break;
            default:
                throw new TypeError("Unsupported key type");
        }
        info.push( new Uint8Array( der2b(key) ).buffer );
        if ( !prv ) info[1] = { 'tag': 0x03, 'value': info[1] };
        else info.unshift( new Uint8Array([0]) ); // add version to PKCS#8 PrivateKeyInfo structure
        return new Uint8Array( der2b(info) ).buffer;
    }

    var oid2str = { 'KoZIhvcNAQEB': '1.2.840.113549.1.1.1' },
        str2oid = { '1.2.840.113549.1.1.1': 'KoZIhvcNAQEB' };

    function b2der ( buf, ctx ) {
        if ( buf instanceof ArrayBuffer ) buf = new Uint8Array(buf);
        if ( !ctx ) ctx = { pos: 0, end: buf.length };

        if ( ctx.end - ctx.pos < 2 || ctx.end > buf.length ) throw new RangeError("Malformed DER");

        var tag = buf[ctx.pos++],
            len = buf[ctx.pos++];

        if ( len >= 0x80 ) {
            len &= 0x7f;
            if ( ctx.end - ctx.pos < len ) throw new RangeError("Malformed DER");
            for ( var xlen = 0; len--; ) xlen <<= 8, xlen |= buf[ctx.pos++];
            len = xlen;
        }

        if ( ctx.end - ctx.pos < len ) throw new RangeError("Malformed DER");

        var rv;

        switch ( tag ) {
            case 0x02: // Universal Primitive INTEGER
                rv = buf.subarray( ctx.pos, ctx.pos += len );
                break;
            case 0x03: // Universal Primitive BIT STRING
                if ( buf[ctx.pos++] ) throw new Error( "Unsupported bit string" );
                len--;
            case 0x04: // Universal Primitive OCTET STRING
                rv = new Uint8Array( buf.subarray( ctx.pos, ctx.pos += len ) ).buffer;
                break;
            case 0x05: // Universal Primitive NULL
                rv = null;
                break;
            case 0x06: // Universal Primitive OBJECT IDENTIFIER
                var oid = btoa( b2s( buf.subarray( ctx.pos, ctx.pos += len ) ) );
                if ( !( oid in oid2str ) ) throw new Error( "Unsupported OBJECT ID " + oid );
                rv = oid2str[oid];
                break;
            case 0x30: // Universal Constructed SEQUENCE
                rv = [];
                for ( var end = ctx.pos + len; ctx.pos < end; ) rv.push( b2der( buf, ctx ) );
                break;
            default:
                throw new Error( "Unsupported DER tag 0x" + tag.toString(16) );
        }

        return rv;
    }

    function der2b ( val, buf ) {
        if ( !buf ) buf = [];

        var tag = 0, len = 0,
            pos = buf.length + 2;

        buf.push( 0, 0 ); // placeholder

        if ( val instanceof Uint8Array ) {  // Universal Primitive INTEGER
            tag = 0x02, len = val.length;
            for ( var i = 0; i < len; i++ ) buf.push( val[i] );
        }
        else if ( val instanceof ArrayBuffer ) { // Universal Primitive OCTET STRING
            tag = 0x04, len = val.byteLength, val = new Uint8Array(val);
            for ( var i = 0; i < len; i++ ) buf.push( val[i] );
        }
        else if ( val === null ) { // Universal Primitive NULL
            tag = 0x05, len = 0;
        }
        else if ( typeof val === 'string' && val in str2oid ) { // Universal Primitive OBJECT IDENTIFIER
            var oid = s2b( atob( str2oid[val] ) );
            tag = 0x06, len = oid.length;
            for ( var i = 0; i < len; i++ ) buf.push( oid[i] );
        }
        else if ( val instanceof Array ) { // Universal Constructed SEQUENCE
            for ( var i = 0; i < val.length; i++ ) der2b( val[i], buf );
            tag = 0x30, len = buf.length - pos;
        }
        else if ( typeof val === 'object' && val.tag === 0x03 && val.value instanceof ArrayBuffer ) { // Tag hint
            val = new Uint8Array(val.value), tag = 0x03, len = val.byteLength;
            buf.push(0); for ( var i = 0; i < len; i++ ) buf.push( val[i] );
            len++;
        }
        else {
            throw new Error( "Unsupported DER value " + val );
        }

        if ( len >= 0x80 ) {
            var xlen = len, len = 4;
            buf.splice( pos, 0, (xlen >> 24) & 0xff, (xlen >> 16) & 0xff, (xlen >> 8) & 0xff, xlen & 0xff );
            while ( len > 1 && !(xlen >> 24) ) xlen <<= 8, len--;
            if ( len < 4 ) buf.splice( pos, 4 - len );
            len |= 0x80;
        }

        buf.splice( pos - 2, 2, tag, len );

        return buf;
    }

    function CryptoKey ( key, alg, ext, use ) {
        Object.defineProperties( this, {
            _key: {
                value: key
            },
            type: {
                value: key.type,
                enumerable: true,
            },
            extractable: {
                value: (ext === undefined) ? key.extractable : ext,
                enumerable: true,
            },
            algorithm: {
                value: (alg === undefined) ? key.algorithm : alg,
                enumerable: true,
            },
            usages: {
                value: (use === undefined) ? key.usages : use,
                enumerable: true,
            },
        });
    }

    function isPubKeyUse ( u ) {
        return u === 'verify' || u === 'encrypt' || u === 'wrapKey';
    }

    function isPrvKeyUse ( u ) {
        return u === 'sign' || u === 'decrypt' || u === 'unwrapKey';
    }

    [ 'generateKey', 'importKey', 'unwrapKey' ]
        .forEach( function ( m ) {
            var _fn = _subtle[m];

            _subtle[m] = function ( a, b, c ) {
                var args = [].slice.call(arguments),
                    ka, kx, ku;

                switch ( m ) {
                    case 'generateKey':
                        ka = alg(a), kx = b, ku = c;
                        break;
                    case 'importKey':
                        ka = alg(c), kx = args[3], ku = args[4];
                        if ( a === 'jwk' ) {
                            b = b2jwk(b);
                            if ( !b.alg ) b.alg = jwkAlg(ka);
                            if ( !b.key_ops ) b.key_ops = ( b.kty !== 'oct' ) ? ( 'd' in b ) ? ku.filter(isPrvKeyUse) : ku.filter(isPubKeyUse) : ku.slice();
                            args[1] = jwk2b(b);
                        }
                        break;
                    case 'unwrapKey':
                        ka = args[4], kx = args[5], ku = args[6];
                        args[2] = c._key;
                        break;
                }

                if ( m === 'generateKey' && ka.name === 'HMAC' && ka.hash ) {
                    ka.length = ka.length || { 'SHA-1': 512, 'SHA-256': 512, 'SHA-384': 1024, 'SHA-512': 1024 }[ka.hash.name];
                    return _subtle.importKey( 'raw', _crypto.getRandomValues( new Uint8Array( (ka.length+7)>>3 ) ), ka, kx, ku );
                }

                if ( isWebkit && m === 'generateKey' && ka.name === 'RSASSA-PKCS1-v1_5' && ( !ka.modulusLength || ka.modulusLength >= 2048 ) ) {
                    a = alg(a), a.name = 'RSAES-PKCS1-v1_5', delete a.hash;
                    return _subtle.generateKey( a, true, [ 'encrypt', 'decrypt' ] )
                        .then( function ( k ) {
                            return Promise.all([
                                _subtle.exportKey( 'jwk', k.publicKey ),
                                _subtle.exportKey( 'jwk', k.privateKey ),
                            ]);
                        })
                        .then( function ( keys ) {
                            keys[0].alg = keys[1].alg = jwkAlg(ka);
                            keys[0].key_ops = ku.filter(isPubKeyUse), keys[1].key_ops = ku.filter(isPrvKeyUse);
                            return Promise.all([
                                _subtle.importKey( 'jwk', keys[0], ka, true, keys[0].key_ops ),
                                _subtle.importKey( 'jwk', keys[1], ka, kx, keys[1].key_ops ),
                            ]);
                        })
                        .then( function ( keys ) {
                            return {
                                publicKey: keys[0],
                                privateKey: keys[1],
                            };
                        });
                }

                if ( ( isWebkit || ( isIE && ( ka.hash || {} ).name === 'SHA-1' ) )
                        && m === 'importKey' && a === 'jwk' && ka.name === 'HMAC' && b.kty === 'oct' ) {
                    return _subtle.importKey( 'raw', s2b( a2s(b.k) ), c, args[3], args[4] );
                }

                if ( isWebkit && m === 'importKey' && ( a === 'spki' || a === 'pkcs8' ) ) {
                    return _subtle.importKey( 'jwk', pkcs2jwk(b), c, args[3], args[4] );
                }

                if ( isIE && m === 'unwrapKey' ) {
                    return _subtle.decrypt( args[3], c, b )
                        .then( function ( k ) {
                            return _subtle.importKey( a, k, args[4], args[5], args[6] );
                        });
                }

                var op;
                try {
                    op = _fn.apply( _subtle, args );
                }
                catch ( e ) {
                    return Promise.reject(e);
                }

                if ( isIE ) {
                    op = new Promise( function ( res, rej ) {
                        op.onabort =
                        op.onerror =    function ( e ) { rej(e)               };
                        op.oncomplete = function ( r ) { res(r.target.result) };
                    });
                }

                op = op.then( function ( k ) {
                    if ( ka.name === 'HMAC' ) {
                        if ( !ka.length ) ka.length = 8 * k.algorithm.length;
                    }
                    if ( ka.name.search('RSA') == 0 ) {
                        if ( !ka.modulusLength ) ka.modulusLength = (k.publicKey || k).algorithm.modulusLength;
                        if ( !ka.publicExponent ) ka.publicExponent = (k.publicKey || k).algorithm.publicExponent;
                    }
                    if ( k.publicKey && k.privateKey ) {
                        k = {
                            publicKey: new CryptoKey( k.publicKey, ka, kx, ku.filter(isPubKeyUse) ),
                            privateKey: new CryptoKey( k.privateKey, ka, kx, ku.filter(isPrvKeyUse) ),
                        };
                    }
                    else {
                        k = new CryptoKey( k, ka, kx, ku );
                    }
                    return k;
                });

                return op;
            }
        });

    [ 'exportKey', 'wrapKey' ]
        .forEach( function ( m ) {
            var _fn = _subtle[m];

            _subtle[m] = function ( a, b, c ) {
                var args = [].slice.call(arguments);

                switch ( m ) {
                    case 'exportKey':
                        args[1] = b._key;
                        break;
                    case 'wrapKey':
                        args[1] = b._key, args[2] = c._key;
                        break;
                }

                if ( ( isWebkit || ( isIE && ( b.algorithm.hash || {} ).name === 'SHA-1' ) )
                        && m === 'exportKey' && a === 'jwk' && b.algorithm.name === 'HMAC' ) {
                    args[0] = 'raw';
                }

                if ( isWebkit && m === 'exportKey' && ( a === 'spki' || a === 'pkcs8' ) ) {
                    args[0] = 'jwk';
                }

                if ( isIE && m === 'wrapKey' ) {
                    return _subtle.exportKey( a, b )
                        .then( function ( k ) {
                            if ( a === 'jwk' ) k = s2b( unescape( encodeURIComponent( JSON.stringify( b2jwk(k) ) ) ) );
                            return  _subtle.encrypt( args[3], c, k );
                        });
                }

                var op;
                try {
                    op = _fn.apply( _subtle, args );
                }
                catch ( e ) {
                    return Promise.reject(e);
                }

                if ( isIE ) {
                    op = new Promise( function ( res, rej ) {
                        op.onabort =
                        op.onerror =    function ( e ) { rej(e)               };
                        op.oncomplete = function ( r ) { res(r.target.result) };
                    });
                }

                if ( m === 'exportKey' && a === 'jwk' ) {
                    op = op.then( function ( k ) {
                        if ( ( isWebkit || ( isIE && ( b.algorithm.hash || {} ).name === 'SHA-1' ) )
                                && b.algorithm.name === 'HMAC') {
                            return { 'kty': 'oct', 'alg': jwkAlg(b.algorithm), 'key_ops': b.usages.slice(), 'ext': true, 'k': s2a( b2s(k) ) };
                        }
                        k = b2jwk(k);
                        if ( !k.alg ) k['alg'] = jwkAlg(b.algorithm);
                        if ( !k.key_ops ) k['key_ops'] = ( b.type === 'public' ) ? b.usages.filter(isPubKeyUse) : ( b.type === 'private' ) ? b.usages.filter(isPrvKeyUse) : b.usages.slice();
                        return k;
                    });
                }

                if ( isWebkit && m === 'exportKey' && ( a === 'spki' || a === 'pkcs8' ) ) {
                    op = op.then( function ( k ) {
                        k = jwk2pkcs( b2jwk(k) );
                        return k;
                    });
                }

                return op;
            }
        });

    [ 'encrypt', 'decrypt', 'sign', 'verify' ]
        .forEach( function ( m ) {
            var _fn = _subtle[m];

            _subtle[m] = function ( a, b, c, d ) {
                if ( isIE && ( !c.byteLength || ( d && !d.byteLength ) ) )
                    throw new Error("Empty input is not allowed");

                var args = [].slice.call(arguments),
                    ka = alg(a);

                if ( isIE && ( m === 'sign' || m === 'verify') && ( a === 'RSASSA-PKCS1-v1_5' || a === 'HMAC' ) ) {
                    args[0] = { name: a };
                }

                if ( isIE && b.algorithm.hash ) {
                    args[0].hash = args[0].hash || b.algorithm.hash;
                }

                if ( isIE && m === 'decrypt' && ka.name === 'AES-GCM' ) {
                    var tl = a.tagLength >> 3;
                    args[2] = (c.buffer || c).slice( 0, c.byteLength - tl ),
                    a.tag = (c.buffer || c).slice( c.byteLength - tl );
                }

                if ( isIE && ka.name === 'AES-GCM' && args[0].tagLength === undefined ) {
                    args[0].tagLength = 128;
                }

                args[1] = b._key;

                var op;
                try {
                    op = _fn.apply( _subtle, args );
                }
                catch ( e ) {
                    return Promise.reject(e);
                }

                if ( isIE ) {
                    op = new Promise( function ( res, rej ) {
                        op.onabort =
                        op.onerror = function ( e ) {
                            rej(e);
                        };

                        op.oncomplete = function ( r ) {
                            var r = r.target.result;

                            if ( m === 'encrypt' && r instanceof AesGcmEncryptResult ) {
                                var c = r.ciphertext, t = r.tag;
                                r = new Uint8Array( c.byteLength + t.byteLength );
                                r.set( new Uint8Array(c), 0 );
                                r.set( new Uint8Array(t), c.byteLength );
                                r = r.buffer;
                            }

                            res(r);
                        };
                    });
                }

                return op;
            }
        });

    if ( isIE ) {
        var _digest = _subtle.digest;

        _subtle['digest'] = function ( a, b ) {
            if ( !b.byteLength )
                throw new Error("Empty input is not allowed");

            var op;
            try {
                op = _digest.call( _subtle, a, b );
            }
            catch ( e ) {
                return Promise.reject(e);
            }

            op = new Promise( function ( res, rej ) {
                op.onabort =
                op.onerror =    function ( e ) { rej(e)               };
                op.oncomplete = function ( r ) { res(r.target.result) };
            });

            return op;
        };

        global.crypto = Object.create( _crypto, {
            getRandomValues: { value: function ( a ) { return _crypto.getRandomValues(a) } },
            subtle:          { value: _subtle },
        });

        global.CryptoKey = CryptoKey;
    }

    if ( isWebkit ) {
        _crypto.subtle = _subtle;

        global.Crypto = _Crypto;
        global.SubtleCrypto = _SubtleCrypto;
        global.CryptoKey = CryptoKey;
    }
}));


/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.c497f8f34d4503efa006.js